
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire130b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire130b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("12zqx", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $0c21756c5f4cbc80$export$882461b6382ed46c; }, function (v) { return $0c21756c5f4cbc80$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $0c21756c5f4cbc80$export$757ceba2d55c277e; }, function (v) { return $0c21756c5f4cbc80$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $0c21756c5f4cbc80$export$83d89fbfd8236492; }, function (v) { return $0c21756c5f4cbc80$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0c21756c5f4cbc80$export$882461b6382ed46c;
var $0c21756c5f4cbc80$export$757ceba2d55c277e;
var $0c21756c5f4cbc80$export$83d89fbfd8236492;
"use strict";

var $g09Uk = parcelRequire("g09Uk");

var $5NSbj = parcelRequire("5NSbj");

var $21jDP = parcelRequire("21jDP");
function $0c21756c5f4cbc80$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $0c21756c5f4cbc80$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $0c21756c5f4cbc80$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $0c21756c5f4cbc80$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $0c21756c5f4cbc80$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $0c21756c5f4cbc80$var$assertIsMounted(fiber) {
    if ($0c21756c5f4cbc80$var$getNearestMountedFiber(fiber) !== fiber) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(188));
}
function $0c21756c5f4cbc80$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $0c21756c5f4cbc80$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $0c21756c5f4cbc80$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $0c21756c5f4cbc80$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $0c21756c5f4cbc80$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $0c21756c5f4cbc80$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $0c21756c5f4cbc80$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $0c21756c5f4cbc80$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $0c21756c5f4cbc80$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $0c21756c5f4cbc80$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $0c21756c5f4cbc80$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $0c21756c5f4cbc80$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $0c21756c5f4cbc80$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $0c21756c5f4cbc80$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(559));
    }
}
var $0c21756c5f4cbc80$var$searchTarget = null, $0c21756c5f4cbc80$var$searchBoundary = null;
function $0c21756c5f4cbc80$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($0c21756c5f4cbc80$var$searchTarget = child, !0) : !1;
}
function $0c21756c5f4cbc80$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($0c21756c5f4cbc80$var$searchBoundary = child, !1) : child === target ? (null !== $0c21756c5f4cbc80$var$searchBoundary && ($0c21756c5f4cbc80$var$searchTarget = child), !0) : !1;
}
function $0c21756c5f4cbc80$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $0c21756c5f4cbc80$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $0c21756c5f4cbc80$var$assign = Object.assign, $0c21756c5f4cbc80$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $0c21756c5f4cbc80$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $0c21756c5f4cbc80$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $0c21756c5f4cbc80$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $0c21756c5f4cbc80$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $0c21756c5f4cbc80$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $0c21756c5f4cbc80$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $0c21756c5f4cbc80$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $0c21756c5f4cbc80$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $0c21756c5f4cbc80$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $0c21756c5f4cbc80$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $0c21756c5f4cbc80$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $0c21756c5f4cbc80$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $0c21756c5f4cbc80$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $0c21756c5f4cbc80$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $0c21756c5f4cbc80$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $0c21756c5f4cbc80$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $0c21756c5f4cbc80$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $0c21756c5f4cbc80$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $0c21756c5f4cbc80$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $0c21756c5f4cbc80$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$0c21756c5f4cbc80$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $0c21756c5f4cbc80$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $0c21756c5f4cbc80$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $0c21756c5f4cbc80$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $0c21756c5f4cbc80$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $0c21756c5f4cbc80$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $0c21756c5f4cbc80$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $0c21756c5f4cbc80$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $0c21756c5f4cbc80$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $0c21756c5f4cbc80$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $0c21756c5f4cbc80$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $0c21756c5f4cbc80$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $0c21756c5f4cbc80$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $0c21756c5f4cbc80$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $0c21756c5f4cbc80$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $0c21756c5f4cbc80$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $0c21756c5f4cbc80$var$getComponentNameFromType(type.type) || "Memo";
        case $0c21756c5f4cbc80$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $0c21756c5f4cbc80$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $0c21756c5f4cbc80$var$isArrayImpl = Array.isArray, $0c21756c5f4cbc80$var$ReactSharedInternals = $5NSbj.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $0c21756c5f4cbc80$var$ReactDOMSharedInternals = $21jDP.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $0c21756c5f4cbc80$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $0c21756c5f4cbc80$var$valueStack = [], $0c21756c5f4cbc80$var$index = -1;
function $0c21756c5f4cbc80$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $0c21756c5f4cbc80$var$pop(cursor) {
    0 > $0c21756c5f4cbc80$var$index || (cursor.current = $0c21756c5f4cbc80$var$valueStack[$0c21756c5f4cbc80$var$index], $0c21756c5f4cbc80$var$valueStack[$0c21756c5f4cbc80$var$index] = null, $0c21756c5f4cbc80$var$index--);
}
function $0c21756c5f4cbc80$var$push(cursor, value) {
    $0c21756c5f4cbc80$var$index++;
    $0c21756c5f4cbc80$var$valueStack[$0c21756c5f4cbc80$var$index] = cursor.current;
    cursor.current = value;
}
var $0c21756c5f4cbc80$var$contextStackCursor = $0c21756c5f4cbc80$var$createCursor(null), $0c21756c5f4cbc80$var$contextFiberStackCursor = $0c21756c5f4cbc80$var$createCursor(null), $0c21756c5f4cbc80$var$rootInstanceStackCursor = $0c21756c5f4cbc80$var$createCursor(null), $0c21756c5f4cbc80$var$hostTransitionProviderCursor = $0c21756c5f4cbc80$var$createCursor(null);
function $0c21756c5f4cbc80$var$pushHostContainer(fiber, nextRootInstance) {
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$rootInstanceStackCursor, nextRootInstance);
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$contextFiberStackCursor, fiber);
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $0c21756c5f4cbc80$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $0c21756c5f4cbc80$var$getOwnHostContext(nextRootInstance), fiber = $0c21756c5f4cbc80$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$contextStackCursor);
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$contextStackCursor, fiber);
}
function $0c21756c5f4cbc80$var$popHostContainer() {
    $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$contextStackCursor);
    $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$contextFiberStackCursor);
    $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$rootInstanceStackCursor);
}
function $0c21756c5f4cbc80$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($0c21756c5f4cbc80$var$HostTransitionContext._currentValue = stateHook.memoizedState, $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$hostTransitionProviderCursor, fiber));
    stateHook = $0c21756c5f4cbc80$var$contextStackCursor.current;
    var JSCompiler_inline_result = $0c21756c5f4cbc80$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$contextFiberStackCursor, fiber), $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$contextStackCursor, JSCompiler_inline_result));
}
function $0c21756c5f4cbc80$var$popHostContext(fiber) {
    $0c21756c5f4cbc80$var$contextFiberStackCursor.current === fiber && ($0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$contextStackCursor), $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$contextFiberStackCursor));
    $0c21756c5f4cbc80$var$hostTransitionProviderCursor.current === fiber && ($0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$hostTransitionProviderCursor), $0c21756c5f4cbc80$var$HostTransitionContext._currentValue = $0c21756c5f4cbc80$var$sharedNotPendingObject);
}
var $0c21756c5f4cbc80$var$prefix, $0c21756c5f4cbc80$var$suffix;
function $0c21756c5f4cbc80$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $0c21756c5f4cbc80$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $0c21756c5f4cbc80$var$prefix = match && match[1] || "";
        $0c21756c5f4cbc80$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $0c21756c5f4cbc80$var$prefix + name + $0c21756c5f4cbc80$var$suffix;
}
var $0c21756c5f4cbc80$var$reentry = !1;
function $0c21756c5f4cbc80$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $0c21756c5f4cbc80$var$reentry) return "";
    $0c21756c5f4cbc80$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $0c21756c5f4cbc80$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $0c21756c5f4cbc80$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $0c21756c5f4cbc80$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $0c21756c5f4cbc80$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $0c21756c5f4cbc80$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $0c21756c5f4cbc80$var$describeBuiltInComponentFrame("Suspense Fallback") : $0c21756c5f4cbc80$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $0c21756c5f4cbc80$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $0c21756c5f4cbc80$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $0c21756c5f4cbc80$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $0c21756c5f4cbc80$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $0c21756c5f4cbc80$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $0c21756c5f4cbc80$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $0c21756c5f4cbc80$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $0c21756c5f4cbc80$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $0c21756c5f4cbc80$var$hasOwnProperty = Object.prototype.hasOwnProperty, $0c21756c5f4cbc80$var$scheduleCallback$3 = $g09Uk.unstable_scheduleCallback, $0c21756c5f4cbc80$var$cancelCallback$1 = $g09Uk.unstable_cancelCallback, $0c21756c5f4cbc80$var$shouldYield = $g09Uk.unstable_shouldYield, $0c21756c5f4cbc80$var$requestPaint = $g09Uk.unstable_requestPaint, $0c21756c5f4cbc80$var$now = $g09Uk.unstable_now, $0c21756c5f4cbc80$var$getCurrentPriorityLevel = $g09Uk.unstable_getCurrentPriorityLevel, $0c21756c5f4cbc80$var$ImmediatePriority = $g09Uk.unstable_ImmediatePriority, $0c21756c5f4cbc80$var$UserBlockingPriority = $g09Uk.unstable_UserBlockingPriority, $0c21756c5f4cbc80$var$NormalPriority$1 = $g09Uk.unstable_NormalPriority, $0c21756c5f4cbc80$var$LowPriority = $g09Uk.unstable_LowPriority, $0c21756c5f4cbc80$var$IdlePriority = $g09Uk.unstable_IdlePriority, $0c21756c5f4cbc80$var$log$1 = $g09Uk.log, $0c21756c5f4cbc80$var$unstable_setDisableYieldValue = $g09Uk.unstable_setDisableYieldValue, $0c21756c5f4cbc80$var$rendererID = null, $0c21756c5f4cbc80$var$injectedHook = null;
function $0c21756c5f4cbc80$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $0c21756c5f4cbc80$var$log$1 && $0c21756c5f4cbc80$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($0c21756c5f4cbc80$var$injectedHook && "function" === typeof $0c21756c5f4cbc80$var$injectedHook.setStrictMode) try {
        $0c21756c5f4cbc80$var$injectedHook.setStrictMode($0c21756c5f4cbc80$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $0c21756c5f4cbc80$var$clz32 = Math.clz32 ? Math.clz32 : $0c21756c5f4cbc80$var$clz32Fallback, $0c21756c5f4cbc80$var$log = Math.log, $0c21756c5f4cbc80$var$LN2 = Math.LN2;
function $0c21756c5f4cbc80$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($0c21756c5f4cbc80$var$log(x) / $0c21756c5f4cbc80$var$LN2 | 0) | 0;
}
var $0c21756c5f4cbc80$var$nextTransitionUpdateLane = 256, $0c21756c5f4cbc80$var$nextTransitionDeferredLane = 262144, $0c21756c5f4cbc80$var$nextRetryLane = 4194304;
function $0c21756c5f4cbc80$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $0c21756c5f4cbc80$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $0c21756c5f4cbc80$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $0c21756c5f4cbc80$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $0c21756c5f4cbc80$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $0c21756c5f4cbc80$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $0c21756c5f4cbc80$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $0c21756c5f4cbc80$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $0c21756c5f4cbc80$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $0c21756c5f4cbc80$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $0c21756c5f4cbc80$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $0c21756c5f4cbc80$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0c21756c5f4cbc80$var$claimNextRetryLane() {
    var lane = $0c21756c5f4cbc80$var$nextRetryLane;
    $0c21756c5f4cbc80$var$nextRetryLane <<= 1;
    0 === ($0c21756c5f4cbc80$var$nextRetryLane & 62914560) && ($0c21756c5f4cbc80$var$nextRetryLane = 4194304);
    return lane;
}
function $0c21756c5f4cbc80$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $0c21756c5f4cbc80$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $0c21756c5f4cbc80$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $0c21756c5f4cbc80$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $0c21756c5f4cbc80$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $0c21756c5f4cbc80$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $0c21756c5f4cbc80$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $0c21756c5f4cbc80$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $0c21756c5f4cbc80$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $0c21756c5f4cbc80$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $0c21756c5f4cbc80$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $0c21756c5f4cbc80$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $0c21756c5f4cbc80$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $0c21756c5f4cbc80$var$resolveUpdatePriority() {
    var updatePriority = $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $0c21756c5f4cbc80$var$getEventPriority(updatePriority.type);
}
function $0c21756c5f4cbc80$var$runWithPriority(priority, fn) {
    var previousPriority = $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p;
    try {
        return $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $0c21756c5f4cbc80$var$randomKey = Math.random().toString(36).slice(2), $0c21756c5f4cbc80$var$internalInstanceKey = "__reactFiber$" + $0c21756c5f4cbc80$var$randomKey, $0c21756c5f4cbc80$var$internalPropsKey = "__reactProps$" + $0c21756c5f4cbc80$var$randomKey, $0c21756c5f4cbc80$var$internalContainerInstanceKey = "__reactContainer$" + $0c21756c5f4cbc80$var$randomKey, $0c21756c5f4cbc80$var$internalEventHandlersKey = "__reactEvents$" + $0c21756c5f4cbc80$var$randomKey, $0c21756c5f4cbc80$var$internalEventHandlerListenersKey = "__reactListeners$" + $0c21756c5f4cbc80$var$randomKey, $0c21756c5f4cbc80$var$internalEventHandlesSetKey = "__reactHandles$" + $0c21756c5f4cbc80$var$randomKey, $0c21756c5f4cbc80$var$internalRootNodeResourcesKey = "__reactResources$" + $0c21756c5f4cbc80$var$randomKey, $0c21756c5f4cbc80$var$internalHoistableMarker = "__reactMarker$" + $0c21756c5f4cbc80$var$randomKey, $0c21756c5f4cbc80$var$internalLoadPendingKey = "__reactLoad$" + $0c21756c5f4cbc80$var$randomKey;
function $0c21756c5f4cbc80$var$detachDeletedInstance(node) {
    delete node[$0c21756c5f4cbc80$var$internalInstanceKey];
    delete node[$0c21756c5f4cbc80$var$internalPropsKey];
    delete node[$0c21756c5f4cbc80$var$internalEventHandlerListenersKey];
    delete node[$0c21756c5f4cbc80$var$internalEventHandlesSetKey];
}
function $0c21756c5f4cbc80$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$0c21756c5f4cbc80$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$0c21756c5f4cbc80$var$internalContainerInstanceKey] || parentNode[$0c21756c5f4cbc80$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $0c21756c5f4cbc80$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$0c21756c5f4cbc80$var$internalInstanceKey]) return parentNode;
                targetNode = $0c21756c5f4cbc80$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $0c21756c5f4cbc80$var$getInstanceFromNode(node) {
    if (node = node[$0c21756c5f4cbc80$var$internalInstanceKey] || node[$0c21756c5f4cbc80$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $0c21756c5f4cbc80$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(33));
}
function $0c21756c5f4cbc80$var$getResourcesFromRoot(root) {
    var resources = root[$0c21756c5f4cbc80$var$internalRootNodeResourcesKey];
    resources || (resources = root[$0c21756c5f4cbc80$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $0c21756c5f4cbc80$var$markNodeAsHoistable(node) {
    node[$0c21756c5f4cbc80$var$internalHoistableMarker] = !0;
}
function $0c21756c5f4cbc80$var$clearPendingLoadOnNode(node) {
    node[$0c21756c5f4cbc80$var$internalLoadPendingKey] = void 0;
}
var $0c21756c5f4cbc80$var$allNativeEvents = new Set(), $0c21756c5f4cbc80$var$registrationNameDependencies = {};
function $0c21756c5f4cbc80$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $0c21756c5f4cbc80$var$registerDirectEvent(registrationName, dependencies);
    $0c21756c5f4cbc80$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $0c21756c5f4cbc80$var$registerDirectEvent(registrationName, dependencies) {
    $0c21756c5f4cbc80$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$0c21756c5f4cbc80$var$allNativeEvents.add(dependencies[registrationName]);
}
var $0c21756c5f4cbc80$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $0c21756c5f4cbc80$var$illegalAttributeNameCache = {}, $0c21756c5f4cbc80$var$validatedAttributeNameCache = {};
function $0c21756c5f4cbc80$var$isAttributeNameSafe(attributeName) {
    if ($0c21756c5f4cbc80$var$hasOwnProperty.call($0c21756c5f4cbc80$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($0c21756c5f4cbc80$var$hasOwnProperty.call($0c21756c5f4cbc80$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($0c21756c5f4cbc80$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $0c21756c5f4cbc80$var$validatedAttributeNameCache[attributeName] = !0;
    $0c21756c5f4cbc80$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $0c21756c5f4cbc80$var$viewTransitionMutationContext = !1;
function $0c21756c5f4cbc80$var$pushMutationContext() {
    var prev = $0c21756c5f4cbc80$var$viewTransitionMutationContext;
    $0c21756c5f4cbc80$var$viewTransitionMutationContext = !1;
    return prev;
}
function $0c21756c5f4cbc80$var$setValueForAttribute(node, name, value) {
    if ($0c21756c5f4cbc80$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $0c21756c5f4cbc80$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $0c21756c5f4cbc80$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $0c21756c5f4cbc80$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $0c21756c5f4cbc80$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $0c21756c5f4cbc80$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $0c21756c5f4cbc80$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $0c21756c5f4cbc80$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $0c21756c5f4cbc80$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $0c21756c5f4cbc80$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $0c21756c5f4cbc80$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $0c21756c5f4cbc80$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $0c21756c5f4cbc80$var$getToStringValue(value);
        } else element.value !== "" + $0c21756c5f4cbc80$var$getToStringValue(value) && (element.value = "" + $0c21756c5f4cbc80$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $0c21756c5f4cbc80$var$setDefaultValue(element, $0c21756c5f4cbc80$var$getToStringValue(element.value)) : $0c21756c5f4cbc80$var$setDefaultValue(element, $0c21756c5f4cbc80$var$getToStringValue(value)) : null != defaultValue ? $0c21756c5f4cbc80$var$setDefaultValue(element, $0c21756c5f4cbc80$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $0c21756c5f4cbc80$var$getToStringValue(name) : element.removeAttribute("name");
}
function $0c21756c5f4cbc80$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $0c21756c5f4cbc80$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $0c21756c5f4cbc80$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $0c21756c5f4cbc80$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $0c21756c5f4cbc80$var$track(element);
}
function $0c21756c5f4cbc80$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $0c21756c5f4cbc80$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $0c21756c5f4cbc80$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $0c21756c5f4cbc80$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $0c21756c5f4cbc80$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $0c21756c5f4cbc80$var$getToStringValue(defaultValue) : "";
}
function $0c21756c5f4cbc80$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(92));
            if ($0c21756c5f4cbc80$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $0c21756c5f4cbc80$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $0c21756c5f4cbc80$var$track(element);
}
function $0c21756c5f4cbc80$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $0c21756c5f4cbc80$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $0c21756c5f4cbc80$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $0c21756c5f4cbc80$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $0c21756c5f4cbc80$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $0c21756c5f4cbc80$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($0c21756c5f4cbc80$var$setValueForStyle(node, styleName$16, styleName), $0c21756c5f4cbc80$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $0c21756c5f4cbc80$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $0c21756c5f4cbc80$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0c21756c5f4cbc80$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $0c21756c5f4cbc80$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $0c21756c5f4cbc80$var$sanitizeURL(url) {
    return $0c21756c5f4cbc80$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $0c21756c5f4cbc80$var$noop$1() {}
var $0c21756c5f4cbc80$var$currentReplayingEvent = null;
function $0c21756c5f4cbc80$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $0c21756c5f4cbc80$var$restoreTarget = null, $0c21756c5f4cbc80$var$restoreQueue = null;
function $0c21756c5f4cbc80$var$restoreStateOfTarget(target) {
    var internalInstance = $0c21756c5f4cbc80$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$0c21756c5f4cbc80$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $0c21756c5f4cbc80$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$0c21756c5f4cbc80$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(90));
                            $0c21756c5f4cbc80$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $0c21756c5f4cbc80$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $0c21756c5f4cbc80$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $0c21756c5f4cbc80$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $0c21756c5f4cbc80$var$isInsideEventHandler = !1;
function $0c21756c5f4cbc80$var$batchedUpdates$1(fn, a, b) {
    if ($0c21756c5f4cbc80$var$isInsideEventHandler) return fn(a, b);
    $0c21756c5f4cbc80$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($0c21756c5f4cbc80$var$isInsideEventHandler = !1, null !== $0c21756c5f4cbc80$var$restoreTarget || null !== $0c21756c5f4cbc80$var$restoreQueue) {
            if ($0c21756c5f4cbc80$var$flushSyncWork$1(), $0c21756c5f4cbc80$var$restoreTarget && (a = $0c21756c5f4cbc80$var$restoreTarget, fn = $0c21756c5f4cbc80$var$restoreQueue, $0c21756c5f4cbc80$var$restoreQueue = $0c21756c5f4cbc80$var$restoreTarget = null, $0c21756c5f4cbc80$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$0c21756c5f4cbc80$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $0c21756c5f4cbc80$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$0c21756c5f4cbc80$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $0c21756c5f4cbc80$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0c21756c5f4cbc80$var$passiveBrowserEventsSupported = !1;
if ($0c21756c5f4cbc80$var$canUseDOM) try {
    var $0c21756c5f4cbc80$var$options = {};
    Object.defineProperty($0c21756c5f4cbc80$var$options, "passive", {
        get: function() {
            $0c21756c5f4cbc80$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $0c21756c5f4cbc80$var$options, $0c21756c5f4cbc80$var$options);
    window.removeEventListener("test", $0c21756c5f4cbc80$var$options, $0c21756c5f4cbc80$var$options);
} catch (e) {
    $0c21756c5f4cbc80$var$passiveBrowserEventsSupported = !1;
}
var $0c21756c5f4cbc80$var$root = null, $0c21756c5f4cbc80$var$startText = null, $0c21756c5f4cbc80$var$fallbackText = null;
function $0c21756c5f4cbc80$var$getData() {
    if ($0c21756c5f4cbc80$var$fallbackText) return $0c21756c5f4cbc80$var$fallbackText;
    var start, startValue = $0c21756c5f4cbc80$var$startText, startLength = startValue.length, end, endValue = "value" in $0c21756c5f4cbc80$var$root ? $0c21756c5f4cbc80$var$root.value : $0c21756c5f4cbc80$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $0c21756c5f4cbc80$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $0c21756c5f4cbc80$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $0c21756c5f4cbc80$var$functionThatReturnsTrue() {
    return !0;
}
function $0c21756c5f4cbc80$var$functionThatReturnsFalse() {
    return !1;
}
function $0c21756c5f4cbc80$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $0c21756c5f4cbc80$var$functionThatReturnsTrue : $0c21756c5f4cbc80$var$functionThatReturnsFalse;
        this.isPropagationStopped = $0c21756c5f4cbc80$var$functionThatReturnsFalse;
        return this;
    }
    $0c21756c5f4cbc80$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $0c21756c5f4cbc80$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $0c21756c5f4cbc80$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $0c21756c5f4cbc80$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $0c21756c5f4cbc80$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0c21756c5f4cbc80$var$SyntheticEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$EventInterface), $0c21756c5f4cbc80$var$UIEventInterface = $0c21756c5f4cbc80$var$assign({}, $0c21756c5f4cbc80$var$EventInterface, {
    view: 0,
    detail: 0
}), $0c21756c5f4cbc80$var$SyntheticUIEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$UIEventInterface), $0c21756c5f4cbc80$var$lastMovementX, $0c21756c5f4cbc80$var$lastMovementY, $0c21756c5f4cbc80$var$lastMouseEvent, $0c21756c5f4cbc80$var$MouseEventInterface = $0c21756c5f4cbc80$var$assign({}, $0c21756c5f4cbc80$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0c21756c5f4cbc80$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $0c21756c5f4cbc80$var$lastMouseEvent && ($0c21756c5f4cbc80$var$lastMouseEvent && "mousemove" === event.type ? ($0c21756c5f4cbc80$var$lastMovementX = event.screenX - $0c21756c5f4cbc80$var$lastMouseEvent.screenX, $0c21756c5f4cbc80$var$lastMovementY = event.screenY - $0c21756c5f4cbc80$var$lastMouseEvent.screenY) : $0c21756c5f4cbc80$var$lastMovementY = $0c21756c5f4cbc80$var$lastMovementX = 0, $0c21756c5f4cbc80$var$lastMouseEvent = event);
        return $0c21756c5f4cbc80$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $0c21756c5f4cbc80$var$lastMovementY;
    }
}), $0c21756c5f4cbc80$var$SyntheticMouseEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$MouseEventInterface), $0c21756c5f4cbc80$var$DragEventInterface = $0c21756c5f4cbc80$var$assign({}, $0c21756c5f4cbc80$var$MouseEventInterface, {
    dataTransfer: 0
}), $0c21756c5f4cbc80$var$SyntheticDragEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$DragEventInterface), $0c21756c5f4cbc80$var$FocusEventInterface = $0c21756c5f4cbc80$var$assign({}, $0c21756c5f4cbc80$var$UIEventInterface, {
    relatedTarget: 0
}), $0c21756c5f4cbc80$var$SyntheticFocusEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$FocusEventInterface), $0c21756c5f4cbc80$var$AnimationEventInterface = $0c21756c5f4cbc80$var$assign({}, $0c21756c5f4cbc80$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0c21756c5f4cbc80$var$SyntheticAnimationEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$AnimationEventInterface), $0c21756c5f4cbc80$var$ClipboardEventInterface = $0c21756c5f4cbc80$var$assign({}, $0c21756c5f4cbc80$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $0c21756c5f4cbc80$var$SyntheticClipboardEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$ClipboardEventInterface), $0c21756c5f4cbc80$var$CompositionEventInterface = $0c21756c5f4cbc80$var$assign({}, $0c21756c5f4cbc80$var$EventInterface, {
    data: 0
}), $0c21756c5f4cbc80$var$SyntheticCompositionEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$CompositionEventInterface), $0c21756c5f4cbc80$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0c21756c5f4cbc80$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0c21756c5f4cbc80$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0c21756c5f4cbc80$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $0c21756c5f4cbc80$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $0c21756c5f4cbc80$var$getEventModifierState() {
    return $0c21756c5f4cbc80$var$modifierStateGetter;
}
var $0c21756c5f4cbc80$var$KeyboardEventInterface = $0c21756c5f4cbc80$var$assign({}, $0c21756c5f4cbc80$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $0c21756c5f4cbc80$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $0c21756c5f4cbc80$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $0c21756c5f4cbc80$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0c21756c5f4cbc80$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $0c21756c5f4cbc80$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $0c21756c5f4cbc80$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $0c21756c5f4cbc80$var$SyntheticKeyboardEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$KeyboardEventInterface), $0c21756c5f4cbc80$var$PointerEventInterface = $0c21756c5f4cbc80$var$assign({}, $0c21756c5f4cbc80$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0c21756c5f4cbc80$var$SyntheticPointerEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$PointerEventInterface), $0c21756c5f4cbc80$var$SubmitEventInterface = $0c21756c5f4cbc80$var$assign({}, $0c21756c5f4cbc80$var$EventInterface, {
    submitter: 0
}), $0c21756c5f4cbc80$var$SyntheticSubmitEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$SubmitEventInterface), $0c21756c5f4cbc80$var$TouchEventInterface = $0c21756c5f4cbc80$var$assign({}, $0c21756c5f4cbc80$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0c21756c5f4cbc80$var$getEventModifierState
}), $0c21756c5f4cbc80$var$SyntheticTouchEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$TouchEventInterface), $0c21756c5f4cbc80$var$TransitionEventInterface = $0c21756c5f4cbc80$var$assign({}, $0c21756c5f4cbc80$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0c21756c5f4cbc80$var$SyntheticTransitionEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$TransitionEventInterface), $0c21756c5f4cbc80$var$WheelEventInterface = $0c21756c5f4cbc80$var$assign({}, $0c21756c5f4cbc80$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0c21756c5f4cbc80$var$SyntheticWheelEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$WheelEventInterface), $0c21756c5f4cbc80$var$ToggleEventInterface = $0c21756c5f4cbc80$var$assign({}, $0c21756c5f4cbc80$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $0c21756c5f4cbc80$var$SyntheticToggleEvent = $0c21756c5f4cbc80$var$createSyntheticEvent($0c21756c5f4cbc80$var$ToggleEventInterface), $0c21756c5f4cbc80$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $0c21756c5f4cbc80$var$canUseCompositionEvent = $0c21756c5f4cbc80$var$canUseDOM && "CompositionEvent" in window, $0c21756c5f4cbc80$var$documentMode = null;
$0c21756c5f4cbc80$var$canUseDOM && "documentMode" in document && ($0c21756c5f4cbc80$var$documentMode = document.documentMode);
var $0c21756c5f4cbc80$var$canUseTextInputEvent = $0c21756c5f4cbc80$var$canUseDOM && "TextEvent" in window && !$0c21756c5f4cbc80$var$documentMode, $0c21756c5f4cbc80$var$useFallbackCompositionData = $0c21756c5f4cbc80$var$canUseDOM && (!$0c21756c5f4cbc80$var$canUseCompositionEvent || $0c21756c5f4cbc80$var$documentMode && 8 < $0c21756c5f4cbc80$var$documentMode && 11 >= $0c21756c5f4cbc80$var$documentMode), $0c21756c5f4cbc80$var$SPACEBAR_CHAR = String.fromCharCode(32), $0c21756c5f4cbc80$var$hasSpaceKeypress = !1;
function $0c21756c5f4cbc80$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $0c21756c5f4cbc80$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0c21756c5f4cbc80$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $0c21756c5f4cbc80$var$isComposing = !1;
function $0c21756c5f4cbc80$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $0c21756c5f4cbc80$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $0c21756c5f4cbc80$var$hasSpaceKeypress = !0;
            return $0c21756c5f4cbc80$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $0c21756c5f4cbc80$var$SPACEBAR_CHAR && $0c21756c5f4cbc80$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $0c21756c5f4cbc80$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($0c21756c5f4cbc80$var$isComposing) return "compositionend" === domEventName || !$0c21756c5f4cbc80$var$canUseCompositionEvent && $0c21756c5f4cbc80$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $0c21756c5f4cbc80$var$getData(), $0c21756c5f4cbc80$var$fallbackText = $0c21756c5f4cbc80$var$startText = $0c21756c5f4cbc80$var$root = null, $0c21756c5f4cbc80$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $0c21756c5f4cbc80$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $0c21756c5f4cbc80$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0c21756c5f4cbc80$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$0c21756c5f4cbc80$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $0c21756c5f4cbc80$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $0c21756c5f4cbc80$var$restoreTarget ? $0c21756c5f4cbc80$var$restoreQueue ? $0c21756c5f4cbc80$var$restoreQueue.push(target) : $0c21756c5f4cbc80$var$restoreQueue = [
        target
    ] : $0c21756c5f4cbc80$var$restoreTarget = target;
    inst = $0c21756c5f4cbc80$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $0c21756c5f4cbc80$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $0c21756c5f4cbc80$var$activeElement$1 = null, $0c21756c5f4cbc80$var$activeElementInst$1 = null;
function $0c21756c5f4cbc80$var$runEventInBatch(dispatchQueue) {
    $0c21756c5f4cbc80$var$processDispatchQueue(dispatchQueue, 0);
}
function $0c21756c5f4cbc80$var$getInstIfValueChanged(targetInst) {
    var targetNode = $0c21756c5f4cbc80$var$getNodeFromInstance(targetInst);
    if ($0c21756c5f4cbc80$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $0c21756c5f4cbc80$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $0c21756c5f4cbc80$var$isInputEventSupported = !1;
if ($0c21756c5f4cbc80$var$canUseDOM) {
    var $0c21756c5f4cbc80$var$JSCompiler_inline_result$jscomp$318;
    if ($0c21756c5f4cbc80$var$canUseDOM) {
        var $0c21756c5f4cbc80$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$0c21756c5f4cbc80$var$isSupported$jscomp$inline_474) {
            var $0c21756c5f4cbc80$var$element$jscomp$inline_475 = document.createElement("div");
            $0c21756c5f4cbc80$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $0c21756c5f4cbc80$var$isSupported$jscomp$inline_474 = "function" === typeof $0c21756c5f4cbc80$var$element$jscomp$inline_475.oninput;
        }
        $0c21756c5f4cbc80$var$JSCompiler_inline_result$jscomp$318 = $0c21756c5f4cbc80$var$isSupported$jscomp$inline_474;
    } else $0c21756c5f4cbc80$var$JSCompiler_inline_result$jscomp$318 = !1;
    $0c21756c5f4cbc80$var$isInputEventSupported = $0c21756c5f4cbc80$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $0c21756c5f4cbc80$var$stopWatchingForValueChange() {
    $0c21756c5f4cbc80$var$activeElement$1 && ($0c21756c5f4cbc80$var$activeElement$1.detachEvent("onpropertychange", $0c21756c5f4cbc80$var$handlePropertyChange), $0c21756c5f4cbc80$var$activeElementInst$1 = $0c21756c5f4cbc80$var$activeElement$1 = null);
}
function $0c21756c5f4cbc80$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $0c21756c5f4cbc80$var$getInstIfValueChanged($0c21756c5f4cbc80$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $0c21756c5f4cbc80$var$createAndAccumulateChangeEvent(dispatchQueue, $0c21756c5f4cbc80$var$activeElementInst$1, nativeEvent, $0c21756c5f4cbc80$var$getEventTarget(nativeEvent));
        $0c21756c5f4cbc80$var$batchedUpdates$1($0c21756c5f4cbc80$var$runEventInBatch, dispatchQueue);
    }
}
function $0c21756c5f4cbc80$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($0c21756c5f4cbc80$var$stopWatchingForValueChange(), $0c21756c5f4cbc80$var$activeElement$1 = target, $0c21756c5f4cbc80$var$activeElementInst$1 = targetInst, $0c21756c5f4cbc80$var$activeElement$1.attachEvent("onpropertychange", $0c21756c5f4cbc80$var$handlePropertyChange)) : "focusout" === domEventName && $0c21756c5f4cbc80$var$stopWatchingForValueChange();
}
function $0c21756c5f4cbc80$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $0c21756c5f4cbc80$var$getInstIfValueChanged($0c21756c5f4cbc80$var$activeElementInst$1);
}
function $0c21756c5f4cbc80$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $0c21756c5f4cbc80$var$getInstIfValueChanged(targetInst);
}
function $0c21756c5f4cbc80$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $0c21756c5f4cbc80$var$getInstIfValueChanged(targetInst);
}
function $0c21756c5f4cbc80$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $0c21756c5f4cbc80$var$objectIs = "function" === typeof Object.is ? Object.is : $0c21756c5f4cbc80$var$is;
function $0c21756c5f4cbc80$var$shallowEqual(objA, objB) {
    if ($0c21756c5f4cbc80$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$0c21756c5f4cbc80$var$hasOwnProperty.call(objB, currentKey) || !$0c21756c5f4cbc80$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $0c21756c5f4cbc80$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $0c21756c5f4cbc80$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $0c21756c5f4cbc80$var$getNodeForCharacterOffset(root, offset) {
    var node = $0c21756c5f4cbc80$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $0c21756c5f4cbc80$var$getLeafNode(node);
    }
}
function $0c21756c5f4cbc80$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $0c21756c5f4cbc80$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $0c21756c5f4cbc80$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $0c21756c5f4cbc80$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $0c21756c5f4cbc80$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $0c21756c5f4cbc80$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $0c21756c5f4cbc80$var$skipSelectionChangeEvent = $0c21756c5f4cbc80$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $0c21756c5f4cbc80$var$activeElement = null, $0c21756c5f4cbc80$var$activeElementInst = null, $0c21756c5f4cbc80$var$lastSelection = null, $0c21756c5f4cbc80$var$mouseDown = !1;
function $0c21756c5f4cbc80$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $0c21756c5f4cbc80$var$mouseDown || null == $0c21756c5f4cbc80$var$activeElement || $0c21756c5f4cbc80$var$activeElement !== $0c21756c5f4cbc80$var$getActiveElement(doc) || (doc = $0c21756c5f4cbc80$var$activeElement, "selectionStart" in doc && $0c21756c5f4cbc80$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $0c21756c5f4cbc80$var$lastSelection && $0c21756c5f4cbc80$var$shallowEqual($0c21756c5f4cbc80$var$lastSelection, doc) || ($0c21756c5f4cbc80$var$lastSelection = doc, doc = $0c21756c5f4cbc80$var$accumulateTwoPhaseListeners($0c21756c5f4cbc80$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $0c21756c5f4cbc80$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $0c21756c5f4cbc80$var$activeElement)));
}
function $0c21756c5f4cbc80$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $0c21756c5f4cbc80$var$vendorPrefixes = {
    animationend: $0c21756c5f4cbc80$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $0c21756c5f4cbc80$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $0c21756c5f4cbc80$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $0c21756c5f4cbc80$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $0c21756c5f4cbc80$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $0c21756c5f4cbc80$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $0c21756c5f4cbc80$var$makePrefixMap("Transition", "TransitionEnd")
}, $0c21756c5f4cbc80$var$prefixedEventNames = {}, $0c21756c5f4cbc80$var$style = {};
$0c21756c5f4cbc80$var$canUseDOM && ($0c21756c5f4cbc80$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $0c21756c5f4cbc80$var$vendorPrefixes.animationend.animation, delete $0c21756c5f4cbc80$var$vendorPrefixes.animationiteration.animation, delete $0c21756c5f4cbc80$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $0c21756c5f4cbc80$var$vendorPrefixes.transitionend.transition);
function $0c21756c5f4cbc80$var$getVendorPrefixedEventName(eventName) {
    if ($0c21756c5f4cbc80$var$prefixedEventNames[eventName]) return $0c21756c5f4cbc80$var$prefixedEventNames[eventName];
    if (!$0c21756c5f4cbc80$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $0c21756c5f4cbc80$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $0c21756c5f4cbc80$var$style) return $0c21756c5f4cbc80$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $0c21756c5f4cbc80$var$ANIMATION_END = $0c21756c5f4cbc80$var$getVendorPrefixedEventName("animationend"), $0c21756c5f4cbc80$var$ANIMATION_ITERATION = $0c21756c5f4cbc80$var$getVendorPrefixedEventName("animationiteration"), $0c21756c5f4cbc80$var$ANIMATION_START = $0c21756c5f4cbc80$var$getVendorPrefixedEventName("animationstart"), $0c21756c5f4cbc80$var$TRANSITION_RUN = $0c21756c5f4cbc80$var$getVendorPrefixedEventName("transitionrun"), $0c21756c5f4cbc80$var$TRANSITION_START = $0c21756c5f4cbc80$var$getVendorPrefixedEventName("transitionstart"), $0c21756c5f4cbc80$var$TRANSITION_CANCEL = $0c21756c5f4cbc80$var$getVendorPrefixedEventName("transitioncancel"), $0c21756c5f4cbc80$var$TRANSITION_END = $0c21756c5f4cbc80$var$getVendorPrefixedEventName("transitionend"), $0c21756c5f4cbc80$var$topLevelEventsToReactNames = new Map(), $0c21756c5f4cbc80$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$0c21756c5f4cbc80$var$simpleEventPluginEvents.push("scrollEnd");
function $0c21756c5f4cbc80$var$registerSimpleEvent(domEventName, reactName) {
    $0c21756c5f4cbc80$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $0c21756c5f4cbc80$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $0c21756c5f4cbc80$var$globalClientIdCounter$1 = 0;
function $0c21756c5f4cbc80$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $0c21756c5f4cbc80$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $0c21756c5f4cbc80$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $0c21756c5f4cbc80$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $0c21756c5f4cbc80$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $0c21756c5f4cbc80$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $0c21756c5f4cbc80$var$getClassNameByType(defaultClass);
    eventClass = $0c21756c5f4cbc80$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $0c21756c5f4cbc80$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $0c21756c5f4cbc80$var$concurrentQueues = [], $0c21756c5f4cbc80$var$concurrentQueuesIndex = 0, $0c21756c5f4cbc80$var$concurrentlyUpdatedLanes = 0;
function $0c21756c5f4cbc80$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $0c21756c5f4cbc80$var$concurrentQueuesIndex, i = $0c21756c5f4cbc80$var$concurrentlyUpdatedLanes = $0c21756c5f4cbc80$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $0c21756c5f4cbc80$var$concurrentQueues[i];
        $0c21756c5f4cbc80$var$concurrentQueues[i++] = null;
        var queue = $0c21756c5f4cbc80$var$concurrentQueues[i];
        $0c21756c5f4cbc80$var$concurrentQueues[i++] = null;
        var update = $0c21756c5f4cbc80$var$concurrentQueues[i];
        $0c21756c5f4cbc80$var$concurrentQueues[i++] = null;
        var lane = $0c21756c5f4cbc80$var$concurrentQueues[i];
        $0c21756c5f4cbc80$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $0c21756c5f4cbc80$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $0c21756c5f4cbc80$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $0c21756c5f4cbc80$var$concurrentQueues[$0c21756c5f4cbc80$var$concurrentQueuesIndex++] = fiber;
    $0c21756c5f4cbc80$var$concurrentQueues[$0c21756c5f4cbc80$var$concurrentQueuesIndex++] = queue;
    $0c21756c5f4cbc80$var$concurrentQueues[$0c21756c5f4cbc80$var$concurrentQueuesIndex++] = update;
    $0c21756c5f4cbc80$var$concurrentQueues[$0c21756c5f4cbc80$var$concurrentQueuesIndex++] = lane;
    $0c21756c5f4cbc80$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $0c21756c5f4cbc80$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $0c21756c5f4cbc80$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $0c21756c5f4cbc80$var$getRootForUpdatedFiber(fiber);
}
function $0c21756c5f4cbc80$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $0c21756c5f4cbc80$var$enqueueUpdate$1(fiber, null, null, lane);
    return $0c21756c5f4cbc80$var$getRootForUpdatedFiber(fiber);
}
function $0c21756c5f4cbc80$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $0c21756c5f4cbc80$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $0c21756c5f4cbc80$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $0c21756c5f4cbc80$var$nestedUpdateCount) throw $0c21756c5f4cbc80$var$nestedUpdateCount = 0, $0c21756c5f4cbc80$var$rootWithNestedUpdates = null, Error($0c21756c5f4cbc80$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $0c21756c5f4cbc80$var$emptyContextObject = {};
function $0c21756c5f4cbc80$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0c21756c5f4cbc80$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $0c21756c5f4cbc80$var$FiberNode(tag, pendingProps, key, mode);
}
function $0c21756c5f4cbc80$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $0c21756c5f4cbc80$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $0c21756c5f4cbc80$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $0c21756c5f4cbc80$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $0c21756c5f4cbc80$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $0c21756c5f4cbc80$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $0c21756c5f4cbc80$var$isHostHoistableType(type, pendingProps, $0c21756c5f4cbc80$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $0c21756c5f4cbc80$var$REACT_ACTIVITY_TYPE:
            return type = $0c21756c5f4cbc80$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $0c21756c5f4cbc80$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $0c21756c5f4cbc80$var$REACT_FRAGMENT_TYPE:
            return $0c21756c5f4cbc80$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $0c21756c5f4cbc80$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $0c21756c5f4cbc80$var$REACT_PROFILER_TYPE:
            return type = $0c21756c5f4cbc80$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $0c21756c5f4cbc80$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $0c21756c5f4cbc80$var$REACT_SUSPENSE_TYPE:
            return type = $0c21756c5f4cbc80$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $0c21756c5f4cbc80$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $0c21756c5f4cbc80$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $0c21756c5f4cbc80$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $0c21756c5f4cbc80$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $0c21756c5f4cbc80$var$REACT_LEGACY_HIDDEN_TYPE:
        case $0c21756c5f4cbc80$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $0c21756c5f4cbc80$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $0c21756c5f4cbc80$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $0c21756c5f4cbc80$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $0c21756c5f4cbc80$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $0c21756c5f4cbc80$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $0c21756c5f4cbc80$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $0c21756c5f4cbc80$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($0c21756c5f4cbc80$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $0c21756c5f4cbc80$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $0c21756c5f4cbc80$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $0c21756c5f4cbc80$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $0c21756c5f4cbc80$var$createFiberFromText(content, mode, lanes) {
    content = $0c21756c5f4cbc80$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $0c21756c5f4cbc80$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $0c21756c5f4cbc80$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $0c21756c5f4cbc80$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $0c21756c5f4cbc80$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $0c21756c5f4cbc80$var$CapturedStacks = new WeakMap();
function $0c21756c5f4cbc80$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $0c21756c5f4cbc80$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $0c21756c5f4cbc80$var$getStackByFiberInDevAndProd(source)
        };
        $0c21756c5f4cbc80$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $0c21756c5f4cbc80$var$getStackByFiberInDevAndProd(source)
    };
}
var $0c21756c5f4cbc80$var$forkStack = [], $0c21756c5f4cbc80$var$forkStackIndex = 0, $0c21756c5f4cbc80$var$treeForkProvider = null, $0c21756c5f4cbc80$var$treeForkCount = 0, $0c21756c5f4cbc80$var$idStack = [], $0c21756c5f4cbc80$var$idStackIndex = 0, $0c21756c5f4cbc80$var$treeContextProvider = null, $0c21756c5f4cbc80$var$treeContextId = 1, $0c21756c5f4cbc80$var$treeContextOverflow = "";
function $0c21756c5f4cbc80$var$pushTreeFork(workInProgress, totalChildren) {
    $0c21756c5f4cbc80$var$forkStack[$0c21756c5f4cbc80$var$forkStackIndex++] = $0c21756c5f4cbc80$var$treeForkCount;
    $0c21756c5f4cbc80$var$forkStack[$0c21756c5f4cbc80$var$forkStackIndex++] = $0c21756c5f4cbc80$var$treeForkProvider;
    $0c21756c5f4cbc80$var$treeForkProvider = workInProgress;
    $0c21756c5f4cbc80$var$treeForkCount = totalChildren;
}
function $0c21756c5f4cbc80$var$pushTreeId(workInProgress, totalChildren, index) {
    $0c21756c5f4cbc80$var$idStack[$0c21756c5f4cbc80$var$idStackIndex++] = $0c21756c5f4cbc80$var$treeContextId;
    $0c21756c5f4cbc80$var$idStack[$0c21756c5f4cbc80$var$idStackIndex++] = $0c21756c5f4cbc80$var$treeContextOverflow;
    $0c21756c5f4cbc80$var$idStack[$0c21756c5f4cbc80$var$idStackIndex++] = $0c21756c5f4cbc80$var$treeContextProvider;
    $0c21756c5f4cbc80$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $0c21756c5f4cbc80$var$treeContextId;
    workInProgress = $0c21756c5f4cbc80$var$treeContextOverflow;
    var baseLength = 32 - $0c21756c5f4cbc80$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $0c21756c5f4cbc80$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $0c21756c5f4cbc80$var$treeContextId = 1 << 32 - $0c21756c5f4cbc80$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $0c21756c5f4cbc80$var$treeContextOverflow = length + workInProgress;
    } else $0c21756c5f4cbc80$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $0c21756c5f4cbc80$var$treeContextOverflow = workInProgress;
}
function $0c21756c5f4cbc80$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($0c21756c5f4cbc80$var$pushTreeFork(workInProgress, 1), $0c21756c5f4cbc80$var$pushTreeId(workInProgress, 1, 0));
}
function $0c21756c5f4cbc80$var$popTreeContext(workInProgress) {
    for(; workInProgress === $0c21756c5f4cbc80$var$treeForkProvider;)$0c21756c5f4cbc80$var$treeForkProvider = $0c21756c5f4cbc80$var$forkStack[--$0c21756c5f4cbc80$var$forkStackIndex], $0c21756c5f4cbc80$var$forkStack[$0c21756c5f4cbc80$var$forkStackIndex] = null, $0c21756c5f4cbc80$var$treeForkCount = $0c21756c5f4cbc80$var$forkStack[--$0c21756c5f4cbc80$var$forkStackIndex], $0c21756c5f4cbc80$var$forkStack[$0c21756c5f4cbc80$var$forkStackIndex] = null;
    for(; workInProgress === $0c21756c5f4cbc80$var$treeContextProvider;)$0c21756c5f4cbc80$var$treeContextProvider = $0c21756c5f4cbc80$var$idStack[--$0c21756c5f4cbc80$var$idStackIndex], $0c21756c5f4cbc80$var$idStack[$0c21756c5f4cbc80$var$idStackIndex] = null, $0c21756c5f4cbc80$var$treeContextOverflow = $0c21756c5f4cbc80$var$idStack[--$0c21756c5f4cbc80$var$idStackIndex], $0c21756c5f4cbc80$var$idStack[$0c21756c5f4cbc80$var$idStackIndex] = null, $0c21756c5f4cbc80$var$treeContextId = $0c21756c5f4cbc80$var$idStack[--$0c21756c5f4cbc80$var$idStackIndex], $0c21756c5f4cbc80$var$idStack[$0c21756c5f4cbc80$var$idStackIndex] = null;
}
function $0c21756c5f4cbc80$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $0c21756c5f4cbc80$var$idStack[$0c21756c5f4cbc80$var$idStackIndex++] = $0c21756c5f4cbc80$var$treeContextId;
    $0c21756c5f4cbc80$var$idStack[$0c21756c5f4cbc80$var$idStackIndex++] = $0c21756c5f4cbc80$var$treeContextOverflow;
    $0c21756c5f4cbc80$var$idStack[$0c21756c5f4cbc80$var$idStackIndex++] = $0c21756c5f4cbc80$var$treeContextProvider;
    $0c21756c5f4cbc80$var$treeContextId = suspendedContext.id;
    $0c21756c5f4cbc80$var$treeContextOverflow = suspendedContext.overflow;
    $0c21756c5f4cbc80$var$treeContextProvider = workInProgress;
}
var $0c21756c5f4cbc80$var$hydrationParentFiber = null, $0c21756c5f4cbc80$var$nextHydratableInstance = null, $0c21756c5f4cbc80$var$isHydrating = !1, $0c21756c5f4cbc80$var$hydrationErrors = null, $0c21756c5f4cbc80$var$rootOrSingletonContext = !1, $0c21756c5f4cbc80$var$HydrationMismatchException = Error($0c21756c5f4cbc80$var$formatProdErrorMessage(519));
function $0c21756c5f4cbc80$var$throwOnHydrationMismatch(fiber) {
    var error = Error($0c21756c5f4cbc80$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $0c21756c5f4cbc80$var$queueHydrationError($0c21756c5f4cbc80$var$createCapturedValueAtFiber(error, fiber));
    throw $0c21756c5f4cbc80$var$HydrationMismatchException;
}
function $0c21756c5f4cbc80$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$0c21756c5f4cbc80$var$internalInstanceKey] = fiber;
    instance[$0c21756c5f4cbc80$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("cancel", instance);
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $0c21756c5f4cbc80$var$mediaEventTypes.length; type++)$0c21756c5f4cbc80$var$listenToNonDelegatedEvent($0c21756c5f4cbc80$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("error", instance);
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("invalid", instance);
            $0c21756c5f4cbc80$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("invalid", instance), $0c21756c5f4cbc80$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $0c21756c5f4cbc80$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($0c21756c5f4cbc80$var$listenToNonDelegatedEvent("beforetoggle", instance), $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $0c21756c5f4cbc80$var$noop$1), instance = !0) : instance = !1;
    instance || $0c21756c5f4cbc80$var$throwOnHydrationMismatch(fiber, !0);
}
function $0c21756c5f4cbc80$var$popToNextHostParent(fiber) {
    for($0c21756c5f4cbc80$var$hydrationParentFiber = fiber.return; $0c21756c5f4cbc80$var$hydrationParentFiber;)switch($0c21756c5f4cbc80$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $0c21756c5f4cbc80$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $0c21756c5f4cbc80$var$rootOrSingletonContext = !0;
            return;
        default:
            $0c21756c5f4cbc80$var$hydrationParentFiber = $0c21756c5f4cbc80$var$hydrationParentFiber.return;
    }
}
function $0c21756c5f4cbc80$var$popHydrationState(fiber) {
    if (fiber !== $0c21756c5f4cbc80$var$hydrationParentFiber) return !1;
    if (!$0c21756c5f4cbc80$var$isHydrating) return $0c21756c5f4cbc80$var$popToNextHostParent(fiber), $0c21756c5f4cbc80$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $0c21756c5f4cbc80$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $0c21756c5f4cbc80$var$nextHydratableInstance && $0c21756c5f4cbc80$var$throwOnHydrationMismatch(fiber);
    $0c21756c5f4cbc80$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(317));
        $0c21756c5f4cbc80$var$nextHydratableInstance = $0c21756c5f4cbc80$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(317));
        $0c21756c5f4cbc80$var$nextHydratableInstance = $0c21756c5f4cbc80$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $0c21756c5f4cbc80$var$nextHydratableInstance, $0c21756c5f4cbc80$var$isSingletonScope(fiber.type) ? (fiber = $0c21756c5f4cbc80$var$previousHydratableOnEnteringScopedSingleton, $0c21756c5f4cbc80$var$previousHydratableOnEnteringScopedSingleton = null, $0c21756c5f4cbc80$var$nextHydratableInstance = fiber) : $0c21756c5f4cbc80$var$nextHydratableInstance = tag) : $0c21756c5f4cbc80$var$nextHydratableInstance = $0c21756c5f4cbc80$var$hydrationParentFiber ? $0c21756c5f4cbc80$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $0c21756c5f4cbc80$var$resetHydrationState() {
    $0c21756c5f4cbc80$var$nextHydratableInstance = $0c21756c5f4cbc80$var$hydrationParentFiber = null;
    $0c21756c5f4cbc80$var$isHydrating = !1;
}
function $0c21756c5f4cbc80$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $0c21756c5f4cbc80$var$hydrationErrors;
    null !== queuedErrors && (null === $0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors ? $0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors = queuedErrors : $0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors.push.apply($0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors, queuedErrors), $0c21756c5f4cbc80$var$hydrationErrors = null);
    return queuedErrors;
}
function $0c21756c5f4cbc80$var$queueHydrationError(error) {
    null === $0c21756c5f4cbc80$var$hydrationErrors ? $0c21756c5f4cbc80$var$hydrationErrors = [
        error
    ] : $0c21756c5f4cbc80$var$hydrationErrors.push(error);
}
var $0c21756c5f4cbc80$var$valueCursor = $0c21756c5f4cbc80$var$createCursor(null), $0c21756c5f4cbc80$var$currentlyRenderingFiber$1 = null, $0c21756c5f4cbc80$var$lastContextDependency = null;
function $0c21756c5f4cbc80$var$pushProvider(providerFiber, context, nextValue) {
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $0c21756c5f4cbc80$var$popProvider(context) {
    context._currentValue = $0c21756c5f4cbc80$var$valueCursor.current;
    $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$valueCursor);
}
function $0c21756c5f4cbc80$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $0c21756c5f4cbc80$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $0c21756c5f4cbc80$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $0c21756c5f4cbc80$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $0c21756c5f4cbc80$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $0c21756c5f4cbc80$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $0c21756c5f4cbc80$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $0c21756c5f4cbc80$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($0c21756c5f4cbc80$var$HostTransitionContext) : current = [
                $0c21756c5f4cbc80$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $0c21756c5f4cbc80$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $0c21756c5f4cbc80$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$0c21756c5f4cbc80$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $0c21756c5f4cbc80$var$prepareToReadContext(workInProgress) {
    $0c21756c5f4cbc80$var$currentlyRenderingFiber$1 = workInProgress;
    $0c21756c5f4cbc80$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $0c21756c5f4cbc80$var$readContext(context) {
    return $0c21756c5f4cbc80$var$readContextForConsumer($0c21756c5f4cbc80$var$currentlyRenderingFiber$1, context);
}
function $0c21756c5f4cbc80$var$readContextDuringReconciliation(consumer, context) {
    null === $0c21756c5f4cbc80$var$currentlyRenderingFiber$1 && $0c21756c5f4cbc80$var$prepareToReadContext(consumer);
    return $0c21756c5f4cbc80$var$readContextForConsumer(consumer, context);
}
function $0c21756c5f4cbc80$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $0c21756c5f4cbc80$var$lastContextDependency) {
        if (null === consumer) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(308));
        $0c21756c5f4cbc80$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $0c21756c5f4cbc80$var$lastContextDependency = $0c21756c5f4cbc80$var$lastContextDependency.next = context;
    return value;
}
var $0c21756c5f4cbc80$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $0c21756c5f4cbc80$var$scheduleCallback$2 = $g09Uk.unstable_scheduleCallback, $0c21756c5f4cbc80$var$NormalPriority = $g09Uk.unstable_NormalPriority, $0c21756c5f4cbc80$var$CacheContext = {
    $$typeof: $0c21756c5f4cbc80$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $0c21756c5f4cbc80$var$createCache() {
    return {
        controller: new $0c21756c5f4cbc80$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $0c21756c5f4cbc80$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $0c21756c5f4cbc80$var$scheduleCallback$2($0c21756c5f4cbc80$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $0c21756c5f4cbc80$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $0c21756c5f4cbc80$var$entangledTransitionTypes = null;
function $0c21756c5f4cbc80$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $0c21756c5f4cbc80$var$currentEntangledListeners = null, $0c21756c5f4cbc80$var$currentEntangledPendingCount = 0, $0c21756c5f4cbc80$var$currentEntangledLane = 0, $0c21756c5f4cbc80$var$currentEntangledActionThenable = null;
function $0c21756c5f4cbc80$var$entangleAsyncAction(transition, thenable) {
    if (null === $0c21756c5f4cbc80$var$currentEntangledListeners) {
        var entangledListeners = $0c21756c5f4cbc80$var$currentEntangledListeners = [];
        $0c21756c5f4cbc80$var$currentEntangledPendingCount = 0;
        $0c21756c5f4cbc80$var$currentEntangledLane = $0c21756c5f4cbc80$var$requestTransitionLane();
        $0c21756c5f4cbc80$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $0c21756c5f4cbc80$var$currentEntangledPendingCount++;
    thenable.then($0c21756c5f4cbc80$var$pingEngtangledActionScope, $0c21756c5f4cbc80$var$pingEngtangledActionScope);
    return thenable;
}
function $0c21756c5f4cbc80$var$pingEngtangledActionScope() {
    if (0 === --$0c21756c5f4cbc80$var$currentEntangledPendingCount && ($0c21756c5f4cbc80$var$entangledTransitionTypes = null, null !== $0c21756c5f4cbc80$var$currentEntangledListeners)) {
        null !== $0c21756c5f4cbc80$var$currentEntangledActionThenable && ($0c21756c5f4cbc80$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $0c21756c5f4cbc80$var$currentEntangledListeners;
        $0c21756c5f4cbc80$var$currentEntangledListeners = null;
        $0c21756c5f4cbc80$var$currentEntangledLane = 0;
        $0c21756c5f4cbc80$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $0c21756c5f4cbc80$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $0c21756c5f4cbc80$var$prevOnStartTransitionFinish = $0c21756c5f4cbc80$var$ReactSharedInternals.S;
$0c21756c5f4cbc80$var$ReactSharedInternals.S = function(transition, returnValue) {
    $0c21756c5f4cbc80$var$globalMostRecentTransitionTime = $0c21756c5f4cbc80$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $0c21756c5f4cbc80$var$entangleAsyncAction(transition, returnValue);
    if (null !== $0c21756c5f4cbc80$var$entangledTransitionTypes) for(var root$28 = $0c21756c5f4cbc80$var$firstScheduledRoot; null !== root$28;)$0c21756c5f4cbc80$var$queueTransitionTypes(root$28, $0c21756c5f4cbc80$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $0c21756c5f4cbc80$var$firstScheduledRoot; null !== root$29;)$0c21756c5f4cbc80$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $0c21756c5f4cbc80$var$currentEntangledLane) {
            root$29 = $0c21756c5f4cbc80$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $0c21756c5f4cbc80$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $0c21756c5f4cbc80$var$prevOnStartTransitionFinish && $0c21756c5f4cbc80$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $0c21756c5f4cbc80$var$resumedCache = $0c21756c5f4cbc80$var$createCursor(null);
function $0c21756c5f4cbc80$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $0c21756c5f4cbc80$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $0c21756c5f4cbc80$var$workInProgressRoot.pooledCache;
}
function $0c21756c5f4cbc80$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$resumedCache, $0c21756c5f4cbc80$var$resumedCache.current) : $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$resumedCache, prevCachePool.pool);
}
function $0c21756c5f4cbc80$var$getSuspendedCache() {
    var cacheFromPool = $0c21756c5f4cbc80$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $0c21756c5f4cbc80$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $0c21756c5f4cbc80$var$SuspenseException = Error($0c21756c5f4cbc80$var$formatProdErrorMessage(460)), $0c21756c5f4cbc80$var$SuspenseyCommitException = Error($0c21756c5f4cbc80$var$formatProdErrorMessage(474)), $0c21756c5f4cbc80$var$SuspenseActionException = Error($0c21756c5f4cbc80$var$formatProdErrorMessage(542)), $0c21756c5f4cbc80$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $0c21756c5f4cbc80$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $0c21756c5f4cbc80$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($0c21756c5f4cbc80$var$noop$1, $0c21756c5f4cbc80$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $0c21756c5f4cbc80$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($0c21756c5f4cbc80$var$noop$1, $0c21756c5f4cbc80$var$noop$1);
            else {
                thenableState = $0c21756c5f4cbc80$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $0c21756c5f4cbc80$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $0c21756c5f4cbc80$var$suspendedThenable = thenable;
            throw $0c21756c5f4cbc80$var$SuspenseException;
    }
}
function $0c21756c5f4cbc80$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $0c21756c5f4cbc80$var$suspendedThenable = x, $0c21756c5f4cbc80$var$SuspenseException;
        throw x;
    }
}
var $0c21756c5f4cbc80$var$suspendedThenable = null;
function $0c21756c5f4cbc80$var$getSuspendedThenable() {
    if (null === $0c21756c5f4cbc80$var$suspendedThenable) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(459));
    var thenable = $0c21756c5f4cbc80$var$suspendedThenable;
    $0c21756c5f4cbc80$var$suspendedThenable = null;
    return thenable;
}
function $0c21756c5f4cbc80$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $0c21756c5f4cbc80$var$SuspenseException || rejectedReason === $0c21756c5f4cbc80$var$SuspenseActionException) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(483));
}
var $0c21756c5f4cbc80$var$thenableState$1 = null, $0c21756c5f4cbc80$var$thenableIndexCounter$1 = 0;
function $0c21756c5f4cbc80$var$unwrapThenable(thenable) {
    var index = $0c21756c5f4cbc80$var$thenableIndexCounter$1;
    $0c21756c5f4cbc80$var$thenableIndexCounter$1 += 1;
    null === $0c21756c5f4cbc80$var$thenableState$1 && ($0c21756c5f4cbc80$var$thenableState$1 = []);
    return $0c21756c5f4cbc80$var$trackUsedThenable($0c21756c5f4cbc80$var$thenableState$1, thenable, index);
}
function $0c21756c5f4cbc80$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $0c21756c5f4cbc80$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $0c21756c5f4cbc80$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $0c21756c5f4cbc80$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $0c21756c5f4cbc80$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $0c21756c5f4cbc80$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $0c21756c5f4cbc80$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $0c21756c5f4cbc80$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $0c21756c5f4cbc80$var$REACT_LAZY_TYPE && $0c21756c5f4cbc80$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $0c21756c5f4cbc80$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $0c21756c5f4cbc80$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $0c21756c5f4cbc80$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $0c21756c5f4cbc80$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $0c21756c5f4cbc80$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $0c21756c5f4cbc80$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $0c21756c5f4cbc80$var$REACT_ELEMENT_TYPE:
                    return lanes = $0c21756c5f4cbc80$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $0c21756c5f4cbc80$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $0c21756c5f4cbc80$var$REACT_PORTAL_TYPE:
                    return newChild = $0c21756c5f4cbc80$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $0c21756c5f4cbc80$var$REACT_LAZY_TYPE:
                    return newChild = $0c21756c5f4cbc80$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($0c21756c5f4cbc80$var$isArrayImpl(newChild) || $0c21756c5f4cbc80$var$getIteratorFn(newChild)) return newChild = $0c21756c5f4cbc80$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $0c21756c5f4cbc80$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $0c21756c5f4cbc80$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $0c21756c5f4cbc80$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $0c21756c5f4cbc80$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $0c21756c5f4cbc80$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $0c21756c5f4cbc80$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $0c21756c5f4cbc80$var$REACT_LAZY_TYPE:
                    return newChild = $0c21756c5f4cbc80$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($0c21756c5f4cbc80$var$isArrayImpl(newChild) || $0c21756c5f4cbc80$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $0c21756c5f4cbc80$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $0c21756c5f4cbc80$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $0c21756c5f4cbc80$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $0c21756c5f4cbc80$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $0c21756c5f4cbc80$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $0c21756c5f4cbc80$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $0c21756c5f4cbc80$var$REACT_LAZY_TYPE:
                    return newChild = $0c21756c5f4cbc80$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($0c21756c5f4cbc80$var$isArrayImpl(newChild) || $0c21756c5f4cbc80$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $0c21756c5f4cbc80$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $0c21756c5f4cbc80$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $0c21756c5f4cbc80$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $0c21756c5f4cbc80$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $0c21756c5f4cbc80$var$isHydrating && $0c21756c5f4cbc80$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $0c21756c5f4cbc80$var$isHydrating && $0c21756c5f4cbc80$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $0c21756c5f4cbc80$var$isHydrating && $0c21756c5f4cbc80$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $0c21756c5f4cbc80$var$isHydrating && $0c21756c5f4cbc80$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $0c21756c5f4cbc80$var$isHydrating && $0c21756c5f4cbc80$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $0c21756c5f4cbc80$var$isHydrating && $0c21756c5f4cbc80$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $0c21756c5f4cbc80$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $0c21756c5f4cbc80$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $0c21756c5f4cbc80$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $0c21756c5f4cbc80$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $0c21756c5f4cbc80$var$REACT_LAZY_TYPE && $0c21756c5f4cbc80$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $0c21756c5f4cbc80$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $0c21756c5f4cbc80$var$REACT_FRAGMENT_TYPE ? (lanes = $0c21756c5f4cbc80$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $0c21756c5f4cbc80$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $0c21756c5f4cbc80$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $0c21756c5f4cbc80$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $0c21756c5f4cbc80$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $0c21756c5f4cbc80$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $0c21756c5f4cbc80$var$REACT_LAZY_TYPE:
                    return newChild = $0c21756c5f4cbc80$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($0c21756c5f4cbc80$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($0c21756c5f4cbc80$var$getIteratorFn(newChild)) {
                key = $0c21756c5f4cbc80$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $0c21756c5f4cbc80$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $0c21756c5f4cbc80$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $0c21756c5f4cbc80$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $0c21756c5f4cbc80$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $0c21756c5f4cbc80$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $0c21756c5f4cbc80$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $0c21756c5f4cbc80$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $0c21756c5f4cbc80$var$SuspenseException || x === $0c21756c5f4cbc80$var$SuspenseActionException) throw x;
            var fiber = $0c21756c5f4cbc80$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $0c21756c5f4cbc80$var$reconcileChildFibers = $0c21756c5f4cbc80$var$createChildReconciler(!0), $0c21756c5f4cbc80$var$mountChildFibers = $0c21756c5f4cbc80$var$createChildReconciler(!1), $0c21756c5f4cbc80$var$hasForceUpdate = !1;
function $0c21756c5f4cbc80$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $0c21756c5f4cbc80$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $0c21756c5f4cbc80$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0c21756c5f4cbc80$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($0c21756c5f4cbc80$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $0c21756c5f4cbc80$var$getRootForUpdatedFiber(fiber);
        $0c21756c5f4cbc80$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $0c21756c5f4cbc80$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $0c21756c5f4cbc80$var$getRootForUpdatedFiber(fiber);
}
function $0c21756c5f4cbc80$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $0c21756c5f4cbc80$var$markRootEntangled(root, lane);
    }
}
function $0c21756c5f4cbc80$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $0c21756c5f4cbc80$var$didReadFromEntangledAsyncAction = !1;
function $0c21756c5f4cbc80$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($0c21756c5f4cbc80$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $0c21756c5f4cbc80$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $0c21756c5f4cbc80$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $0c21756c5f4cbc80$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $0c21756c5f4cbc80$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($0c21756c5f4cbc80$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $0c21756c5f4cbc80$var$currentEntangledLane && ($0c21756c5f4cbc80$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $0c21756c5f4cbc80$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $0c21756c5f4cbc80$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $0c21756c5f4cbc80$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $0c21756c5f4cbc80$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $0c21756c5f4cbc80$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$0c21756c5f4cbc80$var$callCallback(callbacks[updateQueue], context);
}
var $0c21756c5f4cbc80$var$currentTreeHiddenStackCursor = $0c21756c5f4cbc80$var$createCursor(null), $0c21756c5f4cbc80$var$prevEntangledRenderLanesCursor = $0c21756c5f4cbc80$var$createCursor(0);
function $0c21756c5f4cbc80$var$pushHiddenContext(fiber, context) {
    fiber = $0c21756c5f4cbc80$var$entangledRenderLanes;
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$prevEntangledRenderLanesCursor, fiber);
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$currentTreeHiddenStackCursor, context);
    $0c21756c5f4cbc80$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $0c21756c5f4cbc80$var$reuseHiddenContextOnStack() {
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$prevEntangledRenderLanesCursor, $0c21756c5f4cbc80$var$entangledRenderLanes);
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$currentTreeHiddenStackCursor, $0c21756c5f4cbc80$var$currentTreeHiddenStackCursor.current);
}
function $0c21756c5f4cbc80$var$popHiddenContext() {
    $0c21756c5f4cbc80$var$entangledRenderLanes = $0c21756c5f4cbc80$var$prevEntangledRenderLanesCursor.current;
    $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$currentTreeHiddenStackCursor);
    $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$prevEntangledRenderLanesCursor);
}
var $0c21756c5f4cbc80$var$suspenseHandlerStackCursor = $0c21756c5f4cbc80$var$createCursor(null), $0c21756c5f4cbc80$var$shellBoundary = null;
function $0c21756c5f4cbc80$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$suspenseStackCursor, $0c21756c5f4cbc80$var$suspenseStackCursor.current & 1);
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$suspenseHandlerStackCursor, handler);
    null === $0c21756c5f4cbc80$var$shellBoundary && (null === current || null !== $0c21756c5f4cbc80$var$currentTreeHiddenStackCursor.current ? $0c21756c5f4cbc80$var$shellBoundary = handler : null !== current.memoizedState && ($0c21756c5f4cbc80$var$shellBoundary = handler));
}
function $0c21756c5f4cbc80$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$suspenseStackCursor, $0c21756c5f4cbc80$var$suspenseStackCursor.current);
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$suspenseHandlerStackCursor, fiber);
    null === $0c21756c5f4cbc80$var$shellBoundary && ($0c21756c5f4cbc80$var$shellBoundary = fiber);
}
function $0c21756c5f4cbc80$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$suspenseStackCursor, $0c21756c5f4cbc80$var$suspenseStackCursor.current), $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$suspenseHandlerStackCursor, fiber), null === $0c21756c5f4cbc80$var$shellBoundary && ($0c21756c5f4cbc80$var$shellBoundary = fiber)) : $0c21756c5f4cbc80$var$reuseSuspenseHandlerOnStack();
}
function $0c21756c5f4cbc80$var$reuseSuspenseHandlerOnStack() {
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$suspenseStackCursor, $0c21756c5f4cbc80$var$suspenseStackCursor.current);
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$suspenseHandlerStackCursor, $0c21756c5f4cbc80$var$suspenseHandlerStackCursor.current);
}
function $0c21756c5f4cbc80$var$popSuspenseHandler(fiber) {
    $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$suspenseHandlerStackCursor);
    $0c21756c5f4cbc80$var$shellBoundary === fiber && ($0c21756c5f4cbc80$var$shellBoundary = null);
    $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$suspenseStackCursor);
}
var $0c21756c5f4cbc80$var$suspenseStackCursor = $0c21756c5f4cbc80$var$createCursor(0);
function $0c21756c5f4cbc80$var$pushSuspenseListContext(fiber, newContext) {
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$suspenseHandlerStackCursor, $0c21756c5f4cbc80$var$suspenseHandlerStackCursor.current);
    $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$suspenseStackCursor, newContext);
}
function $0c21756c5f4cbc80$var$popSuspenseListContext(fiber) {
    $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$suspenseStackCursor);
    $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$suspenseHandlerStackCursor);
    $0c21756c5f4cbc80$var$shellBoundary === fiber && ($0c21756c5f4cbc80$var$shellBoundary = null);
}
function $0c21756c5f4cbc80$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $0c21756c5f4cbc80$var$isSuspenseInstancePending(state) || $0c21756c5f4cbc80$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $0c21756c5f4cbc80$var$renderLanes = 0, $0c21756c5f4cbc80$var$currentlyRenderingFiber = null, $0c21756c5f4cbc80$var$currentHook = null, $0c21756c5f4cbc80$var$workInProgressHook = null, $0c21756c5f4cbc80$var$didScheduleRenderPhaseUpdate = !1, $0c21756c5f4cbc80$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $0c21756c5f4cbc80$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $0c21756c5f4cbc80$var$localIdCounter = 0, $0c21756c5f4cbc80$var$thenableIndexCounter = 0, $0c21756c5f4cbc80$var$thenableState = null, $0c21756c5f4cbc80$var$globalClientIdCounter = 0;
function $0c21756c5f4cbc80$var$throwInvalidHookError() {
    throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(321));
}
function $0c21756c5f4cbc80$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$0c21756c5f4cbc80$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $0c21756c5f4cbc80$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $0c21756c5f4cbc80$var$renderLanes = nextRenderLanes;
    $0c21756c5f4cbc80$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $0c21756c5f4cbc80$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $0c21756c5f4cbc80$var$HooksDispatcherOnMount : $0c21756c5f4cbc80$var$HooksDispatcherOnUpdate;
    $0c21756c5f4cbc80$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $0c21756c5f4cbc80$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $0c21756c5f4cbc80$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $0c21756c5f4cbc80$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $0c21756c5f4cbc80$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $0c21756c5f4cbc80$var$finishRenderingHooks(current) {
    $0c21756c5f4cbc80$var$ReactSharedInternals.H = $0c21756c5f4cbc80$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $0c21756c5f4cbc80$var$currentHook && null !== $0c21756c5f4cbc80$var$currentHook.next;
    $0c21756c5f4cbc80$var$renderLanes = 0;
    $0c21756c5f4cbc80$var$workInProgressHook = $0c21756c5f4cbc80$var$currentHook = $0c21756c5f4cbc80$var$currentlyRenderingFiber = null;
    $0c21756c5f4cbc80$var$didScheduleRenderPhaseUpdate = !1;
    $0c21756c5f4cbc80$var$thenableIndexCounter = 0;
    $0c21756c5f4cbc80$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(300));
    null === current || $0c21756c5f4cbc80$var$didReceiveUpdate || (current = current.dependencies, null !== current && $0c21756c5f4cbc80$var$checkIfContextChanged(current) && ($0c21756c5f4cbc80$var$didReceiveUpdate = !0));
}
function $0c21756c5f4cbc80$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $0c21756c5f4cbc80$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $0c21756c5f4cbc80$var$didScheduleRenderPhaseUpdateDuringThisPass && ($0c21756c5f4cbc80$var$thenableState = null);
        $0c21756c5f4cbc80$var$thenableIndexCounter = 0;
        $0c21756c5f4cbc80$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $0c21756c5f4cbc80$var$workInProgressHook = $0c21756c5f4cbc80$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $0c21756c5f4cbc80$var$ReactSharedInternals.H = $0c21756c5f4cbc80$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($0c21756c5f4cbc80$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $0c21756c5f4cbc80$var$TransitionAwareHostComponent() {
    var dispatcher = $0c21756c5f4cbc80$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $0c21756c5f4cbc80$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $0c21756c5f4cbc80$var$currentHook ? $0c21756c5f4cbc80$var$currentHook.memoizedState : null) !== dispatcher && ($0c21756c5f4cbc80$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $0c21756c5f4cbc80$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $0c21756c5f4cbc80$var$localIdCounter;
    $0c21756c5f4cbc80$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $0c21756c5f4cbc80$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $0c21756c5f4cbc80$var$resetHooksOnUnwind(workInProgress) {
    if ($0c21756c5f4cbc80$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $0c21756c5f4cbc80$var$didScheduleRenderPhaseUpdate = !1;
    }
    $0c21756c5f4cbc80$var$renderLanes = 0;
    $0c21756c5f4cbc80$var$workInProgressHook = $0c21756c5f4cbc80$var$currentHook = $0c21756c5f4cbc80$var$currentlyRenderingFiber = null;
    $0c21756c5f4cbc80$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $0c21756c5f4cbc80$var$thenableIndexCounter = $0c21756c5f4cbc80$var$localIdCounter = 0;
    $0c21756c5f4cbc80$var$thenableState = null;
}
function $0c21756c5f4cbc80$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0c21756c5f4cbc80$var$workInProgressHook ? $0c21756c5f4cbc80$var$currentlyRenderingFiber.memoizedState = $0c21756c5f4cbc80$var$workInProgressHook = hook : $0c21756c5f4cbc80$var$workInProgressHook = $0c21756c5f4cbc80$var$workInProgressHook.next = hook;
    return $0c21756c5f4cbc80$var$workInProgressHook;
}
function $0c21756c5f4cbc80$var$updateWorkInProgressHook() {
    if (null === $0c21756c5f4cbc80$var$currentHook) {
        var nextCurrentHook = $0c21756c5f4cbc80$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $0c21756c5f4cbc80$var$currentHook.next;
    var nextWorkInProgressHook = null === $0c21756c5f4cbc80$var$workInProgressHook ? $0c21756c5f4cbc80$var$currentlyRenderingFiber.memoizedState : $0c21756c5f4cbc80$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $0c21756c5f4cbc80$var$workInProgressHook = nextWorkInProgressHook, $0c21756c5f4cbc80$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $0c21756c5f4cbc80$var$currentlyRenderingFiber.alternate) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(467));
            throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(310));
        }
        $0c21756c5f4cbc80$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $0c21756c5f4cbc80$var$currentHook.memoizedState,
            baseState: $0c21756c5f4cbc80$var$currentHook.baseState,
            baseQueue: $0c21756c5f4cbc80$var$currentHook.baseQueue,
            queue: $0c21756c5f4cbc80$var$currentHook.queue,
            next: null
        };
        null === $0c21756c5f4cbc80$var$workInProgressHook ? $0c21756c5f4cbc80$var$currentlyRenderingFiber.memoizedState = $0c21756c5f4cbc80$var$workInProgressHook = nextCurrentHook : $0c21756c5f4cbc80$var$workInProgressHook = $0c21756c5f4cbc80$var$workInProgressHook.next = nextCurrentHook;
    }
    return $0c21756c5f4cbc80$var$workInProgressHook;
}
function $0c21756c5f4cbc80$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $0c21756c5f4cbc80$var$useThenable(thenable) {
    var index = $0c21756c5f4cbc80$var$thenableIndexCounter;
    $0c21756c5f4cbc80$var$thenableIndexCounter += 1;
    null === $0c21756c5f4cbc80$var$thenableState && ($0c21756c5f4cbc80$var$thenableState = []);
    thenable = $0c21756c5f4cbc80$var$trackUsedThenable($0c21756c5f4cbc80$var$thenableState, thenable, index);
    index = $0c21756c5f4cbc80$var$currentlyRenderingFiber;
    null === (null === $0c21756c5f4cbc80$var$workInProgressHook ? index.memoizedState : $0c21756c5f4cbc80$var$workInProgressHook.next) && (index = index.alternate, $0c21756c5f4cbc80$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $0c21756c5f4cbc80$var$HooksDispatcherOnMount : $0c21756c5f4cbc80$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $0c21756c5f4cbc80$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $0c21756c5f4cbc80$var$useThenable(usable);
        if (usable.$$typeof === $0c21756c5f4cbc80$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $0c21756c5f4cbc80$var$REACT_CONTEXT_TYPE) return $0c21756c5f4cbc80$var$readContext(usable);
    }
    throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(438, String(usable)));
}
function $0c21756c5f4cbc80$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $0c21756c5f4cbc80$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $0c21756c5f4cbc80$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $0c21756c5f4cbc80$var$createFunctionComponentUpdateQueue(), $0c21756c5f4cbc80$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $0c21756c5f4cbc80$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $0c21756c5f4cbc80$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $0c21756c5f4cbc80$var$updateReducer(reducer) {
    var hook = $0c21756c5f4cbc80$var$updateWorkInProgressHook();
    return $0c21756c5f4cbc80$var$updateReducerImpl(hook, $0c21756c5f4cbc80$var$currentHook, reducer);
}
function $0c21756c5f4cbc80$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($0c21756c5f4cbc80$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($0c21756c5f4cbc80$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $0c21756c5f4cbc80$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($0c21756c5f4cbc80$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $0c21756c5f4cbc80$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $0c21756c5f4cbc80$var$currentlyRenderingFiber.lanes |= revertLane, $0c21756c5f4cbc80$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $0c21756c5f4cbc80$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $0c21756c5f4cbc80$var$currentlyRenderingFiber.lanes |= updateLane, $0c21756c5f4cbc80$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$0c21756c5f4cbc80$var$objectIs(pendingQueue, hook.memoizedState) && ($0c21756c5f4cbc80$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $0c21756c5f4cbc80$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $0c21756c5f4cbc80$var$rerenderReducer(reducer) {
    var hook = $0c21756c5f4cbc80$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $0c21756c5f4cbc80$var$objectIs(newState, hook.memoizedState) || ($0c21756c5f4cbc80$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $0c21756c5f4cbc80$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $0c21756c5f4cbc80$var$currentlyRenderingFiber, hook = $0c21756c5f4cbc80$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $0c21756c5f4cbc80$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$0c21756c5f4cbc80$var$objectIs(($0c21756c5f4cbc80$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $0c21756c5f4cbc80$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $0c21756c5f4cbc80$var$updateEffect($0c21756c5f4cbc80$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $0c21756c5f4cbc80$var$workInProgressHook && 0 !== ($0c21756c5f4cbc80$var$workInProgressHook.memoizedState.tag & 1);
    $0c21756c5f4cbc80$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $0c21756c5f4cbc80$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $0c21756c5f4cbc80$var$workInProgressRoot) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($0c21756c5f4cbc80$var$renderLanes & 127) || $0c21756c5f4cbc80$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $0c21756c5f4cbc80$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $0c21756c5f4cbc80$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $0c21756c5f4cbc80$var$createFunctionComponentUpdateQueue(), $0c21756c5f4cbc80$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $0c21756c5f4cbc80$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $0c21756c5f4cbc80$var$checkIfSnapshotChanged(inst) && $0c21756c5f4cbc80$var$forceStoreRerender(fiber);
}
function $0c21756c5f4cbc80$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $0c21756c5f4cbc80$var$checkIfSnapshotChanged(inst) && $0c21756c5f4cbc80$var$forceStoreRerender(fiber);
    });
}
function $0c21756c5f4cbc80$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$0c21756c5f4cbc80$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $0c21756c5f4cbc80$var$forceStoreRerender(fiber) {
    var root = $0c21756c5f4cbc80$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $0c21756c5f4cbc80$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $0c21756c5f4cbc80$var$mountStateImpl(initialState) {
    var hook = $0c21756c5f4cbc80$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($0c21756c5f4cbc80$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $0c21756c5f4cbc80$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $0c21756c5f4cbc80$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0c21756c5f4cbc80$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $0c21756c5f4cbc80$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $0c21756c5f4cbc80$var$updateReducerImpl(hook, $0c21756c5f4cbc80$var$currentHook, "function" === typeof reducer ? reducer : $0c21756c5f4cbc80$var$basicStateReducer);
}
function $0c21756c5f4cbc80$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($0c21756c5f4cbc80$var$isRenderPhaseUpdate(fiber)) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $0c21756c5f4cbc80$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $0c21756c5f4cbc80$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $0c21756c5f4cbc80$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $0c21756c5f4cbc80$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $0c21756c5f4cbc80$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $0c21756c5f4cbc80$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $0c21756c5f4cbc80$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $0c21756c5f4cbc80$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $0c21756c5f4cbc80$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $0c21756c5f4cbc80$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $0c21756c5f4cbc80$var$onActionError(actionQueue, node, error$70);
    }
}
function $0c21756c5f4cbc80$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $0c21756c5f4cbc80$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $0c21756c5f4cbc80$var$onActionError(actionQueue, node, error);
    }) : $0c21756c5f4cbc80$var$onActionSuccess(actionQueue, node, returnValue);
}
function $0c21756c5f4cbc80$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $0c21756c5f4cbc80$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $0c21756c5f4cbc80$var$runActionStateAction(actionQueue, nextState)));
}
function $0c21756c5f4cbc80$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $0c21756c5f4cbc80$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $0c21756c5f4cbc80$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $0c21756c5f4cbc80$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $0c21756c5f4cbc80$var$mountActionState(action, initialStateProp) {
    if ($0c21756c5f4cbc80$var$isHydrating) {
        var ssrFormState = $0c21756c5f4cbc80$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $0c21756c5f4cbc80$var$currentlyRenderingFiber;
                if ($0c21756c5f4cbc80$var$isHydrating) {
                    if ($0c21756c5f4cbc80$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $0c21756c5f4cbc80$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $0c21756c5f4cbc80$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $0c21756c5f4cbc80$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $0c21756c5f4cbc80$var$nextHydratableInstance = $0c21756c5f4cbc80$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $0c21756c5f4cbc80$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $0c21756c5f4cbc80$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0c21756c5f4cbc80$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $0c21756c5f4cbc80$var$dispatchSetState.bind(null, $0c21756c5f4cbc80$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $0c21756c5f4cbc80$var$mountStateImpl(!1);
    inRootOrSingleton = $0c21756c5f4cbc80$var$dispatchOptimisticSetState.bind(null, $0c21756c5f4cbc80$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $0c21756c5f4cbc80$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $0c21756c5f4cbc80$var$dispatchActionState.bind(null, $0c21756c5f4cbc80$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $0c21756c5f4cbc80$var$updateActionState(action) {
    var stateHook = $0c21756c5f4cbc80$var$updateWorkInProgressHook();
    return $0c21756c5f4cbc80$var$updateActionStateImpl(stateHook, $0c21756c5f4cbc80$var$currentHook, action);
}
function $0c21756c5f4cbc80$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $0c21756c5f4cbc80$var$updateReducerImpl(stateHook, currentStateHook, $0c21756c5f4cbc80$var$actionStateReducer)[0];
    stateHook = $0c21756c5f4cbc80$var$updateReducer($0c21756c5f4cbc80$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $0c21756c5f4cbc80$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $0c21756c5f4cbc80$var$SuspenseException) throw $0c21756c5f4cbc80$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $0c21756c5f4cbc80$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($0c21756c5f4cbc80$var$currentlyRenderingFiber.flags |= 2048, $0c21756c5f4cbc80$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $0c21756c5f4cbc80$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $0c21756c5f4cbc80$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $0c21756c5f4cbc80$var$rerenderActionState(action) {
    var stateHook = $0c21756c5f4cbc80$var$updateWorkInProgressHook(), currentStateHook = $0c21756c5f4cbc80$var$currentHook;
    if (null !== currentStateHook) return $0c21756c5f4cbc80$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $0c21756c5f4cbc80$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $0c21756c5f4cbc80$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $0c21756c5f4cbc80$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $0c21756c5f4cbc80$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $0c21756c5f4cbc80$var$createFunctionComponentUpdateQueue(), $0c21756c5f4cbc80$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $0c21756c5f4cbc80$var$updateRef() {
    return $0c21756c5f4cbc80$var$updateWorkInProgressHook().memoizedState;
}
function $0c21756c5f4cbc80$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $0c21756c5f4cbc80$var$mountWorkInProgressHook();
    $0c21756c5f4cbc80$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $0c21756c5f4cbc80$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $0c21756c5f4cbc80$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $0c21756c5f4cbc80$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $0c21756c5f4cbc80$var$currentHook && null !== deps && $0c21756c5f4cbc80$var$areHookInputsEqual(deps, $0c21756c5f4cbc80$var$currentHook.memoizedState.deps) ? hook.memoizedState = $0c21756c5f4cbc80$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($0c21756c5f4cbc80$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $0c21756c5f4cbc80$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $0c21756c5f4cbc80$var$mountEffect(create, deps) {
    $0c21756c5f4cbc80$var$mountEffectImpl(8390656, 8, create, deps);
}
function $0c21756c5f4cbc80$var$updateEffect(create, deps) {
    $0c21756c5f4cbc80$var$updateEffectImpl(2048, 8, create, deps);
}
function $0c21756c5f4cbc80$var$useEffectEventImpl(payload) {
    $0c21756c5f4cbc80$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $0c21756c5f4cbc80$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $0c21756c5f4cbc80$var$createFunctionComponentUpdateQueue(), $0c21756c5f4cbc80$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $0c21756c5f4cbc80$var$updateEvent(callback) {
    var ref = $0c21756c5f4cbc80$var$updateWorkInProgressHook().memoizedState;
    $0c21756c5f4cbc80$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($0c21756c5f4cbc80$var$executionContext & 2)) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $0c21756c5f4cbc80$var$updateInsertionEffect(create, deps) {
    return $0c21756c5f4cbc80$var$updateEffectImpl(4, 2, create, deps);
}
function $0c21756c5f4cbc80$var$updateLayoutEffect(create, deps) {
    return $0c21756c5f4cbc80$var$updateEffectImpl(4, 4, create, deps);
}
function $0c21756c5f4cbc80$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $0c21756c5f4cbc80$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $0c21756c5f4cbc80$var$updateEffectImpl(4, 4, $0c21756c5f4cbc80$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $0c21756c5f4cbc80$var$mountDebugValue() {}
function $0c21756c5f4cbc80$var$updateCallback(callback, deps) {
    var hook = $0c21756c5f4cbc80$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $0c21756c5f4cbc80$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $0c21756c5f4cbc80$var$updateMemo(nextCreate, deps) {
    var hook = $0c21756c5f4cbc80$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $0c21756c5f4cbc80$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($0c21756c5f4cbc80$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $0c21756c5f4cbc80$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $0c21756c5f4cbc80$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $0c21756c5f4cbc80$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($0c21756c5f4cbc80$var$renderLanes & 1073741824) && 0 === ($0c21756c5f4cbc80$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $0c21756c5f4cbc80$var$requestDeferredLane();
    $0c21756c5f4cbc80$var$currentlyRenderingFiber.lanes |= hook;
    $0c21756c5f4cbc80$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $0c21756c5f4cbc80$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($0c21756c5f4cbc80$var$objectIs(value, prevValue)) return value;
    if (null !== $0c21756c5f4cbc80$var$currentTreeHiddenStackCursor.current) return hook = $0c21756c5f4cbc80$var$mountDeferredValueImpl(hook, value, initialValue), $0c21756c5f4cbc80$var$objectIs(hook, prevValue) || ($0c21756c5f4cbc80$var$didReceiveUpdate = !0), hook;
    if (0 === ($0c21756c5f4cbc80$var$renderLanes & 106) || 0 !== ($0c21756c5f4cbc80$var$renderLanes & 1073741824) && 0 === ($0c21756c5f4cbc80$var$workInProgressRootRenderLanes & 261930)) return $0c21756c5f4cbc80$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $0c21756c5f4cbc80$var$requestDeferredLane();
    $0c21756c5f4cbc80$var$currentlyRenderingFiber.lanes |= hook;
    $0c21756c5f4cbc80$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $0c21756c5f4cbc80$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p;
    $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $0c21756c5f4cbc80$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $0c21756c5f4cbc80$var$ReactSharedInternals.T = currentTransition;
    $0c21756c5f4cbc80$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $0c21756c5f4cbc80$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $0c21756c5f4cbc80$var$chainThenableValue(returnValue, finishedState);
            $0c21756c5f4cbc80$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $0c21756c5f4cbc80$var$requestUpdateLane(fiber));
        } else $0c21756c5f4cbc80$var$dispatchSetStateInternal(fiber, queue, finishedState, $0c21756c5f4cbc80$var$requestUpdateLane(fiber));
    } catch (error) {
        $0c21756c5f4cbc80$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $0c21756c5f4cbc80$var$requestUpdateLane());
    } finally{
        $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $0c21756c5f4cbc80$var$ReactSharedInternals.T = prevTransition;
    }
}
function $0c21756c5f4cbc80$var$noop() {}
function $0c21756c5f4cbc80$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(476));
    var queue = $0c21756c5f4cbc80$var$ensureFormComponentIsStateful(formFiber).queue;
    $0c21756c5f4cbc80$var$startTransition(formFiber, queue, pendingState, $0c21756c5f4cbc80$var$sharedNotPendingObject, null === action ? $0c21756c5f4cbc80$var$noop : function() {
        $0c21756c5f4cbc80$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $0c21756c5f4cbc80$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $0c21756c5f4cbc80$var$sharedNotPendingObject,
        baseState: $0c21756c5f4cbc80$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $0c21756c5f4cbc80$var$basicStateReducer,
            lastRenderedState: $0c21756c5f4cbc80$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $0c21756c5f4cbc80$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $0c21756c5f4cbc80$var$requestFormReset$1(formFiber) {
    var stateHook = $0c21756c5f4cbc80$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $0c21756c5f4cbc80$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $0c21756c5f4cbc80$var$requestUpdateLane());
}
function $0c21756c5f4cbc80$var$useHostTransitionStatus() {
    return $0c21756c5f4cbc80$var$readContext($0c21756c5f4cbc80$var$HostTransitionContext);
}
function $0c21756c5f4cbc80$var$updateId() {
    return $0c21756c5f4cbc80$var$updateWorkInProgressHook().memoizedState;
}
function $0c21756c5f4cbc80$var$updateRefresh() {
    return $0c21756c5f4cbc80$var$updateWorkInProgressHook().memoizedState;
}
function $0c21756c5f4cbc80$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $0c21756c5f4cbc80$var$requestUpdateLane();
                fiber = $0c21756c5f4cbc80$var$createUpdate(lane);
                var root$73 = $0c21756c5f4cbc80$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($0c21756c5f4cbc80$var$scheduleUpdateOnFiber(root$73, provider, lane), $0c21756c5f4cbc80$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $0c21756c5f4cbc80$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $0c21756c5f4cbc80$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $0c21756c5f4cbc80$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $0c21756c5f4cbc80$var$isRenderPhaseUpdate(fiber) ? $0c21756c5f4cbc80$var$enqueueRenderPhaseUpdate(queue, action) : (action = $0c21756c5f4cbc80$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($0c21756c5f4cbc80$var$scheduleUpdateOnFiber(action, fiber, lane), $0c21756c5f4cbc80$var$entangleTransitionUpdate(action, queue, lane)));
}
function $0c21756c5f4cbc80$var$dispatchSetState(fiber, queue, action) {
    var lane = $0c21756c5f4cbc80$var$requestUpdateLane();
    $0c21756c5f4cbc80$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $0c21756c5f4cbc80$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0c21756c5f4cbc80$var$isRenderPhaseUpdate(fiber)) $0c21756c5f4cbc80$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($0c21756c5f4cbc80$var$objectIs(eagerState, currentState)) return $0c21756c5f4cbc80$var$enqueueUpdate$1(fiber, queue, update, 0), null === $0c21756c5f4cbc80$var$workInProgressRoot && $0c21756c5f4cbc80$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $0c21756c5f4cbc80$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $0c21756c5f4cbc80$var$scheduleUpdateOnFiber(action, fiber, lane), $0c21756c5f4cbc80$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $0c21756c5f4cbc80$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $0c21756c5f4cbc80$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0c21756c5f4cbc80$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $0c21756c5f4cbc80$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $0c21756c5f4cbc80$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $0c21756c5f4cbc80$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $0c21756c5f4cbc80$var$currentlyRenderingFiber || null !== alternate && alternate === $0c21756c5f4cbc80$var$currentlyRenderingFiber;
}
function $0c21756c5f4cbc80$var$enqueueRenderPhaseUpdate(queue, update) {
    $0c21756c5f4cbc80$var$didScheduleRenderPhaseUpdateDuringThisPass = $0c21756c5f4cbc80$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $0c21756c5f4cbc80$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $0c21756c5f4cbc80$var$markRootEntangled(root, lane);
    }
}
var $0c21756c5f4cbc80$var$ContextOnlyDispatcher = {
    readContext: $0c21756c5f4cbc80$var$readContext,
    use: $0c21756c5f4cbc80$var$use,
    useCallback: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useContext: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useEffect: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useImperativeHandle: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useLayoutEffect: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useInsertionEffect: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useMemo: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useReducer: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useRef: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useState: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useDebugValue: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useDeferredValue: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useTransition: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useSyncExternalStore: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useId: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useHostTransitionStatus: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useFormState: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useActionState: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useOptimistic: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useMemoCache: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useCacheRefresh: $0c21756c5f4cbc80$var$throwInvalidHookError,
    useEffectEvent: $0c21756c5f4cbc80$var$throwInvalidHookError
}, $0c21756c5f4cbc80$var$HooksDispatcherOnMount = {
    readContext: $0c21756c5f4cbc80$var$readContext,
    use: $0c21756c5f4cbc80$var$use,
    useCallback: function(callback, deps) {
        $0c21756c5f4cbc80$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $0c21756c5f4cbc80$var$readContext,
    useEffect: $0c21756c5f4cbc80$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $0c21756c5f4cbc80$var$mountEffectImpl(4194308, 4, $0c21756c5f4cbc80$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $0c21756c5f4cbc80$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $0c21756c5f4cbc80$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $0c21756c5f4cbc80$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($0c21756c5f4cbc80$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $0c21756c5f4cbc80$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $0c21756c5f4cbc80$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $0c21756c5f4cbc80$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($0c21756c5f4cbc80$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $0c21756c5f4cbc80$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $0c21756c5f4cbc80$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $0c21756c5f4cbc80$var$dispatchReducerAction.bind(null, $0c21756c5f4cbc80$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $0c21756c5f4cbc80$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $0c21756c5f4cbc80$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $0c21756c5f4cbc80$var$dispatchSetState.bind(null, $0c21756c5f4cbc80$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $0c21756c5f4cbc80$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $0c21756c5f4cbc80$var$mountWorkInProgressHook();
        return $0c21756c5f4cbc80$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $0c21756c5f4cbc80$var$mountStateImpl(!1);
        stateHook = $0c21756c5f4cbc80$var$startTransition.bind(null, $0c21756c5f4cbc80$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $0c21756c5f4cbc80$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $0c21756c5f4cbc80$var$currentlyRenderingFiber, hook = $0c21756c5f4cbc80$var$mountWorkInProgressHook();
        if ($0c21756c5f4cbc80$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $0c21756c5f4cbc80$var$workInProgressRoot) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(349));
            0 !== ($0c21756c5f4cbc80$var$workInProgressRootRenderLanes & 127) || $0c21756c5f4cbc80$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $0c21756c5f4cbc80$var$mountEffect($0c21756c5f4cbc80$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $0c21756c5f4cbc80$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $0c21756c5f4cbc80$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $0c21756c5f4cbc80$var$mountWorkInProgressHook(), identifierPrefix = $0c21756c5f4cbc80$var$workInProgressRoot.identifierPrefix;
        if ($0c21756c5f4cbc80$var$isHydrating) {
            var JSCompiler_inline_result = $0c21756c5f4cbc80$var$treeContextOverflow;
            var idWithLeadingBit = $0c21756c5f4cbc80$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $0c21756c5f4cbc80$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $0c21756c5f4cbc80$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $0c21756c5f4cbc80$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $0c21756c5f4cbc80$var$useHostTransitionStatus,
    useFormState: $0c21756c5f4cbc80$var$mountActionState,
    useActionState: $0c21756c5f4cbc80$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $0c21756c5f4cbc80$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $0c21756c5f4cbc80$var$dispatchOptimisticSetState.bind(null, $0c21756c5f4cbc80$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $0c21756c5f4cbc80$var$useMemoCache,
    useCacheRefresh: function() {
        return $0c21756c5f4cbc80$var$mountWorkInProgressHook().memoizedState = $0c21756c5f4cbc80$var$refreshCache.bind(null, $0c21756c5f4cbc80$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $0c21756c5f4cbc80$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($0c21756c5f4cbc80$var$executionContext & 2)) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $0c21756c5f4cbc80$var$HooksDispatcherOnUpdate = {
    readContext: $0c21756c5f4cbc80$var$readContext,
    use: $0c21756c5f4cbc80$var$use,
    useCallback: $0c21756c5f4cbc80$var$updateCallback,
    useContext: $0c21756c5f4cbc80$var$readContext,
    useEffect: $0c21756c5f4cbc80$var$updateEffect,
    useImperativeHandle: $0c21756c5f4cbc80$var$updateImperativeHandle,
    useInsertionEffect: $0c21756c5f4cbc80$var$updateInsertionEffect,
    useLayoutEffect: $0c21756c5f4cbc80$var$updateLayoutEffect,
    useMemo: $0c21756c5f4cbc80$var$updateMemo,
    useReducer: $0c21756c5f4cbc80$var$updateReducer,
    useRef: $0c21756c5f4cbc80$var$updateRef,
    useState: function() {
        return $0c21756c5f4cbc80$var$updateReducer($0c21756c5f4cbc80$var$basicStateReducer);
    },
    useDebugValue: $0c21756c5f4cbc80$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $0c21756c5f4cbc80$var$updateWorkInProgressHook();
        return $0c21756c5f4cbc80$var$updateDeferredValueImpl(hook, $0c21756c5f4cbc80$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $0c21756c5f4cbc80$var$updateReducer($0c21756c5f4cbc80$var$basicStateReducer)[0], start = $0c21756c5f4cbc80$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $0c21756c5f4cbc80$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $0c21756c5f4cbc80$var$updateSyncExternalStore,
    useId: $0c21756c5f4cbc80$var$updateId,
    useHostTransitionStatus: $0c21756c5f4cbc80$var$useHostTransitionStatus,
    useFormState: $0c21756c5f4cbc80$var$updateActionState,
    useActionState: $0c21756c5f4cbc80$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $0c21756c5f4cbc80$var$updateWorkInProgressHook();
        return $0c21756c5f4cbc80$var$updateOptimisticImpl(hook, $0c21756c5f4cbc80$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $0c21756c5f4cbc80$var$useMemoCache,
    useCacheRefresh: $0c21756c5f4cbc80$var$updateRefresh,
    useEffectEvent: $0c21756c5f4cbc80$var$updateEvent
}, $0c21756c5f4cbc80$var$HooksDispatcherOnRerender = {
    readContext: $0c21756c5f4cbc80$var$readContext,
    use: $0c21756c5f4cbc80$var$use,
    useCallback: $0c21756c5f4cbc80$var$updateCallback,
    useContext: $0c21756c5f4cbc80$var$readContext,
    useEffect: $0c21756c5f4cbc80$var$updateEffect,
    useImperativeHandle: $0c21756c5f4cbc80$var$updateImperativeHandle,
    useInsertionEffect: $0c21756c5f4cbc80$var$updateInsertionEffect,
    useLayoutEffect: $0c21756c5f4cbc80$var$updateLayoutEffect,
    useMemo: $0c21756c5f4cbc80$var$updateMemo,
    useReducer: $0c21756c5f4cbc80$var$rerenderReducer,
    useRef: $0c21756c5f4cbc80$var$updateRef,
    useState: function() {
        return $0c21756c5f4cbc80$var$rerenderReducer($0c21756c5f4cbc80$var$basicStateReducer);
    },
    useDebugValue: $0c21756c5f4cbc80$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $0c21756c5f4cbc80$var$updateWorkInProgressHook();
        return null === $0c21756c5f4cbc80$var$currentHook ? $0c21756c5f4cbc80$var$mountDeferredValueImpl(hook, value, initialValue) : $0c21756c5f4cbc80$var$updateDeferredValueImpl(hook, $0c21756c5f4cbc80$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $0c21756c5f4cbc80$var$rerenderReducer($0c21756c5f4cbc80$var$basicStateReducer)[0], start = $0c21756c5f4cbc80$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $0c21756c5f4cbc80$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $0c21756c5f4cbc80$var$updateSyncExternalStore,
    useId: $0c21756c5f4cbc80$var$updateId,
    useHostTransitionStatus: $0c21756c5f4cbc80$var$useHostTransitionStatus,
    useFormState: $0c21756c5f4cbc80$var$rerenderActionState,
    useActionState: $0c21756c5f4cbc80$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $0c21756c5f4cbc80$var$updateWorkInProgressHook();
        if (null !== $0c21756c5f4cbc80$var$currentHook) return $0c21756c5f4cbc80$var$updateOptimisticImpl(hook, $0c21756c5f4cbc80$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $0c21756c5f4cbc80$var$useMemoCache,
    useCacheRefresh: $0c21756c5f4cbc80$var$updateRefresh,
    useEffectEvent: $0c21756c5f4cbc80$var$updateEvent
};
function $0c21756c5f4cbc80$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $0c21756c5f4cbc80$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $0c21756c5f4cbc80$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $0c21756c5f4cbc80$var$requestUpdateLane(), update = $0c21756c5f4cbc80$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $0c21756c5f4cbc80$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($0c21756c5f4cbc80$var$scheduleUpdateOnFiber(payload, inst, lane), $0c21756c5f4cbc80$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $0c21756c5f4cbc80$var$requestUpdateLane(), update = $0c21756c5f4cbc80$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $0c21756c5f4cbc80$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($0c21756c5f4cbc80$var$scheduleUpdateOnFiber(payload, inst, lane), $0c21756c5f4cbc80$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $0c21756c5f4cbc80$var$requestUpdateLane(), update = $0c21756c5f4cbc80$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $0c21756c5f4cbc80$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($0c21756c5f4cbc80$var$scheduleUpdateOnFiber(callback, inst, lane), $0c21756c5f4cbc80$var$entangleTransitions(callback, inst, lane));
    }
};
function $0c21756c5f4cbc80$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$0c21756c5f4cbc80$var$shallowEqual(oldProps, newProps) || !$0c21756c5f4cbc80$var$shallowEqual(oldState, newState) : !0;
}
function $0c21756c5f4cbc80$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $0c21756c5f4cbc80$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $0c21756c5f4cbc80$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $0c21756c5f4cbc80$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $0c21756c5f4cbc80$var$defaultOnUncaughtError(error) {
    $0c21756c5f4cbc80$var$reportGlobalError(error);
}
function $0c21756c5f4cbc80$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $0c21756c5f4cbc80$var$defaultOnRecoverableError(error) {
    $0c21756c5f4cbc80$var$reportGlobalError(error);
}
function $0c21756c5f4cbc80$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $0c21756c5f4cbc80$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $0c21756c5f4cbc80$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $0c21756c5f4cbc80$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $0c21756c5f4cbc80$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $0c21756c5f4cbc80$var$createClassErrorUpdate(lane) {
    lane = $0c21756c5f4cbc80$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $0c21756c5f4cbc80$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $0c21756c5f4cbc80$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $0c21756c5f4cbc80$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $0c21756c5f4cbc80$var$legacyErrorBoundariesThatAlreadyFailed ? $0c21756c5f4cbc80$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $0c21756c5f4cbc80$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $0c21756c5f4cbc80$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $0c21756c5f4cbc80$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $0c21756c5f4cbc80$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $0c21756c5f4cbc80$var$shellBoundary ? $0c21756c5f4cbc80$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $0c21756c5f4cbc80$var$workInProgressRootExitStatus && ($0c21756c5f4cbc80$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $0c21756c5f4cbc80$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $0c21756c5f4cbc80$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $0c21756c5f4cbc80$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $0c21756c5f4cbc80$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $0c21756c5f4cbc80$var$attachPingListener(root, value, rootRenderLanes);
        $0c21756c5f4cbc80$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($0c21756c5f4cbc80$var$isHydrating) return returnFiber = $0c21756c5f4cbc80$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $0c21756c5f4cbc80$var$HydrationMismatchException && (root = Error($0c21756c5f4cbc80$var$formatProdErrorMessage(422), {
        cause: value
    }), $0c21756c5f4cbc80$var$queueHydrationError($0c21756c5f4cbc80$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $0c21756c5f4cbc80$var$HydrationMismatchException && (returnFiber = Error($0c21756c5f4cbc80$var$formatProdErrorMessage(423), {
        cause: value
    }), $0c21756c5f4cbc80$var$queueHydrationError($0c21756c5f4cbc80$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $0c21756c5f4cbc80$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $0c21756c5f4cbc80$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $0c21756c5f4cbc80$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $0c21756c5f4cbc80$var$workInProgressRootExitStatus && ($0c21756c5f4cbc80$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($0c21756c5f4cbc80$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $0c21756c5f4cbc80$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $0c21756c5f4cbc80$var$workInProgressRootConcurrentErrors ? $0c21756c5f4cbc80$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $0c21756c5f4cbc80$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $0c21756c5f4cbc80$var$workInProgressRootExitStatus && ($0c21756c5f4cbc80$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $0c21756c5f4cbc80$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $0c21756c5f4cbc80$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $0c21756c5f4cbc80$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $0c21756c5f4cbc80$var$legacyErrorBoundariesThatAlreadyFailed || !$0c21756c5f4cbc80$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $0c21756c5f4cbc80$var$createClassErrorUpdate(rootRenderLanes), $0c21756c5f4cbc80$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $0c21756c5f4cbc80$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $0c21756c5f4cbc80$var$SelectiveHydrationException = Error($0c21756c5f4cbc80$var$formatProdErrorMessage(461)), $0c21756c5f4cbc80$var$didReceiveUpdate = !1;
function $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $0c21756c5f4cbc80$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $0c21756c5f4cbc80$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $0c21756c5f4cbc80$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $0c21756c5f4cbc80$var$prepareToReadContext(workInProgress);
    nextProps = $0c21756c5f4cbc80$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $0c21756c5f4cbc80$var$checkDidRenderIdHook();
    if (null !== current && !$0c21756c5f4cbc80$var$didReceiveUpdate) return $0c21756c5f4cbc80$var$bailoutHooks(current, workInProgress, renderLanes), $0c21756c5f4cbc80$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $0c21756c5f4cbc80$var$isHydrating && key && $0c21756c5f4cbc80$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $0c21756c5f4cbc80$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$0c21756c5f4cbc80$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $0c21756c5f4cbc80$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $0c21756c5f4cbc80$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$0c21756c5f4cbc80$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $0c21756c5f4cbc80$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $0c21756c5f4cbc80$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $0c21756c5f4cbc80$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $0c21756c5f4cbc80$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($0c21756c5f4cbc80$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($0c21756c5f4cbc80$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $0c21756c5f4cbc80$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($0c21756c5f4cbc80$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $0c21756c5f4cbc80$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $0c21756c5f4cbc80$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $0c21756c5f4cbc80$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $0c21756c5f4cbc80$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $0c21756c5f4cbc80$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $0c21756c5f4cbc80$var$pushHiddenContext(workInProgress, prevState) : $0c21756c5f4cbc80$var$reuseHiddenContextOnStack(), $0c21756c5f4cbc80$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $0c21756c5f4cbc80$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($0c21756c5f4cbc80$var$pushTransition(workInProgress, prevState.cachePool), $0c21756c5f4cbc80$var$pushHiddenContext(workInProgress, prevState), $0c21756c5f4cbc80$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $0c21756c5f4cbc80$var$pushTransition(workInProgress, null), $0c21756c5f4cbc80$var$reuseHiddenContextOnStack(), $0c21756c5f4cbc80$var$reuseSuspenseHandlerOnStack());
    $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $0c21756c5f4cbc80$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $0c21756c5f4cbc80$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $0c21756c5f4cbc80$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $0c21756c5f4cbc80$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $0c21756c5f4cbc80$var$pushTransition(workInProgress, null);
    $0c21756c5f4cbc80$var$reuseHiddenContextOnStack();
    $0c21756c5f4cbc80$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $0c21756c5f4cbc80$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $0c21756c5f4cbc80$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $0c21756c5f4cbc80$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $0c21756c5f4cbc80$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $0c21756c5f4cbc80$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $0c21756c5f4cbc80$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $0c21756c5f4cbc80$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $0c21756c5f4cbc80$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($0c21756c5f4cbc80$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $0c21756c5f4cbc80$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $0c21756c5f4cbc80$var$bailoutOffscreenComponent(null, current);
            $0c21756c5f4cbc80$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $0c21756c5f4cbc80$var$nextHydratableInstance) ? (current = $0c21756c5f4cbc80$var$canHydrateHydrationBoundary(current, $0c21756c5f4cbc80$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $0c21756c5f4cbc80$var$treeContextProvider ? {
                    id: $0c21756c5f4cbc80$var$treeContextId,
                    overflow: $0c21756c5f4cbc80$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $0c21756c5f4cbc80$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $0c21756c5f4cbc80$var$hydrationParentFiber = workInProgress, $0c21756c5f4cbc80$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $0c21756c5f4cbc80$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $0c21756c5f4cbc80$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $0c21756c5f4cbc80$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $0c21756c5f4cbc80$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(558));
        } else if ($0c21756c5f4cbc80$var$didReceiveUpdate || $0c21756c5f4cbc80$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $0c21756c5f4cbc80$var$didReceiveUpdate || didSuspend) {
            if (null === $0c21756c5f4cbc80$var$currentTreeHiddenStackCursor.current) {
                nextProps = $0c21756c5f4cbc80$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $0c21756c5f4cbc80$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $0c21756c5f4cbc80$var$enqueueConcurrentRenderForLane(current, dehydrated), $0c21756c5f4cbc80$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $0c21756c5f4cbc80$var$SelectiveHydrationException;
                $0c21756c5f4cbc80$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $0c21756c5f4cbc80$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $0c21756c5f4cbc80$var$nextHydratableInstance = $0c21756c5f4cbc80$var$getNextHydratable(dehydrated.nextSibling), $0c21756c5f4cbc80$var$hydrationParentFiber = workInProgress, $0c21756c5f4cbc80$var$isHydrating = !0, $0c21756c5f4cbc80$var$hydrationErrors = null, $0c21756c5f4cbc80$var$rootOrSingletonContext = !1, null !== current && $0c21756c5f4cbc80$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $0c21756c5f4cbc80$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $0c21756c5f4cbc80$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $0c21756c5f4cbc80$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $0c21756c5f4cbc80$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $0c21756c5f4cbc80$var$prepareToReadContext(workInProgress);
    Component = $0c21756c5f4cbc80$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $0c21756c5f4cbc80$var$checkDidRenderIdHook();
    if (null !== current && !$0c21756c5f4cbc80$var$didReceiveUpdate) return $0c21756c5f4cbc80$var$bailoutHooks(current, workInProgress, renderLanes), $0c21756c5f4cbc80$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $0c21756c5f4cbc80$var$isHydrating && nextProps && $0c21756c5f4cbc80$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $0c21756c5f4cbc80$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $0c21756c5f4cbc80$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $0c21756c5f4cbc80$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $0c21756c5f4cbc80$var$finishRenderingHooks(current);
    Component = $0c21756c5f4cbc80$var$checkDidRenderIdHook();
    if (null !== current && !$0c21756c5f4cbc80$var$didReceiveUpdate) return $0c21756c5f4cbc80$var$bailoutHooks(current, workInProgress, renderLanes), $0c21756c5f4cbc80$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $0c21756c5f4cbc80$var$isHydrating && Component && $0c21756c5f4cbc80$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $0c21756c5f4cbc80$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $0c21756c5f4cbc80$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $0c21756c5f4cbc80$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $0c21756c5f4cbc80$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $0c21756c5f4cbc80$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $0c21756c5f4cbc80$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $0c21756c5f4cbc80$var$readContext(contextType) : $0c21756c5f4cbc80$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($0c21756c5f4cbc80$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $0c21756c5f4cbc80$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $0c21756c5f4cbc80$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $0c21756c5f4cbc80$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $0c21756c5f4cbc80$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $0c21756c5f4cbc80$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $0c21756c5f4cbc80$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $0c21756c5f4cbc80$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $0c21756c5f4cbc80$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $0c21756c5f4cbc80$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $0c21756c5f4cbc80$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $0c21756c5f4cbc80$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($0c21756c5f4cbc80$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $0c21756c5f4cbc80$var$hasForceUpdate || $0c21756c5f4cbc80$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $0c21756c5f4cbc80$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $0c21756c5f4cbc80$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $0c21756c5f4cbc80$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $0c21756c5f4cbc80$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $0c21756c5f4cbc80$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $0c21756c5f4cbc80$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $0c21756c5f4cbc80$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $0c21756c5f4cbc80$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $0c21756c5f4cbc80$var$hasForceUpdate || null !== current && null !== current.dependencies && $0c21756c5f4cbc80$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($0c21756c5f4cbc80$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $0c21756c5f4cbc80$var$hasForceUpdate || $0c21756c5f4cbc80$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $0c21756c5f4cbc80$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $0c21756c5f4cbc80$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $0c21756c5f4cbc80$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $0c21756c5f4cbc80$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $0c21756c5f4cbc80$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $0c21756c5f4cbc80$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $0c21756c5f4cbc80$var$resetHydrationState();
    workInProgress.flags |= 256;
    $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $0c21756c5f4cbc80$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $0c21756c5f4cbc80$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $0c21756c5f4cbc80$var$getSuspendedCache()
    };
}
function $0c21756c5f4cbc80$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $0c21756c5f4cbc80$var$workInProgressDeferredLane);
    return current;
}
function $0c21756c5f4cbc80$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($0c21756c5f4cbc80$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($0c21756c5f4cbc80$var$isHydrating) {
            showFallback ? $0c21756c5f4cbc80$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $0c21756c5f4cbc80$var$reuseSuspenseHandlerOnStack();
            (current = $0c21756c5f4cbc80$var$nextHydratableInstance) ? (current = $0c21756c5f4cbc80$var$canHydrateHydrationBoundary(current, $0c21756c5f4cbc80$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $0c21756c5f4cbc80$var$treeContextProvider ? {
                    id: $0c21756c5f4cbc80$var$treeContextId,
                    overflow: $0c21756c5f4cbc80$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $0c21756c5f4cbc80$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $0c21756c5f4cbc80$var$hydrationParentFiber = workInProgress, $0c21756c5f4cbc80$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $0c21756c5f4cbc80$var$throwOnHydrationMismatch(workInProgress);
            $0c21756c5f4cbc80$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $0c21756c5f4cbc80$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $0c21756c5f4cbc80$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $0c21756c5f4cbc80$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $0c21756c5f4cbc80$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $0c21756c5f4cbc80$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $0c21756c5f4cbc80$var$SUSPENDED_MARKER, $0c21756c5f4cbc80$var$bailoutOffscreenComponent(null, nextProps);
        $0c21756c5f4cbc80$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $0c21756c5f4cbc80$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $0c21756c5f4cbc80$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $0c21756c5f4cbc80$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $0c21756c5f4cbc80$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $0c21756c5f4cbc80$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $0c21756c5f4cbc80$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $0c21756c5f4cbc80$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $0c21756c5f4cbc80$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $0c21756c5f4cbc80$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $0c21756c5f4cbc80$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $0c21756c5f4cbc80$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $0c21756c5f4cbc80$var$SUSPENDED_MARKER, $0c21756c5f4cbc80$var$bailoutOffscreenComponent(current.child, nextProps);
    $0c21756c5f4cbc80$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $0c21756c5f4cbc80$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $0c21756c5f4cbc80$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $0c21756c5f4cbc80$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $0c21756c5f4cbc80$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $0c21756c5f4cbc80$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $0c21756c5f4cbc80$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $0c21756c5f4cbc80$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $0c21756c5f4cbc80$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $0c21756c5f4cbc80$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $0c21756c5f4cbc80$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $0c21756c5f4cbc80$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $0c21756c5f4cbc80$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $0c21756c5f4cbc80$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $0c21756c5f4cbc80$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $0c21756c5f4cbc80$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $0c21756c5f4cbc80$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $0c21756c5f4cbc80$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $0c21756c5f4cbc80$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $0c21756c5f4cbc80$var$SUSPENDED_MARKER;
        return $0c21756c5f4cbc80$var$bailoutOffscreenComponent(null, nextProps);
    }
    $0c21756c5f4cbc80$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($0c21756c5f4cbc80$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($0c21756c5f4cbc80$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $0c21756c5f4cbc80$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $0c21756c5f4cbc80$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $0c21756c5f4cbc80$var$didReceiveUpdate || $0c21756c5f4cbc80$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($0c21756c5f4cbc80$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $0c21756c5f4cbc80$var$currentTreeHiddenStackCursor.current) return $0c21756c5f4cbc80$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $0c21756c5f4cbc80$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $0c21756c5f4cbc80$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $0c21756c5f4cbc80$var$enqueueConcurrentRenderForLane(current, nextProps), $0c21756c5f4cbc80$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $0c21756c5f4cbc80$var$SelectiveHydrationException;
        $0c21756c5f4cbc80$var$isSuspenseInstancePending(suspenseInstance) || $0c21756c5f4cbc80$var$renderDidSuspendDelayIfPossible();
        return $0c21756c5f4cbc80$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($0c21756c5f4cbc80$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $0c21756c5f4cbc80$var$nextHydratableInstance = $0c21756c5f4cbc80$var$getNextHydratable(suspenseInstance.nextSibling);
    $0c21756c5f4cbc80$var$hydrationParentFiber = workInProgress;
    $0c21756c5f4cbc80$var$isHydrating = !0;
    $0c21756c5f4cbc80$var$hydrationErrors = null;
    $0c21756c5f4cbc80$var$rootOrSingletonContext = !1;
    null !== current && $0c21756c5f4cbc80$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $0c21756c5f4cbc80$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $0c21756c5f4cbc80$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $0c21756c5f4cbc80$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $0c21756c5f4cbc80$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $0c21756c5f4cbc80$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $0c21756c5f4cbc80$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $0c21756c5f4cbc80$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $0c21756c5f4cbc80$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $0c21756c5f4cbc80$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $0c21756c5f4cbc80$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $0c21756c5f4cbc80$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($0c21756c5f4cbc80$var$reverseChildren(current), $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $0c21756c5f4cbc80$var$reverseChildren(current)) : $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $0c21756c5f4cbc80$var$isHydrating ? $0c21756c5f4cbc80$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $0c21756c5f4cbc80$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $0c21756c5f4cbc80$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $0c21756c5f4cbc80$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $0c21756c5f4cbc80$var$reverseChildren(workInProgress));
            $0c21756c5f4cbc80$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $0c21756c5f4cbc80$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $0c21756c5f4cbc80$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $0c21756c5f4cbc80$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $0c21756c5f4cbc80$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $0c21756c5f4cbc80$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $0c21756c5f4cbc80$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $0c21756c5f4cbc80$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $0c21756c5f4cbc80$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $0c21756c5f4cbc80$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($0c21756c5f4cbc80$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $0c21756c5f4cbc80$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $0c21756c5f4cbc80$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $0c21756c5f4cbc80$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $0c21756c5f4cbc80$var$checkIfContextChanged(current) ? !0 : !1;
}
function $0c21756c5f4cbc80$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $0c21756c5f4cbc80$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $0c21756c5f4cbc80$var$pushProvider(workInProgress, $0c21756c5f4cbc80$var$CacheContext, current.memoizedState.cache);
            $0c21756c5f4cbc80$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $0c21756c5f4cbc80$var$pushHostContext(workInProgress);
            break;
        case 4:
            $0c21756c5f4cbc80$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $0c21756c5f4cbc80$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $0c21756c5f4cbc80$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $0c21756c5f4cbc80$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $0c21756c5f4cbc80$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $0c21756c5f4cbc80$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $0c21756c5f4cbc80$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $0c21756c5f4cbc80$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $0c21756c5f4cbc80$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $0c21756c5f4cbc80$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($0c21756c5f4cbc80$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $0c21756c5f4cbc80$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $0c21756c5f4cbc80$var$pushSuspenseListContext(workInProgress, $0c21756c5f4cbc80$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $0c21756c5f4cbc80$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $0c21756c5f4cbc80$var$pushProvider(workInProgress, $0c21756c5f4cbc80$var$CacheContext, current.memoizedState.cache);
    }
    return $0c21756c5f4cbc80$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $0c21756c5f4cbc80$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $0c21756c5f4cbc80$var$didReceiveUpdate = !0;
        else {
            if (!$0c21756c5f4cbc80$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $0c21756c5f4cbc80$var$didReceiveUpdate = !1, $0c21756c5f4cbc80$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $0c21756c5f4cbc80$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $0c21756c5f4cbc80$var$didReceiveUpdate = !1, $0c21756c5f4cbc80$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $0c21756c5f4cbc80$var$pushTreeId(workInProgress, $0c21756c5f4cbc80$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $0c21756c5f4cbc80$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $0c21756c5f4cbc80$var$shouldConstruct(current) ? (props = $0c21756c5f4cbc80$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $0c21756c5f4cbc80$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $0c21756c5f4cbc80$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $0c21756c5f4cbc80$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $0c21756c5f4cbc80$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $0c21756c5f4cbc80$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $0c21756c5f4cbc80$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $0c21756c5f4cbc80$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $0c21756c5f4cbc80$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $0c21756c5f4cbc80$var$getComponentNameFromType(current) || current;
                    throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $0c21756c5f4cbc80$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $0c21756c5f4cbc80$var$resolveClassComponentProps(props, workInProgress.pendingProps), $0c21756c5f4cbc80$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $0c21756c5f4cbc80$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $0c21756c5f4cbc80$var$cloneUpdateQueue(current, workInProgress);
                $0c21756c5f4cbc80$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $0c21756c5f4cbc80$var$pushProvider(workInProgress, $0c21756c5f4cbc80$var$CacheContext, props);
                props !== prevState.cache && $0c21756c5f4cbc80$var$propagateContextChanges(workInProgress, [
                    $0c21756c5f4cbc80$var$CacheContext
                ], renderLanes, !0);
                $0c21756c5f4cbc80$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $0c21756c5f4cbc80$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $0c21756c5f4cbc80$var$createCapturedValueAtFiber(Error($0c21756c5f4cbc80$var$formatProdErrorMessage(424)), workInProgress);
                        $0c21756c5f4cbc80$var$queueHydrationError($$typeof);
                        workInProgress = $0c21756c5f4cbc80$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $0c21756c5f4cbc80$var$nextHydratableInstance = $0c21756c5f4cbc80$var$getNextHydratable(current.firstChild);
                        $0c21756c5f4cbc80$var$hydrationParentFiber = workInProgress;
                        $0c21756c5f4cbc80$var$isHydrating = !0;
                        $0c21756c5f4cbc80$var$hydrationErrors = null;
                        $0c21756c5f4cbc80$var$rootOrSingletonContext = !0;
                        renderLanes = $0c21756c5f4cbc80$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $0c21756c5f4cbc80$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $0c21756c5f4cbc80$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $0c21756c5f4cbc80$var$markRef(current, workInProgress), null === current ? (renderLanes = $0c21756c5f4cbc80$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $0c21756c5f4cbc80$var$isHydrating || (workInProgress.stateNode = $0c21756c5f4cbc80$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $0c21756c5f4cbc80$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $0c21756c5f4cbc80$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $0c21756c5f4cbc80$var$pushHostContext(workInProgress), null === current && $0c21756c5f4cbc80$var$isHydrating && (props = workInProgress.stateNode = $0c21756c5f4cbc80$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $0c21756c5f4cbc80$var$rootInstanceStackCursor.current), $0c21756c5f4cbc80$var$hydrationParentFiber = workInProgress, $0c21756c5f4cbc80$var$rootOrSingletonContext = !0, $$typeof = $0c21756c5f4cbc80$var$nextHydratableInstance, $0c21756c5f4cbc80$var$isSingletonScope(workInProgress.type) ? ($0c21756c5f4cbc80$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $0c21756c5f4cbc80$var$nextHydratableInstance = $0c21756c5f4cbc80$var$getNextHydratable(props.firstChild)) : $0c21756c5f4cbc80$var$nextHydratableInstance = $$typeof), $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $0c21756c5f4cbc80$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $0c21756c5f4cbc80$var$isHydrating) {
                if ($$typeof = props = $0c21756c5f4cbc80$var$nextHydratableInstance) props = $0c21756c5f4cbc80$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $0c21756c5f4cbc80$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $0c21756c5f4cbc80$var$hydrationParentFiber = workInProgress, $0c21756c5f4cbc80$var$nextHydratableInstance = $0c21756c5f4cbc80$var$getNextHydratable(props.firstChild), $0c21756c5f4cbc80$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $0c21756c5f4cbc80$var$throwOnHydrationMismatch(workInProgress);
            }
            $0c21756c5f4cbc80$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $0c21756c5f4cbc80$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $0c21756c5f4cbc80$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $0c21756c5f4cbc80$var$renderWithHooks(current, workInProgress, $0c21756c5f4cbc80$var$TransitionAwareHostComponent, null, null, renderLanes), $0c21756c5f4cbc80$var$HostTransitionContext._currentValue = $$typeof);
            $0c21756c5f4cbc80$var$markRef(current, workInProgress);
            $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $0c21756c5f4cbc80$var$isHydrating) {
                if (current = renderLanes = $0c21756c5f4cbc80$var$nextHydratableInstance) renderLanes = $0c21756c5f4cbc80$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $0c21756c5f4cbc80$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $0c21756c5f4cbc80$var$hydrationParentFiber = workInProgress, $0c21756c5f4cbc80$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $0c21756c5f4cbc80$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $0c21756c5f4cbc80$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $0c21756c5f4cbc80$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $0c21756c5f4cbc80$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $0c21756c5f4cbc80$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $0c21756c5f4cbc80$var$markRef(current, workInProgress), $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $0c21756c5f4cbc80$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $0c21756c5f4cbc80$var$prepareToReadContext(workInProgress), $$typeof = $0c21756c5f4cbc80$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $0c21756c5f4cbc80$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $0c21756c5f4cbc80$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $0c21756c5f4cbc80$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $0c21756c5f4cbc80$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $0c21756c5f4cbc80$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $0c21756c5f4cbc80$var$prepareToReadContext(workInProgress), props = $0c21756c5f4cbc80$var$readContext($0c21756c5f4cbc80$var$CacheContext), null === current ? ($$typeof = $0c21756c5f4cbc80$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $0c21756c5f4cbc80$var$workInProgressRoot, prevState = $0c21756c5f4cbc80$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $0c21756c5f4cbc80$var$initializeUpdateQueue(workInProgress), $0c21756c5f4cbc80$var$pushProvider(workInProgress, $0c21756c5f4cbc80$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($0c21756c5f4cbc80$var$cloneUpdateQueue(current, workInProgress), $0c21756c5f4cbc80$var$processUpdateQueue(workInProgress, null, null, renderLanes), $0c21756c5f4cbc80$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $0c21756c5f4cbc80$var$pushProvider(workInProgress, $0c21756c5f4cbc80$var$CacheContext, props)) : (props = prevState.cache, $0c21756c5f4cbc80$var$pushProvider(workInProgress, $0c21756c5f4cbc80$var$CacheContext, props), props !== $$typeof.cache && $0c21756c5f4cbc80$var$propagateContextChanges(workInProgress, [
                $0c21756c5f4cbc80$var$CacheContext
            ], renderLanes, !0))), $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $0c21756c5f4cbc80$var$isHydrating && $0c21756c5f4cbc80$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $0c21756c5f4cbc80$var$markRef(current, workInProgress), $0c21756c5f4cbc80$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $0c21756c5f4cbc80$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $0c21756c5f4cbc80$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $0c21756c5f4cbc80$var$maySuspendCommit(type, newProps) : $0c21756c5f4cbc80$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($0c21756c5f4cbc80$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $0c21756c5f4cbc80$var$suspendedThenable = $0c21756c5f4cbc80$var$noopSuspenseyCommitThenable, $0c21756c5f4cbc80$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $0c21756c5f4cbc80$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$0c21756c5f4cbc80$var$preloadResource(resource)) {
        if ($0c21756c5f4cbc80$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $0c21756c5f4cbc80$var$suspendedThenable = $0c21756c5f4cbc80$var$noopSuspenseyCommitThenable, $0c21756c5f4cbc80$var$SuspenseyCommitException;
    }
}
function $0c21756c5f4cbc80$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $0c21756c5f4cbc80$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $0c21756c5f4cbc80$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $0c21756c5f4cbc80$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$0c21756c5f4cbc80$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $0c21756c5f4cbc80$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $0c21756c5f4cbc80$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $0c21756c5f4cbc80$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0c21756c5f4cbc80$var$bubbleProperties(workInProgress), null;
        case 1:
            return $0c21756c5f4cbc80$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $0c21756c5f4cbc80$var$popProvider($0c21756c5f4cbc80$var$CacheContext);
            $0c21756c5f4cbc80$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $0c21756c5f4cbc80$var$popHydrationState(workInProgress) ? $0c21756c5f4cbc80$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $0c21756c5f4cbc80$var$upgradeHydrationErrorsToRecoverable());
            $0c21756c5f4cbc80$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($0c21756c5f4cbc80$var$markUpdate(workInProgress), null !== nextResource ? ($0c21756c5f4cbc80$var$bubbleProperties(workInProgress), $0c21756c5f4cbc80$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($0c21756c5f4cbc80$var$bubbleProperties(workInProgress), $0c21756c5f4cbc80$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($0c21756c5f4cbc80$var$markUpdate(workInProgress), $0c21756c5f4cbc80$var$bubbleProperties(workInProgress), $0c21756c5f4cbc80$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($0c21756c5f4cbc80$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $0c21756c5f4cbc80$var$markUpdate(workInProgress), $0c21756c5f4cbc80$var$bubbleProperties(workInProgress), $0c21756c5f4cbc80$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $0c21756c5f4cbc80$var$popHostContext(workInProgress);
            renderLanes = $0c21756c5f4cbc80$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $0c21756c5f4cbc80$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(166));
                    $0c21756c5f4cbc80$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $0c21756c5f4cbc80$var$contextStackCursor.current;
                $0c21756c5f4cbc80$var$popHydrationState(workInProgress) ? $0c21756c5f4cbc80$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $0c21756c5f4cbc80$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $0c21756c5f4cbc80$var$markUpdate(workInProgress));
            }
            $0c21756c5f4cbc80$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $0c21756c5f4cbc80$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $0c21756c5f4cbc80$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(166));
                    $0c21756c5f4cbc80$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $0c21756c5f4cbc80$var$contextStackCursor.current;
                if ($0c21756c5f4cbc80$var$popHydrationState(workInProgress)) $0c21756c5f4cbc80$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $0c21756c5f4cbc80$var$getOwnerDocumentFromRootContainer($0c21756c5f4cbc80$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$0c21756c5f4cbc80$var$internalInstanceKey] = workInProgress;
                    nextResource[$0c21756c5f4cbc80$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($0c21756c5f4cbc80$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $0c21756c5f4cbc80$var$markUpdate(workInProgress);
                }
            }
            $0c21756c5f4cbc80$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $0c21756c5f4cbc80$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $0c21756c5f4cbc80$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(166));
                current = $0c21756c5f4cbc80$var$rootInstanceStackCursor.current;
                if ($0c21756c5f4cbc80$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $0c21756c5f4cbc80$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$0c21756c5f4cbc80$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $0c21756c5f4cbc80$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $0c21756c5f4cbc80$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $0c21756c5f4cbc80$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$0c21756c5f4cbc80$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $0c21756c5f4cbc80$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $0c21756c5f4cbc80$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(557));
                        current[$0c21756c5f4cbc80$var$internalInstanceKey] = workInProgress;
                    } else $0c21756c5f4cbc80$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $0c21756c5f4cbc80$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $0c21756c5f4cbc80$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $0c21756c5f4cbc80$var$popSuspenseHandler(workInProgress), workInProgress;
                    $0c21756c5f4cbc80$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(558));
            }
            $0c21756c5f4cbc80$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $0c21756c5f4cbc80$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(317));
                        type[$0c21756c5f4cbc80$var$internalInstanceKey] = workInProgress;
                    } else $0c21756c5f4cbc80$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $0c21756c5f4cbc80$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $0c21756c5f4cbc80$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $0c21756c5f4cbc80$var$popSuspenseHandler(workInProgress), workInProgress;
                    $0c21756c5f4cbc80$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $0c21756c5f4cbc80$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $0c21756c5f4cbc80$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $0c21756c5f4cbc80$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $0c21756c5f4cbc80$var$popHostContainer(), null === current && $0c21756c5f4cbc80$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $0c21756c5f4cbc80$var$bubbleProperties(workInProgress), null;
        case 10:
            return $0c21756c5f4cbc80$var$popProvider(workInProgress.type), $0c21756c5f4cbc80$var$bubbleProperties(workInProgress), null;
        case 19:
            $0c21756c5f4cbc80$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $0c21756c5f4cbc80$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $0c21756c5f4cbc80$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $0c21756c5f4cbc80$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $0c21756c5f4cbc80$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $0c21756c5f4cbc80$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $0c21756c5f4cbc80$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$0c21756c5f4cbc80$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $0c21756c5f4cbc80$var$pushSuspenseListContext(workInProgress, $0c21756c5f4cbc80$var$suspenseStackCursor.current & 1 | 2);
                            $0c21756c5f4cbc80$var$isHydrating && $0c21756c5f4cbc80$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $0c21756c5f4cbc80$var$now() > $0c21756c5f4cbc80$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $0c21756c5f4cbc80$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $0c21756c5f4cbc80$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $0c21756c5f4cbc80$var$scheduleRetryEffect(workInProgress, current), $0c21756c5f4cbc80$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$0c21756c5f4cbc80$var$isHydrating) return $0c21756c5f4cbc80$var$bubbleProperties(workInProgress), null;
                    } else 2 * $0c21756c5f4cbc80$var$now() - newProps.renderingStartTime > $0c21756c5f4cbc80$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $0c21756c5f4cbc80$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $0c21756c5f4cbc80$var$now();
                current.sibling = null;
                nextResource = $0c21756c5f4cbc80$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $0c21756c5f4cbc80$var$isHydrating ? $0c21756c5f4cbc80$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$suspenseHandlerStackCursor, workInProgress), $0c21756c5f4cbc80$var$push($0c21756c5f4cbc80$var$suspenseStackCursor, renderLanes), null === $0c21756c5f4cbc80$var$shellBoundary && ($0c21756c5f4cbc80$var$shellBoundary = workInProgress));
                $0c21756c5f4cbc80$var$isHydrating && $0c21756c5f4cbc80$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $0c21756c5f4cbc80$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $0c21756c5f4cbc80$var$popSuspenseHandler(workInProgress), $0c21756c5f4cbc80$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($0c21756c5f4cbc80$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $0c21756c5f4cbc80$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $0c21756c5f4cbc80$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $0c21756c5f4cbc80$var$popProvider($0c21756c5f4cbc80$var$CacheContext), $0c21756c5f4cbc80$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $0c21756c5f4cbc80$var$bubbleProperties(workInProgress), null;
    }
    throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $0c21756c5f4cbc80$var$unwindWork(current, workInProgress) {
    $0c21756c5f4cbc80$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $0c21756c5f4cbc80$var$popProvider($0c21756c5f4cbc80$var$CacheContext), $0c21756c5f4cbc80$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $0c21756c5f4cbc80$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $0c21756c5f4cbc80$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(340));
                $0c21756c5f4cbc80$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $0c21756c5f4cbc80$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(340));
                $0c21756c5f4cbc80$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $0c21756c5f4cbc80$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $0c21756c5f4cbc80$var$popHostContainer(), null;
        case 10:
            return $0c21756c5f4cbc80$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $0c21756c5f4cbc80$var$popSuspenseHandler(workInProgress), $0c21756c5f4cbc80$var$popHiddenContext(), null !== current && $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $0c21756c5f4cbc80$var$popProvider($0c21756c5f4cbc80$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $0c21756c5f4cbc80$var$unwindInterruptedWork(current, interruptedWork) {
    $0c21756c5f4cbc80$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $0c21756c5f4cbc80$var$popProvider($0c21756c5f4cbc80$var$CacheContext);
            $0c21756c5f4cbc80$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $0c21756c5f4cbc80$var$popHostContext(interruptedWork);
            break;
        case 4:
            $0c21756c5f4cbc80$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $0c21756c5f4cbc80$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $0c21756c5f4cbc80$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $0c21756c5f4cbc80$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $0c21756c5f4cbc80$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $0c21756c5f4cbc80$var$popSuspenseHandler(interruptedWork);
            $0c21756c5f4cbc80$var$popHiddenContext();
            null !== current && $0c21756c5f4cbc80$var$pop($0c21756c5f4cbc80$var$resumedCache);
            break;
        case 24:
            $0c21756c5f4cbc80$var$popProvider($0c21756c5f4cbc80$var$CacheContext);
    }
}
function $0c21756c5f4cbc80$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $0c21756c5f4cbc80$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $0c21756c5f4cbc80$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $0c21756c5f4cbc80$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $0c21756c5f4cbc80$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $0c21756c5f4cbc80$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $0c21756c5f4cbc80$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $0c21756c5f4cbc80$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $0c21756c5f4cbc80$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $0c21756c5f4cbc80$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $0c21756c5f4cbc80$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $0c21756c5f4cbc80$var$FragmentInstance(current);
                        $0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $0c21756c5f4cbc80$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $0c21756c5f4cbc80$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $0c21756c5f4cbc80$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $0c21756c5f4cbc80$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $0c21756c5f4cbc80$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $0c21756c5f4cbc80$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$0c21756c5f4cbc80$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $0c21756c5f4cbc80$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $0c21756c5f4cbc80$var$isFragmentInstanceParent(parent) && $0c21756c5f4cbc80$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($0c21756c5f4cbc80$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $0c21756c5f4cbc80$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $0c21756c5f4cbc80$var$isFragmentInstanceParent(parent) && $0c21756c5f4cbc80$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($0c21756c5f4cbc80$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $0c21756c5f4cbc80$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $0c21756c5f4cbc80$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $0c21756c5f4cbc80$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $0c21756c5f4cbc80$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $0c21756c5f4cbc80$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$0c21756c5f4cbc80$var$internalPropsKey] = newProps;
    } catch (error) {
        $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $0c21756c5f4cbc80$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $0c21756c5f4cbc80$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $0c21756c5f4cbc80$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $0c21756c5f4cbc80$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $0c21756c5f4cbc80$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $0c21756c5f4cbc80$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $0c21756c5f4cbc80$var$noop$1)), $0c21756c5f4cbc80$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $0c21756c5f4cbc80$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($0c21756c5f4cbc80$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $0c21756c5f4cbc80$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($0c21756c5f4cbc80$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$0c21756c5f4cbc80$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $0c21756c5f4cbc80$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $0c21756c5f4cbc80$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $0c21756c5f4cbc80$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($0c21756c5f4cbc80$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $0c21756c5f4cbc80$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($0c21756c5f4cbc80$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$0c21756c5f4cbc80$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $0c21756c5f4cbc80$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $0c21756c5f4cbc80$var$setInitialProperties(singleton, type, props);
        singleton[$0c21756c5f4cbc80$var$internalInstanceKey] = finishedWork;
        singleton[$0c21756c5f4cbc80$var$internalPropsKey] = props;
    } catch (error) {
        $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $0c21756c5f4cbc80$var$shouldStartViewTransition = !1, $0c21756c5f4cbc80$var$appearingViewTransitions = null;
function $0c21756c5f4cbc80$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $0c21756c5f4cbc80$var$shouldStartViewTransition = !0;
}
var $0c21756c5f4cbc80$var$viewTransitionCancelableChildren = null;
function $0c21756c5f4cbc80$var$pushViewTransitionCancelableScope() {
    var prevChildren = $0c21756c5f4cbc80$var$viewTransitionCancelableChildren;
    $0c21756c5f4cbc80$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx = 0;
function $0c21756c5f4cbc80$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx = 0;
    return $0c21756c5f4cbc80$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $0c21756c5f4cbc80$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $0c21756c5f4cbc80$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $0c21756c5f4cbc80$var$measureInstance(instance).view && (inViewport = !0);
            $0c21756c5f4cbc80$var$shouldStartViewTransition = !0;
            $0c21756c5f4cbc80$var$applyViewTransitionName(instance, 0 === $0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx ? name : name + "_" + $0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx, className);
            $0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $0c21756c5f4cbc80$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $0c21756c5f4cbc80$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $0c21756c5f4cbc80$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $0c21756c5f4cbc80$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $0c21756c5f4cbc80$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($0c21756c5f4cbc80$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $0c21756c5f4cbc80$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($0c21756c5f4cbc80$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $0c21756c5f4cbc80$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $0c21756c5f4cbc80$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $0c21756c5f4cbc80$var$getViewTransitionName(props, state), className = $0c21756c5f4cbc80$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $0c21756c5f4cbc80$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($0c21756c5f4cbc80$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $0c21756c5f4cbc80$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $0c21756c5f4cbc80$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $0c21756c5f4cbc80$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$0c21756c5f4cbc80$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $0c21756c5f4cbc80$var$commitAppearingPairViewTransitions(placement);
}
function $0c21756c5f4cbc80$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $0c21756c5f4cbc80$var$appearingViewTransitions && 0 !== $0c21756c5f4cbc80$var$appearingViewTransitions.size) {
        var pairs = $0c21756c5f4cbc80$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $0c21756c5f4cbc80$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($0c21756c5f4cbc80$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $0c21756c5f4cbc80$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $0c21756c5f4cbc80$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $0c21756c5f4cbc80$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $0c21756c5f4cbc80$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $0c21756c5f4cbc80$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $0c21756c5f4cbc80$var$appearingViewTransitions ? $0c21756c5f4cbc80$var$appearingViewTransitions.get(name) : void 0, className = $0c21756c5f4cbc80$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($0c21756c5f4cbc80$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $0c21756c5f4cbc80$var$appearingViewTransitions.delete(name), $0c21756c5f4cbc80$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $0c21756c5f4cbc80$var$scheduleViewTransitionEvent(deletion, props.onExit) : $0c21756c5f4cbc80$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $0c21756c5f4cbc80$var$appearingViewTransitions && $0c21756c5f4cbc80$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$0c21756c5f4cbc80$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $0c21756c5f4cbc80$var$appearingViewTransitions && $0c21756c5f4cbc80$var$commitDeletedPairViewTransitions(deletion);
}
function $0c21756c5f4cbc80$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $0c21756c5f4cbc80$var$getViewTransitionName(props, changedParent.stateNode);
            props = $0c21756c5f4cbc80$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $0c21756c5f4cbc80$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $0c21756c5f4cbc80$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $0c21756c5f4cbc80$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $0c21756c5f4cbc80$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $0c21756c5f4cbc80$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $0c21756c5f4cbc80$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $0c21756c5f4cbc80$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $0c21756c5f4cbc80$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$0c21756c5f4cbc80$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $0c21756c5f4cbc80$var$restorePairedViewTransitions(fiber);
}
function $0c21756c5f4cbc80$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $0c21756c5f4cbc80$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $0c21756c5f4cbc80$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $0c21756c5f4cbc80$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx], nextMeasurement = $0c21756c5f4cbc80$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $0c21756c5f4cbc80$var$applyViewTransitionName(instance, 0 === $0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $0c21756c5f4cbc80$var$viewTransitionCancelableChildren && ($0c21756c5f4cbc80$var$viewTransitionCancelableChildren = []), $0c21756c5f4cbc80$var$viewTransitionCancelableChildren.push(instance, 0 === $0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $0c21756c5f4cbc80$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $0c21756c5f4cbc80$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $0c21756c5f4cbc80$var$getViewTransitionName(props, state), className = $0c21756c5f4cbc80$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($0c21756c5f4cbc80$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx = 0;
            name = $0c21756c5f4cbc80$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $0c21756c5f4cbc80$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $0c21756c5f4cbc80$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden = !1, $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden = !1, $0c21756c5f4cbc80$var$offscreenDirectParentIsHidden = !1, $0c21756c5f4cbc80$var$needsFormReset = !1, $0c21756c5f4cbc80$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $0c21756c5f4cbc80$var$nextEffect = null, $0c21756c5f4cbc80$var$viewTransitionContextChanged = !1, $0c21756c5f4cbc80$var$inUpdateViewTransition = !1, $0c21756c5f4cbc80$var$rootViewTransitionAffected = !1, $0c21756c5f4cbc80$var$rootViewTransitionNameCanceled = !1;
function $0c21756c5f4cbc80$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $0c21756c5f4cbc80$var$eventsEnabled = $0c21756c5f4cbc80$var$_enabled;
    root = $0c21756c5f4cbc80$var$getActiveElementDeep(root);
    if ($0c21756c5f4cbc80$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $0c21756c5f4cbc80$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $0c21756c5f4cbc80$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $0c21756c5f4cbc80$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $0c21756c5f4cbc80$var$nextEffect;){
        root = $0c21756c5f4cbc80$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $0c21756c5f4cbc80$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $0c21756c5f4cbc80$var$trackEnterViewTransitions(root), $0c21756c5f4cbc80$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $0c21756c5f4cbc80$var$commitExitViewTransitions(JSCompiler_temp);
                    $0c21756c5f4cbc80$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $0c21756c5f4cbc80$var$trackEnterViewTransitions(root);
                    $0c21756c5f4cbc80$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $0c21756c5f4cbc80$var$nextEffect = JSCompiler_temp) : (committedLanes && $0c21756c5f4cbc80$var$commitNestedViewTransitions(root), $0c21756c5f4cbc80$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $0c21756c5f4cbc80$var$appearingViewTransitions = null;
}
function $0c21756c5f4cbc80$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $0c21756c5f4cbc80$var$nextEffect;){
        var fiber = $0c21756c5f4cbc80$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $0c21756c5f4cbc80$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $0c21756c5f4cbc80$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $0c21756c5f4cbc80$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $0c21756c5f4cbc80$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $0c21756c5f4cbc80$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $0c21756c5f4cbc80$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $0c21756c5f4cbc80$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $0c21756c5f4cbc80$var$nextEffect = current;
            break;
        }
        $0c21756c5f4cbc80$var$nextEffect = fiber.return;
    }
}
function $0c21756c5f4cbc80$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $0c21756c5f4cbc80$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $0c21756c5f4cbc80$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $0c21756c5f4cbc80$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $0c21756c5f4cbc80$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $0c21756c5f4cbc80$var$commitClassCallbacks(finishedWork);
            flags & 512 && $0c21756c5f4cbc80$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $0c21756c5f4cbc80$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $0c21756c5f4cbc80$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $0c21756c5f4cbc80$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $0c21756c5f4cbc80$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $0c21756c5f4cbc80$var$commitHostMount(finishedWork);
            flags & 512 && $0c21756c5f4cbc80$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $0c21756c5f4cbc80$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $0c21756c5f4cbc80$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $0c21756c5f4cbc80$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $0c21756c5f4cbc80$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $0c21756c5f4cbc80$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $0c21756c5f4cbc80$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $0c21756c5f4cbc80$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden;
                current = $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden;
                prevProps = $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden;
                $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden = flags;
                ($0c21756c5f4cbc80$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $0c21756c5f4cbc80$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $0c21756c5f4cbc80$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden = current;
                $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $0c21756c5f4cbc80$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $0c21756c5f4cbc80$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $0c21756c5f4cbc80$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $0c21756c5f4cbc80$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $0c21756c5f4cbc80$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$0c21756c5f4cbc80$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $0c21756c5f4cbc80$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $0c21756c5f4cbc80$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $0c21756c5f4cbc80$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $0c21756c5f4cbc80$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $0c21756c5f4cbc80$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $0c21756c5f4cbc80$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $0c21756c5f4cbc80$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $0c21756c5f4cbc80$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $0c21756c5f4cbc80$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $0c21756c5f4cbc80$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $0c21756c5f4cbc80$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $0c21756c5f4cbc80$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $0c21756c5f4cbc80$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $0c21756c5f4cbc80$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $0c21756c5f4cbc80$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $0c21756c5f4cbc80$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $0c21756c5f4cbc80$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $0c21756c5f4cbc80$var$hostParent = null, $0c21756c5f4cbc80$var$hostParentIsContainer = !1;
function $0c21756c5f4cbc80$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$0c21756c5f4cbc80$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $0c21756c5f4cbc80$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($0c21756c5f4cbc80$var$injectedHook && "function" === typeof $0c21756c5f4cbc80$var$injectedHook.onCommitFiberUnmount) try {
        $0c21756c5f4cbc80$var$injectedHook.onCommitFiberUnmount($0c21756c5f4cbc80$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || $0c21756c5f4cbc80$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $0c21756c5f4cbc80$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$0c21756c5f4cbc80$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || $0c21756c5f4cbc80$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $0c21756c5f4cbc80$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $0c21756c5f4cbc80$var$hostParent, prevHostParentIsContainer = $0c21756c5f4cbc80$var$hostParentIsContainer;
            $0c21756c5f4cbc80$var$isSingletonScope(deletedFiber.type) && ($0c21756c5f4cbc80$var$hostParent = deletedFiber.stateNode, $0c21756c5f4cbc80$var$hostParentIsContainer = !1);
            $0c21756c5f4cbc80$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $0c21756c5f4cbc80$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $0c21756c5f4cbc80$var$hostParent = prevHostParent;
            $0c21756c5f4cbc80$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || $0c21756c5f4cbc80$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $0c21756c5f4cbc80$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $0c21756c5f4cbc80$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $0c21756c5f4cbc80$var$hostParent;
            prevHostParentIsContainer = $0c21756c5f4cbc80$var$hostParentIsContainer;
            $0c21756c5f4cbc80$var$hostParent = null;
            $0c21756c5f4cbc80$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $0c21756c5f4cbc80$var$hostParent = prevHostParent;
            $0c21756c5f4cbc80$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $0c21756c5f4cbc80$var$hostParent) {
                if ($0c21756c5f4cbc80$var$hostParentIsContainer) try {
                    (9 === $0c21756c5f4cbc80$var$hostParent.nodeType ? $0c21756c5f4cbc80$var$hostParent.body : "HTML" === $0c21756c5f4cbc80$var$hostParent.nodeName ? $0c21756c5f4cbc80$var$hostParent.ownerDocument.body : $0c21756c5f4cbc80$var$hostParent).removeChild(deletedFiber.stateNode), $0c21756c5f4cbc80$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $0c21756c5f4cbc80$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $0c21756c5f4cbc80$var$hostParent.removeChild(deletedFiber.stateNode), $0c21756c5f4cbc80$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $0c21756c5f4cbc80$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $0c21756c5f4cbc80$var$hostParent && ($0c21756c5f4cbc80$var$hostParentIsContainer ? (finishedRoot = $0c21756c5f4cbc80$var$hostParent, $0c21756c5f4cbc80$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $0c21756c5f4cbc80$var$retryIfBlockedOn(finishedRoot)) : $0c21756c5f4cbc80$var$clearHydrationBoundary($0c21756c5f4cbc80$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $0c21756c5f4cbc80$var$hostParent;
            prevHostParentIsContainer = $0c21756c5f4cbc80$var$hostParentIsContainer;
            $0c21756c5f4cbc80$var$hostParent = deletedFiber.stateNode.containerInfo;
            $0c21756c5f4cbc80$var$hostParentIsContainer = !0;
            $0c21756c5f4cbc80$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $0c21756c5f4cbc80$var$hostParent = prevHostParent;
            $0c21756c5f4cbc80$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $0c21756c5f4cbc80$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || $0c21756c5f4cbc80$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $0c21756c5f4cbc80$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || ($0c21756c5f4cbc80$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $0c21756c5f4cbc80$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $0c21756c5f4cbc80$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $0c21756c5f4cbc80$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden = (prevHostParent = $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $0c21756c5f4cbc80$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $0c21756c5f4cbc80$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $0c21756c5f4cbc80$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || $0c21756c5f4cbc80$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $0c21756c5f4cbc80$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $0c21756c5f4cbc80$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $0c21756c5f4cbc80$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $0c21756c5f4cbc80$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $0c21756c5f4cbc80$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $0c21756c5f4cbc80$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $0c21756c5f4cbc80$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $0c21756c5f4cbc80$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $0c21756c5f4cbc80$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $0c21756c5f4cbc80$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $0c21756c5f4cbc80$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $0c21756c5f4cbc80$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($0c21756c5f4cbc80$var$isSingletonScope(parent.type)) {
                        $0c21756c5f4cbc80$var$hostParent = parent.stateNode;
                        $0c21756c5f4cbc80$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $0c21756c5f4cbc80$var$hostParent = parent.stateNode;
                    $0c21756c5f4cbc80$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $0c21756c5f4cbc80$var$hostParent = parent.stateNode.containerInfo;
                    $0c21756c5f4cbc80$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $0c21756c5f4cbc80$var$hostParent) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(160));
        $0c21756c5f4cbc80$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $0c21756c5f4cbc80$var$hostParent = null;
        $0c21756c5f4cbc80$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$0c21756c5f4cbc80$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $0c21756c5f4cbc80$var$currentHoistableRoot = null;
function $0c21756c5f4cbc80$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($0c21756c5f4cbc80$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $0c21756c5f4cbc80$var$commitHookEffectListMount(3, finishedWork), $0c21756c5f4cbc80$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || null === current || $0c21756c5f4cbc80$var$safelyDetachRef(current, current.return));
            flags & 64 && $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $0c21756c5f4cbc80$var$currentHoistableRoot;
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || null === current || $0c21756c5f4cbc80$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($0c21756c5f4cbc80$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $0c21756c5f4cbc80$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$0c21756c5f4cbc80$var$internalHoistableMarker] || current[$0c21756c5f4cbc80$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $0c21756c5f4cbc80$var$setInitialProperties(current, root, lanes);
                                            current[$0c21756c5f4cbc80$var$internalInstanceKey] = finishedWork;
                                            $0c21756c5f4cbc80$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $0c21756c5f4cbc80$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $0c21756c5f4cbc80$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $0c21756c5f4cbc80$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $0c21756c5f4cbc80$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$0c21756c5f4cbc80$var$internalInstanceKey] = finishedWork;
                                    $0c21756c5f4cbc80$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden || $0c21756c5f4cbc80$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $0c21756c5f4cbc80$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden || $0c21756c5f4cbc80$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $0c21756c5f4cbc80$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $0c21756c5f4cbc80$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || null === current || $0c21756c5f4cbc80$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $0c21756c5f4cbc80$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $0c21756c5f4cbc80$var$offscreenDirectParentIsHidden;
            $0c21756c5f4cbc80$var$offscreenDirectParentIsHidden = !1;
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $0c21756c5f4cbc80$var$offscreenDirectParentIsHidden = ii;
            $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || null === current || $0c21756c5f4cbc80$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $0c21756c5f4cbc80$var$setTextContent(root, ""), $0c21756c5f4cbc80$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $0c21756c5f4cbc80$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($0c21756c5f4cbc80$var$needsFormReset = !0);
            break;
        case 6:
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $0c21756c5f4cbc80$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $0c21756c5f4cbc80$var$viewTransitionMutationContext = !1;
            $0c21756c5f4cbc80$var$tagCaches = null;
            ii = $0c21756c5f4cbc80$var$currentHoistableRoot;
            $0c21756c5f4cbc80$var$currentHoistableRoot = $0c21756c5f4cbc80$var$getHoistableRoot(root.containerInfo);
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $0c21756c5f4cbc80$var$currentHoistableRoot = ii;
            $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $0c21756c5f4cbc80$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $0c21756c5f4cbc80$var$needsFormReset && ($0c21756c5f4cbc80$var$needsFormReset = !1, $0c21756c5f4cbc80$var$recursivelyResetForms(finishedWork));
            $0c21756c5f4cbc80$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $0c21756c5f4cbc80$var$offscreenDirectParentIsHidden;
            $0c21756c5f4cbc80$var$offscreenDirectParentIsHidden = $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden;
            current = $0c21756c5f4cbc80$var$pushMutationContext();
            ii = $0c21756c5f4cbc80$var$currentHoistableRoot;
            $0c21756c5f4cbc80$var$currentHoistableRoot = $0c21756c5f4cbc80$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
            $0c21756c5f4cbc80$var$currentHoistableRoot = ii;
            $0c21756c5f4cbc80$var$viewTransitionMutationContext && $0c21756c5f4cbc80$var$inUpdateViewTransition && ($0c21756c5f4cbc80$var$rootViewTransitionAffected = !0);
            $0c21756c5f4cbc80$var$viewTransitionMutationContext = current;
            $0c21756c5f4cbc80$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $0c21756c5f4cbc80$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($0c21756c5f4cbc80$var$globalMostRecentFallbackTime = $0c21756c5f4cbc80$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $0c21756c5f4cbc80$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $0c21756c5f4cbc80$var$offscreenDirectParentIsHidden;
            $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $0c21756c5f4cbc80$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $0c21756c5f4cbc80$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden || $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden, lanes = $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden, current = $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden, $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden = ii || $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden, $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden = root, $0c21756c5f4cbc80$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden = lanes, $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden = current), !ii && $0c21756c5f4cbc80$var$offscreenDirectParentIsHidden || $0c21756c5f4cbc80$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $0c21756c5f4cbc80$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $0c21756c5f4cbc80$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || null === current || $0c21756c5f4cbc80$var$safelyDetachRef(current, current.return));
            flags = $0c21756c5f4cbc80$var$pushMutationContext();
            ii = $0c21756c5f4cbc80$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $0c21756c5f4cbc80$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $0c21756c5f4cbc80$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $0c21756c5f4cbc80$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $0c21756c5f4cbc80$var$inUpdateViewTransition = ii;
            $0c21756c5f4cbc80$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || null === current || $0c21756c5f4cbc80$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $0c21756c5f4cbc80$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork);
    }
}
function $0c21756c5f4cbc80$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($0c21756c5f4cbc80$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($0c21756c5f4cbc80$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($0c21756c5f4cbc80$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $0c21756c5f4cbc80$var$getHostSibling(finishedWork);
                    $0c21756c5f4cbc80$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($0c21756c5f4cbc80$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $0c21756c5f4cbc80$var$getHostSibling(finishedWork);
                    $0c21756c5f4cbc80$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $0c21756c5f4cbc80$var$getHostSibling(finishedWork);
                    $0c21756c5f4cbc80$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $0c21756c5f4cbc80$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $0c21756c5f4cbc80$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $0c21756c5f4cbc80$var$_enabled = !0, fiber.reset(), $0c21756c5f4cbc80$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $0c21756c5f4cbc80$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$0c21756c5f4cbc80$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $0c21756c5f4cbc80$var$measureNestedViewTransitions(parentFiber, !1);
}
function $0c21756c5f4cbc80$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $0c21756c5f4cbc80$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $0c21756c5f4cbc80$var$rootViewTransitionNameCanceled = $0c21756c5f4cbc80$var$viewTransitionContextChanged = !1;
            $0c21756c5f4cbc80$var$pushViewTransitionCancelableScope();
            $0c21756c5f4cbc80$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$0c21756c5f4cbc80$var$viewTransitionContextChanged && !$0c21756c5f4cbc80$var$rootViewTransitionAffected) {
                finishedWork = $0c21756c5f4cbc80$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $0c21756c5f4cbc80$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $0c21756c5f4cbc80$var$rootViewTransitionNameCanceled = !0;
            }
            $0c21756c5f4cbc80$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $0c21756c5f4cbc80$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $0c21756c5f4cbc80$var$viewTransitionContextChanged;
            $0c21756c5f4cbc80$var$viewTransitionContextChanged = !1;
            $0c21756c5f4cbc80$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $0c21756c5f4cbc80$var$viewTransitionContextChanged && ($0c21756c5f4cbc80$var$rootViewTransitionAffected = !0);
            $0c21756c5f4cbc80$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $0c21756c5f4cbc80$var$commitEnterViewTransitions(finishedWork, !1) : $0c21756c5f4cbc80$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $0c21756c5f4cbc80$var$viewTransitionContextChanged;
            oldName = $0c21756c5f4cbc80$var$pushViewTransitionCancelableScope();
            $0c21756c5f4cbc80$var$viewTransitionContextChanged = !1;
            $0c21756c5f4cbc80$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $0c21756c5f4cbc80$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $0c21756c5f4cbc80$var$getViewTransitionName(props, state);
            state = $0c21756c5f4cbc80$var$getViewTransitionName(current.memoizedProps, state);
            var className = $0c21756c5f4cbc80$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx = 0, root = $0c21756c5f4cbc80$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $0c21756c5f4cbc80$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($0c21756c5f4cbc80$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $0c21756c5f4cbc80$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $0c21756c5f4cbc80$var$viewTransitionCancelableChildren), $0c21756c5f4cbc80$var$viewTransitionCancelableChildren = oldName);
            $0c21756c5f4cbc80$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $0c21756c5f4cbc80$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $0c21756c5f4cbc80$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$0c21756c5f4cbc80$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $0c21756c5f4cbc80$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $0c21756c5f4cbc80$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $0c21756c5f4cbc80$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $0c21756c5f4cbc80$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $0c21756c5f4cbc80$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $0c21756c5f4cbc80$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $0c21756c5f4cbc80$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $0c21756c5f4cbc80$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $0c21756c5f4cbc80$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $0c21756c5f4cbc80$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $0c21756c5f4cbc80$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $0c21756c5f4cbc80$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $0c21756c5f4cbc80$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $0c21756c5f4cbc80$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $0c21756c5f4cbc80$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $0c21756c5f4cbc80$var$safelyDetachRef(finishedWork, finishedWork.return);
                $0c21756c5f4cbc80$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $0c21756c5f4cbc80$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $0c21756c5f4cbc80$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $0c21756c5f4cbc80$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $0c21756c5f4cbc80$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $0c21756c5f4cbc80$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $0c21756c5f4cbc80$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $0c21756c5f4cbc80$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$0c21756c5f4cbc80$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $0c21756c5f4cbc80$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $0c21756c5f4cbc80$var$commitClassCallbacks(finishedWork);
                $0c21756c5f4cbc80$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $0c21756c5f4cbc80$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $0c21756c5f4cbc80$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $0c21756c5f4cbc80$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $0c21756c5f4cbc80$var$commitHostMount(finishedWork);
                $0c21756c5f4cbc80$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $0c21756c5f4cbc80$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $0c21756c5f4cbc80$var$offscreenSubtreeIsHidden || $0c21756c5f4cbc80$var$mountHoistable($0c21756c5f4cbc80$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $0c21756c5f4cbc80$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $0c21756c5f4cbc80$var$commitHostMount(finishedWork);
                $0c21756c5f4cbc80$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $0c21756c5f4cbc80$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $0c21756c5f4cbc80$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $0c21756c5f4cbc80$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $0c21756c5f4cbc80$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $0c21756c5f4cbc80$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $0c21756c5f4cbc80$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $0c21756c5f4cbc80$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $0c21756c5f4cbc80$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $0c21756c5f4cbc80$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $0c21756c5f4cbc80$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $0c21756c5f4cbc80$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $0c21756c5f4cbc80$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $0c21756c5f4cbc80$var$releaseCache(previousCache));
}
function $0c21756c5f4cbc80$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $0c21756c5f4cbc80$var$releaseCache(current));
}
function $0c21756c5f4cbc80$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$0c21756c5f4cbc80$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $0c21756c5f4cbc80$var$restoreNestedViewTransitions(parentFiber);
}
function $0c21756c5f4cbc80$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $0c21756c5f4cbc80$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $0c21756c5f4cbc80$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $0c21756c5f4cbc80$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $0c21756c5f4cbc80$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $0c21756c5f4cbc80$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $0c21756c5f4cbc80$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $0c21756c5f4cbc80$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $0c21756c5f4cbc80$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $0c21756c5f4cbc80$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $0c21756c5f4cbc80$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $0c21756c5f4cbc80$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $0c21756c5f4cbc80$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $0c21756c5f4cbc80$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $0c21756c5f4cbc80$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $0c21756c5f4cbc80$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $0c21756c5f4cbc80$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $0c21756c5f4cbc80$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $0c21756c5f4cbc80$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $0c21756c5f4cbc80$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $0c21756c5f4cbc80$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $0c21756c5f4cbc80$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($0c21756c5f4cbc80$var$restoreViewTransitionOnHostInstances(flags.child, !0), $0c21756c5f4cbc80$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $0c21756c5f4cbc80$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $0c21756c5f4cbc80$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $0c21756c5f4cbc80$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $0c21756c5f4cbc80$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $0c21756c5f4cbc80$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $0c21756c5f4cbc80$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $0c21756c5f4cbc80$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $0c21756c5f4cbc80$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $0c21756c5f4cbc80$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $0c21756c5f4cbc80$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $0c21756c5f4cbc80$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $0c21756c5f4cbc80$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $0c21756c5f4cbc80$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $0c21756c5f4cbc80$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $0c21756c5f4cbc80$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $0c21756c5f4cbc80$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $0c21756c5f4cbc80$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $0c21756c5f4cbc80$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $0c21756c5f4cbc80$var$suspenseyCommitFlag = 8192;
function $0c21756c5f4cbc80$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $0c21756c5f4cbc80$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$0c21756c5f4cbc80$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $0c21756c5f4cbc80$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $0c21756c5f4cbc80$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $0c21756c5f4cbc80$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $0c21756c5f4cbc80$var$suspendResource(suspendedState, $0c21756c5f4cbc80$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $0c21756c5f4cbc80$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $0c21756c5f4cbc80$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $0c21756c5f4cbc80$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $0c21756c5f4cbc80$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $0c21756c5f4cbc80$var$currentHoistableRoot;
            $0c21756c5f4cbc80$var$currentHoistableRoot = $0c21756c5f4cbc80$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $0c21756c5f4cbc80$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $0c21756c5f4cbc80$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $0c21756c5f4cbc80$var$suspenseyCommitFlag, $0c21756c5f4cbc80$var$suspenseyCommitFlag = 16777216, $0c21756c5f4cbc80$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $0c21756c5f4cbc80$var$suspenseyCommitFlag = previousHoistableRoot) : $0c21756c5f4cbc80$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $0c21756c5f4cbc80$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $0c21756c5f4cbc80$var$appearingViewTransitions && ($0c21756c5f4cbc80$var$appearingViewTransitions = new Map());
                $0c21756c5f4cbc80$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $0c21756c5f4cbc80$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $0c21756c5f4cbc80$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $0c21756c5f4cbc80$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $0c21756c5f4cbc80$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $0c21756c5f4cbc80$var$nextEffect = childToDelete;
            $0c21756c5f4cbc80$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $0c21756c5f4cbc80$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$0c21756c5f4cbc80$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $0c21756c5f4cbc80$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $0c21756c5f4cbc80$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $0c21756c5f4cbc80$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $0c21756c5f4cbc80$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $0c21756c5f4cbc80$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $0c21756c5f4cbc80$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $0c21756c5f4cbc80$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $0c21756c5f4cbc80$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $0c21756c5f4cbc80$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $0c21756c5f4cbc80$var$nextEffect = childToDelete;
            $0c21756c5f4cbc80$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $0c21756c5f4cbc80$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $0c21756c5f4cbc80$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $0c21756c5f4cbc80$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $0c21756c5f4cbc80$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $0c21756c5f4cbc80$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $0c21756c5f4cbc80$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $0c21756c5f4cbc80$var$nextEffect;){
        var fiber = $0c21756c5f4cbc80$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $0c21756c5f4cbc80$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $0c21756c5f4cbc80$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $0c21756c5f4cbc80$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $0c21756c5f4cbc80$var$nextEffect;){
            cache = $0c21756c5f4cbc80$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $0c21756c5f4cbc80$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $0c21756c5f4cbc80$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $0c21756c5f4cbc80$var$nextEffect = sibling;
                break a;
            }
            $0c21756c5f4cbc80$var$nextEffect = returnFiber;
        }
    }
}
var $0c21756c5f4cbc80$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $0c21756c5f4cbc80$var$readContext($0c21756c5f4cbc80$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $0c21756c5f4cbc80$var$readContext($0c21756c5f4cbc80$var$CacheContext).controller.signal;
    }
}, $0c21756c5f4cbc80$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $0c21756c5f4cbc80$var$executionContext = 0, $0c21756c5f4cbc80$var$workInProgressRoot = null, $0c21756c5f4cbc80$var$workInProgress = null, $0c21756c5f4cbc80$var$workInProgressRootRenderLanes = 0, $0c21756c5f4cbc80$var$workInProgressSuspendedReason = 0, $0c21756c5f4cbc80$var$workInProgressThrownValue = null, $0c21756c5f4cbc80$var$workInProgressRootDidSkipSuspendedSiblings = !1, $0c21756c5f4cbc80$var$workInProgressRootIsPrerendering = !1, $0c21756c5f4cbc80$var$workInProgressRootDidAttachPingListener = !1, $0c21756c5f4cbc80$var$entangledRenderLanes = 0, $0c21756c5f4cbc80$var$workInProgressRootExitStatus = 0, $0c21756c5f4cbc80$var$workInProgressRootSkippedLanes = 0, $0c21756c5f4cbc80$var$workInProgressRootInterleavedUpdatedLanes = 0, $0c21756c5f4cbc80$var$workInProgressRootPingedLanes = 0, $0c21756c5f4cbc80$var$workInProgressDeferredLane = 0, $0c21756c5f4cbc80$var$workInProgressSuspendedRetryLanes = 0, $0c21756c5f4cbc80$var$workInProgressRootConcurrentErrors = null, $0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors = null, $0c21756c5f4cbc80$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $0c21756c5f4cbc80$var$globalMostRecentFallbackTime = 0, $0c21756c5f4cbc80$var$globalMostRecentTransitionTime = 0, $0c21756c5f4cbc80$var$workInProgressRootRenderTargetTime = Infinity, $0c21756c5f4cbc80$var$workInProgressTransitions = null, $0c21756c5f4cbc80$var$legacyErrorBoundariesThatAlreadyFailed = null, $0c21756c5f4cbc80$var$pendingEffectsStatus = 0, $0c21756c5f4cbc80$var$pendingEffectsRoot = null, $0c21756c5f4cbc80$var$pendingFinishedWork = null, $0c21756c5f4cbc80$var$pendingEffectsLanes = 0, $0c21756c5f4cbc80$var$pendingEffectsRemainingLanes = 0, $0c21756c5f4cbc80$var$pendingPassiveTransitions = null, $0c21756c5f4cbc80$var$pendingRecoverableErrors = null, $0c21756c5f4cbc80$var$pendingViewTransition = null, $0c21756c5f4cbc80$var$pendingViewTransitionEvents = null, $0c21756c5f4cbc80$var$pendingTransitionTypes = null, $0c21756c5f4cbc80$var$nestedUpdateCount = 0, $0c21756c5f4cbc80$var$rootWithNestedUpdates = null;
function $0c21756c5f4cbc80$var$requestUpdateLane() {
    return 0 !== ($0c21756c5f4cbc80$var$executionContext & 2) && 0 !== $0c21756c5f4cbc80$var$workInProgressRootRenderLanes ? $0c21756c5f4cbc80$var$workInProgressRootRenderLanes & -$0c21756c5f4cbc80$var$workInProgressRootRenderLanes : null !== $0c21756c5f4cbc80$var$ReactSharedInternals.T ? $0c21756c5f4cbc80$var$requestTransitionLane() : $0c21756c5f4cbc80$var$resolveUpdatePriority();
}
function $0c21756c5f4cbc80$var$requestDeferredLane() {
    if (0 === $0c21756c5f4cbc80$var$workInProgressDeferredLane) {
        if (0 === ($0c21756c5f4cbc80$var$workInProgressRootRenderLanes & 536870912) || $0c21756c5f4cbc80$var$isHydrating) {
            var lane = $0c21756c5f4cbc80$var$nextTransitionDeferredLane;
            $0c21756c5f4cbc80$var$nextTransitionDeferredLane <<= 1;
            0 === ($0c21756c5f4cbc80$var$nextTransitionDeferredLane & 3932160) && ($0c21756c5f4cbc80$var$nextTransitionDeferredLane = 262144);
            $0c21756c5f4cbc80$var$workInProgressDeferredLane = lane;
        } else $0c21756c5f4cbc80$var$workInProgressDeferredLane = 536870912;
    }
    lane = $0c21756c5f4cbc80$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $0c21756c5f4cbc80$var$workInProgressDeferredLane;
}
function $0c21756c5f4cbc80$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $0c21756c5f4cbc80$var$createViewTransitionInstance($0c21756c5f4cbc80$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $0c21756c5f4cbc80$var$pendingViewTransitionEvents && ($0c21756c5f4cbc80$var$pendingViewTransitionEvents = []);
        $0c21756c5f4cbc80$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $0c21756c5f4cbc80$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $0c21756c5f4cbc80$var$workInProgressRoot && (2 === $0c21756c5f4cbc80$var$workInProgressSuspendedReason || 9 === $0c21756c5f4cbc80$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $0c21756c5f4cbc80$var$prepareFreshStack(root, 0), $0c21756c5f4cbc80$var$markRootSuspended(root, $0c21756c5f4cbc80$var$workInProgressRootRenderLanes, $0c21756c5f4cbc80$var$workInProgressDeferredLane, !1);
    $0c21756c5f4cbc80$var$markRootUpdated$1(root, lane);
    if (0 === ($0c21756c5f4cbc80$var$executionContext & 2) || root !== $0c21756c5f4cbc80$var$workInProgressRoot) root === $0c21756c5f4cbc80$var$workInProgressRoot && (0 === ($0c21756c5f4cbc80$var$executionContext & 2) && ($0c21756c5f4cbc80$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $0c21756c5f4cbc80$var$workInProgressRootExitStatus && $0c21756c5f4cbc80$var$markRootSuspended(root, $0c21756c5f4cbc80$var$workInProgressRootRenderLanes, $0c21756c5f4cbc80$var$workInProgressDeferredLane, !1)), $0c21756c5f4cbc80$var$ensureRootIsScheduled(root);
}
function $0c21756c5f4cbc80$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($0c21756c5f4cbc80$var$executionContext & 6)) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $0c21756c5f4cbc80$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $0c21756c5f4cbc80$var$renderRootConcurrent(root$jscomp$0, lanes) : $0c21756c5f4cbc80$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $0c21756c5f4cbc80$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $0c21756c5f4cbc80$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$0c21756c5f4cbc80$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $0c21756c5f4cbc80$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $0c21756c5f4cbc80$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($0c21756c5f4cbc80$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $0c21756c5f4cbc80$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($0c21756c5f4cbc80$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $0c21756c5f4cbc80$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors;
                            $0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors ? $0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors.push.apply($0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $0c21756c5f4cbc80$var$prepareFreshStack(root$jscomp$0, 0);
                $0c21756c5f4cbc80$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $0c21756c5f4cbc80$var$markRootSuspended(shouldTimeSlice, lanes, $0c21756c5f4cbc80$var$workInProgressDeferredLane, !$0c21756c5f4cbc80$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $0c21756c5f4cbc80$var$globalMostRecentFallbackTime + 300 - $0c21756c5f4cbc80$var$now(), 10 < exitStatus)) {
                    $0c21756c5f4cbc80$var$markRootSuspended(shouldTimeSlice, lanes, $0c21756c5f4cbc80$var$workInProgressDeferredLane, !$0c21756c5f4cbc80$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $0c21756c5f4cbc80$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $0c21756c5f4cbc80$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $0c21756c5f4cbc80$var$scheduleTimeout($0c21756c5f4cbc80$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors, $0c21756c5f4cbc80$var$workInProgressTransitions, $0c21756c5f4cbc80$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $0c21756c5f4cbc80$var$workInProgressDeferredLane, $0c21756c5f4cbc80$var$workInProgressRootInterleavedUpdatedLanes, $0c21756c5f4cbc80$var$workInProgressSuspendedRetryLanes, $0c21756c5f4cbc80$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $0c21756c5f4cbc80$var$completeRootWhenReady(shouldTimeSlice, forceSync, $0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors, $0c21756c5f4cbc80$var$workInProgressTransitions, $0c21756c5f4cbc80$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $0c21756c5f4cbc80$var$workInProgressDeferredLane, $0c21756c5f4cbc80$var$workInProgressRootInterleavedUpdatedLanes, $0c21756c5f4cbc80$var$workInProgressSuspendedRetryLanes, $0c21756c5f4cbc80$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $0c21756c5f4cbc80$var$ensureRootIsScheduled(root$jscomp$0);
}
function $0c21756c5f4cbc80$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $0c21756c5f4cbc80$var$noop$1
        }, $0c21756c5f4cbc80$var$appearingViewTransitions = null, $0c21756c5f4cbc80$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $0c21756c5f4cbc80$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $0c21756c5f4cbc80$var$globalMostRecentFallbackTime - $0c21756c5f4cbc80$var$now() : (lanes & 4194048) === lanes ? $0c21756c5f4cbc80$var$globalMostRecentTransitionTime - $0c21756c5f4cbc80$var$now() : 0, subtreeFlags = $0c21756c5f4cbc80$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $0c21756c5f4cbc80$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($0c21756c5f4cbc80$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $0c21756c5f4cbc80$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $0c21756c5f4cbc80$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $0c21756c5f4cbc80$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$0c21756c5f4cbc80$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $0c21756c5f4cbc80$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $0c21756c5f4cbc80$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$0c21756c5f4cbc80$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$0c21756c5f4cbc80$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $0c21756c5f4cbc80$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $0c21756c5f4cbc80$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $0c21756c5f4cbc80$var$flushSyncWork$1() {
    return 0 === ($0c21756c5f4cbc80$var$executionContext & 6) ? ($0c21756c5f4cbc80$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $0c21756c5f4cbc80$var$resetWorkInProgressStack() {
    if (null !== $0c21756c5f4cbc80$var$workInProgress) {
        if (0 === $0c21756c5f4cbc80$var$workInProgressSuspendedReason) var interruptedWork = $0c21756c5f4cbc80$var$workInProgress.return;
        else interruptedWork = $0c21756c5f4cbc80$var$workInProgress, $0c21756c5f4cbc80$var$lastContextDependency = $0c21756c5f4cbc80$var$currentlyRenderingFiber$1 = null, $0c21756c5f4cbc80$var$resetHooksOnUnwind(interruptedWork), $0c21756c5f4cbc80$var$thenableState$1 = null, $0c21756c5f4cbc80$var$thenableIndexCounter$1 = 0, interruptedWork = $0c21756c5f4cbc80$var$workInProgress;
        for(; null !== interruptedWork;)$0c21756c5f4cbc80$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $0c21756c5f4cbc80$var$workInProgress = null;
    }
}
function $0c21756c5f4cbc80$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $0c21756c5f4cbc80$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $0c21756c5f4cbc80$var$pendingEffectsLanes = 0;
    $0c21756c5f4cbc80$var$resetWorkInProgressStack();
    $0c21756c5f4cbc80$var$workInProgressRoot = root;
    $0c21756c5f4cbc80$var$workInProgress = timeoutHandle = $0c21756c5f4cbc80$var$createWorkInProgress(root.current, null);
    $0c21756c5f4cbc80$var$workInProgressRootRenderLanes = lanes;
    $0c21756c5f4cbc80$var$workInProgressSuspendedReason = 0;
    $0c21756c5f4cbc80$var$workInProgressThrownValue = null;
    $0c21756c5f4cbc80$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $0c21756c5f4cbc80$var$workInProgressRootIsPrerendering = $0c21756c5f4cbc80$var$checkIfRootIsPrerendering(root, lanes);
    $0c21756c5f4cbc80$var$workInProgressRootDidAttachPingListener = !1;
    $0c21756c5f4cbc80$var$workInProgressSuspendedRetryLanes = $0c21756c5f4cbc80$var$workInProgressDeferredLane = $0c21756c5f4cbc80$var$workInProgressRootPingedLanes = $0c21756c5f4cbc80$var$workInProgressRootInterleavedUpdatedLanes = $0c21756c5f4cbc80$var$workInProgressRootSkippedLanes = $0c21756c5f4cbc80$var$workInProgressRootExitStatus = 0;
    $0c21756c5f4cbc80$var$workInProgressRootRecoverableErrors = $0c21756c5f4cbc80$var$workInProgressRootConcurrentErrors = null;
    $0c21756c5f4cbc80$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $0c21756c5f4cbc80$var$entangledRenderLanes = $0c21756c5f4cbc80$var$getEntangledLanes(root, lanes);
    $0c21756c5f4cbc80$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $0c21756c5f4cbc80$var$handleThrow(root, thrownValue) {
    $0c21756c5f4cbc80$var$currentlyRenderingFiber = null;
    $0c21756c5f4cbc80$var$ReactSharedInternals.H = $0c21756c5f4cbc80$var$ContextOnlyDispatcher;
    thrownValue === $0c21756c5f4cbc80$var$SuspenseException || thrownValue === $0c21756c5f4cbc80$var$SuspenseActionException ? (thrownValue = $0c21756c5f4cbc80$var$getSuspendedThenable(), $0c21756c5f4cbc80$var$workInProgressSuspendedReason = 3) : thrownValue === $0c21756c5f4cbc80$var$SuspenseyCommitException ? (thrownValue = $0c21756c5f4cbc80$var$getSuspendedThenable(), $0c21756c5f4cbc80$var$workInProgressSuspendedReason = 4) : $0c21756c5f4cbc80$var$workInProgressSuspendedReason = thrownValue === $0c21756c5f4cbc80$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $0c21756c5f4cbc80$var$workInProgressThrownValue = thrownValue;
    null === $0c21756c5f4cbc80$var$workInProgress && ($0c21756c5f4cbc80$var$workInProgressRootExitStatus = 1, $0c21756c5f4cbc80$var$logUncaughtError(root, $0c21756c5f4cbc80$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $0c21756c5f4cbc80$var$shouldRemainOnPreviousScreen() {
    var handler = $0c21756c5f4cbc80$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($0c21756c5f4cbc80$var$workInProgressRootRenderLanes & 4194048) === $0c21756c5f4cbc80$var$workInProgressRootRenderLanes ? null === $0c21756c5f4cbc80$var$shellBoundary ? !0 : !1 : ($0c21756c5f4cbc80$var$workInProgressRootRenderLanes & 62914560) === $0c21756c5f4cbc80$var$workInProgressRootRenderLanes || 0 !== ($0c21756c5f4cbc80$var$workInProgressRootRenderLanes & 536870912) ? handler === $0c21756c5f4cbc80$var$shellBoundary : !1;
}
function $0c21756c5f4cbc80$var$pushDispatcher() {
    var prevDispatcher = $0c21756c5f4cbc80$var$ReactSharedInternals.H;
    $0c21756c5f4cbc80$var$ReactSharedInternals.H = $0c21756c5f4cbc80$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $0c21756c5f4cbc80$var$ContextOnlyDispatcher : prevDispatcher;
}
function $0c21756c5f4cbc80$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $0c21756c5f4cbc80$var$ReactSharedInternals.A;
    $0c21756c5f4cbc80$var$ReactSharedInternals.A = $0c21756c5f4cbc80$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $0c21756c5f4cbc80$var$renderDidSuspendDelayIfPossible() {
    $0c21756c5f4cbc80$var$workInProgressRootExitStatus = 4;
    $0c21756c5f4cbc80$var$workInProgressRootDidSkipSuspendedSiblings || ($0c21756c5f4cbc80$var$workInProgressRootRenderLanes & 4194048) !== $0c21756c5f4cbc80$var$workInProgressRootRenderLanes && null !== $0c21756c5f4cbc80$var$suspenseHandlerStackCursor.current || ($0c21756c5f4cbc80$var$workInProgressRootIsPrerendering = !0);
    0 === ($0c21756c5f4cbc80$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($0c21756c5f4cbc80$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $0c21756c5f4cbc80$var$workInProgressRoot || $0c21756c5f4cbc80$var$markRootSuspended($0c21756c5f4cbc80$var$workInProgressRoot, $0c21756c5f4cbc80$var$workInProgressRootRenderLanes, $0c21756c5f4cbc80$var$workInProgressDeferredLane, !1);
}
function $0c21756c5f4cbc80$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $0c21756c5f4cbc80$var$executionContext;
    $0c21756c5f4cbc80$var$executionContext |= 2;
    var prevDispatcher = $0c21756c5f4cbc80$var$pushDispatcher(), prevAsyncDispatcher = $0c21756c5f4cbc80$var$pushAsyncDispatcher();
    if ($0c21756c5f4cbc80$var$workInProgressRoot !== root || $0c21756c5f4cbc80$var$workInProgressRootRenderLanes !== lanes) $0c21756c5f4cbc80$var$workInProgressTransitions = null, $0c21756c5f4cbc80$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $0c21756c5f4cbc80$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $0c21756c5f4cbc80$var$workInProgressSuspendedReason && null !== $0c21756c5f4cbc80$var$workInProgress) {
            var unitOfWork = $0c21756c5f4cbc80$var$workInProgress, thrownValue = $0c21756c5f4cbc80$var$workInProgressThrownValue;
            switch($0c21756c5f4cbc80$var$workInProgressSuspendedReason){
                case 8:
                    $0c21756c5f4cbc80$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $0c21756c5f4cbc80$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $0c21756c5f4cbc80$var$workInProgressSuspendedReason;
                    $0c21756c5f4cbc80$var$workInProgressSuspendedReason = 0;
                    $0c21756c5f4cbc80$var$workInProgressThrownValue = null;
                    $0c21756c5f4cbc80$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $0c21756c5f4cbc80$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $0c21756c5f4cbc80$var$workInProgressSuspendedReason, $0c21756c5f4cbc80$var$workInProgressSuspendedReason = 0, $0c21756c5f4cbc80$var$workInProgressThrownValue = null, $0c21756c5f4cbc80$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $0c21756c5f4cbc80$var$workLoopSync();
        exitStatus = $0c21756c5f4cbc80$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $0c21756c5f4cbc80$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $0c21756c5f4cbc80$var$lastContextDependency = $0c21756c5f4cbc80$var$currentlyRenderingFiber$1 = null;
    $0c21756c5f4cbc80$var$executionContext = prevExecutionContext;
    $0c21756c5f4cbc80$var$ReactSharedInternals.H = prevDispatcher;
    $0c21756c5f4cbc80$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $0c21756c5f4cbc80$var$workInProgress && ($0c21756c5f4cbc80$var$workInProgressRoot = null, $0c21756c5f4cbc80$var$workInProgressRootRenderLanes = 0, $0c21756c5f4cbc80$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $0c21756c5f4cbc80$var$workLoopSync() {
    for(; null !== $0c21756c5f4cbc80$var$workInProgress;)$0c21756c5f4cbc80$var$performUnitOfWork($0c21756c5f4cbc80$var$workInProgress);
}
function $0c21756c5f4cbc80$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $0c21756c5f4cbc80$var$executionContext;
    $0c21756c5f4cbc80$var$executionContext |= 2;
    var prevDispatcher = $0c21756c5f4cbc80$var$pushDispatcher(), prevAsyncDispatcher = $0c21756c5f4cbc80$var$pushAsyncDispatcher();
    $0c21756c5f4cbc80$var$workInProgressRoot !== root || $0c21756c5f4cbc80$var$workInProgressRootRenderLanes !== lanes ? ($0c21756c5f4cbc80$var$workInProgressTransitions = null, $0c21756c5f4cbc80$var$workInProgressRootRenderTargetTime = $0c21756c5f4cbc80$var$now() + 500, $0c21756c5f4cbc80$var$prepareFreshStack(root, lanes)) : $0c21756c5f4cbc80$var$workInProgressRootIsPrerendering = $0c21756c5f4cbc80$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $0c21756c5f4cbc80$var$workInProgressSuspendedReason && null !== $0c21756c5f4cbc80$var$workInProgress) {
            lanes = $0c21756c5f4cbc80$var$workInProgress;
            var thrownValue = $0c21756c5f4cbc80$var$workInProgressThrownValue;
            b: switch($0c21756c5f4cbc80$var$workInProgressSuspendedReason){
                case 1:
                    $0c21756c5f4cbc80$var$workInProgressSuspendedReason = 0;
                    $0c21756c5f4cbc80$var$workInProgressThrownValue = null;
                    $0c21756c5f4cbc80$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($0c21756c5f4cbc80$var$isThenableResolved(thrownValue)) {
                        $0c21756c5f4cbc80$var$workInProgressSuspendedReason = 0;
                        $0c21756c5f4cbc80$var$workInProgressThrownValue = null;
                        $0c21756c5f4cbc80$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $0c21756c5f4cbc80$var$workInProgressSuspendedReason && 9 !== $0c21756c5f4cbc80$var$workInProgressSuspendedReason || $0c21756c5f4cbc80$var$workInProgressRoot !== root || ($0c21756c5f4cbc80$var$workInProgressSuspendedReason = 7);
                        $0c21756c5f4cbc80$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $0c21756c5f4cbc80$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $0c21756c5f4cbc80$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $0c21756c5f4cbc80$var$isThenableResolved(thrownValue) ? ($0c21756c5f4cbc80$var$workInProgressSuspendedReason = 0, $0c21756c5f4cbc80$var$workInProgressThrownValue = null, $0c21756c5f4cbc80$var$replaySuspendedUnitOfWork(lanes)) : ($0c21756c5f4cbc80$var$workInProgressSuspendedReason = 0, $0c21756c5f4cbc80$var$workInProgressThrownValue = null, $0c21756c5f4cbc80$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($0c21756c5f4cbc80$var$workInProgress.tag){
                        case 26:
                            resource = $0c21756c5f4cbc80$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $0c21756c5f4cbc80$var$workInProgress;
                            if (resource ? $0c21756c5f4cbc80$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $0c21756c5f4cbc80$var$workInProgressSuspendedReason = 0;
                                $0c21756c5f4cbc80$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $0c21756c5f4cbc80$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($0c21756c5f4cbc80$var$workInProgress = returnFiber, $0c21756c5f4cbc80$var$completeUnitOfWork(returnFiber)) : $0c21756c5f4cbc80$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $0c21756c5f4cbc80$var$workInProgressSuspendedReason = 0;
                    $0c21756c5f4cbc80$var$workInProgressThrownValue = null;
                    $0c21756c5f4cbc80$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $0c21756c5f4cbc80$var$workInProgressSuspendedReason = 0;
                    $0c21756c5f4cbc80$var$workInProgressThrownValue = null;
                    $0c21756c5f4cbc80$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $0c21756c5f4cbc80$var$resetWorkInProgressStack();
                    $0c21756c5f4cbc80$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(462));
            }
        }
        $0c21756c5f4cbc80$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $0c21756c5f4cbc80$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $0c21756c5f4cbc80$var$lastContextDependency = $0c21756c5f4cbc80$var$currentlyRenderingFiber$1 = null;
    $0c21756c5f4cbc80$var$ReactSharedInternals.H = prevDispatcher;
    $0c21756c5f4cbc80$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $0c21756c5f4cbc80$var$executionContext = prevExecutionContext;
    if (null !== $0c21756c5f4cbc80$var$workInProgress) return 0;
    $0c21756c5f4cbc80$var$workInProgressRoot = null;
    $0c21756c5f4cbc80$var$workInProgressRootRenderLanes = 0;
    $0c21756c5f4cbc80$var$finishQueueingConcurrentUpdates();
    return $0c21756c5f4cbc80$var$workInProgressRootExitStatus;
}
function $0c21756c5f4cbc80$var$workLoopConcurrentByScheduler() {
    for(; null !== $0c21756c5f4cbc80$var$workInProgress && !$0c21756c5f4cbc80$var$shouldYield();)$0c21756c5f4cbc80$var$performUnitOfWork($0c21756c5f4cbc80$var$workInProgress);
}
function $0c21756c5f4cbc80$var$performUnitOfWork(unitOfWork) {
    var next = $0c21756c5f4cbc80$var$beginWork(unitOfWork.alternate, unitOfWork, $0c21756c5f4cbc80$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $0c21756c5f4cbc80$var$completeUnitOfWork(unitOfWork) : $0c21756c5f4cbc80$var$workInProgress = next;
}
function $0c21756c5f4cbc80$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $0c21756c5f4cbc80$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $0c21756c5f4cbc80$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $0c21756c5f4cbc80$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $0c21756c5f4cbc80$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $0c21756c5f4cbc80$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $0c21756c5f4cbc80$var$hydrationParentFiber && ($0c21756c5f4cbc80$var$isHydrating ? ($0c21756c5f4cbc80$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($0c21756c5f4cbc80$var$nextHydratableInstance = fiber.stateNode)) : ($0c21756c5f4cbc80$var$popToNextHostParent(fiber), $0c21756c5f4cbc80$var$isHydrating = !0));
        default:
            $0c21756c5f4cbc80$var$unwindInterruptedWork(current, next), next = $0c21756c5f4cbc80$var$workInProgress = $0c21756c5f4cbc80$var$resetWorkInProgress(next, $0c21756c5f4cbc80$var$entangledRenderLanes), next = $0c21756c5f4cbc80$var$beginWork(current, next, $0c21756c5f4cbc80$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $0c21756c5f4cbc80$var$completeUnitOfWork(unitOfWork) : $0c21756c5f4cbc80$var$workInProgress = next;
}
function $0c21756c5f4cbc80$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $0c21756c5f4cbc80$var$lastContextDependency = $0c21756c5f4cbc80$var$currentlyRenderingFiber$1 = null;
    $0c21756c5f4cbc80$var$resetHooksOnUnwind(unitOfWork);
    $0c21756c5f4cbc80$var$thenableState$1 = null;
    $0c21756c5f4cbc80$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($0c21756c5f4cbc80$var$throwException(root, returnFiber, unitOfWork, thrownValue, $0c21756c5f4cbc80$var$workInProgressRootRenderLanes)) {
            $0c21756c5f4cbc80$var$workInProgressRootExitStatus = 1;
            $0c21756c5f4cbc80$var$logUncaughtError(root, $0c21756c5f4cbc80$var$createCapturedValueAtFiber(thrownValue, root.current));
            $0c21756c5f4cbc80$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $0c21756c5f4cbc80$var$workInProgress = returnFiber, error;
        $0c21756c5f4cbc80$var$workInProgressRootExitStatus = 1;
        $0c21756c5f4cbc80$var$logUncaughtError(root, $0c21756c5f4cbc80$var$createCapturedValueAtFiber(thrownValue, root.current));
        $0c21756c5f4cbc80$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($0c21756c5f4cbc80$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($0c21756c5f4cbc80$var$workInProgressRootIsPrerendering || 0 !== ($0c21756c5f4cbc80$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($0c21756c5f4cbc80$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $0c21756c5f4cbc80$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $0c21756c5f4cbc80$var$unwindUnitOfWork(unitOfWork, root);
    } else $0c21756c5f4cbc80$var$completeUnitOfWork(unitOfWork);
}
function $0c21756c5f4cbc80$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $0c21756c5f4cbc80$var$unwindUnitOfWork(completedWork, $0c21756c5f4cbc80$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $0c21756c5f4cbc80$var$completeWork(completedWork.alternate, completedWork, $0c21756c5f4cbc80$var$entangledRenderLanes);
        if (null !== next) {
            $0c21756c5f4cbc80$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $0c21756c5f4cbc80$var$workInProgress = completedWork;
            return;
        }
        $0c21756c5f4cbc80$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $0c21756c5f4cbc80$var$workInProgressRootExitStatus && ($0c21756c5f4cbc80$var$workInProgressRootExitStatus = 5);
}
function $0c21756c5f4cbc80$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $0c21756c5f4cbc80$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $0c21756c5f4cbc80$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $0c21756c5f4cbc80$var$workInProgress = unitOfWork;
            return;
        }
        $0c21756c5f4cbc80$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $0c21756c5f4cbc80$var$workInProgressRootExitStatus = 6;
    $0c21756c5f4cbc80$var$workInProgress = null;
}
function $0c21756c5f4cbc80$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $0c21756c5f4cbc80$var$flushPendingEffects();
    while (0 !== $0c21756c5f4cbc80$var$pendingEffectsStatus);
    if (0 !== ($0c21756c5f4cbc80$var$executionContext & 6)) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(177));
        root === $0c21756c5f4cbc80$var$workInProgressRoot && ($0c21756c5f4cbc80$var$workInProgress = $0c21756c5f4cbc80$var$workInProgressRoot = null, $0c21756c5f4cbc80$var$workInProgressRootRenderLanes = 0);
        $0c21756c5f4cbc80$var$pendingFinishedWork = finishedWork;
        $0c21756c5f4cbc80$var$pendingEffectsRoot = root;
        $0c21756c5f4cbc80$var$pendingEffectsLanes = lanes;
        $0c21756c5f4cbc80$var$pendingPassiveTransitions = transitions;
        $0c21756c5f4cbc80$var$pendingRecoverableErrors = recoverableErrors;
        $0c21756c5f4cbc80$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $0c21756c5f4cbc80$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $0c21756c5f4cbc80$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $0c21756c5f4cbc80$var$concurrentlyUpdatedLanes;
    $0c21756c5f4cbc80$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $0c21756c5f4cbc80$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($0c21756c5f4cbc80$var$pendingTransitionTypes = $0c21756c5f4cbc80$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($0c21756c5f4cbc80$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $0c21756c5f4cbc80$var$scheduleCallback$1($0c21756c5f4cbc80$var$NormalPriority$1, function() {
        $0c21756c5f4cbc80$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $0c21756c5f4cbc80$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $0c21756c5f4cbc80$var$ReactSharedInternals.T;
        $0c21756c5f4cbc80$var$ReactSharedInternals.T = null;
        updatedLanes = $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p;
        $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $0c21756c5f4cbc80$var$executionContext;
        $0c21756c5f4cbc80$var$executionContext |= 4;
        try {
            $0c21756c5f4cbc80$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $0c21756c5f4cbc80$var$executionContext = suspendedRetryLanes, $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = updatedLanes, $0c21756c5f4cbc80$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $0c21756c5f4cbc80$var$pendingEffectsStatus = 1;
    $0c21756c5f4cbc80$var$shouldStartViewTransition ? $0c21756c5f4cbc80$var$pendingViewTransition = $0c21756c5f4cbc80$var$startViewTransition(suspendedState, root.containerInfo, $0c21756c5f4cbc80$var$pendingTransitionTypes, $0c21756c5f4cbc80$var$flushMutationEffects, $0c21756c5f4cbc80$var$flushLayoutEffects, $0c21756c5f4cbc80$var$flushAfterMutationEffects, $0c21756c5f4cbc80$var$flushSpawnedWork, $0c21756c5f4cbc80$var$flushPassiveEffects, $0c21756c5f4cbc80$var$reportViewTransitionError, null, null) : ($0c21756c5f4cbc80$var$flushMutationEffects(), $0c21756c5f4cbc80$var$flushLayoutEffects(), $0c21756c5f4cbc80$var$flushSpawnedWork());
}
function $0c21756c5f4cbc80$var$reportViewTransitionError(error) {
    if (0 !== $0c21756c5f4cbc80$var$pendingEffectsStatus) {
        var onRecoverableError = $0c21756c5f4cbc80$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $0c21756c5f4cbc80$var$flushAfterMutationEffects() {
    3 === $0c21756c5f4cbc80$var$pendingEffectsStatus && ($0c21756c5f4cbc80$var$pendingEffectsStatus = 0, $0c21756c5f4cbc80$var$commitAfterMutationEffectsOnFiber($0c21756c5f4cbc80$var$pendingFinishedWork, $0c21756c5f4cbc80$var$pendingEffectsRoot), $0c21756c5f4cbc80$var$pendingEffectsStatus = 4);
}
function $0c21756c5f4cbc80$var$flushMutationEffects() {
    if (1 === $0c21756c5f4cbc80$var$pendingEffectsStatus) {
        $0c21756c5f4cbc80$var$pendingEffectsStatus = 0;
        var root = $0c21756c5f4cbc80$var$pendingEffectsRoot, finishedWork = $0c21756c5f4cbc80$var$pendingFinishedWork, lanes = $0c21756c5f4cbc80$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $0c21756c5f4cbc80$var$ReactSharedInternals.T;
            $0c21756c5f4cbc80$var$ReactSharedInternals.T = null;
            var previousPriority = $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p;
            $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $0c21756c5f4cbc80$var$executionContext;
            $0c21756c5f4cbc80$var$executionContext |= 4;
            try {
                $0c21756c5f4cbc80$var$inUpdateViewTransition = $0c21756c5f4cbc80$var$rootViewTransitionAffected = !1;
                $0c21756c5f4cbc80$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $0c21756c5f4cbc80$var$selectionInformation;
                var curFocusedElem = $0c21756c5f4cbc80$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $0c21756c5f4cbc80$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $0c21756c5f4cbc80$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $0c21756c5f4cbc80$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $0c21756c5f4cbc80$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $0c21756c5f4cbc80$var$_enabled = !!$0c21756c5f4cbc80$var$eventsEnabled;
                $0c21756c5f4cbc80$var$selectionInformation = $0c21756c5f4cbc80$var$eventsEnabled = null;
            } finally{
                $0c21756c5f4cbc80$var$executionContext = prevExecutionContext, $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = previousPriority, $0c21756c5f4cbc80$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $0c21756c5f4cbc80$var$pendingEffectsStatus = 2;
    }
}
function $0c21756c5f4cbc80$var$flushLayoutEffects() {
    if (2 === $0c21756c5f4cbc80$var$pendingEffectsStatus) {
        $0c21756c5f4cbc80$var$pendingEffectsStatus = 0;
        var root = $0c21756c5f4cbc80$var$pendingEffectsRoot, finishedWork = $0c21756c5f4cbc80$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $0c21756c5f4cbc80$var$ReactSharedInternals.T;
            $0c21756c5f4cbc80$var$ReactSharedInternals.T = null;
            var previousPriority = $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p;
            $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $0c21756c5f4cbc80$var$executionContext;
            $0c21756c5f4cbc80$var$executionContext |= 4;
            try {
                $0c21756c5f4cbc80$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $0c21756c5f4cbc80$var$executionContext = prevExecutionContext, $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = previousPriority, $0c21756c5f4cbc80$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $0c21756c5f4cbc80$var$pendingEffectsStatus = 3;
    }
}
function $0c21756c5f4cbc80$var$flushSpawnedWork() {
    if (4 === $0c21756c5f4cbc80$var$pendingEffectsStatus || 3 === $0c21756c5f4cbc80$var$pendingEffectsStatus) {
        $0c21756c5f4cbc80$var$pendingEffectsStatus = 0;
        var committedViewTransition = $0c21756c5f4cbc80$var$pendingViewTransition;
        $0c21756c5f4cbc80$var$pendingViewTransition = null;
        $0c21756c5f4cbc80$var$requestPaint();
        var root = $0c21756c5f4cbc80$var$pendingEffectsRoot, finishedWork = $0c21756c5f4cbc80$var$pendingFinishedWork, lanes = $0c21756c5f4cbc80$var$pendingEffectsLanes, recoverableErrors = $0c21756c5f4cbc80$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $0c21756c5f4cbc80$var$pendingEffectsStatus = 5 : ($0c21756c5f4cbc80$var$pendingEffectsStatus = 0, $0c21756c5f4cbc80$var$pendingFinishedWork = $0c21756c5f4cbc80$var$pendingEffectsRoot = null, $0c21756c5f4cbc80$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($0c21756c5f4cbc80$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $0c21756c5f4cbc80$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($0c21756c5f4cbc80$var$injectedHook && "function" === typeof $0c21756c5f4cbc80$var$injectedHook.onCommitFiberRoot) try {
            $0c21756c5f4cbc80$var$injectedHook.onCommitFiberRoot($0c21756c5f4cbc80$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $0c21756c5f4cbc80$var$ReactSharedInternals.T;
            passiveSubtreeMask = $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p;
            $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = 2;
            $0c21756c5f4cbc80$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $0c21756c5f4cbc80$var$ReactSharedInternals.T = finishedWork, $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $0c21756c5f4cbc80$var$pendingViewTransitionEvents;
        onRecoverableError = $0c21756c5f4cbc80$var$pendingTransitionTypes;
        $0c21756c5f4cbc80$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($0c21756c5f4cbc80$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($0c21756c5f4cbc80$var$pendingEffectsLanes & 3) && $0c21756c5f4cbc80$var$flushPendingEffects();
        $0c21756c5f4cbc80$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $0c21756c5f4cbc80$var$rootWithNestedUpdates ? $0c21756c5f4cbc80$var$nestedUpdateCount++ : ($0c21756c5f4cbc80$var$nestedUpdateCount = 0, $0c21756c5f4cbc80$var$rootWithNestedUpdates = root) : ($0c21756c5f4cbc80$var$nestedUpdateCount = 0, $0c21756c5f4cbc80$var$rootWithNestedUpdates = null);
        $0c21756c5f4cbc80$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $0c21756c5f4cbc80$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $0c21756c5f4cbc80$var$releaseCache(remainingLanes)));
}
function $0c21756c5f4cbc80$var$flushPendingEffects() {
    null !== $0c21756c5f4cbc80$var$pendingViewTransition && ($0c21756c5f4cbc80$var$pendingViewTransition.skipTransition(), $0c21756c5f4cbc80$var$pendingViewTransition = null);
    $0c21756c5f4cbc80$var$flushMutationEffects();
    $0c21756c5f4cbc80$var$flushLayoutEffects();
    $0c21756c5f4cbc80$var$flushSpawnedWork();
    return $0c21756c5f4cbc80$var$flushPassiveEffects();
}
function $0c21756c5f4cbc80$var$flushPassiveEffects() {
    if (5 !== $0c21756c5f4cbc80$var$pendingEffectsStatus) return !1;
    var root = $0c21756c5f4cbc80$var$pendingEffectsRoot, remainingLanes = $0c21756c5f4cbc80$var$pendingEffectsRemainingLanes;
    $0c21756c5f4cbc80$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $0c21756c5f4cbc80$var$lanesToEventPriority($0c21756c5f4cbc80$var$pendingEffectsLanes), prevTransition = $0c21756c5f4cbc80$var$ReactSharedInternals.T, previousPriority = $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p;
    try {
        $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $0c21756c5f4cbc80$var$ReactSharedInternals.T = null;
        renderPriority = $0c21756c5f4cbc80$var$pendingPassiveTransitions;
        $0c21756c5f4cbc80$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $0c21756c5f4cbc80$var$pendingEffectsRoot, lanes = $0c21756c5f4cbc80$var$pendingEffectsLanes;
        $0c21756c5f4cbc80$var$pendingEffectsStatus = 0;
        $0c21756c5f4cbc80$var$pendingFinishedWork = $0c21756c5f4cbc80$var$pendingEffectsRoot = null;
        $0c21756c5f4cbc80$var$pendingEffectsLanes = 0;
        if (0 !== ($0c21756c5f4cbc80$var$executionContext & 6)) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(331));
        var prevExecutionContext = $0c21756c5f4cbc80$var$executionContext;
        $0c21756c5f4cbc80$var$executionContext |= 4;
        $0c21756c5f4cbc80$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $0c21756c5f4cbc80$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $0c21756c5f4cbc80$var$executionContext = prevExecutionContext;
        $0c21756c5f4cbc80$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($0c21756c5f4cbc80$var$injectedHook && "function" === typeof $0c21756c5f4cbc80$var$injectedHook.onPostCommitFiberRoot) try {
            $0c21756c5f4cbc80$var$injectedHook.onPostCommitFiberRoot($0c21756c5f4cbc80$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = previousPriority, $0c21756c5f4cbc80$var$ReactSharedInternals.T = prevTransition, $0c21756c5f4cbc80$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $0c21756c5f4cbc80$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $0c21756c5f4cbc80$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $0c21756c5f4cbc80$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $0c21756c5f4cbc80$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($0c21756c5f4cbc80$var$markRootUpdated$1(rootFiber, 2), $0c21756c5f4cbc80$var$ensureRootIsScheduled(rootFiber));
}
function $0c21756c5f4cbc80$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $0c21756c5f4cbc80$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $0c21756c5f4cbc80$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $0c21756c5f4cbc80$var$legacyErrorBoundariesThatAlreadyFailed || !$0c21756c5f4cbc80$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $0c21756c5f4cbc80$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $0c21756c5f4cbc80$var$createClassErrorUpdate(2);
                instance = $0c21756c5f4cbc80$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($0c21756c5f4cbc80$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $0c21756c5f4cbc80$var$markRootUpdated$1(instance, 2), $0c21756c5f4cbc80$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $0c21756c5f4cbc80$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $0c21756c5f4cbc80$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($0c21756c5f4cbc80$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $0c21756c5f4cbc80$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $0c21756c5f4cbc80$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $0c21756c5f4cbc80$var$workInProgressRoot === root && ($0c21756c5f4cbc80$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $0c21756c5f4cbc80$var$workInProgressRootExitStatus || 3 === $0c21756c5f4cbc80$var$workInProgressRootExitStatus && ($0c21756c5f4cbc80$var$workInProgressRootRenderLanes & 62914560) === $0c21756c5f4cbc80$var$workInProgressRootRenderLanes && 300 > $0c21756c5f4cbc80$var$now() - $0c21756c5f4cbc80$var$globalMostRecentFallbackTime ? 0 === ($0c21756c5f4cbc80$var$executionContext & 2) ? $0c21756c5f4cbc80$var$prepareFreshStack(root, 0) : $0c21756c5f4cbc80$var$workInProgressRootPingedLanes |= pingedLanes : $0c21756c5f4cbc80$var$workInProgressRootPingedLanes |= pingedLanes, $0c21756c5f4cbc80$var$workInProgressSuspendedRetryLanes === $0c21756c5f4cbc80$var$workInProgressRootRenderLanes && ($0c21756c5f4cbc80$var$workInProgressSuspendedRetryLanes = 0));
    $0c21756c5f4cbc80$var$ensureRootIsScheduled(root);
}
function $0c21756c5f4cbc80$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $0c21756c5f4cbc80$var$claimNextRetryLane());
    boundaryFiber = $0c21756c5f4cbc80$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($0c21756c5f4cbc80$var$markRootUpdated$1(boundaryFiber, retryLane), $0c21756c5f4cbc80$var$ensureRootIsScheduled(boundaryFiber));
}
function $0c21756c5f4cbc80$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $0c21756c5f4cbc80$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $0c21756c5f4cbc80$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $0c21756c5f4cbc80$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $0c21756c5f4cbc80$var$scheduleCallback$1(priorityLevel, callback) {
    return $0c21756c5f4cbc80$var$scheduleCallback$3(priorityLevel, callback);
}
var $0c21756c5f4cbc80$var$firstScheduledRoot = null, $0c21756c5f4cbc80$var$lastScheduledRoot = null, $0c21756c5f4cbc80$var$didScheduleMicrotask = !1, $0c21756c5f4cbc80$var$mightHavePendingSyncWork = !1, $0c21756c5f4cbc80$var$isFlushingWork = !1, $0c21756c5f4cbc80$var$currentEventTransitionLane = 0;
function $0c21756c5f4cbc80$var$ensureRootIsScheduled(root) {
    root !== $0c21756c5f4cbc80$var$lastScheduledRoot && null === root.next && (null === $0c21756c5f4cbc80$var$lastScheduledRoot ? $0c21756c5f4cbc80$var$firstScheduledRoot = $0c21756c5f4cbc80$var$lastScheduledRoot = root : $0c21756c5f4cbc80$var$lastScheduledRoot = $0c21756c5f4cbc80$var$lastScheduledRoot.next = root);
    $0c21756c5f4cbc80$var$mightHavePendingSyncWork = !0;
    $0c21756c5f4cbc80$var$didScheduleMicrotask || ($0c21756c5f4cbc80$var$didScheduleMicrotask = !0, $0c21756c5f4cbc80$var$scheduleImmediateRootScheduleTask());
}
function $0c21756c5f4cbc80$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$0c21756c5f4cbc80$var$isFlushingWork && $0c21756c5f4cbc80$var$mightHavePendingSyncWork) {
        $0c21756c5f4cbc80$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $0c21756c5f4cbc80$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $0c21756c5f4cbc80$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $0c21756c5f4cbc80$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $0c21756c5f4cbc80$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $0c21756c5f4cbc80$var$getNextLanes(root$190, root$190 === $0c21756c5f4cbc80$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $0c21756c5f4cbc80$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $0c21756c5f4cbc80$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $0c21756c5f4cbc80$var$isFlushingWork = !1;
    }
}
function $0c21756c5f4cbc80$var$processRootScheduleInImmediateTask() {
    $0c21756c5f4cbc80$var$processRootScheduleInMicrotask();
}
function $0c21756c5f4cbc80$var$processRootScheduleInMicrotask() {
    $0c21756c5f4cbc80$var$mightHavePendingSyncWork = $0c21756c5f4cbc80$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $0c21756c5f4cbc80$var$currentEventTransitionLane && $0c21756c5f4cbc80$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $0c21756c5f4cbc80$var$currentEventTransitionLane);
    for(var currentTime = $0c21756c5f4cbc80$var$now(), prev = null, root = $0c21756c5f4cbc80$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $0c21756c5f4cbc80$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $0c21756c5f4cbc80$var$firstScheduledRoot = next : prev.next = next, null === next && ($0c21756c5f4cbc80$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $0c21756c5f4cbc80$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $0c21756c5f4cbc80$var$pendingEffectsStatus && 5 !== $0c21756c5f4cbc80$var$pendingEffectsStatus || $0c21756c5f4cbc80$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $0c21756c5f4cbc80$var$currentEventTransitionLane && ($0c21756c5f4cbc80$var$currentEventTransitionLane = 0);
}
function $0c21756c5f4cbc80$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $0c21756c5f4cbc80$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $0c21756c5f4cbc80$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $0c21756c5f4cbc80$var$workInProgressRoot;
    suspendedLanes = $0c21756c5f4cbc80$var$workInProgressRootRenderLanes;
    suspendedLanes = $0c21756c5f4cbc80$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $0c21756c5f4cbc80$var$workInProgressSuspendedReason || 9 === $0c21756c5f4cbc80$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $0c21756c5f4cbc80$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $0c21756c5f4cbc80$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $0c21756c5f4cbc80$var$cancelCallback$1(pingedLanes);
        switch($0c21756c5f4cbc80$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $0c21756c5f4cbc80$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $0c21756c5f4cbc80$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $0c21756c5f4cbc80$var$IdlePriority;
                break;
            default:
                suspendedLanes = $0c21756c5f4cbc80$var$NormalPriority$1;
        }
        pingedLanes = $0c21756c5f4cbc80$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $0c21756c5f4cbc80$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $0c21756c5f4cbc80$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $0c21756c5f4cbc80$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $0c21756c5f4cbc80$var$pendingEffectsStatus && 5 !== $0c21756c5f4cbc80$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($0c21756c5f4cbc80$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $0c21756c5f4cbc80$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $0c21756c5f4cbc80$var$getNextLanes(root, root === $0c21756c5f4cbc80$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $0c21756c5f4cbc80$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $0c21756c5f4cbc80$var$scheduleTaskForRootDuringMicrotask(root, $0c21756c5f4cbc80$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $0c21756c5f4cbc80$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $0c21756c5f4cbc80$var$performSyncWorkOnRoot(root, lanes) {
    if ($0c21756c5f4cbc80$var$flushPendingEffects()) return null;
    $0c21756c5f4cbc80$var$performWorkOnRoot(root, lanes, !0);
}
function $0c21756c5f4cbc80$var$scheduleImmediateRootScheduleTask() {
    $0c21756c5f4cbc80$var$scheduleMicrotask(function() {
        0 !== ($0c21756c5f4cbc80$var$executionContext & 6) ? $0c21756c5f4cbc80$var$scheduleCallback$3($0c21756c5f4cbc80$var$ImmediatePriority, $0c21756c5f4cbc80$var$processRootScheduleInImmediateTask) : $0c21756c5f4cbc80$var$processRootScheduleInMicrotask();
    });
}
function $0c21756c5f4cbc80$var$requestTransitionLane() {
    if (0 === $0c21756c5f4cbc80$var$currentEventTransitionLane) {
        var actionScopeLane = $0c21756c5f4cbc80$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $0c21756c5f4cbc80$var$nextTransitionUpdateLane, $0c21756c5f4cbc80$var$nextTransitionUpdateLane <<= 1, 0 === ($0c21756c5f4cbc80$var$nextTransitionUpdateLane & 261888) && ($0c21756c5f4cbc80$var$nextTransitionUpdateLane = 256));
        $0c21756c5f4cbc80$var$currentEventTransitionLane = actionScopeLane;
    }
    return $0c21756c5f4cbc80$var$currentEventTransitionLane;
}
function $0c21756c5f4cbc80$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $0c21756c5f4cbc80$var$sanitizeURL(actionProp);
}
function $0c21756c5f4cbc80$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $0c21756c5f4cbc80$var$coerceFormActionProp((nativeEventTarget[$0c21756c5f4cbc80$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$0c21756c5f4cbc80$var$internalPropsKey] || null) ? $0c21756c5f4cbc80$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $0c21756c5f4cbc80$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $0c21756c5f4cbc80$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $0c21756c5f4cbc80$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $0c21756c5f4cbc80$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $0c21756c5f4cbc80$var$i$jscomp$inline_1667 = 0; $0c21756c5f4cbc80$var$i$jscomp$inline_1667 < $0c21756c5f4cbc80$var$simpleEventPluginEvents.length; $0c21756c5f4cbc80$var$i$jscomp$inline_1667++){
    var $0c21756c5f4cbc80$var$eventName$jscomp$inline_1668 = $0c21756c5f4cbc80$var$simpleEventPluginEvents[$0c21756c5f4cbc80$var$i$jscomp$inline_1667], $0c21756c5f4cbc80$var$domEventName$jscomp$inline_1669 = $0c21756c5f4cbc80$var$eventName$jscomp$inline_1668.toLowerCase(), $0c21756c5f4cbc80$var$capitalizedEvent$jscomp$inline_1670 = $0c21756c5f4cbc80$var$eventName$jscomp$inline_1668[0].toUpperCase() + $0c21756c5f4cbc80$var$eventName$jscomp$inline_1668.slice(1);
    $0c21756c5f4cbc80$var$registerSimpleEvent($0c21756c5f4cbc80$var$domEventName$jscomp$inline_1669, "on" + $0c21756c5f4cbc80$var$capitalizedEvent$jscomp$inline_1670);
}
$0c21756c5f4cbc80$var$registerSimpleEvent($0c21756c5f4cbc80$var$ANIMATION_END, "onAnimationEnd");
$0c21756c5f4cbc80$var$registerSimpleEvent($0c21756c5f4cbc80$var$ANIMATION_ITERATION, "onAnimationIteration");
$0c21756c5f4cbc80$var$registerSimpleEvent($0c21756c5f4cbc80$var$ANIMATION_START, "onAnimationStart");
$0c21756c5f4cbc80$var$registerSimpleEvent("dblclick", "onDoubleClick");
$0c21756c5f4cbc80$var$registerSimpleEvent("focusin", "onFocus");
$0c21756c5f4cbc80$var$registerSimpleEvent("focusout", "onBlur");
$0c21756c5f4cbc80$var$registerSimpleEvent($0c21756c5f4cbc80$var$TRANSITION_RUN, "onTransitionRun");
$0c21756c5f4cbc80$var$registerSimpleEvent($0c21756c5f4cbc80$var$TRANSITION_START, "onTransitionStart");
$0c21756c5f4cbc80$var$registerSimpleEvent($0c21756c5f4cbc80$var$TRANSITION_CANCEL, "onTransitionCancel");
$0c21756c5f4cbc80$var$registerSimpleEvent($0c21756c5f4cbc80$var$TRANSITION_END, "onTransitionEnd");
$0c21756c5f4cbc80$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0c21756c5f4cbc80$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0c21756c5f4cbc80$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0c21756c5f4cbc80$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0c21756c5f4cbc80$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0c21756c5f4cbc80$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0c21756c5f4cbc80$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0c21756c5f4cbc80$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0c21756c5f4cbc80$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0c21756c5f4cbc80$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0c21756c5f4cbc80$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0c21756c5f4cbc80$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($0c21756c5f4cbc80$var$mediaEventTypes));
function $0c21756c5f4cbc80$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $0c21756c5f4cbc80$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $0c21756c5f4cbc80$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $0c21756c5f4cbc80$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$0c21756c5f4cbc80$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$0c21756c5f4cbc80$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($0c21756c5f4cbc80$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $0c21756c5f4cbc80$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $0c21756c5f4cbc80$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $0c21756c5f4cbc80$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $0c21756c5f4cbc80$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$0c21756c5f4cbc80$var$listeningMarker]) {
        rootContainerElement[$0c21756c5f4cbc80$var$listeningMarker] = !0;
        $0c21756c5f4cbc80$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($0c21756c5f4cbc80$var$nonDelegatedEvents.has(domEventName) || $0c21756c5f4cbc80$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $0c21756c5f4cbc80$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$0c21756c5f4cbc80$var$listeningMarker] || (ownerDocument[$0c21756c5f4cbc80$var$listeningMarker] = !0, $0c21756c5f4cbc80$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $0c21756c5f4cbc80$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($0c21756c5f4cbc80$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $0c21756c5f4cbc80$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $0c21756c5f4cbc80$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $0c21756c5f4cbc80$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$0c21756c5f4cbc80$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $0c21756c5f4cbc80$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $0c21756c5f4cbc80$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $0c21756c5f4cbc80$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $0c21756c5f4cbc80$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $0c21756c5f4cbc80$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $0c21756c5f4cbc80$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticTouchEvent;
                        break;
                    case $0c21756c5f4cbc80$var$ANIMATION_END:
                    case $0c21756c5f4cbc80$var$ANIMATION_ITERATION:
                    case $0c21756c5f4cbc80$var$ANIMATION_START:
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticAnimationEvent;
                        break;
                    case $0c21756c5f4cbc80$var$TRANSITION_END:
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $0c21756c5f4cbc80$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $0c21756c5f4cbc80$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($0c21756c5f4cbc80$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $0c21756c5f4cbc80$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($0c21756c5f4cbc80$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$0c21756c5f4cbc80$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $0c21756c5f4cbc80$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $0c21756c5f4cbc80$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $0c21756c5f4cbc80$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $0c21756c5f4cbc80$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $0c21756c5f4cbc80$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $0c21756c5f4cbc80$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $0c21756c5f4cbc80$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $0c21756c5f4cbc80$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $0c21756c5f4cbc80$var$getParent) : null;
                        null !== reactName && $0c21756c5f4cbc80$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $0c21756c5f4cbc80$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $0c21756c5f4cbc80$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $0c21756c5f4cbc80$var$getTargetInstForChangeEvent;
                else if ($0c21756c5f4cbc80$var$isTextInputElement(reactName)) {
                    if ($0c21756c5f4cbc80$var$isInputEventSupported) getTargetInstFunc = $0c21756c5f4cbc80$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $0c21756c5f4cbc80$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $0c21756c5f4cbc80$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $0c21756c5f4cbc80$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $0c21756c5f4cbc80$var$getTargetInstForChangeEvent) : getTargetInstFunc = $0c21756c5f4cbc80$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $0c21756c5f4cbc80$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $0c21756c5f4cbc80$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($0c21756c5f4cbc80$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $0c21756c5f4cbc80$var$activeElement = handleEventFunc, $0c21756c5f4cbc80$var$activeElementInst = targetInst, $0c21756c5f4cbc80$var$lastSelection = null;
                    break;
                case "focusout":
                    $0c21756c5f4cbc80$var$lastSelection = $0c21756c5f4cbc80$var$activeElementInst = $0c21756c5f4cbc80$var$activeElement = null;
                    break;
                case "mousedown":
                    $0c21756c5f4cbc80$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0c21756c5f4cbc80$var$mouseDown = !1;
                    $0c21756c5f4cbc80$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($0c21756c5f4cbc80$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $0c21756c5f4cbc80$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($0c21756c5f4cbc80$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $0c21756c5f4cbc80$var$isComposing ? $0c21756c5f4cbc80$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($0c21756c5f4cbc80$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($0c21756c5f4cbc80$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $0c21756c5f4cbc80$var$isComposing && (fallbackData = $0c21756c5f4cbc80$var$getData()) : ($0c21756c5f4cbc80$var$root = nativeEventTarget, $0c21756c5f4cbc80$var$startText = "value" in $0c21756c5f4cbc80$var$root ? $0c21756c5f4cbc80$var$root.value : $0c21756c5f4cbc80$var$root.textContent, $0c21756c5f4cbc80$var$isComposing = !0)), handleEventFunc = $0c21756c5f4cbc80$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $0c21756c5f4cbc80$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $0c21756c5f4cbc80$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $0c21756c5f4cbc80$var$canUseTextInputEvent ? $0c21756c5f4cbc80$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $0c21756c5f4cbc80$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $0c21756c5f4cbc80$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $0c21756c5f4cbc80$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $0c21756c5f4cbc80$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $0c21756c5f4cbc80$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $0c21756c5f4cbc80$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $0c21756c5f4cbc80$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $0c21756c5f4cbc80$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($0c21756c5f4cbc80$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $0c21756c5f4cbc80$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($0c21756c5f4cbc80$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $0c21756c5f4cbc80$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $0c21756c5f4cbc80$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $0c21756c5f4cbc80$var$getListener(target, registrationName), null != stateNode && listeners.unshift($0c21756c5f4cbc80$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $0c21756c5f4cbc80$var$getListener(target, registrationName), null != stateNode && listeners.push($0c21756c5f4cbc80$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $0c21756c5f4cbc80$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $0c21756c5f4cbc80$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $0c21756c5f4cbc80$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($0c21756c5f4cbc80$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($0c21756c5f4cbc80$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $0c21756c5f4cbc80$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $0c21756c5f4cbc80$var$normalizeMarkupForTextOrAttribute(clientText);
    return $0c21756c5f4cbc80$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $0c21756c5f4cbc80$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $0c21756c5f4cbc80$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $0c21756c5f4cbc80$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $0c21756c5f4cbc80$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $0c21756c5f4cbc80$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $0c21756c5f4cbc80$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $0c21756c5f4cbc80$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $0c21756c5f4cbc80$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $0c21756c5f4cbc80$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $0c21756c5f4cbc80$var$setProp(domElement, tag, "name", props.name, props, null), $0c21756c5f4cbc80$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $0c21756c5f4cbc80$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $0c21756c5f4cbc80$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($0c21756c5f4cbc80$var$setProp(domElement, tag, "encType", props.encType, props, null), $0c21756c5f4cbc80$var$setProp(domElement, tag, "method", props.method, props, null), $0c21756c5f4cbc80$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $0c21756c5f4cbc80$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $0c21756c5f4cbc80$var$noop$1);
            return;
        case "onScroll":
            null != value && $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $0c21756c5f4cbc80$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("toggle", domElement);
            $0c21756c5f4cbc80$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $0c21756c5f4cbc80$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $0c21756c5f4cbc80$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $0c21756c5f4cbc80$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $0c21756c5f4cbc80$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $0c21756c5f4cbc80$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $0c21756c5f4cbc80$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $0c21756c5f4cbc80$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $0c21756c5f4cbc80$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $0c21756c5f4cbc80$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $0c21756c5f4cbc80$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $0c21756c5f4cbc80$var$aliases.get(key) || key, $0c21756c5f4cbc80$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $0c21756c5f4cbc80$var$viewTransitionMutationContext = !0;
}
function $0c21756c5f4cbc80$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $0c21756c5f4cbc80$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $0c21756c5f4cbc80$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $0c21756c5f4cbc80$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $0c21756c5f4cbc80$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$0c21756c5f4cbc80$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$0c21756c5f4cbc80$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $0c21756c5f4cbc80$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $0c21756c5f4cbc80$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $0c21756c5f4cbc80$var$viewTransitionMutationContext = !0;
}
function $0c21756c5f4cbc80$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("error", domElement);
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(137, tag));
                    default:
                        $0c21756c5f4cbc80$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $0c21756c5f4cbc80$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $0c21756c5f4cbc80$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $0c21756c5f4cbc80$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $0c21756c5f4cbc80$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $0c21756c5f4cbc80$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $0c21756c5f4cbc80$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $0c21756c5f4cbc80$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(91));
                    break;
                default:
                    $0c21756c5f4cbc80$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $0c21756c5f4cbc80$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $0c21756c5f4cbc80$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("toggle", domElement);
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("cancel", domElement);
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $0c21756c5f4cbc80$var$mediaEventTypes.length; hasSrc++)$0c21756c5f4cbc80$var$listenToNonDelegatedEvent($0c21756c5f4cbc80$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("error", domElement);
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("error", domElement), $0c21756c5f4cbc80$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(137, tag));
                default:
                    $0c21756c5f4cbc80$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($0c21756c5f4cbc80$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $0c21756c5f4cbc80$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $0c21756c5f4cbc80$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $0c21756c5f4cbc80$var$emptyProps = {};
function $0c21756c5f4cbc80$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $0c21756c5f4cbc80$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($0c21756c5f4cbc80$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($0c21756c5f4cbc80$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($0c21756c5f4cbc80$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($0c21756c5f4cbc80$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($0c21756c5f4cbc80$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($0c21756c5f4cbc80$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $0c21756c5f4cbc80$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $0c21756c5f4cbc80$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $0c21756c5f4cbc80$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($0c21756c5f4cbc80$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($0c21756c5f4cbc80$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($0c21756c5f4cbc80$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $0c21756c5f4cbc80$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $0c21756c5f4cbc80$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $0c21756c5f4cbc80$var$updateOptions(domElement, !!lastProps, tag, !0) : $0c21756c5f4cbc80$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $0c21756c5f4cbc80$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($0c21756c5f4cbc80$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($0c21756c5f4cbc80$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $0c21756c5f4cbc80$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $0c21756c5f4cbc80$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $0c21756c5f4cbc80$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($0c21756c5f4cbc80$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $0c21756c5f4cbc80$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $0c21756c5f4cbc80$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $0c21756c5f4cbc80$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($0c21756c5f4cbc80$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $0c21756c5f4cbc80$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $0c21756c5f4cbc80$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $0c21756c5f4cbc80$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $0c21756c5f4cbc80$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $0c21756c5f4cbc80$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $0c21756c5f4cbc80$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $0c21756c5f4cbc80$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $0c21756c5f4cbc80$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $0c21756c5f4cbc80$var$eventsEnabled = null, $0c21756c5f4cbc80$var$selectionInformation = null;
function $0c21756c5f4cbc80$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $0c21756c5f4cbc80$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $0c21756c5f4cbc80$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $0c21756c5f4cbc80$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $0c21756c5f4cbc80$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$0c21756c5f4cbc80$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$0c21756c5f4cbc80$var$internalPropsKey] = props;
    $0c21756c5f4cbc80$var$setInitialProperties(rootContainerInstance, type, props);
    $0c21756c5f4cbc80$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $0c21756c5f4cbc80$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $0c21756c5f4cbc80$var$currentPopstateTransitionEvent = null;
function $0c21756c5f4cbc80$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $0c21756c5f4cbc80$var$currentPopstateTransitionEvent) return !1;
        $0c21756c5f4cbc80$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $0c21756c5f4cbc80$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $0c21756c5f4cbc80$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $0c21756c5f4cbc80$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $0c21756c5f4cbc80$var$localPromise = "function" === typeof Promise ? Promise : void 0, $0c21756c5f4cbc80$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $0c21756c5f4cbc80$var$scheduleTimeout, $0c21756c5f4cbc80$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0c21756c5f4cbc80$var$localPromise ? function(callback) {
    return $0c21756c5f4cbc80$var$localPromise.resolve(null).then(callback).catch($0c21756c5f4cbc80$var$handleErrorInNextTick);
} : $0c21756c5f4cbc80$var$scheduleTimeout;
function $0c21756c5f4cbc80$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $0c21756c5f4cbc80$var$isSingletonScope(type) {
    return "head" === type;
}
function $0c21756c5f4cbc80$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $0c21756c5f4cbc80$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $0c21756c5f4cbc80$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $0c21756c5f4cbc80$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$0c21756c5f4cbc80$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $0c21756c5f4cbc80$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $0c21756c5f4cbc80$var$retryIfBlockedOn(hydrationInstance);
}
function $0c21756c5f4cbc80$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $0c21756c5f4cbc80$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $0c21756c5f4cbc80$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $0c21756c5f4cbc80$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $0c21756c5f4cbc80$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $0c21756c5f4cbc80$var$createMeasurement(rect, computedStyle, instance);
}
function $0c21756c5f4cbc80$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $0c21756c5f4cbc80$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $0c21756c5f4cbc80$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $0c21756c5f4cbc80$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $0c21756c5f4cbc80$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($0c21756c5f4cbc80$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $0c21756c5f4cbc80$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $0c21756c5f4cbc80$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($0c21756c5f4cbc80$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $0c21756c5f4cbc80$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$0c21756c5f4cbc80$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $0c21756c5f4cbc80$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$0c21756c5f4cbc80$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$0c21756c5f4cbc80$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $0c21756c5f4cbc80$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $0c21756c5f4cbc80$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $0c21756c5f4cbc80$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $0c21756c5f4cbc80$var$ViewTransitionPseudoElement("old", name),
        new: new $0c21756c5f4cbc80$var$ViewTransitionPseudoElement("new", name)
    };
}
function $0c21756c5f4cbc80$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$0c21756c5f4cbc80$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $0c21756c5f4cbc80$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $0c21756c5f4cbc80$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $0c21756c5f4cbc80$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $0c21756c5f4cbc80$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $0c21756c5f4cbc80$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$0c21756c5f4cbc80$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $0c21756c5f4cbc80$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $0c21756c5f4cbc80$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $0c21756c5f4cbc80$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $0c21756c5f4cbc80$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $0c21756c5f4cbc80$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $0c21756c5f4cbc80$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $0c21756c5f4cbc80$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $0c21756c5f4cbc80$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $0c21756c5f4cbc80$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $0c21756c5f4cbc80$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$0c21756c5f4cbc80$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $0c21756c5f4cbc80$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $0c21756c5f4cbc80$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $0c21756c5f4cbc80$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$0c21756c5f4cbc80$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $0c21756c5f4cbc80$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $0c21756c5f4cbc80$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(fiber);
    return $0c21756c5f4cbc80$var$setFocusIfFocusable(fiber, focusOptions);
}
$0c21756c5f4cbc80$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $0c21756c5f4cbc80$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$0c21756c5f4cbc80$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $0c21756c5f4cbc80$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$0c21756c5f4cbc80$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $0c21756c5f4cbc80$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $0c21756c5f4cbc80$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $0c21756c5f4cbc80$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $0c21756c5f4cbc80$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$0c21756c5f4cbc80$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $0c21756c5f4cbc80$var$observeChild, observer, void 0, void 0);
};
function $0c21756c5f4cbc80$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$0c21756c5f4cbc80$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $0c21756c5f4cbc80$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $0c21756c5f4cbc80$var$pendingIntersectionUnobserves.length; i++){
            var pending = $0c21756c5f4cbc80$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $0c21756c5f4cbc80$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $0c21756c5f4cbc80$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $0c21756c5f4cbc80$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $0c21756c5f4cbc80$var$pendingIntersectionUnobserves = [], $0c21756c5f4cbc80$var$intersectionUnobserveScheduled = !1;
function $0c21756c5f4cbc80$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $0c21756c5f4cbc80$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $0c21756c5f4cbc80$var$intersectionUnobserveScheduled || ($0c21756c5f4cbc80$var$intersectionUnobserveScheduled = !0, $0c21756c5f4cbc80$var$requestPostPaintCallback(function() {
        $0c21756c5f4cbc80$var$intersectionUnobserveScheduled = !1;
        var pending = $0c21756c5f4cbc80$var$pendingIntersectionUnobserves;
        $0c21756c5f4cbc80$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$0c21756c5f4cbc80$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $0c21756c5f4cbc80$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $0c21756c5f4cbc80$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$0c21756c5f4cbc80$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $0c21756c5f4cbc80$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $0c21756c5f4cbc80$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$0c21756c5f4cbc80$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $0c21756c5f4cbc80$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $0c21756c5f4cbc80$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($0c21756c5f4cbc80$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $0c21756c5f4cbc80$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(children[0]);
    result = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $0c21756c5f4cbc80$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $0c21756c5f4cbc80$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $0c21756c5f4cbc80$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $0c21756c5f4cbc80$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $0c21756c5f4cbc80$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $0c21756c5f4cbc80$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $0c21756c5f4cbc80$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $0c21756c5f4cbc80$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $0c21756c5f4cbc80$var$searchTarget, $0c21756c5f4cbc80$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $0c21756c5f4cbc80$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $0c21756c5f4cbc80$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $0c21756c5f4cbc80$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $0c21756c5f4cbc80$var$searchTarget, $0c21756c5f4cbc80$var$searchBoundary = $0c21756c5f4cbc80$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $0c21756c5f4cbc80$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$0c21756c5f4cbc80$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(566));
    var children = [];
    $0c21756c5f4cbc80$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $0c21756c5f4cbc80$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $0c21756c5f4cbc80$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $0c21756c5f4cbc80$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(hostSiblings);
            $0c21756c5f4cbc80$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(child), $0c21756c5f4cbc80$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $0c21756c5f4cbc80$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $0c21756c5f4cbc80$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $0c21756c5f4cbc80$var$getInstanceFromHostFiber(child);
    $0c21756c5f4cbc80$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $0c21756c5f4cbc80$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $0c21756c5f4cbc80$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $0c21756c5f4cbc80$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $0c21756c5f4cbc80$var$pendingIntersectionUnobserves.length; i++){
            var pending = $0c21756c5f4cbc80$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $0c21756c5f4cbc80$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $0c21756c5f4cbc80$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $0c21756c5f4cbc80$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $0c21756c5f4cbc80$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $0c21756c5f4cbc80$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $0c21756c5f4cbc80$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $0c21756c5f4cbc80$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $0c21756c5f4cbc80$var$clearContainerSparingly(node);
                $0c21756c5f4cbc80$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $0c21756c5f4cbc80$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$0c21756c5f4cbc80$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $0c21756c5f4cbc80$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $0c21756c5f4cbc80$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $0c21756c5f4cbc80$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $0c21756c5f4cbc80$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $0c21756c5f4cbc80$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $0c21756c5f4cbc80$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $0c21756c5f4cbc80$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $0c21756c5f4cbc80$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $0c21756c5f4cbc80$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $0c21756c5f4cbc80$var$previousHydratableOnEnteringScopedSingleton = null;
function $0c21756c5f4cbc80$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $0c21756c5f4cbc80$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $0c21756c5f4cbc80$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $0c21756c5f4cbc80$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $0c21756c5f4cbc80$var$requestPostPaintCallback(callback) {
    $0c21756c5f4cbc80$var$localRequestAnimationFrame(function() {
        $0c21756c5f4cbc80$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $0c21756c5f4cbc80$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $0c21756c5f4cbc80$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(451));
    }
}
function $0c21756c5f4cbc80$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $0c21756c5f4cbc80$var$setProp(instance, type, propKey, null, $0c21756c5f4cbc80$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $0c21756c5f4cbc80$var$noop$1 && (instance.onclick = null);
    $0c21756c5f4cbc80$var$detachDeletedInstance(instance);
}
function $0c21756c5f4cbc80$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $0c21756c5f4cbc80$var$detachDeletedInstance(instance);
}
var $0c21756c5f4cbc80$var$preloadPropsMap = new Map(), $0c21756c5f4cbc80$var$preconnectsSet = new Set();
function $0c21756c5f4cbc80$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $0c21756c5f4cbc80$var$previousDispatcher = $0c21756c5f4cbc80$var$ReactDOMSharedInternals.d;
$0c21756c5f4cbc80$var$ReactDOMSharedInternals.d = {
    f: $0c21756c5f4cbc80$var$flushSyncWork,
    r: $0c21756c5f4cbc80$var$requestFormReset,
    D: $0c21756c5f4cbc80$var$prefetchDNS,
    C: $0c21756c5f4cbc80$var$preconnect,
    L: $0c21756c5f4cbc80$var$preload,
    m: $0c21756c5f4cbc80$var$preloadModule,
    X: $0c21756c5f4cbc80$var$preinitScript,
    S: $0c21756c5f4cbc80$var$preinitStyle,
    M: $0c21756c5f4cbc80$var$preinitModuleScript
};
function $0c21756c5f4cbc80$var$flushSyncWork() {
    var previousWasRendering = $0c21756c5f4cbc80$var$previousDispatcher.f(), wasRendering = $0c21756c5f4cbc80$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $0c21756c5f4cbc80$var$requestFormReset(form) {
    var formInst = $0c21756c5f4cbc80$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $0c21756c5f4cbc80$var$requestFormReset$1(formInst) : $0c21756c5f4cbc80$var$previousDispatcher.r(form);
}
var $0c21756c5f4cbc80$var$globalDocument = "undefined" === typeof document ? null : document;
function $0c21756c5f4cbc80$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $0c21756c5f4cbc80$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $0c21756c5f4cbc80$var$preconnectsSet.has(limitedEscapedHref) || ($0c21756c5f4cbc80$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $0c21756c5f4cbc80$var$setInitialProperties(href, "link", rel), $0c21756c5f4cbc80$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $0c21756c5f4cbc80$var$prefetchDNS(href) {
    $0c21756c5f4cbc80$var$previousDispatcher.D(href);
    $0c21756c5f4cbc80$var$preconnectAs("dns-prefetch", href, null);
}
function $0c21756c5f4cbc80$var$preconnect(href, crossOrigin) {
    $0c21756c5f4cbc80$var$previousDispatcher.C(href, crossOrigin);
    $0c21756c5f4cbc80$var$preconnectAs("preconnect", href, crossOrigin);
}
function $0c21756c5f4cbc80$var$preload(href, as, options) {
    $0c21756c5f4cbc80$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $0c21756c5f4cbc80$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $0c21756c5f4cbc80$var$getStyleKey(href);
                break;
            case "script":
                key = $0c21756c5f4cbc80$var$getScriptKey(href);
        }
        if (!($0c21756c5f4cbc80$var$preloadPropsMap.has(key) || (href = $0c21756c5f4cbc80$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $0c21756c5f4cbc80$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($0c21756c5f4cbc80$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($0c21756c5f4cbc80$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $0c21756c5f4cbc80$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$0c21756c5f4cbc80$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $0c21756c5f4cbc80$var$clearPendingLoadOnNode(instance);
            });
            $0c21756c5f4cbc80$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $0c21756c5f4cbc80$var$preloadModule(href, options) {
    $0c21756c5f4cbc80$var$previousDispatcher.m(href, options);
    var ownerDocument = $0c21756c5f4cbc80$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $0c21756c5f4cbc80$var$getScriptKey(href);
        }
        if (!$0c21756c5f4cbc80$var$preloadPropsMap.has(key) && (href = $0c21756c5f4cbc80$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $0c21756c5f4cbc80$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($0c21756c5f4cbc80$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $0c21756c5f4cbc80$var$setInitialProperties(as, "link", href);
            $0c21756c5f4cbc80$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $0c21756c5f4cbc80$var$preinitStyle(href, precedence, options) {
    $0c21756c5f4cbc80$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $0c21756c5f4cbc80$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $0c21756c5f4cbc80$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $0c21756c5f4cbc80$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($0c21756c5f4cbc80$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $0c21756c5f4cbc80$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $0c21756c5f4cbc80$var$preloadPropsMap.get(key)) && $0c21756c5f4cbc80$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $0c21756c5f4cbc80$var$markNodeAsHoistable(link);
                $0c21756c5f4cbc80$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $0c21756c5f4cbc80$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $0c21756c5f4cbc80$var$preinitScript(src, options) {
    $0c21756c5f4cbc80$var$previousDispatcher.X(src, options);
    var ownerDocument = $0c21756c5f4cbc80$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $0c21756c5f4cbc80$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $0c21756c5f4cbc80$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($0c21756c5f4cbc80$var$getScriptSelectorFromKey(key)), resource || (src = $0c21756c5f4cbc80$var$assign({
            src: src,
            async: !0
        }, options), (options = $0c21756c5f4cbc80$var$preloadPropsMap.get(key)) && $0c21756c5f4cbc80$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $0c21756c5f4cbc80$var$markNodeAsHoistable(resource), $0c21756c5f4cbc80$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $0c21756c5f4cbc80$var$preinitModuleScript(src, options) {
    $0c21756c5f4cbc80$var$previousDispatcher.M(src, options);
    var ownerDocument = $0c21756c5f4cbc80$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $0c21756c5f4cbc80$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $0c21756c5f4cbc80$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($0c21756c5f4cbc80$var$getScriptSelectorFromKey(key)), resource || (src = $0c21756c5f4cbc80$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $0c21756c5f4cbc80$var$preloadPropsMap.get(key)) && $0c21756c5f4cbc80$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $0c21756c5f4cbc80$var$markNodeAsHoistable(resource), $0c21756c5f4cbc80$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $0c21756c5f4cbc80$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $0c21756c5f4cbc80$var$rootInstanceStackCursor.current) ? $0c21756c5f4cbc80$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $0c21756c5f4cbc80$var$getStyleKey(pendingProps.href), currentProps = $0c21756c5f4cbc80$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $0c21756c5f4cbc80$var$getStyleKey(pendingProps.href);
                var styles$268 = $0c21756c5f4cbc80$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($0c21756c5f4cbc80$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $0c21756c5f4cbc80$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $0c21756c5f4cbc80$var$preloadPropsMap.set(type, styles$268)), $0c21756c5f4cbc80$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $0c21756c5f4cbc80$var$getScriptKey(pendingProps), currentProps = $0c21756c5f4cbc80$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(444, type));
    }
}
function $0c21756c5f4cbc80$var$getStyleKey(href) {
    return 'href="' + $0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $0c21756c5f4cbc80$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $0c21756c5f4cbc80$var$stylesheetPropsFromRawProps(rawProps) {
    return $0c21756c5f4cbc80$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $0c21756c5f4cbc80$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$0c21756c5f4cbc80$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$0c21756c5f4cbc80$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $0c21756c5f4cbc80$var$clearPendingLoadOnNode.bind(null, key), $0c21756c5f4cbc80$var$setInitialProperties(key, "link", preloadProps), $0c21756c5f4cbc80$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $0c21756c5f4cbc80$var$getScriptKey(src) {
    return '[src="' + $0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $0c21756c5f4cbc80$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $0c21756c5f4cbc80$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $0c21756c5f4cbc80$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $0c21756c5f4cbc80$var$markNodeAsHoistable(instance), instance;
            var styleProps = $0c21756c5f4cbc80$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $0c21756c5f4cbc80$var$markNodeAsHoistable(instance);
            $0c21756c5f4cbc80$var$setInitialProperties(instance, "style", styleProps);
            $0c21756c5f4cbc80$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $0c21756c5f4cbc80$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($0c21756c5f4cbc80$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $0c21756c5f4cbc80$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $0c21756c5f4cbc80$var$stylesheetPropsFromRawProps(props);
            (styleProps = $0c21756c5f4cbc80$var$preloadPropsMap.get(styleProps)) && $0c21756c5f4cbc80$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $0c21756c5f4cbc80$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $0c21756c5f4cbc80$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $0c21756c5f4cbc80$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $0c21756c5f4cbc80$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($0c21756c5f4cbc80$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $0c21756c5f4cbc80$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $0c21756c5f4cbc80$var$preloadPropsMap.get(instance$274)) instance = $0c21756c5f4cbc80$var$assign({}, props), $0c21756c5f4cbc80$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $0c21756c5f4cbc80$var$markNodeAsHoistable(styleProps);
            $0c21756c5f4cbc80$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $0c21756c5f4cbc80$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $0c21756c5f4cbc80$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $0c21756c5f4cbc80$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $0c21756c5f4cbc80$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $0c21756c5f4cbc80$var$tagCaches = null;
function $0c21756c5f4cbc80$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $0c21756c5f4cbc80$var$tagCaches) {
        var cache = new Map();
        var caches = $0c21756c5f4cbc80$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $0c21756c5f4cbc80$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$0c21756c5f4cbc80$var$internalHoistableMarker] || node[$0c21756c5f4cbc80$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $0c21756c5f4cbc80$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $0c21756c5f4cbc80$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $0c21756c5f4cbc80$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $0c21756c5f4cbc80$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $0c21756c5f4cbc80$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $0c21756c5f4cbc80$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $0c21756c5f4cbc80$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $0c21756c5f4cbc80$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $0c21756c5f4cbc80$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $0c21756c5f4cbc80$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($0c21756c5f4cbc80$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $0c21756c5f4cbc80$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $0c21756c5f4cbc80$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $0c21756c5f4cbc80$var$stylesheetPropsFromRawProps(props);
            (key = $0c21756c5f4cbc80$var$preloadPropsMap.get(key)) && $0c21756c5f4cbc80$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $0c21756c5f4cbc80$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $0c21756c5f4cbc80$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $0c21756c5f4cbc80$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $0c21756c5f4cbc80$var$estimatedBytesWithinLimit = 0;
function $0c21756c5f4cbc80$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $0c21756c5f4cbc80$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $0c21756c5f4cbc80$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $0c21756c5f4cbc80$var$estimatedBytesWithinLimit && ($0c21756c5f4cbc80$var$estimatedBytesWithinLimit = 62500 * $0c21756c5f4cbc80$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $0c21756c5f4cbc80$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $0c21756c5f4cbc80$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $0c21756c5f4cbc80$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $0c21756c5f4cbc80$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $0c21756c5f4cbc80$var$onUnsuspend() {
    this.count--;
    $0c21756c5f4cbc80$var$checkIfFullyUnsuspended(this);
}
function $0c21756c5f4cbc80$var$onUnsuspendImg() {
    this.imgCount--;
    $0c21756c5f4cbc80$var$checkIfFullyUnsuspended(this);
}
var $0c21756c5f4cbc80$var$precedencesByRoot = null;
function $0c21756c5f4cbc80$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $0c21756c5f4cbc80$var$precedencesByRoot = new Map(), resources.forEach($0c21756c5f4cbc80$var$insertStylesheetIntoRoot, state), $0c21756c5f4cbc80$var$precedencesByRoot = null, $0c21756c5f4cbc80$var$onUnsuspend.call(state));
}
function $0c21756c5f4cbc80$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $0c21756c5f4cbc80$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $0c21756c5f4cbc80$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $0c21756c5f4cbc80$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $0c21756c5f4cbc80$var$HostTransitionContext = {
    $$typeof: $0c21756c5f4cbc80$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $0c21756c5f4cbc80$var$sharedNotPendingObject,
    _currentValue2: $0c21756c5f4cbc80$var$sharedNotPendingObject,
    _threadCount: 0
};
function $0c21756c5f4cbc80$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $0c21756c5f4cbc80$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0c21756c5f4cbc80$var$createLaneMap(0);
    this.hiddenUpdates = $0c21756c5f4cbc80$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $0c21756c5f4cbc80$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $0c21756c5f4cbc80$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $0c21756c5f4cbc80$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $0c21756c5f4cbc80$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $0c21756c5f4cbc80$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $0c21756c5f4cbc80$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $0c21756c5f4cbc80$var$emptyContextObject;
    parentComponent = $0c21756c5f4cbc80$var$emptyContextObject;
    return parentComponent;
}
function $0c21756c5f4cbc80$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $0c21756c5f4cbc80$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $0c21756c5f4cbc80$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $0c21756c5f4cbc80$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($0c21756c5f4cbc80$var$scheduleUpdateOnFiber(element, rootFiber, lane), $0c21756c5f4cbc80$var$entangleTransitions(element, rootFiber, lane));
}
function $0c21756c5f4cbc80$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $0c21756c5f4cbc80$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $0c21756c5f4cbc80$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $0c21756c5f4cbc80$var$markRetryLaneImpl(fiber, retryLane);
}
function $0c21756c5f4cbc80$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $0c21756c5f4cbc80$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $0c21756c5f4cbc80$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $0c21756c5f4cbc80$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $0c21756c5f4cbc80$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $0c21756c5f4cbc80$var$requestUpdateLane();
        lane = $0c21756c5f4cbc80$var$getBumpedLaneForHydrationByLane(lane);
        var root = $0c21756c5f4cbc80$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $0c21756c5f4cbc80$var$scheduleUpdateOnFiber(root, fiber, lane);
        $0c21756c5f4cbc80$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $0c21756c5f4cbc80$var$_enabled = !0;
function $0c21756c5f4cbc80$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $0c21756c5f4cbc80$var$ReactSharedInternals.T;
    $0c21756c5f4cbc80$var$ReactSharedInternals.T = null;
    var previousPriority = $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p;
    try {
        $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = 2, $0c21756c5f4cbc80$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = previousPriority, $0c21756c5f4cbc80$var$ReactSharedInternals.T = prevTransition;
    }
}
function $0c21756c5f4cbc80$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $0c21756c5f4cbc80$var$ReactSharedInternals.T;
    $0c21756c5f4cbc80$var$ReactSharedInternals.T = null;
    var previousPriority = $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p;
    try {
        $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = 8, $0c21756c5f4cbc80$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $0c21756c5f4cbc80$var$ReactDOMSharedInternals.p = previousPriority, $0c21756c5f4cbc80$var$ReactSharedInternals.T = prevTransition;
    }
}
function $0c21756c5f4cbc80$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($0c21756c5f4cbc80$var$_enabled) {
        var blockedOn = $0c21756c5f4cbc80$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $0c21756c5f4cbc80$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $0c21756c5f4cbc80$var$return_targetInst, targetContainer), $0c21756c5f4cbc80$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($0c21756c5f4cbc80$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($0c21756c5f4cbc80$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $0c21756c5f4cbc80$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $0c21756c5f4cbc80$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $0c21756c5f4cbc80$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $0c21756c5f4cbc80$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $0c21756c5f4cbc80$var$ensureRootIsScheduled(fiber);
                                0 === ($0c21756c5f4cbc80$var$executionContext & 6) && ($0c21756c5f4cbc80$var$workInProgressRootRenderTargetTime = $0c21756c5f4cbc80$var$now() + 500, $0c21756c5f4cbc80$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $0c21756c5f4cbc80$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $0c21756c5f4cbc80$var$scheduleUpdateOnFiber(root, fiber, 2), $0c21756c5f4cbc80$var$flushSyncWork$1(), $0c21756c5f4cbc80$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $0c21756c5f4cbc80$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $0c21756c5f4cbc80$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $0c21756c5f4cbc80$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $0c21756c5f4cbc80$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $0c21756c5f4cbc80$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $0c21756c5f4cbc80$var$getEventTarget(nativeEvent);
    return $0c21756c5f4cbc80$var$findInstanceBlockingTarget(nativeEvent);
}
var $0c21756c5f4cbc80$var$return_targetInst = null;
function $0c21756c5f4cbc80$var$findInstanceBlockingTarget(targetNode) {
    $0c21756c5f4cbc80$var$return_targetInst = null;
    targetNode = $0c21756c5f4cbc80$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $0c21756c5f4cbc80$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $0c21756c5f4cbc80$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $0c21756c5f4cbc80$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $0c21756c5f4cbc80$var$return_targetInst = targetNode;
    return null;
}
function $0c21756c5f4cbc80$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($0c21756c5f4cbc80$var$getCurrentPriorityLevel()){
                case $0c21756c5f4cbc80$var$ImmediatePriority:
                    return 2;
                case $0c21756c5f4cbc80$var$UserBlockingPriority:
                    return 8;
                case $0c21756c5f4cbc80$var$NormalPriority$1:
                case $0c21756c5f4cbc80$var$LowPriority:
                    return 32;
                case $0c21756c5f4cbc80$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $0c21756c5f4cbc80$var$hasScheduledReplayAttempt = !1, $0c21756c5f4cbc80$var$queuedFocus = null, $0c21756c5f4cbc80$var$queuedDrag = null, $0c21756c5f4cbc80$var$queuedMouse = null, $0c21756c5f4cbc80$var$queuedPointers = new Map(), $0c21756c5f4cbc80$var$queuedPointerCaptures = new Map(), $0c21756c5f4cbc80$var$queuedExplicitHydrationTargets = [], $0c21756c5f4cbc80$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $0c21756c5f4cbc80$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $0c21756c5f4cbc80$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $0c21756c5f4cbc80$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $0c21756c5f4cbc80$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $0c21756c5f4cbc80$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0c21756c5f4cbc80$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $0c21756c5f4cbc80$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $0c21756c5f4cbc80$var$getInstanceFromNode(blockedOn), null !== blockedOn && $0c21756c5f4cbc80$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $0c21756c5f4cbc80$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $0c21756c5f4cbc80$var$queuedFocus = $0c21756c5f4cbc80$var$accumulateOrCreateContinuousQueuedReplayableEvent($0c21756c5f4cbc80$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $0c21756c5f4cbc80$var$queuedDrag = $0c21756c5f4cbc80$var$accumulateOrCreateContinuousQueuedReplayableEvent($0c21756c5f4cbc80$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $0c21756c5f4cbc80$var$queuedMouse = $0c21756c5f4cbc80$var$accumulateOrCreateContinuousQueuedReplayableEvent($0c21756c5f4cbc80$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $0c21756c5f4cbc80$var$queuedPointers.set(pointerId, $0c21756c5f4cbc80$var$accumulateOrCreateContinuousQueuedReplayableEvent($0c21756c5f4cbc80$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $0c21756c5f4cbc80$var$queuedPointerCaptures.set(pointerId, $0c21756c5f4cbc80$var$accumulateOrCreateContinuousQueuedReplayableEvent($0c21756c5f4cbc80$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $0c21756c5f4cbc80$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $0c21756c5f4cbc80$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $0c21756c5f4cbc80$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $0c21756c5f4cbc80$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $0c21756c5f4cbc80$var$runWithPriority(queuedTarget.priority, function() {
                        $0c21756c5f4cbc80$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $0c21756c5f4cbc80$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $0c21756c5f4cbc80$var$runWithPriority(queuedTarget.priority, function() {
                        $0c21756c5f4cbc80$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $0c21756c5f4cbc80$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $0c21756c5f4cbc80$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $0c21756c5f4cbc80$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $0c21756c5f4cbc80$var$currentReplayingEvent = null;
        } else return targetContainers = $0c21756c5f4cbc80$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $0c21756c5f4cbc80$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $0c21756c5f4cbc80$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $0c21756c5f4cbc80$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $0c21756c5f4cbc80$var$replayUnblockedEvents() {
    $0c21756c5f4cbc80$var$hasScheduledReplayAttempt = !1;
    null !== $0c21756c5f4cbc80$var$queuedFocus && $0c21756c5f4cbc80$var$attemptReplayContinuousQueuedEvent($0c21756c5f4cbc80$var$queuedFocus) && ($0c21756c5f4cbc80$var$queuedFocus = null);
    null !== $0c21756c5f4cbc80$var$queuedDrag && $0c21756c5f4cbc80$var$attemptReplayContinuousQueuedEvent($0c21756c5f4cbc80$var$queuedDrag) && ($0c21756c5f4cbc80$var$queuedDrag = null);
    null !== $0c21756c5f4cbc80$var$queuedMouse && $0c21756c5f4cbc80$var$attemptReplayContinuousQueuedEvent($0c21756c5f4cbc80$var$queuedMouse) && ($0c21756c5f4cbc80$var$queuedMouse = null);
    $0c21756c5f4cbc80$var$queuedPointers.forEach($0c21756c5f4cbc80$var$attemptReplayContinuousQueuedEventInMap);
    $0c21756c5f4cbc80$var$queuedPointerCaptures.forEach($0c21756c5f4cbc80$var$attemptReplayContinuousQueuedEventInMap);
}
function $0c21756c5f4cbc80$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $0c21756c5f4cbc80$var$hasScheduledReplayAttempt || ($0c21756c5f4cbc80$var$hasScheduledReplayAttempt = !0, $g09Uk.unstable_scheduleCallback($g09Uk.unstable_NormalPriority, $0c21756c5f4cbc80$var$replayUnblockedEvents)));
}
var $0c21756c5f4cbc80$var$lastScheduledReplayQueue = null;
function $0c21756c5f4cbc80$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $0c21756c5f4cbc80$var$lastScheduledReplayQueue !== formReplayingQueue && ($0c21756c5f4cbc80$var$lastScheduledReplayQueue = formReplayingQueue, $g09Uk.unstable_scheduleCallback($g09Uk.unstable_NormalPriority, function() {
        $0c21756c5f4cbc80$var$lastScheduledReplayQueue === formReplayingQueue && ($0c21756c5f4cbc80$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $0c21756c5f4cbc80$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $0c21756c5f4cbc80$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $0c21756c5f4cbc80$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $0c21756c5f4cbc80$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $0c21756c5f4cbc80$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $0c21756c5f4cbc80$var$queuedFocus && $0c21756c5f4cbc80$var$scheduleCallbackIfUnblocked($0c21756c5f4cbc80$var$queuedFocus, unblocked);
    null !== $0c21756c5f4cbc80$var$queuedDrag && $0c21756c5f4cbc80$var$scheduleCallbackIfUnblocked($0c21756c5f4cbc80$var$queuedDrag, unblocked);
    null !== $0c21756c5f4cbc80$var$queuedMouse && $0c21756c5f4cbc80$var$scheduleCallbackIfUnblocked($0c21756c5f4cbc80$var$queuedMouse, unblocked);
    $0c21756c5f4cbc80$var$queuedPointers.forEach(unblock);
    $0c21756c5f4cbc80$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $0c21756c5f4cbc80$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $0c21756c5f4cbc80$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $0c21756c5f4cbc80$var$queuedExplicitHydrationTargets.length && (i = $0c21756c5f4cbc80$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$0c21756c5f4cbc80$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $0c21756c5f4cbc80$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$0c21756c5f4cbc80$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $0c21756c5f4cbc80$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$0c21756c5f4cbc80$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $0c21756c5f4cbc80$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $0c21756c5f4cbc80$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $0c21756c5f4cbc80$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $0c21756c5f4cbc80$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$0c21756c5f4cbc80$var$ReactDOMHydrationRoot.prototype.render = $0c21756c5f4cbc80$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(409));
    var current = root.current, lane = $0c21756c5f4cbc80$var$requestUpdateLane();
    $0c21756c5f4cbc80$var$updateContainerImpl(current, lane, children, root, null, null);
};
$0c21756c5f4cbc80$var$ReactDOMHydrationRoot.prototype.unmount = $0c21756c5f4cbc80$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $0c21756c5f4cbc80$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $0c21756c5f4cbc80$var$flushSyncWork$1();
        container[$0c21756c5f4cbc80$var$internalContainerInstanceKey] = null;
    }
};
function $0c21756c5f4cbc80$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$0c21756c5f4cbc80$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $0c21756c5f4cbc80$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $0c21756c5f4cbc80$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $0c21756c5f4cbc80$var$queuedExplicitHydrationTargets[i].priority; i++);
        $0c21756c5f4cbc80$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $0c21756c5f4cbc80$var$attemptExplicitHydrationTarget(target);
    }
};
var $0c21756c5f4cbc80$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $5NSbj.version;
if ("19.3.1" !== $0c21756c5f4cbc80$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(527, $0c21756c5f4cbc80$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$0c21756c5f4cbc80$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $0c21756c5f4cbc80$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $0c21756c5f4cbc80$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $0c21756c5f4cbc80$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $0c21756c5f4cbc80$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0c21756c5f4cbc80$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0c21756c5f4cbc80$var$hook$jscomp$inline_2587.isDisabled && $0c21756c5f4cbc80$var$hook$jscomp$inline_2587.supportsFiber) try {
        $0c21756c5f4cbc80$var$rendererID = $0c21756c5f4cbc80$var$hook$jscomp$inline_2587.inject($0c21756c5f4cbc80$var$internals$jscomp$inline_2586), $0c21756c5f4cbc80$var$injectedHook = $0c21756c5f4cbc80$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$0c21756c5f4cbc80$export$882461b6382ed46c = function(container, options) {
    if (!$0c21756c5f4cbc80$var$isValidContainer(container)) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $0c21756c5f4cbc80$var$defaultOnUncaughtError, onCaughtError = $0c21756c5f4cbc80$var$defaultOnCaughtError, onRecoverableError = $0c21756c5f4cbc80$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $0c21756c5f4cbc80$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $0c21756c5f4cbc80$var$defaultOnDefaultTransitionIndicator);
    container[$0c21756c5f4cbc80$var$internalContainerInstanceKey] = options.current;
    $0c21756c5f4cbc80$var$listenToAllSupportedEvents(container);
    return new $0c21756c5f4cbc80$var$ReactDOMRoot(options);
};
$0c21756c5f4cbc80$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$0c21756c5f4cbc80$var$isValidContainer(container)) throw Error($0c21756c5f4cbc80$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $0c21756c5f4cbc80$var$defaultOnUncaughtError, onCaughtError = $0c21756c5f4cbc80$var$defaultOnCaughtError, onRecoverableError = $0c21756c5f4cbc80$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $0c21756c5f4cbc80$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $0c21756c5f4cbc80$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $0c21756c5f4cbc80$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $0c21756c5f4cbc80$var$requestUpdateLane();
    isStrictMode = $0c21756c5f4cbc80$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $0c21756c5f4cbc80$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $0c21756c5f4cbc80$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $0c21756c5f4cbc80$var$markRootUpdated$1(initialChildren, options);
    $0c21756c5f4cbc80$var$ensureRootIsScheduled(initialChildren);
    container[$0c21756c5f4cbc80$var$internalContainerInstanceKey] = initialChildren.current;
    $0c21756c5f4cbc80$var$listenToAllSupportedEvents(container);
    return new $0c21756c5f4cbc80$var$ReactDOMHydrationRoot(initialChildren);
};
$0c21756c5f4cbc80$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("g09Uk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gil7A"));

});
parcelRegister("gil7A", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $bdceb60f58967f22$export$c4744153514ff05d; }, function (v) { return $bdceb60f58967f22$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $bdceb60f58967f22$export$3e506c1ccc9cc1a7; }, function (v) { return $bdceb60f58967f22$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $bdceb60f58967f22$export$e26fe2ed2fa76875; }, function (v) { return $bdceb60f58967f22$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $bdceb60f58967f22$export$502329bbf4b505b1; }, function (v) { return $bdceb60f58967f22$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $bdceb60f58967f22$export$6e3807111c4874c4; }, function (v) { return $bdceb60f58967f22$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $bdceb60f58967f22$export$c27134553091fb3a; }, function (v) { return $bdceb60f58967f22$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $bdceb60f58967f22$export$33ee1acdc04fd2a2; }, function (v) { return $bdceb60f58967f22$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $bdceb60f58967f22$export$b00a404bbd5edef2; }, function (v) { return $bdceb60f58967f22$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $bdceb60f58967f22$export$d66a1c1c77bd778b; }, function (v) { return $bdceb60f58967f22$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $bdceb60f58967f22$export$d3dfb8e4810cb555; }, function (v) { return $bdceb60f58967f22$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $bdceb60f58967f22$export$72fdf0e06517287b; }, function (v) { return $bdceb60f58967f22$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $bdceb60f58967f22$export$816d2913ae6b83b1; }, function (v) { return $bdceb60f58967f22$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $bdceb60f58967f22$export$61bcfe829111a1d0; }, function (v) { return $bdceb60f58967f22$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $bdceb60f58967f22$export$7ee8c9beb337bc3f; }, function (v) { return $bdceb60f58967f22$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $bdceb60f58967f22$export$b5836b71941fa3ed; }, function (v) { return $bdceb60f58967f22$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $bdceb60f58967f22$export$cf845f2c119da08a; }, function (v) { return $bdceb60f58967f22$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bdceb60f58967f22$export$c4744153514ff05d;
var $bdceb60f58967f22$export$3e506c1ccc9cc1a7;
var $bdceb60f58967f22$export$e26fe2ed2fa76875;
var $bdceb60f58967f22$export$502329bbf4b505b1;
var $bdceb60f58967f22$export$6e3807111c4874c4;
var $bdceb60f58967f22$export$c27134553091fb3a;
var $bdceb60f58967f22$export$33ee1acdc04fd2a2;
var $bdceb60f58967f22$export$b00a404bbd5edef2;
var $bdceb60f58967f22$export$d66a1c1c77bd778b;
var $bdceb60f58967f22$export$d3dfb8e4810cb555;
var $bdceb60f58967f22$export$72fdf0e06517287b;
var $bdceb60f58967f22$export$816d2913ae6b83b1;
var $bdceb60f58967f22$export$61bcfe829111a1d0;
var $bdceb60f58967f22$export$7ee8c9beb337bc3f;
var $bdceb60f58967f22$export$b5836b71941fa3ed;
var $bdceb60f58967f22$export$cf845f2c119da08a;
"use strict";
function $bdceb60f58967f22$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $bdceb60f58967f22$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $bdceb60f58967f22$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $bdceb60f58967f22$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $bdceb60f58967f22$var$compare(left, last)) rightIndex < length && 0 > $bdceb60f58967f22$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $bdceb60f58967f22$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $bdceb60f58967f22$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$bdceb60f58967f22$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bdceb60f58967f22$var$localPerformance = performance;
    $bdceb60f58967f22$export$c4744153514ff05d = function() {
        return $bdceb60f58967f22$var$localPerformance.now();
    };
} else {
    var $bdceb60f58967f22$var$localDate = Date, $bdceb60f58967f22$var$initialTime = $bdceb60f58967f22$var$localDate.now();
    $bdceb60f58967f22$export$c4744153514ff05d = function() {
        return $bdceb60f58967f22$var$localDate.now() - $bdceb60f58967f22$var$initialTime;
    };
}
var $bdceb60f58967f22$var$taskQueue = [], $bdceb60f58967f22$var$timerQueue = [], $bdceb60f58967f22$var$taskIdCounter = 1, $bdceb60f58967f22$var$currentTask = null, $bdceb60f58967f22$var$currentPriorityLevel = 3, $bdceb60f58967f22$var$isPerformingWork = !1, $bdceb60f58967f22$var$isHostCallbackScheduled = !1, $bdceb60f58967f22$var$isHostTimeoutScheduled = !1, $bdceb60f58967f22$var$needsPaint = !1, $bdceb60f58967f22$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $bdceb60f58967f22$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $bdceb60f58967f22$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $bdceb60f58967f22$var$advanceTimers(currentTime) {
    for(var timer = $bdceb60f58967f22$var$peek($bdceb60f58967f22$var$timerQueue); null !== timer;){
        if (null === timer.callback) $bdceb60f58967f22$var$pop($bdceb60f58967f22$var$timerQueue);
        else if (timer.startTime <= currentTime) $bdceb60f58967f22$var$pop($bdceb60f58967f22$var$timerQueue), timer.sortIndex = timer.expirationTime, $bdceb60f58967f22$var$push($bdceb60f58967f22$var$taskQueue, timer);
        else break;
        timer = $bdceb60f58967f22$var$peek($bdceb60f58967f22$var$timerQueue);
    }
}
function $bdceb60f58967f22$var$handleTimeout(currentTime) {
    $bdceb60f58967f22$var$isHostTimeoutScheduled = !1;
    $bdceb60f58967f22$var$advanceTimers(currentTime);
    if (!$bdceb60f58967f22$var$isHostCallbackScheduled) {
        if (null !== $bdceb60f58967f22$var$peek($bdceb60f58967f22$var$taskQueue)) $bdceb60f58967f22$var$isHostCallbackScheduled = !0, $bdceb60f58967f22$var$isMessageLoopRunning || ($bdceb60f58967f22$var$isMessageLoopRunning = !0, $bdceb60f58967f22$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $bdceb60f58967f22$var$peek($bdceb60f58967f22$var$timerQueue);
            null !== firstTimer && $bdceb60f58967f22$var$requestHostTimeout($bdceb60f58967f22$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $bdceb60f58967f22$var$isMessageLoopRunning = !1, $bdceb60f58967f22$var$taskTimeoutID = -1, $bdceb60f58967f22$var$frameInterval = 5, $bdceb60f58967f22$var$startTime = -1;
function $bdceb60f58967f22$var$shouldYieldToHost() {
    return $bdceb60f58967f22$var$needsPaint ? !0 : $bdceb60f58967f22$export$c4744153514ff05d() - $bdceb60f58967f22$var$startTime < $bdceb60f58967f22$var$frameInterval ? !1 : !0;
}
function $bdceb60f58967f22$var$performWorkUntilDeadline() {
    $bdceb60f58967f22$var$needsPaint = !1;
    if ($bdceb60f58967f22$var$isMessageLoopRunning) {
        var currentTime = $bdceb60f58967f22$export$c4744153514ff05d();
        $bdceb60f58967f22$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $bdceb60f58967f22$var$isHostCallbackScheduled = !1;
                $bdceb60f58967f22$var$isHostTimeoutScheduled && ($bdceb60f58967f22$var$isHostTimeoutScheduled = !1, $bdceb60f58967f22$var$localClearTimeout($bdceb60f58967f22$var$taskTimeoutID), $bdceb60f58967f22$var$taskTimeoutID = -1);
                $bdceb60f58967f22$var$isPerformingWork = !0;
                var previousPriorityLevel = $bdceb60f58967f22$var$currentPriorityLevel;
                try {
                    b: {
                        $bdceb60f58967f22$var$advanceTimers(currentTime);
                        for($bdceb60f58967f22$var$currentTask = $bdceb60f58967f22$var$peek($bdceb60f58967f22$var$taskQueue); null !== $bdceb60f58967f22$var$currentTask && !($bdceb60f58967f22$var$currentTask.expirationTime > currentTime && $bdceb60f58967f22$var$shouldYieldToHost());){
                            var callback = $bdceb60f58967f22$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $bdceb60f58967f22$var$currentTask.callback = null;
                                $bdceb60f58967f22$var$currentPriorityLevel = $bdceb60f58967f22$var$currentTask.priorityLevel;
                                var continuationCallback = callback($bdceb60f58967f22$var$currentTask.expirationTime <= currentTime);
                                currentTime = $bdceb60f58967f22$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $bdceb60f58967f22$var$currentTask.callback = continuationCallback;
                                    $bdceb60f58967f22$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $bdceb60f58967f22$var$currentTask === $bdceb60f58967f22$var$peek($bdceb60f58967f22$var$taskQueue) && $bdceb60f58967f22$var$pop($bdceb60f58967f22$var$taskQueue);
                                $bdceb60f58967f22$var$advanceTimers(currentTime);
                            } else $bdceb60f58967f22$var$pop($bdceb60f58967f22$var$taskQueue);
                            $bdceb60f58967f22$var$currentTask = $bdceb60f58967f22$var$peek($bdceb60f58967f22$var$taskQueue);
                        }
                        if (null !== $bdceb60f58967f22$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $bdceb60f58967f22$var$peek($bdceb60f58967f22$var$timerQueue);
                            null !== firstTimer && $bdceb60f58967f22$var$requestHostTimeout($bdceb60f58967f22$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $bdceb60f58967f22$var$currentTask = null, $bdceb60f58967f22$var$currentPriorityLevel = previousPriorityLevel, $bdceb60f58967f22$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $bdceb60f58967f22$var$schedulePerformWorkUntilDeadline() : $bdceb60f58967f22$var$isMessageLoopRunning = !1;
        }
    }
}
var $bdceb60f58967f22$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $bdceb60f58967f22$var$localSetImmediate) $bdceb60f58967f22$var$schedulePerformWorkUntilDeadline = function() {
    $bdceb60f58967f22$var$localSetImmediate($bdceb60f58967f22$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bdceb60f58967f22$var$channel = new MessageChannel(), $bdceb60f58967f22$var$port = $bdceb60f58967f22$var$channel.port2;
    $bdceb60f58967f22$var$channel.port1.onmessage = $bdceb60f58967f22$var$performWorkUntilDeadline;
    $bdceb60f58967f22$var$schedulePerformWorkUntilDeadline = function() {
        $bdceb60f58967f22$var$port.postMessage(null);
    };
} else $bdceb60f58967f22$var$schedulePerformWorkUntilDeadline = function() {
    $bdceb60f58967f22$var$localSetTimeout($bdceb60f58967f22$var$performWorkUntilDeadline, 0);
};
function $bdceb60f58967f22$var$requestHostTimeout(callback, ms) {
    $bdceb60f58967f22$var$taskTimeoutID = $bdceb60f58967f22$var$localSetTimeout(function() {
        callback($bdceb60f58967f22$export$c4744153514ff05d());
    }, ms);
}
$bdceb60f58967f22$export$3e506c1ccc9cc1a7 = 5;
$bdceb60f58967f22$export$e26fe2ed2fa76875 = 1;
$bdceb60f58967f22$export$502329bbf4b505b1 = 4;
$bdceb60f58967f22$export$6e3807111c4874c4 = 3;
$bdceb60f58967f22$export$c27134553091fb3a = null;
$bdceb60f58967f22$export$33ee1acdc04fd2a2 = 2;
$bdceb60f58967f22$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$bdceb60f58967f22$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bdceb60f58967f22$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$bdceb60f58967f22$export$d3dfb8e4810cb555 = function() {
    return $bdceb60f58967f22$var$currentPriorityLevel;
};
$bdceb60f58967f22$export$72fdf0e06517287b = function(eventHandler) {
    switch($bdceb60f58967f22$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $bdceb60f58967f22$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $bdceb60f58967f22$var$currentPriorityLevel;
    $bdceb60f58967f22$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $bdceb60f58967f22$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$bdceb60f58967f22$export$816d2913ae6b83b1 = function() {
    $bdceb60f58967f22$var$needsPaint = !0;
};
$bdceb60f58967f22$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $bdceb60f58967f22$var$currentPriorityLevel;
    $bdceb60f58967f22$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $bdceb60f58967f22$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$bdceb60f58967f22$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $bdceb60f58967f22$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $bdceb60f58967f22$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $bdceb60f58967f22$var$push($bdceb60f58967f22$var$timerQueue, priorityLevel), null === $bdceb60f58967f22$var$peek($bdceb60f58967f22$var$taskQueue) && priorityLevel === $bdceb60f58967f22$var$peek($bdceb60f58967f22$var$timerQueue) && ($bdceb60f58967f22$var$isHostTimeoutScheduled ? ($bdceb60f58967f22$var$localClearTimeout($bdceb60f58967f22$var$taskTimeoutID), $bdceb60f58967f22$var$taskTimeoutID = -1) : $bdceb60f58967f22$var$isHostTimeoutScheduled = !0, $bdceb60f58967f22$var$requestHostTimeout($bdceb60f58967f22$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $bdceb60f58967f22$var$push($bdceb60f58967f22$var$taskQueue, priorityLevel), $bdceb60f58967f22$var$isHostCallbackScheduled || $bdceb60f58967f22$var$isPerformingWork || ($bdceb60f58967f22$var$isHostCallbackScheduled = !0, $bdceb60f58967f22$var$isMessageLoopRunning || ($bdceb60f58967f22$var$isMessageLoopRunning = !0, $bdceb60f58967f22$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$bdceb60f58967f22$export$b5836b71941fa3ed = $bdceb60f58967f22$var$shouldYieldToHost;
$bdceb60f58967f22$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $bdceb60f58967f22$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $bdceb60f58967f22$var$currentPriorityLevel;
        $bdceb60f58967f22$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $bdceb60f58967f22$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("5NSbj", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dp5Kz"));

});
parcelRegister("dp5Kz", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $9c221205b909fe74$export$9c16c1426311996d; }, function (v) { return $9c221205b909fe74$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $9c221205b909fe74$export$dca3b0875bd9a954; }, function (v) { return $9c221205b909fe74$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $9c221205b909fe74$export$16fa2f45be04daa8; }, function (v) { return $9c221205b909fe74$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $9c221205b909fe74$export$ffb0004e005737fa; }, function (v) { return $9c221205b909fe74$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $9c221205b909fe74$export$e2c29f18771995cb; }, function (v) { return $9c221205b909fe74$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $9c221205b909fe74$export$221d75b3f55bb0bd; }, function (v) { return $9c221205b909fe74$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $9c221205b909fe74$export$5f8d39834fd61797; }, function (v) { return $9c221205b909fe74$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $9c221205b909fe74$export$74bf444e3cd11ea5; }, function (v) { return $9c221205b909fe74$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "ViewTransition", function () { return $9c221205b909fe74$export$8cdaa4703948c5e9; }, function (v) { return $9c221205b909fe74$export$8cdaa4703948c5e9 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $9c221205b909fe74$export$1ced07cd6b1985ce; }, function (v) { return $9c221205b909fe74$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $9c221205b909fe74$export$abd8e32b826d7ea7; }, function (v) { return $9c221205b909fe74$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "addTransitionType", function () { return $9c221205b909fe74$export$87c99536b1b8cdd8; }, function (v) { return $9c221205b909fe74$export$87c99536b1b8cdd8 = v; });
$parcel$export(module.exports, "cache", function () { return $9c221205b909fe74$export$69a3209f1a06c04d; }, function (v) { return $9c221205b909fe74$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $9c221205b909fe74$export$8c538325882c7eec; }, function (v) { return $9c221205b909fe74$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $9c221205b909fe74$export$e530037191fcd5d7; }, function (v) { return $9c221205b909fe74$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $9c221205b909fe74$export$fd42f52fd3ae1109; }, function (v) { return $9c221205b909fe74$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $9c221205b909fe74$export$c8a8987d4410bf2d; }, function (v) { return $9c221205b909fe74$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $9c221205b909fe74$export$7d1e3a5e95ceca43; }, function (v) { return $9c221205b909fe74$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $9c221205b909fe74$export$257a8862b851cb5b; }, function (v) { return $9c221205b909fe74$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $9c221205b909fe74$export$a8257692ac88316c; }, function (v) { return $9c221205b909fe74$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $9c221205b909fe74$export$488013bae63b21da; }, function (v) { return $9c221205b909fe74$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $9c221205b909fe74$export$7c73462e0d25e514; }, function (v) { return $9c221205b909fe74$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $9c221205b909fe74$export$7568632d0d33d16d; }, function (v) { return $9c221205b909fe74$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $9c221205b909fe74$export$f93f40ac0ca7e3a8; }, function (v) { return $9c221205b909fe74$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $9c221205b909fe74$export$1f96ae73734a86cc; }, function (v) { return $9c221205b909fe74$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $9c221205b909fe74$export$9a47ced3238df325; }, function (v) { return $9c221205b909fe74$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $9c221205b909fe74$export$35808ee640e87ca7; }, function (v) { return $9c221205b909fe74$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $9c221205b909fe74$export$fae74005e78b1a27; }, function (v) { return $9c221205b909fe74$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $9c221205b909fe74$export$dc8fbce3eb94dc1e; }, function (v) { return $9c221205b909fe74$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $9c221205b909fe74$export$6a7bc4e911dc01cf; }, function (v) { return $9c221205b909fe74$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $9c221205b909fe74$export$6d9c69b0de29b591; }, function (v) { return $9c221205b909fe74$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $9c221205b909fe74$export$7f54fc3180508a52; }, function (v) { return $9c221205b909fe74$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $9c221205b909fe74$export$f680877a34711e37; }, function (v) { return $9c221205b909fe74$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $9c221205b909fe74$export$d5a552a76deda3c2; }, function (v) { return $9c221205b909fe74$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $9c221205b909fe74$export$aaabe4eda9ed9969; }, function (v) { return $9c221205b909fe74$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $9c221205b909fe74$export$e5c5a5f917a5871c; }, function (v) { return $9c221205b909fe74$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $9c221205b909fe74$export$1538c33de8887b59; }, function (v) { return $9c221205b909fe74$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $9c221205b909fe74$export$fca7f784ae7a249a; }, function (v) { return $9c221205b909fe74$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $9c221205b909fe74$export$13e3392192263954; }, function (v) { return $9c221205b909fe74$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $9c221205b909fe74$export$b8f5890fc79d6aca; }, function (v) { return $9c221205b909fe74$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $9c221205b909fe74$export$60241385465d0a34; }, function (v) { return $9c221205b909fe74$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $9c221205b909fe74$export$306c0aa65ff9ec16; }, function (v) { return $9c221205b909fe74$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $9c221205b909fe74$export$7b286972b8d8ccbf; }, function (v) { return $9c221205b909fe74$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $9c221205b909fe74$export$83d89fbfd8236492; }, function (v) { return $9c221205b909fe74$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9c221205b909fe74$export$9c16c1426311996d;
var $9c221205b909fe74$export$dca3b0875bd9a954;
var $9c221205b909fe74$export$16fa2f45be04daa8;
var $9c221205b909fe74$export$ffb0004e005737fa;
var $9c221205b909fe74$export$e2c29f18771995cb;
var $9c221205b909fe74$export$221d75b3f55bb0bd;
var $9c221205b909fe74$export$5f8d39834fd61797;
var $9c221205b909fe74$export$74bf444e3cd11ea5;
var $9c221205b909fe74$export$8cdaa4703948c5e9;
var $9c221205b909fe74$export$1ced07cd6b1985ce;
var $9c221205b909fe74$export$abd8e32b826d7ea7;
var $9c221205b909fe74$export$87c99536b1b8cdd8;
var $9c221205b909fe74$export$69a3209f1a06c04d;
var $9c221205b909fe74$export$8c538325882c7eec;
var $9c221205b909fe74$export$e530037191fcd5d7;
var $9c221205b909fe74$export$fd42f52fd3ae1109;
var $9c221205b909fe74$export$c8a8987d4410bf2d;
var $9c221205b909fe74$export$7d1e3a5e95ceca43;
var $9c221205b909fe74$export$257a8862b851cb5b;
var $9c221205b909fe74$export$a8257692ac88316c;
var $9c221205b909fe74$export$488013bae63b21da;
var $9c221205b909fe74$export$7c73462e0d25e514;
var $9c221205b909fe74$export$7568632d0d33d16d;
var $9c221205b909fe74$export$f93f40ac0ca7e3a8;
var $9c221205b909fe74$export$1f96ae73734a86cc;
var $9c221205b909fe74$export$9a47ced3238df325;
var $9c221205b909fe74$export$35808ee640e87ca7;
var $9c221205b909fe74$export$fae74005e78b1a27;
var $9c221205b909fe74$export$dc8fbce3eb94dc1e;
var $9c221205b909fe74$export$6a7bc4e911dc01cf;
var $9c221205b909fe74$export$6d9c69b0de29b591;
var $9c221205b909fe74$export$7f54fc3180508a52;
var $9c221205b909fe74$export$f680877a34711e37;
var $9c221205b909fe74$export$d5a552a76deda3c2;
var $9c221205b909fe74$export$aaabe4eda9ed9969;
var $9c221205b909fe74$export$e5c5a5f917a5871c;
var $9c221205b909fe74$export$1538c33de8887b59;
var $9c221205b909fe74$export$fca7f784ae7a249a;
var $9c221205b909fe74$export$13e3392192263954;
var $9c221205b909fe74$export$b8f5890fc79d6aca;
var $9c221205b909fe74$export$60241385465d0a34;
var $9c221205b909fe74$export$306c0aa65ff9ec16;
var $9c221205b909fe74$export$7b286972b8d8ccbf;
var $9c221205b909fe74$export$83d89fbfd8236492;
"use strict";
var $9c221205b909fe74$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $9c221205b909fe74$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $9c221205b909fe74$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $9c221205b909fe74$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $9c221205b909fe74$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $9c221205b909fe74$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $9c221205b909fe74$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $9c221205b909fe74$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $9c221205b909fe74$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $9c221205b909fe74$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $9c221205b909fe74$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $9c221205b909fe74$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $9c221205b909fe74$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $9c221205b909fe74$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $9c221205b909fe74$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $9c221205b909fe74$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$9c221205b909fe74$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $9c221205b909fe74$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $9c221205b909fe74$var$assign = Object.assign, $9c221205b909fe74$var$emptyObject = {};
function $9c221205b909fe74$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $9c221205b909fe74$var$emptyObject;
    this.updater = updater || $9c221205b909fe74$var$ReactNoopUpdateQueue;
}
$9c221205b909fe74$var$Component.prototype.isReactComponent = {};
$9c221205b909fe74$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$9c221205b909fe74$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $9c221205b909fe74$var$ComponentDummy() {}
$9c221205b909fe74$var$ComponentDummy.prototype = $9c221205b909fe74$var$Component.prototype;
function $9c221205b909fe74$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $9c221205b909fe74$var$emptyObject;
    this.updater = updater || $9c221205b909fe74$var$ReactNoopUpdateQueue;
}
var $9c221205b909fe74$var$pureComponentPrototype = $9c221205b909fe74$var$PureComponent.prototype = new $9c221205b909fe74$var$ComponentDummy();
$9c221205b909fe74$var$pureComponentPrototype.constructor = $9c221205b909fe74$var$PureComponent;
$9c221205b909fe74$var$assign($9c221205b909fe74$var$pureComponentPrototype, $9c221205b909fe74$var$Component.prototype);
$9c221205b909fe74$var$pureComponentPrototype.isPureReactComponent = !0;
var $9c221205b909fe74$var$isArrayImpl = Array.isArray;
function $9c221205b909fe74$var$noop() {}
var $9c221205b909fe74$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $9c221205b909fe74$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $9c221205b909fe74$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $9c221205b909fe74$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $9c221205b909fe74$var$cloneAndReplaceKey(oldElement, newKey) {
    return $9c221205b909fe74$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $9c221205b909fe74$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $9c221205b909fe74$var$REACT_ELEMENT_TYPE;
}
function $9c221205b909fe74$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $9c221205b909fe74$var$userProvidedKeyEscapeRegex = /\/+/g;
function $9c221205b909fe74$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $9c221205b909fe74$var$escape("" + element.key) : index.toString(36);
}
function $9c221205b909fe74$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($9c221205b909fe74$var$noop, $9c221205b909fe74$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $9c221205b909fe74$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $9c221205b909fe74$var$REACT_ELEMENT_TYPE:
                case $9c221205b909fe74$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $9c221205b909fe74$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $9c221205b909fe74$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $9c221205b909fe74$var$getElementKey(children, 0) : nameSoFar, $9c221205b909fe74$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($9c221205b909fe74$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $9c221205b909fe74$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($9c221205b909fe74$var$isValidElement(callback) && (callback = $9c221205b909fe74$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($9c221205b909fe74$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($9c221205b909fe74$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $9c221205b909fe74$var$getElementKey(nameSoFar, i), invokeCallback += $9c221205b909fe74$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $9c221205b909fe74$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $9c221205b909fe74$var$getElementKey(nameSoFar, i++), invokeCallback += $9c221205b909fe74$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $9c221205b909fe74$var$mapIntoArray($9c221205b909fe74$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $9c221205b909fe74$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $9c221205b909fe74$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $9c221205b909fe74$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $9c221205b909fe74$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $9c221205b909fe74$var$startTransition(scope) {
    var prevTransition = $9c221205b909fe74$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $9c221205b909fe74$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $9c221205b909fe74$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($9c221205b909fe74$var$noop, $9c221205b909fe74$var$reportGlobalError);
    } catch (error) {
        $9c221205b909fe74$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $9c221205b909fe74$var$ReactSharedInternals.T = prevTransition;
    }
}
function $9c221205b909fe74$var$addTransitionType(type) {
    var transition = $9c221205b909fe74$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $9c221205b909fe74$var$startTransition($9c221205b909fe74$var$addTransitionType.bind(null, type));
}
var $9c221205b909fe74$var$Children = {
    map: $9c221205b909fe74$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $9c221205b909fe74$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $9c221205b909fe74$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $9c221205b909fe74$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$9c221205b909fe74$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$9c221205b909fe74$export$9c16c1426311996d = $9c221205b909fe74$var$REACT_ACTIVITY_TYPE;
$9c221205b909fe74$export$dca3b0875bd9a954 = $9c221205b909fe74$var$Children;
$9c221205b909fe74$export$16fa2f45be04daa8 = $9c221205b909fe74$var$Component;
$9c221205b909fe74$export$ffb0004e005737fa = $9c221205b909fe74$var$REACT_FRAGMENT_TYPE;
$9c221205b909fe74$export$e2c29f18771995cb = $9c221205b909fe74$var$REACT_PROFILER_TYPE;
$9c221205b909fe74$export$221d75b3f55bb0bd = $9c221205b909fe74$var$PureComponent;
$9c221205b909fe74$export$5f8d39834fd61797 = $9c221205b909fe74$var$REACT_STRICT_MODE_TYPE;
$9c221205b909fe74$export$74bf444e3cd11ea5 = $9c221205b909fe74$var$REACT_SUSPENSE_TYPE;
$9c221205b909fe74$export$8cdaa4703948c5e9 = $9c221205b909fe74$var$REACT_VIEW_TRANSITION_TYPE;
$9c221205b909fe74$export$1ced07cd6b1985ce = $9c221205b909fe74$var$ReactSharedInternals;
$9c221205b909fe74$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $9c221205b909fe74$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$9c221205b909fe74$export$87c99536b1b8cdd8 = $9c221205b909fe74$var$addTransitionType;
$9c221205b909fe74$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$9c221205b909fe74$export$8c538325882c7eec = function() {
    return null;
};
$9c221205b909fe74$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $9c221205b909fe74$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$9c221205b909fe74$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $9c221205b909fe74$var$ReactElement(element.type, key, props);
};
$9c221205b909fe74$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $9c221205b909fe74$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $9c221205b909fe74$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$9c221205b909fe74$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$9c221205b909fe74$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $9c221205b909fe74$var$ReactElement(type, key, props);
};
$9c221205b909fe74$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$9c221205b909fe74$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $9c221205b909fe74$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$9c221205b909fe74$export$a8257692ac88316c = $9c221205b909fe74$var$isValidElement;
$9c221205b909fe74$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $9c221205b909fe74$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $9c221205b909fe74$var$lazyInitializer
    };
};
$9c221205b909fe74$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $9c221205b909fe74$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$9c221205b909fe74$export$7568632d0d33d16d = $9c221205b909fe74$var$startTransition;
$9c221205b909fe74$export$f93f40ac0ca7e3a8 = function() {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useCacheRefresh();
};
$9c221205b909fe74$export$1f96ae73734a86cc = function(usable) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.use(usable);
};
$9c221205b909fe74$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$9c221205b909fe74$export$35808ee640e87ca7 = function(callback, deps) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$9c221205b909fe74$export$fae74005e78b1a27 = function(Context) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useContext(Context);
};
$9c221205b909fe74$export$dc8fbce3eb94dc1e = function() {};
$9c221205b909fe74$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$9c221205b909fe74$export$6d9c69b0de29b591 = function(create, deps) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useEffect(create, deps);
};
$9c221205b909fe74$export$7f54fc3180508a52 = function(callback) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$9c221205b909fe74$export$f680877a34711e37 = function() {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useId();
};
$9c221205b909fe74$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$9c221205b909fe74$export$aaabe4eda9ed9969 = function(create, deps) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$9c221205b909fe74$export$e5c5a5f917a5871c = function(create, deps) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$9c221205b909fe74$export$1538c33de8887b59 = function(create, deps) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useMemo(create, deps);
};
$9c221205b909fe74$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$9c221205b909fe74$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$9c221205b909fe74$export$b8f5890fc79d6aca = function(initialValue) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useRef(initialValue);
};
$9c221205b909fe74$export$60241385465d0a34 = function(initialState) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useState(initialState);
};
$9c221205b909fe74$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$9c221205b909fe74$export$7b286972b8d8ccbf = function() {
    return $9c221205b909fe74$var$ReactSharedInternals.H.useTransition();
};
$9c221205b909fe74$export$83d89fbfd8236492 = "19.3.1";

});


parcelRegister("21jDP", function(module, exports) {
'use strict';
function $178ae9275e33f716$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($178ae9275e33f716$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$178ae9275e33f716$var$checkDCE();

module.exports = (parcelRequire("eFhBa"));

});
parcelRegister("eFhBa", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $aad28bbbec217917$export$69ce8ef3fe5cead0; }, function (v) { return $aad28bbbec217917$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "browser", function () { return $aad28bbbec217917$export$3f2684e5d7cb1006; }, function (v) { return $aad28bbbec217917$export$3f2684e5d7cb1006 = v; });
$parcel$export(module.exports, "createPortal", function () { return $aad28bbbec217917$export$d39a5bbd09211389; }, function (v) { return $aad28bbbec217917$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $aad28bbbec217917$export$cd75ccfd720a3cd4; }, function (v) { return $aad28bbbec217917$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $aad28bbbec217917$export$a0816fa17a9e79be; }, function (v) { return $aad28bbbec217917$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $aad28bbbec217917$export$7292efcadded39f3; }, function (v) { return $aad28bbbec217917$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $aad28bbbec217917$export$da407abadb9b8f86; }, function (v) { return $aad28bbbec217917$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $aad28bbbec217917$export$314cfea32580671c; }, function (v) { return $aad28bbbec217917$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $aad28bbbec217917$export$513ccb98c53b8039; }, function (v) { return $aad28bbbec217917$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $aad28bbbec217917$export$dbca993bc2d264a; }, function (v) { return $aad28bbbec217917$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $aad28bbbec217917$export$4797a8006f0655d0; }, function (v) { return $aad28bbbec217917$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $aad28bbbec217917$export$c78a37762a8d58e1; }, function (v) { return $aad28bbbec217917$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $aad28bbbec217917$export$606f11b2eb45ecc6; }, function (v) { return $aad28bbbec217917$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $aad28bbbec217917$export$f7e8a0bf92324b1e; }, function (v) { return $aad28bbbec217917$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $aad28bbbec217917$export$83d89fbfd8236492; }, function (v) { return $aad28bbbec217917$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aad28bbbec217917$export$69ce8ef3fe5cead0;
var $aad28bbbec217917$export$3f2684e5d7cb1006;
var $aad28bbbec217917$export$d39a5bbd09211389;
var $aad28bbbec217917$export$cd75ccfd720a3cd4;
var $aad28bbbec217917$export$a0816fa17a9e79be;
var $aad28bbbec217917$export$7292efcadded39f3;
var $aad28bbbec217917$export$da407abadb9b8f86;
var $aad28bbbec217917$export$314cfea32580671c;
var $aad28bbbec217917$export$513ccb98c53b8039;
var $aad28bbbec217917$export$dbca993bc2d264a;
var $aad28bbbec217917$export$4797a8006f0655d0;
var $aad28bbbec217917$export$c78a37762a8d58e1;
var $aad28bbbec217917$export$606f11b2eb45ecc6;
var $aad28bbbec217917$export$f7e8a0bf92324b1e;
var $aad28bbbec217917$export$83d89fbfd8236492;
"use strict";

var $5NSbj = parcelRequire("5NSbj");
function $aad28bbbec217917$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $aad28bbbec217917$var$noop() {}
var $aad28bbbec217917$var$Internals = {
    d: {
        f: $aad28bbbec217917$var$noop,
        r: function() {
            throw Error($aad28bbbec217917$var$formatProdErrorMessage(522));
        },
        D: $aad28bbbec217917$var$noop,
        C: $aad28bbbec217917$var$noop,
        L: $aad28bbbec217917$var$noop,
        m: $aad28bbbec217917$var$noop,
        X: $aad28bbbec217917$var$noop,
        S: $aad28bbbec217917$var$noop,
        M: $aad28bbbec217917$var$noop
    },
    p: 0,
    findDOMNode: null
}, $aad28bbbec217917$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $aad28bbbec217917$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $aad28bbbec217917$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $aad28bbbec217917$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $aad28bbbec217917$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $aad28bbbec217917$var$REACT_OPTIMISTIC_KEY ? $aad28bbbec217917$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $aad28bbbec217917$var$ReactSharedInternals = $5NSbj.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $aad28bbbec217917$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$aad28bbbec217917$export$69ce8ef3fe5cead0 = $aad28bbbec217917$var$Internals;
$aad28bbbec217917$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $aad28bbbec217917$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$aad28bbbec217917$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($aad28bbbec217917$var$formatProdErrorMessage(299));
    return $aad28bbbec217917$var$createPortal$1(children, container, null, key);
};
$aad28bbbec217917$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $aad28bbbec217917$var$ReactSharedInternals.T, previousUpdatePriority = $aad28bbbec217917$var$Internals.p;
    try {
        if ($aad28bbbec217917$var$ReactSharedInternals.T = null, $aad28bbbec217917$var$Internals.p = 2, fn) return fn();
    } finally{
        $aad28bbbec217917$var$ReactSharedInternals.T = previousTransition, $aad28bbbec217917$var$Internals.p = previousUpdatePriority, $aad28bbbec217917$var$Internals.d.f();
    }
};
$aad28bbbec217917$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $aad28bbbec217917$var$Internals.d.C(href, options));
};
$aad28bbbec217917$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $aad28bbbec217917$var$Internals.d.D(href);
};
$aad28bbbec217917$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $aad28bbbec217917$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $aad28bbbec217917$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $aad28bbbec217917$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$aad28bbbec217917$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $aad28bbbec217917$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $aad28bbbec217917$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $aad28bbbec217917$var$Internals.d.M(href);
    }
};
$aad28bbbec217917$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $aad28bbbec217917$var$getCrossOriginStringAs(as, options.crossOrigin);
        $aad28bbbec217917$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$aad28bbbec217917$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $aad28bbbec217917$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $aad28bbbec217917$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $aad28bbbec217917$var$Internals.d.m(href);
    }
};
$aad28bbbec217917$export$4797a8006f0655d0 = function(form) {
    $aad28bbbec217917$var$Internals.d.r(form);
};
$aad28bbbec217917$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$aad28bbbec217917$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $aad28bbbec217917$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$aad28bbbec217917$export$f7e8a0bf92324b1e = function() {
    return $aad28bbbec217917$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$aad28bbbec217917$export$83d89fbfd8236492 = "19.3.1";

});



parcelRegister("4zhFK", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $353823aaac54334e$export$ffb0004e005737fa; }, function (v) { return $353823aaac54334e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $353823aaac54334e$export$34b9dba7ce09269b; }, function (v) { return $353823aaac54334e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $353823aaac54334e$export$25062201e9e25d76; }, function (v) { return $353823aaac54334e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $353823aaac54334e$export$ffb0004e005737fa;
var $353823aaac54334e$export$34b9dba7ce09269b;
var $353823aaac54334e$export$25062201e9e25d76;
"use strict";
var $353823aaac54334e$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $353823aaac54334e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $353823aaac54334e$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $353823aaac54334e$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$353823aaac54334e$export$ffb0004e005737fa = $353823aaac54334e$var$REACT_FRAGMENT_TYPE;
$353823aaac54334e$export$34b9dba7ce09269b = $353823aaac54334e$var$jsxProd;
$353823aaac54334e$export$25062201e9e25d76 = $353823aaac54334e$var$jsxProd;

});

parcelRegister("gdAUR", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $bcea7efedc099dc4$export$306c0aa65ff9ec16; }, function (v) { return $bcea7efedc099dc4$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcea7efedc099dc4$export$306c0aa65ff9ec16;
"use strict";

var $5NSbj = parcelRequire("5NSbj");
function $bcea7efedc099dc4$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $bcea7efedc099dc4$var$objectIs = "function" === typeof Object.is ? Object.is : $bcea7efedc099dc4$var$is, $bcea7efedc099dc4$var$useState = $5NSbj.useState, $bcea7efedc099dc4$var$useEffect = $5NSbj.useEffect, $bcea7efedc099dc4$var$useLayoutEffect = $5NSbj.useLayoutEffect, $bcea7efedc099dc4$var$useDebugValue = $5NSbj.useDebugValue;
function $bcea7efedc099dc4$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $bcea7efedc099dc4$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $bcea7efedc099dc4$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $bcea7efedc099dc4$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $bcea7efedc099dc4$var$useEffect(function() {
        $bcea7efedc099dc4$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $bcea7efedc099dc4$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $bcea7efedc099dc4$var$useDebugValue(value);
    return value;
}
function $bcea7efedc099dc4$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$bcea7efedc099dc4$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $bcea7efedc099dc4$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $bcea7efedc099dc4$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $bcea7efedc099dc4$var$useSyncExternalStore$1 : $bcea7efedc099dc4$var$useSyncExternalStore$2;
$bcea7efedc099dc4$export$306c0aa65ff9ec16 = void 0 !== $5NSbj.useSyncExternalStore ? $5NSbj.useSyncExternalStore : $bcea7efedc099dc4$var$shim;

});

var $63830844fe0600a3$exports = {};
$parcel$extendImportMap({
    "api2T": "selfoss-sw-offline.js"
});

var $265f56d83db539c0$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $265f56d83db539c0$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $265f56d83db539c0$exports));
try {
    regeneratorRuntime = $265f56d83db539c0$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $265f56d83db539c0$var$runtime;
    else Function("r", "regeneratorRuntime = r")($265f56d83db539c0$var$runtime);
}


var $fdb09cd070e137df$exports = {};
'use strict';
function $fdb09cd070e137df$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($fdb09cd070e137df$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$fdb09cd070e137df$var$checkDCE();

$fdb09cd070e137df$exports = (parcelRequire("12zqx"));


class $b82622975d92f7af$export$1871035840b7f83a extends Error {
    constructor(message = 'Offline storage is not available'){
        super(message);
        this.name = 'OfflineStorageNotAvailableError';
    }
}
class $b82622975d92f7af$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super(message);
        this.name = 'TimeoutError';
    }
}
class $b82622975d92f7af$export$65bd6083489bd8bb extends Error {
    constructor(message){
        super(message);
        this.name = 'HttpError';
    }
}
class $b82622975d92f7af$export$5e64a9683d127ef6 extends Error {
    constructor(message){
        super(message);
        this.name = 'LoginError';
    }
}
class $b82622975d92f7af$export$4511c7da58e2d9c2 extends Error {
    constructor(message){
        super(message);
        this.name = 'UnexpectedStateError';
    }
}


var $0081a42221085bd6$exports = {};

$parcel$export($0081a42221085bd6$exports, "rejectUnless", function () { return $0081a42221085bd6$export$8d90b058a02656d9; });
$parcel$export($0081a42221085bd6$exports, "rejectIfNotOkay", function () { return $0081a42221085bd6$export$3a2f576a374b4dda; });
$parcel$export($0081a42221085bd6$exports, "options", function () { return $0081a42221085bd6$export$41c562ebe57d11e2; });
$parcel$export($0081a42221085bd6$exports, "option", function () { return $0081a42221085bd6$export$a75d1723e6bda2ec; });
$parcel$export($0081a42221085bd6$exports, "headers", function () { return $0081a42221085bd6$export$838e2a576d4d6ff6; });
$parcel$export($0081a42221085bd6$exports, "header", function () { return $0081a42221085bd6$export$38e42c68cf43b5d4; });
$parcel$export($0081a42221085bd6$exports, "liftToPromiseField", function () { return $0081a42221085bd6$export$e39d76e25ce37988; });
$parcel$export($0081a42221085bd6$exports, "makeAbortableFetch", function () { return $0081a42221085bd6$export$9c77439751b4390b; });
$parcel$export($0081a42221085bd6$exports, "makeFetchWithTimeout", function () { return $0081a42221085bd6$export$e9a8372937ef7f1; });
$parcel$export($0081a42221085bd6$exports, "makeFetchFailOnHttpErrors", function () { return $0081a42221085bd6$export$fe633c745f42b5cd; });
$parcel$export($0081a42221085bd6$exports, "makeFetchSupportGetBody", function () { return $0081a42221085bd6$export$f4ba43f659d5549c; });
$parcel$export($0081a42221085bd6$exports, "fetch", function () { return $0081a42221085bd6$export$e7aa7bc5c1b3cfb3; });
$parcel$export($0081a42221085bd6$exports, "get", function () { return $0081a42221085bd6$export$3988ae62b71be9a3; });
$parcel$export($0081a42221085bd6$exports, "post", function () { return $0081a42221085bd6$export$299ba2dee77727e9; });
$parcel$export($0081a42221085bd6$exports, "delete_", function () { return $0081a42221085bd6$export$38dab5a9fea42f39; });
$parcel$export($0081a42221085bd6$exports, "makeSearchParams", function () { return $0081a42221085bd6$export$92871f7982deaf9f; });
var $f371b6920dd318b0$export$2e2bcd8739ae039 = (data, opts = {})=>{
    const { sorted: sorted, ignorenull: ignorenull, ignoreEmptyArray: ignoreEmptyArray, useDot: useDot, skipIndex: skipIndex, skipBracket: skipBracket, whitespace: whitespace = '+' } = opts;
    const encode = (value)=>String(value).replace(/[^ !'()~*]/gu, encodeURIComponent).replace(/ /g, whitespace).replace(/[!'()~*]/g, (ch)=>`%${ch.charCodeAt().toString(16).slice(-2).toUpperCase()}`);
    const keys = (obj, keyarr = Object.keys(obj))=>sorted ? keyarr.sort() : keyarr;
    const filterjoin = (arr)=>arr.filter((e)=>e).join('&');
    const objnest = (name, obj)=>filterjoin(keys(obj).map((key)=>useDot ? nest(`${name}.${key}`, obj[key]) : nest(`${name}[${key}]`, obj[key])));
    const arrnest = (name, arr, brackets = skipBracket ? '' : '[]')=>arr.length ? filterjoin(arr.map((elem, index)=>skipIndex ? nest(name + brackets, elem) : nest(name + '[' + index + ']', elem))) : ignoreEmptyArray ? null : encode(name + brackets);
    const setnest = (name, set)=>filterjoin(Array.from(set).map((elem)=>nest(name, elem)));
    const nest = (name, value, type = typeof value, f = null)=>{
        if (value === f) f = ignorenull ? f : encode(name) + '=' + f;
        else if (/string|number|boolean/.test(type)) f = encode(name) + '=' + encode(value);
        else if (Array.isArray(value)) f = arrnest(name, value);
        else if (value instanceof Set) f = setnest(name, value);
        else if (type === 'object') f = objnest(name, value);
        return f;
    };
    return data && filterjoin(keys(data).map((key)=>nest(key, data[key])));
};


var $d84591a9ff0ebb48$exports = {};
var $11b3c3fd62c22b91$exports = {};
var $7930f30efbe644a1$exports = {};
var $fd1d129950ecf19e$exports = {};
function $fd1d129950ecf19e$var$_isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
$fd1d129950ecf19e$exports = $fd1d129950ecf19e$var$_isPlaceholder;


/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $7930f30efbe644a1$var$_curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || $fd1d129950ecf19e$exports(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
$7930f30efbe644a1$exports = $7930f30efbe644a1$var$_curry1;



/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $11b3c3fd62c22b91$var$_curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return $fd1d129950ecf19e$exports(a) ? f2 : $7930f30efbe644a1$exports(function(_b) {
                    return fn(a, _b);
                });
            default:
                return $fd1d129950ecf19e$exports(a) && $fd1d129950ecf19e$exports(b) ? f2 : $fd1d129950ecf19e$exports(a) ? $7930f30efbe644a1$exports(function(_a) {
                    return fn(_a, b);
                }) : $fd1d129950ecf19e$exports(b) ? $7930f30efbe644a1$exports(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
$11b3c3fd62c22b91$exports = $11b3c3fd62c22b91$var$_curry2;


var $978b2ede170a45e5$exports = {};
var $79baec68be7bb256$exports = {};



/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $79baec68be7bb256$var$_curry3(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return $fd1d129950ecf19e$exports(a) ? f3 : $11b3c3fd62c22b91$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return $fd1d129950ecf19e$exports(a) && $fd1d129950ecf19e$exports(b) ? f3 : $fd1d129950ecf19e$exports(a) ? $11b3c3fd62c22b91$exports(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : $fd1d129950ecf19e$exports(b) ? $11b3c3fd62c22b91$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : $7930f30efbe644a1$exports(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return $fd1d129950ecf19e$exports(a) && $fd1d129950ecf19e$exports(b) && $fd1d129950ecf19e$exports(c) ? f3 : $fd1d129950ecf19e$exports(a) && $fd1d129950ecf19e$exports(b) ? $11b3c3fd62c22b91$exports(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : $fd1d129950ecf19e$exports(a) && $fd1d129950ecf19e$exports(c) ? $11b3c3fd62c22b91$exports(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : $fd1d129950ecf19e$exports(b) && $fd1d129950ecf19e$exports(c) ? $11b3c3fd62c22b91$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : $fd1d129950ecf19e$exports(a) ? $7930f30efbe644a1$exports(function(_a) {
                    return fn(_a, b, c);
                }) : $fd1d129950ecf19e$exports(b) ? $7930f30efbe644a1$exports(function(_b) {
                    return fn(a, _b, c);
                }) : $fd1d129950ecf19e$exports(c) ? $7930f30efbe644a1$exports(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}
$79baec68be7bb256$exports = $79baec68be7bb256$var$_curry3;


var $a060db5eca4f28fd$exports = {};
function $a060db5eca4f28fd$var$_isObject(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
}
$a060db5eca4f28fd$exports = $a060db5eca4f28fd$var$_isObject;


var $9b2e7c822ef70d5b$exports = {};

var $b67b11238be38685$exports = {};
function $b67b11238be38685$var$_has(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
$b67b11238be38685$exports = $b67b11238be38685$var$_has;


/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var $9b2e7c822ef70d5b$var$mergeWithKey = /*#__PURE__*/ $79baec68be7bb256$exports(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    l = l || {};
    r = r || {};
    for(k in l)if ($b67b11238be38685$exports(k, l)) result[k] = $b67b11238be38685$exports(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ($b67b11238be38685$exports(k, r) && !$b67b11238be38685$exports(k, result)) result[k] = r[k];
    return result;
});
$9b2e7c822ef70d5b$exports = $9b2e7c822ef70d5b$var$mergeWithKey;


/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var $978b2ede170a45e5$var$mergeDeepWithKey = /*#__PURE__*/ $79baec68be7bb256$exports(function mergeDeepWithKey(fn, lObj, rObj) {
    return $9b2e7c822ef70d5b$exports(function(k, lVal, rVal) {
        if ($a060db5eca4f28fd$exports(lVal) && $a060db5eca4f28fd$exports(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
$978b2ede170a45e5$exports = $978b2ede170a45e5$var$mergeDeepWithKey;


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var $d84591a9ff0ebb48$var$mergeDeepLeft = /*#__PURE__*/ $11b3c3fd62c22b91$exports(function mergeDeepLeft(lObj, rObj) {
    return $978b2ede170a45e5$exports(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
$d84591a9ff0ebb48$exports = $d84591a9ff0ebb48$var$mergeDeepLeft;


var $00ab3e86e584dd7b$exports = {};
var $e54479dfc8e6276d$exports = {};
function $e54479dfc8e6276d$var$_arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}
$e54479dfc8e6276d$exports = $e54479dfc8e6276d$var$_arity;


var $889892c42e9badec$exports = {};
function $889892c42e9badec$var$_pipe(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}
$889892c42e9badec$exports = $889892c42e9badec$var$_pipe;


var $79955e417640e2d0$exports = {};

var $72f6f8d46a04a8db$exports = {};
var $8d26e1096e1356d4$exports = {};
var $12e66c9e65e60cae$exports = {};

var $ba1de13db1e87172$exports = {};
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ $ba1de13db1e87172$exports = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};


var $acb10f4bb9254ad8$exports = {};
function $acb10f4bb9254ad8$var$_isString(x) {
    return Object.prototype.toString.call(x) === '[object String]';
}
$acb10f4bb9254ad8$exports = $acb10f4bb9254ad8$var$_isString;


/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 *      _isArrayLike({nodeType: 1, length: 1}) // => false
 */ var $12e66c9e65e60cae$var$_isArrayLike = /*#__PURE__*/ $7930f30efbe644a1$exports(function isArrayLike(x) {
    if ($ba1de13db1e87172$exports(x)) return true;
    if (!x) return false;
    if (typeof x !== 'object') return false;
    if ($acb10f4bb9254ad8$exports(x)) return false;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
$12e66c9e65e60cae$exports = $12e66c9e65e60cae$var$_isArrayLike;


var $8d26e1096e1356d4$var$symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
function $8d26e1096e1356d4$var$_createReduce(arrayReduce, methodReduce, iterableReduce) {
    return function _reduce(xf, acc, list) {
        if ($12e66c9e65e60cae$exports(list)) return arrayReduce(xf, acc, list);
        if (list == null) return acc;
        if (typeof list['fantasy-land/reduce'] === 'function') return methodReduce(xf, acc, list, 'fantasy-land/reduce');
        if (list[$8d26e1096e1356d4$var$symIterator] != null) return iterableReduce(xf, acc, list[$8d26e1096e1356d4$var$symIterator]());
        if (typeof list.next === 'function') return iterableReduce(xf, acc, list);
        if (typeof list.reduce === 'function') return methodReduce(xf, acc, list, 'reduce');
        throw new TypeError('reduce: list must be array or iterable');
    };
}
$8d26e1096e1356d4$exports = $8d26e1096e1356d4$var$_createReduce;


var $58e8baccbb3f3299$exports = {};
function $58e8baccbb3f3299$var$_xArrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf['@@transducer/step'](acc, list[idx]);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        idx += 1;
    }
    return xf['@@transducer/result'](acc);
}
$58e8baccbb3f3299$exports = $58e8baccbb3f3299$var$_xArrayReduce;


var $3431363f125f2e07$exports = {};


/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var $3431363f125f2e07$var$bind = /*#__PURE__*/ $11b3c3fd62c22b91$exports(function bind(fn, thisObj) {
    return $e54479dfc8e6276d$exports(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
$3431363f125f2e07$exports = $3431363f125f2e07$var$bind;


function $72f6f8d46a04a8db$var$_xIterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf['@@transducer/step'](acc, step.value);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        step = iter.next();
    }
    return xf['@@transducer/result'](acc);
}
function $72f6f8d46a04a8db$var$_xMethodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName]($3431363f125f2e07$exports(xf['@@transducer/step'], xf), acc));
}
var $72f6f8d46a04a8db$var$_xReduce = /*#__PURE__*/ $8d26e1096e1356d4$exports($58e8baccbb3f3299$exports, $72f6f8d46a04a8db$var$_xMethodReduce, $72f6f8d46a04a8db$var$_xIterableReduce);
$72f6f8d46a04a8db$exports = $72f6f8d46a04a8db$var$_xReduce;


var $d161b2485e3b6c60$exports = {};
var $d161b2485e3b6c60$var$XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype['@@transducer/init'] = function() {
        throw new Error('init not implemented on XWrap');
    };
    XWrap.prototype['@@transducer/result'] = function(acc) {
        return acc;
    };
    XWrap.prototype['@@transducer/step'] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function $d161b2485e3b6c60$var$_xwrap(fn) {
    return new $d161b2485e3b6c60$var$XWrap(fn);
}
$d161b2485e3b6c60$exports = $d161b2485e3b6c60$var$_xwrap;


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Be cautious of mutating and returning the accumulator. If you reuse it across
 * invocations, it will continue to accumulate onto the same value. The general
 * recommendation is to always return a new value. If you can't do so for
 * performance reasons, then be sure to reinitialize the accumulator on each
 * invocation.
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var $79955e417640e2d0$var$reduce = /*#__PURE__*/ $79baec68be7bb256$exports(function(xf, acc, list) {
    return $72f6f8d46a04a8db$exports(typeof xf === 'function' ? $d161b2485e3b6c60$exports(xf) : xf, acc, list);
});
$79955e417640e2d0$exports = $79955e417640e2d0$var$reduce;


var $af38f6844df9a44f$exports = {};
var $6cbc125171a9f4c6$exports = {};

/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implementation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */ function $6cbc125171a9f4c6$var$_checkForMethod(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return $ba1de13db1e87172$exports(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}
$6cbc125171a9f4c6$exports = $6cbc125171a9f4c6$var$_checkForMethod;



var $4c3ac4a56cdd2fd0$exports = {};


/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $4c3ac4a56cdd2fd0$var$slice = /*#__PURE__*/ $79baec68be7bb256$exports(/*#__PURE__*/ $6cbc125171a9f4c6$exports('slice', function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
$4c3ac4a56cdd2fd0$exports = $4c3ac4a56cdd2fd0$var$slice;


/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var $af38f6844df9a44f$var$tail = /*#__PURE__*/ $7930f30efbe644a1$exports(/*#__PURE__*/ $6cbc125171a9f4c6$exports('tail', /*#__PURE__*/ $4c3ac4a56cdd2fd0$exports(1, Infinity)));
$af38f6844df9a44f$exports = $af38f6844df9a44f$var$tail;


/**
 * Performs left-to-right function composition. The first argument may have
 * any arity; the remaining arguments must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      const f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 * @symb R.pipe(f, g, h)(a)(b) = h(g(f(a)))(b)
 */ function $00ab3e86e584dd7b$var$pipe() {
    if (arguments.length === 0) throw new Error('pipe requires at least one argument');
    return $e54479dfc8e6276d$exports(arguments[0].length, $79955e417640e2d0$exports($889892c42e9badec$exports, arguments[0], $af38f6844df9a44f$exports(arguments)));
}
$00ab3e86e584dd7b$exports = $00ab3e86e584dd7b$var$pipe;



function $0081a42221085bd6$export$8d90b058a02656d9(pred) {
    return (response)=>{
        if (pred(response)) return response;
        else {
            const err = new (0, $b82622975d92f7af$export$65bd6083489bd8bb)(response.statusText);
            err.response = response;
            throw err;
        }
    };
}
function $0081a42221085bd6$export$3a2f576a374b4dda(response) {
    return $0081a42221085bd6$export$8d90b058a02656d9((response)=>response.ok)(response);
}
const $0081a42221085bd6$export$41c562ebe57d11e2 = (newOpts)=>(fetch)=>(url, opts = {})=>fetch(url, (0, (/*@__PURE__*/$parcel$interopDefault($d84591a9ff0ebb48$exports)))(opts, newOpts));
const $0081a42221085bd6$export$a75d1723e6bda2ec = (name, value)=>$0081a42221085bd6$export$41c562ebe57d11e2({
        [name]: value
    });
const $0081a42221085bd6$export$838e2a576d4d6ff6 = (value)=>$0081a42221085bd6$export$a75d1723e6bda2ec('headers', value);
const $0081a42221085bd6$export$38e42c68cf43b5d4 = (name, value)=>$0081a42221085bd6$export$838e2a576d4d6ff6({
        [name]: value
    });
const $0081a42221085bd6$export$e39d76e25ce37988 = (wrapper)=>(f)=>(...params)=>{
            let rest;
            const promise = wrapper((...innerParams)=>{
                const { promise: promise, ...innerRest } = f(...innerParams);
                rest = innerRest;
                return promise;
            })(...params);
            return {
                promise: promise,
                ...rest
            };
        };
function $0081a42221085bd6$export$9c77439751b4390b(fetch) {
    return (url, opts = {})=>{
        const controller = opts.abortController || new AbortController();
        const promise = fetch(url, {
            signal: controller.signal,
            ...opts
        });
        return {
            controller: controller,
            promise: promise
        };
    };
}
function $0081a42221085bd6$export$e9a8372937ef7f1(abortableFetch) {
    return (url, opts = {})=>{
        // offline db consistency requires ajax calls to fail reliably,
        // so we enforce a default timeout on ajax calls
        const { timeout: timeout = 60000, ...rest } = opts;
        const { controller: controller, promise: promise } = abortableFetch(url, rest);
        if (timeout !== 0) {
            const newPromise = promise.catch((error)=>{
                // Change error name in case of time out so that we can
                // distinguish it from explicit abort.
                if (error.name === 'AbortError' && 'timedOut' in promise) error = new (0, $b82622975d92f7af$export$66d311bf29d5c89c)(`Request timed out after ${timeout / 1000} seconds`);
                throw error;
            });
            setTimeout(()=>{
                promise.timedOut = true;
                controller.abort();
            }, timeout);
            return {
                controller: controller,
                promise: newPromise
            };
        }
        return {
            controller: controller,
            promise: promise
        };
    };
}
function $0081a42221085bd6$export$fe633c745f42b5cd(fetch) {
    return (url, opts = {})=>{
        const { failOnHttpErrors: failOnHttpErrors = true, ...rest } = opts;
        const promise = fetch(url, rest);
        if (failOnHttpErrors) return promise.then($0081a42221085bd6$export$3a2f576a374b4dda);
        return promise;
    };
}
function $0081a42221085bd6$export$f4ba43f659d5549c(fetch) {
    return (url, opts = {})=>{
        const { body: body, method: method, ...rest } = opts;
        let newUrl = url;
        let newOpts = opts;
        if (Object.keys(opts).includes('method') && Object.keys(opts).includes('body') && method.toUpperCase() === 'GET' && body instanceof URLSearchParams) {
            const [main, ...fragments] = newUrl.split('#');
            const separator = main.includes('?') ? '&' : '?';
            // append the body to the query string
            newUrl = `${main}${separator}${body.toString()}#${fragments.join('#')}`;
            // remove the body since it has been moved to URL
            newOpts = {
                method: method,
                ...rest
            };
        }
        return fetch(newUrl, newOpts);
    };
}
const $0081a42221085bd6$export$e7aa7bc5c1b3cfb3 = (0, (/*@__PURE__*/$parcel$interopDefault($00ab3e86e584dd7b$exports)))(// Same as jQuery.ajax
$0081a42221085bd6$export$a75d1723e6bda2ec('credentials', 'same-origin'), $0081a42221085bd6$export$38e42c68cf43b5d4('X-Requested-With', 'XMLHttpRequest'), $0081a42221085bd6$export$fe633c745f42b5cd, $0081a42221085bd6$export$f4ba43f659d5549c, $0081a42221085bd6$export$9c77439751b4390b, $0081a42221085bd6$export$e9a8372937ef7f1)(window.fetch);
const $0081a42221085bd6$export$3988ae62b71be9a3 = $0081a42221085bd6$export$e39d76e25ce37988($0081a42221085bd6$export$a75d1723e6bda2ec('method', 'GET'))($0081a42221085bd6$export$e7aa7bc5c1b3cfb3);
const $0081a42221085bd6$export$299ba2dee77727e9 = $0081a42221085bd6$export$e39d76e25ce37988($0081a42221085bd6$export$a75d1723e6bda2ec('method', 'POST'))($0081a42221085bd6$export$e7aa7bc5c1b3cfb3);
const $0081a42221085bd6$export$38dab5a9fea42f39 = $0081a42221085bd6$export$e39d76e25ce37988($0081a42221085bd6$export$a75d1723e6bda2ec('method', 'DELETE'))($0081a42221085bd6$export$e7aa7bc5c1b3cfb3);
function $0081a42221085bd6$export$92871f7982deaf9f(data) {
    return new URLSearchParams((0, $f371b6920dd318b0$export$2e2bcd8739ae039)(data, {
        ignorenull: true
    }));
}


class $139c0902db4c349b$export$1a748576aa07f99b extends Error {
    constructor(message){
        super(message);
        this.name = 'PasswordHashingError';
    }
}
function $139c0902db4c349b$export$1d2e6bc0307ffd89() {
    return $0081a42221085bd6$export$3988ae62b71be9a3('api/about', {
        // we want fresh configuration each time
        cache: 'no-store'
    }).promise.then((response)=>response.json());
}
function $139c0902db4c349b$export$596d806903d1f59e(credentials) {
    return $0081a42221085bd6$export$299ba2dee77727e9('login', {
        body: new URLSearchParams(credentials)
    }).promise.then((response)=>response.json()).then((data)=>{
        if (data.success) return Promise.resolve();
        else return Promise.reject(new (0, $b82622975d92f7af$export$5e64a9683d127ef6)(data.error));
    });
}
function $139c0902db4c349b$export$708be5cd94908894(password) {
    return $0081a42221085bd6$export$299ba2dee77727e9('api/private/hash-password', {
        body: new URLSearchParams({
            password: password
        })
    }).promise.then((response)=>response.json()).then((data)=>{
        if (data.success) return Promise.resolve(data.hash);
        else return Promise.reject(new $139c0902db4c349b$export$1a748576aa07f99b(data.error));
    });
}
function $139c0902db4c349b$export$b3b4cde15a96b715(file) {
    const data = new FormData();
    data.append('opml', file);
    return $0081a42221085bd6$export$299ba2dee77727e9('opml', {
        body: data,
        failOnHttpErrors: false
    }).promise.then($0081a42221085bd6$export$8d90b058a02656d9((response)=>response.status === 200 || response.status === 202 || response.status === 400)).then((response)=>response.json().then((data)=>({
                response: response,
                data: data
            })));
}
function $139c0902db4c349b$export$a0973bcfe11b05c9() {
    return $0081a42221085bd6$export$38dab5a9fea42f39('api/session/current').promise;
}



function $cfb76a7b6769ced6$export$c36f611d5eb39a7() {
    return $0081a42221085bd6$export$3988ae62b71be9a3('tags').promise.then((response)=>response.json());
}
function $cfb76a7b6769ced6$export$6f3c7c74c4b252bb(tag, color) {
    return $0081a42221085bd6$export$299ba2dee77727e9('tags/color', {
        body: $0081a42221085bd6$export$92871f7982deaf9f({
            tag: tag,
            color: color
        })
    }).promise;
}



class $9b6f9431d1a0bef0$export$5521c47db270880f extends Event {
    constructor(value){
        super('change');
        this.value = value;
    }
}
class $9b6f9431d1a0bef0$export$8fa6ce44b7b131e9 extends EventTarget {
    constructor(value){
        super();
        this.value = value;
    }
    update(value) {
        if (this.value !== value) {
            this.value = value;
            const event = new $9b6f9431d1a0bef0$export$5521c47db270880f(value);
            this.dispatchEvent(event);
        }
    }
}



/**
 * Object describing what state a request is in.
 */ var $f5b3c040e086fbc1$export$62aa48085237e36f = /*#__PURE__*/ function(LoadingState) {
    LoadingState["INITIAL"] = "initial";
    LoadingState["LOADING"] = "loading";
    LoadingState["SUCCESS"] = "success";
    LoadingState["FAILURE"] = "failure";
    return LoadingState;
}({});


var $fcda9d1f1901e894$exports = {};
'use strict';

$fcda9d1f1901e894$exports = (parcelRequire("4zhFK"));



var $5NSbj = parcelRequire("5NSbj");
/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/url.ts
const $38b29aefca9c076c$export$6c52c2011d568bd0 = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
const $38b29aefca9c076c$export$825a82322d91916e = /^[\\/]{2}/;
function $38b29aefca9c076c$export$977999b735cd4f26(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/router/history.ts
/**
* Actions represent the type of change to a location value.
*/ let $573a89bde77cb3ae$export$e19cd5f9376f8cee = /* @__PURE__ */ function(Action) {
    /**
	* A POP indicates a change to an arbitrary index in the history stack, such
	* as a back or forward navigation. It does not describe the direction of the
	* navigation, only that the current index changed.
	*
	* Note: This is the default action for newly created history objects.
	*/ Action["Pop"] = "POP";
    /**
	* A PUSH indicates a new entry being added to the history stack, such as when
	* a link is clicked and a new page loads. When this happens, all subsequent
	* entries in the stack are lost.
	*/ Action["Push"] = "PUSH";
    /**
	* A REPLACE indicates the entry at the current index in the history stack
	* being replaced by a new one.
	*/ Action["Replace"] = "REPLACE";
    return Action;
}({});
const $573a89bde77cb3ae$var$PopStateEventType = "popstate";
function $573a89bde77cb3ae$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
/**
* Memory history stores the current location in memory. It is designed for use
* in stateful non-browser environments like tests and React Native.
*/ function $573a89bde77cb3ae$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP";
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $573a89bde77cb3ae$export$90c043f1c57770b8(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $573a89bde77cb3ae$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $573a89bde77cb3ae$export$fe53371bee54353d(to);
    }
    return {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $573a89bde77cb3ae$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH";
            let nextLocation = $573a89bde77cb3ae$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE";
            let nextLocation = $573a89bde77cb3ae$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP";
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
}
/**
* Browser history stores the location in regular URLs. This is the standard for
* most web apps, but it requires some configuration on the server to ensure you
* serve the same app at multiple URLs.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
*/ function $573a89bde77cb3ae$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window.location;
        return $573a89bde77cb3ae$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash
        } : void 0);
    }
    function createBrowserHref(window, to) {
        return typeof to === "string" ? to : $573a89bde77cb3ae$export$fe53371bee54353d(to);
    }
    return $573a89bde77cb3ae$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
* Hash history stores the location in window.location.hash. This makes it ideal
* for situations where you don't want to send the location to the server for
* some reason, either because you do cannot configure it or the URL space is
* reserved for something else.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
*/ function $573a89bde77cb3ae$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $573a89bde77cb3ae$export$8ccf933b0513f8d0(window.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $573a89bde77cb3ae$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window, to) {
        let base = window.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $573a89bde77cb3ae$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $573a89bde77cb3ae$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $573a89bde77cb3ae$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $573a89bde77cb3ae$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $573a89bde77cb3ae$export$491112666e282270(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch  {}
    }
}
function $573a89bde77cb3ae$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
/**
* For browser-based histories, we combine the state and key into an object
*/ function $573a89bde77cb3ae$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
/**
* Creates a Location object with a unique key from the given Path
*/ function $573a89bde77cb3ae$export$90c043f1c57770b8(current, to, state = null, key, mask) {
    return {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $573a89bde77cb3ae$export$8ccf933b0513f8d0(to) : to,
        state: state,
        key: to && to.key || key || $573a89bde77cb3ae$var$createKey(),
        mask: mask
    };
}
/**
* Creates a string URL path from the given pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The pathname, search, and hash components to combine.
* @returns The combined URL path.
*/ function $573a89bde77cb3ae$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
* Parses a string URL path into its separate pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The URL path to parse.
* @returns The parsed pathname, search, and hash components.
*/ function $573a89bde77cb3ae$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $573a89bde77cb3ae$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options = {}) {
    let { window: window = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window.history;
    let action = "POP";
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        return (globalHistory.state || {
            idx: null
        }).idx;
    }
    function handlePop() {
        action = "POP";
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH";
        let location = $573a89bde77cb3ae$var$isLocation(to) ? to : $573a89bde77cb3ae$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $573a89bde77cb3ae$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = "REPLACE";
        let location = $573a89bde77cb3ae$var$isLocation(to) ? to : $573a89bde77cb3ae$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $573a89bde77cb3ae$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $573a89bde77cb3ae$export$e2450fce17852bf2(window, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window.addEventListener($573a89bde77cb3ae$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window.removeEventListener($573a89bde77cb3ae$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $573a89bde77cb3ae$export$e2450fce17852bf2(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $573a89bde77cb3ae$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $573a89bde77cb3ae$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && (0, $38b29aefca9c076c$export$825a82322d91916e).test(href)) href = base + href;
    return new URL(href, base);
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $5NSbj = parcelRequire("5NSbj");
//#region lib/router/utils.ts
/**
* Creates a type-safe {@link RouterContext} object that can be used to
* store and retrieve arbitrary values in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
* Similar to React's [`createContext`](https://react.dev/reference/react/createContext),
* but specifically designed for React Router's request/response lifecycle.
*
* If a `defaultValue` is provided, it will be returned from `context.get()`
* when no value has been set for the context. Otherwise, reading this context
* when no value has been set will throw an error.
*
* ```tsx filename=app/context.ts
* import { createContext } from "react-router";
*
* // Create a context for user data
* export const userContext =
*   createContext<User | null>(null);
* ```
*
* ```tsx filename=app/middleware/auth.ts
* import { getUserFromSession } from "~/auth.server";
* import { userContext } from "~/context";
*
* export const authMiddleware = async ({
*   context,
*   request,
* }) => {
*   const user = await getUserFromSession(request);
*   context.set(userContext, user);
* };
* ```
*
* ```tsx filename=app/routes/profile.tsx
* import { userContext } from "~/context";
*
* export async function loader({
*   context,
* }: Route.LoaderArgs) {
*   const user = context.get(userContext);
*
*   if (!user) {
*     throw new Response("Unauthorized", { status: 401 });
*   }
*
*   return { user };
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param defaultValue An optional default value for the context. This value
* will be returned if no value has been set for this context.
* @returns A {@link RouterContext} object that can be used with
* `context.get()` and `context.set()` in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
*/ function $71ae0bb7947fe91a$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
/**
* Provides methods for writing/reading values in application context in a
* type-safe way. Primarily for usage with [middleware](../../how-to/middleware).
*
* @example
* import {
*   createContext,
*   RouterContextProvider
* } from "react-router";
*
* const userContext = createContext<User | null>(null);
* const contextProvider = new RouterContextProvider();
* contextProvider.set(userContext, getUser());
* //                               ^ Type-safe
* const user = contextProvider.get(userContext);
* //    ^ User
*
* @public
* @category Utils
* @mode framework
* @mode data
*/ var $71ae0bb7947fe91a$export$b8d3e69d4b3eff04 = class {
    #map = /* @__PURE__ */ new Map();
    /**
	* Create a new `RouterContextProvider` instance
	* @param init An optional initial context map to populate the provider with
	*/ constructor(init){
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
	* Access a value from the context. If no value has been set for the context,
	* it will return the context's `defaultValue` if provided, or throw an error
	* if no `defaultValue` was set.
	* @param context The context to get the value for
	* @returns The value for the context, or the context's `defaultValue` if no
	* value was set
	*/ get(context) {
        if (this.#map.has(context)) return this.#map.get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
	* Set a value for the context. If the context already has a value set, this
	* will overwrite it.
	*
	* @param context The context to set the value for
	* @param value The value to set for the context
	* @returns {void}
	*/ set(context, value) {
        this.#map.set(context, value);
    }
};
const $71ae0bb7947fe91a$var$unsupportedLazyRouteObjectKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children",
    "unstable_validateParams"
]);
function $71ae0bb7947fe91a$export$3e22299e33adeed1(key) {
    return $71ae0bb7947fe91a$var$unsupportedLazyRouteObjectKeys.has(key);
}
const $71ae0bb7947fe91a$var$unsupportedLazyRouteFunctionKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children",
    "unstable_validateParams"
]);
function $71ae0bb7947fe91a$export$a89d811eaa209e85(key) {
    return $71ae0bb7947fe91a$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $71ae0bb7947fe91a$var$isIndexRoute(route) {
    return route.index === true;
}
function $71ae0bb7947fe91a$export$6bc17138063be773(route) {
    let updates = {};
    if (route.Component) Object.assign(updates, {
        element: $5NSbj.createElement(route.Component),
        Component: void 0
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: $5NSbj.createElement(route.HydrateFallback),
        HydrateFallback: void 0
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: $5NSbj.createElement(route.ErrorBoundary),
        ErrorBoundary: void 0
    });
    return updates;
}
function $71ae0bb7947fe91a$export$87cb1a9238dc3fba(routes, mapRouteProperties = $71ae0bb7947fe91a$export$6bc17138063be773, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(route.index !== true || !route.children, `Cannot specify children on an index route`);
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($71ae0bb7947fe91a$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $71ae0bb7947fe91a$var$mergeRouteUpdates(indexRoute, mapRouteProperties(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $71ae0bb7947fe91a$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $71ae0bb7947fe91a$export$87cb1a9238dc3fba(route.children, mapRouteProperties, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $71ae0bb7947fe91a$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
/**
* Matches the given routes to a location and returns the match data.
*
* @example
* import { matchRoutes } from "react-router";
*
* let routes = [{
*   path: "/",
*   Component: Root,
*   children: [{
*     path: "dashboard",
*     Component: Dashboard,
*   }]
* }];
*
* matchRoutes(routes, "/dashboard"); // [rootMatch, dashboardMatch]
*
* @public
* @category Utils
* @param routes The array of route objects to match against.
* @param locationArg The location to match against, either a string path or a
* partial {@link Location} object
* @param basename Optional base path to strip from the location before matching.
* Defaults to `/`.
* @returns An array of matched routes, or `null` if no matches were found.
*/ function $71ae0bb7947fe91a$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $71ae0bb7947fe91a$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $71ae0bb7947fe91a$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let pathname = $71ae0bb7947fe91a$export$b69e3301ce081aa3((typeof locationArg === "string" ? (0, $573a89bde77cb3ae$export$8ccf933b0513f8d0)(locationArg) : locationArg).pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $71ae0bb7947fe91a$export$e486c0390e42ccf6(routes);
    let matches = null;
    let decoded = $71ae0bb7947fe91a$export$cd27bea214d030c2(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $71ae0bb7947fe91a$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $71ae0bb7947fe91a$export$fcf533780bf49ee2(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $71ae0bb7947fe91a$export$e486c0390e42ccf6(routes) {
    let branches = $71ae0bb7947fe91a$var$flattenRoutes(routes);
    $71ae0bb7947fe91a$var$rankRouteBranches(branches);
    return branches;
}
function $71ae0bb7947fe91a$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            (0, $573a89bde77cb3ae$export$f5708dca728d7177)(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $71ae0bb7947fe91a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            (0, $573a89bde77cb3ae$export$f5708dca728d7177)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $71ae0bb7947fe91a$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $71ae0bb7947fe91a$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta, i)=>{
                let [matcher, params] = $71ae0bb7947fe91a$export$d726f29eb2425705(meta.relativePath, meta.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $71ae0bb7947fe91a$export$82472424e06ad5c9(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $71ae0bb7947fe91a$export$82472424e06ad5c9(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $71ae0bb7947fe91a$export$82472424e06ad5c9(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $71ae0bb7947fe91a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $71ae0bb7947fe91a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $71ae0bb7947fe91a$var$paramRe = /^:[\w-]+$/;
const $71ae0bb7947fe91a$var$partialParamRe = /^:[\w-]+/;
const $71ae0bb7947fe91a$var$partialDynamicSegmentValue = 3.5;
const $71ae0bb7947fe91a$var$dynamicSegmentValue = 3;
const $71ae0bb7947fe91a$var$indexRouteValue = 2;
const $71ae0bb7947fe91a$var$emptySegmentValue = 1;
const $71ae0bb7947fe91a$var$staticSegmentValue = 10;
const $71ae0bb7947fe91a$var$splatPenalty = -2;
const $71ae0bb7947fe91a$var$isSplat = (s)=>s === "*";
function $71ae0bb7947fe91a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($71ae0bb7947fe91a$var$isSplat)) initialScore += $71ae0bb7947fe91a$var$splatPenalty;
    if (index) initialScore += $71ae0bb7947fe91a$var$indexRouteValue;
    return segments.filter((s)=>!$71ae0bb7947fe91a$var$isSplat(s)).reduce((score, segment)=>score + ($71ae0bb7947fe91a$var$paramRe.test(segment) ? $71ae0bb7947fe91a$var$dynamicSegmentValue : $71ae0bb7947fe91a$var$partialParamRe.test(segment) ? $71ae0bb7947fe91a$var$partialDynamicSegmentValue : segment === "" ? $71ae0bb7947fe91a$var$emptySegmentValue : $71ae0bb7947fe91a$var$staticSegmentValue), initialScore);
}
function $71ae0bb7947fe91a$var$compareIndexes(a, b) {
    return a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]) ? a[a.length - 1] - b[b.length - 1] : 0;
}
function $71ae0bb7947fe91a$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = meta.matcher && meta.compiledParams ? $71ae0bb7947fe91a$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $71ae0bb7947fe91a$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $71ae0bb7947fe91a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            params: matchedParams,
            pathname: $71ae0bb7947fe91a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $71ae0bb7947fe91a$export$a5c6d149b50c1d86($71ae0bb7947fe91a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $71ae0bb7947fe91a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
* Characters that `encodeURIComponent` escapes but that are valid literally in
* a URL path segment. Per RFC 3986 §3.3, a path segment is made of `pchar`:
*
* ```
* pchar = unreserved / pct-encoded / sub-delims / ":" / "@"
* sub-delims = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
* ```
*
* `encodeURIComponent` targets query-string values, where `$ & + , ; = : @`
* are delimiters and must be escaped — but in a path segment they carry no
* special meaning, and browsers keep them literal in `location.pathname`.
* (`! ' ( ) *` and the unreserved set are already left alone by
* `encodeURIComponent`, so they need no restoring.)
*/ const $71ae0bb7947fe91a$var$PATH_PARAM_OVERESCAPED = {
    "%24": "$",
    "%26": "&",
    "%2B": "+",
    "%2C": ",",
    "%3A": ":",
    "%3B": ";",
    "%3D": "=",
    "%40": "@"
};
/**
* Encodes a param value for interpolation into a single URL path segment.
*
* Escapes characters that would break the path (`/ ? # %`, whitespace,
* non-ASCII, …) while leaving characters that RFC 3986 permits literally in a
* path segment untouched. Escaping those would needlessly rewrite URLs — e.g.
*  a semver build param `1.0.0+1` would become `1.0.0%2B1` even though browsers
* display and match the `+` literally in `location.pathname`.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3))
*
* @param value The param value to encode.
* @returns The encoded value, safe for use as a single path segment.
*/ function $71ae0bb7947fe91a$export$1adf7db041bd81b8(value) {
    return encodeURIComponent(value).replace(/%(?:24|26|2B|2C|3A|3B|3D|40)/g, (match)=>$71ae0bb7947fe91a$var$PATH_PARAM_OVERESCAPED[match]);
}
/**
* Returns a path with params interpolated.
*
* Param values are percent-encoded for use in a path segment: characters that
* would change the URL structure (`/`, `?`, `#`, `%`, whitespace, non-ASCII)
* are escaped, while characters that RFC 3986 allows literally in a path
* segment (`$ & + , ; = : @`) are kept as-is. Note this differs from query-string
* encoding (`encodeURIComponent`/`URLSearchParams`), where those characters are
* delimiters and must be escaped. Splat (`*`) values are encoded per segment,
* preserving `/` separators.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3)
*
* @example
* import { generatePath } from "react-router";
*
* generatePath("/users/:id", { id: "123" }); // "/users/123"
* generatePath("/files/:name", { name: "a b" }); // "/files/a%20b"
* generatePath("/releases/:v", { v: "1.0.0+1" }); // "/releases/1.0.0+1"
*
* @public
* @category Utils
* @param originalPath The original path to generate.
* @param params The parameters to interpolate into the path.
* @returns The generated path with parameters interpolated.
*/ function $71ae0bb7947fe91a$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        (0, $573a89bde77cb3ae$export$491112666e282270)(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    return prefix + path.split(/\/+/).map((segment, index, array)=>{
        if (index === array.length - 1 && segment === "*") return stringify(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            (0, $573a89bde77cb3ae$export$f5708dca728d7177)(optional === "?" || param != null, `Missing ":${key}" param`);
            return $71ae0bb7947fe91a$export$1adf7db041bd81b8(stringify(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment).join("/");
}
/**
* Performs pattern matching on a URL pathname and returns information about
* the match.
*
* @public
* @category Utils
* @param pattern The pattern to match against the URL pathname. This can be a
* string or a {@link PathPattern} object. If a string is provided, it will be
* treated as a pattern with `caseSensitive` set to `false` and `end` set to
* `true`.
* @param pathname The URL pathname to match against the pattern.
* @returns A path match object if the pattern matches the pathname,
* or `null` if it does not match.
*/ function $71ae0bb7947fe91a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $71ae0bb7947fe91a$export$d726f29eb2425705(pattern.path, pattern.caseSensitive, pattern.end);
    return $71ae0bb7947fe91a$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $71ae0bb7947fe91a$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $71ae0bb7947fe91a$export$b6d465111d914331(matchedPathname, 1);
    let captureGroups = match.slice(1);
    return {
        params: compiledParams.reduce((memo, { paramName: paramName, isOptional: isOptional }, index)=>{
            if (paramName === "*") {
                let splatValue = captureGroups[index] || "";
                pathnameBase = $71ae0bb7947fe91a$export$b6d465111d914331(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
            }
            const value = captureGroups[index];
            if (isOptional && !value) memo[paramName] = void 0;
            else memo[paramName] = (value || "").replace(/%2F/g, "/");
            return memo;
        }, {}),
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $71ae0bb7947fe91a$export$d726f29eb2425705(path, caseSensitive = false, end = true) {
    (0, $573a89bde77cb3ae$export$491112666e282270)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(?=\/|$|\()/g, "(?:/$1)?");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    return [
        new RegExp(regexpSource, caseSensitive ? void 0 : "i"),
        params
    ];
}
function $71ae0bb7947fe91a$export$cd27bea214d030c2(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        (0, $573a89bde77cb3ae$export$491112666e282270)(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $71ae0bb7947fe91a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $71ae0bb7947fe91a$export$e9a5bfadbc179142({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $71ae0bb7947fe91a$export$86d9a7913e44197e([
        basename,
        pathname
    ]);
}
const $71ae0bb7947fe91a$export$a1cbf2de32a9fd1 = (url)=>(0, $38b29aefca9c076c$export$6c52c2011d568bd0).test(url);
/**
* Returns a resolved {@link Path} object relative to the given pathname.
*
* @public
* @category Utils
* @param to The path to resolve, either a string or a partial {@link Path}
* object.
* @param fromPathname The pathname to resolve the path from. Defaults to `/`.
* @returns A {@link Path} object with the resolved pathname, search, and hash.
*/ function $71ae0bb7947fe91a$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $573a89bde77cb3ae$export$8ccf933b0513f8d0)(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $71ae0bb7947fe91a$export$f857a07c5bd323b8(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $71ae0bb7947fe91a$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $71ae0bb7947fe91a$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $71ae0bb7947fe91a$var$normalizeSearch(search),
        hash: $71ae0bb7947fe91a$var$normalizeHash(hash)
    };
}
function $71ae0bb7947fe91a$var$resolvePathname(relativePath, fromPathname) {
    let segments = $71ae0bb7947fe91a$export$b6d465111d914331(fromPathname).split("/");
    relativePath.split("/").forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $71ae0bb7947fe91a$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $71ae0bb7947fe91a$export$b234c29a3bb68fc8(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $71ae0bb7947fe91a$export$fe6dbc5de95f53ab(matches) {
    let pathMatches = $71ae0bb7947fe91a$export$b234c29a3bb68fc8(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $71ae0bb7947fe91a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = (0, $573a89bde77cb3ae$export$8ccf933b0513f8d0)(toArg);
    else {
        to = {
            ...toArg
        };
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("?"), $71ae0bb7947fe91a$var$getInvalidPathError("?", "pathname", "search", to));
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("#"), $71ae0bb7947fe91a$var$getInvalidPathError("#", "pathname", "hash", to));
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(!to.search || !to.search.includes("#"), $71ae0bb7947fe91a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $71ae0bb7947fe91a$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
const $71ae0bb7947fe91a$export$f857a07c5bd323b8 = (path)=>path.replace(/[\\/]{2,}/g, "/");
const $71ae0bb7947fe91a$export$86d9a7913e44197e = (paths)=>$71ae0bb7947fe91a$export$f857a07c5bd323b8(paths.join("/"));
function $71ae0bb7947fe91a$export$b6d465111d914331(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
const $71ae0bb7947fe91a$export$a5c6d149b50c1d86 = (pathname)=>$71ae0bb7947fe91a$export$b6d465111d914331(pathname).replace(/^\/*/, "/");
const $71ae0bb7947fe91a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $71ae0bb7947fe91a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $71ae0bb7947fe91a$var$DataWithResponseInit = class {
    type = "DataWithResponseInit";
    data;
    init;
    constructor(data, init){
        this.data = data;
        this.init = init || null;
    }
};
/**
* Create "responses" that contain `headers`/`status` without forcing
* serialization into an actual [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
*
* @example
* import { data } from "react-router";
*
* export async function action({ request }: Route.ActionArgs) {
*   let formData = await request.formData();
*   let item = await createItem(formData);
*   return data(item, {
*     headers: { "X-Custom-Header": "value" }
*     status: 201,
*   });
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param data The data to be included in the response.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A {@link DataWithResponseInit} instance containing the data and
* response init.
*/ function $71ae0bb7947fe91a$export$4051a07651545597(data, init) {
    return new $71ae0bb7947fe91a$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response).
* Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* @example
* import { redirect } from "react-router";
*
* export async function loader({ request }: Route.LoaderArgs) {
*   if (!isLoggedIn(request))
*     throw redirect("/login");
*   }
*
*   // ...
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $71ae0bb7947fe91a$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will force a document reload to the new location. Sets the status code
* and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* ```tsx filename=routes/logout.tsx
* import { redirectDocument } from "react-router";
*
* import { destroySession } from "../sessions.server";
*
* export async function action({ request }: Route.ActionArgs) {
*   let session = await getSession(request.headers.get("Cookie"));
*   return redirectDocument("/", {
*     headers: { "Set-Cookie": await destroySession(session) }
*   });
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $71ae0bb7947fe91a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $71ae0bb7947fe91a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will perform a [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState)
* instead of a [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* for client-side navigation redirects. Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* @example
* import { replace } from "react-router";
*
* export async function loader() {
*   return replace("/new-location");
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $71ae0bb7947fe91a$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $71ae0bb7947fe91a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
const $71ae0bb7947fe91a$export$1a235bd2b33434e5 = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $71ae0bb7947fe91a$export$f2680fa305b734ca = class {
    status;
    statusText;
    data;
    error;
    internal;
    constructor(status, statusText, data, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
};
/**
* Check if the given error is an {@link ErrorResponse} generated from a 4xx/5xx
* [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* thrown from an [`action`](../../start/framework/route-module#action) or
* [`loader`](../../start/framework/route-module#loader) function.
*
* @example
* import { isRouteErrorResponse } from "react-router";
*
* export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
*   if (isRouteErrorResponse(error)) {
*     return (
*       <>
*         <p>Error: `${error.status}: ${error.statusText}`</p>
*         <p>{error.data}</p>
*       </>
*     );
*   }
*
*   return (
*     <p>Error: {error instanceof Error ? error.message : "Unknown Error"}</p>
*   );
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param error The error to check.
* @returns `true` if the error is an {@link ErrorResponse}, `false` otherwise.
*/ function $71ae0bb7947fe91a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $71ae0bb7947fe91a$export$d738435097971c09(matches) {
    return $71ae0bb7947fe91a$export$86d9a7913e44197e(matches.map((m)=>m.route.path).filter(Boolean)) || "/";
}
function $71ae0bb7947fe91a$export$141d98e45b4b08e4(request, path) {
    let url = new URL(typeof request === "string" || request instanceof URL ? request : request.url);
    let parsed = typeof path === "string" ? (0, $573a89bde77cb3ae$export$8ccf933b0513f8d0)(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        let search = searchParams.toString();
        url.search = search ? `?${search}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
const $71ae0bb7947fe91a$export$4e09c449d6c407f7 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $71ae0bb7947fe91a$export$ac5aeb949e84fd96(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !(0, $38b29aefca9c076c$export$6c52c2011d568bd0).test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($71ae0bb7947fe91a$export$4e09c449d6c407f7) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = (0, $38b29aefca9c076c$export$825a82322d91916e).test(to) ? new URL((0, $38b29aefca9c076c$export$977999b735cd4f26)(to, currentUrl.protocol)) : new URL(to);
        let path = $71ae0bb7947fe91a$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch  {
        (0, $573a89bde77cb3ae$export$491112666e282270)(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

//#region lib/router/instrumentation.ts
const $cf5f77708a26e901$var$UninstrumentedSymbol = Symbol("Uninstrumented");
const $cf5f77708a26e901$export$b1aab28b8e9d7d25 = (0, $71ae0bb7947fe91a$export$fd42f52fd3ae1109)();
let $cf5f77708a26e901$var$instrumentationClientResultMetaReceivers = /* @__PURE__ */ new WeakMap();
function $cf5f77708a26e901$export$3cb8f5f9ecc770ef(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                if (i.lazy != null) aggregated.lazy.push(i.lazy);
                if (i["lazy.loader"] != null) aggregated["lazy.loader"].push(i["lazy.loader"]);
                if (i["lazy.action"] != null) aggregated["lazy.action"].push(i["lazy.action"]);
                if (i["lazy.middleware"] != null) aggregated["lazy.middleware"].push(i["lazy.middleware"]);
                if (i.middleware != null) aggregated.middleware.push(i.middleware);
                if (i.loader != null) aggregated.loader.push(i.loader);
                if (i.action != null) aggregated.action.push(i.action);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let lazy = route.lazy;
        updates.lazy = async (...args)=>{
            return $cf5f77708a26e901$var$throwOrReturnResult(await $cf5f77708a26e901$var$recurseRight(aggregated.lazy, void 0, ()=>lazy(...args), $cf5f77708a26e901$var$getInstrumentationInnerResult));
        };
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        if (typeof lazyObject.middleware === "function" && aggregated["lazy.middleware"].length > 0) {
            let middleware = lazyObject.middleware;
            updates.lazy = Object.assign(updates.lazy || {}, {
                middleware: async (...args)=>{
                    return $cf5f77708a26e901$var$throwOrReturnResult(await $cf5f77708a26e901$var$recurseRight(aggregated["lazy.middleware"], void 0, ()=>middleware(...args), $cf5f77708a26e901$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.loader === "function" && aggregated["lazy.loader"].length > 0) {
            let loader = lazyObject.loader;
            updates.lazy = Object.assign(updates.lazy || {}, {
                loader: async (...args)=>{
                    return $cf5f77708a26e901$var$throwOrReturnResult(await $cf5f77708a26e901$var$recurseRight(aggregated["lazy.loader"], void 0, ()=>loader(...args), $cf5f77708a26e901$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.action === "function" && aggregated["lazy.action"].length > 0) {
            let action = lazyObject.action;
            updates.lazy = Object.assign(updates.lazy || {}, {
                action: async (...args)=>{
                    return $cf5f77708a26e901$var$throwOrReturnResult(await $cf5f77708a26e901$var$recurseRight(aggregated["lazy.action"], void 0, ()=>action(...args), $cf5f77708a26e901$var$getInstrumentationInnerResult));
                }
            });
        }
    }
    if (typeof route.loader === "function" && aggregated.loader.length > 0) {
        let original = $cf5f77708a26e901$var$getUninstrumentedHandler(route.loader);
        let instrumented = async (...args)=>{
            return $cf5f77708a26e901$var$throwOrReturnResult(await $cf5f77708a26e901$var$recurseRight(aggregated.loader, $cf5f77708a26e901$var$getHandlerInfo(args[0]), ()=>original(...args), $cf5f77708a26e901$var$getInstrumentationInnerResult));
        };
        if (original.hydrate === true) instrumented.hydrate = true;
        $cf5f77708a26e901$var$setUninstrumentedHandler(instrumented, original);
        updates.loader = instrumented;
    }
    if (typeof route.action === "function" && aggregated.action.length > 0) {
        let original = $cf5f77708a26e901$var$getUninstrumentedHandler(route.action);
        let instrumented = async (...args)=>{
            return $cf5f77708a26e901$var$throwOrReturnResult(await $cf5f77708a26e901$var$recurseRight(aggregated.action, $cf5f77708a26e901$var$getHandlerInfo(args[0]), ()=>original(...args), $cf5f77708a26e901$var$getInstrumentationInnerResult));
        };
        $cf5f77708a26e901$var$setUninstrumentedHandler(instrumented, original);
        updates.action = instrumented;
    }
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = $cf5f77708a26e901$var$getUninstrumentedHandler(middleware);
        let instrumented = async (...args)=>{
            return $cf5f77708a26e901$var$throwOrReturnResult(await $cf5f77708a26e901$var$recurseRight(aggregated.middleware, $cf5f77708a26e901$var$getHandlerInfo(args[0]), ()=>original(...args), $cf5f77708a26e901$var$getInstrumentationInnerResult));
        };
        $cf5f77708a26e901$var$setUninstrumentedHandler(instrumented, original);
        return instrumented;
    });
    return updates;
}
function $cf5f77708a26e901$export$ac4df491f31cbbfc(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.navigate != null) aggregated.navigate.push(i.navigate);
                if (i.fetch != null) aggregated.fetch.push(i.fetch);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = $cf5f77708a26e901$var$getUninstrumentedHandler(router.navigate);
        let instrumentedNavigate = async (...args)=>{
            let [to, opts] = args;
            let meta;
            let info = {
                to: typeof to === "number" || typeof to === "string" ? to : to ? (0, $573a89bde77cb3ae$export$fe53371bee54353d)(to) : ".",
                ...$cf5f77708a26e901$var$getRouterInfo(router, opts ?? {})
            };
            return $cf5f77708a26e901$var$throwOrReturnResult(await $cf5f77708a26e901$var$recurseRight(aggregated.navigate, info, async ()=>{
                if (typeof to === "number") return await navigate(...args);
                let cleanup = $cf5f77708a26e901$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await navigate(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$cf5f77708a26e901$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $cf5f77708a26e901$var$setUninstrumentedHandler(instrumentedNavigate, navigate);
        router.navigate = instrumentedNavigate;
    }
    if (aggregated.fetch.length > 0) {
        let fetch = $cf5f77708a26e901$var$getUninstrumentedHandler(router.fetch);
        let instrumentedFetch = async (...args)=>{
            let [key, _, href, opts] = args;
            let meta;
            return $cf5f77708a26e901$var$throwOrReturnResult(await $cf5f77708a26e901$var$recurseRight(aggregated.fetch, {
                href: href ?? ".",
                fetcherKey: key,
                ...$cf5f77708a26e901$var$getRouterInfo(router, opts ?? {})
            }, async ()=>{
                let cleanup = $cf5f77708a26e901$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await fetch(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$cf5f77708a26e901$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $cf5f77708a26e901$var$setUninstrumentedHandler(instrumentedFetch, fetch);
        router.fetch = instrumentedFetch;
    }
    return router;
}
function $cf5f77708a26e901$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.request != null) aggregated.request.push(i.request);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = async (...args)=>{
        let [request, context] = args;
        let instrumentationContext = context ?? new (0, $71ae0bb7947fe91a$export$b8d3e69d4b3eff04)();
        return $cf5f77708a26e901$var$throwOrReturnResult(await $cf5f77708a26e901$var$recurseRight(aggregated.request, {
            request: $cf5f77708a26e901$var$getReadonlyRequest(request),
            context: $cf5f77708a26e901$var$getReadonlyContext(instrumentationContext)
        }, ()=>handler(request, instrumentationContext), (result, info)=>{
            let meta;
            try {
                meta = info.context?.get($cf5f77708a26e901$export$b1aab28b8e9d7d25);
            } catch  {}
            (0, $573a89bde77cb3ae$export$f5708dca728d7177)(result.value instanceof Response, "Expected a Response from the request handler");
            return {
                ...$cf5f77708a26e901$var$getInstrumentationInnerResult(result),
                statusCode: result.value.status,
                meta: meta
            };
        }));
    };
    return instrumentedHandler;
}
function $cf5f77708a26e901$var$getUninstrumentedHandler(handler) {
    return handler[$cf5f77708a26e901$var$UninstrumentedSymbol] ?? handler;
}
function $cf5f77708a26e901$var$setUninstrumentedHandler(handler, uninstrumentedHandler) {
    handler[$cf5f77708a26e901$var$UninstrumentedSymbol] = uninstrumentedHandler;
}
function $cf5f77708a26e901$var$setInstrumentationClientResultMetaReceiver(router, receiver) {
    $cf5f77708a26e901$var$instrumentationClientResultMetaReceivers.set(router, receiver);
    return ()=>{
        if ($cf5f77708a26e901$var$instrumentationClientResultMetaReceivers.get(router) === receiver) $cf5f77708a26e901$var$instrumentationClientResultMetaReceivers.delete(router);
    };
}
function $cf5f77708a26e901$export$5579798e35f5560e(router) {
    let receiver = $cf5f77708a26e901$var$instrumentationClientResultMetaReceivers.get(router);
    $cf5f77708a26e901$var$instrumentationClientResultMetaReceivers.delete(router);
    return receiver;
}
function $cf5f77708a26e901$var$throwOrReturnResult(result) {
    if (result.type === "error") throw result.value;
    return result.value;
}
async function $cf5f77708a26e901$var$recurseRight(impls, info, handler, getInnerResult, state = {
    result: null,
    innerResult: null
}, index = impls.length - 1) {
    let impl = impls[index];
    if (!impl) {
        try {
            state.result = {
                type: "success",
                value: await handler()
            };
        } catch (e) {
            state.result = {
                type: "error",
                value: e
            };
        }
        state.innerResult = getInnerResult(state.result, info);
    } else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $cf5f77708a26e901$var$recurseRight(impls, info, handler, getInnerResult, state, index - 1);
            await handlerPromise;
            (0, $573a89bde77cb3ae$export$f5708dca728d7177)(state.innerResult, "Expected an inner result");
            return state.innerResult;
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (state.result) return state.result;
    state.result = {
        type: "error",
        value: /* @__PURE__ */ new Error("No result assigned in instrumentation chain.")
    };
    state.innerResult = getInnerResult(state.result, info);
    return state.result;
}
function $cf5f77708a26e901$var$getInstrumentationInnerResult(result) {
    if (result.type === "error" && result.value instanceof Error) return {
        status: "error",
        error: result.value
    };
    return {
        status: "success",
        error: void 0
    };
}
function $cf5f77708a26e901$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params } = args;
    return {
        ...args,
        request: $cf5f77708a26e901$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        context: $cf5f77708a26e901$var$getReadonlyContext(context)
    };
}
function $cf5f77708a26e901$var$getRouterInfo(router, opts) {
    return {
        currentUrl: (0, $573a89bde77cb3ae$export$fe53371bee54353d)(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $cf5f77708a26e901$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $cf5f77708a26e901$var$getReadonlyContext(context) {
    return {
        get: (ctx)=>context.get(ctx)
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/router/matcher.ts
var $3c2ef84a5d00df40$export$92541312f2982378 = class {
    #routes = [];
    #branches = [];
    #basename;
    constructor(basename){
        this.#basename = basename;
    }
    update(routes) {
        this.#routes = routes;
        this.#branches = (0, $71ae0bb7947fe91a$export$e486c0390e42ccf6)(routes);
    }
    match(locationArg, allowPartial = false) {
        return (0, $71ae0bb7947fe91a$export$5c7b09132f833c25)(this.#routes, locationArg, this.#basename, allowPartial, this.#branches);
    }
};


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

/**
 * Split a route pattern into protocol, hostname, port, pathname, and search
 * spans delimited as `protocol://hostname:port/pathname?search`.
 *
 * Delimiters are not included in the spans with the exception of the leading `/` for pathname.
 * Spans are [begin (inclusive), end (exclusive)].
 *
 * @param source the route pattern string to split
 * @returns an object containing spans for each URL component
 */ function $592c47a22ee83bbc$export$65980d18b75784e2(source) {
    let result = {
        protocol: null,
        hostname: null,
        port: null,
        pathname: null,
        search: null
    };
    let questionMarkIndex = source.indexOf('?');
    if (questionMarkIndex !== -1) {
        result.search = $592c47a22ee83bbc$var$span(questionMarkIndex + 1, source.length);
        source = source.slice(0, questionMarkIndex);
    }
    let solidusIndex = source.indexOf('://');
    if (solidusIndex === -1) {
        result.pathname = $592c47a22ee83bbc$var$pathnameSpan(source, 0, source.length);
        return result;
    }
    let slashIndex = source.indexOf('/');
    if (slashIndex === solidusIndex + 1) slashIndex = source.indexOf('/', solidusIndex + 3);
    if (slashIndex === -1) {
        result.protocol = $592c47a22ee83bbc$var$span(0, solidusIndex);
        let host = $592c47a22ee83bbc$var$span(solidusIndex + 3, source.length);
        if (host) {
            let { hostname: hostname, port: port } = $592c47a22ee83bbc$var$hostSpans(source, host);
            result.hostname = hostname;
            result.port = port;
        }
        return result;
    }
    if (slashIndex < solidusIndex) {
        result.pathname = $592c47a22ee83bbc$var$pathnameSpan(source, 0, source.length);
        return result;
    }
    result.protocol = $592c47a22ee83bbc$var$span(0, solidusIndex);
    let host = $592c47a22ee83bbc$var$span(solidusIndex + 3, slashIndex);
    if (host) {
        let { hostname: hostname, port: port } = $592c47a22ee83bbc$var$hostSpans(source, host);
        result.hostname = hostname;
        result.port = port;
    }
    result.pathname = $592c47a22ee83bbc$var$pathnameSpan(source, slashIndex, source.length);
    return result;
}
function $592c47a22ee83bbc$var$span(start, end) {
    if (start === end) return null;
    return [
        start,
        end
    ];
}
function $592c47a22ee83bbc$var$hostSpans(source, host) {
    let lastColonIndex = source.slice(0, host[1]).lastIndexOf(':');
    if (lastColonIndex === -1 || lastColonIndex < host[0]) return {
        hostname: host,
        port: null
    };
    if (source.slice(lastColonIndex + 1, host[1]).match(/^\d+$/)) return {
        hostname: $592c47a22ee83bbc$var$span(host[0], lastColonIndex),
        port: $592c47a22ee83bbc$var$span(lastColonIndex + 1, host[1])
    };
    return {
        hostname: host,
        port: null
    };
}
function $592c47a22ee83bbc$var$pathnameSpan(source, begin, end) {
    if (source[begin] === '/') begin += 1;
    return $592c47a22ee83bbc$var$span(begin, end);
}



const $2e5715da18450ef9$var$IDENTIFIER_RE = /^[a-zA-Z_$][a-zA-Z_$0-9]*/;
function $2e5715da18450ef9$export$e26190e3669abbfe(source) {
    let spans = (0, $592c47a22ee83bbc$export$65980d18b75784e2)(source);
    return new (0, $c80bce60b563fbfc$export$2917961db0dd6e8b)({
        protocol: $2e5715da18450ef9$var$parseProtocol(source, spans.protocol),
        hostname: $2e5715da18450ef9$var$parseHostname(source, spans.hostname),
        port: spans.port ? source.slice(...spans.port) : null,
        pathname: spans.pathname ? $2e5715da18450ef9$export$6681bda78b6b4cbd(source, {
            span: spans.pathname,
            type: 'pathname'
        }) : $2e5715da18450ef9$export$6681bda78b6b4cbd('', {
            span: [
                0,
                0
            ],
            type: 'pathname'
        }),
        search: spans.search ? $2e5715da18450ef9$var$parseSearch(source.slice(...spans.search)) : new Map()
    });
}
function $2e5715da18450ef9$export$6681bda78b6b4cbd(source, options) {
    let span = options.span ?? [
        0,
        source.length
    ];
    let separator = options.type === 'hostname' ? '.' : '/';
    let tokens = [];
    let optionals = new Map();
    let appendText = (text)=>{
        let currentToken = tokens.at(-1);
        if (currentToken?.type === 'text') currentToken.text += text;
        else tokens.push({
            type: 'text',
            text: text
        });
    };
    let i = span[0];
    let optionalStack = [];
    while(i < span[1]){
        let char = source[i];
        if (char === '(') {
            optionalStack.push(tokens.length);
            tokens.push({
                type: char
            });
            i += 1;
            continue;
        }
        if (char === ')') {
            let begin = optionalStack.pop();
            if (begin === undefined) throw new $2e5715da18450ef9$export$f9c837a54db411d('unmatched )', source, i);
            optionals.set(begin, tokens.length);
            tokens.push({
                type: char
            });
            i += 1;
            continue;
        }
        if (char === ':') {
            i += 1;
            let name = $2e5715da18450ef9$var$IDENTIFIER_RE.exec(source.slice(i, span[1]))?.[0];
            if (!name) throw new $2e5715da18450ef9$export$f9c837a54db411d('missing variable name', source, i - 1);
            tokens.push({
                type: ':',
                name: name
            });
            i += name.length;
            continue;
        }
        if (char === '*') {
            i += 1;
            let name = $2e5715da18450ef9$var$IDENTIFIER_RE.exec(source.slice(i, span[1]))?.[0];
            tokens.push({
                type: '*',
                name: name ?? '*'
            });
            i += name?.length ?? 0;
            continue;
        }
        if (char === separator) {
            tokens.push({
                type: 'separator'
            });
            i += 1;
            continue;
        }
        if (char === '\\') {
            if (i + 1 === span[1]) throw new $2e5715da18450ef9$export$f9c837a54db411d('dangling escape', source, i);
            let text = source.slice(i + 1, i + 2);
            appendText(text);
            i += 2;
            continue;
        }
        appendText(char);
        i += 1;
    }
    if (optionalStack.length > 0) throw new $2e5715da18450ef9$export$f9c837a54db411d('unmatched (', source, optionalStack.at(-1));
    return {
        tokens: tokens,
        optionals: optionals,
        type: options.type
    };
}
function $2e5715da18450ef9$var$parseProtocol(source, span) {
    if (!span) return null;
    let protocol = source.slice(...span);
    if (protocol === '' || protocol === 'http' || protocol === 'https' || protocol === 'http(s)') return protocol === '' ? null : protocol;
    throw new $2e5715da18450ef9$export$f9c837a54db411d('invalid protocol', source, span[0]);
}
function $2e5715da18450ef9$var$parseHostname(source, span) {
    if (!span) return null;
    let part = $2e5715da18450ef9$export$6681bda78b6b4cbd(source, {
        span: span,
        type: 'hostname'
    });
    if ($2e5715da18450ef9$var$isNamelessWildcard(part)) return null;
    return part;
}
function $2e5715da18450ef9$var$isNamelessWildcard(part) {
    if (part.tokens.length !== 1) return false;
    let token = part.tokens[0];
    if (token.type !== '*') return false;
    return token.name === '*';
}
function $2e5715da18450ef9$var$parseSearch(source) {
    let constraints = new Map();
    let searchParams = new URLSearchParams(source);
    for (let [key, value] of searchParams){
        let requiredValues = constraints.get(key);
        if (!requiredValues) {
            requiredValues = new Set();
            constraints.set(key, requiredValues);
        }
        if (value === '') continue;
        requiredValues.add(value);
    }
    return constraints;
}
class $2e5715da18450ef9$export$f9c837a54db411d extends Error {
    /** The parse failure category. */ type;
    /** Original pattern source being parsed. */ source;
    /** Character index where parsing failed. */ index;
    constructor(type, source, index){
        let underline = ' '.repeat(index) + '^';
        let message = `${type}\n\n${source}\n${underline}`;
        super(message);
        this.name = 'ParseError';
        this.type = type;
        this.source = source;
        this.index = index;
    }
}


/**
 * An internal error that should never happen.
 *
 * @param value Typed as `never` to ensure exhaustiveness for discriminated unions.
 */ function $66f718c575951cb2$export$565e9d9bd6b6e0d4(value) {
    let message = value === undefined ? 'Unreachable' : `Unreachable: ${value}`;
    throw new Error(message);
}


function $d668dd603a0549bd$export$f54f830b0caf58b(pattern) {
    let protocol = $d668dd603a0549bd$export$f5782abab8870711(pattern);
    let hostname = $d668dd603a0549bd$export$191bef10f978d68f(pattern);
    let port = $d668dd603a0549bd$export$776a5d5828862b2f(pattern);
    let pathname = $d668dd603a0549bd$export$a2dfe5fa28b7cbe3(pattern);
    let search = $d668dd603a0549bd$export$3ba2b473bde2deb8(pattern);
    let result = '';
    if (protocol || hostname || port) result += `${protocol}://${hostname}${port === '' ? '' : `:${port}`}`;
    result += '/' + pathname;
    if (search) result += `?${search}`;
    return result;
}
function $d668dd603a0549bd$export$161f896add7aeb90(pattern) {
    return {
        protocol: $d668dd603a0549bd$export$f5782abab8870711(pattern),
        hostname: $d668dd603a0549bd$export$191bef10f978d68f(pattern),
        port: $d668dd603a0549bd$export$776a5d5828862b2f(pattern),
        pathname: $d668dd603a0549bd$export$a2dfe5fa28b7cbe3(pattern),
        search: $d668dd603a0549bd$export$3ba2b473bde2deb8(pattern)
    };
}
function $d668dd603a0549bd$export$f5782abab8870711(pattern) {
    return pattern.protocol ?? '';
}
function $d668dd603a0549bd$export$191bef10f978d68f(pattern) {
    return pattern.hostname ? $d668dd603a0549bd$export$4d98ccdba8645223(pattern.hostname) : '';
}
function $d668dd603a0549bd$export$776a5d5828862b2f(pattern) {
    return pattern.port ?? '';
}
function $d668dd603a0549bd$export$a2dfe5fa28b7cbe3(pattern) {
    return $d668dd603a0549bd$export$4d98ccdba8645223(pattern.pathname);
}
function $d668dd603a0549bd$export$3ba2b473bde2deb8(pattern) {
    if (pattern.search.size === 0) return '';
    let searchParams = new URLSearchParams();
    for (let [key, constraint] of pattern.search){
        if (constraint.size === 0) searchParams.append(key, '');
        else for (let value of constraint)searchParams.append(key, value);
    }
    return searchParams.toString();
}
function $d668dd603a0549bd$var$escapeText(text) {
    return text.replaceAll(/[:*()\\]/g, '\\$&');
}
function $d668dd603a0549bd$export$4d98ccdba8645223(part) {
    let separator = part.type === 'hostname' ? '.' : '/';
    let result = '';
    for (let token of part.tokens){
        if (token.type === '(' || token.type === ')') {
            result += token.type;
            continue;
        }
        if (token.type === 'text') {
            result += $d668dd603a0549bd$var$escapeText(token.text);
            continue;
        }
        if (token.type === ':' || token.type === '*') {
            let name = token.name === '*' ? '' : token.name;
            result += `${token.type}${name}`;
            continue;
        }
        if (token.type === 'separator') {
            result += separator;
            continue;
        }
        (0, $66f718c575951cb2$export$565e9d9bd6b6e0d4)(token.type);
    }
    return result;
}


class $c80bce60b563fbfc$export$2917961db0dd6e8b {
    protocol;
    hostname;
    port;
    pathname;
    search;
    /**
     * Create a new `RoutePattern` by parsing a source string.
     *
     * @param source The route pattern source string.
     * @returns The parsed route pattern.
     */ static parse(source) {
        return (0, $2e5715da18450ef9$export$e26190e3669abbfe)(source);
    }
    /**
     * Create a new `RoutePattern` from parsed parts of a route pattern.
     *
     * Useful for efficiently deriving new patterns from already parsed patterns.
     * Unless you know what you are doing, you probably want `RoutePattern.parse`.
     *
     * @param parsed Parsed route pattern parts.
     */ constructor(parsed){
        this.protocol = parsed.protocol;
        this.hostname = parsed.hostname;
        this.port = parsed.port;
        this.pathname = parsed.pathname;
        this.search = parsed.search;
    }
    /** Normalized string representation of this pattern */ get source() {
        return (0, $d668dd603a0549bd$export$f54f830b0caf58b)(this);
    }
    /**
     * Returns a string representing this route pattern.
     *
     * @returns The same normalized pattern string as `RoutePattern.source`.
     */ toString() {
        return this.source;
    }
    /**
     * Returns a JSON-serializable object containing each serialized part of this route pattern.
     *
     * @returns The serialized protocol, hostname, port, pathname, and search.
     */ toJSON() {
        return (0, $d668dd603a0549bd$export$161f896add7aeb90)(this);
    }
}



// Adapted from https://github.com/mathiasbynens/punycode.js/blob/9e1b2cda98d215d3a73fcbfe93c62e021f4ba768/punycode.js
/** Highest positive signed 32-bit float value */ const $c5f56781b613b2fa$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $c5f56781b613b2fa$var$base = 36;
const $c5f56781b613b2fa$var$tMin = 1;
const $c5f56781b613b2fa$var$tMax = 26;
const $c5f56781b613b2fa$var$skew = 38;
const $c5f56781b613b2fa$var$damp = 700;
const $c5f56781b613b2fa$var$initialBias = 72;
const $c5f56781b613b2fa$var$initialN = 128; // 0x80
const $c5f56781b613b2fa$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $c5f56781b613b2fa$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $c5f56781b613b2fa$var$errors = {
    overflow: 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
const $c5f56781b613b2fa$var$baseMinusTMin = $c5f56781b613b2fa$var$base - $c5f56781b613b2fa$var$tMin;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @param type The error type.
 */ function $c5f56781b613b2fa$var$error(type) {
    throw new RangeError($c5f56781b613b2fa$var$errors[type]);
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @param domain The domain name or email address.
 * @param callback The function that gets called for every character.
 * @returns A new string of characters returned by the callback function.
 */ function $c5f56781b613b2fa$var$mapDomain(domain, callback) {
    let parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    domain = domain.replace($c5f56781b613b2fa$var$regexSeparators, '.');
    let labels = domain.split('.');
    let encoded = labels.map(callback).join('.');
    return result + encoded;
}
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @param codePoint The basic numeric code point value.
 * @returns The numeric value of a basic code point in the range `0` to
 * `base - 1`, or `base` if the code point does not represent a value.
 */ function $c5f56781b613b2fa$var$basicToDigit(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3a) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5b) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7b) return codePoint - 0x61;
    return $c5f56781b613b2fa$var$base;
}
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @param delta The current delta.
 * @param numPoints The number of code points handled.
 * @param firstTime Whether this is the first adaptation.
 * @returns The adapted bias.
 */ function $c5f56781b613b2fa$var$adapt(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? Math.floor(delta / $c5f56781b613b2fa$var$damp) : delta >> 1;
    delta += Math.floor(delta / numPoints);
    for(; delta > $c5f56781b613b2fa$var$baseMinusTMin * $c5f56781b613b2fa$var$tMax >> 1; k += $c5f56781b613b2fa$var$base)delta = Math.floor(delta / $c5f56781b613b2fa$var$baseMinusTMin);
    return Math.floor(k + ($c5f56781b613b2fa$var$baseMinusTMin + 1) * delta / (delta + $c5f56781b613b2fa$var$skew));
}
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @param input The Punycode string of ASCII-only symbols.
 * @returns The resulting string of Unicode symbols.
 */ function $c5f56781b613b2fa$var$decode(input) {
    // Don't use UCS-2.
    let output = [];
    let inputLength = input.length;
    let i = 0;
    let n = $c5f56781b613b2fa$var$initialN;
    let bias = $c5f56781b613b2fa$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($c5f56781b613b2fa$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $c5f56781b613b2fa$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength /* no final expression */ ;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        let oldi = i;
        for(let w = 1, k = $c5f56781b613b2fa$var$base /* no condition */ ;; k += $c5f56781b613b2fa$var$base){
            if (index >= inputLength) $c5f56781b613b2fa$var$error('invalid-input');
            let digit = $c5f56781b613b2fa$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $c5f56781b613b2fa$var$base) $c5f56781b613b2fa$var$error('invalid-input');
            if (digit > Math.floor(($c5f56781b613b2fa$var$maxInt - i) / w)) $c5f56781b613b2fa$var$error('overflow');
            i += digit * w;
            let t = k <= bias ? $c5f56781b613b2fa$var$tMin : k >= bias + $c5f56781b613b2fa$var$tMax ? $c5f56781b613b2fa$var$tMax : k - bias;
            if (digit < t) break;
            let baseMinusT = $c5f56781b613b2fa$var$base - t;
            if (w > Math.floor($c5f56781b613b2fa$var$maxInt / baseMinusT)) $c5f56781b613b2fa$var$error('overflow');
            w *= baseMinusT;
        }
        let out = output.length + 1;
        bias = $c5f56781b613b2fa$var$adapt(i - oldi, out, oldi === 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if (Math.floor(i / out) > $c5f56781b613b2fa$var$maxInt - n) $c5f56781b613b2fa$var$error('overflow');
        n += Math.floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
}
const $c5f56781b613b2fa$export$110c810e8727e62b = function(input) {
    // Optimization: skip if no punycode markers found
    if (!input.includes('xn--')) return input;
    return $c5f56781b613b2fa$var$mapDomain(input, function(string) {
        return string.startsWith('xn--') ? $c5f56781b613b2fa$var$decode(string.slice(4).toLowerCase()) : string;
    });
};





function $8cfcdd83addb9a5f$export$4e7f196112fea3c5(text) {
    return text.replace(/[.*+?^${}()|[\]\\-]/g, '\\$&');
}
function $8cfcdd83addb9a5f$export$238374f1b270e387(tokens, options) {
    let result = '';
    for (let token of tokens){
        if (token.type === 'text') {
            result += $8cfcdd83addb9a5f$export$4e7f196112fea3c5(token.text);
            continue;
        }
        if (token.type === ':') {
            result += `([^${options.separator}]+?)`;
            continue;
        }
        if (token.type === '*') {
            result += `(.*)`;
            continue;
        }
        if (token.type === '(') {
            result += '(?:';
            continue;
        }
        if (token.type === ')') {
            result += ')?';
            continue;
        }
        if (token.type === 'separator') {
            result += $8cfcdd83addb9a5f$export$4e7f196112fea3c5(options.separator);
            continue;
        }
        (0, $66f718c575951cb2$export$565e9d9bd6b6e0d4)(token.type);
    }
    let flags = 'd';
    if (options.ignoreCase) flags += 'i';
    return new RegExp(`^${result}$`, flags);
}



function $141be13c0b714baa$export$9ac16898ad61bc17(pattern) {
    let result = [];
    for (let protocol of $141be13c0b714baa$var$generateProtocolVariants(pattern.protocol)){
        let port = $141be13c0b714baa$var$normalizePort(protocol, pattern.port);
        for (let hostname of $141be13c0b714baa$var$generateHostnameVariants(pattern.hostname))for (let pathname of $141be13c0b714baa$var$generatePathnameVariants(pattern.pathname))result.push({
            protocol: protocol,
            hostname: hostname,
            port: port,
            pathname: pathname
        });
    }
    return result;
}
function $141be13c0b714baa$var$generateProtocolVariants(protocol) {
    if (protocol === null || protocol === 'http(s)') return [
        'http',
        'https'
    ];
    return [
        protocol
    ];
}
function $141be13c0b714baa$var$normalizePort(protocol, port) {
    if (port === null) return '';
    if (protocol === 'http' && port === '80') return '';
    if (protocol === 'https' && port === '443') return '';
    return port;
}
function $141be13c0b714baa$var$toParams(tokens) {
    let params = [];
    for (let token of tokens)if (token.type === ':' || token.type === '*') params.push(token);
    return params;
}
function $141be13c0b714baa$var$generateHostnameVariants(hostname) {
    let result = [];
    if (hostname === null) return [
        {
            type: 'any'
        }
    ];
    for (let variant of $141be13c0b714baa$export$57a1d23d0b7a46c(hostname)){
        let params = $141be13c0b714baa$var$toParams(variant);
        if (params.length > 0) result.push({
            type: 'dynamic',
            params: params,
            regexp: (0, $8cfcdd83addb9a5f$export$238374f1b270e387)(variant, {
                separator: '.',
                ignoreCase: false
            })
        });
        else result.push({
            type: 'static',
            value: $141be13c0b714baa$var$stringifyStatic(variant, '.')
        });
    }
    return result;
}
function $141be13c0b714baa$var$stringifyStatic(variant, separator) {
    let result = '';
    for (let token of variant){
        if (token.type === 'text') result += token.text;
        else if (token.type === 'separator') result += separator;
        else throw new Error(`expected static part variant, got token type '${token.type}'`);
    }
    return result;
}
function $141be13c0b714baa$var$generatePathnameVariants(pathname, options) {
    let result = [];
    let ignoreCase = options?.ignoreCase ?? false;
    for (let tokens of $141be13c0b714baa$export$57a1d23d0b7a46c(pathname)){
        let variant = [];
        let key = '';
        let reSource = '';
        let reFlags = ignoreCase ? 'di' : 'd';
        let type = 'static';
        let params = [];
        for (let token of tokens){
            if (token.type === 'separator') {
                if (type === 'static') {
                    variant.push({
                        type: 'static',
                        key: ignoreCase ? key.toLowerCase() : key
                    });
                    key = '';
                    reSource = '';
                    continue;
                }
                if (type === 'variable') {
                    variant.push({
                        type: 'variable',
                        key: key,
                        regexp: new RegExp(`^${reSource}$`, reFlags),
                        params: params
                    });
                    key = '';
                    reSource = '';
                    params = [];
                    type = 'static';
                    continue;
                }
                if (type === 'wildcard') {
                    key += '/';
                    reSource += (0, $8cfcdd83addb9a5f$export$4e7f196112fea3c5)('/');
                    continue;
                }
                (0, $66f718c575951cb2$export$565e9d9bd6b6e0d4)(type);
            }
            if (token.type === 'text') {
                // Encode to comply with URL pathname normalization in trie matcher
                let text = encodeURIComponent(token.text);
                key += text;
                reSource += (0, $8cfcdd83addb9a5f$export$4e7f196112fea3c5)(text);
                continue;
            }
            if (token.type === ':') {
                key += '{:}';
                reSource += `([^/]+)`;
                params.push(token);
                if (type === 'static') type = 'variable';
                continue;
            }
            if (token.type === '*') {
                key += '{*}';
                reSource += `(.*)`;
                params.push(token);
                type = 'wildcard';
                continue;
            }
            (0, $66f718c575951cb2$export$565e9d9bd6b6e0d4)(token.type);
        }
        if (type === 'static') variant.push({
            type: 'static',
            key: ignoreCase ? key.toLowerCase() : key
        });
        if (type === 'variable' || type === 'wildcard') variant.push({
            type: type,
            key: key,
            regexp: new RegExp(`^${reSource}$`, reFlags),
            params: params
        });
        result.push(variant);
    }
    return result;
}
function $141be13c0b714baa$export$57a1d23d0b7a46c(part) {
    let result = [];
    let stack = [
        {
            index: 0,
            tokens: []
        }
    ];
    while(stack.length > 0){
        let { index: index, tokens: tokens } = stack.pop();
        if (index === part.tokens.length) {
            result.push(tokens);
            continue;
        }
        let token = part.tokens[index];
        if (token.type === '(') {
            stack.push({
                index: index + 1,
                tokens: tokens
            }, {
                index: part.optionals.get(index) + 1,
                tokens: tokens.slice()
            });
            continue;
        }
        if (token.type === ')') {
            stack.push({
                index: index + 1,
                tokens: tokens
            });
            continue;
        }
        if (token.type === ':' || token.type === '*' || token.type === 'text' || token.type === 'separator') {
            tokens.push(token);
            stack.push({
                index: index + 1,
                tokens: tokens
            });
            continue;
        }
        (0, $66f718c575951cb2$export$565e9d9bd6b6e0d4)(token.type);
    }
    return result;
}



class $a4c308cc4c8c7934$export$73571c50d0f2507e {
    ignoreCase;
    #root;
    constructor(options){
        this.ignoreCase = options?.ignoreCase ?? false;
        this.#root = {
            http: $a4c308cc4c8c7934$var$createHostnameNode(),
            https: $a4c308cc4c8c7934$var$createHostnameNode()
        };
    }
    insert(pattern, data) {
        for (let variant of (0, $141be13c0b714baa$export$9ac16898ad61bc17)(pattern)){
            let hostnameNode = this.#root[variant.protocol];
            let portNode;
            if (variant.hostname.type === 'any') portNode = hostnameNode.any;
            else if (variant.hostname.type === 'static') {
                let key = variant.hostname.value.toLowerCase();
                let existing = hostnameNode.static.get(key);
                if (existing === undefined) {
                    existing = new Map();
                    hostnameNode.static.set(key, existing);
                }
                portNode = existing;
            } else {
                portNode = new Map();
                hostnameNode.dynamic.push({
                    regexp: variant.hostname.regexp,
                    params: variant.hostname.params,
                    portNode: portNode
                });
            }
            let pathnameRoot = portNode.get(variant.port);
            if (pathnameRoot === undefined) {
                pathnameRoot = $a4c308cc4c8c7934$var$createPathnameNode();
                portNode.set(variant.port, pathnameRoot);
            }
            let pathnameNode = pathnameRoot;
            for (let segment of variant.pathname){
                if (segment.type === 'static') {
                    let key = this.ignoreCase ? segment.key.toLowerCase() : segment.key;
                    let next = pathnameNode.static.get(key);
                    if (next === undefined) {
                        next = $a4c308cc4c8c7934$var$createPathnameNode();
                        pathnameNode.static.set(key, next);
                    }
                    pathnameNode = next;
                    continue;
                }
                if (segment.type === 'variable') {
                    let next = pathnameNode.variable.get(segment.key);
                    if (next === undefined) {
                        next = {
                            regexp: segment.regexp,
                            pathnameNode: $a4c308cc4c8c7934$var$createPathnameNode()
                        };
                        pathnameNode.variable.set(segment.key, next);
                    }
                    pathnameNode = next.pathnameNode;
                    continue;
                }
                if (segment.type === 'wildcard') {
                    let next = pathnameNode.wildcard.get(segment.key);
                    if (next === undefined) {
                        next = {
                            regexp: segment.regexp,
                            pathnameNode: $a4c308cc4c8c7934$var$createPathnameNode()
                        };
                        pathnameNode.wildcard.set(segment.key, next);
                    }
                    pathnameNode = next.pathnameNode;
                    continue;
                }
                (0, $66f718c575951cb2$export$565e9d9bd6b6e0d4)(segment);
            }
            let requiredParams = [];
            for (let segment of variant.pathname){
                if (segment.type === 'variable' || segment.type === 'wildcard') for (let param of segment.params)requiredParams.push(param);
            }
            let undefinedParams = [];
            for (let param of pattern.pathname.tokens){
                if (param.type !== ':' && param.type !== '*') continue;
                if (requiredParams.some((p)=>p.name === param.name)) continue;
                if (undefinedParams.some((p)=>p.name === param.name)) continue;
                undefinedParams.push(param);
            }
            pathnameNode.values.push({
                pattern: pattern,
                data: data,
                requiredParams: requiredParams,
                undefinedParams: undefinedParams
            });
        }
    }
    search(url) {
        let protocol = url.protocol.slice(0, -1);
        if (protocol !== 'http' && protocol !== 'https') return [];
        let hostnameNode = this.#root[protocol];
        let decodedHostname = (0, $c5f56781b613b2fa$export$110c810e8727e62b)(url.hostname);
        let origins = [];
        // any hostname (no port allowed -- empty-port key)
        let anyPathname = hostnameNode.any.get('');
        if (anyPathname) origins.push({
            hostnameMatch: [
                {
                    type: '*',
                    name: '*',
                    value: decodedHostname,
                    begin: 0,
                    end: decodedHostname.length
                }
            ],
            pathnameNode: anyPathname
        });
        // static hostname
        let staticPort = hostnameNode.static.get(decodedHostname.toLowerCase());
        if (staticPort) {
            let next = staticPort.get(url.port);
            if (next) origins.push({
                hostnameMatch: [],
                pathnameNode: next
            });
        }
        // dynamic hostnames
        for (let entry of hostnameNode.dynamic){
            let m = entry.regexp.exec(decodedHostname);
            if (!m) continue;
            let next = entry.portNode.get(url.port);
            if (!next) continue;
            let hostnameMatch = [];
            for(let i = 0; i < entry.params.length; i++){
                let param = entry.params[i];
                let span = m.indices?.[i + 1];
                if (span === undefined) continue;
                hostnameMatch.push({
                    type: param.type,
                    name: param.name,
                    value: m[i + 1],
                    begin: span[0],
                    end: span[1]
                });
            }
            origins.push({
                hostnameMatch: hostnameMatch,
                pathnameNode: next
            });
        }
        let results = [];
        let urlSegments = $a4c308cc4c8c7934$var$normalizePathname(url.pathname);
        if (urlSegments === null) return results;
        for (let origin of origins){
            let stack = [
                {
                    segmentIndex: 0,
                    pathnameNode: origin.pathnameNode,
                    charOffset: 0,
                    captures: []
                }
            ];
            while(stack.length > 0){
                let current = stack.pop();
                if (current.segmentIndex === urlSegments.length) {
                    for (let value of current.pathnameNode.values){
                        if (!$a4c308cc4c8c7934$var$matchSearch(url.searchParams, value.pattern.search)) continue;
                        let pathnameMatch = [];
                        for(let i = 0; i < value.requiredParams.length; i++){
                            let param = value.requiredParams[i];
                            let cap = current.captures[i];
                            pathnameMatch.push({
                                type: param.type,
                                name: param.name,
                                value: $a4c308cc4c8c7934$var$fastDecodeURIComponent(cap.value),
                                begin: cap.begin,
                                end: cap.end
                            });
                        }
                        let params = {};
                        for (let token of value.pattern.hostname?.tokens ?? [])if ((token.type === ':' || token.type === '*') && token.name !== '*') params[token.name] = undefined;
                        for (let token of value.pattern.pathname.tokens)if ((token.type === ':' || token.type === '*') && token.name !== '*') params[token.name] = undefined;
                        for (let p of origin.hostnameMatch){
                            if (p.name === '*') continue;
                            params[p.name] = p.value;
                        }
                        for (let p of pathnameMatch){
                            if (p.name === '*') continue;
                            params[p.name] = p.value;
                        }
                        results.push({
                            url: url,
                            pattern: value.pattern,
                            data: value.data,
                            params: params,
                            paramsMeta: {
                                hostname: origin.hostnameMatch,
                                pathname: pathnameMatch
                            }
                        });
                    }
                    continue;
                }
                let urlSegment = urlSegments[current.segmentIndex];
                let staticKey = this.ignoreCase ? urlSegment.toLowerCase() : urlSegment;
                let nextStatic = current.pathnameNode.static.get(staticKey);
                if (nextStatic) stack.push({
                    segmentIndex: current.segmentIndex + 1,
                    pathnameNode: nextStatic,
                    charOffset: current.charOffset + urlSegment.length + 1,
                    captures: current.captures
                });
                for (let { regexp: regexp, pathnameNode: pathnameNode } of current.pathnameNode.variable.values()){
                    let m = regexp.exec(urlSegment);
                    if (!m) continue;
                    let captures = current.captures.slice();
                    for(let i = 1; i < m.indices.length; i++){
                        let span = m.indices[i];
                        if (span === undefined) (0, $66f718c575951cb2$export$565e9d9bd6b6e0d4)();
                        captures.push({
                            value: m[i],
                            begin: current.charOffset + span[0],
                            end: current.charOffset + span[1]
                        });
                    }
                    stack.push({
                        segmentIndex: current.segmentIndex + 1,
                        pathnameNode: pathnameNode,
                        charOffset: current.charOffset + m.index + m[0].length + 1,
                        captures: captures
                    });
                }
                for (let { regexp: regexp, pathnameNode: pathnameNode } of current.pathnameNode.wildcard.values()){
                    let remaining = urlSegments.slice(current.segmentIndex).join('/');
                    let m = regexp.exec(remaining);
                    if (!m) continue;
                    let captures = current.captures.slice();
                    for(let i = 1; i < m.indices.length; i++){
                        let span = m.indices[i];
                        if (span === undefined) continue;
                        captures.push({
                            value: m[i],
                            begin: current.charOffset + span[0],
                            end: current.charOffset + span[1]
                        });
                    }
                    stack.push({
                        segmentIndex: urlSegments.length,
                        pathnameNode: pathnameNode,
                        charOffset: current.charOffset + remaining.length,
                        captures: captures
                    });
                }
            }
        }
        return results;
    }
}
// Pathname codec ----------------------------------------------------------------------------------
// Pathname matching uses canonical percent-encoded text. URL pathnames are split on structural
// "/" before normalization so encoded slashes like "%2F" remain data within a segment instead of
// becoming separators. Pattern static text is encoded the same way when variants are generated.
function $a4c308cc4c8c7934$var$normalizePathname(pathname) {
    let segments = [];
    for (let segment of pathname.slice(1).split('/')){
        let normalized = $a4c308cc4c8c7934$var$normalizePathnameText(segment);
        if (normalized === null) return null;
        segments.push(normalized);
    }
    return segments;
}
function $a4c308cc4c8c7934$var$normalizePathnameText(text) {
    let decoded = $a4c308cc4c8c7934$var$safeDecodeURIComponent(text);
    return decoded === null ? null : encodeURIComponent(decoded);
}
function $a4c308cc4c8c7934$var$fastDecodeURIComponent(text) {
    return text.includes('%') ? decodeURIComponent(text) : text;
}
function $a4c308cc4c8c7934$var$safeDecodeURIComponent(text) {
    try {
        return $a4c308cc4c8c7934$var$fastDecodeURIComponent(text);
    } catch (error) {
        if (error instanceof URIError) return null;
        throw error;
    }
}
// Search ------------------------------------------------------------------------------------------
function $a4c308cc4c8c7934$var$matchSearch(params, constraints) {
    for (let [name, requiredValues] of constraints){
        if (requiredValues.size === 0) {
            if (!params.has(name)) return false;
            continue;
        }
        let values = params.getAll(name);
        for (let requiredValue of requiredValues){
            if (!values.includes(requiredValue)) return false;
        }
    }
    return true;
}
function $a4c308cc4c8c7934$var$createHostnameNode() {
    return {
        static: new Map(),
        dynamic: [],
        any: new Map()
    };
}
function $a4c308cc4c8c7934$var$createPathnameNode() {
    return {
        static: new Map(),
        variable: new Map(),
        wildcard: new Map(),
        values: []
    };
}



function $a5378e78742f1691$export$9b050841a3a1b328(a, b) {
    return $a5378e78742f1691$export$398604a469f7de9a(a, b) === -1;
}
function $a5378e78742f1691$export$f517ea36c68d4644(a, b) {
    return $a5378e78742f1691$export$398604a469f7de9a(a, b) === 1;
}
function $a5378e78742f1691$export$411ce8e5a71e3069(a, b) {
    return $a5378e78742f1691$export$398604a469f7de9a(a, b) === 0;
}
const $a5378e78742f1691$export$fcb633242ef15540 = (a, b)=>$a5378e78742f1691$export$398604a469f7de9a(a, b);
const $a5378e78742f1691$export$4fa3190a997c3d8f = (a, b)=>$a5378e78742f1691$export$398604a469f7de9a(a, b) * -1;
function $a5378e78742f1691$export$398604a469f7de9a(a, b) {
    if (a.url.href !== b.url.href) throw new Error(`Cannot compare matches for different URLs: ${a.url.href} vs ${b.url.href}`);
    let hostname = (0, $c5f56781b613b2fa$export$110c810e8727e62b)(a.url.hostname);
    let hostnameResult = $a5378e78742f1691$var$compareHostname(hostname, a.paramsMeta.hostname, b.paramsMeta.hostname);
    if (hostnameResult !== 0) return hostnameResult;
    let pathnameResult = $a5378e78742f1691$var$comparePathname(a.paramsMeta.pathname, b.paramsMeta.pathname);
    if (pathnameResult !== 0) return pathnameResult;
    let searchResult = $a5378e78742f1691$var$compareSearch(a.pattern.search, b.pattern.search);
    if (searchResult !== 0) return searchResult;
    return 0;
}
function $a5378e78742f1691$var$compareHostname(hostname, a, b) {
    if (a.length === 0 && b.length === 0) return 0;
    if (a.length === 0 && b.length > 0) return 1;
    if (a.length > 0 && b.length === 0) return -1;
    // Encoding of hostname chars: 0 = static, 1 = variable (:), 2 = wildcard (*)
    // Note: `Int8Array` defaults to 0 for all indices not explicitly set.
    let aEncoding = new Int8Array(hostname.length);
    for (let range of a)aEncoding.fill(range.type === ':' ? 1 : 2, range.begin, range.end);
    let bEncoding = new Int8Array(hostname.length);
    for (let range of b)bEncoding.fill(range.type === ':' ? 1 : 2, range.begin, range.end);
    // Build segments right-to-left: desc order by begin
    let segments = [];
    let end = hostname.length;
    for(let i = hostname.length - 1; i >= 0; i--)if (hostname[i] === '.') {
        segments.push({
            begin: i + 1,
            end: end
        });
        end = i;
    }
    segments.push({
        begin: 0,
        end: end
    }); // leftmost segment
    for (let segment of segments)for(let j = segment.begin; j < segment.end; j++){
        if (aEncoding[j] < bEncoding[j]) return 1; // a is more specific
        if (aEncoding[j] > bEncoding[j]) return -1; // b is more specific
    }
    return 0;
}
function $a5378e78742f1691$var$comparePathname(a, b) {
    if (a.length === 0 && b.length === 0) return 0;
    if (a.length === 0 && b.length > 0) return 1;
    if (a.length > 0 && b.length === 0) return -1;
    let i = 0;
    let aIndex = 0;
    let bIndex = 0;
    while(aIndex < a.length || bIndex < b.length){
        let aRange = a[aIndex];
        let bRange = b[bIndex];
        if (aRange === undefined) return 1; // a is fully static from here
        if (bRange === undefined) return -1; // b is fully static from here
        // Skip to the minimum begin of the two current ranges
        i = Math.min(aRange.begin, bRange.begin);
        if (i < aRange.begin) return 1; // a has static content at i
        if (i < bRange.begin) return -1; // b has static content at i
        if (aRange.type === ':' && bRange.type === '*') return 1; // a is more specific
        if (aRange.type === '*' && bRange.type === ':') return -1; // b is more specific
        let minEnd = Math.min(aRange.end, bRange.end);
        i = minEnd;
        // Advance range indices if we've reached their ends
        if (i >= aRange.end) aIndex += 1;
        if (i >= bRange.end) bIndex += 1;
    }
    return 0;
}
function $a5378e78742f1691$var$compareSearch(a, b) {
    let aSpecificity = $a5378e78742f1691$var$searchSpecificity(a);
    let bSpecificity = $a5378e78742f1691$var$searchSpecificity(b);
    if (aSpecificity.keyValue > bSpecificity.keyValue) return 1;
    if (aSpecificity.keyValue < bSpecificity.keyValue) return -1;
    if (aSpecificity.key > bSpecificity.key) return 1;
    if (aSpecificity.key < bSpecificity.key) return -1;
    return 0;
}
function $a5378e78742f1691$var$searchSpecificity(constraints) {
    let specificity = {
        key: 0,
        keyValue: 0
    };
    for (let constraint of constraints.values()){
        if (constraint.size === 0) {
            specificity.key += 1;
            continue;
        }
        specificity.keyValue += constraint.size;
    }
    return specificity;
}


function $ecd1e795eb3e2a5b$export$1d94974cf1366deb(pattern, options) {
    pattern = typeof pattern === 'string' ? (0, $c80bce60b563fbfc$export$2917961db0dd6e8b).parse(pattern) : pattern;
    let matcher = $ecd1e795eb3e2a5b$export$cf760d085d57ec27(options);
    matcher.add(pattern, undefined);
    return {
        match (url) {
            return matcher.match(url);
        }
    };
}
function $ecd1e795eb3e2a5b$export$cf760d085d57ec27(options) {
    return new $ecd1e795eb3e2a5b$var$TrieMatcher(options);
}
class $ecd1e795eb3e2a5b$var$TrieMatcher {
    ignoreCase;
    #trie;
    constructor(options){
        this.ignoreCase = options?.ignoreCase ?? false;
        this.#trie = new (0, $a4c308cc4c8c7934$export$73571c50d0f2507e)({
            ignoreCase: this.ignoreCase
        });
    }
    add(pattern, data) {
        pattern = typeof pattern === 'string' ? (0, $2e5715da18450ef9$export$e26190e3669abbfe)(pattern) : pattern;
        this.#trie.insert(pattern, data);
    }
    match(url) {
        let parsedUrl = typeof url === 'string' ? new URL(url) : url;
        let best = null;
        for (let match of this.#trie.search(parsedUrl))if (best === null || $a5378e78742f1691$export$f517ea36c68d4644(match, best)) best = match;
        return best;
    }
    matchAll(url) {
        let parsedUrl = typeof url === 'string' ? new URL(url) : url;
        let matches = [];
        for (let match of this.#trie.search(parsedUrl))matches.push(match);
        return matches.sort($a5378e78742f1691$export$4fa3190a997c3d8f);
    }
}







//#region lib/router/matcher-route-pattern.ts
var $1261a13b3d1e0513$export$9f42f7e9b7c469cc = class {
    #state;
    #basename;
    constructor(basename){
        this.#basename = basename;
    }
    update(routes) {
        let branches = $1261a13b3d1e0513$var$flattenRoutes(routes);
        let matcher = (0, $ecd1e795eb3e2a5b$export$cf760d085d57ec27)({
            ignoreCase: true
        });
        let partialMatcher = (0, $ecd1e795eb3e2a5b$export$cf760d085d57ec27)({
            ignoreCase: true
        });
        for (let branch of branches){
            let routePattern = $1261a13b3d1e0513$var$convertReactRouterPathToRoutePattern(branch.path);
            $1261a13b3d1e0513$var$validateRoutePatternSplat(branch.path, routePattern);
            routePattern = $1261a13b3d1e0513$var$addOptionalTrailingSlash(routePattern);
            matcher.add(routePattern, branch);
            if (!branch.routesMeta[branch.routesMeta.length - 1].route.index) partialMatcher.add(routePattern === "/" ? `/*__rr_partial` : `${routePattern}(/*__rr_partial)`, branch);
        }
        this.#state = {
            branches: branches,
            matcher: matcher,
            partialMatcher: partialMatcher
        };
        return branches;
    }
    match(locationArg, allowPartial = false) {
        let pathname = (0, $71ae0bb7947fe91a$export$b69e3301ce081aa3)((typeof locationArg === "string" ? (0, $573a89bde77cb3ae$export$8ccf933b0513f8d0)(locationArg) : locationArg).pathname || "/", this.#basename);
        if (pathname == null) return null;
        let decoded = (0, $71ae0bb7947fe91a$export$cd27bea214d030c2)(pathname);
        let url = new URL("http://reactrouter.local");
        url.pathname = pathname.endsWith("/") ? pathname : `${pathname}/`;
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(this.#state, "Route pattern routes must be initialized before matching.");
        let matches = this.#state.matcher.matchAll(url);
        if (allowPartial) matches.push(...this.#state.partialMatcher.matchAll(url));
        for (let match of $1261a13b3d1e0513$var$prioritizeValidatedMatches(matches)){
            let routeMatches = $1261a13b3d1e0513$var$convertRoutePatternMatchToRouteMatches(match, decoded, allowPartial);
            if (routeMatches && $1261a13b3d1e0513$var$validateRouteMatchParams(routeMatches)) return routeMatches;
        }
        return null;
    }
};
function $1261a13b3d1e0513$var$validateRoutePatternSplat(routePath, routePattern) {
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)($1261a13b3d1e0513$var$getRoutePatternSplatIndexes(routePattern).length <= 1 && $1261a13b3d1e0513$var$isTerminalRoutePatternSplat(routePattern), `Route path "${routePath}" is not supported with \`future.unstable_routePatternMatching\` because React Router only supports a single splat at the end of a route path.`);
}
function $1261a13b3d1e0513$var$getRoutePatternSplatIndexes(routePattern) {
    let splatIndexes = [];
    for(let i = 0; i < routePattern.length; i++){
        let char = routePattern[i];
        if (char === "\\") {
            i++;
            continue;
        }
        if (char === "*") splatIndexes.push(i);
    }
    return splatIndexes;
}
function $1261a13b3d1e0513$var$isTerminalRoutePatternSplat(routePattern) {
    for(let i = 0; i < routePattern.length; i++){
        let char = routePattern[i];
        if (char === "\\") {
            i++;
            continue;
        }
        if (char !== "*") continue;
        let suffix = routePattern.slice(i + 1);
        return /^[a-zA-Z_$][a-zA-Z_$0-9]*$/.test(suffix) || suffix === "";
    }
    return true;
}
function $1261a13b3d1e0513$var$addOptionalTrailingSlash(routePattern) {
    return routePattern === "/" ? routePattern : `${routePattern.replace(/\/+$/, "")}(/)`;
}
function $1261a13b3d1e0513$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    routes.forEach((route, index)=>{
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(route.caseSensitive !== true, "`caseSensitive` routes are not supported with `future.unstable_routePatternMatching`.");
        let meta = {
            relativePath: route.path || "",
            caseSensitive: false,
            childrenIndex: index,
            route: route
        };
        let absolutePath;
        if (meta.relativePath.startsWith("/")) {
            absolutePath = meta.relativePath;
            let parentPathMatch = (0, $71ae0bb7947fe91a$export$82472424e06ad5c9)(parentPath).find((path)=>meta.relativePath.startsWith(path));
            (0, $573a89bde77cb3ae$export$f5708dca728d7177)(parentPathMatch != null, `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPathMatch.length);
        }
        let routesMeta = parentsMeta.concat(meta);
        let path = absolutePath ?? (meta.relativePath ? (0, $71ae0bb7947fe91a$export$86d9a7913e44197e)([
            parentPath,
            meta.relativePath
        ]) : parentPath);
        if (route.children && route.children.length > 0) {
            (0, $573a89bde77cb3ae$export$f5708dca728d7177)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $1261a13b3d1e0513$var$flattenRoutes(route.children, branches, routesMeta, path);
            if (route.children?.some((child)=>child.index)) return;
        }
        if (route.path != null || route.index) branches.push({
            path: path,
            score: 0,
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $1261a13b3d1e0513$var$convertReactRouterPathToRoutePattern(path) {
    (0, $573a89bde77cb3ae$export$491112666e282270)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) path = path.replace(/\*$/, "/*");
    path = path.replace(/^\/*/, "/");
    if (path === "") return "/";
    let segments = path.split("/");
    let pattern = segments.shift() || "";
    for(let i = 0; i < segments.length;){
        let optionalRun = [];
        while(i < segments.length && $1261a13b3d1e0513$var$isOptionalRouteSegment(segments[i])){
            optionalRun.push($1261a13b3d1e0513$var$convertRouteSegment(segments[i].slice(0, -1)));
            i++;
        }
        if (optionalRun.length > 0) {
            let nested = optionalRun.reduceRight((child, segment)=>`/${segment}${child ? `(${child})` : ""}`, "");
            pattern += `(${nested})`;
            continue;
        }
        pattern += `/${$1261a13b3d1e0513$var$convertRouteSegment(segments[i])}`;
        i++;
    }
    return pattern || "/";
}
function $1261a13b3d1e0513$var$isOptionalRouteSegment(segment) {
    return segment.endsWith("?");
}
function $1261a13b3d1e0513$var$convertRouteSegment(segment) {
    if (segment === "*") return "*__rr_splat";
    let paramMatch = segment.match(/^:([\w-]+)(\?)?(.*)$/);
    if (paramMatch) {
        let [, paramName, optional, suffix] = paramMatch;
        let converted = `:${paramName}${$1261a13b3d1e0513$var$escapeRoutePatternLiteral(suffix)}`;
        return optional ? `(:${paramName})${$1261a13b3d1e0513$var$escapeRoutePatternLiteral(suffix)}` : converted;
    }
    return $1261a13b3d1e0513$var$escapeRoutePatternLiteral(segment);
}
function $1261a13b3d1e0513$var$escapeRoutePatternLiteral(value) {
    return value.replace(/[\\():*]/g, "\\$&");
}
function $1261a13b3d1e0513$var$validateRouteMatchParams(matches) {
    return matches.every(({ route: route, params: params })=>route.unstable_validateParams == null || Object.keys(route.unstable_validateParams).length === 0 || Object.entries(route.unstable_validateParams).every(([param, re])=>params[param] != null ? new RegExp(re.source, re.flags).test(params[param]) : true));
}
function $1261a13b3d1e0513$var$prioritizeValidatedMatches(matches) {
    return matches.sort((a, b)=>{
        let specificity = (0, $a5378e78742f1691$export$4fa3190a997c3d8f)(a, b);
        if (specificity !== 0) return specificity;
        return Number($1261a13b3d1e0513$var$hasParamValidators(b)) - Number($1261a13b3d1e0513$var$hasParamValidators(a));
    });
}
function $1261a13b3d1e0513$var$hasParamValidators(match) {
    return match.data.routesMeta.some((meta)=>meta.route.unstable_validateParams != null && Object.keys(meta.route.unstable_validateParams).length > 0);
}
function $1261a13b3d1e0513$var$convertRoutePatternMatchToRouteMatches(match, pathname, allowPartial) {
    let result = $1261a13b3d1e0513$var$matchRoutePatternBranch(match.data, pathname, allowPartial, 0, "/", {});
    if (result == null) return null;
    for (let routeMatch of result.matches)routeMatch.params = result.params;
    return result.matches;
}
function $1261a13b3d1e0513$var$matchRoutePatternBranch(branch, pathname, allowPartial, metaIndex, matchedPathname, matchedParams) {
    let meta = branch.routesMeta[metaIndex];
    let end = metaIndex === branch.routesMeta.length - 1;
    let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
    for (let relativePath of (0, $71ae0bb7947fe91a$export$82472424e06ad5c9)(meta.relativePath)){
        let pattern = {
            path: relativePath,
            caseSensitive: false,
            end: end
        };
        let pathMatch = (0, $71ae0bb7947fe91a$export$81336c211d5ff295)(pattern, remainingPathname);
        if (!pathMatch && end && allowPartial && !meta.route.index) pathMatch = (0, $71ae0bb7947fe91a$export$81336c211d5ff295)({
            ...pattern,
            end: false
        }, remainingPathname);
        if (!pathMatch) continue;
        let params = {
            ...matchedParams,
            ...pathMatch.params
        };
        let routeMatch = {
            params: params,
            pathname: (0, $71ae0bb7947fe91a$export$86d9a7913e44197e)([
                matchedPathname,
                pathMatch.pathname
            ]),
            pathnameBase: (0, $71ae0bb7947fe91a$export$a5c6d149b50c1d86)((0, $71ae0bb7947fe91a$export$86d9a7913e44197e)([
                matchedPathname,
                pathMatch.pathnameBase
            ])),
            route: meta.route
        };
        let nextMatchedPathname = pathMatch.pathnameBase === "/" ? matchedPathname : (0, $71ae0bb7947fe91a$export$86d9a7913e44197e)([
            matchedPathname,
            pathMatch.pathnameBase
        ]);
        if (end) return {
            matches: [
                routeMatch
            ],
            params: params
        };
        let childResult = $1261a13b3d1e0513$var$matchRoutePatternBranch(branch, pathname, allowPartial, metaIndex + 1, nextMatchedPathname, params);
        if (childResult) return {
            matches: [
                routeMatch,
                ...childResult.matches
            ],
            params: childResult.params
        };
    }
    return null;
}


//#region lib/router/matcher-route-pattern.preload.ts
let $37360eb951365398$var$RoutePatternMatcher;
function $37360eb951365398$export$45cda2a841115322() {
    return $37360eb951365398$var$RoutePatternMatcher;
}
/**
* Initialize the route-pattern matcher before creating a Data Router or static
* handler with `future.unstable_routePatternMatching` enabled. Import from
* `react-router/route-pattern` and call this once during application startup.
* Server and browser applications must each preload their own matcher.
*
* The matcher is statically imported by this module. Tree-shaking bundlers can
* remove it from applications that do not use this function. Initialization is
* synchronous, and repeated calls are safe.
*
* @public
* @category Data Routers
* @mode data
* @returns {void}
*/ function $37360eb951365398$export$c6cb8c636109e21b() {
    $37360eb951365398$var$RoutePatternMatcher = (0, $1261a13b3d1e0513$export$9f42f7e9b7c469cc);
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/navigation.ts
const $474e8f43e2235ddf$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $474e8f43e2235ddf$export$1da545bc000055cf(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $474e8f43e2235ddf$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $474e8f43e2235ddf$var$DEFAULT_NAVIGATION_URL;
    }
}
function $474e8f43e2235ddf$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $474e8f43e2235ddf$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $474e8f43e2235ddf$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$474e8f43e2235ddf$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$474e8f43e2235ddf$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$474e8f43e2235ddf$var$isExplicitUrl(original, originalUrl) || !$474e8f43e2235ddf$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}


//#region lib/router/router.ts
const $e9436205c8a93fd8$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
const $e9436205c8a93fd8$var$validMutationMethods = new Set($e9436205c8a93fd8$var$validMutationMethodsArr);
const $e9436205c8a93fd8$var$validRequestMethodsArr = [
    "GET",
    ...$e9436205c8a93fd8$var$validMutationMethodsArr
];
const $e9436205c8a93fd8$var$validRequestMethods = new Set($e9436205c8a93fd8$var$validRequestMethodsArr);
const $e9436205c8a93fd8$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $e9436205c8a93fd8$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $e9436205c8a93fd8$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $e9436205c8a93fd8$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $e9436205c8a93fd8$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
const $e9436205c8a93fd8$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
const $e9436205c8a93fd8$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $e9436205c8a93fd8$export$5e64b3b9d7e2ec36(future, basename) {
    if (future.unstable_routePatternMatching) {
        let RoutePatternMatcher = (0, $37360eb951365398$export$45cda2a841115322)();
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(RoutePatternMatcher, "You must call unstable_preloadRoutePattern() from \"react-router/route-pattern\" before enabling future.unstable_routePatternMatching.");
        return new RoutePatternMatcher(basename);
    }
    return new (0, $3c2ef84a5d00df40$export$92541312f2982378)(basename);
}
/**
* Encapsulates the stable and in-flight route trees together with their
* pre-computed branch caches so the structures always stay in sync.
*/ var $e9436205c8a93fd8$var$DataRoutes = class {
    #routes;
    #hmrRoutes;
    #matcher;
    constructor(routes, matcher){
        this.#routes = routes;
        this.#matcher = matcher;
        this.#matcher.update(routes);
    }
    /** The stable route tree */ get stableRoutes() {
        return this.#routes;
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return this.#hmrRoutes ?? this.#routes;
    }
    get hasHMRRoutes() {
        return this.#hmrRoutes != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        this.#routes = routes;
        if (!this.#hmrRoutes) this.#matcher.update(routes);
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        this.#hmrRoutes = routes;
        this.#matcher.update(routes);
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if (this.#hmrRoutes) {
            this.#routes = this.#hmrRoutes;
            this.#hmrRoutes = void 0;
            this.#matcher.update(this.#routes);
        }
    }
};
/**
* Create a router and listen to history POP navigations
*/ function $e9436205c8a93fd8$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $cf5f77708a26e901$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let future = {
        ...init.future
    };
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataRouteMatcher = $e9436205c8a93fd8$export$5e64b3b9d7e2ec36(future, basename);
    let manifest = {};
    let dataRoutes = new $e9436205c8a93fd8$var$DataRoutes((0, $71ae0bb7947fe91a$export$87cb1a9238dc3fba)(init.routes, mapRouteProperties, void 0, manifest), dataRouteMatcher);
    let dataStrategyImpl = init.dataStrategy || $e9436205c8a93fd8$var$defaultDataStrategyWithMiddleware;
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions = null;
    let getScrollRestorationKey = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = dataRouteMatcher.match(init.history.location);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $e9436205c8a93fd8$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $e9436205c8a93fd8$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            if (checkFogOfWar(initialMatches, init.history.location.pathname).active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$e9436205c8a93fd8$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $e9436205c8a93fd8$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $e9436205c8a93fd8$export$ed3e14b2f9e105d0,
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP";
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            (0, $573a89bde77cb3ae$export$491112666e282270)(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $e9436205c8a93fd8$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            $e9436205c8a93fd8$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$e9436205c8a93fd8$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP", state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $e9436205c8a93fd8$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $e9436205c8a93fd8$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0 && !isUninterruptedRevalidation) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $e9436205c8a93fd8$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $e9436205c8a93fd8$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP") ;
        else if (pendingAction === "PUSH") init.history.push(location, location.state);
        else if (pendingAction === "REPLACE") init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $e9436205c8a93fd8$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP";
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $e9436205c8a93fd8$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let instrumentationNavigateMetaReceiver = (0, $cf5f77708a26e901$export$5579798e35f5560e)(router);
        let { path: path, submission: submission, error: error } = $e9436205c8a93fd8$var$normalizeNavigateOptions(false, $e9436205c8a93fd8$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative), opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? (0, $573a89bde77cb3ae$export$8ccf933b0513f8d0)(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ((0, $38b29aefca9c076c$export$825a82322d91916e).test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            (0, $474e8f43e2235ddf$export$6c8e41f66e7aa990)(typeof opts.mask === "string" ? opts.mask : (0, $573a89bde77cb3ae$export$fe53371bee54353d)(opts.mask), (0, $573a89bde77cb3ae$export$fe53371bee54353d)(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = (0, $573a89bde77cb3ae$export$90c043f1c57770b8)(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        (0, $474e8f43e2235ddf$export$6c8e41f66e7aa990)(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : (0, $573a89bde77cb3ae$export$fe53371bee54353d)(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH";
        if (userReplace === true) historyAction = "REPLACE";
        else if (userReplace === false) ;
        else if (submission != null && $e9436205c8a93fd8$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE";
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $e9436205c8a93fd8$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate,
            instrumentationNavigateMetaReceiver: instrumentationNavigateMetaReceiver
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $e9436205c8a93fd8$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? state.matches : dataRouteMatcher.match(location);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $e9436205c8a93fd8$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $e9436205c8a93fd8$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (opts?.instrumentationNavigateMetaReceiver) {
            let meta = $e9436205c8a93fd8$var$getInstrumentationNavigateMeta(init.history, location, matches);
            opts.instrumentationNavigateMetaReceiver(meta);
        }
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $e9436205c8a93fd8$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new (0, $71ae0bb7947fe91a$export$b8d3e69d4b3eff04)();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $e9436205c8a93fd8$var$findNearestBoundary(matches).route.id,
            {
                type: "error",
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $e9436205c8a93fd8$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($e9436205c8a93fd8$var$isErrorResult(result) && (0, $71ae0bb7947fe91a$export$972111febbeef05b)(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $e9436205c8a93fd8$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $e9436205c8a93fd8$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$e9436205c8a93fd8$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        updateState({
            navigation: $e9436205c8a93fd8$var$getSubmittingNavigation(location, matches, historyAction, submission)
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $e9436205c8a93fd8$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error",
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $e9436205c8a93fd8$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error",
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error",
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $e9436205c8a93fd8$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error",
            error: $e9436205c8a93fd8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy(request, location, $e9436205c8a93fd8$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties, scopedContext), scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($e9436205c8a93fd8$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else replace = $e9436205c8a93fd8$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history) === state.location.pathname + state.location.search;
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($e9436205c8a93fd8$var$isErrorResult(result)) {
            let boundaryMatch = $e9436205c8a93fd8$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH";
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $e9436205c8a93fd8$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $e9436205c8a93fd8$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $e9436205c8a93fd8$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $e9436205c8a93fd8$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $e9436205c8a93fd8$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers = new Map(state.fetchers);
            let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                errors: pendingActionResult && $e9436205c8a93fd8$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$e9436205c8a93fd8$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects ? {
                    fetchers: workingFetchers
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect = $e9436205c8a93fd8$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $e9436205c8a93fd8$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $e9436205c8a93fd8$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$e9436205c8a93fd8$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $e9436205c8a93fd8$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let instrumentationResultMetaReceiver = (0, $cf5f77708a26e901$export$5579798e35f5560e)(router);
        let normalizedPath = $e9436205c8a93fd8$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = dataRouteMatcher.match(normalizedPath);
        let fogOfWar = checkFogOfWar(matches, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (instrumentationResultMetaReceiver) instrumentationResultMetaReceiver($e9436205c8a93fd8$var$getInstrumentationNavigateMeta(init.history, normalizedPath, matches));
        if (!matches) {
            setFetcherError(key, routeId, $e9436205c8a93fd8$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $e9436205c8a93fd8$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new (0, $71ae0bb7947fe91a$export$b8d3e69d4b3eff04)();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $e9436205c8a93fd8$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        let loadMatch = {
            routeId: routeId,
            path: path,
            isDiscovering: fogOfWar.active
        };
        fetchLoadMatches.set(key, loadMatch);
        await handleFetcherLoader(key, loadMatch, matches, scopedContext, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        updateFetcherState(key, $e9436205c8a93fd8$var$getSubmittingFetcher(submission, state.fetchers.get(key)), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e9436205c8a93fd8$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e9436205c8a93fd8$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $e9436205c8a93fd8$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            setFetcherError(key, routeId, $e9436205c8a93fd8$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            }), {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $e9436205c8a93fd8$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match of fetchMatches)if (actionResults[match.route.id]) {
                actionResult = actionResults[match.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($e9436205c8a93fd8$var$isRedirectResult(actionResult) || $e9436205c8a93fd8$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $e9436205c8a93fd8$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($e9436205c8a93fd8$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $e9436205c8a93fd8$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $e9436205c8a93fd8$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($e9436205c8a93fd8$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $e9436205c8a93fd8$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let matches = state.navigation.state !== "idle" ? dataRouteMatcher.match(state.navigation.location) : state.matches;
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $e9436205c8a93fd8$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $e9436205c8a93fd8$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = workingFetchers.get(staleKey);
            let revalidatingFetcher = $e9436205c8a93fd8$var$getLoadingFetcher(void 0, existingFetcher ? existingFetcher.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) {
            if (fetchReloadIds.get(key) === loadId) fetchReloadIds.delete(key);
            return;
        }
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers = new Map(s.fetchers);
            workingFetchers.set(key, $e9436205c8a93fd8$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers
            };
        };
        let redirect = $e9436205c8a93fd8$var$findRedirect(loaderResults);
        if (redirect) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect = $e9436205c8a93fd8$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $e9436205c8a93fd8$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $e9436205c8a93fd8$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            (0, $573a89bde77cb3ae$export$f5708dca728d7177)(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $e9436205c8a93fd8$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, loadMatch, matches, scopedContext, flushSync, preventScrollReset, submission) {
        let { routeId: routeId, path: path } = loadMatch;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e9436205c8a93fd8$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e9436205c8a93fd8$var$createClientSideRequest(init.history, path, abortController.signal);
        if (loadMatch.isDiscovering) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e9436205c8a93fd8$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                loadMatch.isDiscovering = false;
            }
        }
        let match = $e9436205c8a93fd8$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy(fetchRequest, path, $e9436205c8a93fd8$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, matches, match, hydrationRouteProperties, scopedContext), scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match of matches)if (results[match.route.id]) {
                result = results[match.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $e9436205c8a93fd8$var$getDoneFetcher(void 0));
            return;
        }
        if ($e9436205c8a93fd8$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $e9436205c8a93fd8$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($e9436205c8a93fd8$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $e9436205c8a93fd8$var$getDoneFetcher(result.data));
    }
    /**
	* Utility function to handle redirects returned from an action or loader.
	* Normally, a redirect "replaces" the navigation that triggered it.  So, for
	* example:
	*
	*  - user is on /a
	*  - user clicks a link to /b
	*  - loader for /b redirects to /c
	*
	* In a non-JS app the browser would track the in-flight navigation to /b and
	* then replace it with /c when it encountered the redirect response.  In
	* the end it would only ever update the URL bar with /c.
	*
	* In client-side routing using pushState/replaceState, we aim to emulate
	* this behavior and we also do not update history until the end of the
	* navigation (including processed redirects).  This means that we never
	* actually touch history until we've processed redirects, so we just use
	* the history action from the original navigation (PUSH or REPLACE).
	*/ async function startRedirectNavigation(request, redirect, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $e9436205c8a93fd8$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        (0, $474e8f43e2235ddf$export$6c8e41f66e7aa990)(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = (0, $573a89bde77cb3ae$export$90c043f1c57770b8)(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ((0, $71ae0bb7947fe91a$export$a1cbf2de32a9fd1)(location)) {
                const url = (0, $573a89bde77cb3ae$export$e2450fce17852bf2)(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || (0, $71ae0bb7947fe91a$export$b69e3301ce081aa3)(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace === true || redirect.response.headers.has("X-Remix-Replace") ? "REPLACE" : "PUSH";
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $e9436205c8a93fd8$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($e9436205c8a93fd8$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $e9436205c8a93fd8$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else await startNavigation(redirectNavigationType, redirectLocation, {
            overrideNavigation: $e9436205c8a93fd8$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission),
            fetcherSubmission: fetcherSubmission,
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $e9436205c8a93fd8$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error",
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$e9436205c8a93fd8$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error") break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error",
                result: /* @__PURE__ */ new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($e9436205c8a93fd8$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect",
                response: $e9436205c8a93fd8$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $e9436205c8a93fd8$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let result = (await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key))[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error",
                    error: $e9436205c8a93fd8$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        return {
            loaderResults: await loaderResultsPromise,
            fetcherResults: (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {})
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $e9436205c8a93fd8$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $e9436205c8a93fd8$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $e9436205c8a93fd8$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            (0, $573a89bde77cb3ae$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $e9436205c8a93fd8$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            (0, $573a89bde77cb3ae$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            (0, $573a89bde77cb3ae$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $e9436205c8a93fd8$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $e9436205c8a93fd8$export$386d57f03f0b2883;
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) (0, $573a89bde77cb3ae$export$491112666e282270)(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $e9436205c8a93fd8$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $e9436205c8a93fd8$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        if (!initialScrollRestored && state.navigation === $e9436205c8a93fd8$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) return getScrollRestorationKey(location, matches.map((m)=>(0, $71ae0bb7947fe91a$export$fcf533780bf49ee2)(m, state.loaderData))) || location.key;
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) return {
                active: true,
                matches: dataRouteMatcher.match(pathname, true) || []
            };
            else if (Object.keys(matches[0].params).length > 0) return {
                active: true,
                matches: dataRouteMatcher.match(pathname, true)
            };
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $e9436205c8a93fd8$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = dataRouteMatcher.match(pathname);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = dataRouteMatcher.match(pathname, true);
                    if (!(newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length)))) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = dataRouteMatcher.match(pathname, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes((0, $71ae0bb7947fe91a$export$87cb1a9238dc3fba)(newRoutes, mapRouteProperties, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $e9436205c8a93fd8$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        match (locationArg) {
            return dataRouteMatcher.match(locationArg);
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = (0, $cf5f77708a26e901$export$ac4df491f31cbbfc)(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
/**
* Create a static handler to perform server-side data loading
*
* @example
* export async function handleRequest(request: Request) {
*   let { query, dataRoutes } = createStaticHandler(routes);
*   let context = await query(request);
*
*   if (context instanceof Response) {
*     return context;
*   }
*
*   let router = createStaticRouter(dataRoutes, context);
*   return new Response(
*     ReactDOMServer.renderToString(<StaticRouterProvider ... />),
*     { headers: { "Content-Type": "text/html" } }
*   );
* }
*
* @public
* @category Data Routers
* @mode data
* @param routes The {@link RouteObject | route objects} to create a static
* handler for
* @param opts Options
* @param opts.basename The base URL for the static handler (default: `/`)
* @param opts.future Future flags for the static handler
* @returns A static handler that can be used to query data for the provided
* routes
*/ function $e9436205c8a93fd8$export$3336b097a6fbc59a(routes, opts) {
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    let dataRouteMatcher = $e9436205c8a93fd8$export$5e64b3b9d7e2ec36({
        ...opts?.future
    }, basename);
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $cf5f77708a26e901$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = (0, $71ae0bb7947fe91a$export$87cb1a9238dc3fba)(routes, mapRouteProperties, void 0, manifest);
    dataRouteMatcher.update(dataRoutes);
    let match = (locationArg)=>dataRouteMatcher.match(locationArg);
    /**
	* The query() method is intended for document requests, in which we want to
	* call an optional action and potentially multiple loaders for all nested
	* routes.  It returns a StaticHandlerContext object, which is very similar
	* to the router state (location, loaderData, actionData, errors, etc.) and
	* also adds SSR-specific information such as the statusCode and headers
	* from action/loaders Responses.
	*
	* It _should_ never throw and should report all errors through the
	* returned handlerContext.errors object, properly associating errors to
	* their error boundary.  Additionally, it tracks _deepestRenderedBoundaryId
	* which can be used to emulate React error boundaries during SSR by performing
	* a second pass only down to the boundaryId.
	*
	* The one exception where we do not return a StaticHandlerContext is when a
	* redirect response is returned or thrown from any action/loader.  We
	* propagate that out and return the raw Response so the HTTP server can
	* return it directly.
	*
	* - `opts.requestContext` is an optional server context that will be passed
	*   to actions/loaders in the `context` parameter
	* - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
	*   the bubbling of errors which allows single-fetch-type implementations
	*   where the client will handle the bubbling and we may need to return data
	*   for the handling route
	*/ async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $e9436205c8a93fd8$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $573a89bde77cb3ae$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = dataRouteMatcher.match(location);
        requestContext = requestContext != null ? requestContext : new (0, $71ae0bb7947fe91a$export$b8d3e69d4b3eff04)();
        if (!$e9436205c8a93fd8$var$isValidMethod(method) && method !== "HEAD") {
            let error = $e9436205c8a93fd8$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $e9436205c8a93fd8$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                _match: match
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $e9436205c8a93fd8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $e9436205c8a93fd8$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                _match: match
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            (0, $573a89bde77cb3ae$export$f5708dca728d7177)(requestContext instanceof (0, $71ae0bb7947fe91a$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $e9436205c8a93fd8$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
                let renderedStaticContext;
                let response = await $e9436205c8a93fd8$var$runServerMiddlewarePipeline({
                    request: request,
                    url: (0, $71ae0bb7947fe91a$export$141d98e45b4b08e4)(request, location),
                    pattern: (0, $71ae0bb7947fe91a$export$d738435097971c09)(matches),
                    matches: matches,
                    params: matches[0].params,
                    context: requestContext
                }, async ()=>{
                    return await generateMiddlewareResponse(async (revalidationRequest, opts = {})=>{
                        let result = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts ? opts.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($e9436205c8a93fd8$export$3f1eb41d9a6a6a27(result)) return result;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result,
                            _match: match
                        };
                        return renderedStaticContext;
                    });
                }, async (error, routeId)=>{
                    if ($e9436205c8a93fd8$export$6e80290866a84dd4(error)) return error;
                    if ($e9436205c8a93fd8$export$3f1eb41d9a6a6a27(error)) try {
                        error = new (0, $71ae0bb7947fe91a$export$f2680fa305b734ca)(error.status, error.statusText, await $e9436205c8a93fd8$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($e9436205c8a93fd8$export$e0163cfdf7bc9cfa(error)) error = $e9436205c8a93fd8$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $e9436205c8a93fd8$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $e9436205c8a93fd8$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [skipLoaderErrorBubbling ? routeId : $e9436205c8a93fd8$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id]: error
                            },
                            statusCode: (0, $71ae0bb7947fe91a$export$972111febbeef05b)(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {},
                            _match: match
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                (0, $573a89bde77cb3ae$export$f5708dca728d7177)($e9436205c8a93fd8$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($e9436205c8a93fd8$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($e9436205c8a93fd8$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result,
            _match: match
        };
    }
    /**
	* The queryRoute() method is intended for targeted route requests, either
	* for fetch ?_data requests or resource route requests.  In this case, we
	* are only ever calling a single action or loader, and we are returning the
	* returned value directly.  In most cases, this will be a Response returned
	* from the action/loader, but it may be a primitive or other value as well -
	* and in such cases the calling context should handle that accordingly.
	*
	* We do respect the throw/return differentiation, so if an action/loader
	* throws, then this method will throw the value.  This is important so we
	* can do proper boundary identification in Remix where a thrown Response
	* must go to the Catch Boundary but a returned Response is happy-path.
	*
	* One thing to note is that any Router-initiated Errors that make sense
	* to associate with a status code will be thrown as an ErrorResponse
	* instance which include the raw Error, such that the calling context can
	* serialize the error as they see fit while including the proper response
	* code.  Examples here are 404 and 405 errors that occur prior to reaching
	* any user-defined loaders.
	*
	* - `opts.routeId` allows you to specify the specific route handler to call.
	*   If not provided the handler will determine the proper route by matching
	*   against `request.url`
	* - `opts.requestContext` is an optional server context that will be passed
	*    to actions/loaders in the `context` parameter
	*/ async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $e9436205c8a93fd8$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $573a89bde77cb3ae$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = dataRouteMatcher.match(location);
        requestContext = requestContext != null ? requestContext : new (0, $71ae0bb7947fe91a$export$b8d3e69d4b3eff04)();
        if (!$e9436205c8a93fd8$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $e9436205c8a93fd8$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $e9436205c8a93fd8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $e9436205c8a93fd8$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $e9436205c8a93fd8$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $e9436205c8a93fd8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            (0, $573a89bde77cb3ae$export$f5708dca728d7177)(requestContext instanceof (0, $71ae0bb7947fe91a$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $e9436205c8a93fd8$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
            return await $e9436205c8a93fd8$var$runServerMiddlewarePipeline({
                request: request,
                url: (0, $71ae0bb7947fe91a$export$141d98e45b4b08e4)(request, location),
                pattern: (0, $71ae0bb7947fe91a$export$d738435097971c09)(matches),
                matches: matches,
                params: matches[0].params,
                context: requestContext
            }, async ()=>{
                return await generateMiddlewareResponse(async (innerRequest)=>{
                    let processed = handleQueryResult(await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false));
                    return $e9436205c8a93fd8$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
            }, (error)=>{
                if ($e9436205c8a93fd8$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($e9436205c8a93fd8$var$dataWithResponseInitToResponse(error));
                if ($e9436205c8a93fd8$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
        }
        return handleQueryResult(await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false));
        function handleQueryResult(result) {
            if ($e9436205c8a93fd8$export$3f1eb41d9a6a6a27(result)) return result;
            let error = result.errors ? Object.values(result.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result.actionData) return Object.values(result.actionData)[0];
            if (result.loaderData) return Object.values(result.loaderData)[0];
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($e9436205c8a93fd8$export$cbae47800eb95bc3(request.method)) return await submit(request, location, matches, routeMatch || $e9436205c8a93fd8$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $e9436205c8a93fd8$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($e9436205c8a93fd8$var$isDataStrategyResult(e) && $e9436205c8a93fd8$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error") throw e.result;
                return e.result;
            }
            if ($e9436205c8a93fd8$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $e9436205c8a93fd8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error",
                error: error
            };
        } else {
            result = (await callDataStrategy(request, location, $e9436205c8a93fd8$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, [], requestContext), isRouteRequest, requestContext, dataStrategy))[actionMatch.route.id];
            if (request.signal.aborted) $e9436205c8a93fd8$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($e9436205c8a93fd8$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($e9436205c8a93fd8$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($e9436205c8a93fd8$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $e9436205c8a93fd8$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: (0, $71ae0bb7947fe91a$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($e9436205c8a93fd8$var$isErrorResult(result)) return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                (skipLoaderErrorBubbling ? actionMatch : $e9436205c8a93fd8$var$findNearestBoundary(matches, actionMatch.route.id)).route.id,
                result
            ]),
            statusCode: (0, $71ae0bb7947fe91a$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
            actionData: null,
            actionHeaders: {
                ...result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {}
            }
        };
        return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad),
            actionData: {
                [actionMatch.route.id]: result.data
            },
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $e9436205c8a93fd8$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $e9436205c8a93fd8$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $e9436205c8a93fd8$var$isErrorResult(pendingActionResult[1]) ? matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = (0, $71ae0bb7947fe91a$export$d738435097971c09)(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $e9436205c8a93fd8$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, false);
                return $e9436205c8a93fd8$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $e9436205c8a93fd8$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $e9436205c8a93fd8$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        return {
            ...$e9436205c8a93fd8$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling),
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $e9436205c8a93fd8$var$callDataStrategyImpl(dataStrategy || $e9436205c8a93fd8$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($e9436205c8a93fd8$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $e9436205c8a93fd8$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($e9436205c8a93fd8$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($e9436205c8a93fd8$export$e0163cfdf7bc9cfa(result.result)) throw $e9436205c8a93fd8$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $e9436205c8a93fd8$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        match: match,
        query: query,
        queryRoute: queryRoute
    };
}
/**
* Given an existing StaticHandlerContext and an error thrown at render time,
* provide an updated StaticHandlerContext suitable for a second SSR render
*
* @category Utils
*/ function $e9436205c8a93fd8$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: (0, $71ae0bb7947fe91a$export$972111febbeef05b)(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $e9436205c8a93fd8$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    throw new Error(`${isRouteRequest ? "queryRoute" : "query"}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $e9436205c8a93fd8$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $e9436205c8a93fd8$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $e9436205c8a93fd8$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = (0, $71ae0bb7947fe91a$export$cae722b0cc860f13)(to ? to : ".", (0, $71ae0bb7947fe91a$export$fe6dbc5de95f53ab)(contextualMatches), (0, $71ae0bb7947fe91a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $e9436205c8a93fd8$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = (0, $71ae0bb7947fe91a$export$e9a5bfadbc179142)({
        basename: basename,
        pathname: path.pathname
    });
    return (0, $573a89bde77cb3ae$export$fe53371bee54353d)(path);
}
function $e9436205c8a93fd8$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$e9436205c8a93fd8$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$e9436205c8a93fd8$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $e9436205c8a93fd8$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $e9436205c8a93fd8$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let formMethod = (opts.formMethod || "get").toUpperCase();
    let formAction = $e9436205c8a93fd8$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$e9436205c8a93fd8$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}\n`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$e9436205c8a93fd8$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch  {
                return getInvalidBodyError();
            }
        }
    }
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $e9436205c8a93fd8$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $e9436205c8a93fd8$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $e9436205c8a93fd8$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $e9436205c8a93fd8$var$convertSearchParamsToFormData(searchParams);
    } catch  {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($e9436205c8a93fd8$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = (0, $573a89bde77cb3ae$export$8ccf933b0513f8d0)(path);
    if (isFetcher && parsedPath.search && $e9436205c8a93fd8$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: (0, $573a89bde77cb3ae$export$fe53371bee54353d)(parsedPath),
        submission: submission
    };
}
function $e9436205c8a93fd8$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $e9436205c8a93fd8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $e9436205c8a93fd8$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = (0, $71ae0bb7947fe91a$export$d738435097971c09)(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$e9436205c8a93fd8$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad } = $e9436205c8a93fd8$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad;
        } else if ($e9436205c8a93fd8$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $e9436205c8a93fd8$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($e9436205c8a93fd8$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        return $e9436205c8a93fd8$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, $e9436205c8a93fd8$var$shouldRevalidateLoader(match, shouldRevalidateArgs), shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key) || f.isDiscovering) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = dataRouteMatcher.match(f.path);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $e9436205c8a93fd8$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $e9436205c8a93fd8$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $e9436205c8a93fd8$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $e9436205c8a93fd8$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($e9436205c8a93fd8$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $e9436205c8a93fd8$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $e9436205c8a93fd8$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $e9436205c8a93fd8$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$e9436205c8a93fd8$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $e9436205c8a93fd8$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $e9436205c8a93fd8$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $e9436205c8a93fd8$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $e9436205c8a93fd8$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute)=>$e9436205c8a93fd8$var$isSameRoute(newRoute, existingRoute));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = (0, $71ae0bb7947fe91a$export$87cb1a9238dc3fba)(uniqueChildren, mapRouteProperties, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = (0, $71ae0bb7947fe91a$export$87cb1a9238dc3fba)([
            newRoute
        ], mapRouteProperties, [], {}, true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $e9436205c8a93fd8$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$e9436205c8a93fd8$var$isSameRoute(aChild, bChild))) ?? false;
}
const $e9436205c8a93fd8$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
const $e9436205c8a93fd8$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties })=>{
    let routeToUpdate = manifest[route.id];
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $e9436205c8a93fd8$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $e9436205c8a93fd8$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = (0, $71ae0bb7947fe91a$export$3e22299e33adeed1)(key);
        let isStaticallyDefined = routeToUpdate[key] !== void 0;
        if (isUnsupported) {
            (0, $573a89bde77cb3ae$export$491112666e282270)(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) (0, $573a89bde77cb3ae$export$491112666e282270)(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
const $e9436205c8a93fd8$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
/**
* Execute route.lazy functions to lazily load route modules (loader, action,
* shouldRevalidate) and update the routeManifest in place which shares objects
* with dataRoutes so those get updated as well.
*/ function $e9436205c8a93fd8$var$loadLazyRoute(route, type, manifest, mapRouteProperties, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $e9436205c8a93fd8$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise = (async ()=>{
            (0, $573a89bde77cb3ae$export$f5708dca728d7177)(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = (0, $71ae0bb7947fe91a$export$a89d811eaa209e85)(lazyRouteProperty);
                let isStaticallyDefined = routeToUpdate[lazyRouteProperty] !== void 0;
                if (isUnsupported) (0, $573a89bde77cb3ae$export$491112666e282270)(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) (0, $573a89bde77cb3ae$export$491112666e282270)(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                ...mapRouteProperties(routeToUpdate),
                lazy: void 0
            });
        })();
        $e9436205c8a93fd8$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise);
        lazyRoutePromise.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise,
            lazyHandlerPromise: lazyRoutePromise
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $e9436205c8a93fd8$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $e9436205c8a93fd8$var$isNonNullable(value) {
    return value !== void 0;
}
function $e9436205c8a93fd8$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return;
        return $e9436205c8a93fd8$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
    }).filter($e9436205c8a93fd8$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $e9436205c8a93fd8$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    (await Promise.all(matchesToLoad.map((m)=>m.resolve()))).forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $e9436205c8a93fd8$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $e9436205c8a93fd8$var$defaultDataStrategy(args);
    return $e9436205c8a93fd8$var$runClientMiddlewarePipeline(args, ()=>$e9436205c8a93fd8$var$defaultDataStrategy(args));
}
function $e9436205c8a93fd8$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $e9436205c8a93fd8$var$runMiddlewarePipeline(args, handler, processResult, $e9436205c8a93fd8$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $e9436205c8a93fd8$export$e0163cfdf7bc9cfa(result) ? $e9436205c8a93fd8$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $e9436205c8a93fd8$var$runClientMiddlewarePipeline(args, handler) {
    return $e9436205c8a93fd8$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($e9436205c8a93fd8$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $e9436205c8a93fd8$var$isDataStrategyResults, errorHandler);
    async function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        });
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let deepestRouteId = matches[maxBoundaryIdx].route.id;
            for (let match of matches.slice(0, maxBoundaryIdx + 1))try {
                await match._lazyPromises?.route;
            } catch  {
                deepestRouteId = match.route.id;
                break;
            }
            return {
                [$e9436205c8a93fd8$var$findNearestBoundary(matches, deepestRouteId).route.id]: {
                    type: "error",
                    result: error
                }
            };
        }
    }
}
async function $e9436205c8a93fd8$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    return await $e9436205c8a93fd8$var$callRouteMiddleware(dataFnArgs, matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []), handler, processResult, isResult, errorHandler);
}
async function $e9436205c8a93fd8$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? /* @__PURE__ */ new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) return await handler();
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            nextResult = {
                value: await $e9436205c8a93fd8$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        return await errorHandler(error, routeId, nextResult);
    }
}
function $e9436205c8a93fd8$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $e9436205c8a93fd8$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties
    });
    let lazyRoutePromises = $e9436205c8a93fd8$var$loadLazyRoute(match.route, $e9436205c8a93fd8$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $e9436205c8a93fd8$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $e9436205c8a93fd8$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $e9436205c8a93fd8$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $e9436205c8a93fd8$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $e9436205c8a93fd8$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$e9436205c8a93fd8$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($e9436205c8a93fd8$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $e9436205c8a93fd8$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data",
                result: void 0
            });
        }
    };
}
function $e9436205c8a93fd8$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $e9436205c8a93fd8$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $e9436205c8a93fd8$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, (0, $71ae0bb7947fe91a$export$d738435097971c09)(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $e9436205c8a93fd8$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: (0, $71ae0bb7947fe91a$export$141d98e45b4b08e4)(request, path),
        pattern: (0, $71ae0bb7947fe91a$export$d738435097971c09)(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $e9436205c8a93fd8$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch  {}
    return results;
}
async function $e9436205c8a93fd8$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $e9436205c8a93fd8$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(/* @__PURE__ */ new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: (0, $71ae0bb7947fe91a$export$141d98e45b4b08e4)(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                return {
                    type: "data",
                    result: await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler())
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler = isAction ? match.route.action : match.route.loader;
                if (handler) [result] = await Promise.all([
                    runHandler(handler),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $e9436205c8a93fd8$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data",
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            throw $e9436205c8a93fd8$var$getInternalRouterError(404, {
                pathname: url.pathname + url.search
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error",
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $e9436205c8a93fd8$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $e9436205c8a93fd8$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($e9436205c8a93fd8$export$3f1eb41d9a6a6a27(result)) {
        let data;
        try {
            data = await $e9436205c8a93fd8$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error",
                error: e
            };
        }
        if (type === "error") return {
            type: "error",
            error: new (0, $71ae0bb7947fe91a$export$f2680fa305b734ca)(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data",
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error") {
        if ($e9436205c8a93fd8$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error",
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error",
                error: $e9436205c8a93fd8$var$dataWithResponseInitToErrorResponse(result),
                statusCode: (0, $71ae0bb7947fe91a$export$972111febbeef05b)(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error",
            error: result,
            statusCode: (0, $71ae0bb7947fe91a$export$972111febbeef05b)(result) ? result.status : void 0
        };
    }
    if ($e9436205c8a93fd8$export$e0163cfdf7bc9cfa(result)) return {
        type: "data",
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data",
        data: result
    };
}
function $e9436205c8a93fd8$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!(0, $71ae0bb7947fe91a$export$a1cbf2de32a9fd1)(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $e9436205c8a93fd8$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
const $e9436205c8a93fd8$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    "javascript:"
];
function $e9436205c8a93fd8$export$961a3ef7a4da3a39(location) {
    try {
        return $e9436205c8a93fd8$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $e9436205c8a93fd8$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ((0, $71ae0bb7947fe91a$export$a1cbf2de32a9fd1)(location)) {
        let normalizedLocation = location;
        let url = (0, $38b29aefca9c076c$export$825a82322d91916e).test(normalizedLocation) ? new URL((0, $38b29aefca9c076c$export$977999b735cd4f26)(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($e9436205c8a93fd8$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = (0, $71ae0bb7947fe91a$export$b69e3301ce081aa3)(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return (0, $71ae0bb7947fe91a$export$f857a07c5bd323b8)(url.pathname) + url.search + url.hash;
    }
    try {
        if ($e9436205c8a93fd8$export$961a3ef7a4da3a39(historyInstance.createURL(location).toString())) throw new Error("Invalid redirect location");
    } catch  {}
    return location;
}
function $e9436205c8a93fd8$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($e9436205c8a93fd8$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $e9436205c8a93fd8$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $e9436205c8a93fd8$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $e9436205c8a93fd8$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $e9436205c8a93fd8$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $e9436205c8a93fd8$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $e9436205c8a93fd8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(!$e9436205c8a93fd8$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($e9436205c8a93fd8$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $e9436205c8a93fd8$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $e9436205c8a93fd8$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = (0, $71ae0bb7947fe91a$export$972111febbeef05b)(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $e9436205c8a93fd8$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $e9436205c8a93fd8$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(result, "Did not find corresponding fetcher result");
        if ($e9436205c8a93fd8$var$isErrorResult(result)) {
            let boundaryMatch = $e9436205c8a93fd8$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($e9436205c8a93fd8$var$isRedirectResult(result)) (0, $573a89bde77cb3ae$export$f5708dca728d7177)(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $e9436205c8a93fd8$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $e9436205c8a93fd8$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $e9436205c8a93fd8$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    let preservedCount = 0;
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) {
            mergedLoaderData[id] = loaderData[id];
            preservedCount++;
        }
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return Object.keys(newLoaderData).length === 0 && preservedCount === Object.keys(loaderData).length ? loaderData : mergedLoaderData;
}
function $e9436205c8a93fd8$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $e9436205c8a93fd8$var$isErrorResult(pendingActionResult[1]) ? {
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $e9436205c8a93fd8$var$findNearestBoundary(matches, routeId) {
    return (routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ]).reverse().find((m)=>m.route.ErrorBoundary != null || m.route.errorElement != null) || matches[0];
}
function $e9436205c8a93fd8$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $e9436205c8a93fd8$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new (0, $71ae0bb7947fe91a$export$f2680fa305b734ca)(status || 500, statusText, new Error(errorMessage), true);
}
function $e9436205c8a93fd8$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($e9436205c8a93fd8$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $e9436205c8a93fd8$var$stripHashFromPath(path) {
    return (0, $573a89bde77cb3ae$export$fe53371bee54353d)({
        ...typeof path === "string" ? (0, $573a89bde77cb3ae$export$8ccf933b0513f8d0)(path) : path,
        hash: ""
    });
}
function $e9436205c8a93fd8$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $e9436205c8a93fd8$var$dataWithResponseInitToResponse(data) {
    return Response.json(data.data, data.init ?? void 0);
}
function $e9436205c8a93fd8$var$dataWithResponseInitToErrorResponse(data) {
    return new (0, $71ae0bb7947fe91a$export$f2680fa305b734ca)(data.init?.status ?? 500, data.init?.statusText ?? "Internal Server Error", data.data);
}
function $e9436205c8a93fd8$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $e9436205c8a93fd8$var$isDataStrategyResult(value));
}
function $e9436205c8a93fd8$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" || result.type === "error");
}
function $e9436205c8a93fd8$var$isRedirectDataStrategyResult(result) {
    return $e9436205c8a93fd8$export$3f1eb41d9a6a6a27(result.result) && $e9436205c8a93fd8$var$redirectStatusCodes.has(result.result.status);
}
function $e9436205c8a93fd8$var$isErrorResult(result) {
    return result.type === "error";
}
function $e9436205c8a93fd8$var$isRedirectResult(result) {
    return (result && result.type) === "redirect";
}
function $e9436205c8a93fd8$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $e9436205c8a93fd8$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $e9436205c8a93fd8$export$794b2760043cf8cd(statusCode) {
    return $e9436205c8a93fd8$var$redirectStatusCodes.has(statusCode);
}
function $e9436205c8a93fd8$export$6e80290866a84dd4(result) {
    return $e9436205c8a93fd8$export$3f1eb41d9a6a6a27(result) && $e9436205c8a93fd8$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $e9436205c8a93fd8$var$isValidMethod(method) {
    return $e9436205c8a93fd8$var$validRequestMethods.has(method.toUpperCase());
}
function $e9436205c8a93fd8$export$cbae47800eb95bc3(method) {
    return $e9436205c8a93fd8$var$validMutationMethods.has(method.toUpperCase());
}
function $e9436205c8a93fd8$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $e9436205c8a93fd8$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? (0, $573a89bde77cb3ae$export$8ccf933b0513f8d0)(location).search : location.search;
    if (matches[matches.length - 1].route.index && $e9436205c8a93fd8$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = (0, $71ae0bb7947fe91a$export$b234c29a3bb68fc8)(matches);
    return pathMatches[pathMatches.length - 1];
}
function $e9436205c8a93fd8$var$getInstrumentationNavigateMeta(history, location, matches) {
    return {
        url: (0, $71ae0bb7947fe91a$export$141d98e45b4b08e4)(history.createURL(location), location),
        pattern: matches ? (0, $71ae0bb7947fe91a$export$d738435097971c09)(matches) : "",
        params: matches?.[0]?.params ? {
            ...matches[0].params
        } : {}
    };
}
function $e9436205c8a93fd8$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $e9436205c8a93fd8$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    else return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0
    };
}
function $e9436205c8a93fd8$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    return {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
}
function $e9436205c8a93fd8$var$getLoadingFetcher(submission, data) {
    if (submission) return {
        state: "loading",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: data
    };
    else return {
        state: "loading",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $e9436205c8a93fd8$var$getSubmittingFetcher(submission, existingFetcher) {
    return {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
}
function $e9436205c8a93fd8$var$getDoneFetcher(data) {
    return {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $e9436205c8a93fd8$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($e9436205c8a93fd8$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch  {}
}
function $e9436205c8a93fd8$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($e9436205c8a93fd8$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            (0, $573a89bde77cb3ae$export$491112666e282270)(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $e9436205c8a93fd8$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch  {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch  {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $5NSbj = parcelRequire("5NSbj");
//#region lib/context.ts
const $18b65179e9a5902f$export$2eeee58951ff3c1c = $5NSbj.createContext(null);
$18b65179e9a5902f$export$2eeee58951ff3c1c.displayName = "DataRouter";
const $18b65179e9a5902f$export$315e3ffb01f217 = $5NSbj.createContext(null);
$18b65179e9a5902f$export$315e3ffb01f217.displayName = "DataRouterState";
const $18b65179e9a5902f$export$19d7395466bdeac8 = $5NSbj.createContext(null);
$18b65179e9a5902f$export$19d7395466bdeac8.displayName = "DataRouterData";
const $18b65179e9a5902f$export$2473c5952c6a10d1 = $5NSbj.createContext(null);
$18b65179e9a5902f$export$2473c5952c6a10d1.displayName = "DataRouterNavigation";
const $18b65179e9a5902f$export$717f757c655223f1 = $5NSbj.createContext(false);
function $18b65179e9a5902f$export$6e1eeb090b3ec35b() {
    return $5NSbj.useContext($18b65179e9a5902f$export$717f757c655223f1);
}
const $18b65179e9a5902f$export$3681f408decb40d1 = $5NSbj.createContext({
    isTransitioning: false
});
$18b65179e9a5902f$export$3681f408decb40d1.displayName = "ViewTransition";
const $18b65179e9a5902f$export$cb3f1df1bef00a39 = $5NSbj.createContext(null);
$18b65179e9a5902f$export$cb3f1df1bef00a39.displayName = "Fetchers";
const $18b65179e9a5902f$export$804c460aade54ac8 = $5NSbj.createContext(null);
$18b65179e9a5902f$export$804c460aade54ac8.displayName = "Await";
const $18b65179e9a5902f$export$2666c20e15407622 = (props)=>$5NSbj.createElement($18b65179e9a5902f$export$804c460aade54ac8.Provider, props);
const $18b65179e9a5902f$export$3044ab7fdabeaee6 = $5NSbj.createContext(null);
$18b65179e9a5902f$export$3044ab7fdabeaee6.displayName = "Navigation";
const $18b65179e9a5902f$export$e6a44b110a0c44d3 = $5NSbj.createContext(null);
$18b65179e9a5902f$export$e6a44b110a0c44d3.displayName = "Location";
const $18b65179e9a5902f$export$aac280ed165a4397 = $5NSbj.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$18b65179e9a5902f$export$aac280ed165a4397.displayName = "Route";
const $18b65179e9a5902f$export$efd71bfc7ccfba1 = $5NSbj.createContext(false);
$18b65179e9a5902f$export$efd71bfc7ccfba1.displayName = "IsDataRoute";
const $18b65179e9a5902f$export$92d0be8f6ef5c7bf = $5NSbj.createContext(void 0);
$18b65179e9a5902f$export$92d0be8f6ef5c7bf.displayName = "RouteId";
const $18b65179e9a5902f$export$af8bd2647fea9c11 = $5NSbj.createContext(null);
$18b65179e9a5902f$export$af8bd2647fea9c11.displayName = "RouteError";


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/errors.ts
const $a4d54cae4efb812d$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
const $a4d54cae4efb812d$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
const $a4d54cae4efb812d$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $a4d54cae4efb812d$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$a4d54cae4efb812d$var$ERROR_DIGEST_BASE}:${$a4d54cae4efb812d$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $a4d54cae4efb812d$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$a4d54cae4efb812d$var$ERROR_DIGEST_BASE}:${$a4d54cae4efb812d$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new (0, $71ae0bb7947fe91a$export$f2680fa305b734ca)(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}



var $5NSbj = parcelRequire("5NSbj");
//#region lib/hooks.tsx
/**
* Resolves a URL against the current {@link Location}.
*
* @example
* import { useHref } from "react-router";
*
* function SomeComponent() {
*   let href = useHref("some/where");
*   // "/resolved/some/where"
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the
* route tree.
* Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved href string
*/ function $4a2ef0180f3aa5fe$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)($4a2ef0180f3aa5fe$export$9c954a9d03d32f4a(), `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $5NSbj.useContext((0, $18b65179e9a5902f$export$3044ab7fdabeaee6));
    let { hash: hash, pathname: pathname, search: search } = $4a2ef0180f3aa5fe$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $71ae0bb7947fe91a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
* Returns `true` if this component is a descendant of a {@link Router}, useful
* to ensure a component is used within a {@link Router}.
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns Whether the component is within a {@link Router} context
*/ function $4a2ef0180f3aa5fe$export$9c954a9d03d32f4a() {
    return $5NSbj.useContext((0, $18b65179e9a5902f$export$e6a44b110a0c44d3)) != null;
}
/**
* Returns the current {@link Location}. This can be useful if you'd like to
* perform some side effect whenever it changes.
*
* @example
* import * as React from 'react'
* import { useLocation } from 'react-router'
*
* function SomeComponent() {
*   let location = useLocation()
*
*   React.useEffect(() => {
*     // Google Analytics
*     ga('send', 'pageview')
*   }, [location]);
*
*   return (
*     // ...
*   );
* }
*
* @public
* @category Hooks
* @returns The current {@link Location} object
*/ function $4a2ef0180f3aa5fe$export$45d76561a5302f2b() {
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)($4a2ef0180f3aa5fe$export$9c954a9d03d32f4a(), `useLocation() may be used only in the context of a <Router> component.`);
    return $5NSbj.useContext((0, $18b65179e9a5902f$export$e6a44b110a0c44d3)).location;
}
/**
* Returns the current {@link Navigation} action which describes how the router
* came to the current {@link Location}, either by a pop, push, or replace on
* the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack.
*
* @public
* @category Hooks
* @returns The current {@link NavigationType} (`"POP"`, `"PUSH"`, or `"REPLACE"`)
*/ function $4a2ef0180f3aa5fe$export$1b3f31771c5d07c() {
    return $5NSbj.useContext((0, $18b65179e9a5902f$export$e6a44b110a0c44d3)).navigationType;
}
/**
* Returns a {@link PathMatch} object if the given pattern matches the current URL.
* This is useful for components that need to know "active" state, e.g.
* {@link NavLink | `<NavLink>`}.
*
* @public
* @category Hooks
* @param pattern The pattern to match against the current {@link Location}
* @returns The path match object if the pattern matches, `null` otherwise
*/ function $4a2ef0180f3aa5fe$export$6c330e8992e8a295(pattern) {
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)($4a2ef0180f3aa5fe$export$9c954a9d03d32f4a(), `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $4a2ef0180f3aa5fe$export$45d76561a5302f2b();
    return $5NSbj.useMemo(()=>(0, $71ae0bb7947fe91a$export$81336c211d5ff295)(pattern, (0, $71ae0bb7947fe91a$export$cd27bea214d030c2)(pathname)), [
        pathname,
        pattern
    ]);
}
const $4a2ef0180f3aa5fe$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
/**
* Returns a function that lets you navigate programmatically in the browser in
* response to user interactions or effects.
*
* It's often better to use {@link redirect} in [`action`](../../start/framework/route-module#action)/[`loader`](../../start/framework/route-module#loader)
* functions than this hook.
*
* The returned function signature is `navigate(to, options?)`/`navigate(delta)` where:
*
* * `to` can be a string path, a {@link To} object, or a number (delta)
* * `options` contains options for modifying the navigation
*   * These options work in all modes (Framework, Data, and Declarative):
*     * `relative`: `"route"` or `"path"` to control relative routing logic
*     * `replace`: Replace the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack
*     * `state`: Optional [`history.state`](https://developer.mozilla.org/en-US/docs/Web/API/History/state) to include with the new {@link Location}
*   * These options only work in Framework and Data modes:
*     * `flushSync`: Wrap the DOM updates in [`ReactDom.flushSync`](https://react.dev/reference/react-dom/flushSync)
*     * `preventScrollReset`: Do not scroll back to the top of the page after navigation
*     * `viewTransition`: Enable [`document.startViewTransition`](https://developer.mozilla.org/en-US/docs/Web/API/Document/startViewTransition) for this navigation
*
* @example
* import { useNavigate } from "react-router";
*
* function SomeComponent() {
*   let navigate = useNavigate();
*   return (
*     <button onClick={() => navigate(-1)}>
*       Go Back
*     </button>
*   );
* }
*
* @additionalExamples
* ### Navigate to another path
*
* ```tsx
* navigate("/some/route");
* navigate("/some/route?search=param");
* ```
*
* ### Navigate with a {@link To} object
*
* All properties are optional.
*
* ```tsx
* navigate(
*   {
*     pathname: "/some/route",
*     search: "?search=param",
*     hash: "#hash",
*   },
*   {
*     state: { some: "state" },
*   },
* );
* ```
*
* If you use `state`, that will be available on the {@link Location} object on
* the next page. Access it with `useLocation().state` (see {@link useLocation}).
*
* ### Navigate back or forward in the history stack
*
* ```tsx
* // back
* // often used to close modals
* navigate(-1);
*
* // forward
* // often used in a multistep wizard workflows
* navigate(1);
* ```
*
* Be cautious with `navigate(number)`. If your application can load up to a
* route that has a button that tries to navigate forward/back, there may not be
* a [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry to go back or forward to, or it can go somewhere you don't expect
* (like a different domain).
*
* Only use this if you're sure they will have an entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack to navigate to.
*
* ### Replace the current entry in the history stack
*
* This will remove the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, replacing it with a new one, similar to a server side redirect.
*
* ```tsx
* navigate("/some/route", { replace: true });
* ```
*
* ### Prevent Scroll Reset
*
* [MODES: framework, data]
*
* <br/>
* <br/>
*
* To prevent {@link ScrollRestoration | `<ScrollRestoration>`} from resetting
* the scroll position, use the `preventScrollReset` option.
*
* ```tsx
* navigate("?some-tab=1", { preventScrollReset: true });
* ```
*
* For example, if you have a tab interface connected to search params in the
* middle of a page, and you don't want it to scroll to the top when a tab is
* clicked.
*
* ### Return Type Augmentation
*
* Internally, `useNavigate` uses a separate implementation when you are in
* Declarative mode versus Data/Framework mode - the primary difference being
* that the latter is able to return a stable reference that does not change
* identity across navigations. The implementation in Data/Framework mode also
* returns a [`Promise`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise)
* that resolves when the navigation is completed. This means the return type of
* `useNavigate` is `void | Promise<void>`. This is accurate, but can lead to
* some red squigglies based on the union in the return value:
*
* - If you're using `typescript-eslint`, you may see errors from
*   [`@typescript-eslint/no-floating-promises`](https://typescript-eslint.io/rules/no-floating-promises)
* - In Framework/Data mode, `React.use(navigate())` will show a false-positive
*   `Argument of type 'void | Promise<void>' is not assignable to parameter of
*   type 'Usable<void>'` error
*
* The easiest way to work around these issues is to augment the type based on the
* router you're using:
*
* ```ts
* // If using <BrowserRouter>
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): void;
*     (delta: number): void;
*   }
* }
*
* // If using <RouterProvider> or Framework mode
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): Promise<void>;
*     (delta: number): Promise<void>;
*   }
* }
* ```
*
* @public
* @category Hooks
* @returns A navigate function for programmatic navigation
*/ function $4a2ef0180f3aa5fe$export$9770f232ac06a008() {
    return $5NSbj.useContext((0, $18b65179e9a5902f$export$efd71bfc7ccfba1)) ? $4a2ef0180f3aa5fe$var$useNavigateStable() : $4a2ef0180f3aa5fe$var$useNavigateUnstable();
}
function $4a2ef0180f3aa5fe$var$useNavigateUnstable() {
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)($4a2ef0180f3aa5fe$export$9c954a9d03d32f4a(), `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $5NSbj.useContext((0, $18b65179e9a5902f$export$2eeee58951ff3c1c));
    let { basename: basename, navigator: navigator } = $5NSbj.useContext((0, $18b65179e9a5902f$export$3044ab7fdabeaee6));
    let { matches: matches } = $5NSbj.useContext((0, $18b65179e9a5902f$export$aac280ed165a4397));
    let { pathname: locationPathname } = $4a2ef0180f3aa5fe$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $71ae0bb7947fe91a$export$fe6dbc5de95f53ab)(matches));
    let activeRef = $5NSbj.useRef(false);
    $5NSbj.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $5NSbj.useCallback((to, options = {})=>{
        (0, $573a89bde77cb3ae$export$491112666e282270)(activeRef.current, $4a2ef0180f3aa5fe$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $71ae0bb7947fe91a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $71ae0bb7947fe91a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (0, $474e8f43e2235ddf$export$6c8e41f66e7aa990)(typeof to === "string" ? to : (0, $573a89bde77cb3ae$export$fe53371bee54353d)(to), navigator.createHref(path), (0, $474e8f43e2235ddf$export$1da545bc000055cf)(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
}
const $4a2ef0180f3aa5fe$var$OutletContext = $5NSbj.createContext(null);
/**
* Returns the parent route {@link Outlet | `<Outlet context>`}.
*
* Often parent routes manage state or other values you want shared with child
* routes. You can create your own [context provider](https://react.dev/learn/passing-data-deeply-with-context)
* if you like, but this is such a common situation that it's built-into
* {@link Outlet | `<Outlet>`}.
*
* ```tsx
* // Parent route
* function Parent() {
*   const [count, setCount] = React.useState(0);
*   return <Outlet context={[count, setCount]} />;
* }
* ```
*
* ```tsx
* // Child route
* import { useOutletContext } from "react-router";
*
* function Child() {
*   const [count, setCount] = useOutletContext();
*   const increment = () => setCount((c) => c + 1);
*   return <button onClick={increment}>{count}</button>;
* }
* ```
*
* If you're using TypeScript, we recommend the parent component provide a
* custom hook for accessing the context value. This makes it easier for
* consumers to get nice typings, control consumers, and know who's consuming
* the context value.
*
* Here's a more realistic example:
*
* ```tsx filename=src/routes/dashboard.tsx lines=[14,20]
* import { useState } from "react";
* import { Outlet, useOutletContext } from "react-router";
*
* import type { User } from "./types";
*
* type ContextType = { user: User | null };
*
* export default function Dashboard() {
*   const [user, setUser] = useState<User | null>(null);
*
*   return (
*     <div>
*       <h1>Dashboard</h1>
*       <Outlet context={{ user } satisfies ContextType} />
*     </div>
*   );
* }
*
* export function useUser() {
*   return useOutletContext<ContextType>();
* }
* ```
*
* ```tsx filename=src/routes/dashboard/messages.tsx lines=[1,4]
* import { useUser } from "../dashboard";
*
* export default function DashboardMessages() {
*   const { user } = useUser();
*   return (
*     <div>
*       <h2>Messages</h2>
*       <p>Hello, {user.name}!</p>
*     </div>
*   );
* }
* ```
*
* @public
* @category Hooks
* @returns The context value passed to the parent {@link Outlet} component
*/ function $4a2ef0180f3aa5fe$export$4138103a3ae699cc() {
    return $5NSbj.useContext($4a2ef0180f3aa5fe$var$OutletContext);
}
/**
* Returns the element for the child route at this level of the route
* hierarchy. Used internally by {@link Outlet | `<Outlet>`} to render child
* routes.
*
* @public
* @category Hooks
* @param context The context to pass to the outlet
* @returns The child route element or `null` if no child routes match
*/ function $4a2ef0180f3aa5fe$export$a3be3530d8e40d0b(context) {
    let outlet = $5NSbj.useContext((0, $18b65179e9a5902f$export$aac280ed165a4397)).outlet;
    return $5NSbj.useMemo(()=>outlet && /* @__PURE__ */ $5NSbj.createElement($4a2ef0180f3aa5fe$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
/**
* Returns an object of key/value-pairs of the dynamic params from the current
* URL that were matched by the routes. Child routes inherit all params from
* their parent routes.
*
* Assuming a route pattern like `/posts/:postId` is matched by `/posts/123`
* then `params.postId` will be `"123"`.
*
* @example
* import { useParams } from "react-router";
*
* function SomeComponent() {
*   let params = useParams();
*   params.postId;
* }
*
* @additionalExamples
* ### Basic Usage
*
* ```tsx
* import { useParams } from "react-router";
*
* // given a route like:
* <Route path="/posts/:postId" element={<Post />} />;
*
* // or a data route like:
* createBrowserRouter([
*   {
*     path: "/posts/:postId",
*     component: Post,
*   },
* ]);
*
* // or in routes.ts
* route("/posts/:postId", "routes/post.tsx");
* ```
*
* Access the params in a component:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return <h1>Post: {params.postId}</h1>;
* }
* ```
*
* ### Multiple Params
*
* Patterns can have multiple params:
*
* ```tsx
* "/posts/:postId/comments/:commentId";
* ```
*
* All will be available in the params object:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return (
*     <h1>
*       Post: {params.postId}, Comment: {params.commentId}
*     </h1>
*   );
* }
* ```
*
* ### Catchall Params
*
* Catchall params are defined with `*`:
*
* ```tsx
* "/files/*";
* ```
*
* The matched value will be available in the params object as follows:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function File() {
*   let params = useParams();
*   let catchall = params["*"];
*   // ...
* }
* ```
*
* You can destructure the catchall param:
*
* ```tsx
* export default function File() {
*   let { "*": catchall } = useParams();
*   console.log(catchall);
* }
* ```
*
* @public
* @category Hooks
* @returns An object containing the dynamic route parameters
*/ function $4a2ef0180f3aa5fe$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $5NSbj.useContext((0, $18b65179e9a5902f$export$aac280ed165a4397));
    return matches[matches.length - 1]?.params ?? {};
}
/**
* Resolves the pathname of the given `to` value against the current
* {@link Location}. Similar to {@link useHref}, but returns a
* {@link Path} instead of a string.
*
* @example
* import { useResolvedPath } from "react-router";
*
* function SomeComponent() {
*   // if the user is at /dashboard/profile
*   let path = useResolvedPath("../accounts");
*   path.pathname; // "/dashboard/accounts"
*   path.search; // ""
*   path.hash; // ""
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the route tree.
*                         Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved {@link Path} object with `pathname`, `search`, and `hash`
*/ function $4a2ef0180f3aa5fe$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $5NSbj.useContext((0, $18b65179e9a5902f$export$aac280ed165a4397));
    let { pathname: locationPathname } = $4a2ef0180f3aa5fe$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $71ae0bb7947fe91a$export$fe6dbc5de95f53ab)(matches));
    return $5NSbj.useMemo(()=>(0, $71ae0bb7947fe91a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
* Hook version of {@link Routes | `<Routes>`} that uses objects instead of
* components. These objects have the same properties as the component props.
* The return value of `useRoutes` is either a valid React element you can use
* to render the route tree, or `null` if nothing matched.
*
* @example
* import { useRoutes } from "react-router";
*
* function App() {
*   let element = useRoutes([
*     {
*       path: "/",
*       element: <Dashboard />,
*       children: [
*         {
*           path: "messages",
*           element: <DashboardMessages />,
*         },
*         { path: "tasks", element: <DashboardTasks /> },
*       ],
*     },
*     { path: "team", element: <AboutPage /> },
*   ]);
*
*   return element;
* }
*
* @public
* @category Hooks
* @param routes An array of {@link RouteObject}s that define the route hierarchy
* @param locationArg An optional {@link Location} object or pathname string to
* use instead of the current {@link Location}
* @returns A React element to render the matched route, or `null` if no routes matched
*/ function $4a2ef0180f3aa5fe$export$5d3fca4a98652595(routes, locationArg) {
    return $4a2ef0180f3aa5fe$export$f7ce0646a48561fb(routes, locationArg);
}
function $4a2ef0180f3aa5fe$export$f7ce0646a48561fb(routes, locationArg, dataRouterOpts) {
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)($4a2ef0180f3aa5fe$export$9c954a9d03d32f4a(), `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $5NSbj.useContext((0, $18b65179e9a5902f$export$3044ab7fdabeaee6));
    let { matches: parentMatches } = $5NSbj.useContext((0, $18b65179e9a5902f$export$aac280ed165a4397));
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    routeMatch && routeMatch.pathname;
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    routeMatch && routeMatch.route;
    let locationFromContext = $4a2ef0180f3aa5fe$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? (0, $573a89bde77cb3ae$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        remainingPathname = "/" + pathname.replace(/^\//, "").split("/").slice(parentSegments.length).join("/");
    }
    let matches;
    if (dataRouterOpts) {
        if (dataRouterOpts.state.matches.length) matches = dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
                route: dataRouterOpts.manifest[m.route.id] || m.route
            }));
        else matches = dataRouterOpts.router.match(dataRouterOpts.state.location);
    } else matches = (0, $71ae0bb7947fe91a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $4a2ef0180f3aa5fe$export$569816e95a012c39(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $71ae0bb7947fe91a$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $71ae0bb7947fe91a$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$e6a44b110a0c44d3).Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP"
        }
    }, renderedMatches);
    return renderedMatches;
}
function $4a2ef0180f3aa5fe$var$DefaultErrorComponent() {
    let error = $4a2ef0180f3aa5fe$export$ed527bf60f6e05f2();
    let message = (0, $71ae0bb7947fe91a$export$972111febbeef05b)(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    return /* @__PURE__ */ $5NSbj.createElement($5NSbj.Fragment, null, /* @__PURE__ */ $5NSbj.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $5NSbj.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $5NSbj.createElement("pre", {
        style: {
            padding: "0.5rem",
            backgroundColor: "rgba(200,200,200, 0.5)"
        }
    }, stack) : null, null);
}
const $4a2ef0180f3aa5fe$var$defaultErrorElement = /* @__PURE__ */ $5NSbj.createElement($4a2ef0180f3aa5fe$var$DefaultErrorComponent, null);
var $4a2ef0180f3aa5fe$var$RenderErrorBoundary = class extends $5NSbj.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static contextType = (0, $18b65179e9a5902f$export$717f757c655223f1);
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = (0, $a4d54cae4efb812d$export$2b5950305b3e7eaf)(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$aac280ed165a4397).Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$efd71bfc7ccfba1).Provider, {
            value: this.props.routeContext.isDataRoute
        }, /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$92d0be8f6ef5c7bf).Provider, {
            value: this.props.routeContext.matches[this.props.routeContext.matches.length - 1]?.route.id
        }, /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$af8bd2647fea9c11).Provider, {
            value: error,
            children: this.props.component
        })))) : this.props.children;
        if (this.context) return /* @__PURE__ */ $5NSbj.createElement($4a2ef0180f3aa5fe$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
const $4a2ef0180f3aa5fe$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $4a2ef0180f3aa5fe$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $5NSbj.useContext((0, $18b65179e9a5902f$export$3044ab7fdabeaee6));
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect = (0, $a4d54cae4efb812d$export$30db792b333fd2ee)(error.digest);
        if (redirect) {
            let existingRedirect = $4a2ef0180f3aa5fe$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = (0, $71ae0bb7947fe91a$export$ac5aeb949e84fd96)(redirect.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            (0, $474e8f43e2235ddf$export$6c8e41f66e7aa990)(redirect.location, target, (0, $474e8f43e2235ddf$export$1da545bc000055cf)(navigator), "allow-explicit");
            if ((0, $e9436205c8a93fd8$export$961a3ef7a4da3a39)(target)) throw new Error("Invalid redirect location");
            if ((0, $71ae0bb7947fe91a$export$4e09c449d6c407f7) && !$4a2ef0180f3aa5fe$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect.replace
                        }));
                    $4a2ef0180f3aa5fe$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $5NSbj.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $4a2ef0180f3aa5fe$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $5NSbj.useContext((0, $18b65179e9a5902f$export$2eeee58951ff3c1c));
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$aac280ed165a4397).Provider, {
        value: routeContext
    }, /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$efd71bfc7ccfba1).Provider, {
        value: routeContext.isDataRoute
    }, /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$92d0be8f6ef5c7bf).Provider, {
        value: match.route.id
    }, children)));
}
function $4a2ef0180f3aa5fe$export$569816e95a012c39(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors || errors[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: (0, $71ae0bb7947fe91a$export$d738435097971c09)(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $4a2ef0180f3aa5fe$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $4a2ef0180f3aa5fe$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $5NSbj.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $5NSbj.createElement($4a2ef0180f3aa5fe$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $5NSbj.createElement($4a2ef0180f3aa5fe$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $4a2ef0180f3aa5fe$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $4a2ef0180f3aa5fe$export$ae09415e57d46628(hookName) {
    let ctx = $5NSbj.useContext((0, $18b65179e9a5902f$export$2eeee58951ff3c1c));
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(ctx, $4a2ef0180f3aa5fe$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $4a2ef0180f3aa5fe$export$f93124018767f269(hookName) {
    let state = $5NSbj.useContext((0, $18b65179e9a5902f$export$315e3ffb01f217));
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(state, $4a2ef0180f3aa5fe$var$getDataRouterConsoleError(hookName));
    return state;
}
function $4a2ef0180f3aa5fe$export$c6e4e4d7047d4ffe(hookName) {
    let fetchers = $5NSbj.useContext((0, $18b65179e9a5902f$export$cb3f1df1bef00a39));
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(fetchers, $4a2ef0180f3aa5fe$var$getDataRouterConsoleError(hookName));
    return fetchers;
}
function $4a2ef0180f3aa5fe$export$798168c290ba5b3d(hookName) {
    let data = $5NSbj.useContext((0, $18b65179e9a5902f$export$19d7395466bdeac8));
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(data, $4a2ef0180f3aa5fe$var$getDataRouterConsoleError(hookName));
    return data;
}
function $4a2ef0180f3aa5fe$var$useDataRouterNavigation(hookName) {
    let navigation = $5NSbj.useContext((0, $18b65179e9a5902f$export$2473c5952c6a10d1));
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(navigation, $4a2ef0180f3aa5fe$var$getDataRouterConsoleError(hookName));
    return navigation;
}
function $4a2ef0180f3aa5fe$export$501a3f562d56eac6(hookName) {
    let routeId = $5NSbj.useContext((0, $18b65179e9a5902f$export$92d0be8f6ef5c7bf));
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(routeId, `${hookName} can only be used on routes that contain a unique "id"`);
    return routeId;
}
/**
* Returns the current {@link Navigation}, defaulting to an "idle" navigation
* when no navigation is in progress. You can use this to render pending UI
* (like a global spinner) or read [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
* from a form navigation.
*
* @example
* import { useNavigation } from "react-router";
*
* function SomeComponent() {
*   let navigation = useNavigation();
*   navigation.state;
*   navigation.formData;
*   // etc.
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current {@link Navigation} object
*/ function $4a2ef0180f3aa5fe$export$d0fd4b7106de2769() {
    let { navigation: navigation } = $4a2ef0180f3aa5fe$var$useDataRouterNavigation("useNavigation");
    return $5NSbj.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = navigation;
        return rest;
    }, [
        navigation
    ]);
}
/**
* Revalidate the data on the page for reasons outside of normal data mutations
* like [`Window` focus](https://developer.mozilla.org/en-US/docs/Web/API/Window/focus_event)
* or polling on an interval.
*
* Note that page data is already revalidated automatically after actions.
* If you find yourself using this for normal CRUD operations on your data in
* response to user interactions, you're probably not taking advantage of the
* other APIs like {@link useFetcher}, {@link Form}, {@link useSubmit} that do
* this automatically.
*
* @example
* import { useRevalidator } from "react-router";
*
* function WindowFocusRevalidator() {
*   const revalidator = useRevalidator();
*
*   useFakeWindowFocus(() => {
*     revalidator.revalidate();
*   });
*
*   return (
*     <div hidden={revalidator.state === "idle"}>
*       Revalidating...
*     </div>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An object with a `revalidate` function and the current revalidation
* `state`
*/ function $4a2ef0180f3aa5fe$export$600dc272ed516c15() {
    let dataRouterContext = $4a2ef0180f3aa5fe$export$ae09415e57d46628("useRevalidator");
    let { revalidation: revalidation } = $4a2ef0180f3aa5fe$var$useDataRouterNavigation("useRevalidator");
    let revalidate = $5NSbj.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $5NSbj.useMemo(()=>({
            revalidate: revalidate,
            state: revalidation
        }), [
        revalidate,
        revalidation
    ]);
}
/**
* Returns the active route matches, useful for accessing `loaderData` for
* parent/child routes or the route [`handle`](../../start/framework/route-module#handle)
* property
*
* Pairing the route `handle` with `useMatches` gets very powerful since you can put
* whatever you want on a route handle and have access to `useMatches` anywhere.
* Please see the [handle](../../how-to/using-handle) documentation for an example
* of breadcrumbs via `useMatches`/`handle`.
*
* ```tsx
* import { useMatches } from "react-router";
*
* function SomeComponent() {
*   const matches = useMatches();
*   // matches[i].id          // route id
*   // matches[i].pathname    // the portion of the URL the route matched
*   // matches[i].params      // the parsed params from the URL
*   // matches[i].loaderData  // the data from the loader
*   // matches[i].handle      // the route handle with any app specific data
* }
* ```
*
* <docs-info>useMatches only works with a data router like `createBrowserRouter`,
* since they know the full route tree up front and can provide all of the current
* matches. Additionally, `useMatches` will not match down into any descendant route
* trees since the router isn't aware of the descendant routes.</docs-info>
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of {@link UIMatch | UI matches} for the current route hierarchy
*/ function $4a2ef0180f3aa5fe$export$2378eb7f5ff86053() {
    let { matches: matches } = $4a2ef0180f3aa5fe$export$f93124018767f269("useMatches");
    let { loaderData: loaderData } = $4a2ef0180f3aa5fe$export$798168c290ba5b3d("useMatches");
    return $5NSbj.useMemo(()=>matches.map((m)=>(0, $71ae0bb7947fe91a$export$fcf533780bf49ee2)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
* Returns the data from the closest route
* [`loader`](../../start/framework/route-module#loader) or
* [`clientLoader`](../../start/framework/route-module#clientloader).
*
* @example
* import { useLoaderData } from "react-router";
*
* export async function loader() {
*   return await fakeDb.invoices.findAll();
* }
*
* export default function Invoices() {
*   let invoices = useLoaderData<typeof loader>();
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`loader`](../../start/framework/route-module#loader) or [`clientLoader`](../../start/framework/route-module#clientloader) function
*/ function $4a2ef0180f3aa5fe$export$1448a5050d252c4d() {
    let data = $4a2ef0180f3aa5fe$export$798168c290ba5b3d("useLoaderData");
    let routeId = $4a2ef0180f3aa5fe$export$501a3f562d56eac6("useLoaderData");
    return data.loaderData[routeId];
}
/**
* Returns the [`loader`](../../start/framework/route-module#loader) data for a
* given route by route ID.
*
* Route IDs are created automatically. They are simply the path of the route file
* relative to the app folder without the extension.
*
* | Route Filename               | Route ID               |
* | ---------------------------- | ---------------------- |
* | `app/root.tsx`               | `"root"`               |
* | `app/routes/teams.tsx`       | `"routes/teams"`       |
* | `app/whatever/teams.$id.tsx` | `"whatever/teams.$id"` |
*
* @example
* import { useRouteLoaderData } from "react-router";
*
* function SomeComponent() {
*   const { user } = useRouteLoaderData("root");
* }
*
* // You can also specify your own route ID's manually in your routes.ts file:
* route("/", "containers/app.tsx", { id: "app" })
* useRouteLoaderData("app");
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param routeId The ID of the route to return loader data from
* @returns The data returned from the specified route's [`loader`](../../start/framework/route-module#loader)
* function, or `undefined` if not found
*/ function $4a2ef0180f3aa5fe$export$fd5d37484eab868d(routeId) {
    return $4a2ef0180f3aa5fe$export$798168c290ba5b3d("useRouteLoaderData").loaderData[routeId];
}
/**
* Returns the [`action`](../../start/framework/route-module#action) data from
* the most recent `POST` navigation form submission or `undefined` if there
* hasn't been one.
*
* @example
* import { Form, useActionData } from "react-router";
*
* export async function action({ request }) {
*   const body = await request.formData();
*   const name = body.get("visitorsName");
*   return { message: `Hello, ${name}` };
* }
*
* export default function Invoices() {
*   const data = useActionData();
*   return (
*     <Form method="post">
*       <input type="text" name="visitorsName" />
*       {data ? data.message : "Waiting..."}
*     </Form>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`action`](../../start/framework/route-module#action)
* function, or `undefined` if no [`action`](../../start/framework/route-module#action)
* has been called
*/ function $4a2ef0180f3aa5fe$export$fdc00f3f26066d5e() {
    let data = $4a2ef0180f3aa5fe$export$798168c290ba5b3d("useActionData");
    let routeId = $4a2ef0180f3aa5fe$export$501a3f562d56eac6("useActionData");
    return data.actionData ? data.actionData[routeId] : void 0;
}
/**
* Accesses the error thrown during an
* [`action`](../../start/framework/route-module#action),
* [`loader`](../../start/framework/route-module#loader),
* or component render to be used in a route module
* [`ErrorBoundary`](../../start/framework/route-module#errorboundary).
*
* @example
* export function ErrorBoundary() {
*   const error = useRouteError();
*   return <div>{error.message}</div>;
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown during route [loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action) execution, or rendering
*/ function $4a2ef0180f3aa5fe$export$ed527bf60f6e05f2() {
    let error = $5NSbj.useContext((0, $18b65179e9a5902f$export$af8bd2647fea9c11));
    let data = $4a2ef0180f3aa5fe$export$798168c290ba5b3d("useRouteError");
    let routeId = $4a2ef0180f3aa5fe$export$501a3f562d56eac6("useRouteError");
    if (error !== void 0) return error;
    return data.errors?.[routeId];
}
/**
* Returns the resolved promise value from the closest {@link Await | `<Await>`}.
*
* @example
* function SomeDescendant() {
*   const value = useAsyncValue();
*   // ...
* }
*
* // somewhere in your app
* <Await resolve={somePromise}>
*   <SomeDescendant />
* </Await>;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The resolved value from the nearest {@link Await} component
*/ function $4a2ef0180f3aa5fe$export$78a72ddb39bdd145() {
    return $5NSbj.useContext((0, $18b65179e9a5902f$export$804c460aade54ac8))?._data;
}
/**
* Returns the rejection value from the closest {@link Await | `<Await>`}.
*
* @example
* import { Await, useAsyncError } from "react-router";
*
* function ErrorElement() {
*   const error = useAsyncError();
*   return (
*     <p>Uh Oh, something went wrong! {error.message}</p>
*   );
* }
*
* // somewhere in your app
* <Await
*   resolve={promiseThatRejects}
*   errorElement={<ErrorElement />}
* />;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown in the nearest {@link Await} component
*/ function $4a2ef0180f3aa5fe$export$17f53340677d5831() {
    return $5NSbj.useContext((0, $18b65179e9a5902f$export$804c460aade54ac8))?._error;
}
let $4a2ef0180f3aa5fe$var$blockerId = 0;
/**
* Allow the application to block navigations within the SPA and present the
* user a confirmation dialog to confirm the navigation. Mostly used to avoid
* using half-filled form data. This does not handle hard-reloads or
* cross-origin navigations.
*
* The {@link Blocker} object returned by the hook has the following properties:
*
* - **`state`**
*   - `unblocked` - the blocker is idle and has not prevented any navigation
*   - `blocked` - the blocker has prevented a navigation
*   - `proceeding` - the blocker is proceeding through from a blocked navigation
* - **`location`**
*   - When in a `blocked` state, this represents the {@link Location} to which
*     we blocked a navigation. When in a `proceeding` state, this is the
*     location being navigated to after a `blocker.proceed()` call.
* - **`proceed()`**
*   - When in a `blocked` state, you may call `blocker.proceed()` to proceed to
*     the blocked location.
* - **`reset()`**
*   - When in a `blocked` state, you may call `blocker.reset()` to return the
*     blocker to an `unblocked` state and leave the user at the current
*     location.
*
* @example
* // Boolean version
* let blocker = useBlocker(value !== "");
*
* // Function version
* let blocker = useBlocker(
*   ({ currentLocation, nextLocation, historyAction }) =>
*     value !== "" &&
*     currentLocation.pathname !== nextLocation.pathname
* );
*
* @additionalExamples
* ```tsx
* import { useCallback, useState } from "react";
* import { BlockerFunction, useBlocker } from "react-router";
*
* export function ImportantForm() {
*   const [value, setValue] = useState("");
*
*   const shouldBlock = useCallback<BlockerFunction>(
*     () => value !== "",
*     [value]
*   );
*   const blocker = useBlocker(shouldBlock);
*
*   return (
*     <form
*       onSubmit={(e) => {
*         e.preventDefault();
*         setValue("");
*         if (blocker.state === "blocked") {
*           blocker.proceed();
*         }
*       }}
*     >
*       <input
*         name="data"
*         value={value}
*         onChange={(e) => setValue(e.target.value)}
*       />
*
*       <button type="submit">Save</button>
*
*       {blocker.state === "blocked" ? (
*         <>
*           <p style={{ color: "red" }}>
*             Blocked the last navigation to
*           </p>
*           <button
*             type="button"
*             onClick={() => blocker.proceed()}
*           >
*             Let me through
*           </button>
*           <button
*             type="button"
*             onClick={() => blocker.reset()}
*           >
*             Keep me here
*           </button>
*         </>
*       ) : blocker.state === "proceeding" ? (
*         <p style={{ color: "orange" }}>
*           Proceeding through blocked navigation
*         </p>
*       ) : (
*         <p style={{ color: "green" }}>
*           Blocker is currently unblocked
*         </p>
*       )}
*     </form>
*   );
* }
* ```
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param shouldBlock Either a boolean or a function returning a boolean which
* indicates whether the navigation should be blocked. The function format
* receives a single object parameter containing the `currentLocation`,
* `nextLocation`, and `historyAction` of the potential navigation.
* @returns A {@link Blocker} object with state and reset functionality
*/ function $4a2ef0180f3aa5fe$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $4a2ef0180f3aa5fe$export$ae09415e57d46628("useBlocker");
    let state = $4a2ef0180f3aa5fe$export$f93124018767f269("useBlocker");
    let [blockerKey, setBlockerKey] = $5NSbj.useState("");
    let blockerFunction = $5NSbj.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: (0, $71ae0bb7947fe91a$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: (0, $71ae0bb7947fe91a$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $5NSbj.useEffect(()=>{
        let key = String(++$4a2ef0180f3aa5fe$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $5NSbj.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $e9436205c8a93fd8$export$386d57f03f0b2883);
}
function $4a2ef0180f3aa5fe$var$useNavigateStable() {
    let { router: router } = $4a2ef0180f3aa5fe$export$ae09415e57d46628("useNavigate");
    let id = $4a2ef0180f3aa5fe$export$501a3f562d56eac6("useNavigate");
    let activeRef = $5NSbj.useRef(false);
    $5NSbj.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $5NSbj.useCallback(async (to, options = {})=>{
        (0, $573a89bde77cb3ae$export$491112666e282270)(activeRef.current, $4a2ef0180f3aa5fe$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
}
const $4a2ef0180f3aa5fe$var$alreadyWarned = {};
function $4a2ef0180f3aa5fe$var$warningOnce(key, cond, message) {
    if (!cond && !$4a2ef0180f3aa5fe$var$alreadyWarned[key]) {
        $4a2ef0180f3aa5fe$var$alreadyWarned[key] = true;
        (0, $573a89bde77cb3ae$export$491112666e282270)(false, message);
    }
}
function $4a2ef0180f3aa5fe$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $4a2ef0180f3aa5fe$export$501a3f562d56eac6("useRoute");
    const id = args[0] ?? currentRouteId;
    const state = $4a2ef0180f3aa5fe$export$f93124018767f269("useRoute");
    const data = $4a2ef0180f3aa5fe$export$798168c290ba5b3d("useRoute");
    const route = state.matches.find(({ route: route })=>route.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: data.loaderData[id],
        actionData: data.actionData?.[id]
    };
}
function $4a2ef0180f3aa5fe$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
/**
* A unified hook for reading router state: current (`active`) and in-flight
* (`pending`) locations, search params, params, matches, and navigation type.
*
* This hook consolidates the information you used to get from {@link useLocation},
* {@link useSearchParams}, {@link useParams}, {@link useMatches}, {@link useNavigation},
* and {@link useNavigationType} into a single hook.
*
*
* @example
* import { unstable_useRouterState as useRouterState } from "react-router";
*
* let { active, pending } = unstable_useRouterState();
*
* // Active is always populated with the current location
* active.location; // replaces `useLocation()`
* active.searchParams; // replaces `useSearchParams()[0]`
* active.params; // replaces `useParams()`
* active.matches; // replaces `useMatches()`
* active.type; // replaces `useNavigationType()`
*
* // Pending is only populated during a navigation
* pending.location; // replaces `useNavigation().location`
* pending.searchParams; // equivalent to `new URLSearchParams(useNavigation().search)`
* pending.params; // Not directly accessible today
* pending.matches; // Not directly accessible today
* pending.type; // Not directly accessible today
* pending.state; // replaces `useNavigation().state`
* pending.formMethod; // replaces useNavigation().formMethod
* pending.formAction; // replaces useNavigation().formAction
* pending.formEncType; // replaces useNavigation().formEncType
* pending.formData; // replaces useNavigation().formData
* pending.json; // replaces useNavigation().json
* pending.text; // replaces useNavigation().text
*
* @name unstable_useRouterState
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current router state with `active` and `pending` variants
*/ function $4a2ef0180f3aa5fe$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches } = $4a2ef0180f3aa5fe$export$f93124018767f269("unstable_useRouterState");
    let { navigation: navigation } = $4a2ef0180f3aa5fe$var$useDataRouterNavigation("unstable_useRouterState");
    let active = $5NSbj.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$4a2ef0180f3aa5fe$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $5NSbj.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$4a2ef0180f3aa5fe$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $5NSbj.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 





/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/server-runtime/warnings.ts
const $757c9f1efeb7812e$var$alreadyWarned = {};
function $757c9f1efeb7812e$export$5b28268982f175ba(condition, message) {
    if (!condition && !$757c9f1efeb7812e$var$alreadyWarned[message]) {
        $757c9f1efeb7812e$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}



var $5NSbj = parcelRequire("5NSbj");
//#region lib/components.tsx
const $cc78a6e3ef89ca34$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
/**
* Create a new {@link DataRouter} that manages the application path using an
* in-memory [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack. Useful for non-browser environments without a DOM API.
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {MemoryRouterOpts.basename} opts.basename n/a
* @param {MemoryRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {MemoryRouterOpts.future} opts.future n/a
* @param {MemoryRouterOpts.getContext} opts.getContext n/a
* @param {MemoryRouterOpts.hydrationData} opts.hydrationData n/a
* @param {MemoryRouterOpts.initialEntries} opts.initialEntries n/a
* @param {MemoryRouterOpts.initialIndex} opts.initialIndex n/a
* @param {MemoryRouterOpts.instrumentations} opts.instrumentations n/a
* @param {MemoryRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @returns An initialized {@link DataRouter} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $cc78a6e3ef89ca34$export$f30f7e456d254e83(routes, opts) {
    return (0, $e9436205c8a93fd8$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $573a89bde77cb3ae$export$2b76ad033c6e6d08)({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: (0, $71ae0bb7947fe91a$export$6bc17138063be773),
        hydrationRouteProperties: $cc78a6e3ef89ca34$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $cc78a6e3ef89ca34$var$Deferred = class {
    status = "pending";
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
/**
* Render the UI for the given {@link DataRouter}. This component should
* typically be at the top of an app's element tree. The router prop should
* be a single router instance created outside of the React tree. Avoid
* creating new routers during React renders/re-renders.
*
* ```tsx
* import { createBrowserRouter } from "react-router";
* import { RouterProvider } from "react-router/dom";
* import { createRoot } from "react-dom/client";
*
* const router = createBrowserRouter(routes);
* createRoot(document.getElementById("root")).render(
*   <RouterProvider router={router} />
* );
* ```
*
* <docs-info>Please note that this component is exported both from
* `react-router` and `react-router/dom` with the only difference being that the
* latter automatically wires up `react-dom`'s [`flushSync`](https://react.dev/reference/react-dom/flushSync)
* implementation. You _almost always_ want to use the version from
* `react-router/dom` unless you're running in a non-DOM environment.</docs-info>
*
*
* @public
* @category Data Routers
* @mode data
* @param props Props
* @param {RouterProviderProps.flushSync} props.flushSync n/a
* @param {RouterProviderProps.onError} props.onError n/a
* @param {RouterProviderProps.router} props.router n/a
* @param {RouterProviderProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router
*/ function $cc78a6e3ef89ca34$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    useTransitions = (0, $18b65179e9a5902f$export$6e1eeb090b3ec35b)() || useTransitions;
    let [_state, setStateImpl] = $5NSbj.useState(router.state);
    let [state, setOptimisticState] = (0, $5NSbj.useOptimistic)(_state);
    let [pendingState, setPendingState] = $5NSbj.useState();
    let [vtContext, setVtContext] = $5NSbj.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $5NSbj.useState();
    let [transition, setTransition] = $5NSbj.useState();
    let [interruption, setInterruption] = $5NSbj.useState();
    let fetcherData = $5NSbj.useRef(/* @__PURE__ */ new Map());
    let setState = $5NSbj.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: (0, $71ae0bb7947fe91a$export$d738435097971c09)(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        (0, $757c9f1efeb7812e$export$5b28268982f175ba)(flushSync === false || reactDomFlushSyncImpl != null, "You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from \"react-router/dom\"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.");
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        (0, $757c9f1efeb7812e$export$5b28268982f175ba)(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $5NSbj.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$cc78a6e3ef89ca34$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $5NSbj.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $5NSbj.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $cc78a6e3ef89ca34$var$Deferred());
    }, [
        vtContext
    ]);
    $5NSbj.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $5NSbj.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$cc78a6e3ef89ca34$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $5NSbj.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $5NSbj.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $5NSbj.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $5NSbj.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    let dataRouterState = $5NSbj.useMemo(()=>({
            historyAction: state.historyAction,
            location: state.location,
            matches: state.matches,
            initialized: state.initialized,
            renderFallback: state.renderFallback,
            restoreScrollPosition: state.restoreScrollPosition,
            preventScrollReset: state.preventScrollReset,
            blockers: state.blockers
        }), [
        state.historyAction,
        state.location,
        state.matches,
        state.initialized,
        state.renderFallback,
        state.restoreScrollPosition,
        state.preventScrollReset,
        state.blockers
    ]);
    let dataRouterNavigation = $5NSbj.useMemo(()=>({
            navigation: state.navigation,
            revalidation: state.revalidation
        }), [
        state.navigation,
        state.revalidation
    ]);
    let dataRouterData = $5NSbj.useMemo(()=>({
            loaderData: state.loaderData,
            actionData: state.actionData,
            errors: state.errors
        }), [
        state.loaderData,
        state.actionData,
        state.errors
    ]);
    let fetchersContext = $5NSbj.useMemo(()=>({
            fetchers: state.fetchers,
            fetcherData: fetcherData.current
        }), [
        state.fetchers
    ]);
    return /* @__PURE__ */ $5NSbj.createElement($5NSbj.Fragment, null, /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$2eeee58951ff3c1c).Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$315e3ffb01f217).Provider, {
        value: dataRouterState
    }, /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$2473c5952c6a10d1).Provider, {
        value: dataRouterNavigation
    }, /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$19d7395466bdeac8).Provider, {
        value: dataRouterData
    }, /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$cb3f1df1bef00a39).Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$3681f408decb40d1).Provider, {
        value: vtContext
    }, /* @__PURE__ */ $5NSbj.createElement($cc78a6e3ef89ca34$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $5NSbj.createElement($cc78a6e3ef89ca34$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        state: state,
        isStatic: false,
        onError: onError
    })))))))), null);
}
function $cc78a6e3ef89ca34$var$getOptimisticRouterState(currentState, newState) {
    return {
        ...currentState,
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
const $cc78a6e3ef89ca34$var$MemoizedDataRoutes = $5NSbj.memo($cc78a6e3ef89ca34$export$699f06c8afb533c9);
function $cc78a6e3ef89ca34$export$699f06c8afb533c9({ routes: routes, manifest: manifest, state: state, isStatic: isStatic, onError: onError }) {
    let dataRouterContext = $5NSbj.useContext((0, $18b65179e9a5902f$export$2eeee58951ff3c1c));
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(dataRouterContext, "You must render this element inside a <DataRouterContext.Provider> element");
    return (0, $4a2ef0180f3aa5fe$export$f7ce0646a48561fb)(routes, void 0, {
        router: dataRouterContext.router,
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores all entries in memory.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {MemoryRouterProps.basename} props.basename n/a
* @param {MemoryRouterProps.children} props.children n/a
* @param {MemoryRouterProps.initialEntries} props.initialEntries n/a
* @param {MemoryRouterProps.initialIndex} props.initialIndex n/a
* @param {MemoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative in-memory {@link Router | `<Router>`} for client-side
* routing.
*/ function $cc78a6e3ef89ca34$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $5NSbj.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $573a89bde77cb3ae$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $5NSbj.useState({
        action: history.action,
        location: history.location
    });
    let setState = $5NSbj.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $5NSbj.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $5NSbj.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $5NSbj.createElement($cc78a6e3ef89ca34$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A component-based version of {@link useNavigate} to use in a
* [`React.Component` class](https://react.dev/reference/react/Component) where
* hooks cannot be used.
*
* It's recommended to avoid using this component in favor of {@link useNavigate}.
*
* @example
* <Navigate to="/tasks" />
*
* @public
* @category Components
* @param props Props
* @param {NavigateProps.relative} props.relative n/a
* @param {NavigateProps.replace} props.replace n/a
* @param {NavigateProps.state} props.state n/a
* @param {NavigateProps.to} props.to n/a
* @returns {void}
*
*/ function $cc78a6e3ef89ca34$export$444b3ab0cb9aec40({ to: to, replace: replace, state: state, relative: relative }) {
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)((0, $4a2ef0180f3aa5fe$export$9c954a9d03d32f4a)(), `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $5NSbj.useContext((0, $18b65179e9a5902f$export$3044ab7fdabeaee6));
    (0, $573a89bde77cb3ae$export$491112666e282270)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $5NSbj.useContext((0, $18b65179e9a5902f$export$aac280ed165a4397));
    let { pathname: locationPathname } = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    let navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    let path = (0, $71ae0bb7947fe91a$export$cae722b0cc860f13)(to, (0, $71ae0bb7947fe91a$export$fe6dbc5de95f53ab)(matches), locationPathname, relative === "path");
    (0, $474e8f43e2235ddf$export$6c8e41f66e7aa990)(typeof to === "string" ? to : (0, $573a89bde77cb3ae$export$fe53371bee54353d)(to), navigator.createHref(path), (0, $474e8f43e2235ddf$export$1da545bc000055cf)(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $5NSbj.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
* Renders the matching child route of a parent route or nothing if no child
* route matches.
*
* @example
* import { Outlet } from "react-router";
*
* export default function SomeParent() {
*   return (
*     <div>
*       <h1>Parent Content</h1>
*       <Outlet />
*     </div>
*   );
* }
*
* @public
* @category Components
* @param props Props
* @param {OutletProps.context} props.context n/a
* @returns React element for the rendered outlet or `null` if no child route matches.
*/ function $cc78a6e3ef89ca34$export$910ae8079b2c2852(props) {
    return (0, $4a2ef0180f3aa5fe$export$a3be3530d8e40d0b)(props.context);
}
/**
* Configures an element to render when a pattern matches the current location.
* It must be rendered within a {@link Routes} element. Note that these routes
* do not participate in data loading, actions, code splitting, or any other
* route module features.
*
* @example
* // Usually used in a declarative router
* function App() {
*   return (
*     <BrowserRouter>
*       <Routes>
*         <Route index element={<StepOne />} />
*         <Route path="step-2" element={<StepTwo />} />
*         <Route path="step-3" element={<StepThree />} />
*       </Routes>
*    </BrowserRouter>
*   );
* }
*
* // But can be used with a data router as well if you prefer the JSX notation
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @public
* @category Components
* @param props Props
* @param {PathRouteProps.action} props.action n/a
* @param {PathRouteProps.caseSensitive} props.caseSensitive n/a
* @param {PathRouteProps.Component} props.Component n/a
* @param {PathRouteProps.children} props.children n/a
* @param {PathRouteProps.element} props.element n/a
* @param {PathRouteProps.ErrorBoundary} props.ErrorBoundary n/a
* @param {PathRouteProps.errorElement} props.errorElement n/a
* @param {PathRouteProps.handle} props.handle n/a
* @param {PathRouteProps.HydrateFallback} props.HydrateFallback n/a
* @param {PathRouteProps.hydrateFallbackElement} props.hydrateFallbackElement n/a
* @param {PathRouteProps.id} props.id n/a
* @param {PathRouteProps.index} props.index n/a
* @param {PathRouteProps.lazy} props.lazy n/a
* @param {PathRouteProps.loader} props.loader n/a
* @param {PathRouteProps.path} props.path n/a
* @param {PathRouteProps.shouldRevalidate} props.shouldRevalidate n/a
* @returns {void}
*/ function $cc78a6e3ef89ca34$export$e7b0ac011bb776c6(props) {
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
* Provides location context for the rest of the app.
*
* Note: You usually won't render a `<Router>` directly. Instead, you'll render a
* router that is more specific to your environment such as a {@link BrowserRouter}
* in web browsers or a {@link ServerRouter} for server rendering.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {RouterProps.basename} props.basename n/a
* @param {RouterProps.children} props.children n/a
* @param {RouterProps.location} props.location n/a
* @param {RouterProps.navigationType} props.navigationType n/a
* @param {RouterProps.navigator} props.navigator n/a
* @param {RouterProps.static} props.static n/a
* @param {RouterProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router or `null` if the location does
* not match the {@link props.basename}
*/ function $cc78a6e3ef89ca34$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP", navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(!(0, $4a2ef0180f3aa5fe$export$9c954a9d03d32f4a)(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $5NSbj.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = (0, $573a89bde77cb3ae$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $5NSbj.useMemo(()=>{
        let trailingPathname = (0, $71ae0bb7947fe91a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    (0, $573a89bde77cb3ae$export$491112666e282270)(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$3044ab7fdabeaee6).Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$e6a44b110a0c44d3).Provider, {
        children: children,
        value: locationContext
    }));
}
/**
* Renders a branch of {@link Route | `<Route>`s} that best matches the current
* location. Note that these routes do not participate in [data loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action), code splitting, or
* any other [route module](../../start/framework/route-module) features.
*
* @example
* import { Route, Routes } from "react-router";
*
* <Routes>
*   <Route index element={<StepOne />} />
*   <Route path="step-2" element={<StepTwo />} />
*   <Route path="step-3" element={<StepThree />} />
* </Routes>
*
* @public
* @category Components
* @param props Props
* @param {RoutesProps.children} props.children n/a
* @param {RoutesProps.location} props.location n/a
* @returns React element for the rendered routes or `null` if no route matches
*/ function $cc78a6e3ef89ca34$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return (0, $4a2ef0180f3aa5fe$export$5d3fca4a98652595)($cc78a6e3ef89ca34$export$16da398f5434bdec(children), location);
}
/**
* Used to render promise values with automatic error handling.
*
* **Note:** `<Await>` expects to be rendered inside a [`<React.Suspense>`](https://react.dev/reference/react/Suspense)
*
* @example
* import { Await, useLoaderData } from "react-router";
*
* export async function loader() {
*   // not awaited
*   const reviews = getReviews();
*   // awaited (blocks the transition)
*   const book = await fetch("/api/book").then((res) => res.json());
*   return { book, reviews };
* }
*
* function Book() {
*   const { book, reviews } = useLoaderData();
*   return (
*     <div>
*       <h1>{book.title}</h1>
*       <p>{book.description}</p>
*       <React.Suspense fallback={<ReviewsSkeleton />}>
*         <Await
*           resolve={reviews}
*           errorElement={
*             <div>Could not load reviews 😬</div>
*           }
*           children={(resolvedReviews) => (
*             <Reviews items={resolvedReviews} />
*           )}
*         />
*       </React.Suspense>
*     </div>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {AwaitProps.children} props.children n/a
* @param {AwaitProps.errorElement} props.errorElement n/a
* @param {AwaitProps.resolve} props.resolve n/a
* @returns React element for the rendered awaited value
*/ function $cc78a6e3ef89ca34$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $5NSbj.useContext((0, $18b65179e9a5902f$export$2eeee58951ff3c1c));
    let dataRouterStateContext = $5NSbj.useContext((0, $18b65179e9a5902f$export$315e3ffb01f217));
    let onError = $5NSbj.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: (0, $71ae0bb7947fe91a$export$d738435097971c09)(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $5NSbj.createElement($cc78a6e3ef89ca34$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $5NSbj.createElement($cc78a6e3ef89ca34$var$ResolveAwait, null, children));
}
var $cc78a6e3ef89ca34$var$AwaitErrorBoundary = class extends $5NSbj.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0;
        if (!(resolve instanceof Promise)) {
            status = 1;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 : "_data" in promise ? 1 : 0;
        } else {
            status = 0;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 && !errorElement) throw promise._error;
        if (status === 2) return /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$804c460aade54ac8).Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1) return /* @__PURE__ */ $5NSbj.createElement((0, $18b65179e9a5902f$export$804c460aade54ac8).Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $cc78a6e3ef89ca34$var$ResolveAwait({ children: children }) {
    let data = (0, $4a2ef0180f3aa5fe$export$78a72ddb39bdd145)();
    let toRender = typeof children === "function" ? children(data) : children;
    return /* @__PURE__ */ $5NSbj.createElement($5NSbj.Fragment, null, toRender);
}
/**
* Creates a route config from a React "children" object, which is usually
* either a `<Route>` element or an array of them. Used internally by
* `<Routes>` to create a route config from its children.
*
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ function $cc78a6e3ef89ca34$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $5NSbj.Children.forEach(children, (element, index)=>{
        if (!$5NSbj.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $5NSbj.Fragment) {
            routes.push.apply(routes, $cc78a6e3ef89ca34$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(element.type === $cc78a6e3ef89ca34$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        let props = element.props;
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(!props.index || !props.children, "An index route cannot have child routes.");
        let route = {
            id: props.id || treePath.join("-"),
            caseSensitive: props.caseSensitive,
            element: props.element,
            Component: props.Component,
            index: props.index,
            path: props.path,
            middleware: props.middleware,
            loader: props.loader,
            action: props.action,
            hydrateFallbackElement: props.hydrateFallbackElement,
            HydrateFallback: props.HydrateFallback,
            errorElement: props.errorElement,
            ErrorBoundary: props.ErrorBoundary,
            shouldRevalidate: props.shouldRevalidate,
            handle: props.handle,
            lazy: props.lazy
        };
        if (props.children) route.children = $cc78a6e3ef89ca34$export$16da398f5434bdec(props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
* Create route objects from JSX elements instead of arrays of objects.
*
* @example
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @name createRoutesFromElements
* @public
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* This is used for internal recursion and is not intended to be used by the
* application developer.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ const $cc78a6e3ef89ca34$export$9b5b6d122dea0c88 = $cc78a6e3ef89ca34$export$16da398f5434bdec;
/**
* Renders the result of {@link matchRoutes} into a React element.
*
* @public
* @category Utils
* @param matches The array of {@link RouteMatch | route matches} to render
* @returns A React element that renders the matched routes or `null` if no matches
*/ function $cc78a6e3ef89ca34$export$daf73786167a7f72(matches) {
    return (0, $4a2ef0180f3aa5fe$export$569816e95a012c39)(matches);
}
function $cc78a6e3ef89ca34$var$useRouteComponentProps() {
    return {
        params: (0, $4a2ef0180f3aa5fe$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $4a2ef0180f3aa5fe$export$1448a5050d252c4d)(),
        actionData: (0, $4a2ef0180f3aa5fe$export$fdc00f3f26066d5e)(),
        matches: (0, $4a2ef0180f3aa5fe$export$2378eb7f5ff86053)()
    };
}
function $cc78a6e3ef89ca34$export$6c4f3826290c37af({ children: children }) {
    const props = $cc78a6e3ef89ca34$var$useRouteComponentProps();
    return $5NSbj.cloneElement(children, props);
}
function $cc78a6e3ef89ca34$export$1a5de91a5c3255e0(Component) {
    return function WithComponentProps() {
        const props = $cc78a6e3ef89ca34$var$useRouteComponentProps();
        return $5NSbj.createElement(Component, props);
    };
}
function $cc78a6e3ef89ca34$var$useHydrateFallbackProps() {
    return {
        params: (0, $4a2ef0180f3aa5fe$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $4a2ef0180f3aa5fe$export$1448a5050d252c4d)(),
        actionData: (0, $4a2ef0180f3aa5fe$export$fdc00f3f26066d5e)()
    };
}
function $cc78a6e3ef89ca34$export$f8cff34f39c1932a({ children: children }) {
    const props = $cc78a6e3ef89ca34$var$useHydrateFallbackProps();
    return $5NSbj.cloneElement(children, props);
}
function $cc78a6e3ef89ca34$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps() {
        const props = $cc78a6e3ef89ca34$var$useHydrateFallbackProps();
        return $5NSbj.createElement(HydrateFallback, props);
    };
}
function $cc78a6e3ef89ca34$var$useErrorBoundaryProps() {
    return {
        params: (0, $4a2ef0180f3aa5fe$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $4a2ef0180f3aa5fe$export$1448a5050d252c4d)(),
        actionData: (0, $4a2ef0180f3aa5fe$export$fdc00f3f26066d5e)(),
        error: (0, $4a2ef0180f3aa5fe$export$ed527bf60f6e05f2)()
    };
}
function $cc78a6e3ef89ca34$export$e5afde5c4b6d747b({ children: children }) {
    const props = $cc78a6e3ef89ca34$var$useErrorBoundaryProps();
    return $5NSbj.cloneElement(children, props);
}
function $cc78a6e3ef89ca34$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps() {
        const props = $cc78a6e3ef89ca34$var$useErrorBoundaryProps();
        return $5NSbj.createElement(ErrorBoundary, props);
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

const $901b6e094b303fb5$var$defaultEncType = "application/x-www-form-urlencoded";
function $901b6e094b303fb5$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $901b6e094b303fb5$var$isButtonElement(object) {
    return $901b6e094b303fb5$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $901b6e094b303fb5$var$isFormElement(object) {
    return $901b6e094b303fb5$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $901b6e094b303fb5$var$isInputElement(object) {
    return $901b6e094b303fb5$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $901b6e094b303fb5$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $901b6e094b303fb5$export$4c2d35dce1b682e(event, target) {
    return event.button === 0 && (!target || target === "_self") && !$901b6e094b303fb5$var$isModifiedEvent(event);
}
/**
* Creates a URLSearchParams object using the given initializer.
*
* This is identical to `new URLSearchParams(init)` except it also supports
* arrays as values in the object form of the initializer instead of just
* strings. This is convenient when you need multiple values for a given key,
* but don't want to use an array initializer.
*
* @example
* // Instead of:
* let searchParams = new URLSearchParams([
*   ["sort", "name"],
*   ["sort", "price"],
* ]);
*
* // You can do:
* let searchParams = createSearchParams({
*   sort: ["name", "price"],
* });
*
* @public
* @category Utils
* @param init The value used to initialize the URL search parameters.
* @returns A URLSearchParams object containing the initialized search
* parameters.
*/ function $901b6e094b303fb5$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $901b6e094b303fb5$export$4370c962fe3096e6(locationSearch, defaultSearchParams) {
    let searchParams = $901b6e094b303fb5$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
let $901b6e094b303fb5$var$_formDataSupportsSubmitter = null;
function $901b6e094b303fb5$var$isFormDataSubmitterSupported() {
    if ($901b6e094b303fb5$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), 0);
        $901b6e094b303fb5$var$_formDataSupportsSubmitter = false;
    } catch  {
        $901b6e094b303fb5$var$_formDataSupportsSubmitter = true;
    }
    return $901b6e094b303fb5$var$_formDataSupportsSubmitter;
}
const $901b6e094b303fb5$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $901b6e094b303fb5$var$getFormEncType(encType) {
    if (encType != null && !$901b6e094b303fb5$var$supportedFormEncTypes.has(encType)) {
        (0, $573a89bde77cb3ae$export$491112666e282270)(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$901b6e094b303fb5$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $901b6e094b303fb5$export$80917616746b9ab4(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($901b6e094b303fb5$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? (0, $71ae0bb7947fe91a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || "get";
        encType = $901b6e094b303fb5$var$getFormEncType(target.getAttribute("enctype")) || $901b6e094b303fb5$var$defaultEncType;
        formData = new FormData(target);
    } else if ($901b6e094b303fb5$var$isButtonElement(target) || $901b6e094b303fb5$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $71ae0bb7947fe91a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || "get";
        encType = $901b6e094b303fb5$var$getFormEncType(target.getAttribute("formenctype")) || $901b6e094b303fb5$var$getFormEncType(form.getAttribute("enctype")) || $901b6e094b303fb5$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$901b6e094b303fb5$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($901b6e094b303fb5$var$isHtmlElement(target)) throw new Error("Cannot submit element that is not <form>, <button>, or <input type=\"submit|image\">");
    else {
        method = "get";
        action = null;
        encType = $901b6e094b303fb5$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/markup.ts
const $af58c0c8e2a925bb$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
const $af58c0c8e2a925bb$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $af58c0c8e2a925bb$export$4cf11838cdc2a8a8(html) {
    return html.replace($af58c0c8e2a925bb$var$ESCAPE_REGEX, (match)=>$af58c0c8e2a925bb$var$ESCAPE_LOOKUP[match]);
}
function $af58c0c8e2a925bb$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/invariant.ts
function $c329193cf46f039b$export$2e2bcd8739ae039(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/routeModules.ts
var $e7d332d2d56a253f$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/production/lib/dom/ssr/routeModules.js"
});
async function $e7d332d2d56a253f$export$d9c4a4e8105733a6(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && $e7d332d2d56a253f$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}


//#region lib/dom/ssr/links.ts
/**
* Gets all the links for a set of matches. The modules are assumed to have been
* loaded already.
*/ function $8e90b9de414d2ae0$export$c43eb07eab2c950a(matches, routeModules, manifest) {
    return $8e90b9de414d2ae0$var$dedupeLinkDescriptors(matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2), $8e90b9de414d2ae0$export$442b9e023f41af00(matches, manifest));
}
function $8e90b9de414d2ae0$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $8e90b9de414d2ae0$export$2ee8f5601ba37b41(route) {
    if (!route.css) return;
    let descriptors = $8e90b9de414d2ae0$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($8e90b9de414d2ae0$var$prefetchStyleLink));
}
async function $8e90b9de414d2ae0$export$26f28bc6dfd6cfc6(route, routeModule) {
    if (!route.css && !routeModule.links || !$8e90b9de414d2ae0$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$8e90b9de414d2ae0$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$8e90b9de414d2ae0$export$aea1aca0de10baae(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($8e90b9de414d2ae0$var$prefetchStyleLink));
}
async function $8e90b9de414d2ae0$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $8e90b9de414d2ae0$export$aea1aca0de10baae(object) {
    return object != null && typeof object.page === "string";
}
function $8e90b9de414d2ae0$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $8e90b9de414d2ae0$export$98f31d7a23772264(matches, manifest, routeModules) {
    return $8e90b9de414d2ae0$var$dedupeLinkDescriptors((await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await (0, $e7d332d2d56a253f$export$d9c4a4e8105733a6)(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }))).flat(1).filter($8e90b9de414d2ae0$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $8e90b9de414d2ae0$export$4af547f9516933c(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return currentMatches[index].pathname !== match.pathname || currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"];
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $8e90b9de414d2ae0$export$442b9e023f41af00(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $8e90b9de414d2ae0$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $8e90b9de414d2ae0$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $8e90b9de414d2ae0$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $8e90b9de414d2ae0$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        if (preloads && !$8e90b9de414d2ae0$export$aea1aca0de10baae(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href)) return deduped;
        let key = JSON.stringify($8e90b9de414d2ae0$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
let $8e90b9de414d2ae0$var$_isPreloadSupported;
function $8e90b9de414d2ae0$var$isPreloadSupported() {
    if ($8e90b9de414d2ae0$var$_isPreloadSupported !== void 0) return $8e90b9de414d2ae0$var$_isPreloadSupported;
    let el = document.createElement("link");
    $8e90b9de414d2ae0$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $8e90b9de414d2ae0$var$_isPreloadSupported;
}



/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 



/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/utils.ts
var $25364ac8de4b5c2b$export$85f6557964517f1a = class {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $25364ac8de4b5c2b$export$4786a9f20844482d() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/flatten.ts
const $5b61dfd9f820e3bc$var$TIME_LIMIT_MS = 1;
const $5b61dfd9f820e3bc$var$getNow = ()=>Date.now();
const $5b61dfd9f820e3bc$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $5b61dfd9f820e3bc$export$bffa455ba8c619a6(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return -7;
    if (input === null) return -5;
    if (Number.isNaN(input)) return -2;
    if (input === Number.POSITIVE_INFINITY) return -6;
    if (input === Number.NEGATIVE_INFINITY) return -3;
    if (input === 0 && 1 / input < 0) return -4;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $5b61dfd9f820e3bc$var$stringify.call(this, stack);
    return index;
}
async function $5b61dfd9f820e3bc$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $5b61dfd9f820e3bc$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return -7;
        if (value === null) return -5;
        if (Number.isNaN(value)) return -2;
        if (value === Number.POSITIVE_INFINITY) return -6;
        if (value === Number.NEGATIVE_INFINITY) return -3;
        if (value === 0 && 1 / value < 0) return -4;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $5b61dfd9f820e3bc$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $5b61dfd9f820e3bc$var$TIME_LIMIT_MS) {
            await $5b61dfd9f820e3bc$var$yieldToMain();
            lastYieldTime = $5b61dfd9f820e3bc$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["B","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = /* @__PURE__ */ new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["Y",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `-5`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? flattenValue(input[i]) : -1);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["D",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["U",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["R",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["S",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["S"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["M",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["M"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["P",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["E",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["N",{${partsForObj(input)}}]`;
                        else if ($5b61dfd9f820e3bc$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = /* @__PURE__ */ new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = /* @__PURE__ */ new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $5b61dfd9f820e3bc$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $5b61dfd9f820e3bc$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $5b61dfd9f820e3bc$var$objectProtoNames;
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

//#region vendor/turbo-stream-v2/unflatten.ts
const $0c467f0bf71bf7c6$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $0c467f0bf71bf7c6$export$4315a2af848d75d7(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $0c467f0bf71bf7c6$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $0c467f0bf71bf7c6$var$hydrate.call(this, startIndex);
}
function $0c467f0bf71bf7c6$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case -7:
                set(void 0);
                continue;
            case -5:
                set(null);
                continue;
            case -2:
                set(NaN);
                continue;
            case -6:
                set(Infinity);
                continue;
            case -3:
                set(-Infinity);
                continue;
            case -4:
                set(-0);
                continue;
        }
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case "D":
                        set(hydrated[index] = new Date(b));
                        continue;
                    case "U":
                        set(hydrated[index] = new URL(b));
                        continue;
                    case "B":
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case "R":
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case "Y":
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case "S":
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case "M":
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case "N":
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case "P":
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new (0, $25364ac8de4b5c2b$export$85f6557964517f1a)();
                            deferred[b] = d;
                            set(hydrated[index] = d.promise);
                        }
                        continue;
                    case "E":
                        const [, message, errorType] = value;
                        let error = errorType && $0c467f0bf71bf7c6$var$globalObj && (0, $71ae0bb7947fe91a$export$1a235bd2b33434e5).includes(errorType) && errorType in $0c467f0bf71bf7c6$var$globalObj && typeof $0c467f0bf71bf7c6$var$globalObj[errorType] === "function" ? new $0c467f0bf71bf7c6$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case "Z":
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== -1) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}


//#region vendor/turbo-stream-v2/turbo-stream.ts
async function $b8a1df436bd3e5e5$export$2f872c0f2117be69(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new (0, $25364ac8de4b5c2b$export$85f6557964517f1a)();
    const reader = readable.pipeThrough((0, $25364ac8de4b5c2b$export$4786a9f20844482d)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $b8a1df436bd3e5e5$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $b8a1df436bd3e5e5$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $b8a1df436bd3e5e5$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch  {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: (0, $0c467f0bf71bf7c6$export$4315a2af848d75d7).call(this, line)
    };
}
async function $b8a1df436bd3e5e5$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case "P":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch  {
                        throw new SyntaxError();
                    }
                    const value = (0, $0c467f0bf71bf7c6$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case "E":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch  {
                        throw new SyntaxError();
                    }
                    const value = (0, $0c467f0bf71bf7c6$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $b8a1df436bd3e5e5$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    return new ReadableStream({
        async start (controller) {
            const id = await (0, $5b61dfd9f820e3bc$export$bffa455ba8c619a6).call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || /* @__PURE__ */ new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id = await (0, $5b61dfd9f820e3bc$export$bffa455ba8c619a6).call(encoder, resolved);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`P${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = /* @__PURE__ */ new Error("An unknown error occurred");
                                const id = await (0, $5b61dfd9f820e3bc$export$bffa455ba8c619a6).call(encoder, reason);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`E${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/data.ts
async function $a2261aa064902e54$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}



var $5NSbj = parcelRequire("5NSbj");
//#region lib/dom/ssr/single-fetch.tsx
const $9e2fc6b8781d51bb$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $9e2fc6b8781d51bb$var$SingleFetchNoResultError = class extends Error {
};
const $9e2fc6b8781d51bb$export$e35ccdcde387134d = new Set([
    100,
    101,
    204,
    205
]);
function $9e2fc6b8781d51bb$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $5NSbj.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${(0, $af58c0c8e2a925bb$export$4cf11838cdc2a8a8)(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $5NSbj.createElement($5NSbj.Fragment, null, scriptTag, /* @__PURE__ */ $5NSbj.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $5NSbj.createElement($5NSbj.Fragment, null, scriptTag, /* @__PURE__ */ $5NSbj.createElement($5NSbj.Suspense, null, /* @__PURE__ */ $5NSbj.createElement($9e2fc6b8781d51bb$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $9e2fc6b8781d51bb$export$77d7799427e365da(getRouter, manifest, routeModules, ssr) {
    let dataStrategy = $9e2fc6b8781d51bb$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        (0, $c329193cf46f039b$export$2e2bcd8739ae039)(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $9e2fc6b8781d51bb$var$fetchAndDecodeViaTurboStream, ssr);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $9e2fc6b8781d51bb$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $9e2fc6b8781d51bb$var$singleFetchActionStrategy(args, fetchAndDecode);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $9e2fc6b8781d51bb$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode);
        if (fetcherKey) return $9e2fc6b8781d51bb$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode);
        return $9e2fc6b8781d51bb$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut);
    };
}
async function $9e2fc6b8781d51bb$var$singleFetchActionStrategy(args, fetchAndDecode) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $c329193cf46f039b$export$2e2bcd8739ae039)(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        return await handler(async ()=>{
            let { data: data, status: status } = await fetchAndDecode(args, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $9e2fc6b8781d51bb$var$unwrapSingleFetchResult(data, actionMatch.route.id);
        });
    });
    if ((0, $e9436205c8a93fd8$export$3f1eb41d9a6a6a27)(result.result) || (0, $71ae0bb7947fe91a$export$972111febbeef05b)(result.result) || (0, $e9436205c8a93fd8$export$e0163cfdf7bc9cfa)(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: (0, $71ae0bb7947fe91a$export$4051a07651545597)(result.result, actionStatus)
        }
    };
}
async function $9e2fc6b8781d51bb$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map(async (m)=>{
        let routeId = m.route.id;
        results[routeId] = await m.resolve(async (handler)=>{
            let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return hasClientLoader ? handler(async ()=>{
                let { data: data } = await fetchAndDecode(args, [
                    routeId
                ]);
                return $9e2fc6b8781d51bb$var$unwrapSingleFetchResult(data, routeId);
            }) : handler();
        });
    }));
    return results;
}
async function $9e2fc6b8781d51bb$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$9e2fc6b8781d51bb$var$createDeferred());
    let singleFetchDfd = $9e2fc6b8781d51bb$var$createDeferred();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            if (!m.shouldCallHandler(defaultShouldRevalidate)) {
                foundOptOutRoute ||= m.shouldRevalidateArgs != null && hasLoader;
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    results[routeId] = {
                        type: "data",
                        result: await handler(async ()=>{
                            let { data: data } = await fetchAndDecode(args, [
                                routeId
                            ]);
                            return $9e2fc6b8781d51bb$var$unwrapSingleFetchResult(data, routeId);
                        })
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                results[routeId] = {
                    type: "data",
                    result: await handler(async ()=>{
                        return $9e2fc6b8781d51bb$var$unwrapSingleFetchResult(await singleFetchDfd.promise, routeId);
                    })
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    if ((!router.state.initialized && router.state.navigation.state === "idle" || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data = await fetchAndDecode(args, targetRoutes);
            singleFetchDfd.resolve(data.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $9e2fc6b8781d51bb$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $9e2fc6b8781d51bb$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $9e2fc6b8781d51bb$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch  {}
}
async function $9e2fc6b8781d51bb$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $c329193cf46f039b$export$2e2bcd8739ae039)(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data } = await fetchAndDecode(args, [
                routeId
            ]);
            return $9e2fc6b8781d51bb$var$unwrapSingleFetchResult(data, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $9e2fc6b8781d51bb$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $9e2fc6b8781d51bb$export$7b977381851b2c(reqUrl, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
    else url.pathname = `${url.pathname}.${extension}`;
    return url;
}
async function $9e2fc6b8781d51bb$var$fetchAndDecodeViaTurboStream(args, targetRoutes) {
    let { request: request } = args;
    let url = $9e2fc6b8781d51bb$export$7b977381851b2c(request.url, "data");
    if (request.method === "GET") {
        url = $9e2fc6b8781d51bb$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await (0, $a2261aa064902e54$export$a30aa2a0fce6c468)(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $71ae0bb7947fe91a$export$f2680fa305b734ca)(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: 202,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($9e2fc6b8781d51bb$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    (0, $c329193cf46f039b$export$2e2bcd8739ae039)(res.body, "No response body to decode");
    try {
        let decoded = await $9e2fc6b8781d51bb$export$4023ad4ecd4126a2(res.body, window);
        let data;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($9e2fc6b8781d51bb$export$60644022b8b46aaa in typed) data = {
                redirect: typed[$9e2fc6b8781d51bb$export$60644022b8b46aaa]
            };
            else data = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            (0, $c329193cf46f039b$export$2e2bcd8739ae039)(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data = {
                redirect: typed
            };
            else data = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data
        };
    } catch (cause) {
        throw new Error("Unable to decode turbo-stream response", {
            cause: cause
        });
    }
}
function $9e2fc6b8781d51bb$export$4023ad4ecd4126a2(body, global) {
    return (0, $b8a1df436bd3e5e5$export$2f872c0f2117be69)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && (0, $71ae0bb7947fe91a$export$1a235bd2b33434e5).includes(name) && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data, status, statusText] = rest;
                    return {
                        value: new (0, $71ae0bb7947fe91a$export$f2680fa305b734ca)(status, statusText, data)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$9e2fc6b8781d51bb$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $9e2fc6b8781d51bb$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace, status: status } = result.redirect;
        throw (0, $71ae0bb7947fe91a$export$89e12c5b50f7529d)(location, {
            status: status,
            headers: {
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $9e2fc6b8781d51bb$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $9e2fc6b8781d51bb$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch  {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch  {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $5NSbj = parcelRequire("5NSbj");
//#region lib/dom/ssr/errorBoundaries.tsx
var $a6d40ef4cee22f76$export$32e57f52df4b6e34 = class extends $5NSbj.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $5NSbj.createElement($a6d40ef4cee22f76$export$20b33acd14692c9, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
/**
* When app's don't provide a root level ErrorBoundary, we default to this.
*/ function $a6d40ef4cee22f76$export$20b33acd14692c9({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = (0, $dbf4ca4378b6e653$export$17134ff624fc6bc2)();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $5NSbj.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $71ae0bb7947fe91a$export$972111febbeef05b)(error)) return /* @__PURE__ */ $5NSbj.createElement($a6d40ef4cee22f76$export$cf8626ebc6a4ba63, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $5NSbj.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $5NSbj.createElement($a6d40ef4cee22f76$export$cf8626ebc6a4ba63, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $5NSbj.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $5NSbj.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $a6d40ef4cee22f76$export$cf8626ebc6a4ba63({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = (0, $dbf4ca4378b6e653$export$17134ff624fc6bc2)();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $5NSbj.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $5NSbj.createElement("head", null, /* @__PURE__ */ $5NSbj.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $5NSbj.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $5NSbj.createElement("title", null, title)), /* @__PURE__ */ $5NSbj.createElement("body", null, /* @__PURE__ */ $5NSbj.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $5NSbj.createElement((0, $dbf4ca4378b6e653$export$ff0bf87698939488), null) : null)));
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $5NSbj = parcelRequire("5NSbj");
//#region lib/dom/ssr/fallback.tsx
function $cf4ee396acc78fd3$export$7e8143a7b6df36d9() {
    let { nonce: nonce } = (0, $dbf4ca4378b6e653$export$17134ff624fc6bc2)();
    return /* @__PURE__ */ $5NSbj.createElement((0, $a6d40ef4cee22f76$export$cf8626ebc6a4ba63), {
        title: "Loading...",
        renderScripts: true
    }, null);
}



var $5NSbj = parcelRequire("5NSbj");
//#region lib/dom/ssr/routes.tsx
function $469a1a9e12942981$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $469a1a9e12942981$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component = $469a1a9e12942981$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? (0, $cf4ee396acc78fd3$export$7e8143a7b6df36d9) : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $5NSbj.createElement((0, $a6d40ef4cee22f76$export$20b33acd14692c9), {
            error: (0, $4a2ef0180f3aa5fe$export$ed527bf60f6e05f2)()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component ? {
            element: /* @__PURE__ */ $5NSbj.createElement(routeModule.Layout, null, /* @__PURE__ */ $5NSbj.createElement(Component, null))
        } : {
            Component: Component
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $5NSbj.createElement(routeModule.Layout, null, /* @__PURE__ */ $5NSbj.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $5NSbj.createElement(routeModule.Layout, null, /* @__PURE__ */ $5NSbj.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $469a1a9e12942981$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $469a1a9e12942981$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        (0, $c329193cf46f039b$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$469a1a9e12942981$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $469a1a9e12942981$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $469a1a9e12942981$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $469a1a9e12942981$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $469a1a9e12942981$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $469a1a9e12942981$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let msg = `You are trying to call ${type === "action" ? "serverAction()" : "serverLoader()"} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new (0, $71ae0bb7947fe91a$export$f2680fa305b734ca)(400, "Bad Request", new Error(msg), true);
    }
}
function $469a1a9e12942981$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new (0, $71ae0bb7947fe91a$export$f2680fa305b734ca)(405, "Method Not Allowed", new Error(msg), true);
}
function $469a1a9e12942981$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $469a1a9e12942981$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            (0, $c329193cf46f039b$export$2e2bcd8739ae039)(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $469a1a9e12942981$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route) {
            if (route.clientActionModule) prefetchModule(route.clientActionModule);
            if (route.clientLoaderModule) prefetchModule(route.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? (0, $8e90b9de414d2ae0$export$26f28bc6dfd6cfc6)(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$469a1a9e12942981$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $469a1a9e12942981$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                return await prefetchStylesAndCallHandler(async ()=>{
                    (0, $c329193cf46f039b$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $469a1a9e12942981$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
            };
            dataRoute.loader.hydrate = $469a1a9e12942981$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    (0, $c329193cf46f039b$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $469a1a9e12942981$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $469a1a9e12942981$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $469a1a9e12942981$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $469a1a9e12942981$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    (0, $c329193cf46f039b$export$2e2bcd8739ae039)(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $469a1a9e12942981$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    (0, $c329193cf46f039b$export$2e2bcd8739ae039)(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $469a1a9e12942981$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    (0, $c329193cf46f039b$export$2e2bcd8739ae039)(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $469a1a9e12942981$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $469a1a9e12942981$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $469a1a9e12942981$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $469a1a9e12942981$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? (0, $71ae0bb7947fe91a$export$d726f29eb2425705)(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $469a1a9e12942981$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $469a1a9e12942981$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = (0, $e7d332d2d56a253f$export$d9c4a4e8105733a6)(route, routeModules);
    let prefetchRouteCssPromise = (0, $8e90b9de414d2ae0$export$2ee8f5601ba37b41)(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        (0, $8e90b9de414d2ae0$export$26f28bc6dfd6cfc6)(route, routeModule)
    ]);
    return {
        Component: $469a1a9e12942981$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $469a1a9e12942981$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    if (!(typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0)) return routeModule.default;
}
function $469a1a9e12942981$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}



var $5NSbj = parcelRequire("5NSbj");
//#region lib/dom/ssr/fog-of-war.ts
const $3433e08d3f0a49b0$var$nextPaths = /* @__PURE__ */ new Set();
const $3433e08d3f0a49b0$var$discoveredPathsMaxSize = 1e3;
const $3433e08d3f0a49b0$var$discoveredPaths = /* @__PURE__ */ new Set();
const $3433e08d3f0a49b0$export$b5915cf27fa06b9f = 7680;
function $3433e08d3f0a49b0$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $3433e08d3f0a49b0$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $3433e08d3f0a49b0$export$ae5150779dbcc11a({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = router.match(path);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $3433e08d3f0a49b0$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$3433e08d3f0a49b0$export$741d98b28dbfd(routeDiscovery, ssr)) return;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($3433e08d3f0a49b0$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $3433e08d3f0a49b0$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : (0, $573a89bde77cb3ae$export$fe53371bee54353d)(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $3433e08d3f0a49b0$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $5NSbj.useEffect(()=>{
        if (!$3433e08d3f0a49b0$export$741d98b28dbfd(routeDiscovery, ssr) || window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$3433e08d3f0a49b0$var$discoveredPaths.has(pathname)) $3433e08d3f0a49b0$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($3433e08d3f0a49b0$var$nextPaths.keys()).filter((path)=>{
                if ($3433e08d3f0a49b0$var$discoveredPaths.has(path)) {
                    $3433e08d3f0a49b0$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $3433e08d3f0a49b0$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $3433e08d3f0a49b0$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $3433e08d3f0a49b0$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : (0, $71ae0bb7947fe91a$export$86d9a7913e44197e)([
        basename,
        manifestPath
    ]);
}
const $3433e08d3f0a49b0$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
const $3433e08d3f0a49b0$var$MANIFEST_RELOAD_TIMEOUT = 5e3;
let $3433e08d3f0a49b0$var$pendingManifestReload;
async function $3433e08d3f0a49b0$export$2f7ce2790dc2d211(needsReload, version, errorReloadPath) {
    if ($3433e08d3f0a49b0$var$pendingManifestReload) return $3433e08d3f0a49b0$var$pendingManifestReload;
    if (!needsReload) {
        try {
            sessionStorage.removeItem($3433e08d3f0a49b0$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        return false;
    }
    if (!errorReloadPath) {
        console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
        return true;
    }
    let alreadyReloaded = false;
    try {
        alreadyReloaded = sessionStorage.getItem($3433e08d3f0a49b0$var$MANIFEST_VERSION_STORAGE_KEY) === version;
        if (!alreadyReloaded) sessionStorage.setItem($3433e08d3f0a49b0$var$MANIFEST_VERSION_STORAGE_KEY, version);
    } catch  {}
    if (alreadyReloaded) throw new Error("Unable to discover routes due to manifest version mismatch.");
    let rejectReload;
    let reloadPromise = new Promise((_, reject)=>{
        rejectReload = reject;
    });
    $3433e08d3f0a49b0$var$pendingManifestReload = reloadPromise;
    let failReload = ()=>{
        clearTimeout(timeout);
        window.removeEventListener("pageshow", onPageShow);
        $3433e08d3f0a49b0$var$pendingManifestReload = void 0;
        rejectReload(/* @__PURE__ */ new Error("Unable to discover routes due to manifest version mismatch."));
    };
    let timeout = setTimeout(failReload, $3433e08d3f0a49b0$var$MANIFEST_RELOAD_TIMEOUT);
    let onPageShow = (event)=>{
        if (event.persisted) failReload();
    };
    window.addEventListener("pageshow", onPageShow);
    try {
        window.location.href = errorReloadPath;
        console.warn("Detected manifest version mismatch, reloading...");
    } catch  {
        failReload();
    }
    return reloadPromise;
}
async function $3433e08d3f0a49b0$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $3433e08d3f0a49b0$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($3433e08d3f0a49b0$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > 7680) {
        $3433e08d3f0a49b0$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        if (await $3433e08d3f0a49b0$export$2f7ce2790dc2d211(res.status === 204 && res.headers.has("X-Remix-Reload-Document"), manifest.version, errorReloadPath)) return;
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    if (signal?.aborted) return;
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$3433e08d3f0a49b0$var$addToFifoQueue(p, $3433e08d3f0a49b0$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, (0, $469a1a9e12942981$export$af76e85f27ba0229)(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $3433e08d3f0a49b0$var$addToFifoQueue(path, queue) {
    if (queue.size >= $3433e08d3f0a49b0$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        if (first !== void 0) queue.delete(first);
    }
    queue.add(path);
}
function $3433e08d3f0a49b0$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}



var $5NSbj = parcelRequire("5NSbj");
//#region lib/dom/ssr/components.tsx
const $dbf4ca4378b6e653$export$208d6a3bc3aa62bd = $5NSbj.createContext(void 0);
$dbf4ca4378b6e653$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $dbf4ca4378b6e653$export$17134ff624fc6bc2() {
    let context = $5NSbj.useContext($dbf4ca4378b6e653$export$208d6a3bc3aa62bd);
    (0, $c329193cf46f039b$export$2e2bcd8739ae039)(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $dbf4ca4378b6e653$export$6eb91431f5da407c(prefetch, theirElementProps) {
    let frameworkContext = $5NSbj.useContext($dbf4ca4378b6e653$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $5NSbj.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $5NSbj.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $5NSbj.useRef(null);
    $5NSbj.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: .5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $5NSbj.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $dbf4ca4378b6e653$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $dbf4ca4378b6e653$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $dbf4ca4378b6e653$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $dbf4ca4378b6e653$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $dbf4ca4378b6e653$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $dbf4ca4378b6e653$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $dbf4ca4378b6e653$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$dbf4ca4378b6e653$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
const $dbf4ca4378b6e653$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
/**
* Renders all the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags created by the route module's [`links`](../../start/framework/route-module#links)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Links } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Links />
*       </head>
*       <body></body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {LinksProps.nonce} props.nonce n/a
* @param {LinksProps.crossOrigin} props.crossOrigin n/a
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $dbf4ca4378b6e653$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $dbf4ca4378b6e653$export$17134ff624fc6bc2();
    let { matches: routerMatches } = (0, $4a2ef0180f3aa5fe$export$f93124018767f269)("Links");
    let { errors: errors } = (0, $4a2ef0180f3aa5fe$export$798168c290ba5b3d)("Links");
    let matches = $dbf4ca4378b6e653$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $5NSbj.useMemo(()=>(0, $8e90b9de414d2ae0$export$c43eb07eab2c950a)(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $5NSbj.createElement($5NSbj.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $5NSbj.createElement("style", {
        [$dbf4ca4378b6e653$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $5NSbj.createElement("link", {
        [$dbf4ca4378b6e653$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>(0, $8e90b9de414d2ae0$export$aea1aca0de10baae)(link) ? /* @__PURE__ */ $5NSbj.createElement($dbf4ca4378b6e653$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $5NSbj.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
/**
* Renders [`<link rel=prefetch|modulepreload>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel)
* tags for modules and data of another page to enable an instant navigation to
* that page. [`<Link prefetch>`](./Link#prefetch) uses this internally, but you
* can render it to prefetch a page for any other reason.
*
* For example, you may render one of this as the user types into a search field
* to prefetch search results before they click through to their selection.
*
* @example
* import { PrefetchPageLinks } from "react-router";
*
* <PrefetchPageLinks page="/absolute/path" />
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {PageLinkDescriptor.page} props.page n/a
* @param props.linkProps Additional props to spread onto the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/crossOrigin),
* [`integrity`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/integrity),
* [`rel`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel),
* etc.
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $dbf4ca4378b6e653$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = (0, $18b65179e9a5902f$export$6e1eeb090b3ec35b)();
    let { nonce: contextNonce } = $dbf4ca4378b6e653$export$17134ff624fc6bc2();
    let { router: router } = (0, $4a2ef0180f3aa5fe$export$ae09415e57d46628)("PrefetchPageLinks");
    let matches = $5NSbj.useMemo(()=>router.match(page), [
        router,
        router.routes,
        page
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $5NSbj.createElement($dbf4ca4378b6e653$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $5NSbj.createElement($dbf4ca4378b6e653$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $dbf4ca4378b6e653$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $dbf4ca4378b6e653$export$17134ff624fc6bc2();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $5NSbj.useState([]);
    $5NSbj.useEffect(()=>{
        let interrupted = false;
        (0, $8e90b9de414d2ae0$export$98f31d7a23772264)(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $dbf4ca4378b6e653$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    let dataHrefs = $5NSbj.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = (0, $9e2fc6b8781d51bb$export$7b977381851b2c)(page, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $5NSbj.createElement($5NSbj.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $5NSbj.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $dbf4ca4378b6e653$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    let { manifest: manifest, routeModules: routeModules } = $dbf4ca4378b6e653$export$17134ff624fc6bc2();
    let { matches: matches } = (0, $4a2ef0180f3aa5fe$export$f93124018767f269)("PrefetchPageLinks");
    let { loaderData: loaderData } = (0, $4a2ef0180f3aa5fe$export$798168c290ba5b3d)("PrefetchPageLinks");
    let newMatchesForData = $5NSbj.useMemo(()=>(0, $8e90b9de414d2ae0$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $5NSbj.useMemo(()=>(0, $8e90b9de414d2ae0$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $5NSbj.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = (0, $9e2fc6b8781d51bb$export$7b977381851b2c)(page, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $5NSbj.useMemo(()=>(0, $8e90b9de414d2ae0$export$442b9e023f41af00)(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $dbf4ca4378b6e653$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $5NSbj.createElement($5NSbj.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $5NSbj.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $5NSbj.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>/* @__PURE__ */ $5NSbj.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
/**
* Renders all the [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags created by the route module's [`meta`](../../start/framework/route-module#meta)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Meta } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Meta />
*       </head>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @returns A collection of React elements for [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags
*/ function $dbf4ca4378b6e653$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $dbf4ca4378b6e653$export$17134ff624fc6bc2();
    let { matches: routerMatches } = (0, $4a2ef0180f3aa5fe$export$f93124018767f269)("Meta");
    let { errors: errors, loaderData: loaderData } = (0, $4a2ef0180f3aa5fe$export$798168c290ba5b3d)("Meta");
    let location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    let _matches = $dbf4ca4378b6e653$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            loaderData: data,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            loaderData: data,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $5NSbj.createElement($5NSbj.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$dbf4ca4378b6e653$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $5NSbj.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $5NSbj.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ??= metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $5NSbj.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $5NSbj.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: (0, $af58c0c8e2a925bb$export$4cf11838cdc2a8a8)(json)
                }
            });
        } catch  {
            return null;
        }
        return /* @__PURE__ */ $5NSbj.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $dbf4ca4378b6e653$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
/**
* Tracks whether hydration is finished, so scripts can be skipped
* during client-side updates.
*/ let $dbf4ca4378b6e653$var$isHydrated = false;
function $dbf4ca4378b6e653$export$3be068dde909e563() {
    $dbf4ca4378b6e653$var$isHydrated = true;
}
/**
* Renders the client runtime of your app. It should be rendered inside the
* [`<body>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/body)
*  of the document.
*
* If server rendering, you can omit `<Scripts/>` and the app will work as a
* traditional web app without JavaScript, relying solely on HTML and browser
* behaviors.
*
* @example
* import { Scripts } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head />
*       <body>
*         <Scripts />
*       </body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param scriptProps Additional props to spread onto the [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement/crossOrigin),
* [`nonce`](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/nonce),
* etc.
* @returns A collection of React elements for [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags
*/ function $dbf4ca4378b6e653$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $dbf4ca4378b6e653$export$17134ff624fc6bc2();
    let { router: router, static: isStatic, staticContext: staticContext } = (0, $4a2ef0180f3aa5fe$export$ae09415e57d46628)("Scripts");
    let { matches: routerMatches } = (0, $4a2ef0180f3aa5fe$export$f93124018767f269)("Scripts");
    let isRSCRouterContext = (0, $18b65179e9a5902f$export$6e1eeb090b3ec35b)();
    let enableFogOfWar = (0, $3433e08d3f0a49b0$export$741d98b28dbfd)(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $dbf4ca4378b6e653$var$getActiveMatches(routerMatches, null, isSpaMode);
    $5NSbj.useEffect(()=>{
        $dbf4ca4378b6e653$export$3be068dde909e563();
    }, []);
    let initialScripts = $5NSbj.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            (0, $c329193cf46f039b$export$2e2bcd8739ae039)(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            return [
                chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n"),
                `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? `window.__reactRouterManifest = ${JSON.stringify((0, $3433e08d3f0a49b0$export$ae5150779dbcc11a)(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $5NSbj.createElement($5NSbj.Fragment, null, /* @__PURE__ */ $5NSbj.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $5NSbj.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $dbf4ca4378b6e653$var$isHydrated || isRSCRouterContext ? [] : [
        ...new Set(manifest.entry.imports.concat((0, $8e90b9de414d2ae0$export$442b9e023f41af00)(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    (0, $757c9f1efeb7812e$export$5b28268982f175ba)(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $dbf4ca4378b6e653$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $5NSbj.createElement($5NSbj.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $5NSbj.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $5NSbj.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $5NSbj.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $5NSbj.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $dbf4ca4378b6e653$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}



var $5NSbj = parcelRequire("5NSbj");
//#region lib/dom/lib.tsx
const $1b28ddd4ebfaf955$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($1b28ddd4ebfaf955$var$isBrowser) window.__reactRouterVersion = "8";
} catch  {}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* and [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $1b28ddd4ebfaf955$export$1f3f55432a00e06d(routes, opts) {
    return (0, $e9436205c8a93fd8$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $573a89bde77cb3ae$export$719fc203c4e16dee)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $1b28ddd4ebfaf955$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $71ae0bb7947fe91a$export$6bc17138063be773),
        hydrationRouteProperties: $cc78a6e3ef89ca34$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $1b28ddd4ebfaf955$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $e9436205c8a93fd8$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $573a89bde77cb3ae$export$b71fdd3798280242)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $1b28ddd4ebfaf955$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $71ae0bb7947fe91a$export$6bc17138063be773),
        hydrationRouteProperties: $cc78a6e3ef89ca34$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $1b28ddd4ebfaf955$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $1b28ddd4ebfaf955$var$deserializeErrors(state.errors)
    };
    return state;
}
function $1b28ddd4ebfaf955$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries)if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $71ae0bb7947fe91a$export$f2680fa305b734ca)(val.status, val.statusText, val.data, val.internal === true);
    else if (val && val.__type === "Error") {
        if (typeof val.__subType === "string" && (0, $71ae0bb7947fe91a$export$1a235bd2b33434e5).includes(val.__subType)) {
            let ErrorConstructor = window[val.__subType];
            if (typeof ErrorConstructor === "function") try {
                let error = new ErrorConstructor(val.message);
                error.stack = "";
                serialized[key] = error;
            } catch  {}
        }
        if (serialized[key] == null) {
            let error = new Error(val.message);
            error.stack = "";
            serialized[key] = error;
        }
    } else serialized[key] = val;
    return serialized;
}
/**
* A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {BrowserRouterProps.basename} props.basename n/a
* @param {BrowserRouterProps.children} props.children n/a
* @param {BrowserRouterProps.useTransitions} props.useTransitions n/a
* @param {BrowserRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*/ function $1b28ddd4ebfaf955$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $5NSbj.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $573a89bde77cb3ae$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $5NSbj.useState({
        action: history.action,
        location: history.location
    });
    let setState = $5NSbj.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $5NSbj.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $5NSbj.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $5NSbj.createElement((0, $cc78a6e3ef89ca34$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores the location in the
* [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash) portion
* of the URL so it is not sent to the server.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HashRouterProps.basename} props.basename n/a
* @param {HashRouterProps.children} props.children n/a
* @param {HashRouterProps.useTransitions} props.useTransitions n/a
* @param {HashRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash)
* for client-side routing.
*/ function $1b28ddd4ebfaf955$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $5NSbj.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $573a89bde77cb3ae$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $5NSbj.useState({
        action: history.action,
        location: history.location
    });
    let setState = $5NSbj.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $5NSbj.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $5NSbj.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $5NSbj.createElement((0, $cc78a6e3ef89ca34$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that accepts a pre-instantiated
* `history` object.
* It's important to note that using your own `history` object is highly discouraged
* and may add two versions of the `history` library to your bundles unless you use
* the same version of the `history` library that React Router uses internally.
*
* @name unstable_HistoryRouter
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HistoryRouterProps.basename} props.basename n/a
* @param {HistoryRouterProps.children} props.children n/a
* @param {HistoryRouterProps.history} props.history n/a
* @param {HistoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative {@link Router | `<Router>`} using the provided history
* implementation for client-side routing.
*/ function $1b28ddd4ebfaf955$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $5NSbj.useState({
        action: history.action,
        location: history.location
    });
    let setState = $5NSbj.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $5NSbj.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $5NSbj.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $5NSbj.createElement((0, $cc78a6e3ef89ca34$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$1b28ddd4ebfaf955$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
/**
* A progressively enhanced [`<a href>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a)
* wrapper to enable navigation with client-side routing.
*
* @example
* import { Link } from "react-router";
*
* <Link to="/dashboard">Dashboard</Link>;
*
* <Link
*   to={{
*     pathname: "/some/path",
*     search: "?query=string",
*     hash: "#hash",
*   }}
* />;
*
* @public
* @category Components
* @param {LinkProps.discover} props.discover [modes: framework] n/a
* @param {LinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {LinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {LinkProps.relative} props.relative n/a
* @param {LinkProps.reloadDocument} props.reloadDocument n/a
* @param {LinkProps.replace} props.replace n/a
* @param {LinkProps.state} props.state n/a
* @param {LinkProps.to} props.to n/a
* @param {LinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
* @param {LinkProps.defaultShouldRevalidate} props.defaultShouldRevalidate n/a
* @param {LinkProps.mask} props.mask [modes: framework, data] n/a
*/ const $1b28ddd4ebfaf955$export$a6c7ac8248d6e38a = $5NSbj.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $5NSbj.useContext((0, $18b65179e9a5902f$export$3044ab7fdabeaee6));
    let isAbsolute = typeof to === "string" && (0, $38b29aefca9c076c$export$6c52c2011d568bd0).test(to);
    let parsed = (0, $71ae0bb7947fe91a$export$ac5aeb949e84fd96)(to, basename);
    to = parsed.to;
    let href = (0, $4a2ef0180f3aa5fe$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    let maskedHref = null;
    if (mask) {
        let resolved = (0, $71ae0bb7947fe91a$export$cae722b0cc860f13)(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : (0, $71ae0bb7947fe91a$export$86d9a7913e44197e)([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = (0, $dbf4ca4378b6e653$export$6eb91431f5da407c)(prefetch, rest);
    let internalOnClick = $1b28ddd4ebfaf955$export$67621102c14d847(to, {
        replace: replace,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = /* @__PURE__ */ $5NSbj.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: (0, $dbf4ca4378b6e653$export$c9058316764c140e)(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $5NSbj.createElement($5NSbj.Fragment, null, link, /* @__PURE__ */ $5NSbj.createElement((0, $dbf4ca4378b6e653$export$60dcec93e67386bd), {
        page: href
    })) : link;
});
$1b28ddd4ebfaf955$export$a6c7ac8248d6e38a.displayName = "Link";
/**
* Wraps {@link Link | `<Link>`} with additional props for styling active and
* pending states.
*
* - Automatically applies classes to the link based on its `active` and `pending`
* states, see {@link NavLinkProps.className}
*   - Note that `pending` is only available with Framework and Data modes.
* - Automatically applies `aria-current="page"` to the link when the link is active.
* See [`aria-current`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-current)
* on MDN.
* - States are additionally available through the className, style, and children
* render props. See {@link NavLinkRenderProps}.
*
* @example
* <NavLink to="/message">Messages</NavLink>
*
* // Using render props
* <NavLink
*   to="/messages"
*   className={({ isActive, isPending }) =>
*     isPending ? "pending" : isActive ? "active" : ""
*   }
* >
*   Messages
* </NavLink>
*
* @public
* @category Components
* @param {NavLinkProps.caseSensitive} props.caseSensitive n/a
* @param {NavLinkProps.children} props.children n/a
* @param {NavLinkProps.className} props.className n/a
* @param {NavLinkProps.discover} props.discover [modes: framework] n/a
* @param {NavLinkProps.end} props.end n/a
* @param {NavLinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {NavLinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {NavLinkProps.relative} props.relative n/a
* @param {NavLinkProps.reloadDocument} props.reloadDocument n/a
* @param {NavLinkProps.replace} props.replace n/a
* @param {NavLinkProps.state} props.state n/a
* @param {NavLinkProps.style} props.style n/a
* @param {NavLinkProps.to} props.to n/a
* @param {NavLinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
*/ const $1b28ddd4ebfaf955$export$b0d92dbee9b5b60d = $5NSbj.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = (0, $4a2ef0180f3aa5fe$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    let routerNavigation = $5NSbj.useContext((0, $18b65179e9a5902f$export$2473c5952c6a10d1));
    let { navigator: navigator, basename: basename } = $5NSbj.useContext((0, $18b65179e9a5902f$export$3044ab7fdabeaee6));
    let isTransitioning = routerNavigation != null && $1b28ddd4ebfaf955$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerNavigation?.navigation.location ? routerNavigation.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $71ae0bb7947fe91a$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(endSlashPosition) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $5NSbj.createElement($1b28ddd4ebfaf955$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$1b28ddd4ebfaf955$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
* A progressively enhanced HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form)
* that submits data to actions via [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/fetch),
* activating pending states in {@link useNavigation} which enables advanced
* user interfaces beyond a basic HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
* After a form's `action` completes, all data on the page is automatically
* revalidated to keep the UI in sync with the data.
*
* Because it uses the HTML form API, server rendered pages are interactive at a
* basic level before JavaScript loads. Instead of React Router managing the
* submission, the browser manages the submission as well as the pending states
* (like the spinning favicon). After JavaScript loads, React Router takes over
* enabling web application user experiences.
*
* `Form` is most useful for submissions that should also change the URL or
* otherwise add an entry to the browser history stack. For forms that shouldn't
* manipulate the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, use {@link FetcherWithComponents.Form | `<fetcher.Form>`}.
*
* @example
* import { Form } from "react-router";
*
* function NewEvent() {
*   return (
*     <Form action="/events" method="post">
*       <input name="title" type="text" />
*       <input name="description" type="text" />
*     </Form>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param {FormProps.action} action n/a
* @param {FormProps.discover} discover n/a
* @param {FormProps.encType} encType n/a
* @param {FormProps.fetcherKey} fetcherKey n/a
* @param {FormProps.method} method n/a
* @param {FormProps.navigate} navigate n/a
* @param {FormProps.preventScrollReset} preventScrollReset n/a
* @param {FormProps.relative} relative n/a
* @param {FormProps.reloadDocument} reloadDocument n/a
* @param {FormProps.replace} replace n/a
* @param {FormProps.state} state n/a
* @param {FormProps.viewTransition} viewTransition n/a
* @param {FormProps.defaultShouldRevalidate} defaultShouldRevalidate n/a
* @returns A progressively enhanced [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) component
*/ const $1b28ddd4ebfaf955$export$a7fed597f4b8afd8 = $5NSbj.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = "get", action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $5NSbj.useContext((0, $18b65179e9a5902f$export$3044ab7fdabeaee6));
    let submit = $1b28ddd4ebfaf955$export$47c85c6e3a081d3();
    let formAction = $1b28ddd4ebfaf955$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && (0, $38b29aefca9c076c$export$6c52c2011d568bd0).test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $5NSbj.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $5NSbj.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$1b28ddd4ebfaf955$export$a7fed597f4b8afd8.displayName = "Form";
/**
* Emulates the browser's scroll restoration on location changes. Apps should only render one of these, right before the {@link Scripts} component.
*
* ```tsx
* import { ScrollRestoration } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <body>
*         <ScrollRestoration />
*         <Scripts />
*       </body>
*     </html>
*   );
* }
* ```
*
* This component renders an inline `<script>` to prevent scroll flashing. The
* `nonce` prop will be passed down to the script tag to allow CSP nonce usage.
* If not provided in Framework Mode, it will default to any
* {@link ServerRouter | `<ServerRouter nonce>`} prop.
*
* ```tsx
* <ScrollRestoration nonce={cspNonce} />
* ```
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {ScrollRestorationProps.getKey} props.getKey n/a
* @param {ScriptsProps.nonce} props.nonce n/a
* @param {ScrollRestorationProps.storageKey} props.storageKey n/a
* @returns A [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tag that restores scroll positions on navigation.
*/ function $1b28ddd4ebfaf955$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $5NSbj.useContext((0, $dbf4ca4378b6e653$export$208d6a3bc3aa62bd));
    let { basename: basename } = $5NSbj.useContext((0, $18b65179e9a5902f$export$3044ab7fdabeaee6));
    let location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    let matches = (0, $4a2ef0180f3aa5fe$export$2378eb7f5ff86053)();
    $1b28ddd4ebfaf955$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $5NSbj.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $1b28ddd4ebfaf955$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let storedY = JSON.parse(sessionStorage.getItem(storageKey) || "{}")[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $5NSbj.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${(0, $af58c0c8e2a925bb$export$4cf11838cdc2a8a8)(JSON.stringify(storageKey || $1b28ddd4ebfaf955$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${(0, $af58c0c8e2a925bb$export$4cf11838cdc2a8a8)(JSON.stringify(ssrKey))})`
        }
    });
}
$1b28ddd4ebfaf955$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
/**
* Handles the click behavior for router {@link Link | `<Link>`} components.This
* is useful if you need to create custom {@link Link | `<Link>`} components with
* the same click behavior we use in our exported {@link Link | `<Link>`}.
*
* @public
* @category Hooks
* @param to The URL to navigate to, can be a string or a partial {@link Path}.
* @param options Options
* @param options.preventScrollReset Whether to prevent the scroll position from
* being reset to the top of the viewport on completion of the navigation when
* using the {@link ScrollRestoration} component. Defaults to `false`.
* @param options.relative The {@link RelativeRoutingType | relative routing type}
* to use for the link. Defaults to `"route"`.
* @param options.replace Whether to replace the current [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry instead of pushing a new one. Defaults to `false`.
* @param options.state The state to add to the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry for this navigation. Defaults to `undefined`.
* @param options.target The target attribute for the link. Defaults to `undefined`.
* @param options.viewTransition Enables a [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* for this navigation. To apply specific styles during the transition, see
* {@link useViewTransitionState}. Defaults to `false`.
* @param options.defaultShouldRevalidate Specify the default revalidation
* behavior for the navigation. When not specified, loaders revalidate
* according to the router's standard revalidation behavior.
* @param options.mask Masked location to display in the browser instead
* of the router location. Defaults to `undefined`.
* @param options.useTransitions Wraps the navigation in
* [`React.startTransition`](https://react.dev/reference/react/startTransition)
* for concurrent rendering. Defaults to `false`.
* @returns A click handler function that can be used in a custom {@link Link} component.
*/ function $1b28ddd4ebfaf955$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    let location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    let path = (0, $4a2ef0180f3aa5fe$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $5NSbj.useCallback((event)=>{
        if ((0, $901b6e094b303fb5$export$4c2d35dce1b682e)(event, target)) {
            event.preventDefault();
            let replace = replaceProp !== void 0 ? replaceProp : (0, $573a89bde77cb3ae$export$fe53371bee54353d)(location) === (0, $573a89bde77cb3ae$export$fe53371bee54353d)(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $5NSbj.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
/**
* Returns a tuple of the current URL's [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them. Setting the search params causes a navigation.
*
* ```tsx
* import { useSearchParams } from "react-router";
*
* export function SomeComponent() {
*   const [searchParams, setSearchParams] = useSearchParams();
*   // ...
* }
* ```
*
* ### `setSearchParams` function
*
* The second element of the tuple is a function that can be used to update the
* search params. It accepts the same types as `defaultInit` and will cause a
* navigation to the new URL.
*
* ```tsx
* let [searchParams, setSearchParams] = useSearchParams();
*
* // a search param string
* setSearchParams("?tab=1");
*
* // a shorthand object
* setSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* setSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* setSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* setSearchParams(new URLSearchParams("?tab=1"));
* ```
*
* It also supports a function callback like React's
* [`setState`](https://react.dev/reference/react/useState#setstate):
*
* ```tsx
* setSearchParams((searchParams) => {
*   searchParams.set("tab", "2");
*   return searchParams;
* });
* ```
*
* <docs-warning>The function callback version of `setSearchParams` does not support
* the [queueing](https://react.dev/reference/react/useState#setstate-parameters)
* logic that React's `setState` implements.  Multiple calls to `setSearchParams`
* in the same tick will not build on the prior value.  If you need this behavior,
* you can use `setState` manually.</docs-warning>
*
* ### Notes
*
* Note that `searchParams` is a stable reference, so you can reliably use it
* as a dependency in React's [`useEffect`](https://react.dev/reference/react/useEffect)
* hooks.
*
* ```tsx
* useEffect(() => {
*   console.log(searchParams.get("tab"));
* }, [searchParams]);
* ```
*
* However, this also means it's mutable. If you change the object without
* calling `setSearchParams`, its values will change between renders if some
* other state causes the component to re-render and URL will not reflect the
* values.
*
* @public
* @category Hooks
* @param defaultInit
* You can initialize the search params with a default value, though it **will
* not** change the URL on the first render.
*
* ```tsx
* // a search param string
* useSearchParams("?tab=1");
*
* // a shorthand object
* useSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* useSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* useSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* useSearchParams(new URLSearchParams("?tab=1"));
* ```
* @returns A tuple of the current [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them.
*/ function $1b28ddd4ebfaf955$export$f1a78c17382fe22a(defaultInit) {
    (0, $573a89bde77cb3ae$export$491112666e282270)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let defaultSearchParamsRef = $5NSbj.useRef((0, $901b6e094b303fb5$export$a2e4e2dcc7b1f22f)(defaultInit));
    let hasSetSearchParamsRef = $5NSbj.useRef(false);
    let location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    let searchParams = $5NSbj.useMemo(()=>(0, $901b6e094b303fb5$export$4370c962fe3096e6)(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    return [
        searchParams,
        $5NSbj.useCallback((nextInit, navigateOptions)=>{
            const newSearchParams = (0, $901b6e094b303fb5$export$a2e4e2dcc7b1f22f)(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
            hasSetSearchParamsRef.current = true;
            navigate("?" + newSearchParams, navigateOptions);
        }, [
            navigate,
            searchParams
        ])
    ];
}
let $1b28ddd4ebfaf955$var$fetcherId = 0;
let $1b28ddd4ebfaf955$var$getUniqueFetcherId = ()=>`__${String(++$1b28ddd4ebfaf955$var$fetcherId)}__`;
/**
* The imperative version of {@link Form | `<Form>`} that lets you submit a form
* from code instead of a user interaction.
*
* @example
* import { useSubmit } from "react-router";
*
* function SomeComponent() {
*   const submit = useSubmit();
*   return (
*     <Form onChange={(event) => submit(event.currentTarget)} />
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns A function that can be called to submit a {@link Form} imperatively.
*/ function $1b28ddd4ebfaf955$export$47c85c6e3a081d3() {
    let { router: router } = (0, $4a2ef0180f3aa5fe$export$ae09415e57d46628)("useSubmit");
    let { basename: basename } = $5NSbj.useContext((0, $18b65179e9a5902f$export$3044ab7fdabeaee6));
    let currentRouteId = (0, $4a2ef0180f3aa5fe$export$501a3f562d56eac6)("useSubmit");
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $5NSbj.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = (0, $901b6e094b303fb5$export$80917616746b9ab4)(target, basename);
        if (options.navigate === false) await routerFetch(options.fetcherKey || $1b28ddd4ebfaf955$var$getUniqueFetcherId(), currentRouteId, options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            relative: options.relative,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            flushSync: options.flushSync
        });
        else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            relative: options.relative,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
/**
* Resolves the URL to the closest route in the component hierarchy instead of
* the current URL of the app.
*
* This is used internally by {@link Form} to resolve the `action` to the closest
* route, but can be used generically as well.
*
* ```ts
* import { useFormAction } from "react-router";
*
* function SomeComponent() {
*   // closest route URL
*   let action = useFormAction();
*
*   // closest route URL + "destroy"
*   let destroyAction = useFormAction("destroy");
* }
* ```
*
* <docs-info>This hook adds a `basename` if your app specifies one, so that it
* can be used with raw `<form>` elements in a progressively enhanced way.  If
* you are using this to provide an `action` to `<Form>` or `fetcher.submit`, you
* will need to remove the `basename` since both of those will prepend it
* internally.</docs-info>
*
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param action The action to append to the closest route URL. Defaults to the
* closest route URL.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* action. Defaults to `"route"`.
* @returns The resolved action URL.
*/ function $1b28ddd4ebfaf955$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $5NSbj.useContext((0, $18b65179e9a5902f$export$3044ab7fdabeaee6));
    let routeContext = $5NSbj.useContext((0, $18b65179e9a5902f$export$aac280ed165a4397));
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...(0, $4a2ef0180f3aa5fe$export$e75d2a2d1b3c245b)(action ? action : ".", {
            relative: relative
        })
    };
    let location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        if (indexValues.some((v)=>v === "")) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $71ae0bb7947fe91a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $573a89bde77cb3ae$export$fe53371bee54353d)(path);
}
/**
* Useful for creating complex, dynamic user interfaces that require multiple,
* concurrent data interactions without causing a navigation.
*
* Fetchers track their own, independent state and can be used to load data, submit
* forms, and generally interact with [`action`](../../start/framework/route-module#action)
* and [`loader`](../../start/framework/route-module#loader) functions.
*
* @example
* import { useFetcher } from "react-router"
*
* function SomeComponent() {
*   let fetcher = useFetcher()
*
*   // states are available on the fetcher
*   fetcher.state // "idle" | "loading" | "submitting"
*   fetcher.data // the data returned from the action or loader
*
*   // render a form
*   <fetcher.Form method="post" />
*
*   // load data
*   fetcher.load("/some/route")
*
*   // submit data
*   fetcher.submit(someFormRef, { method: "post" })
*   fetcher.submit(someData, {
*     method: "post",
*     encType: "application/json"
*   })
*
*   // reset fetcher
*   fetcher.reset()
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.key A unique key to identify the fetcher.
*
*
* By default, `useFetcher` generates a unique fetcher scoped to that component.
* If you want to identify a fetcher with your own key such that you can access
* it from elsewhere in your app, you can do that with the `key` option:
*
* ```tsx
* function SomeComp() {
*   let fetcher = useFetcher({ key: "my-key" })
*   // ...
* }
*
* // Somewhere else
* function AnotherComp() {
*   // this will be the same fetcher, sharing the state across the app
*   let fetcher = useFetcher({ key: "my-key" });
*   // ...
* }
* ```
* @returns A {@link FetcherWithComponents} object that contains the fetcher's state, data, and components for submitting forms and loading data.
*/ function $1b28ddd4ebfaf955$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = (0, $4a2ef0180f3aa5fe$export$ae09415e57d46628)("useFetcher");
    let fetchersContext = (0, $4a2ef0180f3aa5fe$export$c6e4e4d7047d4ffe)("useFetcher");
    let routeId = (0, $4a2ef0180f3aa5fe$export$501a3f562d56eac6)("useFetcher");
    let defaultKey = $5NSbj.useId();
    let [fetcherKey, setFetcherKey] = $5NSbj.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $5NSbj.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $5NSbj.useCallback(async (href, opts)=>{
        (0, $573a89bde77cb3ae$export$f5708dca728d7177)(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $1b28ddd4ebfaf955$export$47c85c6e3a081d3();
    let submit = $5NSbj.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $5NSbj.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $5NSbj.useMemo(()=>{
        let FetcherForm = $5NSbj.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $5NSbj.createElement($1b28ddd4ebfaf955$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    let fetcher = fetchersContext.fetchers.get(fetcherKey) || (0, $e9436205c8a93fd8$export$52eace9c284d3585);
    let data = fetchersContext.fetcherData.get(fetcherKey);
    return $5NSbj.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data
    ]);
}
/**
* Returns an array of all in-flight {@link Fetcher}s. This is useful for components
* throughout the app that didn't create the fetchers but want to use their submissions
* to participate in optimistic UI.
*
* @example
* import { useFetchers } from "react-router";
*
* function SomeComponent() {
*   const fetchers = useFetchers();
*   fetchers[0].formData; // FormData
*   fetchers[0].state; // etc.
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of all in-flight {@link Fetcher}s, each with a unique `key`
* property.
*/ function $1b28ddd4ebfaf955$export$fa996778a3a31087() {
    let { fetchers: fetchers } = (0, $4a2ef0180f3aa5fe$export$c6e4e4d7047d4ffe)("useFetchers");
    return $5NSbj.useMemo(()=>Array.from(fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        fetchers
    ]);
}
const $1b28ddd4ebfaf955$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $1b28ddd4ebfaf955$var$savedScrollPositions = {};
function $1b28ddd4ebfaf955$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: (0, $71ae0bb7947fe91a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
/**
* When rendered inside a {@link RouterProvider}, will restore scroll positions
* on navigations
*
* <!--
* Not marked `@public` because we only export as UNSAFE_ and therefore we don't
* maintain an .md file for this hook
* -->
*
* @name UNSAFE_useScrollRestoration
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.getKey A function that returns a key to use for scroll restoration.
* This is useful for custom scroll restoration logic, such as using only the pathname
* so that subsequent navigations to prior paths will restore the scroll. Defaults
* to `location.key`.
* @param options.storageKey The key to use for storing scroll positions in
* `sessionStorage`. Defaults to `"react-router-scroll-positions"`.
* @returns {void}
*/ function $1b28ddd4ebfaf955$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = (0, $4a2ef0180f3aa5fe$export$ae09415e57d46628)("useScrollRestoration");
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = (0, $4a2ef0180f3aa5fe$export$f93124018767f269)("useScrollRestoration");
    let { basename: basename } = $5NSbj.useContext((0, $18b65179e9a5902f$export$3044ab7fdabeaee6));
    let location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    let matches = (0, $4a2ef0180f3aa5fe$export$2378eb7f5ff86053)();
    let navigation = (0, $4a2ef0180f3aa5fe$export$d0fd4b7106de2769)();
    $5NSbj.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $1b28ddd4ebfaf955$var$usePageShow($5NSbj.useCallback((event)=>{
        if (event.persisted) window.history.scrollRestoration = "manual";
    }, []));
    $1b28ddd4ebfaf955$var$usePageHide($5NSbj.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $1b28ddd4ebfaf955$var$getScrollRestorationKey(location, matches, basename, getKey);
            $1b28ddd4ebfaf955$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $1b28ddd4ebfaf955$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($1b28ddd4ebfaf955$var$savedScrollPositions));
        } catch (error) {
            (0, $573a89bde77cb3ae$export$491112666e282270)(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $5NSbj.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $1b28ddd4ebfaf955$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $1b28ddd4ebfaf955$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch  {}
        }, [
            storageKey
        ]);
        $5NSbj.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($1b28ddd4ebfaf955$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location, matches)=>$1b28ddd4ebfaf955$var$getScrollRestorationKey(location, matches, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $5NSbj.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                (0, $573a89bde77cb3ae$export$491112666e282270)(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
* Set up a callback to be fired on [Window's `beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event).
*
* @public
* @category Hooks
* @param callback The callback to be called when the [`beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event)
* is fired.
* @param options Options
* @param options.capture If `true`, the event will be captured during the capture
* phase. Defaults to `false`.
* @returns {void}
*/ function $1b28ddd4ebfaf955$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $5NSbj.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $1b28ddd4ebfaf955$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $5NSbj.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $1b28ddd4ebfaf955$var$usePageShow(callback, options) {
    let { capture: capture } = options || {};
    $5NSbj.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pageshow", callback, opts);
        return ()=>{
            window.removeEventListener("pageshow", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
* Wrapper around {@link useBlocker} to show a [`window.confirm`](https://developer.mozilla.org/en-US/docs/Web/API/Window/confirm)
* prompt to users instead of building a custom UI with {@link useBlocker}.
*
* The `unstable_` flag will not be removed because this technique has a lot of
* rough edges and behaves very differently (and incorrectly sometimes) across
* browsers if users click addition back/forward navigations while the
* confirmation is open. Use at your own risk.
*
* @example
* function ImportantForm() {
*   let [value, setValue] = React.useState("");
*
*   // Block navigating elsewhere when data has been entered into the input
*   unstable_usePrompt({
*     message: "Are you sure?",
*     when: ({ currentLocation, nextLocation }) =>
*       value !== "" &&
*       currentLocation.pathname !== nextLocation.pathname,
*   });
*
*   return (
*     <Form method="post">
*       <label>
*         Enter some important data:
*         <input
*           name="data"
*           value={value}
*           onChange={(e) => setValue(e.target.value)}
*         />
*       </label>
*       <button type="submit">Save</button>
*     </Form>
*   );
* }
*
* @name unstable_usePrompt
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.message The message to show in the confirmation dialog.
* @param options.when A boolean or a function that returns a boolean indicating
* whether to block the navigation. If a function is provided, it will receive an
* object with `currentLocation` and `nextLocation` properties.
* @returns {void}
*/ function $1b28ddd4ebfaf955$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = (0, $4a2ef0180f3aa5fe$export$b273b3273281a049)(when);
    $5NSbj.useEffect(()=>{
        if (blocker.state === "blocked") {
            if (window.confirm(message)) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $5NSbj.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
* This hook returns `true` when there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the specified location matches either side of the navigation (the URL you are
* navigating **to** or the URL you are navigating **from**). This can be used to apply finer-grained styles to
* elements to further customize the view transition. This requires that view
* transitions have been enabled for the given navigation via {@link LinkProps.viewTransition}
* (or the `Form`, `submit`, or `navigate` call)
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param to The {@link To} location to compare against the active transition's current
* and next URLs.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* `to` location, defaults to `"route"`. See {@link RelativeRoutingType} for
* more details.
* @returns `true` if there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the resolved path matches the transition's destination or source pathname, otherwise `false`.
*/ function $1b28ddd4ebfaf955$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $5NSbj.useContext((0, $18b65179e9a5902f$export$3681f408decb40d1));
    (0, $573a89bde77cb3ae$export$f5708dca728d7177)(vtContext != null, "`useViewTransitionState` must be used within `react-router/dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = (0, $4a2ef0180f3aa5fe$export$ae09415e57d46628)("useViewTransitionState");
    let path = (0, $4a2ef0180f3aa5fe$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $71ae0bb7947fe91a$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $71ae0bb7947fe91a$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return (0, $71ae0bb7947fe91a$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $71ae0bb7947fe91a$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $5NSbj = parcelRequire("5NSbj");
/*!
 * Font Awesome Free 7.3.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2026 Fonticons, Inc.
 */ function $9bfddff2bd1f5fe3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $9bfddff2bd1f5fe3$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $9bfddff2bd1f5fe3$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $9bfddff2bd1f5fe3$var$_arrayLikeToArray(r);
}
function $9bfddff2bd1f5fe3$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $9bfddff2bd1f5fe3$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $9bfddff2bd1f5fe3$var$_toPropertyKey(o.key), o);
    }
}
function $9bfddff2bd1f5fe3$var$_createClass(e, r, t) {
    return r && $9bfddff2bd1f5fe3$var$_defineProperties(e.prototype, r), t && $9bfddff2bd1f5fe3$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $9bfddff2bd1f5fe3$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $9bfddff2bd1f5fe3$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var n = 0, F = function() {};
            return {
                s: F,
                n: function() {
                    return n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[n++]
                    };
                },
                e: function(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function() {
            t = t.call(r);
        },
        n: function() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function(r) {
            u = !0, o = r;
        },
        f: function() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $9bfddff2bd1f5fe3$var$_defineProperty(e, r, t) {
    return (r = $9bfddff2bd1f5fe3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9bfddff2bd1f5fe3$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $9bfddff2bd1f5fe3$var$_setPrototypeOf(t, e);
}
function $9bfddff2bd1f5fe3$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $9bfddff2bd1f5fe3$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9bfddff2bd1f5fe3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9bfddff2bd1f5fe3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9bfddff2bd1f5fe3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9bfddff2bd1f5fe3$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9bfddff2bd1f5fe3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9bfddff2bd1f5fe3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9bfddff2bd1f5fe3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9bfddff2bd1f5fe3$var$_setPrototypeOf(t, e) {
    return $9bfddff2bd1f5fe3$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $9bfddff2bd1f5fe3$var$_setPrototypeOf(t, e);
}
function $9bfddff2bd1f5fe3$var$_slicedToArray(r, e) {
    return $9bfddff2bd1f5fe3$var$_arrayWithHoles(r) || $9bfddff2bd1f5fe3$var$_iterableToArrayLimit(r, e) || $9bfddff2bd1f5fe3$var$_unsupportedIterableToArray(r, e) || $9bfddff2bd1f5fe3$var$_nonIterableRest();
}
function $9bfddff2bd1f5fe3$var$_toConsumableArray(r) {
    return $9bfddff2bd1f5fe3$var$_arrayWithoutHoles(r) || $9bfddff2bd1f5fe3$var$_iterableToArray(r) || $9bfddff2bd1f5fe3$var$_unsupportedIterableToArray(r) || $9bfddff2bd1f5fe3$var$_nonIterableSpread();
}
function $9bfddff2bd1f5fe3$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9bfddff2bd1f5fe3$var$_toPropertyKey(t) {
    var i = $9bfddff2bd1f5fe3$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9bfddff2bd1f5fe3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9bfddff2bd1f5fe3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9bfddff2bd1f5fe3$var$_typeof(o);
}
function $9bfddff2bd1f5fe3$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9bfddff2bd1f5fe3$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9bfddff2bd1f5fe3$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9bfddff2bd1f5fe3$var$_wrapRegExp() {
    $9bfddff2bd1f5fe3$var$_wrapRegExp = function(e, r) {
        return new BabelRegExp(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap();
    function BabelRegExp(e, t, p) {
        var o = RegExp(e, t);
        return r.set(o, p || r.get(e)), $9bfddff2bd1f5fe3$var$_setPrototypeOf(o, BabelRegExp.prototype);
    }
    function buildGroups(e, t) {
        var p = r.get(t);
        return Object.keys(p).reduce(function(r, t) {
            var o = p[t];
            if ("number" == typeof o) r[t] = e[o];
            else {
                for(var i = 0; void 0 === e[o[i]] && i + 1 < o.length;)i++;
                r[t] = e[o[i]];
            }
            return r;
        }, Object.create(null));
    }
    return $9bfddff2bd1f5fe3$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = buildGroups(t, this);
            var p = t.indices;
            p && (p.groups = buildGroups(p, this));
        }
        return t;
    }, BabelRegExp.prototype[Symbol.replace] = function(t, p) {
        if ("string" == typeof p) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)(>|$)/g, function(e, r, t) {
                if ("" === t) return e;
                var p = o[r];
                return Array.isArray(p) ? "$" + p.join("$") : "number" == typeof p ? "$" + p : "";
            }));
        }
        if ("function" == typeof p) {
            var i = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, p);
    }, $9bfddff2bd1f5fe3$var$_wrapRegExp.apply(this, arguments);
}
var $9bfddff2bd1f5fe3$var$noop = function noop() {};
var $9bfddff2bd1f5fe3$var$_WINDOW = {};
var $9bfddff2bd1f5fe3$var$_DOCUMENT = {};
var $9bfddff2bd1f5fe3$var$_MUTATION_OBSERVER = null;
var $9bfddff2bd1f5fe3$var$_PERFORMANCE = {
    mark: $9bfddff2bd1f5fe3$var$noop,
    measure: $9bfddff2bd1f5fe3$var$noop
};
try {
    if (typeof window !== 'undefined') $9bfddff2bd1f5fe3$var$_WINDOW = window;
    if (typeof document !== 'undefined') $9bfddff2bd1f5fe3$var$_DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') $9bfddff2bd1f5fe3$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') $9bfddff2bd1f5fe3$var$_PERFORMANCE = performance;
} catch (e) {} // eslint-disable-line no-empty
var $9bfddff2bd1f5fe3$var$_ref = $9bfddff2bd1f5fe3$var$_WINDOW.navigator || {}, $9bfddff2bd1f5fe3$var$_ref$userAgent = $9bfddff2bd1f5fe3$var$_ref.userAgent, $9bfddff2bd1f5fe3$var$userAgent = $9bfddff2bd1f5fe3$var$_ref$userAgent === void 0 ? '' : $9bfddff2bd1f5fe3$var$_ref$userAgent;
var $9bfddff2bd1f5fe3$var$WINDOW = $9bfddff2bd1f5fe3$var$_WINDOW;
var $9bfddff2bd1f5fe3$var$DOCUMENT = $9bfddff2bd1f5fe3$var$_DOCUMENT;
var $9bfddff2bd1f5fe3$var$MUTATION_OBSERVER = $9bfddff2bd1f5fe3$var$_MUTATION_OBSERVER;
var $9bfddff2bd1f5fe3$var$PERFORMANCE = $9bfddff2bd1f5fe3$var$_PERFORMANCE;
var $9bfddff2bd1f5fe3$var$IS_BROWSER = !!$9bfddff2bd1f5fe3$var$WINDOW.document;
var $9bfddff2bd1f5fe3$var$IS_DOM = !!$9bfddff2bd1f5fe3$var$DOCUMENT.documentElement && !!$9bfddff2bd1f5fe3$var$DOCUMENT.head && typeof $9bfddff2bd1f5fe3$var$DOCUMENT.addEventListener === 'function' && typeof $9bfddff2bd1f5fe3$var$DOCUMENT.createElement === 'function';
var $9bfddff2bd1f5fe3$var$IS_IE = ~$9bfddff2bd1f5fe3$var$userAgent.indexOf('MSIE') || ~$9bfddff2bd1f5fe3$var$userAgent.indexOf('Trident/');
var $9bfddff2bd1f5fe3$var$_cl;
var $9bfddff2bd1f5fe3$var$Z = /fa(k|kd|s|r|l|t|d|dr|dl|dt|b|slr|slpr|wsb|tl|ns|nds|es|gt|jr|jfr|jdr|usb|ufsb|udsb|cr|ss|sr|sl|st|sds|sdr|sdl|sdt|sldr|slpdr|pr|ms|vs)?[\-\ ]/, $9bfddff2bd1f5fe3$var$$ = /Font ?Awesome ?([567 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit|Notdog Duo|Notdog|Chisel|Etch|Graphite|Thumbprint|Jelly Fill|Jelly Duo|Jelly|Utility|Utility Fill|Utility Duo|Slab Press|Slab|Slab Duo|Slab Press Duo|Pixel|Mosaic|Vellum|Whiteboard)?.*/i;
var $9bfddff2bd1f5fe3$var$rl = {
    classic: {
        fa: "solid",
        fas: "solid",
        "fa-solid": "solid",
        far: "regular",
        "fa-regular": "regular",
        fal: "light",
        "fa-light": "light",
        fat: "thin",
        "fa-thin": "thin",
        fab: "brands",
        "fa-brands": "brands"
    },
    duotone: {
        fa: "solid",
        fad: "solid",
        "fa-solid": "solid",
        "fa-duotone": "solid",
        fadr: "regular",
        "fa-regular": "regular",
        fadl: "light",
        "fa-light": "light",
        fadt: "thin",
        "fa-thin": "thin"
    },
    sharp: {
        fa: "solid",
        fass: "solid",
        "fa-solid": "solid",
        fasr: "regular",
        "fa-regular": "regular",
        fasl: "light",
        "fa-light": "light",
        fast: "thin",
        "fa-thin": "thin"
    },
    "sharp-duotone": {
        fa: "solid",
        fasds: "solid",
        "fa-solid": "solid",
        fasdr: "regular",
        "fa-regular": "regular",
        fasdl: "light",
        "fa-light": "light",
        fasdt: "thin",
        "fa-thin": "thin"
    },
    slab: {
        "fa-regular": "regular",
        faslr: "regular"
    },
    "slab-press": {
        "fa-regular": "regular",
        faslpr: "regular"
    },
    "slab-duo": {
        "fa-regular": "regular",
        fasldr: "regular"
    },
    "slab-press-duo": {
        "fa-regular": "regular",
        faslpdr: "regular"
    },
    thumbprint: {
        "fa-light": "light",
        fatl: "light"
    },
    vellum: {
        "fa-solid": "solid",
        favs: "solid"
    },
    pixel: {
        "fa-regular": "regular",
        fapr: "regular"
    },
    mosaic: {
        "fa-solid": "solid",
        fams: "solid"
    },
    whiteboard: {
        "fa-semibold": "semibold",
        fawsb: "semibold"
    },
    notdog: {
        "fa-solid": "solid",
        fans: "solid"
    },
    "notdog-duo": {
        "fa-solid": "solid",
        fands: "solid"
    },
    etch: {
        "fa-solid": "solid",
        faes: "solid"
    },
    graphite: {
        "fa-thin": "thin",
        fagt: "thin"
    },
    jelly: {
        "fa-regular": "regular",
        fajr: "regular"
    },
    "jelly-fill": {
        "fa-regular": "regular",
        fajfr: "regular"
    },
    "jelly-duo": {
        "fa-regular": "regular",
        fajdr: "regular"
    },
    chisel: {
        "fa-regular": "regular",
        facr: "regular"
    },
    utility: {
        "fa-semibold": "semibold",
        fausb: "semibold"
    },
    "utility-duo": {
        "fa-semibold": "semibold",
        faudsb: "semibold"
    },
    "utility-fill": {
        "fa-semibold": "semibold",
        faufsb: "semibold"
    }
}, $9bfddff2bd1f5fe3$var$il = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $9bfddff2bd1f5fe3$var$dl = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone",
    "fa-thumbprint",
    "fa-whiteboard",
    "fa-notdog",
    "fa-notdog-duo",
    "fa-chisel",
    "fa-etch",
    "fa-graphite",
    "fa-jelly",
    "fa-jelly-fill",
    "fa-jelly-duo",
    "fa-slab",
    "fa-slab-press",
    "fa-slab-press-duo",
    "fa-slab-duo",
    "fa-mosaic",
    "fa-pixel",
    "fa-vellum",
    "fa-utility",
    "fa-utility-duo",
    "fa-utility-fill"
];
var $9bfddff2bd1f5fe3$var$u = "classic", $9bfddff2bd1f5fe3$var$l = "duotone", $9bfddff2bd1f5fe3$var$h = "sharp", $9bfddff2bd1f5fe3$var$t = "sharp-duotone", $9bfddff2bd1f5fe3$var$g = "chisel", $9bfddff2bd1f5fe3$var$n = "etch", $9bfddff2bd1f5fe3$var$m = "graphite", $9bfddff2bd1f5fe3$var$p = "jelly", $9bfddff2bd1f5fe3$var$s = "jelly-duo", $9bfddff2bd1f5fe3$var$y = "jelly-fill", $9bfddff2bd1f5fe3$var$w = "mosaic", $9bfddff2bd1f5fe3$var$x = "notdog", $9bfddff2bd1f5fe3$var$e = "notdog-duo", $9bfddff2bd1f5fe3$var$b = "pixel", $9bfddff2bd1f5fe3$var$c = "slab", $9bfddff2bd1f5fe3$var$o = "slab-duo", $9bfddff2bd1f5fe3$var$I = "slab-press", $9bfddff2bd1f5fe3$var$a = "slab-press-duo", $9bfddff2bd1f5fe3$var$r = "thumbprint", $9bfddff2bd1f5fe3$var$v = "utility", $9bfddff2bd1f5fe3$var$i = "utility-duo", $9bfddff2bd1f5fe3$var$F = "utility-fill", $9bfddff2bd1f5fe3$var$d = "vellum", $9bfddff2bd1f5fe3$var$S = "whiteboard", $9bfddff2bd1f5fe3$var$A = "Classic", $9bfddff2bd1f5fe3$var$P = "Duotone", $9bfddff2bd1f5fe3$var$j = "Sharp", $9bfddff2bd1f5fe3$var$B = "Sharp Duotone", $9bfddff2bd1f5fe3$var$N = "Chisel", $9bfddff2bd1f5fe3$var$D = "Etch", $9bfddff2bd1f5fe3$var$k = "Graphite", $9bfddff2bd1f5fe3$var$T = "Jelly", $9bfddff2bd1f5fe3$var$C = "Jelly Duo", $9bfddff2bd1f5fe3$var$W = "Jelly Fill", $9bfddff2bd1f5fe3$var$R = "Mosaic", $9bfddff2bd1f5fe3$var$K = "Notdog", $9bfddff2bd1f5fe3$var$L = "Notdog Duo", $9bfddff2bd1f5fe3$var$U = "Pixel", $9bfddff2bd1f5fe3$var$J = "Slab", $9bfddff2bd1f5fe3$var$_ = "Slab Duo", $9bfddff2bd1f5fe3$var$M = "Slab Press", $9bfddff2bd1f5fe3$var$E = "Slab Press Duo", $9bfddff2bd1f5fe3$var$G = "Thumbprint", $9bfddff2bd1f5fe3$var$V = "Utility", $9bfddff2bd1f5fe3$var$z = "Utility Duo", $9bfddff2bd1f5fe3$var$O = "Utility Fill", $9bfddff2bd1f5fe3$var$Y = "Vellum", $9bfddff2bd1f5fe3$var$q = "Whiteboard", $9bfddff2bd1f5fe3$var$xl = [
    $9bfddff2bd1f5fe3$var$u,
    $9bfddff2bd1f5fe3$var$l,
    $9bfddff2bd1f5fe3$var$h,
    $9bfddff2bd1f5fe3$var$t,
    $9bfddff2bd1f5fe3$var$g,
    $9bfddff2bd1f5fe3$var$n,
    $9bfddff2bd1f5fe3$var$m,
    $9bfddff2bd1f5fe3$var$p,
    $9bfddff2bd1f5fe3$var$s,
    $9bfddff2bd1f5fe3$var$y,
    $9bfddff2bd1f5fe3$var$w,
    $9bfddff2bd1f5fe3$var$x,
    $9bfddff2bd1f5fe3$var$e,
    $9bfddff2bd1f5fe3$var$b,
    $9bfddff2bd1f5fe3$var$c,
    $9bfddff2bd1f5fe3$var$o,
    $9bfddff2bd1f5fe3$var$I,
    $9bfddff2bd1f5fe3$var$a,
    $9bfddff2bd1f5fe3$var$r,
    $9bfddff2bd1f5fe3$var$v,
    $9bfddff2bd1f5fe3$var$i,
    $9bfddff2bd1f5fe3$var$F,
    $9bfddff2bd1f5fe3$var$d,
    $9bfddff2bd1f5fe3$var$S
], $9bfddff2bd1f5fe3$var$cl = ($9bfddff2bd1f5fe3$var$_cl = {}, $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_cl, $9bfddff2bd1f5fe3$var$u, $9bfddff2bd1f5fe3$var$A), $9bfddff2bd1f5fe3$var$l, $9bfddff2bd1f5fe3$var$P), $9bfddff2bd1f5fe3$var$h, $9bfddff2bd1f5fe3$var$j), $9bfddff2bd1f5fe3$var$t, $9bfddff2bd1f5fe3$var$B), $9bfddff2bd1f5fe3$var$g, $9bfddff2bd1f5fe3$var$N), $9bfddff2bd1f5fe3$var$n, $9bfddff2bd1f5fe3$var$D), $9bfddff2bd1f5fe3$var$m, $9bfddff2bd1f5fe3$var$k), $9bfddff2bd1f5fe3$var$p, $9bfddff2bd1f5fe3$var$T), $9bfddff2bd1f5fe3$var$s, $9bfddff2bd1f5fe3$var$C), $9bfddff2bd1f5fe3$var$y, $9bfddff2bd1f5fe3$var$W), $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_cl, $9bfddff2bd1f5fe3$var$w, $9bfddff2bd1f5fe3$var$R), $9bfddff2bd1f5fe3$var$x, $9bfddff2bd1f5fe3$var$K), $9bfddff2bd1f5fe3$var$e, $9bfddff2bd1f5fe3$var$L), $9bfddff2bd1f5fe3$var$b, $9bfddff2bd1f5fe3$var$U), $9bfddff2bd1f5fe3$var$c, $9bfddff2bd1f5fe3$var$J), $9bfddff2bd1f5fe3$var$o, $9bfddff2bd1f5fe3$var$_), $9bfddff2bd1f5fe3$var$I, $9bfddff2bd1f5fe3$var$M), $9bfddff2bd1f5fe3$var$a, $9bfddff2bd1f5fe3$var$E), $9bfddff2bd1f5fe3$var$r, $9bfddff2bd1f5fe3$var$G), $9bfddff2bd1f5fe3$var$v, $9bfddff2bd1f5fe3$var$V), $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_cl, $9bfddff2bd1f5fe3$var$i, $9bfddff2bd1f5fe3$var$z), $9bfddff2bd1f5fe3$var$F, $9bfddff2bd1f5fe3$var$O), $9bfddff2bd1f5fe3$var$d, $9bfddff2bd1f5fe3$var$Y), $9bfddff2bd1f5fe3$var$S, $9bfddff2bd1f5fe3$var$q));
var $9bfddff2bd1f5fe3$var$Al = {
    classic: {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    duotone: {
        900: "fad",
        400: "fadr",
        300: "fadl",
        100: "fadt"
    },
    sharp: {
        900: "fass",
        400: "fasr",
        300: "fasl",
        100: "fast"
    },
    "sharp-duotone": {
        900: "fasds",
        400: "fasdr",
        300: "fasdl",
        100: "fasdt"
    },
    slab: {
        400: "faslr"
    },
    "slab-press": {
        400: "faslpr"
    },
    "slab-duo": {
        400: "fasldr"
    },
    "slab-press-duo": {
        400: "faslpdr"
    },
    vellum: {
        900: "favs"
    },
    mosaic: {
        900: "fams"
    },
    pixel: {
        400: "fapr"
    },
    whiteboard: {
        600: "fawsb"
    },
    thumbprint: {
        300: "fatl"
    },
    notdog: {
        900: "fans"
    },
    "notdog-duo": {
        900: "fands"
    },
    etch: {
        900: "faes"
    },
    graphite: {
        100: "fagt"
    },
    chisel: {
        400: "facr"
    },
    jelly: {
        400: "fajr"
    },
    "jelly-fill": {
        400: "fajfr"
    },
    "jelly-duo": {
        400: "fajdr"
    },
    utility: {
        600: "fausb"
    },
    "utility-duo": {
        600: "faudsb"
    },
    "utility-fill": {
        600: "faufsb"
    }
};
var $9bfddff2bd1f5fe3$var$zl = {
    "Font Awesome 7 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 7 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    "Font Awesome 7 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 7 Duotone": {
        900: "fad",
        400: "fadr",
        normal: "fadr",
        300: "fadl",
        100: "fadt"
    },
    "Font Awesome 7 Sharp": {
        900: "fass",
        400: "fasr",
        normal: "fasr",
        300: "fasl",
        100: "fast"
    },
    "Font Awesome 7 Sharp Duotone": {
        900: "fasds",
        400: "fasdr",
        normal: "fasdr",
        300: "fasdl",
        100: "fasdt"
    },
    "Font Awesome 7 Jelly": {
        400: "fajr",
        normal: "fajr"
    },
    "Font Awesome 7 Jelly Fill": {
        400: "fajfr",
        normal: "fajfr"
    },
    "Font Awesome 7 Jelly Duo": {
        400: "fajdr",
        normal: "fajdr"
    },
    "Font Awesome 7 Slab": {
        400: "faslr",
        normal: "faslr"
    },
    "Font Awesome 7 Slab Press": {
        400: "faslpr",
        normal: "faslpr"
    },
    "Font Awesome 7 Slab Duo": {
        400: "fasldr",
        normal: "fasldr"
    },
    "Font Awesome 7 Slab Press Duo": {
        400: "faslpdr",
        normal: "faslpdr"
    },
    "Font Awesome 7 Pixel": {
        400: "fapr",
        normal: "fapr"
    },
    "Font Awesome 7 Mosaic": {
        900: "fams",
        normal: "fams"
    },
    "Font Awesome 7 Vellum": {
        900: "favs",
        normal: "favs"
    },
    "Font Awesome 7 Thumbprint": {
        300: "fatl",
        normal: "fatl"
    },
    "Font Awesome 7 Notdog": {
        900: "fans",
        normal: "fans"
    },
    "Font Awesome 7 Notdog Duo": {
        900: "fands",
        normal: "fands"
    },
    "Font Awesome 7 Etch": {
        900: "faes",
        normal: "faes"
    },
    "Font Awesome 7 Graphite": {
        100: "fagt",
        normal: "fagt"
    },
    "Font Awesome 7 Chisel": {
        400: "facr",
        normal: "facr"
    },
    "Font Awesome 7 Whiteboard": {
        600: "fawsb",
        normal: "fawsb"
    },
    "Font Awesome 7 Utility": {
        600: "fausb",
        normal: "fausb"
    },
    "Font Awesome 7 Utility Duo": {
        600: "faudsb",
        normal: "faudsb"
    },
    "Font Awesome 7 Utility Fill": {
        600: "faufsb",
        normal: "faufsb"
    }
};
var $9bfddff2bd1f5fe3$var$Ql = new Map([
    [
        "classic",
        {
            defaultShortPrefixId: "fas",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin",
                "brands"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "duotone",
        {
            defaultShortPrefixId: "fad",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp",
        {
            defaultShortPrefixId: "fass",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp-duotone",
        {
            defaultShortPrefixId: "fasds",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "chisel",
        {
            defaultShortPrefixId: "facr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "etch",
        {
            defaultShortPrefixId: "faes",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "graphite",
        {
            defaultShortPrefixId: "fagt",
            defaultStyleId: "thin",
            styleIds: [
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 100
        }
    ],
    [
        "jelly",
        {
            defaultShortPrefixId: "fajr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "jelly-duo",
        {
            defaultShortPrefixId: "fajdr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "jelly-fill",
        {
            defaultShortPrefixId: "fajfr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "mosaic",
        {
            defaultShortPrefixId: "fams",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "notdog",
        {
            defaultShortPrefixId: "fans",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "notdog-duo",
        {
            defaultShortPrefixId: "fands",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "pixel",
        {
            defaultShortPrefixId: "fapr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "slab",
        {
            defaultShortPrefixId: "faslr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "slab-duo",
        {
            defaultShortPrefixId: "fasldr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "slab-press",
        {
            defaultShortPrefixId: "faslpr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "slab-press-duo",
        {
            defaultShortPrefixId: "faslpdr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "thumbprint",
        {
            defaultShortPrefixId: "fatl",
            defaultStyleId: "light",
            styleIds: [
                "light"
            ],
            futureStyleIds: [],
            defaultFontWeight: 300
        }
    ],
    [
        "utility",
        {
            defaultShortPrefixId: "fausb",
            defaultStyleId: "semibold",
            styleIds: [
                "semibold"
            ],
            futureStyleIds: [],
            defaultFontWeight: 600
        }
    ],
    [
        "utility-duo",
        {
            defaultShortPrefixId: "faudsb",
            defaultStyleId: "semibold",
            styleIds: [
                "semibold"
            ],
            futureStyleIds: [],
            defaultFontWeight: 600
        }
    ],
    [
        "utility-fill",
        {
            defaultShortPrefixId: "faufsb",
            defaultStyleId: "semibold",
            styleIds: [
                "semibold"
            ],
            futureStyleIds: [],
            defaultFontWeight: 600
        }
    ],
    [
        "vellum",
        {
            defaultShortPrefixId: "favs",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "whiteboard",
        {
            defaultShortPrefixId: "fawsb",
            defaultStyleId: "semibold",
            styleIds: [
                "semibold"
            ],
            futureStyleIds: [],
            defaultFontWeight: 600
        }
    ]
]), $9bfddff2bd1f5fe3$var$$l = {
    chisel: {
        regular: "facr"
    },
    classic: {
        brands: "fab",
        light: "fal",
        regular: "far",
        solid: "fas",
        thin: "fat"
    },
    duotone: {
        light: "fadl",
        regular: "fadr",
        solid: "fad",
        thin: "fadt"
    },
    etch: {
        solid: "faes"
    },
    graphite: {
        thin: "fagt"
    },
    jelly: {
        regular: "fajr"
    },
    "jelly-duo": {
        regular: "fajdr"
    },
    "jelly-fill": {
        regular: "fajfr"
    },
    mosaic: {
        solid: "fams"
    },
    notdog: {
        solid: "fans"
    },
    "notdog-duo": {
        solid: "fands"
    },
    pixel: {
        regular: "fapr"
    },
    sharp: {
        light: "fasl",
        regular: "fasr",
        solid: "fass",
        thin: "fast"
    },
    "sharp-duotone": {
        light: "fasdl",
        regular: "fasdr",
        solid: "fasds",
        thin: "fasdt"
    },
    slab: {
        regular: "faslr"
    },
    "slab-duo": {
        regular: "fasldr"
    },
    "slab-press": {
        regular: "faslpr"
    },
    "slab-press-duo": {
        regular: "faslpdr"
    },
    thumbprint: {
        light: "fatl"
    },
    utility: {
        semibold: "fausb"
    },
    "utility-duo": {
        semibold: "faudsb"
    },
    "utility-fill": {
        semibold: "faufsb"
    },
    vellum: {
        solid: "favs"
    },
    whiteboard: {
        semibold: "fawsb"
    }
};
var $9bfddff2bd1f5fe3$var$at = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
], $9bfddff2bd1f5fe3$var$rt = {
    kit: {
        fak: "kit",
        "fa-kit": "kit"
    },
    "kit-duotone": {
        fakd: "kit-duotone",
        "fa-kit-duotone": "kit-duotone"
    }
}, $9bfddff2bd1f5fe3$var$it = [
    "kit"
];
var $9bfddff2bd1f5fe3$var$H = "kit", $9bfddff2bd1f5fe3$var$f = "kit-duotone", $9bfddff2bd1f5fe3$var$Q = "Kit", $9bfddff2bd1f5fe3$var$X = "Kit Duotone", $9bfddff2bd1f5fe3$var$ht = $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty({}, $9bfddff2bd1f5fe3$var$H, $9bfddff2bd1f5fe3$var$Q), $9bfddff2bd1f5fe3$var$f, $9bfddff2bd1f5fe3$var$X);
var $9bfddff2bd1f5fe3$var$mt = {
    kit: {
        "fa-kit": "fak"
    },
    "kit-duotone": {
        "fa-kit-duotone": "fakd"
    }
};
var $9bfddff2bd1f5fe3$var$ct = {
    "Font Awesome Kit": {
        400: "fak",
        normal: "fak"
    },
    "Font Awesome Kit Duotone": {
        400: "fakd",
        normal: "fakd"
    }
}, $9bfddff2bd1f5fe3$var$It = {
    kit: {
        fak: "fa-kit"
    },
    "kit-duotone": {
        fakd: "fa-kit-duotone"
    }
};
var $9bfddff2bd1f5fe3$var$St = {
    kit: {
        kit: "fak"
    },
    "kit-duotone": {
        "kit-duotone": "fakd"
    }
};
var $9bfddff2bd1f5fe3$var$_jl;
var $9bfddff2bd1f5fe3$var$l$1 = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $9bfddff2bd1f5fe3$var$n$1 = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone",
    "fa-thumbprint",
    "fa-whiteboard",
    "fa-notdog",
    "fa-notdog-duo",
    "fa-chisel",
    "fa-etch",
    "fa-graphite",
    "fa-jelly",
    "fa-jelly-fill",
    "fa-jelly-duo",
    "fa-slab",
    "fa-slab-press",
    "fa-slab-press-duo",
    "fa-slab-duo",
    "fa-mosaic",
    "fa-pixel",
    "fa-vellum",
    "fa-utility",
    "fa-utility-duo",
    "fa-utility-fill"
];
var $9bfddff2bd1f5fe3$var$g$1 = "classic", $9bfddff2bd1f5fe3$var$a$1 = "duotone", $9bfddff2bd1f5fe3$var$m$1 = "sharp", $9bfddff2bd1f5fe3$var$t$1 = "sharp-duotone", $9bfddff2bd1f5fe3$var$p$1 = "chisel", $9bfddff2bd1f5fe3$var$y$1 = "etch", $9bfddff2bd1f5fe3$var$b$1 = "graphite", $9bfddff2bd1f5fe3$var$w$1 = "jelly", $9bfddff2bd1f5fe3$var$e$1 = "jelly-duo", $9bfddff2bd1f5fe3$var$x$1 = "jelly-fill", $9bfddff2bd1f5fe3$var$c$1 = "mosaic", $9bfddff2bd1f5fe3$var$I$1 = "notdog", $9bfddff2bd1f5fe3$var$o$1 = "notdog-duo", $9bfddff2bd1f5fe3$var$v$1 = "pixel", $9bfddff2bd1f5fe3$var$F$1 = "slab", $9bfddff2bd1f5fe3$var$r$1 = "slab-duo", $9bfddff2bd1f5fe3$var$S$1 = "slab-press", $9bfddff2bd1f5fe3$var$i$1 = "slab-press-duo", $9bfddff2bd1f5fe3$var$d$1 = "thumbprint", $9bfddff2bd1f5fe3$var$A$1 = "utility", $9bfddff2bd1f5fe3$var$f$1 = "utility-duo", $9bfddff2bd1f5fe3$var$P$1 = "utility-fill", $9bfddff2bd1f5fe3$var$u$1 = "vellum", $9bfddff2bd1f5fe3$var$j$1 = "whiteboard", $9bfddff2bd1f5fe3$var$B$1 = "Classic", $9bfddff2bd1f5fe3$var$N$1 = "Duotone", $9bfddff2bd1f5fe3$var$D$1 = "Sharp", $9bfddff2bd1f5fe3$var$k$1 = "Sharp Duotone", $9bfddff2bd1f5fe3$var$C$1 = "Chisel", $9bfddff2bd1f5fe3$var$T$1 = "Etch", $9bfddff2bd1f5fe3$var$L$1 = "Graphite", $9bfddff2bd1f5fe3$var$W$1 = "Jelly", $9bfddff2bd1f5fe3$var$R$1 = "Jelly Duo", $9bfddff2bd1f5fe3$var$K$1 = "Jelly Fill", $9bfddff2bd1f5fe3$var$U$1 = "Mosaic", $9bfddff2bd1f5fe3$var$J$1 = "Notdog", $9bfddff2bd1f5fe3$var$_$1 = "Notdog Duo", $9bfddff2bd1f5fe3$var$M$1 = "Pixel", $9bfddff2bd1f5fe3$var$E$1 = "Slab", $9bfddff2bd1f5fe3$var$G$1 = "Slab Duo", $9bfddff2bd1f5fe3$var$O$1 = "Slab Press", $9bfddff2bd1f5fe3$var$V$1 = "Slab Press Duo", $9bfddff2bd1f5fe3$var$z$1 = "Thumbprint", $9bfddff2bd1f5fe3$var$Y$1 = "Utility", $9bfddff2bd1f5fe3$var$$$1 = "Utility Duo", $9bfddff2bd1f5fe3$var$q$1 = "Utility Fill", $9bfddff2bd1f5fe3$var$H$1 = "Vellum", $9bfddff2bd1f5fe3$var$Q$1 = "Whiteboard", $9bfddff2bd1f5fe3$var$jl$1 = ($9bfddff2bd1f5fe3$var$_jl = {}, $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_jl, $9bfddff2bd1f5fe3$var$g$1, $9bfddff2bd1f5fe3$var$B$1), $9bfddff2bd1f5fe3$var$a$1, $9bfddff2bd1f5fe3$var$N$1), $9bfddff2bd1f5fe3$var$m$1, $9bfddff2bd1f5fe3$var$D$1), $9bfddff2bd1f5fe3$var$t$1, $9bfddff2bd1f5fe3$var$k$1), $9bfddff2bd1f5fe3$var$p$1, $9bfddff2bd1f5fe3$var$C$1), $9bfddff2bd1f5fe3$var$y$1, $9bfddff2bd1f5fe3$var$T$1), $9bfddff2bd1f5fe3$var$b$1, $9bfddff2bd1f5fe3$var$L$1), $9bfddff2bd1f5fe3$var$w$1, $9bfddff2bd1f5fe3$var$W$1), $9bfddff2bd1f5fe3$var$e$1, $9bfddff2bd1f5fe3$var$R$1), $9bfddff2bd1f5fe3$var$x$1, $9bfddff2bd1f5fe3$var$K$1), $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_jl, $9bfddff2bd1f5fe3$var$c$1, $9bfddff2bd1f5fe3$var$U$1), $9bfddff2bd1f5fe3$var$I$1, $9bfddff2bd1f5fe3$var$J$1), $9bfddff2bd1f5fe3$var$o$1, $9bfddff2bd1f5fe3$var$_$1), $9bfddff2bd1f5fe3$var$v$1, $9bfddff2bd1f5fe3$var$M$1), $9bfddff2bd1f5fe3$var$F$1, $9bfddff2bd1f5fe3$var$E$1), $9bfddff2bd1f5fe3$var$r$1, $9bfddff2bd1f5fe3$var$G$1), $9bfddff2bd1f5fe3$var$S$1, $9bfddff2bd1f5fe3$var$O$1), $9bfddff2bd1f5fe3$var$i$1, $9bfddff2bd1f5fe3$var$V$1), $9bfddff2bd1f5fe3$var$d$1, $9bfddff2bd1f5fe3$var$z$1), $9bfddff2bd1f5fe3$var$A$1, $9bfddff2bd1f5fe3$var$Y$1), $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_jl, $9bfddff2bd1f5fe3$var$f$1, $9bfddff2bd1f5fe3$var$$$1), $9bfddff2bd1f5fe3$var$P$1, $9bfddff2bd1f5fe3$var$q$1), $9bfddff2bd1f5fe3$var$u$1, $9bfddff2bd1f5fe3$var$H$1), $9bfddff2bd1f5fe3$var$j$1, $9bfddff2bd1f5fe3$var$Q$1));
var $9bfddff2bd1f5fe3$var$X$1 = "kit", $9bfddff2bd1f5fe3$var$h$1 = "kit-duotone", $9bfddff2bd1f5fe3$var$Z$1 = "Kit", $9bfddff2bd1f5fe3$var$ll$1 = "Kit Duotone", $9bfddff2bd1f5fe3$var$ws = $9bfddff2bd1f5fe3$var$_defineProperty($9bfddff2bd1f5fe3$var$_defineProperty({}, $9bfddff2bd1f5fe3$var$X$1, $9bfddff2bd1f5fe3$var$Z$1), $9bfddff2bd1f5fe3$var$h$1, $9bfddff2bd1f5fe3$var$ll$1);
var $9bfddff2bd1f5fe3$var$ra = {
    classic: {
        "fa-brands": "fab",
        "fa-duotone": "fad",
        "fa-light": "fal",
        "fa-regular": "far",
        "fa-solid": "fas",
        "fa-thin": "fat"
    },
    duotone: {
        "fa-regular": "fadr",
        "fa-light": "fadl",
        "fa-thin": "fadt"
    },
    sharp: {
        "fa-solid": "fass",
        "fa-regular": "fasr",
        "fa-light": "fasl",
        "fa-thin": "fast"
    },
    "sharp-duotone": {
        "fa-solid": "fasds",
        "fa-regular": "fasdr",
        "fa-light": "fasdl",
        "fa-thin": "fasdt"
    },
    slab: {
        "fa-regular": "faslr"
    },
    "slab-press": {
        "fa-regular": "faslpr"
    },
    "slab-duo": {
        "fa-regular": "fasldr"
    },
    "slab-press-duo": {
        "fa-regular": "faslpdr"
    },
    pixel: {
        "fa-regular": "fapr"
    },
    mosaic: {
        "fa-solid": "fams"
    },
    vellum: {
        "fa-solid": "favs"
    },
    whiteboard: {
        "fa-semibold": "fawsb"
    },
    thumbprint: {
        "fa-light": "fatl"
    },
    notdog: {
        "fa-solid": "fans"
    },
    "notdog-duo": {
        "fa-solid": "fands"
    },
    etch: {
        "fa-solid": "faes"
    },
    graphite: {
        "fa-thin": "fagt"
    },
    jelly: {
        "fa-regular": "fajr"
    },
    "jelly-fill": {
        "fa-regular": "fajfr"
    },
    "jelly-duo": {
        "fa-regular": "fajdr"
    },
    chisel: {
        "fa-regular": "facr"
    },
    utility: {
        "fa-semibold": "fausb"
    },
    "utility-duo": {
        "fa-semibold": "faudsb"
    },
    "utility-fill": {
        "fa-semibold": "faufsb"
    }
}, $9bfddff2bd1f5fe3$var$al$1 = {
    classic: [
        "fas",
        "far",
        "fal",
        "fat",
        "fad"
    ],
    duotone: [
        "fadr",
        "fadl",
        "fadt"
    ],
    sharp: [
        "fass",
        "fasr",
        "fasl",
        "fast"
    ],
    "sharp-duotone": [
        "fasds",
        "fasdr",
        "fasdl",
        "fasdt"
    ],
    slab: [
        "faslr"
    ],
    "slab-press": [
        "faslpr"
    ],
    "slab-duo": [
        "fasldr"
    ],
    "slab-press-duo": [
        "faslpdr"
    ],
    pixel: [
        "fapr"
    ],
    mosaic: [
        "fams"
    ],
    vellum: [
        "favs"
    ],
    whiteboard: [
        "fawsb"
    ],
    thumbprint: [
        "fatl"
    ],
    notdog: [
        "fans"
    ],
    "notdog-duo": [
        "fands"
    ],
    etch: [
        "faes"
    ],
    graphite: [
        "fagt"
    ],
    jelly: [
        "fajr"
    ],
    "jelly-fill": [
        "fajfr"
    ],
    "jelly-duo": [
        "fajdr"
    ],
    chisel: [
        "facr"
    ],
    utility: [
        "fausb"
    ],
    "utility-duo": [
        "faudsb"
    ],
    "utility-fill": [
        "faufsb"
    ]
}, $9bfddff2bd1f5fe3$var$da = {
    classic: {
        fab: "fa-brands",
        fad: "fa-duotone",
        fal: "fa-light",
        far: "fa-regular",
        fas: "fa-solid",
        fat: "fa-thin"
    },
    duotone: {
        fadr: "fa-regular",
        fadl: "fa-light",
        fadt: "fa-thin"
    },
    sharp: {
        fass: "fa-solid",
        fasr: "fa-regular",
        fasl: "fa-light",
        fast: "fa-thin"
    },
    "sharp-duotone": {
        fasds: "fa-solid",
        fasdr: "fa-regular",
        fasdl: "fa-light",
        fasdt: "fa-thin"
    },
    slab: {
        faslr: "fa-regular"
    },
    "slab-press": {
        faslpr: "fa-regular"
    },
    "slab-duo": {
        fasldr: "fa-regular"
    },
    "slab-press-duo": {
        faslpdr: "fa-regular"
    },
    pixel: {
        fapr: "fa-regular"
    },
    mosaic: {
        fams: "fa-solid"
    },
    vellum: {
        favs: "fa-solid"
    },
    whiteboard: {
        fawsb: "fa-semibold"
    },
    thumbprint: {
        fatl: "fa-light"
    },
    notdog: {
        fans: "fa-solid"
    },
    "notdog-duo": {
        fands: "fa-solid"
    },
    etch: {
        faes: "fa-solid"
    },
    graphite: {
        fagt: "fa-thin"
    },
    jelly: {
        fajr: "fa-regular"
    },
    "jelly-fill": {
        fajfr: "fa-regular"
    },
    "jelly-duo": {
        fajdr: "fa-regular"
    },
    chisel: {
        facr: "fa-regular"
    },
    utility: {
        fausb: "fa-semibold"
    },
    "utility-duo": {
        faudsb: "fa-semibold"
    },
    "utility-fill": {
        faufsb: "fa-semibold"
    }
}, $9bfddff2bd1f5fe3$var$tl = [
    "fa-solid",
    "fa-regular",
    "fa-light",
    "fa-thin",
    "fa-duotone",
    "fa-brands",
    "fa-semibold"
], $9bfddff2bd1f5fe3$var$ha = [
    "fa",
    "fas",
    "far",
    "fal",
    "fat",
    "fad",
    "fadr",
    "fadl",
    "fadt",
    "fab",
    "fass",
    "fasr",
    "fasl",
    "fast",
    "fasds",
    "fasdr",
    "fasdl",
    "fasdt",
    "faslr",
    "faslpr",
    "fasldr",
    "faslpdr",
    "fapr",
    "fams",
    "favs",
    "fawsb",
    "fatl",
    "fans",
    "fands",
    "faes",
    "fagt",
    "fajr",
    "fajfr",
    "fajdr",
    "facr",
    "fausb",
    "faudsb",
    "faufsb"
].concat($9bfddff2bd1f5fe3$var$n$1, $9bfddff2bd1f5fe3$var$tl), $9bfddff2bd1f5fe3$var$el$1 = [
    "solid",
    "regular",
    "light",
    "thin",
    "duotone",
    "brands",
    "semibold"
], $9bfddff2bd1f5fe3$var$sl$1 = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
], $9bfddff2bd1f5fe3$var$ol$1 = $9bfddff2bd1f5fe3$var$sl$1.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]), $9bfddff2bd1f5fe3$var$rl$1 = [
    "aw",
    "fw",
    "pull-left",
    "pull-right"
], $9bfddff2bd1f5fe3$var$ga = [].concat($9bfddff2bd1f5fe3$var$_toConsumableArray(Object.keys($9bfddff2bd1f5fe3$var$al$1)), $9bfddff2bd1f5fe3$var$el$1, $9bfddff2bd1f5fe3$var$rl$1, [
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "beat-fade",
    "border",
    "bounce",
    "buzz",
    "canvas-square",
    "canvas-roomy",
    "fade",
    "flip-360",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "float",
    "inverse",
    "jello",
    "layers",
    "layers-bottom-left",
    "layers-bottom-right",
    "layers-counter",
    "layers-text",
    "layers-top-left",
    "layers-top-right",
    "li",
    "pull-end",
    "pull-start",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "spin-snap",
    "spin-snap-4",
    "spin-snap-8",
    "stack-1x",
    "stack-2x",
    "stack",
    "swing",
    "ul",
    "wag",
    "width-auto",
    "width-fixed",
    $9bfddff2bd1f5fe3$var$l$1.GROUP,
    $9bfddff2bd1f5fe3$var$l$1.SWAP_OPACITY,
    $9bfddff2bd1f5fe3$var$l$1.PRIMARY,
    $9bfddff2bd1f5fe3$var$l$1.SECONDARY
]).concat($9bfddff2bd1f5fe3$var$sl$1.map(function(s) {
    return "".concat(s, "x");
})).concat($9bfddff2bd1f5fe3$var$ol$1.map(function(s) {
    return "w-".concat(s);
}));
var $9bfddff2bd1f5fe3$var$wa = {
    "Font Awesome 5 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 5 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal"
    },
    "Font Awesome 5 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 5 Duotone": {
        900: "fad"
    }
};
var $9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var $9bfddff2bd1f5fe3$var$UNITS_IN_GRID = 16;
var $9bfddff2bd1f5fe3$var$DEFAULT_CSS_PREFIX = 'fa';
var $9bfddff2bd1f5fe3$var$DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var $9bfddff2bd1f5fe3$var$DATA_FA_I2SVG = 'data-fa-i2svg';
var $9bfddff2bd1f5fe3$var$DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var $9bfddff2bd1f5fe3$var$DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var $9bfddff2bd1f5fe3$var$DATA_PREFIX = 'data-prefix';
var $9bfddff2bd1f5fe3$var$DATA_ICON = 'data-icon';
var $9bfddff2bd1f5fe3$var$HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var $9bfddff2bd1f5fe3$var$MUTATION_APPROACH_ASYNC = 'async';
var $9bfddff2bd1f5fe3$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    'HTML',
    'HEAD',
    'STYLE',
    'SCRIPT'
];
var $9bfddff2bd1f5fe3$var$PSEUDO_ELEMENTS = [
    '::before',
    '::after',
    ':before',
    ':after'
];
var $9bfddff2bd1f5fe3$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e$$1) {
        return false;
    }
}();
function $9bfddff2bd1f5fe3$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get: function get(target, prop) {
            return prop in target ? target[prop] : target[$9bfddff2bd1f5fe3$var$u];
        }
    });
}
var $9bfddff2bd1f5fe3$var$_PREFIX_TO_STYLE = $9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$rl);
// We changed FACSSClassesToStyleId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _PREFIX_TO_STYLE below, so we are manually adding
// {'fa-duotone': 'duotone'}
$9bfddff2bd1f5fe3$var$_PREFIX_TO_STYLE[$9bfddff2bd1f5fe3$var$u] = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, {
    'fa-duotone': 'duotone'
}), $9bfddff2bd1f5fe3$var$rl[$9bfddff2bd1f5fe3$var$u]), $9bfddff2bd1f5fe3$var$rt['kit']), $9bfddff2bd1f5fe3$var$rt['kit-duotone']);
var $9bfddff2bd1f5fe3$var$PREFIX_TO_STYLE = $9bfddff2bd1f5fe3$var$familyProxy($9bfddff2bd1f5fe3$var$_PREFIX_TO_STYLE);
var $9bfddff2bd1f5fe3$var$_STYLE_TO_PREFIX = $9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$$l);
// We changed FAStyleIdToShortPrefixId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _STYLE_TO_PREFIX below, so we are manually adding {duotone: 'fad'}
$9bfddff2bd1f5fe3$var$_STYLE_TO_PREFIX[$9bfddff2bd1f5fe3$var$u] = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, {
    duotone: 'fad'
}), $9bfddff2bd1f5fe3$var$_STYLE_TO_PREFIX[$9bfddff2bd1f5fe3$var$u]), $9bfddff2bd1f5fe3$var$St['kit']), $9bfddff2bd1f5fe3$var$St['kit-duotone']);
var $9bfddff2bd1f5fe3$var$STYLE_TO_PREFIX = $9bfddff2bd1f5fe3$var$familyProxy($9bfddff2bd1f5fe3$var$_STYLE_TO_PREFIX);
var $9bfddff2bd1f5fe3$var$_PREFIX_TO_LONG_STYLE = $9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$da);
$9bfddff2bd1f5fe3$var$_PREFIX_TO_LONG_STYLE[$9bfddff2bd1f5fe3$var$u] = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$_PREFIX_TO_LONG_STYLE[$9bfddff2bd1f5fe3$var$u]), $9bfddff2bd1f5fe3$var$It['kit']);
var $9bfddff2bd1f5fe3$var$PREFIX_TO_LONG_STYLE = $9bfddff2bd1f5fe3$var$familyProxy($9bfddff2bd1f5fe3$var$_PREFIX_TO_LONG_STYLE);
var $9bfddff2bd1f5fe3$var$_LONG_STYLE_TO_PREFIX = $9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$ra);
$9bfddff2bd1f5fe3$var$_LONG_STYLE_TO_PREFIX[$9bfddff2bd1f5fe3$var$u] = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$_LONG_STYLE_TO_PREFIX[$9bfddff2bd1f5fe3$var$u]), $9bfddff2bd1f5fe3$var$mt['kit']);
var $9bfddff2bd1f5fe3$var$LONG_STYLE_TO_PREFIX = $9bfddff2bd1f5fe3$var$familyProxy($9bfddff2bd1f5fe3$var$_LONG_STYLE_TO_PREFIX);
var $9bfddff2bd1f5fe3$var$ICON_SELECTION_SYNTAX_PATTERN = $9bfddff2bd1f5fe3$var$Z;
var $9bfddff2bd1f5fe3$var$LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var $9bfddff2bd1f5fe3$var$FONT_FAMILY_PATTERN = $9bfddff2bd1f5fe3$var$$;
var $9bfddff2bd1f5fe3$var$_FONT_WEIGHT_TO_PREFIX = $9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$Al);
var $9bfddff2bd1f5fe3$var$FONT_WEIGHT_TO_PREFIX = $9bfddff2bd1f5fe3$var$familyProxy($9bfddff2bd1f5fe3$var$_FONT_WEIGHT_TO_PREFIX);
var $9bfddff2bd1f5fe3$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    'class',
    'data-prefix',
    'data-icon',
    'data-fa-transform',
    'data-fa-mask'
];
var $9bfddff2bd1f5fe3$var$DUOTONE_CLASSES = $9bfddff2bd1f5fe3$var$il;
var $9bfddff2bd1f5fe3$var$RESERVED_CLASSES = [].concat($9bfddff2bd1f5fe3$var$_toConsumableArray($9bfddff2bd1f5fe3$var$it), $9bfddff2bd1f5fe3$var$_toConsumableArray($9bfddff2bd1f5fe3$var$ga));
var $9bfddff2bd1f5fe3$var$initial = $9bfddff2bd1f5fe3$var$WINDOW.FontAwesomeConfig || {};
function $9bfddff2bd1f5fe3$var$getAttrConfig(attr) {
    var element = $9bfddff2bd1f5fe3$var$DOCUMENT.querySelector('script[' + attr + ']');
    if (element) return element.getAttribute(attr);
}
function $9bfddff2bd1f5fe3$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
}
if ($9bfddff2bd1f5fe3$var$DOCUMENT && typeof $9bfddff2bd1f5fe3$var$DOCUMENT.querySelector === 'function') {
    var $9bfddff2bd1f5fe3$var$attrs = [
        [
            'data-family-prefix',
            'familyPrefix'
        ],
        [
            'data-css-prefix',
            'cssPrefix'
        ],
        [
            'data-family-default',
            'familyDefault'
        ],
        [
            'data-style-default',
            'styleDefault'
        ],
        [
            'data-replacement-class',
            'replacementClass'
        ],
        [
            'data-auto-replace-svg',
            'autoReplaceSvg'
        ],
        [
            'data-auto-add-css',
            'autoAddCss'
        ],
        [
            'data-search-pseudo-elements',
            'searchPseudoElements'
        ],
        [
            'data-search-pseudo-elements-warnings',
            'searchPseudoElementsWarnings'
        ],
        [
            'data-search-pseudo-elements-full-scan',
            'searchPseudoElementsFullScan'
        ],
        [
            'data-observe-mutations',
            'observeMutations'
        ],
        [
            'data-mutate-approach',
            'mutateApproach'
        ],
        [
            'data-keep-original-source',
            'keepOriginalSource'
        ],
        [
            'data-measure-performance',
            'measurePerformance'
        ],
        [
            'data-show-missing-icons',
            'showMissingIcons'
        ]
    ];
    $9bfddff2bd1f5fe3$var$attrs.forEach(function(_ref) {
        var _ref2 = $9bfddff2bd1f5fe3$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $9bfddff2bd1f5fe3$var$coerce($9bfddff2bd1f5fe3$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $9bfddff2bd1f5fe3$var$initial[key] = val;
    });
}
var $9bfddff2bd1f5fe3$var$_default = {
    styleDefault: 'solid',
    familyDefault: $9bfddff2bd1f5fe3$var$u,
    cssPrefix: $9bfddff2bd1f5fe3$var$DEFAULT_CSS_PREFIX,
    replacementClass: $9bfddff2bd1f5fe3$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    searchPseudoElements: false,
    searchPseudoElementsWarnings: true,
    searchPseudoElementsFullScan: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
// familyPrefix is deprecated but we must still support it if present
if ($9bfddff2bd1f5fe3$var$initial.familyPrefix) $9bfddff2bd1f5fe3$var$initial.cssPrefix = $9bfddff2bd1f5fe3$var$initial.familyPrefix;
var $9bfddff2bd1f5fe3$var$_config = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$_default), $9bfddff2bd1f5fe3$var$initial);
if (!$9bfddff2bd1f5fe3$var$_config.autoReplaceSvg) $9bfddff2bd1f5fe3$var$_config.observeMutations = false;
var $9bfddff2bd1f5fe3$var$config = {};
Object.keys($9bfddff2bd1f5fe3$var$_default).forEach(function(key) {
    Object.defineProperty($9bfddff2bd1f5fe3$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $9bfddff2bd1f5fe3$var$_config[key] = val;
            $9bfddff2bd1f5fe3$var$_onChangeCb.forEach(function(cb) {
                return cb($9bfddff2bd1f5fe3$var$config);
            });
        },
        get: function get() {
            return $9bfddff2bd1f5fe3$var$_config[key];
        }
    });
});
// familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($9bfddff2bd1f5fe3$var$config, 'familyPrefix', {
    enumerable: true,
    set: function set(val) {
        $9bfddff2bd1f5fe3$var$_config.cssPrefix = val;
        $9bfddff2bd1f5fe3$var$_onChangeCb.forEach(function(cb) {
            return cb($9bfddff2bd1f5fe3$var$config);
        });
    },
    get: function get() {
        return $9bfddff2bd1f5fe3$var$_config.cssPrefix;
    }
});
$9bfddff2bd1f5fe3$var$WINDOW.FontAwesomeConfig = $9bfddff2bd1f5fe3$var$config;
var $9bfddff2bd1f5fe3$var$_onChangeCb = [];
function $9bfddff2bd1f5fe3$var$onChange(cb) {
    $9bfddff2bd1f5fe3$var$_onChangeCb.push(cb);
    return function() {
        $9bfddff2bd1f5fe3$var$_onChangeCb.splice($9bfddff2bd1f5fe3$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $9bfddff2bd1f5fe3$var$d$2 = $9bfddff2bd1f5fe3$var$UNITS_IN_GRID;
var $9bfddff2bd1f5fe3$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $9bfddff2bd1f5fe3$var$insertCss(css) {
    if (!css || !$9bfddff2bd1f5fe3$var$IS_DOM) return;
    var style = $9bfddff2bd1f5fe3$var$DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    var headChildren = $9bfddff2bd1f5fe3$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || '').toUpperCase();
        if ([
            'STYLE',
            'LINK'
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $9bfddff2bd1f5fe3$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $9bfddff2bd1f5fe3$var$idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function $9bfddff2bd1f5fe3$var$nextUniqueId() {
    var size = 12;
    var id = '';
    while(size-- > 0)id += $9bfddff2bd1f5fe3$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $9bfddff2bd1f5fe3$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $9bfddff2bd1f5fe3$var$classArray(node) {
    if (node.classList) return $9bfddff2bd1f5fe3$var$toArray(node.classList);
    else return (node.getAttribute('class') || '').split(' ').filter(function(i) {
        return i;
    });
}
function $9bfddff2bd1f5fe3$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $9bfddff2bd1f5fe3$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, "=\"").concat($9bfddff2bd1f5fe3$var$htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
}
function $9bfddff2bd1f5fe3$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, '');
}
function $9bfddff2bd1f5fe3$var$transformIsMeaningful(transform) {
    return transform.size !== $9bfddff2bd1f5fe3$var$meaninglessTransform.size || transform.x !== $9bfddff2bd1f5fe3$var$meaninglessTransform.x || transform.y !== $9bfddff2bd1f5fe3$var$meaninglessTransform.y || transform.rotate !== $9bfddff2bd1f5fe3$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $9bfddff2bd1f5fe3$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $9bfddff2bd1f5fe3$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $9bfddff2bd1f5fe3$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $9bfddff2bd1f5fe3$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = '';
    if (startCentered && $9bfddff2bd1f5fe3$var$IS_IE) val += "translate(".concat(transform.x / $9bfddff2bd1f5fe3$var$d$2 - width / 2, "em, ").concat(transform.y / $9bfddff2bd1f5fe3$var$d$2 - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $9bfddff2bd1f5fe3$var$d$2, "em), calc(-50% + ").concat(transform.y / $9bfddff2bd1f5fe3$var$d$2, "em)) ");
    else val += "translate(".concat(transform.x / $9bfddff2bd1f5fe3$var$d$2, "em, ").concat(transform.y / $9bfddff2bd1f5fe3$var$d$2, "em) ");
    val += "scale(".concat(transform.size / $9bfddff2bd1f5fe3$var$d$2 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $9bfddff2bd1f5fe3$var$d$2 * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $9bfddff2bd1f5fe3$var$baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 'Font Awesome 7 Free';\n  --fa-font-regular: normal 400 1em/1 'Font Awesome 7 Free';\n  --fa-font-light: normal 300 1em/1 'Font Awesome 7 Pro';\n  --fa-font-thin: normal 100 1em/1 'Font Awesome 7 Pro';\n  --fa-font-duotone: normal 900 1em/1 'Font Awesome 7 Duotone';\n  --fa-font-duotone-regular: normal 400 1em/1 'Font Awesome 7 Duotone';\n  --fa-font-duotone-light: normal 300 1em/1 'Font Awesome 7 Duotone';\n  --fa-font-duotone-thin: normal 100 1em/1 'Font Awesome 7 Duotone';\n  --fa-font-brands: normal 400 1em/1 'Font Awesome 7 Brands';\n  --fa-font-sharp-solid: normal 900 1em/1 'Font Awesome 7 Sharp';\n  --fa-font-sharp-regular: normal 400 1em/1 'Font Awesome 7 Sharp';\n  --fa-font-sharp-light: normal 300 1em/1 'Font Awesome 7 Sharp';\n  --fa-font-sharp-thin: normal 100 1em/1 'Font Awesome 7 Sharp';\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 'Font Awesome 7 Sharp Duotone';\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 'Font Awesome 7 Sharp Duotone';\n  --fa-font-sharp-duotone-light: normal 300 1em/1 'Font Awesome 7 Sharp Duotone';\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 'Font Awesome 7 Sharp Duotone';\n  --fa-font-slab-regular: normal 400 1em/1 'Font Awesome 7 Slab';\n  --fa-font-slab-press-regular: normal 400 1em/1 'Font Awesome 7 Slab Press';\n  --fa-font-slab-duo-regular: normal 400 1em/1 'Font Awesome 7 Slab Duo';\n  --fa-font-slab-press-duo-regular: normal 400 1em/1 'Font Awesome 7 Slab Press Duo';\n  --fa-font-pixel-regular: normal 400 1em/1 'Font Awesome 7 Pixel';\n  --fa-font-mosaic-solid: normal 900 1em/1 'Font Awesome 7 Mosaic';\n  --fa-font-vellum-solid: normal 900 1em/1 'Font Awesome 7 Vellum';\n  --fa-font-whiteboard-semibold: normal 600 1em/1 'Font Awesome 7 Whiteboard';\n  --fa-font-thumbprint-light: normal 300 1em/1 'Font Awesome 7 Thumbprint';\n  --fa-font-notdog-solid: normal 900 1em/1 'Font Awesome 7 Notdog';\n  --fa-font-notdog-duo-solid: normal 900 1em/1 'Font Awesome 7 Notdog Duo';\n  --fa-font-etch-solid: normal 900 1em/1 'Font Awesome 7 Etch';\n  --fa-font-graphite-thin: normal 100 1em/1 'Font Awesome 7 Graphite';\n  --fa-font-jelly-regular: normal 400 1em/1 'Font Awesome 7 Jelly';\n  --fa-font-jelly-fill-regular: normal 400 1em/1 'Font Awesome 7 Jelly Fill';\n  --fa-font-jelly-duo-regular: normal 400 1em/1 'Font Awesome 7 Jelly Duo';\n  --fa-font-chisel-regular: normal 400 1em/1 'Font Awesome 7 Chisel';\n  --fa-font-utility-semibold: normal 600 1em/1 'Font Awesome 7 Utility';\n  --fa-font-utility-duo-semibold: normal 600 1em/1 'Font Awesome 7 Utility Duo';\n  --fa-font-utility-fill-semibold: normal 600 1em/1 'Font Awesome 7 Utility Fill';\n}\n\n.svg-inline--fa {\n  box-sizing: content-box;\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n  width: var(--fa-width, 1.25em);\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285714em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left,\n.svg-inline--fa .fa-pull-start {\n  float: inline-start;\n  margin-inline-end: var(--fa-pull-margin, 0.3em);\n}\n.svg-inline--fa.fa-pull-right,\n.svg-inline--fa .fa-pull-end {\n  float: inline-end;\n  margin-inline-start: var(--fa-pull-margin, 0.3em);\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  inset-inline-start: calc(-1 * var(--fa-li-width, 2em));\n  inset-block-start: 0.25em; /* syncing vertical alignment with Web Font rendering */\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: var(--fa-width, 1.25em);\n}\n.fa-layers .svg-inline--fa {\n  inset: 0;\n  margin: auto;\n  position: absolute;\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: calc(10 / 16 * 1em); /* converts a 10px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 10 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 10 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-xs {\n  font-size: calc(12 / 16 * 1em); /* converts a 12px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 12 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 12 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-sm {\n  font-size: calc(14 / 16 * 1em); /* converts a 14px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 14 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 14 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-lg {\n  font-size: calc(20 / 16 * 1em); /* converts a 20px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 20 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 20 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-xl {\n  font-size: calc(24 / 16 * 1em); /* converts a 24px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 24 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 24 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-2xl {\n  font-size: calc(32 / 16 * 1em); /* converts a 32px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 32 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 32 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-width-auto {\n  --fa-width: auto;\n}\n\n.fa-fw,\n.fa-width-fixed {\n  --fa-width: 1.25em;\n}\n\n.fa-canvas-square {\n  padding-block: 0.125em;\n  margin-block-end: -0.125em;\n}\n\n.fa-canvas-roomy {\n  padding-block: 0.25em;\n  padding-inline: 0.125em;\n  margin-block-end: -0.25em;\n  box-sizing: content-box;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-inline-start: var(--fa-li-margin, 2.5em);\n  padding-inline-start: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  inset-inline-start: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n/* Heads Up: Bordered Icons will not be supported in the future!\n  - This feature will be deprecated in the next major release of Font Awesome (v8)!\n  - You may continue to use it in this version *v7), but it will not be supported in Font Awesome v8.\n*/\n/* Notes:\n* --@{v.$css-prefix}-border-width = 1/16 by default (to render as ~1px based on a 16px default font-size)\n* --@{v.$css-prefix}-border-padding =\n  ** 3/16 for vertical padding (to give ~2px of vertical whitespace around an icon considering it's vertical alignment)\n  ** 4/16 for horizontal padding (to give ~4px of horizontal whitespace around an icon)\n*/\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.0625em);\n  box-sizing: var(--fa-border-box-sizing, content-box);\n  padding: var(--fa-border-padding, 0.1875em 0.25em);\n}\n\n.fa-pull-left,\n.fa-pull-start {\n  float: inline-start;\n  margin-inline-end: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right,\n.fa-pull-end {\n  float: inline-end;\n  margin-inline-start: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1.5s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-flip-360 {\n  animation-name: fa-flip-360;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 0.75s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n.fa-spin-snap {\n  animation-name: fa-spin-snap;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 3s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-snap-4 {\n  animation-name: fa-spin-snap-4;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2.4s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-snap-8 {\n  animation-name: fa-spin-snap-8;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 4s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-buzz {\n  animation-name: fa-buzz;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 0.6s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-wag {\n  animation-name: fa-wag;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 0.9s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-out);\n  transform-origin: bottom center;\n}\n\n.fa-float {\n  animation-name: fa-float;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 3s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n  will-change: transform;\n}\n\n.fa-swing {\n  animation-name: fa-swing;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1.2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-out);\n  transform-origin: top center;\n}\n\n.fa-jello {\n  animation-name: fa-jello;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 0.9s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-out);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n  .fa-bounce,\n  .fa-fade,\n  .fa-beat-fade,\n  .fa-flip,\n  .fa-flip-360,\n  .fa-pulse,\n  .fa-shake,\n  .fa-spin,\n  .fa-spin-pulse,\n  .fa-buzz,\n  .fa-float,\n  .fa-jello,\n  .fa-spin-snap,\n  .fa-spin-snap-4,\n  .fa-spin-snap-8,\n  .fa-swing,\n  .fa-wag {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n@keyframes fa-beat {\n  0% {\n    transform: scale(1);\n  }\n  25% {\n    transform: scale(calc(1.25 * var(--fa-beat-scale, 1.25)));\n  }\n  45% {\n    transform: scale(calc(1.22 * var(--fa-beat-scale, 1.22)));\n  }\n  65% {\n    transform: scale(calc(1.25 * var(--fa-beat-scale, 1.25)));\n  }\n  90% {\n    transform: scale(1);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n    animation-timing-function: var(--fa-animation-timing);\n  }\n  14% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.06), var(--fa-bounce-start-scale-y, 0.94)) translateY(var(--fa-bounce-anticipation, 3px));\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);\n  }\n  32% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.94), var(--fa-bounce-jump-scale-y, 1.12)) translateY(calc(-1 * var(--fa-bounce-height, 0.5em)));\n    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);\n  }\n  52% {\n    transform: scale(1, 1) translateY(calc(-1 * var(--fa-bounce-height, 0.5em) * 1.1));\n    animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);\n  }\n  70% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.06), var(--fa-bounce-land-scale-y, 0.92)) translateY(0);\n    animation-timing-function: cubic-bezier(0.33, 0.33, 0.66, 1);\n  }\n  85% {\n    transform: scale(0.98, 1.04) translateY(calc(-2px * var(--fa-bounce-rebound, 1)));\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 1);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.4, 1);\n  }\n  40% {\n    opacity: var(--fa-fade-opacity, 0.4);\n    transform: scale(0.98);\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes fa-beat-fade {\n  0% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.4, 1);\n  }\n  25% {\n    opacity: calc(var(--fa-beat-fade-opacity, 0.4) + 0.4);\n    transform: scale(var(--fa-beat-fade-scale, 1.28));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  45% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.25));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  65% {\n    opacity: calc(var(--fa-beat-fade-opacity, 0.4) + 0.4);\n    transform: scale(var(--fa-beat-fade-scale, 1.28));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n}\n@keyframes fa-flip {\n  0% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), 0deg);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.4, 1);\n  }\n  8% {\n    transform: perspective(2em) scale(var(--fa-flip-anticipation-scale, 0.95)) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), 0deg);\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);\n  }\n  35% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * 0.6));\n    animation-timing-function: linear;\n  }\n  65% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * 0.5));\n    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);\n  }\n  92% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * var(--fa-flip-overshoot, 1.04)));\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 1);\n  }\n  100% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -360deg));\n  }\n}\n@keyframes fa-flip-360 {\n  0% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), 0deg);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.4, 1);\n  }\n  8% {\n    transform: perspective(2em) scale(var(--fa-flip-anticipation-scale, 0.95)) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), 0deg);\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);\n  }\n  50% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * 0.6));\n    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);\n  }\n  80% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * var(--fa-flip-overshoot, 1.04)));\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 1);\n  }\n  100% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -360deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(0deg);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.8, 1);\n  }\n  8% {\n    transform: rotate(35deg) translateX(1px);\n    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);\n  }\n  20% {\n    transform: rotate(-22deg) translateX(-1px);\n    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);\n  }\n  35% {\n    transform: rotate(15deg) translateX(1px);\n    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);\n  }\n  50% {\n    transform: rotate(-9deg);\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  65% {\n    transform: rotate(5deg);\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  78% {\n    transform: rotate(-3deg);\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  90% {\n    transform: rotate(1deg);\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin-snap {\n  0% {\n    transform: rotate(0deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  12% {\n    transform: rotate(60deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  16.67% {\n    transform: rotate(60deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  28.67% {\n    transform: rotate(120deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  33.33% {\n    transform: rotate(120deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  45.33% {\n    transform: rotate(180deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  50% {\n    transform: rotate(180deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  62% {\n    transform: rotate(240deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  66.67% {\n    transform: rotate(240deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  78.67% {\n    transform: rotate(300deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  83.33% {\n    transform: rotate(300deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  95.33% {\n    transform: rotate(360deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin-snap-4 {\n  0% {\n    transform: rotate(0deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  15% {\n    transform: rotate(90deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  25% {\n    transform: rotate(90deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  40% {\n    transform: rotate(180deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  50% {\n    transform: rotate(180deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  65% {\n    transform: rotate(270deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  75% {\n    transform: rotate(270deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  90% {\n    transform: rotate(360deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin-snap-8 {\n  0% {\n    transform: rotate(0deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  9% {\n    transform: rotate(45deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  12.5% {\n    transform: rotate(45deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  21.5% {\n    transform: rotate(90deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  25% {\n    transform: rotate(90deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  34% {\n    transform: rotate(135deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  37.5% {\n    transform: rotate(135deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  46.5% {\n    transform: rotate(180deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  50% {\n    transform: rotate(180deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  59% {\n    transform: rotate(225deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  62.5% {\n    transform: rotate(225deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  71.5% {\n    transform: rotate(270deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  75% {\n    transform: rotate(270deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  84% {\n    transform: rotate(315deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  87.5% {\n    transform: rotate(315deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  96.5% {\n    transform: rotate(360deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes fa-buzz {\n  0% {\n    transform: translateX(0) rotate(0deg);\n    animation-timing-function: cubic-bezier(0.1, 0, 0.9, 1);\n  }\n  5% {\n    transform: translateX(var(--fa-buzz-distance, 4px)) rotate(0.5deg);\n  }\n  10% {\n    transform: translateX(calc(-1 * var(--fa-buzz-distance, 4px))) rotate(-0.5deg);\n  }\n  15% {\n    transform: translateX(var(--fa-buzz-distance, 4px)) rotate(0.3deg);\n  }\n  20% {\n    transform: translateX(calc(-1 * var(--fa-buzz-distance, 4px))) rotate(-0.3deg);\n  }\n  25% {\n    transform: translateX(calc(var(--fa-buzz-distance, 4px) * 0.7)) rotate(0.2deg);\n  }\n  30% {\n    transform: translateX(calc(-1 * var(--fa-buzz-distance, 4px) * 0.7)) rotate(-0.2deg);\n  }\n  35% {\n    transform: translateX(calc(var(--fa-buzz-distance, 4px) * 0.4)) rotate(0.1deg);\n  }\n  40% {\n    transform: translateX(0) rotate(0deg);\n  }\n  100% {\n    transform: translateX(0) rotate(0deg);\n  }\n}\n@keyframes fa-wag {\n  0% {\n    transform: rotate(0deg);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.6, 1);\n  }\n  12% {\n    transform: rotate(var(--fa-wag-angle, 12deg));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  24% {\n    transform: rotate(2deg);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.6, 1);\n  }\n  36% {\n    transform: rotate(calc(var(--fa-wag-angle, 12deg) * 0.85));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  48% {\n    transform: rotate(1deg);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.6, 1);\n  }\n  58% {\n    transform: rotate(calc(var(--fa-wag-angle, 12deg) * 0.6));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  68% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-float {\n  0% {\n    transform: translateY(0) translateX(0) rotate(0deg) scale(var(--fa-float-squash-x, 1.02), var(--fa-float-squash-y, 0.98));\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);\n  }\n  15% {\n    transform: translateY(calc(-0.4 * var(--fa-float-height, 6px))) translateX(var(--fa-float-drift, 1px)) rotate(var(--fa-float-tilt, 1deg)) scale(1, 1);\n    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);\n  }\n  35% {\n    transform: translateY(calc(-1 * var(--fa-float-height, 6px))) translateX(0) rotate(0deg) scale(var(--fa-float-stretch-x, 0.98), var(--fa-float-stretch-y, 1.03));\n    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 0);\n  }\n  50% {\n    transform: translateY(calc(-0.92 * var(--fa-float-height, 6px))) translateX(calc(-0.5 * var(--fa-float-drift, 1px))) rotate(calc(-0.5 * var(--fa-float-tilt, 1deg))) scale(0.995, 1.01);\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);\n  }\n  70% {\n    transform: translateY(calc(-0.3 * var(--fa-float-height, 6px))) translateX(calc(-1 * var(--fa-float-drift, 1px))) rotate(calc(-1 * var(--fa-float-tilt, 1deg))) scale(1, 1);\n    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);\n  }\n  90% {\n    transform: translateY(calc(0.05 * var(--fa-float-height, 6px))) translateX(0) rotate(0deg) scale(var(--fa-float-squash-x, 1.02), var(--fa-float-squash-y, 0.98));\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 1);\n  }\n  100% {\n    transform: translateY(0) translateX(0) rotate(0deg) scale(var(--fa-float-squash-x, 1.02), var(--fa-float-squash-y, 0.98));\n  }\n}\n@keyframes fa-swing {\n  0% {\n    transform: rotate(0deg);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.8, 1);\n  }\n  8% {\n    transform: rotate(var(--fa-swing-angle, 22deg));\n    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);\n  }\n  18% {\n    transform: rotate(calc(-1 * var(--fa-swing-angle, 22deg) * 0.85));\n    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);\n  }\n  28% {\n    transform: rotate(calc(var(--fa-swing-angle, 22deg) * 0.65));\n    animation-timing-function: cubic-bezier(0.35, 0, 0.65, 1);\n  }\n  38% {\n    transform: rotate(calc(-1 * var(--fa-swing-angle, 22deg) * 0.45));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  48% {\n    transform: rotate(calc(var(--fa-swing-angle, 22deg) * 0.25));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  56% {\n    transform: rotate(calc(-1 * var(--fa-swing-angle, 22deg) * 0.1));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  64% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-jello {\n  0% {\n    transform: scale(1, 1);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.8, 1);\n  }\n  12% {\n    transform: scale(var(--fa-jello-scale-x, 1.15), calc(2 - var(--fa-jello-scale-x, 1.15)));\n    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);\n  }\n  24% {\n    transform: scale(calc(2 - var(--fa-jello-scale-y, 1.12)), var(--fa-jello-scale-y, 1.12));\n    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);\n  }\n  36% {\n    transform: scale(calc(1 + (var(--fa-jello-scale-x, 1.15) - 1) * 0.5), calc(2 - (1 + (var(--fa-jello-scale-x, 1.15) - 1) * 0.5)));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  48% {\n    transform: scale(calc(2 - (1 + (var(--fa-jello-scale-y, 1.12) - 1) * 0.3)), calc(1 + (var(--fa-jello-scale-y, 1.12) - 1) * 0.3));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  58% {\n    transform: scale(1.02, 0.98);\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  68% {\n    transform: scale(1, 1);\n  }\n  100% {\n    transform: scale(1, 1);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.svg-inline--fa.fa-inverse {\n  fill: var(--fa-inverse, #fff);\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  --fa-width: 1.25em;\n  height: 1em;\n  width: var(--fa-width);\n}\n.svg-inline--fa.fa-stack-2x {\n  --fa-width: 2.5em;\n  height: 2em;\n  width: var(--fa-width);\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  inset: 0;\n  margin: auto;\n  position: absolute;\n  z-index: var(--fa-stack-z-index, auto);\n}";
function $9bfddff2bd1f5fe3$var$css() {
    var dcp = $9bfddff2bd1f5fe3$var$DEFAULT_CSS_PREFIX;
    var drc = $9bfddff2bd1f5fe3$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $9bfddff2bd1f5fe3$var$config.cssPrefix;
    var rc = $9bfddff2bd1f5fe3$var$config.replacementClass;
    var s = $9bfddff2bd1f5fe3$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
        var rPatt = new RegExp("\\.".concat(drc), 'g');
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $9bfddff2bd1f5fe3$var$_cssInserted = false;
function $9bfddff2bd1f5fe3$var$ensureCss() {
    if ($9bfddff2bd1f5fe3$var$config.autoAddCss && !$9bfddff2bd1f5fe3$var$_cssInserted) {
        $9bfddff2bd1f5fe3$var$insertCss($9bfddff2bd1f5fe3$var$css());
        $9bfddff2bd1f5fe3$var$_cssInserted = true;
    }
}
var $9bfddff2bd1f5fe3$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $9bfddff2bd1f5fe3$var$css,
                insertCss: $9bfddff2bd1f5fe3$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $9bfddff2bd1f5fe3$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $9bfddff2bd1f5fe3$var$ensureCss();
            }
        };
    }
};
var $9bfddff2bd1f5fe3$var$w$2 = $9bfddff2bd1f5fe3$var$WINDOW || {};
if (!$9bfddff2bd1f5fe3$var$w$2[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER]) $9bfddff2bd1f5fe3$var$w$2[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER] = {};
if (!$9bfddff2bd1f5fe3$var$w$2[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER].styles) $9bfddff2bd1f5fe3$var$w$2[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$9bfddff2bd1f5fe3$var$w$2[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER].hooks) $9bfddff2bd1f5fe3$var$w$2[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$9bfddff2bd1f5fe3$var$w$2[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER].shims) $9bfddff2bd1f5fe3$var$w$2[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER].shims = [];
var $9bfddff2bd1f5fe3$var$namespace = $9bfddff2bd1f5fe3$var$w$2[$9bfddff2bd1f5fe3$var$NAMESPACE_IDENTIFIER];
var $9bfddff2bd1f5fe3$var$functions = [];
var $9bfddff2bd1f5fe3$var$_listener = function listener() {
    $9bfddff2bd1f5fe3$var$DOCUMENT.removeEventListener('DOMContentLoaded', $9bfddff2bd1f5fe3$var$_listener);
    $9bfddff2bd1f5fe3$var$loaded = 1;
    $9bfddff2bd1f5fe3$var$functions.map(function(fn) {
        return fn();
    });
};
var $9bfddff2bd1f5fe3$var$loaded = false;
if ($9bfddff2bd1f5fe3$var$IS_DOM) {
    $9bfddff2bd1f5fe3$var$loaded = ($9bfddff2bd1f5fe3$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($9bfddff2bd1f5fe3$var$DOCUMENT.readyState);
    if (!$9bfddff2bd1f5fe3$var$loaded) $9bfddff2bd1f5fe3$var$DOCUMENT.addEventListener('DOMContentLoaded', $9bfddff2bd1f5fe3$var$_listener);
}
function $9bfddff2bd1f5fe3$var$domready(fn) {
    if (!$9bfddff2bd1f5fe3$var$IS_DOM) return;
    $9bfddff2bd1f5fe3$var$loaded ? setTimeout(fn, 0) : $9bfddff2bd1f5fe3$var$functions.push(fn);
}
function $9bfddff2bd1f5fe3$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === 'string') return $9bfddff2bd1f5fe3$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($9bfddff2bd1f5fe3$var$joinAttributes(attributes), ">").concat(children.map($9bfddff2bd1f5fe3$var$toHtml).join(''), "</").concat(tag, ">");
}
function $9bfddff2bd1f5fe3$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $9bfddff2bd1f5fe3$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $9bfddff2bd1f5fe3$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $9bfddff2bd1f5fe3$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * Return hexadecimal string for a unicode character
 * Returns `null` when more than one character (not bytes!) are passed
 * For example: 'K' → '7B'
 */ function $9bfddff2bd1f5fe3$var$toHex(unicode) {
    if ($9bfddff2bd1f5fe3$var$_toConsumableArray(unicode).length !== 1) return null;
    return unicode.codePointAt(0).toString(16);
}
function $9bfddff2bd1f5fe3$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $9bfddff2bd1f5fe3$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $9bfddff2bd1f5fe3$var$normalizeIcons(icons);
    if (typeof $9bfddff2bd1f5fe3$var$namespace.hooks.addPack === 'function' && !skipHooks) $9bfddff2bd1f5fe3$var$namespace.hooks.addPack(prefix, $9bfddff2bd1f5fe3$var$normalizeIcons(icons));
    else $9bfddff2bd1f5fe3$var$namespace.styles[prefix] = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === 'fas') $9bfddff2bd1f5fe3$var$defineIcons('fa', icons);
}
var $9bfddff2bd1f5fe3$var$MONO = 0x1;
var $9bfddff2bd1f5fe3$var$DUO = 0x2;
// New v7 compatible matchers using the style attribute to determine layer membership
var $9bfddff2bd1f5fe3$var$modernMatches = [
    [
        $9bfddff2bd1f5fe3$var$DUO,
        /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path opacity="([^"]*)".*d="([^"]*)".*path.*d="([^"]*)"/, {
            d2: 2,
            d1: 3
        })
    ],
    [
        $9bfddff2bd1f5fe3$var$DUO,
        /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path opacity="([^"]*)".*d="([^"]*)"/, {
            d2: 2
        })
    ],
    [
        $9bfddff2bd1f5fe3$var$MONO,
        /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path fill="currentColor".*d="([^"]+)"/, {
            d1: 1
        })
    ]
];
// Old <= v6 matchers, these should rarely get used.
//
// Why are there so many? Over the lifecycle of version 5 and 6 we modified the
// syntax for our source SVG files several times. These patterns match the
// historical record and attempt to handle backwards-compatibility in rare edge
// cases (loading version 6 SVG source files using the version 7 SVG parser)
var $9bfddff2bd1f5fe3$var$legacyMatches = [
    [
        $9bfddff2bd1f5fe3$var$DUO,
        /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path class="([^"]*secondary[^"]*)".*d="([^"]+)".*path class="([^"]*primary[^"]*)".*d="([^"]+)"/, {
            attr2: 1,
            d2: 2,
            attr1: 3,
            d1: 4
        })
    ],
    [
        $9bfddff2bd1f5fe3$var$DUO,
        /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path class="([^"]*primary[^"]*)".*d="([^"]+)".*path class="([^"]*secondary[^"]*)".*d="([^"]+)"/, {
            attr1: 1,
            d1: 2,
            attr2: 3,
            d2: 4
        })
    ],
    [
        $9bfddff2bd1f5fe3$var$DUO,
        /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path class="([^"]*primary[^"]*)".*d="([^"]+)"/, {
            attr1: 1,
            d1: 2
        })
    ],
    [
        $9bfddff2bd1f5fe3$var$DUO,
        /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path class="([^"]*secondary[^"]*)".*d="([^"]+)"/, {
            attr2: 1,
            d2: 2
        })
    ],
    [
        $9bfddff2bd1f5fe3$var$DUO,
        /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*secondary[^"]*)".*path d="([^"]+)".*class="([^"]*primary[^"]*)"/, {
            d2: 1,
            attr2: 2,
            d1: 3,
            attr1: 4
        })
    ],
    [
        $9bfddff2bd1f5fe3$var$DUO,
        /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*primary[^"]*)".*path d="([^"]+)".*class="([^"]*secondary[^"]*)"/, {
            d1: 1,
            attr1: 2,
            d2: 3,
            attr2: 4
        })
    ],
    [
        $9bfddff2bd1f5fe3$var$DUO,
        /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*primary[^"]*)"/, {
            d1: 1,
            attr1: 2
        })
    ],
    [
        $9bfddff2bd1f5fe3$var$DUO,
        /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*secondary[^"]*)"/, {
            d2: 1,
            attr2: 2
        })
    ],
    [
        $9bfddff2bd1f5fe3$var$DUO,
        /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path d="([^"]+)".*path d="([^"]+)"/, {
            d1: 1,
            d2: 2
        })
    ],
    [
        $9bfddff2bd1f5fe3$var$MONO,
        /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path d="([^"]+)"/, {
            d1: 1
        })
    ],
    [
        $9bfddff2bd1f5fe3$var$MONO,
        /*#__PURE__*/ $9bfddff2bd1f5fe3$var$_wrapRegExp(/path style="([^"]+)".*d="([^"]+)"/, {
            attr1: 1,
            d1: 2
        })
    ]
];
var $9bfddff2bd1f5fe3$var$styles = $9bfddff2bd1f5fe3$var$namespace.styles, $9bfddff2bd1f5fe3$var$shims = $9bfddff2bd1f5fe3$var$namespace.shims;
var $9bfddff2bd1f5fe3$var$FAMILY_NAMES = Object.keys($9bfddff2bd1f5fe3$var$PREFIX_TO_LONG_STYLE);
var $9bfddff2bd1f5fe3$var$PREFIXES_FOR_FAMILY = $9bfddff2bd1f5fe3$var$FAMILY_NAMES.reduce(function(acc, familyId) {
    acc[familyId] = Object.keys($9bfddff2bd1f5fe3$var$PREFIX_TO_LONG_STYLE[familyId]);
    return acc;
}, {});
var $9bfddff2bd1f5fe3$var$_defaultUsablePrefix = null;
var $9bfddff2bd1f5fe3$var$_byUnicode = {};
var $9bfddff2bd1f5fe3$var$_byLigature = {};
var $9bfddff2bd1f5fe3$var$_byOldName = {};
var $9bfddff2bd1f5fe3$var$_byOldUnicode = {};
var $9bfddff2bd1f5fe3$var$_byAlias = {};
function $9bfddff2bd1f5fe3$var$isReserved(name) {
    return ~$9bfddff2bd1f5fe3$var$RESERVED_CLASSES.indexOf(name);
}
function $9bfddff2bd1f5fe3$var$getIconName(cssPrefix, cls) {
    var parts = cls.split('-');
    var prefix = parts[0];
    var iconName = parts.slice(1).join('-');
    if (prefix === cssPrefix && iconName !== '' && !$9bfddff2bd1f5fe3$var$isReserved(iconName)) return iconName;
    else return null;
}
var $9bfddff2bd1f5fe3$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $9bfddff2bd1f5fe3$var$reduce($9bfddff2bd1f5fe3$var$styles, function(o$$1, style, prefix) {
            o$$1[prefix] = $9bfddff2bd1f5fe3$var$reduce(style, reducer, {});
            return o$$1;
        }, {});
    };
    $9bfddff2bd1f5fe3$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a$$1) {
                return typeof a$$1 === 'number';
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $9bfddff2bd1f5fe3$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a$$1) {
                return typeof a$$1 === 'string';
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $9bfddff2bd1f5fe3$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    });
    // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = 'far' in $9bfddff2bd1f5fe3$var$styles || $9bfddff2bd1f5fe3$var$config.autoFetchSvg;
    var shimLookups = $9bfddff2bd1f5fe3$var$reduce($9bfddff2bd1f5fe3$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === 'far' && !hasRegular) prefix = 'fas';
        if (typeof maybeNameMaybeUnicode === 'string') acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === 'number') acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $9bfddff2bd1f5fe3$var$_byOldName = shimLookups.names;
    $9bfddff2bd1f5fe3$var$_byOldUnicode = shimLookups.unicodes;
    $9bfddff2bd1f5fe3$var$_defaultUsablePrefix = $9bfddff2bd1f5fe3$var$getCanonicalPrefix($9bfddff2bd1f5fe3$var$config.styleDefault, {
        family: $9bfddff2bd1f5fe3$var$config.familyDefault
    });
};
$9bfddff2bd1f5fe3$var$onChange(function(c$$1) {
    $9bfddff2bd1f5fe3$var$_defaultUsablePrefix = $9bfddff2bd1f5fe3$var$getCanonicalPrefix(c$$1.styleDefault, {
        family: $9bfddff2bd1f5fe3$var$config.familyDefault
    });
});
$9bfddff2bd1f5fe3$var$build();
function $9bfddff2bd1f5fe3$var$byUnicode(prefix, unicode) {
    return ($9bfddff2bd1f5fe3$var$_byUnicode[prefix] || {})[unicode];
}
function $9bfddff2bd1f5fe3$var$byLigature(prefix, ligature) {
    return ($9bfddff2bd1f5fe3$var$_byLigature[prefix] || {})[ligature];
}
function $9bfddff2bd1f5fe3$var$byAlias(prefix, alias) {
    return ($9bfddff2bd1f5fe3$var$_byAlias[prefix] || {})[alias];
}
function $9bfddff2bd1f5fe3$var$byOldName(name) {
    return $9bfddff2bd1f5fe3$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $9bfddff2bd1f5fe3$var$byOldUnicode(unicode) {
    var oldUnicode = $9bfddff2bd1f5fe3$var$_byOldUnicode[unicode];
    var newUnicode = $9bfddff2bd1f5fe3$var$byUnicode('fas', unicode);
    return oldUnicode || (newUnicode ? {
        prefix: 'fas',
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix() {
    return $9bfddff2bd1f5fe3$var$_defaultUsablePrefix;
}
var $9bfddff2bd1f5fe3$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $9bfddff2bd1f5fe3$var$getFamilyId(values) {
    var family = $9bfddff2bd1f5fe3$var$u;
    var famProps = $9bfddff2bd1f5fe3$var$FAMILY_NAMES.reduce(function(acc, familyId) {
        acc[familyId] = "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-").concat(familyId);
        return acc;
    }, {});
    $9bfddff2bd1f5fe3$var$xl.forEach(function(familyId) {
        if (values.includes(famProps[familyId]) || values.some(function(v$$1) {
            return $9bfddff2bd1f5fe3$var$PREFIXES_FOR_FAMILY[familyId].includes(v$$1);
        })) family = familyId;
    });
    return family;
}
function $9bfddff2bd1f5fe3$var$getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? $9bfddff2bd1f5fe3$var$u : _params$family;
    var style = $9bfddff2bd1f5fe3$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    // handles the exception of passing in only a family of 'duotone' with no style
    if (family === $9bfddff2bd1f5fe3$var$l && !styleOrPrefix) return 'fad';
    var prefix = $9bfddff2bd1f5fe3$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $9bfddff2bd1f5fe3$var$STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in $9bfddff2bd1f5fe3$var$namespace.styles ? styleOrPrefix : null;
    var result = prefix || defined || null;
    return result;
}
function $9bfddff2bd1f5fe3$var$moveNonFaClassesToRest(classNames) {
    var rest = [];
    var iconName = null;
    classNames.forEach(function(cls) {
        var result = $9bfddff2bd1f5fe3$var$getIconName($9bfddff2bd1f5fe3$var$config.cssPrefix, cls);
        if (result) iconName = result;
        else if (cls) rest.push(cls);
    });
    return {
        iconName: iconName,
        rest: rest
    };
}
function $9bfddff2bd1f5fe3$var$sortedUniqueValues(arr) {
    return arr.sort().filter(function(value, index, arr) {
        return arr.indexOf(value) === index;
    });
}
var $9bfddff2bd1f5fe3$var$_faCombinedClasses = $9bfddff2bd1f5fe3$var$ha.concat($9bfddff2bd1f5fe3$var$at);
function $9bfddff2bd1f5fe3$var$getCanonicalIcon(values) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var givenPrefix = null;
    var faStyleOrFamilyClasses = $9bfddff2bd1f5fe3$var$sortedUniqueValues(values.filter(function(cls) {
        return $9bfddff2bd1f5fe3$var$_faCombinedClasses.includes(cls);
    }));
    var nonStyleOrFamilyClasses = $9bfddff2bd1f5fe3$var$sortedUniqueValues(values.filter(function(cls) {
        return !$9bfddff2bd1f5fe3$var$_faCombinedClasses.includes(cls);
    }));
    var faStyles = faStyleOrFamilyClasses.filter(function(cls) {
        givenPrefix = cls;
        return !$9bfddff2bd1f5fe3$var$dl.includes(cls);
    });
    var _faStyles = $9bfddff2bd1f5fe3$var$_slicedToArray(faStyles, 1), _faStyles$ = _faStyles[0], styleFromValues = _faStyles$ === void 0 ? null : _faStyles$;
    var family = $9bfddff2bd1f5fe3$var$getFamilyId(faStyleOrFamilyClasses);
    var canonical = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$moveNonFaClassesToRest(nonStyleOrFamilyClasses)), {}, {
        prefix: $9bfddff2bd1f5fe3$var$getCanonicalPrefix(styleFromValues, {
            family: family
        })
    });
    return $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, canonical), $9bfddff2bd1f5fe3$var$getDefaultCanonicalPrefix({
        values: values,
        family: family,
        styles: $9bfddff2bd1f5fe3$var$styles,
        config: $9bfddff2bd1f5fe3$var$config,
        canonical: canonical,
        givenPrefix: givenPrefix
    })), $9bfddff2bd1f5fe3$var$applyShimAndAlias(skipLookups, givenPrefix, canonical));
}
function $9bfddff2bd1f5fe3$var$applyShimAndAlias(skipLookups, givenPrefix, canonical) {
    var prefix = canonical.prefix, iconName = canonical.iconName;
    if (skipLookups || !prefix || !iconName) return {
        prefix: prefix,
        iconName: iconName
    };
    var shim = givenPrefix === 'fa' ? $9bfddff2bd1f5fe3$var$byOldName(iconName) : {};
    var aliasIconName = $9bfddff2bd1f5fe3$var$byAlias(prefix, iconName);
    iconName = shim.iconName || aliasIconName || iconName;
    prefix = shim.prefix || prefix;
    if (prefix === 'far' && !$9bfddff2bd1f5fe3$var$styles['far'] && $9bfddff2bd1f5fe3$var$styles['fas'] && !$9bfddff2bd1f5fe3$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
    // but only if we aren't auto-fetching SVGs
    prefix = 'fas';
    return {
        prefix: prefix,
        iconName: iconName
    };
}
var $9bfddff2bd1f5fe3$var$newCanonicalFamilies = $9bfddff2bd1f5fe3$var$xl.filter(function(familyId) {
    return familyId !== $9bfddff2bd1f5fe3$var$u || familyId !== $9bfddff2bd1f5fe3$var$l;
});
var $9bfddff2bd1f5fe3$var$newCanonicalStyles = Object.keys($9bfddff2bd1f5fe3$var$da).filter(function(key) {
    return key !== $9bfddff2bd1f5fe3$var$u;
}).map(function(key) {
    return Object.keys($9bfddff2bd1f5fe3$var$da[key]);
}).flat();
function $9bfddff2bd1f5fe3$var$getDefaultCanonicalPrefix(prefixOptions) {
    var values = prefixOptions.values, family = prefixOptions.family, canonical = prefixOptions.canonical, _prefixOptions$givenP = prefixOptions.givenPrefix, givenPrefix = _prefixOptions$givenP === void 0 ? '' : _prefixOptions$givenP, _prefixOptions$styles = prefixOptions.styles, styles = _prefixOptions$styles === void 0 ? {} : _prefixOptions$styles, _prefixOptions$config = prefixOptions.config, config$$1 = _prefixOptions$config === void 0 ? {} : _prefixOptions$config;
    var isDuotoneFamily = family === $9bfddff2bd1f5fe3$var$l;
    var valuesHasDuotone = values.includes('fa-duotone') || values.includes('fad');
    var defaultFamilyIsDuotone = config$$1.familyDefault === 'duotone';
    var canonicalPrefixIsDuotone = canonical.prefix === 'fad' || canonical.prefix === 'fa-duotone';
    if (!isDuotoneFamily && (valuesHasDuotone || defaultFamilyIsDuotone || canonicalPrefixIsDuotone)) canonical.prefix = 'fad';
    if (values.includes('fa-brands') || values.includes('fab')) canonical.prefix = 'fab';
    if (!canonical.prefix && $9bfddff2bd1f5fe3$var$newCanonicalFamilies.includes(family)) {
        var validPrefix = Object.keys(styles).find(function(key) {
            return $9bfddff2bd1f5fe3$var$newCanonicalStyles.includes(key);
        });
        if (validPrefix || config$$1.autoFetchSvg) {
            var defaultPrefix = $9bfddff2bd1f5fe3$var$Ql.get(family).defaultShortPrefixId;
            canonical.prefix = defaultPrefix;
            canonical.iconName = $9bfddff2bd1f5fe3$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
        }
    }
    if (canonical.prefix === 'fa' || givenPrefix === 'fa') // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix() || 'fas';
    return canonical;
}
var $9bfddff2bd1f5fe3$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $9bfddff2bd1f5fe3$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    return $9bfddff2bd1f5fe3$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $9bfddff2bd1f5fe3$var$defineIcons(key, additions[key]);
                    // To keep support for older Classic styles, also add longer prefixes
                    var longPrefix = $9bfddff2bd1f5fe3$var$PREFIX_TO_LONG_STYLE[$9bfddff2bd1f5fe3$var$u][key];
                    if (longPrefix) $9bfddff2bd1f5fe3$var$defineIcons(longPrefix, additions[key]);
                    $9bfddff2bd1f5fe3$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === 'string') additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
}();
var $9bfddff2bd1f5fe3$var$_plugins = [];
var $9bfddff2bd1f5fe3$var$_hooks = {};
var $9bfddff2bd1f5fe3$var$providers = {};
var $9bfddff2bd1f5fe3$var$defaultProviderKeys = Object.keys($9bfddff2bd1f5fe3$var$providers);
function $9bfddff2bd1f5fe3$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $9bfddff2bd1f5fe3$var$_plugins = nextPlugins;
    $9bfddff2bd1f5fe3$var$_hooks = {};
    Object.keys($9bfddff2bd1f5fe3$var$providers).forEach(function(k) {
        if ($9bfddff2bd1f5fe3$var$defaultProviderKeys.indexOf(k) === -1) delete $9bfddff2bd1f5fe3$var$providers[k];
    });
    $9bfddff2bd1f5fe3$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === 'function') obj[tk] = mixout[tk];
            if ($9bfddff2bd1f5fe3$var$_typeof(mixout[tk]) === 'object') Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$9bfddff2bd1f5fe3$var$_hooks[hook]) $9bfddff2bd1f5fe3$var$_hooks[hook] = [];
                $9bfddff2bd1f5fe3$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($9bfddff2bd1f5fe3$var$providers);
    });
    return obj;
}
function $9bfddff2bd1f5fe3$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $9bfddff2bd1f5fe3$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args));
    });
    return accumulator;
}
function $9bfddff2bd1f5fe3$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $9bfddff2bd1f5fe3$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $9bfddff2bd1f5fe3$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $9bfddff2bd1f5fe3$var$providers[hook] ? $9bfddff2bd1f5fe3$var$providers[hook].apply(null, args) : undefined;
}
function $9bfddff2bd1f5fe3$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === 'fa') iconLookup.prefix = 'fas';
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $9bfddff2bd1f5fe3$var$byAlias(prefix, iconName) || iconName;
    return $9bfddff2bd1f5fe3$var$iconFromMapping($9bfddff2bd1f5fe3$var$library.definitions, prefix, iconName) || $9bfddff2bd1f5fe3$var$iconFromMapping($9bfddff2bd1f5fe3$var$namespace.styles, prefix, iconName);
}
var $9bfddff2bd1f5fe3$var$library = new $9bfddff2bd1f5fe3$var$Library();
var $9bfddff2bd1f5fe3$var$noAuto = function noAuto() {
    $9bfddff2bd1f5fe3$var$config.autoReplaceSvg = false;
    $9bfddff2bd1f5fe3$var$config.observeMutations = false;
    $9bfddff2bd1f5fe3$var$callHooks('noAuto');
};
var $9bfddff2bd1f5fe3$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($9bfddff2bd1f5fe3$var$IS_DOM) {
            $9bfddff2bd1f5fe3$var$callHooks('beforeI2svg', params);
            $9bfddff2bd1f5fe3$var$callProvided('pseudoElements2svg', params);
            return $9bfddff2bd1f5fe3$var$callProvided('i2svg', params);
        } else return Promise.reject(new Error('Operation requires a DOM of some kind.'));
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($9bfddff2bd1f5fe3$var$config.autoReplaceSvg === false) $9bfddff2bd1f5fe3$var$config.autoReplaceSvg = true;
        $9bfddff2bd1f5fe3$var$config.observeMutations = true;
        $9bfddff2bd1f5fe3$var$domready(function() {
            $9bfddff2bd1f5fe3$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $9bfddff2bd1f5fe3$var$callHooks('watch', params);
        });
    }
};
var $9bfddff2bd1f5fe3$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($9bfddff2bd1f5fe3$var$_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $9bfddff2bd1f5fe3$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $9bfddff2bd1f5fe3$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $9bfddff2bd1f5fe3$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === 'string' && (_icon.indexOf("".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-")) > -1 || _icon.match($9bfddff2bd1f5fe3$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $9bfddff2bd1f5fe3$var$getCanonicalIcon(_icon.split(' '), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix(),
                iconName: $9bfddff2bd1f5fe3$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === 'string') {
            var _prefix = $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $9bfddff2bd1f5fe3$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $9bfddff2bd1f5fe3$export$644d8ea042df96a6 = {
    noAuto: $9bfddff2bd1f5fe3$var$noAuto,
    config: $9bfddff2bd1f5fe3$var$config,
    dom: $9bfddff2bd1f5fe3$var$dom,
    parse: $9bfddff2bd1f5fe3$var$parse,
    library: $9bfddff2bd1f5fe3$var$library,
    findIconDefinition: $9bfddff2bd1f5fe3$var$findIconDefinition,
    toHtml: $9bfddff2bd1f5fe3$var$toHtml
};
var $9bfddff2bd1f5fe3$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $9bfddff2bd1f5fe3$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($9bfddff2bd1f5fe3$var$namespace.styles).length > 0 || $9bfddff2bd1f5fe3$var$config.autoFetchSvg) && $9bfddff2bd1f5fe3$var$IS_DOM && $9bfddff2bd1f5fe3$var$config.autoReplaceSvg) $9bfddff2bd1f5fe3$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $9bfddff2bd1f5fe3$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
        get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
        get: function get() {
            return val.abstract.map(function(a) {
                return $9bfddff2bd1f5fe3$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, 'node', {
        get: function get() {
            if (!$9bfddff2bd1f5fe3$var$IS_DOM) return undefined;
            var container = $9bfddff2bd1f5fe3$var$DOCUMENT.createElement('div');
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $9bfddff2bd1f5fe3$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($9bfddff2bd1f5fe3$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes['style'] = $9bfddff2bd1f5fe3$var$joinStyles($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, styles), {}, {
            'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: 'svg',
            attributes: attributes,
            children: children
        }
    ];
}
function $9bfddff2bd1f5fe3$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: 'svg',
            attributes: {
                style: 'display: none;'
            },
            children: [
                {
                    tag: 'symbol',
                    attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
// If any of these attributes are present, don't assume the icon is decorative
function $9bfddff2bd1f5fe3$var$isLabeled(attributes) {
    var labels = [
        'aria-label',
        'aria-labelledby',
        'title',
        'role'
    ];
    return labels.some(function(label) {
        return label in attributes;
    });
}
function $9bfddff2bd1f5fe3$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, maskId = params.maskId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var attrClass = [
        $9bfddff2bd1f5fe3$var$config.replacementClass,
        iconName ? "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-").concat(iconName) : ''
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== '' || !!c;
    }).concat(extra.classes).join(' ');
    var content = {
        children: [],
        attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, extra.attributes), {}, {
            'data-prefix': prefix,
            'data-icon': iconName,
            'class': attrClass,
            'role': extra.attributes.role || 'img',
            'viewBox': "0 0 ".concat(width, " ").concat(height)
        })
    };
    if (!$9bfddff2bd1f5fe3$var$isLabeled(extra.attributes) && !extra.attributes['aria-hidden']) content.attributes['aria-hidden'] = 'true';
    if (watchable) content.attributes[$9bfddff2bd1f5fe3$var$DATA_FA_I2SVG] = '';
    var args = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $9bfddff2bd1f5fe3$var$_objectSpread2({}, extra.styles)
    });
    var _ref2 = mask.found && main.found ? $9bfddff2bd1f5fe3$var$callProvided('generateAbstractMask', args) || {
        children: [],
        attributes: {}
    } : $9bfddff2bd1f5fe3$var$callProvided('generateAbstractIcon', args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $9bfddff2bd1f5fe3$var$asSymbol(args);
    else return $9bfddff2bd1f5fe3$var$asIcon(args);
}
function $9bfddff2bd1f5fe3$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, extra.attributes), {}, {
        class: extra.classes.join(' ')
    });
    if (watchable) attributes[$9bfddff2bd1f5fe3$var$DATA_FA_I2SVG] = '';
    var styles = $9bfddff2bd1f5fe3$var$_objectSpread2({}, extra.styles);
    if ($9bfddff2bd1f5fe3$var$transformIsMeaningful(transform)) {
        styles['transform'] = $9bfddff2bd1f5fe3$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles['-webkit-transform'] = styles['transform'];
    }
    var styleString = $9bfddff2bd1f5fe3$var$joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    return val;
}
function $9bfddff2bd1f5fe3$var$makeLayersCounterAbstract(params) {
    var content = params.content, extra = params.extra;
    var attributes = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, extra.attributes), {}, {
        class: extra.classes.join(' ')
    });
    var styleString = $9bfddff2bd1f5fe3$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    return val;
}
var $9bfddff2bd1f5fe3$var$styles$1 = $9bfddff2bd1f5fe3$var$namespace.styles;
function $9bfddff2bd1f5fe3$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $9bfddff2bd1f5fe3$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: 'g',
        attributes: {
            class: "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-").concat($9bfddff2bd1f5fe3$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: 'path',
                attributes: {
                    class: "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-").concat($9bfddff2bd1f5fe3$var$DUOTONE_CLASSES.SECONDARY),
                    fill: 'currentColor',
                    d: vectorData[0]
                }
            },
            {
                tag: 'path',
                attributes: {
                    class: "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-").concat($9bfddff2bd1f5fe3$var$DUOTONE_CLASSES.PRIMARY),
                    fill: 'currentColor',
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: 'path',
        attributes: {
            fill: 'currentColor',
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $9bfddff2bd1f5fe3$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $9bfddff2bd1f5fe3$var$maybeNotifyMissing(iconName, prefix) {
    if (!$9bfddff2bd1f5fe3$var$PRODUCTION && !$9bfddff2bd1f5fe3$var$config.showMissingIcons && iconName) console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
}
function $9bfddff2bd1f5fe3$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === 'fa' && $9bfddff2bd1f5fe3$var$config.styleDefault !== null) prefix = $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        if (givenPrefix === 'fa') {
            var shim = $9bfddff2bd1f5fe3$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $9bfddff2bd1f5fe3$var$styles$1[prefix] && $9bfddff2bd1f5fe3$var$styles$1[prefix][iconName]) {
            var icon = $9bfddff2bd1f5fe3$var$styles$1[prefix][iconName];
            return resolve($9bfddff2bd1f5fe3$var$asFoundIcon(icon));
        }
        $9bfddff2bd1f5fe3$var$maybeNotifyMissing(iconName, prefix);
        resolve($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$missingIconResolutionMixin), {}, {
            icon: $9bfddff2bd1f5fe3$var$config.showMissingIcons && iconName ? $9bfddff2bd1f5fe3$var$callProvided('missingIconAbstract') || {} : {}
        }));
    });
}
var $9bfddff2bd1f5fe3$var$noop$1 = function noop() {};
var $9bfddff2bd1f5fe3$var$p$2 = $9bfddff2bd1f5fe3$var$config.measurePerformance && $9bfddff2bd1f5fe3$var$PERFORMANCE && $9bfddff2bd1f5fe3$var$PERFORMANCE.mark && $9bfddff2bd1f5fe3$var$PERFORMANCE.measure ? $9bfddff2bd1f5fe3$var$PERFORMANCE : {
    mark: $9bfddff2bd1f5fe3$var$noop$1,
    measure: $9bfddff2bd1f5fe3$var$noop$1
};
var $9bfddff2bd1f5fe3$var$preamble = "FA \"7.3.1\"";
var $9bfddff2bd1f5fe3$var$begin = function begin(name) {
    $9bfddff2bd1f5fe3$var$p$2.mark("".concat($9bfddff2bd1f5fe3$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $9bfddff2bd1f5fe3$var$end(name);
    };
};
var $9bfddff2bd1f5fe3$var$end = function end(name) {
    $9bfddff2bd1f5fe3$var$p$2.mark("".concat($9bfddff2bd1f5fe3$var$preamble, " ").concat(name, " ends"));
    $9bfddff2bd1f5fe3$var$p$2.measure("".concat($9bfddff2bd1f5fe3$var$preamble, " ").concat(name), "".concat($9bfddff2bd1f5fe3$var$preamble, " ").concat(name, " begins"), "".concat($9bfddff2bd1f5fe3$var$preamble, " ").concat(name, " ends"));
};
var $9bfddff2bd1f5fe3$var$perf = {
    begin: $9bfddff2bd1f5fe3$var$begin,
    end: $9bfddff2bd1f5fe3$var$end
};
var $9bfddff2bd1f5fe3$var$noop$2 = function noop() {};
function $9bfddff2bd1f5fe3$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($9bfddff2bd1f5fe3$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
}
function $9bfddff2bd1f5fe3$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($9bfddff2bd1f5fe3$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($9bfddff2bd1f5fe3$var$DATA_ICON) : null;
    return prefix && icon;
}
function $9bfddff2bd1f5fe3$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($9bfddff2bd1f5fe3$var$config.replacementClass);
}
function $9bfddff2bd1f5fe3$var$getMutator() {
    if ($9bfddff2bd1f5fe3$var$config.autoReplaceSvg === true) return $9bfddff2bd1f5fe3$var$mutators.replace;
    var mutator = $9bfddff2bd1f5fe3$var$mutators[$9bfddff2bd1f5fe3$var$config.autoReplaceSvg];
    return mutator || $9bfddff2bd1f5fe3$var$mutators.replace;
}
function $9bfddff2bd1f5fe3$var$createElementNS(tag) {
    return $9bfddff2bd1f5fe3$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function $9bfddff2bd1f5fe3$var$createElement(tag) {
    return $9bfddff2bd1f5fe3$var$DOCUMENT.createElement(tag);
}
function $9bfddff2bd1f5fe3$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? $9bfddff2bd1f5fe3$var$createElementNS : $9bfddff2bd1f5fe3$var$createElement : _params$ceFn;
    if (typeof abstractObj === 'string') return $9bfddff2bd1f5fe3$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($9bfddff2bd1f5fe3$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $9bfddff2bd1f5fe3$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $9bfddff2bd1f5fe3$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(abstract) {
                node.parentNode.insertBefore($9bfddff2bd1f5fe3$var$convertSVG(abstract), node);
            });
            if (node.getAttribute($9bfddff2bd1f5fe3$var$DATA_FA_I2SVG) === null && $9bfddff2bd1f5fe3$var$config.keepOriginalSource) {
                var comment = $9bfddff2bd1f5fe3$var$DOCUMENT.createComment($9bfddff2bd1f5fe3$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var abstract = mutation[1];
        // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$9bfddff2bd1f5fe3$var$classArray(node).indexOf($9bfddff2bd1f5fe3$var$config.replacementClass)) return $9bfddff2bd1f5fe3$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            var splitClasses = abstract[0].attributes.class.split(' ').reduce(function(acc, cls) {
                if (cls === $9bfddff2bd1f5fe3$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(' ');
            if (splitClasses.toNode.length === 0) node.removeAttribute('class');
            else node.setAttribute('class', splitClasses.toNode.join(' '));
        }
        var newInnerHTML = abstract.map(function(a) {
            return $9bfddff2bd1f5fe3$var$toHtml(a);
        }).join('\n');
        node.setAttribute($9bfddff2bd1f5fe3$var$DATA_FA_I2SVG, '');
        node.innerHTML = newInnerHTML;
    }
};
function $9bfddff2bd1f5fe3$var$performOperationSync(op) {
    op();
}
function $9bfddff2bd1f5fe3$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === 'function' ? callback : $9bfddff2bd1f5fe3$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $9bfddff2bd1f5fe3$var$performOperationSync;
        if ($9bfddff2bd1f5fe3$var$config.mutateApproach === $9bfddff2bd1f5fe3$var$MUTATION_APPROACH_ASYNC) frame = $9bfddff2bd1f5fe3$var$WINDOW.requestAnimationFrame || $9bfddff2bd1f5fe3$var$performOperationSync;
        frame(function() {
            var mutator = $9bfddff2bd1f5fe3$var$getMutator();
            var mark = $9bfddff2bd1f5fe3$var$perf.begin('mutate');
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $9bfddff2bd1f5fe3$var$disabled = false;
function $9bfddff2bd1f5fe3$var$disableObservation() {
    $9bfddff2bd1f5fe3$var$disabled = true;
}
function $9bfddff2bd1f5fe3$var$enableObservation() {
    $9bfddff2bd1f5fe3$var$disabled = false;
}
var $9bfddff2bd1f5fe3$var$mo = null;
function $9bfddff2bd1f5fe3$var$observe(options) {
    if (!$9bfddff2bd1f5fe3$var$MUTATION_OBSERVER) return;
    if (!$9bfddff2bd1f5fe3$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $9bfddff2bd1f5fe3$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $9bfddff2bd1f5fe3$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $9bfddff2bd1f5fe3$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $9bfddff2bd1f5fe3$var$DOCUMENT : _options$observeMutat;
    $9bfddff2bd1f5fe3$var$mo = new $9bfddff2bd1f5fe3$var$MUTATION_OBSERVER(function(objects) {
        if ($9bfddff2bd1f5fe3$var$disabled) return;
        var defaultPrefix = $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix();
        $9bfddff2bd1f5fe3$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !$9bfddff2bd1f5fe3$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($9bfddff2bd1f5fe3$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && $9bfddff2bd1f5fe3$var$config.searchPseudoElements) pseudoElementsCallback([
                mutationRecord.target
            ], true);
            if (mutationRecord.type === 'attributes' && $9bfddff2bd1f5fe3$var$isWatched(mutationRecord.target) && ~$9bfddff2bd1f5fe3$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === 'class' && $9bfddff2bd1f5fe3$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $9bfddff2bd1f5fe3$var$getCanonicalIcon($9bfddff2bd1f5fe3$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($9bfddff2bd1f5fe3$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($9bfddff2bd1f5fe3$var$DATA_ICON, iconName);
                } else if ($9bfddff2bd1f5fe3$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$9bfddff2bd1f5fe3$var$IS_DOM) return;
    $9bfddff2bd1f5fe3$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $9bfddff2bd1f5fe3$var$disconnect() {
    if (!$9bfddff2bd1f5fe3$var$mo) return;
    $9bfddff2bd1f5fe3$var$mo.disconnect();
}
function $9bfddff2bd1f5fe3$var$styleParser(node) {
    var style = node.getAttribute('style');
    var val = [];
    if (style) val = style.split(';').reduce(function(acc, style) {
        var styles = style.split(':');
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(':').trim();
        return acc;
    }, {});
    return val;
}
function $9bfddff2bd1f5fe3$var$classParser(node) {
    var existingPrefix = node.getAttribute('data-prefix');
    var existingIconName = node.getAttribute('data-icon');
    var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    var val = $9bfddff2bd1f5fe3$var$getCanonicalIcon($9bfddff2bd1f5fe3$var$classArray(node));
    if (!val.prefix) val.prefix = $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $9bfddff2bd1f5fe3$var$byLigature(val.prefix, node.innerText) || $9bfddff2bd1f5fe3$var$byUnicode(val.prefix, $9bfddff2bd1f5fe3$var$toHex(node.innerText));
    if (!val.iconName && $9bfddff2bd1f5fe3$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $9bfddff2bd1f5fe3$var$attributesParser(node) {
    var extraAttributes = $9bfddff2bd1f5fe3$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
        return acc;
    }, {});
    return extraAttributes;
}
function $9bfddff2bd1f5fe3$var$blankMeta() {
    return {
        iconName: null,
        prefix: null,
        transform: $9bfddff2bd1f5fe3$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $9bfddff2bd1f5fe3$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $9bfddff2bd1f5fe3$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $9bfddff2bd1f5fe3$var$attributesParser(node);
    var pluginMeta = $9bfddff2bd1f5fe3$var$chainHooks('parseNodeAttributes', {}, node);
    var extraStyles = parser.styleParser ? $9bfddff2bd1f5fe3$var$styleParser(node) : [];
    return $9bfddff2bd1f5fe3$var$_objectSpread2({
        iconName: iconName,
        prefix: prefix,
        transform: $9bfddff2bd1f5fe3$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $9bfddff2bd1f5fe3$var$styles$2 = $9bfddff2bd1f5fe3$var$namespace.styles;
function $9bfddff2bd1f5fe3$var$generateMutation(node) {
    var nodeMeta = $9bfddff2bd1f5fe3$var$config.autoReplaceSvg === 'nest' ? $9bfddff2bd1f5fe3$var$parseMeta(node, {
        styleParser: false
    }) : $9bfddff2bd1f5fe3$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($9bfddff2bd1f5fe3$var$LAYERS_TEXT_CLASSNAME)) return $9bfddff2bd1f5fe3$var$callProvided('generateLayersText', node, nodeMeta);
    else return $9bfddff2bd1f5fe3$var$callProvided('generateSvgReplacementMutation', node, nodeMeta);
}
function $9bfddff2bd1f5fe3$var$getKnownPrefixes() {
    return [].concat($9bfddff2bd1f5fe3$var$_toConsumableArray($9bfddff2bd1f5fe3$var$at), $9bfddff2bd1f5fe3$var$_toConsumableArray($9bfddff2bd1f5fe3$var$ha));
}
function $9bfddff2bd1f5fe3$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$9bfddff2bd1f5fe3$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $9bfddff2bd1f5fe3$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($9bfddff2bd1f5fe3$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($9bfddff2bd1f5fe3$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $9bfddff2bd1f5fe3$var$config.autoFetchSvg ? $9bfddff2bd1f5fe3$var$getKnownPrefixes() : $9bfddff2bd1f5fe3$var$dl.concat(Object.keys($9bfddff2bd1f5fe3$var$styles$2));
    if (!prefixes.includes('fa')) prefixes.push('fa');
    var prefixesDomQuery = [
        ".".concat($9bfddff2bd1f5fe3$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($9bfddff2bd1f5fe3$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p$$1) {
        return ".".concat(p$$1, ":not([").concat($9bfddff2bd1f5fe3$var$DATA_FA_I2SVG, "])");
    })).join(', ');
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $9bfddff2bd1f5fe3$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e$$1) {
    // noop
    }
    if (candidates.length > 0) {
        hclAdd('pending');
        hclRemove('complete');
    } else return Promise.resolve();
    var mark = $9bfddff2bd1f5fe3$var$perf.begin('onTree');
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $9bfddff2bd1f5fe3$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e$$1) {
            if (!$9bfddff2bd1f5fe3$var$PRODUCTION) {
                if (e$$1.name === 'MissingIcon') console.error(e$$1);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $9bfddff2bd1f5fe3$var$perform(resolvedMutations, function() {
                hclAdd('active');
                hclAdd('complete');
                hclRemove('pending');
                if (typeof callback === 'function') callback();
                mark();
                resolve();
            });
        }).catch(function(e$$1) {
            mark();
            reject(e$$1);
        });
    });
}
function $9bfddff2bd1f5fe3$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $9bfddff2bd1f5fe3$var$generateMutation(node).then(function(mutation) {
        if (mutation) $9bfddff2bd1f5fe3$var$perform([
            mutation
        ], callback);
    });
}
function $9bfddff2bd1f5fe3$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $9bfddff2bd1f5fe3$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $9bfddff2bd1f5fe3$var$findIconDefinition(mask || {});
        return next(iconDefinition, $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $9bfddff2bd1f5fe3$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $9bfddff2bd1f5fe3$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $9bfddff2bd1f5fe3$var$domVariants($9bfddff2bd1f5fe3$var$_objectSpread2({
        type: 'icon'
    }, iconDefinition), function() {
        $9bfddff2bd1f5fe3$var$callHooks('beforeDOMElementCreation', {
            iconDefinition: iconDefinition,
            params: params
        });
        return $9bfddff2bd1f5fe3$var$makeInlineSvgAbstract({
            icons: {
                main: $9bfddff2bd1f5fe3$var$asFoundIcon(icon),
                mask: mask ? $9bfddff2bd1f5fe3$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$meaninglessTransform), transform),
            symbol: symbol,
            maskId: maskId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $9bfddff2bd1f5fe3$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $9bfddff2bd1f5fe3$var$resolveIcons($9bfddff2bd1f5fe3$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $9bfddff2bd1f5fe3$var$onTree;
                accumulator.nodeCallback = $9bfddff2bd1f5fe3$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $9bfddff2bd1f5fe3$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            return $9bfddff2bd1f5fe3$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $9bfddff2bd1f5fe3$var$findIcon(iconName, prefix),
                    mask.iconName ? $9bfddff2bd1f5fe3$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $9bfddff2bd1f5fe3$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $9bfddff2bd1f5fe3$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $9bfddff2bd1f5fe3$var$joinStyles(styles);
            if (styleString.length > 0) attributes['style'] = styleString;
            var nextChild;
            if ($9bfddff2bd1f5fe3$var$transformIsMeaningful(transform)) nextChild = $9bfddff2bd1f5fe3$var$callProvided('generateAbstractTransformGrouping', {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $9bfddff2bd1f5fe3$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $9bfddff2bd1f5fe3$var$domVariants({
                    type: 'layer'
                }, function() {
                    $9bfddff2bd1f5fe3$var$callHooks('beforeDOMElementCreation', {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: 'span',
                            attributes: {
                                class: [
                                    "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-layers")
                                ].concat($9bfddff2bd1f5fe3$var$_toConsumableArray(classes)).join(' ')
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $9bfddff2bd1f5fe3$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $9bfddff2bd1f5fe3$var$domVariants({
                    type: 'counter',
                    content: content
                }, function() {
                    $9bfddff2bd1f5fe3$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $9bfddff2bd1f5fe3$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-layers-counter")
                            ].concat($9bfddff2bd1f5fe3$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $9bfddff2bd1f5fe3$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $9bfddff2bd1f5fe3$var$meaninglessTransform : _params$transform, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $9bfddff2bd1f5fe3$var$domVariants({
                    type: 'text',
                    content: content
                }, function() {
                    $9bfddff2bd1f5fe3$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $9bfddff2bd1f5fe3$var$makeLayersTextAbstract({
                        content: content,
                        transform: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$meaninglessTransform), transform),
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($9bfddff2bd1f5fe3$var$config.cssPrefix, "-layers-text")
                            ].concat($9bfddff2bd1f5fe3$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($9bfddff2bd1f5fe3$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            return Promise.resolve([
                node,
                $9bfddff2bd1f5fe3$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $9bfddff2bd1f5fe3$var$CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var $9bfddff2bd1f5fe3$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
var $9bfddff2bd1f5fe3$var$_FONT_FAMILY_WEIGHT_TO_PREFIX = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, {
    FontAwesome: {
        normal: 'fas',
        400: 'fas'
    }
}), $9bfddff2bd1f5fe3$var$zl), $9bfddff2bd1f5fe3$var$wa), $9bfddff2bd1f5fe3$var$ct);
var $9bfddff2bd1f5fe3$var$FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys($9bfddff2bd1f5fe3$var$_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce(function(acc, key) {
    acc[key.toLowerCase()] = $9bfddff2bd1f5fe3$var$_FONT_FAMILY_WEIGHT_TO_PREFIX[key];
    return acc;
}, {});
var $9bfddff2bd1f5fe3$var$FONT_FAMILY_WEIGHT_FALLBACK = Object.keys($9bfddff2bd1f5fe3$var$FONT_FAMILY_WEIGHT_TO_PREFIX).reduce(function(acc, fontFamily) {
    var weights = $9bfddff2bd1f5fe3$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamily];
    acc[fontFamily] = weights[900] || $9bfddff2bd1f5fe3$var$_toConsumableArray(Object.entries(weights))[0][1];
    return acc;
}, {});
// Return hex value of *first* character in `content`
function $9bfddff2bd1f5fe3$var$hexValueFromContent(content) {
    var cleaned = content.replace($9bfddff2bd1f5fe3$var$CLEAN_CONTENT_PATTERN, '');
    return $9bfddff2bd1f5fe3$var$toHex($9bfddff2bd1f5fe3$var$_toConsumableArray(cleaned)[0] || '');
}
// Check if it's a secondary Duotone layer, by checking if:
// - Unicode value in `content` is repeated
// - Unicode value in `content` is above 0x10000
// - The "ss01" font feature is enabled on the `content`
function $9bfddff2bd1f5fe3$var$isSecondaryLayer(styles) {
    var hasStylisticSet = styles.getPropertyValue('font-feature-settings').includes('ss01');
    var content = styles.getPropertyValue('content');
    var cleaned = content.replace($9bfddff2bd1f5fe3$var$CLEAN_CONTENT_PATTERN, '');
    var codePoint = cleaned.codePointAt(0);
    var isPrependTen = codePoint >= $9bfddff2bd1f5fe3$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $9bfddff2bd1f5fe3$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return isPrependTen || isDoubled || hasStylisticSet;
}
function $9bfddff2bd1f5fe3$var$getPrefix(fontFamily, fontWeight) {
    var fontFamilySanitized = fontFamily.replace(/^['"]|['"]$/g, '').toLowerCase();
    var fontWeightInteger = parseInt(fontWeight);
    var fontWeightSanitized = isNaN(fontWeightInteger) ? 'normal' : fontWeightInteger;
    return ($9bfddff2bd1f5fe3$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamilySanitized] || {})[fontWeightSanitized] || $9bfddff2bd1f5fe3$var$FONT_FAMILY_WEIGHT_FALLBACK[fontFamilySanitized];
}
function $9bfddff2bd1f5fe3$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($9bfddff2bd1f5fe3$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $9bfddff2bd1f5fe3$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c$$1) {
            return c$$1.getAttribute($9bfddff2bd1f5fe3$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $9bfddff2bd1f5fe3$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue('font-family');
        var fontFamilyMatch = fontFamily.match($9bfddff2bd1f5fe3$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue('font-weight');
        var content = styles.getPropertyValue('content');
        if (alreadyProcessedPseudoElement && !fontFamilyMatch) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamilyMatch && content !== 'none' && content !== '') {
            var _content = styles.getPropertyValue('content');
            var prefix = $9bfddff2bd1f5fe3$var$getPrefix(fontFamily, fontWeight);
            var hexValue = $9bfddff2bd1f5fe3$var$hexValueFromContent(_content);
            var isV4 = fontFamilyMatch[0].startsWith('FontAwesome');
            var isSecondary = $9bfddff2bd1f5fe3$var$isSecondaryLayer(styles);
            var iconName = $9bfddff2bd1f5fe3$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $9bfddff2bd1f5fe3$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            }
            // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($9bfddff2bd1f5fe3$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($9bfddff2bd1f5fe3$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $9bfddff2bd1f5fe3$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$9bfddff2bd1f5fe3$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $9bfddff2bd1f5fe3$var$findIcon(iconName, prefix).then(function(main) {
                    var abstract = $9bfddff2bd1f5fe3$var$makeInlineSvgAbstract($9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $9bfddff2bd1f5fe3$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $9bfddff2bd1f5fe3$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    if (position === '::before') node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map(function(a$$1) {
                        return $9bfddff2bd1f5fe3$var$toHtml(a$$1);
                    }).join('\n');
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $9bfddff2bd1f5fe3$var$replace(node) {
    return Promise.all([
        $9bfddff2bd1f5fe3$var$replaceForPosition(node, '::before'),
        $9bfddff2bd1f5fe3$var$replaceForPosition(node, '::after')
    ]);
}
function $9bfddff2bd1f5fe3$var$processable(node) {
    return node.parentNode !== document.head && !~$9bfddff2bd1f5fe3$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($9bfddff2bd1f5fe3$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
var $9bfddff2bd1f5fe3$var$hasPseudoElement = function hasPseudoElement(selector) {
    return !!selector && $9bfddff2bd1f5fe3$var$PSEUDO_ELEMENTS.some(function(pseudoSelector) {
        return selector.includes(pseudoSelector);
    });
};
// Return selectors from all available stylesheets that have
// pseudo-elements defined.
var $9bfddff2bd1f5fe3$var$parseCSSRuleForPseudos = function parseCSSRuleForPseudos(selectorText) {
    if (!selectorText) return [];
    var selectorSet = new Set();
    var selectors = selectorText.split(/,(?![^()]*\))/).map(function(s$$1) {
        return s$$1.trim();
    });
    selectors = selectors.flatMap(function(selector) {
        return selector.includes('(') ? selector : selector.split(',').map(function(s$$1) {
            return s$$1.trim();
        });
    });
    var _iterator = $9bfddff2bd1f5fe3$var$_createForOfIteratorHelper(selectors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var selector = _step.value;
            if ($9bfddff2bd1f5fe3$var$hasPseudoElement(selector)) {
                // Remove pseudo-elements from the selector
                var selectorWithoutPseudo = $9bfddff2bd1f5fe3$var$PSEUDO_ELEMENTS.reduce(function(acc, pseudoSelector) {
                    return acc.replace(pseudoSelector, '');
                }, selector);
                if (selectorWithoutPseudo !== '' && selectorWithoutPseudo !== '*') selectorSet.add(selectorWithoutPseudo);
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return selectorSet;
};
function $9bfddff2bd1f5fe3$var$searchPseudoElements(root) {
    var useAsNodeList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!$9bfddff2bd1f5fe3$var$IS_DOM) return;
    var nodeList;
    if (useAsNodeList) nodeList = root;
    else if ($9bfddff2bd1f5fe3$var$config.searchPseudoElementsFullScan) nodeList = root.querySelectorAll('*');
    else {
        // Get elements that have pseudo elements defined in the CSS
        var selectorSet = new Set();
        var _iterator2 = $9bfddff2bd1f5fe3$var$_createForOfIteratorHelper(document.styleSheets), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var stylesheet = _step2.value;
                try {
                    var _iterator3 = $9bfddff2bd1f5fe3$var$_createForOfIteratorHelper(stylesheet.cssRules), _step3;
                    try {
                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                            var rule = _step3.value;
                            var parsedSelectors = $9bfddff2bd1f5fe3$var$parseCSSRuleForPseudos(rule.selectorText);
                            var _iterator4 = $9bfddff2bd1f5fe3$var$_createForOfIteratorHelper(parsedSelectors), _step4;
                            try {
                                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                    var selector = _step4.value;
                                    selectorSet.add(selector);
                                }
                            } catch (err) {
                                _iterator4.e(err);
                            } finally{
                                _iterator4.f();
                            }
                        }
                    } catch (err) {
                        _iterator3.e(err);
                    } finally{
                        _iterator3.f();
                    }
                } catch (e$$1) {
                    if ($9bfddff2bd1f5fe3$var$config.searchPseudoElementsWarnings) console.warn("Font Awesome: cannot parse stylesheet: ".concat(stylesheet.href, " (").concat(e$$1.message, ")\nIf it declares any Font Awesome CSS pseudo-elements, they will not be rendered as SVG icons. Add crossorigin=\"anonymous\" to the <link>, enable searchPseudoElementsFullScan for slower but more thorough DOM parsing, or suppress this warning by setting searchPseudoElementsWarnings to false."));
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        if (!selectorSet.size) return;
        var cleanSelectors = Array.from(selectorSet).join(', ');
        try {
            nodeList = root.querySelectorAll(cleanSelectors);
        } catch (_unused) {} // eslint-disable-line no-empty
    }
    return new Promise(function(resolve, reject) {
        var operations = $9bfddff2bd1f5fe3$var$toArray(nodeList).filter($9bfddff2bd1f5fe3$var$processable).map($9bfddff2bd1f5fe3$var$replace);
        var end = $9bfddff2bd1f5fe3$var$perf.begin('searchPseudoElements');
        $9bfddff2bd1f5fe3$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $9bfddff2bd1f5fe3$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $9bfddff2bd1f5fe3$var$enableObservation();
            reject();
        });
    });
}
var $9bfddff2bd1f5fe3$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $9bfddff2bd1f5fe3$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $9bfddff2bd1f5fe3$var$DOCUMENT : _params$node;
            if ($9bfddff2bd1f5fe3$var$config.searchPseudoElements) $9bfddff2bd1f5fe3$var$searchPseudoElements(node);
        };
    }
};
var $9bfddff2bd1f5fe3$var$_unwatched = false;
var $9bfddff2bd1f5fe3$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $9bfddff2bd1f5fe3$var$disableObservation();
                    $9bfddff2bd1f5fe3$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $9bfddff2bd1f5fe3$var$observe($9bfddff2bd1f5fe3$var$chainHooks('mutationObserverCallbacks', {}));
            },
            noAuto: function noAuto() {
                $9bfddff2bd1f5fe3$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($9bfddff2bd1f5fe3$var$_unwatched) $9bfddff2bd1f5fe3$var$enableObservation();
                else $9bfddff2bd1f5fe3$var$observe($9bfddff2bd1f5fe3$var$chainHooks('mutationObserverCallbacks', {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $9bfddff2bd1f5fe3$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(' ').reduce(function(acc, n) {
        var parts = n.toLowerCase().split('-');
        var first = parts[0];
        var rest = parts.slice(1).join('-');
        if (first && rest === 'h') {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === 'v') {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case 'grow':
                acc.size = acc.size + rest;
                break;
            case 'shrink':
                acc.size = acc.size - rest;
                break;
            case 'left':
                acc.x = acc.x - rest;
                break;
            case 'right':
                acc.x = acc.x + rest;
                break;
            case 'up':
                acc.y = acc.y - rest;
                break;
            case 'down':
                acc.y = acc.y + rest;
                break;
            case 'rotate':
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $9bfddff2bd1f5fe3$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $9bfddff2bd1f5fe3$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute('data-fa-transform');
                if (transformString) accumulator.transform = $9bfddff2bd1f5fe3$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: 'g',
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: 'g',
                        attributes: $9bfddff2bd1f5fe3$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $9bfddff2bd1f5fe3$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
};
function $9bfddff2bd1f5fe3$var$fillBlack(abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = 'black';
    return abstract;
}
function $9bfddff2bd1f5fe3$var$deGroup(abstract) {
    if (abstract.tag === 'g') return abstract.children;
    else return [
        abstract
    ];
}
var $9bfddff2bd1f5fe3$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute('data-fa-mask');
                var mask = !maskData ? $9bfddff2bd1f5fe3$var$emptyCanonicalIcon() : $9bfddff2bd1f5fe3$var$getCanonicalIcon(maskData.split(' ').map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $9bfddff2bd1f5fe3$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute('data-fa-mask-id');
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $9bfddff2bd1f5fe3$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: 'rect',
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$ALL_SPACE), {}, {
                    fill: 'white'
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($9bfddff2bd1f5fe3$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: 'g',
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2({}, trans.inner),
                children: [
                    $9bfddff2bd1f5fe3$var$fillBlack($9bfddff2bd1f5fe3$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: 'g',
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $9bfddff2bd1f5fe3$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $9bfddff2bd1f5fe3$var$nextUniqueId());
            var maskTag = {
                tag: 'mask',
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, $9bfddff2bd1f5fe3$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: 'userSpaceOnUse',
                    maskContentUnits: 'userSpaceOnUse'
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: 'defs',
                children: [
                    {
                        tag: 'clipPath',
                        attributes: {
                            id: clipId
                        },
                        children: $9bfddff2bd1f5fe3$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: 'rect',
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2({
                    'fill': 'currentColor',
                    'clip-path': "url(#".concat(clipId, ")"),
                    'mask': "url(#".concat(maskId, ")")
                }, $9bfddff2bd1f5fe3$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $9bfddff2bd1f5fe3$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($9bfddff2bd1f5fe3$var$WINDOW.matchMedia) reduceMotion = $9bfddff2bd1f5fe3$var$WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: 'currentColor'
            };
            var ANIMATION_BASE = {
                attributeType: 'XML',
                repeatCount: 'indefinite',
                dur: '2s'
            };
            // Ring
            gChildren.push({
                tag: 'path',
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, FILL), {}, {
                    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
                })
            });
            var OPACITY_ANIMATE = $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: 'opacity'
            });
            var dot = {
                tag: 'circle',
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, FILL), {}, {
                    cx: '256',
                    cy: '364',
                    r: '28'
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: 'animate',
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: 'r',
                    values: '28;14;28;28;14;28;'
                })
            }, {
                tag: 'animate',
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: '1;0;1;1;0;1;'
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: 'path',
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, FILL), {}, {
                    opacity: '1',
                    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: 'animate',
                        attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '1;0;0;0;0;1;'
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: 'path',
                attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, FILL), {}, {
                    opacity: '0',
                    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
                }),
                children: [
                    {
                        tag: 'animate',
                        attributes: $9bfddff2bd1f5fe3$var$_objectSpread2($9bfddff2bd1f5fe3$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '0;0;1;1;0;0;'
                        })
                    }
                ]
            });
            return {
                tag: 'g',
                attributes: {
                    class: 'missing'
                },
                children: gChildren
            };
        };
    }
};
var $9bfddff2bd1f5fe3$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute('data-fa-symbol');
                var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
                accumulator['symbol'] = symbol;
                return accumulator;
            }
        };
    }
};
var $9bfddff2bd1f5fe3$var$plugins = [
    $9bfddff2bd1f5fe3$var$InjectCSS,
    $9bfddff2bd1f5fe3$var$ReplaceElements,
    $9bfddff2bd1f5fe3$var$Layers,
    $9bfddff2bd1f5fe3$var$LayersCounter,
    $9bfddff2bd1f5fe3$var$LayersText,
    $9bfddff2bd1f5fe3$var$PseudoElements,
    $9bfddff2bd1f5fe3$var$MutationObserver$1,
    $9bfddff2bd1f5fe3$var$PowerTransforms,
    $9bfddff2bd1f5fe3$var$Masks,
    $9bfddff2bd1f5fe3$var$MissingIconIndicator,
    $9bfddff2bd1f5fe3$var$SvgSymbols
];
$9bfddff2bd1f5fe3$var$registerPlugins($9bfddff2bd1f5fe3$var$plugins, {
    mixoutsTo: $9bfddff2bd1f5fe3$export$644d8ea042df96a6
});
var $9bfddff2bd1f5fe3$export$4f8e844b2782642c = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.noAuto;
var $9bfddff2bd1f5fe3$export$e506a1d27d1eaa20 = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.config;
var $9bfddff2bd1f5fe3$export$b839f963c7dc0e34 = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.library;
var $9bfddff2bd1f5fe3$export$df3a06d6289f983e = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.dom;
var $9bfddff2bd1f5fe3$export$98e6a39c04603d36 = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.parse;
var $9bfddff2bd1f5fe3$export$221fed4a47f597a5 = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.findIconDefinition;
var $9bfddff2bd1f5fe3$export$a10125c086a4df16 = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.toHtml;
var $9bfddff2bd1f5fe3$export$1ca1ec8b29a4ce27 = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.icon;
var $9bfddff2bd1f5fe3$export$50a222d9023da98b = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.layer;
var $9bfddff2bd1f5fe3$export$6f093cfa640b7166 = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.text;
var $9bfddff2bd1f5fe3$export$e575061ef2a070eb = $9bfddff2bd1f5fe3$export$644d8ea042df96a6.counter;



// src/components/FontAwesomeIcon.tsx
// src/utils/camelize.ts
function $ef2738a79ec9a22f$var$_isNumerical(object) {
    object = object - 0;
    return object === object;
}
function $ef2738a79ec9a22f$var$camelize(string) {
    if ($ef2738a79ec9a22f$var$_isNumerical(string)) return string;
    string = string.replace(/[_-]+(.)?/g, (_, chr)=>{
        return chr ? chr.toUpperCase() : "";
    });
    return string.charAt(0).toLowerCase() + string.slice(1);
}
var $ef2738a79ec9a22f$var$createGradientStops = (stop, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement("stop", {
        key: `${index}-${stop.offset}`,
        offset: stop.offset,
        stopColor: stop.color,
        ...stop.opacity !== void 0 && {
            stopOpacity: stop.opacity
        }
    });
// src/converter.ts
function $ef2738a79ec9a22f$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
var $ef2738a79ec9a22f$var$styleCache = /* @__PURE__ */ new Map();
var $ef2738a79ec9a22f$var$STYLE_CACHE_LIMIT = 1e3;
function $ef2738a79ec9a22f$var$styleToObject(style) {
    if ($ef2738a79ec9a22f$var$styleCache.has(style)) return $ef2738a79ec9a22f$var$styleCache.get(style);
    const result = {};
    let start = 0;
    const len = style.length;
    while(start < len){
        const semicolonIndex = style.indexOf(";", start);
        const end = semicolonIndex === -1 ? len : semicolonIndex;
        const pair = style.slice(start, end).trim();
        if (pair) {
            const colonIndex = pair.indexOf(":");
            if (colonIndex > 0) {
                const rawProp = pair.slice(0, colonIndex).trim();
                const value = pair.slice(colonIndex + 1).trim();
                if (rawProp && value) {
                    const prop = $ef2738a79ec9a22f$var$camelize(rawProp);
                    result[prop.startsWith("webkit") ? $ef2738a79ec9a22f$var$capitalize(prop) : prop] = value;
                }
            }
        }
        start = end + 1;
    }
    if ($ef2738a79ec9a22f$var$styleCache.size === $ef2738a79ec9a22f$var$STYLE_CACHE_LIMIT) {
        const oldestKey = $ef2738a79ec9a22f$var$styleCache.keys().next().value;
        if (oldestKey) $ef2738a79ec9a22f$var$styleCache.delete(oldestKey);
    }
    $ef2738a79ec9a22f$var$styleCache.set(style, result);
    return result;
}
function $ef2738a79ec9a22f$var$convert(createElement, element, extraProps = {}) {
    if (typeof element === "string") return element;
    const children = (element.children || []).map((child)=>{
        let element2 = child;
        if (("fill" in extraProps || extraProps.gradientFill) && child.tag === "path" && "fill" in child.attributes) element2 = {
            ...child,
            attributes: {
                ...child.attributes,
                fill: void 0
            }
        };
        return $ef2738a79ec9a22f$var$convert(createElement, element2);
    });
    const elementAttributes = element.attributes || {};
    const attrs = {};
    for (const [key, val] of Object.entries(elementAttributes))switch(true){
        case key === "class":
            attrs.className = val;
            break;
        case key === "style":
            attrs.style = $ef2738a79ec9a22f$var$styleToObject(String(val));
            break;
        case key.startsWith("aria-"):
        case key.startsWith("data-"):
            attrs[key.toLowerCase()] = val;
            break;
        default:
            attrs[$ef2738a79ec9a22f$var$camelize(key)] = val;
    }
    const { style: existingStyle, role: existingRole, "aria-label": ariaLabel, gradientFill: gradientFill, ...remaining } = extraProps;
    if (existingStyle) attrs.style = attrs.style ? {
        ...attrs.style,
        ...existingStyle
    } : existingStyle;
    if (existingRole) attrs.role = existingRole;
    if (ariaLabel) {
        attrs["aria-label"] = ariaLabel;
        attrs["aria-hidden"] = "false";
    }
    if (gradientFill) {
        attrs.fill = `url(#${gradientFill.id})`;
        const { type: gradientType, stops: gradientStops = [], ...gradientProps } = gradientFill;
        children.unshift(createElement(gradientType === "linear" ? "linearGradient" : "radialGradient", {
            ...gradientProps,
            id: gradientFill.id
        }, gradientStops.map($ef2738a79ec9a22f$var$createGradientStops)));
    }
    return createElement(element.tag, {
        ...attrs,
        ...remaining
    }, ...children);
}
var $ef2738a79ec9a22f$var$makeReactConverter = $ef2738a79ec9a22f$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createElement);
var $ef2738a79ec9a22f$var$useAccessibilityId = (id, hasAccessibleProps)=>{
    const generatedId = (0, $5NSbj.useId)();
    return id || (hasAccessibleProps ? generatedId : void 0);
};
// src/logger.ts
var $ef2738a79ec9a22f$var$Logger = class {
    constructor(scope = "react-fontawesome"){
        this.enabled = false;
        let IS_DEV = false;
        try {
            IS_DEV = false;
        } catch  {}
        this.scope = scope;
        this.enabled = IS_DEV;
    }
    /**
   * Logs messages to the console if not in production.
   * @param args - The message and/or data to log.
   */ log(...args) {
        if (!this.enabled) return;
        console.log(`[${this.scope}]`, ...args);
    }
    /**
   * Logs warnings to the console if not in production.
   * @param args - The warning message and/or data to log.
   */ warn(...args) {
        if (!this.enabled) return;
        console.warn(`[${this.scope}]`, ...args);
    }
    /**
   * Logs errors to the console if not in production.
   * @param args - The error message and/or data to log.
   */ error(...args) {
        if (!this.enabled) return;
        console.error(`[${this.scope}]`, ...args);
    }
};
"7.0.0";
var $ef2738a79ec9a22f$var$SVG_CORE_VERSION = // @ts-expect-error TS2872 - Expression is always truthy - This is true when v7 of SVGCore is used, but not when v6 is used.
// This is the point of this check - if the property exists on config, we have v7, otherwise we have v6.
// TS is checking this against the dev dependencies which uses v7, so it reports a false error here.
"searchPseudoElementsFullScan" in (0, $9bfddff2bd1f5fe3$export$e506a1d27d1eaa20) && typeof (0, $9bfddff2bd1f5fe3$export$e506a1d27d1eaa20).searchPseudoElementsFullScan === "boolean" ? "7.0.0" : "6.0.0";
var $ef2738a79ec9a22f$var$IS_VERSION_7_OR_LATER = Number.parseInt($ef2738a79ec9a22f$var$SVG_CORE_VERSION) >= 7;
var $ef2738a79ec9a22f$var$getIsVersion7OrLater = ()=>$ef2738a79ec9a22f$var$IS_VERSION_7_OR_LATER;
var $ef2738a79ec9a22f$var$DEFAULT_CLASSNAME_PREFIX = "fa";
var $ef2738a79ec9a22f$var$ANIMATION_CLASSES = {
    beat: "fa-beat",
    fade: "fa-fade",
    beatFade: "fa-beat-fade",
    bounce: "fa-bounce",
    shake: "fa-shake",
    spin: "fa-spin",
    spinPulse: "fa-spin-pulse",
    spinReverse: "fa-spin-reverse",
    pulse: "fa-pulse",
    // the following animations are only supported in version 7.3.0 and later
    flip360: "fa-flip-360",
    buzz: "fa-buzz",
    float: "fa-float",
    jello: "fa-jello",
    spinSnap: "fa-spin-snap",
    spinSnap4: "fa-spin-snap-4",
    spinSnap8: "fa-spin-snap-8",
    swing: "fa-swing",
    wag: "fa-wag"
};
var $ef2738a79ec9a22f$var$PULL_CLASSES = {
    left: "fa-pull-left",
    right: "fa-pull-right"
};
var $ef2738a79ec9a22f$var$ROTATE_CLASSES = {
    "90": "fa-rotate-90",
    "180": "fa-rotate-180",
    "270": "fa-rotate-270"
};
var $ef2738a79ec9a22f$var$SIZE_CLASSES = {
    "2xs": "fa-2xs",
    xs: "fa-xs",
    sm: "fa-sm",
    lg: "fa-lg",
    xl: "fa-xl",
    "2xl": "fa-2xl",
    "1x": "fa-1x",
    "2x": "fa-2x",
    "3x": "fa-3x",
    "4x": "fa-4x",
    "5x": "fa-5x",
    "6x": "fa-6x",
    "7x": "fa-7x",
    "8x": "fa-8x",
    "9x": "fa-9x",
    "10x": "fa-10x"
};
var $ef2738a79ec9a22f$var$STYLE_CLASSES = {
    border: "fa-border",
    /** @deprecated */ fixedWidth: "fa-fw",
    flip: "fa-flip",
    flipHorizontal: "fa-flip-horizontal",
    flipVertical: "fa-flip-vertical",
    inverse: "fa-inverse",
    rotateBy: "fa-rotate-by",
    swapOpacity: "fa-swap-opacity",
    widthAuto: "fa-width-auto",
    // the following style classes are only supported in version 7.3.0 and later
    canvasSquare: "fa-canvas-square",
    canvasRoomy: "fa-canvas-roomy"
};
var $ef2738a79ec9a22f$var$LAYER_CLASSES = {
    default: "fa-layers"
};
// src/utils/get-class-list-from-props.ts
function $ef2738a79ec9a22f$var$withPrefix(cls) {
    const prefix = (0, $9bfddff2bd1f5fe3$export$e506a1d27d1eaa20).cssPrefix || (0, $9bfddff2bd1f5fe3$export$e506a1d27d1eaa20).familyPrefix || $ef2738a79ec9a22f$var$DEFAULT_CLASSNAME_PREFIX;
    return prefix === $ef2738a79ec9a22f$var$DEFAULT_CLASSNAME_PREFIX ? cls : cls.replace(new RegExp(String.raw`(?<=^|\s)${$ef2738a79ec9a22f$var$DEFAULT_CLASSNAME_PREFIX}-`, "g"), `${prefix}-`);
}
function $ef2738a79ec9a22f$var$getClassListFromProps(props) {
    const { beat: beat, fade: fade, beatFade: beatFade, bounce: bounce, shake: shake, spin: spin, spinPulse: spinPulse, spinReverse: spinReverse, pulse: pulse, fixedWidth: fixedWidth, inverse: inverse, border: border, flip: flip, size: size, rotation: rotation, pull: pull, swapOpacity: swapOpacity, rotateBy: rotateBy, widthAuto: widthAuto, canvasSquare: canvasSquare, canvasRoomy: canvasRoomy, flip360: flip360, buzz: buzz, float: float, jello: jello, spinSnap: spinSnap, spinSnap4: spinSnap4, spinSnap8: spinSnap8, swing: swing, wag: wag, className: className } = props;
    const result = [];
    if (className) result.push(...className.split(" "));
    if (beat) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.beat);
    if (fade) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.fade);
    if (beatFade) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.beatFade);
    if (bounce) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.bounce);
    if (shake) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.shake);
    if (spin) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.spin);
    if (spinReverse) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.spinReverse);
    if (spinPulse) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.spinPulse);
    if (pulse) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.pulse);
    if (fixedWidth) result.push($ef2738a79ec9a22f$var$STYLE_CLASSES.fixedWidth);
    if (inverse) result.push($ef2738a79ec9a22f$var$STYLE_CLASSES.inverse);
    if (border) result.push($ef2738a79ec9a22f$var$STYLE_CLASSES.border);
    if (flip === true) result.push($ef2738a79ec9a22f$var$STYLE_CLASSES.flip);
    if (flip === "horizontal" || flip === "both") result.push($ef2738a79ec9a22f$var$STYLE_CLASSES.flipHorizontal);
    if (flip === "vertical" || flip === "both") result.push($ef2738a79ec9a22f$var$STYLE_CLASSES.flipVertical);
    if (size !== void 0 && size !== null) result.push($ef2738a79ec9a22f$var$SIZE_CLASSES[size]);
    if (rotation !== void 0 && rotation !== null && rotation !== 0) result.push($ef2738a79ec9a22f$var$ROTATE_CLASSES[rotation]);
    if (pull !== void 0 && pull !== null) result.push($ef2738a79ec9a22f$var$PULL_CLASSES[pull]);
    if (swapOpacity) result.push($ef2738a79ec9a22f$var$STYLE_CLASSES.swapOpacity);
    if (!$ef2738a79ec9a22f$var$getIsVersion7OrLater()) return result;
    if (rotateBy) result.push($ef2738a79ec9a22f$var$STYLE_CLASSES.rotateBy);
    if (widthAuto) result.push($ef2738a79ec9a22f$var$STYLE_CLASSES.widthAuto);
    if (canvasSquare) result.push($ef2738a79ec9a22f$var$STYLE_CLASSES.canvasSquare);
    if (canvasRoomy) result.push($ef2738a79ec9a22f$var$STYLE_CLASSES.canvasRoomy);
    if (flip360) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.flip360);
    if (buzz) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.buzz);
    if (float) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.float);
    if (jello) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.jello);
    if (spinSnap) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.spinSnap);
    if (spinSnap4) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.spinSnap4);
    if (spinSnap8) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.spinSnap8);
    if (swing) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.swing);
    if (wag) result.push($ef2738a79ec9a22f$var$ANIMATION_CLASSES.wag);
    const prefix = (0, $9bfddff2bd1f5fe3$export$e506a1d27d1eaa20).cssPrefix || (0, $9bfddff2bd1f5fe3$export$e506a1d27d1eaa20).familyPrefix || $ef2738a79ec9a22f$var$DEFAULT_CLASSNAME_PREFIX;
    return prefix === $ef2738a79ec9a22f$var$DEFAULT_CLASSNAME_PREFIX ? result : // TODO: see if we can achieve custom prefix support without iterating
    // eslint-disable-next-line unicorn/no-array-callback-reference
    result.map($ef2738a79ec9a22f$var$withPrefix);
}
var $ef2738a79ec9a22f$var$isIconDefinition = (icon)=>typeof icon === "object" && "icon" in icon && !!icon.icon;
function $ef2738a79ec9a22f$var$normalizeIconArgs(icon) {
    if (!icon) return void 0;
    if ($ef2738a79ec9a22f$var$isIconDefinition(icon)) return icon;
    return (0, $9bfddff2bd1f5fe3$export$98e6a39c04603d36).icon(icon);
}
// src/utils/typed-object-keys.ts
function $ef2738a79ec9a22f$var$typedObjectKeys(obj) {
    return Object.keys(obj);
}
// src/components/FontAwesomeIcon.tsx
var $ef2738a79ec9a22f$var$logger = new $ef2738a79ec9a22f$var$Logger("FontAwesomeIcon");
var $ef2738a79ec9a22f$var$DEFAULT_PROPS = {
    border: false,
    className: "",
    mask: void 0,
    maskId: void 0,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: void 0,
    listItem: false,
    pull: void 0,
    pulse: false,
    rotation: void 0,
    rotateBy: false,
    size: void 0,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: "",
    titleId: void 0,
    transform: void 0,
    swapOpacity: false,
    widthAuto: false,
    canvasSquare: false,
    canvasRoomy: false,
    flip360: false,
    buzz: false,
    float: false,
    jello: false,
    spinSnap: false,
    spinSnap4: false,
    spinSnap8: false,
    swing: false,
    wag: false
};
var $ef2738a79ec9a22f$var$DEFAULT_PROP_KEYS = new Set(Object.keys($ef2738a79ec9a22f$var$DEFAULT_PROPS));
var $ef2738a79ec9a22f$export$2b9260d4a45c8710 = (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).forwardRef((props, ref)=>{
    const allProps = {
        ...$ef2738a79ec9a22f$var$DEFAULT_PROPS,
        ...props
    };
    const { icon: iconArgs, mask: maskArgs, symbol: symbol, title: title, titleId: titleIdFromProps, maskId: maskIdFromProps, transform: transform } = allProps;
    const maskId = $ef2738a79ec9a22f$var$useAccessibilityId(maskIdFromProps, Boolean(maskArgs));
    const titleId = $ef2738a79ec9a22f$var$useAccessibilityId(titleIdFromProps, Boolean(title));
    const iconLookup = $ef2738a79ec9a22f$var$normalizeIconArgs(iconArgs);
    if (!iconLookup) {
        $ef2738a79ec9a22f$var$logger.error("Icon lookup is undefined", iconArgs);
        return null;
    }
    const classList = $ef2738a79ec9a22f$var$getClassListFromProps(allProps);
    const transformProps = typeof transform === "string" ? (0, $9bfddff2bd1f5fe3$export$98e6a39c04603d36).transform(transform) : transform;
    const normalizedMaskArgs = $ef2738a79ec9a22f$var$normalizeIconArgs(maskArgs);
    const renderedIcon = (0, $9bfddff2bd1f5fe3$export$1ca1ec8b29a4ce27)(iconLookup, {
        ...classList.length > 0 && {
            classes: classList
        },
        ...transformProps && {
            transform: transformProps
        },
        ...normalizedMaskArgs && {
            mask: normalizedMaskArgs
        },
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    });
    if (!renderedIcon) {
        $ef2738a79ec9a22f$var$logger.error("Could not find icon", iconLookup);
        return null;
    }
    const { abstract: abstract } = renderedIcon;
    const extraProps = {
        ref: ref
    };
    for (const key of $ef2738a79ec9a22f$var$typedObjectKeys(allProps)){
        if ($ef2738a79ec9a22f$var$DEFAULT_PROP_KEYS.has(key)) continue;
        extraProps[key] = allProps[key];
    }
    return $ef2738a79ec9a22f$var$makeReactConverter(abstract[0], extraProps);
});
$ef2738a79ec9a22f$export$2b9260d4a45c8710.displayName = "FontAwesomeIcon";
var $ef2738a79ec9a22f$var$DEFAULT_CLASSNAMES = `${$ef2738a79ec9a22f$var$LAYER_CLASSES.default} ${$ef2738a79ec9a22f$var$STYLE_CLASSES.fixedWidth}`;
var $ef2738a79ec9a22f$export$9ef6be9fed098e07 = ({ children: children, className: className, size: size, ...attributes })=>{
    const prefixedDefaultClasses = $ef2738a79ec9a22f$var$withPrefix($ef2738a79ec9a22f$var$DEFAULT_CLASSNAMES);
    const classes = className ? `${prefixedDefaultClasses} ${className}` : prefixedDefaultClasses;
    const element = /* @__PURE__ */ (0, $fcda9d1f1901e894$exports.jsx)("span", {
        ...attributes,
        className: classes,
        children: children
    });
    if (size) return /* @__PURE__ */ (0, $fcda9d1f1901e894$exports.jsx)("div", {
        className: $ef2738a79ec9a22f$var$withPrefix(`fa-${size}`),
        children: element
    });
    return element;
};
var $ef2738a79ec9a22f$export$1ff69b5f8cc6202a = ({ text: text$1, className: className, inverse: inverse, transform: transform, style: style, ...attributes })=>{
    const textAbstractElement = (0, $5NSbj.useMemo)(()=>{
        const textObject = (0, $9bfddff2bd1f5fe3$export$6f093cfa640b7166)(text$1, {
            classes: [
                ...className?.split(" ") || [],
                ...inverse ? [
                    $ef2738a79ec9a22f$var$STYLE_CLASSES.inverse
                ] : []
            ],
            transform: typeof transform === "string" ? (0, $9bfddff2bd1f5fe3$export$98e6a39c04603d36).transform(transform) : transform
        });
        return textObject.abstract[0];
    }, [
        text$1,
        transform,
        className,
        inverse
    ]);
    return $ef2738a79ec9a22f$var$makeReactConverter(textAbstractElement, {
        ...attributes,
        style: style
    });
};
var $ef2738a79ec9a22f$export$aa94eec7b7fb6e02 = ({ count: count, className: className, style: style, ...attributes })=>{
    const counterAbstractElement = (0, $5NSbj.useMemo)(()=>(0, $9bfddff2bd1f5fe3$export$e575061ef2a070eb)(count, {
            classes: className?.split(" ")
        }).abstract[0], [
        count,
        className
    ]);
    return $ef2738a79ec9a22f$var$makeReactConverter(counterAbstractElement, {
        ...attributes,
        style: style
    });
};




var $5NSbj = parcelRequire("5NSbj");
const $5c9ab921368ace58$var$w = "collapsed", $5c9ab921368ace58$var$p = "collapsing", $5c9ab921368ace58$var$r = "expanding", $5c9ab921368ace58$var$a = "expanded", $5c9ab921368ace58$var$K = "collapse-css-transition", $5c9ab921368ace58$var$M = "div", $5c9ab921368ace58$var$Q = "0px";
function $5c9ab921368ace58$var$N(o) {
    requestAnimationFrame(function() {
        requestAnimationFrame(o);
    });
}
const $5c9ab921368ace58$export$78768a9af065a7b = ({ children: o, transition: T, style: A, render: d, elementType: y = $5c9ab921368ace58$var$M, isOpen: n, collapseHeight: s = $5c9ab921368ace58$var$Q, onInit: L, onChange: P, className: v = $5c9ab921368ace58$var$K, addState: R, noAnim: h, overflowOnExpanded: S, ...F })=>{
    const m = ()=>s === "0px" ? "hidden" : void 0, [W, u] = (0, $5NSbj.useReducer)((t)=>t + 1, 0), i = (0, $5NSbj.useRef)(), [b, l] = (0, $5NSbj.useState)(0), e = (0, $5NSbj.useRef)({
        collapse: n ? $5c9ab921368ace58$var$a : $5c9ab921368ace58$var$w,
        style: {
            height: n ? void 0 : s,
            visibility: n ? void 0 : m()
        }
    }).current;
    (0, $5NSbj.useEffect)(()=>{
        b && g(P);
    }, [
        b
    ]);
    const g = (t, f = {})=>{
        t && t({
            state: e.collapse,
            style: e.style,
            ...f
        });
    };
    function C() {
        i.current && (e.collapse = $5c9ab921368ace58$var$w, e.style = {
            height: s,
            visibility: m()
        }, u(), setTimeout(()=>l(Date.now), 0));
    }
    function $() {
        if (i.current) {
            if (h) return C();
            e.collapse = $5c9ab921368ace58$var$p, e.style = {
                height: x(),
                visibility: void 0
            }, u(), $5c9ab921368ace58$var$N(()=>{
                i.current && e.collapse === $5c9ab921368ace58$var$p && (e.style = {
                    height: s,
                    visibility: void 0
                }, l(Date.now));
            });
        }
    }
    function q() {
        if (i.current) {
            if (h) return E();
            e.collapse = $5c9ab921368ace58$var$r, $5c9ab921368ace58$var$N(()=>{
                i.current && e.collapse === $5c9ab921368ace58$var$r && (e.style = {
                    height: x(),
                    visibility: void 0
                }, l(Date.now));
            });
        }
    }
    function E() {
        i.current && (e.collapse = $5c9ab921368ace58$var$a, e.style = {
            height: void 0,
            visibility: void 0
        }, u(), setTimeout(()=>l(Date.now), 0));
    }
    function x() {
        return `${i.current.scrollHeight}px`;
    }
    function G({ target: t, propertyName: f }) {
        if (t === i.current && f === "height") {
            const c = t.style.height;
            switch(e.collapse){
                case $5c9ab921368ace58$var$r:
                    c === void 0 || c === s || E();
                    break;
                case $5c9ab921368ace58$var$p:
                    c === void 0 || c !== s || C();
                    break;
            }
        }
    }
    const k = e.collapse === $5c9ab921368ace58$var$a || e.collapse === $5c9ab921368ace58$var$r;
    !k && n && q(), k && !n && $();
    const I = {
        overflow: e.collapse === $5c9ab921368ace58$var$a && S ? void 0 : "hidden",
        transition: T,
        ...A,
        ...e.style
    }, X = y, j = (0, $5NSbj.useCallback)((t)=>{
        t && (i.current = t, g(L, {
            node: t
        }));
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        y
    ]), U = R ? `${v} --c-${e.collapse}` : v;
    return(// @ts-ignore
    /* @__PURE__ */ (0, $fcda9d1f1901e894$exports.jsx)(X, {
        ref: j,
        style: I,
        onTransitionEnd: G,
        className: U,
        ...F,
        children: typeof o == "function" ? o(e.collapse) : typeof d == "function" ? d(e.collapse) : o
    }));
};


var $9230d46773d20d22$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($9230d46773d20d22$exports) {
        classNames.default = classNames;
        $9230d46773d20d22$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();




class $fbb973a7ef395689$export$5300a9e19ff2767e {
    constructor(initElement){
        this.formData = new FormData();
        if (!initElement) return;
        if (initElement instanceof FormData) {
            this.formData = initElement;
            return;
        }
        this.formData = new FormData(initElement);
    }
    get(key) {
        return this.formData.get(key);
    }
    getAll(key) {
        return this.formData.getAll(key);
    }
    /**
     * Executes a provided function once for each key/value pair in the FormData object.
     * @deprecated This method is deprecated and is not advised to be used. Use entries() or for...of loop instead.
     * @param callbackfn A function that is called for each key/value pair in the FormData object.
     * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
     */ forEach(callbackfn, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    thisArg) {
        this.formData.forEach(callbackfn, thisArg);
    }
    getFormData() {
        return this.formData;
    }
    getObject() {
        return Object.fromEntries(this.entries());
    }
    entries() {
        return this.formData.entries();
    }
    typedEntries() {
        return this.entries();
    }
    keys() {
        return this.formData.keys();
    }
    values() {
        return this.formData.values();
    }
    set(key, value, filename) {
        if (typeof value === "string") this.formData.set(key, value);
        else this.formData.set(key, value, filename);
    }
    append(key, value, filename) {
        if (typeof value === "string") this.formData.append(key, value);
        else this.formData.append(key, value, filename);
    }
    has(key) {
        return this.formData.has(key);
    }
    delete(key) {
        this.formData.delete(key);
    }
    *[Symbol.iterator]() {
        yield* this.entries();
    }
}



var $ada490817d84b3d0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $ada490817d84b3d0$export$bd735ad4938c7be8(request) {
    return $ada490817d84b3d0$var$__awaiter(this, void 0, void 0, function*() {
        const formData = yield request.formData();
        return new (0, $fbb973a7ef395689$export$5300a9e19ff2767e)(formData);
    });
}
function $ada490817d84b3d0$export$ae2b2db16f8c0171(formData) {
    return new (0, $fbb973a7ef395689$export$5300a9e19ff2767e)(formData);
}





var $5NSbj = parcelRequire("5NSbj");



function $2118d280c9bed8e8$export$2e2bcd8739ae039(props) {
    const { setTitle: setTitle } = props;
    const navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    const [state, submitAction, isPending] = (0, $5NSbj.useActionState)(async (_previousState, formData)=>{
        try {
            const password = formData.get('password').trim();
            const hashedPassword = await (0, $139c0902db4c349b$export$708be5cd94908894)(password);
            return {
                hashedPassword: hashedPassword
            };
        } catch (error) {
            if (error instanceof (0, $b82622975d92f7af$export$65bd6083489bd8bb) && error.response.status === 403) {
                navigate('/sign/in', {
                    state: {
                        error: "Generating a new password hash requires being logged in or not setting \u201Cpassword\u201D in selfoss configuration.",
                        returnLocation: '/password'
                    }
                });
                return {};
            }
            return {
                error: error
            };
        }
    }, {});
    const submit = (0, $5NSbj.useCallback)((event)=>{
        // Unlike `action` prop, `onSubmit` avoids clearing the form on submit.
        // https://github.com/facebook/react/issues/29034#issuecomment-2143595195
        event.preventDefault();
        const formData = new (0, $fbb973a7ef395689$export$5300a9e19ff2767e)(event.currentTarget);
        (0, $5NSbj.startTransition)(()=>submitAction(formData));
    }, [
        submitAction
    ]);
    (0, $5NSbj.useEffect)(()=>{
        setTitle('selfoss password hash generator');
        return ()=>{
            setTitle(null);
        };
    }, [
        setTitle
    ]);
    const message = isPending ? null : 'hashedPassword' in state ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("p", {
        className: "error",
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("label", {
            children: [
                "Generated Password (insert this into config.ini):",
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                    type: "text",
                    value: state.hashedPassword,
                    readOnly: true
                })
            ]
        })
    }) : 'error' in state ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("p", {
        className: "error",
        children: [
            "Unexpected happened.",
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("details", {
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("pre", {
                    children: [
                        "$",
                        JSON.stringify(state.error)
                    ]
                })
            })
        ]
    }) : null;
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("form", {
        action: "",
        method: "post",
        onSubmit: submit,
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
            id: "login",
            children: [
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h1", {
                        children: "hash generator"
                    })
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            htmlFor: "password",
                            children: "Password:"
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                            type: "password",
                            name: "password",
                            autoComplete: "new-password",
                            accessKey: "p"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                    className: "message-container",
                    "aria-live": "assertive",
                    children: message
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                            className: "button",
                            type: "submit",
                            value: isPending ? "Hashing password\u2026" : 'Compute hash',
                            accessKey: "g",
                            disabled: isPending
                        })
                    ]
                })
            ]
        })
    });
}





var $5NSbj = parcelRequire("5NSbj");
// src/hooks/useIsomorphicEffect.ts

var $5NSbj = parcelRequire("5NSbj");
var $0302d50d2b00a3cf$export$363c9f3eb56bbdbe = typeof window === "undefined" ? (0, $5NSbj.useEffect) : (0, $5NSbj.useLayoutEffect);
function $0302d50d2b00a3cf$export$38e1734badfda8d9(value, preferLayoutEffect = false) {
    const useEffectToUse = preferLayoutEffect ? $0302d50d2b00a3cf$export$363c9f3eb56bbdbe : (0, $5NSbj.useEffect);
    const ref = (0, $5NSbj.useRef)(value);
    useEffectToUse(()=>{
        ref.current = value;
    });
    return ref;
}
function $0302d50d2b00a3cf$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $0302d50d2b00a3cf$export$ebc1e1560c2dffa5(refA, refB) {
    return (0, $5NSbj.useMemo)(()=>{
        if (refA === null && refB === null) return null;
        return (refValue)=>{
            $0302d50d2b00a3cf$var$setRef(refA, refValue);
            $0302d50d2b00a3cf$var$setRef(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
function $0302d50d2b00a3cf$var$isEventLike(error) {
    return error instanceof Event || error instanceof Error;
}
function $0302d50d2b00a3cf$export$e38c76da774a8077(channelName, options) {
    const { onMessage: onMessage, onError: onError } = options || {};
    const isSupported = (0, $5NSbj.useMemo)(()=>{
        return typeof window !== "undefined" && typeof BroadcastChannel !== "undefined";
    }, []);
    const channelRef = (0, $5NSbj.useRef)(null);
    const stableOnMessage = (0, $5NSbj.useCallback)((event)=>{
        if (onMessage) onMessage(event.data);
    }, [
        onMessage
    ]);
    const stableOnError = (0, $5NSbj.useCallback)((event)=>{
        if (onError) onError(event);
    }, [
        onError
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (!isSupported) return;
        try {
            const channel = new BroadcastChannel(channelName);
            channelRef.current = channel;
            channel.addEventListener("message", stableOnMessage);
            channel.addEventListener("messageerror", stableOnError);
            return ()=>{
                channel.removeEventListener("message", stableOnMessage);
                channel.removeEventListener("messageerror", stableOnError);
                channel.close();
                channelRef.current = null;
            };
        } catch (error) {
            if (onError && $0302d50d2b00a3cf$var$isEventLike(error)) onError(error);
        }
    }, [
        channelName,
        isSupported,
        stableOnMessage,
        stableOnError,
        onError
    ]);
    const postMessage = (0, $5NSbj.useCallback)((data)=>{
        if (!isSupported) {
            console.warn("useBroadcastChannel: BroadcastChannel API is not supported");
            return;
        }
        if (!channelRef.current) {
            console.warn("useBroadcastChannel: Channel is not initialized");
            return;
        }
        try {
            channelRef.current.postMessage(data);
        } catch (error) {
            console.error("useBroadcastChannel: Failed to post message", error);
            if (onError && $0302d50d2b00a3cf$var$isEventLike(error)) onError(error);
        }
    }, [
        isSupported,
        onError
    ]);
    const close = (0, $5NSbj.useCallback)(()=>{
        if (channelRef.current) {
            channelRef.current.close();
            channelRef.current = null;
        }
    }, []);
    return {
        postMessage: postMessage,
        close: close,
        isSupported: isSupported
    };
}
// src/utils/eventTarget.ts
function $0302d50d2b00a3cf$var$isRefObject(value) {
    return typeof value === "object" && value !== null && "current" in value && !("addEventListener" in value);
}
function $0302d50d2b00a3cf$export$e83fa2d056381696(target) {
    if (!target) return null;
    if ($0302d50d2b00a3cf$var$isRefObject(target)) return target.current;
    return target;
}
// src/hooks/useEventListener.ts
function $0302d50d2b00a3cf$export$7080b3e976bc91ab(eventName, callback, options) {
    const { target: target, listenerOptions: listenerOptions = {}, when: when = true, isLayoutEffect: isLayoutEffect = false } = options;
    const callbackRef = $0302d50d2b00a3cf$export$38e1734badfda8d9(callback, true);
    const subscriptionRef = (0, $5NSbj.useRef)(null);
    const capture = typeof listenerOptions === "boolean" ? listenerOptions : listenerOptions.capture;
    const once = typeof listenerOptions === "boolean" ? void 0 : listenerOptions.once;
    const passive = typeof listenerOptions === "boolean" ? void 0 : listenerOptions.passive;
    const signal = typeof listenerOptions === "boolean" ? void 0 : listenerOptions.signal;
    const listener = (0, $5NSbj.useCallback)((event)=>{
        callbackRef.current(event);
    }, [
        callbackRef
    ]);
    const detach = (0, $5NSbj.useCallback)(()=>{
        const subscription = subscriptionRef.current;
        if (!subscription) return;
        subscription.target.removeEventListener(subscription.eventName, subscription.listener, subscription.listenerOptions);
        subscriptionRef.current = null;
    }, []);
    const synchronize = ()=>{
        const resolvedTarget = $0302d50d2b00a3cf$export$e83fa2d056381696(target);
        const subscription = subscriptionRef.current;
        const isCurrent = subscription?.target === resolvedTarget && subscription.eventName === eventName && subscription.listener === listener && subscription.capture === capture && subscription.once === once && subscription.passive === passive && subscription.signal === signal && subscription.isLayoutEffect === isLayoutEffect;
        if (!when || !resolvedTarget) {
            detach();
            return;
        }
        if (isCurrent) return;
        detach();
        resolvedTarget.addEventListener(eventName, listener, listenerOptions);
        subscriptionRef.current = {
            target: resolvedTarget,
            eventName: eventName,
            listener: listener,
            listenerOptions: listenerOptions,
            capture: capture,
            once: once,
            passive: passive,
            signal: signal,
            isLayoutEffect: isLayoutEffect
        };
    };
    $0302d50d2b00a3cf$export$363c9f3eb56bbdbe(()=>{
        if (isLayoutEffect) synchronize();
    });
    (0, $5NSbj.useEffect)(()=>{
        if (!isLayoutEffect) synchronize();
    });
    $0302d50d2b00a3cf$export$363c9f3eb56bbdbe(()=>{
        return ()=>{
            detach();
        };
    }, [
        detach
    ]);
}
function $0302d50d2b00a3cf$export$231305e360fbdfeb() {
    const [refElement, setRefElement] = (0, $5NSbj.useState)(null);
    const ref = (0, $5NSbj.useCallback)((element)=>{
        setRefElement(element);
    }, []);
    return [
        ref,
        refElement
    ];
}
// src/utils/noop.ts
var $0302d50d2b00a3cf$export$8793edee2d425525 = ()=>{};
// src/utils/doesIdentifierMatchKeyboardEvent.ts
var $0302d50d2b00a3cf$export$8f5885e0a893ee67 = (error, identifier)=>{
    if (error.key === identifier || error.code === identifier || error.keyCode === identifier || error.which === identifier || error.charCode === identifier) return true;
    return false;
};



var $5NSbj = parcelRequire("5NSbj");
var $4202badc4f08d1bf$exports = {};
var $976a03ca7acd7e41$exports = {};
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $976a03ca7acd7e41$exports = function() {
        return performance.now();
    };
    else if (Date.now) {
        $976a03ca7acd7e41$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $976a03ca7acd7e41$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($976a03ca7acd7e41$exports);


var $4202badc4f08d1bf$var$root = typeof window === 'undefined' ? $parcel$global : window, $4202badc4f08d1bf$var$vendors = [
    'moz',
    'webkit'
], $4202badc4f08d1bf$var$suffix = 'AnimationFrame', $4202badc4f08d1bf$var$raf = $4202badc4f08d1bf$var$root['request' + $4202badc4f08d1bf$var$suffix], $4202badc4f08d1bf$var$caf = $4202badc4f08d1bf$var$root['cancel' + $4202badc4f08d1bf$var$suffix] || $4202badc4f08d1bf$var$root['cancelRequest' + $4202badc4f08d1bf$var$suffix];
for(var $4202badc4f08d1bf$var$i = 0; !$4202badc4f08d1bf$var$raf && $4202badc4f08d1bf$var$i < $4202badc4f08d1bf$var$vendors.length; $4202badc4f08d1bf$var$i++){
    $4202badc4f08d1bf$var$raf = $4202badc4f08d1bf$var$root[$4202badc4f08d1bf$var$vendors[$4202badc4f08d1bf$var$i] + 'Request' + $4202badc4f08d1bf$var$suffix];
    $4202badc4f08d1bf$var$caf = $4202badc4f08d1bf$var$root[$4202badc4f08d1bf$var$vendors[$4202badc4f08d1bf$var$i] + 'Cancel' + $4202badc4f08d1bf$var$suffix] || $4202badc4f08d1bf$var$root[$4202badc4f08d1bf$var$vendors[$4202badc4f08d1bf$var$i] + 'CancelRequest' + $4202badc4f08d1bf$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$4202badc4f08d1bf$var$raf || !$4202badc4f08d1bf$var$caf) {
    var $4202badc4f08d1bf$var$last = 0, $4202badc4f08d1bf$var$id = 0, $4202badc4f08d1bf$var$queue = [], $4202badc4f08d1bf$var$frameDuration = 1000 / 60;
    $4202badc4f08d1bf$var$raf = function(callback) {
        if ($4202badc4f08d1bf$var$queue.length === 0) {
            var _now = $976a03ca7acd7e41$exports(), next = Math.max(0, $4202badc4f08d1bf$var$frameDuration - (_now - $4202badc4f08d1bf$var$last));
            $4202badc4f08d1bf$var$last = next + _now;
            setTimeout(function() {
                var cp = $4202badc4f08d1bf$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $4202badc4f08d1bf$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($4202badc4f08d1bf$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $4202badc4f08d1bf$var$queue.push({
            handle: ++$4202badc4f08d1bf$var$id,
            callback: callback,
            cancelled: false
        });
        return $4202badc4f08d1bf$var$id;
    };
    $4202badc4f08d1bf$var$caf = function(handle) {
        for(var i = 0; i < $4202badc4f08d1bf$var$queue.length; i++)if ($4202badc4f08d1bf$var$queue[i].handle === handle) $4202badc4f08d1bf$var$queue[i].cancelled = true;
    };
}
$4202badc4f08d1bf$exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $4202badc4f08d1bf$var$raf.call($4202badc4f08d1bf$var$root, fn);
};
$4202badc4f08d1bf$exports.cancel = function() {
    $4202badc4f08d1bf$var$caf.apply($4202badc4f08d1bf$var$root, arguments);
};
$4202badc4f08d1bf$exports.polyfill = function(object) {
    if (!object) object = $4202badc4f08d1bf$var$root;
    object.requestAnimationFrame = $4202badc4f08d1bf$var$raf;
    object.cancelAnimationFrame = $4202badc4f08d1bf$var$caf;
};


var $c20c09989d14b17a$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $c20c09989d14b17a$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $c20c09989d14b17a$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $c20c09989d14b17a$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $c20c09989d14b17a$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $c20c09989d14b17a$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $c20c09989d14b17a$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $c20c09989d14b17a$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $c20c09989d14b17a$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $c20c09989d14b17a$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $c20c09989d14b17a$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $c20c09989d14b17a$var$root = $c20c09989d14b17a$var$freeGlobal || $c20c09989d14b17a$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $c20c09989d14b17a$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c20c09989d14b17a$var$objectToString = $c20c09989d14b17a$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c20c09989d14b17a$var$nativeMax = Math.max, $c20c09989d14b17a$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $c20c09989d14b17a$var$now = function() {
    return $c20c09989d14b17a$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $c20c09989d14b17a$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($c20c09989d14b17a$var$FUNC_ERROR_TEXT);
    wait = $c20c09989d14b17a$var$toNumber(wait) || 0;
    if ($c20c09989d14b17a$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $c20c09989d14b17a$var$nativeMax($c20c09989d14b17a$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $c20c09989d14b17a$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $c20c09989d14b17a$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($c20c09989d14b17a$var$now());
    }
    function debounced() {
        var time = $c20c09989d14b17a$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $c20c09989d14b17a$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c20c09989d14b17a$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $c20c09989d14b17a$var$isSymbol(value) {
    return typeof value == 'symbol' || $c20c09989d14b17a$var$isObjectLike(value) && $c20c09989d14b17a$var$objectToString.call(value) == $c20c09989d14b17a$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $c20c09989d14b17a$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($c20c09989d14b17a$var$isSymbol(value)) return $c20c09989d14b17a$var$NAN;
    if ($c20c09989d14b17a$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $c20c09989d14b17a$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($c20c09989d14b17a$var$reTrim, '');
    var isBinary = $c20c09989d14b17a$var$reIsBinary.test(value);
    return isBinary || $c20c09989d14b17a$var$reIsOctal.test(value) ? $c20c09989d14b17a$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $c20c09989d14b17a$var$reIsBadHex.test(value) ? $c20c09989d14b17a$var$NAN : +value;
}
$c20c09989d14b17a$exports = $c20c09989d14b17a$var$debounce;


var $380697950572f495$exports = {};
'use strict';
// do not edit .js files directly - edit src/index.jst
$380697950572f495$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


var $66149cfac528b117$exports = {};
'use strict';

$66149cfac528b117$exports = (parcelRequire("gdAUR"));


function $875b08fe0af98e08$export$b3553245f2c17524(callback) {
    const freshRef = (0, $0302d50d2b00a3cf$export$38e1734badfda8d9)(callback);
    const tick = (0, $5NSbj.useCallback)((...args)=>{
        return freshRef.current(...args);
    }, [
        freshRef
    ]);
    return tick;
}
function $875b08fe0af98e08$export$6d974d04a2e6dd6e(callback, timeoutDelayMs = 0, when = true, key = 0) {
    const freshCallback = $875b08fe0af98e08$export$b3553245f2c17524(callback);
    (0, $5NSbj.useEffect)(()=>{
        if (when) {
            let internalCallback2 = function() {
                freshCallback();
            };
            var internalCallback = internalCallback2;
            if (typeof window !== "undefined") {
                const timeout = window.setTimeout(internalCallback2, timeoutDelayMs);
                return ()=>{
                    window.clearTimeout(timeout);
                };
            } else console.warn("useTimeoutWhen: window is undefined.");
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        timeoutDelayMs,
        when,
        key,
        freshCallback
    ]);
}
// src/hooks/useOnLongHover.ts
var $875b08fe0af98e08$export$fb63347121d3339d = (callback, { duration: duration = 300 } = {})=>{
    const [targetNode, setTargetNode] = (0, $5NSbj.useState)(null);
    const ref = (0, $5NSbj.useCallback)((node)=>{
        setTargetNode(node);
    }, []);
    const [isHovering, setIsHovering] = (0, $5NSbj.useState)(false);
    const freshCallback = $875b08fe0af98e08$export$b3553245f2c17524(callback);
    $875b08fe0af98e08$export$6d974d04a2e6dd6e(()=>{
        freshCallback();
    }, duration, isHovering);
    const start = (0, $5NSbj.useCallback)(()=>{
        setIsHovering(true);
    }, []);
    const handleOnMouseLeave = (0, $5NSbj.useCallback)((_)=>{
        setIsHovering(false);
    }, []);
    (0, $5NSbj.useEffect)(()=>{
        if (targetNode) {
            targetNode.addEventListener("mouseenter", start);
            targetNode.addEventListener("mouseleave", handleOnMouseLeave);
        }
        return ()=>{
            if (targetNode) {
                targetNode.removeEventListener("mouseenter", start);
                targetNode.removeEventListener("mouseleave", handleOnMouseLeave);
            }
        };
    }, [
        start,
        handleOnMouseLeave,
        targetNode
    ]);
    return ref;
};
var $875b08fe0af98e08$var$defaultOnClick = ()=>{};
var $875b08fe0af98e08$export$2efba5bd220821d1 = (callback, { onClick: onClick, duration: duration = 300 } = {})=>{
    const [targetNode, setTargetNode] = (0, $5NSbj.useState)(null);
    const ref = (0, $5NSbj.useCallback)((node)=>{
        setTargetNode(node);
    }, []);
    const [isPressing, setIsPressing] = (0, $5NSbj.useState)(false);
    const freshCallback = $875b08fe0af98e08$export$b3553245f2c17524(callback);
    const freshClick = $875b08fe0af98e08$export$b3553245f2c17524(onClick ?? $875b08fe0af98e08$var$defaultOnClick);
    $875b08fe0af98e08$export$6d974d04a2e6dd6e(freshCallback, duration, isPressing);
    const start = (0, $5NSbj.useCallback)((_)=>{
        setIsPressing(true);
    }, []);
    const handleOnClick = (0, $5NSbj.useCallback)((event)=>{
        setIsPressing(false);
        freshClick(event);
    }, [
        freshClick
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (targetNode) {
            targetNode.addEventListener("mousedown", start);
            targetNode.addEventListener("mouseup", handleOnClick);
            targetNode.addEventListener("mouseleave", handleOnClick);
            targetNode.addEventListener("touchstart", start);
            targetNode.addEventListener("touchend", handleOnClick);
            targetNode.addEventListener("touchcancel", handleOnClick);
        }
        return ()=>{
            if (targetNode) {
                targetNode.removeEventListener("mousedown", start);
                targetNode.removeEventListener("mouseup", handleOnClick);
                targetNode.removeEventListener("mouseleave", handleOnClick);
                targetNode.removeEventListener("touchstart", start);
                targetNode.removeEventListener("touchend", handleOnClick);
                targetNode.removeEventListener("touchcancel", handleOnClick);
            }
        };
    }, [
        start,
        handleOnClick,
        targetNode
    ]);
    return ref;
};
function $875b08fe0af98e08$export$a1e544cd5fbfa31(initialValue) {
    const [map, setMap] = (0, $5NSbj.useState)(initialValue);
    const set = (0, $5NSbj.useCallback)((key, value)=>{
        setMap((currentMap)=>({
                ...currentMap,
                [key]: value
            }));
    }, []);
    const has = (0, $5NSbj.useCallback)((key)=>{
        return typeof map[key] !== "undefined";
    }, [
        map
    ]);
    const setMultiple = (0, $5NSbj.useCallback)((nextMap)=>{
        setMap((currentMap)=>({
                ...currentMap,
                ...nextMap
            }));
    }, []);
    const removeMultiple = (0, $5NSbj.useCallback)((...keys)=>{
        setMap((currentMap)=>{
            const nextMap = {
                ...currentMap
            };
            for (const key of keys)delete nextMap[key];
            return nextMap;
        });
    }, [
        setMap
    ]);
    const remove = (0, $5NSbj.useCallback)((key)=>{
        setMap((currentMap)=>{
            const nextMap = {
                ...currentMap
            };
            delete nextMap[key];
            return nextMap;
        });
    }, [
        setMap
    ]);
    const removeAll = (0, $5NSbj.useCallback)(()=>{
        setMap((currentMap)=>{
            const nextMap = {
                ...currentMap
            };
            for (const key of Object.keys(nextMap))delete nextMap[key];
            return nextMap;
        });
    }, [
        setMap
    ]);
    return [
        map,
        {
            has: has,
            remove: remove,
            removeAll: removeAll,
            removeMultiple: removeMultiple,
            set: set,
            setMultiple: setMultiple
        }
    ];
}
function $875b08fe0af98e08$export$3d0be2420b17e328(callback, isActive) {
    const savedCallback = (0, $5NSbj.useRef)(null);
    (0, $5NSbj.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $5NSbj.useEffect)(()=>{
        let animationFrame;
        let startTime = Date.now();
        function tick() {
            const timeElapsed = Date.now() - startTime;
            startTime = Date.now();
            loop();
            savedCallback.current?.(timeElapsed);
        }
        function loop() {
            animationFrame = (0, (/*@__PURE__*/$parcel$interopDefault($4202badc4f08d1bf$exports)))(tick);
        }
        if (isActive) {
            startTime = Date.now();
            loop();
            return ()=>{
                if (animationFrame) (0, (/*@__PURE__*/$parcel$interopDefault($4202badc4f08d1bf$exports))).cancel(animationFrame);
            };
        } else return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        isActive
    ]);
}
// src/hooks/useAnimation.ts
var $875b08fe0af98e08$var$hasWarnedDeprecation = false;
function $875b08fe0af98e08$export$9e2608686d4ad846(options) {
    const { duration: duration, easing: easing = (t)=>t, delay: delay = 0, loop: loop = false } = options;
    const [value, setValue] = (0, $5NSbj.useState)(0);
    const startTimeRef = (0, $5NSbj.useRef)(null);
    const delayRef = (0, $5NSbj.useRef)(delay);
    $875b08fe0af98e08$export$3d0be2420b17e328(()=>{
        if (startTimeRef.current === null) startTimeRef.current = performance.now();
        const elapsed = performance.now() - startTimeRef.current;
        if (elapsed < delayRef.current) return true;
        const timeSinceStart = elapsed - delayRef.current;
        const progress = Math.min(timeSinceStart / duration, 1);
        const easedProgress = easing(progress);
        setValue(easedProgress);
        if (progress < 1) return true;
        if (loop) {
            startTimeRef.current = performance.now();
            delayRef.current = 0;
            return true;
        }
        return false;
    }, true);
    (0, $5NSbj.useEffect)(()=>{
        startTimeRef.current = null;
        delayRef.current = delay;
    }, [
        duration,
        easing,
        delay,
        loop
    ]);
    return value;
}
function $875b08fe0af98e08$export$959143d64510bf04(initial) {
    const [array, setArray] = (0, $5NSbj.useState)(initial ?? []);
    const push = (0, $5NSbj.useCallback)((...values)=>{
        setArray((currentArray)=>[
                ...currentArray,
                ...values
            ]);
    }, []);
    const pop = (0, $5NSbj.useCallback)(()=>{
        setArray((currentArray)=>currentArray.slice(0, -1));
    }, []);
    const clear = (0, $5NSbj.useCallback)(()=>{
        setArray([]);
    }, []);
    const unshift = (0, $5NSbj.useCallback)((...values)=>{
        setArray((currentArray)=>[
                ...values,
                ...currentArray
            ]);
    }, []);
    const shift = (0, $5NSbj.useCallback)(()=>{
        setArray((currentArray)=>currentArray.slice(1));
    }, []);
    const reverse = (0, $5NSbj.useCallback)(()=>{
        setArray((currentArray)=>[
                ...currentArray
            ].reverse());
    }, []);
    const concat = (0, $5NSbj.useCallback)((value)=>{
        setArray((currentArray)=>[
                ...currentArray,
                ...value
            ]);
    }, []);
    const fill = (0, $5NSbj.useCallback)((value, start, end)=>{
        setArray((currentArray)=>[
                ...currentArray
            ].fill(value, start, end));
    }, []);
    const updateItemAtIndex = (0, $5NSbj.useCallback)((index, value)=>{
        setArray((prevArray)=>{
            const newArray = [
                ...prevArray
            ];
            newArray[index] = value;
            return newArray;
        });
    }, [
        setArray
    ]);
    const splice = (0, $5NSbj.useCallback)((...args)=>{
        setArray((prevArray)=>{
            const newArray = [
                ...prevArray
            ];
            newArray.splice(...args);
            return newArray;
        });
    }, [
        setArray
    ]);
    const removeItemAtIndex = (0, $5NSbj.useCallback)((index)=>{
        setArray((prevArray)=>{
            const newArray = [
                ...prevArray
            ];
            newArray.splice(index, 1);
            return newArray;
        });
    }, [
        setArray
    ]);
    const replaceItemAtIndex = (0, $5NSbj.useCallback)((index, value)=>{
        setArray((prevArray)=>{
            const newArray = [
                ...prevArray
            ];
            newArray.splice(index, 1, value);
            return newArray;
        });
    }, [
        setArray
    ]);
    const insertItemAtIndex = (0, $5NSbj.useCallback)((index, value)=>{
        setArray((prevArray)=>{
            const newArray = [
                ...prevArray
            ];
            newArray.splice(index, 0, value);
            return newArray;
        });
    }, [
        setArray
    ]);
    const sort = (0, $5NSbj.useCallback)((compareFn)=>{
        setArray((currentArray)=>[
                ...currentArray
            ].sort(compareFn));
    }, []);
    const controls = (0, $5NSbj.useMemo)(()=>{
        return {
            push: push,
            pop: pop,
            clear: clear,
            unshift: unshift,
            shift: shift,
            reverse: reverse,
            concat: concat,
            fill: fill,
            updateItemAtIndex: updateItemAtIndex,
            setArray: setArray,
            splice: splice,
            removeItemAtIndex: removeItemAtIndex,
            replaceItemAtIndex: replaceItemAtIndex,
            insertItemAtIndex: insertItemAtIndex,
            sort: sort
        };
    }, [
        push,
        pop,
        clear,
        unshift,
        shift,
        reverse,
        concat,
        fill,
        updateItemAtIndex,
        setArray,
        splice,
        removeItemAtIndex,
        replaceItemAtIndex,
        insertItemAtIndex,
        sort
    ]);
    const returnValue = (0, $5NSbj.useMemo)(()=>{
        return [
            array,
            controls
        ];
    }, [
        array,
        controls
    ]);
    return returnValue;
}
var $875b08fe0af98e08$export$7aa0022395cd4c49 = ()=>{
    const isMountedRef = (0, $5NSbj.useRef)(false);
    const get = (0, $5NSbj.useCallback)(()=>isMountedRef.current, []);
    (0, $5NSbj.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return get;
};
// src/hooks/useAsyncEffect.ts
function $875b08fe0af98e08$export$6875e16a8bdc9a91(effect, deps, cleanup) {
    const lastCallId = (0, $5NSbj.useRef)(0);
    const getIsMounted = $875b08fe0af98e08$export$7aa0022395cd4c49();
    const effectRef = (0, $0302d50d2b00a3cf$export$38e1734badfda8d9)(effect);
    const cleanupCallback = $875b08fe0af98e08$export$b3553245f2c17524((result)=>{
        cleanup?.(result);
    });
    const callback = (0, $5NSbj.useCallback)(async ()=>{
        const callId = ++lastCallId.current;
        const shouldContinueEffect = ()=>{
            return getIsMounted() && callId === lastCallId.current;
        };
        return await effectRef.current(shouldContinueEffect);
    }, [
        getIsMounted,
        ...deps
    ]);
    (0, $5NSbj.useEffect)(()=>{
        let result;
        callback().then((value)=>{
            result = value;
        });
        return ()=>{
            cleanupCallback(result);
        };
    }, [
        callback,
        cleanupCallback
    ]);
}
var $875b08fe0af98e08$var$noop2 = ()=>{};
function $875b08fe0af98e08$export$91047320af7bf70b(options = {}, callbacks = {}) {
    const { autoPlay: autoPlay = false, isMuted: initialIsMuted = false, volume: initialVolume = 1, playbackRate: initialPlaybackRate = 1, loop: initialLoop = false, preload: preload = "metadata" } = options;
    const [audioNode, setAudioNode] = (0, $5NSbj.useState)(null);
    const [state, setState] = (0, $5NSbj.useState)({
        isPlaying: false,
        isMuted: initialIsMuted,
        volume: initialVolume,
        currentTime: 0,
        duration: 0,
        playbackRate: initialPlaybackRate,
        isLoading: false,
        isBuffering: false,
        loop: initialLoop,
        hasError: false
    });
    const onPlay = $875b08fe0af98e08$export$b3553245f2c17524(callbacks.onPlay ?? $875b08fe0af98e08$var$noop2);
    const onPause = $875b08fe0af98e08$export$b3553245f2c17524(callbacks.onPause ?? $875b08fe0af98e08$var$noop2);
    const onEnded = $875b08fe0af98e08$export$b3553245f2c17524(callbacks.onEnded ?? $875b08fe0af98e08$var$noop2);
    const onMute = $875b08fe0af98e08$export$b3553245f2c17524(callbacks.onMute ?? $875b08fe0af98e08$var$noop2);
    const onUnmute = $875b08fe0af98e08$export$b3553245f2c17524(callbacks.onUnmute ?? $875b08fe0af98e08$var$noop2);
    const onLoadedMetadata = $875b08fe0af98e08$export$b3553245f2c17524(callbacks.onLoadedMetadata ?? $875b08fe0af98e08$var$noop2);
    const onTimeUpdate = $875b08fe0af98e08$export$b3553245f2c17524(callbacks.onTimeUpdate ?? $875b08fe0af98e08$var$noop2);
    const onDurationChange = $875b08fe0af98e08$export$b3553245f2c17524(callbacks.onDurationChange ?? $875b08fe0af98e08$var$noop2);
    const onVolumeChange = $875b08fe0af98e08$export$b3553245f2c17524(callbacks.onVolumeChange ?? $875b08fe0af98e08$var$noop2);
    const onRateChange = $875b08fe0af98e08$export$b3553245f2c17524(callbacks.onRateChange ?? $875b08fe0af98e08$var$noop2);
    const onError = $875b08fe0af98e08$export$b3553245f2c17524(callbacks.onError ?? $875b08fe0af98e08$var$noop2);
    const onLoadStart = $875b08fe0af98e08$export$b3553245f2c17524(callbacks.onLoadStart ?? $875b08fe0af98e08$var$noop2);
    const onCanPlay = $875b08fe0af98e08$export$b3553245f2c17524(callbacks.onCanPlay ?? $875b08fe0af98e08$var$noop2);
    const onWaiting = $875b08fe0af98e08$export$b3553245f2c17524(callbacks.onWaiting ?? $875b08fe0af98e08$var$noop2);
    const audioCallbackRef = (node)=>{
        if (node !== null) setAudioNode(node);
    };
    (0, $5NSbj.useEffect)(()=>{
        if (!audioNode) return;
        audioNode.muted = state.isMuted;
        audioNode.volume = state.volume;
        audioNode.playbackRate = state.playbackRate;
        audioNode.loop = state.loop;
        audioNode.preload = preload;
        if (autoPlay) audioNode.autoplay = true;
    }, [
        audioNode,
        autoPlay,
        preload
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (!audioNode) return;
        const handleLoadStart = ()=>{
            setState((prev)=>({
                    ...prev,
                    isLoading: true,
                    hasError: false
                }));
            onLoadStart();
        };
        const handleLoadedMetadata = ()=>{
            setState((prev)=>({
                    ...prev,
                    duration: audioNode.duration,
                    isLoading: false,
                    hasError: false
                }));
            onLoadedMetadata();
            onDurationChange(audioNode.duration);
        };
        const handleCanPlay = ()=>{
            setState((prev)=>({
                    ...prev,
                    isBuffering: false,
                    hasError: false
                }));
            onCanPlay();
        };
        const handleWaiting = ()=>{
            setState((prev)=>({
                    ...prev,
                    isBuffering: true
                }));
            onWaiting();
        };
        const handlePlay = ()=>{
            setState((prev)=>({
                    ...prev,
                    isPlaying: true,
                    hasError: false
                }));
            onPlay();
        };
        const handlePause = ()=>{
            setState((prev)=>({
                    ...prev,
                    isPlaying: false
                }));
            onPause();
        };
        const handleEnded = ()=>{
            setState((prev)=>({
                    ...prev,
                    isPlaying: false
                }));
            onEnded();
        };
        const handleTimeUpdate = ()=>{
            const currentTime = audioNode.currentTime;
            setState((prev)=>({
                    ...prev,
                    currentTime: currentTime
                }));
            onTimeUpdate(currentTime);
        };
        const handleDurationChange = ()=>{
            const duration = audioNode.duration;
            setState((prev)=>({
                    ...prev,
                    duration: duration
                }));
            onDurationChange(duration);
        };
        const handleVolumeChange = ()=>{
            const volume = audioNode.volume;
            const isMuted = audioNode.muted;
            setState((prev)=>{
                const newState = {
                    ...prev,
                    volume: volume,
                    isMuted: isMuted
                };
                if (isMuted !== prev.isMuted) {
                    if (isMuted) onMute();
                    else onUnmute();
                }
                return newState;
            });
            onVolumeChange(volume);
        };
        const handleRateChange = ()=>{
            const playbackRate = audioNode.playbackRate;
            setState((prev)=>({
                    ...prev,
                    playbackRate: playbackRate
                }));
            onRateChange(playbackRate);
        };
        const handleError = ()=>{
            const error = audioNode.error;
            const errorMessage = error ? `Audio error (${error.code}): ${error.message}` : "Unknown audio error occurred";
            setState((prev)=>({
                    ...prev,
                    hasError: true,
                    error: errorMessage,
                    isLoading: false,
                    isBuffering: false,
                    isPlaying: false
                }));
            onError(errorMessage);
        };
        audioNode.addEventListener("loadstart", handleLoadStart);
        audioNode.addEventListener("loadedmetadata", handleLoadedMetadata);
        audioNode.addEventListener("canplay", handleCanPlay);
        audioNode.addEventListener("waiting", handleWaiting);
        audioNode.addEventListener("play", handlePlay);
        audioNode.addEventListener("pause", handlePause);
        audioNode.addEventListener("ended", handleEnded);
        audioNode.addEventListener("timeupdate", handleTimeUpdate);
        audioNode.addEventListener("durationchange", handleDurationChange);
        audioNode.addEventListener("volumechange", handleVolumeChange);
        audioNode.addEventListener("ratechange", handleRateChange);
        audioNode.addEventListener("error", handleError);
        return ()=>{
            audioNode.removeEventListener("loadstart", handleLoadStart);
            audioNode.removeEventListener("loadedmetadata", handleLoadedMetadata);
            audioNode.removeEventListener("canplay", handleCanPlay);
            audioNode.removeEventListener("waiting", handleWaiting);
            audioNode.removeEventListener("play", handlePlay);
            audioNode.removeEventListener("pause", handlePause);
            audioNode.removeEventListener("ended", handleEnded);
            audioNode.removeEventListener("timeupdate", handleTimeUpdate);
            audioNode.removeEventListener("durationchange", handleDurationChange);
            audioNode.removeEventListener("volumechange", handleVolumeChange);
            audioNode.removeEventListener("ratechange", handleRateChange);
            audioNode.removeEventListener("error", handleError);
        };
    }, [
        audioNode,
        onLoadStart,
        onLoadedMetadata,
        onCanPlay,
        onWaiting,
        onPlay,
        onPause,
        onEnded,
        onTimeUpdate,
        onDurationChange,
        onVolumeChange,
        onRateChange,
        onError,
        onMute,
        onUnmute
    ]);
    const play = ()=>{
        if (!audioNode) return;
        audioNode.play().catch((error)=>{
            const errorMessage = error instanceof Error ? error.message : "Failed to play audio";
            setState((prev)=>({
                    ...prev,
                    hasError: true,
                    error: errorMessage,
                    isPlaying: false
                }));
            onError(errorMessage);
        });
    };
    const pause = ()=>{
        if (!audioNode) return;
        audioNode.pause();
    };
    const togglePlay = ()=>{
        if (state.isPlaying) pause();
        else play();
    };
    const mute = ()=>{
        if (!audioNode) return;
        audioNode.muted = true;
    };
    const unmute = ()=>{
        if (!audioNode) return;
        audioNode.muted = false;
    };
    const toggleMute = ()=>{
        if (state.isMuted) unmute();
        else mute();
    };
    const setVolume = (volume)=>{
        if (!audioNode) return;
        const clampedVolume = Math.max(0, Math.min(1, volume));
        audioNode.volume = clampedVolume;
    };
    const setCurrentTime = (time)=>{
        if (!audioNode) return;
        const clampedTime = Math.max(0, Math.min(state.duration || 0, time));
        audioNode.currentTime = clampedTime;
    };
    const setPlaybackRate = (rate)=>{
        if (!audioNode) return;
        const clampedRate = Math.max(0.25, Math.min(4, rate));
        audioNode.playbackRate = clampedRate;
    };
    const seek = (seconds)=>{
        setCurrentTime(state.currentTime + seconds);
    };
    const fastForward = (seconds = 10)=>{
        seek(seconds);
    };
    const rewind = (seconds = 10)=>{
        seek(-seconds);
    };
    const setLoop = (loop)=>{
        if (!audioNode) return;
        audioNode.loop = loop;
        setState((prev)=>({
                ...prev,
                loop: loop
            }));
    };
    const controls = {
        play: play,
        pause: pause,
        togglePlay: togglePlay,
        mute: mute,
        unmute: unmute,
        toggleMute: toggleMute,
        setVolume: setVolume,
        setCurrentTime: setCurrentTime,
        setPlaybackRate: setPlaybackRate,
        seek: seek,
        fastForward: fastForward,
        rewind: rewind,
        setLoop: setLoop
    };
    return [
        audioCallbackRef,
        state,
        controls
    ];
}
function $875b08fe0af98e08$export$4984640464733c64(callback) {
    (0, $5NSbj.useEffect)(()=>{
        if (typeof callback === "function") callback();
    }, []);
}
var $875b08fe0af98e08$var$config = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
function $875b08fe0af98e08$export$8ecdcf3bb089e9cd(ref, callback, options = $875b08fe0af98e08$var$config) {
    (0, $5NSbj.useEffect)(()=>{
        if (ref.current) {
            const observer = new MutationObserver(callback);
            observer.observe(ref.current, options);
            return ()=>{
                observer.disconnect();
            };
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        callback,
        options,
        ref
    ]);
}
// src/hooks/useBoundingclientrect.ts
function $875b08fe0af98e08$var$getBoundingClientRect(element) {
    return element.getBoundingClientRect();
}
function $875b08fe0af98e08$export$b95e3d4f036ffdbe(ref) {
    const [domRect, setDomRect] = (0, $5NSbj.useState)(null);
    const update = (0, $5NSbj.useCallback)(()=>{
        setDomRect(ref.current ? $875b08fe0af98e08$var$getBoundingClientRect(ref.current) : null);
    }, [
        ref
    ]);
    $875b08fe0af98e08$export$4984640464733c64(()=>{
        update();
    });
    $875b08fe0af98e08$export$8ecdcf3bb089e9cd(ref, update);
    return domRect;
}
var $875b08fe0af98e08$var$config2 = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
function $875b08fe0af98e08$export$cdfcc5138d0e9570(callback, options = $875b08fe0af98e08$var$config2) {
    const [node, setNode] = (0, $5NSbj.useState)(null);
    (0, $5NSbj.useEffect)(()=>{
        if (node) {
            const observer = new MutationObserver(callback);
            observer.observe(node, options);
            return ()=>{
                observer.disconnect();
            };
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        node,
        callback,
        options
    ]);
    const ref = (0, $5NSbj.useCallback)((nodeElement)=>{
        setNode(nodeElement);
    }, []);
    return [
        ref
    ];
}
// src/hooks/useBoundingclientrectRef.ts
function $875b08fe0af98e08$var$getBoundingClientRect2(element) {
    return element.getBoundingClientRect();
}
function $875b08fe0af98e08$export$e44360762afe9191() {
    const [domRect, setDomRect] = (0, $5NSbj.useState)(null);
    const [node, setNode] = (0, $5NSbj.useState)(null);
    const update = (0, $5NSbj.useCallback)(()=>{
        setDomRect(node ? $875b08fe0af98e08$var$getBoundingClientRect2(node) : null);
    }, [
        node
    ]);
    (0, $5NSbj.useEffect)(()=>{
        update();
    }, [
        update
    ]);
    const ref = (0, $5NSbj.useCallback)((nodeElement)=>{
        setNode(nodeElement);
    }, []);
    const [mutationObserverRef] = $875b08fe0af98e08$export$cdfcc5138d0e9570(update);
    const forkedRef = (0, $0302d50d2b00a3cf$export$ebc1e1560c2dffa5)(ref, mutationObserverRef);
    return [
        forkedRef,
        domRect,
        update
    ];
}
function $875b08fe0af98e08$export$d41d1c6c7d9f02aa(initialValue) {
    const [checked, setInternalChecked] = (0, $5NSbj.useState)(initialValue);
    const setChecked = (0, $5NSbj.useCallback)((newChecked)=>{
        setInternalChecked(newChecked);
    }, []);
    const toggle = (0, $5NSbj.useCallback)(()=>{
        setInternalChecked((prev)=>!prev);
    }, []);
    const handleChange = (0, $5NSbj.useCallback)((event)=>{
        setInternalChecked(event.target.checked);
    }, []);
    const inputProps = (0, $5NSbj.useMemo)(()=>({
            checked: checked,
            onChange: handleChange
        }), [
        checked,
        handleChange
    ]);
    return {
        checked: checked,
        toggle: toggle,
        setChecked: setChecked,
        inputProps: inputProps
    };
}
function $875b08fe0af98e08$export$2314ca2a3e892862() {
    const [text, setText] = (0, $5NSbj.useState)(null);
    const [error, setError] = (0, $5NSbj.useState)(null);
    const isSupported = typeof window !== "undefined" && typeof navigator !== "undefined" && "clipboard" in navigator;
    const copy = (0, $5NSbj.useCallback)(async (value)=>{
        if (!isSupported) {
            const err = new Error("Clipboard API is not supported");
            setError(err);
            throw err;
        }
        try {
            await navigator.clipboard.writeText(value);
            setText(value);
            setError(null);
        } catch (err) {
            const error2 = err instanceof Error ? err : new Error("Failed to copy to clipboard");
            setError(error2);
            throw error2;
        }
    }, [
        isSupported
    ]);
    const paste = (0, $5NSbj.useCallback)(async ()=>{
        if (!isSupported) {
            const err = new Error("Clipboard API is not supported");
            setError(err);
            throw err;
        }
        try {
            const clipboardText = await navigator.clipboard.readText();
            setText(clipboardText);
            setError(null);
        } catch (err) {
            const error2 = err instanceof Error ? err : new Error("Failed to read from clipboard");
            setError(error2);
            throw error2;
        }
    }, [
        isSupported
    ]);
    return {
        text: text,
        copy: copy,
        paste: paste,
        isSupported: isSupported,
        error: error
    };
}
function $875b08fe0af98e08$export$88af857a8946da7e(callback, intervalDurationMs = 0, when = true, startImmediate = false) {
    const savedRefCallback = (0, $5NSbj.useRef)(void 0);
    (0, $5NSbj.useEffect)(()=>{
        savedRefCallback.current = callback;
    });
    (0, $5NSbj.useEffect)(()=>{
        if (when) {
            let internalCallback2 = function() {
                savedRefCallback.current?.();
            };
            var internalCallback = internalCallback2;
            if (startImmediate) internalCallback2();
            const interval = window.setInterval(internalCallback2, intervalDurationMs);
            return ()=>{
                window.clearInterval(interval);
            };
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        when,
        intervalDurationMs,
        startImmediate
    ]);
}
// src/hooks/useCountdown.ts
function $875b08fe0af98e08$export$8103f7eb37e19f7b(endTime, options = {}) {
    const { interval: interval = 1e3, onDown: onDown, onEnd: onEnd } = options;
    const [time, setTime] = (0, $5NSbj.useState)(()=>/* @__PURE__ */ new Date());
    const endTimeMs = endTime.getTime();
    const restTime = endTimeMs - time.getTime();
    const count = restTime > 0 ? Math.ceil(restTime / interval) : 0;
    const endedAtRef = (0, $5NSbj.useRef)(null);
    const onEndRef = (0, $0302d50d2b00a3cf$export$38e1734badfda8d9)(onEnd);
    $875b08fe0af98e08$export$88af857a8946da7e(onTick, interval, count > 0, true);
    (0, $5NSbj.useEffect)(()=>{
        if (Number.isFinite(endTimeMs) && endTimeMs <= Date.now() && endedAtRef.current !== endTimeMs) {
            endedAtRef.current = endTimeMs;
            onEndRef.current?.(/* @__PURE__ */ new Date());
        }
    }, [
        endTimeMs,
        onEndRef
    ]);
    return count;
    function onTick() {
        const newTime = /* @__PURE__ */ new Date();
        const newRestTime = endTimeMs - newTime.getTime();
        if (newRestTime <= 0) {
            if (endedAtRef.current !== endTimeMs) {
                endedAtRef.current = endTimeMs;
                onEnd?.(newTime);
            }
            setTime(endTime);
            return;
        }
        if (onDown) onDown(newRestTime, newTime);
        setTime(newTime);
    }
}
function $875b08fe0af98e08$export$70c4067197c60e2d(initialValue) {
    const [counter, setCounter] = (0, $5NSbj.useState)(initialValue);
    const incrementBy = (0, $5NSbj.useCallback)((incrAmount)=>{
        setCounter((currentCounter)=>currentCounter + incrAmount);
    }, []);
    const decrementBy = (0, $5NSbj.useCallback)((decrAmount)=>{
        incrementBy(-decrAmount);
    }, [
        incrementBy
    ]);
    const increment = (0, $5NSbj.useCallback)(()=>{
        incrementBy(1);
    }, [
        incrementBy
    ]);
    const decrement = (0, $5NSbj.useCallback)(()=>{
        incrementBy(-1);
    }, [
        incrementBy
    ]);
    const reset = (0, $5NSbj.useCallback)(()=>{
        setCounter(initialValue);
    }, [
        initialValue
    ]);
    return {
        decrement: decrement,
        decrementBy: decrementBy,
        increment: increment,
        incrementBy: incrementBy,
        reset: reset,
        value: counter
    };
}
function $875b08fe0af98e08$export$328d69a66df243d8(callback) {
    (0, $5NSbj.useEffect)(()=>{
        return callback;
    }, []);
}
// src/hooks/useDebounce.ts
function $875b08fe0af98e08$export$21805fee57372823(callback, wait, options) {
    const createDebouncedCallback = (0, $5NSbj.useCallback)((function_)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($c20c09989d14b17a$exports)))(function_, wait, options);
    }, [
        wait,
        options
    ]);
    const freshCallback = (0, $0302d50d2b00a3cf$export$38e1734badfda8d9)(callback);
    function tick(...args) {
        freshCallback.current?.(...args);
    }
    const debouncedCallbackRef = (0, $5NSbj.useRef)(createDebouncedCallback(tick));
    $875b08fe0af98e08$export$328d69a66df243d8(()=>{
        debouncedCallbackRef.current?.cancel();
    });
    return debouncedCallbackRef.current;
}
function $875b08fe0af98e08$export$ddf8f1aa96b8ea88(func, delay, options = {
    leading: false,
    trailing: true
}) {
    const { leading: leading, trailing: trailing, maxWait: maxWait } = options;
    if (!leading && !trailing) throw new Error("leading and trailing cannot both be false");
    else if (typeof maxWait !== "undefined" && maxWait < delay) throw new Error("maxWait cannot be less than delay");
    const funcRef = $875b08fe0af98e08$export$b3553245f2c17524(func);
    const [isTimeoutEnabled, setIsTimeoutEnabled] = (0, $5NSbj.useState)(false);
    const [key, setKey] = (0, $5NSbj.useState)(0);
    const lastExecutionTimeRef = (0, $5NSbj.useRef)(0);
    const argsRef = (0, $5NSbj.useRef)(void 0);
    const debouncedFn = (0, $5NSbj.useCallback)((...args)=>{
        argsRef.current = args;
        const overrideTimeout = typeof maxWait !== "undefined" && lastExecutionTimeRef.current && Date.now() - lastExecutionTimeRef.current > maxWait;
        if (leading) {
            if (isTimeoutEnabled && overrideTimeout) {
                setKey((prevKey)=>prevKey + 1);
                lastExecutionTimeRef.current = Date.now();
                try {
                    funcRef(...args);
                } catch (error) {
                    console.warn(error);
                }
            } else if (overrideTimeout && !isTimeoutEnabled) {
                setIsTimeoutEnabled(true);
                lastExecutionTimeRef.current = Date.now();
                try {
                    funcRef(...args);
                } catch (error) {
                    console.warn(error);
                }
            } else if (isTimeoutEnabled && !overrideTimeout) ;
            else {
                setIsTimeoutEnabled(true);
                lastExecutionTimeRef.current = Date.now();
                try {
                    funcRef(...args);
                } catch (error) {
                    console.warn(error);
                }
            }
        }
        if (trailing) {
            if (isTimeoutEnabled) setKey((prevKey)=>prevKey + 1);
            else setIsTimeoutEnabled(true);
        }
    }, [
        maxWait,
        isTimeoutEnabled,
        leading,
        trailing,
        funcRef
    ]);
    $875b08fe0af98e08$export$6d974d04a2e6dd6e(()=>{
        if (typeof maxWait !== "undefined" && trailing) {
            if (!argsRef.current) return;
            lastExecutionTimeRef.current = Date.now();
            try {
                funcRef(...argsRef.current);
            } catch (error) {
                console.warn(error);
            }
        }
    }, maxWait ?? Infinity, isTimeoutEnabled && typeof maxWait !== "undefined" && trailing, key);
    $875b08fe0af98e08$export$6d974d04a2e6dd6e(()=>{
        if (trailing) {
            if (!argsRef.current) return;
            lastExecutionTimeRef.current = Date.now();
            try {
                funcRef(...argsRef.current);
            } catch (error) {
                console.warn(error);
            }
        }
        setIsTimeoutEnabled(false);
    }, delay, isTimeoutEnabled && trailing, key);
    const freshDebouncedFn = $875b08fe0af98e08$export$b3553245f2c17524(debouncedFn);
    return [
        freshDebouncedFn,
        isTimeoutEnabled
    ];
}
function $875b08fe0af98e08$export$f61003a1bfad2e1d(effect, deps, delay = 500, cleanup, options) {
    const lastCallId = (0, $5NSbj.useRef)(0);
    const getIsMounted = $875b08fe0af98e08$export$7aa0022395cd4c49();
    const effectRef = (0, $0302d50d2b00a3cf$export$38e1734badfda8d9)(effect);
    const resultRef = (0, $5NSbj.useRef)(void 0);
    const asyncCallback = (0, $5NSbj.useCallback)(async ()=>{
        const callId = ++lastCallId.current;
        const shouldContinueEffect = ()=>{
            return getIsMounted() && callId === lastCallId.current;
        };
        try {
            const result = await effectRef.current(shouldContinueEffect);
            if (shouldContinueEffect()) resultRef.current = result;
            return result;
        } catch (error) {
            if (shouldContinueEffect()) throw error;
        }
    }, [
        getIsMounted,
        effectRef
    ]);
    const debouncedAsyncCallback = $875b08fe0af98e08$export$21805fee57372823(asyncCallback, delay, options);
    const cleanupRef = (0, $0302d50d2b00a3cf$export$38e1734badfda8d9)(cleanup);
    (0, $5NSbj.useEffect)(()=>{
        debouncedAsyncCallback();
        const currentCleanup = cleanupRef.current;
        return ()=>{
            lastCallId.current += 1;
            debouncedAsyncCallback.cancel();
            const result = resultRef.current;
            resultRef.current = void 0;
            currentCleanup?.(result);
        };
    }, deps);
}
function $875b08fe0af98e08$export$44b55d93c84df466(effect, deps, delay = 500, options) {
    const cleanupRef = (0, $5NSbj.useRef)(void 0);
    const wrappedEffect = ()=>{
        if (typeof cleanupRef.current === "function") cleanupRef.current();
        cleanupRef.current = effect();
    };
    const debouncedEffect = $875b08fe0af98e08$export$21805fee57372823(wrappedEffect, delay, options);
    (0, $5NSbj.useEffect)(()=>{
        debouncedEffect();
        return ()=>{
            debouncedEffect.cancel();
            if (typeof cleanupRef.current === "function") {
                cleanupRef.current();
                cleanupRef.current = void 0;
            }
        };
    }, deps);
}
function $875b08fe0af98e08$export$e34ed88fef4dc107(callback, conditions) {
    const hasMountedRef = (0, $5NSbj.useRef)(false);
    const internalConditions = (0, $5NSbj.useMemo)(()=>{
        if (typeof conditions !== "undefined" && !Array.isArray(conditions)) return [
            conditions
        ];
        else if (Array.isArray(conditions) && conditions.length === 0) console.warn("Using [] as the second argument makes useDidUpdate a noop. The second argument should either be `undefined` or an array of length greater than 0.");
        return conditions;
    }, [
        conditions
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (hasMountedRef.current) callback();
    }, internalConditions);
    $875b08fe0af98e08$export$4984640464733c64(()=>{
        hasMountedRef.current = true;
    });
    $875b08fe0af98e08$export$328d69a66df243d8(()=>{
        hasMountedRef.current = false;
    });
}
// src/hooks/useDebouncedValue.ts
var $875b08fe0af98e08$var$defaultUseDebounceValueOptions = {
    initializeWithNull: false
};
var $875b08fe0af98e08$export$5ab4fa7caa249e6e = (value, timeout, options = {})=>{
    const { initializeWithNull: initializeWithNull } = Object.assign({}, $875b08fe0af98e08$var$defaultUseDebounceValueOptions, options);
    const [updatedValue, setUpdatedValue] = (0, $5NSbj.useState)(initializeWithNull ? null : value);
    const debouncedSetUpdatedValue = $875b08fe0af98e08$export$21805fee57372823(setUpdatedValue, timeout);
    $875b08fe0af98e08$export$4984640464733c64(()=>{
        if (initializeWithNull) debouncedSetUpdatedValue(value);
    });
    $875b08fe0af98e08$export$e34ed88fef4dc107(()=>{
        debouncedSetUpdatedValue(value);
    }, [
        value
    ]);
    return [
        updatedValue,
        setUpdatedValue
    ];
};
// src/hooks/warning.ts
var $875b08fe0af98e08$var$isDevelopmentEnvironment = false;
var $875b08fe0af98e08$var$warning = ()=>{};
if ($875b08fe0af98e08$var$isDevelopmentEnvironment) {
    const printWarning = (actualMessage)=>{
        const message = `Warning: ${actualMessage}`;
        if (typeof console !== "undefined") console.error(message);
        try {
            throw new Error(message);
        } catch  {}
    };
    $875b08fe0af98e08$var$warning = function(condition, actualMessage) {
        if (!condition) printWarning(actualMessage);
    };
}
// src/hooks/useDeepCompareEffect.ts
function $875b08fe0af98e08$var$isPrimitive(value) {
    const valueType = typeof value;
    return valueType === "string" || valueType === "number" || valueType === "bigint" || valueType === "boolean" || valueType === "undefined" || valueType === "symbol";
}
function $875b08fe0af98e08$export$db77f469fe79526e(callback, dependencies) {
    const previousDeps = (0, $5NSbj.useRef)(dependencies);
    if (!Array.isArray(dependencies)) throw new Error("useDeepCompareEffect should be used with an array of dependencies");
    const hasPrimitives = dependencies.every($875b08fe0af98e08$var$isPrimitive);
    $875b08fe0af98e08$var$warning(!hasPrimitives, "useDeepCompareEffect should not be used with primitive values as dependencies");
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($380697950572f495$exports)))(previousDeps.current, dependencies)) previousDeps.current = dependencies;
    (0, $5NSbj.useEffect)(callback, previousDeps.current);
}
function $875b08fe0af98e08$var$useGlobalObjectEventListener(globalObject, eventName, callback, listenerOptions = {}, when = true, isLayoutEffect = false) {
    (0, $5NSbj.useEffect)(()=>{
        $875b08fe0af98e08$var$warning(typeof window === "undefined" || typeof globalObject !== "undefined", "[useGlobalObjectEventListener]: Cannot attach event handlers to undefined.");
    }, [
        globalObject
    ]);
    (0, $0302d50d2b00a3cf$export$7080b3e976bc91ab)(eventName, callback, {
        target: globalObject,
        listenerOptions: listenerOptions,
        when: when,
        isLayoutEffect: isLayoutEffect
    });
}
// src/hooks/useOnWindowResize.ts
function $875b08fe0af98e08$export$61171a90a6148cf5(callback, when = true, isLayoutEffect = false) {
    $875b08fe0af98e08$var$useGlobalObjectEventListener(typeof window !== "undefined" ? window : void 0, "resize", callback, {
        passive: true
    }, when, isLayoutEffect);
}
// src/hooks/useOnWindowScroll.ts
function $875b08fe0af98e08$export$f2fb712044277d5e(callback, when = true, isLayoutEffect = false) {
    $875b08fe0af98e08$var$useGlobalObjectEventListener(typeof window !== "undefined" ? window : void 0, "scroll", callback, {
        passive: true
    }, when, isLayoutEffect);
}
// src/hooks/useDimensionsRef.ts
var $875b08fe0af98e08$var$getDimensionObject = (node)=>{
    const rect = node.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width,
        x: rect.left,
        y: rect.top
    };
};
var $875b08fe0af98e08$var$noWindowReturnValue = [
    void 0,
    null,
    null
];
var $875b08fe0af98e08$export$b5cb37376a215039 = ({ updateOnScroll: updateOnScroll = true, updateOnResize: updateOnResize = true } = {})=>{
    const [dimensions, setDimensions] = (0, $5NSbj.useState)(null);
    const [node, setNode] = (0, $5NSbj.useState)(null);
    const ref = (0, $5NSbj.useCallback)((nodeFromCallback)=>{
        setNode(nodeFromCallback);
    }, []);
    const measure = (0, $5NSbj.useCallback)(()=>{
        window.requestAnimationFrame(()=>{
            if (node) setDimensions($875b08fe0af98e08$var$getDimensionObject(node));
        });
    }, [
        node
    ]);
    (0, $5NSbj.useLayoutEffect)(()=>{
        measure();
    }, [
        measure
    ]);
    $875b08fe0af98e08$export$61171a90a6148cf5(()=>{
        measure();
    }, updateOnResize, true);
    $875b08fe0af98e08$export$f2fb712044277d5e(()=>{
        measure();
    }, updateOnScroll, true);
    if (typeof window === "undefined") {
        console.warn("useDimensionsRef: window is undefined.");
        return $875b08fe0af98e08$var$noWindowReturnValue;
    }
    return [
        ref,
        dimensions,
        node
    ];
};
// src/hooks/useDocumentEventListener.ts
function $875b08fe0af98e08$export$3d17299e951a5198(eventName, callback, listenerOptions = {}, isLayoutEffect = false) {
    $875b08fe0af98e08$var$useGlobalObjectEventListener(typeof document !== "undefined" ? document : void 0, eventName, callback, listenerOptions, true, isLayoutEffect);
}
function $875b08fe0af98e08$export$4b208edda918084f(title, options = {}) {
    const isBrowser = typeof window !== "undefined";
    const prevTitleRef = (0, $5NSbj.useRef)(isBrowser ? document.title : "");
    const { resetOnUnmount: resetOnUnmount = false } = options;
    (0, $5NSbj.useEffect)(()=>{
        if (isBrowser) {
            document.title = title;
            const lastTitle = prevTitleRef.current;
            if (resetOnUnmount) return ()=>{
                document.title = lastTitle;
            };
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        title,
        isBrowser,
        resetOnUnmount
    ]);
}
var $875b08fe0af98e08$export$cea96571ebbff9dd = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>t * (2 - t),
    easeInOutQuad: (t)=>t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>--t * t * t + 1,
    easeInOutCubic: (t)=>t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
};
function $875b08fe0af98e08$export$c27926f3509c2cc6(duration, options = {}) {
    const { easing: easing = $875b08fe0af98e08$export$cea96571ebbff9dd.linear, autoStart: autoStart = true, loop: loop = false, alternate: alternate = false, delay: delay = 0, onEnd: onEnd } = options;
    const [progress, setProgress] = (0, $5NSbj.useState)(0);
    const [state, setState] = (0, $5NSbj.useState)(autoStart ? "running" : "idle");
    const [direction, setDirection] = (0, $5NSbj.useState)("forward");
    const [endCount, setEndCount] = (0, $5NSbj.useState)(0);
    const startTimeRef = (0, $5NSbj.useRef)(null);
    const pausedRawProgressRef = (0, $5NSbj.useRef)(0);
    const delayRemainingRef = (0, $5NSbj.useRef)(delay);
    const isFirstRunRef = (0, $5NSbj.useRef)(true);
    const hasCompletedRef = (0, $5NSbj.useRef)(false);
    const currentRawProgressRef = (0, $5NSbj.useRef)(0);
    const onEndRef = (0, $5NSbj.useRef)(onEnd);
    onEndRef.current = onEnd;
    const directionRef = (0, $5NSbj.useRef)(direction);
    directionRef.current = direction;
    const start = (0, $5NSbj.useCallback)(()=>{
        if (state === "running") return;
        startTimeRef.current = null;
        hasCompletedRef.current = false;
        setState("running");
    }, [
        state
    ]);
    const stop = (0, $5NSbj.useCallback)(()=>{
        if (state === "idle") return;
        pausedRawProgressRef.current = currentRawProgressRef.current;
        setState("idle");
    }, [
        state
    ]);
    const reset = (0, $5NSbj.useCallback)(()=>{
        setState("idle");
        setProgress(0);
        setDirection("forward");
        setEndCount(0);
        startTimeRef.current = null;
        pausedRawProgressRef.current = 0;
        currentRawProgressRef.current = 0;
        delayRemainingRef.current = delay;
        isFirstRunRef.current = true;
        hasCompletedRef.current = false;
        directionRef.current = "forward";
    }, [
        delay
    ]);
    const restart = (0, $5NSbj.useCallback)(()=>{
        reset();
        setTimeout(()=>{
            setState("running");
        }, 0);
    }, [
        reset
    ]);
    $875b08fe0af98e08$export$3d0be2420b17e328(()=>{
        if (startTimeRef.current === null) {
            const resumeOffset = pausedRawProgressRef.current * duration;
            startTimeRef.current = performance.now() - resumeOffset;
        }
        const elapsed = performance.now() - startTimeRef.current;
        if (isFirstRunRef.current && delayRemainingRef.current > 0) {
            if (elapsed < delayRemainingRef.current) return;
            startTimeRef.current = performance.now() - (elapsed - delayRemainingRef.current);
            delayRemainingRef.current = 0;
            isFirstRunRef.current = false;
        }
        const adjustedElapsed = performance.now() - startTimeRef.current;
        const rawProgress = Math.min(adjustedElapsed / duration, 1);
        currentRawProgressRef.current = rawProgress;
        const directionalProgress = directionRef.current === "forward" ? rawProgress : 1 - rawProgress;
        const easedProgress = easing(directionalProgress);
        setProgress(easedProgress);
        if (rawProgress >= 1 && !hasCompletedRef.current) {
            hasCompletedRef.current = true;
            setEndCount((prev)=>prev + 1);
            onEndRef.current?.();
            if (loop) {
                startTimeRef.current = performance.now();
                hasCompletedRef.current = false;
                if (alternate) {
                    const newDirection = directionRef.current === "forward" ? "backward" : "forward";
                    directionRef.current = newDirection;
                    setDirection(newDirection);
                }
            } else setState("idle");
        }
    }, state === "running");
    (0, $5NSbj.useEffect)(()=>{
        if (autoStart) setState("running");
    }, []);
    const controls = (0, $5NSbj.useMemo)(()=>({
            start: start,
            stop: stop,
            reset: reset,
            restart: restart,
            state: state,
            direction: direction,
            endCount: endCount
        }), [
        start,
        stop,
        reset,
        restart,
        state,
        direction,
        endCount
    ]);
    return [
        progress,
        controls
    ];
}
function $875b08fe0af98e08$var$getVisibilityStateSnapshot() {
    if (typeof document !== "undefined") return document.visibilityState;
    else return null;
}
function $875b08fe0af98e08$var$getVisibilityStateSubscription(callback) {
    if (typeof document !== "undefined") {
        document.addEventListener("visibilitychange", callback);
        return ()=>{
            document.removeEventListener("visibilitychange", callback);
        };
    }
    return ()=>{};
}
function $875b08fe0af98e08$var$getVisibilityStateServerSnapshot() {
    return null;
}
function $875b08fe0af98e08$export$84b371b406ccb709() {
    return (0, $5NSbj.useSyncExternalStore)($875b08fe0af98e08$var$getVisibilityStateSubscription, $875b08fe0af98e08$var$getVisibilityStateSnapshot, $875b08fe0af98e08$var$getVisibilityStateServerSnapshot);
}
function $875b08fe0af98e08$export$7a4c3f7300df51d9(callback, when = true) {
    const hasRunOnceRef = (0, $5NSbj.useRef)(false);
    const callbackRef = (0, $5NSbj.useRef)(callback);
    (0, $5NSbj.useEffect)(()=>{
        callbackRef.current = callback;
    });
    (0, $5NSbj.useEffect)(()=>{
        if (when && !hasRunOnceRef.current) {
            callbackRef.current();
            hasRunOnceRef.current = true;
        }
    }, [
        when
    ]);
}
// src/hooks/useEventListenerRef.ts
function $875b08fe0af98e08$export$f2a41a0f37ebea17(eventName, callback, listenerOptions = {}, isLayoutEffect = false) {
    const [ref, element] = (0, $0302d50d2b00a3cf$export$231305e360fbdfeb)();
    (0, $0302d50d2b00a3cf$export$7080b3e976bc91ab)(eventName, callback, {
        target: element,
        listenerOptions: listenerOptions,
        isLayoutEffect: isLayoutEffect
    });
    return ref;
}
function $875b08fe0af98e08$export$7066775237fab396(options = {}, callbacks = {}) {
    const { accept: accept, maxFileSize: maxFileSize, maxFiles: maxFiles } = options;
    const { onDrop: onDrop = (0, $0302d50d2b00a3cf$export$8793edee2d425525), onFileAccepted: onFileAccepted = (0, $0302d50d2b00a3cf$export$8793edee2d425525), onFileRejected: onFileRejected = (0, $0302d50d2b00a3cf$export$8793edee2d425525), onDragEnter: onDragEnter = (0, $0302d50d2b00a3cf$export$8793edee2d425525), onDragLeave: onDragLeave = (0, $0302d50d2b00a3cf$export$8793edee2d425525) } = callbacks;
    const [targetNode, setTargetNode] = (0, $5NSbj.useState)(null);
    const freshOnDrop = $875b08fe0af98e08$export$b3553245f2c17524(onDrop);
    const freshOnFileAccepted = $875b08fe0af98e08$export$b3553245f2c17524(onFileAccepted);
    const freshOnFileRejected = $875b08fe0af98e08$export$b3553245f2c17524(onFileRejected);
    const freshOnDragEnter = $875b08fe0af98e08$export$b3553245f2c17524(onDragEnter);
    const freshOnDragLeave = $875b08fe0af98e08$export$b3553245f2c17524(onDragLeave);
    const fileIsValid = (0, $5NSbj.useCallback)((file)=>{
        if (accept && !accept.includes(file.type)) return {
            valid: false,
            reason: "File type not allowed"
        };
        if (maxFileSize !== void 0 && file.size > maxFileSize) return {
            valid: false,
            reason: "File size exceeds the limit"
        };
        return {
            valid: true
        };
    }, [
        accept,
        maxFileSize
    ]);
    const handleDrop = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        const files = Array.from(event.dataTransfer?.files || []);
        const acceptedFiles = [];
        const rejectedFiles = [];
        if (maxFiles !== void 0 && files.length > maxFiles) for (const file of files){
            rejectedFiles.push(file);
            freshOnFileRejected(file, "Exceeded maximum number of files");
        }
        else files.forEach((file)=>{
            const validationResult = fileIsValid(file);
            if (validationResult.valid) {
                acceptedFiles.push(file);
                freshOnFileAccepted(file);
            } else {
                rejectedFiles.push(file);
                freshOnFileRejected(file, validationResult.reason || "Unknown reason");
            }
        });
        freshOnDrop(acceptedFiles, rejectedFiles);
    }, [
        fileIsValid,
        freshOnFileAccepted,
        freshOnFileRejected,
        maxFiles,
        freshOnDrop
    ]);
    const handleDragOver = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    (0, $5NSbj.useEffect)(()=>{
        if (targetNode) {
            targetNode.addEventListener("drop", handleDrop);
            targetNode.addEventListener("dragover", handleDragOver);
            targetNode.addEventListener("dragenter", freshOnDragEnter);
            targetNode.addEventListener("dragleave", freshOnDragLeave);
            return ()=>{
                targetNode.removeEventListener("drop", handleDrop);
                targetNode.removeEventListener("dragover", handleDragOver);
                targetNode.removeEventListener("dragenter", freshOnDragEnter);
                targetNode.removeEventListener("dragleave", freshOnDragLeave);
            };
        } else return ()=>{};
    }, [
        targetNode,
        handleDrop,
        handleDragOver,
        freshOnDragEnter,
        freshOnDragLeave
    ]);
    return (0, $5NSbj.useCallback)((node)=>{
        setTargetNode(node);
    }, []);
}
// src/hooks/useFreshTick.ts
function $875b08fe0af98e08$export$699327ecb1dd6b0d(callback) {
    const freshRef = (0, $0302d50d2b00a3cf$export$38e1734badfda8d9)(callback);
    function tick(...args) {
        if (typeof freshRef.current === "function") freshRef.current(...args);
    }
    return tick;
}
var $875b08fe0af98e08$var$FullscreenApi = {
    DOM_UNAVAILABLE_ERROR: "DOM is unavailable server-side. Please use this method client-side only.",
    FULLSCREEN_UNSUPPORTED_ERROR: "Your browser does not support Fullscreen API.",
    getEventsNames () {
        if (typeof document === "undefined") return null;
        const _document = document;
        if ("exitFullscreen" in _document) return [
            "fullscreenchange",
            "fullscreenerror"
        ];
        if ("webkitExitFullscreen" in _document) return [
            "webkitfullscreenchange",
            "webkitfullscreenerror"
        ];
        if ("webkitCancelFullScreen" in _document) return [
            "webkitfullscreenchange",
            "webkitfullscreenerror"
        ];
        if ("mozCancelFullScreen" in _document) return [
            "mozfullscreenchange",
            "mozfullscreenerror"
        ];
        if ("msExitFullscreen" in _document) return [
            "MSFullscreenChange",
            "MSFullscreenError"
        ];
        return null;
    },
    getEventName (eventType) {
        const eventsNames = this.getEventsNames();
        if (!eventsNames) return null;
        if (eventType === "change") return eventsNames[0];
        return eventsNames[1];
    },
    get fullscreenEnabled () {
        if (typeof document === "undefined") return false;
        const _document = document;
        return _document.fullscreenEnabled || _document.webkitFullscreenEnabled || !!_document.webkitCancelFullScreen || _document.mozFullScreenEnabled || _document.msFullscreenEnabled || false;
    },
    get fullscreenElement () {
        if (typeof document === "undefined") return null;
        const _document = document;
        return _document.fullscreenElement || _document.webkitFullscreenElement || _document.webkitCurrentFullScreenElement || _document.mozFullScreenElement || _document.msFullscreenElement || null;
    },
    requestFullscreen (element, options) {
        if (typeof document === "undefined") throw new Error(this.DOM_UNAVAILABLE_ERROR);
        const target = element ?? document.documentElement;
        const method = target.requestFullscreen || target.webkitRequestFullscreen || target.webkitRequestFullScreen || target.mozRequestFullScreen || target.msRequestFullscreen;
        if (!method) throw new Error(this.FULLSCREEN_UNSUPPORTED_ERROR);
        return method.call(target, options);
    },
    exitFullscreen () {
        if (typeof document === "undefined") throw new Error(this.DOM_UNAVAILABLE_ERROR);
        const _document = document;
        const method = _document.exitFullscreen || _document.webkitExitFullscreen || _document.webkitCancelFullScreen || _document.mozCancelFullScreen || _document.msExitFullscreen;
        if (!method) throw new Error(this.FULLSCREEN_UNSUPPORTED_ERROR);
        return method.call(_document);
    },
    on (eventType, callback) {
        const eventName = this.getEventName(eventType);
        if (!eventName) return;
        document.addEventListener(eventName, callback);
    },
    off (eventType, callback) {
        const eventName = this.getEventName(eventType);
        if (!eventName) return;
        document.removeEventListener(eventName, callback);
    }
};
function $875b08fe0af98e08$export$873ff9d3a24fe223(props = {}) {
    const { target: target, onChange: onChange, onError: onError, requestFullScreenOptions: requestFullScreenOptions } = props;
    const [isFullscreenAvailable, setIsFullscreenAvailable] = (0, $5NSbj.useState)(false);
    const [fullscreenElement, setFullscreenElement] = (0, $5NSbj.useState)(null);
    const [isFullscreenEnabled, setIsFullscreenEnabled] = (0, $5NSbj.useState)(false);
    const enableFullscreen = (0, $5NSbj.useCallback)(()=>{
        return $875b08fe0af98e08$var$FullscreenApi.requestFullscreen(target?.current || null, requestFullScreenOptions);
    }, [
        target,
        requestFullScreenOptions
    ]);
    const disableFullscreen = (0, $5NSbj.useCallback)(()=>{
        return $875b08fe0af98e08$var$FullscreenApi.exitFullscreen();
    }, []);
    const toggleFullscreen = (0, $5NSbj.useCallback)(()=>{
        if ($875b08fe0af98e08$var$FullscreenApi.fullscreenElement) return disableFullscreen();
        return enableFullscreen();
    }, [
        enableFullscreen,
        disableFullscreen
    ]);
    const onChangeHandler = (0, $5NSbj.useCallback)((event)=>{
        const fullscreenElement2 = $875b08fe0af98e08$var$FullscreenApi.fullscreenElement;
        setFullscreenElement(fullscreenElement2);
        setIsFullscreenEnabled(!!fullscreenElement2);
        onChange?.(event);
    }, [
        onChange
    ]);
    const onErrorHandler = (0, $5NSbj.useCallback)((event)=>{
        const fullscreenElement2 = $875b08fe0af98e08$var$FullscreenApi.fullscreenElement;
        setFullscreenElement(fullscreenElement2);
        setIsFullscreenEnabled(!!fullscreenElement2);
        onError?.(event);
    }, [
        onError
    ]);
    (0, $5NSbj.useEffect)(()=>{
        setIsFullscreenAvailable($875b08fe0af98e08$var$FullscreenApi.fullscreenEnabled);
    }, []);
    (0, $5NSbj.useEffect)(()=>{
        $875b08fe0af98e08$var$FullscreenApi.on("change", onChangeHandler);
        $875b08fe0af98e08$var$FullscreenApi.on("error", onErrorHandler);
        return ()=>{
            $875b08fe0af98e08$var$FullscreenApi.off("change", onChangeHandler);
            $875b08fe0af98e08$var$FullscreenApi.off("error", onErrorHandler);
        };
    }, [
        onChangeHandler,
        onErrorHandler
    ]);
    return {
        isFullscreenAvailable: isFullscreenAvailable,
        fullscreenElement: fullscreenElement,
        isFullscreenEnabled: isFullscreenEnabled,
        enableFullscreen: enableFullscreen,
        disableFullscreen: disableFullscreen,
        toggleFullscreen: toggleFullscreen
    };
}
var $875b08fe0af98e08$export$f8168d8dd8fd66e6 = (props)=>{
    const { onBlur: propsOnBlur, onFocus: propsOnFocus, onFocusChange: propsOnFocusChange } = props;
    const onBlur = (0, $5NSbj.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (propsOnBlur) propsOnBlur(e);
            if (propsOnFocusChange) propsOnFocusChange(false);
        }
    }, [
        propsOnBlur,
        propsOnFocusChange
    ]);
    const onFocus = (0, $5NSbj.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (propsOnFocus) propsOnFocus(e);
            if (propsOnFocusChange) propsOnFocusChange(true);
        }
    }, [
        propsOnFocusChange,
        propsOnFocus
    ]);
    return {
        focusProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
};
var $875b08fe0af98e08$export$420e68273165f4ec = (props)=>{
    const { onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    const state = (0, $5NSbj.useRef)({
        isFocusWithin: false
    });
    const onBlur = (0, $5NSbj.useCallback)((e)=>{
        const isFocusMovingWithin = e.relatedTarget instanceof Node && e.currentTarget.contains(e.relatedTarget);
        if (state.current.isFocusWithin && !isFocusMovingWithin) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange
    ]);
    const onFocus = (0, $5NSbj.useCallback)((e)=>{
        if (!state.current.isFocusWithin) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
        }
    }, [
        onFocusWithin,
        onFocusWithinChange
    ]);
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
};
function $875b08fe0af98e08$export$606f11b2eb45ecc6({ initialValues: initialValues, validate: validate, onSubmit: onSubmit }) {
    const [values, setValues] = (0, $5NSbj.useState)(initialValues);
    const [errors, setErrors] = (0, $5NSbj.useState)({});
    const [touched, setTouched] = (0, $5NSbj.useState)({});
    const [isSubmitting, setIsSubmitting] = (0, $5NSbj.useState)(false);
    const validateField = (0, $5NSbj.useCallback)((name, value)=>{
        if (validate) return validate(name, value, values);
        return void 0;
    }, [
        validate,
        values
    ]);
    const validateForm = (0, $5NSbj.useCallback)(()=>{
        if (!validate) return true;
        const newErrors = {};
        let isValid2 = true;
        for(const key in values){
            const error = validate(key, values[key], values);
            if (error) {
                newErrors[key] = error;
                isValid2 = false;
            }
        }
        setErrors(newErrors);
        return isValid2;
    }, [
        validate,
        values
    ]);
    const isValid = Object.keys(errors).length === 0;
    const handleChange = (0, $5NSbj.useCallback)((event)=>{
        const { name: name, value: value, type: type } = event.target;
        const fieldName = name;
        const fieldValue = type === "checkbox" ? event.target.checked : value;
        setValues((prev)=>({
                ...prev,
                [fieldName]: fieldValue
            }));
        setTouched((prev)=>({
                ...prev,
                [fieldName]: true
            }));
        const error = validateField(fieldName, fieldValue);
        setErrors((prev)=>{
            const newErrors = {
                ...prev
            };
            if (error) newErrors[fieldName] = error;
            else delete newErrors[fieldName];
            return newErrors;
        });
    }, [
        validateField
    ]);
    const handleSubmit = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        const allTouched = {};
        for(const key in values)allTouched[key] = true;
        setTouched(allTouched);
        const formIsValid = validateForm();
        if (formIsValid && onSubmit) {
            setIsSubmitting(true);
            Promise.resolve(onSubmit(values)).finally(()=>{
                setIsSubmitting(false);
            });
        }
    }, [
        values,
        validateForm,
        onSubmit
    ]);
    const setFieldValue = (0, $5NSbj.useCallback)((name, value)=>{
        setValues((prev)=>({
                ...prev,
                [name]: value
            }));
    }, []);
    const setFieldError = (0, $5NSbj.useCallback)((name, error)=>{
        setErrors((prev)=>({
                ...prev,
                [name]: error
            }));
    }, []);
    const setFieldTouched = (0, $5NSbj.useCallback)((name, isTouched)=>{
        setTouched((prev)=>({
                ...prev,
                [name]: isTouched
            }));
    }, []);
    const reset = (0, $5NSbj.useCallback)(()=>{
        setValues(initialValues);
        setErrors({});
        setTouched({});
        setIsSubmitting(false);
    }, [
        initialValues
    ]);
    return {
        values: values,
        errors: errors,
        touched: touched,
        isSubmitting: isSubmitting,
        isValid: isValid,
        handleChange: handleChange,
        handleSubmit: handleSubmit,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        reset: reset
    };
}
function $875b08fe0af98e08$var$getGeoLocation(options) {
    return new Promise((resolve, reject)=>{
        if (navigator.geolocation) navigator.geolocation.getCurrentPosition((position)=>{
            const { coords: coords } = position;
            const { latitude: latitude, longitude: longitude } = coords;
            resolve({
                isError: false,
                lat: latitude,
                lng: longitude,
                message: ""
            });
        }, (error)=>{
            resolve({
                isError: true,
                message: error && typeof error === "object" && "message" in error ? error.message : "Geolocation error"
            });
        }, options);
        else resolve({
            isError: true,
            message: "Geolocation is not supported for this Browser/OS."
        });
    });
}
var $875b08fe0af98e08$var$defaultGeoLocationOptions = {
    enableHighAccuracy: false,
    maximumAge: 0,
    timeout: Number.POSITIVE_INFINITY,
    when: true
};
var $875b08fe0af98e08$export$8c959c84e890409a = (geoLocationOptions = $875b08fe0af98e08$var$defaultGeoLocationOptions)=>{
    const [geoObject, setGeoObject] = (0, $5NSbj.useState)(null);
    const { when: when, enableHighAccuracy: enableHighAccuracy, timeout: timeout, maximumAge: maximumAge } = geoLocationOptions;
    const getIsMounted = $875b08fe0af98e08$export$7aa0022395cd4c49();
    (0, $5NSbj.useEffect)(()=>{
        async function getGeoCode() {
            try {
                const value = await $875b08fe0af98e08$var$getGeoLocation({
                    enableHighAccuracy: enableHighAccuracy,
                    maximumAge: maximumAge,
                    timeout: timeout,
                    when: when
                });
                if (getIsMounted()) setGeoObject(value);
            } catch (error) {
                if (getIsMounted()) setGeoObject({
                    isError: true,
                    message: error instanceof Error ? error.message : String(error)
                });
            }
        }
        if (when) getGeoCode();
    }, [
        when,
        enableHighAccuracy,
        timeout,
        maximumAge,
        getIsMounted
    ]);
    return geoObject;
};
var $875b08fe0af98e08$var$IdlePolyfill = class {
    threshold;
    isIdle = false;
    _userState = "active";
    _screenState = "unlocked";
    listeners = [];
    timeoutId = null;
    started = false;
    constructor(threshold){
        this.threshold = Math.max(threshold, 6e4);
    }
    handleUserActivity = ()=>{
        if (this.isIdle) {
            this.isIdle = false;
            this._userState = "active";
            this.notifyListeners();
        }
        this.resetIdleTimer();
    };
    handleVisibilityChange = ()=>{
        this._screenState = document.hidden ? "locked" : "unlocked";
        this.notifyListeners();
    };
    resetIdleTimer() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
        this.timeoutId = window.setTimeout(()=>{
            this.isIdle = true;
            this._userState = "idle";
            this.notifyListeners();
        }, this.threshold);
    }
    notifyListeners() {
        this.listeners.forEach((listener)=>listener());
    }
    get userState() {
        return this._userState;
    }
    get screenState() {
        return this._screenState;
    }
    get isIdleState() {
        return this.isIdle;
    }
    addEventListener(event, listener) {
        if (event === "change") this.listeners.push(listener);
    }
    removeEventListener(event, listener) {
        if (event === "change") {
            const index = this.listeners.indexOf(listener);
            if (index > -1) this.listeners.splice(index, 1);
        }
    }
    start() {
        if (this.started) return;
        this.started = true;
        const events = [
            "mousemove",
            "keydown",
            "click",
            "scroll",
            "touchstart"
        ];
        events.forEach((event)=>{
            document.addEventListener(event, this.handleUserActivity, true);
        });
        document.addEventListener("visibilitychange", this.handleVisibilityChange);
        this.resetIdleTimer();
    }
    stop() {
        if (!this.started) return;
        this.started = false;
        const events = [
            "mousemove",
            "keydown",
            "click",
            "scroll",
            "touchstart"
        ];
        events.forEach((event)=>{
            document.removeEventListener(event, this.handleUserActivity, true);
        });
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
        this.isIdle = false;
        this._userState = "active";
        this._screenState = "unlocked";
    }
};
function $875b08fe0af98e08$export$8c23cdf9de53b14f(options = {}) {
    const { threshold: threshold = 6e4, autoStart: // Default 60 seconds
    autoStart = false, requestPermission: requestPermission = false, onIdleChange: onIdleChange, onError: onError } = options;
    const [isIdle, setIsIdle] = (0, $5NSbj.useState)(false);
    const [userState, setUserState] = (0, $5NSbj.useState)("active");
    const [screenState, setScreenState] = (0, $5NSbj.useState)("unlocked");
    const [isPermissionGranted, setIsPermissionGranted] = (0, $5NSbj.useState)(false);
    const detectorRef = (0, $5NSbj.useRef)(null);
    const polyfillRef = (0, $5NSbj.useRef)(null);
    const startedRef = (0, $5NSbj.useRef)(false);
    const isSupported = typeof window !== "undefined" && "IdleDetector" in window;
    const actualThreshold = Math.max(threshold, 6e4);
    const handleChange = (0, $5NSbj.useCallback)(()=>{
        const detector = detectorRef.current;
        const polyfill = polyfillRef.current;
        let newIsIdle = false;
        let newUserState = "active";
        let newScreenState = "unlocked";
        if (detector && detector.userState && detector.screenState) {
            newIsIdle = detector.userState === "idle";
            newUserState = detector.userState;
            newScreenState = detector.screenState;
        } else if (polyfill) {
            newIsIdle = polyfill.isIdleState;
            newUserState = polyfill.userState;
            newScreenState = polyfill.screenState;
        }
        setIsIdle(newIsIdle);
        setUserState(newUserState);
        setScreenState(newScreenState);
        onIdleChange?.({
            isIdle: newIsIdle,
            userState: newUserState,
            screenState: newScreenState
        });
    }, [
        onIdleChange
    ]);
    const start = (0, $5NSbj.useCallback)(async ()=>{
        if (startedRef.current) return;
        startedRef.current = true;
        try {
            if (isSupported && window.IdleDetector) {
                const detector = new window.IdleDetector();
                detectorRef.current = detector;
                if (requestPermission) {
                    const permission = await window.IdleDetector.requestPermission();
                    setIsPermissionGranted(permission === "granted");
                    if (permission === "denied") {
                        onError?.(new Error("Permission denied"));
                        return;
                    }
                } else setIsPermissionGranted(true);
                detector.addEventListener("change", handleChange);
                await detector.start({
                    threshold: actualThreshold
                });
            } else {
                const polyfill = new $875b08fe0af98e08$var$IdlePolyfill(actualThreshold);
                polyfillRef.current = polyfill;
                polyfill.addEventListener("change", handleChange);
                polyfill.start();
                setIsPermissionGranted(true);
            }
        } catch (error) {
            onError?.(error instanceof Error ? error : new Error("Failed to start idle detection"));
        }
    }, [
        isSupported,
        requestPermission,
        actualThreshold,
        handleChange,
        onError
    ]);
    const stop = (0, $5NSbj.useCallback)(()=>{
        if (!startedRef.current) return;
        startedRef.current = false;
        if (detectorRef.current) {
            detectorRef.current.removeEventListener("change", handleChange);
            detectorRef.current = null;
        }
        if (polyfillRef.current) {
            polyfillRef.current.removeEventListener("change", handleChange);
            polyfillRef.current.stop();
            polyfillRef.current = null;
        }
        setIsIdle(false);
        setUserState("active");
        setScreenState("unlocked");
    }, [
        handleChange
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (autoStart && !startedRef.current) start();
    }, [
        autoStart,
        start
    ]);
    (0, $5NSbj.useEffect)(()=>{
        return ()=>{
            stop();
        };
    }, [
        stop
    ]);
    return {
        isIdle: isIdle,
        userState: userState,
        screenState: screenState,
        isSupported: isSupported,
        isPermissionGranted: isPermissionGranted,
        start: start,
        stop: stop
    };
}
var $875b08fe0af98e08$var$defaultOptions = {};
function $875b08fe0af98e08$export$1e36b9f257eee5fa(initialValue = "", options = $875b08fe0af98e08$var$defaultOptions) {
    const [value, setValue] = (0, $5NSbj.useState)(initialValue);
    const onChange = (0, $5NSbj.useCallback)((event)=>{
        const newValue = event.target.value;
        let shouldUpdate = true;
        if (typeof options.validate === "function") shouldUpdate = options.validate(newValue, value);
        if (shouldUpdate) setValue(newValue);
    }, [
        options,
        value
    ]);
    (0, $5NSbj.useEffect)(()=>{
        setValue(initialValue);
    }, [
        initialValue
    ]);
    const handler = {
        onChange: onChange,
        value: value
    };
    return handler;
}
var $875b08fe0af98e08$var$defaultMeasurements = {
    innerWidth: 0,
    innerHeight: 0,
    innerScrollWidth: 0,
    innerScrollHeight: 0,
    outerWidth: 0,
    outerHeight: 0,
    outerScrollWidth: 0,
    outerScrollHeight: 0
};
function $875b08fe0af98e08$var$getMeasurements(element) {
    return {
        innerWidth: element.clientWidth,
        innerHeight: element.clientHeight,
        innerScrollWidth: element.scrollWidth,
        innerScrollHeight: element.scrollHeight,
        outerWidth: element.offsetWidth,
        outerHeight: element.offsetHeight,
        outerScrollWidth: element.scrollWidth,
        outerScrollHeight: element.scrollHeight
    };
}
function $875b08fe0af98e08$export$e295b0c537d32d7d(options = {}) {
    const { debounce: debounce2 = 0, disabled: disabled = false, onMeasure: onMeasure } = options;
    const [node, setNode] = (0, $5NSbj.useState)(null);
    const [measurements, setMeasurements] = (0, $5NSbj.useState)($875b08fe0af98e08$var$defaultMeasurements);
    const onMeasureRef = (0, $5NSbj.useRef)(onMeasure);
    const resizeObserverRef = (0, $5NSbj.useRef)(null);
    (0, $5NSbj.useEffect)(()=>{
        onMeasureRef.current = onMeasure;
    });
    const measure = (0, $5NSbj.useCallback)(()=>{
        if (!node || disabled) return;
        const newMeasurements = $875b08fe0af98e08$var$getMeasurements(node);
        setMeasurements(newMeasurements);
        if (onMeasureRef.current) onMeasureRef.current(newMeasurements);
    }, [
        node,
        disabled
    ]);
    const [debouncedMeasure] = $875b08fe0af98e08$export$ddf8f1aa96b8ea88(measure, debounce2, {
        leading: false,
        trailing: true
    });
    const measureFunction = debounce2 > 0 ? debouncedMeasure : measure;
    const handleResizeObserver = (0, $5NSbj.useCallback)(()=>{
        measureFunction();
    }, [
        measureFunction
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (!node || disabled) {
            if (resizeObserverRef.current) {
                resizeObserverRef.current.disconnect();
                resizeObserverRef.current = null;
            }
            return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
        }
        if (typeof ResizeObserver === "undefined") {
            console.warn("useMeasure: ResizeObserver is not available in this environment");
            return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
        }
        const observer = new ResizeObserver(handleResizeObserver);
        resizeObserverRef.current = observer;
        observer.observe(node, {
            box: "content-box"
        });
        measureFunction();
        return ()=>{
            observer.disconnect();
            resizeObserverRef.current = null;
        };
    }, [
        node,
        disabled,
        handleResizeObserver,
        measureFunction
    ]);
    const ref = (0, $5NSbj.useCallback)((element)=>{
        setNode(element);
    }, []);
    (0, $5NSbj.useEffect)(()=>{
        if (typeof window === "undefined") console.warn("useMeasure: window is undefined (SSR environment)");
    }, []);
    return [
        ref,
        measurements
    ];
}
var $875b08fe0af98e08$var$config3 = {
    root: null,
    rootMargin: "0px 0px 0px 0px",
    threshold: [
        0,
        1
    ]
};
function $875b08fe0af98e08$export$44b5bb7485b3d5ca(callback, options = $875b08fe0af98e08$var$config3) {
    const { root: root = null, rootMargin: rootMargin, threshold: threshold } = options;
    const [node, setNode] = (0, $5NSbj.useState)(null);
    const callbackRef = (0, $5NSbj.useRef)(callback);
    (0, $5NSbj.useEffect)(()=>{
        callbackRef.current = callback;
    });
    const handleIntersectionObserver = (0, $5NSbj.useCallback)((...args)=>{
        return callbackRef.current?.(...args);
    }, []);
    (0, $5NSbj.useEffect)(()=>{
        if (node) {
            const observer = new IntersectionObserver(handleIntersectionObserver, {
                root: root,
                rootMargin: rootMargin,
                threshold: threshold
            });
            observer.observe(node);
            return ()=>{
                observer.disconnect();
            };
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        node,
        handleIntersectionObserver,
        root,
        rootMargin,
        threshold
    ]);
    const ref = (0, $5NSbj.useCallback)((nodeElement)=>{
        setNode(nodeElement);
    }, []);
    return [
        ref
    ];
}
var $875b08fe0af98e08$var$config4 = {
    root: null,
    rootMargin: "0px 0px 0px 0px",
    threshold: [
        0,
        1
    ]
};
function $875b08fe0af98e08$export$14734974288d5830(callbackOrOptions, options) {
    const callback = typeof callbackOrOptions === "function" ? callbackOrOptions : (0, $0302d50d2b00a3cf$export$8793edee2d425525);
    const opts = typeof callbackOrOptions === "object" ? callbackOrOptions : options || $875b08fe0af98e08$var$config4;
    const { root: root = null, rootMargin: rootMargin, threshold: threshold } = opts;
    const [node, setNode] = (0, $5NSbj.useState)(null);
    const [inView, setInView] = (0, $5NSbj.useState)(false);
    (0, $5NSbj.useEffect)(()=>{
        if (node) {
            const observer = new IntersectionObserver((entries, observerRef)=>{
                for (const { isIntersecting: isIntersecting } of entries)setInView(isIntersecting);
                callback(entries, observerRef);
            }, opts);
            observer.observe(node);
            return ()=>{
                observer.disconnect();
            };
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        node,
        callback,
        root,
        rootMargin,
        threshold,
        opts
    ]);
    const ref = (0, $5NSbj.useCallback)((nodeElement)=>{
        setNode(nodeElement);
    }, []);
    return [
        ref,
        inView
    ];
}
function $875b08fe0af98e08$export$a70fb0bde1aaaf0d(isTargetWindow = false) {
    const [targetNode, setTargetNode] = (0, $5NSbj.useState)(null);
    const ref = (0, $5NSbj.useCallback)((node)=>{
        setTargetNode(node);
    }, []);
    const [isDroppingFiles, setIsDroppingFiles] = (0, $5NSbj.useState)(false);
    const handleDragEnter = (0, $5NSbj.useCallback)((e)=>{
        e.preventDefault();
        if (e.dataTransfer?.types.includes("Files")) {
            if (!isDroppingFiles) setIsDroppingFiles(true);
        } else setIsDroppingFiles(false);
    }, [
        isDroppingFiles
    ]);
    const handleDragOver = (0, $5NSbj.useCallback)((e)=>{
        e.preventDefault();
        if (e.dataTransfer?.types.includes("Files")) {
            if (!isDroppingFiles) setIsDroppingFiles(true);
        } else setIsDroppingFiles(false);
    }, [
        isDroppingFiles
    ]);
    const handleDragLeave = (0, $5NSbj.useCallback)((e)=>{
        e.preventDefault();
        setIsDroppingFiles(false);
    }, []);
    const handleDrop = (0, $5NSbj.useCallback)((e)=>{
        e.preventDefault();
        setIsDroppingFiles(false);
    }, []);
    const freshHandleDragEnter = $875b08fe0af98e08$export$b3553245f2c17524(handleDragEnter);
    const freshHandleDragOver = $875b08fe0af98e08$export$b3553245f2c17524(handleDragOver);
    const freshHandleDragLeave = $875b08fe0af98e08$export$b3553245f2c17524(handleDragLeave);
    const freshHandleDrop = $875b08fe0af98e08$export$b3553245f2c17524(handleDrop);
    (0, $5NSbj.useEffect)(()=>{
        const target = isTargetWindow ? window : targetNode;
        if (target) {
            target.addEventListener("dragenter", freshHandleDragEnter);
            target.addEventListener("dragover", freshHandleDragOver);
            target.addEventListener("dragleave", freshHandleDragLeave);
            target.addEventListener("drop", freshHandleDrop);
        }
        return ()=>{
            if (target) {
                target.removeEventListener("dragenter", freshHandleDragEnter);
                target.removeEventListener("dragover", freshHandleDragOver);
                target.removeEventListener("dragleave", freshHandleDragLeave);
                target.removeEventListener("drop", freshHandleDrop);
            }
        };
    }, [
        freshHandleDragEnter,
        freshHandleDragLeave,
        freshHandleDragOver,
        freshHandleDrop,
        isDroppingFiles,
        isTargetWindow,
        targetNode
    ]);
    if (isTargetWindow) return isDroppingFiles;
    return [
        ref,
        isDroppingFiles
    ];
}
var $875b08fe0af98e08$var$defaultOptions2 = {
    eventTypes: [
        "keydown"
    ],
    when: true
};
function $875b08fe0af98e08$export$a41bc8a5485cb6b(keys, callback, options) {
    const keyList = (0, $5NSbj.useMemo)(()=>{
        if (Array.isArray(keys)) return keys;
        else return [
            keys
        ];
    }, [
        keys
    ]);
    const internalOptions = (0, $5NSbj.useMemo)(()=>{
        return {
            ...$875b08fe0af98e08$var$defaultOptions2,
            ...options
        };
    }, [
        options
    ]);
    const { when: when, eventTypes: eventTypes } = internalOptions;
    const callbackRef = (0, $5NSbj.useRef)(callback);
    const { target: target } = internalOptions;
    (0, $5NSbj.useEffect)(()=>{
        callbackRef.current = callback;
    });
    const handle = (0, $5NSbj.useCallback)((event)=>{
        if (keyList.some((identifier)=>(0, $0302d50d2b00a3cf$export$8f5885e0a893ee67)(event, identifier))) callbackRef.current(event);
    }, [
        keyList
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (when && typeof window !== "undefined") {
            if (target) {
                const targetNode = target.current;
                if (targetNode) {
                    for (const eventType of eventTypes)targetNode.addEventListener(eventType, handle);
                    return ()=>{
                        for (const eventType of eventTypes)targetNode.removeEventListener(eventType, handle);
                    };
                }
            } else {
                for (const eventType of eventTypes)window.addEventListener(eventType, handle);
                return ()=>{
                    for (const eventType of eventTypes)window.removeEventListener(eventType, handle);
                };
            }
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        when,
        eventTypes,
        keyList,
        target,
        callback,
        handle
    ]);
}
// src/hooks/useKeyBindings.ts
var $875b08fe0af98e08$export$40f9c496c4444fe4 = (keyBindings, options)=>{
    for(const key in keyBindings){
        const handler = keyBindings[key];
        if (handler) $875b08fe0af98e08$export$a41bc8a5485cb6b(key, handler, options);
    }
};
var $875b08fe0af98e08$var$defaultOptions3 = {
    eventTypes: [
        "keydown"
    ],
    when: true
};
function $875b08fe0af98e08$export$26675181ca12477d(keys, callback, options) {
    const [targetNode, setTargetNode] = (0, $5NSbj.useState)(null);
    const ref = (0, $5NSbj.useCallback)((node)=>{
        setTargetNode(node);
    }, []);
    const keyList = (0, $5NSbj.useMemo)(()=>{
        if (Array.isArray(keys)) return keys;
        else return [
            keys
        ];
    }, [
        keys
    ]);
    const internalOptions = (0, $5NSbj.useMemo)(()=>{
        return {
            ...$875b08fe0af98e08$var$defaultOptions3,
            ...options
        };
    }, [
        options
    ]);
    const { when: when, eventTypes: eventTypes } = internalOptions;
    const callbackRef = (0, $5NSbj.useRef)(callback);
    (0, $5NSbj.useEffect)(()=>{
        callbackRef.current = callback;
    });
    const handle = (0, $5NSbj.useCallback)((event)=>{
        if (keyList.some((identifier)=>(0, $0302d50d2b00a3cf$export$8f5885e0a893ee67)(event, identifier))) callbackRef.current(event);
    }, [
        keyList
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (when && targetNode) {
            for (const eventType of eventTypes)targetNode.addEventListener(eventType, handle);
            return ()=>{
                for (const eventType of eventTypes)targetNode.removeEventListener(eventType, handle);
            };
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        targetNode,
        when,
        eventTypes,
        keyList,
        handle
    ]);
    return ref;
}
var $875b08fe0af98e08$var$defaultOptions4 = {
    continuous: false,
    when: true
};
function $875b08fe0af98e08$export$2006064841430665(keysList, callback, options) {
    const internalOptions = {
        ...$875b08fe0af98e08$var$defaultOptions4,
        ...options
    };
    const { target: target, when: when, continuous: continuous, preventLostKeyup: preventLostKeyup } = internalOptions;
    const savedCallback = (0, $5NSbj.useRef)(callback);
    const pressedKeyMappingRef = (0, $5NSbj.useRef)({});
    const PressedKeyMapping = pressedKeyMappingRef.current;
    (0, $5NSbj.useEffect)(()=>{
        savedCallback.current = callback;
    });
    const handleKeyDown = (0, $5NSbj.useCallback)((event)=>{
        let pressedKeyIdentifier = null;
        let areAllKeysFromListPressed = false;
        for (const identifier of keysList)if ((0, $0302d50d2b00a3cf$export$8f5885e0a893ee67)(event, identifier)) {
            PressedKeyMapping[identifier] = true;
            pressedKeyIdentifier = identifier;
        }
        if (keysList.every((identifier)=>Boolean(PressedKeyMapping[identifier]))) areAllKeysFromListPressed = true;
        if (areAllKeysFromListPressed) {
            savedCallback.current(event);
            if (!continuous && pressedKeyIdentifier !== null) PressedKeyMapping[pressedKeyIdentifier] = false;
        }
    }, [
        keysList,
        PressedKeyMapping,
        continuous
    ]);
    const handleKeyUp = (0, $5NSbj.useCallback)((event)=>{
        for (const identifier of keysList)if ((0, $0302d50d2b00a3cf$export$8f5885e0a893ee67)(event, identifier)) PressedKeyMapping[identifier] = void 0;
    }, [
        PressedKeyMapping,
        keysList
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (when && typeof window !== "undefined") {
            const targetNode = target?.current ? target.current : document;
            targetNode.addEventListener("keydown", handleKeyDown);
            targetNode.addEventListener("keyup", handleKeyUp);
            return ()=>{
                targetNode.removeEventListener("keydown", handleKeyDown);
                targetNode.removeEventListener("keyup", handleKeyUp);
            };
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        when,
        target,
        keysList,
        handleKeyDown,
        handleKeyUp
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (preventLostKeyup !== true) return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
        if (typeof window !== "undefined") {
            const originalAlert = window.alert;
            window.alert = (message)=>{
                for (const identifier of keysList)PressedKeyMapping[identifier] = void 0;
                return originalAlert(message);
            };
            const originalConfirm = window.confirm;
            window.confirm = (message)=>{
                for (const identifier of keysList)PressedKeyMapping[identifier] = void 0;
                return originalConfirm(message);
            };
            const originalPrompt = window.prompt;
            window.prompt = (message, _default)=>{
                for (const identifier of keysList)PressedKeyMapping[identifier] = void 0;
                return originalPrompt(message, _default);
            };
            return ()=>{
                window.alert = originalAlert;
                window.confirm = originalConfirm;
                window.prompt = originalPrompt;
            };
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        PressedKeyMapping,
        keysList,
        preventLostKeyup
    ]);
}
// src/hooks/useLifecycleLogger.ts
var $875b08fe0af98e08$export$88d6c78aac91ea11 = (componentName = "Component", ...otherArgs)=>{
    $875b08fe0af98e08$export$4984640464733c64(()=>{
        console.log(`${componentName} mounted`, ...otherArgs);
        return ()=>console.log(`${componentName} unmounted`);
    });
    $875b08fe0af98e08$export$e34ed88fef4dc107(()=>{
        console.log(`${componentName} updated`, ...otherArgs);
    });
    $875b08fe0af98e08$export$328d69a66df243d8(()=>{
        console.log(`${componentName} unmounted`);
    });
};
function $875b08fe0af98e08$export$bd4ec12442706c3d(isLocked) {
    (0, $5NSbj.useEffect)(()=>{
        if (isLocked) {
            const originalOverflow = window.getComputedStyle(document.body).overflow;
            document.body.style.overflow = "hidden";
            return ()=>{
                document.body.style.overflow = originalOverflow;
            };
        } else return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        isLocked
    ]);
}
function $875b08fe0af98e08$var$getValueFromLocalStorage(key) {
    try {
        if (typeof localStorage === "undefined") return null;
        const storedValue = localStorage.getItem(key) ?? "null";
        try {
            return JSON.parse(storedValue);
        } catch (error) {
            console.error(error);
            return storedValue;
        }
    } catch (error) {
        console.error(error);
        return null;
    }
}
function $875b08fe0af98e08$var$saveValueToLocalStorage(key, value) {
    try {
        if (typeof localStorage === "undefined") return null;
        if (value === void 0) return localStorage.removeItem(key);
        return localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.error(error);
        return null;
    }
}
function $875b08fe0af98e08$var$initialize(key, initialState) {
    const valueLoadedFromLocalStorage = $875b08fe0af98e08$var$getValueFromLocalStorage(key);
    if (valueLoadedFromLocalStorage === null) return typeof initialState === "function" ? initialState() : initialState;
    else return valueLoadedFromLocalStorage;
}
function $875b08fe0af98e08$export$1ad8e86cf52f97f1(key, initialState) {
    const [value, setValue] = (0, $5NSbj.useState)(()=>$875b08fe0af98e08$var$initialize(key, initialState));
    const [stateKey, setStateKey] = (0, $5NSbj.useState)(key);
    const currentValueRef = (0, $5NSbj.useRef)(value);
    const currentKeyRef = (0, $5NSbj.useRef)(key);
    (0, $5NSbj.useInsertionEffect)(()=>{
        currentValueRef.current = value;
        currentKeyRef.current = key;
    }, [
        key,
        value
    ]);
    if (stateKey !== key) {
        setStateKey(key);
        setValue($875b08fe0af98e08$var$initialize(key, initialState));
    }
    const isUpdateFromCrossDocumentListener = (0, $5NSbj.useRef)(false);
    const isUpdateFromWithinDocumentListener = (0, $5NSbj.useRef)(false);
    const updateSourceKeyRef = (0, $5NSbj.useRef)(null);
    const customEventTypeName = (0, $5NSbj.useMemo)(()=>{
        return `rooks-${key}-localstorage-update`;
    }, [
        key
    ]);
    (0, $5NSbj.useEffect)(()=>{
        const cameFromSynchronizedUpdate = (isUpdateFromCrossDocumentListener.current || isUpdateFromWithinDocumentListener.current) && updateSourceKeyRef.current === key;
        if (!cameFromSynchronizedUpdate) $875b08fe0af98e08$var$saveValueToLocalStorage(key, value);
        isUpdateFromCrossDocumentListener.current = false;
        isUpdateFromWithinDocumentListener.current = false;
        updateSourceKeyRef.current = null;
    }, [
        key,
        value
    ]);
    const listenToCrossDocumentStorageEvents = (0, $5NSbj.useCallback)((event)=>{
        try {
            if (event.storageArea === localStorage && event.key === key) {
                const newValue = JSON.parse(event.newValue ?? "null");
                isUpdateFromCrossDocumentListener.current = true;
                updateSourceKeyRef.current = key;
                currentValueRef.current = newValue;
                setValue((currentValue)=>Object.is(currentValue, newValue) ? currentValue : newValue);
            }
        } catch (error) {
            isUpdateFromCrossDocumentListener.current = false;
            updateSourceKeyRef.current = null;
            console.log(error);
        }
    }, [
        currentValueRef,
        key
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (typeof window !== "undefined") {
            window.addEventListener("storage", listenToCrossDocumentStorageEvents);
            return ()=>{
                window.removeEventListener("storage", listenToCrossDocumentStorageEvents);
            };
        } else {
            console.warn("useLocalstorageState: window is undefined.");
            return ()=>{};
        }
    }, [
        listenToCrossDocumentStorageEvents
    ]);
    const listenToCustomEventWithinDocument = (0, $5NSbj.useCallback)((event)=>{
        try {
            const { newValue: newValue } = event.detail;
            isUpdateFromWithinDocumentListener.current = true;
            updateSourceKeyRef.current = key;
            currentValueRef.current = newValue;
            setValue((currentValue)=>Object.is(currentValue, newValue) ? currentValue : newValue);
        } catch (error) {
            isUpdateFromWithinDocumentListener.current = false;
            updateSourceKeyRef.current = null;
            console.log(error);
        }
    }, [
        currentValueRef,
        key
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (typeof document !== "undefined") {
            document.addEventListener(customEventTypeName, listenToCustomEventWithinDocument);
            return ()=>{
                document.removeEventListener(customEventTypeName, listenToCustomEventWithinDocument);
            };
        } else {
            console.warn("[useLocalstorageState] document is undefined.");
            return ()=>{};
        }
    }, [
        customEventTypeName,
        listenToCustomEventWithinDocument
    ]);
    const broadcastValueWithinDocument = (0, $5NSbj.useCallback)((storageKey, newValue)=>{
        if (typeof document !== "undefined") {
            const event = new CustomEvent(`rooks-${storageKey}-localstorage-update`, {
                detail: {
                    newValue: newValue
                }
            });
            document.dispatchEvent(event);
        } else console.warn("[useLocalstorageState] document is undefined.");
    }, []);
    const set = (0, $5NSbj.useCallback)((newValue)=>{
        const resolvedNewValue = typeof newValue === "function" ? newValue(currentValueRef.current) : newValue;
        const storageKey = currentKeyRef.current;
        isUpdateFromCrossDocumentListener.current = false;
        isUpdateFromWithinDocumentListener.current = true;
        updateSourceKeyRef.current = storageKey;
        currentValueRef.current = resolvedNewValue;
        $875b08fe0af98e08$var$saveValueToLocalStorage(storageKey, resolvedNewValue);
        setValue(resolvedNewValue);
        broadcastValueWithinDocument(storageKey, resolvedNewValue);
    }, [
        broadcastValueWithinDocument,
        currentKeyRef,
        currentValueRef
    ]);
    const remove = (0, $5NSbj.useCallback)(()=>{
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error(error);
        }
    }, [
        key
    ]);
    return [
        value,
        set,
        remove
    ];
}
function $875b08fe0af98e08$export$1c18f7df404570ad(initialMapState) {
    const [map, setMap] = (0, $5NSbj.useState)(initialMapState || /* @__PURE__ */ new Map());
    const set = (0, $5NSbj.useCallback)((key, value)=>{
        setMap((prevMap)=>new Map(prevMap.set(key, value)));
    }, []);
    const setMultiple = (0, $5NSbj.useCallback)((entries)=>{
        setMap((prevMap)=>{
            const newMap = new Map(prevMap);
            entries.forEach(([key, value])=>{
                newMap.set(key, value);
            });
            return newMap;
        });
    }, []);
    const remove = (0, $5NSbj.useCallback)((key)=>{
        setMap((prevMap)=>{
            const newMap = new Map(prevMap);
            newMap.delete(key);
            return newMap;
        });
    }, []);
    const removeMultiple = (0, $5NSbj.useCallback)((keys)=>{
        setMap((prevMap)=>{
            const newMap = new Map(prevMap);
            keys.forEach((key)=>{
                newMap.delete(key);
            });
            return newMap;
        });
    }, []);
    const clear = (0, $5NSbj.useCallback)(()=>{
        setMap(/* @__PURE__ */ new Map());
    }, []);
    const has = (0, $5NSbj.useCallback)((key)=>{
        return map.has(key);
    }, [
        map
    ]);
    const hasSome = (0, $5NSbj.useCallback)((keys)=>{
        return keys.some((key)=>map.has(key));
    }, [
        map
    ]);
    const hasEvery = (0, $5NSbj.useCallback)((keys)=>{
        return keys.every((key)=>map.has(key));
    }, [
        map
    ]);
    const get = (0, $5NSbj.useCallback)((key)=>{
        return map.get(key);
    }, [
        map
    ]);
    const size = (0, $5NSbj.useCallback)(()=>{
        return map.size;
    }, [
        map
    ]);
    const controls = {
        set: set,
        remove: remove,
        clear: clear,
        has: has,
        get: get,
        size: size,
        setMultiple: setMultiple,
        removeMultiple: removeMultiple,
        hasSome: hasSome,
        hasEvery: hasEvery
    };
    return [
        map,
        controls
    ];
}
function $875b08fe0af98e08$export$b1eecdc553bff745(query, defaultServerRenderedValue = false) {
    const subscribe3 = (0, $5NSbj.useCallback)((onStoreChange)=>{
        const mediaQueryList = window.matchMedia(query);
        mediaQueryList.addEventListener("change", onStoreChange);
        return ()=>mediaQueryList.removeEventListener("change", onStoreChange);
    }, [
        query
    ]);
    const getSnapshot2 = (0, $5NSbj.useCallback)(()=>{
        return window.matchMedia(query).matches;
    }, [
        query
    ]);
    const getServerSnapshot = (0, $5NSbj.useCallback)(()=>defaultServerRenderedValue, [
        defaultServerRenderedValue
    ]);
    return (0, $5NSbj.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
}
function $875b08fe0af98e08$export$75af6b43202b4fc9(stream, options = {}) {
    const [recordingState, setRecordingState] = (0, $5NSbj.useState)("idle");
    const [data, setData] = (0, $5NSbj.useState)(null);
    const [dataUrl, setDataUrl] = (0, $5NSbj.useState)(null);
    const [error, setError] = (0, $5NSbj.useState)(null);
    const mediaRecorderRef = (0, $5NSbj.useRef)(null);
    const chunksRef = (0, $5NSbj.useRef)([]);
    const isSupported = typeof window !== "undefined" && "MediaRecorder" in window;
    const stableOptions = (0, $5NSbj.useMemo)(()=>options, [
        JSON.stringify(options)
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (!isSupported || !stream) return;
        try {
            const mediaRecorder = new MediaRecorder(stream, stableOptions);
            mediaRecorderRef.current = mediaRecorder;
            mediaRecorder.ondataavailable = (event)=>{
                if (event.data.size > 0) chunksRef.current.push(event.data);
            };
            mediaRecorder.onstop = ()=>{
                const blob = new Blob(chunksRef.current, {
                    type: options.mimeType || "video/webm"
                });
                setData(blob);
                setDataUrl(URL.createObjectURL(blob));
                setRecordingState("stopped");
                chunksRef.current = [];
            };
            mediaRecorder.onerror = (event)=>{
                const err = new Error(`MediaRecorder error: ${event.error?.message || "Unknown error"}`);
                setError(err);
                setRecordingState("idle");
            };
            return ()=>{
                if (mediaRecorder.state !== "inactive") mediaRecorder.stop();
            };
        } catch (err) {
            const error2 = err instanceof Error ? err : new Error("Failed to create MediaRecorder");
            setError(error2);
        }
    }, [
        stream,
        stableOptions,
        isSupported
    ]);
    const startRecording = (0, $5NSbj.useCallback)(()=>{
        if (!isSupported) {
            const err = new Error("MediaRecorder is not supported");
            setError(err);
            return;
        }
        if (!mediaRecorderRef.current) {
            const err = new Error("MediaRecorder not initialized");
            setError(err);
            return;
        }
        try {
            chunksRef.current = [];
            setData(null);
            setDataUrl(null);
            setError(null);
            mediaRecorderRef.current.start();
            setRecordingState("recording");
        } catch (err) {
            const error2 = err instanceof Error ? err : new Error("Failed to start recording");
            setError(error2);
        }
    }, [
        isSupported
    ]);
    const stopRecording = (0, $5NSbj.useCallback)(()=>{
        if (mediaRecorderRef.current && recordingState !== "idle") try {
            mediaRecorderRef.current.stop();
        } catch (err) {
            const error2 = err instanceof Error ? err : new Error("Failed to stop recording");
            setError(error2);
        }
    }, [
        recordingState
    ]);
    const pauseRecording = (0, $5NSbj.useCallback)(()=>{
        if (mediaRecorderRef.current && recordingState === "recording") try {
            mediaRecorderRef.current.pause();
            setRecordingState("paused");
        } catch (err) {
            const error2 = err instanceof Error ? err : new Error("Failed to pause recording");
            setError(error2);
        }
    }, [
        recordingState
    ]);
    const resumeRecording = (0, $5NSbj.useCallback)(()=>{
        if (mediaRecorderRef.current && recordingState === "paused") try {
            mediaRecorderRef.current.resume();
            setRecordingState("recording");
        } catch (err) {
            const error2 = err instanceof Error ? err : new Error("Failed to resume recording");
            setError(error2);
        }
    }, [
        recordingState
    ]);
    (0, $5NSbj.useEffect)(()=>{
        return ()=>{
            if (dataUrl) URL.revokeObjectURL(dataUrl);
        };
    }, [
        dataUrl
    ]);
    return {
        startRecording: startRecording,
        stopRecording: stopRecording,
        pauseRecording: pauseRecording,
        resumeRecording: resumeRecording,
        recordingState: recordingState,
        data: data,
        dataUrl: dataUrl,
        error: error,
        isSupported: isSupported
    };
}
function $875b08fe0af98e08$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $875b08fe0af98e08$export$74665b213cb5c4cf(...refs) {
    return (0, $5NSbj.useMemo)(()=>{
        if (refs.every((ref)=>ref === null)) return null;
        return (refValue)=>{
            for (const ref of refs)$875b08fe0af98e08$var$setRef(ref, refValue);
        };
    }, [
        refs
    ]);
}
var $875b08fe0af98e08$var$initialMouseState = {
    clientX: null,
    clientY: null,
    movementX: null,
    movementY: null,
    offsetX: null,
    offsetY: null,
    pageX: null,
    pageY: null,
    screenX: null,
    screenY: null,
    x: null,
    y: null
};
function $875b08fe0af98e08$var$getMousePositionFromEvent(event) {
    const { screenX: screenX, screenY: screenY, movementX: movementX, movementY: movementY, pageX: pageX, pageY: pageY, clientX: clientX, clientY: clientY, offsetX: offsetX, offsetY: offsetY } = event;
    return {
        clientX: clientX,
        clientY: clientY,
        movementX: movementX,
        movementY: movementY,
        offsetX: offsetX,
        offsetY: offsetY,
        pageX: pageX,
        pageY: pageY,
        screenX: screenX,
        screenY: screenY,
        x: screenX,
        y: screenY
    };
}
function $875b08fe0af98e08$export$70811b4970b0f258() {
    const cacheRef = (0, $5NSbj.useRef)($875b08fe0af98e08$var$initialMouseState);
    const subscribe3 = (0, $5NSbj.useCallback)((onStoreChange)=>{
        const handleMouseMove = (event)=>{
            cacheRef.current = $875b08fe0af98e08$var$getMousePositionFromEvent(event);
            onStoreChange();
        };
        document.addEventListener("mousemove", handleMouseMove);
        return ()=>{
            document.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);
    const getSnapshot2 = (0, $5NSbj.useCallback)(()=>{
        return cacheRef.current;
    }, []);
    const getServerSnapshot = (0, $5NSbj.useCallback)(()=>{
        return $875b08fe0af98e08$var$initialMouseState;
    }, []);
    return (0, $5NSbj.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
}
var $875b08fe0af98e08$var$initialReturnValue = {
    deltaX: 0,
    deltaY: 0,
    velocityX: 0,
    velocityY: 0
};
function $875b08fe0af98e08$export$7b61ea4399b4754c() {
    const stateRef = (0, $5NSbj.useRef)({
        deltaX: 0,
        deltaY: 0,
        clientX: null,
        clientY: null,
        velocityX: 0,
        velocityY: 0,
        timeStamp: Date.now()
    });
    const returnValueRef = (0, $5NSbj.useRef)($875b08fe0af98e08$var$initialReturnValue);
    const subscribe3 = (0, $5NSbj.useCallback)((onStoreChange)=>{
        const handleMouseMove = (event)=>{
            const currentTimestamp = event.timeStamp;
            const lastState = stateRef.current;
            if (lastState.clientX !== null && lastState.clientY !== null) {
                const deltaX = event.clientX - lastState.clientX;
                const deltaY = event.clientY - lastState.clientY;
                const timeDelta = currentTimestamp - lastState.timeStamp;
                const velocityX = timeDelta === 0 ? 0 : deltaX / timeDelta;
                const velocityY = timeDelta === 0 ? 0 : deltaY / timeDelta;
                stateRef.current = {
                    deltaX: deltaX,
                    deltaY: deltaY,
                    clientX: event.clientX,
                    clientY: event.clientY,
                    velocityX: velocityX,
                    velocityY: velocityY,
                    timeStamp: currentTimestamp
                };
                returnValueRef.current = {
                    deltaX: deltaX,
                    deltaY: deltaY,
                    velocityX: velocityX,
                    velocityY: velocityY
                };
            } else {
                stateRef.current = {
                    deltaX: 0,
                    deltaY: 0,
                    clientX: event.clientX,
                    clientY: event.clientY,
                    velocityX: 0,
                    velocityY: 0,
                    timeStamp: event.timeStamp
                };
                returnValueRef.current = {
                    deltaX: 0,
                    deltaY: 0,
                    velocityX: 0,
                    velocityY: 0
                };
            }
            onStoreChange();
        };
        document.addEventListener("mousemove", handleMouseMove, {
            passive: true
        });
        return ()=>{
            document.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);
    const getSnapshot2 = (0, $5NSbj.useCallback)(()=>{
        return returnValueRef.current;
    }, []);
    const getServerSnapshot = (0, $5NSbj.useCallback)(()=>{
        return $875b08fe0af98e08$var$initialReturnValue;
    }, []);
    return (0, $5NSbj.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
}
var $875b08fe0af98e08$var$initialReturnValue2 = {
    delta: 0,
    velocity: 0
};
function $875b08fe0af98e08$export$145b759060b8fae5() {
    const stateRef = (0, $5NSbj.useRef)(null);
    const returnValueRef = (0, $5NSbj.useRef)($875b08fe0af98e08$var$initialReturnValue2);
    const subscribe3 = (0, $5NSbj.useCallback)((onStoreChange)=>{
        const handleWheel = (event)=>{
            const currentTimestamp = event.timeStamp;
            const lastState = stateRef.current;
            if (lastState !== null) {
                const delta = event.deltaY;
                const timeDelta = currentTimestamp - lastState.timeStamp;
                const velocity = timeDelta === 0 ? 0 : delta / timeDelta;
                stateRef.current = {
                    delta: delta,
                    velocity: velocity,
                    timeStamp: currentTimestamp
                };
                returnValueRef.current = {
                    delta: delta,
                    velocity: velocity
                };
            } else {
                stateRef.current = {
                    delta: event.deltaY,
                    velocity: 0,
                    timeStamp: event.timeStamp
                };
                returnValueRef.current = {
                    delta: event.deltaY,
                    velocity: 0
                };
            }
            onStoreChange();
        };
        document.addEventListener("wheel", handleWheel);
        return ()=>{
            document.removeEventListener("wheel", handleWheel);
        };
    }, []);
    const getSnapshot2 = (0, $5NSbj.useCallback)(()=>{
        return returnValueRef.current;
    }, []);
    const getServerSnapshot = (0, $5NSbj.useCallback)(()=>{
        return $875b08fe0af98e08$var$initialReturnValue2;
    }, []);
    return (0, $5NSbj.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
}
function $875b08fe0af98e08$var$warnIfBothValueAndIndexAreProvided(functionName, object) {
    if (Object.values(object).every((value)=>typeof value !== "undefined")) console.warn(`${functionName}. Expected either ${Object.keys(object).join(" or ")} to be provided. However all were provided`);
    else if (Object.values(object).every((value)=>typeof value === "undefined")) console.warn(`${functionName}. ${Object.keys(object).join(" , ")} are all undefined.`);
}
function $875b08fe0af98e08$export$a7f42c7977b517c0(list = [], initialSelectIndices = [
    0
], allowUnselected = false) {
    const [currentIndices, setCurrentIndices] = (0, $5NSbj.useState)(initialSelectIndices);
    const currentValues = currentIndices.map((index)=>list[index]).filter((value)=>value !== void 0);
    const selection = [
        currentIndices,
        currentValues
    ];
    const updateSelections = ({ indices: indices, values: values })=>{
        return ()=>{
            $875b08fe0af98e08$var$warnIfBothValueAndIndexAreProvided("updateSelections", {
                indices: indices,
                values: values
            });
            if (typeof indices !== "undefined") {
                if (!allowUnselected && indices.length === 0) {
                    console.warn(`updateSelections failed. indices is an empty list.`);
                    return;
                }
                setCurrentIndices(indices);
            } else if (typeof values !== "undefined") {
                const valueIndices = list.reduce((accumulator, current, index)=>{
                    if (values.includes(current)) {
                        const array = [
                            ...accumulator,
                            index
                        ];
                        return array;
                    }
                    return accumulator;
                }, []);
                if (valueIndices.length > 0) setCurrentIndices(valueIndices);
                else if (allowUnselected) setCurrentIndices(valueIndices);
                else console.warn(`updateSelections failed. Do the values exist in the list?`);
            }
        };
    };
    const toggleSelectionByIndex = (0, $5NSbj.useCallback)((index)=>{
        let newIndices;
        if (!currentIndices.includes(index)) newIndices = [
            ...currentIndices,
            index
        ];
        else {
            newIndices = [
                ...currentIndices
            ];
            const indexOfIndex = currentIndices.indexOf(index);
            if (indexOfIndex !== -1) newIndices.splice(indexOfIndex, 1);
        }
        if (newIndices.length > 0) setCurrentIndices(newIndices);
        else if (allowUnselected) setCurrentIndices(newIndices);
        else console.warn(`toggleSelection failed. Do the values exist in the list?`);
    }, [
        allowUnselected,
        currentIndices
    ]);
    const toggleSelection = (0, $5NSbj.useCallback)(({ index: index, value: value })=>{
        return ()=>{
            $875b08fe0af98e08$var$warnIfBothValueAndIndexAreProvided("toggleSelection", {
                index: index,
                value: value
            });
            if (typeof index !== "undefined") toggleSelectionByIndex(index);
            else if (typeof value !== "undefined") {
                const valueIndex = list.indexOf(value);
                if (valueIndex > -1) toggleSelectionByIndex(valueIndex);
            }
        };
    }, [
        list,
        toggleSelectionByIndex
    ]);
    const matchSelection = (0, $5NSbj.useCallback)(({ index: index, value: value })=>{
        $875b08fe0af98e08$var$warnIfBothValueAndIndexAreProvided("matchSelection", {
            index: index,
            value: value
        });
        if (typeof index !== "undefined") return currentIndices.includes(index);
        else if (typeof value !== "undefined") return currentValues.includes(value);
        return false;
    }, [
        currentIndices,
        currentValues
    ]);
    const controls = {
        matchSelection: matchSelection,
        toggleSelection: toggleSelection,
        updateSelections: updateSelections
    };
    return [
        selection,
        controls
    ];
}
function $875b08fe0af98e08$var$getLanguageSnapshot() {
    if (typeof navigator !== "undefined") return navigator.language;
    else return null;
}
function $875b08fe0af98e08$var$getLanguageSubscription(callback) {
    if (typeof window !== "undefined") {
        window.addEventListener("languagechange", callback);
        return ()=>{
            window.removeEventListener("languagechange", callback);
        };
    }
    return ()=>{};
}
function $875b08fe0af98e08$var$getLanguageServerSnapshot() {
    return null;
}
function $875b08fe0af98e08$export$64fd3a716d6bb70f() {
    return (0, $5NSbj.useSyncExternalStore)($875b08fe0af98e08$var$getLanguageSubscription, $875b08fe0af98e08$var$getLanguageSnapshot, $875b08fe0af98e08$var$getLanguageServerSnapshot);
}
function $875b08fe0af98e08$var$getConnection() {
    if (typeof navigator === "undefined") return null;
    const nav = navigator;
    return nav.connection || nav.mozConnection || nav.webkitConnection || null;
}
function $875b08fe0af98e08$var$getNetworkInfo() {
    const connection = $875b08fe0af98e08$var$getConnection();
    if (!connection) return {
        type: null,
        effectiveType: null,
        downlink: null,
        downlinkMax: null,
        rtt: null,
        saveData: false
    };
    return {
        type: connection.type || null,
        effectiveType: connection.effectiveType || null,
        downlink: connection.downlink ?? null,
        downlinkMax: connection.downlinkMax ?? null,
        rtt: connection.rtt ?? null,
        saveData: connection.saveData ?? false
    };
}
var $875b08fe0af98e08$var$defaultNetworkInfo = {
    type: null,
    effectiveType: null,
    downlink: null,
    downlinkMax: null,
    rtt: null,
    saveData: false,
    isSupported: false
};
function $875b08fe0af98e08$export$c4fda957ffe4f2ef() {
    const cacheRef = (0, $5NSbj.useRef)($875b08fe0af98e08$var$defaultNetworkInfo);
    const subscribe3 = (0, $5NSbj.useCallback)((onStoreChange)=>{
        const connection = $875b08fe0af98e08$var$getConnection();
        if (!connection) return ()=>{};
        connection.addEventListener("change", onStoreChange);
        return ()=>{
            connection.removeEventListener("change", onStoreChange);
        };
    }, []);
    const getSnapshot2 = (0, $5NSbj.useCallback)(()=>{
        const networkInfo = $875b08fe0af98e08$var$getNetworkInfo();
        const isSupported = $875b08fe0af98e08$var$getConnection() !== null;
        if (cacheRef.current.type !== networkInfo.type || cacheRef.current.effectiveType !== networkInfo.effectiveType || cacheRef.current.downlink !== networkInfo.downlink || cacheRef.current.downlinkMax !== networkInfo.downlinkMax || cacheRef.current.rtt !== networkInfo.rtt || cacheRef.current.saveData !== networkInfo.saveData || cacheRef.current.isSupported !== isSupported) cacheRef.current = {
            ...networkInfo,
            isSupported: isSupported
        };
        return cacheRef.current;
    }, []);
    const getServerSnapshot = (0, $5NSbj.useCallback)(()=>{
        return $875b08fe0af98e08$var$defaultNetworkInfo;
    }, []);
    return (0, $5NSbj.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
}
function $875b08fe0af98e08$export$9949bd9c713ba425() {
    const isSupported = typeof window !== "undefined" && "Notification" in window;
    const [permission, setPermission] = (0, $5NSbj.useState)(isSupported ? Notification.permission : "default");
    (0, $5NSbj.useEffect)(()=>{
        if (isSupported) setPermission(Notification.permission);
    }, [
        isSupported
    ]);
    const requestPermission = (0, $5NSbj.useCallback)(async ()=>{
        if (!isSupported) {
            console.warn("Notification API is not supported");
            return "denied";
        }
        try {
            const result = await Notification.requestPermission();
            const permissionState = result;
            setPermission(permissionState);
            return permissionState;
        } catch (error) {
            console.error("Error requesting notification permission:", error);
            return "denied";
        }
    }, [
        isSupported
    ]);
    const show = (0, $5NSbj.useCallback)(async (title, options)=>{
        if (!isSupported) {
            console.warn("Notification API is not supported");
            return null;
        }
        if (permission !== "granted") {
            console.warn("Notification permission not granted. Current permission:", permission);
            return null;
        }
        try {
            const notification = new Notification(title, options);
            return notification;
        } catch (error) {
            console.error("Error showing notification:", error);
            return null;
        }
    }, [
        isSupported,
        permission
    ]);
    return {
        show: show,
        permission: permission,
        requestPermission: requestPermission,
        isSupported: isSupported
    };
}
function $875b08fe0af98e08$export$1d0625984c38ae85(onClick) {
    const [node, setNode] = (0, $5NSbj.useState)(null);
    const handleEvent = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        onClick();
    }, [
        onClick
    ]);
    const freshCallback = $875b08fe0af98e08$export$b3553245f2c17524(handleEvent);
    (0, $5NSbj.useEffect)(()=>{
        if (node) {
            node.addEventListener("click", freshCallback);
            node.addEventListener("touchend", freshCallback);
            return ()=>{
                node.removeEventListener("click", freshCallback);
                node.removeEventListener("touchend", freshCallback);
            };
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        node,
        freshCallback
    ]);
    const ref = (0, $5NSbj.useCallback)((element)=>{
        if (element) setNode(element);
    }, []);
    return ref;
}
function $875b08fe0af98e08$export$a95d525b9d8df060(onMouseEnter, onMouseLeave) {
    const [node, setNode] = (0, $5NSbj.useState)(null);
    const handleMouseEnter = (0, $5NSbj.useCallback)((e)=>{
        onMouseEnter?.(e);
    }, [
        onMouseEnter
    ]);
    const handleMouseLeave = (0, $5NSbj.useCallback)((e)=>{
        onMouseLeave?.(e);
    }, [
        onMouseLeave
    ]);
    const mouseEnterCallback = $875b08fe0af98e08$export$b3553245f2c17524(handleMouseEnter);
    const mouseLeaveCallback = $875b08fe0af98e08$export$b3553245f2c17524(handleMouseLeave);
    (0, $5NSbj.useEffect)(()=>{
        if (node) {
            node.addEventListener("mouseenter", mouseEnterCallback);
            node.addEventListener("mouseleave", mouseLeaveCallback);
            return ()=>{
                node.removeEventListener("mouseenter", mouseEnterCallback);
                node.removeEventListener("mouseleave", mouseLeaveCallback);
            };
        } else return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        mouseEnterCallback,
        mouseLeaveCallback,
        node
    ]);
    const ref = (el)=>{
        setNode(el);
    };
    return ref;
}
function $875b08fe0af98e08$var$getSnapshot() {
    if (typeof window === "undefined") return null;
    return navigator.onLine;
}
function $875b08fe0af98e08$var$subscribe(onStoreChange) {
    if (typeof window !== "undefined") {
        window.addEventListener("online", onStoreChange);
        window.addEventListener("offline", onStoreChange);
        return ()=>{
            window.removeEventListener("online", onStoreChange);
            window.removeEventListener("offline", onStoreChange);
        };
    } else {
        console.warn("useOnline: window is undefined.");
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }
}
function $875b08fe0af98e08$export$6feb6ada280bcdab() {
    const isOnline = (0, $66149cfac528b117$exports.useSyncExternalStore)($875b08fe0af98e08$var$subscribe, $875b08fe0af98e08$var$getSnapshot, ()=>null);
    return isOnline;
}
var $875b08fe0af98e08$export$550084c67147f6c4 = ()=>{
    const subscribe3 = (0, $5NSbj.useCallback)((onStoreChange)=>{
        window.screen.orientation.addEventListener("change", onStoreChange);
        return ()=>{
            window.screen.orientation.removeEventListener("change", onStoreChange);
        };
    }, []);
    const getSnapshot2 = (0, $5NSbj.useCallback)(()=>{
        return window.screen.orientation;
    }, []);
    const getServerSnapshot = (0, $5NSbj.useCallback)(()=>{
        return null;
    }, []);
    return (0, $5NSbj.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
};
function $875b08fe0af98e08$export$6bd1f37e929013e5(onPageLeave) {
    const freshCallback = $875b08fe0af98e08$export$b3553245f2c17524(onPageLeave);
    const isLeavingRef = (0, $5NSbj.useRef)(false);
    (0, $5NSbj.useEffect)(()=>{
        if (typeof window === "undefined") return;
        const handleBeforeUnload = (event)=>{
            isLeavingRef.current = true;
            const result = freshCallback();
            if (typeof result === "string") {
                event.preventDefault();
                event.returnValue = result;
                return result;
            }
        };
        const handleVisibilityChange = ()=>{
            if (document.visibilityState === "hidden" && !isLeavingRef.current) freshCallback();
        };
        const handlePageHide = ()=>{
            if (!isLeavingRef.current) freshCallback();
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("pagehide", handlePageHide);
        return ()=>{
            window.removeEventListener("beforeunload", handleBeforeUnload);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("pagehide", handlePageHide);
            isLeavingRef.current = false;
        };
    }, [
        freshCallback
    ]);
}
function $875b08fe0af98e08$export$246005d45236a985(videoRef) {
    const [isPiPActive, setIsPiPActive] = (0, $5NSbj.useState)(false);
    const [isSupported, setIsSupported] = (0, $5NSbj.useState)(false);
    const [error, setError] = (0, $5NSbj.useState)(null);
    const [pipWindow, setPipWindow] = (0, $5NSbj.useState)(null);
    const attachedVideoRef = (0, $5NSbj.useRef)(null);
    const getIsSupported = (0, $5NSbj.useCallback)(()=>{
        if (!videoRef.current) return false;
        if (!document.pictureInPictureEnabled) return false;
        if (!videoRef.current.requestPictureInPicture) return false;
        if (videoRef.current.disablePictureInPicture) return false;
        return true;
    }, [
        videoRef
    ]);
    const checkPiPActive = (0, $5NSbj.useCallback)(()=>{
        return document.pictureInPictureElement === videoRef.current;
    }, [
        videoRef
    ]);
    const updatePiPState = (0, $5NSbj.useCallback)(()=>{
        setIsPiPActive(checkPiPActive());
    }, [
        checkPiPActive
    ]);
    const enterPiP = (0, $5NSbj.useCallback)(async ()=>{
        if (!getIsSupported() || !videoRef.current) return;
        try {
            setError(null);
            await videoRef.current.requestPictureInPicture();
        } catch (err) {
            setError(err instanceof Error ? err : new Error(String(err)));
        }
    }, [
        getIsSupported,
        videoRef
    ]);
    const exitPiP = (0, $5NSbj.useCallback)(async ()=>{
        if (!document.pictureInPictureElement) return;
        try {
            setError(null);
            await document.exitPictureInPicture();
        } catch (err) {
            setError(err instanceof Error ? err : new Error(String(err)));
        }
    }, []);
    const toggle = (0, $5NSbj.useCallback)(async ()=>{
        if (checkPiPActive()) await exitPiP();
        else await enterPiP();
    }, [
        checkPiPActive,
        exitPiP,
        enterPiP
    ]);
    const handleEnterPiP = (0, $5NSbj.useCallback)((event)=>{
        const pipEvent = event;
        setPipWindow(pipEvent.pictureInPictureWindow);
        setIsPiPActive(true);
    }, []);
    const handleLeavePiP = (0, $5NSbj.useCallback)(()=>{
        setPipWindow(null);
        setIsPiPActive(false);
    }, []);
    (0, $0302d50d2b00a3cf$export$363c9f3eb56bbdbe)(()=>{
        const video = videoRef.current;
        const nextIsSupported = getIsSupported();
        setIsSupported((current)=>current === nextIsSupported ? current : nextIsSupported);
        if (attachedVideoRef.current === video) return;
        attachedVideoRef.current?.removeEventListener("enterpictureinpicture", handleEnterPiP);
        attachedVideoRef.current?.removeEventListener("leavepictureinpicture", handleLeavePiP);
        attachedVideoRef.current = video;
        if (video) {
            video.addEventListener("enterpictureinpicture", handleEnterPiP);
            video.addEventListener("leavepictureinpicture", handleLeavePiP);
            updatePiPState();
        }
    });
    (0, $5NSbj.useEffect)(()=>{
        return ()=>{
            attachedVideoRef.current?.removeEventListener("enterpictureinpicture", handleEnterPiP);
            attachedVideoRef.current?.removeEventListener("leavepictureinpicture", handleLeavePiP);
            attachedVideoRef.current = null;
        };
    }, [
        handleEnterPiP,
        handleLeavePiP
    ]);
    return {
        isPiPActive: isPiPActive,
        isSupported: isSupported,
        error: error,
        pipWindow: pipWindow,
        enterPiP: enterPiP,
        exitPiP: exitPiP,
        toggle: toggle
    };
}
function $875b08fe0af98e08$var$getColorScheme() {
    if (typeof window === "undefined") return null;
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
    if (window.matchMedia("(prefers-color-scheme: light)").matches) return "light";
    return "no-preference";
}
function $875b08fe0af98e08$var$subscribe2(onStoreChange) {
    if (typeof window === "undefined") {
        console.warn("usePreferredColorScheme: window is undefined.");
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }
    const darkModeQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const lightModeQuery = window.matchMedia("(prefers-color-scheme: light)");
    if (darkModeQuery.addEventListener) {
        darkModeQuery.addEventListener("change", onStoreChange);
        lightModeQuery.addEventListener("change", onStoreChange);
        return ()=>{
            darkModeQuery.removeEventListener("change", onStoreChange);
            lightModeQuery.removeEventListener("change", onStoreChange);
        };
    } else {
        const legacyDarkModeQuery = darkModeQuery;
        const legacyLightModeQuery = lightModeQuery;
        legacyDarkModeQuery.addListener(onStoreChange);
        legacyLightModeQuery.addListener(onStoreChange);
        return ()=>{
            legacyDarkModeQuery.removeListener(onStoreChange);
            legacyLightModeQuery.removeListener(onStoreChange);
        };
    }
}
function $875b08fe0af98e08$export$7c3b8f854ca5e941() {
    const colorScheme = (0, $66149cfac528b117$exports.useSyncExternalStore)($875b08fe0af98e08$var$subscribe2, $875b08fe0af98e08$var$getColorScheme, ()=>null);
    return {
        colorScheme: colorScheme,
        isDark: colorScheme === "dark",
        isLight: colorScheme === "light"
    };
}
function $875b08fe0af98e08$export$71b2224f1ce5e08e(ref, handler, when = true) {
    const savedHandler = (0, $5NSbj.useRef)(handler);
    const memoizedCallback = (0, $5NSbj.useCallback)((event)=>{
        if (ref.current && !ref.current.contains(event.target)) savedHandler.current(event);
    }, [
        ref
    ]);
    (0, $5NSbj.useEffect)(()=>{
        savedHandler.current = handler;
    });
    (0, $5NSbj.useEffect)(()=>{
        if (when) {
            document.addEventListener("click", memoizedCallback, true);
            document.addEventListener("touchstart", memoizedCallback, true);
            return ()=>{
                document.removeEventListener("click", memoizedCallback, true);
                document.removeEventListener("touchstart", memoizedCallback, true);
            };
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        ref,
        handler,
        when,
        memoizedCallback
    ]);
}
function $875b08fe0af98e08$export$c5f9bba475faecdf(handler, when = true) {
    const [node, setNode] = (0, $5NSbj.useState)(null);
    const savedHandler = (0, $5NSbj.useRef)(handler);
    const memoizedCallback = (0, $5NSbj.useCallback)((event)=>{
        if (node && !node.contains(event.target)) savedHandler.current(event);
    }, [
        node
    ]);
    (0, $5NSbj.useEffect)(()=>{
        savedHandler.current = handler;
    });
    const ref = (0, $5NSbj.useCallback)((nodeElement)=>{
        setNode(nodeElement);
    }, []);
    (0, $5NSbj.useEffect)(()=>{
        if (when) {
            document.addEventListener("click", memoizedCallback, true);
            document.addEventListener("touchstart", memoizedCallback, true);
            return ()=>{
                document.removeEventListener("click", memoizedCallback, true);
                document.removeEventListener("touchstart", memoizedCallback, true);
            };
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        when,
        memoizedCallback
    ]);
    return [
        ref
    ];
}
// src/hooks/usePrefersReducedMotion.ts
function $875b08fe0af98e08$export$c170580b40c8999d() {
    return $875b08fe0af98e08$export$b1eecdc553bff745("(prefers-reduced-motion: reduce)");
}
function $875b08fe0af98e08$export$c3eac79c5e1cdf4e(currentValue) {
    const previousRef = (0, $5NSbj.useRef)(null);
    const previousRef2 = (0, $5NSbj.useRef)(null);
    (0, $5NSbj.useEffect)(()=>{
        previousRef2.current = previousRef.current;
        previousRef.current = currentValue;
    }, [
        currentValue
    ]);
    return currentValue === previousRef.current ? previousRef2.current : previousRef.current;
}
function $875b08fe0af98e08$export$f6f3f74729fdd0b7(currentValue) {
    const previousRef = (0, $5NSbj.useRef)(null);
    (0, $5NSbj.useEffect)(()=>{
        previousRef.current = currentValue;
    });
    return previousRef.current;
}
function $875b08fe0af98e08$export$dd6b79aaabe7bc37(asyncFunction, deps = []) {
    const [state, setState] = (0, $5NSbj.useState)({
        data: null,
        loading: true,
        error: null
    });
    const freshAsyncCallback = $875b08fe0af98e08$export$b3553245f2c17524(asyncFunction);
    (0, $5NSbj.useEffect)(()=>{
        let isMounted = true;
        async function fetchData() {
            try {
                const data = await freshAsyncCallback();
                if (isMounted) setState({
                    data: data,
                    loading: false,
                    error: null
                });
            } catch (error) {
                if (isMounted) setState({
                    data: null,
                    loading: false,
                    error: error instanceof Error ? error : new Error(String(error))
                });
            }
        }
        fetchData();
        return ()=>{
            isMounted = false;
        };
    }, [
        freshAsyncCallback,
        ...deps
    ]);
    return state;
}
function $875b08fe0af98e08$export$4d9119e556c12833(initialList) {
    const [list, setList] = (0, $5NSbj.useState)([
        ...initialList
    ]);
    const enqueue = (0, $5NSbj.useCallback)((item)=>{
        const newList = [
            ...list,
            item
        ];
        setList(newList);
        return newList.length;
    }, [
        list
    ]);
    const dequeue = (0, $5NSbj.useCallback)(()=>{
        if (list.length > 0) {
            const firstItem = list[0];
            setList([
                ...list.slice(1)
            ]);
            return firstItem;
        }
        return void 0;
    }, [
        list
    ]);
    const peek = (0, $5NSbj.useCallback)(()=>{
        if (list.length > 0) return list[0];
        return void 0;
    }, [
        list
    ]);
    const controls = {
        dequeue: dequeue,
        enqueue: enqueue,
        length: list.length,
        peek: peek
    };
    return [
        list,
        controls
    ];
}
function $875b08fe0af98e08$export$4d5d35ff55b6d811(initialState) {
    const [state, setState] = (0, $5NSbj.useState)(initialState);
    const rafIdRef = (0, $5NSbj.useRef)(null);
    const pendingRef = (0, $5NSbj.useRef)(null);
    (0, $5NSbj.useEffect)(()=>{
        return ()=>{
            if (rafIdRef.current !== null) {
                cancelAnimationFrame(rafIdRef.current);
                rafIdRef.current = null;
            }
        };
    }, []);
    const rafSetState = (0, $5NSbj.useCallback)((action)=>{
        if (typeof requestAnimationFrame === "undefined") {
            setState(action);
            return;
        }
        pendingRef.current = {
            action: action
        };
        if (rafIdRef.current !== null) return;
        rafIdRef.current = requestAnimationFrame(()=>{
            rafIdRef.current = null;
            if (pendingRef.current !== null) {
                setState(pendingRef.current.action);
                pendingRef.current = null;
            }
        });
    }, []);
    return [
        state,
        rafSetState
    ];
}
var $875b08fe0af98e08$var$config5 = {
    box: "content-box"
};
function $875b08fe0af98e08$export$1e496cef3ab4aa33(callback, options = $875b08fe0af98e08$var$config5) {
    const { box: box } = options;
    const [node, setNode] = (0, $5NSbj.useState)(null);
    const callbackRef = (0, $5NSbj.useRef)(callback);
    (0, $5NSbj.useEffect)(()=>{
        callbackRef.current = callback;
    });
    const handleResizeObserver = (0, $5NSbj.useCallback)((...args)=>{
        callbackRef.current?.(...args);
    }, []);
    (0, $5NSbj.useEffect)(()=>{
        if (node) {
            const observer = new ResizeObserver(handleResizeObserver);
            observer.observe(node, {
                box: box
            });
            return ()=>{
                observer.disconnect();
            };
        }
        return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
    }, [
        node,
        handleResizeObserver,
        box
    ]);
    const ref = (0, $5NSbj.useCallback)((node2)=>{
        setNode(node2);
    }, []);
    return [
        ref
    ];
}
function $875b08fe0af98e08$export$894a34a32cdbdc06() {
    return ++(0, $5NSbj.useRef)(0).current;
}
function $875b08fe0af98e08$export$73e242da76f85109(initialState) {
    const [state, setState] = (0, $5NSbj.useState)(initialState);
    const getIsMounted = $875b08fe0af98e08$export$7aa0022395cd4c49();
    const safeSetState = (0, $5NSbj.useCallback)((newState)=>{
        if (getIsMounted()) setState(newState);
    }, [
        getIsMounted
    ]);
    return [
        state,
        safeSetState
    ];
}
function $875b08fe0af98e08$export$ab808b17bf61ae66(options = {}) {
    const { requestOnMount: requestOnMount = false, autoRefresh: autoRefresh = true } = options;
    const [screens, setScreens] = (0, $5NSbj.useState)([]);
    const [currentScreen, setCurrentScreen] = (0, $5NSbj.useState)(null);
    const [isLoading, setIsLoading] = (0, $5NSbj.useState)(false);
    const [hasPermission, setHasPermission] = (0, $5NSbj.useState)(false);
    const [error, setError] = (0, $5NSbj.useState)(null);
    const screenDetailsRef = (0, $5NSbj.useRef)(null);
    const permissionStatusRef = (0, $5NSbj.useRef)(null);
    const isSupported = (0, $5NSbj.useMemo)(()=>{
        if (typeof window === "undefined") return false;
        const screenDetailsWindow = window;
        return typeof screenDetailsWindow.getScreenDetails === "function";
    }, []);
    const primaryScreen = (0, $5NSbj.useMemo)(()=>{
        return screens.find((screen)=>screen.isPrimary) || null;
    }, [
        screens
    ]);
    const externalScreens = (0, $5NSbj.useMemo)(()=>{
        return screens.filter((screen)=>!screen.isPrimary);
    }, [
        screens
    ]);
    const fetchScreenDetails = (0, $5NSbj.useCallback)(async ()=>{
        if (!isSupported) return;
        setIsLoading(true);
        setError(null);
        try {
            const screenDetailsWindow = window;
            const screenDetails = await screenDetailsWindow.getScreenDetails?.();
            if (!screenDetails) throw new Error("Screen Details API is not supported");
            screenDetailsRef.current = screenDetails;
            setScreens(screenDetails.screens);
            setCurrentScreen(screenDetails.currentScreen);
            setHasPermission(true);
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : String(err);
            setError(errorMessage);
            setHasPermission(false);
        } finally{
            setIsLoading(false);
        }
    }, [
        isSupported
    ]);
    const requestPermission = (0, $5NSbj.useCallback)(async ()=>{
        if (!isSupported) {
            setError("Screen Details API is not supported");
            return;
        }
        setIsLoading(true);
        setError(null);
        try {
            const permissionStatus = await navigator.permissions.query({
                name: "window-management"
            });
            permissionStatusRef.current = permissionStatus;
            if (permissionStatus.state === "denied") {
                setError("Permission denied for window-management");
                setHasPermission(false);
                setIsLoading(false);
                return;
            }
            await fetchScreenDetails();
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : String(err);
            setError(errorMessage);
            setHasPermission(false);
            setIsLoading(false);
        }
    }, [
        isSupported,
        fetchScreenDetails
    ]);
    const refresh = (0, $5NSbj.useCallback)(async ()=>{
        if (!hasPermission) return;
        try {
            await fetchScreenDetails();
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : String(err);
            setError(errorMessage);
        }
    }, [
        hasPermission,
        fetchScreenDetails
    ]);
    const handleScreensChange = (0, $5NSbj.useCallback)(()=>{
        if (autoRefresh) refresh();
    }, [
        autoRefresh,
        refresh
    ]);
    const handleCurrentScreenChange = (0, $5NSbj.useCallback)(()=>{
        if (autoRefresh) refresh();
    }, [
        autoRefresh,
        refresh
    ]);
    const handlePermissionChange = (0, $5NSbj.useCallback)(()=>{
        if (permissionStatusRef.current) {
            const newState = permissionStatusRef.current.state;
            if (newState === "denied") {
                setHasPermission(false);
                setScreens([]);
                setCurrentScreen(null);
                setError("Permission denied for window-management");
            } else if (newState === "granted") {
                setHasPermission(true);
                setError(null);
                if (autoRefresh) refresh();
            }
        }
    }, [
        autoRefresh,
        refresh
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (!screenDetailsRef.current) return;
        const screenDetails = screenDetailsRef.current;
        screenDetails.addEventListener("screenschange", handleScreensChange);
        screenDetails.addEventListener("currentscreenchange", handleCurrentScreenChange);
        return ()=>{
            screenDetails.removeEventListener("screenschange", handleScreensChange);
            screenDetails.removeEventListener("currentscreenchange", handleCurrentScreenChange);
        };
    }, [
        handleScreensChange,
        handleCurrentScreenChange
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (!permissionStatusRef.current) return;
        const permissionStatus = permissionStatusRef.current;
        permissionStatus.addEventListener("change", handlePermissionChange);
        return ()=>{
            permissionStatus.removeEventListener("change", handlePermissionChange);
        };
    }, [
        handlePermissionChange
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (requestOnMount && isSupported) requestPermission();
    }, [
        requestOnMount,
        isSupported,
        requestPermission
    ]);
    return {
        screens: screens,
        currentScreen: currentScreen,
        primaryScreen: primaryScreen,
        externalScreens: externalScreens,
        isSupported: isSupported,
        isLoading: isLoading,
        hasPermission: hasPermission,
        error: error,
        requestPermission: requestPermission,
        refresh: refresh
    };
}
function $875b08fe0af98e08$export$e64b2f635402ca43(list, initialIndex = 0) {
    const [selectedIndex, setSelectedIndex] = (0, $5NSbj.useState)(initialIndex);
    const setItem = (0, $5NSbj.useCallback)((item)=>{
        setSelectedIndex(list.indexOf(item));
    }, [
        list
    ]);
    return {
        index: selectedIndex,
        item: list[selectedIndex],
        setIndex: setSelectedIndex,
        setItem: setItem
    };
}
function $875b08fe0af98e08$var$warnIfBothValueAndIndexAreProvided2(functionName, object) {
    if (Object.values(object).every((value)=>typeof value !== "undefined")) console.warn(`${functionName}. Expected either ${Object.keys(object).join(" or ")} to be provided. However all were provided`);
    else if (Object.values(object).every((value)=>typeof value === "undefined")) console.warn(`${functionName}. ${Object.keys(object).join(" , ")} are all undefined.`);
}
function $875b08fe0af98e08$export$b95089534ab7c1fd(list = [], initialIndex = 0, allowUnselected = false) {
    const [currentIndex, setCurrentIndex] = (0, $5NSbj.useState)(initialIndex);
    const currentValue = list[currentIndex];
    const selection = [
        currentIndex,
        currentValue
    ];
    const updateSelection = (0, $5NSbj.useCallback)(({ index: index, value: value })=>{
        return ()=>{
            $875b08fe0af98e08$var$warnIfBothValueAndIndexAreProvided2("updateSelection", {
                index: index,
                value: value
            });
            if (typeof index !== "undefined") setCurrentIndex(index);
            else if (typeof value !== "undefined") {
                const valueIndex = list.indexOf(value);
                if (valueIndex > -1) setCurrentIndex(valueIndex);
                else console.warn(`updateSelection failed. Does the value ${value} exist in the list?`);
            }
        };
    }, [
        list
    ]);
    const toggleSelection = (0, $5NSbj.useCallback)(({ index: index, value: value })=>{
        return ()=>{
            $875b08fe0af98e08$var$warnIfBothValueAndIndexAreProvided2("toggleSelection", {
                index: index,
                value: value
            });
            if (typeof index !== "undefined") {
                if (currentIndex === index) {
                    if (allowUnselected) setCurrentIndex(-1);
                    else console.warn("allowUnselected is false. Cannot unselect item");
                } else setCurrentIndex(index);
            } else if (typeof value !== "undefined") {
                const valueIndex = list.indexOf(value);
                if (valueIndex > -1) {
                    if (currentIndex === valueIndex) {
                        if (allowUnselected) setCurrentIndex(-1);
                        else console.warn("allowUnselected is false. Cannot unselect item");
                    } else setCurrentIndex(valueIndex);
                } else console.warn(`toggleSelection failed. Does the value ${value} exist in the list?`);
            }
        };
    }, [
        allowUnselected,
        currentIndex,
        list
    ]);
    const matchSelection = (0, $5NSbj.useCallback)(({ index: index, value: value })=>{
        $875b08fe0af98e08$var$warnIfBothValueAndIndexAreProvided2("matchSelection", {
            index: index,
            value: value
        });
        if (typeof index !== "undefined") return index === currentIndex;
        else return value === currentValue;
    }, [
        currentIndex,
        currentValue
    ]);
    const controls = {
        matchSelection: matchSelection,
        toggleSelection: toggleSelection,
        updateSelection: updateSelection
    };
    return [
        selection,
        controls
    ];
}
function $875b08fe0af98e08$var$getValueFromSessionStorage(key) {
    try {
        if (typeof sessionStorage === "undefined") return null;
        const storedValue = sessionStorage.getItem(key) ?? "null";
        try {
            return JSON.parse(storedValue);
        } catch (error) {
            console.error(error);
            return storedValue;
        }
    } catch (error) {
        console.error(error);
        return null;
    }
}
function $875b08fe0af98e08$var$saveValueToSessionStorage(key, value) {
    try {
        if (typeof sessionStorage === "undefined") return null;
        if (value === void 0) return sessionStorage.removeItem(key);
        return sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.error(error);
        return null;
    }
}
function $875b08fe0af98e08$var$initialize2(key, initialState) {
    const valueLoadedFromSessionStorage = $875b08fe0af98e08$var$getValueFromSessionStorage(key);
    if (valueLoadedFromSessionStorage === null) return typeof initialState === "function" ? initialState() : initialState;
    else return valueLoadedFromSessionStorage;
}
function $875b08fe0af98e08$export$ab5dd7ac86ae2916(key, initialState) {
    const [value, setValue] = (0, $5NSbj.useState)(()=>$875b08fe0af98e08$var$initialize2(key, initialState));
    const [stateKey, setStateKey] = (0, $5NSbj.useState)(key);
    const currentValueRef = (0, $5NSbj.useRef)(value);
    const currentKeyRef = (0, $5NSbj.useRef)(key);
    (0, $5NSbj.useInsertionEffect)(()=>{
        currentValueRef.current = value;
        currentKeyRef.current = key;
    }, [
        key,
        value
    ]);
    if (stateKey !== key) {
        setStateKey(key);
        setValue($875b08fe0af98e08$var$initialize2(key, initialState));
    }
    const isUpdateFromCrossDocumentListener = (0, $5NSbj.useRef)(false);
    const isUpdateFromWithinDocumentListener = (0, $5NSbj.useRef)(false);
    const updateSourceKeyRef = (0, $5NSbj.useRef)(null);
    const customEventTypeName = (0, $5NSbj.useMemo)(()=>{
        return `rooks-${key}-sessionstorage-update`;
    }, [
        key
    ]);
    (0, $5NSbj.useEffect)(()=>{
        const cameFromSynchronizedUpdate = (isUpdateFromCrossDocumentListener.current || isUpdateFromWithinDocumentListener.current) && updateSourceKeyRef.current === key;
        if (!cameFromSynchronizedUpdate) $875b08fe0af98e08$var$saveValueToSessionStorage(key, value);
        isUpdateFromCrossDocumentListener.current = false;
        isUpdateFromWithinDocumentListener.current = false;
        updateSourceKeyRef.current = null;
    }, [
        key,
        value
    ]);
    const listenToCrossDocumentStorageEvents = (0, $5NSbj.useCallback)((event)=>{
        try {
            if (event.storageArea === sessionStorage && event.key === key) {
                const newValue = JSON.parse(event.newValue ?? "null");
                isUpdateFromCrossDocumentListener.current = true;
                updateSourceKeyRef.current = key;
                currentValueRef.current = newValue;
                setValue((currentValue)=>Object.is(currentValue, newValue) ? currentValue : newValue);
            }
        } catch (error) {
            isUpdateFromCrossDocumentListener.current = false;
            updateSourceKeyRef.current = null;
            console.log(error);
        }
    }, [
        currentValueRef,
        key
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (typeof window !== "undefined") {
            window.addEventListener("storage", listenToCrossDocumentStorageEvents);
            return ()=>{
                window.removeEventListener("storage", listenToCrossDocumentStorageEvents);
            };
        } else {
            console.warn("[useSessionstorageState] window is undefined.");
            return ()=>{};
        }
    }, [
        listenToCrossDocumentStorageEvents
    ]);
    const listenToCustomEventWithinDocument = (0, $5NSbj.useCallback)((event)=>{
        try {
            const { newValue: newValue } = event.detail;
            isUpdateFromWithinDocumentListener.current = true;
            updateSourceKeyRef.current = key;
            currentValueRef.current = newValue;
            setValue((currentValue)=>Object.is(currentValue, newValue) ? currentValue : newValue);
        } catch (error) {
            isUpdateFromWithinDocumentListener.current = false;
            updateSourceKeyRef.current = null;
            console.log(error);
        }
    }, [
        currentValueRef,
        key
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (typeof document !== "undefined") {
            document.addEventListener(customEventTypeName, listenToCustomEventWithinDocument);
            return ()=>{
                document.removeEventListener(customEventTypeName, listenToCustomEventWithinDocument);
            };
        } else {
            console.warn("[useSessionstorageState] document is undefined.");
            return ()=>{};
        }
    }, [
        customEventTypeName,
        listenToCustomEventWithinDocument
    ]);
    const broadcastValueWithinDocument = (0, $5NSbj.useCallback)((storageKey, newValue)=>{
        if (typeof document !== "undefined") {
            const event = new CustomEvent(`rooks-${storageKey}-sessionstorage-update`, {
                detail: {
                    newValue: newValue
                }
            });
            document.dispatchEvent(event);
        } else console.warn("[useSessionstorageState] document is undefined.");
    }, []);
    const set = (0, $5NSbj.useCallback)((newValue)=>{
        const resolvedNewValue = typeof newValue === "function" ? newValue(currentValueRef.current) : newValue;
        const storageKey = currentKeyRef.current;
        isUpdateFromCrossDocumentListener.current = false;
        isUpdateFromWithinDocumentListener.current = true;
        updateSourceKeyRef.current = storageKey;
        currentValueRef.current = resolvedNewValue;
        $875b08fe0af98e08$var$saveValueToSessionStorage(storageKey, resolvedNewValue);
        setValue(resolvedNewValue);
        broadcastValueWithinDocument(storageKey, resolvedNewValue);
    }, [
        broadcastValueWithinDocument,
        currentKeyRef,
        currentValueRef
    ]);
    const remove = (0, $5NSbj.useCallback)(()=>{
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
            console.error(error);
        }
    }, [
        key
    ]);
    return [
        value,
        set,
        remove
    ];
}
function $875b08fe0af98e08$export$96a35531d1008427() {
    const [error, setError] = (0, $5NSbj.useState)(null);
    const [isSharing, setIsSharing] = (0, $5NSbj.useState)(false);
    const isSupported = typeof window !== "undefined" && typeof navigator !== "undefined" && "share" in navigator;
    const share = (0, $5NSbj.useCallback)(async (data)=>{
        if (!isSupported) {
            const err = new Error("Web Share API is not supported");
            setError(err);
            throw err;
        }
        try {
            setIsSharing(true);
            setError(null);
            await navigator.share(data);
        } catch (err) {
            if (err instanceof Error && err.name === "AbortError") setError(null);
            else {
                const error2 = err instanceof Error ? err : new Error("Failed to share");
                setError(error2);
                throw error2;
            }
        } finally{
            setIsSharing(false);
        }
    }, [
        isSupported
    ]);
    return {
        share: share,
        isSupported: isSupported,
        error: error,
        isSharing: isSharing
    };
}
function $875b08fe0af98e08$export$89c35abda4d6d7ba(initialSetValue) {
    const [setValue, setSetValue] = (0, $5NSbj.useState)(new Set(initialSetValue));
    const add = (0, $5NSbj.useCallback)((...args)=>{
        setSetValue((currentSet)=>{
            const nextSet = new Set(currentSet);
            nextSet.add(...args);
            return nextSet;
        });
    }, []);
    const deleteValue = (0, $5NSbj.useCallback)((...args)=>{
        setSetValue((currentSet)=>{
            const nextSet = new Set(currentSet);
            nextSet.delete(...args);
            return nextSet;
        });
    }, []);
    const clear = (0, $5NSbj.useCallback)(()=>{
        setSetValue(/* @__PURE__ */ new Set());
    }, []);
    const controls = (0, $5NSbj.useMemo)(()=>{
        return {
            add: add,
            delete: deleteValue,
            clear: clear
        };
    }, [
        add,
        deleteValue,
        clear
    ]);
    const returnValue = (0, $5NSbj.useMemo)(()=>{
        return [
            setValue,
            controls
        ];
    }, [
        setValue,
        controls
    ]);
    return returnValue;
}
function $875b08fe0af98e08$export$c4af9125706c4d30(targetValue, config6 = {}) {
    const { stiffness: stiffness = 170, damping: damping = 26, mass: mass = 1, precision: precision = 0.01 } = config6;
    const [value, setValue] = (0, $5NSbj.useState)(targetValue);
    const velocityRef = (0, $5NSbj.useRef)(0);
    const valueRef = (0, $5NSbj.useRef)(targetValue);
    const targetRef = (0, $5NSbj.useRef)(targetValue);
    (0, $5NSbj.useEffect)(()=>{
        targetRef.current = targetValue;
    }, [
        targetValue
    ]);
    $875b08fe0af98e08$export$3d0be2420b17e328(()=>{
        const distance = targetRef.current - valueRef.current;
        const force = distance * stiffness;
        const acceleration = force / mass;
        const friction = -velocityRef.current * damping;
        velocityRef.current += (acceleration + friction) * (1 / 60);
        valueRef.current += velocityRef.current * (1 / 60);
        setValue(valueRef.current);
        if (Math.abs(distance) < precision && Math.abs(velocityRef.current) < precision) {
            if (valueRef.current !== targetRef.current) {
                valueRef.current = targetRef.current;
                setValue(targetRef.current);
            }
            return false;
        }
        return true;
    }, true);
    return value;
}
function $875b08fe0af98e08$export$d924c858c6da95fa(initialList) {
    const [list, setList] = (0, $5NSbj.useState)([
        ...initialList
    ]);
    const length = list.length;
    const listInReverse = (0, $5NSbj.useMemo)(()=>{
        const reverseList = [
            ...list
        ];
        reverseList.reverse();
        return reverseList;
    }, [
        list
    ]);
    const push = (0, $5NSbj.useCallback)((item)=>{
        const newList = [
            ...list,
            item
        ];
        setList(newList);
        return newList.length;
    }, [
        list
    ]);
    const pop = (0, $5NSbj.useCallback)(()=>{
        if (list.length > 0) {
            const lastItem = list[list.length - 1];
            setList([
                ...list.slice(0, list.length - 1)
            ]);
            return lastItem;
        }
        return void 0;
    }, [
        list
    ]);
    const peek = (0, $5NSbj.useCallback)(()=>{
        if (list.length > 0) return list[list.length - 1];
        return void 0;
    }, [
        list
    ]);
    const clear = ()=>setList([]);
    const isEmpty = (0, $5NSbj.useCallback)(()=>list.length === 0, [
        list
    ]);
    const controls = {
        clear: clear,
        isEmpty: isEmpty,
        length: length,
        peek: peek,
        pop: pop,
        push: push
    };
    return [
        list,
        controls,
        listInReverse
    ];
}
function $875b08fe0af98e08$export$57e792e009c800a0(options) {
    const { text: text, language: language = "en-US", voiceURI: voiceURI, onEnd: onEnd = (0, $0302d50d2b00a3cf$export$8793edee2d425525), volume: volume = 1, pitch: pitch = 1, rate: rate = 1 } = options;
    const freshOnEnd = $875b08fe0af98e08$export$b3553245f2c17524(onEnd);
    const speechRef = (0, $5NSbj.useRef)(null);
    const [isPlaying, setIsPlaying] = (0, $5NSbj.useState)(false);
    (0, $5NSbj.useEffect)(()=>{
        if (speechRef.current && isPlaying) {
            speechRef.current.text = text;
            speechRef.current.lang = language;
            speechRef.current.volume = volume;
            speechRef.current.pitch = pitch;
            speechRef.current.rate = rate;
            if (voiceURI) {
                const voices = window.speechSynthesis.getVoices();
                const selectedVoice = voices.find((voice)=>voice.voiceURI === voiceURI);
                if (selectedVoice) speechRef.current.voice = selectedVoice;
            }
        }
    }, [
        text,
        isPlaying,
        language,
        voiceURI,
        volume,
        pitch,
        rate
    ]);
    const start = (0, $5NSbj.useCallback)(()=>{
        if (!("speechSynthesis" in window)) {
            console.error("Web Speech API is not supported in your browser.");
            return;
        }
        if (speechRef.current) window.speechSynthesis.cancel();
        speechRef.current = new SpeechSynthesisUtterance(text);
        speechRef.current.lang = language;
        speechRef.current.volume = volume;
        speechRef.current.pitch = pitch;
        speechRef.current.rate = rate;
        if (voiceURI) {
            const voices = window.speechSynthesis.getVoices();
            const selectedVoice = voices.find((voice)=>voice.voiceURI === voiceURI);
            if (selectedVoice) speechRef.current.voice = selectedVoice;
        }
        speechRef.current.onstart = ()=>setIsPlaying(true);
        speechRef.current.onend = ()=>{
            setIsPlaying(false);
            freshOnEnd();
        };
        speechRef.current.onerror = ()=>setIsPlaying(false);
        window.speechSynthesis.speak(speechRef.current);
    }, [
        text,
        language,
        volume,
        pitch,
        rate,
        voiceURI,
        freshOnEnd
    ]);
    const pause = (0, $5NSbj.useCallback)(()=>{
        if (window.speechSynthesis && isPlaying) {
            window.speechSynthesis.pause();
            setIsPlaying(false);
        }
    }, [
        isPlaying
    ]);
    const resume = (0, $5NSbj.useCallback)(()=>{
        if (window.speechSynthesis && !isPlaying) {
            window.speechSynthesis.resume();
            setIsPlaying(true);
        }
    }, [
        isPlaying
    ]);
    const stop = (0, $5NSbj.useCallback)(()=>{
        if (window.speechSynthesis) {
            window.speechSynthesis.cancel();
            setIsPlaying(false);
        }
    }, []);
    return {
        start: start,
        pause: pause,
        resume: resume,
        stop: stop,
        isPlaying: isPlaying
    };
}
// src/utils/utils.ts
var $875b08fe0af98e08$var$isFunction = (value)=>typeof value === "function";
var $875b08fe0af98e08$var$isNumber = (value)=>typeof value === "number";
var $875b08fe0af98e08$var$getSplitIndex = (step, arr)=>{
    let index = step > 0 ? step - 1 : arr.length + step;
    if (index >= arr.length - 1) index = arr.length - 1;
    if (index < 0) index = 0;
    return index;
};
var $875b08fe0af98e08$var$split = (step, targetArr)=>{
    const index = $875b08fe0af98e08$var$getSplitIndex(step, targetArr);
    return {
        _current: targetArr[index],
        _before: targetArr.slice(0, index),
        _after: targetArr.slice(index + 1)
    };
};
function $875b08fe0af98e08$export$cb9753ee02b19404(initialValue) {
    const [history, setHistory] = (0, $5NSbj.useState)({
        present: initialValue,
        past: [],
        future: []
    });
    const { present: present, past: past, future: future } = history;
    const initialValueRef = (0, $5NSbj.useRef)(initialValue);
    const reset = (0, $5NSbj.useCallback)((resetInitialValue)=>{
        const newInitialValue = resetInitialValue ?? initialValueRef.current;
        initialValueRef.current = newInitialValue;
        setHistory({
            present: newInitialValue,
            future: [],
            past: []
        });
    }, [
        initialValueRef,
        setHistory
    ]);
    const updateValue = (0, $5NSbj.useCallback)((val, options)=>{
        setHistory((currentHistory)=>{
            const { past: past2, present: present2 } = currentHistory;
            const { overwriteLastEntry: overwriteLastEntry = false } = options || {};
            let newValue = void 0;
            if ($875b08fe0af98e08$var$isFunction(val)) newValue = val(present2);
            else newValue = val;
            if (overwriteLastEntry) return {
                present: newValue,
                past: past2,
                future: []
            };
            else return {
                present: newValue,
                future: [],
                past: [
                    ...past2,
                    present2
                ]
            };
        });
    }, []);
    const goForwardInternal = (0, $5NSbj.useCallback)((step = 1)=>{
        setHistory((currentHistory)=>{
            const { future: future2, past: past2, present: present2 } = currentHistory;
            if (future2.length === 0) return currentHistory;
            const { _before: _before, _current: _current, _after: _after } = $875b08fe0af98e08$var$split(step, future2);
            return {
                past: [
                    ...past2,
                    present2,
                    ..._before
                ],
                present: _current,
                future: _after
            };
        });
    }, []);
    const goBackwardInternal = (0, $5NSbj.useCallback)((step = -1)=>{
        setHistory((currentHistory)=>{
            const { future: future2, past: past2, present: present2 } = currentHistory;
            if (past2.length === 0) return currentHistory;
            const { _before: _before, _current: _current, _after: _after } = $875b08fe0af98e08$var$split(step, past2);
            return {
                past: _before,
                present: _current,
                future: [
                    ..._after,
                    present2,
                    ...future2
                ]
            };
        });
    }, []);
    const go = (0, $5NSbj.useCallback)((step)=>{
        const stepNum = $875b08fe0af98e08$var$isNumber(step) ? step : Number(step);
        if (stepNum === 0) return;
        if (stepNum > 0) return goForwardInternal(stepNum);
        goBackwardInternal(stepNum);
    }, [
        goBackwardInternal,
        goForwardInternal
    ]);
    const back = (0, $5NSbj.useCallback)(()=>{
        go(-1);
    }, [
        go
    ]);
    const forward = (0, $5NSbj.useCallback)(()=>{
        go(1);
    }, [
        go
    ]);
    const canUndo = (0, $5NSbj.useMemo)(()=>{
        return past.length > 0;
    }, [
        past.length
    ]);
    const canRedo = (0, $5NSbj.useMemo)(()=>{
        return future.length > 0;
    }, [
        future.length
    ]);
    const controls = (0, $5NSbj.useMemo)(()=>{
        return {
            backLength: past.length,
            forwardLength: future.length,
            go: go,
            back: back,
            forward: forward,
            reset: reset,
            undo: back,
            redo: forward,
            canUndo: canUndo,
            canRedo: canRedo
        };
    }, [
        back,
        canRedo,
        canUndo,
        forward,
        future.length,
        go,
        past.length,
        reset
    ]);
    const returnValue = (0, $5NSbj.useMemo)(()=>{
        return [
            present,
            updateValue,
            controls
        ];
    }, [
        controls,
        present,
        updateValue
    ]);
    return returnValue;
}
async function $875b08fe0af98e08$var$createFetchPromise(url, options = {}, signal) {
    const requestOptions = {
        ...options
    };
    delete requestOptions.onSuccess;
    delete requestOptions.onError;
    delete requestOptions.onFetch;
    const response = await fetch(url, {
        ...requestOptions,
        signal: signal
    });
    if (!response.ok) {
        const errorMessage = `HTTP ${response.status}: ${response.statusText}`;
        const httpError = new Error(errorMessage);
        httpError.status = response.status;
        httpError.statusText = response.statusText;
        throw httpError;
    }
    return await response.json();
}
function $875b08fe0af98e08$export$d852f5f778460fa4(url, options = {}) {
    const [data, setData] = (0, $5NSbj.useState)(null);
    const [loading, setLoading] = (0, $5NSbj.useState)(false);
    const [error, setError] = (0, $5NSbj.useState)(null);
    const mountedRef = (0, $5NSbj.useRef)(true);
    const mountGenerationRef = (0, $5NSbj.useRef)(0);
    const abortControllersRef = (0, $5NSbj.useRef)(/* @__PURE__ */ new Set());
    const fetchData = (0, $5NSbj.useCallback)(async ()=>{
        if (!mountedRef.current) return;
        const mountGeneration = mountGenerationRef.current;
        setLoading(true);
        setError(null);
        options.onFetch?.();
        if (!mountedRef.current || mountGeneration !== mountGenerationRef.current) return;
        let abortController = null;
        const canCommitResult = ()=>mountedRef.current && mountGeneration === mountGenerationRef.current && !abortController?.signal.aborted;
        try {
            abortController = new AbortController();
            abortControllersRef.current.add(abortController);
            const result = await $875b08fe0af98e08$var$createFetchPromise(url, options, abortController.signal);
            if (canCommitResult()) {
                setData(result);
                options.onSuccess?.(result);
            }
        } catch (err) {
            const fetchError = err instanceof Error ? err : new Error(String(err));
            if (canCommitResult()) {
                setError(fetchError);
                options.onError?.(fetchError);
            }
        } finally{
            if (abortController) abortControllersRef.current.delete(abortController);
            if (canCommitResult()) setLoading(false);
        }
    }, [
        options,
        url
    ]);
    (0, $5NSbj.useEffect)(()=>{
        mountedRef.current = true;
        const abortControllers = abortControllersRef.current;
        return ()=>{
            mountedRef.current = false;
            mountGenerationRef.current += 1;
            for (const abortController of abortControllers)abortController.abort();
            abortControllers.clear();
        };
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        startFetch: fetchData
    };
}
function $875b08fe0af98e08$export$8b7b9481d6186f21(callback, timeout = 300) {
    const [ready, setReady] = (0, $5NSbj.useState)(true);
    const readyRef = (0, $5NSbj.useRef)(true);
    const timerRef = (0, $5NSbj.useRef)(void 0);
    const callbackRef = (0, $0302d50d2b00a3cf$export$38e1734badfda8d9)(callback, true);
    const throttledFunction = (0, $5NSbj.useCallback)((...args)=>{
        if (!readyRef.current) return;
        readyRef.current = false;
        setReady(false);
        callbackRef.current(...args);
    }, [
        callbackRef
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (ready) {
            readyRef.current = true;
            return 0, $0302d50d2b00a3cf$export$8793edee2d425525;
        }
        timerRef.current = window.setTimeout(()=>{
            setReady(true);
        }, timeout);
        return ()=>window.clearTimeout(timerRef.current);
    }, [
        ready,
        timeout
    ]);
    return [
        throttledFunction,
        ready
    ];
}
var $875b08fe0af98e08$var$initialSelectionState = {
    text: "",
    rect: null,
    startOffset: 0,
    endOffset: 0,
    anchorNode: null,
    focusNode: null
};
function $875b08fe0af98e08$var$readSelectionState(targetElement) {
    if (typeof window === "undefined" || !window.getSelection) return $875b08fe0af98e08$var$initialSelectionState;
    const selection = window.getSelection();
    if (!selection || selection.isCollapsed) return $875b08fe0af98e08$var$initialSelectionState;
    const text = selection.toString();
    if (!text) return $875b08fe0af98e08$var$initialSelectionState;
    if (targetElement) {
        const { anchorNode: anchorNode, focusNode: focusNode } = selection;
        if (!anchorNode || !focusNode || !targetElement.contains(anchorNode) || !targetElement.contains(focusNode)) return $875b08fe0af98e08$var$initialSelectionState;
    }
    let rect = null;
    if (selection.rangeCount > 0) try {
        rect = selection.getRangeAt(0).getBoundingClientRect();
    } catch  {}
    return {
        text: text,
        rect: rect,
        startOffset: selection.anchorOffset,
        endOffset: selection.focusOffset,
        anchorNode: selection.anchorNode,
        focusNode: selection.focusNode
    };
}
function $875b08fe0af98e08$export$9c9cf404b65a1c0a(target) {
    const cacheRef = (0, $5NSbj.useRef)($875b08fe0af98e08$var$initialSelectionState);
    const targetRef = (0, $5NSbj.useRef)(target);
    targetRef.current = target;
    const subscribe3 = (0, $5NSbj.useCallback)((onStoreChange)=>{
        if (typeof document === "undefined") return ()=>{};
        const handleSelectionChange = ()=>{
            cacheRef.current = $875b08fe0af98e08$var$readSelectionState(targetRef.current?.current ?? null);
            onStoreChange();
        };
        const handleMouseDown = (event)=>{
            const targetElement = targetRef.current?.current;
            if (targetElement && !targetElement.contains(event.target) && cacheRef.current.text !== "") {
                cacheRef.current = $875b08fe0af98e08$var$initialSelectionState;
                onStoreChange();
            }
        };
        document.addEventListener("selectionchange", handleSelectionChange);
        document.addEventListener("mousedown", handleMouseDown);
        return ()=>{
            document.removeEventListener("selectionchange", handleSelectionChange);
            document.removeEventListener("mousedown", handleMouseDown);
        };
    }, []);
    const getSnapshot2 = (0, $5NSbj.useCallback)(()=>cacheRef.current, []);
    const getServerSnapshot = (0, $5NSbj.useCallback)(()=>$875b08fe0af98e08$var$initialSelectionState, []);
    const selectionState = (0, $5NSbj.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
    return [
        selectionState
    ];
}
var $875b08fe0af98e08$var$defaultToggleFunction = (value)=>!value;
function $875b08fe0af98e08$export$cbe85ee05b554577(initialValue = false, toggleFunction) {
    if (toggleFunction) return (0, $5NSbj.useReducer)(toggleFunction, initialValue);
    return (0, $5NSbj.useReducer)($875b08fe0af98e08$var$defaultToggleFunction, initialValue);
}
var $875b08fe0af98e08$var$defaultOptions5 = {
    maxSize: 100
};
var $875b08fe0af98e08$export$99d290bffb3da24d = (defaultValue, options)=>{
    const { maxSize: maxSize } = (0, $5NSbj.useMemo)(()=>{
        return {
            ...$875b08fe0af98e08$var$defaultOptions5,
            ...options
        };
    }, [
        options
    ]);
    const [value, setValue] = (0, $5NSbj.useState)([
        defaultValue
    ]);
    const push = (0, $5NSbj.useCallback)((argument)=>{
        return setValue((current)=>{
            const restValues = current.length >= maxSize ? current.slice(0, maxSize) : current;
            if (typeof argument === "function") return [
                argument(current[0]),
                ...restValues
            ];
            else return [
                argument,
                ...restValues
            ];
        });
    }, [
        maxSize
    ]);
    const undo = (0, $5NSbj.useCallback)(()=>{
        setValue((current)=>{
            if (current.length === 1) return current;
            const [, ...values] = current;
            return values;
        });
    }, []);
    const returnValue = (0, $5NSbj.useMemo)(()=>{
        return [
            value[0],
            push,
            undo
        ];
    }, [
        push,
        undo,
        value
    ]);
    return returnValue;
};
var $875b08fe0af98e08$var$Easing2 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>t * (2 - t),
    easeInOutQuad: (t)=>t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>--t * t * t + 1,
    easeInOutCubic: (t)=>t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
};
function $875b08fe0af98e08$export$b543325d5f654b02(duration = 200, easing = $875b08fe0af98e08$var$Easing2.linear) {
    const [value, setValue] = (0, $5NSbj.useState)(0);
    const startTimeRef = (0, $5NSbj.useRef)(null);
    const raf2 = $875b08fe0af98e08$export$3d0be2420b17e328(()=>{
        if (startTimeRef.current === null) startTimeRef.current = performance.now();
        const elapsed = performance.now() - startTimeRef.current;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = easing(progress);
        setValue(easedProgress);
        if (progress < 1) return true;
        return false;
    }, true);
    (0, $5NSbj.useEffect)(()=>{
        startTimeRef.current = null;
    }, [
        duration,
        easing
    ]);
    return value;
}
function $875b08fe0af98e08$var$isFunctionInitializer(functionToCheck) {
    return typeof functionToCheck === "function";
}
function $875b08fe0af98e08$export$35dec198dbda4c09(initialState, options) {
    const [state, _setState] = (0, $5NSbj.useState)(initialState);
    const [past, setPast] = (0, $5NSbj.useState)([]);
    const [future, setFuture] = (0, $5NSbj.useState)([]);
    const maxDepth = options?.maxDepth ?? 100;
    const undo = (0, $5NSbj.useCallback)(()=>{
        setPast((pastStates)=>{
            const newPast = [
                ...pastStates
            ];
            const previousState = newPast.pop();
            if (typeof previousState !== "undefined") {
                setFuture((futureStates)=>[
                        state,
                        ...futureStates
                    ]);
                _setState(previousState);
            }
            return newPast;
        });
    }, [
        state
    ]);
    const redo = (0, $5NSbj.useCallback)(()=>{
        setFuture((futureStates)=>{
            const newFuture = [
                ...futureStates
            ];
            const nextState = newFuture.shift();
            if (typeof nextState !== "undefined") {
                setPast((pastStates)=>[
                        ...pastStates,
                        state
                    ]);
                _setState(nextState);
            }
            return newFuture;
        });
    }, [
        state
    ]);
    const canUndo = (0, $5NSbj.useCallback)(()=>past.length > 0, [
        past
    ]);
    const canRedo = (0, $5NSbj.useCallback)(()=>future.length > 0, [
        future
    ]);
    const isUndoPossible = (0, $5NSbj.useMemo)(()=>past.length > 0, [
        past
    ]);
    const isRedoPossible = (0, $5NSbj.useMemo)(()=>future.length > 0, [
        future
    ]);
    const setState = (0, $5NSbj.useCallback)((value)=>{
        _setState((prevState)=>{
            const nextState = $875b08fe0af98e08$var$isFunctionInitializer(value) ? value(prevState) : value;
            setPast((pastStates)=>{
                const newPast = [
                    ...pastStates,
                    prevState
                ];
                if (newPast.length > maxDepth) newPast.shift();
                return newPast;
            });
            setFuture([]);
            return nextState;
        });
    }, [
        maxDepth
    ]);
    const clearUndoStack = (0, $5NSbj.useCallback)(()=>{
        setPast([]);
    }, []);
    const clearRedoStack = (0, $5NSbj.useCallback)(()=>{
        setFuture([]);
    }, []);
    const clearAll = (0, $5NSbj.useCallback)(()=>{
        setPast([]);
        setFuture([]);
    }, []);
    const controls = (0, $5NSbj.useMemo)(()=>{
        return {
            undo: undo,
            redo: redo,
            canUndo: canUndo,
            canRedo: canRedo,
            clearUndoStack: clearUndoStack,
            clearRedoStack: clearRedoStack,
            clearAll: clearAll,
            isUndoPossible: isUndoPossible,
            isRedoPossible: isRedoPossible
        };
    }, [
        undo,
        redo,
        canUndo,
        canRedo,
        clearUndoStack,
        clearRedoStack,
        clearAll,
        isUndoPossible,
        isRedoPossible
    ]);
    return [
        state,
        setState,
        controls
    ];
}
function $875b08fe0af98e08$export$165ce7a5158a386d({ isEnabled: isEnabled, pattern: pattern }) {
    (0, $5NSbj.useEffect)(()=>{
        if (!("vibrate" in navigator) || typeof navigator.vibrate !== "function") {
            console.warn("Vibration API not supported by the current browser");
            return;
        }
        if (isEnabled) navigator.vibrate(pattern);
        else navigator.vibrate(0);
        return ()=>{
            navigator.vibrate(0);
        };
    }, [
        isEnabled,
        pattern
    ]);
}
var $875b08fe0af98e08$export$5269023cd97c8c79 = ()=>{
    const videoRef = (0, $5NSbj.useRef)(null);
    const [state, setState] = (0, $5NSbj.useState)({
        currentTime: 0,
        duration: 0,
        isPaused: true,
        isMuted: false,
        volume: 1
    });
    const controls = {
        play: ()=>{
            if (videoRef.current) {
                videoRef.current.play();
                setState({
                    ...state,
                    isPaused: false
                });
            }
        },
        pause: ()=>{
            if (videoRef.current) {
                videoRef.current.pause();
                setState({
                    ...state,
                    isPaused: true
                });
            }
        },
        toggleMute: ()=>{
            if (videoRef.current) {
                videoRef.current.muted = !videoRef.current.muted;
                setState({
                    ...state,
                    isMuted: videoRef.current.muted
                });
            }
        },
        setVolume: (volume)=>{
            if (videoRef.current) {
                videoRef.current.volume = volume;
                setState({
                    ...state,
                    volume: volume
                });
            }
        },
        setCurrentTime: (time)=>{
            if (videoRef.current) {
                videoRef.current.currentTime = time;
                setState({
                    ...state,
                    currentTime: time
                });
            }
        },
        fastForward: (seconds)=>{
            if (videoRef.current) {
                videoRef.current.currentTime += seconds;
                setState({
                    ...state,
                    currentTime: videoRef.current.currentTime
                });
            }
        },
        rewind: (seconds)=>{
            if (videoRef.current) {
                videoRef.current.currentTime -= seconds;
                setState({
                    ...state,
                    currentTime: videoRef.current.currentTime
                });
            }
        },
        toggleFullScreen: ()=>{
            if (videoRef.current) {
                if (document.fullscreenElement) document.exitFullscreen();
                else videoRef.current.requestFullscreen();
            }
        }
    };
    (0, $5NSbj.useEffect)(()=>{
        const video = videoRef.current;
        const handleTimeUpdate = ()=>{
            setState((prevState)=>({
                    ...prevState,
                    currentTime: video.currentTime
                }));
        };
        const handleDurationChange = ()=>{
            setState((prevState)=>({
                    ...prevState,
                    duration: video.duration
                }));
        };
        const handlePause = ()=>{
            setState((prevState)=>({
                    ...prevState,
                    isPaused: true
                }));
        };
        const handlePlay = ()=>{
            setState((prevState)=>({
                    ...prevState,
                    isPaused: false
                }));
        };
        if (video) {
            video.addEventListener("timeupdate", handleTimeUpdate);
            video.addEventListener("durationchange", handleDurationChange);
            video.addEventListener("pause", handlePause);
            video.addEventListener("play", handlePlay);
        }
        return ()=>{
            if (video) {
                video.removeEventListener("timeupdate", handleTimeUpdate);
                video.removeEventListener("durationchange", handleDurationChange);
                video.removeEventListener("pause", handlePause);
                video.removeEventListener("play", handlePlay);
            }
        };
    }, [
        videoRef
    ]);
    return [
        videoRef,
        state,
        controls
    ];
};
function $875b08fe0af98e08$export$cb3ad10de185e7a8(resourceName, options = {}) {
    if (typeof resourceName !== "string") throw new Error("Resource name must be a string");
    const { periodicCheck: periodicCheck = false, checkInterval: checkInterval = 1e3 } = options;
    const isSupported = (0, $5NSbj.useMemo)(()=>{
        return typeof navigator !== "undefined" && navigator.locks !== void 0 && typeof navigator.locks.request === "function";
    }, []);
    const [isLocked, setIsLocked] = (0, $5NSbj.useState)(false);
    const [waitingCount, setWaitingCount] = (0, $5NSbj.useState)(0);
    const [error, setError] = (0, $5NSbj.useState)(null);
    const abortControllerRef = (0, $5NSbj.useRef)(null);
    const periodicCheckTimeoutRef = (0, $5NSbj.useRef)(void 0);
    const setErrorState = (0, $5NSbj.useCallback)((err)=>{
        setError(err);
    }, []);
    const clearError = (0, $5NSbj.useCallback)(()=>{
        setError(null);
    }, []);
    const query = (0, $5NSbj.useCallback)(async ()=>{
        if (!isSupported) {
            const err = new Error("Web Locks API is not supported");
            setErrorState(err);
            throw err;
        }
        try {
            const result = await navigator.locks.query();
            const resourceLocks = result.held?.filter((lock)=>lock.name === resourceName) || [];
            const pendingLocks = result.pending?.filter((lock)=>lock.name === resourceName) || [];
            setIsLocked(resourceLocks.length > 0);
            setWaitingCount(pendingLocks.length);
            clearError();
            return result;
        } catch (err) {
            const error2 = err instanceof Error ? err : new Error("Query failed");
            setErrorState(error2);
            throw error2;
        }
    }, [
        isSupported,
        resourceName,
        setErrorState,
        clearError
    ]);
    const acquire = (0, $5NSbj.useCallback)(async (callback, lockOptions)=>{
        if (!isSupported) {
            const err = new Error("Web Locks API is not supported");
            setErrorState(err);
            throw err;
        }
        try {
            setIsLocked(true);
            clearError();
            let controller = null;
            if (!lockOptions?.signal && !lockOptions?.ifAvailable) {
                controller = new AbortController();
                abortControllerRef.current = controller;
            }
            const finalOptions = {
                ...lockOptions
            };
            if (!lockOptions?.ifAvailable && !lockOptions?.signal && controller) finalOptions.signal = controller.signal;
            else if (lockOptions?.signal) finalOptions.signal = lockOptions.signal;
            const result = await navigator.locks.request(resourceName, finalOptions, async ()=>{
                try {
                    return await callback();
                } catch (err) {
                    const error2 = err instanceof Error ? err : new Error("Callback failed");
                    setErrorState(error2);
                    throw error2;
                }
            });
            return result;
        } catch (err) {
            const error2 = err instanceof Error ? err : new Error("Lock acquisition failed");
            setErrorState(error2);
            throw error2;
        } finally{
            setIsLocked(false);
            abortControllerRef.current = null;
        }
    }, [
        isSupported,
        resourceName,
        setErrorState,
        clearError
    ]);
    const release = (0, $5NSbj.useCallback)(()=>{
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
        }
    }, []);
    (0, $5NSbj.useEffect)(()=>{
        if (!isSupported) return;
        query().catch(()=>{});
        if (periodicCheck) {
            const setupPeriodicCheck = ()=>{
                periodicCheckTimeoutRef.current = window.setTimeout(()=>{
                    query().catch(()=>{}).finally(()=>{
                        setupPeriodicCheck();
                    });
                }, checkInterval);
            };
            setupPeriodicCheck();
        }
        return ()=>{
            if (periodicCheckTimeoutRef.current) {
                window.clearTimeout(periodicCheckTimeoutRef.current);
                periodicCheckTimeoutRef.current = void 0;
            }
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
                abortControllerRef.current = null;
            }
        };
    }, [
        isSupported,
        resourceName,
        periodicCheck,
        checkInterval,
        query
    ]);
    return {
        isSupported: isSupported,
        isLocked: isLocked,
        waitingCount: waitingCount,
        error: error,
        resourceName: resourceName,
        acquire: acquire,
        release: release,
        query: query
    };
}
function $875b08fe0af98e08$export$44bc62d25eb3a976(workerUrl) {
    const [status, setStatus] = (0, $5NSbj.useState)("idle");
    const [data, setData] = (0, $5NSbj.useState)(null);
    const [error, setError] = (0, $5NSbj.useState)(null);
    const workerRef = (0, $5NSbj.useRef)(null);
    const isSupported = typeof window !== "undefined" && "Worker" in window;
    (0, $5NSbj.useEffect)(()=>{
        if (!isSupported || !workerUrl) return;
        try {
            const worker = new Worker(workerUrl);
            workerRef.current = worker;
            worker.onmessage = (event)=>{
                setData(event.data);
                setStatus("success");
                setError(null);
            };
            worker.onerror = (event)=>{
                const err = new Error(event.message || "Worker error");
                setError(err);
                setStatus("error");
            };
            return ()=>{
                worker.terminate();
                workerRef.current = null;
            };
        } catch (err) {
            const error2 = err instanceof Error ? err : new Error("Failed to create worker");
            setError(error2);
            setStatus("error");
        }
    }, [
        workerUrl,
        isSupported
    ]);
    const postMessage = (0, $5NSbj.useCallback)((message)=>{
        if (!isSupported) {
            console.warn("Web Workers are not supported");
            return;
        }
        if (!workerRef.current) {
            console.warn("Worker not initialized");
            return;
        }
        if (status === "terminated") {
            console.warn("Cannot post message to terminated worker");
            return;
        }
        try {
            setStatus("running");
            setError(null);
            workerRef.current.postMessage(message);
        } catch (err) {
            const error2 = err instanceof Error ? err : new Error("Failed to post message");
            setError(error2);
            setStatus("error");
        }
    }, [
        isSupported,
        status
    ]);
    const terminate = (0, $5NSbj.useCallback)(()=>{
        if (workerRef.current) {
            workerRef.current.terminate();
            workerRef.current = null;
            setStatus("terminated");
        }
    }, []);
    return {
        postMessage: postMessage,
        terminate: terminate,
        status: status,
        data: data,
        error: error,
        isSupported: isSupported
    };
}
function $875b08fe0af98e08$export$d610da56a90dcd8d(componentName, currentProps, enableLogging = true) {
    const previousProps = (0, $5NSbj.useRef)({});
    $875b08fe0af98e08$export$e34ed88fef4dc107(()=>{
        if (previousProps.current && enableLogging) {
            const combinedKeys = Object.keys({
                ...previousProps.current,
                ...currentProps
            });
            const changedProps = {};
            combinedKeys.forEach((key)=>{
                if (!Object.is(previousProps.current[key], currentProps[key])) changedProps[key] = {
                    from: previousProps.current[key],
                    to: currentProps[key]
                };
            });
            if (Object.keys(changedProps).length) console.log("[why-did-you-update]", componentName, changedProps);
        }
    }, [
        currentProps,
        componentName,
        enableLogging
    ]);
    (0, $5NSbj.useEffect)(()=>{
        previousProps.current = currentProps;
    });
}
// src/hooks/useWindowEventListener.ts
function $875b08fe0af98e08$export$8efa3c5b6bec5fbd(eventName, callback, listenerOptions = {}, isLayoutEffect = false) {
    $875b08fe0af98e08$var$useGlobalObjectEventListener(typeof window !== "undefined" ? window : void 0, eventName, callback, listenerOptions, true, isLayoutEffect);
}
function $875b08fe0af98e08$var$computeScrollPosition() {
    if (typeof window === "undefined") return {
        scrollX: 0,
        scrollY: 0
    };
    else return {
        scrollX: window.scrollX || window.pageXOffset,
        scrollY: window.scrollY || window.pageYOffset
    };
}
function $875b08fe0af98e08$export$46be7d46e2475cd6() {
    const [scrollPosition, setScrollPosition] = (0, $5NSbj.useState)($875b08fe0af98e08$var$computeScrollPosition);
    $875b08fe0af98e08$export$f2fb712044277d5e(()=>{
        setScrollPosition($875b08fe0af98e08$var$computeScrollPosition());
    }, true, true);
    $875b08fe0af98e08$export$61171a90a6148cf5(()=>{
        setScrollPosition($875b08fe0af98e08$var$computeScrollPosition());
    }, true, true);
    return scrollPosition;
}
var $875b08fe0af98e08$var$nullDimensions = {
    innerHeight: null,
    innerWidth: null,
    outerHeight: null,
    outerWidth: null
};
function $875b08fe0af98e08$var$getDimensions() {
    return {
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth,
        outerHeight: window.outerHeight,
        outerWidth: window.outerWidth
    };
}
function $875b08fe0af98e08$export$42c02f33970a2afa() {
    const cacheRef = (0, $5NSbj.useRef)($875b08fe0af98e08$var$nullDimensions);
    const subscribe3 = (0, $5NSbj.useCallback)((onStoreChange)=>{
        window.addEventListener("resize", onStoreChange);
        return ()=>{
            window.removeEventListener("resize", onStoreChange);
        };
    }, []);
    const getSnapshot2 = (0, $5NSbj.useCallback)(()=>{
        const newDimensions = $875b08fe0af98e08$var$getDimensions();
        if (cacheRef.current.innerHeight !== newDimensions.innerHeight || cacheRef.current.innerWidth !== newDimensions.innerWidth || cacheRef.current.outerHeight !== newDimensions.outerHeight || cacheRef.current.outerWidth !== newDimensions.outerWidth) cacheRef.current = newDimensions;
        return cacheRef.current;
    }, []);
    const getServerSnapshot = (0, $5NSbj.useCallback)(()=>{
        return $875b08fe0af98e08$var$nullDimensions;
    }, []);
    return (0, $5NSbj.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
}
function $875b08fe0af98e08$var$isFocusedElementEditable() {
    const { activeElement: activeElement, body: body } = document;
    if (!activeElement) return false;
    if (activeElement === body) return false;
    const tag = activeElement.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA") return true;
    return activeElement.hasAttribute("contenteditable");
}
function $875b08fe0af98e08$var$isAllowedKey(event, options) {
    if (event.metaKey || event.ctrlKey || event.altKey) return false;
    const { key: key } = event;
    if (options.includeAZ && /^[a-zA-Z]$/.test(key)) return true;
    if (options.includeNumbers && /^[0-9]$/.test(key)) return true;
    return false;
}
function $875b08fe0af98e08$export$906b9e7f6c564e10(callback, options) {
    const opts = {
        includeAZ: true,
        includeNumbers: false,
        ...options
    };
    const freshCallback = $875b08fe0af98e08$export$699327ecb1dd6b0d(callback);
    const handler = (0, $5NSbj.useCallback)((event)=>{
        if (!$875b08fe0af98e08$var$isFocusedElementEditable() && $875b08fe0af98e08$var$isAllowedKey(event, opts)) freshCallback(event);
    }, [
        freshCallback,
        opts.includeAZ,
        opts.includeNumbers
    ]);
    (0, $0302d50d2b00a3cf$export$363c9f3eb56bbdbe)(()=>{
        document.addEventListener("keydown", handler);
        return ()=>{
            document.removeEventListener("keydown", handler);
        };
    }, [
        handler
    ]);
}





function $75268d55fcc03c89$export$2e2bcd8739ae039(props) {
    const { setTitle: setTitle } = props;
    const navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    const [message, submitAction, isPending] = (0, $5NSbj.useActionState)(async (_previousState, formData)=>{
        const file = formData.get('opml');
        try {
            const { response: response, data: data } = await (0, $139c0902db4c349b$export$b3b4cde15a96b715)(file);
            const { messages: messages } = data;
            if (response.status === 200) return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("p", {
                className: "msg success",
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("ul", {
                        children: messages.map((msg, i)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                                children: msg
                            }, i))
                    }),
                    "You might want to ",
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("a", {
                        href: "update",
                        children: "update now"
                    }),
                    " or",
                    ' ',
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $1b28ddd4ebfaf955$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: "view your feeds"
                    }),
                    "."
                ]
            });
            else if (response.status === 202) return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("p", {
                className: "msg error",
                children: [
                    "The following feeds could not be imported:",
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("ul", {
                        children: messages.map((msg, i)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                                children: msg
                            }, i))
                    })
                ]
            });
            else if (response.status === 400) return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("p", {
                className: "msg error",
                children: [
                    "There was a problem importing your OPML file:",
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("ul", {
                        children: messages.map((msg, i)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                                children: msg
                            }, i))
                    })
                ]
            });
            else throw new (0, $b82622975d92f7af$export$4511c7da58e2d9c2)(`OPML import handler received status ${response.status}. This should not happen.`);
        } catch (error) {
            if (error instanceof (0, $b82622975d92f7af$export$65bd6083489bd8bb) && error.response.status === 403) {
                navigate('/sign/in', {
                    state: {
                        error: "Importing OPML file requires being logged in or not setting \u201Cpassword\u201D in selfoss configuration.",
                        returnLocation: '/opml'
                    }
                });
                return null;
            } else return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                className: "msg error",
                children: [
                    "Unexpected error occurred.",
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("details", {
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("pre", {
                            children: error.message
                        })
                    })
                ]
            });
        }
    }, null);
    const submit = (0, $5NSbj.useCallback)((event)=>{
        // We cannot use `action` prop with `enctype`.
        event.preventDefault();
        const formData = new (0, $fbb973a7ef395689$export$5300a9e19ff2767e)(event.currentTarget);
        (0, $5NSbj.startTransition)(()=>submitAction(formData));
    }, [
        submitAction
    ]);
    (0, $5NSbj.useEffect)(()=>{
        setTitle('selfoss OPML importer');
        return ()=>{
            setTitle(null);
        };
    }, [
        setTitle
    ]);
    const isOnline = (0, $875b08fe0af98e08$export$6feb6ada280bcdab)();
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("form", {
        action: "",
        method: "post",
        encType: "multipart/form-data",
        onSubmit: submit,
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
            id: "opml",
            children: [
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h1", {
                        children: "Upload an OPML File"
                    })
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("p", {
                        children: "Coming from a different RSS Reader? Export your subscriptions to an OPML file and upload it here. OPML export is usually located somewhere in settings, consult the reader\u2019s manual."
                    })
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    className: "message-container",
                    "aria-live": "assertive",
                    children: [
                        !isOnline && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                            className: "msg error",
                            children: "OPML import requires an internet connection. Please reconnect before proceeding."
                        }),
                        !isPending && message
                    ]
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    className: "center",
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            htmlFor: "opml",
                            children: "Opml.xml:"
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                            type: "file",
                            name: "opml",
                            accessKey: "f",
                            id: "opml",
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    className: "button",
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                            type: "submit",
                            value: isPending ? "Importing\u2026" : 'Deliver my OPML!',
                            accessKey: "d",
                            disabled: !isOnline || isPending
                        })
                    ]
                })
            ]
        })
    });
}





var $5NSbj = parcelRequire("5NSbj");


/**
 * Object describing how feed items are filtered in the view.
 */ var $42d3119d6a1baa33$export$c67e46de1ec7dfa6 = /*#__PURE__*/ function(FilterType) {
    FilterType["NEWEST"] = "newest";
    FilterType["UNREAD"] = "unread";
    FilterType["STARRED"] = "starred";
    return FilterType;
}({});


function $dcbcccfe7d0a797a$export$45d76561a5302f2b() {
    return (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
}
function $dcbcccfe7d0a797a$export$46e843a62e9cebcc(type) {
    if (type == 'newest') return (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).NEWEST;
    else if (type == 'unread') return (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).UNREAD;
    else if (type == 'starred') return (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).STARRED;
    else throw new Error(`Invalid filter type: \u{201C}${type}\u{201D}`);
}
function $dcbcccfe7d0a797a$export$63b3966ca4cc85d9(type) {
    if (type == (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).NEWEST) return 'newest';
    else if (type == (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).UNREAD) return 'unread';
    else if (type == (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).STARRED) return 'starred';
    else throw new Error(`Invalid filter type: \u{201C}${type}\u{201D}`);
}
function $dcbcccfe7d0a797a$var$generatePath({ filter: filter, category: category, id: id }) {
    return `/${filter}/${category}${id ? `/${id}` : ''}`;
}
function $dcbcccfe7d0a797a$export$216385125ee84ae7() {
    const match = (0, $4a2ef0180f3aa5fe$export$6c330e8992e8a295)(':filter/:category/:id?');
    if (match === null) return null;
    const { params: params } = match;
    if (!params.filter || !params.category) // Note: it isn't possible to reach this part of the code
    //       This is to keep the TypeScript compiler happy
    return null;
    const filterValid = /^(newest|unread|starred)$/.test(params.filter);
    const categoryValid = /^(all|tag-.+|source-[0-9]+)$/.test(params.category);
    const idValid = params.id === undefined || /^\d+$/.test(params.id);
    if (!filterValid || !idValid || !categoryValid) return null;
    return {
        filter: $dcbcccfe7d0a797a$export$46e843a62e9cebcc(params.filter),
        category: params.category,
        id: params.id === undefined ? null : parseInt(params.id, 10)
    };
}
function $dcbcccfe7d0a797a$export$d0bb2ab5375d1521(location, { filter: filter, category: category, id: id, search: search }) {
    const queryString = new URLSearchParams(location.search);
    let path;
    if (location.pathname.match(/^\/(newest|unread|starred)\//) !== null) {
        const [, ...segments] = location.pathname.split('/');
        path = $dcbcccfe7d0a797a$var$generatePath({
            filter: filter ?? segments[0],
            category: category ?? segments[1],
            id: typeof id !== 'undefined' ? id : segments[2]
        });
    } else path = $dcbcccfe7d0a797a$var$generatePath({
        // TODO: change default from config
        filter: filter ?? 'unread',
        category: category ?? 'all',
        id: id
    });
    if (typeof search !== 'undefined') {
        if (search) queryString.set('search', search);
        else queryString.delete('search');
    }
    return {
        pathname: path,
        search: queryString.toString()
    };
}
function $dcbcccfe7d0a797a$export$7f0beea2aa79e4fa(location, params) {
    const { pathname: pathname, search: search } = $dcbcccfe7d0a797a$export$d0bb2ab5375d1521(location, params);
    return pathname + (search !== '' ? `?${search}` : '');
}
function $dcbcccfe7d0a797a$export$e64cf1b9b4b3aa56(location) {
    const state = location.state ?? {};
    return {
        ...state,
        forceReload: (state.forceReload ?? 0) + 1
    };
}
function $dcbcccfe7d0a797a$export$6bccca1b7088ecd7() {
    const location = $dcbcccfe7d0a797a$export$45d76561a5302f2b();
    return $dcbcccfe7d0a797a$export$e64cf1b9b4b3aa56(location);
}




parcelRequire("5NSbj");

var $3af4382a42f8c157$exports = {};
'use strict';
Object.defineProperty($3af4382a42f8c157$exports, '__esModule', {
    value: true
});
var $3af4382a42f8c157$var$prefix = 'fab';
var $3af4382a42f8c157$var$iconName = 'diaspora';
var $3af4382a42f8c157$var$width = 448;
var $3af4382a42f8c157$var$height = 512;
var $3af4382a42f8c157$var$aliases = [];
var $3af4382a42f8c157$var$unicode = 'f791';
var $3af4382a42f8c157$var$svgPathData = 'M219.7 354.6c-1.4 0-88 119.9-88.7 119.9S44.4 414 44 413.3 130.6 287.5 130.6 285.8c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1 .6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3 .4-2 1-148.6 1.7-149.6 .8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3 .8 .9 31.9 102.2 31.5 102.6-.9 .9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5l0 0z';
$3af4382a42f8c157$exports.definition = {
    prefix: $3af4382a42f8c157$var$prefix,
    iconName: $3af4382a42f8c157$var$iconName,
    icon: [
        $3af4382a42f8c157$var$width,
        $3af4382a42f8c157$var$height,
        $3af4382a42f8c157$var$aliases,
        $3af4382a42f8c157$var$unicode,
        $3af4382a42f8c157$var$svgPathData
    ]
};
$3af4382a42f8c157$exports.faDiaspora = $3af4382a42f8c157$exports.definition;
$3af4382a42f8c157$exports.prefix = $3af4382a42f8c157$var$prefix;
$3af4382a42f8c157$exports.iconName = $3af4382a42f8c157$var$iconName;
$3af4382a42f8c157$exports.width = $3af4382a42f8c157$var$width;
$3af4382a42f8c157$exports.height = $3af4382a42f8c157$var$height;
$3af4382a42f8c157$exports.ligatures = $3af4382a42f8c157$var$aliases;
$3af4382a42f8c157$exports.unicode = $3af4382a42f8c157$var$unicode;
$3af4382a42f8c157$exports.svgPathData = $3af4382a42f8c157$var$svgPathData;
$3af4382a42f8c157$exports.aliases = $3af4382a42f8c157$var$aliases;


var $164536c7567608d5$exports = {};
'use strict';
Object.defineProperty($164536c7567608d5$exports, '__esModule', {
    value: true
});
var $d0fe6b5e5bc9cff1$exports = {};
'use strict';
Object.defineProperty($d0fe6b5e5bc9cff1$exports, '__esModule', {
    value: true
});
var $d0fe6b5e5bc9cff1$var$prefix = 'fab';
var $d0fe6b5e5bc9cff1$var$iconName = 'square-facebook';
var $d0fe6b5e5bc9cff1$var$width = 448;
var $d0fe6b5e5bc9cff1$var$height = 512;
var $d0fe6b5e5bc9cff1$var$aliases = [
    "facebook-square"
];
var $d0fe6b5e5bc9cff1$var$unicode = 'f082';
var $d0fe6b5e5bc9cff1$var$svgPathData = 'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l98.2 0 0-145.8-52.8 0 0-78.2 52.8 0 0-33.7c0-87.1 39.4-127.5 125-127.5 16.2 0 44.2 3.2 55.7 6.4l0 70.8c-6-.6-16.5-1-29.6-1-42 0-58.2 15.9-58.2 57.2l0 27.8 83.6 0-14.4 78.2-69.3 0 0 145.8 129 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z';
$d0fe6b5e5bc9cff1$exports.definition = {
    prefix: $d0fe6b5e5bc9cff1$var$prefix,
    iconName: $d0fe6b5e5bc9cff1$var$iconName,
    icon: [
        $d0fe6b5e5bc9cff1$var$width,
        $d0fe6b5e5bc9cff1$var$height,
        $d0fe6b5e5bc9cff1$var$aliases,
        $d0fe6b5e5bc9cff1$var$unicode,
        $d0fe6b5e5bc9cff1$var$svgPathData
    ]
};
$d0fe6b5e5bc9cff1$exports.faSquareFacebook = $d0fe6b5e5bc9cff1$exports.definition;
$d0fe6b5e5bc9cff1$exports.prefix = $d0fe6b5e5bc9cff1$var$prefix;
$d0fe6b5e5bc9cff1$exports.iconName = $d0fe6b5e5bc9cff1$var$iconName;
$d0fe6b5e5bc9cff1$exports.width = $d0fe6b5e5bc9cff1$var$width;
$d0fe6b5e5bc9cff1$exports.height = $d0fe6b5e5bc9cff1$var$height;
$d0fe6b5e5bc9cff1$exports.ligatures = $d0fe6b5e5bc9cff1$var$aliases;
$d0fe6b5e5bc9cff1$exports.unicode = $d0fe6b5e5bc9cff1$var$unicode;
$d0fe6b5e5bc9cff1$exports.svgPathData = $d0fe6b5e5bc9cff1$var$svgPathData;
$d0fe6b5e5bc9cff1$exports.aliases = $d0fe6b5e5bc9cff1$var$aliases;


$164536c7567608d5$exports.definition = {
    prefix: $d0fe6b5e5bc9cff1$exports.prefix,
    iconName: $d0fe6b5e5bc9cff1$exports.iconName,
    icon: [
        $d0fe6b5e5bc9cff1$exports.width,
        $d0fe6b5e5bc9cff1$exports.height,
        $d0fe6b5e5bc9cff1$exports.aliases,
        $d0fe6b5e5bc9cff1$exports.unicode,
        $d0fe6b5e5bc9cff1$exports.svgPathData
    ]
};
$164536c7567608d5$exports.faFacebookSquare = $164536c7567608d5$exports.definition;
$164536c7567608d5$exports.prefix = $d0fe6b5e5bc9cff1$exports.prefix;
$164536c7567608d5$exports.iconName = $d0fe6b5e5bc9cff1$exports.iconName;
$164536c7567608d5$exports.width = $d0fe6b5e5bc9cff1$exports.width;
$164536c7567608d5$exports.height = $d0fe6b5e5bc9cff1$exports.height;
$164536c7567608d5$exports.ligatures = $d0fe6b5e5bc9cff1$exports.aliases;
$164536c7567608d5$exports.unicode = $d0fe6b5e5bc9cff1$exports.unicode;
$164536c7567608d5$exports.svgPathData = $d0fe6b5e5bc9cff1$exports.svgPathData;
$164536c7567608d5$exports.aliases = $d0fe6b5e5bc9cff1$exports.aliases;


var $d7a77b6f799d2f63$exports = {};
'use strict';
Object.defineProperty($d7a77b6f799d2f63$exports, '__esModule', {
    value: true
});
var $d7a77b6f799d2f63$var$prefix = 'fab';
var $d7a77b6f799d2f63$var$iconName = 'get-pocket';
var $d7a77b6f799d2f63$var$width = 448;
var $d7a77b6f799d2f63$var$height = 512;
var $d7a77b6f799d2f63$var$aliases = [];
var $d7a77b6f799d2f63$var$unicode = 'f265';
var $d7a77b6f799d2f63$var$svgPathData = 'M407.6 64l-367 0C18.5 64 0 82.5 0 104.6L0 239.8C0 364.5 99.7 464 224.2 464 348.2 464 448 364.5 448 239.8l0-135.2C448 82.2 430.3 64 407.6 64zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0-113.7-108.9-114.9-105.1-114.9-123.2 0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3s30.7 13.8 30.7 30.7c0 17.8-2.9 15.7-114.8 123.2z';
$d7a77b6f799d2f63$exports.definition = {
    prefix: $d7a77b6f799d2f63$var$prefix,
    iconName: $d7a77b6f799d2f63$var$iconName,
    icon: [
        $d7a77b6f799d2f63$var$width,
        $d7a77b6f799d2f63$var$height,
        $d7a77b6f799d2f63$var$aliases,
        $d7a77b6f799d2f63$var$unicode,
        $d7a77b6f799d2f63$var$svgPathData
    ]
};
$d7a77b6f799d2f63$exports.faGetPocket = $d7a77b6f799d2f63$exports.definition;
$d7a77b6f799d2f63$exports.prefix = $d7a77b6f799d2f63$var$prefix;
$d7a77b6f799d2f63$exports.iconName = $d7a77b6f799d2f63$var$iconName;
$d7a77b6f799d2f63$exports.width = $d7a77b6f799d2f63$var$width;
$d7a77b6f799d2f63$exports.height = $d7a77b6f799d2f63$var$height;
$d7a77b6f799d2f63$exports.ligatures = $d7a77b6f799d2f63$var$aliases;
$d7a77b6f799d2f63$exports.unicode = $d7a77b6f799d2f63$var$unicode;
$d7a77b6f799d2f63$exports.svgPathData = $d7a77b6f799d2f63$var$svgPathData;
$d7a77b6f799d2f63$exports.aliases = $d7a77b6f799d2f63$var$aliases;


var $d7e8063e124a7dab$exports = {};
'use strict';
Object.defineProperty($d7e8063e124a7dab$exports, '__esModule', {
    value: true
});
var $d7e8063e124a7dab$var$prefix = 'fab';
var $d7e8063e124a7dab$var$iconName = 'twitter';
var $d7e8063e124a7dab$var$width = 512;
var $d7e8063e124a7dab$var$height = 512;
var $d7e8063e124a7dab$var$aliases = [];
var $d7e8063e124a7dab$var$unicode = 'f099';
var $d7e8063e124a7dab$var$svgPathData = 'M459.4 151.7c.3 4.5 .3 9.1 .3 13.6 0 138.7-105.6 298.6-298.6 298.6-59.5 0-114.7-17.2-161.1-47.1 8.4 1 16.6 1.3 25.3 1.3 49.1 0 94.2-16.6 130.3-44.8-46.1-1-84.8-31.2-98.1-72.8 6.5 1 13 1.6 19.8 1.6 9.4 0 18.8-1.3 27.6-3.6-48.1-9.7-84.1-52-84.1-103l0-1.3c14 7.8 30.2 12.7 47.4 13.3-28.3-18.8-46.8-51-46.8-87.4 0-19.5 5.2-37.4 14.3-53 51.7 63.7 129.3 105.3 216.4 109.8-1.6-7.8-2.6-15.9-2.6-24 0-57.8 46.8-104.9 104.9-104.9 30.2 0 57.5 12.7 76.7 33.1 23.7-4.5 46.5-13.3 66.6-25.3-7.8 24.4-24.4 44.8-46.1 57.8 21.1-2.3 41.6-8.1 60.4-16.2-14.3 20.8-32.2 39.3-52.6 54.3z';
$d7e8063e124a7dab$exports.definition = {
    prefix: $d7e8063e124a7dab$var$prefix,
    iconName: $d7e8063e124a7dab$var$iconName,
    icon: [
        $d7e8063e124a7dab$var$width,
        $d7e8063e124a7dab$var$height,
        $d7e8063e124a7dab$var$aliases,
        $d7e8063e124a7dab$var$unicode,
        $d7e8063e124a7dab$var$svgPathData
    ]
};
$d7e8063e124a7dab$exports.faTwitter = $d7e8063e124a7dab$exports.definition;
$d7e8063e124a7dab$exports.prefix = $d7e8063e124a7dab$var$prefix;
$d7e8063e124a7dab$exports.iconName = $d7e8063e124a7dab$var$iconName;
$d7e8063e124a7dab$exports.width = $d7e8063e124a7dab$var$width;
$d7e8063e124a7dab$exports.height = $d7e8063e124a7dab$var$height;
$d7e8063e124a7dab$exports.ligatures = $d7e8063e124a7dab$var$aliases;
$d7e8063e124a7dab$exports.unicode = $d7e8063e124a7dab$var$unicode;
$d7e8063e124a7dab$exports.svgPathData = $d7e8063e124a7dab$var$svgPathData;
$d7e8063e124a7dab$exports.aliases = $d7e8063e124a7dab$var$aliases;


var $ee1da5f4ecb633d4$exports = {};
'use strict';
Object.defineProperty($ee1da5f4ecb633d4$exports, '__esModule', {
    value: true
});
var $ee1da5f4ecb633d4$var$prefix = 'fab';
var $ee1da5f4ecb633d4$var$iconName = 'wordpress-simple';
var $ee1da5f4ecb633d4$var$width = 512;
var $ee1da5f4ecb633d4$var$height = 512;
var $ee1da5f4ecb633d4$var$aliases = [];
var $ee1da5f4ecb633d4$var$unicode = 'f411';
var $ee1da5f4ecb633d4$var$svgPathData = 'M256 8a248 248 0 1 0 0 496 248 248 0 1 0 0-496zM33 256c0-32.3 6.9-63 19.3-90.7L158.7 456.7C84.3 420.5 33 344.2 33 256zM256 479c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2-48.8 146.3-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3 39.9-60.5 108.4-100.5 186.3-100.5 58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z';
$ee1da5f4ecb633d4$exports.definition = {
    prefix: $ee1da5f4ecb633d4$var$prefix,
    iconName: $ee1da5f4ecb633d4$var$iconName,
    icon: [
        $ee1da5f4ecb633d4$var$width,
        $ee1da5f4ecb633d4$var$height,
        $ee1da5f4ecb633d4$var$aliases,
        $ee1da5f4ecb633d4$var$unicode,
        $ee1da5f4ecb633d4$var$svgPathData
    ]
};
$ee1da5f4ecb633d4$exports.faWordpressSimple = $ee1da5f4ecb633d4$exports.definition;
$ee1da5f4ecb633d4$exports.prefix = $ee1da5f4ecb633d4$var$prefix;
$ee1da5f4ecb633d4$exports.iconName = $ee1da5f4ecb633d4$var$iconName;
$ee1da5f4ecb633d4$exports.width = $ee1da5f4ecb633d4$var$width;
$ee1da5f4ecb633d4$exports.height = $ee1da5f4ecb633d4$var$height;
$ee1da5f4ecb633d4$exports.ligatures = $ee1da5f4ecb633d4$var$aliases;
$ee1da5f4ecb633d4$exports.unicode = $ee1da5f4ecb633d4$var$unicode;
$ee1da5f4ecb633d4$exports.svgPathData = $ee1da5f4ecb633d4$var$svgPathData;
$ee1da5f4ecb633d4$exports.aliases = $ee1da5f4ecb633d4$var$aliases;


var $e15eeddf947b426f$exports = {};
'use strict';
Object.defineProperty($e15eeddf947b426f$exports, '__esModule', {
    value: true
});
var $e15eeddf947b426f$var$prefix = 'fab';
var $e15eeddf947b426f$var$iconName = 'mastodon';
var $e15eeddf947b426f$var$width = 448;
var $e15eeddf947b426f$var$height = 512;
var $e15eeddf947b426f$var$aliases = [];
var $e15eeddf947b426f$var$unicode = 'f4f6';
var $e15eeddf947b426f$var$svgPathData = 'M433 179.1c0-97.2-63.7-125.7-63.7-125.7-62.5-28.7-228.6-28.4-290.5 0 0 0-63.7 28.5-63.7 125.7 0 115.7-6.6 259.4 105.6 289.1 40.5 10.7 75.3 13 103.3 11.4 50.8-2.8 79.3-18.1 79.3-18.1l-1.7-36.9s-36.3 11.4-77.1 10.1c-40.4-1.4-83-4.4-89.6-54-.6-4.6-.9-9.3-.9-13.9 85.6 20.9 158.7 9.1 178.7 6.7 56.1-6.7 105-41.3 111.2-72.9 9.8-49.8 9-121.5 9-121.5zM357.9 304.3l-46.6 0 0-114.2c0-49.7-64-51.6-64 6.9l0 62.5-46.3 0 0-62.5c0-58.5-64-56.6-64-6.9l0 114.2-46.7 0c0-122.1-5.2-147.9 18.4-175 25.9-28.9 79.8-30.8 103.8 6.1l11.6 19.5 11.6-19.5c24.1-37.1 78.1-34.8 103.8-6.1 23.7 27.3 18.4 53 18.4 175l0 0z';
$e15eeddf947b426f$exports.definition = {
    prefix: $e15eeddf947b426f$var$prefix,
    iconName: $e15eeddf947b426f$var$iconName,
    icon: [
        $e15eeddf947b426f$var$width,
        $e15eeddf947b426f$var$height,
        $e15eeddf947b426f$var$aliases,
        $e15eeddf947b426f$var$unicode,
        $e15eeddf947b426f$var$svgPathData
    ]
};
$e15eeddf947b426f$exports.faMastodon = $e15eeddf947b426f$exports.definition;
$e15eeddf947b426f$exports.prefix = $e15eeddf947b426f$var$prefix;
$e15eeddf947b426f$exports.iconName = $e15eeddf947b426f$var$iconName;
$e15eeddf947b426f$exports.width = $e15eeddf947b426f$var$width;
$e15eeddf947b426f$exports.height = $e15eeddf947b426f$var$height;
$e15eeddf947b426f$exports.ligatures = $e15eeddf947b426f$var$aliases;
$e15eeddf947b426f$exports.unicode = $e15eeddf947b426f$var$unicode;
$e15eeddf947b426f$exports.svgPathData = $e15eeddf947b426f$var$svgPathData;
$e15eeddf947b426f$exports.aliases = $e15eeddf947b426f$var$aliases;


var $154f2d6577c9bf5d$exports = {};
'use strict';
Object.defineProperty($154f2d6577c9bf5d$exports, '__esModule', {
    value: true
});
var $d3388fc3d30da66a$exports = {};
'use strict';
Object.defineProperty($d3388fc3d30da66a$exports, '__esModule', {
    value: true
});
var $d3388fc3d30da66a$var$prefix = 'far';
var $d3388fc3d30da66a$var$iconName = 'circle-check';
var $d3388fc3d30da66a$var$width = 512;
var $d3388fc3d30da66a$var$height = 512;
var $d3388fc3d30da66a$var$aliases = [
    61533,
    "check-circle"
];
var $d3388fc3d30da66a$var$unicode = 'f058';
var $d3388fc3d30da66a$var$svgPathData = 'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-464a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm70.7 121.9c7.8-10.7 22.8-13.1 33.5-5.3 10.7 7.8 13.1 22.8 5.3 33.5L243.4 366.1c-4.1 5.7-10.5 9.3-17.5 9.8-7 .5-13.9-2-18.8-6.9l-55.9-55.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36 36 105.6-145.2z';
$d3388fc3d30da66a$exports.definition = {
    prefix: $d3388fc3d30da66a$var$prefix,
    iconName: $d3388fc3d30da66a$var$iconName,
    icon: [
        $d3388fc3d30da66a$var$width,
        $d3388fc3d30da66a$var$height,
        $d3388fc3d30da66a$var$aliases,
        $d3388fc3d30da66a$var$unicode,
        $d3388fc3d30da66a$var$svgPathData
    ]
};
$d3388fc3d30da66a$exports.faCircleCheck = $d3388fc3d30da66a$exports.definition;
$d3388fc3d30da66a$exports.prefix = $d3388fc3d30da66a$var$prefix;
$d3388fc3d30da66a$exports.iconName = $d3388fc3d30da66a$var$iconName;
$d3388fc3d30da66a$exports.width = $d3388fc3d30da66a$var$width;
$d3388fc3d30da66a$exports.height = $d3388fc3d30da66a$var$height;
$d3388fc3d30da66a$exports.ligatures = $d3388fc3d30da66a$var$aliases;
$d3388fc3d30da66a$exports.unicode = $d3388fc3d30da66a$var$unicode;
$d3388fc3d30da66a$exports.svgPathData = $d3388fc3d30da66a$var$svgPathData;
$d3388fc3d30da66a$exports.aliases = $d3388fc3d30da66a$var$aliases;


$154f2d6577c9bf5d$exports.definition = {
    prefix: $d3388fc3d30da66a$exports.prefix,
    iconName: $d3388fc3d30da66a$exports.iconName,
    icon: [
        $d3388fc3d30da66a$exports.width,
        $d3388fc3d30da66a$exports.height,
        $d3388fc3d30da66a$exports.aliases,
        $d3388fc3d30da66a$exports.unicode,
        $d3388fc3d30da66a$exports.svgPathData
    ]
};
$154f2d6577c9bf5d$exports.faCheckCircle = $154f2d6577c9bf5d$exports.definition;
$154f2d6577c9bf5d$exports.prefix = $d3388fc3d30da66a$exports.prefix;
$154f2d6577c9bf5d$exports.iconName = $d3388fc3d30da66a$exports.iconName;
$154f2d6577c9bf5d$exports.width = $d3388fc3d30da66a$exports.width;
$154f2d6577c9bf5d$exports.height = $d3388fc3d30da66a$exports.height;
$154f2d6577c9bf5d$exports.ligatures = $d3388fc3d30da66a$exports.aliases;
$154f2d6577c9bf5d$exports.unicode = $d3388fc3d30da66a$exports.unicode;
$154f2d6577c9bf5d$exports.svgPathData = $d3388fc3d30da66a$exports.svgPathData;
$154f2d6577c9bf5d$exports.aliases = $d3388fc3d30da66a$exports.aliases;


var $1e8ca391384385ce$exports = {};
'use strict';
Object.defineProperty($1e8ca391384385ce$exports, '__esModule', {
    value: true
});
var $1e8ca391384385ce$var$prefix = 'far';
var $1e8ca391384385ce$var$iconName = 'star';
var $1e8ca391384385ce$var$width = 576;
var $1e8ca391384385ce$var$height = 512;
var $1e8ca391384385ce$var$aliases = [
    11088,
    61446
];
var $1e8ca391384385ce$var$unicode = 'f005';
var $1e8ca391384385ce$var$svgPathData = 'M288.1-32c9 0 17.3 5.1 21.4 13.1L383 125.3 542.9 150.7c8.9 1.4 16.3 7.7 19.1 16.3s.5 18-5.8 24.4L441.7 305.9 467 465.8c1.4 8.9-2.3 17.9-9.6 23.2s-17 6.1-25 2L288.1 417.6 143.8 491c-8 4.1-17.7 3.3-25-2s-11-14.2-9.6-23.2L134.4 305.9 20 191.4c-6.4-6.4-8.6-15.8-5.8-24.4s10.1-14.9 19.1-16.3l159.9-25.4 73.6-144.2c4.1-8 12.4-13.1 21.4-13.1zm0 76.8L230.3 158c-3.5 6.8-10 11.6-17.6 12.8l-125.5 20 89.8 89.9c5.4 5.4 7.9 13.1 6.7 20.7l-19.8 125.5 113.3-57.6c6.8-3.5 14.9-3.5 21.8 0l113.3 57.6-19.8-125.5c-1.2-7.6 1.3-15.3 6.7-20.7l89.8-89.9-125.5-20c-7.6-1.2-14.1-6-17.6-12.8L288.1 44.8z';
$1e8ca391384385ce$exports.definition = {
    prefix: $1e8ca391384385ce$var$prefix,
    iconName: $1e8ca391384385ce$var$iconName,
    icon: [
        $1e8ca391384385ce$var$width,
        $1e8ca391384385ce$var$height,
        $1e8ca391384385ce$var$aliases,
        $1e8ca391384385ce$var$unicode,
        $1e8ca391384385ce$var$svgPathData
    ]
};
$1e8ca391384385ce$exports.faStar = $1e8ca391384385ce$exports.definition;
$1e8ca391384385ce$exports.prefix = $1e8ca391384385ce$var$prefix;
$1e8ca391384385ce$exports.iconName = $1e8ca391384385ce$var$iconName;
$1e8ca391384385ce$exports.width = $1e8ca391384385ce$var$width;
$1e8ca391384385ce$exports.height = $1e8ca391384385ce$var$height;
$1e8ca391384385ce$exports.ligatures = $1e8ca391384385ce$var$aliases;
$1e8ca391384385ce$exports.unicode = $1e8ca391384385ce$var$unicode;
$1e8ca391384385ce$exports.svgPathData = $1e8ca391384385ce$var$svgPathData;
$1e8ca391384385ce$exports.aliases = $1e8ca391384385ce$var$aliases;


var $72abcd8059f7a937$exports = {};
'use strict';
Object.defineProperty($72abcd8059f7a937$exports, '__esModule', {
    value: true
});
var $5b42293b476b3f18$exports = {};
'use strict';
Object.defineProperty($5b42293b476b3f18$exports, '__esModule', {
    value: true
});
var $5b42293b476b3f18$var$prefix = 'far';
var $5b42293b476b3f18$var$iconName = 'circle-xmark';
var $5b42293b476b3f18$var$width = 512;
var $5b42293b476b3f18$var$height = 512;
var $5b42293b476b3f18$var$aliases = [
    61532,
    "times-circle",
    "xmark-circle"
];
var $5b42293b476b3f18$var$unicode = 'f057';
var $5b42293b476b3f18$var$svgPathData = 'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM167 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z';
$5b42293b476b3f18$exports.definition = {
    prefix: $5b42293b476b3f18$var$prefix,
    iconName: $5b42293b476b3f18$var$iconName,
    icon: [
        $5b42293b476b3f18$var$width,
        $5b42293b476b3f18$var$height,
        $5b42293b476b3f18$var$aliases,
        $5b42293b476b3f18$var$unicode,
        $5b42293b476b3f18$var$svgPathData
    ]
};
$5b42293b476b3f18$exports.faCircleXmark = $5b42293b476b3f18$exports.definition;
$5b42293b476b3f18$exports.prefix = $5b42293b476b3f18$var$prefix;
$5b42293b476b3f18$exports.iconName = $5b42293b476b3f18$var$iconName;
$5b42293b476b3f18$exports.width = $5b42293b476b3f18$var$width;
$5b42293b476b3f18$exports.height = $5b42293b476b3f18$var$height;
$5b42293b476b3f18$exports.ligatures = $5b42293b476b3f18$var$aliases;
$5b42293b476b3f18$exports.unicode = $5b42293b476b3f18$var$unicode;
$5b42293b476b3f18$exports.svgPathData = $5b42293b476b3f18$var$svgPathData;
$5b42293b476b3f18$exports.aliases = $5b42293b476b3f18$var$aliases;


$72abcd8059f7a937$exports.definition = {
    prefix: $5b42293b476b3f18$exports.prefix,
    iconName: $5b42293b476b3f18$exports.iconName,
    icon: [
        $5b42293b476b3f18$exports.width,
        $5b42293b476b3f18$exports.height,
        $5b42293b476b3f18$exports.aliases,
        $5b42293b476b3f18$exports.unicode,
        $5b42293b476b3f18$exports.svgPathData
    ]
};
$72abcd8059f7a937$exports.faTimesCircle = $72abcd8059f7a937$exports.definition;
$72abcd8059f7a937$exports.prefix = $5b42293b476b3f18$exports.prefix;
$72abcd8059f7a937$exports.iconName = $5b42293b476b3f18$exports.iconName;
$72abcd8059f7a937$exports.width = $5b42293b476b3f18$exports.width;
$72abcd8059f7a937$exports.height = $5b42293b476b3f18$exports.height;
$72abcd8059f7a937$exports.ligatures = $5b42293b476b3f18$exports.aliases;
$72abcd8059f7a937$exports.unicode = $5b42293b476b3f18$exports.unicode;
$72abcd8059f7a937$exports.svgPathData = $5b42293b476b3f18$exports.svgPathData;
$72abcd8059f7a937$exports.aliases = $5b42293b476b3f18$exports.aliases;


var $2feb01c0637ffeff$exports = {};
'use strict';
Object.defineProperty($2feb01c0637ffeff$exports, '__esModule', {
    value: true
});
var $53d82ec27a6b7ce9$exports = {};
'use strict';
Object.defineProperty($53d82ec27a6b7ce9$exports, '__esModule', {
    value: true
});
var $53d82ec27a6b7ce9$var$prefix = 'fas';
var $53d82ec27a6b7ce9$var$iconName = 'circle-down';
var $53d82ec27a6b7ce9$var$width = 512;
var $53d82ec27a6b7ce9$var$height = 512;
var $53d82ec27a6b7ce9$var$aliases = [
    61466,
    "arrow-alt-circle-down"
];
var $53d82ec27a6b7ce9$var$unicode = 'f358';
var $53d82ec27a6b7ce9$var$svgPathData = 'M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM244.7 387.3l-104-104c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l56 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 56 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-104 104c-6.2 6.2-16.4 6.2-22.6 0z';
$53d82ec27a6b7ce9$exports.definition = {
    prefix: $53d82ec27a6b7ce9$var$prefix,
    iconName: $53d82ec27a6b7ce9$var$iconName,
    icon: [
        $53d82ec27a6b7ce9$var$width,
        $53d82ec27a6b7ce9$var$height,
        $53d82ec27a6b7ce9$var$aliases,
        $53d82ec27a6b7ce9$var$unicode,
        $53d82ec27a6b7ce9$var$svgPathData
    ]
};
$53d82ec27a6b7ce9$exports.faCircleDown = $53d82ec27a6b7ce9$exports.definition;
$53d82ec27a6b7ce9$exports.prefix = $53d82ec27a6b7ce9$var$prefix;
$53d82ec27a6b7ce9$exports.iconName = $53d82ec27a6b7ce9$var$iconName;
$53d82ec27a6b7ce9$exports.width = $53d82ec27a6b7ce9$var$width;
$53d82ec27a6b7ce9$exports.height = $53d82ec27a6b7ce9$var$height;
$53d82ec27a6b7ce9$exports.ligatures = $53d82ec27a6b7ce9$var$aliases;
$53d82ec27a6b7ce9$exports.unicode = $53d82ec27a6b7ce9$var$unicode;
$53d82ec27a6b7ce9$exports.svgPathData = $53d82ec27a6b7ce9$var$svgPathData;
$53d82ec27a6b7ce9$exports.aliases = $53d82ec27a6b7ce9$var$aliases;


$2feb01c0637ffeff$exports.definition = {
    prefix: $53d82ec27a6b7ce9$exports.prefix,
    iconName: $53d82ec27a6b7ce9$exports.iconName,
    icon: [
        $53d82ec27a6b7ce9$exports.width,
        $53d82ec27a6b7ce9$exports.height,
        $53d82ec27a6b7ce9$exports.aliases,
        $53d82ec27a6b7ce9$exports.unicode,
        $53d82ec27a6b7ce9$exports.svgPathData
    ]
};
$2feb01c0637ffeff$exports.faArrowAltCircleDown = $2feb01c0637ffeff$exports.definition;
$2feb01c0637ffeff$exports.prefix = $53d82ec27a6b7ce9$exports.prefix;
$2feb01c0637ffeff$exports.iconName = $53d82ec27a6b7ce9$exports.iconName;
$2feb01c0637ffeff$exports.width = $53d82ec27a6b7ce9$exports.width;
$2feb01c0637ffeff$exports.height = $53d82ec27a6b7ce9$exports.height;
$2feb01c0637ffeff$exports.ligatures = $53d82ec27a6b7ce9$exports.aliases;
$2feb01c0637ffeff$exports.unicode = $53d82ec27a6b7ce9$exports.unicode;
$2feb01c0637ffeff$exports.svgPathData = $53d82ec27a6b7ce9$exports.svgPathData;
$2feb01c0637ffeff$exports.aliases = $53d82ec27a6b7ce9$exports.aliases;


var $e4ff5d82615e7815$exports = {};
'use strict';
Object.defineProperty($e4ff5d82615e7815$exports, '__esModule', {
    value: true
});
var $e4ff5d82615e7815$var$prefix = 'fas';
var $e4ff5d82615e7815$var$iconName = 'arrow-right';
var $e4ff5d82615e7815$var$width = 512;
var $e4ff5d82615e7815$var$height = 512;
var $e4ff5d82615e7815$var$aliases = [
    8594
];
var $e4ff5d82615e7815$var$unicode = 'f061';
var $e4ff5d82615e7815$var$svgPathData = 'M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-105.4 105.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z';
$e4ff5d82615e7815$exports.definition = {
    prefix: $e4ff5d82615e7815$var$prefix,
    iconName: $e4ff5d82615e7815$var$iconName,
    icon: [
        $e4ff5d82615e7815$var$width,
        $e4ff5d82615e7815$var$height,
        $e4ff5d82615e7815$var$aliases,
        $e4ff5d82615e7815$var$unicode,
        $e4ff5d82615e7815$var$svgPathData
    ]
};
$e4ff5d82615e7815$exports.faArrowRight = $e4ff5d82615e7815$exports.definition;
$e4ff5d82615e7815$exports.prefix = $e4ff5d82615e7815$var$prefix;
$e4ff5d82615e7815$exports.iconName = $e4ff5d82615e7815$var$iconName;
$e4ff5d82615e7815$exports.width = $e4ff5d82615e7815$var$width;
$e4ff5d82615e7815$exports.height = $e4ff5d82615e7815$var$height;
$e4ff5d82615e7815$exports.ligatures = $e4ff5d82615e7815$var$aliases;
$e4ff5d82615e7815$exports.unicode = $e4ff5d82615e7815$var$unicode;
$e4ff5d82615e7815$exports.svgPathData = $e4ff5d82615e7815$var$svgPathData;
$e4ff5d82615e7815$exports.aliases = $e4ff5d82615e7815$var$aliases;


var $e9206858efef3e95$exports = {};
'use strict';
Object.defineProperty($e9206858efef3e95$exports, '__esModule', {
    value: true
});
var $e9206858efef3e95$var$prefix = 'fas';
var $e9206858efef3e95$var$iconName = 'check';
var $e9206858efef3e95$var$width = 448;
var $e9206858efef3e95$var$height = 512;
var $e9206858efef3e95$var$aliases = [
    10003,
    10004
];
var $e9206858efef3e95$var$unicode = 'f00c';
var $e9206858efef3e95$var$svgPathData = 'M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z';
$e9206858efef3e95$exports.definition = {
    prefix: $e9206858efef3e95$var$prefix,
    iconName: $e9206858efef3e95$var$iconName,
    icon: [
        $e9206858efef3e95$var$width,
        $e9206858efef3e95$var$height,
        $e9206858efef3e95$var$aliases,
        $e9206858efef3e95$var$unicode,
        $e9206858efef3e95$var$svgPathData
    ]
};
$e9206858efef3e95$exports.faCheck = $e9206858efef3e95$exports.definition;
$e9206858efef3e95$exports.prefix = $e9206858efef3e95$var$prefix;
$e9206858efef3e95$exports.iconName = $e9206858efef3e95$var$iconName;
$e9206858efef3e95$exports.width = $e9206858efef3e95$var$width;
$e9206858efef3e95$exports.height = $e9206858efef3e95$var$height;
$e9206858efef3e95$exports.ligatures = $e9206858efef3e95$var$aliases;
$e9206858efef3e95$exports.unicode = $e9206858efef3e95$var$unicode;
$e9206858efef3e95$exports.svgPathData = $e9206858efef3e95$var$svgPathData;
$e9206858efef3e95$exports.aliases = $e9206858efef3e95$var$aliases;


var $8e226679142db257$exports = {};
'use strict';
Object.defineProperty($8e226679142db257$exports, '__esModule', {
    value: true
});
var $dfa3efc3728a4590$exports = {};
'use strict';
Object.defineProperty($dfa3efc3728a4590$exports, '__esModule', {
    value: true
});
var $dfa3efc3728a4590$var$prefix = 'fas';
var $dfa3efc3728a4590$var$iconName = 'circle-check';
var $dfa3efc3728a4590$var$width = 512;
var $dfa3efc3728a4590$var$height = 512;
var $dfa3efc3728a4590$var$aliases = [
    61533,
    "check-circle"
];
var $dfa3efc3728a4590$var$unicode = 'f058';
var $dfa3efc3728a4590$var$svgPathData = 'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM374 145.7c-10.7-7.8-25.7-5.4-33.5 5.3L221.1 315.2 169 263.1c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c5 5 11.8 7.5 18.8 7s13.4-4.1 17.5-9.8L379.3 179.2c7.8-10.7 5.4-25.7-5.3-33.5z';
$dfa3efc3728a4590$exports.definition = {
    prefix: $dfa3efc3728a4590$var$prefix,
    iconName: $dfa3efc3728a4590$var$iconName,
    icon: [
        $dfa3efc3728a4590$var$width,
        $dfa3efc3728a4590$var$height,
        $dfa3efc3728a4590$var$aliases,
        $dfa3efc3728a4590$var$unicode,
        $dfa3efc3728a4590$var$svgPathData
    ]
};
$dfa3efc3728a4590$exports.faCircleCheck = $dfa3efc3728a4590$exports.definition;
$dfa3efc3728a4590$exports.prefix = $dfa3efc3728a4590$var$prefix;
$dfa3efc3728a4590$exports.iconName = $dfa3efc3728a4590$var$iconName;
$dfa3efc3728a4590$exports.width = $dfa3efc3728a4590$var$width;
$dfa3efc3728a4590$exports.height = $dfa3efc3728a4590$var$height;
$dfa3efc3728a4590$exports.ligatures = $dfa3efc3728a4590$var$aliases;
$dfa3efc3728a4590$exports.unicode = $dfa3efc3728a4590$var$unicode;
$dfa3efc3728a4590$exports.svgPathData = $dfa3efc3728a4590$var$svgPathData;
$dfa3efc3728a4590$exports.aliases = $dfa3efc3728a4590$var$aliases;


$8e226679142db257$exports.definition = {
    prefix: $dfa3efc3728a4590$exports.prefix,
    iconName: $dfa3efc3728a4590$exports.iconName,
    icon: [
        $dfa3efc3728a4590$exports.width,
        $dfa3efc3728a4590$exports.height,
        $dfa3efc3728a4590$exports.aliases,
        $dfa3efc3728a4590$exports.unicode,
        $dfa3efc3728a4590$exports.svgPathData
    ]
};
$8e226679142db257$exports.faCheckCircle = $8e226679142db257$exports.definition;
$8e226679142db257$exports.prefix = $dfa3efc3728a4590$exports.prefix;
$8e226679142db257$exports.iconName = $dfa3efc3728a4590$exports.iconName;
$8e226679142db257$exports.width = $dfa3efc3728a4590$exports.width;
$8e226679142db257$exports.height = $dfa3efc3728a4590$exports.height;
$8e226679142db257$exports.ligatures = $dfa3efc3728a4590$exports.aliases;
$8e226679142db257$exports.unicode = $dfa3efc3728a4590$exports.unicode;
$8e226679142db257$exports.svgPathData = $dfa3efc3728a4590$exports.svgPathData;
$8e226679142db257$exports.aliases = $dfa3efc3728a4590$exports.aliases;


var $b39548c706c2a5e0$exports = {};
'use strict';
Object.defineProperty($b39548c706c2a5e0$exports, '__esModule', {
    value: true
});
var $b39548c706c2a5e0$var$prefix = 'fas';
var $b39548c706c2a5e0$var$iconName = 'caret-down';
var $b39548c706c2a5e0$var$width = 320;
var $b39548c706c2a5e0$var$height = 512;
var $b39548c706c2a5e0$var$aliases = [];
var $b39548c706c2a5e0$var$unicode = 'f0d7';
var $b39548c706c2a5e0$var$svgPathData = 'M140.3 376.8c12.6 10.2 31.1 9.5 42.8-2.2l128-128c9.2-9.2 11.9-22.9 6.9-34.9S301.4 192 288.5 192l-256 0c-12.9 0-24.6 7.8-29.6 19.8S.7 237.5 9.9 246.6l128 128 2.4 2.2z';
$b39548c706c2a5e0$exports.definition = {
    prefix: $b39548c706c2a5e0$var$prefix,
    iconName: $b39548c706c2a5e0$var$iconName,
    icon: [
        $b39548c706c2a5e0$var$width,
        $b39548c706c2a5e0$var$height,
        $b39548c706c2a5e0$var$aliases,
        $b39548c706c2a5e0$var$unicode,
        $b39548c706c2a5e0$var$svgPathData
    ]
};
$b39548c706c2a5e0$exports.faCaretDown = $b39548c706c2a5e0$exports.definition;
$b39548c706c2a5e0$exports.prefix = $b39548c706c2a5e0$var$prefix;
$b39548c706c2a5e0$exports.iconName = $b39548c706c2a5e0$var$iconName;
$b39548c706c2a5e0$exports.width = $b39548c706c2a5e0$var$width;
$b39548c706c2a5e0$exports.height = $b39548c706c2a5e0$var$height;
$b39548c706c2a5e0$exports.ligatures = $b39548c706c2a5e0$var$aliases;
$b39548c706c2a5e0$exports.unicode = $b39548c706c2a5e0$var$unicode;
$b39548c706c2a5e0$exports.svgPathData = $b39548c706c2a5e0$var$svgPathData;
$b39548c706c2a5e0$exports.aliases = $b39548c706c2a5e0$var$aliases;


var $e9e52821f7276495$exports = {};
'use strict';
Object.defineProperty($e9e52821f7276495$exports, '__esModule', {
    value: true
});
var $e9e52821f7276495$var$prefix = 'fas';
var $e9e52821f7276495$var$iconName = 'caret-right';
var $e9e52821f7276495$var$width = 256;
var $e9e52821f7276495$var$height = 512;
var $e9e52821f7276495$var$aliases = [];
var $e9e52821f7276495$var$unicode = 'f0da';
var $e9e52821f7276495$var$svgPathData = 'M249.3 235.8c10.2 12.6 9.5 31.1-2.2 42.8l-128 128c-9.2 9.2-22.9 11.9-34.9 6.9S64.5 396.9 64.5 384l0-256c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l128 128 2.2 2.4z';
$e9e52821f7276495$exports.definition = {
    prefix: $e9e52821f7276495$var$prefix,
    iconName: $e9e52821f7276495$var$iconName,
    icon: [
        $e9e52821f7276495$var$width,
        $e9e52821f7276495$var$height,
        $e9e52821f7276495$var$aliases,
        $e9e52821f7276495$var$unicode,
        $e9e52821f7276495$var$svgPathData
    ]
};
$e9e52821f7276495$exports.faCaretRight = $e9e52821f7276495$exports.definition;
$e9e52821f7276495$exports.prefix = $e9e52821f7276495$var$prefix;
$e9e52821f7276495$exports.iconName = $e9e52821f7276495$var$iconName;
$e9e52821f7276495$exports.width = $e9e52821f7276495$var$width;
$e9e52821f7276495$exports.height = $e9e52821f7276495$var$height;
$e9e52821f7276495$exports.ligatures = $e9e52821f7276495$var$aliases;
$e9e52821f7276495$exports.unicode = $e9e52821f7276495$var$unicode;
$e9e52821f7276495$exports.svgPathData = $e9e52821f7276495$var$svgPathData;
$e9e52821f7276495$exports.aliases = $e9e52821f7276495$var$aliases;


var $89b603728dcec9de$exports = {};
'use strict';
Object.defineProperty($89b603728dcec9de$exports, '__esModule', {
    value: true
});
var $31c27e3921df46d5$exports = {};
'use strict';
Object.defineProperty($31c27e3921df46d5$exports, '__esModule', {
    value: true
});
var $31c27e3921df46d5$var$prefix = 'fas';
var $31c27e3921df46d5$var$iconName = 'cloud-arrow-up';
var $31c27e3921df46d5$var$width = 576;
var $31c27e3921df46d5$var$height = 512;
var $31c27e3921df46d5$var$aliases = [
    62338,
    "cloud-upload",
    "cloud-upload-alt"
];
var $31c27e3921df46d5$var$unicode = 'f0ee';
var $31c27e3921df46d5$var$svgPathData = 'M144 480c-79.5 0-144-64.5-144-144 0-63.4 41-117.2 97.9-136.5-1.3-7.7-1.9-15.5-1.9-23.5 0-79.5 64.5-144 144-144 55.4 0 103.5 31.3 127.6 77.1 14.2-8.3 30.8-13.1 48.4-13.1 53 0 96 43 96 96 0 15.7-3.8 30.6-10.5 43.7 44 20.3 74.5 64.7 74.5 116.3 0 70.7-57.3 128-128 128l-304 0zM305 191c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 102.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72z';
$31c27e3921df46d5$exports.definition = {
    prefix: $31c27e3921df46d5$var$prefix,
    iconName: $31c27e3921df46d5$var$iconName,
    icon: [
        $31c27e3921df46d5$var$width,
        $31c27e3921df46d5$var$height,
        $31c27e3921df46d5$var$aliases,
        $31c27e3921df46d5$var$unicode,
        $31c27e3921df46d5$var$svgPathData
    ]
};
$31c27e3921df46d5$exports.faCloudArrowUp = $31c27e3921df46d5$exports.definition;
$31c27e3921df46d5$exports.prefix = $31c27e3921df46d5$var$prefix;
$31c27e3921df46d5$exports.iconName = $31c27e3921df46d5$var$iconName;
$31c27e3921df46d5$exports.width = $31c27e3921df46d5$var$width;
$31c27e3921df46d5$exports.height = $31c27e3921df46d5$var$height;
$31c27e3921df46d5$exports.ligatures = $31c27e3921df46d5$var$aliases;
$31c27e3921df46d5$exports.unicode = $31c27e3921df46d5$var$unicode;
$31c27e3921df46d5$exports.svgPathData = $31c27e3921df46d5$var$svgPathData;
$31c27e3921df46d5$exports.aliases = $31c27e3921df46d5$var$aliases;


$89b603728dcec9de$exports.definition = {
    prefix: $31c27e3921df46d5$exports.prefix,
    iconName: $31c27e3921df46d5$exports.iconName,
    icon: [
        $31c27e3921df46d5$exports.width,
        $31c27e3921df46d5$exports.height,
        $31c27e3921df46d5$exports.aliases,
        $31c27e3921df46d5$exports.unicode,
        $31c27e3921df46d5$exports.svgPathData
    ]
};
$89b603728dcec9de$exports.faCloudUploadAlt = $89b603728dcec9de$exports.definition;
$89b603728dcec9de$exports.prefix = $31c27e3921df46d5$exports.prefix;
$89b603728dcec9de$exports.iconName = $31c27e3921df46d5$exports.iconName;
$89b603728dcec9de$exports.width = $31c27e3921df46d5$exports.width;
$89b603728dcec9de$exports.height = $31c27e3921df46d5$exports.height;
$89b603728dcec9de$exports.ligatures = $31c27e3921df46d5$exports.aliases;
$89b603728dcec9de$exports.unicode = $31c27e3921df46d5$exports.unicode;
$89b603728dcec9de$exports.svgPathData = $31c27e3921df46d5$exports.svgPathData;
$89b603728dcec9de$exports.aliases = $31c27e3921df46d5$exports.aliases;


var $2af23e40017b25d9$exports = {};
'use strict';
Object.defineProperty($2af23e40017b25d9$exports, '__esModule', {
    value: true
});
var $a749e0663c54d6fc$exports = {};
'use strict';
Object.defineProperty($a749e0663c54d6fc$exports, '__esModule', {
    value: true
});
var $a749e0663c54d6fc$var$prefix = 'fas';
var $a749e0663c54d6fc$var$iconName = 'gear';
var $a749e0663c54d6fc$var$width = 512;
var $a749e0663c54d6fc$var$height = 512;
var $a749e0663c54d6fc$var$aliases = [
    9881,
    "cog"
];
var $a749e0663c54d6fc$var$unicode = 'f013';
var $a749e0663c54d6fc$var$svgPathData = 'M195.1 9.5C198.1-5.3 211.2-16 226.4-16l59.8 0c15.2 0 28.3 10.7 31.3 25.5L332 79.5c14.1 6 27.3 13.7 39.3 22.8l67.8-22.5c14.4-4.8 30.2 1.2 37.8 14.4l29.9 51.8c7.6 13.2 4.9 29.8-6.5 39.9L447 233.3c.9 7.4 1.3 15 1.3 22.7s-.5 15.3-1.3 22.7l53.4 47.5c11.4 10.1 14 26.8 6.5 39.9l-29.9 51.8c-7.6 13.1-23.4 19.2-37.8 14.4l-67.8-22.5c-12.1 9.1-25.3 16.7-39.3 22.8l-14.4 69.9c-3.1 14.9-16.2 25.5-31.3 25.5l-59.8 0c-15.2 0-28.3-10.7-31.3-25.5l-14.4-69.9c-14.1-6-27.2-13.7-39.3-22.8L73.5 432.3c-14.4 4.8-30.2-1.2-37.8-14.4L5.8 366.1c-7.6-13.2-4.9-29.8 6.5-39.9l53.4-47.5c-.9-7.4-1.3-15-1.3-22.7s.5-15.3 1.3-22.7L12.3 185.8c-11.4-10.1-14-26.8-6.5-39.9L35.7 94.1c7.6-13.2 23.4-19.2 37.8-14.4l67.8 22.5c12.1-9.1 25.3-16.7 39.3-22.8L195.1 9.5zM256.3 336a80 80 0 1 0 -.6-160 80 80 0 1 0 .6 160z';
$a749e0663c54d6fc$exports.definition = {
    prefix: $a749e0663c54d6fc$var$prefix,
    iconName: $a749e0663c54d6fc$var$iconName,
    icon: [
        $a749e0663c54d6fc$var$width,
        $a749e0663c54d6fc$var$height,
        $a749e0663c54d6fc$var$aliases,
        $a749e0663c54d6fc$var$unicode,
        $a749e0663c54d6fc$var$svgPathData
    ]
};
$a749e0663c54d6fc$exports.faGear = $a749e0663c54d6fc$exports.definition;
$a749e0663c54d6fc$exports.prefix = $a749e0663c54d6fc$var$prefix;
$a749e0663c54d6fc$exports.iconName = $a749e0663c54d6fc$var$iconName;
$a749e0663c54d6fc$exports.width = $a749e0663c54d6fc$var$width;
$a749e0663c54d6fc$exports.height = $a749e0663c54d6fc$var$height;
$a749e0663c54d6fc$exports.ligatures = $a749e0663c54d6fc$var$aliases;
$a749e0663c54d6fc$exports.unicode = $a749e0663c54d6fc$var$unicode;
$a749e0663c54d6fc$exports.svgPathData = $a749e0663c54d6fc$var$svgPathData;
$a749e0663c54d6fc$exports.aliases = $a749e0663c54d6fc$var$aliases;


$2af23e40017b25d9$exports.definition = {
    prefix: $a749e0663c54d6fc$exports.prefix,
    iconName: $a749e0663c54d6fc$exports.iconName,
    icon: [
        $a749e0663c54d6fc$exports.width,
        $a749e0663c54d6fc$exports.height,
        $a749e0663c54d6fc$exports.aliases,
        $a749e0663c54d6fc$exports.unicode,
        $a749e0663c54d6fc$exports.svgPathData
    ]
};
$2af23e40017b25d9$exports.faCog = $2af23e40017b25d9$exports.definition;
$2af23e40017b25d9$exports.prefix = $a749e0663c54d6fc$exports.prefix;
$2af23e40017b25d9$exports.iconName = $a749e0663c54d6fc$exports.iconName;
$2af23e40017b25d9$exports.width = $a749e0663c54d6fc$exports.width;
$2af23e40017b25d9$exports.height = $a749e0663c54d6fc$exports.height;
$2af23e40017b25d9$exports.ligatures = $a749e0663c54d6fc$exports.aliases;
$2af23e40017b25d9$exports.unicode = $a749e0663c54d6fc$exports.unicode;
$2af23e40017b25d9$exports.svgPathData = $a749e0663c54d6fc$exports.svgPathData;
$2af23e40017b25d9$exports.aliases = $a749e0663c54d6fc$exports.aliases;


var $9e163d018ad3ce2a$exports = {};
'use strict';
Object.defineProperty($9e163d018ad3ce2a$exports, '__esModule', {
    value: true
});
var $9e163d018ad3ce2a$var$prefix = 'fas';
var $9e163d018ad3ce2a$var$iconName = 'copy';
var $9e163d018ad3ce2a$var$width = 448;
var $9e163d018ad3ce2a$var$height = 512;
var $9e163d018ad3ce2a$var$aliases = [];
var $9e163d018ad3ce2a$var$unicode = 'f0c5';
var $9e163d018ad3ce2a$var$svgPathData = 'M192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-200.6c0-17.4-7.1-34.1-19.7-46.2L370.6 17.8C358.7 6.4 342.8 0 326.3 0L192 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-64 0 0 16-192 0 0-256 16 0 0-64-16 0z';
$9e163d018ad3ce2a$exports.definition = {
    prefix: $9e163d018ad3ce2a$var$prefix,
    iconName: $9e163d018ad3ce2a$var$iconName,
    icon: [
        $9e163d018ad3ce2a$var$width,
        $9e163d018ad3ce2a$var$height,
        $9e163d018ad3ce2a$var$aliases,
        $9e163d018ad3ce2a$var$unicode,
        $9e163d018ad3ce2a$var$svgPathData
    ]
};
$9e163d018ad3ce2a$exports.faCopy = $9e163d018ad3ce2a$exports.definition;
$9e163d018ad3ce2a$exports.prefix = $9e163d018ad3ce2a$var$prefix;
$9e163d018ad3ce2a$exports.iconName = $9e163d018ad3ce2a$var$iconName;
$9e163d018ad3ce2a$exports.width = $9e163d018ad3ce2a$var$width;
$9e163d018ad3ce2a$exports.height = $9e163d018ad3ce2a$var$height;
$9e163d018ad3ce2a$exports.ligatures = $9e163d018ad3ce2a$var$aliases;
$9e163d018ad3ce2a$exports.unicode = $9e163d018ad3ce2a$var$unicode;
$9e163d018ad3ce2a$exports.svgPathData = $9e163d018ad3ce2a$var$svgPathData;
$9e163d018ad3ce2a$exports.aliases = $9e163d018ad3ce2a$var$aliases;


var $9ba76af6c08a1d33$exports = {};
'use strict';
Object.defineProperty($9ba76af6c08a1d33$exports, '__esModule', {
    value: true
});
var $9ba76af6c08a1d33$var$prefix = 'fas';
var $9ba76af6c08a1d33$var$iconName = 'envelope';
var $9ba76af6c08a1d33$var$width = 512;
var $9ba76af6c08a1d33$var$height = 512;
var $9ba76af6c08a1d33$var$aliases = [
    128386,
    9993,
    61443
];
var $9ba76af6c08a1d33$var$unicode = 'f0e0';
var $9ba76af6c08a1d33$var$svgPathData = 'M48 64c-26.5 0-48 21.5-48 48 0 15.1 7.1 29.3 19.2 38.4l208 156c17.1 12.8 40.5 12.8 57.6 0l208-156c12.1-9.1 19.2-23.3 19.2-38.4 0-26.5-21.5-48-48-48L48 64zM0 196L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-188-198.4 148.8c-34.1 25.6-81.1 25.6-115.2 0L0 196z';
$9ba76af6c08a1d33$exports.definition = {
    prefix: $9ba76af6c08a1d33$var$prefix,
    iconName: $9ba76af6c08a1d33$var$iconName,
    icon: [
        $9ba76af6c08a1d33$var$width,
        $9ba76af6c08a1d33$var$height,
        $9ba76af6c08a1d33$var$aliases,
        $9ba76af6c08a1d33$var$unicode,
        $9ba76af6c08a1d33$var$svgPathData
    ]
};
$9ba76af6c08a1d33$exports.faEnvelope = $9ba76af6c08a1d33$exports.definition;
$9ba76af6c08a1d33$exports.prefix = $9ba76af6c08a1d33$var$prefix;
$9ba76af6c08a1d33$exports.iconName = $9ba76af6c08a1d33$var$iconName;
$9ba76af6c08a1d33$exports.width = $9ba76af6c08a1d33$var$width;
$9ba76af6c08a1d33$exports.height = $9ba76af6c08a1d33$var$height;
$9ba76af6c08a1d33$exports.ligatures = $9ba76af6c08a1d33$var$aliases;
$9ba76af6c08a1d33$exports.unicode = $9ba76af6c08a1d33$var$unicode;
$9ba76af6c08a1d33$exports.svgPathData = $9ba76af6c08a1d33$var$svgPathData;
$9ba76af6c08a1d33$exports.aliases = $9ba76af6c08a1d33$var$aliases;


var $4f6e76a0ad832aa1$exports = {};
'use strict';
Object.defineProperty($4f6e76a0ad832aa1$exports, '__esModule', {
    value: true
});
var $1005239a8ed8fecd$exports = {};
'use strict';
Object.defineProperty($1005239a8ed8fecd$exports, '__esModule', {
    value: true
});
var $1005239a8ed8fecd$var$prefix = 'fas';
var $1005239a8ed8fecd$var$iconName = 'up-right-from-square';
var $1005239a8ed8fecd$var$width = 512;
var $1005239a8ed8fecd$var$height = 512;
var $1005239a8ed8fecd$var$aliases = [
    "external-link-alt"
];
var $1005239a8ed8fecd$var$unicode = 'f35d';
var $1005239a8ed8fecd$var$svgPathData = 'M290.4 19.8C295.4 7.8 307.1 0 320 0L480 0c17.7 0 32 14.3 32 32l0 160c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9L400 157.3 246.6 310.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L354.7 112 297.4 54.6c-9.2-9.2-11.9-22.9-6.9-34.9zM0 176c0-44.2 35.8-80 80-80l80 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-80 0c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-80c0-17.7 14.3-32 32-32s32 14.3 32 32l0 80c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 176z';
$1005239a8ed8fecd$exports.definition = {
    prefix: $1005239a8ed8fecd$var$prefix,
    iconName: $1005239a8ed8fecd$var$iconName,
    icon: [
        $1005239a8ed8fecd$var$width,
        $1005239a8ed8fecd$var$height,
        $1005239a8ed8fecd$var$aliases,
        $1005239a8ed8fecd$var$unicode,
        $1005239a8ed8fecd$var$svgPathData
    ]
};
$1005239a8ed8fecd$exports.faUpRightFromSquare = $1005239a8ed8fecd$exports.definition;
$1005239a8ed8fecd$exports.prefix = $1005239a8ed8fecd$var$prefix;
$1005239a8ed8fecd$exports.iconName = $1005239a8ed8fecd$var$iconName;
$1005239a8ed8fecd$exports.width = $1005239a8ed8fecd$var$width;
$1005239a8ed8fecd$exports.height = $1005239a8ed8fecd$var$height;
$1005239a8ed8fecd$exports.ligatures = $1005239a8ed8fecd$var$aliases;
$1005239a8ed8fecd$exports.unicode = $1005239a8ed8fecd$var$unicode;
$1005239a8ed8fecd$exports.svgPathData = $1005239a8ed8fecd$var$svgPathData;
$1005239a8ed8fecd$exports.aliases = $1005239a8ed8fecd$var$aliases;


$4f6e76a0ad832aa1$exports.definition = {
    prefix: $1005239a8ed8fecd$exports.prefix,
    iconName: $1005239a8ed8fecd$exports.iconName,
    icon: [
        $1005239a8ed8fecd$exports.width,
        $1005239a8ed8fecd$exports.height,
        $1005239a8ed8fecd$exports.aliases,
        $1005239a8ed8fecd$exports.unicode,
        $1005239a8ed8fecd$exports.svgPathData
    ]
};
$4f6e76a0ad832aa1$exports.faExternalLinkAlt = $4f6e76a0ad832aa1$exports.definition;
$4f6e76a0ad832aa1$exports.prefix = $1005239a8ed8fecd$exports.prefix;
$4f6e76a0ad832aa1$exports.iconName = $1005239a8ed8fecd$exports.iconName;
$4f6e76a0ad832aa1$exports.width = $1005239a8ed8fecd$exports.width;
$4f6e76a0ad832aa1$exports.height = $1005239a8ed8fecd$exports.height;
$4f6e76a0ad832aa1$exports.ligatures = $1005239a8ed8fecd$exports.aliases;
$4f6e76a0ad832aa1$exports.unicode = $1005239a8ed8fecd$exports.unicode;
$4f6e76a0ad832aa1$exports.svgPathData = $1005239a8ed8fecd$exports.svgPathData;
$4f6e76a0ad832aa1$exports.aliases = $1005239a8ed8fecd$exports.aliases;


var $c4ec402fabc5b4fe$exports = {};
'use strict';
Object.defineProperty($c4ec402fabc5b4fe$exports, '__esModule', {
    value: true
});
var $c4ec402fabc5b4fe$var$prefix = 'fas';
var $c4ec402fabc5b4fe$var$iconName = 'key';
var $c4ec402fabc5b4fe$var$width = 512;
var $c4ec402fabc5b4fe$var$height = 512;
var $c4ec402fabc5b4fe$var$aliases = [
    128273
];
var $c4ec402fabc5b4fe$var$unicode = 'f084';
var $c4ec402fabc5b4fe$var$svgPathData = 'M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0 160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z';
$c4ec402fabc5b4fe$exports.definition = {
    prefix: $c4ec402fabc5b4fe$var$prefix,
    iconName: $c4ec402fabc5b4fe$var$iconName,
    icon: [
        $c4ec402fabc5b4fe$var$width,
        $c4ec402fabc5b4fe$var$height,
        $c4ec402fabc5b4fe$var$aliases,
        $c4ec402fabc5b4fe$var$unicode,
        $c4ec402fabc5b4fe$var$svgPathData
    ]
};
$c4ec402fabc5b4fe$exports.faKey = $c4ec402fabc5b4fe$exports.definition;
$c4ec402fabc5b4fe$exports.prefix = $c4ec402fabc5b4fe$var$prefix;
$c4ec402fabc5b4fe$exports.iconName = $c4ec402fabc5b4fe$var$iconName;
$c4ec402fabc5b4fe$exports.width = $c4ec402fabc5b4fe$var$width;
$c4ec402fabc5b4fe$exports.height = $c4ec402fabc5b4fe$var$height;
$c4ec402fabc5b4fe$exports.ligatures = $c4ec402fabc5b4fe$var$aliases;
$c4ec402fabc5b4fe$exports.unicode = $c4ec402fabc5b4fe$var$unicode;
$c4ec402fabc5b4fe$exports.svgPathData = $c4ec402fabc5b4fe$var$svgPathData;
$c4ec402fabc5b4fe$exports.aliases = $c4ec402fabc5b4fe$var$aliases;


var $83e399a08305a885$exports = {};
'use strict';
Object.defineProperty($83e399a08305a885$exports, '__esModule', {
    value: true
});
var $28e5ea3492a10643$exports = {};
'use strict';
Object.defineProperty($28e5ea3492a10643$exports, '__esModule', {
    value: true
});
var $28e5ea3492a10643$var$prefix = 'fas';
var $28e5ea3492a10643$var$iconName = 'magnifying-glass';
var $28e5ea3492a10643$var$width = 512;
var $28e5ea3492a10643$var$height = 512;
var $28e5ea3492a10643$var$aliases = [
    128269,
    "search"
];
var $28e5ea3492a10643$var$unicode = 'f002';
var $28e5ea3492a10643$var$svgPathData = 'M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z';
$28e5ea3492a10643$exports.definition = {
    prefix: $28e5ea3492a10643$var$prefix,
    iconName: $28e5ea3492a10643$var$iconName,
    icon: [
        $28e5ea3492a10643$var$width,
        $28e5ea3492a10643$var$height,
        $28e5ea3492a10643$var$aliases,
        $28e5ea3492a10643$var$unicode,
        $28e5ea3492a10643$var$svgPathData
    ]
};
$28e5ea3492a10643$exports.faMagnifyingGlass = $28e5ea3492a10643$exports.definition;
$28e5ea3492a10643$exports.prefix = $28e5ea3492a10643$var$prefix;
$28e5ea3492a10643$exports.iconName = $28e5ea3492a10643$var$iconName;
$28e5ea3492a10643$exports.width = $28e5ea3492a10643$var$width;
$28e5ea3492a10643$exports.height = $28e5ea3492a10643$var$height;
$28e5ea3492a10643$exports.ligatures = $28e5ea3492a10643$var$aliases;
$28e5ea3492a10643$exports.unicode = $28e5ea3492a10643$var$unicode;
$28e5ea3492a10643$exports.svgPathData = $28e5ea3492a10643$var$svgPathData;
$28e5ea3492a10643$exports.aliases = $28e5ea3492a10643$var$aliases;


$83e399a08305a885$exports.definition = {
    prefix: $28e5ea3492a10643$exports.prefix,
    iconName: $28e5ea3492a10643$exports.iconName,
    icon: [
        $28e5ea3492a10643$exports.width,
        $28e5ea3492a10643$exports.height,
        $28e5ea3492a10643$exports.aliases,
        $28e5ea3492a10643$exports.unicode,
        $28e5ea3492a10643$exports.svgPathData
    ]
};
$83e399a08305a885$exports.faSearch = $83e399a08305a885$exports.definition;
$83e399a08305a885$exports.prefix = $28e5ea3492a10643$exports.prefix;
$83e399a08305a885$exports.iconName = $28e5ea3492a10643$exports.iconName;
$83e399a08305a885$exports.width = $28e5ea3492a10643$exports.width;
$83e399a08305a885$exports.height = $28e5ea3492a10643$exports.height;
$83e399a08305a885$exports.ligatures = $28e5ea3492a10643$exports.aliases;
$83e399a08305a885$exports.unicode = $28e5ea3492a10643$exports.unicode;
$83e399a08305a885$exports.svgPathData = $28e5ea3492a10643$exports.svgPathData;
$83e399a08305a885$exports.aliases = $28e5ea3492a10643$exports.aliases;


var $1788f2b1ea8f3501$exports = {};
'use strict';
Object.defineProperty($1788f2b1ea8f3501$exports, '__esModule', {
    value: true
});
var $482cf6497b419ab9$exports = {};
'use strict';
Object.defineProperty($482cf6497b419ab9$exports, '__esModule', {
    value: true
});
var $482cf6497b419ab9$var$prefix = 'fas';
var $482cf6497b419ab9$var$iconName = 'share-nodes';
var $482cf6497b419ab9$var$width = 512;
var $482cf6497b419ab9$var$height = 512;
var $482cf6497b419ab9$var$aliases = [
    "share-alt"
];
var $482cf6497b419ab9$var$unicode = 'f1e0';
var $482cf6497b419ab9$var$svgPathData = 'M384 192c53 0 96-43 96-96s-43-96-96-96-96 43-96 96c0 5.4 .5 10.8 1.3 16L159.6 184.1c-16.9-15-39.2-24.1-63.6-24.1-53 0-96 43-96 96s43 96 96 96c24.4 0 46.6-9.1 63.6-24.1L289.3 400c-.9 5.2-1.3 10.5-1.3 16 0 53 43 96 96 96s96-43 96-96-43-96-96-96c-24.4 0-46.6 9.1-63.6 24.1L190.7 272c.9-5.2 1.3-10.5 1.3-16s-.5-10.8-1.3-16l129.7-72.1c16.9 15 39.2 24.1 63.6 24.1z';
$482cf6497b419ab9$exports.definition = {
    prefix: $482cf6497b419ab9$var$prefix,
    iconName: $482cf6497b419ab9$var$iconName,
    icon: [
        $482cf6497b419ab9$var$width,
        $482cf6497b419ab9$var$height,
        $482cf6497b419ab9$var$aliases,
        $482cf6497b419ab9$var$unicode,
        $482cf6497b419ab9$var$svgPathData
    ]
};
$482cf6497b419ab9$exports.faShareNodes = $482cf6497b419ab9$exports.definition;
$482cf6497b419ab9$exports.prefix = $482cf6497b419ab9$var$prefix;
$482cf6497b419ab9$exports.iconName = $482cf6497b419ab9$var$iconName;
$482cf6497b419ab9$exports.width = $482cf6497b419ab9$var$width;
$482cf6497b419ab9$exports.height = $482cf6497b419ab9$var$height;
$482cf6497b419ab9$exports.ligatures = $482cf6497b419ab9$var$aliases;
$482cf6497b419ab9$exports.unicode = $482cf6497b419ab9$var$unicode;
$482cf6497b419ab9$exports.svgPathData = $482cf6497b419ab9$var$svgPathData;
$482cf6497b419ab9$exports.aliases = $482cf6497b419ab9$var$aliases;


$1788f2b1ea8f3501$exports.definition = {
    prefix: $482cf6497b419ab9$exports.prefix,
    iconName: $482cf6497b419ab9$exports.iconName,
    icon: [
        $482cf6497b419ab9$exports.width,
        $482cf6497b419ab9$exports.height,
        $482cf6497b419ab9$exports.aliases,
        $482cf6497b419ab9$exports.unicode,
        $482cf6497b419ab9$exports.svgPathData
    ]
};
$1788f2b1ea8f3501$exports.faShareAlt = $1788f2b1ea8f3501$exports.definition;
$1788f2b1ea8f3501$exports.prefix = $482cf6497b419ab9$exports.prefix;
$1788f2b1ea8f3501$exports.iconName = $482cf6497b419ab9$exports.iconName;
$1788f2b1ea8f3501$exports.width = $482cf6497b419ab9$exports.width;
$1788f2b1ea8f3501$exports.height = $482cf6497b419ab9$exports.height;
$1788f2b1ea8f3501$exports.ligatures = $482cf6497b419ab9$exports.aliases;
$1788f2b1ea8f3501$exports.unicode = $482cf6497b419ab9$exports.unicode;
$1788f2b1ea8f3501$exports.svgPathData = $482cf6497b419ab9$exports.svgPathData;
$1788f2b1ea8f3501$exports.aliases = $482cf6497b419ab9$exports.aliases;


var $7ab16ab4e5fbaa94$exports = {};
'use strict';
Object.defineProperty($7ab16ab4e5fbaa94$exports, '__esModule', {
    value: true
});
var $92a7526ef4732e2b$exports = {};
'use strict';
Object.defineProperty($92a7526ef4732e2b$exports, '__esModule', {
    value: true
});
var $92a7526ef4732e2b$var$prefix = 'fas';
var $92a7526ef4732e2b$var$iconName = 'right-from-bracket';
var $92a7526ef4732e2b$var$width = 512;
var $92a7526ef4732e2b$var$height = 512;
var $92a7526ef4732e2b$var$aliases = [
    "sign-out-alt"
];
var $92a7526ef4732e2b$var$unicode = 'f2f5';
var $92a7526ef4732e2b$var$svgPathData = 'M505 273c9.4-9.4 9.4-24.6 0-33.9L361 95c-6.9-6.9-17.2-8.9-26.2-5.2S320 102.3 320 112l0 80-112 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l112 0 0 80c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2L505 273zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z';
$92a7526ef4732e2b$exports.definition = {
    prefix: $92a7526ef4732e2b$var$prefix,
    iconName: $92a7526ef4732e2b$var$iconName,
    icon: [
        $92a7526ef4732e2b$var$width,
        $92a7526ef4732e2b$var$height,
        $92a7526ef4732e2b$var$aliases,
        $92a7526ef4732e2b$var$unicode,
        $92a7526ef4732e2b$var$svgPathData
    ]
};
$92a7526ef4732e2b$exports.faRightFromBracket = $92a7526ef4732e2b$exports.definition;
$92a7526ef4732e2b$exports.prefix = $92a7526ef4732e2b$var$prefix;
$92a7526ef4732e2b$exports.iconName = $92a7526ef4732e2b$var$iconName;
$92a7526ef4732e2b$exports.width = $92a7526ef4732e2b$var$width;
$92a7526ef4732e2b$exports.height = $92a7526ef4732e2b$var$height;
$92a7526ef4732e2b$exports.ligatures = $92a7526ef4732e2b$var$aliases;
$92a7526ef4732e2b$exports.unicode = $92a7526ef4732e2b$var$unicode;
$92a7526ef4732e2b$exports.svgPathData = $92a7526ef4732e2b$var$svgPathData;
$92a7526ef4732e2b$exports.aliases = $92a7526ef4732e2b$var$aliases;


$7ab16ab4e5fbaa94$exports.definition = {
    prefix: $92a7526ef4732e2b$exports.prefix,
    iconName: $92a7526ef4732e2b$exports.iconName,
    icon: [
        $92a7526ef4732e2b$exports.width,
        $92a7526ef4732e2b$exports.height,
        $92a7526ef4732e2b$exports.aliases,
        $92a7526ef4732e2b$exports.unicode,
        $92a7526ef4732e2b$exports.svgPathData
    ]
};
$7ab16ab4e5fbaa94$exports.faSignOutAlt = $7ab16ab4e5fbaa94$exports.definition;
$7ab16ab4e5fbaa94$exports.prefix = $92a7526ef4732e2b$exports.prefix;
$7ab16ab4e5fbaa94$exports.iconName = $92a7526ef4732e2b$exports.iconName;
$7ab16ab4e5fbaa94$exports.width = $92a7526ef4732e2b$exports.width;
$7ab16ab4e5fbaa94$exports.height = $92a7526ef4732e2b$exports.height;
$7ab16ab4e5fbaa94$exports.ligatures = $92a7526ef4732e2b$exports.aliases;
$7ab16ab4e5fbaa94$exports.unicode = $92a7526ef4732e2b$exports.unicode;
$7ab16ab4e5fbaa94$exports.svgPathData = $92a7526ef4732e2b$exports.svgPathData;
$7ab16ab4e5fbaa94$exports.aliases = $92a7526ef4732e2b$exports.aliases;


var $f7bce8bbcf358cf9$exports = {};
'use strict';
Object.defineProperty($f7bce8bbcf358cf9$exports, '__esModule', {
    value: true
});
var $f7bce8bbcf358cf9$var$prefix = 'fas';
var $f7bce8bbcf358cf9$var$iconName = 'slash';
var $f7bce8bbcf358cf9$var$width = 576;
var $f7bce8bbcf358cf9$var$height = 512;
var $f7bce8bbcf358cf9$var$aliases = [];
var $f7bce8bbcf358cf9$var$unicode = 'f715';
var $f7bce8bbcf358cf9$var$svgPathData = 'M7-25c9.4-9.4 24.6-9.4 33.9 0L569 503c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 9C-2.3-.4-2.3-15.6 7-25z';
$f7bce8bbcf358cf9$exports.definition = {
    prefix: $f7bce8bbcf358cf9$var$prefix,
    iconName: $f7bce8bbcf358cf9$var$iconName,
    icon: [
        $f7bce8bbcf358cf9$var$width,
        $f7bce8bbcf358cf9$var$height,
        $f7bce8bbcf358cf9$var$aliases,
        $f7bce8bbcf358cf9$var$unicode,
        $f7bce8bbcf358cf9$var$svgPathData
    ]
};
$f7bce8bbcf358cf9$exports.faSlash = $f7bce8bbcf358cf9$exports.definition;
$f7bce8bbcf358cf9$exports.prefix = $f7bce8bbcf358cf9$var$prefix;
$f7bce8bbcf358cf9$exports.iconName = $f7bce8bbcf358cf9$var$iconName;
$f7bce8bbcf358cf9$exports.width = $f7bce8bbcf358cf9$var$width;
$f7bce8bbcf358cf9$exports.height = $f7bce8bbcf358cf9$var$height;
$f7bce8bbcf358cf9$exports.ligatures = $f7bce8bbcf358cf9$var$aliases;
$f7bce8bbcf358cf9$exports.unicode = $f7bce8bbcf358cf9$var$unicode;
$f7bce8bbcf358cf9$exports.svgPathData = $f7bce8bbcf358cf9$var$svgPathData;
$f7bce8bbcf358cf9$exports.aliases = $f7bce8bbcf358cf9$var$aliases;


var $16a4fe33ccdf2ed7$exports = {};
'use strict';
Object.defineProperty($16a4fe33ccdf2ed7$exports, '__esModule', {
    value: true
});
var $16a4fe33ccdf2ed7$var$prefix = 'fas';
var $16a4fe33ccdf2ed7$var$iconName = 'spinner';
var $16a4fe33ccdf2ed7$var$width = 512;
var $16a4fe33ccdf2ed7$var$height = 512;
var $16a4fe33ccdf2ed7$var$aliases = [];
var $16a4fe33ccdf2ed7$var$unicode = 'f110';
var $16a4fe33ccdf2ed7$var$svgPathData = 'M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm0 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM48 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm368 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM75 369.1A48 48 0 1 1 142.9 437 48 48 0 1 1 75 369.1zM75 75A48 48 0 1 1 142.9 142.9 48 48 0 1 1 75 75zM437 369.1A48 48 0 1 1 369.1 437 48 48 0 1 1 437 369.1z';
$16a4fe33ccdf2ed7$exports.definition = {
    prefix: $16a4fe33ccdf2ed7$var$prefix,
    iconName: $16a4fe33ccdf2ed7$var$iconName,
    icon: [
        $16a4fe33ccdf2ed7$var$width,
        $16a4fe33ccdf2ed7$var$height,
        $16a4fe33ccdf2ed7$var$aliases,
        $16a4fe33ccdf2ed7$var$unicode,
        $16a4fe33ccdf2ed7$var$svgPathData
    ]
};
$16a4fe33ccdf2ed7$exports.faSpinner = $16a4fe33ccdf2ed7$exports.definition;
$16a4fe33ccdf2ed7$exports.prefix = $16a4fe33ccdf2ed7$var$prefix;
$16a4fe33ccdf2ed7$exports.iconName = $16a4fe33ccdf2ed7$var$iconName;
$16a4fe33ccdf2ed7$exports.width = $16a4fe33ccdf2ed7$var$width;
$16a4fe33ccdf2ed7$exports.height = $16a4fe33ccdf2ed7$var$height;
$16a4fe33ccdf2ed7$exports.ligatures = $16a4fe33ccdf2ed7$var$aliases;
$16a4fe33ccdf2ed7$exports.unicode = $16a4fe33ccdf2ed7$var$unicode;
$16a4fe33ccdf2ed7$exports.svgPathData = $16a4fe33ccdf2ed7$var$svgPathData;
$16a4fe33ccdf2ed7$exports.aliases = $16a4fe33ccdf2ed7$var$aliases;


var $2d6ef9374862f0b1$exports = {};
'use strict';
Object.defineProperty($2d6ef9374862f0b1$exports, '__esModule', {
    value: true
});
var $2d6ef9374862f0b1$var$prefix = 'fas';
var $2d6ef9374862f0b1$var$iconName = 'star';
var $2d6ef9374862f0b1$var$width = 576;
var $2d6ef9374862f0b1$var$height = 512;
var $2d6ef9374862f0b1$var$aliases = [
    11088,
    61446
];
var $2d6ef9374862f0b1$var$unicode = 'f005';
var $2d6ef9374862f0b1$var$svgPathData = 'M309.5-18.9c-4.1-8-12.4-13.1-21.4-13.1s-17.3 5.1-21.4 13.1L193.1 125.3 33.2 150.7c-8.9 1.4-16.3 7.7-19.1 16.3s-.5 18 5.8 24.4l114.4 114.5-25.2 159.9c-1.4 8.9 2.3 17.9 9.6 23.2s16.9 6.1 25 2L288.1 417.6 432.4 491c8 4.1 17.7 3.3 25-2s11-14.2 9.6-23.2L441.7 305.9 556.1 191.4c6.4-6.4 8.6-15.8 5.8-24.4s-10.1-14.9-19.1-16.3L383 125.3 309.5-18.9z';
$2d6ef9374862f0b1$exports.definition = {
    prefix: $2d6ef9374862f0b1$var$prefix,
    iconName: $2d6ef9374862f0b1$var$iconName,
    icon: [
        $2d6ef9374862f0b1$var$width,
        $2d6ef9374862f0b1$var$height,
        $2d6ef9374862f0b1$var$aliases,
        $2d6ef9374862f0b1$var$unicode,
        $2d6ef9374862f0b1$var$svgPathData
    ]
};
$2d6ef9374862f0b1$exports.faStar = $2d6ef9374862f0b1$exports.definition;
$2d6ef9374862f0b1$exports.prefix = $2d6ef9374862f0b1$var$prefix;
$2d6ef9374862f0b1$exports.iconName = $2d6ef9374862f0b1$var$iconName;
$2d6ef9374862f0b1$exports.width = $2d6ef9374862f0b1$var$width;
$2d6ef9374862f0b1$exports.height = $2d6ef9374862f0b1$var$height;
$2d6ef9374862f0b1$exports.ligatures = $2d6ef9374862f0b1$var$aliases;
$2d6ef9374862f0b1$exports.unicode = $2d6ef9374862f0b1$var$unicode;
$2d6ef9374862f0b1$exports.svgPathData = $2d6ef9374862f0b1$var$svgPathData;
$2d6ef9374862f0b1$exports.aliases = $2d6ef9374862f0b1$var$aliases;


var $6a208664f359f326$exports = {};
'use strict';
Object.defineProperty($6a208664f359f326$exports, '__esModule', {
    value: true
});
var $381148eb8a7561d1$exports = {};
'use strict';
Object.defineProperty($381148eb8a7561d1$exports, '__esModule', {
    value: true
});
var $381148eb8a7561d1$var$prefix = 'fas';
var $381148eb8a7561d1$var$iconName = 'rotate';
var $381148eb8a7561d1$var$width = 512;
var $381148eb8a7561d1$var$height = 512;
var $381148eb8a7561d1$var$aliases = [
    128260,
    "sync-alt"
];
var $381148eb8a7561d1$var$unicode = 'f2f1';
var $381148eb8a7561d1$var$svgPathData = 'M480.1 192l7.9 0c13.3 0 24-10.7 24-24l0-144c0-9.7-5.8-18.5-14.8-22.2S477.9 .2 471 7L419.3 58.8C375 22.1 318 0 256 0 127 0 20.3 95.4 2.6 219.5 .1 237 12.2 253.2 29.7 255.7s33.7-9.7 36.2-27.1C79.2 135.5 159.3 64 256 64 300.4 64 341.2 79 373.7 104.3L327 151c-6.9 6.9-8.9 17.2-5.2 26.2S334.3 192 344 192l136.1 0zm29.4 100.5c2.5-17.5-9.7-33.7-27.1-36.2s-33.7 9.7-36.2 27.1c-13.3 93-93.4 164.5-190.1 164.5-44.4 0-85.2-15-117.7-40.3L185 361c6.9-6.9 8.9-17.2 5.2-26.2S177.7 320 168 320L24 320c-13.3 0-24 10.7-24 24L0 488c0 9.7 5.8 18.5 14.8 22.2S34.1 511.8 41 505l51.8-51.8C137 489.9 194 512 256 512 385 512 491.7 416.6 509.4 292.5z';
$381148eb8a7561d1$exports.definition = {
    prefix: $381148eb8a7561d1$var$prefix,
    iconName: $381148eb8a7561d1$var$iconName,
    icon: [
        $381148eb8a7561d1$var$width,
        $381148eb8a7561d1$var$height,
        $381148eb8a7561d1$var$aliases,
        $381148eb8a7561d1$var$unicode,
        $381148eb8a7561d1$var$svgPathData
    ]
};
$381148eb8a7561d1$exports.faRotate = $381148eb8a7561d1$exports.definition;
$381148eb8a7561d1$exports.prefix = $381148eb8a7561d1$var$prefix;
$381148eb8a7561d1$exports.iconName = $381148eb8a7561d1$var$iconName;
$381148eb8a7561d1$exports.width = $381148eb8a7561d1$var$width;
$381148eb8a7561d1$exports.height = $381148eb8a7561d1$var$height;
$381148eb8a7561d1$exports.ligatures = $381148eb8a7561d1$var$aliases;
$381148eb8a7561d1$exports.unicode = $381148eb8a7561d1$var$unicode;
$381148eb8a7561d1$exports.svgPathData = $381148eb8a7561d1$var$svgPathData;
$381148eb8a7561d1$exports.aliases = $381148eb8a7561d1$var$aliases;


$6a208664f359f326$exports.definition = {
    prefix: $381148eb8a7561d1$exports.prefix,
    iconName: $381148eb8a7561d1$exports.iconName,
    icon: [
        $381148eb8a7561d1$exports.width,
        $381148eb8a7561d1$exports.height,
        $381148eb8a7561d1$exports.aliases,
        $381148eb8a7561d1$exports.unicode,
        $381148eb8a7561d1$exports.svgPathData
    ]
};
$6a208664f359f326$exports.faSyncAlt = $6a208664f359f326$exports.definition;
$6a208664f359f326$exports.prefix = $381148eb8a7561d1$exports.prefix;
$6a208664f359f326$exports.iconName = $381148eb8a7561d1$exports.iconName;
$6a208664f359f326$exports.width = $381148eb8a7561d1$exports.width;
$6a208664f359f326$exports.height = $381148eb8a7561d1$exports.height;
$6a208664f359f326$exports.ligatures = $381148eb8a7561d1$exports.aliases;
$6a208664f359f326$exports.unicode = $381148eb8a7561d1$exports.unicode;
$6a208664f359f326$exports.svgPathData = $381148eb8a7561d1$exports.svgPathData;
$6a208664f359f326$exports.aliases = $381148eb8a7561d1$exports.aliases;


var $246a305793432a97$exports = {};
'use strict';
Object.defineProperty($246a305793432a97$exports, '__esModule', {
    value: true
});
var $e6ffc3c33e64566b$exports = {};
'use strict';
Object.defineProperty($e6ffc3c33e64566b$exports, '__esModule', {
    value: true
});
var $e6ffc3c33e64566b$var$prefix = 'fas';
var $e6ffc3c33e64566b$var$iconName = 'xmark';
var $e6ffc3c33e64566b$var$width = 384;
var $e6ffc3c33e64566b$var$height = 512;
var $e6ffc3c33e64566b$var$aliases = [
    128473,
    10005,
    10006,
    10060,
    215,
    "close",
    "multiply",
    "remove",
    "times"
];
var $e6ffc3c33e64566b$var$unicode = 'f00d';
var $e6ffc3c33e64566b$var$svgPathData = 'M55.1 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L147.2 256 9.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192.5 301.3 329.9 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.8 256 375.1 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192.5 210.7 55.1 73.4z';
$e6ffc3c33e64566b$exports.definition = {
    prefix: $e6ffc3c33e64566b$var$prefix,
    iconName: $e6ffc3c33e64566b$var$iconName,
    icon: [
        $e6ffc3c33e64566b$var$width,
        $e6ffc3c33e64566b$var$height,
        $e6ffc3c33e64566b$var$aliases,
        $e6ffc3c33e64566b$var$unicode,
        $e6ffc3c33e64566b$var$svgPathData
    ]
};
$e6ffc3c33e64566b$exports.faXmark = $e6ffc3c33e64566b$exports.definition;
$e6ffc3c33e64566b$exports.prefix = $e6ffc3c33e64566b$var$prefix;
$e6ffc3c33e64566b$exports.iconName = $e6ffc3c33e64566b$var$iconName;
$e6ffc3c33e64566b$exports.width = $e6ffc3c33e64566b$var$width;
$e6ffc3c33e64566b$exports.height = $e6ffc3c33e64566b$var$height;
$e6ffc3c33e64566b$exports.ligatures = $e6ffc3c33e64566b$var$aliases;
$e6ffc3c33e64566b$exports.unicode = $e6ffc3c33e64566b$var$unicode;
$e6ffc3c33e64566b$exports.svgPathData = $e6ffc3c33e64566b$var$svgPathData;
$e6ffc3c33e64566b$exports.aliases = $e6ffc3c33e64566b$var$aliases;


$246a305793432a97$exports.definition = {
    prefix: $e6ffc3c33e64566b$exports.prefix,
    iconName: $e6ffc3c33e64566b$exports.iconName,
    icon: [
        $e6ffc3c33e64566b$exports.width,
        $e6ffc3c33e64566b$exports.height,
        $e6ffc3c33e64566b$exports.aliases,
        $e6ffc3c33e64566b$exports.unicode,
        $e6ffc3c33e64566b$exports.svgPathData
    ]
};
$246a305793432a97$exports.faTimes = $246a305793432a97$exports.definition;
$246a305793432a97$exports.prefix = $e6ffc3c33e64566b$exports.prefix;
$246a305793432a97$exports.iconName = $e6ffc3c33e64566b$exports.iconName;
$246a305793432a97$exports.width = $e6ffc3c33e64566b$exports.width;
$246a305793432a97$exports.height = $e6ffc3c33e64566b$exports.height;
$246a305793432a97$exports.ligatures = $e6ffc3c33e64566b$exports.aliases;
$246a305793432a97$exports.unicode = $e6ffc3c33e64566b$exports.unicode;
$246a305793432a97$exports.svgPathData = $e6ffc3c33e64566b$exports.svgPathData;
$246a305793432a97$exports.aliases = $e6ffc3c33e64566b$exports.aliases;


var $9abdfe45332a1725$exports = {};
'use strict';
Object.defineProperty($9abdfe45332a1725$exports, '__esModule', {
    value: true
});
var $9abdfe45332a1725$var$prefix = 'fas';
var $9abdfe45332a1725$var$iconName = 'wifi';
var $9abdfe45332a1725$var$width = 576;
var $9abdfe45332a1725$var$height = 512;
var $9abdfe45332a1725$var$aliases = [
    "wifi-3",
    "wifi-strong"
];
var $9abdfe45332a1725$var$unicode = 'f1eb';
var $9abdfe45332a1725$var$svgPathData = 'M288 96c-90.9 0-173.2 36-233.7 94.6-12.7 12.3-33 12-45.2-.7s-12-33 .7-45.2C81.7 74.9 179.9 32 288 32S494.3 74.9 566.3 144.7c12.7 12.3 13 32.6 .7 45.2s-32.6 13-45.2 .7C461.2 132 378.9 96 288 96zM240 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM168 326.2c-11.7 13.3-31.9 14.5-45.2 2.8s-14.5-31.9-2.8-45.2C161 237.4 221.1 208 288 208s127 29.4 168 75.8c11.7 13.3 10.4 33.5-2.8 45.2s-33.5 10.4-45.2-2.8C378.6 292.9 335.8 272 288 272s-90.6 20.9-120 54.2z';
$9abdfe45332a1725$exports.definition = {
    prefix: $9abdfe45332a1725$var$prefix,
    iconName: $9abdfe45332a1725$var$iconName,
    icon: [
        $9abdfe45332a1725$var$width,
        $9abdfe45332a1725$var$height,
        $9abdfe45332a1725$var$aliases,
        $9abdfe45332a1725$var$unicode,
        $9abdfe45332a1725$var$svgPathData
    ]
};
$9abdfe45332a1725$exports.faWifi = $9abdfe45332a1725$exports.definition;
$9abdfe45332a1725$exports.prefix = $9abdfe45332a1725$var$prefix;
$9abdfe45332a1725$exports.iconName = $9abdfe45332a1725$var$iconName;
$9abdfe45332a1725$exports.width = $9abdfe45332a1725$var$width;
$9abdfe45332a1725$exports.height = $9abdfe45332a1725$var$height;
$9abdfe45332a1725$exports.ligatures = $9abdfe45332a1725$var$aliases;
$9abdfe45332a1725$exports.unicode = $9abdfe45332a1725$var$unicode;
$9abdfe45332a1725$exports.svgPathData = $9abdfe45332a1725$var$svgPathData;
$9abdfe45332a1725$exports.aliases = $9abdfe45332a1725$var$aliases;


const $cd949c93e9cf3aa7$var$WALLABAG_ICON = [
    124.155,
    133.529,
    [],
    '',
    // wallabag.svg: Free Art License 1.3 https://github.com/wallabag/logo
    'M108.69.004c-.241-.026-.512.083-.777.299-.572.465-5.551 1.614-8.504 3.917-4.768 3.72-7.707 10.796-9.04 14.708-.024.06-.205.603-.265.79-.62 1.499-1.857 1.495-1.857 1.495v.002c-.6-.065-1.202-.102-1.809-.102-.54 0-1.078.03-1.615.082-.012.002-.02 0-.031 0-1.581.233-2.451-1.696-2.633-2.156C80.312 13.735 75.342 3.277 64.174.463c0 0-2.028-1.554-1.41 1.074.588 2.51 1.805 5.048 1.535 8.74-.124 1.704-1.18 10.442 6.85 14.99.763.432 1.44.796 2.05 1.102-4.041 3.235-7.715 7.739-10.858 12.852 1.597-.981 10.206-5.557 24.097.177 14.29 5.897 23.155.777 24.254.08-3.454-5.678-7.561-10.62-12.103-13.943.303-.083.612-.168.939-.264 6.023-1.742 7.553-6.84 7.875-11.209.364-4.954.615-5.029 1.691-9.486.774-3.21.32-4.495-.404-4.572zM86.774 50.228a4.677 4.677 0 00-1.652.256 6.555 6.555 0 00-1.332.615 3.879 3.879 0 00-1.094.985c-.322.432-.486.901-.486 1.396v16.307c0 2.158-.362 3.75-1.078 4.73-.688.94-1.85 1.397-3.55 1.397-1.704 0-2.876-.46-3.583-1.402-.734-.98-1.108-2.57-1.108-4.725V53.73c0-.908-.383-1.727-1.144-2.437-.751-.702-1.75-1.059-2.973-1.059-1.258 0-2.297.352-3.086 1.045-.81.71-1.22 1.536-1.22 2.451v15.807c0 1.988.193 3.869.574 5.588.393 1.758 1.077 3.3 2.035 4.586.968 1.299 2.282 2.322 3.906 3.049 1.607.716 3.617 1.08 5.975 1.08 2.457 0 4.515-.457 6.115-1.356a10.678 10.678 0 003.371-2.95 10.256 10.256 0 003.295 2.95c1.58.9 3.669 1.354 6.21 1.354 2.358 0 4.358-.363 5.946-1.08 1.601-.726 2.903-1.752 3.873-3.05.96-1.29 1.644-2.832 2.033-4.585.381-1.72.577-3.6.577-5.588V53.73c0-.91-.398-1.733-1.184-2.445-.767-.697-1.82-1.05-3.121-1.05-1.181 0-2.161.356-2.912 1.058-.76.71-1.145 1.53-1.145 2.437v16.057c0 2.154-.381 3.742-1.134 4.72-.728.947-1.891 1.407-3.555 1.407-1.703 0-2.863-.458-3.549-1.397-.716-.979-1.078-2.57-1.078-4.73v-16.12c0-1.097-.501-1.997-1.45-2.597-.805-.507-1.607-.81-2.476-.842zM51.796 82.363a31.2 31.2 0 001.865 5.742c.666 3.745 1.561 12.563-2.674 20.282-3.731 6.8-22.15 16.069-49.484 10.748 0 0-1.096-.765-1.428-.135-.491.932 1.516 1.684 3.582 2.228 19.03 5.04 47.756 2.989 56.777-4.443 4.116-3.388 5.705-7.953 6.108-12.865l.002.008s.11-1.288 1.718-.32c.461.276 2.126 1.36 2.391 2.585.232 1.743.248 3.884-.652 5.383-1.287 2.144-1.302 2.45.392 3.66 1.04.742 5.289 3.865 11.2 7.416.015.01.022.02.037.028 1.25.753 2.988 2.595 2.988 2.595 2.662 3.08 8.45 9.277 10.97 8.11 1.19-.551-.05-3.033-.05-3.033s1.98 2.572 3.043 1.695c.809-.668-.473-3.23-.473-3.23s1.73 1.5 2.758.945c1.258-.68-.188-4.614-10.08-10.627-9.896-6.018-12.579-6.941-12.815-9.627 0 0-.004-.134.004-.365.077-.593.416-1.848 1.854-1.713 2.14.346 4.347.53 6.607.53 2.587 0 5.106-.236 7.535-.689l.002.002.164-.029c.284-.036.838-.019.84.67-.09.873-.331 1.752-.845 2.52-1.447 2.168-.971 2.466.54 3.859.934.859 5.212 4.622 11.07 8.264.013.009.016.016.03.023 1.25.752 3.41 2.814 3.41 2.814 2.428 2.466 6.895 6.595 9.328 6.346 1.646-.168.305-3.002.305-3.002s2.079 2.006 3.1 1.416c1.142-.659-.475-2.754-.475-2.754s1.338.708 2.283.473c.948-.236 1.187-2.643-8.654-8.736-9.842-6.098-13.154-8.244-12.947-10.577 0 0 .003-.379.1-.957.238-1.236.994-3.346 3.406-4.55.079-.04.147-.084.209-.13 7.668-4.45 13.27-11.614 15.246-20.56-1.99 4.941-16.737 8.78-34.647 8.78-17.903 0-32.65-3.839-34.64-8.78z'
];
var $cd949c93e9cf3aa7$export$2e2bcd8739ae039 = $cd949c93e9cf3aa7$var$WALLABAG_ICON;


'use strict';
const $850e10ea38777a82$export$a67558cb68d63c7e = {
    prefix: 'fac',
    iconName: 'wallabag',
    icon: (0, $cd949c93e9cf3aa7$export$2e2bcd8739ae039)
};


function $b6b0d4eaa4224082$export$7f7cbe89f1eacd2(props) {
    const { label: label, size: size } = props;
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $fcda9d1f1901e894$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                icon: $16a4fe33ccdf2ed7$exports.faSpinner,
                size: size,
                spin: true,
                "aria-hidden": "true",
                title: label
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                className: "visually-hidden",
                role: "alert",
                children: label
            })
        ]
    });
}
function $b6b0d4eaa4224082$export$84dbad74efe95918(props) {
    const { label: label } = props;
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
        className: "spinner-big",
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($b6b0d4eaa4224082$export$7f7cbe89f1eacd2, {
            size: "10x",
            label: label
        })
    });
}





var $5NSbj = parcelRequire("5NSbj");
function $433f7d372a884a6c$export$e51161e9fbfde80e(translated, params) {
    let formatted = '';
    let curChar;
    let buffer = '';
    let state = 'out';
    let placeholder;
    let plural;
    let pluralKeyword;
    let pluralValue;
    for(let i = 0, len = translated.length; i < len; i++){
        curChar = translated.charAt(i);
        switch(curChar){
            case '{':
                if (placeholder) {
                    if (state === 'plural') {
                        const kw = buffer.trim();
                        if (kw === 'zero' || kw === 'one' || kw === 'other') {
                            pluralKeyword = kw;
                            buffer = '';
                        } else pluralKeyword = undefined;
                    }
                } else {
                    formatted = formatted + buffer;
                    buffer = '';
                    placeholder = {};
                    state = 'index';
                }
                break;
            case '}':
            case ',':
                if (placeholder) {
                    if (state === 'index') {
                        placeholder.index = buffer.trim();
                        placeholder.value = params[placeholder.index];
                        buffer = '';
                    } else if (state === 'type') {
                        placeholder.type = buffer.trim();
                        buffer = '';
                        if (placeholder.type === 'plural') {
                            plural = {};
                            state = 'plural';
                        }
                    }
                    if (curChar === '}') {
                        if (state === 'plural' && pluralKeyword) {
                            plural[pluralKeyword] = buffer;
                            buffer = '';
                            pluralKeyword = undefined;
                        } else if (plural) {
                            if ('zero' in plural && placeholder.value === 0) pluralValue = plural.zero;
                            else if ('one' in plural && placeholder.value === 1) pluralValue = plural.one;
                            else pluralValue = plural.other;
                            formatted = formatted + pluralValue.replace('#', placeholder.value.toString());
                            plural = undefined;
                            placeholder = undefined;
                            state = 'out';
                        } else {
                            formatted = formatted + placeholder.value;
                            placeholder = undefined;
                            state = 'out';
                        }
                    } else if (curChar === ',' && state === 'index') state = 'type';
                }
                break;
            default:
                buffer = buffer + curChar;
                break;
        }
    }
    if (state != 'out') return "Error formatting '" + translated + "', bug report?";
    formatted = formatted + buffer;
    return formatted;
}
const $433f7d372a884a6c$export$51216bcc3983e55d = (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).createContext(()=>{
    throw new Error('Missing l10n context');
});



var $5NSbj = parcelRequire("5NSbj");
const $b7416e8649ee66da$export$326f6d1b69f1c06e = (0, $5NSbj.createContext)(undefined);


async function $2fd9af2234740b06$var$handleLogIn({ configuration: configuration, navigate: navigate, username: username, password: password, enableOffline: enableOffline, returnLocation: returnLocation, _: _ }) {
    try {
        await (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).login({
            configuration: configuration,
            username: username,
            password: password,
            enableOffline: enableOffline
        });
        navigate(returnLocation);
    } catch (err) {
        const message = err instanceof (0, $b82622975d92f7af$export$5e64a9683d127ef6) ? _('login_invalid_credentials') : _('login_error_generic', {
            errorMessage: err instanceof (0, $b82622975d92f7af$export$65bd6083489bd8bb) ? `HTTP ${err.response.status} ${err.message}` : err.message
        });
        navigate('/sign/in', {
            replace: true,
            state: {
                error: message
            }
        });
    }
}
function $2fd9af2234740b06$export$2e2bcd8739ae039(props) {
    const { offlineEnabled: offlineEnabled } = props;
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    const configuration = (0, $5NSbj.use)((0, $b7416e8649ee66da$export$326f6d1b69f1c06e));
    const navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    const location = (0, $dcbcccfe7d0a797a$export$45d76561a5302f2b)();
    const error = location?.state?.error;
    const returnLocation = location?.state?.returnLocation ?? '/';
    const [, submitAction, loading] = (0, $5NSbj.useActionState)(async (_previousState, formData)=>{
        const username = formData.get('username');
        const password = formData.get('password');
        const enableOffline = formData.get('enableoffline') === 'on';
        await $2fd9af2234740b06$var$handleLogIn({
            configuration: configuration,
            navigate: navigate,
            username: username,
            password: password,
            enableOffline: enableOffline,
            returnLocation: returnLocation,
            _: _
        });
    }, undefined);
    const formOnSubmit = (0, $5NSbj.useCallback)((event)=>{
        // Unlike `action` prop, `onSubmit` avoids clearing the form on submit.
        // https://github.com/facebook/react/issues/29034#issuecomment-2143595195
        event.preventDefault();
        const formData = new (0, $fbb973a7ef395689$export$5300a9e19ff2767e)(event.currentTarget);
        (0, $5NSbj.startTransition)(()=>submitAction(formData));
    }, []);
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $fcda9d1f1901e894$exports.Fragment), {
        children: [
            loading ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $b6b0d4eaa4224082$export$84dbad74efe95918), {
                label: _('login_in_progress')
            }) : null,
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("form", {
                action: "",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                    loading: loading
                }),
                method: "post",
                onSubmit: formOnSubmit,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
                    id: "login",
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("h1", {
                                children: [
                                    configuration.htmlTitle,
                                    " login"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                                    htmlFor: "username",
                                    children: _('login_username')
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                                    type: "text",
                                    name: "username",
                                    id: "username",
                                    accessKey: "u",
                                    autoComplete: "username",
                                    autoFocus: true,
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                                    htmlFor: "password",
                                    children: _('login_password')
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                                    type: "password",
                                    name: "password",
                                    id: "password",
                                    accessKey: "p",
                                    autoComplete: "current-password"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                                    htmlFor: "enableoffline",
                                    children: _('login_offline')
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                                            type: "checkbox",
                                            name: "enableoffline",
                                            id: "enableoffline",
                                            accessKey: "o",
                                            defaultChecked: offlineEnabled
                                        }),
                                        ' ',
                                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                            className: "badge-experimental",
                                            children: _('experimental')
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                            className: "error",
                            "aria-live": "assertive",
                            children: error
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                            className: "button",
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                                    type: "submit",
                                    accessKey: "l",
                                    value: _('login')
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $5NSbj = parcelRequire("5NSbj");





var $5NSbj = parcelRequire("5NSbj");

var $5NSbj = parcelRequire("5NSbj");

var $5NSbj = parcelRequire("5NSbj");

var $21jDP = parcelRequire("21jDP");

var $5NSbj = parcelRequire("5NSbj");

var $21jDP = parcelRequire("21jDP");

var $5NSbj = parcelRequire("5NSbj");


var $5NSbj = parcelRequire("5NSbj");
const $f873b6743b782796$export$7ae630fe844fbd1f = ({ block: block, element: element, modifiers: modifiers, className: className })=>(0, $5NSbj.useMemo)(()=>{
        const blockElement = element ? `${block}__${element}` : block;
        let classString = blockElement;
        modifiers && Object.keys(modifiers).forEach((name)=>{
            const value = modifiers[name];
            if (value) classString += ` ${blockElement}--${value === true ? name : `${name}-${value}`}`;
        });
        let expandedClassName = typeof className === 'function' ? className(modifiers) : className;
        if (typeof expandedClassName === 'string') {
            expandedClassName = expandedClassName.trim();
            if (expandedClassName) classString += ` ${expandedClassName}`;
        }
        return classString;
    }, [
        block,
        element,
        modifiers,
        className
    ]);



var $5NSbj = parcelRequire("5NSbj");
const $116b33b50ccf2e72$export$ccf052fa53df1929 = 'szh-menu-container';
const $116b33b50ccf2e72$export$832250593589325a = 'szh-menu';
const $116b33b50ccf2e72$export$b3d82f113f746a0 = 'szh-menu-button';
const $116b33b50ccf2e72$export$3b35f0f35c840df9 = 'arrow';
const $116b33b50ccf2e72$export$b5a3c9a9995a8c24 = 'item';
const $116b33b50ccf2e72$export$10b42530e0558a83 = 'divider';
const $116b33b50ccf2e72$export$29e3fcfc61abbafd = 'header';
const $116b33b50ccf2e72$export$e4f8e9b9e6d790ae = 'group';
const $116b33b50ccf2e72$export$3b437b9ab85faa03 = 'submenu';
const $116b33b50ccf2e72$export$d6766e4ef63d0cb0 = 'radio-group';
const $116b33b50ccf2e72$export$15c1690330cd94e = /*#__PURE__*/ (0, $5NSbj.createContext)();
const $116b33b50ccf2e72$export$7cb023214e4bda1e = /*#__PURE__*/ (0, $5NSbj.createContext)({});
const $116b33b50ccf2e72$export$1c2bdfb4407fdacf = /*#__PURE__*/ (0, $5NSbj.createContext)({});
const $116b33b50ccf2e72$export$ee9f2ec6c8119c2a = /*#__PURE__*/ (0, $5NSbj.createContext)({});
const $116b33b50ccf2e72$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $5NSbj.createContext)({});
const $116b33b50ccf2e72$export$8fa45c82eddfe270 = /*#__PURE__*/ (0, $5NSbj.createContext)({});
const $116b33b50ccf2e72$export$4b0075e5ea5e1f26 = /*#__PURE__*/ Object.freeze({
    ENTER: 'Enter',
    ESC: 'Escape',
    SPACE: ' ',
    HOME: 'Home',
    END: 'End',
    LEFT: 'ArrowLeft',
    RIGHT: 'ArrowRight',
    UP: 'ArrowUp',
    DOWN: 'ArrowDown'
});
const $116b33b50ccf2e72$export$6db955af9e6f8fcd = /*#__PURE__*/ Object.freeze({
    RESET: 0,
    SET: 1,
    UNSET: 2,
    INCREASE: 3,
    DECREASE: 4,
    FIRST: 5,
    LAST: 6,
    SET_INDEX: 7
});
const $116b33b50ccf2e72$export$8fd8df51a9b835e6 = /*#__PURE__*/ Object.freeze({
    CLICK: 'click',
    CANCEL: 'cancel',
    BLUR: 'blur',
    SCROLL: 'scroll'
});
const $116b33b50ccf2e72$export$8c6ccba1b6ce32e9 = /*#__PURE__*/ Object.freeze({
    FIRST: 'first',
    LAST: 'last'
});
const $116b33b50ccf2e72$export$be1d8b0328ba66b6 = /*#__PURE__*/ Object.freeze({
    entering: 'opening',
    entered: 'open',
    exiting: 'closing',
    exited: 'closed'
});
const $116b33b50ccf2e72$export$f8d144aafbd3a470 = 'absolute';
const $116b33b50ccf2e72$export$a5a9d7469a9cc520 = 'none';
const $116b33b50ccf2e72$export$3e982710469daaf = 'menuitem';
const $116b33b50ccf2e72$export$42466afb37c6c021 = {
    preventScroll: true
};



var $21jDP = parcelRequire("21jDP");
const $404ce4a19ed08ccf$export$30c2dce1a652e248 = (state)=>!!state && state[0] === 'o';
const $404ce4a19ed08ccf$export$3e3e6d241f8feb60 = (0, $21jDP.unstable_batchedUpdates);
const $404ce4a19ed08ccf$export$d5639c01d489b0c = (transition, name)=>transition === true || !!(transition && transition[name]);
const $404ce4a19ed08ccf$export$175e60bb96229ece = (fn, arg)=>typeof fn === 'function' ? fn(arg) : fn;
const $404ce4a19ed08ccf$var$internalKey = '_szhsinMenu';
const $404ce4a19ed08ccf$export$7d9f7e9c1c02b41e = (component)=>component[$404ce4a19ed08ccf$var$internalKey];
const $404ce4a19ed08ccf$export$4c4bf90f1b4d3105 = (name, component)=>Object.defineProperty(component, $404ce4a19ed08ccf$var$internalKey, {
        value: name
    });
const $404ce4a19ed08ccf$export$9d1611c77c2fe928 = (target, source)=>{
    source && Object.keys(source).forEach((key)=>{
        const targetProp = target[key];
        const sourceProp = source[key];
        if (typeof sourceProp === 'function' && targetProp) target[key] = (...arg)=>{
            sourceProp(...arg);
            targetProp(...arg);
        };
        else target[key] = sourceProp;
    });
    return target;
};
const $404ce4a19ed08ccf$export$4bc3c325941e6f67 = (paddingStr)=>{
    if (typeof paddingStr !== 'string') return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    const padding = paddingStr.trim().split(/\s+/, 4).map(parseFloat);
    const top = !isNaN(padding[0]) ? padding[0] : 0;
    const right = !isNaN(padding[1]) ? padding[1] : top;
    return {
        top: top,
        right: right,
        bottom: !isNaN(padding[2]) ? padding[2] : top,
        left: !isNaN(padding[3]) ? padding[3] : right
    };
};
const $404ce4a19ed08ccf$export$7414735161c19437 = (node)=>{
    while(node){
        node = node.parentNode;
        if (!node || node === document.body || !node.parentNode) return;
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY } = getComputedStyle(node);
        if (/auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX)) return node;
    }
};
function $404ce4a19ed08ccf$export$ffb2d5922287e12(isDisabled, isHovering) {
    return {
        'aria-disabled': isDisabled || undefined,
        tabIndex: isHovering ? 0 : -1
    };
}
function $404ce4a19ed08ccf$export$a12bd5aaf0b59fa0(nodeList, node) {
    for(let i = 0; i < nodeList.length; i++){
        if (nodeList[i] === node) return i;
    }
    return -1;
}


const $f928c1f56265b480$export$b286f91cddfedb5a = ({ className: className, containerRef: containerRef, containerProps: containerProps, children: children, isOpen: isOpen, theming: theming, transition: transition, onClose: onClose })=>{
    const itemTransition = (0, $404ce4a19ed08ccf$export$d5639c01d489b0c)(transition, 'item');
    const onKeyDown = ({ key: key })=>{
        switch(key){
            case (0, $116b33b50ccf2e72$export$4b0075e5ea5e1f26).ESC:
                (0, $404ce4a19ed08ccf$export$175e60bb96229ece)(onClose, {
                    key: key,
                    reason: (0, $116b33b50ccf2e72$export$8fd8df51a9b835e6).CANCEL
                });
                break;
        }
    };
    const onBlur = (e)=>{
        if (isOpen && !e.currentTarget.contains(e.relatedTarget)) (0, $404ce4a19ed08ccf$export$175e60bb96229ece)(onClose, {
            reason: (0, $116b33b50ccf2e72$export$8fd8df51a9b835e6).BLUR
        });
    };
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
        ...(0, $404ce4a19ed08ccf$export$9d1611c77c2fe928)({
            onKeyDown: onKeyDown,
            onBlur: onBlur
        }, containerProps),
        className: (0, $f873b6743b782796$export$7ae630fe844fbd1f)({
            block: (0, $116b33b50ccf2e72$export$ccf052fa53df1929),
            modifiers: (0, $5NSbj.useMemo)(()=>({
                    theme: theming,
                    itemTransition: itemTransition
                }), [
                theming,
                itemTransition
            ]),
            className: className
        }),
        style: {
            position: 'absolute',
            ...containerProps?.style
        },
        ref: containerRef,
        children: children
    });
};



const $ab643f056147bc91$export$fd76cd1ffdc0d698 = ()=>{
    let timer, count = 0;
    return {
        toggle: (isOpen)=>{
            isOpen ? count++ : count--;
            count = Math.max(count, 0);
        },
        on: (closeDelay, pending, settled)=>{
            if (count) {
                if (!timer) timer = setTimeout(()=>{
                    timer = 0;
                    pending();
                }, closeDelay);
            } else settled?.();
        },
        off: ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = 0;
            }
        }
    };
};




var $5NSbj = parcelRequire("5NSbj");


const $42355e5a654758d4$export$7bfdd97581ca93c = (menuRef)=>{
    const [hoverItem, setHoverItem] = (0, $5NSbj.useState)();
    const stateRef = (0, $5NSbj.useRef)({
        items: [],
        hoverIndex: -1,
        sorted: false
    });
    const mutableState = stateRef.current;
    const updateItems = (0, $5NSbj.useCallback)((item, isMounted)=>{
        const { items: items } = mutableState;
        if (!item) mutableState.items = [];
        else if (isMounted) items.push(item);
        else {
            const index = items.indexOf(item);
            if (index > -1) {
                items.splice(index, 1);
                if (item.contains(document.activeElement)) {
                    menuRef.current.focus((0, $116b33b50ccf2e72$export$42466afb37c6c021));
                    setHoverItem();
                }
            }
        }
        mutableState.hoverIndex = -1;
        mutableState.sorted = false;
    }, [
        mutableState,
        menuRef
    ]);
    const dispatch = (0, $5NSbj.useCallback)((actionType, item, nextIndex)=>{
        const { items: items, hoverIndex: hoverIndex } = mutableState;
        const sortItems = ()=>{
            if (mutableState.sorted) return;
            const orderedNodes = menuRef.current.querySelectorAll('.szh-menu__item');
            items.sort((a, b)=>(0, $404ce4a19ed08ccf$export$a12bd5aaf0b59fa0)(orderedNodes, a) - (0, $404ce4a19ed08ccf$export$a12bd5aaf0b59fa0)(orderedNodes, b));
            mutableState.sorted = true;
        };
        let index = -1, newItem = undefined;
        switch(actionType){
            case (0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).RESET:
                break;
            case (0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).SET:
                newItem = item;
                break;
            case (0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).UNSET:
                newItem = (prevItem)=>prevItem === item ? undefined : prevItem;
                break;
            case (0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).FIRST:
                sortItems();
                index = 0;
                newItem = items[index];
                break;
            case (0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).LAST:
                sortItems();
                index = items.length - 1;
                newItem = items[index];
                break;
            case (0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).SET_INDEX:
                sortItems();
                index = nextIndex;
                newItem = items[index];
                break;
            case (0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).INCREASE:
                sortItems();
                index = hoverIndex;
                if (index < 0) index = items.indexOf(item);
                index++;
                if (index >= items.length) index = 0;
                newItem = items[index];
                break;
            case (0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).DECREASE:
                sortItems();
                index = hoverIndex;
                if (index < 0) index = items.indexOf(item);
                index--;
                if (index < 0) index = items.length - 1;
                newItem = items[index];
                break;
            default:
        }
        if (!newItem) index = -1;
        setHoverItem(newItem);
        mutableState.hoverIndex = index;
    }, [
        menuRef,
        mutableState
    ]);
    return {
        hoverItem: hoverItem,
        dispatch: dispatch,
        updateItems: updateItems
    };
};



const $1df674500b6bf66e$var$getNativeDimension = (transformed, untransformed)=>Math.round(transformed) === untransformed ? transformed : untransformed;
const $1df674500b6bf66e$export$e34ab37ec351e6cb = (element)=>{
    const rect = element.getBoundingClientRect();
    rect.width = $1df674500b6bf66e$var$getNativeDimension(rect.width, element.offsetWidth);
    rect.height = $1df674500b6bf66e$var$getNativeDimension(rect.height, element.offsetHeight);
    return rect;
};



const $dbb4f7ccaaebec59$export$62e2806a96b09d4 = (containerElt, menuElt, menuScroll, boundingBoxPadding)=>{
    const menuRect = (0, $1df674500b6bf66e$export$e34ab37ec351e6cb)(menuElt);
    const containerRect = containerElt.getBoundingClientRect();
    const boundingRect = menuScroll === window ? {
        left: 0,
        top: 0,
        right: document.documentElement.clientWidth,
        bottom: window.innerHeight
    } : menuScroll.getBoundingClientRect();
    const padding = (0, $404ce4a19ed08ccf$export$4bc3c325941e6f67)(boundingBoxPadding);
    const getLeftOverflow = (x)=>x + containerRect.left - boundingRect.left - padding.left;
    const getRightOverflow = (x)=>x + containerRect.left + menuRect.width - boundingRect.right + padding.right;
    const getTopOverflow = (y)=>y + containerRect.top - boundingRect.top - padding.top;
    const getBottomOverflow = (y)=>y + containerRect.top + menuRect.height - boundingRect.bottom + padding.bottom;
    const confineHorizontally = (x)=>{
        let leftOverflow = getLeftOverflow(x);
        if (leftOverflow < 0) x -= leftOverflow;
        else {
            const rightOverflow = getRightOverflow(x);
            if (rightOverflow > 0) {
                x -= rightOverflow;
                leftOverflow = getLeftOverflow(x);
                if (leftOverflow < 0) x -= leftOverflow;
            }
        }
        return x;
    };
    const confineVertically = (y)=>{
        let topOverflow = getTopOverflow(y);
        if (topOverflow < 0) y -= topOverflow;
        else {
            const bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0) {
                y -= bottomOverflow;
                topOverflow = getTopOverflow(y);
                if (topOverflow < 0) y -= topOverflow;
            }
        }
        return y;
    };
    return {
        menuRect: menuRect,
        containerRect: containerRect,
        getLeftOverflow: getLeftOverflow,
        getRightOverflow: getRightOverflow,
        getTopOverflow: getTopOverflow,
        getBottomOverflow: getBottomOverflow,
        confineHorizontally: confineHorizontally,
        confineVertically: confineVertically
    };
};


const $41327b5748854172$export$95257ec7631d2e00 = ({ arrowRef: arrowRef, menuY: menuY, anchorRect: anchorRect, containerRect: containerRect, menuRect: menuRect })=>{
    let y = anchorRect.top - containerRect.top - menuY + anchorRect.height / 2;
    const offset = arrowRef.current.offsetHeight * 1.25;
    y = Math.max(offset, y);
    y = Math.min(y, menuRect.height - offset);
    return y;
};


const $eab445d4d245d8cb$export$f768fc0fa8f5878e = ({ anchorRect: anchorRect, containerRect: containerRect, menuRect: menuRect, placeLeftorRightY: placeLeftorRightY, placeLeftX: placeLeftX, placeRightX: placeRightX, getLeftOverflow: getLeftOverflow, getRightOverflow: getRightOverflow, confineHorizontally: confineHorizontally, confineVertically: confineVertically, arrowRef: arrowRef, arrow: arrow, direction: direction, position: position })=>{
    let computedDirection = direction;
    let y = placeLeftorRightY;
    if (position !== 'initial') {
        y = confineVertically(y);
        if (position === 'anchor') {
            y = Math.min(y, anchorRect.bottom - containerRect.top);
            y = Math.max(y, anchorRect.top - containerRect.top - menuRect.height);
        }
    }
    let x, leftOverflow, rightOverflow;
    if (computedDirection === 'left') {
        x = placeLeftX;
        if (position !== 'initial') {
            leftOverflow = getLeftOverflow(x);
            if (leftOverflow < 0) {
                rightOverflow = getRightOverflow(placeRightX);
                if (rightOverflow <= 0 || -leftOverflow > rightOverflow) {
                    x = placeRightX;
                    computedDirection = 'right';
                }
            }
        }
    } else {
        x = placeRightX;
        if (position !== 'initial') {
            rightOverflow = getRightOverflow(x);
            if (rightOverflow > 0) {
                leftOverflow = getLeftOverflow(placeLeftX);
                if (leftOverflow >= 0 || -leftOverflow < rightOverflow) {
                    x = placeLeftX;
                    computedDirection = 'left';
                }
            }
        }
    }
    if (position === 'auto') x = confineHorizontally(x);
    const arrowY = arrow ? (0, $41327b5748854172$export$95257ec7631d2e00)({
        menuY: y,
        arrowRef: arrowRef,
        anchorRect: anchorRect,
        containerRect: containerRect,
        menuRect: menuRect
    }) : undefined;
    return {
        arrowY: arrowY,
        x: x,
        y: y,
        computedDirection: computedDirection
    };
};


const $8093c731807a3a72$export$4c9b3bcc0c46b8d3 = ({ arrowRef: arrowRef, menuX: menuX, anchorRect: anchorRect, containerRect: containerRect, menuRect: menuRect })=>{
    let x = anchorRect.left - containerRect.left - menuX + anchorRect.width / 2;
    const offset = arrowRef.current.offsetWidth * 1.25;
    x = Math.max(offset, x);
    x = Math.min(x, menuRect.width - offset);
    return x;
};


const $0c29b83c85b7f8b2$export$65848579d307fa3f = ({ anchorRect: anchorRect, containerRect: containerRect, menuRect: menuRect, placeToporBottomX: placeToporBottomX, placeTopY: placeTopY, placeBottomY: placeBottomY, getTopOverflow: getTopOverflow, getBottomOverflow: getBottomOverflow, confineHorizontally: confineHorizontally, confineVertically: confineVertically, arrowRef: arrowRef, arrow: arrow, direction: direction, position: position })=>{
    let computedDirection = direction === 'top' ? 'top' : 'bottom';
    let x = placeToporBottomX;
    if (position !== 'initial') {
        x = confineHorizontally(x);
        if (position === 'anchor') {
            x = Math.min(x, anchorRect.right - containerRect.left);
            x = Math.max(x, anchorRect.left - containerRect.left - menuRect.width);
        }
    }
    let y, topOverflow, bottomOverflow;
    if (computedDirection === 'top') {
        y = placeTopY;
        if (position !== 'initial') {
            topOverflow = getTopOverflow(y);
            if (topOverflow < 0) {
                bottomOverflow = getBottomOverflow(placeBottomY);
                if (bottomOverflow <= 0 || -topOverflow > bottomOverflow) {
                    y = placeBottomY;
                    computedDirection = 'bottom';
                }
            }
        }
    } else {
        y = placeBottomY;
        if (position !== 'initial') {
            bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0) {
                topOverflow = getTopOverflow(placeTopY);
                if (topOverflow >= 0 || -topOverflow < bottomOverflow) {
                    y = placeTopY;
                    computedDirection = 'top';
                }
            }
        }
    }
    if (position === 'auto') y = confineVertically(y);
    const arrowX = arrow ? (0, $8093c731807a3a72$export$4c9b3bcc0c46b8d3)({
        menuX: x,
        arrowRef: arrowRef,
        anchorRect: anchorRect,
        containerRect: containerRect,
        menuRect: menuRect
    }) : undefined;
    return {
        arrowX: arrowX,
        x: x,
        y: y,
        computedDirection: computedDirection
    };
};


const $797cff5a5141e988$export$5a6e2d3543ff3d7e = ({ arrow: arrow, align: align, direction: direction, gap: gap, shift: shift, position: position, anchorRect: anchorRect, arrowRef: arrowRef, positionHelpers: positionHelpers })=>{
    const { menuRect: menuRect, containerRect: containerRect } = positionHelpers;
    const isHorizontal = direction === 'left' || direction === 'right';
    let horizontalOffset = isHorizontal ? gap : shift;
    let verticalOffset = isHorizontal ? shift : gap;
    if (arrow) {
        const arrowElt = arrowRef.current;
        if (isHorizontal) horizontalOffset += arrowElt.offsetWidth;
        else verticalOffset += arrowElt.offsetHeight;
    }
    const placeLeftX = anchorRect.left - containerRect.left - menuRect.width - horizontalOffset;
    const placeRightX = anchorRect.right - containerRect.left + horizontalOffset;
    const placeTopY = anchorRect.top - containerRect.top - menuRect.height - verticalOffset;
    const placeBottomY = anchorRect.bottom - containerRect.top + verticalOffset;
    let placeToporBottomX, placeLeftorRightY;
    if (align === 'end') {
        placeToporBottomX = anchorRect.right - containerRect.left - menuRect.width;
        placeLeftorRightY = anchorRect.bottom - containerRect.top - menuRect.height;
    } else if (align === 'center') {
        placeToporBottomX = anchorRect.left - containerRect.left - (menuRect.width - anchorRect.width) / 2;
        placeLeftorRightY = anchorRect.top - containerRect.top - (menuRect.height - anchorRect.height) / 2;
    } else {
        placeToporBottomX = anchorRect.left - containerRect.left;
        placeLeftorRightY = anchorRect.top - containerRect.top;
    }
    placeToporBottomX += horizontalOffset;
    placeLeftorRightY += verticalOffset;
    const options = {
        ...positionHelpers,
        anchorRect: anchorRect,
        placeLeftX: placeLeftX,
        placeRightX: placeRightX,
        placeLeftorRightY: placeLeftorRightY,
        placeTopY: placeTopY,
        placeBottomY: placeBottomY,
        placeToporBottomX: placeToporBottomX,
        arrowRef: arrowRef,
        arrow: arrow,
        direction: direction,
        position: position
    };
    switch(direction){
        case 'left':
        case 'right':
            return (0, $eab445d4d245d8cb$export$f768fc0fa8f5878e)(options);
        case 'top':
        case 'bottom':
        default:
            return (0, $0c29b83c85b7f8b2$export$65848579d307fa3f)(options);
    }
};



var $5NSbj = parcelRequire("5NSbj");
const $751cb7229c9a43e9$export$e5c5a5f917a5871c = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $5NSbj.useLayoutEffect) : (0, $5NSbj.useEffect);




var $5NSbj = parcelRequire("5NSbj");
function $20a0bbe0b4c957b3$var$setRef(ref, instance) {
    typeof ref === 'function' ? ref(instance) : ref.current = instance;
}
const $20a0bbe0b4c957b3$export$2d8be4568b07be94 = (refA, refB)=>(0, $5NSbj.useMemo)(()=>{
        if (!refA) return refB;
        if (!refB) return refA;
        return (instance)=>{
            $20a0bbe0b4c957b3$var$setRef(refA, instance);
            $20a0bbe0b4c957b3$var$setRef(refB, instance);
        };
    }, [
        refA,
        refB
    ]);


const $fcbd87a20e962171$var$offScreen = -9999;
const $fcbd87a20e962171$export$d4c4e98c5044dc8 = ({ ariaLabel: ariaLabel, menuClassName: menuClassName, menuStyle: menuStyle, arrow: arrow, arrowProps: arrowProps = {}, anchorPoint: anchorPoint, anchorRef: anchorRef, containerRef: containerRef, containerProps: containerProps, externalRef: externalRef, parentScrollingRef: parentScrollingRef, align: align = 'start', direction: direction = 'bottom', position: position = 'auto', overflow: overflow = 'visible', setDownOverflow: setDownOverflow, repositionFlag: repositionFlag, captureFocus: captureFocus = true, state: state, endTransition: endTransition, isDisabled: isDisabled, menuItemFocus: menuItemFocus, gap: gap = 0, shift: shift = 0, children: children, onClose: onClose, focusProps: _1, ...restProps })=>{
    const [menuPosition, setMenuPosition] = (0, $5NSbj.useState)({
        x: $fcbd87a20e962171$var$offScreen,
        y: $fcbd87a20e962171$var$offScreen
    });
    const [arrowPosition, setArrowPosition] = (0, $5NSbj.useState)({});
    const [overflowData, setOverflowData] = (0, $5NSbj.useState)();
    const [expandedDirection, setExpandedDirection] = (0, $5NSbj.useState)(direction);
    const [submenuCtx] = (0, $5NSbj.useState)((0, $ab643f056147bc91$export$fd76cd1ffdc0d698));
    const [reposSubmenu, forceReposSubmenu] = (0, $5NSbj.useReducer)((c)=>c + 1, 1);
    const { transition: transition, boundingBoxRef: boundingBoxRef, boundingBoxPadding: boundingBoxPadding, rootMenuRef: rootMenuRef, rootAnchorRef: rootAnchorRef, scrollNodesRef: scrollNodesRef, reposition: reposition, viewScroll: viewScroll, submenuCloseDelay: submenuCloseDelay } = (0, $5NSbj.useContext)((0, $116b33b50ccf2e72$export$8fa45c82eddfe270));
    const { submenuCtx: parentSubmenuCtx, reposSubmenu: reposFlag = repositionFlag } = (0, $5NSbj.useContext)((0, $116b33b50ccf2e72$export$1c2bdfb4407fdacf));
    const menuRef = (0, $5NSbj.useRef)();
    const arrowRef = (0, $5NSbj.useRef)();
    const prevOpen = (0, $5NSbj.useRef)(false);
    const { hoverItem: hoverItem, dispatch: dispatch, updateItems: updateItems } = (0, $42355e5a654758d4$export$7bfdd97581ca93c)(menuRef);
    const isOpen = (0, $404ce4a19ed08ccf$export$30c2dce1a652e248)(state);
    const openTransition = (0, $404ce4a19ed08ccf$export$d5639c01d489b0c)(transition, 'open');
    const closeTransition = (0, $404ce4a19ed08ccf$export$d5639c01d489b0c)(transition, 'close');
    const scrollNodes = scrollNodesRef.current;
    const onKeyDown = (e)=>{
        switch(e.key){
            case (0, $116b33b50ccf2e72$export$4b0075e5ea5e1f26).HOME:
                dispatch((0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).FIRST);
                break;
            case (0, $116b33b50ccf2e72$export$4b0075e5ea5e1f26).END:
                dispatch((0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).LAST);
                break;
            case (0, $116b33b50ccf2e72$export$4b0075e5ea5e1f26).UP:
                dispatch((0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).DECREASE, hoverItem);
                break;
            case (0, $116b33b50ccf2e72$export$4b0075e5ea5e1f26).DOWN:
                dispatch((0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).INCREASE, hoverItem);
                break;
            case (0, $116b33b50ccf2e72$export$4b0075e5ea5e1f26).SPACE:
                if (e.target && e.target.className.indexOf((0, $116b33b50ccf2e72$export$832250593589325a)) !== -1) e.preventDefault();
                return;
            default:
                return;
        }
        e.preventDefault();
        e.stopPropagation();
    };
    const onAnimationEnd = ()=>{
        if (state === 'closing') setOverflowData();
        (0, $404ce4a19ed08ccf$export$175e60bb96229ece)(endTransition);
    };
    const onPointerMove = (e)=>{
        e.stopPropagation();
        submenuCtx.on(submenuCloseDelay, ()=>{
            dispatch((0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).RESET);
            menuRef.current.focus((0, $116b33b50ccf2e72$export$42466afb37c6c021));
        });
    };
    const onPointerLeave = (e)=>{
        if (e.target === e.currentTarget) submenuCtx.off();
    };
    const handlePosition = (0, $5NSbj.useCallback)((noOverflowCheck)=>{
        const menuElt = menuRef.current;
        const containerElt = containerRef.current;
        if (!menuElt || !containerElt) return;
        const anchorRect = anchorRef ? anchorRef.current?.getBoundingClientRect() : anchorPoint ? {
            left: anchorPoint.x,
            right: anchorPoint.x,
            top: anchorPoint.y,
            bottom: anchorPoint.y,
            width: 0,
            height: 0
        } : null;
        if (!anchorRect) return;
        if (!scrollNodes.menu) scrollNodes.menu = (boundingBoxRef ? boundingBoxRef.current : (0, $404ce4a19ed08ccf$export$7414735161c19437)(rootMenuRef.current)) || window;
        const positionHelpers = (0, $dbb4f7ccaaebec59$export$62e2806a96b09d4)(containerElt, menuElt, scrollNodes.menu, boundingBoxPadding);
        let { arrowX: arrowX, arrowY: arrowY, x: x, y: y, computedDirection: computedDirection } = (0, $797cff5a5141e988$export$5a6e2d3543ff3d7e)({
            arrow: arrow,
            align: align,
            direction: direction,
            gap: gap,
            shift: shift,
            position: position,
            anchorRect: anchorRect,
            arrowRef: arrowRef,
            positionHelpers: positionHelpers
        });
        const { menuRect: menuRect } = positionHelpers;
        const menuHeight = menuRect.height;
        if (!noOverflowCheck && overflow !== 'visible') {
            const { getTopOverflow: getTopOverflow, getBottomOverflow: getBottomOverflow } = positionHelpers;
            let height, overflowAmt;
            const bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0) {
                height = menuHeight - bottomOverflow;
                overflowAmt = bottomOverflow;
            } else {
                const topOverflow = getTopOverflow(y);
                if (topOverflow < 0) {
                    height = menuHeight + topOverflow;
                    overflowAmt = 0 - topOverflow;
                    if (height >= 0) y -= topOverflow;
                }
            }
            if (height >= 0) setOverflowData({
                height: height,
                overflowAmt: overflowAmt
            });
        }
        if (arrow) setArrowPosition({
            x: arrowX,
            y: arrowY
        });
        setMenuPosition({
            x: x,
            y: y
        });
        setExpandedDirection(computedDirection);
    }, [
        arrow,
        align,
        boundingBoxPadding,
        direction,
        gap,
        shift,
        position,
        overflow,
        anchorPoint,
        anchorRef,
        containerRef,
        boundingBoxRef,
        rootMenuRef,
        scrollNodes
    ]);
    (0, $751cb7229c9a43e9$export$e5c5a5f917a5871c)(()=>{
        if (isOpen) {
            handlePosition();
            if (prevOpen.current) forceReposSubmenu();
        }
        prevOpen.current = isOpen;
    }, [
        isOpen,
        handlePosition,
        reposFlag
    ]);
    (0, $751cb7229c9a43e9$export$e5c5a5f917a5871c)(()=>{
        if (overflowData && !setDownOverflow) menuRef.current.scrollTop = 0;
    }, [
        overflowData,
        setDownOverflow
    ]);
    (0, $751cb7229c9a43e9$export$e5c5a5f917a5871c)(()=>updateItems, [
        updateItems
    ]);
    (0, $5NSbj.useEffect)(()=>{
        let { menu: menuScroll } = scrollNodes;
        if (!isOpen || !menuScroll) return;
        menuScroll = menuScroll.addEventListener ? menuScroll : window;
        if (!scrollNodes.anchors) {
            scrollNodes.anchors = [];
            let anchorScroll = (0, $404ce4a19ed08ccf$export$7414735161c19437)(rootAnchorRef && rootAnchorRef.current);
            while(anchorScroll && anchorScroll !== menuScroll){
                scrollNodes.anchors.push(anchorScroll);
                anchorScroll = (0, $404ce4a19ed08ccf$export$7414735161c19437)(anchorScroll);
            }
        }
        let scroll = viewScroll;
        if (scrollNodes.anchors.length && scroll === 'initial') scroll = 'auto';
        if (scroll === 'initial') return;
        const handleScroll = ()=>{
            if (scroll === 'auto') (0, $404ce4a19ed08ccf$export$3e3e6d241f8feb60)(()=>handlePosition(true));
            else (0, $404ce4a19ed08ccf$export$175e60bb96229ece)(onClose, {
                reason: (0, $116b33b50ccf2e72$export$8fd8df51a9b835e6).SCROLL
            });
        };
        const scrollObservers = scrollNodes.anchors.concat(viewScroll !== 'initial' ? menuScroll : []);
        scrollObservers.forEach((o)=>o.addEventListener('scroll', handleScroll));
        return ()=>scrollObservers.forEach((o)=>o.removeEventListener('scroll', handleScroll));
    }, [
        rootAnchorRef,
        scrollNodes,
        isOpen,
        onClose,
        viewScroll,
        handlePosition
    ]);
    const hasOverflow = !!overflowData && overflowData.overflowAmt > 0;
    (0, $5NSbj.useEffect)(()=>{
        if (hasOverflow || !isOpen || !parentScrollingRef) return;
        const handleScroll = ()=>(0, $404ce4a19ed08ccf$export$3e3e6d241f8feb60)(handlePosition);
        const parentScroll = parentScrollingRef.current;
        parentScroll.addEventListener('scroll', handleScroll);
        return ()=>parentScroll.removeEventListener('scroll', handleScroll);
    }, [
        isOpen,
        hasOverflow,
        parentScrollingRef,
        handlePosition
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (!isOpen || typeof ResizeObserver !== 'function' || reposition === 'initial') return;
        const targetList = [];
        const resizeObserver = new ResizeObserver((entries)=>entries.forEach(({ target: target })=>{
                if (targetList.indexOf(target) < 0) targetList.push(target);
                else if (target.offsetWidth && target.offsetHeight) (0, $21jDP.flushSync)(()=>{
                    handlePosition();
                    forceReposSubmenu();
                });
            }));
        const resizeObserverOptions = {
            box: 'border-box'
        };
        resizeObserver.observe(menuRef.current, resizeObserverOptions);
        const anchor = anchorRef?.current;
        anchor && resizeObserver.observe(anchor, resizeObserverOptions);
        return ()=>resizeObserver.disconnect();
    }, [
        isOpen,
        reposition,
        anchorRef,
        handlePosition
    ]);
    (0, $5NSbj.useEffect)(()=>{
        if (!isOpen) {
            dispatch((0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).RESET);
            if (!closeTransition) setOverflowData();
            return;
        }
        const { position: position, alwaysUpdate: alwaysUpdate } = menuItemFocus || {};
        const setItemFocus = ()=>{
            if (position === (0, $116b33b50ccf2e72$export$8c6ccba1b6ce32e9).FIRST) dispatch((0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).FIRST);
            else if (position === (0, $116b33b50ccf2e72$export$8c6ccba1b6ce32e9).LAST) dispatch((0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).LAST);
            else if (position >= -1) dispatch((0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).SET_INDEX, undefined, position);
        };
        if (alwaysUpdate) setItemFocus();
        else if (captureFocus) {
            const id = setTimeout(()=>{
                const menuElt = menuRef.current;
                if (menuElt && !menuElt.contains(document.activeElement)) {
                    menuElt.focus((0, $116b33b50ccf2e72$export$42466afb37c6c021));
                    setItemFocus();
                }
            }, openTransition ? 170 : 100);
            return ()=>clearTimeout(id);
        }
    }, [
        isOpen,
        openTransition,
        closeTransition,
        captureFocus,
        menuItemFocus,
        dispatch
    ]);
    const itemContext = (0, $5NSbj.useMemo)(()=>({
            isParentOpen: isOpen,
            submenuCtx: submenuCtx,
            dispatch: dispatch,
            updateItems: updateItems
        }), [
        isOpen,
        submenuCtx,
        dispatch,
        updateItems
    ]);
    let maxHeight, overflowAmt;
    if (overflowData) setDownOverflow ? overflowAmt = overflowData.overflowAmt : maxHeight = overflowData.height;
    const listContext = (0, $5NSbj.useMemo)(()=>({
            reposSubmenu: reposSubmenu,
            submenuCtx: submenuCtx,
            overflow: overflow,
            overflowAmt: overflowAmt,
            parentMenuRef: menuRef,
            parentDir: expandedDirection
        }), [
        reposSubmenu,
        submenuCtx,
        overflow,
        overflowAmt,
        expandedDirection
    ]);
    const overflowStyle = maxHeight >= 0 ? {
        maxHeight: maxHeight,
        overflow: overflow
    } : undefined;
    const modifiers = (0, $5NSbj.useMemo)(()=>({
            state: state,
            align: align,
            dir: expandedDirection
        }), [
        state,
        align,
        expandedDirection
    ]);
    const arrowModifiers = (0, $5NSbj.useMemo)(()=>({
            dir: expandedDirection
        }), [
        expandedDirection
    ]);
    const _arrowClassName = (0, $f873b6743b782796$export$7ae630fe844fbd1f)({
        block: (0, $116b33b50ccf2e72$export$832250593589325a),
        element: (0, $116b33b50ccf2e72$export$3b35f0f35c840df9),
        modifiers: arrowModifiers,
        className: arrowProps.className
    });
    const menu = /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
        role: "menu",
        "aria-label": ariaLabel,
        ...(0, $404ce4a19ed08ccf$export$ffb2d5922287e12)(isDisabled),
        ...(0, $404ce4a19ed08ccf$export$9d1611c77c2fe928)({
            onPointerEnter: parentSubmenuCtx?.off,
            onPointerMove: onPointerMove,
            onPointerLeave: onPointerLeave,
            onKeyDown: onKeyDown,
            onAnimationEnd: onAnimationEnd
        }, restProps),
        ref: (0, $20a0bbe0b4c957b3$export$2d8be4568b07be94)(externalRef, menuRef),
        className: (0, $f873b6743b782796$export$7ae630fe844fbd1f)({
            block: (0, $116b33b50ccf2e72$export$832250593589325a),
            modifiers: modifiers,
            className: menuClassName
        }),
        style: {
            ...menuStyle,
            ...overflowStyle,
            margin: 0,
            display: state === 'closed' ? 'none' : undefined,
            position: (0, $116b33b50ccf2e72$export$f8d144aafbd3a470),
            left: menuPosition.x,
            top: menuPosition.y
        },
        children: [
            arrow && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                "aria-hidden": true,
                ...arrowProps,
                className: _arrowClassName,
                style: {
                    display: 'block',
                    position: (0, $116b33b50ccf2e72$export$f8d144aafbd3a470),
                    left: arrowPosition.x,
                    top: arrowPosition.y,
                    ...arrowProps.style
                },
                ref: arrowRef
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $116b33b50ccf2e72$export$1c2bdfb4407fdacf).Provider, {
                value: listContext,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $116b33b50ccf2e72$export$7cb023214e4bda1e).Provider, {
                    value: itemContext,
                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $116b33b50ccf2e72$export$15c1690330cd94e).Provider, {
                        value: hoverItem,
                        children: (0, $404ce4a19ed08ccf$export$175e60bb96229ece)(children, modifiers)
                    })
                })
            })
        ]
    });
    return containerProps ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $f928c1f56265b480$export$b286f91cddfedb5a), {
        ...containerProps,
        isOpen: isOpen,
        children: menu
    }) : menu;
};





const $1f5f594a8ebe93f0$export$a5a70f2f059d02ee = /*#__PURE__*/ (0, $5NSbj.forwardRef)(function ControlledMenu({ 'aria-label': ariaLabel, className: className, containerProps: containerProps, initialMounted: initialMounted, unmountOnClose: unmountOnClose, transition: transition, transitionTimeout: transitionTimeout, boundingBoxRef: boundingBoxRef, boundingBoxPadding: boundingBoxPadding, reposition: reposition = 'auto', submenuOpenDelay: submenuOpenDelay = 300, submenuCloseDelay: submenuCloseDelay = 150, viewScroll: viewScroll = 'initial', portal: portal, theming: theming, onItemClick: onItemClick, ...restProps }, externalRef) {
    const containerRef = (0, $5NSbj.useRef)(null);
    const scrollNodesRef = (0, $5NSbj.useRef)({});
    const { anchorRef: anchorRef, state: state, onClose: onClose } = restProps;
    const settings = (0, $5NSbj.useMemo)(()=>({
            initialMounted: initialMounted,
            unmountOnClose: unmountOnClose,
            transition: transition,
            transitionTimeout: transitionTimeout,
            boundingBoxRef: boundingBoxRef,
            boundingBoxPadding: boundingBoxPadding,
            rootMenuRef: containerRef,
            rootAnchorRef: anchorRef,
            scrollNodesRef: scrollNodesRef,
            reposition: reposition,
            viewScroll: viewScroll,
            submenuOpenDelay: submenuOpenDelay,
            submenuCloseDelay: submenuCloseDelay
        }), [
        initialMounted,
        unmountOnClose,
        transition,
        transitionTimeout,
        anchorRef,
        boundingBoxRef,
        boundingBoxPadding,
        reposition,
        viewScroll,
        submenuOpenDelay,
        submenuCloseDelay
    ]);
    const eventHandlers = (0, $5NSbj.useMemo)(()=>({
            handleClick (event, isCheckorRadio) {
                if (!event.stopPropagation) (0, $404ce4a19ed08ccf$export$175e60bb96229ece)(onItemClick, event);
                let keepOpen = event.keepOpen;
                if (keepOpen === undefined) keepOpen = isCheckorRadio && event.key === (0, $116b33b50ccf2e72$export$4b0075e5ea5e1f26).SPACE;
                if (!keepOpen) (0, $404ce4a19ed08ccf$export$175e60bb96229ece)(onClose, {
                    value: event.value,
                    key: event.key,
                    reason: (0, $116b33b50ccf2e72$export$8fd8df51a9b835e6).CLICK
                });
            },
            handleClose (key) {
                (0, $404ce4a19ed08ccf$export$175e60bb96229ece)(onClose, {
                    key: key,
                    reason: (0, $116b33b50ccf2e72$export$8fd8df51a9b835e6).CLICK
                });
            }
        }), [
        onItemClick,
        onClose
    ]);
    if (!state) return null;
    const menuList = /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $116b33b50ccf2e72$export$8fa45c82eddfe270).Provider, {
        value: settings,
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $116b33b50ccf2e72$export$ee9f2ec6c8119c2a).Provider, {
            value: eventHandlers,
            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $fcbd87a20e962171$export$d4c4e98c5044dc8), {
                ...restProps,
                ariaLabel: ariaLabel || 'Menu',
                externalRef: externalRef,
                containerRef: containerRef,
                containerProps: {
                    className: className,
                    containerRef: containerRef,
                    containerProps: containerProps,
                    theming: theming,
                    transition: transition,
                    onClose: onClose
                }
            })
        })
    });
    if (portal === true && typeof document !== 'undefined') return /*#__PURE__*/ (0, $21jDP.createPortal)(menuList, document.body);
    else if (portal) return portal.target ? /*#__PURE__*/ (0, $21jDP.createPortal)(menuList, portal.target) : portal.stablePosition ? null : menuList;
    return menuList;
});




var $5NSbj = parcelRequire("5NSbj");

var $5NSbj = parcelRequire("5NSbj");
const $52caafce654818b3$var$STATUS = [
    "preEnter",
    "entering",
    "entered",
    "preExit",
    "exiting",
    "exited",
    "unmounted"
];
const $52caafce654818b3$export$50fdfeece43146fd = (status)=>({
        $: status,
        status: $52caafce654818b3$var$STATUS[status],
        isEnter: status < 3,
        isMounted: status !== 6,
        isResolved: status === 2 || status > 4
    });
const $52caafce654818b3$export$eb0971344425f03e = (unmounted)=>unmounted ? 6 : 5;
const $52caafce654818b3$export$c9efa50dd559122e = (status, unmountOnExit)=>{
    switch(status){
        case 1:
        case 0:
            return 2;
        case 4:
        case 3:
            return $52caafce654818b3$export$eb0971344425f03e(unmountOnExit);
    }
};
const $52caafce654818b3$export$d2e3f47e67110e3a = (timeout)=>typeof timeout === "object" ? [
        timeout.enter,
        timeout.exit
    ] : [
        timeout,
        timeout
    ];
const $52caafce654818b3$export$bdd553fddd433dcb = (callback, config)=>{
    config.r = requestAnimationFrame(()=>{
        config.r = requestAnimationFrame(callback);
    });
};



var $5NSbj = parcelRequire("5NSbj");
//#region src/useTransitionState.ts
const $60ac534fbbfaba8a$var$updateState = (status, setState, ref, onChange)=>{
    clearTimeout(ref.t);
    cancelAnimationFrame(ref.r);
    const state = (0, $52caafce654818b3$export$50fdfeece43146fd)(status);
    setState(state);
    ref.s = state;
    onChange?.({
        current: state
    });
};
const $60ac534fbbfaba8a$export$d2a0a1bc267c90f6 = ({ enter: enter = true, exit: exit = true, preEnter: preEnter, preExit: preExit, timeout: timeout, initialEntered: initialEntered, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, onStateChange: onChange } = {})=>{
    const [state, setState] = (0, $5NSbj.useState)(()=>(0, $52caafce654818b3$export$50fdfeece43146fd)(initialEntered ? 2 : (0, $52caafce654818b3$export$eb0971344425f03e)(mountOnEnter)));
    const [ref] = (0, $5NSbj.useState)({
        s: state,
        r: 0
    });
    const [enterTimeout, exitTimeout] = (0, $52caafce654818b3$export$d2e3f47e67110e3a)(timeout);
    const endTransition = (0, $5NSbj.useCallback)(()=>{
        const status = (0, $52caafce654818b3$export$c9efa50dd559122e)(ref.s.$, unmountOnExit);
        if (status) $60ac534fbbfaba8a$var$updateState(status, setState, ref, onChange);
    }, [
        onChange,
        unmountOnExit,
        ref
    ]);
    return [
        state,
        (0, $5NSbj.useCallback)((toEnter)=>{
            const transitState = (status)=>{
                $60ac534fbbfaba8a$var$updateState(status, setState, ref, onChange);
                switch(status){
                    case 1:
                        if (enterTimeout >= 0) ref.t = setTimeout(endTransition, enterTimeout);
                        break;
                    case 4:
                        if (exitTimeout >= 0) ref.t = setTimeout(endTransition, exitTimeout);
                        break;
                    case 0:
                    case 3:
                        (0, $52caafce654818b3$export$bdd553fddd433dcb)(()=>transitState(status + 1), ref);
                        break;
                }
            };
            const enterStage = ref.s.isEnter;
            if (typeof toEnter !== "boolean") toEnter = !enterStage;
            if (toEnter) !enterStage && transitState(enter ? preEnter ? 0 : 1 : 2);
            else enterStage && transitState(exit ? preExit ? 3 : 4 : (0, $52caafce654818b3$export$eb0971344425f03e)(unmountOnExit));
        }, [
            ref,
            endTransition,
            onChange,
            enter,
            exit,
            preEnter,
            preExit,
            enterTimeout,
            exitTimeout,
            unmountOnExit
        ]),
        endTransition
    ];
};




const $a8f0de46f01da81b$export$8091e3849c182a6 = ({ initialOpen: initialOpen, initialMounted: initialMounted, unmountOnClose: unmountOnClose, transition: transition, transitionTimeout: transitionTimeout = 500, onMenuChange: onMenuChange } = {})=>{
    const enter = (0, $404ce4a19ed08ccf$export$d5639c01d489b0c)(transition, 'open');
    const exit = (0, $404ce4a19ed08ccf$export$d5639c01d489b0c)(transition, 'close');
    const [{ status: status }, toggleMenu, endTransition] = (0, $60ac534fbbfaba8a$export$d2a0a1bc267c90f6)({
        initialEntered: initialOpen,
        mountOnEnter: !initialMounted,
        unmountOnExit: unmountOnClose,
        timeout: transitionTimeout,
        enter: enter,
        exit: exit,
        onStateChange: (0, $5NSbj.useCallback)(({ current: { isEnter: isEnter, isResolved: isResolved } })=>{
            if (!onMenuChange || isEnter && enter && isResolved || !isEnter && exit && isResolved) return;
            onMenuChange({
                open: isEnter
            });
        }, [
            onMenuChange,
            enter,
            exit
        ])
    });
    return [
        {
            state: (0, $116b33b50ccf2e72$export$be1d8b0328ba66b6)[status],
            endTransition: endTransition
        },
        toggleMenu
    ];
};


const $1ac57b08fa7c914d$export$1668883ac2d8e856 = (options)=>{
    const [menuProps, toggleMenu] = (0, $a8f0de46f01da81b$export$8091e3849c182a6)(options);
    const [menuItemFocus, setMenuItemFocus] = (0, $5NSbj.useState)();
    const openMenu = (position, alwaysUpdate)=>{
        setMenuItemFocus({
            position: position,
            alwaysUpdate: alwaysUpdate
        });
        toggleMenu(true);
    };
    return [
        {
            menuItemFocus: menuItemFocus,
            ...menuProps
        },
        toggleMenu,
        openMenu
    ];
};



var $5NSbj = parcelRequire("5NSbj");
const $0f20f7b1463b245a$export$98524f11226063fc = (state, onToggle)=>{
    const [skipOpen] = (0, $5NSbj.useState)({});
    return {
        onMouseDown: ()=>{
            skipOpen.v = state && state !== 'closed';
        },
        onClick: (e)=>skipOpen.v ? skipOpen.v = false : onToggle(true, e)
    };
};





const $bcd818c5df72da4b$var$isLegacyReact = parseInt((0, $5NSbj.version)) < 19;
const $bcd818c5df72da4b$export$d9b273488cd8ce6f = /*#__PURE__*/ (0, $5NSbj.forwardRef)(function Menu({ 'aria-label': ariaLabel, captureFocus: _, initialOpen: _1, menuButton: menuButton, instanceRef: instanceRef, onMenuChange: onMenuChange, ...restProps }, externalRef) {
    const [stateProps, toggleMenu, openMenu] = (0, $1ac57b08fa7c914d$export$1668883ac2d8e856)({
        ...restProps,
        onMenuChange: onMenuChange
    });
    const { state: state } = stateProps;
    const isOpen = (0, $404ce4a19ed08ccf$export$30c2dce1a652e248)(state);
    const buttonRef = (0, $5NSbj.useRef)(null);
    const anchorProps = (0, $0f20f7b1463b245a$export$98524f11226063fc)(state, (_, e)=>openMenu(!e.detail ? (0, $116b33b50ccf2e72$export$8c6ccba1b6ce32e9).FIRST : undefined));
    const handleClose = (0, $5NSbj.useCallback)((e)=>{
        toggleMenu(false);
        if (e.key) buttonRef.current.focus();
    }, [
        toggleMenu
    ]);
    const onKeyDown = (e)=>{
        switch(e.key){
            case (0, $116b33b50ccf2e72$export$4b0075e5ea5e1f26).UP:
                openMenu((0, $116b33b50ccf2e72$export$8c6ccba1b6ce32e9).LAST);
                break;
            case (0, $116b33b50ccf2e72$export$4b0075e5ea5e1f26).DOWN:
                openMenu((0, $116b33b50ccf2e72$export$8c6ccba1b6ce32e9).FIRST);
                break;
            default:
                return;
        }
        e.preventDefault();
    };
    const button = (0, $404ce4a19ed08ccf$export$175e60bb96229ece)(menuButton, {
        open: isOpen
    });
    if (!button || !button.type) throw new Error('Menu requires a menuButton prop.');
    const buttonProps = {
        ...(0, $404ce4a19ed08ccf$export$9d1611c77c2fe928)({
            onKeyDown: onKeyDown,
            ...anchorProps
        }, button.props),
        ref: (0, $20a0bbe0b4c957b3$export$2d8be4568b07be94)($bcd818c5df72da4b$var$isLegacyReact ? button.ref : button.props.ref, buttonRef)
    };
    if ((0, $404ce4a19ed08ccf$export$7d9f7e9c1c02b41e)(button.type) === 'MenuButton') buttonProps.isOpen = isOpen;
    const renderButton = /*#__PURE__*/ (0, $5NSbj.cloneElement)(button, buttonProps);
    (0, $5NSbj.useImperativeHandle)(instanceRef, ()=>({
            openMenu: openMenu,
            closeMenu: ()=>toggleMenu(false)
        }));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $5NSbj.Fragment), {
        children: [
            renderButton,
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $1f5f594a8ebe93f0$export$a5a70f2f059d02ee), {
                ...restProps,
                ...stateProps,
                "aria-label": ariaLabel || (typeof button.props.children === 'string' ? button.props.children : 'Menu'),
                anchorRef: buttonRef,
                ref: externalRef,
                onClose: handleClose
            })
        ]
    });
});


var $5NSbj = parcelRequire("5NSbj");




const $af69c093d02babcf$export$266a769812832828 = /*#__PURE__*/ (0, $404ce4a19ed08ccf$export$4c4bf90f1b4d3105)('MenuButton', /*#__PURE__*/ (0, $5NSbj.forwardRef)(function MenuButton({ className: className, isOpen: isOpen, disabled: disabled, children: children, ...restProps }, ref) {
    const modifiers = (0, $5NSbj.useMemo)(()=>({
            open: isOpen
        }), [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
        "aria-haspopup": true,
        "aria-expanded": isOpen,
        "aria-disabled": disabled || undefined,
        type: "button",
        disabled: disabled,
        ...restProps,
        ref: ref,
        className: (0, $f873b6743b782796$export$7ae630fe844fbd1f)({
            block: (0, $116b33b50ccf2e72$export$b3d82f113f746a0),
            modifiers: modifiers,
            className: className
        }),
        children: children
    });
}));


var $5NSbj = parcelRequire("5NSbj");


var $5NSbj = parcelRequire("5NSbj");


const $c0c66cef1b2047ea$export$9f154fa70a6daa25 = (name, WrappedComponent)=>{
    const Component = /*#__PURE__*/ (0, $5NSbj.memo)(WrappedComponent);
    const WithHovering = /*#__PURE__*/ (0, $5NSbj.forwardRef)((props, ref)=>{
        const itemRef = (0, $5NSbj.useRef)(null);
        return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)(Component, {
            ...props,
            itemRef: itemRef,
            externalRef: ref,
            isHovering: (0, $5NSbj.useContext)((0, $116b33b50ccf2e72$export$15c1690330cd94e)) === itemRef.current
        });
    });
    WithHovering.displayName = `WithHovering(${name})`;
    return WithHovering;
};



var $5NSbj = parcelRequire("5NSbj");

const $5a5fa3cef001bac2$export$68b1d6ee802c4a06 = (isDisabled, itemRef, updateItems)=>{
    (0, $751cb7229c9a43e9$export$e5c5a5f917a5871c)(()=>{
        if (isDisabled) return;
        const item = itemRef.current;
        updateItems(item, true);
        return ()=>{
            updateItems(item);
        };
    }, [
        isDisabled,
        itemRef,
        updateItems
    ]);
};



var $5NSbj = parcelRequire("5NSbj");
const $aac12d7c05a269e3$export$77d6bee280bb6d2 = (isHovering)=>{
    const [mouseOver, setMouseOver] = (0, $5NSbj.useState)(false);
    (0, $5NSbj.useEffect)(()=>{
        !isHovering && setMouseOver(false);
    }, [
        isHovering
    ]);
    return [
        mouseOver,
        ()=>!mouseOver && setMouseOver(true),
        ()=>setMouseOver(false)
    ];
};



const $a24414b028fc8309$export$c75b31607cdc621e = (itemRef, focusRef, isHovering, isDisabled)=>{
    const [mouseOver, mouseOverStart, mouseOverEnd] = (0, $aac12d7c05a269e3$export$77d6bee280bb6d2)(isHovering);
    const { submenuCloseDelay: submenuCloseDelay } = (0, $5NSbj.useContext)((0, $116b33b50ccf2e72$export$8fa45c82eddfe270));
    const { isParentOpen: isParentOpen, submenuCtx: submenuCtx, dispatch: dispatch, updateItems: updateItems } = (0, $5NSbj.useContext)((0, $116b33b50ccf2e72$export$7cb023214e4bda1e));
    const setHover = ()=>{
        !isHovering && !isDisabled && dispatch((0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).SET, itemRef.current);
    };
    const unsetHover = ()=>{
        !isDisabled && dispatch((0, $116b33b50ccf2e72$export$6db955af9e6f8fcd).UNSET, itemRef.current);
    };
    const onBlur = (e)=>{
        if (isHovering && !e.currentTarget.contains(e.relatedTarget)) unsetHover();
    };
    const onPointerMove = (e)=>{
        if (!isDisabled) {
            e.stopPropagation();
            mouseOverStart();
            submenuCtx.on(submenuCloseDelay, setHover, setHover);
        }
    };
    const onPointerLeave = (_, keepHover)=>{
        mouseOverEnd();
        submenuCtx.off();
        !keepHover && unsetHover();
    };
    (0, $5a5fa3cef001bac2$export$68b1d6ee802c4a06)(isDisabled, itemRef, updateItems);
    (0, $5NSbj.useEffect)(()=>{
        if (isHovering && isParentOpen) focusRef.current && focusRef.current.focus();
    }, [
        focusRef,
        isHovering,
        isParentOpen
    ]);
    return {
        mouseOver: mouseOver,
        setHover: setHover,
        onBlur: onBlur,
        onPointerMove: onPointerMove,
        onPointerLeave: onPointerLeave
    };
};






const $3400fac6f43cd1b4$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $c0c66cef1b2047ea$export$9f154fa70a6daa25)('MenuItem', function MenuItem({ className: className, value: value, href: href, type: type, checked: checked, disabled: disabled, children: children, onClick: onClick, isHovering: isHovering, itemRef: itemRef, externalRef: externalRef, ...restProps }) {
    const isDisabled = !!disabled;
    const { mouseOver: mouseOver, setHover: setHover, ...restStateProps } = (0, $a24414b028fc8309$export$c75b31607cdc621e)(itemRef, itemRef, isHovering, isDisabled);
    const eventHandlers = (0, $5NSbj.useContext)((0, $116b33b50ccf2e72$export$ee9f2ec6c8119c2a));
    const radioGroup = (0, $5NSbj.useContext)((0, $116b33b50ccf2e72$export$a79eda4ff50e30b6));
    const isRadio = type === 'radio';
    const isCheckBox = type === 'checkbox';
    const isAnchor = !!href && !isDisabled && !isRadio && !isCheckBox;
    const isChecked = isRadio ? radioGroup.value === value : isCheckBox ? !!checked : false;
    const handleClick = (e)=>{
        if (isDisabled) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        const event = {
            value: value,
            syntheticEvent: e
        };
        if (e.key !== undefined) event.key = e.key;
        if (isCheckBox) event.checked = !isChecked;
        if (isRadio) event.name = radioGroup.name;
        (0, $404ce4a19ed08ccf$export$175e60bb96229ece)(onClick, event);
        if (isRadio) (0, $404ce4a19ed08ccf$export$175e60bb96229ece)(radioGroup.onRadioChange, event);
        eventHandlers.handleClick(event, isCheckBox || isRadio);
    };
    const handleKeyDown = (e)=>{
        if (!isHovering) return;
        switch(e.key){
            case (0, $116b33b50ccf2e72$export$4b0075e5ea5e1f26).ENTER:
                e.preventDefault();
            case (0, $116b33b50ccf2e72$export$4b0075e5ea5e1f26).SPACE:
                isAnchor ? itemRef.current.click() : handleClick(e);
        }
    };
    const modifiers = (0, $5NSbj.useMemo)(()=>({
            type: type,
            disabled: isDisabled,
            hover: mouseOver || isHovering,
            checked: isChecked,
            anchor: isAnchor
        }), [
        type,
        isDisabled,
        mouseOver,
        isHovering,
        isChecked,
        isAnchor
    ]);
    const mergedProps = (0, $404ce4a19ed08ccf$export$9d1611c77c2fe928)({
        ...restStateProps,
        onPointerDown: setHover,
        onKeyDown: handleKeyDown,
        onClick: handleClick
    }, restProps);
    const menuItemProps = {
        role: isRadio ? 'menuitemradio' : isCheckBox ? 'menuitemcheckbox' : (0, $116b33b50ccf2e72$export$3e982710469daaf),
        'aria-checked': isRadio || isCheckBox ? isChecked : undefined,
        ...(0, $404ce4a19ed08ccf$export$ffb2d5922287e12)(isDisabled, isHovering),
        ...mergedProps,
        ref: (0, $20a0bbe0b4c957b3$export$2d8be4568b07be94)(externalRef, itemRef),
        className: (0, $f873b6743b782796$export$7ae630fe844fbd1f)({
            block: (0, $116b33b50ccf2e72$export$832250593589325a),
            element: (0, $116b33b50ccf2e72$export$b5a3c9a9995a8c24),
            modifiers: modifiers,
            className: className
        }),
        children: (0, $5NSbj.useMemo)(()=>(0, $404ce4a19ed08ccf$export$175e60bb96229ece)(children, modifiers), [
            children,
            modifiers
        ])
    };
    return isAnchor ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
        role: (0, $116b33b50ccf2e72$export$a5a9d7469a9cc520),
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("a", {
            href: href,
            ...menuItemProps
        })
    }) : /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
        ...menuItemProps
    });
});



/**
 * @callback completeCallback
 */ /**
 * @typedef {Object} Options
 * @property {number} [duration]
 * @property {string} [easing]
 * @property {completeCallback} [complete]
 */ /**
 * @param {Element} element
 * @param {Object.<string, string>} properties
 * @param {completeCallback} complete
 */ function $11fdf00616b3f275$var$fadeComplete(element, properties, complete) {
    if (properties.transition) element.style.transition = properties.transition;
    else element.style.removeProperty('transition');
    if (properties.opacity) element.style.opacity = properties.opacity;
    else element.style.removeProperty('opacity');
    if (complete) complete();
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $11fdf00616b3f275$export$82e6205b15e6c637(element, options = {}) {
    const o = $11fdf00616b3f275$var$getOptions(options);
    const properties = {
        transition: element.style.transition || undefined,
        opacity: element.style.opacity || undefined
    };
    // styles necessary for the animation
    if (!element.style.opacity) element.style.opacity = 0;
    element.style.removeProperty('display');
    element.style.transition = `opacity ${o.duration / 1000}s ${o.easing}`;
    requestAnimationFrame(function() {
        element.style.opacity = 1;
    });
    setTimeout(function() {
        $11fdf00616b3f275$var$fadeComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $11fdf00616b3f275$export$c091916f1530334c(element, options = {}) {
    const o = $11fdf00616b3f275$var$getOptions(options);
    const properties = {
        transition: element.style.transition || undefined,
        opacity: element.style.opacity || undefined
    };
    // styles necessary for the animation
    if (!element.style.opacity) element.style.opacity = 1;
    element.style.transition = `opacity ${o.duration / 1000}s ${o.easing}`;
    requestAnimationFrame(function() {
        element.style.opacity = 0;
    });
    setTimeout(function() {
        element.style.display = 'none';
        $11fdf00616b3f275$var$fadeComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $11fdf00616b3f275$export$75d3d2c72ecccf9b(element, options = {}) {
    const display = element.style.display || undefined;
    if (display == 'none') $11fdf00616b3f275$export$82e6205b15e6c637(element, options);
    else $11fdf00616b3f275$export$c091916f1530334c(element, options);
}
/**
 * @param {Options} options
 * @return {Options}
 */ function $11fdf00616b3f275$var$getOptions(options) {
    return {
        duration: options.duration || 400,
        easing: options.easing || "ease-out",
        complete: options.complete || undefined
    };
}
/**
 * @param {Element} element
 */ function $11fdf00616b3f275$export$fe8985bb6374093c(element) {
    element.style.display = 'none';
}
/**
 * @param {Element} element
 */ function $11fdf00616b3f275$export$57bf213be019eeb0(element) {
    element.style.removeProperty('display');
}
/**
 * @param {Element} element
 * @param {Object.<string, string>} properties
 * @param {completeCallback} complete
 */ function $11fdf00616b3f275$var$slideComplete(element, properties, complete) {
    if (properties.transition) element.style.transition = properties.transition;
    else element.style.removeProperty('transition');
    if (properties.overflowY) element.style.overflowY = properties.overflowY;
    else element.style.removeProperty('overflow-y');
    if (properties.marginTop) element.style.marginTop = properties.marginTop;
    else element.style.removeProperty('margin-top');
    if (properties.marginBottom) element.style.marginBottom = properties.marginBottom;
    else element.style.removeProperty('margin-bottom');
    if (properties.paddingTop) element.style.paddingTop = properties.paddingTop;
    else element.style.removeProperty('padding-top');
    if (properties.paddingBottom) element.style.paddingBottom = properties.paddingBottom;
    else element.style.removeProperty('padding-bottom');
    if (properties.height) element.style.height = properties.height;
    else element.style.removeProperty('height');
    if (complete) complete();
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $11fdf00616b3f275$export$abdd11a06a163232(element, options = {}) {
    const o = $11fdf00616b3f275$var$getOptions(options);
    const properties = {
        transition: element.style.transition || undefined,
        overflowY: element.style.overflowY || undefined,
        marginTop: element.style.marginTop || undefined,
        marginBottom: element.style.marginBottom || undefined,
        paddingTop: element.style.paddingTop || undefined,
        paddingBottom: element.style.paddingBottom || undefined,
        heigth: element.style.height || undefined
    };
    const cs = window.getComputedStyle(element);
    const marginTop = cs.getPropertyValue("margin-top");
    const marginBottom = cs.getPropertyValue("margin-bottom");
    const paddingTop = cs.getPropertyValue("padding-top");
    const paddingBottom = cs.getPropertyValue("padding-bottom");
    // styles necessary for the animation
    if (!element.style.height) element.style.height = '0px';
    element.style.marginTop = '0px';
    element.style.marginBottom = '0px';
    element.style.paddingTop = '0px';
    element.style.paddingBottom = '0px';
    element.style.overflowY = 'hidden';
    element.style.removeProperty('display');
    element.style.transition = `height ${o.duration / 1000}s ${o.easing}, margin ${o.duration / 1000}s ${o.easing}, padding ${o.duration / 1000}s ${o.easing}`;
    requestAnimationFrame(function() {
        let height = element.scrollHeight;
        if (cs.getPropertyValue("box-sizing") == "border-box") height += parseFloat(paddingTop) + parseFloat(paddingBottom);
        element.style.height = `${height}px`;
        element.style.marginTop = marginTop;
        element.style.marginBottom = marginBottom;
        element.style.paddingTop = paddingTop;
        element.style.paddingBottom = paddingBottom;
    });
    setTimeout(function() {
        $11fdf00616b3f275$var$slideComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $11fdf00616b3f275$export$715de50cedc228a8(element, options = {}) {
    const display = element.style.display || undefined;
    if (display == 'none') $11fdf00616b3f275$export$abdd11a06a163232(element, options);
    else $11fdf00616b3f275$export$deed561b1a0ff1ea(element, options);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $11fdf00616b3f275$export$deed561b1a0ff1ea(element, options = {}) {
    const o = $11fdf00616b3f275$var$getOptions(options);
    const properties = {
        transition: element.style.transition || undefined,
        overflowY: element.style.overflowY || undefined,
        marginTop: element.style.marginTop || undefined,
        marginBottom: element.style.marginBottom || undefined,
        paddingTop: element.style.paddingTop || undefined,
        paddingBottom: element.style.paddingBottom || undefined,
        heigth: element.style.height || undefined
    };
    const cs = window.getComputedStyle(element);
    const marginTop = cs.getPropertyValue("margin-top");
    const marginBottom = cs.getPropertyValue("margin-bottom");
    const paddingTop = cs.getPropertyValue("padding-top");
    const paddingBottom = cs.getPropertyValue("padding-bottom");
    // styles necessary for the animation
    requestAnimationFrame(function() {
        if (!element.style.height) {
            let height = element.scrollHeight;
            if (cs.getPropertyValue("box-sizing") == "content-box") height -= parseFloat(paddingTop) + parseFloat(paddingBottom);
            element.style.height = `${height}px`;
        }
        element.style.marginTop = marginTop;
        element.style.marginBottom = marginBottom;
        element.style.paddingTop = paddingTop;
        element.style.paddingBottom = paddingBottom;
        element.style.overflowY = 'hidden';
        element.style.transition = `height ${o.duration / 1000}s ${o.easing}, margin ${o.duration / 1000}s ${o.easing}, padding ${o.duration / 1000}s ${o.easing}`;
        requestAnimationFrame(function() {
            element.style.height = '0px';
            element.style.marginTop = '0px';
            element.style.marginBottom = '0px';
            element.style.paddingTop = '0px';
            element.style.paddingBottom = '0px';
        });
    });
    setTimeout(function() {
        element.style.display = 'none';
        $11fdf00616b3f275$var$slideComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 */ function $11fdf00616b3f275$export$e03c1c3201ee8bb7(element) {
    const display = element.style.display || undefined;
    if (display == 'none') $11fdf00616b3f275$export$57bf213be019eeb0(element);
    else $11fdf00616b3f275$export$fe8985bb6374093c(element);
}



/**
 * Copyright (C) 2017-present by Andrea Giammarchi - @WebReflection
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ const { replace: $ec6aeee77f582aff$var$replace } = '';
// escape
const $ec6aeee77f582aff$var$es = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;
const $ec6aeee77f582aff$var$ca = /[&<>'"]/g;
const $ec6aeee77f582aff$var$esca = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;'
};
const $ec6aeee77f582aff$var$pe = (m)=>$ec6aeee77f582aff$var$esca[m];
const $ec6aeee77f582aff$export$4e7f196112fea3c5 = (es)=>$ec6aeee77f582aff$var$replace.call(es, $ec6aeee77f582aff$var$ca, $ec6aeee77f582aff$var$pe);
// unescape
const $ec6aeee77f582aff$var$unes = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"'
};
const $ec6aeee77f582aff$var$cape = (m)=>$ec6aeee77f582aff$var$unes[m];
const $ec6aeee77f582aff$export$e8bacd2802a88316 = (un)=>$ec6aeee77f582aff$var$replace.call(un, $ec6aeee77f582aff$var$es, $ec6aeee77f582aff$var$cape);



/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $1e1752ba20547388$var$isArray = Array.isArray;
var $1e1752ba20547388$export$2e2bcd8739ae039 = $1e1752ba20547388$var$isArray;



/** Detect free variable `global` from Node.js. */ var $29cd6e27d4144838$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $29cd6e27d4144838$export$2e2bcd8739ae039 = $29cd6e27d4144838$var$freeGlobal;


/** Detect free variable `self`. */ var $1cbf55c3e44c46ce$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1cbf55c3e44c46ce$var$root = (0, $29cd6e27d4144838$export$2e2bcd8739ae039) || $1cbf55c3e44c46ce$var$freeSelf || Function('return this')();
var $1cbf55c3e44c46ce$export$2e2bcd8739ae039 = $1cbf55c3e44c46ce$var$root;


/** Built-in value references. */ var $213ba81f8d233690$var$Symbol = (0, $1cbf55c3e44c46ce$export$2e2bcd8739ae039).Symbol;
var $213ba81f8d233690$export$2e2bcd8739ae039 = $213ba81f8d233690$var$Symbol;



/** Used for built-in method references. */ var $b20e7619a952e06f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b20e7619a952e06f$var$hasOwnProperty = $b20e7619a952e06f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b20e7619a952e06f$var$nativeObjectToString = $b20e7619a952e06f$var$objectProto.toString;
/** Built-in value references. */ var $b20e7619a952e06f$var$symToStringTag = (0, $213ba81f8d233690$export$2e2bcd8739ae039) ? (0, $213ba81f8d233690$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $b20e7619a952e06f$var$getRawTag(value) {
    var isOwn = $b20e7619a952e06f$var$hasOwnProperty.call(value, $b20e7619a952e06f$var$symToStringTag), tag = value[$b20e7619a952e06f$var$symToStringTag];
    try {
        value[$b20e7619a952e06f$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $b20e7619a952e06f$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$b20e7619a952e06f$var$symToStringTag] = tag;
        else delete value[$b20e7619a952e06f$var$symToStringTag];
    }
    return result;
}
var $b20e7619a952e06f$export$2e2bcd8739ae039 = $b20e7619a952e06f$var$getRawTag;


/** Used for built-in method references. */ var $52bc3b663434685e$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $52bc3b663434685e$var$nativeObjectToString = $52bc3b663434685e$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $52bc3b663434685e$var$objectToString(value) {
    return $52bc3b663434685e$var$nativeObjectToString.call(value);
}
var $52bc3b663434685e$export$2e2bcd8739ae039 = $52bc3b663434685e$var$objectToString;


/** `Object#toString` result references. */ var $9b15b088b5f05768$var$nullTag = '[object Null]', $9b15b088b5f05768$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $9b15b088b5f05768$var$symToStringTag = (0, $213ba81f8d233690$export$2e2bcd8739ae039) ? (0, $213ba81f8d233690$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $9b15b088b5f05768$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $9b15b088b5f05768$var$undefinedTag : $9b15b088b5f05768$var$nullTag;
    return $9b15b088b5f05768$var$symToStringTag && $9b15b088b5f05768$var$symToStringTag in Object(value) ? (0, $b20e7619a952e06f$export$2e2bcd8739ae039)(value) : (0, $52bc3b663434685e$export$2e2bcd8739ae039)(value);
}
var $9b15b088b5f05768$export$2e2bcd8739ae039 = $9b15b088b5f05768$var$baseGetTag;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $12b35a1d6f51d03d$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $12b35a1d6f51d03d$export$2e2bcd8739ae039 = $12b35a1d6f51d03d$var$isObjectLike;


/** `Object#toString` result references. */ var $5a2540ebbf553ace$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5a2540ebbf553ace$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $12b35a1d6f51d03d$export$2e2bcd8739ae039)(value) && (0, $9b15b088b5f05768$export$2e2bcd8739ae039)(value) == $5a2540ebbf553ace$var$symbolTag;
}
var $5a2540ebbf553ace$export$2e2bcd8739ae039 = $5a2540ebbf553ace$var$isSymbol;


/** Used to match property names within property paths. */ var $1d2b8ce830c1b769$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $1d2b8ce830c1b769$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $1d2b8ce830c1b769$var$isKey(value, object) {
    if ((0, $1e1752ba20547388$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, $5a2540ebbf553ace$export$2e2bcd8739ae039)(value)) return true;
    return $1d2b8ce830c1b769$var$reIsPlainProp.test(value) || !$1d2b8ce830c1b769$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $1d2b8ce830c1b769$export$2e2bcd8739ae039 = $1d2b8ce830c1b769$var$isKey;



/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $9a883469b282241c$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $9a883469b282241c$export$2e2bcd8739ae039 = $9a883469b282241c$var$isObject;


/** `Object#toString` result references. */ var $15f7be8fcefbe5ec$var$asyncTag = '[object AsyncFunction]', $15f7be8fcefbe5ec$var$funcTag = '[object Function]', $15f7be8fcefbe5ec$var$genTag = '[object GeneratorFunction]', $15f7be8fcefbe5ec$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $15f7be8fcefbe5ec$var$isFunction(value) {
    if (!(0, $9a883469b282241c$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $9b15b088b5f05768$export$2e2bcd8739ae039)(value);
    return tag == $15f7be8fcefbe5ec$var$funcTag || tag == $15f7be8fcefbe5ec$var$genTag || tag == $15f7be8fcefbe5ec$var$asyncTag || tag == $15f7be8fcefbe5ec$var$proxyTag;
}
var $15f7be8fcefbe5ec$export$2e2bcd8739ae039 = $15f7be8fcefbe5ec$var$isFunction;



/** Used to detect overreaching core-js shims. */ var $e3c265cc9322f731$var$coreJsData = (0, $1cbf55c3e44c46ce$export$2e2bcd8739ae039)['__core-js_shared__'];
var $e3c265cc9322f731$export$2e2bcd8739ae039 = $e3c265cc9322f731$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $2239ff27cf281dc7$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $e3c265cc9322f731$export$2e2bcd8739ae039) && (0, $e3c265cc9322f731$export$2e2bcd8739ae039).keys && (0, $e3c265cc9322f731$export$2e2bcd8739ae039).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $2239ff27cf281dc7$var$isMasked(func) {
    return !!$2239ff27cf281dc7$var$maskSrcKey && $2239ff27cf281dc7$var$maskSrcKey in func;
}
var $2239ff27cf281dc7$export$2e2bcd8739ae039 = $2239ff27cf281dc7$var$isMasked;



/** Used for built-in method references. */ var $f14b9f0ef1f2f879$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $f14b9f0ef1f2f879$var$funcToString = $f14b9f0ef1f2f879$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $f14b9f0ef1f2f879$var$toSource(func) {
    if (func != null) {
        try {
            return $f14b9f0ef1f2f879$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $f14b9f0ef1f2f879$export$2e2bcd8739ae039 = $f14b9f0ef1f2f879$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $5bac622fc0b75967$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $5bac622fc0b75967$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $5bac622fc0b75967$var$funcProto = Function.prototype, $5bac622fc0b75967$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $5bac622fc0b75967$var$funcToString = $5bac622fc0b75967$var$funcProto.toString;
/** Used to check objects for own properties. */ var $5bac622fc0b75967$var$hasOwnProperty = $5bac622fc0b75967$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $5bac622fc0b75967$var$reIsNative = RegExp('^' + $5bac622fc0b75967$var$funcToString.call($5bac622fc0b75967$var$hasOwnProperty).replace($5bac622fc0b75967$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $5bac622fc0b75967$var$baseIsNative(value) {
    if (!(0, $9a883469b282241c$export$2e2bcd8739ae039)(value) || (0, $2239ff27cf281dc7$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $15f7be8fcefbe5ec$export$2e2bcd8739ae039)(value) ? $5bac622fc0b75967$var$reIsNative : $5bac622fc0b75967$var$reIsHostCtor;
    return pattern.test((0, $f14b9f0ef1f2f879$export$2e2bcd8739ae039)(value));
}
var $5bac622fc0b75967$export$2e2bcd8739ae039 = $5bac622fc0b75967$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $4308e40ccc761669$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $4308e40ccc761669$export$2e2bcd8739ae039 = $4308e40ccc761669$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $3bb6135c399dfe41$var$getNative(object, key) {
    var value = (0, $4308e40ccc761669$export$2e2bcd8739ae039)(object, key);
    return (0, $5bac622fc0b75967$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $3bb6135c399dfe41$export$2e2bcd8739ae039 = $3bb6135c399dfe41$var$getNative;


/* Built-in method references that are verified to be native. */ var $625bc15752ae5862$var$nativeCreate = (0, $3bb6135c399dfe41$export$2e2bcd8739ae039)(Object, 'create');
var $625bc15752ae5862$export$2e2bcd8739ae039 = $625bc15752ae5862$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $afc915431c3aa343$var$hashClear() {
    this.__data__ = (0, $625bc15752ae5862$export$2e2bcd8739ae039) ? (0, $625bc15752ae5862$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $afc915431c3aa343$export$2e2bcd8739ae039 = $afc915431c3aa343$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $15cfc6594cdf6abb$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $15cfc6594cdf6abb$export$2e2bcd8739ae039 = $15cfc6594cdf6abb$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $405ebaef7811c33a$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $405ebaef7811c33a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $405ebaef7811c33a$var$hasOwnProperty = $405ebaef7811c33a$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $405ebaef7811c33a$var$hashGet(key) {
    var data = this.__data__;
    if (0, $625bc15752ae5862$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $405ebaef7811c33a$var$HASH_UNDEFINED ? undefined : result;
    }
    return $405ebaef7811c33a$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $405ebaef7811c33a$export$2e2bcd8739ae039 = $405ebaef7811c33a$var$hashGet;



/** Used for built-in method references. */ var $3c93aa4ccf1473c1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3c93aa4ccf1473c1$var$hasOwnProperty = $3c93aa4ccf1473c1$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3c93aa4ccf1473c1$var$hashHas(key) {
    var data = this.__data__;
    return (0, $625bc15752ae5862$export$2e2bcd8739ae039) ? data[key] !== undefined : $3c93aa4ccf1473c1$var$hasOwnProperty.call(data, key);
}
var $3c93aa4ccf1473c1$export$2e2bcd8739ae039 = $3c93aa4ccf1473c1$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $7e7a5c85d7addecd$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7e7a5c85d7addecd$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $625bc15752ae5862$export$2e2bcd8739ae039) && value === undefined ? $7e7a5c85d7addecd$var$HASH_UNDEFINED : value;
    return this;
}
var $7e7a5c85d7addecd$export$2e2bcd8739ae039 = $7e7a5c85d7addecd$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7f3ebd7d474e8eb0$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$7f3ebd7d474e8eb0$var$Hash.prototype.clear = (0, $afc915431c3aa343$export$2e2bcd8739ae039);
$7f3ebd7d474e8eb0$var$Hash.prototype['delete'] = (0, $15cfc6594cdf6abb$export$2e2bcd8739ae039);
$7f3ebd7d474e8eb0$var$Hash.prototype.get = (0, $405ebaef7811c33a$export$2e2bcd8739ae039);
$7f3ebd7d474e8eb0$var$Hash.prototype.has = (0, $3c93aa4ccf1473c1$export$2e2bcd8739ae039);
$7f3ebd7d474e8eb0$var$Hash.prototype.set = (0, $7e7a5c85d7addecd$export$2e2bcd8739ae039);
var $7f3ebd7d474e8eb0$export$2e2bcd8739ae039 = $7f3ebd7d474e8eb0$var$Hash;


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $4b69bb4229beea01$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $4b69bb4229beea01$export$2e2bcd8739ae039 = $4b69bb4229beea01$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $e14dbe683b673f9b$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $e14dbe683b673f9b$export$2e2bcd8739ae039 = $e14dbe683b673f9b$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $5c73de08059c4603$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $e14dbe683b673f9b$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $5c73de08059c4603$export$2e2bcd8739ae039 = $5c73de08059c4603$var$assocIndexOf;


/** Used for built-in method references. */ var $74d0ca12e1e7309f$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $74d0ca12e1e7309f$var$splice = $74d0ca12e1e7309f$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $74d0ca12e1e7309f$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $5c73de08059c4603$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $74d0ca12e1e7309f$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $74d0ca12e1e7309f$export$2e2bcd8739ae039 = $74d0ca12e1e7309f$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dda10546e10ea921$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $5c73de08059c4603$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $dda10546e10ea921$export$2e2bcd8739ae039 = $dda10546e10ea921$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a075ad7a6b10f106$var$listCacheHas(key) {
    return (0, $5c73de08059c4603$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $a075ad7a6b10f106$export$2e2bcd8739ae039 = $a075ad7a6b10f106$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b9463aa6dc4bfbfd$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $5c73de08059c4603$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $b9463aa6dc4bfbfd$export$2e2bcd8739ae039 = $b9463aa6dc4bfbfd$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d3714f12bfd2739b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$d3714f12bfd2739b$var$ListCache.prototype.clear = (0, $4b69bb4229beea01$export$2e2bcd8739ae039);
$d3714f12bfd2739b$var$ListCache.prototype['delete'] = (0, $74d0ca12e1e7309f$export$2e2bcd8739ae039);
$d3714f12bfd2739b$var$ListCache.prototype.get = (0, $dda10546e10ea921$export$2e2bcd8739ae039);
$d3714f12bfd2739b$var$ListCache.prototype.has = (0, $a075ad7a6b10f106$export$2e2bcd8739ae039);
$d3714f12bfd2739b$var$ListCache.prototype.set = (0, $b9463aa6dc4bfbfd$export$2e2bcd8739ae039);
var $d3714f12bfd2739b$export$2e2bcd8739ae039 = $d3714f12bfd2739b$var$ListCache;




/* Built-in method references that are verified to be native. */ var $8746442e8a9e7980$var$Map = (0, $3bb6135c399dfe41$export$2e2bcd8739ae039)((0, $1cbf55c3e44c46ce$export$2e2bcd8739ae039), 'Map');
var $8746442e8a9e7980$export$2e2bcd8739ae039 = $8746442e8a9e7980$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $fc9cd1acfec5308f$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $7f3ebd7d474e8eb0$export$2e2bcd8739ae039),
        'map': new ((0, $8746442e8a9e7980$export$2e2bcd8739ae039) || (0, $d3714f12bfd2739b$export$2e2bcd8739ae039)),
        'string': new (0, $7f3ebd7d474e8eb0$export$2e2bcd8739ae039)
    };
}
var $fc9cd1acfec5308f$export$2e2bcd8739ae039 = $fc9cd1acfec5308f$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $2c727976c911cf30$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $2c727976c911cf30$export$2e2bcd8739ae039 = $2c727976c911cf30$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $5eeda81790dd7ae5$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $2c727976c911cf30$export$2e2bcd8739ae039)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $5eeda81790dd7ae5$export$2e2bcd8739ae039 = $5eeda81790dd7ae5$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2e4bebfe466e5034$var$mapCacheDelete(key) {
    var result = (0, $5eeda81790dd7ae5$export$2e2bcd8739ae039)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $2e4bebfe466e5034$export$2e2bcd8739ae039 = $2e4bebfe466e5034$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $22505230c7344f95$var$mapCacheGet(key) {
    return (0, $5eeda81790dd7ae5$export$2e2bcd8739ae039)(this, key).get(key);
}
var $22505230c7344f95$export$2e2bcd8739ae039 = $22505230c7344f95$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ac79a23f4e50d8bf$var$mapCacheHas(key) {
    return (0, $5eeda81790dd7ae5$export$2e2bcd8739ae039)(this, key).has(key);
}
var $ac79a23f4e50d8bf$export$2e2bcd8739ae039 = $ac79a23f4e50d8bf$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $489f5c25a81773b1$var$mapCacheSet(key, value) {
    var data = (0, $5eeda81790dd7ae5$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $489f5c25a81773b1$export$2e2bcd8739ae039 = $489f5c25a81773b1$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $14d8778d8d730781$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$14d8778d8d730781$var$MapCache.prototype.clear = (0, $fc9cd1acfec5308f$export$2e2bcd8739ae039);
$14d8778d8d730781$var$MapCache.prototype['delete'] = (0, $2e4bebfe466e5034$export$2e2bcd8739ae039);
$14d8778d8d730781$var$MapCache.prototype.get = (0, $22505230c7344f95$export$2e2bcd8739ae039);
$14d8778d8d730781$var$MapCache.prototype.has = (0, $ac79a23f4e50d8bf$export$2e2bcd8739ae039);
$14d8778d8d730781$var$MapCache.prototype.set = (0, $489f5c25a81773b1$export$2e2bcd8739ae039);
var $14d8778d8d730781$export$2e2bcd8739ae039 = $14d8778d8d730781$var$MapCache;


/** Error message constants. */ var $52f97e9c5fc92313$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $52f97e9c5fc92313$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($52f97e9c5fc92313$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($52f97e9c5fc92313$var$memoize.Cache || (0, $14d8778d8d730781$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$52f97e9c5fc92313$var$memoize.Cache = (0, $14d8778d8d730781$export$2e2bcd8739ae039);
var $52f97e9c5fc92313$export$2e2bcd8739ae039 = $52f97e9c5fc92313$var$memoize;


/** Used as the maximum memoize cache size. */ var $776baccb4ee0ed53$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $776baccb4ee0ed53$var$memoizeCapped(func) {
    var result = (0, $52f97e9c5fc92313$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $776baccb4ee0ed53$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $776baccb4ee0ed53$export$2e2bcd8739ae039 = $776baccb4ee0ed53$var$memoizeCapped;


/** Used to match property names within property paths. */ var $66f2d0e55716bc61$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $66f2d0e55716bc61$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $66f2d0e55716bc61$var$stringToPath = (0, $776baccb4ee0ed53$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($66f2d0e55716bc61$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($66f2d0e55716bc61$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $66f2d0e55716bc61$export$2e2bcd8739ae039 = $66f2d0e55716bc61$var$stringToPath;



/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $31878feae60a9167$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $31878feae60a9167$export$2e2bcd8739ae039 = $31878feae60a9167$var$arrayMap;




/** Used as references for various `Number` constants. */ var $f17249cf96ab0e91$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f17249cf96ab0e91$var$symbolProto = (0, $213ba81f8d233690$export$2e2bcd8739ae039) ? (0, $213ba81f8d233690$export$2e2bcd8739ae039).prototype : undefined, $f17249cf96ab0e91$var$symbolToString = $f17249cf96ab0e91$var$symbolProto ? $f17249cf96ab0e91$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f17249cf96ab0e91$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $1e1752ba20547388$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $31878feae60a9167$export$2e2bcd8739ae039)(value, $f17249cf96ab0e91$var$baseToString) + '';
    if ((0, $5a2540ebbf553ace$export$2e2bcd8739ae039)(value)) return $f17249cf96ab0e91$var$symbolToString ? $f17249cf96ab0e91$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f17249cf96ab0e91$var$INFINITY ? '-0' : result;
}
var $f17249cf96ab0e91$export$2e2bcd8739ae039 = $f17249cf96ab0e91$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $cc2c747def446e5e$var$toString(value) {
    return value == null ? '' : (0, $f17249cf96ab0e91$export$2e2bcd8739ae039)(value);
}
var $cc2c747def446e5e$export$2e2bcd8739ae039 = $cc2c747def446e5e$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $3281c6aec7b1af5b$var$castPath(value, object) {
    if ((0, $1e1752ba20547388$export$2e2bcd8739ae039)(value)) return value;
    return (0, $1d2b8ce830c1b769$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $66f2d0e55716bc61$export$2e2bcd8739ae039)((0, $cc2c747def446e5e$export$2e2bcd8739ae039)(value));
}
var $3281c6aec7b1af5b$export$2e2bcd8739ae039 = $3281c6aec7b1af5b$var$castPath;



/** Used as references for various `Number` constants. */ var $5a52b012f527fd8b$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $5a52b012f527fd8b$var$toKey(value) {
    if (typeof value == 'string' || (0, $5a2540ebbf553ace$export$2e2bcd8739ae039)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$5a52b012f527fd8b$var$INFINITY ? '-0' : result;
}
var $5a52b012f527fd8b$export$2e2bcd8739ae039 = $5a52b012f527fd8b$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $f1ab29f3b886c84b$var$baseGet(object, path) {
    path = (0, $3281c6aec7b1af5b$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $5a52b012f527fd8b$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $f1ab29f3b886c84b$export$2e2bcd8739ae039 = $f1ab29f3b886c84b$var$baseGet;



var $4ebc8e06beafd880$var$defineProperty = function() {
    try {
        var func = (0, $3bb6135c399dfe41$export$2e2bcd8739ae039)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $4ebc8e06beafd880$export$2e2bcd8739ae039 = $4ebc8e06beafd880$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $e874431ea56f06d0$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $4ebc8e06beafd880$export$2e2bcd8739ae039)) (0, $4ebc8e06beafd880$export$2e2bcd8739ae039)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $e874431ea56f06d0$export$2e2bcd8739ae039 = $e874431ea56f06d0$var$baseAssignValue;



/** Used for built-in method references. */ var $37c8b8086f9a2826$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $37c8b8086f9a2826$var$hasOwnProperty = $37c8b8086f9a2826$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $37c8b8086f9a2826$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($37c8b8086f9a2826$var$hasOwnProperty.call(object, key) && (0, $e14dbe683b673f9b$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $e874431ea56f06d0$export$2e2bcd8739ae039)(object, key, value);
}
var $37c8b8086f9a2826$export$2e2bcd8739ae039 = $37c8b8086f9a2826$var$assignValue;



/** Used as references for various `Number` constants. */ var $4a17ca83a682a8ec$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $4a17ca83a682a8ec$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $4a17ca83a682a8ec$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $4a17ca83a682a8ec$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $4a17ca83a682a8ec$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $4a17ca83a682a8ec$export$2e2bcd8739ae039 = $4a17ca83a682a8ec$var$isIndex;




/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $16d52dd8de1034eb$var$baseSet(object, path, value, customizer) {
    if (!(0, $9a883469b282241c$export$2e2bcd8739ae039)(object)) return object;
    path = (0, $3281c6aec7b1af5b$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = (0, $5a52b012f527fd8b$export$2e2bcd8739ae039)(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = (0, $9a883469b282241c$export$2e2bcd8739ae039)(objValue) ? objValue : (0, $4a17ca83a682a8ec$export$2e2bcd8739ae039)(path[index + 1]) ? [] : {};
        }
        (0, $37c8b8086f9a2826$export$2e2bcd8739ae039)(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
var $16d52dd8de1034eb$export$2e2bcd8739ae039 = $16d52dd8de1034eb$var$baseSet;



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $034c132369d4c9f5$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = (0, $f1ab29f3b886c84b$export$2e2bcd8739ae039)(object, path);
        if (predicate(value, path)) (0, $16d52dd8de1034eb$export$2e2bcd8739ae039)(result, (0, $3281c6aec7b1af5b$export$2e2bcd8739ae039)(path, object), value);
    }
    return result;
}
var $034c132369d4c9f5$export$2e2bcd8739ae039 = $034c132369d4c9f5$var$basePickBy;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $b449890be02da008$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $b449890be02da008$export$2e2bcd8739ae039 = $b449890be02da008$var$baseHasIn;





/** `Object#toString` result references. */ var $441b21c3ff615585$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $441b21c3ff615585$var$baseIsArguments(value) {
    return (0, $12b35a1d6f51d03d$export$2e2bcd8739ae039)(value) && (0, $9b15b088b5f05768$export$2e2bcd8739ae039)(value) == $441b21c3ff615585$var$argsTag;
}
var $441b21c3ff615585$export$2e2bcd8739ae039 = $441b21c3ff615585$var$baseIsArguments;



/** Used for built-in method references. */ var $af98781099b078da$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $af98781099b078da$var$hasOwnProperty = $af98781099b078da$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $af98781099b078da$var$propertyIsEnumerable = $af98781099b078da$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $af98781099b078da$var$isArguments = (0, $441b21c3ff615585$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $441b21c3ff615585$export$2e2bcd8739ae039) : function(value) {
    return (0, $12b35a1d6f51d03d$export$2e2bcd8739ae039)(value) && $af98781099b078da$var$hasOwnProperty.call(value, 'callee') && !$af98781099b078da$var$propertyIsEnumerable.call(value, 'callee');
};
var $af98781099b078da$export$2e2bcd8739ae039 = $af98781099b078da$var$isArguments;




/** Used as references for various `Number` constants. */ var $85e964891d7c59e6$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $85e964891d7c59e6$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $85e964891d7c59e6$var$MAX_SAFE_INTEGER;
}
var $85e964891d7c59e6$export$2e2bcd8739ae039 = $85e964891d7c59e6$var$isLength;



/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $f038ef27f8a033e9$var$hasPath(object, path, hasFunc) {
    path = (0, $3281c6aec7b1af5b$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $5a52b012f527fd8b$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $85e964891d7c59e6$export$2e2bcd8739ae039)(length) && (0, $4a17ca83a682a8ec$export$2e2bcd8739ae039)(key, length) && ((0, $1e1752ba20547388$export$2e2bcd8739ae039)(object) || (0, $af98781099b078da$export$2e2bcd8739ae039)(object));
}
var $f038ef27f8a033e9$export$2e2bcd8739ae039 = $f038ef27f8a033e9$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $bc4649f325999590$var$hasIn(object, path) {
    return object != null && (0, $f038ef27f8a033e9$export$2e2bcd8739ae039)(object, path, (0, $b449890be02da008$export$2e2bcd8739ae039));
}
var $bc4649f325999590$export$2e2bcd8739ae039 = $bc4649f325999590$var$hasIn;


/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $71aa8fbb956005ef$var$basePick(object, paths) {
    return (0, $034c132369d4c9f5$export$2e2bcd8739ae039)(object, paths, function(value, path) {
        return (0, $bc4649f325999590$export$2e2bcd8739ae039)(object, path);
    });
}
var $71aa8fbb956005ef$export$2e2bcd8739ae039 = $71aa8fbb956005ef$var$basePick;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $b89a1ddf24057e86$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $b89a1ddf24057e86$export$2e2bcd8739ae039 = $b89a1ddf24057e86$var$arrayPush;





/** Built-in value references. */ var $a426efb23533eebe$var$spreadableSymbol = (0, $213ba81f8d233690$export$2e2bcd8739ae039) ? (0, $213ba81f8d233690$export$2e2bcd8739ae039).isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $a426efb23533eebe$var$isFlattenable(value) {
    return (0, $1e1752ba20547388$export$2e2bcd8739ae039)(value) || (0, $af98781099b078da$export$2e2bcd8739ae039)(value) || !!($a426efb23533eebe$var$spreadableSymbol && value && value[$a426efb23533eebe$var$spreadableSymbol]);
}
var $a426efb23533eebe$export$2e2bcd8739ae039 = $a426efb23533eebe$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $871373df25110aff$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = (0, $a426efb23533eebe$export$2e2bcd8739ae039));
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $871373df25110aff$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else (0, $b89a1ddf24057e86$export$2e2bcd8739ae039)(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
var $871373df25110aff$export$2e2bcd8739ae039 = $871373df25110aff$var$baseFlatten;


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $ff889d71de4dc96b$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? (0, $871373df25110aff$export$2e2bcd8739ae039)(array, 1) : [];
}
var $ff889d71de4dc96b$export$2e2bcd8739ae039 = $ff889d71de4dc96b$var$flatten;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $a3a46d2bc27fac9b$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $a3a46d2bc27fac9b$export$2e2bcd8739ae039 = $a3a46d2bc27fac9b$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $e77c398c65791961$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $e77c398c65791961$var$overRest(func, start, transform) {
    start = $e77c398c65791961$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $e77c398c65791961$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $a3a46d2bc27fac9b$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $e77c398c65791961$export$2e2bcd8739ae039 = $e77c398c65791961$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $14787307a1c81a02$var$constant(value) {
    return function() {
        return value;
    };
}
var $14787307a1c81a02$export$2e2bcd8739ae039 = $14787307a1c81a02$var$constant;



/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $0db74ad790c2f67a$var$identity(value) {
    return value;
}
var $0db74ad790c2f67a$export$2e2bcd8739ae039 = $0db74ad790c2f67a$var$identity;


/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $311796813c8a1c1a$var$baseSetToString = !(0, $4ebc8e06beafd880$export$2e2bcd8739ae039) ? (0, $0db74ad790c2f67a$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $4ebc8e06beafd880$export$2e2bcd8739ae039)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $14787307a1c81a02$export$2e2bcd8739ae039)(string),
        'writable': true
    });
};
var $311796813c8a1c1a$export$2e2bcd8739ae039 = $311796813c8a1c1a$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $e38f144d8eeef262$var$HOT_COUNT = 800, $e38f144d8eeef262$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e38f144d8eeef262$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $e38f144d8eeef262$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $e38f144d8eeef262$var$nativeNow(), remaining = $e38f144d8eeef262$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $e38f144d8eeef262$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $e38f144d8eeef262$export$2e2bcd8739ae039 = $e38f144d8eeef262$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $31a596daad90a909$var$setToString = (0, $e38f144d8eeef262$export$2e2bcd8739ae039)((0, $311796813c8a1c1a$export$2e2bcd8739ae039));
var $31a596daad90a909$export$2e2bcd8739ae039 = $31a596daad90a909$var$setToString;


/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $b9b8c3325512b9a6$var$flatRest(func) {
    return (0, $31a596daad90a909$export$2e2bcd8739ae039)((0, $e77c398c65791961$export$2e2bcd8739ae039)(func, undefined, (0, $ff889d71de4dc96b$export$2e2bcd8739ae039)), func + '');
}
var $b9b8c3325512b9a6$export$2e2bcd8739ae039 = $b9b8c3325512b9a6$var$flatRest;


/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $7b4876663da3b34b$var$pick = (0, $b9b8c3325512b9a6$export$2e2bcd8739ae039)(function(object, paths) {
    return object == null ? {} : (0, $71aa8fbb956005ef$export$2e2bcd8739ae039)(object, paths);
});
var $7b4876663da3b34b$export$2e2bcd8739ae039 = $7b4876663da3b34b$var$pick;





var $5NSbj = parcelRequire("5NSbj");

function $3b1364f7aaf614fd$var$setFieldValue(setDirty, setEditedSource, spoutParamName, newValue) {
    setDirty(true);
    setEditedSource(({ params: params, ...restSource })=>({
            ...restSource,
            params: {
                ...params,
                [spoutParamName]: newValue
            }
        }));
}
function $3b1364f7aaf614fd$export$2e2bcd8739ae039(props) {
    const { spoutParamName: spoutParamName, spoutParam: spoutParam, params: params = {}, sourceErrors: sourceErrors, sourceId: sourceId, setEditedSource: setEditedSource, setDirty: setDirty } = props;
    const updateSourceParam = (0, $5NSbj.useCallback)((event)=>{
        const newValue = event.currentTarget.value;
        $3b1364f7aaf614fd$var$setFieldValue(setDirty, setEditedSource, spoutParamName, newValue);
    }, [
        setEditedSource,
        setDirty,
        spoutParamName
    ]);
    const updateSourceParamBool = (0, $5NSbj.useCallback)((event)=>{
        const newValue = event.currentTarget.checked ? '1' : undefined;
        $3b1364f7aaf614fd$var$setFieldValue(setDirty, setEditedSource, spoutParamName, newValue);
    }, [
        setEditedSource,
        setDirty,
        spoutParamName
    ]);
    let value = spoutParamName in params ? params[spoutParamName] : spoutParam.default;
    let control = null;
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    if ([
        'text',
        'checkbox',
        'url'
    ].includes(spoutParam.type)) {
        let checked;
        if (spoutParam.type === 'checkbox') {
            checked = value == '1';
            // Value always has to be 1 since HTML sends [name]=[value] when a checkbox is checked
            // and omits the field altogether from HTTP request when not checked.
            value = '1';
        }
        control = /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
            id: `${spoutParamName}-${sourceId}`,
            type: spoutParam.type,
            name: spoutParamName,
            value: value,
            checked: checked,
            onChange: spoutParam.type !== 'checkbox' ? updateSourceParam : updateSourceParamBool
        });
    } else if (spoutParam.type === 'password') control = /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
        id: `${spoutParamName}-${sourceId}`,
        type: spoutParam.type,
        name: spoutParamName,
        placeholder: _('source_pwd_placeholder'),
        onChange: updateSourceParam
    });
    else if (spoutParam.type === 'select') control = /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("select", {
        id: `${spoutParamName}-${sourceId}`,
        name: spoutParamName,
        size: 1,
        value: value,
        onChange: updateSourceParam,
        children: Object.entries(spoutParam.values).map(([optionName, optionTitle])=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("option", {
                value: optionName,
                children: optionTitle
            }, optionName))
    });
    else return null;
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                htmlFor: `${spoutParamName}-${sourceId}`,
                children: spoutParam.title
            }),
            control,
            sourceErrors[spoutParamName] ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                className: "error",
                children: sourceErrors[spoutParamName]
            }) : null
        ]
    });
}




function $377e66b0ec5c5519$export$722fbec263ad908a(id, values) {
    return $0081a42221085bd6$export$299ba2dee77727e9(`source/${id}`, {
        headers: {
            'content-type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify(values),
        failOnHttpErrors: false
    }).promise.then($0081a42221085bd6$export$8d90b058a02656d9((response)=>response.ok || response.status === 400)).then((response)=>response.json().then((json)=>response.ok ? json : {
                success: false,
                errors: json
            }));
}
function $377e66b0ec5c5519$export$c1f8f7c408fa54a(id) {
    return $0081a42221085bd6$export$299ba2dee77727e9('source/' + id + '/update', {
        timeout: 0
    }).promise;
}
function $377e66b0ec5c5519$export$c5eb18431f66026b() {
    return $0081a42221085bd6$export$3988ae62b71be9a3('update', {
        headers: {
            Accept: 'text/event-stream'
        },
        timeout: 0
    }).promise.then((response)=>response.text());
}
function $377e66b0ec5c5519$export$cd7f480d6b8286c3(id) {
    return $0081a42221085bd6$export$38dab5a9fea42f39(`source/${id}`).promise.then((response)=>response.json());
}
var $377e66b0ec5c5519$var$SpoutParameterTypePlain = /*#__PURE__*/ function(SpoutParameterTypePlain) {
    SpoutParameterTypePlain["Text"] = "text";
    SpoutParameterTypePlain["Url"] = "url";
    SpoutParameterTypePlain["Password"] = "password";
    SpoutParameterTypePlain["Checkbox"] = "checkbox";
    return SpoutParameterTypePlain;
}($377e66b0ec5c5519$var$SpoutParameterTypePlain || {});
var $377e66b0ec5c5519$var$SpoutParameterTypeSelect = /*#__PURE__*/ function(SpoutParameterTypeSelect) {
    SpoutParameterTypeSelect["Select"] = "select";
    return SpoutParameterTypeSelect;
}($377e66b0ec5c5519$var$SpoutParameterTypeSelect || {});
var $377e66b0ec5c5519$var$SpoutParameterValidation = /*#__PURE__*/ function(SpoutParameterValidation) {
    SpoutParameterValidation["Alpha"] = "alpha";
    SpoutParameterValidation["Email"] = "email";
    SpoutParameterValidation["Numeric"] = "numeric";
    SpoutParameterValidation["Int"] = "int";
    SpoutParameterValidation["Alphanumeric"] = "alnum";
    SpoutParameterValidation["NonEmpty"] = "notempty";
    return SpoutParameterValidation;
}($377e66b0ec5c5519$var$SpoutParameterValidation || {});
function $377e66b0ec5c5519$export$316f19f1ddc6b34e(abortController) {
    return $0081a42221085bd6$export$3988ae62b71be9a3('sources', {
        abortController: abortController
    }).promise.then((response)=>response.json());
}
function $377e66b0ec5c5519$export$ba43f46f09336c84() {
    return $0081a42221085bd6$export$3988ae62b71be9a3('sources/spouts').promise.then((response)=>response.json());
}
function $377e66b0ec5c5519$export$d72d2378a998c10c(spoutClass) {
    return $0081a42221085bd6$export$3988ae62b71be9a3('source/params', {
        body: $0081a42221085bd6$export$92871f7982deaf9f({
            spout: spoutClass
        })
    }).promise.then((res)=>res.json());
}
function $377e66b0ec5c5519$export$432f698644f45d1() {
    return $0081a42221085bd6$export$3988ae62b71be9a3('sources/stats').promise.then((response)=>response.json());
}




const $e845c2c1aefdcbbe$var$FAST_DURATION_MS = 200;
// cancel source editing
function $e845c2c1aefdcbbe$var$handleCancel(args) {
    const { source: source, sourceElem: sourceElem, setSources: setSources, setEditedSource: setEditedSource } = args;
    const id = source.id;
    if (id.toString().startsWith('new-')) (0, $11fdf00616b3f275$export$c091916f1530334c)(sourceElem.current, {
        duration: $e845c2c1aefdcbbe$var$FAST_DURATION_MS,
        complete: ()=>{
            // Remove the source from this page’s model.
            setSources((sources)=>sources.filter((source)=>source.id !== id));
        }
    });
    else // Hide the input form.
    setEditedSource(null);
}
// save source
function $e845c2c1aefdcbbe$var$handleSave(args) {
    const { event: event, setSources: setSources, source: source, setEditedSource: setEditedSource, setSourceActionLoading: setSourceActionLoading, setJustSavedTimeout: setJustSavedTimeout, setSourceErrors: setSourceErrors, isNew: isNew, setNewIds: setNewIds, showError: showError, _: _ } = args;
    event.preventDefault();
    // remove old errors
    setSourceErrors({});
    setSourceActionLoading(true);
    const newSource = source;
    const { id: id, tags: tags, filter: filter, params: params, ...restSource } = source;
    // Make tags into a list.
    const tagsList = tags ? tags.split(',').map((tag)=>tag.trim()).filter((tag)=>tag !== '') : [];
    const values = {
        ...restSource,
        ...params,
        tags: tagsList,
        filter: filter || null
    };
    const idString = isNew ? `new-${id}` : `${id}`;
    $377e66b0ec5c5519$export$722fbec263ad908a(idString, values).then((response)=>{
        if (response.success === false) setSourceErrors(response.errors);
        else {
            // Set justSavedTimeout state variable to a timeout.
            // The view will show “saved” text while the timeout runs.
            setJustSavedTimeout((oldTimeout)=>{
                // Only keep the most recent timeout.
                if (oldTimeout !== null) clearTimeout(oldTimeout);
                return window.setTimeout(()=>{
                    setJustSavedTimeout(null);
                }, 10000);
            });
            setNewIds((newIds)=>{
                const s = new Set(newIds);
                s.delete(id);
                return s;
            });
            // Hide the input form.
            setEditedSource(null);
            // Update tags and sources for navigation.
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setTags(response.tags);
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setTagsState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS);
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setSources(response.sources);
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setSourcesState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS);
            // Update sources in this page’s model.
            setSources((sources)=>sources.map((source)=>{
                    if (source.id === id) return {
                        ...newSource,
                        id: response.id,
                        tags: tagsList,
                        // Use fetched title.
                        title: response.title,
                        icon: null,
                        lastentry: null,
                        error: null
                    };
                    else return source;
                }));
        }
    }).catch((error)=>{
        showError(_('error_edit_source') + ' ' + error.message);
    }).finally(()=>{
        setSourceActionLoading(false);
    });
}
// delete source
function $e845c2c1aefdcbbe$var$handleDelete(args) {
    const { source: source, sourceElem: sourceElem, setSources: setSources, setSourceBeingDeleted: setSourceBeingDeleted, setDirty: setDirty, showError: showError, _: _ } = args;
    const answer = confirm(_('source_warn'));
    if (answer == false) return;
    // get id
    const id = source.id;
    setDirty(false);
    // show loading
    setSourceBeingDeleted(true);
    // delete on server
    $377e66b0ec5c5519$export$cd7f480d6b8286c3(id).then(()=>{
        (0, $11fdf00616b3f275$export$c091916f1530334c)(sourceElem.current, {
            duration: $e845c2c1aefdcbbe$var$FAST_DURATION_MS,
            complete: ()=>{
                // Remove the source from this page’s model.
                setSources((sources)=>sources.filter((source)=>source.id !== id));
            }
        });
        // Reload tags and remove source from navigation.
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).reloadTags();
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setSources((sources)=>sources.filter((source)=>source.id !== id));
    }).catch((error)=>{
        setSourceBeingDeleted(false);
        showError(_('error_delete_source') + ' ' + error.message);
    });
}
// start editing
function $e845c2c1aefdcbbe$var$handleEdit(args) {
    const { event: event, source: source, setEditedSource: setEditedSource } = args;
    event.preventDefault();
    const { id: id, title: title, tags: tags, filter: filter, spout: spout, params: params } = source;
    setEditedSource({
        id: id,
        title: title ? (0, $ec6aeee77f582aff$export$e8bacd2802a88316)(title) : '',
        tags: tags ? tags.map((0, $ec6aeee77f582aff$export$e8bacd2802a88316)).join(',') : '',
        filter: filter,
        spout: spout,
        params: params
    });
}
// select new source spout type
function $e845c2c1aefdcbbe$var$handleSpoutChange(args) {
    const { event: event, setSpouts: setSpouts, updateEditedSource: updateEditedSource, setSourceParamsLoading: setSourceParamsLoading, setSourceParamsError: setSourceParamsError } = args;
    const spoutClass = event.currentTarget.value;
    updateEditedSource({
        spout: spoutClass
    });
    if (spoutClass.trim().length === 0) return;
    setSourceParamsLoading(true);
    $377e66b0ec5c5519$export$d72d2378a998c10c(spoutClass).then(({ spout: spout })=>{
        setSourceParamsLoading(false);
        setSpouts((spouts)=>({
                ...spouts,
                [spoutClass]: spout
            }));
        const defaults = Object.fromEntries(Object.entries(spout.params).map(([param, props])=>[
                param,
                props.default ?? ''
            ]));
        updateEditedSource((source)=>{
            const oldCompatibleParams = (0, $7b4876663da3b34b$export$2e2bcd8739ae039)(source.params, Object.keys(spout.params));
            return {
                params: {
                    ...defaults,
                    ...oldCompatibleParams
                }
            };
        });
    }).catch((error)=>{
        setSourceParamsLoading(false);
        setSourceParamsError(error.message);
    });
}
// Taken from https://stackoverflow.com/a/15289883/160386
const $e845c2c1aefdcbbe$var$MS_PER_DAY = 86400000;
function $e845c2c1aefdcbbe$var$daysAgo(date) {
    // Get number of days between now and when the last entry was seen
    // Note: The time of the two dates is set to midnight
    // to get the difference of the two dates in calendar days
    // instead of a day equaling any 24 hour period which makes it
    // impossible to distinguish today and yesterday.
    const now = new Date();
    const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    const old = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return Math.floor((today - old) / $e845c2c1aefdcbbe$var$MS_PER_DAY);
}
function $e845c2c1aefdcbbe$var$SourceEditForm(props) {
    const { source: source, sourceElem: sourceElem, sourceError: sourceError, setSources: setSources, spouts: spouts, setSpouts: setSpouts, setEditedSource: setEditedSource, sourceActionLoading: sourceActionLoading, setSourceActionLoading: setSourceActionLoading, sourceParamsLoading: sourceParamsLoading, setSourceParamsLoading: setSourceParamsLoading, sourceParamsError: sourceParamsError, setSourceParamsError: setSourceParamsError, setJustSavedTimeout: setJustSavedTimeout, sourceErrors: sourceErrors, setSourceErrors: setSourceErrors, dirty: dirty, setDirty: setDirty, isNew: isNew, setNewIds: setNewIds, showError: showError } = props;
    const _ = (0, $5NSbj.useContext)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    const sourceId = source.id;
    const updateEditedSource = (0, $5NSbj.useCallback)((changes)=>{
        setDirty(true);
        if (typeof changes === 'function') setEditedSource((source)=>({
                ...source,
                ...changes(source)
            }));
        else setEditedSource((source)=>({
                ...source,
                ...changes
            }));
    }, [
        setEditedSource,
        setDirty
    ]);
    const titleOnChange = (0, $5NSbj.useCallback)((event)=>updateEditedSource({
            title: event.currentTarget.value
        }), [
        updateEditedSource
    ]);
    const tagsOnChange = (0, $5NSbj.useCallback)((event)=>updateEditedSource({
            tags: event.currentTarget.value
        }), [
        updateEditedSource
    ]);
    const filterOnChange = (0, $5NSbj.useCallback)((event)=>updateEditedSource({
            filter: event.currentTarget.value
        }), [
        updateEditedSource
    ]);
    const spoutOnChange = (0, $5NSbj.useCallback)((event)=>$e845c2c1aefdcbbe$var$handleSpoutChange({
            event: event,
            setSpouts: setSpouts,
            updateEditedSource: updateEditedSource,
            setSourceParamsLoading: setSourceParamsLoading,
            setSourceParamsError: setSourceParamsError
        }), [
        setSpouts,
        updateEditedSource,
        setSourceParamsLoading,
        setSourceParamsError
    ]);
    const saveOnClick = (0, $5NSbj.useCallback)((event)=>{
        setDirty(false);
        $e845c2c1aefdcbbe$var$handleSave({
            event: event,
            setSources: setSources,
            source: source,
            setEditedSource: setEditedSource,
            setSourceActionLoading: setSourceActionLoading,
            setJustSavedTimeout: setJustSavedTimeout,
            setSourceErrors: setSourceErrors,
            isNew: isNew,
            setNewIds: setNewIds,
            showError: showError,
            _: _
        });
    }, [
        setSources,
        source,
        setEditedSource,
        setSourceActionLoading,
        setJustSavedTimeout,
        setSourceErrors,
        setDirty,
        isNew,
        setNewIds,
        showError,
        _
    ]);
    const cancelOnClick = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        if (dirty) {
            const answer = confirm(_('source_warn_cancel_dirty'));
            if (answer === false) return;
        }
        setDirty(false);
        $e845c2c1aefdcbbe$var$handleCancel({
            event: event,
            source: source,
            sourceElem: sourceElem,
            setSources: setSources,
            setEditedSource: setEditedSource
        });
    }, [
        source,
        sourceElem,
        setSources,
        setEditedSource,
        dirty,
        setDirty,
        _
    ]);
    const sourceParamsContent = sourceParamsLoading ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $b6b0d4eaa4224082$export$7f7cbe89f1eacd2), {
        size: "3x",
        label: _('source_params_loading')
    }) : sourceParamsError ?? (Object.keys(spouts).includes(source.spout) && Object.keys(spouts[source.spout].params).length > 0 ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("ul", {
        children: Object.entries(spouts[source.spout].params).map(([spoutParamName, spoutParam])=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $3b1364f7aaf614fd$export$2e2bcd8739ae039), {
                params: source.params,
                spoutParamName: spoutParamName,
                spoutParam: spoutParam,
                sourceErrors: sourceErrors,
                sourceId: sourceId,
                setEditedSource: setEditedSource,
                setDirty: setDirty
            }, spoutParamName))
    }) : null);
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("form", {
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
            className: "source-edit-form",
            children: [
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            htmlFor: `title-${sourceId}`,
                            children: _('source_title')
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                            id: `title-${sourceId}`,
                            type: "text",
                            name: "title",
                            accessKey: "t",
                            value: source.title ?? '',
                            placeholder: _('source_autotitle_hint'),
                            onChange: titleOnChange,
                            autoFocus: true
                        }),
                        sourceErrors.title ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors.title
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            htmlFor: `tags-${sourceId}`,
                            children: _('source_tags')
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                            id: `tags-${sourceId}`,
                            type: "text",
                            name: "tags",
                            accessKey: "g",
                            value: source.tags ?? '',
                            onChange: tagsOnChange
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("span", {
                            className: "source-edit-form-help",
                            children: [
                                ' ',
                                _('source_comma')
                            ]
                        }),
                        sourceErrors.tags ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors.tags
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            htmlFor: `filter-${sourceId}`,
                            children: _('source_filter')
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                            id: `filter-${sourceId}`,
                            type: "text",
                            name: "filter",
                            accessKey: "f",
                            value: source.filter ?? '',
                            onChange: filterOnChange
                        }),
                        sourceErrors.filter ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors.filter
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("label", {
                            htmlFor: `type-${sourceId}`,
                            children: _('source_type')
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("select", {
                            id: `type-${sourceId}`,
                            className: "source-spout",
                            name: "spout",
                            accessKey: "y",
                            onChange: spoutOnChange,
                            value: source.spout,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("option", {
                                    value: "",
                                    children: _('source_select')
                                }),
                                Object.entries(spouts).map(([spouttype, spout])=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("option", {
                                        title: spout.description,
                                        value: spouttype,
                                        children: spout.name
                                    }, spouttype))
                            ]
                        }),
                        sourceErrors.spout ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors.spout
                        }) : null
                    ]
                }),
                sourceParamsContent ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                    className: "source-params",
                    children: sourceParamsContent
                }) : null,
                sourceError ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                    className: "source-error",
                    "aria-live": "assertive",
                    children: sourceError
                }) : null,
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
                    className: "source-action",
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                            type: "submit",
                            className: "source-save",
                            accessKey: "s",
                            onClick: saveOnClick,
                            children: [
                                _('source_save'),
                                sourceActionLoading && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $fcda9d1f1901e894$exports.Fragment), {
                                    children: [
                                        ' ',
                                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $b6b0d4eaa4224082$export$7f7cbe89f1eacd2), {
                                            label: _('source_saving')
                                        })
                                    ]
                                })
                            ]
                        }),
                        " \u2022 ",
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                            type: "submit",
                            className: "source-cancel",
                            accessKey: "c",
                            onClick: cancelOnClick,
                            children: _('source_cancel')
                        })
                    ]
                })
            ]
        })
    });
}
function $e845c2c1aefdcbbe$export$2e2bcd8739ae039(props) {
    const { source: source, isNew: isNew, setSources: setSources, spouts: spouts, setSpouts: setSpouts, dirty: dirty, setDirtySources: setDirtySources, setNewIds: setNewIds, showError: showError } = props;
    const _ = (0, $5NSbj.useContext)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    const classes = {
        source: true,
        'source-new': isNew,
        error: source.error && source.error.length > 0
    };
    const [editedSource, setEditedSource] = (0, $5NSbj.useState)(isNew ? {
        id: source.id,
        title: source.title,
        spout: source.spout,
        tags: source.tags.join(', '),
        filter: source.filter,
        params: source.params
    } : null);
    const [sourceActionLoading, setSourceActionLoading] = (0, $5NSbj.useState)(false);
    const [sourceBeingDeleted, setSourceBeingDeleted] = (0, $5NSbj.useState)(false);
    const [sourceParamsLoading, setSourceParamsLoading] = (0, $5NSbj.useState)(false);
    const [justSavedTimeout, setJustSavedTimeout] = (0, $5NSbj.useState)(null);
    const [sourceParamsError, setSourceParamsError] = (0, $5NSbj.useState)(null);
    const [sourceErrors, setSourceErrors] = (0, $5NSbj.useState)({});
    (0, $5NSbj.useEffect)(()=>{
        // Prevent timeout from trying to update state after unmount.
        const oldTimeout = justSavedTimeout;
        return ()=>{
            if (oldTimeout !== null) clearTimeout(oldTimeout);
        };
    }, [
        justSavedTimeout
    ]);
    const editOnClick = (0, $5NSbj.useCallback)((event)=>$e845c2c1aefdcbbe$var$handleEdit({
            event: event,
            source: source,
            setEditedSource: setEditedSource
        }), [
        source,
        setEditedSource
    ]);
    const setDirty = (0, $5NSbj.useCallback)((dirty)=>{
        setDirtySources((dirtySources)=>({
                ...dirtySources,
                [source.id]: dirty
            }));
    }, [
        source.id,
        setDirtySources
    ]);
    const navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    const location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    const sourceElem = (0, $5NSbj.useRef)(null);
    const extraMenuOnSelection = (0, $5NSbj.useCallback)(({ value: value })=>{
        if (value === 'delete') $e845c2c1aefdcbbe$var$handleDelete({
            source: source,
            sourceElem: sourceElem,
            setSources: setSources,
            setSourceBeingDeleted: setSourceBeingDeleted,
            setDirty: setDirty,
            showError: showError,
            _: _
        });
        else if (value === 'browse') navigate((0, $dcbcccfe7d0a797a$export$d0bb2ab5375d1521)(location, {
            category: `source-${source.id}`
        }));
    }, [
        source,
        sourceElem,
        setSources,
        setDirty,
        location,
        navigate,
        showError,
        _
    ]);
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))(classes),
        "data-id": source.id,
        id: `source-${source.id}`,
        ref: sourceElem,
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                className: "source-icon",
                children: source.icon && source.icon != '0' ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("img", {
                    src: `favicons/${source.icon}`,
                    "aria-hidden": "true",
                    alt: ""
                }) : null
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h2", {
                className: "source-title",
                children: source.title ? (0, $ec6aeee77f582aff$export$e8bacd2802a88316)(source.title) : _('source_new')
            }),
            ' ',
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                className: "source-edit-delete",
                children: [
                    !editedSource && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $fcda9d1f1901e894$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                                type: "button",
                                accessKey: "e",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                    'source-showparams': true,
                                    saved: justSavedTimeout !== null
                                }),
                                onClick: editOnClick,
                                "aria-expanded": !!editedSource,
                                children: _(justSavedTimeout !== null ? 'source_saved' : 'source_edit')
                            }),
                            " \u2022 "
                        ]
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $bcd818c5df72da4b$export$d9b273488cd8ce6f), {
                        onItemClick: extraMenuOnSelection,
                        menuButton: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $af69c093d02babcf$export$266a769812832828), {
                            className: "source-menu-button",
                            children: [
                                _('source_menu'),
                                sourceBeingDeleted && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $fcda9d1f1901e894$exports.Fragment), {
                                    children: [
                                        ' ',
                                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $b6b0d4eaa4224082$export$7f7cbe89f1eacd2), {
                                            label: _('source_deleting')
                                        })
                                    ]
                                })
                            ]
                        }),
                        menuClassName: "popup-menu",
                        children: [
                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $3400fac6f43cd1b4$export$2ce376c2cc3355c8), {
                                accessKey: "d",
                                className: "popup-menu-item source-browse",
                                value: "browse",
                                children: _('source_browse')
                            }),
                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $3400fac6f43cd1b4$export$2ce376c2cc3355c8), {
                                accessKey: "d",
                                className: "popup-menu-item source-delete",
                                value: "delete",
                                children: _('source_delete')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                className: "source-days",
                children: source.lastentry ? ` \u{2022} ${_('source_last_post')} ${_('days', {
                    '0': $e845c2c1aefdcbbe$var$daysAgo(new Date(source.lastentry * 1000))
                })}` : null
            }),
            editedSource ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($e845c2c1aefdcbbe$var$SourceEditForm, {
                setSources: setSources,
                spouts: spouts,
                setSpouts: setSpouts,
                setEditedSource: setEditedSource,
                sourceActionLoading: sourceActionLoading,
                setSourceActionLoading: setSourceActionLoading,
                sourceParamsLoading: sourceParamsLoading,
                setSourceParamsLoading: setSourceParamsLoading,
                sourceParamsError: sourceParamsError,
                setSourceParamsError: setSourceParamsError,
                setJustSavedTimeout: setJustSavedTimeout,
                sourceErrors: sourceErrors,
                setSourceErrors: setSourceErrors,
                dirty: dirty,
                setDirty: setDirty,
                isNew: isNew,
                setNewIds: setNewIds,
                sourceElem: sourceElem,
                showError: showError,
                sourceError: source.error,
                source: editedSource
            }) : null
        ]
    });
}






var $5NSbj = parcelRequire("5NSbj");



function $d30756b433a819bb$export$7bcdf1c247ef07b1() {
    const location = (0, $dcbcccfe7d0a797a$export$45d76561a5302f2b)();
    const forceReload = location?.state?.forceReload;
    const [oldForceReload, setOldForceReload] = (0, $5NSbj.useState)(forceReload);
    if (oldForceReload !== forceReload) setOldForceReload(forceReload);
    // The location state is not persisted during navigation
    // so forceReload would change to undefined on successive navigation,
    // triggering an unwanter reload.
    // We use a separate counter to prevent that.
    const [reloadCounter, setReloadCounter] = (0, $5NSbj.useState)(0);
    if (forceReload !== undefined && forceReload !== oldForceReload) {
        const newReloadCounter = reloadCounter + 1;
        setReloadCounter(newReloadCounter);
        return newReloadCounter;
    }
    return reloadCounter;
}
function $d30756b433a819bb$export$443718c44347a6b3() {
    return (0, $875b08fe0af98e08$export$b1eecdc553bff745)('(max-width: 641px)');
}
function $d30756b433a819bb$export$96b5b894afc1d2e3(valueListenable) {
    const [value, setValue] = (0, $5NSbj.useState)(valueListenable.value);
    (0, $5NSbj.useEffect)(()=>{
        const listener = (event)=>{
            setValue(event.value);
        };
        // It might happen that values change between creating the component and setting up the event handlers.
        listener(new (0, $9b6f9431d1a0bef0$export$5521c47db270880f)(valueListenable.value));
        valueListenable.addEventListener('change', listener);
        return ()=>{
            valueListenable.removeEventListener('change', listener);
        };
    }, [
        valueListenable
    ]);
    return value;
}




function $9c2874d6b18f7de8$var$rand() {
    // https://www.php.net/manual/en/function.mt-getrandmax.php#117620
    return Math.floor(Math.random() * 2147483647);
}
function $9c2874d6b18f7de8$var$handleAddSource(args) {
    const { event: event = null, setSources: setSources, setSpouts: setSpouts, setNewIds: setNewIds, extraInitialData: extraInitialData = {} } = args;
    if (event) event.preventDefault();
    const id = $9c2874d6b18f7de8$var$rand();
    setNewIds((newIds)=>new Set([
            id,
            ...newIds
        ]));
    // Add new empty source.
    setSources((sources)=>[
            {
                id: id,
                title: '',
                tags: [],
                spout: '',
                params: {},
                filter: null,
                error: null,
                lastentry: null,
                icon: null,
                ...extraInitialData
            },
            ...sources
        ]);
    // Refresh the spout datea
    $377e66b0ec5c5519$export$ba43f46f09336c84().then((spouts)=>{
        // Update spout data.
        setSpouts(spouts);
    }).catch(()=>{
        console.error('Unable to update spouts, falling back to previously fetched list.');
    });
}
// load sources
function $9c2874d6b18f7de8$var$loadSources(args) {
    const { abortController: abortController, location: location, navigate: navigate, setSpouts: setSpouts, setSources: setSources, setLoadingState: setLoadingState, showError: showError, _: _ } = args;
    if (abortController.signal.aborted) return Promise.resolve();
    setLoadingState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).LOADING);
    return (0, $377e66b0ec5c5519$export$316f19f1ddc6b34e)(abortController).then(({ sources: sources, spouts: spouts })=>{
        if (abortController.signal.aborted) return;
        setSpouts(spouts);
        setSources(sources);
        setLoadingState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS);
        if (location.hash.startsWith('#source-')) {
            const source = document.querySelector(`.source[data-id="${location.hash.replace(/^#source-/, '')}"]`);
            if (!source) return;
            // needs to be delayed for some reason
            requestAnimationFrame(()=>{
                source.scrollIntoView();
            });
        }
    }).catch((error)=>{
        if (error.name === 'AbortError' || abortController.signal.aborted) return;
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).handleAjaxError(error, false).catch((error)=>{
            if (error instanceof (0, $b82622975d92f7af$export$65bd6083489bd8bb) && error.response.status === 403) {
                navigate('/sign/in', {
                    state: {
                        error: _('error_session_expired')
                    }
                });
                return;
            }
            showError(_('error_loading') + ' ' + error.message);
        });
        setLoadingState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).FAILURE);
    });
}
function $9c2874d6b18f7de8$export$2e2bcd8739ae039(props) {
    const { showError: showError } = props;
    const _ = (0, $5NSbj.useContext)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    const [spouts, setSpouts] = (0, $5NSbj.useState)({});
    const [sources, setSources] = (0, $5NSbj.useState)([]);
    const [newIds, setNewIds] = (0, $5NSbj.useState)(()=>new Set());
    const [loadingState, setLoadingState] = (0, $5NSbj.useState)((0, $f5b3c040e086fbc1$export$62aa48085237e36f).INITIAL);
    const forceReload = (0, $d30756b433a819bb$export$7bcdf1c247ef07b1)();
    const navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    const location = (0, $dcbcccfe7d0a797a$export$45d76561a5302f2b)();
    const isAdding = (0, $4a2ef0180f3aa5fe$export$6c330e8992e8a295)('/manage/sources/add');
    const reloader = (0, $5NSbj.useEffectEvent)(async (abortController)=>{
        await $9c2874d6b18f7de8$var$loadSources({
            abortController: abortController,
            location: location,
            navigate: navigate,
            setSpouts: setSpouts,
            setSources: setSources,
            setLoadingState: setLoadingState,
            showError: showError,
            _: _
        });
        if (isAdding) {
            const params = new URLSearchParams(location.search);
            $9c2874d6b18f7de8$var$handleAddSource({
                setSources: setSources,
                setSpouts: setSpouts,
                setNewIds: setNewIds,
                extraInitialData: {
                    spout: 'spouts\\rss\\feed',
                    params: {
                        url: params.get('url') ?? ''
                    }
                }
            });
            // Clear the value from the state so it does not bug us forever.
            navigate('/manage/sources', {
                replace: true
            });
        }
    });
    (0, $5NSbj.useEffect)(()=>{
        const abortController = new AbortController();
        reloader(abortController);
        return ()=>{
            abortController.abort();
        };
    }, [
        forceReload
    ]);
    const addOnClick = (0, $5NSbj.useCallback)((event)=>$9c2874d6b18f7de8$var$handleAddSource({
            event: event,
            setSources: setSources,
            setSpouts: setSpouts,
            setNewIds: setNewIds
        }), []);
    const [dirtySources, setDirtySources] = (0, $5NSbj.useState)({});
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const isDirty = (0, $5NSbj.useMemo)(()=>Object.values(dirtySources).includes(true), [
        dirtySources
    ]);
    // TODO: Error: useBlocker must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.
    // usePrompt({
    //     when: isDirty,
    //     message: _('sources_leaving_unsaved_prompt'),
    // });
    if (loadingState === (0, $f5b3c040e086fbc1$export$62aa48085237e36f).LOADING) return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $b6b0d4eaa4224082$export$84dbad74efe95918), {
        label: _('sources_loading')
    });
    if (loadingState !== (0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS) return null;
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $fcda9d1f1901e894$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                className: "source-add",
                onClick: addOnClick,
                children: _('source_add')
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("a", {
                className: "source-export",
                href: "opmlexport",
                children: _('source_export')
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $1b28ddd4ebfaf955$export$a6c7ac8248d6e38a), {
                className: "source-opml",
                to: "/opml",
                children: _('source_opml')
            }),
            sources ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("ul", {
                children: sources.map((source)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $e845c2c1aefdcbbe$export$2e2bcd8739ae039), {
                        isNew: newIds.has(source.id),
                        dirty: dirtySources[source.id] ?? false,
                        source: source,
                        setSources: setSources,
                        spouts: spouts,
                        setSpouts: setSpouts,
                        setDirtySources: setDirtySources,
                        setNewIds: setNewIds,
                        showError: showError
                    }, source.id))
            }) : /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("p", {
                children: _('no_sources')
            })
        ]
    });
}




var $5NSbj = parcelRequire("5NSbj");


var $7f88ad86c77db2c7$exports = {};
"use strict";
Object.defineProperty($7f88ad86c77db2c7$exports, "__esModule", {
    value: true
});
$7f88ad86c77db2c7$exports.useStateWithDeps = $7f88ad86c77db2c7$var$useStateWithDeps;

var $5NSbj = parcelRequire("5NSbj");
var $f446ed18a2496453$exports = {};
"use strict";
Object.defineProperty($f446ed18a2496453$exports, "__esModule", {
    value: true
});
$f446ed18a2496453$exports.depsAreEqual = $f446ed18a2496453$var$depsAreEqual;
function $f446ed18a2496453$var$depsAreEqual(prevDeps, deps) {
    return prevDeps.length === deps.length && deps.every(function(dep, index) {
        return Object.is(dep, prevDeps[index]);
    });
}


var $15e1f0f410678794$exports = {};
"use strict";
Object.defineProperty($15e1f0f410678794$exports, "__esModule", {
    value: true
});
$15e1f0f410678794$exports.isFunction = $15e1f0f410678794$var$isFunction;
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function $15e1f0f410678794$var$isFunction(input) {
    return typeof input === "function";
}


function $7f88ad86c77db2c7$var$_slicedToArray(r, e) {
    return $7f88ad86c77db2c7$var$_arrayWithHoles(r) || $7f88ad86c77db2c7$var$_iterableToArrayLimit(r, e) || $7f88ad86c77db2c7$var$_unsupportedIterableToArray(r, e) || $7f88ad86c77db2c7$var$_nonIterableRest();
}
function $7f88ad86c77db2c7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7f88ad86c77db2c7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7f88ad86c77db2c7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7f88ad86c77db2c7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7f88ad86c77db2c7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $7f88ad86c77db2c7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7f88ad86c77db2c7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
/**
 * `useState` hook with an additional dependency array that resets
 * the state to the `initialState` param when the dependencies passed
 * in the `deps` array change.
 *
 * @param initialState
 * The state that will be set when the component mounts or the
 * dependencies change.
 *
 * It can also be a function which resolves to the state. If the state
 * is reset due to a change of dependencies, this function will be called with the previous
 * state (`undefined` for the first call upon mount).
 * @param deps Dependencies for this hook that resets the state to `initialState`
 */ function $7f88ad86c77db2c7$var$useStateWithDeps(initialState, deps) {
    var _useState = (0, $5NSbj.useState)(function() {
        var state = (0, $15e1f0f410678794$exports.isFunction)(initialState) ? initialState(undefined) : initialState;
        return {
            state: state,
            deps: deps
        };
    }), _useState2 = $7f88ad86c77db2c7$var$_slicedToArray(_useState, 2), stateAndDeps = _useState2[0], setStateAndDeps = _useState2[1];
    // Use the prevState pattern to detect dependency changes during rendering.
    // Calling setState during render (without refs) is the React-approved approach
    // for adjusting state based on changing inputs, and correctly supports
    // concurrent features like useTransition and useDeferredValue.
    var currentState = stateAndDeps.state;
    if (!(0, $f446ed18a2496453$exports.depsAreEqual)(stateAndDeps.deps, deps)) {
        var nextState = (0, $15e1f0f410678794$exports.isFunction)(initialState) ? initialState(stateAndDeps.state) : initialState;
        currentState = nextState;
        setStateAndDeps({
            state: nextState,
            deps: deps
        });
    }
    var updateState = (0, $5NSbj.useCallback)(function updateState(newState) {
        setStateAndDeps(function(prev) {
            var nextState = (0, $15e1f0f410678794$exports.isFunction)(newState) ? newState(prev.state) : newState;
            if (Object.is(prev.state, nextState)) return prev;
            return {
                state: nextState,
                deps: prev.deps
            };
        });
    }, []);
    return [
        currentState,
        updateState
    ];
}





var $5NSbj = parcelRequire("5NSbj");



/*!
* focus-trap 8.2.3
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ /*!
* tabbable 6.5.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var $2a6aaf9039da226f$var$candidateSelectors = [
    'input:not([inert]):not([inert] *)',
    'select:not([inert]):not([inert] *)',
    'textarea:not([inert]):not([inert] *)',
    'a[href]:not([inert]):not([inert] *)',
    'area[href]:not([inert]):not([inert] *)',
    'button:not([inert]):not([inert] *)',
    '[tabindex]:not(slot):not([inert]):not([inert] *)',
    'audio[controls]:not([inert]):not([inert] *)',
    'video[controls]:not([inert]):not([inert] *)',
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    'details>summary:first-of-type:not([inert]):not([inert] *)',
    'details:not([inert]):not([inert] *)'
];
var $2a6aaf9039da226f$var$candidateSelector = /* #__PURE__ */ $2a6aaf9039da226f$var$candidateSelectors.join(',');
var $2a6aaf9039da226f$var$NoElement = typeof Element === 'undefined';
var $2a6aaf9039da226f$var$matches = $2a6aaf9039da226f$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $2a6aaf9039da226f$var$getRootNode = !$2a6aaf9039da226f$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $2a6aaf9039da226f$var$_isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === 'function' ? node.closest('[inert]') : $2a6aaf9039da226f$var$_isInert(node.parentNode));
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $2a6aaf9039da226f$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $2a6aaf9039da226f$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert (either by itself or via its parent), then all its children are inert
    if ($2a6aaf9039da226f$var$_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($2a6aaf9039da226f$var$candidateSelector));
    if (includeContainer && $2a6aaf9039da226f$var$matches.call(el, $2a6aaf9039da226f$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $2a6aaf9039da226f$var$_getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($2a6aaf9039da226f$var$_isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = $2a6aaf9039da226f$var$_getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $2a6aaf9039da226f$var$matches.call(element, $2a6aaf9039da226f$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$2a6aaf9039da226f$var$_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = $2a6aaf9039da226f$var$_getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $2a6aaf9039da226f$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $2a6aaf9039da226f$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $2a6aaf9039da226f$var$isContentEditable(node)) && !$2a6aaf9039da226f$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $2a6aaf9039da226f$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $2a6aaf9039da226f$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$2a6aaf9039da226f$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $2a6aaf9039da226f$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $2a6aaf9039da226f$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $2a6aaf9039da226f$var$isHiddenInput = function isHiddenInput(node) {
    return $2a6aaf9039da226f$var$isInput(node) && node.type === 'hidden';
};
var $2a6aaf9039da226f$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $2a6aaf9039da226f$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $2a6aaf9039da226f$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $2a6aaf9039da226f$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $2a6aaf9039da226f$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $2a6aaf9039da226f$var$isRadio = function isRadio(node) {
    return $2a6aaf9039da226f$var$isInput(node) && node.type === 'radio';
};
var $2a6aaf9039da226f$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $2a6aaf9039da226f$var$isRadio(node) && !$2a6aaf9039da226f$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $2a6aaf9039da226f$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $2a6aaf9039da226f$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $2a6aaf9039da226f$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $2a6aaf9039da226f$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $2a6aaf9039da226f$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === 'full-native') {
        if ('checkVisibility' in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    var _getComputedStyle = getComputedStyle(node), visibility = _getComputedStyle.visibility;
    if (visibility === 'hidden' || visibility === 'collapse') return true;
    var isDirectSummary = $2a6aaf9039da226f$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($2a6aaf9039da226f$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === 'full-native' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $2a6aaf9039da226f$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $2a6aaf9039da226f$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($2a6aaf9039da226f$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $2a6aaf9039da226f$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $2a6aaf9039da226f$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $2a6aaf9039da226f$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $2a6aaf9039da226f$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $2a6aaf9039da226f$var$isHiddenInput(node) || $2a6aaf9039da226f$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $2a6aaf9039da226f$var$isDetailsWithSummary(node) || $2a6aaf9039da226f$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $2a6aaf9039da226f$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($2a6aaf9039da226f$var$isNonTabbableRadio(node) || $2a6aaf9039da226f$export$a4672efddb4181b8(node) < 0 || !$2a6aaf9039da226f$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $2a6aaf9039da226f$var$isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $2a6aaf9039da226f$var$_sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $2a6aaf9039da226f$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? $2a6aaf9039da226f$var$_sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($2a6aaf9039da226f$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $2a6aaf9039da226f$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $2a6aaf9039da226f$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $2a6aaf9039da226f$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $2a6aaf9039da226f$var$isShadowRootTabbable
    });
    else candidates = $2a6aaf9039da226f$var$getCandidates(container, options.includeContainer, $2a6aaf9039da226f$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $2a6aaf9039da226f$var$_sortByOrder(candidates);
};
var $2a6aaf9039da226f$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $2a6aaf9039da226f$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $2a6aaf9039da226f$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $2a6aaf9039da226f$var$getCandidates(container, options.includeContainer, $2a6aaf9039da226f$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $2a6aaf9039da226f$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($2a6aaf9039da226f$var$matches.call(node, $2a6aaf9039da226f$var$candidateSelector) === false) return false;
    return $2a6aaf9039da226f$var$isNodeMatchingSelectorTabbable(options, node);
};
var $2a6aaf9039da226f$var$focusableCandidateSelector = /* #__PURE__ */ $2a6aaf9039da226f$var$candidateSelectors.concat('iframe:not([inert]):not([inert] *)').join(',');
var $2a6aaf9039da226f$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($2a6aaf9039da226f$var$matches.call(node, $2a6aaf9039da226f$var$focusableCandidateSelector) === false) return false;
    return $2a6aaf9039da226f$var$isNodeMatchingSelectorFocusable(options, node);
};


function $66c441288a5fbbb7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $66c441288a5fbbb7$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $66c441288a5fbbb7$var$_arrayLikeToArray(r);
}
function $66c441288a5fbbb7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $66c441288a5fbbb7$var$_unsupportedIterableToArray(r)) || e) {
            t && (r = t);
            var n = 0, F = function() {};
            return {
                s: F,
                n: function() {
                    return n >= r.length ? {
                        done: true
                    } : {
                        done: false,
                        value: r[n++]
                    };
                },
                e: function(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = true, u = false;
    return {
        s: function() {
            t = t.call(r);
        },
        n: function() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function(r) {
            u = true, o = r;
        },
        f: function() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $66c441288a5fbbb7$var$_defineProperty(e, r, t) {
    return (r = $66c441288a5fbbb7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $66c441288a5fbbb7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $66c441288a5fbbb7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $66c441288a5fbbb7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $66c441288a5fbbb7$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $66c441288a5fbbb7$var$ownKeys(Object(t), true).forEach(function(r) {
            $66c441288a5fbbb7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $66c441288a5fbbb7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $66c441288a5fbbb7$var$_toConsumableArray(r) {
    return $66c441288a5fbbb7$var$_arrayWithoutHoles(r) || $66c441288a5fbbb7$var$_iterableToArray(r) || $66c441288a5fbbb7$var$_unsupportedIterableToArray(r) || $66c441288a5fbbb7$var$_nonIterableSpread();
}
function $66c441288a5fbbb7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $66c441288a5fbbb7$var$_toPropertyKey(t) {
    var i = $66c441288a5fbbb7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $66c441288a5fbbb7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $66c441288a5fbbb7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $66c441288a5fbbb7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $66c441288a5fbbb7$var$activeFocusTraps = {
    // Returns the trap from the top of the stack.
    getActiveTrap: function getActiveTrap(trapStack) {
        if ((trapStack === null || trapStack === void 0 ? void 0 : trapStack.length) > 0) return trapStack[trapStack.length - 1];
        return null;
    },
    // Pauses the currently active trap, then adds a new trap to the stack.
    activateTrap: function activateTrap(trapStack, trap) {
        var activeTrap = $66c441288a5fbbb7$var$activeFocusTraps.getActiveTrap(trapStack);
        if (trap !== activeTrap) $66c441288a5fbbb7$var$activeFocusTraps.pauseTrap(trapStack);
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            // move this existing trap to the front of the queue
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    // Removes the trap from the top of the stack, then unpauses the next trap down.
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        $66c441288a5fbbb7$var$activeFocusTraps.unpauseTrap(trapStack);
    },
    // Pauses the trap at the top of the stack.
    pauseTrap: function pauseTrap(trapStack) {
        var activeTrap = $66c441288a5fbbb7$var$activeFocusTraps.getActiveTrap(trapStack);
        activeTrap === null || activeTrap === void 0 || activeTrap._setPausedState(true);
    },
    // Unpauses the trap at the top of the stack.
    unpauseTrap: function unpauseTrap(trapStack) {
        var activeTrap = $66c441288a5fbbb7$var$activeFocusTraps.getActiveTrap(trapStack);
        if (activeTrap && !activeTrap._isManuallyPaused()) activeTrap._setPausedState(false);
    }
};
var $66c441288a5fbbb7$var$isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};
var $66c441288a5fbbb7$var$isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === 'Escape' || (e === null || e === void 0 ? void 0 : e.key) === 'Esc' || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var $66c441288a5fbbb7$var$isTabEvent = function isTabEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === 'Tab' || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
// checks for TAB by default
var $66c441288a5fbbb7$var$isKeyForward = function isKeyForward(e) {
    return $66c441288a5fbbb7$var$isTabEvent(e) && !e.shiftKey;
};
// checks for SHIFT+TAB by default
var $66c441288a5fbbb7$var$isKeyBackward = function isKeyBackward(e) {
    return $66c441288a5fbbb7$var$isTabEvent(e) && e.shiftKey;
};
var $66c441288a5fbbb7$var$delay = function delay(fn) {
    return setTimeout(fn, 0);
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var $66c441288a5fbbb7$var$valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === 'function' ? value.apply(void 0, params) : value;
};
var $66c441288a5fbbb7$var$getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};
// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var $66c441288a5fbbb7$var$internalTrapStack = [];
var $66c441288a5fbbb7$export$360440dfcba94c00 = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || $66c441288a5fbbb7$var$internalTrapStack;
    var config = $66c441288a5fbbb7$var$_objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        delayReturnFocus: true,
        isolateSubtrees: false,
        isKeyForward: $66c441288a5fbbb7$var$isKeyForward,
        isKeyBackward: $66c441288a5fbbb7$var$isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        /** @type {Array<HTMLElement>} */ containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        /** @type {Array<{
     *    container: HTMLElement,
     *    tabbableNodes: Array<HTMLElement>, // empty if none
     *    focusableNodes: Array<HTMLElement>, // empty if none
     *    posTabIndexesFound: boolean,
     *    firstTabbableNode: HTMLElement|undefined,
     *    lastTabbableNode: HTMLElement|undefined,
     *    firstDomTabbableNode: HTMLElement|undefined,
     *    lastDomTabbableNode: HTMLElement|undefined,
     *    nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
     *  }>}
     */ containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        // references to nodes that are siblings to the ancestors of this trap's containers.
        /** @type {Set<HTMLElement>} */ adjacentElements: new Set(),
        // references to nodes that were inert or aria-hidden before the trap was activated.
        /** @type {Set<HTMLElement>} */ alreadySilent: new Set(),
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        manuallyPaused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === 'function' ? event.composedPath() : undefined;
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @param {Object} options
   * @param {boolean} [options.hasFallback] True if the option could be a selector string
   *  and the option allows for a fallback scenario in the case where the selector is
   *  valid but does not match a node (i.e. the queried node doesn't exist in the DOM).
   * @param {Array} [options.params] Params to pass to the option if it's a function.
   * @returns {undefined | null | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `null` if the option didn't resolve
   *  to a node but `options.hasFallback=true`, `false` if the option resolved to `false`
   *  (node explicitly not given); otherwise, the resolved DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node, unless the option is a selector string and `options.hasFallback=true`.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$hasFallback = _ref2.hasFallback, hasFallback = _ref2$hasFallback === void 0 ? false : _ref2$hasFallback, _ref2$params = _ref2.params, params = _ref2$params === void 0 ? [] : _ref2$params;
        var optionValue = config[optionName];
        if (typeof optionValue === 'function') optionValue = optionValue.apply(void 0, $66c441288a5fbbb7$var$_toConsumableArray(params));
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
            // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === 'string') {
            try {
                node = doc.querySelector(optionValue); // resolve to node, or null if fails
            } catch (err) {
                throw new Error("`".concat(optionName, "` appears to be an invalid selector; error=\"").concat(err.message, "\""), {
                    cause: err
                });
            }
            if (!node) {
                if (!hasFallback) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
            // else, `node` MUST be `null` because that's what `Document.querySelector()` returns
            //  if the selector is valid but doesn't match anything
            }
        }
        return node;
    };
    /**
   * Gets the current activeElement. If it's a web-component and has open shadow-root
   * it will recursively search inside shadow roots for the "true" activeElement.
   *
   * @param {Document | ShadowRoot} el
   *
   * @returns {HTMLElement|null} The element that currently has the focus. `null` if a focused element isn't found.
   **/ var _getActiveElement = function getActiveElement(el) {
        var activeElement = el.activeElement;
        if (!activeElement) return null;
        if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) return _getActiveElement(activeElement.shadowRoot);
        return activeElement;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption('initialFocus', {
            hasFallback: true
        });
        // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined || node && !(0, $2a6aaf9039da226f$export$4c063cf1350e6fed)(node, config.tabbableOptions)) {
            var activeElement = _getActiveElement(doc);
            // option not specified nor focusable: use fallback options
            if (findContainerIndex(activeElement) >= 0) node = activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption('fallbackFocus');
            }
        } else if (node === null) // option is a VALID selector string that doesn't yield a node: use the `fallbackFocus`
        //  option instead of the default behavior when the option isn't specified at all
        node = getNodeForOption('fallbackFocus');
        if (!node) throw new Error('Your focus-trap needs to have at least one focusable element');
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = (0, $2a6aaf9039da226f$export$17100aea90429aa7)(container, config.tabbableOptions);
            // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
            //  are focusable but not tabbable
            var focusableNodes = (0, $2a6aaf9039da226f$export$ecc6d1fcdff4f700)(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return (0, $2a6aaf9039da226f$export$bebd5a1431fec25d)(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return (0, $2a6aaf9039da226f$export$bebd5a1431fec25d)(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return (0, $2a6aaf9039da226f$export$a4672efddb4181b8)(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound: posTabIndexesFound,
                /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode: firstTabbableNode,
                /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode: lastTabbableNode,
                // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode: firstDomTabbableNode,
                /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode: lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
                        //  since `node` should at least have been focusable, we assume that's the case and mimic
                        //  what browsers do, which is set focus to the next node in __document position order__,
                        //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
                        //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
                        //  basic DOM order
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return (0, $2a6aaf9039da226f$export$bebd5a1431fec25d)(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return (0, $2a6aaf9039da226f$export$bebd5a1431fec25d)(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
        ) throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
        // NOTE: Positive tabindexes are only properly supported in single-container traps because
        //  doing it across multiple containers where tabindexes could be all over the place
        //  would require Tabbable to support multiple containers, would require additional
        //  specialized Shadow DOM support, and would require Tabbable's multi-container support
        //  to look at those containers in document position order rather than user-provided
        //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
        //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    var _tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === _getActiveElement(doc)) {
            state.mostRecentlyFocusedNode = node;
            return;
        }
        if (!node || !node.focus) {
            _tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        // NOTE: focus() API does not trigger focusIn event so set MRU node manually
        state.mostRecentlyFocusedNode = node;
        if ($66c441288a5fbbb7$var$isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption('setReturnFocus', {
            params: [
                previousActiveElement
            ]
        });
        return node ? node : node === false ? false : previousActiveElement;
    };
    /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */ var findNextNavNode = function findNextNavNode(_ref3) {
        var target = _ref3.target, event = _ref3.event, _ref3$isBackward = _ref3.isBackward, isBackward = _ref3$isBackward === void 0 ? false : _ref3$isBackward;
        target = target || $66c441288a5fbbb7$var$getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back into...
                if (isBackward) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = state.tabbableGroups.findIndex(function(_ref4) {
                    var firstTabbableNode = _ref4.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || (0, $2a6aaf9039da226f$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $2a6aaf9039da226f$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = (0, $2a6aaf9039da226f$export$a4672efddb4181b8)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!$66c441288a5fbbb7$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = state.tabbableGroups.findIndex(function(_ref5) {
                    var lastTabbableNode = _ref5.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0, $2a6aaf9039da226f$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $2a6aaf9039da226f$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = (0, $2a6aaf9039da226f$export$a4672efddb4181b8)(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!$66c441288a5fbbb7$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else // no groups available
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption('fallbackFocus');
        return destinationNode;
    };
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = $66c441288a5fbbb7$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) // allow the click since it occurred inside the trap
        return;
        if ($66c441288a5fbbb7$var$valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if ($66c441288a5fbbb7$var$valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
        // otherwise, prevent the click
        e.preventDefault();
    };
    // In case focus escapes the trap for some strange reason, pull it back in.
    // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
    //  scrolling if the node that got focused was out of view; there's nothing we can do to
    //  prevent that from happening by the time we discover that focus escaped
    var checkFocusIn = function checkFocusIn(event) {
        var target = $66c441288a5fbbb7$var$getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            event.stopImmediatePropagation();
            // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
            //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
            //  toward a node with a positive tab index
            var nextNode; // next node to focus, if we find one
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if ((0, $2a6aaf9039da226f$export$a4672efddb4181b8)(state.mostRecentlyFocusedNode) > 0) {
                    // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    // there MAY not be any tabbable nodes in the container if there are at least 2 containers
                    //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
                    //  with at least one tabbable node in order to function, so this could be the other container
                    //  with nothing tabbable in it)
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        // else, don't find in container order without considering direction too
                        }
                    }
                // else, no tabbable nodes in that container (which means we must have at least one other
                //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
                //  an error the last time updateTabbableNodes() was run): find next node among all known
                //  containers
                } else // check to see if there's at least one tabbable node with a positive tab index inside
                //  the trap because focus seems to escape when navigating backward from a tabbable node
                //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
                //  the greatest positive tab index like it should)
                if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return (0, $2a6aaf9039da226f$export$a4672efddb4181b8)(n) > 0;
                    });
                })) // no containers with tabbable nodes with positive tab indexes which means the focus
                //  escaped for some other reason and we should just execute the fallback to the
                //  MRU node or initial focus node, if any
                navAcrossContainers = false;
            } else // no MRU node means we're likely in some initial condition when the trap has just
            //  been activated and initial focus hasn't been given yet, in which case we should
            //  fall through to trying to focus the initial focus node, which is what should
            //  happen below at this point in the logic
            navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) _tryFocus(nextNode);
            else _tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = undefined; // clear
    };
    // Hijack key nav events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkKeyNav = function checkKeyNav(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if ($66c441288a5fbbb7$var$isTabEvent(event)) // since tab natively moves focus, we wouldn't have a destination node unless we
            //  were on the edge of a container and had to move to the next/previous edge, in
            //  which case we want to prevent default to keep the browser from moving focus
            //  to where it normally would
            event.preventDefault();
            _tryFocus(destinationNode);
        }
    // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkTabKey = function checkTabKey(event) {
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    // we use a different event phase for the Escape key to allow canceling the event and checking for this in escapeDeactivates
    var checkEscapeKey = function checkEscapeKey(event) {
        if ($66c441288a5fbbb7$var$isEscapeEvent(event) && $66c441288a5fbbb7$var$valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
        }
    };
    var checkClick = function checkClick(e) {
        var target = $66c441288a5fbbb7$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if ($66c441288a5fbbb7$var$valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if ($66c441288a5fbbb7$var$valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    //
    // EVENT LISTENERS
    //
    /**
   * Adds listeners to the document necessary for trapping focus and attempts to set focus
   *  to the configured initial focus node. Does nothing if the trap isn't active.
   * @returns {Promise<void> | undefined} A promise resolved once the initial focus node has
   *  been focused when `delayInitialFocus=true`; `undefined` when focus is set synchronously
   *  or the trap isn't active.
   */ var addListeners = function addListeners() {
        if (!state.active) return;
        // There can be only one listening focus trap at a time
        $66c441288a5fbbb7$var$activeFocusTraps.activateTrap(trapStack, trap);
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        /** @type {Promise<void> | undefined} */ var promise;
        if (config.delayInitialFocus) // NOTE: Promise constructor callback is called synchronously, which is what we want
        //  since we need to capture the timer ID immediately
        promise = new Promise(function(resolve) {
            state.delayInitialFocusTimer = $66c441288a5fbbb7$var$delay(function() {
                _tryFocus(getInitialFocusNode());
                resolve();
            });
        });
        else _tryFocus(getInitialFocusNode());
        doc.addEventListener('focusin', checkFocusIn, true);
        doc.addEventListener('mousedown', checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener('touchstart', checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener('click', checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener('keydown', checkTabKey, {
            capture: true,
            passive: false
        });
        doc.addEventListener('keydown', checkEscapeKey);
        return promise;
    };
    /**
   * Traverses up the DOM from each of `containers`, collecting references to
   * the elements that are siblings to `container` or an ancestor of `container`.
   * @param {Array<HTMLElement>} containers
   */ var collectAdjacentElements = function collectAdjacentElements(containers) {
        // Re-activate all adjacent elements & clear previous collection.
        if (state.active && !state.paused) trap._setSubtreeIsolation(false);
        state.adjacentElements.clear();
        state.alreadySilent.clear();
        // Collect all ancestors of all containers to avoid redundant processing.
        var containerAncestors = new Set();
        var adjacentElements = new Set();
        // Compile all elements adjacent to the focus trap containers & lineage.
        var _iterator = $66c441288a5fbbb7$var$_createForOfIteratorHelper(containers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var container = _step.value;
                containerAncestors.add(container);
                var insideShadowRoot = typeof ShadowRoot !== 'undefined' && container.getRootNode() instanceof ShadowRoot;
                var current = container;
                while(current){
                    containerAncestors.add(current);
                    var parent = current.parentElement;
                    var siblings = [];
                    if (parent) siblings = parent.children;
                    else if (!parent && insideShadowRoot) {
                        siblings = current.getRootNode().children;
                        parent = current.getRootNode().host;
                        insideShadowRoot = typeof ShadowRoot !== 'undefined' && parent.getRootNode() instanceof ShadowRoot;
                    }
                    // Add all the children, we'll remove container lineage later.
                    var _iterator2 = $66c441288a5fbbb7$var$_createForOfIteratorHelper(siblings), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var child = _step2.value;
                            adjacentElements.add(child);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    current = parent;
                }
            }
        // Multi-container traps may overlap.
        // Remove elements within container lineages.
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        containerAncestors.forEach(function(el) {
            adjacentElements["delete"](el);
        });
        state.adjacentElements = adjacentElements;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener('focusin', checkFocusIn, true);
        doc.removeEventListener('mousedown', checkPointerDown, true);
        doc.removeEventListener('touchstart', checkPointerDown, true);
        doc.removeEventListener('click', checkClick, true);
        doc.removeEventListener('keydown', checkTabKey, true);
        doc.removeEventListener('keydown', checkEscapeKey);
        return trap;
    };
    //
    // MUTATION OBSERVER
    //
    var checkDomRemoval = function checkDomRemoval(mutations) {
        var focusedNode = state.mostRecentlyFocusedNode;
        if (!focusedNode) return;
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === focusedNode || typeof node.contains === 'function' && node.contains(focusedNode);
            });
        });
        // If the currently focused node is removed then browsers will move focus to the
        // <body> element. If this happens, try to move focus back into the trap.
        if (isFocusedNodeRemoved && state.containers.some(function(container) {
            return container === null || container === void 0 ? void 0 : container.isConnected;
        })) {
            // Refresh tabbable state before resolving initial focus because
            // getInitialFocusNode() may fall back to the first tabbable node in the trap.
            updateTabbableNodes();
            var initialFocusNode = getInitialFocusNode();
            _tryFocus(initialFocusNode);
        }
    };
    // Use MutationObserver - if supported - to detect if focused node is removed
    // from the DOM.
    var mutationObserver = typeof window !== 'undefined' && 'MutationObserver' in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, 'onActivate');
            var onPostActivate = getOption(activateOptions, 'onPostActivate');
            var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');
            // If a currently-active trap is isolating its subtree, we need to remove
            // that isolation to allow the new trap to find tabbable nodes.
            var preexistingTrap = $66c441288a5fbbb7$var$activeFocusTraps.getActiveTrap(trapStack);
            var revertState = false;
            if (preexistingTrap && !preexistingTrap.paused) {
                var _preexistingTrap$_set;
                // [#1729] method MAY not exist if using `trapStack` option to share stack with older
                //  versions of Focus-trap in the same DOM so use optional chaining here just in case
                //  since this is a trap we may not have created from this instance of the library
                (_preexistingTrap$_set = preexistingTrap._setSubtreeIsolation) === null || _preexistingTrap$_set === void 0 || _preexistingTrap$_set.call(preexistingTrap, false);
                revertState = true;
            }
            try {
                if (!checkCanFocusTrap) updateTabbableNodes();
                state.active = true;
                state.paused = false;
                state.nodeFocusedBeforeActivation = _getActiveElement(doc);
                onActivate === null || onActivate === void 0 || onActivate({
                    trap: trap
                });
                var finishActivation = function finishActivation() {
                    if (checkCanFocusTrap) updateTabbableNodes();
                    var afterListeners = function afterListeners() {
                        trap._setSubtreeIsolation(true);
                        updateObservedNodes();
                        onPostActivate === null || onPostActivate === void 0 || onPostActivate({
                            trap: trap
                        });
                    };
                    // NOTE: wait for initial focus node to get focused (whether activation is fully,
                    //  partially, or not asynchronous) before we potentially isolate the subtrees
                    //  with aria-hidden while focus is still in some other subtree and not yet in
                    //  the trap, resulting in some browsers (e.g. Chrome) logging to the console that
                    //  they, "Blocked aria-hidden on an element because its descendant retained focus..."
                    var listenersPromise = addListeners();
                    if (listenersPromise) listenersPromise.then(afterListeners);
                    else afterListeners();
                };
                if (checkCanFocusTrap) {
                    checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                    return this;
                }
                finishActivation();
            } catch (error) {
                // If our activation throws an exception and the stack hasn't changed,
                // we need to re-enable the prior trap's subtree isolation.
                if (preexistingTrap === $66c441288a5fbbb7$var$activeFocusTraps.getActiveTrap(trapStack) && revertState) {
                    var _preexistingTrap$_set2;
                    // [#1729] method MAY not exist if using `trapStack` option to share stack with older
                    //  versions of Focus-trap in the same DOM so use optional chaining here just in case
                    //  since this is a trap we may not have created from this instance of the library
                    (_preexistingTrap$_set2 = preexistingTrap._setSubtreeIsolation) === null || _preexistingTrap$_set2 === void 0 || _preexistingTrap$_set2.call(preexistingTrap, true);
                }
                throw error;
            }
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = $66c441288a5fbbb7$var$_objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            // Prior to removing this trap from the trapStack, we need to remove any applications of `inert`.
            // This allows the next trap down to update its tabbable nodes properly.
            //
            // If this trap is not top of the stack, don't change any current isolation.
            if (!state.paused) trap._setSubtreeIsolation(false);
            state.alreadySilent.clear();
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            $66c441288a5fbbb7$var$activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, 'onDeactivate');
            var onPostDeactivate = getOption(options, 'onPostDeactivate');
            var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
            var delayReturnFocus = getOption(options, 'delayReturnFocus');
            var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
            onDeactivate === null || onDeactivate === void 0 || onDeactivate({
                trap: trap
            });
            var completeDeactivation = function completeDeactivation() {
                if (returnFocus) _tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate({
                    trap: trap
                });
            };
            var finishDeactivation = function finishDeactivation() {
                if (delayReturnFocus && returnFocus) $66c441288a5fbbb7$var$delay(completeDeactivation);
                else completeDeactivation();
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (!state.active) return this;
            state.manuallyPaused = true;
            return this._setPausedState(true, pauseOptions);
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.active) return this;
            state.manuallyPaused = false;
            if (trapStack[trapStack.length - 1] !== this) return this;
            return this._setPausedState(false, unpauseOptions);
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === 'string' ? doc.querySelector(element) : element;
            });
            if (config.isolateSubtrees) collectAdjacentElements(state.containers);
            if (state.active) {
                updateTabbableNodes();
                if (!state.paused) trap._setSubtreeIsolation(true);
            }
            updateObservedNodes();
            return this;
        }
    };
    Object.defineProperties(trap, {
        _isManuallyPaused: {
            value: function value() {
                return state.manuallyPaused;
            }
        },
        _setPausedState: {
            value: function value(paused, options) {
                if (state.paused === paused) return this;
                state.paused = paused;
                if (paused) {
                    var onPause = getOption(options, 'onPause');
                    var onPostPause = getOption(options, 'onPostPause');
                    onPause === null || onPause === void 0 || onPause({
                        trap: trap
                    });
                    removeListeners();
                    trap._setSubtreeIsolation(false);
                    updateObservedNodes();
                    onPostPause === null || onPostPause === void 0 || onPostPause({
                        trap: trap
                    });
                } else {
                    var onUnpause = getOption(options, 'onUnpause');
                    var onPostUnpause = getOption(options, 'onPostUnpause');
                    onUnpause === null || onUnpause === void 0 || onUnpause({
                        trap: trap
                    });
                    var finishUnpause = function finishUnpause() {
                        updateTabbableNodes();
                        var afterListeners = function afterListeners() {
                            trap._setSubtreeIsolation(true);
                            updateObservedNodes();
                            onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause({
                                trap: trap
                            });
                        };
                        // NOTE: wait for initial focus node to get focused (whether activation is fully,
                        //  partially, or not asynchronous) before we potentially isolate the subtrees
                        //  with aria-hidden while focus is still in some other subtree and not yet in
                        //  the trap, resulting in some browsers (e.g. Chrome) logging to the console that
                        //  they, "Blocked aria-hidden on an element because its descendant retained focus..."
                        var listenersPromise = addListeners();
                        if (listenersPromise) listenersPromise.then(afterListeners);
                        else afterListeners();
                    };
                    finishUnpause();
                }
                return this;
            }
        },
        _setSubtreeIsolation: {
            value: function value(isEnabled) {
                if (config.isolateSubtrees) state.adjacentElements.forEach(function(el) {
                    var _el$getAttribute;
                    if (isEnabled) switch(config.isolateSubtrees){
                        case 'aria-hidden':
                            // check both attribute and property to ensure initial state is captured
                            // correctly across different browsers and test environments (like JSDOM)
                            if (el.ariaHidden === 'true' || ((_el$getAttribute = el.getAttribute('aria-hidden')) === null || _el$getAttribute === void 0 ? void 0 : _el$getAttribute.toLowerCase()) === 'true') state.alreadySilent.add(el);
                            el.setAttribute('aria-hidden', 'true');
                            break;
                        default:
                            // check both attribute and property to ensure initial state is captured
                            // correctly across different browsers and test environments (like JSDOM)
                            if (el.inert || el.hasAttribute('inert')) state.alreadySilent.add(el);
                            el.setAttribute('inert', true);
                            break;
                    }
                    else {
                        if (state.alreadySilent.has(el)) ;
                        else switch(config.isolateSubtrees){
                            case 'aria-hidden':
                                el.removeAttribute('aria-hidden');
                                break;
                            default:
                                el.removeAttribute('inert');
                                break;
                        }
                    }
                });
            }
        }
    });
    // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};





var $5NSbj = parcelRequire("5NSbj");

function $fa4deecc6161d7ee$export$3b062b02b4537682() {
    return (0, $d30756b433a819bb$export$96b5b894afc1d2e3)((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).loggedin);
}
function $fa4deecc6161d7ee$export$f5bdb3b3cec7f803() {
    const loggedIn = $fa4deecc6161d7ee$export$3b062b02b4537682();
    return (0, $5NSbj.useMemo)(()=>(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isAllowedToRead(), [
        loggedIn
    ]);
}
function $fa4deecc6161d7ee$export$683005ba76038aff() {
    const loggedIn = $fa4deecc6161d7ee$export$3b062b02b4537682();
    return (0, $5NSbj.useMemo)(()=>(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isAllowedToUpdate(), [
        loggedIn
    ]);
}
function $fa4deecc6161d7ee$export$b416b77cd328c02f() {
    const loggedIn = $fa4deecc6161d7ee$export$3b062b02b4537682();
    return (0, $5NSbj.useMemo)(()=>(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isAllowedToWrite(), [
        loggedIn
    ]);
}





var $0b4b5bcd4750d386$export$cacd6541cfeeb6c1 = /*#__PURE__*/ function(Direction) {
    Direction["PREV"] = "prev";
    Direction["NEXT"] = "next";
    return Direction;
}({});
function $0b4b5bcd4750d386$export$d976747ecb966cea(target) {
    const viewportHeight = document.body.clientHeight;
    const viewportScrollTop = window.scrollY;
    const targetBb = target.getBoundingClientRect();
    const targetTop = window.scrollY + targetBb.top;
    const targetHeight = targetBb.height;
    // scroll down
    if (viewportScrollTop + viewportHeight < targetTop + targetHeight + 80) {
        if (targetHeight > viewportHeight) window.scrollTo({
            top: targetTop
        });
        else {
            const marginTop = (viewportHeight - targetHeight) / 2;
            const scrollTop = targetTop - marginTop;
            window.scrollTo({
                top: scrollTop
            });
        }
    }
    // scroll up
    if (targetTop <= viewportScrollTop) window.scrollTo({
        top: targetTop
    });
}





var $5NSbj = parcelRequire("5NSbj");

var $1766ce9febb68b06$exports = {};
var $b3f095897a2a15c4$exports = {};
function $b3f095897a2a15c4$var$_arrayReduce(reducer, acc, list) {
    var index = 0;
    var length = list.length;
    while(index < length){
        acc = reducer(acc, list[index]);
        index += 1;
    }
    return acc;
}
$b3f095897a2a15c4$exports = $b3f095897a2a15c4$var$_arrayReduce;



var $73c64daa93a8819d$exports = {};

var $86add80f0c251f70$exports = {};
function $86add80f0c251f70$var$_isTransformer(obj) {
    return obj != null && typeof obj['@@transducer/step'] === 'function';
}
$86add80f0c251f70$exports = $86add80f0c251f70$var$_isTransformer;


/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer created by [transducerCreator] to return a new transformer
 * (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} transducerCreator transducer factory if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */ function $73c64daa93a8819d$var$_dispatchable(methodNames, transducerCreator, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var obj = arguments[arguments.length - 1];
        if (!$ba1de13db1e87172$exports(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === 'function') return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
                idx += 1;
            }
            if ($86add80f0c251f70$exports(obj)) {
                var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}
$73c64daa93a8819d$exports = $73c64daa93a8819d$var$_dispatchable;


var $199a9bffa9acc914$exports = {};
function $199a9bffa9acc914$var$_map(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}
$199a9bffa9acc914$exports = $199a9bffa9acc914$var$_map;


var $bcb7553705419549$exports = {};
var $3862c4e8edd52321$exports = {};
$3862c4e8edd52321$exports = {
    init: function() {
        return this.xf['@@transducer/init']();
    },
    result: function(result) {
        return this.xf['@@transducer/result'](result);
    }
};


var $bcb7553705419549$var$XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype['@@transducer/init'] = $3862c4e8edd52321$exports.init;
    XMap.prototype['@@transducer/result'] = $3862c4e8edd52321$exports.result;
    XMap.prototype['@@transducer/step'] = function(result, input) {
        return this.xf['@@transducer/step'](result, this.f(input));
    };
    return XMap;
}();
var $bcb7553705419549$var$_xmap = function _xmap(f) {
    return function(xf) {
        return new $bcb7553705419549$var$XMap(f, xf);
    };
};
$bcb7553705419549$exports = $bcb7553705419549$var$_xmap;


var $3740a839312e525e$exports = {};



var $f188947f79ac2c90$exports = {};


/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $f188947f79ac2c90$var$_curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        var hasPlaceholder = false;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!$fd1d129950ecf19e$exports(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!$fd1d129950ecf19e$exports(result)) left -= 1;
            else hasPlaceholder = true;
            combinedIdx += 1;
        }
        return !hasPlaceholder && left <= 0 ? fn.apply(this, combined) : $e54479dfc8e6276d$exports(Math.max(0, left), $f188947f79ac2c90$var$_curryN(length, combined, fn));
    };
}
$f188947f79ac2c90$exports = $f188947f79ac2c90$var$_curryN;


/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $3740a839312e525e$var$curryN = /*#__PURE__*/ $11b3c3fd62c22b91$exports(function curryN(length, fn) {
    if (length === 1) return $7930f30efbe644a1$exports(fn);
    return $e54479dfc8e6276d$exports(length, $f188947f79ac2c90$exports(length, [], fn));
});
$3740a839312e525e$exports = $3740a839312e525e$var$curryN;


var $f69bceee8d75a960$exports = {};


var $dace07fd8f8db19f$exports = {};

var $dace07fd8f8db19f$var$toString = Object.prototype.toString;
var $dace07fd8f8db19f$var$_isArguments = /*#__PURE__*/ function() {
    return $dace07fd8f8db19f$var$toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
        return $dace07fd8f8db19f$var$toString.call(x) === '[object Arguments]';
    } : function _isArguments(x) {
        return $b67b11238be38685$exports('callee', x);
    };
}();
$dace07fd8f8db19f$exports = $dace07fd8f8db19f$var$_isArguments;


var $f69bceee8d75a960$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable('toString');
var $f69bceee8d75a960$var$nonEnumerableProps = [
    'constructor',
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
];
// Safari bug
var $f69bceee8d75a960$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    'use strict';
    return arguments.propertyIsEnumerable('length');
}();
var $f69bceee8d75a960$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $f69bceee8d75a960$var$keys = typeof Object.keys === 'function' && !$f69bceee8d75a960$var$hasArgsEnumBug ? /*#__PURE__*/ $7930f30efbe644a1$exports(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ $7930f30efbe644a1$exports(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $f69bceee8d75a960$var$hasArgsEnumBug && $dace07fd8f8db19f$exports(obj);
    for(prop in obj)if ($b67b11238be38685$exports(prop, obj) && (!checkArgsLength || prop !== 'length')) ks[ks.length] = prop;
    if ($f69bceee8d75a960$var$hasEnumBug) {
        nIdx = $f69bceee8d75a960$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $f69bceee8d75a960$var$nonEnumerableProps[nIdx];
            if ($b67b11238be38685$exports(prop, obj) && !$f69bceee8d75a960$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
$f69bceee8d75a960$exports = $f69bceee8d75a960$var$keys;


/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex, R.pluck, R.project
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var $1766ce9febb68b06$var$map = /*#__PURE__*/ $11b3c3fd62c22b91$exports(/*#__PURE__*/ $73c64daa93a8819d$exports([
    'fantasy-land/map',
    'map'
], $bcb7553705419549$exports, function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case '[object Function]':
            return $3740a839312e525e$exports(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case '[object Object]':
            return $b3f095897a2a15c4$exports(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, $f69bceee8d75a960$exports(functor));
        default:
            return $199a9bffa9acc914$exports(fn, functor);
    }
}));
$1766ce9febb68b06$exports = $1766ce9febb68b06$var$map;




function $347fb6369c29cad3$var$materializeSharerIcon(sharer) {
    const { icon: icon } = sharer;
    return {
        ...sharer,
        // We want to allow people to use <svg> or <img> in user.js
        icon: typeof icon === 'string' && icon.includes('<') ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: icon
            }
        }) : icon
    };
}
function $347fb6369c29cad3$export$aebedbd51beb48eb(args) {
    const { configuration: configuration, showError: showError, _: _ } = args;
    return (0, $5NSbj.useMemo)(()=>{
        const availableSharers = {
            a: {
                label: _('share_native_label'),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $1788f2b1ea8f3501$exports.faShareAlt
                }),
                action: ({ url: url, title: title })=>{
                    navigator.share({
                        title: title,
                        url: url
                    }).catch((e)=>{
                        if (e.name === 'AbortError') showError(_('error_share_native_abort'));
                        else showError(_('error_share_native'));
                    });
                },
                available: 'share' in navigator
            },
            d: {
                label: _('share_diaspora_label'),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $3af4382a42f8c157$exports.faDiaspora
                }),
                action: ({ url: url, title: title })=>{
                    window.open('https://share.diasporafoundation.org/?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title), undefined, 'noreferrer');
                }
            },
            t: {
                label: _('share_twitter_label'),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $d7e8063e124a7dab$exports.faTwitter
                }),
                action: ({ url: url, title: title })=>{
                    window.open('https://twitter.com/intent/tweet?source=webclient&text=' + encodeURIComponent(title) + ' ' + encodeURIComponent(url), undefined, 'noreferrer');
                }
            },
            f: {
                label: _('share_facebook_label'),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $164536c7567608d5$exports.faFacebookSquare
                }),
                action: ({ url: url, title: title })=>{
                    window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url) + '&t=' + encodeURIComponent(title), undefined, 'noreferrer');
                }
            },
            m: {
                label: _('share_mastodon_label'),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $e15eeddf947b426f$exports.faMastodon
                }),
                action: ({ url: url, title: title })=>{
                    window.open(configuration.mastodon + '/share?text=' + encodeURIComponent('"' + title + '"\n' + url), undefined, 'noreferrer');
                },
                available: configuration.mastodon !== null
            },
            p: {
                label: _('share_pocket_label'),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $d7a77b6f799d2f63$exports.faGetPocket
                }),
                action: ({ url: url, title: title })=>{
                    window.open('https://getpocket.com/save?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title), undefined, 'noreferrer');
                }
            },
            w: {
                label: _('share_wallabag_label'),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $850e10ea38777a82$export$a67558cb68d63c7e
                }),
                action: ({ url: url })=>{
                    if (configuration.wallabag.version === 2) window.open(configuration.wallabag.url + '/bookmarklet?url=' + encodeURIComponent(url), undefined, 'noreferrer');
                    else window.open(configuration.wallabag.url + '/?action=add&url=' + btoa(url), undefined, 'noreferrer');
                },
                available: configuration.wallabag !== null
            },
            s: {
                label: _('share_wordpress_label'),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $ee1da5f4ecb633d4$exports.faWordpressSimple
                }),
                action: ({ url: url, title: title })=>{
                    window.open(configuration.wordpress + '/wp-admin/press-this.php?u=' + encodeURIComponent(url) + '&t=' + encodeURIComponent(title), undefined, 'noreferrer');
                },
                available: configuration.wordpress !== null
            },
            e: {
                label: _('share_mail_label'),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $9ba76af6c08a1d33$exports.faEnvelope
                }),
                action: ({ url: url, title: title })=>{
                    document.location.href = 'mailto:?body=' + encodeURIComponent(url) + '&subject=' + encodeURIComponent(title);
                }
            },
            c: {
                label: _('share_copy_label'),
                icon: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $9e163d018ad3ce2a$exports.faCopy
                }),
                action: ({ url: url })=>{
                    navigator.clipboard.writeText(url).then(()=>{
                        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.showMessage(_('info_url_copied'));
                    });
                }
            },
            ...(0, (/*@__PURE__*/$parcel$interopDefault($1766ce9febb68b06$exports)))($347fb6369c29cad3$var$materializeSharerIcon, (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).customSharers ?? {})
        };
        const enabledSharers = [];
        for (const letter of configuration.share){
            const sharer = availableSharers[letter];
            if (sharer !== undefined && (sharer.available ?? true)) {
                const { label: label, icon: icon, action: action } = sharer;
                enabledSharers.push({
                    key: letter,
                    label: label,
                    icon: icon,
                    action: action
                });
            }
        }
        return enabledSharers;
    }, [
        configuration,
        showError,
        _
    ]);
}



var $5NSbj = parcelRequire("5NSbj");
const $f848676e0d96e999$export$83fe3bee12eb51bb = "carousel";
const $f848676e0d96e999$export$b861c6f4d58b4c2f = "controller";
const $f848676e0d96e999$export$607ce719f0ec9b98 = "navigation";
const $f848676e0d96e999$export$52cbc29cf5406ba8 = "no-scroll";
const $f848676e0d96e999$export$9d2e4856063e1a22 = "portal";
const $f848676e0d96e999$export$62f3c66ae8dab8a3 = "root";
const $f848676e0d96e999$export$5414719b40b8294f = "toolbar";
const $f848676e0d96e999$export$a23b14c1465897d = "captions";
const $f848676e0d96e999$export$8ae0dbe553798d04 = "counter";
const $f848676e0d96e999$export$ace9d67c0f2290af = "download";
const $f848676e0d96e999$export$4792108761b262a9 = "fullscreen";
const $f848676e0d96e999$export$c21ea5a712f18fb6 = "inline";
const $f848676e0d96e999$export$6bbdc870e6ef9c88 = "share";
const $f848676e0d96e999$export$be7dc72e63e6ef2e = "slideshow";
const $f848676e0d96e999$export$6bf9d56640f46f01 = "thumbnails";
const $f848676e0d96e999$export$929980e2a2c57ecf = "zoom";
const $f848676e0d96e999$export$554a1415841c52a8 = "loading";
const $f848676e0d96e999$export$38ce62e512432ebb = "playing";
const $f848676e0d96e999$export$2ed3c80dbc178d91 = "error";
const $f848676e0d96e999$export$a195e517d37aaa33 = "complete";
const $f848676e0d96e999$export$e51f1c6d74b54a13 = "placeholder";
const $f848676e0d96e999$export$6751782e799f6445 = (status)=>`active-slide-${status}`;
const $f848676e0d96e999$export$7ab73e7383503259 = $f848676e0d96e999$export$6751782e799f6445($f848676e0d96e999$export$554a1415841c52a8);
const $f848676e0d96e999$export$ccb5eb0b2db52ae8 = $f848676e0d96e999$export$6751782e799f6445($f848676e0d96e999$export$38ce62e512432ebb);
const $f848676e0d96e999$export$817be438d1d0e4cf = $f848676e0d96e999$export$6751782e799f6445($f848676e0d96e999$export$2ed3c80dbc178d91);
const $f848676e0d96e999$export$2ec1d32caeb97dfe = $f848676e0d96e999$export$6751782e799f6445($f848676e0d96e999$export$a195e517d37aaa33);
const $f848676e0d96e999$export$37b171d829eeeaa2 = "fullsize";
const $f848676e0d96e999$export$974a68ef150451f5 = "flex_center";
const $f848676e0d96e999$export$b6426a00c33a0175 = "no_scroll";
const $f848676e0d96e999$export$651541414233b476 = "no_scroll_padding";
const $f848676e0d96e999$export$8d922915837a38d3 = "slide";
const $f848676e0d96e999$export$ac396c284080b10c = "slide_wrapper";
const $f848676e0d96e999$export$bb41c4fe76dce9db = "slide_wrapper_interactive";
const $f848676e0d96e999$export$a007161537026955 = "prev";
const $f848676e0d96e999$export$f1d7a854db833ed4 = "next";
const $f848676e0d96e999$export$c43bd1a4101c4078 = "swipe";
const $f848676e0d96e999$export$493a596486210a21 = "close";
const $f848676e0d96e999$export$e15fc153f45a963d = "onPointerDown";
const $f848676e0d96e999$export$1f8863949fbdd7e5 = "onPointerMove";
const $f848676e0d96e999$export$2d868b67a5791b8a = "onPointerUp";
const $f848676e0d96e999$export$526cafa85592f1a5 = "onPointerLeave";
const $f848676e0d96e999$export$22151cee048c4be9 = "onPointerCancel";
const $f848676e0d96e999$export$1aba4f3521686ca9 = "onKeyDown";
const $f848676e0d96e999$export$bdb9f99d61a6879b = "onKeyUp";
const $f848676e0d96e999$export$5635dc9d647242c7 = "onWheel";
const $f848676e0d96e999$export$e8d60d9b5ceff7c0 = "Escape";
const $f848676e0d96e999$export$17dec1da9b0e2eb3 = "ArrowLeft";
const $f848676e0d96e999$export$91898c0e7e48903 = "ArrowRight";
const $f848676e0d96e999$export$d62fb7722b07f2f3 = "button";
const $f848676e0d96e999$export$c5f5ca1963fed141 = "icon";
const $f848676e0d96e999$export$eff7fe5eefd707ad = "contain";
const $f848676e0d96e999$export$9a9f12fc3f1c1e4f = "cover";
const $f848676e0d96e999$export$b149fc25cb186fec = "Unknown action type";



var $21jDP = parcelRequire("21jDP");
"use client";
const $ce68a3edc3fc357d$var$cssPrefix$3 = "yarl__";
function $ce68a3edc3fc357d$export$4f5d2d50c9deca37(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $ce68a3edc3fc357d$export$1283875077dc8f0a(name) {
    return `${$ce68a3edc3fc357d$var$cssPrefix$3}${name}`;
}
function $ce68a3edc3fc357d$export$8b4981022bd80a4e(name) {
    return `--${$ce68a3edc3fc357d$var$cssPrefix$3}${name}`;
}
function $ce68a3edc3fc357d$export$195c4126907dde97(base, prefix) {
    return `${base}${prefix ? `_${prefix}` : ""}`;
}
function $ce68a3edc3fc357d$export$3e7cd27eed1727c(base) {
    return (prefix)=>$ce68a3edc3fc357d$export$195c4126907dde97(base, prefix);
}
function $ce68a3edc3fc357d$export$1c4d965eb6f65dfa(labels, defaultLabel) {
    var _a;
    return (_a = labels === null || labels === void 0 ? void 0 : labels[defaultLabel]) !== null && _a !== void 0 ? _a : defaultLabel;
}
function $ce68a3edc3fc357d$export$1237798dc640739a(labels, defaultLabel) {
    return $ce68a3edc3fc357d$export$1c4d965eb6f65dfa(labels, defaultLabel);
}
function $ce68a3edc3fc357d$export$77152303d9076b8(labels, slides, index) {
    return $ce68a3edc3fc357d$export$1c4d965eb6f65dfa(labels, "{index} of {total}").replace(/\{index}/g, `${$ce68a3edc3fc357d$export$501611100333094a(index, slides.length) + 1}`).replace(/\{total}/g, `${slides.length}`);
}
function $ce68a3edc3fc357d$export$de863c629cb9919d(...cleaners) {
    return ()=>{
        cleaners.forEach((cleaner)=>{
            cleaner();
        });
    };
}
function $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0(name, contextName, context) {
    return ()=>{
        const ctx = $5NSbj.useContext(context);
        if (!ctx) throw new Error(`${name} must be used within a ${contextName}.Provider`);
        return ctx;
    };
}
function $ce68a3edc3fc357d$export$fef62134eea24008() {
    return typeof window !== "undefined";
}
function $ce68a3edc3fc357d$export$2077e0241d6afd3c(value, decimals = 0) {
    const factor = 10 ** decimals;
    return Math.round((value + Number.EPSILON) * factor) / factor;
}
function $ce68a3edc3fc357d$export$55ec18c411514c07(slide) {
    return slide.type === undefined || slide.type === "image";
}
function $ce68a3edc3fc357d$export$f5ba2f5b3fd12e6e(image, imageFit) {
    return image.imageFit === (0, $f848676e0d96e999$export$9a9f12fc3f1c1e4f) || image.imageFit !== (0, $f848676e0d96e999$export$eff7fe5eefd707ad) && imageFit === (0, $f848676e0d96e999$export$9a9f12fc3f1c1e4f);
}
function $ce68a3edc3fc357d$export$5f87784a266e50a4(value) {
    return typeof value === "string" ? Number.parseInt(value, 10) : value;
}
function $ce68a3edc3fc357d$export$7871fb532d320d99(input) {
    if (typeof input === "number") return {
        pixel: input
    };
    if (typeof input === "string") {
        const value = $ce68a3edc3fc357d$export$5f87784a266e50a4(input);
        return input.endsWith("%") ? {
            percent: value
        } : {
            pixel: value
        };
    }
    return {
        pixel: 0
    };
}
function $ce68a3edc3fc357d$export$7ff571008bce9900(containerRect, padding) {
    const paddingValue = $ce68a3edc3fc357d$export$7871fb532d320d99(padding);
    const paddingPixels = paddingValue.percent !== undefined ? containerRect.width / 100 * paddingValue.percent : paddingValue.pixel;
    return {
        width: Math.max(containerRect.width - 2 * paddingPixels, 0),
        height: Math.max(containerRect.height - 2 * paddingPixels, 0)
    };
}
function $ce68a3edc3fc357d$export$508f096bfcdaac40() {
    return ($ce68a3edc3fc357d$export$fef62134eea24008() ? window === null || window === void 0 ? void 0 : window.devicePixelRatio : undefined) || 1;
}
function $ce68a3edc3fc357d$export$501611100333094a(index, slidesCount) {
    return slidesCount > 0 ? (index % slidesCount + slidesCount) % slidesCount : 0;
}
function $ce68a3edc3fc357d$export$883ece934910f98d(slides) {
    return slides.length > 0;
}
function $ce68a3edc3fc357d$export$cdfb855c5eb3bc84(slides, index) {
    return slides[$ce68a3edc3fc357d$export$501611100333094a(index, slides.length)];
}
function $ce68a3edc3fc357d$export$9f2f3fed4fdffdfc(slides, index) {
    return $ce68a3edc3fc357d$export$883ece934910f98d(slides) ? $ce68a3edc3fc357d$export$cdfb855c5eb3bc84(slides, index) : undefined;
}
function $ce68a3edc3fc357d$export$b2184449b7659b5a(slide) {
    return $ce68a3edc3fc357d$export$55ec18c411514c07(slide) ? slide.src : undefined;
}
function $ce68a3edc3fc357d$export$34ce6a408311d810(toolbar, key, button) {
    if (!button) return toolbar;
    const { buttons: buttons, ...restToolbar } = toolbar;
    const index = buttons.findIndex((item)=>item === key);
    const buttonWithKey = $5NSbj.isValidElement(button) ? $5NSbj.cloneElement(button, {
        key: key
    }, null) : button;
    if (index >= 0) {
        const result = [
            ...buttons
        ];
        result.splice(index, 1, buttonWithKey);
        return {
            buttons: result,
            ...restToolbar
        };
    }
    return {
        buttons: [
            buttonWithKey,
            ...buttons
        ],
        ...restToolbar
    };
}
function $ce68a3edc3fc357d$export$e88693bab67822d1() {
    const stopPropagation = (event)=>{
        event.stopPropagation();
    };
    return {
        onPointerDown: stopPropagation,
        onKeyDown: stopPropagation,
        onWheel: stopPropagation
    };
}
function $ce68a3edc3fc357d$export$aab7f3145c728301(carousel, slides, minimum = 0) {
    return Math.min(carousel.preload, Math.max(carousel.finite ? slides.length - 1 : Math.floor(slides.length / 2), minimum));
}
const $ce68a3edc3fc357d$var$isReact19 = Number($5NSbj.version.split(".")[0]) >= 19;
function $ce68a3edc3fc357d$export$9c64d01b28c1f747(condition) {
    const legacyValue = condition ? "" : undefined;
    return {
        inert: $ce68a3edc3fc357d$var$isReact19 ? condition : legacyValue
    };
}
function $ce68a3edc3fc357d$export$b7a864e1eaef9de5(node) {
    node.scrollTop;
}
const $ce68a3edc3fc357d$export$d626463445cef3e9 = {
    open: false,
    close: ()=>{},
    index: 0,
    slides: [],
    render: {},
    plugins: [],
    toolbar: {
        buttons: [
            (0, $f848676e0d96e999$export$493a596486210a21)
        ]
    },
    labels: {},
    animation: {
        fade: 250,
        swipe: 500,
        easing: {
            fade: "ease",
            swipe: "ease-out",
            navigation: "ease-in-out"
        }
    },
    carousel: {
        finite: false,
        preload: 2,
        padding: "16px",
        spacing: "30%",
        imageFit: (0, $f848676e0d96e999$export$eff7fe5eefd707ad),
        imageProps: {}
    },
    controller: {
        ref: null,
        focus: true,
        aria: false,
        touchAction: "none",
        closeOnPullUp: false,
        closeOnPullDown: false,
        closeOnBackdropClick: false,
        closeOnEscape: true,
        preventDefaultWheelX: true,
        preventDefaultWheelY: false,
        disableSwipeNavigation: false
    },
    portal: {},
    noScroll: {
        disabled: false
    },
    on: {},
    styles: {},
    className: ""
};
function $ce68a3edc3fc357d$export$c5ba3739ffba980d(name, component) {
    return {
        name: name,
        component: component
    };
}
function $ce68a3edc3fc357d$export$270e7ba5936d3c48(module, children) {
    return {
        module: module,
        children: children
    };
}
function $ce68a3edc3fc357d$var$traverseNode(node, target, apply) {
    if (node.module.name === target) return apply(node);
    if (node.children) return [
        $ce68a3edc3fc357d$export$270e7ba5936d3c48(node.module, node.children.flatMap((n)=>{
            var _a;
            return (_a = $ce68a3edc3fc357d$var$traverseNode(n, target, apply)) !== null && _a !== void 0 ? _a : [];
        }))
    ];
    return [
        node
    ];
}
function $ce68a3edc3fc357d$var$traverse(nodes, target, apply) {
    return nodes.flatMap((node)=>{
        var _a;
        return (_a = $ce68a3edc3fc357d$var$traverseNode(node, target, apply)) !== null && _a !== void 0 ? _a : [];
    });
}
function $ce68a3edc3fc357d$export$bc996c07eb970c78(root, plugins = [], augmentations = []) {
    let config = root;
    const contains = (target)=>{
        const nodes = [
            ...config
        ];
        while(nodes.length > 0){
            const node = nodes.pop();
            if ((node === null || node === void 0 ? void 0 : node.module.name) === target) return true;
            if (node === null || node === void 0 ? void 0 : node.children) nodes.push(...node.children);
        }
        return false;
    };
    const addParent = (target, module)=>{
        if (target === "") {
            config = [
                $ce68a3edc3fc357d$export$270e7ba5936d3c48(module, config)
            ];
            return;
        }
        config = $ce68a3edc3fc357d$var$traverse(config, target, (node)=>[
                $ce68a3edc3fc357d$export$270e7ba5936d3c48(module, [
                    node
                ])
            ]);
    };
    const append = (target, module)=>{
        config = $ce68a3edc3fc357d$var$traverse(config, target, (node)=>[
                $ce68a3edc3fc357d$export$270e7ba5936d3c48(node.module, [
                    $ce68a3edc3fc357d$export$270e7ba5936d3c48(module, node.children)
                ])
            ]);
    };
    const addChild = (target, module, precede)=>{
        config = $ce68a3edc3fc357d$var$traverse(config, target, (node)=>{
            var _a;
            return [
                $ce68a3edc3fc357d$export$270e7ba5936d3c48(node.module, [
                    ...precede ? [
                        $ce68a3edc3fc357d$export$270e7ba5936d3c48(module)
                    ] : [],
                    ...(_a = node.children) !== null && _a !== void 0 ? _a : [],
                    ...!precede ? [
                        $ce68a3edc3fc357d$export$270e7ba5936d3c48(module)
                    ] : []
                ])
            ];
        });
    };
    const addSibling = (target, module, precede)=>{
        config = $ce68a3edc3fc357d$var$traverse(config, target, (node)=>[
                ...precede ? [
                    $ce68a3edc3fc357d$export$270e7ba5936d3c48(module)
                ] : [],
                node,
                ...!precede ? [
                    $ce68a3edc3fc357d$export$270e7ba5936d3c48(module)
                ] : []
            ]);
    };
    const addModule = (module)=>{
        append((0, $f848676e0d96e999$export$b861c6f4d58b4c2f), module);
    };
    const replace = (target, module)=>{
        config = $ce68a3edc3fc357d$var$traverse(config, target, (node)=>[
                $ce68a3edc3fc357d$export$270e7ba5936d3c48(module, node.children)
            ]);
    };
    const remove = (target)=>{
        config = $ce68a3edc3fc357d$var$traverse(config, target, (node)=>node.children);
    };
    const augment = (augmentation)=>{
        augmentations.push(augmentation);
    };
    plugins.forEach((plugin)=>{
        plugin({
            contains: contains,
            addParent: addParent,
            append: append,
            addChild: addChild,
            addSibling: addSibling,
            addModule: addModule,
            replace: replace,
            remove: remove,
            augment: augment
        });
    });
    return {
        config: config,
        augmentation: (props)=>augmentations.reduce((acc, augmentation)=>augmentation(acc), props)
    };
}
const $ce68a3edc3fc357d$export$bec71e4205979323 = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$3992c64d261ded5a = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useA11yContext", "A11yContext", $ce68a3edc3fc357d$export$bec71e4205979323);
function $ce68a3edc3fc357d$export$e41a845d3e53ea09({ children: children }) {
    const [focusWithin, setFocusWithin] = $5NSbj.useState(false);
    const [autoPlaying, setAutoPlaying] = $5NSbj.useState(false);
    const context = $5NSbj.useMemo(()=>{
        const trackFocusWithin = (onFocus, onBlur)=>{
            const trackAndDelegate = (focusWithinValue)=>(event)=>{
                    var _a;
                    if (!event.currentTarget.contains(event.relatedTarget)) setFocusWithin(focusWithinValue);
                    (_a = focusWithinValue ? onFocus : onBlur) === null || _a === void 0 || _a(event);
                };
            return {
                onFocus: trackAndDelegate(true),
                onBlur: trackAndDelegate(false)
            };
        };
        return {
            focusWithin: focusWithin,
            trackFocusWithin: trackFocusWithin,
            autoPlaying: autoPlaying,
            setAutoPlaying: setAutoPlaying
        };
    }, [
        focusWithin,
        autoPlaying
    ]);
    return $5NSbj.createElement($ce68a3edc3fc357d$export$bec71e4205979323.Provider, {
        value: context
    }, children);
}
const $ce68a3edc3fc357d$export$41b6c5189865fe72 = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$c199d36c2862b6ed = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useDocument", "DocumentContext", $ce68a3edc3fc357d$export$41b6c5189865fe72);
function $ce68a3edc3fc357d$export$30e869153d18a2e6({ nodeRef: nodeRef, children: children }) {
    const context = $5NSbj.useMemo(()=>{
        const getOwnerDocument = (node)=>{
            var _a;
            return ((_a = node || nodeRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) || document;
        };
        const getOwnerWindow = (node)=>{
            var _a;
            return ((_a = getOwnerDocument(node)) === null || _a === void 0 ? void 0 : _a.defaultView) || window;
        };
        return {
            getOwnerDocument: getOwnerDocument,
            getOwnerWindow: getOwnerWindow
        };
    }, [
        nodeRef
    ]);
    return $5NSbj.createElement($ce68a3edc3fc357d$export$41b6c5189865fe72.Provider, {
        value: context
    }, children);
}
const $ce68a3edc3fc357d$export$f4208dae105d4d3 = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$91a992459f6e0f07 = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useEvents", "EventsContext", $ce68a3edc3fc357d$export$f4208dae105d4d3);
function $ce68a3edc3fc357d$export$686accdd53ac150f({ children: children }) {
    const [subscriptions] = $5NSbj.useState({});
    $5NSbj.useEffect(()=>()=>{
            Object.keys(subscriptions).forEach((topic)=>delete subscriptions[topic]);
        }, [
        subscriptions
    ]);
    const context = $5NSbj.useMemo(()=>{
        const unsubscribe = (topic, callback)=>{
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 || _a.splice(0, subscriptions[topic].length, ...subscriptions[topic].filter((cb)=>cb !== callback));
        };
        const subscribe = (topic, callback)=>{
            if (!subscriptions[topic]) subscriptions[topic] = [];
            subscriptions[topic].push(callback);
            return ()=>unsubscribe(topic, callback);
        };
        const publish = (...[topic, event])=>{
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 || _a.forEach((callback)=>callback(event));
        };
        return {
            publish: publish,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };
    }, [
        subscriptions
    ]);
    return $5NSbj.createElement($ce68a3edc3fc357d$export$f4208dae105d4d3.Provider, {
        value: context
    }, children);
}
const $ce68a3edc3fc357d$export$9f6b9cbf1d54cc28 = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$d930f3536e1c64f6 = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useLightboxProps", "LightboxPropsContext", $ce68a3edc3fc357d$export$9f6b9cbf1d54cc28);
function $ce68a3edc3fc357d$export$7141a340a3dea601({ children: children, ...props }) {
    return $5NSbj.createElement($ce68a3edc3fc357d$export$9f6b9cbf1d54cc28.Provider, {
        value: props
    }, children);
}
const $ce68a3edc3fc357d$export$c24db94cf7704d3a = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$566121e2bbc52eec = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useLightboxState", "LightboxStateContext", $ce68a3edc3fc357d$export$c24db94cf7704d3a);
const $ce68a3edc3fc357d$export$42eb31c6c0f01c10 = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$9463bb14d6ba055e = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useLightboxDispatch", "LightboxDispatchContext", $ce68a3edc3fc357d$export$42eb31c6c0f01c10);
function $ce68a3edc3fc357d$var$reducer(state, action) {
    switch(action.type){
        case "swipe":
            {
                const { slides: slides } = state;
                const increment = (action === null || action === void 0 ? void 0 : action.increment) || 0;
                const globalIndex = state.globalIndex + increment;
                const currentIndex = $ce68a3edc3fc357d$export$501611100333094a(globalIndex, slides.length);
                const currentSlide = $ce68a3edc3fc357d$export$9f2f3fed4fdffdfc(slides, currentIndex);
                const animation = increment || action.duration !== undefined ? {
                    increment: increment,
                    duration: action.duration,
                    easing: action.easing
                } : undefined;
                return {
                    slides: slides,
                    currentIndex: currentIndex,
                    globalIndex: globalIndex,
                    currentSlide: currentSlide,
                    animation: animation
                };
            }
        case "update":
            if (action.slides !== state.slides || action.index !== state.currentIndex) return {
                slides: action.slides,
                currentIndex: action.index,
                globalIndex: action.index,
                currentSlide: $ce68a3edc3fc357d$export$9f2f3fed4fdffdfc(action.slides, action.index)
            };
            return state;
        default:
            throw new Error((0, $f848676e0d96e999$export$b149fc25cb186fec));
    }
}
function $ce68a3edc3fc357d$export$62d2e1d2e7609988({ slides: slides, index: index, children: children }) {
    const [state, dispatch] = $5NSbj.useReducer($ce68a3edc3fc357d$var$reducer, {
        slides: slides,
        currentIndex: index,
        globalIndex: index,
        currentSlide: $ce68a3edc3fc357d$export$9f2f3fed4fdffdfc(slides, index)
    });
    const [prevSlides, setPrevSlides] = $5NSbj.useState(slides);
    const [prevIndex, setPrevIndex] = $5NSbj.useState(index);
    if (slides !== prevSlides || index !== prevIndex) {
        setPrevSlides(slides);
        setPrevIndex(index);
        dispatch({
            type: "update",
            slides: slides,
            index: index
        });
    }
    const context = $5NSbj.useMemo(()=>({
            ...state,
            state: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return $5NSbj.createElement($ce68a3edc3fc357d$export$42eb31c6c0f01c10.Provider, {
        value: dispatch
    }, $5NSbj.createElement($ce68a3edc3fc357d$export$c24db94cf7704d3a.Provider, {
        value: context
    }, children));
}
const $ce68a3edc3fc357d$export$e96e3cec40decff1 = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$57c05a83b72fe7b = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useRTLContext", "RTLContext", $ce68a3edc3fc357d$export$e96e3cec40decff1);
function $ce68a3edc3fc357d$export$625eb40e2215f320({ isRTL: isRTL, children: children }) {
    const context = $5NSbj.useMemo(()=>({
            isRTL: isRTL
        }), [
        isRTL
    ]);
    return $5NSbj.createElement($ce68a3edc3fc357d$export$e96e3cec40decff1.Provider, {
        value: context
    }, children);
}
const $ce68a3edc3fc357d$export$e338b1178a56544e = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$1bc7162631c81b3f = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useTimeouts", "TimeoutsContext", $ce68a3edc3fc357d$export$e338b1178a56544e);
function $ce68a3edc3fc357d$export$9d9954f5885fa393({ children: children }) {
    const [timeouts] = $5NSbj.useState([]);
    $5NSbj.useEffect(()=>()=>{
            timeouts.forEach((tid)=>window.clearTimeout(tid));
            timeouts.splice(0, timeouts.length);
        }, [
        timeouts
    ]);
    const context = $5NSbj.useMemo(()=>{
        const removeTimeout = (id)=>{
            timeouts.splice(0, timeouts.length, ...timeouts.filter((tid)=>tid !== id));
        };
        const setTimeout = (fn, delay)=>{
            const id = window.setTimeout(()=>{
                removeTimeout(id);
                fn();
            }, delay);
            timeouts.push(id);
            return id;
        };
        const clearTimeout = (id)=>{
            if (id !== undefined) {
                removeTimeout(id);
                window.clearTimeout(id);
            }
        };
        return {
            setTimeout: setTimeout,
            clearTimeout: clearTimeout
        };
    }, [
        timeouts
    ]);
    return $5NSbj.createElement($ce68a3edc3fc357d$export$e338b1178a56544e.Provider, {
        value: context
    }, children);
}
const $ce68a3edc3fc357d$export$c25acd513dcc8062 = $5NSbj.forwardRef(function IconButton({ label: label, className: className, icon: Icon, renderIcon: renderIcon, onClick: onClick, style: style, ...rest }, ref) {
    const { styles: styles, labels: labels } = $ce68a3edc3fc357d$export$d930f3536e1c64f6();
    const buttonLabel = $ce68a3edc3fc357d$export$1c4d965eb6f65dfa(labels, label);
    return $5NSbj.createElement("button", {
        ref: ref,
        type: "button",
        title: buttonLabel,
        "aria-label": buttonLabel,
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$d62fb7722b07f2f3)), className),
        onClick: onClick,
        style: {
            ...style,
            ...styles.button
        },
        ...rest
    }, renderIcon ? renderIcon() : $5NSbj.createElement(Icon, {
        className: $ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$c5f5ca1963fed141)),
        style: styles.icon
    }));
});
function $ce68a3edc3fc357d$var$svgIcon(name, children) {
    const icon = (props)=>$5NSbj.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24",
            "aria-hidden": "true",
            focusable: "false",
            ...props
        }, children);
    icon.displayName = name;
    return icon;
}
function $ce68a3edc3fc357d$export$274edc73af1ae9c8(name, glyph) {
    return $ce68a3edc3fc357d$var$svgIcon(name, $5NSbj.createElement("g", {
        fill: "currentColor"
    }, $5NSbj.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph));
}
function $ce68a3edc3fc357d$export$6b1fd58c1dc933ec(name, glyph) {
    return $ce68a3edc3fc357d$var$svgIcon(name, $5NSbj.createElement($5NSbj.Fragment, null, $5NSbj.createElement("defs", null, $5NSbj.createElement("mask", {
        id: "strike"
    }, $5NSbj.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "white"
    }), $5NSbj.createElement("path", {
        d: "M0 0L24 24",
        stroke: "black",
        strokeWidth: 4
    }))), $5NSbj.createElement("path", {
        d: "M0.70707 2.121320L21.878680 23.292883",
        stroke: "currentColor",
        strokeWidth: 2
    }), $5NSbj.createElement("g", {
        fill: "currentColor",
        mask: "url(#strike)"
    }, $5NSbj.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph)));
}
const $ce68a3edc3fc357d$export$cae179f078f4b4a4 = $ce68a3edc3fc357d$export$274edc73af1ae9c8("Close", $5NSbj.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}));
const $ce68a3edc3fc357d$export$d05925e1c7f3f136 = $ce68a3edc3fc357d$export$274edc73af1ae9c8("Previous", $5NSbj.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}));
const $ce68a3edc3fc357d$export$3da0e0ec94bd4ce1 = $ce68a3edc3fc357d$export$274edc73af1ae9c8("Next", $5NSbj.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}));
const $ce68a3edc3fc357d$export$b936c55164dcf1db = $ce68a3edc3fc357d$export$274edc73af1ae9c8("Loading", $5NSbj.createElement($5NSbj.Fragment, null, Array.from({
    length: 8
}).map((_, index, array)=>$5NSbj.createElement("line", {
        key: index,
        x1: "12",
        y1: "6.5",
        x2: "12",
        y2: "1.8",
        strokeLinecap: "round",
        strokeWidth: "2.6",
        stroke: "currentColor",
        strokeOpacity: 1 / array.length * (index + 1),
        transform: `rotate(${360 / array.length * index}, 12, 12)`
    }))));
const $ce68a3edc3fc357d$export$19bc16ee58e19b3d = $ce68a3edc3fc357d$export$274edc73af1ae9c8("Error", $5NSbj.createElement("path", {
    d: "M21.9,21.9l-8.49-8.49l0,0L3.59,3.59l0,0L2.1,2.1L0.69,3.51L3,5.83V19c0,1.1,0.9,2,2,2h13.17l2.31,2.31L21.9,21.9z M5,18 l3.5-4.5l2.5,3.01L12.17,15l3,3H5z M21,18.17L5.83,3H19c1.1,0,2,0.9,2,2V18.17z"
}));
const $ce68a3edc3fc357d$export$e5c5a5f917a5871c = $ce68a3edc3fc357d$export$fef62134eea24008() ? $5NSbj.useLayoutEffect : $5NSbj.useEffect;
function $ce68a3edc3fc357d$export$f3e625e1b2b31d60() {
    const [reduceMotion, setReduceMotion] = $5NSbj.useState(false);
    $5NSbj.useEffect(()=>{
        var _a, _b;
        const mediaQuery = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)");
        setReduceMotion(mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches);
        const listener = (event)=>setReduceMotion(event.matches);
        (_b = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener) === null || _b === void 0 || _b.call(mediaQuery, "change", listener);
        return ()=>{
            var _a;
            return (_a = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(mediaQuery, "change", listener);
        };
    }, []);
    return reduceMotion;
}
function $ce68a3edc3fc357d$var$currentTransformation(node) {
    let x = 0;
    let y = 0;
    let z = 0;
    const matrix = window.getComputedStyle(node).transform;
    const matcher = matrix.match(/matrix.*\((.+)\)/);
    if (matcher) {
        const values = matcher[1].split(",").map($ce68a3edc3fc357d$export$5f87784a266e50a4);
        if (values.length === 6) {
            x = values[4];
            y = values[5];
        } else if (values.length === 16) {
            x = values[12];
            y = values[13];
            z = values[14];
        }
    }
    return {
        x: x,
        y: y,
        z: z
    };
}
function $ce68a3edc3fc357d$export$9e2608686d4ad846(nodeRef, computeAnimation) {
    const snapshot = $5NSbj.useRef(undefined);
    const animation = $5NSbj.useRef(undefined);
    const reduceMotion = $ce68a3edc3fc357d$export$f3e625e1b2b31d60();
    $ce68a3edc3fc357d$export$e5c5a5f917a5871c(()=>{
        var _a, _b, _c;
        if (nodeRef.current && snapshot.current !== undefined && !reduceMotion) {
            const { keyframes: keyframes, duration: duration, easing: easing, onfinish: onfinish } = computeAnimation(snapshot.current, nodeRef.current.getBoundingClientRect(), $ce68a3edc3fc357d$var$currentTransformation(nodeRef.current)) || {};
            if (keyframes && duration) {
                (_a = animation.current) === null || _a === void 0 || _a.cancel();
                animation.current = undefined;
                try {
                    animation.current = (_c = (_b = nodeRef.current).animate) === null || _c === void 0 ? void 0 : _c.call(_b, keyframes, {
                        duration: duration,
                        easing: easing
                    });
                } catch (err) {
                    console.error(err);
                }
                if (animation.current) animation.current.onfinish = ()=>{
                    animation.current = undefined;
                    onfinish === null || onfinish === void 0 || onfinish();
                };
            }
        }
        snapshot.current = undefined;
    });
    return {
        prepareAnimation: (currentSnapshot)=>{
            snapshot.current = currentSnapshot;
        },
        isAnimationPlaying: ()=>{
            var _a;
            return ((_a = animation.current) === null || _a === void 0 ? void 0 : _a.playState) === "running";
        }
    };
}
function $ce68a3edc3fc357d$export$b1d85de58d38d09d() {
    const containerRef = $5NSbj.useRef(null);
    const observerRef = $5NSbj.useRef(undefined);
    const [containerRect, setContainerRect] = $5NSbj.useState();
    const setContainerRef = $5NSbj.useCallback((node)=>{
        containerRef.current = node;
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = undefined;
        }
        const updateContainerRect = ()=>{
            if (node) {
                const styles = window.getComputedStyle(node);
                const parse = (value)=>parseFloat(value) || 0;
                setContainerRect({
                    width: Math.round(node.clientWidth - parse(styles.paddingLeft) - parse(styles.paddingRight)),
                    height: Math.round(node.clientHeight - parse(styles.paddingTop) - parse(styles.paddingBottom))
                });
            } else setContainerRect(undefined);
        };
        updateContainerRect();
        if (node && typeof ResizeObserver !== "undefined") {
            observerRef.current = new ResizeObserver(updateContainerRect);
            observerRef.current.observe(node);
        }
    }, []);
    return {
        setContainerRef: setContainerRef,
        containerRef: containerRef,
        containerRect: containerRect
    };
}
function $ce68a3edc3fc357d$export$69f38700ea0cb3b9() {
    const timeoutId = $5NSbj.useRef(undefined);
    const { setTimeout: setTimeout, clearTimeout: clearTimeout } = $ce68a3edc3fc357d$export$1bc7162631c81b3f();
    return $5NSbj.useCallback((callback, delay)=>{
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay > 0 ? delay : 0);
    }, [
        setTimeout,
        clearTimeout
    ]);
}
function $ce68a3edc3fc357d$export$ee5b5d04074a389e(fn) {
    const ref = $5NSbj.useRef(fn);
    $ce68a3edc3fc357d$export$e5c5a5f917a5871c(()=>{
        ref.current = fn;
    });
    return $5NSbj.useCallback((...args)=>{
        var _a;
        return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call(ref, ...args);
    }, []);
}
function $ce68a3edc3fc357d$export$4bb192c7cacf928f(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $ce68a3edc3fc357d$export$ebc1e1560c2dffa5(refA, refB) {
    return $5NSbj.useMemo(()=>refA == null && refB == null ? null : (refValue)=>{
            $ce68a3edc3fc357d$export$4bb192c7cacf928f(refA, refValue);
            $ce68a3edc3fc357d$export$4bb192c7cacf928f(refB, refValue);
        }, [
        refA,
        refB
    ]);
}
function $ce68a3edc3fc357d$export$2bd1c19440b9235c(focus, disabled = false) {
    const focused = $5NSbj.useRef(false);
    $ce68a3edc3fc357d$export$e5c5a5f917a5871c(()=>{
        if (disabled && focused.current) {
            focused.current = false;
            focus();
        }
    }, [
        disabled,
        focus
    ]);
    const onFocus = $5NSbj.useCallback(()=>{
        focused.current = true;
    }, []);
    const onBlur = $5NSbj.useCallback(()=>{
        focused.current = false;
    }, []);
    return {
        onFocus: onFocus,
        onBlur: onBlur
    };
}
function $ce68a3edc3fc357d$export$81f015b3ec5d61cf() {
    return $ce68a3edc3fc357d$export$57c05a83b72fe7b().isRTL;
}
function $ce68a3edc3fc357d$export$19012f58216d597f() {
    const [subscribers] = $5NSbj.useState({});
    const notifySubscribers = $5NSbj.useCallback((type, event)=>{
        var _a;
        (_a = subscribers[type]) === null || _a === void 0 || _a.forEach((listener)=>{
            if (!event.isPropagationStopped()) listener(event);
        });
    }, [
        subscribers
    ]);
    const registerSensors = $5NSbj.useMemo(()=>({
            onPointerDown: (event)=>notifySubscribers((0, $f848676e0d96e999$export$e15fc153f45a963d), event),
            onPointerMove: (event)=>notifySubscribers((0, $f848676e0d96e999$export$1f8863949fbdd7e5), event),
            onPointerUp: (event)=>notifySubscribers((0, $f848676e0d96e999$export$2d868b67a5791b8a), event),
            onPointerLeave: (event)=>notifySubscribers((0, $f848676e0d96e999$export$526cafa85592f1a5), event),
            onPointerCancel: (event)=>notifySubscribers((0, $f848676e0d96e999$export$22151cee048c4be9), event),
            onKeyDown: (event)=>notifySubscribers((0, $f848676e0d96e999$export$1aba4f3521686ca9), event),
            onKeyUp: (event)=>notifySubscribers((0, $f848676e0d96e999$export$bdb9f99d61a6879b), event),
            onWheel: (event)=>notifySubscribers((0, $f848676e0d96e999$export$5635dc9d647242c7), event)
        }), [
        notifySubscribers
    ]);
    const subscribeSensors = $5NSbj.useCallback((type, callback)=>{
        if (!subscribers[type]) subscribers[type] = [];
        subscribers[type].unshift(callback);
        return ()=>{
            const listeners = subscribers[type];
            if (listeners) listeners.splice(0, listeners.length, ...listeners.filter((el)=>el !== callback));
        };
    }, [
        subscribers
    ]);
    return {
        registerSensors: registerSensors,
        subscribeSensors: subscribeSensors
    };
}
function $ce68a3edc3fc357d$export$8b7b9481d6186f21(callback, delay) {
    const lastCallbackTime = $5NSbj.useRef(0);
    const delayCallback = $ce68a3edc3fc357d$export$69f38700ea0cb3b9();
    const executeCallback = $ce68a3edc3fc357d$export$ee5b5d04074a389e((...args)=>{
        lastCallbackTime.current = Date.now();
        callback(...args);
    });
    return $5NSbj.useCallback((...args)=>{
        delayCallback(()=>{
            executeCallback(...args);
        }, delay - (Date.now() - lastCallbackTime.current));
    }, [
        delay,
        executeCallback,
        delayCallback
    ]);
}
const $ce68a3edc3fc357d$var$slidePrefix = $ce68a3edc3fc357d$export$3e7cd27eed1727c("slide");
const $ce68a3edc3fc357d$var$slideImagePrefix = $ce68a3edc3fc357d$export$3e7cd27eed1727c("slide_image");
function $ce68a3edc3fc357d$export$ef86b1d52c77b27b({ slide: image, offset: offset, render: render, rect: rect, imageFit: imageFit, imageProps: imageProps, onClick: onClick, onLoad: onLoad, onError: onError, style: style }) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const [status, setStatus] = $5NSbj.useState((0, $f848676e0d96e999$export$554a1415841c52a8));
    const { publish: publish } = $ce68a3edc3fc357d$export$91a992459f6e0f07();
    const { setTimeout: setTimeout } = $ce68a3edc3fc357d$export$1bc7162631c81b3f();
    const imageRef = $5NSbj.useRef(null);
    $5NSbj.useEffect(()=>{
        if (offset === 0) publish((0, $f848676e0d96e999$export$6751782e799f6445)(status));
    }, [
        offset,
        status,
        publish
    ]);
    const handleLoading = $ce68a3edc3fc357d$export$ee5b5d04074a389e((img)=>{
        ("decode" in img ? img.decode() : Promise.resolve()).catch(()=>{}).then(()=>{
            if (!img.parentNode) return;
            setStatus((0, $f848676e0d96e999$export$a195e517d37aaa33));
            setTimeout(()=>{
                onLoad === null || onLoad === void 0 || onLoad(img);
            }, 0);
        });
    });
    const setImageRef = $5NSbj.useCallback((img)=>{
        imageRef.current = img;
        if (img === null || img === void 0 ? void 0 : img.complete) handleLoading(img);
    }, [
        handleLoading
    ]);
    const handleOnLoad = $5NSbj.useCallback((event)=>{
        handleLoading(event.currentTarget);
    }, [
        handleLoading
    ]);
    const handleOnError = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>{
        setStatus((0, $f848676e0d96e999$export$2ed3c80dbc178d91));
        onError === null || onError === void 0 || onError();
    });
    const cover = $ce68a3edc3fc357d$export$f5ba2f5b3fd12e6e(image, imageFit);
    const nonInfinite = (value, fallback)=>Number.isFinite(value) ? value : fallback;
    const maxWidth = nonInfinite(Math.max(...((_b = (_a = image.srcSet) === null || _a === void 0 ? void 0 : _a.map((x)=>x.width)) !== null && _b !== void 0 ? _b : []).concat(image.width ? [
        image.width
    ] : []).filter(Boolean)), ((_c = imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalWidth) || 0);
    const maxHeight = nonInfinite(Math.max(...((_e = (_d = image.srcSet) === null || _d === void 0 ? void 0 : _d.map((x)=>x.height)) !== null && _e !== void 0 ? _e : []).concat(image.height ? [
        image.height
    ] : []).filter(Boolean)), ((_f = imageRef.current) === null || _f === void 0 ? void 0 : _f.naturalHeight) || 0);
    const defaultStyle = maxWidth && maxHeight ? {
        maxWidth: `min(${maxWidth}px, 100%)`,
        maxHeight: `min(${maxHeight}px, 100%)`
    } : {
        maxWidth: "100%",
        maxHeight: "100%"
    };
    const srcSet = (_g = image.srcSet) === null || _g === void 0 ? void 0 : _g.slice().sort((a, b)=>a.width - b.width).map((item)=>`${item.src} ${item.width}w`).join(", ");
    const estimateActualWidth = ()=>rect && !cover && image.width && image.height ? rect.height / image.height * image.width : Number.MAX_VALUE;
    const sizes = srcSet && rect && $ce68a3edc3fc357d$export$fef62134eea24008() ? `${Math.round(Math.min(estimateActualWidth(), rect.width))}px` : undefined;
    const { style: imagePropsStyle, className: imagePropsClassName, ...restImageProps } = (typeof imageProps === "function" ? imageProps(image) : imageProps) || {};
    return $5NSbj.createElement($5NSbj.Fragment, null, $5NSbj.createElement("img", {
        ref: setImageRef,
        onLoad: handleOnLoad,
        onError: handleOnError,
        onClick: onClick,
        draggable: false,
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$slideImagePrefix()), cover && $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$slideImagePrefix("cover")), status !== (0, $f848676e0d96e999$export$a195e517d37aaa33) && $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$slideImagePrefix("loading")), imagePropsClassName),
        style: {
            ...defaultStyle,
            ...style,
            ...imagePropsStyle
        },
        ...restImageProps,
        alt: (_h = image.alt) !== null && _h !== void 0 ? _h : "",
        sizes: sizes,
        srcSet: srcSet,
        src: image.src
    }), status !== (0, $f848676e0d96e999$export$a195e517d37aaa33) && $5NSbj.createElement("div", {
        className: $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$slidePrefix((0, $f848676e0d96e999$export$e51f1c6d74b54a13)))
    }, status === (0, $f848676e0d96e999$export$554a1415841c52a8) && ((render === null || render === void 0 ? void 0 : render.iconLoading) ? render.iconLoading() : $5NSbj.createElement($ce68a3edc3fc357d$export$b936c55164dcf1db, {
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$c5f5ca1963fed141)), $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$slidePrefix((0, $f848676e0d96e999$export$554a1415841c52a8))))
    })), status === (0, $f848676e0d96e999$export$2ed3c80dbc178d91) && ((render === null || render === void 0 ? void 0 : render.iconError) ? render.iconError() : $5NSbj.createElement($ce68a3edc3fc357d$export$19bc16ee58e19b3d, {
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$c5f5ca1963fed141)), $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$slidePrefix((0, $f848676e0d96e999$export$2ed3c80dbc178d91))))
    }))));
}
const $ce68a3edc3fc357d$export$597a6f74cf288f82 = $5NSbj.forwardRef(function LightboxRoot({ className: className, children: children, onFocus: onFocus, onBlur: onBlur, ...rest }, ref) {
    const nodeRef = $5NSbj.useRef(null);
    const [isRTL, setIsRTL] = $5NSbj.useState(false);
    const { trackFocusWithin: trackFocusWithin } = $ce68a3edc3fc357d$export$3992c64d261ded5a();
    const detectRTL = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>{
        if (nodeRef.current) {
            const rtl = window.getComputedStyle(nodeRef.current).direction === "rtl";
            if (rtl !== isRTL) setIsRTL(rtl);
        }
    });
    $5NSbj.useEffect(detectRTL);
    return $5NSbj.createElement($ce68a3edc3fc357d$export$30e869153d18a2e6, {
        nodeRef: nodeRef
    }, $5NSbj.createElement($ce68a3edc3fc357d$export$625eb40e2215f320, {
        isRTL: isRTL
    }, $5NSbj.createElement("div", {
        ref: $ce68a3edc3fc357d$export$ebc1e1560c2dffa5(ref, nodeRef),
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a("root"), className),
        ...trackFocusWithin(onFocus, onBlur),
        ...rest
    }, children)));
});
var $ce68a3edc3fc357d$export$59f0048f451fc458;
(function(SwipeState) {
    SwipeState[SwipeState["NONE"] = 0] = "NONE";
    SwipeState[SwipeState["SWIPE"] = 1] = "SWIPE";
    SwipeState[SwipeState["PULL"] = 2] = "PULL";
    SwipeState[SwipeState["ANIMATION"] = 3] = "ANIMATION";
})($ce68a3edc3fc357d$export$59f0048f451fc458 || ($ce68a3edc3fc357d$export$59f0048f451fc458 = {}));
function $ce68a3edc3fc357d$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp, disabled) {
    $5NSbj.useEffect(()=>!disabled ? $ce68a3edc3fc357d$export$de863c629cb9919d(subscribeSensors((0, $f848676e0d96e999$export$e15fc153f45a963d), onPointerDown), subscribeSensors((0, $f848676e0d96e999$export$1f8863949fbdd7e5), onPointerMove), subscribeSensors((0, $f848676e0d96e999$export$2d868b67a5791b8a), onPointerUp), subscribeSensors((0, $f848676e0d96e999$export$526cafa85592f1a5), onPointerUp), subscribeSensors((0, $f848676e0d96e999$export$22151cee048c4be9), onPointerUp)) : ()=>{}, [
        subscribeSensors,
        onPointerDown,
        onPointerMove,
        onPointerUp,
        disabled
    ]);
}
var $ce68a3edc3fc357d$var$Gesture;
(function(Gesture) {
    Gesture[Gesture["NONE"] = 0] = "NONE";
    Gesture[Gesture["SWIPE"] = 1] = "SWIPE";
    Gesture[Gesture["PULL"] = 2] = "PULL";
})($ce68a3edc3fc357d$var$Gesture || ($ce68a3edc3fc357d$var$Gesture = {}));
const $ce68a3edc3fc357d$var$SWIPE_THRESHOLD = 30;
function $ce68a3edc3fc357d$export$abaee32ee49963c1({ disableSwipeNavigation: disableSwipeNavigation, closeOnBackdropClick: closeOnBackdropClick }, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel, pullUpEnabled, pullDownEnabled, onPullStart, onPullProgress, onPullFinish, onPullCancel, onClose) {
    const offset = $5NSbj.useRef(0);
    const pointers = $5NSbj.useRef([]);
    const activePointer = $5NSbj.useRef(undefined);
    const startTime = $5NSbj.useRef(0);
    const gesture = $5NSbj.useRef($ce68a3edc3fc357d$var$Gesture.NONE);
    const clearPointer = $5NSbj.useCallback((event)=>{
        if (activePointer.current === event.pointerId) {
            activePointer.current = undefined;
            gesture.current = $ce68a3edc3fc357d$var$Gesture.NONE;
        }
        const currentPointers = pointers.current;
        currentPointers.splice(0, currentPointers.length, ...currentPointers.filter((p)=>p.pointerId !== event.pointerId));
    }, []);
    const addPointer = $5NSbj.useCallback((event)=>{
        clearPointer(event);
        event.persist();
        pointers.current.push(event);
    }, [
        clearPointer
    ]);
    const lookupPointer = $5NSbj.useCallback((event)=>pointers.current.find(({ pointerId: pointerId })=>event.pointerId === pointerId), []);
    const onPointerDown = $ce68a3edc3fc357d$export$ee5b5d04074a389e((event)=>{
        addPointer(event);
    });
    const exceedsPullThreshold = (value, threshold)=>pullDownEnabled && value > threshold || pullUpEnabled && value < -threshold;
    const onPointerUp = $ce68a3edc3fc357d$export$ee5b5d04074a389e((event)=>{
        const pointer = lookupPointer(event);
        if (pointer) {
            if (activePointer.current === event.pointerId) {
                const duration = Date.now() - startTime.current;
                const currentOffset = offset.current;
                if (gesture.current === $ce68a3edc3fc357d$var$Gesture.SWIPE) {
                    if (Math.abs(currentOffset) > 0.3 * containerWidth || Math.abs(currentOffset) > 5 && duration < swipeAnimationDuration) onSwipeFinish(currentOffset, duration);
                    else onSwipeCancel(currentOffset);
                } else if (gesture.current === $ce68a3edc3fc357d$var$Gesture.PULL) {
                    if (exceedsPullThreshold(currentOffset, 2 * $ce68a3edc3fc357d$var$SWIPE_THRESHOLD)) onPullFinish(currentOffset, duration);
                    else onPullCancel(currentOffset);
                }
                offset.current = 0;
                gesture.current = $ce68a3edc3fc357d$var$Gesture.NONE;
            } else {
                const { target: target } = event;
                if (closeOnBackdropClick && target instanceof HTMLElement && target === pointer.target && (target.classList.contains($ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$8d922915837a38d3))) || target.classList.contains($ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$ac396c284080b10c))))) onClose();
            }
        }
        clearPointer(event);
    });
    const onPointerMove = $ce68a3edc3fc357d$export$ee5b5d04074a389e((event)=>{
        const pointer = lookupPointer(event);
        if (pointer) {
            const isCurrentPointer = activePointer.current === event.pointerId;
            if (event.buttons === 0) {
                if (isCurrentPointer && offset.current !== 0) onPointerUp(event);
                else clearPointer(pointer);
                return;
            }
            const deltaX = event.clientX - pointer.clientX;
            const deltaY = event.clientY - pointer.clientY;
            if (activePointer.current === undefined) {
                const startGesture = (newGesture)=>{
                    addPointer(event);
                    activePointer.current = event.pointerId;
                    startTime.current = Date.now();
                    gesture.current = newGesture;
                };
                if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > $ce68a3edc3fc357d$var$SWIPE_THRESHOLD && isSwipeValid(deltaX)) {
                    if (!disableSwipeNavigation) {
                        startGesture($ce68a3edc3fc357d$var$Gesture.SWIPE);
                        onSwipeStart();
                    }
                } else if (Math.abs(deltaY) > Math.abs(deltaX) && exceedsPullThreshold(deltaY, $ce68a3edc3fc357d$var$SWIPE_THRESHOLD)) {
                    startGesture($ce68a3edc3fc357d$var$Gesture.PULL);
                    onPullStart();
                }
            } else if (isCurrentPointer) {
                if (gesture.current === $ce68a3edc3fc357d$var$Gesture.SWIPE) {
                    offset.current = deltaX;
                    onSwipeProgress(deltaX);
                } else if (gesture.current === $ce68a3edc3fc357d$var$Gesture.PULL) {
                    offset.current = deltaY;
                    onPullProgress(deltaY);
                }
            }
        }
    });
    $ce68a3edc3fc357d$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp);
}
function $ce68a3edc3fc357d$export$145fefb2d7286388({ preventDefaultWheelX: preventDefaultWheelX, preventDefaultWheelY: preventDefaultWheelY }) {
    const ref = $5NSbj.useRef(null);
    const listener = $ce68a3edc3fc357d$export$ee5b5d04074a389e((event)=>{
        const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (horizontal && preventDefaultWheelX || !horizontal && preventDefaultWheelY || event.ctrlKey) event.preventDefault();
    });
    return $5NSbj.useCallback((node)=>{
        var _a;
        if (node) node.addEventListener("wheel", listener, {
            passive: false
        });
        else (_a = ref.current) === null || _a === void 0 || _a.removeEventListener("wheel", listener);
        ref.current = node;
    }, [
        listener
    ]);
}
function $ce68a3edc3fc357d$export$10506de8b6841445(swipeState, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel) {
    const offset = $5NSbj.useRef(0);
    const intent = $5NSbj.useRef(0);
    const intentCleanup = $5NSbj.useRef(undefined);
    const resetCleanup = $5NSbj.useRef(undefined);
    const wheelInertia = $5NSbj.useRef(0);
    const wheelInertiaCleanup = $5NSbj.useRef(undefined);
    const startTime = $5NSbj.useRef(0);
    const { setTimeout: setTimeout, clearTimeout: clearTimeout } = $ce68a3edc3fc357d$export$1bc7162631c81b3f();
    const cancelSwipeIntentCleanup = $5NSbj.useCallback(()=>{
        if (intentCleanup.current) {
            clearTimeout(intentCleanup.current);
            intentCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    const cancelSwipeResetCleanup = $5NSbj.useCallback(()=>{
        if (resetCleanup.current) {
            clearTimeout(resetCleanup.current);
            resetCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    const handleCleanup = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>{
        if (swipeState !== $ce68a3edc3fc357d$export$59f0048f451fc458.SWIPE) {
            offset.current = 0;
            startTime.current = 0;
            cancelSwipeIntentCleanup();
            cancelSwipeResetCleanup();
        }
    });
    $5NSbj.useEffect(handleCleanup, [
        swipeState,
        handleCleanup
    ]);
    const handleCancelSwipe = $ce68a3edc3fc357d$export$ee5b5d04074a389e((currentSwipeOffset)=>{
        resetCleanup.current = undefined;
        if (offset.current === currentSwipeOffset) onSwipeCancel(offset.current);
    });
    const onWheel = $ce68a3edc3fc357d$export$ee5b5d04074a389e((event)=>{
        if (event.ctrlKey) return;
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) return;
        const setWheelInertia = (inertia)=>{
            wheelInertia.current = inertia;
            clearTimeout(wheelInertiaCleanup.current);
            wheelInertiaCleanup.current = inertia > 0 ? setTimeout(()=>{
                wheelInertia.current = 0;
                wheelInertiaCleanup.current = undefined;
            }, 300) : undefined;
        };
        if (swipeState === $ce68a3edc3fc357d$export$59f0048f451fc458.NONE) {
            if (Math.abs(event.deltaX) <= 1.2 * Math.abs(wheelInertia.current)) {
                setWheelInertia(event.deltaX);
                return;
            }
            if (!isSwipeValid(-event.deltaX)) return;
            intent.current += event.deltaX;
            cancelSwipeIntentCleanup();
            if (Math.abs(intent.current) > 30) {
                intent.current = 0;
                setWheelInertia(0);
                startTime.current = Date.now();
                onSwipeStart();
            } else {
                const currentSwipeIntent = intent.current;
                intentCleanup.current = setTimeout(()=>{
                    intentCleanup.current = undefined;
                    if (currentSwipeIntent === intent.current) intent.current = 0;
                }, swipeAnimationDuration);
            }
        } else if (swipeState === $ce68a3edc3fc357d$export$59f0048f451fc458.SWIPE) {
            let newSwipeOffset = offset.current - event.deltaX;
            newSwipeOffset = Math.min(Math.abs(newSwipeOffset), containerWidth) * Math.sign(newSwipeOffset);
            offset.current = newSwipeOffset;
            onSwipeProgress(newSwipeOffset);
            cancelSwipeResetCleanup();
            if (Math.abs(newSwipeOffset) > 0.2 * containerWidth) {
                setWheelInertia(event.deltaX);
                onSwipeFinish(newSwipeOffset, Date.now() - startTime.current);
                return;
            }
            resetCleanup.current = setTimeout(()=>handleCancelSwipe(newSwipeOffset), 2 * swipeAnimationDuration);
        } else setWheelInertia(event.deltaX);
    });
    $5NSbj.useEffect(()=>subscribeSensors((0, $f848676e0d96e999$export$5635dc9d647242c7), onWheel), [
        subscribeSensors,
        onWheel
    ]);
}
const $ce68a3edc3fc357d$var$cssContainerPrefix = $ce68a3edc3fc357d$export$3e7cd27eed1727c("container");
const $ce68a3edc3fc357d$export$e92ff191b0c59550 = $5NSbj.createContext(null);
const $ce68a3edc3fc357d$export$e8c786024a2b0a79 = $ce68a3edc3fc357d$export$aac3e49c3c8b5cb0("useController", "ControllerContext", $ce68a3edc3fc357d$export$e92ff191b0c59550);
function $ce68a3edc3fc357d$export$bd0bf19f25da8474({ children: children, ...props }) {
    var _a;
    const { carousel: carousel, animation: animation, controller: controller, on: on, styles: styles, render: render } = props;
    const { closeOnPullUp: closeOnPullUp, closeOnPullDown: closeOnPullDown, preventDefaultWheelX: preventDefaultWheelX, preventDefaultWheelY: preventDefaultWheelY } = controller;
    const [toolbarWidth, setToolbarWidth] = $5NSbj.useState();
    const state = $ce68a3edc3fc357d$export$566121e2bbc52eec();
    const dispatch = $ce68a3edc3fc357d$export$9463bb14d6ba055e();
    const [swipeState, setSwipeState] = $5NSbj.useState($ce68a3edc3fc357d$export$59f0048f451fc458.NONE);
    const swipeOffset = $5NSbj.useRef(0);
    const pullOffset = $5NSbj.useRef(0);
    const pullOpacity = $5NSbj.useRef(1);
    const { registerSensors: registerSensors, subscribeSensors: subscribeSensors } = $ce68a3edc3fc357d$export$19012f58216d597f();
    const { subscribe: subscribe, publish: publish } = $ce68a3edc3fc357d$export$91a992459f6e0f07();
    const cleanupAnimationIncrement = $ce68a3edc3fc357d$export$69f38700ea0cb3b9();
    const cleanupSwipeOffset = $ce68a3edc3fc357d$export$69f38700ea0cb3b9();
    const cleanupPullOffset = $ce68a3edc3fc357d$export$69f38700ea0cb3b9();
    const { containerRef: containerRef, setContainerRef: setContainerRef, containerRect: containerRect } = $ce68a3edc3fc357d$export$b1d85de58d38d09d();
    const handleContainerRef = $ce68a3edc3fc357d$export$ebc1e1560c2dffa5($ce68a3edc3fc357d$export$145fefb2d7286388({
        preventDefaultWheelX: preventDefaultWheelX,
        preventDefaultWheelY: preventDefaultWheelY
    }), setContainerRef);
    const carouselRef = $5NSbj.useRef(null);
    const setCarouselRef = $ce68a3edc3fc357d$export$ebc1e1560c2dffa5(carouselRef, undefined);
    const { getOwnerDocument: getOwnerDocument } = $ce68a3edc3fc357d$export$c199d36c2862b6ed();
    const isRTL = $ce68a3edc3fc357d$export$81f015b3ec5d61cf();
    const rtl = (value)=>(isRTL ? -1 : 1) * (typeof value === "number" ? value : 1);
    const focus = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>{
        var _a;
        return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    const getLightboxProps = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>props);
    const getLightboxState = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>state);
    const prev = $5NSbj.useCallback((params)=>publish((0, $f848676e0d96e999$export$a007161537026955), params), [
        publish
    ]);
    const next = $5NSbj.useCallback((params)=>publish((0, $f848676e0d96e999$export$f1d7a854db833ed4), params), [
        publish
    ]);
    const close = $5NSbj.useCallback(()=>publish((0, $f848676e0d96e999$export$493a596486210a21)), [
        publish
    ]);
    const isSwipeValid = (offset)=>!(carousel.finite && (rtl(offset) > 0 && state.currentIndex === 0 || rtl(offset) < 0 && state.currentIndex === state.slides.length - 1));
    const setSwipeOffset = (offset)=>{
        var _a;
        swipeOffset.current = offset;
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($ce68a3edc3fc357d$export$8b4981022bd80a4e("swipe_offset"), `${Math.round(offset)}px`);
    };
    const setPullOffset = (offset)=>{
        var _a, _b;
        pullOffset.current = offset;
        pullOpacity.current = (()=>{
            const threshold = 60;
            const minOpacity = 0.5;
            const offsetValue = (()=>{
                if (closeOnPullDown && offset > 0) return offset;
                if (closeOnPullUp && offset < 0) return -offset;
                return 0;
            })();
            return Math.min(Math.max($ce68a3edc3fc357d$export$2077e0241d6afd3c(1 - offsetValue / threshold * (1 - minOpacity), 2), minOpacity), 1);
        })();
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($ce68a3edc3fc357d$export$8b4981022bd80a4e("pull_offset"), `${Math.round(offset)}px`);
        (_b = containerRef.current) === null || _b === void 0 || _b.style.setProperty($ce68a3edc3fc357d$export$8b4981022bd80a4e("pull_opacity"), `${pullOpacity.current}`);
    };
    const { prepareAnimation: preparePullAnimation } = $ce68a3edc3fc357d$export$9e2608686d4ad846(carouselRef, (snapshot, rect, translate)=>{
        if (carouselRef.current && containerRect) return {
            keyframes: [
                {
                    transform: `translate(0, ${snapshot.rect.y - rect.y + translate.y}px)`,
                    opacity: snapshot.opacity
                },
                {
                    transform: "translate(0, 0)",
                    opacity: 1
                }
            ],
            duration: snapshot.duration,
            easing: animation.easing.fade
        };
        return undefined;
    });
    const pull = (offset, cancel)=>{
        if (closeOnPullUp || closeOnPullDown) {
            setPullOffset(offset);
            let duration = 0;
            if (carouselRef.current) {
                duration = animation.fade * (cancel ? 2 : 1);
                preparePullAnimation({
                    rect: carouselRef.current.getBoundingClientRect(),
                    opacity: pullOpacity.current,
                    duration: duration
                });
            }
            cleanupPullOffset(()=>{
                setPullOffset(0);
                setSwipeState($ce68a3edc3fc357d$export$59f0048f451fc458.NONE);
            }, duration);
            setSwipeState($ce68a3edc3fc357d$export$59f0048f451fc458.ANIMATION);
            if (!cancel) close();
        }
    };
    const { prepareAnimation: prepareAnimation, isAnimationPlaying: isAnimationPlaying } = $ce68a3edc3fc357d$export$9e2608686d4ad846(carouselRef, (snapshot, rect, translate)=>{
        var _a;
        if (carouselRef.current && containerRect && ((_a = state.animation) === null || _a === void 0 ? void 0 : _a.duration)) {
            const parsedSpacing = $ce68a3edc3fc357d$export$7871fb532d320d99(carousel.spacing);
            const spacingValue = (parsedSpacing.percent ? parsedSpacing.percent * containerRect.width / 100 : parsedSpacing.pixel) || 0;
            return {
                keyframes: [
                    {
                        transform: `translate(${rtl(state.globalIndex - snapshot.index) * (containerRect.width + spacingValue) + snapshot.rect.x - rect.x + translate.x}px, 0)`
                    },
                    {
                        transform: "translate(0, 0)"
                    }
                ],
                duration: state.animation.duration,
                easing: state.animation.easing
            };
        }
        return undefined;
    });
    const swipe = $ce68a3edc3fc357d$export$ee5b5d04074a389e((action)=>{
        var _a, _b;
        const currentSwipeOffset = action.offset || 0;
        const swipeDuration = !currentSwipeOffset ? (_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe : animation.swipe;
        const swipeEasing = !currentSwipeOffset && !isAnimationPlaying() ? animation.easing.navigation : animation.easing.swipe;
        let { direction: direction } = action;
        const count = (_b = action.count) !== null && _b !== void 0 ? _b : 1;
        let newSwipeState = $ce68a3edc3fc357d$export$59f0048f451fc458.ANIMATION;
        let newSwipeAnimationDuration = swipeDuration * count;
        if (!direction) {
            const containerWidth = containerRect === null || containerRect === void 0 ? void 0 : containerRect.width;
            const elapsedTime = action.duration || 0;
            const expectedTime = containerWidth ? swipeDuration / containerWidth * Math.abs(currentSwipeOffset) : swipeDuration;
            if (count !== 0) {
                if (elapsedTime < expectedTime) newSwipeAnimationDuration = newSwipeAnimationDuration / expectedTime * Math.max(elapsedTime, expectedTime / 5);
                else if (containerWidth) newSwipeAnimationDuration = swipeDuration / containerWidth * (containerWidth - Math.abs(currentSwipeOffset));
                direction = rtl(currentSwipeOffset) > 0 ? (0, $f848676e0d96e999$export$a007161537026955) : (0, $f848676e0d96e999$export$f1d7a854db833ed4);
            } else newSwipeAnimationDuration = swipeDuration / 2;
        }
        let increment = 0;
        if (direction === (0, $f848676e0d96e999$export$a007161537026955)) {
            if (isSwipeValid(rtl(1))) increment = -count;
            else {
                newSwipeState = $ce68a3edc3fc357d$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        } else if (direction === (0, $f848676e0d96e999$export$f1d7a854db833ed4)) {
            if (isSwipeValid(rtl(-1))) increment = count;
            else {
                newSwipeState = $ce68a3edc3fc357d$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        }
        newSwipeAnimationDuration = Math.round(newSwipeAnimationDuration);
        cleanupSwipeOffset(()=>{
            setSwipeOffset(0);
            setSwipeState($ce68a3edc3fc357d$export$59f0048f451fc458.NONE);
        }, newSwipeAnimationDuration);
        if (carouselRef.current) prepareAnimation({
            rect: carouselRef.current.getBoundingClientRect(),
            index: state.globalIndex
        });
        setSwipeState(newSwipeState);
        publish((0, $f848676e0d96e999$export$c43bd1a4101c4078), {
            type: "swipe",
            increment: increment,
            duration: newSwipeAnimationDuration,
            easing: swipeEasing
        });
    });
    $5NSbj.useEffect(()=>{
        var _a, _b;
        if (((_a = state.animation) === null || _a === void 0 ? void 0 : _a.increment) && ((_b = state.animation) === null || _b === void 0 ? void 0 : _b.duration)) cleanupAnimationIncrement(()=>dispatch({
                type: "swipe",
                increment: 0
            }), state.animation.duration);
    }, [
        state.animation,
        dispatch,
        cleanupAnimationIncrement
    ]);
    const swipeParams = [
        subscribeSensors,
        isSwipeValid,
        (containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) || 0,
        animation.swipe,
        ()=>setSwipeState($ce68a3edc3fc357d$export$59f0048f451fc458.SWIPE),
        (offset)=>setSwipeOffset(offset),
        (offset, duration)=>swipe({
                offset: offset,
                duration: duration,
                count: 1
            }),
        (offset)=>swipe({
                offset: offset,
                count: 0
            })
    ];
    const pullParams = [
        ()=>{
            if (closeOnPullDown) setSwipeState($ce68a3edc3fc357d$export$59f0048f451fc458.PULL);
        },
        (offset)=>setPullOffset(offset),
        (offset)=>pull(offset),
        (offset)=>pull(offset, true)
    ];
    $ce68a3edc3fc357d$export$abaee32ee49963c1(controller, ...swipeParams, closeOnPullUp, closeOnPullDown, ...pullParams, close);
    $ce68a3edc3fc357d$export$10506de8b6841445(swipeState, ...swipeParams);
    const focusOnMount = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>{
        if (controller.focus && getOwnerDocument().querySelector(`.${$ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$9d2e4856063e1a22))} .${$ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssContainerPrefix())}`)) focus();
    });
    $5NSbj.useEffect(focusOnMount, [
        focusOnMount
    ]);
    const onViewCallback = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>{
        var _a;
        (_a = on.view) === null || _a === void 0 || _a.call(on, {
            index: state.currentIndex
        });
    });
    $5NSbj.useEffect(onViewCallback, [
        state.globalIndex,
        onViewCallback
    ]);
    $5NSbj.useEffect(()=>$ce68a3edc3fc357d$export$de863c629cb9919d(subscribe((0, $f848676e0d96e999$export$a007161537026955), (action)=>swipe({
                direction: (0, $f848676e0d96e999$export$a007161537026955),
                ...action
            })), subscribe((0, $f848676e0d96e999$export$f1d7a854db833ed4), (action)=>swipe({
                direction: (0, $f848676e0d96e999$export$f1d7a854db833ed4),
                ...action
            })), subscribe((0, $f848676e0d96e999$export$c43bd1a4101c4078), (action)=>dispatch(action))), [
        subscribe,
        swipe,
        dispatch
    ]);
    const context = $5NSbj.useMemo(()=>({
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            slideRect: containerRect ? $ce68a3edc3fc357d$export$7ff571008bce9900(containerRect, carousel.padding) : {
                width: 0,
                height: 0
            },
            containerRect: containerRect || {
                width: 0,
                height: 0
            },
            subscribeSensors: subscribeSensors,
            containerRef: containerRef,
            setCarouselRef: setCarouselRef,
            toolbarWidth: toolbarWidth,
            setToolbarWidth: setToolbarWidth
        }), [
        prev,
        next,
        close,
        focus,
        subscribeSensors,
        containerRect,
        containerRef,
        setCarouselRef,
        toolbarWidth,
        setToolbarWidth,
        carousel.padding
    ]);
    $5NSbj.useImperativeHandle(controller.ref, ()=>({
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            getLightboxProps: getLightboxProps,
            getLightboxState: getLightboxState
        }), [
        prev,
        next,
        close,
        focus,
        getLightboxProps,
        getLightboxState
    ]);
    return $5NSbj.createElement("div", {
        ref: handleContainerRef,
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssContainerPrefix()), $ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$974a68ef150451f5))),
        style: {
            ...swipeState === $ce68a3edc3fc357d$export$59f0048f451fc458.SWIPE ? {
                [$ce68a3edc3fc357d$export$8b4981022bd80a4e("swipe_offset")]: `${Math.round(swipeOffset.current)}px`
            } : null,
            ...swipeState === $ce68a3edc3fc357d$export$59f0048f451fc458.PULL ? {
                [$ce68a3edc3fc357d$export$8b4981022bd80a4e("pull_offset")]: `${Math.round(pullOffset.current)}px`,
                [$ce68a3edc3fc357d$export$8b4981022bd80a4e("pull_opacity")]: `${pullOpacity.current}`
            } : null,
            ...controller.touchAction !== "none" ? {
                [$ce68a3edc3fc357d$export$8b4981022bd80a4e("controller_touch_action")]: controller.touchAction
            } : null,
            ...styles.container
        },
        tabIndex: -1,
        ...registerSensors
    }, containerRect && $5NSbj.createElement($ce68a3edc3fc357d$export$e92ff191b0c59550.Provider, {
        value: context
    }, children, (_a = render.controls) === null || _a === void 0 ? void 0 : _a.call(render)));
}
const $ce68a3edc3fc357d$export$be59d34228c8ec8a = $ce68a3edc3fc357d$export$c5ba3739ffba980d((0, $f848676e0d96e999$export$b861c6f4d58b4c2f), $ce68a3edc3fc357d$export$bd0bf19f25da8474);
function $ce68a3edc3fc357d$var$cssPrefix$2(value) {
    return $ce68a3edc3fc357d$export$195c4126907dde97((0, $f848676e0d96e999$export$83fe3bee12eb51bb), value);
}
function $ce68a3edc3fc357d$var$cssSlidePrefix(value) {
    return $ce68a3edc3fc357d$export$195c4126907dde97((0, $f848676e0d96e999$export$8d922915837a38d3), value);
}
function $ce68a3edc3fc357d$var$CarouselSlide({ slide: slide, offset: offset }) {
    const containerRef = $5NSbj.useRef(null);
    const { currentIndex: currentIndex, slides: slides } = $ce68a3edc3fc357d$export$566121e2bbc52eec();
    const { slideRect: slideRect, focus: focus } = $ce68a3edc3fc357d$export$e8c786024a2b0a79();
    const { render: render, carousel: { imageFit: imageFit, imageProps: imageProps }, on: { click: onClick }, styles: { slide: style }, labels: labels } = $ce68a3edc3fc357d$export$d930f3536e1c64f6();
    const { getOwnerDocument: getOwnerDocument } = $ce68a3edc3fc357d$export$c199d36c2862b6ed();
    const offscreen = offset !== 0;
    $5NSbj.useEffect(()=>{
        var _a;
        if (offscreen && ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(getOwnerDocument().activeElement))) focus();
    }, [
        offscreen,
        focus,
        getOwnerDocument
    ]);
    const renderSlide = ()=>{
        var _a, _b, _c, _d;
        let rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, {
            slide: slide,
            offset: offset,
            rect: slideRect
        });
        if (!rendered && $ce68a3edc3fc357d$export$55ec18c411514c07(slide)) rendered = $5NSbj.createElement($ce68a3edc3fc357d$export$ef86b1d52c77b27b, {
            slide: slide,
            offset: offset,
            render: render,
            rect: slideRect,
            imageFit: imageFit,
            imageProps: imageProps,
            onClick: !offscreen ? ()=>onClick === null || onClick === void 0 ? void 0 : onClick({
                    index: currentIndex
                }) : undefined
        });
        return rendered ? $5NSbj.createElement($5NSbj.Fragment, null, (_b = render.slideHeader) === null || _b === void 0 ? void 0 : _b.call(render, {
            slide: slide
        }), ((_c = render.slideContainer) !== null && _c !== void 0 ? _c : ({ children: children })=>children)({
            slide: slide,
            children: rendered
        }), (_d = render.slideFooter) === null || _d === void 0 ? void 0 : _d.call(render, {
            slide: slide
        })) : null;
    };
    return $5NSbj.createElement("div", {
        ref: containerRef,
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssSlidePrefix()), !offscreen && $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssSlidePrefix("current")), $ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$974a68ef150451f5))),
        ...$ce68a3edc3fc357d$export$9c64d01b28c1f747(offscreen),
        style: style,
        role: "group",
        "aria-roledescription": $ce68a3edc3fc357d$export$1c4d965eb6f65dfa(labels, "Slide"),
        "aria-label": $ce68a3edc3fc357d$export$77152303d9076b8(labels, slides, currentIndex + offset)
    }, renderSlide());
}
function $ce68a3edc3fc357d$var$Placeholder() {
    const style = $ce68a3edc3fc357d$export$d930f3536e1c64f6().styles.slide;
    return $5NSbj.createElement("div", {
        className: $ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$8d922915837a38d3)),
        style: style
    });
}
function $ce68a3edc3fc357d$export$144901db2ea8e967({ carousel: carousel, labels: labels }) {
    const { slides: slides, currentIndex: currentIndex, globalIndex: globalIndex } = $ce68a3edc3fc357d$export$566121e2bbc52eec();
    const { setCarouselRef: setCarouselRef } = $ce68a3edc3fc357d$export$e8c786024a2b0a79();
    const { autoPlaying: autoPlaying, focusWithin: focusWithin } = $ce68a3edc3fc357d$export$3992c64d261ded5a();
    const spacingValue = $ce68a3edc3fc357d$export$7871fb532d320d99(carousel.spacing);
    const paddingValue = $ce68a3edc3fc357d$export$7871fb532d320d99(carousel.padding);
    const preload = $ce68a3edc3fc357d$export$aab7f3145c728301(carousel, slides, 1);
    const items = [];
    if ($ce68a3edc3fc357d$export$883ece934910f98d(slides)) for(let index = currentIndex - preload; index <= currentIndex + preload; index += 1){
        const slide = $ce68a3edc3fc357d$export$cdfb855c5eb3bc84(slides, index);
        const key = globalIndex - currentIndex + index;
        const placeholder = carousel.finite && (index < 0 || index > slides.length - 1);
        items.push(!placeholder ? {
            key: [
                `${key}`,
                $ce68a3edc3fc357d$export$b2184449b7659b5a(slide)
            ].filter(Boolean).join("|"),
            offset: index - currentIndex,
            slide: slide
        } : {
            key: key
        });
    }
    return $5NSbj.createElement("div", {
        ref: setCarouselRef,
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37($ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssPrefix$2()), items.length > 0 && $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssPrefix$2("with_slides"))),
        style: {
            [`${$ce68a3edc3fc357d$export$8b4981022bd80a4e($ce68a3edc3fc357d$var$cssPrefix$2("slides_count"))}`]: items.length,
            [`${$ce68a3edc3fc357d$export$8b4981022bd80a4e($ce68a3edc3fc357d$var$cssPrefix$2("spacing_px"))}`]: spacingValue.pixel || 0,
            [`${$ce68a3edc3fc357d$export$8b4981022bd80a4e($ce68a3edc3fc357d$var$cssPrefix$2("spacing_percent"))}`]: spacingValue.percent || 0,
            [`${$ce68a3edc3fc357d$export$8b4981022bd80a4e($ce68a3edc3fc357d$var$cssPrefix$2("padding_px"))}`]: paddingValue.pixel || 0,
            [`${$ce68a3edc3fc357d$export$8b4981022bd80a4e($ce68a3edc3fc357d$var$cssPrefix$2("padding_percent"))}`]: paddingValue.percent || 0
        },
        role: "region",
        "aria-live": autoPlaying && !focusWithin ? "off" : "polite",
        "aria-roledescription": $ce68a3edc3fc357d$export$1c4d965eb6f65dfa(labels, "Carousel"),
        "aria-label": $ce68a3edc3fc357d$export$1c4d965eb6f65dfa(labels, "Photo gallery")
    }, items.map(({ key: key, slide: slide, offset: offset })=>slide ? $5NSbj.createElement($ce68a3edc3fc357d$var$CarouselSlide, {
            key: key,
            slide: slide,
            offset: offset
        }) : $5NSbj.createElement($ce68a3edc3fc357d$var$Placeholder, {
            key: key
        })));
}
const $ce68a3edc3fc357d$export$9c087759a323a56c = $ce68a3edc3fc357d$export$c5ba3739ffba980d((0, $f848676e0d96e999$export$83fe3bee12eb51bb), $ce68a3edc3fc357d$export$144901db2ea8e967);
function $ce68a3edc3fc357d$export$e482f4662aebc4a0() {
    const { carousel: carousel } = $ce68a3edc3fc357d$export$d930f3536e1c64f6();
    const { slides: slides, currentIndex: currentIndex } = $ce68a3edc3fc357d$export$566121e2bbc52eec();
    const prevDisabled = slides.length === 0 || carousel.finite && currentIndex === 0;
    const nextDisabled = slides.length === 0 || carousel.finite && currentIndex === slides.length - 1;
    return {
        prevDisabled: prevDisabled,
        nextDisabled: nextDisabled
    };
}
function $ce68a3edc3fc357d$export$4da28cf324280418(subscribeSensors) {
    var _a;
    const isRTL = $ce68a3edc3fc357d$export$81f015b3ec5d61cf();
    const { publish: publish } = $ce68a3edc3fc357d$export$91a992459f6e0f07();
    const { animation: animation, controller: controller } = $ce68a3edc3fc357d$export$d930f3536e1c64f6();
    const { prevDisabled: prevDisabled, nextDisabled: nextDisabled } = $ce68a3edc3fc357d$export$e482f4662aebc4a0();
    const throttle = ((_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe) / 2;
    const prev = $ce68a3edc3fc357d$export$8b7b9481d6186f21(()=>publish((0, $f848676e0d96e999$export$a007161537026955)), throttle);
    const next = $ce68a3edc3fc357d$export$8b7b9481d6186f21(()=>publish((0, $f848676e0d96e999$export$f1d7a854db833ed4)), throttle);
    const handleKeyDown = $ce68a3edc3fc357d$export$ee5b5d04074a389e((event)=>{
        switch(event.key){
            case 0, $f848676e0d96e999$export$e8d60d9b5ceff7c0:
                if (!controller.closeOnEscape) return;
                publish((0, $f848676e0d96e999$export$493a596486210a21));
                break;
            case 0, $f848676e0d96e999$export$17dec1da9b0e2eb3:
                if (!(isRTL ? nextDisabled : prevDisabled)) (isRTL ? next : prev)();
                break;
            case 0, $f848676e0d96e999$export$91898c0e7e48903:
                if (!(isRTL ? prevDisabled : nextDisabled)) (isRTL ? prev : next)();
                break;
            default:
                return;
        }
        event.stopPropagation();
    });
    $5NSbj.useEffect(()=>subscribeSensors((0, $f848676e0d96e999$export$1aba4f3521686ca9), handleKeyDown), [
        subscribeSensors,
        handleKeyDown
    ]);
}
function $ce68a3edc3fc357d$export$e2d1bd910e689283({ label: label, icon: icon, renderIcon: renderIcon, action: action, onClick: onClick, disabled: disabled, style: style }) {
    return $5NSbj.createElement($ce68a3edc3fc357d$export$c25acd513dcc8062, {
        label: label,
        icon: icon,
        renderIcon: renderIcon,
        className: $ce68a3edc3fc357d$export$1283875077dc8f0a(`navigation_${action}`),
        disabled: disabled,
        onClick: onClick,
        style: style,
        ...$ce68a3edc3fc357d$export$2bd1c19440b9235c($ce68a3edc3fc357d$export$e8c786024a2b0a79().focus, disabled)
    });
}
function $ce68a3edc3fc357d$export$b8a61e5c71402559({ render: { buttonPrev: buttonPrev, buttonNext: buttonNext, iconPrev: iconPrev, iconNext: iconNext }, styles: styles }) {
    const { prev: prev, next: next, subscribeSensors: subscribeSensors } = $ce68a3edc3fc357d$export$e8c786024a2b0a79();
    const { prevDisabled: prevDisabled, nextDisabled: nextDisabled } = $ce68a3edc3fc357d$export$e482f4662aebc4a0();
    $ce68a3edc3fc357d$export$4da28cf324280418(subscribeSensors);
    return $5NSbj.createElement($5NSbj.Fragment, null, buttonPrev ? buttonPrev() : $5NSbj.createElement($ce68a3edc3fc357d$export$e2d1bd910e689283, {
        label: "Previous",
        action: (0, $f848676e0d96e999$export$a007161537026955),
        icon: $ce68a3edc3fc357d$export$d05925e1c7f3f136,
        renderIcon: iconPrev,
        style: styles.navigationPrev,
        disabled: prevDisabled,
        onClick: prev
    }), buttonNext ? buttonNext() : $5NSbj.createElement($ce68a3edc3fc357d$export$e2d1bd910e689283, {
        label: "Next",
        action: (0, $f848676e0d96e999$export$f1d7a854db833ed4),
        icon: $ce68a3edc3fc357d$export$3da0e0ec94bd4ce1,
        renderIcon: iconNext,
        style: styles.navigationNext,
        disabled: nextDisabled,
        onClick: next
    }));
}
const $ce68a3edc3fc357d$export$6c16e1ac15089858 = $ce68a3edc3fc357d$export$c5ba3739ffba980d((0, $f848676e0d96e999$export$607ce719f0ec9b98), $ce68a3edc3fc357d$export$b8a61e5c71402559);
const $ce68a3edc3fc357d$var$noScroll = $ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$b6426a00c33a0175));
const $ce68a3edc3fc357d$var$noScrollPadding = $ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$651541414233b476));
function $ce68a3edc3fc357d$var$isHTMLElement(element) {
    return "style" in element;
}
function $ce68a3edc3fc357d$var$padScrollbar(element, padding, rtl) {
    const styles = window.getComputedStyle(element);
    const property = rtl ? "padding-left" : "padding-right";
    const computedValue = rtl ? styles.paddingLeft : styles.paddingRight;
    const originalValue = element.style.getPropertyValue(property);
    element.style.setProperty(property, `${($ce68a3edc3fc357d$export$5f87784a266e50a4(computedValue) || 0) + padding}px`);
    return ()=>{
        if (originalValue) element.style.setProperty(property, originalValue);
        else element.style.removeProperty(property);
    };
}
function $ce68a3edc3fc357d$export$bbae9e931237726f({ noScroll: { disabled: disabled }, children: children }) {
    const rtl = $ce68a3edc3fc357d$export$81f015b3ec5d61cf();
    const { getOwnerDocument: getOwnerDocument, getOwnerWindow: getOwnerWindow } = $ce68a3edc3fc357d$export$c199d36c2862b6ed();
    $5NSbj.useEffect(()=>{
        if (disabled) return ()=>{};
        const cleanup = [];
        const ownerWindow = getOwnerWindow();
        const { body: body, documentElement: documentElement } = getOwnerDocument();
        const scrollbar = Math.round(ownerWindow.innerWidth - documentElement.clientWidth);
        if (scrollbar > 0) {
            cleanup.push($ce68a3edc3fc357d$var$padScrollbar(body, scrollbar, rtl));
            const elements = body.getElementsByTagName("*");
            for(let i = 0; i < elements.length; i += 1){
                const element = elements[i];
                if ($ce68a3edc3fc357d$var$isHTMLElement(element) && ownerWindow.getComputedStyle(element).getPropertyValue("position") === "fixed" && !element.classList.contains($ce68a3edc3fc357d$var$noScrollPadding)) cleanup.push($ce68a3edc3fc357d$var$padScrollbar(element, scrollbar, rtl));
            }
        }
        body.classList.add($ce68a3edc3fc357d$var$noScroll);
        return ()=>{
            body.classList.remove($ce68a3edc3fc357d$var$noScroll);
            cleanup.forEach((clean)=>clean());
        };
    }, [
        rtl,
        disabled,
        getOwnerDocument,
        getOwnerWindow
    ]);
    return $5NSbj.createElement($5NSbj.Fragment, null, children);
}
const $ce68a3edc3fc357d$export$7ded5f1cd4840ad = $ce68a3edc3fc357d$export$c5ba3739ffba980d((0, $f848676e0d96e999$export$52cbc29cf5406ba8), $ce68a3edc3fc357d$export$bbae9e931237726f);
function $ce68a3edc3fc357d$var$cssPrefix$1(value) {
    return $ce68a3edc3fc357d$export$195c4126907dde97((0, $f848676e0d96e999$export$9d2e4856063e1a22), value);
}
function $ce68a3edc3fc357d$var$setAttribute(element, attribute, value) {
    const previousValue = element.getAttribute(attribute);
    element.setAttribute(attribute, value);
    return ()=>{
        if (previousValue) element.setAttribute(attribute, previousValue);
        else element.removeAttribute(attribute);
    };
}
function $ce68a3edc3fc357d$export$602eac185826482c({ portal: { root: root, container: { className: containerClassName, style: containerStyle, ...containerRest } = {} }, animation: animation, styles: styles, className: className, on: on, close: close, labels: labels, children: children }) {
    const [mounted, setMounted] = $5NSbj.useState(false);
    const [visible, setVisible] = $5NSbj.useState(false);
    const cleanup = $5NSbj.useRef([]);
    const restoreFocus = $5NSbj.useRef(null);
    const { setTimeout: setTimeout } = $ce68a3edc3fc357d$export$1bc7162631c81b3f();
    const { subscribe: subscribe } = $ce68a3edc3fc357d$export$91a992459f6e0f07();
    const reduceMotion = $ce68a3edc3fc357d$export$f3e625e1b2b31d60();
    const animationDuration = !reduceMotion ? animation.fade : 0;
    $5NSbj.useEffect(()=>{
        setMounted(true);
        return ()=>{
            setMounted(false);
            setVisible(false);
        };
    }, []);
    const handleCleanup = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>{
        cleanup.current.forEach((clean)=>clean());
        cleanup.current = [];
    });
    const handleClose = $ce68a3edc3fc357d$export$ee5b5d04074a389e(()=>{
        var _a;
        setVisible(false);
        handleCleanup();
        (_a = on.exiting) === null || _a === void 0 || _a.call(on);
        setTimeout(()=>{
            var _a;
            (_a = on.exited) === null || _a === void 0 || _a.call(on);
            close();
        }, animationDuration);
    });
    $5NSbj.useEffect(()=>subscribe((0, $f848676e0d96e999$export$493a596486210a21), handleClose), [
        subscribe,
        handleClose
    ]);
    const handleEnter = $ce68a3edc3fc357d$export$ee5b5d04074a389e((node)=>{
        var _a, _b, _c;
        $ce68a3edc3fc357d$export$b7a864e1eaef9de5(node);
        setVisible(true);
        (_a = on.entering) === null || _a === void 0 || _a.call(on);
        const elements = (_c = (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : [];
        for(let i = 0; i < elements.length; i += 1){
            const element = elements[i];
            if ([
                "TEMPLATE",
                "SCRIPT",
                "STYLE"
            ].indexOf(element.tagName) === -1 && element !== node) {
                cleanup.current.push($ce68a3edc3fc357d$var$setAttribute(element, "inert", ""));
                cleanup.current.push($ce68a3edc3fc357d$var$setAttribute(element, "aria-hidden", "true"));
            }
        }
        cleanup.current.push(()=>{
            var _a, _b;
            (_b = (_a = restoreFocus.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a);
        });
        setTimeout(()=>{
            var _a;
            (_a = on.entered) === null || _a === void 0 || _a.call(on);
        }, animationDuration);
    });
    const handleRef = $5NSbj.useCallback((node)=>{
        if (node) handleEnter(node);
        else handleCleanup();
    }, [
        handleEnter,
        handleCleanup
    ]);
    return mounted ? (0, $21jDP.createPortal)($5NSbj.createElement($ce68a3edc3fc357d$export$597a6f74cf288f82, {
        ref: handleRef,
        className: $ce68a3edc3fc357d$export$4f5d2d50c9deca37(className, containerClassName, $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssPrefix$1()), $ce68a3edc3fc357d$export$1283875077dc8f0a((0, $f848676e0d96e999$export$651541414233b476)), visible && $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssPrefix$1("open"))),
        "aria-modal": true,
        role: "dialog",
        "aria-label": $ce68a3edc3fc357d$export$1c4d965eb6f65dfa(labels, "Lightbox"),
        style: {
            ...animation.fade !== $ce68a3edc3fc357d$export$d626463445cef3e9.animation.fade ? {
                [$ce68a3edc3fc357d$export$8b4981022bd80a4e("fade_animation_duration")]: `${animationDuration}ms`
            } : null,
            ...animation.easing.fade !== $ce68a3edc3fc357d$export$d626463445cef3e9.animation.easing.fade ? {
                [$ce68a3edc3fc357d$export$8b4981022bd80a4e("fade_animation_timing_function")]: animation.easing.fade
            } : null,
            ...styles.root,
            ...containerStyle
        },
        onFocus: (event)=>{
            if (!restoreFocus.current) restoreFocus.current = event.relatedTarget;
        },
        ...containerRest
    }, children), (typeof root === "function" ? root() : root) || document.body) : null;
}
const $ce68a3edc3fc357d$export$f2a0761442face5c = $ce68a3edc3fc357d$export$c5ba3739ffba980d((0, $f848676e0d96e999$export$9d2e4856063e1a22), $ce68a3edc3fc357d$export$602eac185826482c);
function $ce68a3edc3fc357d$export$be92b6f5f03c0fe9({ children: children }) {
    return $5NSbj.createElement($5NSbj.Fragment, null, children);
}
const $ce68a3edc3fc357d$export$fa1081225b99a9f2 = $ce68a3edc3fc357d$export$c5ba3739ffba980d((0, $f848676e0d96e999$export$62f3c66ae8dab8a3), $ce68a3edc3fc357d$export$be92b6f5f03c0fe9);
function $ce68a3edc3fc357d$var$cssPrefix(value) {
    return $ce68a3edc3fc357d$export$195c4126907dde97((0, $f848676e0d96e999$export$5414719b40b8294f), value);
}
function $ce68a3edc3fc357d$export$4c260019440d418f({ toolbar: { buttons: buttons }, render: { buttonClose: buttonClose, iconClose: iconClose }, styles: styles }) {
    const { close: close, setToolbarWidth: setToolbarWidth } = $ce68a3edc3fc357d$export$e8c786024a2b0a79();
    const { setContainerRef: setContainerRef, containerRect: containerRect } = $ce68a3edc3fc357d$export$b1d85de58d38d09d();
    $ce68a3edc3fc357d$export$e5c5a5f917a5871c(()=>{
        setToolbarWidth(containerRect === null || containerRect === void 0 ? void 0 : containerRect.width);
    }, [
        setToolbarWidth,
        containerRect === null || containerRect === void 0 ? void 0 : containerRect.width
    ]);
    const renderCloseButton = ()=>{
        if (buttonClose) return buttonClose();
        return $5NSbj.createElement($ce68a3edc3fc357d$export$c25acd513dcc8062, {
            key: (0, $f848676e0d96e999$export$493a596486210a21),
            label: "Close",
            icon: $ce68a3edc3fc357d$export$cae179f078f4b4a4,
            renderIcon: iconClose,
            onClick: close
        });
    };
    return $5NSbj.createElement("div", {
        ref: setContainerRef,
        style: styles.toolbar,
        className: $ce68a3edc3fc357d$export$1283875077dc8f0a($ce68a3edc3fc357d$var$cssPrefix())
    }, buttons === null || buttons === void 0 ? void 0 : buttons.map((button)=>button === (0, $f848676e0d96e999$export$493a596486210a21) ? renderCloseButton() : button));
}
const $ce68a3edc3fc357d$export$d0a9743c06e42ce8 = $ce68a3edc3fc357d$export$c5ba3739ffba980d((0, $f848676e0d96e999$export$5414719b40b8294f), $ce68a3edc3fc357d$export$4c260019440d418f);
function $ce68a3edc3fc357d$var$renderNode(node, props) {
    var _a;
    return $5NSbj.createElement(node.module.component, {
        key: node.module.name,
        ...props
    }, (_a = node.children) === null || _a === void 0 ? void 0 : _a.map((child)=>$ce68a3edc3fc357d$var$renderNode(child, props)));
}
function $ce68a3edc3fc357d$var$mergeAnimation(defaultAnimation, animation = {}) {
    const { easing: defaultAnimationEasing, ...restDefaultAnimation } = defaultAnimation;
    const { easing: easing, ...restAnimation } = animation;
    return {
        easing: {
            ...defaultAnimationEasing,
            ...easing
        },
        ...restDefaultAnimation,
        ...restAnimation
    };
}
function $ce68a3edc3fc357d$export$7d2670a66155874b({ carousel: carousel, animation: animation, render: render, toolbar: toolbar, controller: controller, noScroll: noScroll, on: on, plugins: plugins, slides: slides, index: index, ...restProps }) {
    const { animation: defaultAnimation, carousel: defaultCarousel, render: defaultRender, toolbar: defaultToolbar, controller: defaultController, noScroll: defaultNoScroll, on: defaultOn, slides: defaultSlides, index: defaultIndex, plugins: defaultPlugins, ...restDefaultProps } = $ce68a3edc3fc357d$export$d626463445cef3e9;
    const { config: config, augmentation: augmentation } = $ce68a3edc3fc357d$export$bc996c07eb970c78([
        $ce68a3edc3fc357d$export$270e7ba5936d3c48($ce68a3edc3fc357d$export$f2a0761442face5c, [
            $ce68a3edc3fc357d$export$270e7ba5936d3c48($ce68a3edc3fc357d$export$7ded5f1cd4840ad, [
                $ce68a3edc3fc357d$export$270e7ba5936d3c48($ce68a3edc3fc357d$export$be59d34228c8ec8a, [
                    $ce68a3edc3fc357d$export$270e7ba5936d3c48($ce68a3edc3fc357d$export$9c087759a323a56c),
                    $ce68a3edc3fc357d$export$270e7ba5936d3c48($ce68a3edc3fc357d$export$d0a9743c06e42ce8),
                    $ce68a3edc3fc357d$export$270e7ba5936d3c48($ce68a3edc3fc357d$export$6c16e1ac15089858)
                ])
            ])
        ])
    ], plugins || defaultPlugins);
    const props = augmentation({
        animation: $ce68a3edc3fc357d$var$mergeAnimation(defaultAnimation, animation),
        carousel: {
            ...defaultCarousel,
            ...carousel
        },
        render: {
            ...defaultRender,
            ...render
        },
        toolbar: {
            ...defaultToolbar,
            ...toolbar
        },
        controller: {
            ...defaultController,
            ...controller
        },
        noScroll: {
            ...defaultNoScroll,
            ...noScroll
        },
        on: {
            ...defaultOn,
            ...on
        },
        ...restDefaultProps,
        ...restProps
    });
    if (!props.open) return null;
    return $5NSbj.createElement($ce68a3edc3fc357d$export$7141a340a3dea601, {
        ...props
    }, $5NSbj.createElement($ce68a3edc3fc357d$export$62d2e1d2e7609988, {
        slides: slides || defaultSlides,
        index: $ce68a3edc3fc357d$export$5f87784a266e50a4(index || defaultIndex)
    }, $5NSbj.createElement($ce68a3edc3fc357d$export$9d9954f5885fa393, null, $5NSbj.createElement($ce68a3edc3fc357d$export$686accdd53ac150f, null, $5NSbj.createElement($ce68a3edc3fc357d$export$e41a845d3e53ea09, null, $ce68a3edc3fc357d$var$renderNode($ce68a3edc3fc357d$export$270e7ba5936d3c48($ce68a3edc3fc357d$export$fa1081225b99a9f2, config), props))))));
}


// TODO: do the search highlights client-side
function $d62108d7ab77513c$var$reHighlight(text) {
    return text.split(/<span class="found">(.+?)<\/span>/).map((n, i)=>i % 2 == 0 ? n : /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
            className: "found",
            children: n
        }, i));
}
function $d62108d7ab77513c$var$setupLightbox({ element: element, setSlides: setSlides, setSelectedPhotoIndex: setSelectedPhotoIndex }) {
    const images = element.querySelectorAll('a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], a[href$=".jpg:large"], a[href$=".jpeg:large"], a[href$=".png:large"], a[href$=".gif:large"]');
    setSlides(Array.from(images).map((link, index)=>{
        link.addEventListener('click', (event)=>{
            event.preventDefault();
            setSelectedPhotoIndex(index);
        });
        return {
            src: link.getAttribute('href')
        };
    }));
}
function $d62108d7ab77513c$var$stopPropagation(event) {
    event.stopPropagation();
}
function $d62108d7ab77513c$var$forceLoadImages(content) {
    content.querySelectorAll('img').forEach((img)=>{
        img.setAttribute('src', img.getAttribute('data-selfoss-src'));
    });
}
// React will prevent the default action when it bubbles to our callbacks.
// Let’s stop bubbling for links.
// https://medium.com/peloton-engineering/onclick-wat-51331718ba9
function $d62108d7ab77513c$var$fixLinkBubbling(content) {
    content.querySelectorAll('a').forEach((a)=>{
        a.addEventListener('click', (event)=>{
            event.stopPropagation();
        });
    });
}
// Prevent passing referrer info when opening a link.
function $d62108d7ab77513c$var$sanitizeContent(content) {
    content.querySelectorAll('a').forEach((a)=>{
        const oldRel = a.getAttribute('rel');
        a.setAttribute('rel', 'noreferrer' + (oldRel ? ' ' + oldRel : ''));
        // Ensure links inside item content are opened in new tab/window.
        a.setAttribute('target', '_blank');
    });
}
function $d62108d7ab77513c$var$handleKeyUp(event) {
    // emulate clicking when using keyboard
    if (event.keyCode === 13) {
        // ENTER key
        event.currentTarget.click();
        event.preventDefault();
        event.stopPropagation();
    }
}
function $d62108d7ab77513c$var$preventDefaultOnSmartphone(event) {
    // We want to use the whole title as action for opening/closing items
    // and smartphones have separate buttons for opening the article anyway.
    if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isSmartphone()) event.preventDefault();
}
// Handle closing fullscreen on mobile
function $d62108d7ab77513c$var$closeFullScreen({ event: event, navigate: navigate, location: location, entryId: entryId }) {
    event.preventDefault();
    event.stopPropagation();
    (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.setEntryExpanded(entryId, false);
    navigate((0, $dcbcccfe7d0a797a$export$7f0beea2aa79e4fa)(location, {
        id: null
    }), {
        replace: true
    });
}
// show/hide entry
function $d62108d7ab77513c$var$handleClick({ event: event, navigate: navigate, location: location, expanded: expanded, id: id, target: target }) {
    const expected = (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isMobile() ? '.entry' : '.entry-title';
    if (target !== expected) return;
    event.preventDefault();
    event.stopPropagation();
    if (expanded) {
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.setSelectedEntry(id);
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.deactivateEntry(id);
        navigate((0, $dcbcccfe7d0a797a$export$7f0beea2aa79e4fa)(location, {
            id: null
        }), {
            replace: true
        });
    } else {
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.activateEntry(id);
        navigate((0, $dcbcccfe7d0a797a$export$7f0beea2aa79e4fa)(location, {
            id: id.toString()
        }), {
            replace: true
        });
    }
}
// load images
function $d62108d7ab77513c$var$loadImages({ event: event, setImagesLoaded: setImagesLoaded, contentBlock: contentBlock }) {
    event.preventDefault();
    event.stopPropagation();
    $d62108d7ab77513c$var$forceLoadImages(contentBlock.current);
    setImagesLoaded(true);
}
// next item on tablet and smartphone
function $d62108d7ab77513c$var$openNext(event) {
    event.preventDefault();
    event.stopPropagation();
    // TODO: Figure out why it does not work when run immediately.
    requestAnimationFrame(()=>{
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.nextPrev((0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).NEXT, true);
    });
}
function $d62108d7ab77513c$var$ShareButton(props) {
    const { label: label, icon: icon, item: item, action: action, showLabel: showLabel = true } = props;
    const shareOnClick = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        action({
            id: item.id,
            url: item.link,
            // TODO: remove HTML
            title: item.title
        });
    }, [
        item,
        action
    ]);
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
        type: "button",
        className: "entry-share",
        title: label,
        "aria-label": label,
        onClick: shareOnClick,
        children: [
            icon,
            " ",
            showLabel ? label : null
        ]
    });
}
function $d62108d7ab77513c$var$ItemTag(props) {
    const { tag: tag, color: color } = props;
    const style = (0, $5NSbj.useMemo)(()=>({
            color: color.foreColor,
            backgroundColor: color.backColor
        }), [
        color
    ]);
    const location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    const link = (0, $5NSbj.useMemo)(()=>(0, $dcbcccfe7d0a797a$export$d0bb2ab5375d1521)(location, {
            category: `tag-${tag}`,
            id: null
        }), [
        tag,
        location
    ]);
    const forceReload = (0, $dcbcccfe7d0a797a$export$6bccca1b7088ecd7)();
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $1b28ddd4ebfaf955$export$a6c7ac8248d6e38a), {
        className: "entry-tags-tag",
        style: style,
        to: link,
        onClick: $d62108d7ab77513c$var$preventDefaultOnSmartphone,
        state: forceReload,
        children: tag
    });
}
/**
 * Converts Date to a relative string.
 * When the date is too old, null is returned instead.
 * @return {?String} relative time reference
 */ function $d62108d7ab77513c$var$datetimeRelative(currentTime, datetime, _) {
    const ageInseconds = (currentTime.getTime() - datetime.getTime()) / 1000;
    const ageInMinutes = ageInseconds / 60;
    const ageInHours = ageInMinutes / 60;
    const ageInDays = ageInHours / 24;
    if (ageInHours < 1) return _('minutes', {
        '0': Math.round(ageInMinutes).toString()
    });
    else if (ageInDays < 1) return _('hours', {
        '0': Math.round(ageInHours).toString()
    });
    else return null;
}
function $d62108d7ab77513c$export$2e2bcd8739ae039(props) {
    const { currentTime: currentTime, item: item, selected: selected, expanded: expanded, setNavExpanded: setNavExpanded, showError: showError } = props;
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    const { title: title, author: author, sourcetitle: sourcetitle } = item;
    const configuration = (0, $5NSbj.use)((0, $b7416e8649ee66da$export$326f6d1b69f1c06e));
    const shouldAutoLoadImages = !(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isMobile() || configuration.loadImagesOnMobile;
    const [imagesLoaded, setImagesLoaded] = (0, $5NSbj.useState)(shouldAutoLoadImages);
    const contentBlock = (0, $5NSbj.useRef)(null);
    const location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    const navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    const relDate = (0, $5NSbj.useMemo)(()=>$d62108d7ab77513c$var$datetimeRelative(currentTime, item.datetime, _), [
        currentTime,
        item.datetime,
        _
    ]);
    const [slides, setSlides] = (0, $5NSbj.useState)([]);
    const [selectedPhotoIndex, setSelectedPhotoIndex] = (0, $5NSbj.useState)(null);
    const fullScreenTrap = (0, $5NSbj.useRef)(null);
    // This should match scenarios where fullScreenTrap is set.
    const usingFocusTrap = expanded && (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isSmartphone();
    const setExpanded = (0, $5NSbj.useEffectEvent)((expanded)=>{
        // Handle entry becoming/ceasing to be expanded.
        const parent = document.querySelector(`.entry[data-entry-id="${item.id}"]`);
        if (expanded) {
            const firstExpansion = contentBlock.current.childElementCount === 0;
            if (firstExpansion) {
                contentBlock.current.innerHTML = item.content;
                $d62108d7ab77513c$var$sanitizeContent(contentBlock.current);
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).extensionPoints.processItemContents(contentBlock.current);
                // load images not on mobile devices
                if (shouldAutoLoadImages) $d62108d7ab77513c$var$forceLoadImages(contentBlock.current);
            }
            if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isSmartphone()) {
                // save scroll position
                let scrollTop = window.scrollY;
                setNavExpanded((expanded)=>{
                    // hide nav
                    if (expanded) {
                        scrollTop = scrollTop - document.querySelector('#nav').getBoundingClientRect().height;
                        scrollTop = scrollTop < 0 ? 0 : scrollTop;
                        window.scrollTo({
                            top: scrollTop
                        });
                        return false;
                    }
                    return expanded;
                });
                // show fullscreen
                document.body.classList.add('fullscreen-mode');
                const trap = (0, $66c441288a5fbbb7$export$360440dfcba94c00)(parent);
                fullScreenTrap.current = trap;
                trap.activate();
                if (firstExpansion) $d62108d7ab77513c$var$fixLinkBubbling(contentBlock.current);
            } else {
                if (firstExpansion) // setup fancyBox image viewer
                $d62108d7ab77513c$var$setupLightbox({
                    element: contentBlock.current,
                    setSlides: setSlides,
                    setSelectedPhotoIndex: setSelectedPhotoIndex
                });
                // scroll to article header
                if (configuration.scrollToArticleHeader) parent.scrollIntoView();
                if (firstExpansion) // turn of column view if entry is too long
                requestAnimationFrame(()=>{
                    // Delayed into next frame so that the entry is expanded when the height is being determined.
                    if (contentBlock.current.getBoundingClientRect().height > document.body.clientHeight) {
                        const entryContent = contentBlock.current.parentNode;
                        entryContent.classList.add('entry-content-nocolumns');
                    }
                });
            }
        } else {
            // No longer expanded.
            if (fullScreenTrap.current !== null) {
                fullScreenTrap.current.deactivate();
                fullScreenTrap.current = null;
            }
            document.body.classList.remove('fullscreen-mode');
            // Handle autoHideReadOnMobile setting.
            if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isSmartphone()) {
                const autoHideReadOnMobile = configuration.autoHideReadOnMobile && item.unread;
                if (autoHideReadOnMobile && !item.unread) (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.setEntries((entries)=>entries.filter(({ id: id })=>id !== item.id));
            }
        }
    });
    (0, $5NSbj.useEffect)(()=>{
        setExpanded(expanded);
    }, [
        expanded
    ]);
    const entryOnClick = (0, $5NSbj.useCallback)((event)=>$d62108d7ab77513c$var$handleClick({
            event: event,
            navigate: navigate,
            location: location,
            expanded: expanded,
            id: item.id,
            target: '.entry'
        }), [
        navigate,
        location,
        expanded,
        item.id
    ]);
    const titleOnClick = (0, $5NSbj.useCallback)((event)=>$d62108d7ab77513c$var$handleClick({
            event: event,
            navigate: navigate,
            location: location,
            expanded: expanded,
            id: item.id,
            target: '.entry-title'
        }), [
        navigate,
        location,
        expanded,
        item.id
    ]);
    const starOnClick = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.markEntryStarred(item.id, !item.starred);
    }, [
        item
    ]);
    const markReadOnClick = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.markEntryRead(item.id, item.unread);
    }, [
        item
    ]);
    const loadImagesOnClick = (0, $5NSbj.useCallback)((event)=>$d62108d7ab77513c$var$loadImages({
            event: event,
            setImagesLoaded: setImagesLoaded,
            contentBlock: contentBlock
        }), []);
    const closeOnClick = (0, $5NSbj.useCallback)((event)=>$d62108d7ab77513c$var$closeFullScreen({
            event: event,
            navigate: navigate,
            location: location,
            entryId: item.id
        }), [
        navigate,
        location,
        item.id
    ]);
    const titleHtml = (0, $5NSbj.useMemo)(()=>({
            __html: title ? title : _('no_title')
        }), [
        title,
        _
    ]);
    const sourceLink = (0, $5NSbj.useMemo)(()=>(0, $dcbcccfe7d0a797a$export$d0bb2ab5375d1521)(location, {
            category: `source-${item.source}`,
            id: null
        }), [
        item.source,
        location
    ]);
    const forceReload = (0, $dcbcccfe7d0a797a$export$6bccca1b7088ecd7)();
    const canWrite = (0, $fa4deecc6161d7ee$export$b416b77cd328c02f)();
    const sharers = (0, $347fb6369c29cad3$export$aebedbd51beb48eb)({
        configuration: configuration,
        showError: showError,
        _: _
    });
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
        "data-entry-id": item.id,
        "data-entry-source": item.source,
        "data-entry-url": item.link,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
            entry: true,
            unread: item.unread,
            expanded: expanded,
            selected: selected
        }),
        role: "article",
        "aria-modal": usingFocusTrap,
        onClick: entryOnClick,
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("a", {
                href: item.link,
                className: "entry-icon",
                tabIndex: -1,
                rel: "noreferrer",
                "aria-hidden": "true",
                onClick: $d62108d7ab77513c$var$preventDefaultOnSmartphone,
                children: item.icon !== null && item.icon.trim().length > 0 && item.icon != '0' ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("img", {
                    src: `favicons/${item.icon}`,
                    "aria-hidden": "true",
                    alt: ""
                }) : null
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h3", {
                className: "entry-title",
                onClick: titleOnClick,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                    className: "entry-title-link",
                    "aria-expanded": expanded,
                    "aria-current": selected,
                    role: "link",
                    tabIndex: 0,
                    onKeyUp: $d62108d7ab77513c$var$handleKeyUp,
                    dangerouslySetInnerHTML: titleHtml
                })
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                className: "entry-tags",
                children: Object.entries(item.tags).map(([tag, color])=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($d62108d7ab77513c$var$ItemTag, {
                        tag: tag,
                        color: color
                    }, tag))
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $1b28ddd4ebfaf955$export$a6c7ac8248d6e38a), {
                className: "entry-source",
                to: sourceLink,
                onClick: $d62108d7ab77513c$var$preventDefaultOnSmartphone,
                state: forceReload,
                children: $d62108d7ab77513c$var$reHighlight(sourcetitle)
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                className: "entry-separator",
                children: "\u2022"
            }),
            author !== null ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $fcda9d1f1901e894$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "entry-author",
                        children: author
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "entry-separator",
                        children: "\u2022"
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("a", {
                href: item.link,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                    'entry-datetime': true,
                    timestamped: relDate === null
                }),
                target: "_blank",
                rel: "noreferrer",
                onClick: $d62108d7ab77513c$var$preventDefaultOnSmartphone,
                children: relDate !== null ? relDate : item.datetime.toLocaleString()
            }),
            configuration.readingSpeed !== null ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $fcda9d1f1901e894$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "entry-separator",
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "entry-readtime",
                        children: _('article_reading_time', {
                            '0': Math.round(item.wordCount / configuration.readingSpeed)
                        })
                    })
                ]
            }) : null,
            item.thumbnail && item.thumbnail.trim().length > 0 ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                    'entry-thumbnail': true,
                    'entry-thumbnail-always-visible': configuration.showThumbnails
                }),
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("a", {
                    href: item.link,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("img", {
                        src: `thumbnails/${item.thumbnail}`,
                        alt: item.strippedTitle
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                    'entry-content': true,
                    'entry-content-nocolumns': item.lengthWithoutTags < 500
                }),
                children: [
                    slides.length !== 0 && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ce68a3edc3fc357d$export$7d2670a66155874b), {
                        open: selectedPhotoIndex !== null,
                        index: selectedPhotoIndex,
                        close: ()=>setSelectedPhotoIndex(null),
                        carousel: {
                            finite: true
                        },
                        controller: {
                            closeOnBackdropClick: true
                        },
                        on: {
                            entered: ()=>(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).lightboxActive.update(true),
                            exited: ()=>(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).lightboxActive.update(false)
                        },
                        slides: slides
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                        ref: contentBlock
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                        className: "entry-smartphone-share",
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
                            "aria-label": _('article_actions'),
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("a", {
                                        href: item.link,
                                        className: "entry-newwindow",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        accessKey: "o",
                                        onClick: $d62108d7ab77513c$var$stopPropagation,
                                        children: [
                                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                                                icon: $4f6e76a0ad832aa1$exports.faExternalLinkAlt
                                            }),
                                            ' ',
                                            _('open_window')
                                        ]
                                    })
                                }),
                                sharers.map(({ key: key, label: label, icon: icon, action: action })=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($d62108d7ab77513c$var$ShareButton, {
                                            label: label,
                                            icon: icon,
                                            item: item,
                                            action: action
                                        })
                                    }, key)),
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                                        type: "button",
                                        accessKey: "n",
                                        className: "entry-next",
                                        onClick: $d62108d7ab77513c$var$openNext,
                                        children: [
                                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                                                icon: $e4ff5d82615e7815$exports.faArrowRight
                                            }),
                                            ' ',
                                            _('next')
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
                "aria-label": _('article_actions'),
                className: "entry-toolbar",
                children: [
                    canWrite && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                            accessKey: "a",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                'entry-starr': true,
                                active: item.starred
                            }),
                            onClick: starOnClick,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                                    icon: item.starred ? $2d6ef9374862f0b1$exports.faStar : $1e8ca391384385ce$exports.faStar
                                }),
                                ' ',
                                item.starred ? _('unstar') : _('star')
                            ]
                        })
                    }),
                    canWrite && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                            accessKey: "u",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                'entry-unread': true,
                                active: item.unread
                            }),
                            onClick: markReadOnClick,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                                    icon: item.unread ? $8e226679142db257$exports.faCheckCircle : $154f2d6577c9bf5d$exports.faCheckCircle
                                }),
                                ' ',
                                item.unread ? _('mark') : _('unmark')
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("a", {
                            href: item.link,
                            className: "entry-newwindow",
                            target: "_blank",
                            rel: "noreferrer",
                            accessKey: "o",
                            onClick: $d62108d7ab77513c$var$stopPropagation,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                                    icon: $4f6e76a0ad832aa1$exports.faExternalLinkAlt
                                }),
                                ' ',
                                _('open_window')
                            ]
                        })
                    }),
                    !imagesLoaded ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                            className: "entry-loadimages",
                            onClick: loadImagesOnClick,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                                    icon: $2feb01c0637ffeff$exports.faArrowAltCircleDown
                                }),
                                ' ',
                                _('load_img')
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                            type: "button",
                            accessKey: "n",
                            className: "entry-next",
                            onClick: $d62108d7ab77513c$var$openNext,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                                    icon: $e4ff5d82615e7815$exports.faArrowRight
                                }),
                                " ",
                                _('next')
                            ]
                        })
                    }),
                    sharers.map(({ key: key, label: label, icon: icon, action: action })=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($d62108d7ab77513c$var$ShareButton, {
                                label: label,
                                icon: icon,
                                item: item,
                                action: action,
                                showLabel: false
                            })
                        }, key)),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                            accessKey: "c",
                            className: "entry-close",
                            onClick: closeOnClick,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                                    icon: $72abcd8059f7a937$exports.faTimesCircle
                                }),
                                ' ',
                                _('close_entry')
                            ]
                        })
                    })
                ]
            })
        ]
    });
}





function $e7889816bf1934b6$var$safeDate(datetimeString) {
    const date = new Date(datetimeString);
    if (isNaN(date.valueOf())) throw new Error(`Invalid date detected: \u{201C}${datetimeString}\u{201D}`);
    else return date;
}
function $e7889816bf1934b6$export$8ce663b0c6b2535e(ids) {
    return $0081a42221085bd6$export$299ba2dee77727e9('mark', {
        headers: {
            'content-type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify(ids)
    }).promise.then((response)=>response.json());
}
function $e7889816bf1934b6$export$d11ee7cd6d3f95d4(id, starr) {
    return $0081a42221085bd6$export$299ba2dee77727e9(`${starr ? 'starr' : 'unstarr'}/${id}`).promise.then((response)=>response.json());
}
function $e7889816bf1934b6$export$bf7f2fce5c1cf636(id, read) {
    return $0081a42221085bd6$export$299ba2dee77727e9(`${read ? 'unmark' : 'mark'}/${id}`).promise.then((response)=>response.json());
}
/**
 * Converts some values like dates in an entry into a objects.
 */ function $e7889816bf1934b6$var$enrichItem(entry) {
    return {
        ...entry,
        link: (0, $ec6aeee77f582aff$export$e8bacd2802a88316)(entry.link),
        datetime: $e7889816bf1934b6$var$safeDate(entry.datetime),
        updatetime: entry.updatetime !== null ? $e7889816bf1934b6$var$safeDate(entry.updatetime) : null
    };
}
/**
 * Converts some values like dates in response into a objects.
 */ function $e7889816bf1934b6$var$enrichItemsResponse(data) {
    return {
        ...data,
        lastUpdate: data.lastUpdate !== null ? $e7889816bf1934b6$var$safeDate(data.lastUpdate) : null,
        entries: data.entries.map($e7889816bf1934b6$var$enrichItem)
    };
}
function $e7889816bf1934b6$export$d2f92acf417bbf5d(filter, abortController) {
    return $0081a42221085bd6$export$3988ae62b71be9a3('', {
        body: $0081a42221085bd6$export$92871f7982deaf9f({
            ...filter,
            fromDatetime: filter.fromDatetime ? filter.fromDatetime.toISOString() : filter.fromDatetime
        }),
        abortController: abortController
    }).promise.then((response)=>response.json()).then($e7889816bf1934b6$var$enrichItemsResponse);
}
/**
 * Converts some values like dates in response into a objects.
 */ function $e7889816bf1934b6$var$enrichSyncResponse(data) {
    return {
        ...data,
        lastUpdate: data.lastUpdate !== null ? $e7889816bf1934b6$var$safeDate(data.lastUpdate) : null,
        newItems: data.newItems?.map($e7889816bf1934b6$var$enrichItem)
    };
}
function $e7889816bf1934b6$export$92d6409d68f0739a(updatedStatuses, syncParams) {
    const params = {
        ...syncParams,
        updatedStatuses: syncParams.updatedStatuses ? syncParams.updatedStatuses.map((status)=>{
            return {
                ...status,
                datetime: status.datetime.toISOString()
            };
        }) : syncParams.updatedStatuses,
        since: 'since' in syncParams ? syncParams.since.toISOString() : undefined,
        itemsNotBefore: 'itemsNotBefore' in syncParams ? syncParams.itemsNotBefore.toISOString() : undefined
    };
    const { controller: controller, promise: promise } = $0081a42221085bd6$export$e7aa7bc5c1b3cfb3('items/sync', {
        method: updatedStatuses ? 'POST' : 'GET',
        body: $0081a42221085bd6$export$92871f7982deaf9f(params)
    });
    return {
        controller: controller,
        promise: promise.then((response)=>response.json()).then($e7889816bf1934b6$var$enrichSyncResponse)
    };
}













function $903e325e4cd4f232$var$reloadList({ fetchParams: fetchParams, abortController: abortController, navigate: navigate, append: append = false, waitForSync: waitForSync = true, configuration: configuration, entryId: entryId = null, setLoadingState: setLoadingState, showError: showError, _: _ }) {
    if (abortController.signal.aborted) return Promise.resolve();
    if (entryId && fetchParams.fromId === undefined) fetchParams = {
        ...fetchParams,
        extraIds: [
            ...fetchParams.extraIds,
            entryId
        ]
    };
    if (!append || fetchParams.type !== (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).NEWEST) (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.olderEntriesOnline = false;
    setLoadingState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).LOADING);
    const reload = ()=>{
        if (abortController.signal.aborted) return Promise.resolve();
        const forceLoadOnline = (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.olderEntriesOnline || (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.shouldLoadEntriesOnline;
        // tag, source and search filtering not supported offline (yet?)
        const shouldFetch = fetchParams.tag || fetchParams.source || fetchParams.search || !(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.enableOffline.value || (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isOnline() && forceLoadOnline;
        const reloader = shouldFetch ? (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOnline.getEntries(fetchParams, abortController) : (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.getEntries(fetchParams);
        // Clean state when not just adding items.
        if (!append) {
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.setHasMore(false);
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.setExpandedEntries({});
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.setEntries([]);
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.setSelectedEntry(null);
        }
        setLoadingState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).LOADING);
        return reloader.then(({ entries: entries, hasMore: hasMore })=>{
            if (abortController.signal.aborted) return;
            setLoadingState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS);
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.setHasMore(hasMore);
            if (append) (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.appendEntries(entries);
            else {
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.setExpandedEntries({});
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.setEntries(entries);
                // open selected entry only if entry was requested (i.e. if not streaming
                // more)
                if (entryId && fetchParams.fromId === undefined) {
                    const entry = document.querySelector(`.entry[data-entry-id="${entryId}"]`);
                    if (!entry) return;
                    (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.activateEntry(entryId);
                    // ensure scrolling to requested entry even if scrolling to article
                    // header is disabled
                    if (!configuration.scrollToArticleHeader) // needs to be delayed for some reason
                    requestAnimationFrame(()=>{
                        entry.scrollIntoView();
                    });
                } else window.scrollTo({
                    top: 0
                });
            }
        }).catch((error)=>{
            if (abortController.signal.aborted) return;
            if (error instanceof (0, $b82622975d92f7af$export$65bd6083489bd8bb) && error.response.status === 403) {
                navigate('/sign/in', {
                    state: {
                        error: _('error_session_expired')
                    }
                });
                return;
            }
            setLoadingState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).FAILURE);
            showError(_('error_loading') + ' ' + error.message);
        });
    };
    if (waitForSync && (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOnline.syncing.promise) {
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.userWaiting = true;
        return (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOnline.syncing.promise.finally(reload);
    } else return reload();
}
/**
 * Try to open the selected article using the preferred method.
 */ function $903e325e4cd4f232$var$openSelectedArticle(selected) {
    const link = document.querySelector(`.entry[data-entry-id="${selected}"] .entry-datetime`);
    if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).config.openInBackgroundTab) {
        // In Chromium, this will just cause the tab to open in the foreground.
        // Appears to be disallowed by the pop-under prevention:
        // https://crbug.com/431335
        // https://crbug.com/487919
        const event = new MouseEvent('click', {
            ctrlKey: true
        });
        link.dispatchEvent(event);
    } else // open item in new window
    link.click();
}
// updates a source
function $903e325e4cd4f232$var$handleRefreshSource({ event: event, source: source, setLoadingState: setLoadingState, setNavExpanded: setNavExpanded, reload: reload, _: _ }) {
    event.preventDefault();
    // show loading
    setLoadingState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).LOADING);
    return $377e66b0ec5c5519$export$c1f8f7c408fa54a(source).then(()=>{
        // hide nav on smartphone
        setNavExpanded(false);
        // Fetch the new items and reload the list.
        // Will also clear the loading status.
        reload();
    }).catch((error)=>{
        setLoadingState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).FAILURE);
        alert(_('error_refreshing_source') + ' ' + error.message);
    });
}
function $903e325e4cd4f232$export$66d62ccfdff1c843(props) {
    const { entries: entries, hasMore: hasMore, loadingState: loadingState, setLoadingState: setLoadingState, selectedEntry: selectedEntry, expandedEntries: expandedEntries, setNavExpanded: setNavExpanded, navSourcesExpanded: navSourcesExpanded, reload: reload, setGlobalUnreadCount: setGlobalUnreadCount, unreadItemsCount: unreadItemsCount, showError: showError } = props;
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    const allowedToUpdate = (0, $fa4deecc6161d7ee$export$683005ba76038aff)();
    const allowedToWrite = (0, $fa4deecc6161d7ee$export$b416b77cd328c02f)();
    const configuration = (0, $5NSbj.use)((0, $b7416e8649ee66da$export$326f6d1b69f1c06e));
    const location = (0, $dcbcccfe7d0a797a$export$45d76561a5302f2b)();
    const navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    const forceReload = (0, $d30756b433a819bb$export$7bcdf1c247ef07b1)();
    const searchText = (0, $5NSbj.useMemo)(()=>{
        const queryString = new URLSearchParams(location.search);
        return queryString.get('search') ?? '';
    }, [
        location.search
    ]);
    const params = (0, $dcbcccfe7d0a797a$export$216385125ee84ae7)();
    const currentTag = params.category?.startsWith('tag-') ? params.category.replace(/^tag-/, '') : null;
    const currentSource = params.category?.startsWith('source-') ? parseInt(params.category.replace(/^source-/, ''), 10) : null;
    // The offsets for pagination.
    // Clear them when URL changes, except for when only id changes since that happens when reading.
    const [fromDatetime, setFromDatetime] = (0, $7f88ad86c77db2c7$exports.useStateWithDeps)(undefined, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]);
    const [fromId, setFromId] = (0, $7f88ad86c77db2c7$exports.useStateWithDeps)(undefined, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]);
    // Cache the item id from initial URL so that we can fetch it
    // but do not re-fetch when the id in the URI changes later
    // since that happens when reading.
    const initialItemId = (0, $5NSbj.useMemo)(()=>{
        return params.id;
    }, [
        params.filter,
        currentTag,
        currentSource,
        searchText,
        forceReload
    ]);
    // Same for the state of navigation being expanded.
    // It is only passed to the API request as a part of optimization scheme
    // so there is no need for it to trigger refresh of the entries.
    const initialNavSourcesExpanded = (0, $5NSbj.useMemo)(()=>{
        return navSourcesExpanded;
    }, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]);
    const [moreLoadingState, setMoreLoadingState] = (0, $5NSbj.useState)((0, $f5b3c040e086fbc1$export$62aa48085237e36f).INITIAL);
    const reloader = (0, $5NSbj.useEffectEvent)(async (fetchParams, abortController)=>{
        const append = fetchParams.fromId !== undefined || fetchParams.fromDatetime !== undefined;
        await $903e325e4cd4f232$var$reloadList({
            fetchParams: // Object with parameters for GET /items and similar API calls
            // based on the current location.
            fetchParams,
            abortController: abortController,
            navigate: navigate,
            append: append,
            configuration: configuration,
            // We do not want to focus the entry on successive loads.
            entryId: append ? undefined : initialItemId,
            setLoadingState: append ? setMoreLoadingState : setLoadingState,
            showError: showError,
            _: _
        });
        if (currentTag !== null && !(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.isValidTag(currentTag)) showError(_('error_unknown_tag') + ' ' + currentTag);
        if (currentSource !== null && !(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.isValidSource(currentSource)) showError(_('error_unknown_source') + ' ' + currentSource);
    });
    // Perform the scheduled reload.
    (0, $5NSbj.useEffect)(()=>{
        const abortController = new AbortController();
        const fetchParams = {
            type: params.filter,
            tag: currentTag,
            source: currentSource,
            extraIds: [],
            sourcesNav: initialNavSourcesExpanded,
            search: searchText,
            fromDatetime: fromDatetime,
            fromId: fromId
        };
        reloader(fetchParams, abortController);
        return ()=>{
            abortController.abort();
        };
    }, [
        params.filter,
        currentTag,
        currentSource,
        initialNavSourcesExpanded,
        searchText,
        fromDatetime,
        fromId,
        forceReload
    ]);
    (0, $5NSbj.useEffect)(()=>{
        // scroll load more
        const onScroll = ()=>{
            const streamMoreButton = document.querySelector('.stream-more');
            if (streamMoreButton === null) return;
            const streamMoreButtonTop = window.scrollY + streamMoreButton.getBoundingClientRect().top;
            // When “More” button appears on the screen, click it.
            if (streamMoreButtonTop < document.body.clientHeight + window.scrollY) streamMoreButton.click();
        };
        if (hasMore && moreLoadingState !== (0, $f5b3c040e086fbc1$export$62aa48085237e36f).LOADING && configuration.autoStreamMore) {
            window.addEventListener('scroll', onScroll);
            return ()=>{
                window.removeEventListener('scroll', onScroll);
            };
        }
    }, [
        configuration,
        hasMore,
        moreLoadingState
    ]);
    (0, $5NSbj.useEffect)(()=>{
        // setup periodic server status sync
        const interval = window.setInterval((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.sync, 60000);
        return ()=>{
            window.clearInterval(interval);
        };
    }, []);
    (0, $5NSbj.useEffect)(()=>{
        setGlobalUnreadCount(unreadItemsCount);
        return ()=>{
            setGlobalUnreadCount(null);
        };
    }, [
        setGlobalUnreadCount,
        unreadItemsCount
    ]);
    const isOnline = (0, $875b08fe0af98e08$export$6feb6ada280bcdab)();
    const refreshOnClick = (0, $5NSbj.useCallback)((event)=>$903e325e4cd4f232$var$handleRefreshSource({
            event: event,
            source: currentSource,
            setLoadingState: setLoadingState,
            setNavExpanded: setNavExpanded,
            reload: reload,
            _: _
        }), [
        currentSource,
        setLoadingState,
        setNavExpanded,
        reload,
        _
    ]);
    const moreOnClick = (0, $5NSbj.useCallback)((event)=>{
        event.preventDefault();
        const lastEntry = entries[entries.length - 1];
        // Calculate offset.
        setFromDatetime(lastEntry ? lastEntry.datetime : undefined);
        setFromId(lastEntry ? lastEntry.id : undefined);
    }, [
        entries,
        setFromDatetime,
        setFromId
    ]);
    // Current time for calculating relative dates in items.
    const [currentTime, setCurrentTime] = (0, $5NSbj.useState)(()=>new Date());
    (0, $5NSbj.useEffect)(()=>{
        const tick = window.setInterval(()=>{
            setCurrentTime(new Date());
        }, 60000);
        return ()=>{
            clearInterval(tick);
        };
    }, []);
    if (loadingState === (0, $f5b3c040e086fbc1$export$62aa48085237e36f).LOADING) return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $b6b0d4eaa4224082$export$84dbad74efe95918), {
        label: _('entries_loading')
    });
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $fcda9d1f1901e894$exports.Fragment), {
        children: [
            currentSource !== null && allowedToUpdate && isOnline ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                type: "button",
                className: "refresh-source",
                onClick: refreshOnClick,
                children: _('source_refresh')
            }) : null,
            currentSource !== null && allowedToWrite && isOnline ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $1b28ddd4ebfaf955$export$a6c7ac8248d6e38a), {
                to: {
                    pathname: '/manage/sources',
                    hash: `#source-${currentSource}`
                },
                className: "entries-go-to-settings",
                children: _('source_go_to_settings')
            }) : null,
            entries.map((entry)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $d62108d7ab77513c$export$2e2bcd8739ae039), {
                    item: entry,
                    currentTime: currentTime,
                    selected: selectedEntry == entry.id,
                    expanded: expandedEntries[entry.id] ?? false,
                    setNavExpanded: setNavExpanded,
                    showError: showError
                }, entry.id)),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                id: "stream-buttons",
                children: [
                    loadingState === (0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS && entries.length === 0 ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("p", {
                        "aria-live": "assertive",
                        className: "stream-empty",
                        children: _('no_entries')
                    }) : null,
                    hasMore ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                            'stream-button': true,
                            'stream-more': true
                        }),
                        accessKey: "m",
                        "aria-label": _('more'),
                        onClick: moreLoadingState !== (0, $f5b3c040e086fbc1$export$62aa48085237e36f).LOADING ? moreOnClick : null,
                        children: moreLoadingState !== (0, $f5b3c040e086fbc1$export$62aa48085237e36f).LOADING ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                            children: _('more')
                        }) : /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $b6b0d4eaa4224082$export$7f7cbe89f1eacd2), {
                            size: "3x",
                            label: _('entries_loading')
                        })
                    }) : null,
                    entries.length > 0 ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                        className: "stream-button mark-these-read",
                        "aria-label": _('markread'),
                        onClick: (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.markVisibleRead,
                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                            children: _('markread')
                        })
                    }) : null,
                    loadingState == (0, $f5b3c040e086fbc1$export$62aa48085237e36f).FAILURE ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                        className: "stream-button stream-error",
                        "aria-live": "assertive",
                        "aria-label": _('streamerror'),
                        onClick: reload,
                        children: _('streamerror')
                    }) : null
                ]
            })
        ]
    });
}
const $903e325e4cd4f232$var$initialState = {
    entries: [],
    hasMore: false,
    selectedEntry: null,
    expandedEntries: {},
    loadingState: (0, $f5b3c040e086fbc1$export$62aa48085237e36f).INITIAL
};
class $903e325e4cd4f232$export$9c61909d8ed47595 extends (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Component {
    constructor(props){
        super(props);
        this.state = $903e325e4cd4f232$var$initialState;
        this.reload = this.reload.bind(this);
        this.setLoadingState = this.setLoadingState.bind(this);
        this.activateEntry = this.activateEntry.bind(this);
        this.deactivateEntry = this.deactivateEntry.bind(this);
        this.markVisibleRead = this.markVisibleRead.bind(this);
        this.markEntryRead = this.markEntryRead.bind(this);
        this.markEntryStarred = this.markEntryStarred.bind(this);
        this.nextPrev = this.nextPrev.bind(this);
        this.entryNav = this.entryNav.bind(this);
        this.jumpToNext = this.jumpToNext.bind(this);
        this.toggleSelectedStarred = this.toggleSelectedStarred.bind(this);
        this.toggleSelectedRead = this.toggleSelectedRead.bind(this);
        this.toggleSelectedExpanded = this.toggleSelectedExpanded.bind(this);
        this.openSelectedTarget = this.openSelectedTarget.bind(this);
        this.openSelectedTargetAndMarkRead = this.openSelectedTargetAndMarkRead.bind(this);
        this.throw = this.throw.bind(this);
    }
    setEntries(entries) {
        if (typeof entries === 'function') this.setState((state)=>({
                entries: entries(state.entries)
            }));
        else this.setState({
            entries: entries
        });
    }
    appendEntries(extraEntries) {
        this.setEntries((entries)=>[
                ...entries,
                ...extraEntries
            ]);
    }
    /**
     * Make the given entry currently selected one.
     */ setSelectedEntry(selectedEntry) {
        if (typeof selectedEntry === 'function') this.setState((state)=>({
                selectedEntry: selectedEntry(state.selectedEntry)
            }));
        else this.setState({
            selectedEntry: selectedEntry
        });
    }
    /**
     * Get the currently selected entry.
     */ getSelectedEntry() {
        return this.state.selectedEntry;
    }
    setExpandedEntries(expandedEntries) {
        if (typeof expandedEntries === 'function') this.setState((state)=>({
                expandedEntries: expandedEntries(state.expandedEntries)
            }));
        else this.setState({
            expandedEntries: expandedEntries
        });
    }
    setEntryExpanded(id, expand) {
        if (typeof expand === 'function') this.setExpandedEntries((oldEntries)=>({
                ...oldEntries,
                [id]: expand(oldEntries[id] ?? false)
            }));
        else this.setExpandedEntries((oldEntries)=>({
                ...oldEntries,
                [id]: expand
            }));
    }
    /**
     * Collapse all expanded entries.
     */ collapseAllEntries() {
        this.setExpandedEntries({});
    }
    /**
     * Is entry with given id expanded?
     */ isEntryExpanded(id) {
        return this.state.expandedEntries[id] ?? false;
    }
    /**
     * Toggle expanded state of entry with given id.
     */ toggleEntryExpanded(id) {
        if (!id) return;
        this.setEntryExpanded(id, (expanded)=>!(expanded ?? false));
    }
    /**
     * Activate entry as if it were clicked.
     * This will open it, focus it and based on the settings, mark it as read.
     */ activateEntry(id) {
        if (this.props.configuration.autoCollapse) this.collapseAllEntries();
        this.setSelectedEntry(id);
        // show/hide (with toolbar)
        this.setEntryExpanded(id, true);
        // automark as read
        const entry = this.state.entries.find((entry)=>id === entry.id);
        const autoMarkAsRead = (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isAllowedToWrite() && this.props.configuration.autoMarkAsRead && entry.unread;
        if (autoMarkAsRead) this.markEntryRead(id, true);
    }
    /**
     * Deactivate entry, as if it were clicked.
     * This will close it and maybe something more.
     */ deactivateEntry(id) {
        this.setEntryExpanded(id, false);
    }
    starEntryInView(id, starred) {
        this.setEntries((entries)=>entries.map((entry)=>{
                if (entry.id === id) return {
                    ...entry,
                    starred: starred
                };
                else return entry;
            }));
    }
    markEntryInView(id, unread) {
        this.setEntries((entries)=>entries.map((entry)=>{
                if (entry.id === id) return {
                    ...entry,
                    unread: unread
                };
                else return entry;
            }));
    }
    refreshEntryStatuses(entryStatuses) {
        this.state.entries.forEach((entry)=>{
            const { id: id } = entry;
            const newStatus = entryStatuses.find((entryStatus)=>entryStatus.id == id);
            if (newStatus) {
                this.starEntryInView(id, newStatus.starred);
                this.markEntryInView(id, newStatus.unread);
            }
        });
    }
    setHasMore(hasMore) {
        if (typeof hasMore === 'function') this.setState((state)=>({
                hasMore: hasMore(state.hasMore)
            }));
        else this.setState({
            hasMore: hasMore
        });
    }
    setLoadingState(loadingState) {
        if (typeof loadingState === 'function') this.setState((state)=>({
                loadingState: loadingState(state.loadingState)
            }));
        else this.setState({
            loadingState: loadingState
        });
    }
    getActiveTag() {
        const category = this.props.params?.category;
        if (!category) return null;
        return category.startsWith('tag-') ? category.replace(/^tag-/, '') : null;
    }
    getActiveSource() {
        const category = this.props.params?.category;
        if (!category) return null;
        return category.startsWith('source-') ? parseInt(category.replace(/^source-/, ''), 10) : null;
    }
    getActiveFilter() {
        return this.props.params?.filter;
    }
    /**
     * Mark all visible items as read
     */ markVisibleRead() {
        const ids = [];
        const tagUnreadDiff = {};
        const sourceUnreadDiff = {};
        let markedEntries = this.state.entries.map((entry)=>{
            if (!entry.unread) return entry;
            ids.push(entry.id);
            Object.keys(entry.tags).forEach((tag)=>{
                if (Object.keys(tagUnreadDiff).includes(tag)) tagUnreadDiff[tag] += -1;
                else tagUnreadDiff[tag] = -1;
            });
            const { source: source } = entry;
            if (Object.keys(sourceUnreadDiff).includes(source.toString())) sourceUnreadDiff[source] += -1;
            else sourceUnreadDiff[source] = -1;
            return {
                ...entry,
                unread: false
            };
        });
        const oldEntries = this.state.entries;
        const hadMore = this.state.hasMore;
        // close opened entry and list
        this.setExpandedEntries({});
        this.props.setNavExpanded(false);
        if (this.props.params.filter === (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).UNREAD) markedEntries = [];
        this.setLoadingState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).LOADING);
        this.setEntries(markedEntries);
        // update statistics in main menu
        const updateStats = (markRead)=>{
            // update all unread counters
            const unreadstats = (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.state.unreadItemsCount;
            const diff = markRead ? -1 : 1;
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).refreshUnread(unreadstats + diff * ids.length);
            // update unread on tags and sources
            if (markRead) (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.refreshTagSourceUnread(tagUnreadDiff, sourceUnreadDiff);
            else // Diffs are negative by default.
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.refreshTagSourceUnread(Object.fromEntries(Object.entries(tagUnreadDiff).map(([tag, diff])=>[
                    tag,
                    -1 * diff
                ])), Object.fromEntries(Object.entries(sourceUnreadDiff).map(([source, diff])=>[
                    source,
                    -1 * diff
                ])));
        };
        updateStats(true);
        if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.enableOffline.value) (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.entriesMark(ids, false);
        $e7889816bf1934b6$export$8ce663b0c6b2535e(ids).then(()=>{
            this.setLoadingState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS);
        }).catch((error)=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).handleAjaxError(error).then(()=>{
                const statusName = 'unread';
                const statuses = ids.map((id)=>({
                        entryId: id,
                        name: statusName,
                        value: false
                    }));
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.enqueueStatuses(statuses);
            }).catch((error)=>{
                if (error instanceof (0, $b82622975d92f7af$export$65bd6083489bd8bb) && error.response.status === 403) {
                    this.props.navigate('/sign/in', {
                        state: {
                            error: this.props._('error_session_expired')
                        }
                    });
                    return;
                }
                this.setLoadingState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS);
                this.setEntries(oldEntries);
                updateStats(false);
                this.setHasMore(hadMore);
                this.props.showError(this.props._('error_mark_items') + ' ' + error.message);
            });
        });
    }
    /**
     * Requests for an entry to be marked read/unread in the model.
     */ markEntryRead(id, markRead) {
        // only loggedin users
        if (!(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isAllowedToWrite()) {
            console.log('User not allowed to mark an entry (un)read.');
            return;
        }
        const entry = this.state.entries.find((entry)=>id === entry.id);
        const newReadState = markRead === 'toggle' ? entry.unread : markRead;
        this.markEntryInView(id, !newReadState);
        // update statistics in main menue and the currently active tag
        const updateStats = (markRead)=>{
            // update all unread counters
            const unreadstats = (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.state.unreadItemsCount;
            const diff = markRead ? -1 : 1;
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).refreshUnread(unreadstats + diff);
            // update unread on tags and sources
            // Only a single instance of each tag per entry so we can just assign.
            const entryTags = Object.fromEntries(Object.keys(entry.tags).map((tag)=>[
                    tag,
                    diff
                ]));
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.refreshTagSourceUnread(entryTags, {
                [entry.source]: diff
            });
        };
        updateStats(newReadState);
        if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.enableOffline.value) (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.entryMark(id, !newReadState);
        $e7889816bf1934b6$export$bf7f2fce5c1cf636(id, !newReadState).then(()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.setOnline();
        }).catch((error)=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).handleAjaxError(error).then(()=>{
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.enqueueStatus(id, 'unread', !newReadState);
            }).catch((error)=>{
                if (error instanceof (0, $b82622975d92f7af$export$65bd6083489bd8bb) && error.response.status === 403) {
                    this.props.navigate('/sign/in', {
                        state: {
                            error: this.props._('error_session_expired')
                        }
                    });
                    return;
                }
                // rollback ui changes
                this.markEntryInView(id, newReadState);
                updateStats(!newReadState);
                this.props.showError(this.props._('error_mark_item') + ' ' + error.message);
            });
        });
    }
    /**
     * Requests for an entry to be marked (un)starred in the model.
     */ markEntryStarred(id, markStarred) {
        // only loggedin users
        if (!(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isAllowedToWrite()) {
            console.log('User not allowed to (un)star an entry.');
            return;
        }
        let newStarredState;
        if (markStarred === 'toggle') {
            const entry = this.state.entries.find((entry)=>id === entry.id);
            newStarredState = !entry.starred;
        } else newStarredState = markStarred;
        this.starEntryInView(id, newStarredState);
        // update statistics in main menu
        const updateStats = (markStarred)=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setStarredItemsCount((starred)=>starred + (markStarred ? 1 : -1));
        };
        updateStats(newStarredState);
        if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.enableOffline.value) (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.entryStar(id, newStarredState);
        $e7889816bf1934b6$export$d11ee7cd6d3f95d4(id, newStarredState).then(()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.setOnline();
        }).catch((error)=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).handleAjaxError(error).then(()=>{
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.enqueueStatus(id, 'starred', newStarredState);
            }).catch((error)=>{
                if (error instanceof (0, $b82622975d92f7af$export$65bd6083489bd8bb) && error.response.status === 403) {
                    this.props.navigate('/sign/in', {
                        state: {
                            error: this.props._('error_session_expired')
                        }
                    });
                    return;
                }
                // rollback ui changes
                this.starEntryInView(id, !newStarredState);
                updateStats(!newStarredState);
                this.props.showError(this.props._('error_star_item') + ' ' + error.message);
            });
        });
    }
    reload() {
        /**
         * HACK: A counter that is increased every time reload action (r key) is triggered.
         */ this.props.navigate((0, $dcbcccfe7d0a797a$export$d0bb2ab5375d1521)(this.props.location, {
            id: null
        }), {
            replace: true,
            state: (0, $dcbcccfe7d0a797a$export$e64cf1b9b4b3aa56)(this.props.location)
        });
    }
    /**
     * get next/prev item
     */ nextPrev(direction, open = true) {
        if (direction != (0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).NEXT && direction != (0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).PREV) throw new Error('direction must be one of Direction.{PREV,NEXT}');
        // when there are no entries
        if (this.state.entries.length == 0) return;
        // select current
        const old = this.getSelectedEntry();
        const oldIndex = old !== null ? this.state.entries.findIndex(({ id: id })=>id === old) : null;
        let current = null;
        // select next/prev entry and save it to "current"
        // if we would overflow, we stay on the old one
        if (direction == (0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).NEXT) {
            if (old === null) current = this.state.entries[0].id;
            else {
                const nextIndex = oldIndex + 1;
                if (nextIndex >= this.state.entries.length) {
                    current = old;
                    // attempt to load more
                    document.querySelector('.stream-more')?.click();
                } else current = this.state.entries[nextIndex].id;
            }
        } else {
            if (old === null) return;
            else if (oldIndex <= 0) current = old;
            else current = this.state.entries[oldIndex - 1].id;
        }
        if (old !== current) {
            // remove active
            this.deactivateEntry(old);
            if (open) this.activateEntry(current);
            else this.setSelectedEntry(current);
            const currentElement = document.querySelector(`.entry[data-entry-id="${current}"]`);
            // scroll to element
            (0, $0b4b5bcd4750d386$export$d976747ecb966cea)(currentElement);
            // focus the title link for better keyboard navigation
            currentElement.querySelector('.entry-title-link').focus();
        }
    }
    /**
     * entry navigation (next/prev) with keys
     */ entryNav(direction) {
        if (direction != (0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).NEXT && direction != (0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).PREV) throw new Error('direction must be one of Direction.{PREV,NEXT}');
        const open = this.isEntryExpanded(this.getSelectedEntry());
        this.nextPrev(direction, open);
    }
    jumpToNext() {
        const selected = this.getSelectedEntry();
        if (selected !== null && !this.isEntryExpanded(selected)) this.activateEntry(selected);
        else this.nextPrev((0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).NEXT, true);
    }
    toggleSelectedStarred() {
        const selected = this.getSelectedEntry();
        if (selected !== null) this.markEntryStarred(selected, 'toggle');
    }
    toggleSelectedRead() {
        const selected = this.getSelectedEntry();
        if (selected !== null) this.markEntryRead(selected, 'toggle');
    }
    toggleSelectedExpanded() {
        this.toggleEntryExpanded(this.getSelectedEntry());
    }
    openSelectedTarget() {
        const selected = this.getSelectedEntry();
        if (selected !== null) $903e325e4cd4f232$var$openSelectedArticle(selected);
    }
    openSelectedTargetAndMarkRead() {
        const selected = this.getSelectedEntry();
        if (selected !== null) {
            this.markEntryRead(selected, true);
            $903e325e4cd4f232$var$openSelectedArticle(selected);
        }
    }
    throw(direction) {
        const selected = this.getSelectedEntry();
        if (selected !== null) this.markEntryRead(selected, true);
        this.nextPrev(direction, true);
    }
    render() {
        return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($903e325e4cd4f232$export$66d62ccfdff1c843, {
            entries: this.state.entries,
            selectedEntry: this.state.selectedEntry,
            expandedEntries: this.state.expandedEntries,
            hasMore: this.state.hasMore,
            loadingState: this.state.loadingState,
            setLoadingState: this.setLoadingState,
            setNavExpanded: this.props.setNavExpanded,
            navSourcesExpanded: this.props.navSourcesExpanded,
            reload: this.reload,
            setGlobalUnreadCount: this.props.setGlobalUnreadCount,
            unreadItemsCount: this.props.unreadItemsCount,
            showError: this.props.showError
        });
    }
}
function $903e325e4cd4f232$export$f3fcbed2d1eb5db9(props) {
    const { configuration: configuration, setNavExpanded: setNavExpanded, navSourcesExpanded: navSourcesExpanded, setGlobalUnreadCount: setGlobalUnreadCount, unreadItemsCount: unreadItemsCount, showError: showError, ref: ref } = props;
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    const location = (0, $dcbcccfe7d0a797a$export$45d76561a5302f2b)();
    const navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    const params = (0, $dcbcccfe7d0a797a$export$216385125ee84ae7)();
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($903e325e4cd4f232$export$9c61909d8ed47595, {
        ref: ref,
        location: location,
        navigate: navigate,
        params: params,
        configuration: configuration,
        setNavExpanded: setNavExpanded,
        navSourcesExpanded: navSourcesExpanded,
        setGlobalUnreadCount: setGlobalUnreadCount,
        unreadItemsCount: unreadItemsCount,
        showError: showError,
        _: _
    });
}
var $903e325e4cd4f232$export$2e2bcd8739ae039 = $903e325e4cd4f232$export$f3fcbed2d1eb5db9;




var $5NSbj = parcelRequire("5NSbj");



var $5NSbj = parcelRequire("5NSbj");








function $93efd806a4368f07$export$2e2bcd8739ae039(props) {
    const { setNavExpanded: setNavExpanded, offlineState: offlineState, allItemsCount: allItemsCount, allItemsOfflineCount: allItemsOfflineCount, unreadItemsCount: unreadItemsCount, unreadItemsOfflineCount: unreadItemsOfflineCount, starredItemsCount: starredItemsCount, starredItemsOfflineCount: starredItemsOfflineCount } = props;
    const [expanded, setExpanded] = (0, $5NSbj.useState)(true);
    const params = (0, $dcbcccfe7d0a797a$export$216385125ee84ae7)();
    const location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    const toggleExpanded = (0, $5NSbj.useCallback)(()=>setExpanded((expanded)=>!expanded), []);
    const collapseNav = (0, $5NSbj.useCallback)(()=>setNavExpanded(false), [
        setNavExpanded
    ]);
    const newestLink = (0, $5NSbj.useMemo)(()=>(0, $dcbcccfe7d0a797a$export$d0bb2ab5375d1521)(location, {
            filter: (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).NEWEST,
            id: null
        }), [
        location
    ]);
    const unreadLink = (0, $5NSbj.useMemo)(()=>(0, $dcbcccfe7d0a797a$export$d0bb2ab5375d1521)(location, {
            filter: (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).UNREAD,
            id: null
        }), [
        location
    ]);
    const starredLink = (0, $5NSbj.useMemo)(()=>(0, $dcbcccfe7d0a797a$export$d0bb2ab5375d1521)(location, {
            filter: (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).STARRED,
            id: null
        }), [
        location
    ]);
    const forceReload = (0, $dcbcccfe7d0a797a$export$6bccca1b7088ecd7)();
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
        id: "nav-filter-wrapper",
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-filter-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                        'nav-section-toggle': true,
                        'nav-filter-collapsed': !expanded,
                        'nav-filter-expanded': expanded
                    }),
                    "aria-expanded": expanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                            icon: expanded ? $b39548c706c2a5e0$exports.faCaretDown : $e9e52821f7276495$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        ' ',
                        _('filter')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $5c9ab921368ace58$export$78768a9af065a7b), {
                isOpen: expanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
                    id: "nav-filter",
                    "aria-labelledby": "nav-filter-title",
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $1b28ddd4ebfaf955$export$a6c7ac8248d6e38a), {
                                id: "nav-filter-newest",
                                to: newestLink,
                                state: forceReload,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                    'nav-filter-newest': true,
                                    active: params?.filter === (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).NEWEST
                                }),
                                onClick: collapseNav,
                                children: [
                                    _('newest'),
                                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                            'offline-count': true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            diff: allItemsCount !== allItemsOfflineCount && allItemsOfflineCount
                                        }),
                                        title: _('offline_count'),
                                        children: allItemsOfflineCount > 0 ? allItemsOfflineCount : ''
                                    }),
                                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                        className: "count",
                                        title: _('online_count'),
                                        children: allItemsCount > 0 ? allItemsCount : ''
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $1b28ddd4ebfaf955$export$a6c7ac8248d6e38a), {
                                id: "nav-filter-unread",
                                to: unreadLink,
                                state: forceReload,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                    'nav-filter-unread': true,
                                    active: params?.filter === (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).UNREAD
                                }),
                                onClick: collapseNav,
                                children: [
                                    _('unread'),
                                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                            'unread-count': true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            unread: unreadItemsCount > 0
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                                    'offline-count': true,
                                                    offline: offlineState,
                                                    online: !offlineState,
                                                    diff: unreadItemsCount !== unreadItemsOfflineCount && unreadItemsOfflineCount
                                                }),
                                                title: _('offline_count'),
                                                children: unreadItemsOfflineCount > 0 ? unreadItemsOfflineCount : ''
                                            }),
                                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                                className: "count",
                                                title: _('online_count'),
                                                children: unreadItemsCount > 0 ? unreadItemsCount : ''
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $1b28ddd4ebfaf955$export$a6c7ac8248d6e38a), {
                                id: "nav-filter-starred",
                                to: starredLink,
                                state: forceReload,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                    'nav-filter-starred': true,
                                    active: params?.filter === (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).STARRED
                                }),
                                onClick: collapseNav,
                                children: [
                                    _('starred'),
                                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                            'offline-count': true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            diff: starredItemsCount !== starredItemsOfflineCount && starredItemsOfflineCount
                                        }),
                                        title: _('offline_count'),
                                        children: starredItemsOfflineCount > 0 ? starredItemsOfflineCount : ''
                                    }),
                                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                        className: "count",
                                        title: _('online_count'),
                                        children: starredItemsCount > 0 ? starredItemsCount : ''
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}




var $5NSbj = parcelRequire("5NSbj");












function $0d46e887ee24a798$var$handleTitleClick({ setExpanded: setExpanded, sourcesState: sourcesState, setSourcesState: setSourcesState, setSources: setSources, _: _, showError: showError }) {
    if (!(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isOnline()) {
        console.log('Cannot toggle, not online.');
        return;
    }
    setExpanded((expanded)=>{
        if (!expanded && sourcesState === (0, $f5b3c040e086fbc1$export$62aa48085237e36f).INITIAL) $377e66b0ec5c5519$export$432f698644f45d1().then((data)=>{
            setSources(data);
            setSourcesState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS);
        }).catch((error)=>{
            setSourcesState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).FAILURE);
            showError(_('error_loading_stats') + ' ' + error.message);
        });
        return !expanded;
    });
}
function $0d46e887ee24a798$var$Source(props) {
    const { source: source, active: active, collapseNav: collapseNav } = props;
    const location = (0, $dcbcccfe7d0a797a$export$45d76561a5302f2b)();
    const link = (0, $5NSbj.useMemo)(()=>(0, $dcbcccfe7d0a797a$export$d0bb2ab5375d1521)(location, {
            category: `source-${source.id}`,
            id: null
        }), [
        source.id,
        location
    ]);
    const forceReload = (0, $dcbcccfe7d0a797a$export$6bccca1b7088ecd7)();
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
            read: source.unread === 0
        }),
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $1b28ddd4ebfaf955$export$a6c7ac8248d6e38a), {
            to: link,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                active: active,
                unread: source.unread > 0
            }),
            onClick: collapseNav,
            state: forceReload,
            children: [
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                    className: "nav-source",
                    children: (0, $ec6aeee77f582aff$export$e8bacd2802a88316)(source.title)
                }),
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                    className: "unread",
                    children: source.unread > 0 ? source.unread : ''
                })
            ]
        })
    });
}
function $0d46e887ee24a798$export$2e2bcd8739ae039(props) {
    const { setNavExpanded: setNavExpanded, navSourcesExpanded: navSourcesExpanded, setNavSourcesExpanded: setNavSourcesExpanded, sourcesState: sourcesState, setSourcesState: setSourcesState, sources: sources, setSources: setSources, showError: showError } = props;
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    const reallyExpanded = navSourcesExpanded && sourcesState === (0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS;
    const params = (0, $dcbcccfe7d0a797a$export$216385125ee84ae7)();
    const currentSource = params?.category?.startsWith('source-') ? parseInt(params.category.replace(/^source-/, ''), 10) : null;
    const toggleExpanded = (0, $5NSbj.useCallback)(()=>$0d46e887ee24a798$var$handleTitleClick({
            setExpanded: setNavSourcesExpanded,
            sourcesState: sourcesState,
            setSourcesState: setSourcesState,
            setSources: setSources,
            showError: showError,
            _: _
        }), [
        setNavSourcesExpanded,
        sourcesState,
        setSourcesState,
        setSources,
        showError,
        _
    ]);
    const collapseNav = (0, $5NSbj.useCallback)(()=>setNavExpanded(false), [
        setNavExpanded
    ]);
    const previousSourcesState = (0, $875b08fe0af98e08$export$f6f3f74729fdd0b7)(sourcesState);
    (0, $5NSbj.useEffect)(()=>{
        if (previousSourcesState === (0, $f5b3c040e086fbc1$export$62aa48085237e36f).INITIAL && sourcesState === (0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS) setNavSourcesExpanded(true);
    }, [
        previousSourcesState,
        sourcesState,
        setNavSourcesExpanded
    ]);
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $fcda9d1f1901e894$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-sources-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                        'nav-section-toggle': true,
                        'nav-sources-collapsed': !reallyExpanded,
                        'nav-sources-expanded': reallyExpanded
                    }),
                    "aria-expanded": reallyExpanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                            icon: navSourcesExpanded ? $b39548c706c2a5e0$exports.faCaretDown : $e9e52821f7276495$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        ' ',
                        _('sources')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $5c9ab921368ace58$export$78768a9af065a7b), {
                isOpen: reallyExpanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("ul", {
                    id: "nav-sources",
                    "aria-labelledby": "nav-sources-title",
                    children: sources.map((source)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($0d46e887ee24a798$var$Source, {
                            source: source,
                            active: currentSource === source.id,
                            collapseNav: collapseNav
                        }, source.id))
                })
            })
        ]
    });
}




var $5NSbj = parcelRequire("5NSbj");







// search button shows search input or executes search
function $86e12b3bf8fb6cc1$var$handleSubmit({ active: active, setActive: setActive, searchField: searchField, searchText: searchText, navigate: navigate, location: location, setNavExpanded: setNavExpanded }) {
    if (!(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isSmartphone() && !active) {
        setActive(true);
        searchField.current.focus();
        searchField.current.select();
        return;
    }
    navigate((0, $dcbcccfe7d0a797a$export$7f0beea2aa79e4fa)(location, {
        search: searchText,
        id: null
    }));
    setActive(false);
    searchField.current.blur();
    setNavExpanded(false);
}
function $86e12b3bf8fb6cc1$var$handleFieldKeyUp({ event: event, searchButton: searchButton, searchRemoveButton: searchRemoveButton }) {
    // keypress enter in search inputfield
    if (event.which == 13) searchButton.current.click();
    if (event.keyCode == 27) searchRemoveButton.current.click();
}
// remove button of search
function $86e12b3bf8fb6cc1$var$handleRemove({ setActive: setActive, searchField: searchField, navigate: navigate, location: location }) {
    const queryString = new URLSearchParams(location.search);
    const oldTerm = queryString.get('search');
    setActive(false);
    if (oldTerm == '') {
        searchField.current.blur();
        return;
    }
    navigate((0, $dcbcccfe7d0a797a$export$7f0beea2aa79e4fa)(location, {
        search: '',
        id: null
    }));
}
function $86e12b3bf8fb6cc1$export$2e2bcd8739ae039(props) {
    const { setNavExpanded: setNavExpanded, offlineState: offlineState, initialSearchText: initialSearchText } = props;
    const [active, setActive] = (0, $5NSbj.useState)(false);
    const searchField = (0, $5NSbj.useRef)(null);
    const searchButton = (0, $5NSbj.useRef)(null);
    const searchRemoveButton = (0, $5NSbj.useRef)(null);
    const location = (0, $dcbcccfe7d0a797a$export$45d76561a5302f2b)();
    const navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    const [searchText, setSearchText] = (0, $5NSbj.useState)(initialSearchText);
    const termOnKeyUp = (0, $5NSbj.useCallback)((event)=>$86e12b3bf8fb6cc1$var$handleFieldKeyUp({
            event: event,
            searchButton: searchButton,
            searchRemoveButton: searchRemoveButton
        }), []);
    const termOnChange = (0, $5NSbj.useCallback)((event)=>setSearchText(event.currentTarget.value), []);
    const removeOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).useCallback(()=>$86e12b3bf8fb6cc1$var$handleRemove({
            setActive: setActive,
            searchField: searchField,
            navigate: navigate,
            location: location
        }), [
        navigate,
        location
    ]);
    const searchOnClick = (0, $5NSbj.useCallback)(()=>$86e12b3bf8fb6cc1$var$handleSubmit({
            active: active,
            setActive: setActive,
            searchField: searchField,
            searchText: searchText,
            navigate: navigate,
            location: location,
            setNavExpanded: setNavExpanded
        }), [
        active,
        searchText,
        navigate,
        location,
        setNavExpanded
    ]);
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
        id: "search",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
            offline: offlineState,
            online: !offlineState,
            active: active
        }),
        role: "search",
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("input", {
                "aria-label": _('search_label'),
                type: "search",
                id: "search-term",
                accessKey: "s",
                ref: searchField,
                value: searchText,
                onKeyUp: termOnKeyUp,
                onChange: termOnChange
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                id: "search-remove",
                title: _('searchremove'),
                accessKey: "h",
                "aria-label": _('searchremove'),
                onClick: removeOnClick,
                ref: searchRemoveButton,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $246a305793432a97$exports.faTimes
                })
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                id: "search-button",
                title: _('searchbutton'),
                "aria-label": _('searchbutton'),
                accessKey: "e",
                onClick: searchOnClick,
                ref: searchButton,
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                        icon: $83e399a08305a885$exports.faSearch
                    }),
                    ' ',
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "search-button-label",
                        children: _('searchbutton')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("hr", {})
        ]
    });
}




var $5NSbj = parcelRequire("5NSbj");







var $5NSbj = parcelRequire("5NSbj");


/**
 * Get dark OR bright color depending the color contrast.
 *
 * @param hexColor color (hex) value
 * @param darkColor dark color value
 * @param brightColor bright color value
 *
 * @return dark OR bright color value
 *
 * @see https://24ways.org/2010/calculating-color-contrast/
 */ function $ae28f63e028613d7$export$97e1e2675ab19423(hexColor, darkColor = '#555', brightColor = '#EEE') {
    // Strip hash sign.
    const color = hexColor.substr(1);
    const r = parseInt(color.substr(0, 2), 16);
    const g = parseInt(color.substr(2, 2), 16);
    const b = parseInt(color.substr(4, 2), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? darkColor : brightColor;
}




const $234a443c5b77e105$var$palette = [
    '#ffccc9',
    '#ffce93',
    '#fffc9e',
    '#ffffc7',
    '#9aff99',
    '#96fffb',
    '#cdffff',
    '#cbcefb',
    '#fffe65',
    '#cfcfcf',
    '#fd6864',
    '#fe996b',
    '#fcff2f',
    '#67fd9a',
    '#38fff8',
    '#68fdff',
    '#9698ed',
    '#c0c0c0',
    '#fe0000',
    '#f8a102',
    '#ffcc67',
    '#f8ff00',
    '#34ff34',
    '#68cbd0',
    '#34cdf9',
    '#6665cd',
    '#9b9b9b',
    '#cb0000',
    '#f56b00',
    '#ffcb2f',
    '#ffc702',
    '#32cb00',
    '#00d2cb',
    '#3166ff',
    '#6434fc',
    '#656565',
    '#9a0000',
    '#ce6301',
    '#cd9934',
    '#999903',
    '#009901',
    '#329a9d',
    '#3531ff',
    '#6200c9',
    '#343434',
    '#680100',
    '#963400',
    '#986536',
    '#646809',
    '#036400',
    '#34696d',
    '#00009b',
    '#303498',
    '#000000',
    '#330001',
    '#643403',
    '#663234',
    '#343300',
    '#013300',
    '#003532',
    '#010066',
    '#340096'
];
function $234a443c5b77e105$var$ColorButton(props) {
    const { tag: tag, color: color } = props;
    const style = (0, $5NSbj.useMemo)(()=>({
            backgroundColor: color,
            color: (0, $ae28f63e028613d7$export$97e1e2675ab19423)(color)
        }), [
        color
    ]);
    const selected = color === tag.color;
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $3400fac6f43cd1b4$export$2ce376c2cc3355c8), {
        className: "popup-menu-item",
        value: color,
        style: style,
        children: selected ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
            icon: $e9206858efef3e95$exports.faCheck
        }) : ' '
    });
}
const $234a443c5b77e105$var$preventDefault = (event)=>{
    event.preventDefault();
    // Prevent closing navigation on mobile.
    event.stopPropagation();
};
function $234a443c5b77e105$export$2e2bcd8739ae039(props) {
    const { tag: tag, onChange: onChange } = props;
    const style = (0, $5NSbj.useMemo)(()=>({
            backgroundColor: tag.color
        }), [
        tag.color
    ]);
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
        className: "color",
        onClick: $234a443c5b77e105$var$preventDefault,
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $bcd818c5df72da4b$export$d9b273488cd8ce6f), {
            menuButton: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $af69c093d02babcf$export$266a769812832828), {
                className: "color-chooser-button",
                title: _('tag_change_color_button_title'),
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "color-box",
                        style: style
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "visually-hidden",
                        children: _('tag_change_color_button_title')
                    })
                ]
            }),
            menuClassName: "color-chooser popup-menu",
            onItemClick: onChange,
            viewScroll: "auto",
            portal: true,
            children: [
                $234a443c5b77e105$var$palette.map((color)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($234a443c5b77e105$var$ColorButton, {
                        color: color,
                        tag: tag
                    }, color)),
                !$234a443c5b77e105$var$palette.includes(tag.color) && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($234a443c5b77e105$var$ColorButton, {
                    color: tag.color,
                    tag: tag
                }, "custom")
            ]
        })
    });
}







function $c123c02ad063f5df$var$Tag(props) {
    const { tag: tag, active: active, collapseNav: collapseNav, showError: showError } = props;
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    const tagName = tag !== null ? tag.tag : null;
    const colorChanged = (0, $5NSbj.useCallback)(({ value: value })=>{
        (0, $cfb76a7b6769ced6$export$6f3c7c74c4b252bb)(tagName, value).then(()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.reload();
        }).catch((error)=>{
            showError(_('error_saving_color') + ' ' + error.message);
        });
    }, [
        tagName,
        showError,
        _
    ]);
    const category = tag === null ? 'all' : `tag-${tag.tag}`;
    const location = (0, $4a2ef0180f3aa5fe$export$45d76561a5302f2b)();
    const link = (0, $5NSbj.useMemo)(()=>(0, $dcbcccfe7d0a797a$export$d0bb2ab5375d1521)(location, {
            category: category,
            id: null
        }), [
        category,
        location
    ]);
    const forceReload = (0, $dcbcccfe7d0a797a$export$6bccca1b7088ecd7)();
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
            read: tag !== null && tag.unread === 0
        }),
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $1b28ddd4ebfaf955$export$a6c7ac8248d6e38a), {
            to: link,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                'nav-tags-all': tag === null,
                active: active
            }),
            onClick: collapseNav,
            state: forceReload,
            children: tag === null ? _('alltags') : /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $fcda9d1f1901e894$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "tag",
                        children: (0, $ec6aeee77f582aff$export$e8bacd2802a88316)(tag.tag)
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                        className: "unread",
                        children: tag.unread > 0 ? tag.unread : ''
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $234a443c5b77e105$export$2e2bcd8739ae039), {
                        tag: tag,
                        onChange: colorChanged
                    })
                ]
            })
        })
    });
}
function $c123c02ad063f5df$export$2e2bcd8739ae039(props) {
    const { setNavExpanded: setNavExpanded, tags: tags, showError: showError } = props;
    const [expanded, setExpanded] = (0, $5NSbj.useState)(true);
    const params = (0, $dcbcccfe7d0a797a$export$216385125ee84ae7)();
    const currentAllTags = params?.category === 'all';
    const currentTag = params?.category?.startsWith('tag-') ? params.category.replace(/^tag-/, '') : null;
    const toggleExpanded = (0, $5NSbj.useCallback)(()=>setExpanded((expanded)=>!expanded), []);
    const collapseNav = (0, $5NSbj.useCallback)(()=>setNavExpanded(false), [
        setNavExpanded
    ]);
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $fcda9d1f1901e894$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-tags-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                        'nav-section-toggle': true,
                        'nav-tags-collapsed': !expanded,
                        'nav-tags-expanded': expanded
                    }),
                    "aria-expanded": expanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                            icon: expanded ? $b39548c706c2a5e0$exports.faCaretDown : $e9e52821f7276495$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        ' ',
                        _('tags')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $5c9ab921368ace58$export$78768a9af065a7b), {
                isOpen: expanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("ul", {
                    id: "nav-tags",
                    "aria-labelledby": "nav-tags-title",
                    children: [
                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($c123c02ad063f5df$var$Tag, {
                            tag: null,
                            active: currentAllTags,
                            collapseNav: collapseNav,
                            showError: showError
                        }),
                        tags.map((tag)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($c123c02ad063f5df$var$Tag, {
                                tag: tag,
                                active: currentTag === tag.tag,
                                collapseNav: collapseNav,
                                showError: showError
                            }, tag.tag))
                    ]
                })
            })
        ]
    });
}




var $5NSbj = parcelRequire("5NSbj");








function $8cce554121940c7f$var$handleReloadAll({ reloadAll: reloadAll, setReloading: setReloading, setNavExpanded: setNavExpanded }) {
    setReloading(true);
    reloadAll().finally(()=>{
        setNavExpanded(false);
        setReloading(false);
    });
}
function $8cce554121940c7f$var$handleLogOut({ setNavExpanded: setNavExpanded }) {
    // only loggedin users
    if (!(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).hasSession() || !(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isOnline()) return;
    (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.clear();
    (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).logout();
    setNavExpanded(false);
}
function $8cce554121940c7f$export$2e2bcd8739ae039(props) {
    const { reloadAll: reloadAll, setNavExpanded: setNavExpanded } = props;
    const [reloading, setReloading] = (0, $5NSbj.useState)(false);
    const forceReload = (0, $dcbcccfe7d0a797a$export$6bccca1b7088ecd7)();
    const refreshOnClick = (0, $5NSbj.useCallback)(()=>$8cce554121940c7f$var$handleReloadAll({
            reloadAll: reloadAll,
            setReloading: setReloading,
            setNavExpanded: setNavExpanded
        }), [
        reloadAll,
        setNavExpanded
    ]);
    const settingsOnClick = (0, $5NSbj.useCallback)(()=>{
        setNavExpanded(false);
    }, [
        setNavExpanded
    ]);
    const logoutOnClick = (0, $5NSbj.useCallback)(()=>$8cce554121940c7f$var$handleLogOut({
            setNavExpanded: setNavExpanded
        }), [
        setNavExpanded
    ]);
    const isLoggedIn = (0, $fa4deecc6161d7ee$export$3b062b02b4537682)();
    const canRefreshAll = (0, $fa4deecc6161d7ee$export$683005ba76038aff)();
    const canVisitSettings = (0, $fa4deecc6161d7ee$export$b416b77cd328c02f)();
    const canLogOut = isLoggedIn;
    const configuration = (0, $5NSbj.use)((0, $b7416e8649ee66da$export$326f6d1b69f1c06e));
    const canLogIn = !isLoggedIn && configuration.authEnabled;
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
        className: "nav-toolbar",
        children: [
            canRefreshAll && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                id: "nav-refresh",
                title: _('refreshbutton'),
                "aria-label": _('refreshbutton'),
                accessKey: "r",
                onClick: refreshOnClick,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $6a208664f359f326$exports.faSyncAlt,
                    fixedWidth: true,
                    spin: reloading
                })
            }),
            canVisitSettings && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $1b28ddd4ebfaf955$export$a6c7ac8248d6e38a), {
                id: "nav-settings",
                title: _('settingsbutton'),
                "aria-label": _('settingsbutton'),
                accessKey: "t",
                to: "/manage/sources",
                onClick: settingsOnClick,
                state: forceReload,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $89b603728dcec9de$exports.faCloudUploadAlt,
                    fixedWidth: true
                })
            }),
            canLogOut && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                id: "nav-logout",
                title: _('logoutbutton'),
                "aria-label": _('logoutbutton'),
                accessKey: "l",
                onClick: logoutOnClick,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $7ab16ab4e5fbaa94$exports.faSignOutAlt,
                    fixedWidth: true
                })
            }),
            canLogIn && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $1b28ddd4ebfaf955$export$a6c7ac8248d6e38a), {
                id: "nav-login",
                title: _('loginbutton'),
                "aria-label": _('loginbutton'),
                accessKey: "l",
                to: "/sign/in",
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $c4ec402fabc5b4fe$exports.faKey,
                    fixedWidth: true
                })
            })
        ]
    });
}







function $c85565e69a0d22e9$export$2e2bcd8739ae039(props) {
    const { entriesPage: entriesPage, setNavExpanded: setNavExpanded, navSourcesExpanded: navSourcesExpanded, setNavSourcesExpanded: setNavSourcesExpanded, offlineState: offlineState, allItemsCount: allItemsCount, allItemsOfflineCount: allItemsOfflineCount, unreadItemsCount: unreadItemsCount, unreadItemsOfflineCount: unreadItemsOfflineCount, starredItemsCount: starredItemsCount, starredItemsOfflineCount: starredItemsOfflineCount, sourcesState: sourcesState, setSourcesState: setSourcesState, sources: sources, setSources: setSources, tags: tags, reloadAll: reloadAll, showError: showError } = props;
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    const canWrite = (0, $fa4deecc6161d7ee$export$b416b77cd328c02f)();
    const location = (0, $dcbcccfe7d0a797a$export$45d76561a5302f2b)();
    const queryString = new URLSearchParams(location.search);
    const initialSearchText = queryString.get('search') ?? '';
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $fcda9d1f1901e894$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                id: "nav-logo"
            }),
            canWrite && /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                accessKey: "a",
                id: "nav-mark",
                onClick: entriesPage !== null ? entriesPage.markVisibleRead : null,
                disabled: entriesPage === null,
                children: _('markread')
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $93efd806a4368f07$export$2e2bcd8739ae039), {
                setNavExpanded: setNavExpanded,
                offlineState: offlineState,
                allItemsCount: allItemsCount,
                allItemsOfflineCount: allItemsOfflineCount,
                unreadItemsCount: unreadItemsCount,
                unreadItemsOfflineCount: unreadItemsOfflineCount,
                starredItemsCount: starredItemsCount,
                starredItemsOfflineCount: starredItemsOfflineCount
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                className: "separator",
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("hr", {})
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                    'nav-ts-wrapper': true,
                    offline: offlineState,
                    online: !offlineState
                }),
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $c123c02ad063f5df$export$2e2bcd8739ae039), {
                        tags: tags,
                        setNavExpanded: setNavExpanded,
                        showError: showError
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $0d46e887ee24a798$export$2e2bcd8739ae039), {
                        setNavExpanded: setNavExpanded,
                        navSourcesExpanded: navSourcesExpanded,
                        setNavSourcesExpanded: setNavSourcesExpanded,
                        sourcesState: sourcesState,
                        setSourcesState: setSourcesState,
                        sources: sources,
                        setSources: setSources,
                        showError: showError
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                    'nav-unavailable': true,
                    offline: offlineState,
                    online: !offlineState
                }),
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("span", {
                        className: "fa-layers fa-2x",
                        children: [
                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                                icon: $9abdfe45332a1725$exports.faWifi
                            }),
                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                                icon: $f7bce8bbcf358cf9$exports.faSlash
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("p", {
                        children: _('offline_navigation_unavailable')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                className: "separator",
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("hr", {})
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $86e12b3bf8fb6cc1$export$2e2bcd8739ae039), {
                setNavExpanded: setNavExpanded,
                offlineState: offlineState,
                initialSearchText: initialSearchText
            }, initialSearchText),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $8cce554121940c7f$export$2e2bcd8739ae039), {
                reloadAll: reloadAll,
                setNavExpanded: setNavExpanded
            })
        ]
    });
}




var $5NSbj = parcelRequire("5NSbj");





function $dabab91edb61a70e$var$splitTerm(term) {
    if (term == '') return [];
    else if (term.match(/^\/.+\/$/)) return [
        term
    ];
    const words = term.match(/"[^"]+"|\S+/g);
    for(let i = 0; i < words.length; i++)words[i] = words[i].replace(/"/g, '');
    return words;
}
function $dabab91edb61a70e$var$joinTerm(words) {
    if (!words || words.length <= 0) return '';
    for(let i = 0; i < words.length; i++)if (words[i].indexOf(' ') >= 0) words[i] = '"' + words[i] + '"';
    return words.join(' ');
}
// remove search term
function $dabab91edb61a70e$var$handleRemove({ index: index, location: location, navigate: navigate, regexSearch: regexSearch }) {
    let newterm;
    if (regexSearch) newterm = '';
    else {
        const queryString = new URLSearchParams(location.search);
        const oldTerm = queryString.get('search');
        const termArray = $dabab91edb61a70e$var$splitTerm(oldTerm);
        termArray.splice(index, 1);
        newterm = $dabab91edb61a70e$var$joinTerm(termArray);
    }
    navigate((0, $dcbcccfe7d0a797a$export$7f0beea2aa79e4fa)(location, {
        search: newterm,
        id: null
    }));
}
function $dabab91edb61a70e$var$SearchWord(props) {
    const { regexSearch: regexSearch, index: index, item: item } = props;
    const location = (0, $dcbcccfe7d0a797a$export$45d76561a5302f2b)();
    const navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    const removeOnClick = (0, $5NSbj.useCallback)(()=>$dabab91edb61a70e$var$handleRemove({
            index: index,
            location: location,
            navigate: navigate,
            regexSearch: regexSearch
        }), [
        index,
        location,
        navigate,
        regexSearch
    ]);
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("li", {
        onClick: removeOnClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
            'regex-search-term': regexSearch
        }),
        children: [
            item,
            " ",
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                icon: $246a305793432a97$exports.faTimes
            })
        ]
    });
}
function $dabab91edb61a70e$export$2e2bcd8739ae039() {
    const location = (0, $dcbcccfe7d0a797a$export$45d76561a5302f2b)();
    const searchText = (0, $5NSbj.useMemo)(()=>{
        const queryString = new URLSearchParams(location.search);
        return queryString.get('search') ?? '';
    }, [
        location.search
    ]);
    const regexSearch = searchText.match(/^\/.+\/$/) !== null;
    const terms = regexSearch ? [
        searchText
    ] : $dabab91edb61a70e$var$splitTerm(searchText);
    return terms.map((item, index)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($dabab91edb61a70e$var$SearchWord, {
            index: index,
            item: item,
            regexSearch: regexSearch
        }, index));
}


//#region src/tinykeys.ts
/**
* These are the modifier keys that change the meaning of keybindings.
*
* Note: Ignoring "AltGraph" because it is covered by the others.
*/ let $c8488b8185546aac$var$KEYBINDING_MODIFIER_KEYS = [
    "Shift",
    "Meta",
    "Alt",
    "Control"
];
/**
* Keybinding sequences should timeout if individual key presses are more than
* 1s apart by default.
*/ let $c8488b8185546aac$var$DEFAULT_TIMEOUT = 1e3;
/**
* Keybinding sequences should bind to this event by default.
*/ let $c8488b8185546aac$var$DEFAULT_EVENT = "keydown";
/**
* Platform detection code.
* @see https://github.com/jamiebuilds/tinykeys/issues/184
*/ let $c8488b8185546aac$var$PLATFORM = typeof navigator === "object" ? navigator.platform : "";
/**
* An alias for creating platform-specific keybinding aliases.
*/ let $c8488b8185546aac$var$MOD = /Mac|iPod|iPhone|iPad/.test($c8488b8185546aac$var$PLATFORM) ? "Meta" : "Control";
/**
* Meaning of `AltGraph`, from MDN:
* - Windows: Both Alt and Ctrl keys are pressed, or AltGr key is pressed
* - Mac: ⌥ Option key pressed
* - Linux: Level 3 Shift key (or Level 5 Shift key) pressed
* - Android: Not supported
* @see https://github.com/jamiebuilds/tinykeys/issues/185
*/ let $c8488b8185546aac$var$ALT_GRAPH_ALIASES = $c8488b8185546aac$var$PLATFORM === "Win32" ? [
    "Control",
    "Alt"
] : [
    "Alt"
];
/**
* Ensure and stop any event that isn't a full keyboard event.
* Autocomplete option navigation and selection would fire an Event,
* instead of the expected KeyboardEvent
*/ function $c8488b8185546aac$var$isKeyboardEvent(event) {
    return !!(event.key && event.code && event.getModifierState);
}
/**
* Ignores keyboard events from contenteditable and form elements unless they
* are the current target.
*/ function $c8488b8185546aac$export$9539c749efdac4b5(event) {
    let target = event.target;
    return event.repeat || event.isComposing || target !== event.currentTarget && target.matches("[contenteditable],input,select,textarea");
}
/**
* There's a bug in Chrome that causes event.getModifierState not to exist on
* KeyboardEvent's for F1/F2/etc keys.
*/ function $c8488b8185546aac$var$getModifierState(event, mod) {
    return typeof event.getModifierState === "function" ? event.getModifierState(mod) || $c8488b8185546aac$var$ALT_GRAPH_ALIASES.includes(mod) && event.getModifierState("AltGraph") : false;
}
/**
* Parses a keybinding string into its parts.
*
* ```
* grammar    = `<sequence>`
* <sequence> = `<press> <press> <press> ...`
* <press>    = `<key>` or `<mods>+<key>`
* <mods>     = `<mod>+<mod>+...`
* <mod>      = `<modifier>` (required) or `[<modifier>]` (optional)
* <key>      = `<KeyboardEvent.key>` or `<KeyboardEvent.code>` (case-insensitive)
* <key>      = `(<regex>)` -> `/^(?:<regex>)$/iy` (case-insensitive)
* ```
*/ function $c8488b8185546aac$export$d0b30d424c95c5e9(str) {
    return str.trim().split(" ").map((press)=>{
        let parts = press.split(/(?<=\w|\])\+/);
        let last = parts.pop();
        let regex = last.match(/^\((.+)\)$/);
        let key = regex ? new RegExp(`^(?:${regex[1]})$`, "iv") : last;
        let requiredModifiers = [];
        let optionalModifiers = [];
        for (const part of parts){
            let optional = part.match(/^\[(.*)\]$/);
            let mod = optional?.[1] ?? part;
            mod = mod === "$mod" ? $c8488b8185546aac$var$MOD : mod;
            if (optional) optionalModifiers.push(mod);
            else requiredModifiers.push(mod);
        }
        return [
            requiredModifiers,
            optionalModifiers,
            key
        ];
    });
}
/**
* This tells us if a single keyboard event matches a single keybinding press.
*/ function $c8488b8185546aac$export$4bb3a1fe83138634(event, [requiredModifiers, optionalModifiers, key]) {
    const hasAltGraph = requiredModifiers.includes("AltGraph");
    return !((key instanceof RegExp ? !(key.test(event.key) || key.test(event.code)) : key.toUpperCase() !== event.key.toUpperCase() && key !== event.code) || requiredModifiers.find((mod)=>{
        return !$c8488b8185546aac$var$getModifierState(event, mod);
    }) || $c8488b8185546aac$var$KEYBINDING_MODIFIER_KEYS.find((mod)=>{
        return !requiredModifiers.includes(mod) && !optionalModifiers.includes(mod) && key !== mod && $c8488b8185546aac$var$getModifierState(event, mod) && !(hasAltGraph && $c8488b8185546aac$var$ALT_GRAPH_ALIASES.includes(mod));
    }));
}
/**
* Creates an event listener for handling keybindings.
*
* @example
* ```js
* import { createKeybindingsHandler } from "../src/keybindings"
*
* let handler = createKeybindingsHandler({
* 	"Shift+d": () => {
* 		alert("The 'Shift' and 'd' keys were pressed at the same time")
* 	},
* 	"y e e t": () => {
* 		alert("The keys 'y', 'e', 'e', and 't' were pressed in order")
* 	},
* 	"$mod+d": () => {
* 		alert("Either 'Control+d' or 'Meta+d' were pressed")
* 	},
* })
*
* window.addEventListener("keydown", handler)
* ```
*/ function $c8488b8185546aac$export$a3db0ee43d16bb47(keybindingsMap, options = {}) {
    let timeout = options.timeout ?? $c8488b8185546aac$var$DEFAULT_TIMEOUT;
    let ignore = options.ignore ?? $c8488b8185546aac$export$9539c749efdac4b5;
    let keybindings = Object.keys(keybindingsMap).map((input)=>{
        return [
            input,
            $c8488b8185546aac$export$d0b30d424c95c5e9(input),
            keybindingsMap[input]
        ];
    });
    let pending = /* @__PURE__ */ new Map();
    let timer = null;
    return (event)=>{
        if (!$c8488b8185546aac$var$isKeyboardEvent(event) || ignore(event)) return;
        let conflicts = [];
        for (let [input, sequence, handler] of keybindings){
            let prev = pending.get(input);
            let [current, ...rest] = prev ? prev : sequence;
            if (!$c8488b8185546aac$export$4bb3a1fe83138634(event, current)) {
                if (!$c8488b8185546aac$var$getModifierState(event, event.key)) pending.delete(input);
            } else if (rest.length > 0) {
                pending.set(input, rest);
                conflicts.push(input);
            } else {
                pending.delete(input);
                if (conflicts.length) console.warn(`tinykeys: Conflict found, "${input}" did not fire, waiting for:`, conflicts);
                else {
                    handler(event);
                    break;
                }
            }
        }
        if (timer) clearTimeout(timer);
        timer = setTimeout(()=>pending.clear(), timeout);
    };
}
/**
* Subscribes to keybindings.
*
* Returns an unsubscribe method.
*
* @example
* ```js
* import { tinykeys } from "../src/tinykeys"
*
* tinykeys(window, {
* 	"Shift+d": () => {
* 		alert("The 'Shift' and 'd' keys were pressed at the same time")
* 	},
* 	"y e e t": () => {
* 		alert("The keys 'y', 'e', 'e', and 't' were pressed in order")
* 	},
* 	"$mod+d": () => {
* 		alert("Either 'Control+d' or 'Meta+d' were pressed")
* 	},
* })
* ```
*/ function $c8488b8185546aac$export$6fc42dca60e28416(target, keybindingMap, options = {}) {
    let event = options.event ?? $c8488b8185546aac$var$DEFAULT_EVENT;
    let onKeyEvent = $c8488b8185546aac$export$a3db0ee43d16bb47(keybindingMap, options);
    target.addEventListener(event, onKeyEvent, options.capture);
    return ()=>{
        target.removeEventListener(event, onKeyEvent, options.capture);
    };
}




/**
 * Decorates an event handler so that it only runs
 * when not interacting with an input field or lightbox.
 */ function $9a99005d054db156$var$ignoreWhenInteracting(handler, ignoreDialog) {
    return (event)=>{
        if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).lightboxActive.value) return;
        else if (ignoreDialog && ignoreDialog.current.open) return;
        handler(event);
    };
}
const $9a99005d054db156$export$9784374fba94ce79 = {
    Space: {
        description: 'select and open next entry',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.jumpToNext();
        }
    },
    n: {
        description: 'select next entry',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.nextPrev((0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).NEXT, false);
        }
    },
    Arrowright: {
        readableName: "\u2192",
        description: 'select next entry (and open it when the current is open)',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.entryNav((0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).NEXT);
        }
    },
    j: {
        description: 'select and open next entry',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.nextPrev((0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).NEXT, true);
        }
    },
    'Shift+Space': {
        description: 'select and open previous entry',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.nextPrev((0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).PREV, true);
        }
    },
    p: {
        description: 'select previous entry',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.nextPrev((0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).PREV, false);
        }
    },
    ArrowLeft: {
        readableName: "\u2190",
        description: 'select previous entry (and open it when the current is open)',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.entryNav((0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).PREV);
        }
    },
    k: {
        description: 'select and open previous entry',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.nextPrev((0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).PREV, true);
        }
    },
    s: {
        description: 'mark and unmark current selected entry as starred/unstarred',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.toggleSelectedStarred();
        }
    },
    m: {
        description: 'mark and unmark current selected entry as read/unread',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.toggleSelectedRead();
        }
    },
    'Control+m': {
        description: 'mark all as read',
        action: ()=>{
            document.querySelector('#nav-mark').click();
        }
    },
    o: {
        description: 'open / close current entry',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.toggleSelectedExpanded();
        }
    },
    'Shift+o': {
        description: 'close all open entries',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.collapseAllEntries();
        }
    },
    v: {
        description: 'open url of current entry in new tab/window',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.openSelectedTarget();
        }
    },
    'Shift+v': {
        description: 'open url of current entry in new tab/window and mark read',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.openSelectedTargetAndMarkRead();
        }
    },
    r: {
        description: 'reload the list',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.reload();
        }
    },
    'Shift+r': {
        description: 'refresh sources',
        action: ()=>{
            document.querySelector('#nav-refresh').click();
        }
    },
    t: {
        description: 'throw current entry to next (mark as read & open next)',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.throw((0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).NEXT);
        }
    },
    'Shift+t': {
        description: 'throw current entry to previous (mark as read & open previous)',
        action: ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.throw((0, $0b4b5bcd4750d386$export$cacd6541cfeeb6c1).PREV);
        }
    },
    'Shift+n': {
        description: 'open newest entries page',
        action: ()=>{
            document.querySelector('#nav-filter-newest').click();
        }
    },
    'Shift+u': {
        description: 'open unread entries page',
        action: ()=>{
            document.querySelector('#nav-filter-unread').click();
        }
    },
    'Shift+s': {
        description: 'open starred entries page',
        action: ()=>{
            document.querySelector('#nav-filter-starred').click();
        }
    },
    '[Shift]+?': {
        readableName: '?',
        description: 'show help',
        action: ()=>{}
    }
};
function $9a99005d054db156$var$makeKeybindingsMap(shortcutsDialog) {
    const shortcuts = Object.entries($9a99005d054db156$export$9784374fba94ce79);
    const keybindingsMap = {};
    for (const [keycombo, keybind] of shortcuts)if (keycombo === '[Shift]+?') keybindingsMap[keycombo] = $9a99005d054db156$var$ignoreWhenInteracting((event)=>{
        event.preventDefault();
        if (shortcutsDialog.current.open) shortcutsDialog.current.close();
        else shortcutsDialog.current.showModal();
    });
    else keybindingsMap[keycombo] = $9a99005d054db156$var$ignoreWhenInteracting((event)=>{
        event.preventDefault();
        keybind.action(event);
    }, shortcutsDialog);
    return keybindingsMap;
}
function $9a99005d054db156$export$2e2bcd8739ae039(shortcutsDialog) {
    return (0, $c8488b8185546aac$export$6fc42dca60e28416)(window, $9a99005d054db156$var$makeKeybindingsMap(shortcutsDialog));
}









// Unfortunately we need to declare everything manually for Parcel to pick those up.
var $647f766074d64773$exports = {};
$647f766074d64773$exports = JSON.parse('{"markread":"Marca com llegit","filter":"Filtre","newest":"Nous","unread":"Per llegir","starred":"Preferits","online_count":"Elements disponibles al servidor","offline_count":"Elements disponibles localment","tags":"Etiquetes","alltags":"Totes les etiquetes","timestamp":"{0,date} {0,time}","hours":"fa {0,plural,one {1 hora},other {# hores}}","minutes":"fa {0,plural,one {1 minut},other {# minuts}}","seconds":"fa {0,plural,one {1 segon},other {# segons}}","days":"{0,plural,zero {avui},one {ahir},other {fa # dies}}","star":"Preferit","unstar":"Ja no ho prefereixo","mark":"Marca com llegit","unmark":"Marca com no llegit","load_img":"Mostra les imatges","open_window":"Obre","next":"Seg\xfcent","searchbutton":"Cerca","searchremove":"Amaga la cerca","refreshbutton":"Actualitza les fonts","settingsbutton":"Configuraci\xf3","logoutbutton":"Finalitza la sessi\xf3","loginbutton":"Inicia una sessi\xf3","sources":"Fonts","source_add":"Afegeix una font","source_opml":"o importa des d\'un fitxer opml o des del Google Reader (fins al 15 de juliol de 2013)","source_export":"Exporta les fonts","source_edit":"Edita","source_filter":"Filtra","source_delete":"Esborra","source_warn":"Segur que voleu esborrar la font?","source_new":"Nova font per desar","source_title":"T\xedtol","source_autotitle_hint":"Deixa en blanc per a obtindre el t\xedtol","source_tags":"Etiquetes","source_pwd_placeholder":"No ha canviat","source_comma":"Separat per comes","source_select":"Seleccioneu una font","source_type":"Tipus","source_save":"Desa","source_cancel":"Cancel\xb7la","source_saved":"Desat","source_last_post":"\xdaltima entrada vista","source_refresh":"Actualitza aquesta font","no_entries":"No es van trobar entrades","more":"M\xe9s","login":"Inicia una sessi\xf3","login_username":"Nom d\'usuari","login_password":"Contrasenya","login_invalid_credentials":"Nom d\'usuari o contrasenya incorrectes","login_offline":"Emmagatzematge fora de l\xednia","no_title":"Sense t\xedtol","error":"S\'ha produ\xeft un error","streamerror":"No hi ha cap element carregat. Es recarrega?","reload_list":"Recarrega la llista","sources_refreshed":"S\'han actualitzat les fonts","app_update":"selfoss s\'ha actualitzat, torneu a carregar","app_reload":"Recarrega","error_session_expired":"La sessi\xf3 ha expirat","error_add_source":"No s\'ha pogut afegir la font:","error_delete_source":"No s\'ha pogut esborrar la font:","error_load_tags":"No s\'han pogut carregar les etiquetes:","error_unknown_tag":"Etiqueta desconeguda:","error_unknown_source":"Id de font desconeguda:","error_mark_items":"No s\'han pogut marcar tots els elements visibles:","error_mark_item":"No s\'ha pogut marcar/desmarcar element:","error_star_item":"No s\'ha pogut preferir/despreferir l\'element:","error_logout":"No s\'ha pogut finalitzar la sessi\xf3:","error_loading":"Error de c\xe0rrega:","error_loading_stats":"No s\'han pogut carregar les estad\xedstiques de navegaci\xf3:","error_saving_color":"No s\'ha pogut desar el nou color:","error_refreshing_source":"No s\'han pogut refrescar fonts:","error_sync":"No s\'han pogut sincronitzar els \xfaltims canvis del servidor:","error_offline_storage":"Error d\'emmagatzematge fora de l\xednia: {0}. Recarregar pot ajudar. Es desactiva l\'\xfas fora de l\xednia per ara.","error_invalid_subsection":"Subsecci\xf3 inv\xe0lida:","search_label":"Terme de cerca","article_actions":"Accions","error_configuration":"No es pot carregar la configuraci\xf3.","info_url_copied":"S\'ha copiat l\'URL al portaretalls.","share_native_label":"Comparteix","share_diaspora_label":"Comparteix a Diaspora","share_twitter_label":"Comparteix al Twitter","share_facebook_label":"Comparteix al Facebook","share_pocket_label":"Desa a Pocket","share_wallabag_label":"Desa a Wallabag","share_wordpress_label":"Comparteix a WordPress","share_mail_label":"Comparteix per correu electr\xf2nic","share_copy_label":"Copia l\'enlla\xe7 al portaretalls","error_share_native_abort":"No es pot compartir l\'element\u2014o no hi ha destinacions de compartici\xf3, o ho heu cancel\xb7lat.","error_share_native":"No es pot compartir l\'element.","close_entry":"Tanca","error_unwritable_logs":"No es poden escriure els registres.","error_check_system_logs":"S\'ha produ\xeft un error. Comproveu els registres del sistema.","error_check_log_file":"S\'ha produ\xeft un error. Comprova el fitxer de registre \u201C{0}\u201D.","offline_navigation_unavailable":"Canviar etiquetes i fonts no \xe9s disponible en el mode fora de l\xednia.","error_offline_storage_not_available":"Emmagatzematge fora de l\xednia no disponible. Assegureu-vos que el navegador {0}suporta IndexedDB API{1}. Si utilitzeu un navegador basat en Google Chrome, que no estigueu utilitzant selfoss en mode inc\xf2gnit.","error_edit_source":"No es pot desar els canvis a les fonts:","article_reading_time":"{0} min lectura","experimental":"Experimental","source_menu":"M\xe9s accions","source_browse":"Navega","sources_leaving_unsaved_prompt":"Voleu deixar la configuraci\xf3 amb els canvis de font no desats?","source_warn_cancel_dirty":"Vols descartar els canvis no desats?","tag_change_color_button_title":"Canvia el color","sources_loading":"S\'estan carregant les fonts\u2026","source_deleting":"S\'est\xe0 suprimint la font\u2026","source_params_loading":"S\'estan carregant els par\xe0metres\u2026","no_sources":"No hi ha fonts configurades.","source_saving":"S\'estan desant els canvis a la font\u2026","source_go_to_settings":"Obre a la configuraci\xf3","entries_loading":"S\'estan carregant les entrades\u2026","login_in_progress":"S\'est\xe0 intentant iniciar sessi\xf3\u2026","login_error_generic":"No s\'ha pogut iniciar sessi\xf3: {errorMessage}","error_unauthorized":"Si us plau, {link_begin}inicieu sessi\xf3{link_end} per a continuar.","share_mastodon_label":"Comparteix a Mastodon"}');


var $18e6d39c6df6a504$exports = {};
$18e6d39c6df6a504$exports = JSON.parse('{"markread":"Ozna\u010Dit jako p\u0159e\u010Dten\xe9","filter":"Zobrazovat","newest":"Nejnov\u011Bj\u0161\xed","unread":"Nep\u0159e\u010Dten\xe9","starred":"Ozna\u010Den\xe9","tags":"\u0160t\xedtky","alltags":"V\u0161echny \u0161t\xedtky","timestamp":"{0,date} {0,time}","hours":"p\u0159ed {0,plural,one {1 hodinou},other {# hodinami}}","minutes":"p\u0159ed {0,plural,one {1 minutou},other {# minutami}}","seconds":"p\u0159ed {0,plural,one {chv\xedl\xed},other {# sekundami}}","days":"{0,plural,zero {dnes},one {v\u010Dera},other {p\u0159ed # dny}}","star":"Ozna\u010Dit","unstar":"Odzna\u010Dit","mark":"Ozna\u010Dit jako p\u0159e\u010Dten\xe9","unmark":"Ozna\u010Dit jako nep\u0159e\u010Dten\xe9","load_img":"Zobrazit obr\xe1zky","open_window":"Otev\u0159\xedt","next":"Dal\u0161\xed","search_label":"Vyhled\xe1van\xfd text","searchbutton":"Hledat","searchremove":"Skr\xfdt hled\xe1n\xed","refreshbutton":"Obnovit zdroje","settingsbutton":"Nastaven\xed","logoutbutton":"Odhl\xe1sit se","loginbutton":"P\u0159ihl\xe1sit se","sources":"Zdroje","sources_loading":"Na\u010D\xedt\xe1n\xed zdroj\u016F\u2026","no_sources":"Nejsou nastaveny \u017E\xe1dn\xe9 zdroje.","source_add":"P\u0159idat zdroj","source_opml":"nebo nahr\xe1t opml soubor","source_export":"Export zdroj\u016F","source_edit":"Upravit","source_filter":"Filtr","source_menu":"V\xedce akc\xed","source_browse":"Prohl\xed\u017Eet","source_delete":"Smazat","source_warn":"Opravdu chcete tento zdroj smazat?","source_deleting":"Maz\xe1n\xed zdroje\u2026","source_warn_cancel_dirty":"Opravdu chcete zahodit neulo\u017Een\xe9 zm\u011Bny?","source_new":"Nov\xfd neulo\u017Een\xfd zdroj","source_title":"N\xe1zev","source_autotitle_hint":"Pro automatick\xe9 vypln\u011Bn\xed ponechte pr\xe1zdn\xe9","source_tags":"\u0160t\xedtky","source_pwd_placeholder":"Beze zm\u011Bny","source_comma":"Odd\u011Blen\xe9 \u010D\xe1rkou","source_select":"Vyberte pros\xedm zdroj","source_params_loading":"Na\u010D\xedt\xe1n\xed parametr\u016F\u2026","source_type":"Typ","source_save":"Ulo\u017Eit","source_cancel":"Zru\u0161it","source_saving":"Ukl\xe1d\xe1n\xed zm\u011Bn zdroje\u2026","source_saved":"Ulo\u017Eeno","source_last_post":"Posledn\xed p\u0159\xedsp\u011Bvek spat\u0159en","source_refresh":"Obnovit tento zdroj","source_go_to_settings":"Otev\u0159\xedt v\xa0nastaven\xed","sources_leaving_unsaved_prompt":"Na str\xe1nce jsou neulo\u017Een\xe9 zm\u011Bny. Opravdu chcete opustit nastaven\xed?","tag_change_color_button_title":"Zm\u011Bnit barvu","entries_loading":"Na\u010D\xedt\xe1n\xed z\xe1znam\u016F\u2026","no_entries":"\u017D\xe1dn\xfd z\xe1znam","more":"V\xedce","login":"P\u0159ihl\xe1sit","login_in_progress":"P\u0159ihla\u0161ov\xe1n\xed\u2026","login_username":"Jm\xe9no","login_password":"Heslo","login_invalid_credentials":"\u0160patn\xe9 jm\xe9no nebo heslo","login_error_generic":"Pokus o p\u0159ihl\xe1\u0161en\xed selhal: {errorMessage}","no_title":"Bez titulku","error":"Nastala chyba","error_unauthorized":"Pro pokra\u010Dov\xe1n\xed se pros\xedm {link_begin}p\u0159ihlaste{link_end}.","error_check_log_file":"Nastala chyba, zkontrolujte pros\xedm z\xe1znamy v\xa0souboru \u201E{0}\u201C.","error_check_system_logs":"Nastala chyba, zkontrolujte pros\xedm z\xe1znamy v\xa0opera\u010Dn\xedm syst\xe9mu.","error_unwritable_logs":"Nebylo mo\u017En\xe9 zaznamenat chybu.","streamerror":"Nena\u010Dteny \u017E\xe1dn\xe9 polo\u017Eky, zkusit znovu?","reload_list":"Znovu na\u010D\xedst seznam","sources_refreshed":"Zdroje byly obnoveny","error_session_expired":"Va\u0161e sezen\xed vypr\u0161elo","error_add_source":"Zdroj nemohl b\xfdt p\u0159id\xe1n:","error_delete_source":"Zdroj nemohl b\xfdt smaz\xe1n:","error_load_tags":"\u0160t\xedtky nemohly b\xfdt na\u010Dteny:","error_unknown_tag":"Nezn\xe1m\xfd \u0161t\xedtek:","error_unknown_source":"Nezn\xe1m\xe9 id zdroje:","error_mark_items":"Nelze ozna\u010Dit v\u0161echny viditeln\xe9 zdroje:","error_mark_item":"Nelze ozna\u010Dit polo\u017Eku za (ne)p\u0159e\u010Dtenou:","error_star_item":"Nelze o(d)zna\u010Dit polo\u017Eku hv\u011Bzdi\u010Dkou:","error_logout":"Odhl\xe1\u0161en\xed se nezda\u0159ilo:","error_loading":"Chyba na\u010D\xedt\xe1n\xed:","error_loading_stats":"Na\u010D\xedt\xe1n\xed statistik se nezda\u0159ilo:","error_saving_color":"Nelze zm\u011Bnit barvu:","error_refreshing_source":"Nelze obnovit zdroje:","error_sync":"Synchronizace zm\u011Bn ze serveru selhala:","error_invalid_subsection":"Podsekce neexistuje:","online_count":"Polo\u017Eky dostupn\xe9 na serveru","offline_count":"Polo\u017Eky jsou dostupn\xe9 v prohl\xed\u017Ee\u010Di","offline_navigation_unavailable":"Offline re\u017Eim zat\xedm neumo\u017E\u0148uje p\u0159ep\xednat mezi \u0161t\xedtky a zdroji.","login_offline":"Ukl\xe1dat data v prohl\xed\u017Ee\u010Di","app_update":"selfoss byl aktualizov\xe1n, pros\xedm znovu na\u010Dt\u011Bte str\xe1nku","app_reload":"Znovu na\u010D\xedst","error_offline_storage":"Chyba lok\xe1ln\xedho \xfalo\u017Ei\u0161t\u011B: {0}. Mo\u017En\xe1 pom\u016F\u017Ee znovuna\u010Dten\xed str\xe1nky. Prozat\xedm bude ukl\xe1d\xe1n\xed vypnuto.","article_actions":"Akce","error_configuration":"Nelze na\u010D\xedst konfiguraci.","share_native_label":"Sd\xedlet","share_diaspora_label":"Sd\xedlet na Diaspo\u0159e","share_twitter_label":"Sd\xedlet na Twitteru","share_facebook_label":"Sd\xedlet na Facebooku","share_pocket_label":"Ulo\u017Eit do Pocketu","share_wallabag_label":"Ulo\u017Eit do Wallabagu","share_wordpress_label":"Sd\xedlet na WordPressu","share_mail_label":"Sd\xedlet e-mailem","share_copy_label":"Zkop\xedrovat odkaz do schr\xe1nky","info_url_copied":"URL zkop\xedrov\xe1na do schr\xe1nky.","error_share_native_abort":"Nelze sd\xedlet polo\u017Eku: bu\u010F v\xe1\u0161 prohl\xed\u017Ee\u010D nepodporuje sd\xedlen\xed odkaz\u016F, nebo jste sd\xedlen\xed zru\u0161ili.","error_share_native":"Nelze sd\xedlet polo\u017Eku.","close_dialog":"Zav\u0159\xedt","close_entry":"Zav\u0159\xedt","article_reading_time":"{0} min \u010Dten\xed","error_offline_storage_not_available":"Offline \xfalo\u017Ei\u0161t\u011B nen\xed dostupn\xe9. Ujist\u011Bte se, \u017Ee v\xe1\u0161 prohl\xed\u017Ee\u010D {0}podporuje rozhran\xed IndexedDB{1} a, pokud pou\u017E\xedv\xe1te prohl\xed\u017Ee\u010D zalo\u017Een\xfd na Google Chrome, \u017Ee nespou\u0161t\xedte selfoss v re\u017Eimu anonymn\xedho prohl\xed\u017Een\xed.","error_edit_source":"Nelze ulo\u017Eit zm\u011Bny zdroje:","experimental":"Experiment"}');


var $0f57265ba749b28b$exports = {};
$0f57265ba749b28b$exports = JSON.parse('{"markread":"Alles gelesen","newest":"Neueste","unread":"Ungelesen","starred":"Favoriten","tags":"Markierungen","alltags":"Alle Markierungen","timestamp":"{0,date} {0,time}","hours":"vor {0,plural,one {1 Stunde},other {# Stunden}}","minutes":"vor {0,plural,one {1 Minute},other {# Minuten}}","seconds":"{0,plural,one {Jetzt gerade},other {vor # Sekunden}}","days":"{0,plural,zero {heute},one {gestern},other {vor # Tagen}}","star":"behalten","unstar":"vergessen","mark":"als gelesen markieren","unmark":"als ungelesen markieren","load_img":"Zeige Bilder","open_window":"\xf6ffnen","next":"weiter","searchbutton":"suchen","refreshbutton":"Quellen aktualisieren","settingsbutton":"Einstellungen","logoutbutton":"Abmelden","loginbutton":"Anmelden","sources":"Quellen","source_add":"Quelle hinzuf\xfcgen","source_opml":"oder OPML-Datei oder Google Reader importieren","source_export":"Quellen exportieren","source_edit":"bearbeiten","source_filter":"Filter","source_delete":"l\xf6schen","source_warn":"Wirklich diesen Feed entfernen?","source_new":"Neue ungespeicherte Quelle","source_title":"Titel","source_autotitle_hint":"Leer lassen um automatisch Titel zu setzen","source_tags":"Markierungen","source_pwd_placeholder":"Nicht ge\xe4ndert","source_comma":"Komma getrennt","source_select":"Quelle ausw\xe4hlen","source_type":"Typ","source_save":"speichern","source_cancel":"abbrechen","source_saved":"gespeichert","source_last_post":"Letzter gesehener Beitrag","no_entries":"keine Eintr\xe4ge gefunden","more":"mehr","login":"Anmelden","login_username":"Benutzername","login_password":"Passwort","no_title":"kein Titel","error":"Ein Fehler ist aufgetreten","filter":"Filter","online_count":"Auf dem Server verf\xfcgbare Elemente","offline_count":"Lokal verf\xfcgbare Artikel","searchremove":"Suche ausblenden","source_refresh":"Diese Quelle aktualisieren","login_invalid_credentials":"Falscher Benutzername/Passwort","login_offline":"Offline-Speicherung","streamerror":"Keine Artikel geladen, neu laden?","reload_list":"Liste neu laden","sources_refreshed":"Quellen aktualisiert","app_update":"selfoss wurde aktualisiert, bitte neu laden","app_reload":"Neu laden","error_session_expired":"Session abgelaufen","error_add_source":"Die Quelle konnte nicht hinzugef\xfcgt werden:","error_delete_source":"Die Quelle konnte nicht gel\xf6scht werden:","error_load_tags":"Konnte Markierungen nicht laden:","error_unknown_tag":"Unbekannte Markierung:","error_unknown_source":"Unbekannte Quell-ID:","error_mark_items":"Es k\xf6nnen nicht alle sichtbaren Elemente markiert werden:","error_mark_item":"Das Markieren/Deaktivieren von Elementen ist nicht m\xf6glich:","error_star_item":"Artikel kann nicht ge-sternt oder ent-sternt werden:","error_logout":"Konnte nicht ausloggen:","error_loading":"Ladefehler:","error_loading_stats":"Nav-Statistiken k\xf6nnen nicht geladen werden:","error_saving_color":"Neue Farbe kann nicht gespeichert werden:","error_refreshing_source":"Quellen k\xf6nnen nicht aktualisiert werden:","error_sync":"Letzte \xc4nderungen vom Server konnten nicht synchronisiert werden:","error_offline_storage":"Offline-Speicherfehler: {0}. Neu laden k\xf6nnte helfen. Deaktiviere offline vorerst.","error_invalid_subsection":"Ung\xfcltiger Unterabschnitt:","search_label":"Suchbegriff","article_actions":"Aktionen","error_configuration":"Nicht m\xf6glich die Konfiguration zu laden.","info_url_copied":"URL in die Zwischenablage kopiert.","share_native_label":"teilen","share_diaspora_label":"auf Diaspora teilen","share_twitter_label":"auf Twitter teilen","share_facebook_label":"auf Facebook teilen","share_mastodon_label":"auf Mastodon teilen","share_pocket_label":"in Pocket speichern","share_wallabag_label":"in Wallabag speichern","share_wordpress_label":"teile auf WordPress","share_mail_label":"per E-Mail teilen","share_copy_label":"Link in die Zwischenablage kopieren","error_share_native_abort":"Es ist nicht m\xf6glich das Objekt zu teilen\u202F\u2013\u202Fentweder gibt es keine Ziele zum Teilen oder die Aktion wurde abgebrochen.","error_share_native":"Es ist nicht m\xf6glich das Objekt zu teilen.","close_entry":"Schlie\xdfen","error_offline_storage_not_available":"Offline-Speicherung ist nicht verf\xfcgbar. Stelle sicher, dass dein Browser die {0}IndexedDB-API unterst\xfctzt{1} und, falls du einen Browser auf Grundlage von Google Chrome benutzt, dass du selfoss nicht im Incognito-Modus ausf\xfchrst.","error_edit_source":"Konnte die \xc4nderungen an den Quellen nicht speichern:","error_unwritable_logs":"Logdateien konnten nicht geschrieben werden.","error_check_system_logs":"Ein Fehler ist aufgetreten, bitte die Systemlogs pr\xfcfen.","error_check_log_file":"Es ist ein Fehler aufgetreten, bitte Protokolldatei \u201E{0}\u201C pr\xfcfen.","offline_navigation_unavailable":"Markierungen und Quellen zu wechseln wird derzeit im Offline-Modus nicht unterst\xfctzt."}');


var $38fe93b221363e36$exports = {};
$38fe93b221363e36$exports = JSON.parse('{"markread":"Mark as read","filter":"Filter","newest":"Newest","unread":"Unread","starred":"Starred","online_count":"Items available on the server","offline_count":"Items available locally","offline_navigation_unavailable":"Switching tags and sources is currently not available in offline mode.","tags":"Tags","alltags":"All tags","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 hour},other {# hours}} ago","minutes":"{0,plural,one {1 minute},other {# minutes}} ago","seconds":"{0,plural,one {1 second},other {# seconds}} ago","days":"{0,plural,zero {today},one {yesterday},other {# days ago}}","star":"Star","unstar":"Unstar","mark":"Mark as read","unmark":"Mark as unread","load_img":"Show images","open_window":"Open","next":"Next","share_native_label":"Share","share_diaspora_label":"Share on Diaspora","share_twitter_label":"Share on Twitter","share_facebook_label":"Share on Facebook","share_mastodon_label":"Share on Mastodon","share_pocket_label":"Save to Pocket","share_wallabag_label":"Save to Wallabag","share_wordpress_label":"Share on WordPress","share_mail_label":"Share using e-mail","share_copy_label":"Copy link to clipboard","search_label":"Search term","searchbutton":"Search","searchremove":"Hide search","refreshbutton":"Refresh sources","settingsbutton":"Settings","logoutbutton":"Log out","loginbutton":"Log in","sources":"Sources","sources_loading":"Loading sources\u2026","no_sources":"No sources configured.","source_add":"Add source","source_opml":"or import an OPML file","source_export":"Export sources","source_edit":"Edit","source_filter":"Filter","source_menu":"More actions","source_browse":"Browse","source_delete":"Delete","source_warn":"Really delete this source?","source_deleting":"Deleting source\u2026","source_warn_cancel_dirty":"Discard unsaved changes?","source_new":"New unsaved source","source_title":"Title","source_autotitle_hint":"Leave empty to fetch title","source_tags":"Tags","source_pwd_placeholder":"Not changed","source_comma":"Comma separated","source_select":"Please select source","source_params_loading":"Loading parameters\u2026","source_type":"Type","source_save":"Save","source_cancel":"Cancel","source_saving":"Saving source changes\u2026","source_saved":"Saved","source_last_post":"Last post seen","source_refresh":"Refresh this source","source_go_to_settings":"Open in settings","sources_leaving_unsaved_prompt":"Leave settings with unsaved source changes?","tag_change_color_button_title":"Change color","entries_loading":"Loading entries\u2026","no_entries":"No entries found","more":"More","login":"Log in","login_in_progress":"Trying to log in\u2026","login_username":"Username","login_password":"Password","login_invalid_credentials":"Wrong username/password","login_error_generic":"Could not log in: {errorMessage}","login_offline":"Offline storage","no_title":"No title","experimental":"Experimental","error":"An error occurred","error_unauthorized":"Please {link_begin}sign in{link_end} to continue.","error_check_log_file":"An error occured, please check the log file \u201C{0}\u201D.","error_check_system_logs":"An error occured, please check your system logs.","error_unwritable_logs":"Unable to write logs.","streamerror":"No items loaded, reload?","reload_list":"Reload list","sources_refreshed":"Sources refreshed","app_update":"selfoss has been updated, please reload","app_reload":"Reload","error_session_expired":"Session expired","error_add_source":"Could not add source:","error_edit_source":"Could not save source changes:","error_delete_source":"Could not delete source:","error_load_tags":"Could not load tags:","error_unknown_tag":"Unknown tag:","error_unknown_source":"Unknown source ID:","error_mark_items":"Cannot mark all visible items:","error_mark_item":"Cannot mark/unmark item:","error_star_item":"Cannot star/unstar item:","error_logout":"Could not log out:","error_loading":"Loading error:","error_loading_stats":"Cannot load nav stats:","error_saving_color":"Cannot save new color:","error_refreshing_source":"Cannot refresh sources:","error_sync":"Could not sync last changes from server:","error_offline_storage":"Offline storage error: {0}. Reloading may help. Disabling offline for now.","error_offline_storage_not_available":"Offline storage is not available. Make sure your web browser {0}supports IndexedDB API{1} and, if you are using Google Chrome based browser, that you are not running selfoss in incognito mode.","error_invalid_subsection":"Invalid subsection:","error_configuration":"Unable to load configuration.","error_share_native_abort":"Unable to share item\u2014either there are no share targets, or you cancelled it.","error_share_native":"Unable to share item.","info_url_copied":"URL copied to clipboard.","close_dialog":"Close","close_entry":"Close","article_actions":"Actions","article_reading_time":"{0} min read"}');


var $75c67d0db824a550$exports = {};
$75c67d0db824a550$exports = JSON.parse('{"error_share_native_abort":"Unable to share item\u202F\u2013\u202Feither there are no share targets, or you cancelled it.","error_saving_color":"Cannot save new colour:","close_entry":"Close","error_share_native":"Unable to share item.","share_copy_label":"Copy link to clipboard","share_mail_label":"Share using e-mail","share_wordpress_label":"Share on WordPress","share_wallabag_label":"Save to Wallabag","share_pocket_label":"Save to Pocket","share_facebook_label":"Share on Facebook","share_twitter_label":"Share on Twitter","share_diaspora_label":"Share on Diaspora","share_native_label":"Share","info_url_copied":"URL copied to clipboard.","close_dialog":"Close","error_configuration":"Unable to load configuration.","article_actions":"Actions","search_label":"Search term","error_invalid_subsection":"Invalid subsection:","error_offline_storage":"Offline storage error: {0}. Reloading may help. Disabling offline for now.","error_sync":"Could not sync last changes from server:","error_refreshing_source":"Cannot refresh sources:","error_loading_stats":"Cannot load nav stats:","error_loading":"Loading error:","error_logout":"Could not log out:","error_star_item":"Cannot star/unstar item:","error_mark_item":"Cannot mark/unmark item:","error_mark_items":"Cannot mark all visible items:","error_unknown_source":"Unknown source ID:","error_unknown_tag":"Unknown tag:","error_load_tags":"Could not load tags:","error_delete_source":"Could not delete source:","error_add_source":"Could not add source:","error_session_expired":"Session expired","app_reload":"Reload","app_update":"selfoss has been updated, please reload","sources_refreshed":"Sources refreshed","reload_list":"Reload list","streamerror":"No items loaded, reload?","error":"An error occurred","no_title":"No title","login_offline":"Offline storage","login_invalid_credentials":"Wrong username/password","login_password":"Password","login_username":"Username","login":"Log in","more":"More","no_entries":"No entries found","source_refresh":"Refresh this source","source_last_post":"Last post seen","source_saved":"Saved","source_cancel":"Cancel","source_save":"Save","source_type":"Type","source_select":"Please select source","source_comma":"Comma separated","source_pwd_placeholder":"Not changed","source_tags":"Tags","source_autotitle_hint":"Leave empty to fetch title","source_title":"Title","source_new":"New unsaved source","source_warn":"Really delete this source?","source_delete":"Delete","source_filter":"Filter","source_edit":"Edit","source_export":"Export sources","source_opml":"or import an OPML file","source_add":"Add source","sources":"Sources","loginbutton":"Log in","logoutbutton":"Log out","settingsbutton":"Settings","refreshbutton":"Refresh sources","searchremove":"Hide search","searchbutton":"Search","next":"Next","open_window":"Open","load_img":"Show images","unmark":"Mark as unread","mark":"Mark as read","unstar":"Unstar","star":"Star","days":"{0,plural,zero {today},one {yesterday},other {# days ago}}","seconds":"{0,plural,one {1 second},other {# seconds}} ago","minutes":"{0,plural,one {1 minute},other {# minutes}} ago","hours":"{0,plural,one {1 hour},other {# hours}} ago","timestamp":"{0,date} {0,time}","alltags":"All tags","tags":"Tags","offline_count":"Items available locally","online_count":"Items available on the server","starred":"Starred","unread":"Unread","newest":"Newest","filter":"Filter","markread":"Mark as read","error_offline_storage_not_available":"Offline storage is not available. Make sure your web browser {0}supports IndexedDB API{1} and, if you are using Google Chrome based browser, that you are not running selfoss in incognito mode.","error_edit_source":"Could not save source changes:","error_unwritable_logs":"Unable to write logs.","error_check_system_logs":"An error occured, please check your system logs.","error_check_log_file":"An error occured, please check the log file \u2018{0}\u2019.","offline_navigation_unavailable":"Switching tags and sources is currently not available in offline mode.","experimental":"Experimental","entries_loading":"Loading entries\u2026","login_in_progress":"Trying to log in\u2026","login_error_generic":"Could not log in: {errorMessage}","error_unauthorized":"Please {link_begin}sign in{link_end} to continue.","no_sources":"No sources configured.","source_menu":"More actions","source_browse":"Browse","source_params_loading":"Loading parameters\u2026","sources_loading":"Loading sources\u2026","source_deleting":"Deleting source\u2026","source_saving":"Saving source changes\u2026","source_go_to_settings":"Open in settings","source_warn_cancel_dirty":"Discard unsaved changes?","sources_leaving_unsaved_prompt":"Leave settings with unsaved source changes?","tag_change_color_button_title":"Change colour","article_reading_time":"{0} min read","share_mastodon_label":"Share on Mastodon"}');


var $e09fd591c81d8c00$exports = {};
$e09fd591c81d8c00$exports = JSON.parse('{"markread":"marcar como le\xeddo","filter":"filtro","newest":"nuevos","unread":"no le\xeddos","starred":"preferidos","online_count":"Elementos disponibles en el servidor","offline_count":"Elementos disponibles localmente","tags":"Etiquetas","alltags":"todas las etiquetas","timestamp":"{0,date} {0,time}","hours":"hace {0,plural,one {1 hora},other {# horas}}","minutes":"hace {0,plural,one {1 minuto},other {# minutos}}","seconds":"hace {0,plural,one {1 segundo},other {# segundos}}","days":"{0,plural,zero {hoy},one {ayer},other {hace # d\xedas}}","star":"preferido","unstar":"ya no lo prefiero","mark":"marcar como le\xeddo","unmark":"marcar como no le\xeddo","load_img":"cargar Im\xe1genes","open_window":"abrir","next":"siguiente","searchbutton":"buscar","searchremove":"ocultar b\xfasqueda","refreshbutton":"actualizar fuentes","settingsbutton":"configuraci\xf3n","logoutbutton":"cerrar sesi\xf3n","loginbutton":"iniciar sesi\xf3n","sources":"Fuentes","source_add":"agregar fuente","source_opml":"o importar desde un archivo opml o desde Google Reader (Hasta el 15 de Julio de 2013)","source_export":"exportar fuentes","source_edit":"editar","source_filter":"Filtrar","source_delete":"borrar","source_warn":"realmente desea borrar esta fuente?","source_new":"nueva fuente sin guardar","source_title":"Titulo","source_autotitle_hint":"Dejar en blanco para obtener t\xedtulo","source_tags":"Etiquetas","source_pwd_placeholder":"no ha cambiado","source_comma":"separado por comas","source_select":"por favor seleccione una fuente","source_type":"Tipo","source_save":"Guardar","source_cancel":"cancelar","source_saved":"Guardado","source_last_post":"\xdaltima entrada vista","source_refresh":"Actualizar esta fuente","no_entries":"No se encontraron entradas","more":"m\xe1s","login":"iniciar sesi\xf3n","login_username":"usuario","login_password":"contrase\xf1a","login_invalid_credentials":"usuario/contrase\xf1a incorrectos","login_offline":"Almacenaje fuera de l\xednea","no_title":"sin t\xedtulo","error":"ha ocurrido un error","streamerror":"Ning\xfan elemento cargado, \xbfrecargar?","reload_list":"Recargar lista","sources_refreshed":"Las fuentes han sido refrescadas","app_update":"selfoss ha sido actualizado, recargue","app_reload":"Recargar","error_session_expired":"La sesi\xf3n ha expirado","error_add_source":"Error a\xf1adiendo fuente:","error_delete_source":"Error borrando fuente:","error_load_tags":"Error cargando etiquetas:","error_unknown_tag":"Etiqueta desconocida:","error_unknown_source":"Id de fuente desconocido:","error_mark_items":"No se pudo marcar todos los elementos visibles:","error_mark_item":"No se pudo marcar/desmarcar elemento:","error_star_item":"No se pudo preferir/despreferir elemento:","error_logout":"No se pudo registrar:","error_loading":"Error cargando:","error_loading_stats":"No se pudo cargar estad\xedsticas de navegaci\xf3n:","error_saving_color":"No se pudo cargar nuevo color:","error_refreshing_source":"No se pudo refrescar fuentes:","error_sync":"No se pudo sincronizar los \xfaltimos cambios del servidor:","error_offline_storage":"Error de almacenaje fuera de l\xednea: {0}. Recargar puede ayudar. Desactivando uso fuera de l\xednea por ahora.","error_invalid_subsection":"Subsecci\xf3n inv\xe1lida:","search_label":"Buscar t\xe9rmino","article_actions":"Acciones","error_configuration":"Imposible cargar configuraci\xf3n.","info_url_copied":"URL copiada al portapapeles.","share_native_label":"Compartir","share_diaspora_label":"Compartir en Diaspora","share_twitter_label":"Compartir en Twitter","share_facebook_label":"Compartir en Facebook","share_pocket_label":"Guardar en Pocket","share_wallabag_label":"Guardar en Wallabag","share_wordpress_label":"Compartir en WordPress","share_mail_label":"Compartir por e-mail","share_copy_label":"Copiar enlace al portapapeles","error_share_native_abort":"Imposible compartir \xedtem-no hay objetivos que compartir, o has cancelado.","error_share_native":"Imposible compartir \xedtem.","close_entry":"Cerrar","error_unwritable_logs":"Imposible escribir logs.","error_check_system_logs":"Un error ha ocurido, por favor comprueba tus logs de sistema.","error_check_log_file":"Un error ha ocurrido, por favor comprueba el fichero de log \u201C{0}\u201D.","offline_navigation_unavailable":"Cambiar etiquetas y fuentes no est\xe1 disponible en el modo fuera de l\xednea.","error_offline_storage_not_available":"Almacenaje fuera de l\xednea no est\xe1 disponible. Aseg\xfarese que su navegador {0}soporta IndexedDB API{1} y, si est\xe1 utilizando un navegador basado en Google Chrome, que no est\xe1 usando selfoss en modo inc\xf3gnito.","error_edit_source":"No se pudo guardar los cambios en las fuentes:","experimental":"Experimental","article_reading_time":"{0} min lectura","sources_loading":"Cargando fuentes\u2026","source_warn_cancel_dirty":"\xbfDescartar los cambios no guardados?","error_unauthorized":"Por favor, {link_begin}firme{link_end} para continuar.","no_sources":"No hay fuentes configuradas.","source_menu":"M\xe1s acciones","source_browse":"Navegar","source_deleting":"Borrando fuente\u2026","source_params_loading":"Cargando par\xe1metros\u2026","login_in_progress":"Intentando iniciar sesi\xf3n\u2026","source_saving":"Guardando cambios en la fuente\u2026","source_go_to_settings":"Abrir en los ajustes","tag_change_color_button_title":"Cambiar el color","entries_loading":"Cargando las entradas\u2026","login_error_generic":"No se ha podido iniciar la sesi\xf3n: {errorMessage}","sources_leaving_unsaved_prompt":"\xbfDejar la configuraci\xf3n con los cambios sin guardar?","share_mastodon_label":"Compartir en Mastodon"}');


var $09197c62e8f40c51$exports = {};
$09197c62e8f40c51$exports = JSON.parse('{"markread":"M\xe4rgi loetuks","newest":"Uued","unread":"Mitteloetud","starred":"T\xe4rniga","tags":"Sildid","alltags":"K\xf5ik sildid","timestamp":"lisatud {0,date} kell {0,time}","hours":"lisatud {0,plural,one {1 tund},other {# tundi}} tagasi","minutes":"lisatud {0,plural,one {1 minut},other {# minutit}} tagasi","seconds":"lisatud {0,plural,one {1 sekund},other {# sekundit}} tagasi","star":"Lisa t\xe4rn","unstar":"Eemalda t\xe4rn","mark":"M\xe4rgi loetuks","unmark":"M\xe4rgi mitteloetuks","load_img":"Laadi pildid","open_window":"Ava","searchbutton":"Otsi","sources":"Tellimused","source_add":"Lisa tellimus","source_opml":"v\xf5i impordi opml-fail v\xf5i Google Reader","source_export":"ekspordi tellimused","source_edit":"Muuda","source_delete":"Kustuta","source_warn":"Kas t\xf5esti kustutame tellimuse?","source_new":"Uus salvestamata tellimus","source_title":"Nimi","source_tags":"Sildid","source_comma":"komaga eraldatud","source_select":"Tellimuse allika liik","source_type":"Liik","source_save":"Salvesta","source_cancel":"Loobu","source_saved":"Salvestatud","no_entries":"\xdchtki s\xfcndmust ei leitud","more":"rohkem","login":"Logi sisse","login_username":"Kasutajanimi","login_password":"Salas\xf5na","no_title":"Nimeta","settingsbutton":"Seadistused","filter":"Filtreeri","share_diaspora_label":"Jaga Diaspora vahendusel","logoutbutton":"Logi v\xe4lja","streamerror":"\xdchtegi kirjet pole laaditud, kas laadime uuesti?","share_mastodon_label":"Jaga Mastodoni v\xf5rgus","share_wordpress_label":"Jaga WordPressis","share_native_label":"Jaga","offline_navigation_unavailable":"Vallasre\u017Eiimis ei saa hetkel silte ja tellimusi vahetada.","source_deleting":"Kustutame tellimuse\u2026","error_edit_source":"Tellimuse muudatuste salvestamine ei \xf5nnestunud:","login_in_progress":"Proovime sisselogida\u2026","error_mark_items":"K\xf5ikide n\xe4htavate kirjete m\xe4rkimine ei \xf5nnestu:","error_session_expired":"Sessioon on aegunud","error_load_tags":"Siltide laadimine ei \xf5nnestunud:","error_sync":"Viimaste muudatuste s\xfcnkroniseerimine serverist ei \xf5nnestu:","error_share_native":"Kirje jagamine ei \xf5nnestu.","close_entry":"Sulge","sources_refreshed":"Tellimus on v\xe4rskendatud","experimental":"Katselised seadistused","reload_list":"Laadi loend uuesti","error_add_source":"Tellimuse lisamine ei \xf5nnestunud:","share_facebook_label":"Jaga Facebookis","next":"J\xe4rgmine","loginbutton":"Logi sisse","share_wallabag_label":"Salvesta Wallabagi","error_offline_storage_not_available":"Vallasre\u017Eiimis andmehoidla pole saadaval. Palun kontrolli, et sinu veebibrauser {0}toetab IndexedDB APIt{1} ja kui sa kasutad Google Chrome brauserit, siis sa ei vaata selfoss saiti privaatses re\u017Eiimis.","error_invalid_subsection":"Vigane alaml\xf5ik:","error_configuration":"Seadistuste laadimine ei \xf5nnestu.","info_url_copied":"Aadress on kopeeritud l\xf5ikelauale.","article_actions":"Tegevused","article_reading_time":"Lugemiseks kulub {0} minutit","online_count":"Serveris leidub kirjeid","offline_count":"Kohalikus s\xfcsteemis leidub kirjeid","searchremove":"Peida otsing","source_filter":"Filtreeri","source_autotitle_hint":"Nime automaatseks tuvastamiseks j\xe4ta t\xfchjaks","source_pwd_placeholder":"Pole muudetud","login_invalid_credentials":"Vale kasutajanimi ja/v\xf5i salas\xf5na","refreshbutton":"V\xe4rskenda tellimusi","source_last_post":"Viimane n\xe4htud postitus","source_refresh":"V\xe4rskenda see tellimus","login_offline":"Vallasre\u017Eiimis andmehoidla","error":"Tekkis viga","days":"lisatud {0,plural,zero {t\xe4na},one {eile},other {# p\xe4eva tagasi}}","share_mail_label":"Jaga e-kirjaga","share_copy_label":"Kopeeri link l\xf5ikelauale","share_pocket_label":"Salvesta Pocketisse","share_twitter_label":"Jaga Twitteris/X\'is","search_label":"Otsingus\xf5na","source_menu":"T\xe4iendavad toimingud","source_browse":"Sirvi","source_warn_cancel_dirty":"Kas j\xe4tame muudatused salvestamata?","source_params_loading":"Laadime parameetreid\u2026","source_saving":"Salvestame tellimuse muudatusi\u2026","sources_loading":"Laadime tellimustest andmeid\u2026","no_sources":"\xdchtegi tellimust pole seadistatud.","source_go_to_settings":"Ava seadistustes","sources_leaving_unsaved_prompt":"Kas soovid lahkuda seadistustest ja j\xe4tta tellimuse muudatused salvestamata?","error_delete_source":"Tellimuse kustutamine ei \xf5nnestunud:","error_unknown_source":"Tellimuse teadmata tunnus:","error_refreshing_source":"Tellimuste v\xe4rskendamine ei \xf5nnestunud:","tag_change_color_button_title":"Muuda v\xe4rvi","entries_loading":"Laadime kirjeid\u2026","login_error_generic":"Sisselogimine ei \xf5nnestunud: {errorMessage}","error_unauthorized":"J\xe4tkamiseks palun {link_begin}logi sisse{link_end}.","error_check_log_file":"Tekkis viga, palun vaata logifaili \u201E{0}\u201C.","error_check_system_logs":"Tekkis viga, palun vaata s\xfcsteemi logifaile.","error_unwritable_logs":"Logide salvestamine ei \xf5nnestu.","app_update":"selfoss on uuendatud, palun laadi uuesti","app_reload":"Laadi uuesti","error_unknown_tag":"Tundmatu silt:","error_mark_item":"Kirje m\xe4rkimine v\xf5i m\xe4rkimise eemaldamine ei \xf5nnestu:","error_star_item":"Kirje t\xe4rniga m\xe4rkimine v\xf5i m\xe4rkimise eemaldamine ei \xf5nnestu:","error_logout":"V\xe4ljalogimine ei \xf5nnestunud:","error_loading":"Viga laadimisel:","error_loading_stats":"Statistika laadimine ei \xf5nnestu:","error_saving_color":"Uue v\xe4rvi salvestamine ei \xf5nnestu:","error_offline_storage":"Vallasre\u017Eiimis andmehoidla viga: {0}. Uuesti laadimine v\xf5ib viga parandada. L\xfclitame vallasre\u017Eiimi esialgu v\xe4lja.","error_share_native_abort":"Kirje jagamine ei \xf5nnestu - kas brauseris pole \xfchtegi jagamisviisi seadistatud v\xf5i katkestasid jagamise."}');


var $7bfc007d210a165f$exports = {};
$7bfc007d210a165f$exports = JSON.parse('{"markread":"merkitse luetuiksi","newest":"uusimmat","unread":"lukemattomat","starred":"t&auml;hdelliset","tags":"Avainsanat","alltags":"kaikki avainsanat","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 tunti},other {# tuntia}} sitten","minutes":"{0,plural,one {1 minuutti},other {# minuuttia}} sitten","seconds":"{0,plural,one {1 sekunti},other {# sekuntia}} sitten","star":"t&auml;hti","unstar":"t&auml;hti pois","mark":"luetuksi","unmark":"lukemattomaksi","load_img":"lataa kuvat","open_window":"avaa","searchbutton":"etsi","sources":"L&auml;hteet","source_add":"lis&auml;&auml; l&auml;hde","source_opml":"tai tuo opml-tiedosto tai google reader","source_export":"vie l&auml;hteet","source_edit":"muokkaa","source_delete":"poista","source_warn":"Haluatko varmasti poistaa t&auml;m&auml;n l&auml;hteen?","source_new":"uusi tallentamaton l&auml;hde","source_title":"Nimi","source_tags":"Avainsanat","source_comma":"avainsanat erotetaan pilkulla","source_select":"valitse l&auml;hde","source_type":"Tyyppi","source_save":"tallenna","source_cancel":"peruuta","source_saved":"tallennettu","no_entries":"merkint&ouml;j&auml; ei l&ouml;ydetty","more":"lis&auml;&auml;","login":"kirjaudu sis&auml;&auml;n","login_username":"k&auml;ytt&auml;j&auml;tunnus","login_password":"salasana","no_title":"ei otsikkoa","error_share_native_abort":"Kohteen jakaminen ep\xe4onnistui \u2013 joko jakamiskohteita ei ole tai peruutat sen.","close_entry":"Sulje","login_invalid_credentials":"V\xe4\xe4r\xe4 k\xe4ytt\xe4j\xe4nimi/salasana","share_mail_label":"Jaa s\xe4hk\xf6postitse","sources_refreshed":"L\xe4hteet virkistetty","error_refreshing_source":"L\xe4hteit\xe4 ei voi virkist\xe4\xe4:","source_refresh":"Virkist\xe4 t\xe4m\xe4 l\xe4hde","refreshbutton":"Virkist\xe4 l\xe4hteet"}');


var $5d661914acf6fff5$exports = {};
$5d661914acf6fff5$exports = JSON.parse('{"markread":"Marquer comme lu","filter":"Filtrer","newest":"Le plus r\xe9cent","unread":"Non lu","starred":"Favoris","online_count":"Sur le serveur","offline_count":"En local","tags":"\xc9tiquettes","alltags":"Toutes les \xe9tiquettes","timestamp":"{0,date} {0,time}","hours":"il y a {0,plural,one {1 heure},other {# heures}}","minutes":"il y a {0,plural,one {1 minute},other {# minutes}}","seconds":"il y a {0,plural,one {1 seconde},other {# secondes}}","days":"{0,plural,zero {aujourd\u2019hui},one {hier},other {il y a # jours}}","star":"Ajouter aux favoris","unstar":"Supprimer des favoris","mark":"Marquer comme lu","unmark":"Marquer comme non lu","load_img":"Afficher les images","open_window":"Ouvrir","next":"Suivant","searchbutton":"Rechercher","searchremove":"Masquer le champ de recherche","refreshbutton":"Actualiser les sources","settingsbutton":"Param\xe8tres","logoutbutton":"Se d\xe9connecter","loginbutton":"Se connecter","sources":"Sources","source_add":"Ajouter une source","source_opml":"ou importer un fichier OPML ou Google Reader","source_export":"Exporter les sources","source_edit":"Modifier","source_filter":"Filtre","source_delete":"Supprimer","source_warn":"Voulez-vous vraiment supprimer cette source ?","source_new":"Nouvelle source non sauvegard\xe9e","source_title":"Titre","source_autotitle_hint":"Laisser vide pour r\xe9cup\xe9rer le titre","source_tags":"\xc9tiquettes","source_pwd_placeholder":"Mot de passe inchang\xe9","source_comma":"S\xe9par\xe9s par une virgule","source_select":"Veuillez s\xe9lectionner une source","source_type":"Type","source_save":"Enregistrer","source_cancel":"Annuler","source_saved":"Enregistr\xe9","source_last_post":"Dernier \xe9l\xe9ment vu","source_refresh":"Rafra\xeechir cette source","no_entries":"Aucun article \xe0 consulter","more":"Plus","login":"Connexion","login_username":"Identifiant","login_password":"Mot de passe","login_invalid_credentials":"Nom d\u2019utilisateur/Mot de passe incorrect","login_offline":"Stockage hors-ligne","no_title":"Sans titre","error":"Une erreur est survenue","streamerror":"Une erreur s\u2019est produite lors du chargement de la liste, essayer \xe0 nouveau\xa0?","reload_list":"Recharger la liste","sources_refreshed":"Sources actualis\xe9es","app_update":"selfoss a \xe9t\xe9 mis \xe0 jour, merci de recharger","app_reload":"Recharger","error_session_expired":"Session expir\xe9e","error_add_source":"Impossible d\'ajouter la source\xa0:","error_delete_source":"Impossible de supprimer la source :","error_load_tags":"Impossible de charger les \xe9tiquettes :","error_unknown_tag":"Tag inconnu\xa0:","error_unknown_source":"Identifiant de source inconnu\xa0:","error_mark_items":"Impossible de marquer tous les \xe9l\xe9ments visibles\xa0:","error_mark_item":"Erreur lors du marquage lu/non lu\xa0:","error_star_item":"Erreur lors de l\u2019ajouter/suppression du favori\xa0:","error_logout":"Impossible de se d\xe9connecter\xa0:","error_loading":"Erreur de chargement\xa0:","error_loading_stats":"Impossible de charger les statistiques de navigation\xa0:","error_saving_color":"Impossible de sauvegarder une nouvelle couleur\xa0:","error_refreshing_source":"Impossible de rafra\xeechir les sources\xa0:","error_sync":"Impossible de synchroniser les derni\xe8res modifications du serveur\xa0:","error_offline_storage":"Erreur stockage hors-ligne : {0}. Recharger la page pourrait aider. Le mode hors-ligne est d\xe9sactiv\xe9 pour le moment.","error_invalid_subsection":"Sous-section erron\xe9e :","search_label":"Terme de recherche","article_actions":"Actions","error_configuration":"Impossible de charger la configuration.","info_url_copied":"URL copi\xe9e dans le presse-papiers.","share_native_label":"Partager","share_diaspora_label":"Partager sur Diaspora","share_twitter_label":"Partager sur Twitter","share_facebook_label":"Partager sur Facebook","share_pocket_label":"Enregistrer dans Pocket","share_wallabag_label":"Enregistrer dans Wallabag","share_wordpress_label":"Partager sur WordPress","share_mail_label":"Partager par courriel","share_copy_label":"Copier le lien dans le presse-papiers","error_share_native_abort":"Impossible de partager l\'\xe9l\xe9ment, soit il n\'y a pas de cible, soit vous avez annul\xe9 le partage.","error_share_native":"Impossible de partager l\'\xe9l\xe9ment.","close_entry":"Fermer","error_unwritable_logs":"Impossible d\'\xe9crire les fichiers de journalisation.","error_check_system_logs":"Une erreur est survenue. Veuillez consulter votre journalisation syst\xe8me.","error_check_log_file":"Une erreur est survenue. Veuillez consulter le fichier \xab {0} \xbb.","offline_navigation_unavailable":"Modifier les \xe9tiquettes et les sources n\'est pas possible hors ligne pour le moment.","error_offline_storage_not_available":"Le stockage hors ligne n\u2019est pas disponible. Assurez-vous que votre navigateur Web {0}prend en charge l\u2019API IndexedDB{1} et, si vous utilisez un navigateur bas\xe9 sur Google Chrome, que vous n\u2019ex\xe9cutez pas selfoss en mode de navigation priv\xe9e.","error_edit_source":"Impossible d\'enregistrer les modifications de la source\xa0:","source_browse":"Naviguer","no_sources":"Aucune source configur\xe9es.","source_warn_cancel_dirty":"Annuler les changements non sauvegard\xe9s ?","source_deleting":"Suppression de la source\u2026","source_saving":"Sauvegarde des changements de la source\u2026","entries_loading":"Chargement des entr\xe9es\u2026","source_menu":"Plus d\'actions","tag_change_color_button_title":"Changer la couleur","sources_loading":"Chargement des sources\u2026","source_go_to_settings":"Ouvrir dans les param\xe8tres","sources_leaving_unsaved_prompt":"Quitter les param\xe8tres avec des changements sur la source non sauvegard\xe9s ?","source_params_loading":"Chargement des param\xe8tres\u2026","experimental":"Exp\xe9rimentale","article_reading_time":"{0} min de lecture","login_in_progress":"Tentative de connexion\u2026","login_error_generic":"Connexion impossible : {errorMessage}","error_unauthorized":"S\'il vous pla\xeet {link_begin}connectez-vous{link_end} pour continuer."}');


var $17710b319b719f9f$exports = {};
$17710b319b719f9f$exports = JSON.parse('{"error_add_source":"Impossible d\'ajouter la source\u202F:","streamerror":"Une erreur s\u2019est produite lors du chargement de la liste, essayer \xe0 nouveau?","source_warn":"Voulez-vous vraiment supprimer cette source?","sources":"Sources","timestamp":"{0,date} {0,time}","close_entry":"Fermer","error_share_native":"Impossible de partager l\'\xe9l\xe9ment.","error_share_native_abort":"Impossible de partager l\'\xe9l\xe9ment, soit il n\'y a pas de cible, soit vous avez annul\xe9 le partage.","share_copy_label":"Copier le lien dans le presse-papiers","share_mail_label":"Partager par courriel","share_wordpress_label":"Partager sur WordPress","share_wallabag_label":"Enregistrer dans Wallabag","share_pocket_label":"Enregistrer dans Pocket","share_facebook_label":"Partager sur Facebook","share_twitter_label":"Partager sur Twitter","share_diaspora_label":"Partager sur Diaspora","share_native_label":"Partager","info_url_copied":"URL copi\xe9e dans le presse-papiers.","error_configuration":"Impossible de charger la configuration.","article_actions":"Actions","search_label":"Terme de recherche","error_invalid_subsection":"Sous-section erron\xe9e :","error_offline_storage":"Erreur stockage hors-ligne : {0}. Recharger la page pourrait aider. Le mode hors-ligne est d\xe9sactiv\xe9 pour le moment.","error_sync":"Impossible de synchroniser les derni\xe8res modifications du serveur\xa0:","error_refreshing_source":"Impossible de rafra\xeechir les sources\xa0:","error_saving_color":"Impossible de sauvegarder une nouvelle couleur\xa0:","error_loading_stats":"Impossible de charger les statistiques de navigation\xa0:","error_loading":"Erreur de chargement\xa0:","error_logout":"Impossible de se d\xe9connecter\xa0:","error_star_item":"Erreur lors de l\u2019ajouter/suppression du favori\xa0:","error_mark_item":"Erreur lors du marquage lu/non lu\xa0:","error_mark_items":"Impossible de marquer tous les \xe9l\xe9ments visibles\xa0:","error_unknown_source":"Identifiant de source inconnu\xa0:","error_unknown_tag":"Tag inconnu\xa0:","error_load_tags":"Impossible de charger les \xe9tiquettes :","error_delete_source":"Impossible de supprimer la source :","error_session_expired":"Session expir\xe9e","app_reload":"Recharger","app_update":"selfoss a \xe9t\xe9 mis \xe0 jour, merci de recharger","sources_refreshed":"Sources actualis\xe9es","reload_list":"Recharger la liste","error":"Une erreur est survenue","no_title":"Sans titre","login_offline":"Stockage hors-ligne","login_invalid_credentials":"Nom d\u2019utilisateur/Mot de passe incorrect","login_password":"Mot de passe","login_username":"Identifiant","login":"Connexion","more":"Plus","no_entries":"Aucun article \xe0 consulter","source_refresh":"Rafra\xeechir cette source","source_last_post":"Dernier \xe9l\xe9ment vu","source_saved":"Enregistr\xe9","source_cancel":"Annuler","source_save":"Enregistrer","source_type":"Type","source_select":"Veuillez s\xe9lectionner une source","source_comma":"S\xe9par\xe9s par une virgule","source_pwd_placeholder":"Mot de passe inchang\xe9","source_tags":"\xc9tiquettes","source_autotitle_hint":"Laisser vide pour r\xe9cup\xe9rer le titre","source_title":"Titre","source_new":"Nouvelle source non sauvegard\xe9e","source_delete":"Supprimer","source_filter":"Filtre","source_edit":"Modifier","source_export":"Exporter les sources","source_opml":"ou importer un fichier OPML ou Google Reader","source_add":"Ajouter une source","loginbutton":"Se connecter","logoutbutton":"Se d\xe9connecter","settingsbutton":"Param\xe8tres","refreshbutton":"Actualiser les sources","searchremove":"Masquer le champ de recherche","searchbutton":"Rechercher","next":"Suivant","open_window":"Ouvrir","load_img":"Afficher les images","unmark":"Marquer comme non lu","mark":"Marquer comme lu","unstar":"Supprimer des favoris","star":"Ajouter aux favoris","days":"{0,plural,zero {aujourd\u2019hui},one {hier},other {il y a # jours}}","seconds":"il y a {0,plural,one {1 seconde},other {# secondes}}","minutes":"il y a {0,plural,one {1 minute},other {# minutes}}","hours":"il y a {0,plural,one {1 heure},other {# heures}}","alltags":"Toutes les \xe9tiquettes","tags":"\xc9tiquettes","offline_count":"En local","online_count":"Sur le serveur","starred":"Favoris","unread":"Non lu","newest":"Le plus r\xe9cent","filter":"Filtrer","markread":"Marquer comme lu","error_offline_storage_not_available":"Le stockage hors ligne n\u2019est pas disponible. Assurez-vous que votre navigateur Web {0}prend en charge l\u2019API IndexedDB{1} et, si vous utilisez un navigateur bas\xe9 sur Google Chrome, que vous n\u2019ex\xe9cutez pas selfoss en mode de navigation priv\xe9e.","error_edit_source":"Impossible d\'enregistrer les modifications de la source :","error_unwritable_logs":"Impossible d\'\xe9crire les fichiers de journalisation.","error_check_system_logs":"Une erreur est survenue. Veuillez consulter votre journalisation syst\xe8me.","error_check_log_file":"Une erreur est survenue. Veuillez consulter le fichier \xab {0}\xa0\xbb.","offline_navigation_unavailable":"Modifier les \xe9tiquettes et les sources n\'est pas possible hors ligne pour le moment."}');


var $5842b3cf59e511d5$exports = {};
$5842b3cf59e511d5$exports = JSON.parse('{"tags":"Etiquetas","days":"{0,plural,zero {hoxe},one {onte},other {fai # d\xedas}}","unmark":"Marcar como non lido","share_pocket_label":"Gardar en Pocket","no_entries":"Non se atoparon rexistros","more":"M\xe1is","filter":"Filtro","online_count":"Elementos dispo\xf1ibles no servidor","offline_count":"Elementos dispo\xf1ibles localmente","timestamp":"{0,date} {0,time}","hours":"fai {0,plural,one {1 hora},other {# horas}}","minutes":"fai {0,plural,one {1 minuto},other {# minutos}}","seconds":"fai {0,plural,one {1 segundo},other {# segundos}}","share_wallabag_label":"Gardar en Wallabag","share_wordpress_label":"Compartir en WordPress","share_mail_label":"Compartir por email","share_copy_label":"Copiar ligaz\xf3n o portapap\xe9is","search_label":"Buscar termo","searchbutton":"Procurar","searchremove":"Agochar b\xfasqueda","refreshbutton":"Actualizar as fontes","settingsbutton":"Configuraci\xf3n","logoutbutton":"Fechar a sesi\xf3n","loginbutton":"Iniciar sesi\xf3n","sources":"Fontes","sources_loading":"Cargando as fontes\u2026","no_sources":"Non hai fontes configuradas.","source_add":"Engadir fonte","source_opml":"ou importa dende un ficheiro OPML","source_export":"Exportar fontes","source_edit":"Editar","source_filter":"Filtro","source_menu":"M\xe1is acci\xf3ns","source_browse":"Navegar","source_delete":"Borrar","source_warn":"Realmente queres borrar esta fonte?","source_deleting":"Borrando a fonte\u2026","source_warn_cancel_dirty":"Queres descargar os cambios non gardados?","source_new":"Nova fonte sen gardar","source_title":"T\xedtulo","source_autotitle_hint":"Deixar en branco pra obter t\xedtulo","source_type":"Tipo","source_save":"Gardar","source_cancel":"Cancelar","source_saving":"Gardando cambios da fonte\u2026","source_last_post":"\xdaltima entrada vista","error_session_expired":"A sesi\xf3n expirou","error_add_source":"Non se puido engadira a fonte:","error_edit_source":"Non se puideron gardar os cambios as fontes:","error_delete_source":"Erro borrando a fonte:","error_load_tags":"Non se puideron cargar as etiquetas:","error_unknown_tag":"Etiqueta desco\xf1ecida:","error_unknown_source":"Id de fonte desco\xf1ecida:","error_mark_items":"Non se puideron marcar todos os elementos visib\xe9is:","error_mark_item":"Non se puido marcar/desmarcar elemento:","error_star_item":"Non se puido marcar/desmarcar a estrela no elemento:","error_logout":"Non se puido fechar a sesi\xf3n:","error_loading":"Error cargando:","error_loading_stats":"Non se puideron cargar as estat\xedsticas de navegaci\xf3n:","error_saving_color":"Non se puido cargar a nova cor:","error_refreshing_source":"Non se puideron refrescar as fontes:","error_sync":"Non se puideron sincronizar os \xfaltimos cambios do servidor:","error_offline_storage":"Error do almacenamento fora de li\xf1a: {0}. Recargar pode axudar. Desactivando uso fora de li\xf1a polo momento.","share_twitter_label":"Compartir en Twitter","error_offline_storage_not_available":"Almacenamento fora de li\xf1a non dispo\xf1\xedbel. Asegurase de que o seu navegador {0} soporta IndexedDB API{1} e, se est\xe1 utilizando un navegador baseado en Google Chrome, que non est\xe9 usando selfoss en modo inc\xf3gnito.","error_invalid_subsection":"Subsecci\xf3n inv\xe1lida:","error_configuration":"Non se puido cargar a configuraci\xf3n.","error_share_native_abort":"Non se puido compartir o elemento, non tes onde compartilo ou cancel\xe1chelo.","error_share_native":"Non se puido compartir o elemento.","info_url_copied":"Copiouse a URL o portapap\xe9is.","close_entry":"Fechar","article_actions":"Acci\xf3ns","article_reading_time":"{0} min lectura","unread":"Non lidos","offline_navigation_unavailable":"Cambiar etiquetas e fontes non est\xe1 dispo\xf1ible no modo fora de li\xf1a.","source_go_to_settings":"Abrir a configuraci\xf3n","login_in_progress":"Intentando iniciar sesi\xf3n\u2026","markread":"Marcar como lido","newest":"Novos","alltags":"Todas as etiquetas","source_saved":"Gardado","source_refresh":"Actualizar esta fonte","tag_change_color_button_title":"Cambiar a cor","login":"Iniciar sesi\xf3n","login_password":"Contrasinal","sources_refreshed":"Actualizaronse as fontes","star":"Marcar con estrela","starred":"Con estrela","unstar":"Quitar a estrela","next":"Seguinte","share_native_label":"Compartir","share_diaspora_label":"Compartir en Diaspora","share_facebook_label":"Compartir en Facebook","source_comma":"Separado por comas","mark":"Marcar como lido","open_window":"Abrir","load_img":"Cargar imaxes","login_invalid_credentials":"Usuario/contrasinal incorrectos","source_tags":"Etiquetas","source_select":"Por favor, escolle unha fonte","source_pwd_placeholder":"Non cambiou","source_params_loading":"Estanse cargando os par\xe1metros\u2026","sources_leaving_unsaved_prompt":"Queres deixar a configuraci\xf3n con cambios de fonte non gardados?","login_username":"Usuario","entries_loading":"Estanse cargando as entradas\u2026","login_offline":"Almacenamento fora de li\xf1a","error":"Ocurriu un erro","error_check_system_logs":"Ocurriu un erro, por favor comproba os rexistros do sistema.","error_unwritable_logs":"Non se puideron escribir os rexistros.","no_title":"Sen t\xedtulo","experimental":"Experimental","error_check_log_file":"Produciuse un erro, por favor comproba o ficheiro de rexistro \\"{0}\\".","streamerror":"Non hai elementos cargados, recargar?","reload_list":"Recargar lista","app_update":"Selfoss actualizouse, recargue","app_reload":"Recargar","error_unauthorized":"{link_begin}inicia sesi\xf3n{link_end} para continuar.","login_error_generic":"Non se puido iniciar sesi\xf3n: {errorMessage}","share_mastodon_label":"Comparte en Mastodon"}');


var $785c4eb045100ebe$exports = {};
$785c4eb045100ebe$exports = JSON.parse('{"error_offline_storage_not_available":"\u05D4\u05D0\u05D7\u05E1\u05D5\u05DF \u05D4\u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF \u05D0\u05D9\u05E0\u05D5 \u05D6\u05DE\u05D9\u05DF. \u05E0\u05D0 \u05DC\u05D5\u05D5\u05D3\u05D0 \u05E9\u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05E9\u05DC\u05DA {0}\u05EA\u05D5\u05DE\u05DA \u05D1\u05BEAPI \u05DE\u05E1\u05D5\u05D2 IndexedDB{1} \u05D5\u05D2\u05DD, \u05D0\u05DD \u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05E9\u05DE\u05E9\u05DE\u05E9 \u05D0\u05D5\u05EA\u05DA \u05DE\u05D1\u05D5\u05E1\u05E1 Google Chrome, \u05E9\u05D6\u05D0\u05EA \u05D0\u05D9\u05E0\u05D4 \u05D2\u05DC\u05D9\u05E9\u05D4 \u05D1\u05E1\u05EA\u05E8.","error_invalid_subsection":"\u05EA\u05EA\u05BE\u05E1\u05E2\u05D9\u05E3 \u05E9\u05D2\u05D5\u05D9:","error_offline_storage":"\u05E9\u05D2\u05D9\u05D0\u05EA \u05D0\u05D7\u05E1\u05D5\u05DF \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF: {0}. \u05D0\u05D5\u05DC\u05D9 \u05E8\u05E2\u05E0\u05D5\u05DF \u05D9\u05E2\u05D6\u05D5\u05E8. \u05D4\u05DE\u05E6\u05D1 \u05D4\u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF \u05DE\u05D5\u05E9\u05D1\u05EA \u05DB\u05E8\u05D2\u05E2.","error_share_native_abort":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05EA\u05E3 \u05E4\u05E8\u05D9\u05D8 - \u05D0\u05D5 \u05E9\u05D0\u05D9\u05DF \u05D9\u05E2\u05D3 \u05DC\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D0\u05D5 \u05E9\u05D1\u05D9\u05D8\u05DC\u05EA.","error_configuration":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05D4\u05D2\u05D3\u05E8\u05D5\u05EA.","error_share_native":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05EA\u05E3 \u05E4\u05E8\u05D9\u05D8.","article_actions":"\u05E4\u05E2\u05D5\u05DC\u05D5\u05EA","close_entry":"\u05E1\u05D2\u05D9\u05E8\u05D4","info_url_copied":"\u05D4\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05D5\u05E2\u05EA\u05E7\u05D4 \u05DC\u05DC\u05D5\u05D7 \u05D4\u05D2\u05D6\u05D9\u05E8\u05D9\u05DD.","error_sync":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05E0\u05DB\u05E8\u05DF \u05D0\u05EA \u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05D4\u05D0\u05D7\u05E8\u05D5\u05E0\u05D9\u05DD \u05DE\u05D4\u05E9\u05E8\u05EA:","error_refreshing_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E8\u05E2\u05E0\u05DF \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA:","error_saving_color":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05DE\u05D5\u05E8 \u05E6\u05D1\u05E2 \u05D7\u05D3\u05E9:","error_loading_stats":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05E1\u05D8\u05D8\u05D9\u05E1\u05D8\u05D9\u05E7\u05EA \u05E0\u05D9\u05D5\u05D5\u05D8:","error_loading":"\u05E9\u05D2\u05D9\u05D0\u05EA \u05D8\u05E2\u05D9\u05E0\u05D4:","error_logout":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E6\u05D0\u05EA:","error_star_item":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1/\u05DC\u05D1\u05D8\u05DC \u05DB\u05D5\u05DB\u05D1 \u05E9\u05DC \u05E4\u05E8\u05D9\u05D8:","error_mark_item":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF/\u05DC\u05D1\u05D8\u05DC \u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05DC \u05E4\u05E8\u05D9\u05D8:","error_mark_items":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF \u05D0\u05EA \u05DB\u05DC \u05D4\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D4\u05D2\u05DC\u05D5\u05D9\u05D9\u05DD:","error_unknown_source":"\u05DE\u05D6\u05D4\u05D4 \u05D4\u05DE\u05E7\u05D5\u05E8 \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2:","error_unknown_tag":"\u05EA\u05D2\u05D9\u05EA \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2\u05D4:","error_load_tags":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05EA\u05D2\u05D9\u05D5\u05EA:","error_delete_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05DE\u05D7\u05D5\u05E7 \u05DE\u05E7\u05D5\u05E8:","error_edit_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05DE\u05D5\u05E8 \u05D0\u05EA \u05E9\u05D9\u05E0\u05D5\u05D9\u05D9 \u05D4\u05DE\u05E7\u05D5\u05E8:","error_add_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05DE\u05E7\u05D5\u05E8:","error_session_expired":"\u05EA\u05D5\u05E7\u05E3 \u05D4\u05D4\u05E4\u05E2\u05DC\u05D4 \u05E4\u05D2","app_reload":"\u05E8\u05E2\u05E0\u05D5\u05DF","app_update":"selfoss \u05D4\u05EA\u05E2\u05D3\u05DB\u05DF, \u05E0\u05D0 \u05DC\u05E8\u05E2\u05E0\u05DF","sources_refreshed":"\u05D4\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05D4\u05EA\u05E8\u05E2\u05E0\u05E0\u05D5","reload_list":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05E8\u05E9\u05D9\u05DE\u05D4","streamerror":"\u05DC\u05D0 \u05E0\u05D8\u05E2\u05E0\u05D5 \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD, \u05DC\u05E8\u05E2\u05E0\u05DF?","error_unwritable_logs":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05DB\u05EA\u05D5\u05D1 \u05D9\u05D5\u05DE\u05E0\u05D9\u05DD.","error_check_system_logs":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4, \u05E0\u05D0 \u05DC\u05E2\u05D9\u05D9\u05DF \u05D1\u05D9\u05D5\u05DE\u05E0\u05D9 \u05D4\u05DE\u05E2\u05E8\u05DB\u05EA \u05E9\u05DC\u05DA.","error_check_log_file":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4, \u05E0\u05D0 \u05DC\u05E2\u05D9\u05D9\u05DF \u05D1\u05E7\u05D5\u05D1\u05E5 \u05D4\u05D9\u05D5\u05DE\u05DF \u201E{0}\u201D.","error":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4","no_title":"\u05D0\u05D9\u05DF \u05DB\u05D5\u05EA\u05E8\u05EA","login_offline":"\u05D0\u05D7\u05E1\u05D5\u05DF \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF","login_invalid_credentials":"\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9/\u05E1\u05E1\u05DE\u05D4 \u05E9\u05D2\u05D5\u05D9\u05D9\u05DD","login_password":"\u05E1\u05E1\u05DE\u05D4","login_username":"\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9","login":"\u05DB\u05E0\u05D9\u05E1\u05D4","more":"\u05E2\u05D5\u05D3","no_entries":"\u05DC\u05D0 \u05E0\u05DE\u05E6\u05D0\u05D5 \u05E8\u05E9\u05D5\u05DE\u05D5\u05EA","source_refresh":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05D0\u05EA \u05D4\u05DE\u05E7\u05D5\u05E8 \u05D4\u05D6\u05D4","source_last_post":"\u05D4\u05E8\u05E9\u05D5\u05DE\u05D4 \u05D4\u05D0\u05D7\u05E8\u05D5\u05E0\u05D4 \u05E9\u05E0\u05E8\u05D0\u05EA\u05D4","source_saved":"\u05E0\u05E9\u05DE\u05E8","source_cancel":"\u05D1\u05D9\u05D8\u05D5\u05DC","source_save":"\u05E9\u05DE\u05D9\u05E8\u05D4","source_type":"\u05E1\u05D5\u05D2","source_select":"\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05DE\u05E7\u05D5\u05E8","source_comma":"\u05E2\u05DD \u05D4\u05E4\u05E8\u05D3\u05D4 \u05D1\u05E4\u05E1\u05D9\u05E7\u05D9\u05DD","source_pwd_placeholder":"\u05DC\u05D0 \u05D4\u05E9\u05EA\u05E0\u05D4","source_tags":"\u05EA\u05D2\u05D9\u05D5\u05EA","source_autotitle_hint":"\u05D9\u05E9 \u05DC\u05D4\u05E9\u05D0\u05D9\u05E8 \u05E8\u05D9\u05E7 \u05DB\u05D3\u05D9 \u05DC\u05E7\u05D1\u05DC \u05D0\u05EA \u05D4\u05DB\u05D5\u05EA\u05E8\u05EA","source_title":"\u05DB\u05D5\u05EA\u05E8\u05EA","source_new":"\u05DE\u05E7\u05D5\u05E8 \u05D7\u05D3\u05E9 \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8","source_warn":"\u05DC\u05DE\u05D7\u05D5\u05E7 \u05D0\u05EA \u05D4\u05DE\u05E7\u05D5\u05E8 \u05D4\u05D6\u05D4?","source_delete":"\u05DE\u05D7\u05D9\u05E7\u05D4","source_filter":"\u05DE\u05E1\u05E0\u05DF","source_edit":"\u05E2\u05E8\u05D9\u05DB\u05D4","source_export":"\u05D9\u05D9\u05E6\u05D5\u05D0 \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","source_opml":"\u05D0\u05D5 \u05DC\u05D9\u05D9\u05D1\u05D0 \u05E7\u05D5\u05D1\u05E5 OPML","source_add":"\u05D4\u05D5\u05E1\u05E4\u05EA \u05DE\u05E7\u05D5\u05E8","sources":"\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","loginbutton":"\u05DB\u05E0\u05D9\u05E1\u05D4","logoutbutton":"\u05D9\u05E6\u05D9\u05D0\u05D4","settingsbutton":"\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA","refreshbutton":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","searchremove":"\u05D4\u05E1\u05EA\u05E8\u05EA \u05D7\u05D9\u05E4\u05D5\u05E9","searchbutton":"\u05D7\u05D9\u05E4\u05D5\u05E9","search_label":"\u05D1\u05D9\u05D8\u05D5\u05D9 \u05DC\u05D7\u05D9\u05E4\u05D5\u05E9","share_copy_label":"\u05D4\u05E2\u05EA\u05E7\u05EA \u05E7\u05D9\u05E9\u05D5\u05E8 \u05DC\u05DC\u05D5\u05D7 \u05D2\u05D6\u05D9\u05E8\u05D9\u05DD","share_mail_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D3\u05D5\u05D0\u05F4\u05DC","share_wordpress_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D5\u05D5\u05E8\u05D3\u05E4\u05E8\u05E1","share_wallabag_label":"\u05E9\u05DE\u05D9\u05E8\u05D4 \u05D1\u05BEWallabag","share_pocket_label":"\u05E9\u05DE\u05D9\u05E8\u05D4 \u05D1\u05BEPocket","share_facebook_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05E4\u05D9\u05D9\u05E1\u05D1\u05D5\u05E7","share_twitter_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D8\u05D5\u05D5\u05D9\u05D8\u05E8","share_diaspora_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05BEDiaspora","share_native_label":"\u05E9\u05D9\u05EA\u05D5\u05E3","next":"\u05D4\u05D1\u05D0","open_window":"\u05E4\u05EA\u05D9\u05D7\u05D4","load_img":"\u05D4\u05E6\u05D2\u05EA \u05EA\u05DE\u05D5\u05E0\u05D5\u05EA","unmark":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05DC\u05D0 \u05E0\u05E7\u05E8\u05D0","mark":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05E0\u05E7\u05E8\u05D0","unstar":"\u05D1\u05D9\u05D8\u05D5\u05DC \u05DB\u05D5\u05DB\u05D1","star":"\u05DC\u05E1\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1","days":"{0,plural,zero {\u05D4\u05D9\u05D5\u05DD},one {\u05D0\u05EA\u05DE\u05D5\u05DC},two {\u05E9\u05DC\u05E9\u05D5\u05DD},other {\u05DC\u05E4\u05E0\u05D9 # \u05D9\u05DE\u05D9\u05DD}}","seconds":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05E9\u05E0\u05D9\u05D9\u05D4},other {# \u05E9\u05E0\u05D9\u05D5\u05EA}}","minutes":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05D3\u05E7\u05D4},other {# \u05D3\u05E7\u05D5\u05EA}}","hours":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05E9\u05E2\u05D4},two {\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD},other {# \u05E9\u05E2\u05D5\u05EA}}","timestamp":"\u200E{0,date} {0,time}","alltags":"\u05DB\u05DC \u05D4\u05EA\u05D2\u05D9\u05D5\u05EA","tags":"\u05EA\u05D2\u05D9\u05D5\u05EA","offline_navigation_unavailable":"\u05D4\u05D7\u05DC\u05E4\u05EA \u05EA\u05D2\u05D9\u05D5\u05EA \u05D5\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05D0\u05D9\u05E0\u05D4 \u05D6\u05DE\u05D9\u05E0\u05D4 \u05DB\u05E8\u05D2\u05E2 \u05D1\u05DE\u05E6\u05D1 \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF.","offline_count":"\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05DE\u05E7\u05D5\u05DE\u05D9\u05EA","online_count":"\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05D1\u05E9\u05E8\u05EA","starred":"\u05DE\u05E1\u05D5\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1","unread":"\u05DC\u05D0 \u05E0\u05E7\u05E8\u05D0","newest":"\u05D4\u05D7\u05D3\u05E9 \u05D1\u05D9\u05D5\u05EA\u05E8","filter":"\u05DE\u05E1\u05E0\u05DF","markread":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05E0\u05E7\u05E8\u05D0","article_reading_time":"{0} \u05D3\u05E7\u05D5\u05EA \u05E7\u05E8\u05D9\u05D0\u05D4","experimental":"\u05E0\u05D9\u05E1\u05D9\u05D5\u05E0\u05D9","source_warn_cancel_dirty":"\u05DC\u05D4\u05E9\u05DC\u05D9\u05DA \u05D0\u05EA \u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8\u05D5?","sources_leaving_unsaved_prompt":"\u05DC\u05E6\u05D0\u05EA \u05DE\u05D4\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA \u05E2\u05DD \u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05D1\u05DE\u05E7\u05D5\u05E8 \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8\u05D5?","source_browse":"\u05E2\u05D9\u05D5\u05DF","source_menu":"\u05E4\u05E2\u05D5\u05DC\u05D5\u05EA \u05E0\u05D5\u05E1\u05E4\u05D5\u05EA","tag_change_color_button_title":"\u05D4\u05D7\u05DC\u05E4\u05EA \u05E6\u05D1\u05E2","source_go_to_settings":"\u05E4\u05EA\u05D9\u05D7\u05D4 \u05D1\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA","sources_loading":"\u05D4\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05E0\u05D8\u05E2\u05E0\u05D9\u05DD\u2026","no_sources":"\u05DC\u05D0 \u05D4\u05D5\u05D2\u05D3\u05E8\u05D5 \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA.","source_deleting":"\u05D4\u05DE\u05E7\u05D5\u05E8 \u05E0\u05DE\u05D7\u05E7\u2026","source_params_loading":"\u05D4\u05DE\u05E9\u05EA\u05E0\u05D9\u05DD \u05E0\u05D8\u05E2\u05E0\u05D9\u05DD\u2026","source_saving":"\u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05DC\u05DE\u05E7\u05D5\u05E8 \u05E0\u05E9\u05DE\u05E8\u05D9\u05DD\u2026","entries_loading":"\u05D4\u05E8\u05E9\u05D5\u05DE\u05D5\u05EA \u05E0\u05D8\u05E2\u05E0\u05D5\u05EA\u2026","login_in_progress":"\u05DE\u05EA\u05D1\u05E6\u05E2 \u05E0\u05D9\u05E1\u05D9\u05D5\u05DF \u05DB\u05E0\u05D9\u05E1\u05D4\u2026","error_unauthorized":"\u05E0\u05D0 {link_begin}\u05DC\u05D4\u05D9\u05DB\u05E0\u05E1{link_end} \u05DB\u05D3\u05D9 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA.","login_error_generic":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05D9\u05DB\u05E0\u05E1: {errorMessage}","share_mastodon_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05BEMastodon"}');


var $2e8fa1e1c4881081$exports = {};
$2e8fa1e1c4881081$exports = JSON.parse('{"markread":"Mindet olvastam","newest":"Legfrissebb","unread":"Olvasatlan","starred":"Megjel\xf6lt","tags":"C\xedmk\xe9k","alltags":"\xd6sszes c\xedmke","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 \xf3r\xe1ja},other {# \xf3r\xe1ja}}","minutes":"{0,plural,one {1 perce},other {# perce}}","seconds":"{0,plural,one {1 m\xe1sodperce},other {# m\xe1sodperce}}","star":"Megjel\xf6lt","unstar":"Jel\xf6letlen","mark":"Olvasott","unmark":"Olvasatlan","load_img":"K\xe9pbet\xf6lt\xe9s","open_window":"Megnyit\xe1s","searchbutton":"Keres\xe9s","sources":"H\xedrforr\xe1sok","source_add":"\xdaj h\xedrforr\xe1s","source_opml":"OPML-f\xe1jl import\xe1l\xe1sa","source_export":"H\xedrforr\xe1sok export\xe1l\xe1sa","source_edit":"M\xf3dos\xedt\xe1s","source_delete":"T\xf6rl\xe9s","source_warn":"Biztos t\xf6r\xf6lhet\u0151 a h\xedrforr\xe1s?","source_new":"\xdaj h\xedrforr\xe1s","source_title":"C\xedm","source_tags":"C\xedmk\xe9k","source_comma":"(vessz\u0151vel tagolva)","source_select":"A t\xedpus kiv\xe1laszt\xe1sa","source_type":"T\xedpus","source_save":"Ment\xe9s","source_cancel":"M\xe9gsem","source_saved":"Mentve","no_entries":"Nincs megjelen\xedthet\u0151 h\xedr.","more":"Tov\xe1bbiak","login":"Bejelentkez\xe9s","login_username":"Felhaszn\xe1l\xf3n\xe9v","login_password":"Jelsz\xf3","no_title":"Nincs c\xedm","filter":"Sz\u0171r\u0151","online_count":"A kiszolg\xe1l\xf3n l\xe9v\u0151 h\xedrek sz\xe1ma","offline_count":"A helyben t\xe1rolt h\xedrek sz\xe1ma","error_session_expired":"A munkamenet lej\xe1rt.","app_reload":"\xdajrat\xf6lt\xe9s","sources_refreshed":"Az \xfaj h\xedrek keres\xe9se k\xe9sz.","reload_list":"\xdajrat\xf6lt\xe9s","error_unwritable_logs":"A napl\xf3 nem \xedrhat\xf3.","error":"Hiba t\xf6rt\xe9nt","source_pwd_placeholder":"V\xe1ltozatlan","source_filter":"Sz\u0171r\u0151","loginbutton":"Bejelentkez\xe9s","logoutbutton":"Kijelentkez\xe9s","close_entry":"Bez\xe1r\xe1s","share_native_label":"Megoszt\xe1s","error_load_tags":"Nem siker\xfclt bet\xf6lteni a c\xedmk\xe9ket:","searchremove":"Keres\u0151panel elrejt\xe9se","next":"K\xf6vetkez\u0151","app_update":"A selfoss friss\xedtve lett, \xfajra kell t\xf6lteni az oldalt.","error_offline_storage":"T\xe1rol\xf3hiba kapcsolat n\xe9lk\xfcli m\xf3dban: {0}. Az \xfajrat\xf6lt\xe9s seg\xedthet. A kapcsolat n\xe9lk\xfcli m\xf3d mostant\xf3l ki van kapcsolva.","error_star_item":"Nem siker\xfclt m\xf3dos\xedtani a h\xedr megjel\xf6lts\xe9g\xe9t:","days":"{0,plural,zero {ma},one {tegnap},other {# napja}}","share_twitter_label":"Twitter-megoszt\xe1s","share_mail_label":"Megoszt\xe1s e-mailben","settingsbutton":"Be\xe1ll\xedt\xe1sok","sources_loading":"H\xedrforr\xe1sok bet\xf6lt\xe9se\u2026","tag_change_color_button_title":"Sz\xedn cser\xe9je","entries_loading":"Bet\xf6lt\xe9s\u2026","login_invalid_credentials":"Hib\xe1s felhaszn\xe1l\xf3n\xe9v vagy jelsz\xf3","login_error_generic":"Sikertelen bejelentkez\xe9s: {errorMessage}","login_offline":"Kapcsolat n\xe9lk\xfcli t\xe1rol\xf3","experimental":"K\xeds\xe9rleti funkci\xf3","error_saving_color":"Nem siker\xfclt menteni az \xfaj sz\xednt:","error_sync":"Nem siker\xfclt szinkroniz\xe1lni a kiszolg\xe1l\xf3val:","error_configuration":"Nem siker\xfclt beolvasni a be\xe1ll\xedt\xe1sokat.","error_share_native_abort":"Nem siker\xfclt megosztani a h\xedrt \u2013 vagy nincsenek megoszt\xe1si c\xe9lok, vagy a m\u0171velet t\xf6r\xf6lve lett.","error_refreshing_source":"Nem siker\xfclt \xfaj h\xedreket keresni:","info_url_copied":"Az URL a v\xe1g\xf3lapra lett m\xe1solva.","article_actions":"M\u0171veletek","article_reading_time":"~{0} perc","share_diaspora_label":"Diaspora-megoszt\xe1s","share_facebook_label":"Facebook-megoszt\xe1s","offline_navigation_unavailable":"A c\xedmk\xe9k \xe9s h\xedrforr\xe1sok m\xf3dos\xedt\xe1sa kapcsolat n\xe9lk\xfcli m\xf3dban jelenleg nem t\xe1mogatott.","source_last_post":"Legut\xf3bbi h\xedr","source_refresh":"\xdaj h\xedrek keres\xe9se","source_go_to_settings":"Be\xe1ll\xedt\xe1sok","sources_leaving_unsaved_prompt":"Nem minden v\xe1ltoz\xe1s lett elmentve. Biztos bez\xe1rhat\xf3 be\xe1ll\xedt\xf3fel\xfclet?","error_share_native":"Nem siker\xfclt megosztani a h\xedrt.","share_mastodon_label":"Mastodon-megoszt\xe1s","share_pocket_label":"Pocket-ment\xe9s","share_wallabag_label":"Wallabag-ment\xe9s","share_wordpress_label":"WordPress-megoszt\xe1s","share_copy_label":"Hivatkoz\xe1s m\xe1sol\xe1sa","search_label":"Keres\u0151kifejez\xe9s","refreshbutton":"\xdaj h\xedrek keres\xe9se","no_sources":"Nincsenek megadva h\xedrforr\xe1sok.","source_menu":"Tov\xe1bbi m\u0171veletek","source_browse":"Megtekint\xe9s","source_deleting":"A h\xedrforr\xe1s t\xf6rl\xe9se\u2026","source_warn_cancel_dirty":"Bez\xe1r\xe1s ment\xe9s n\xe9lk\xfcl?","source_autotitle_hint":"\xdcresen hagyva automatikus kit\xf6lt\xe9s","source_params_loading":"Param\xe9terek bet\xf6lt\xe9se\u2026","source_saving":"A v\xe1ltoz\xe1sok ment\xe9se\u2026","login_in_progress":"Bejelentkez\xe9s\u2026","error_unauthorized":"A folytat\xe1shoz {link_begin}bejelentkez\xe9s{link_end} sz\xfcks\xe9ges.","error_check_log_file":"Hiba t\xf6rt\xe9nt, r\xe9szletek a napl\xf3f\xe1jlban: \u201E{0}\u201D.","error_check_system_logs":"Hiba t\xf6rt\xe9nt, r\xe9szletek a rendszernapl\xf3ban.","streamerror":"Nem t\xf6lt\u0151d\xf6tt le h\xedr. \xdajrat\xf6lt\xe9s?","error_add_source":"Nem siker\xfclt hozz\xe1adni a h\xedrforr\xe1st:","error_edit_source":"Nem siker\xfclt menteni a h\xedrforr\xe1s v\xe1ltoz\xe1sait:","error_delete_source":"Nem siker\xfclt t\xf6r\xf6lni a h\xedrforr\xe1st:","error_mark_items":"Nem siker\xfclt olvasottra \xe1ll\xedtani a megjelen\xedtett h\xedreket:","error_unknown_tag":"Ismeretlen c\xedmke:","error_unknown_source":"Ismeretlen h\xedrforr\xe1s-azonos\xedt\xf3:","error_mark_item":"Nem siker\xfclt m\xf3dos\xedtani a h\xedr olvasotts\xe1g\xe1t:","error_logout":"Nem siker\xfclt kijelentkezni:","error_loading":"Bet\xf6lt\xe9si hiba:","error_loading_stats":"Nem siker\xfclt bet\xf6lteni a b\xf6ng\xe9sz\xe9si statisztik\xe1t:","error_offline_storage_not_available":"Nem \xe1ll rendelkez\xe9sre t\xe1rol\xf3 a kapcsolat n\xe9lk\xfcli m\xf3dhoz. Ellen\u0151rizni kell, hogy a b\xf6ng\xe9sz\u0151 t\xe1mogatja-e az {0}IndexedDB API{1}-t, illetve Google Chrome alap\xfa b\xf6ng\xe9sz\u0151ben a selfoss nem haszn\xe1lhat\xf3 inkognit\xf3 m\xf3dban.","error_invalid_subsection":"\xc9rv\xe9nytelen aloldal:"}');


var $21a979911d58571c$exports = {};
$21a979911d58571c$exports = JSON.parse('{"timestamp":"{0,date} {0,time}","article_reading_time":"bacaan {0} menit","article_actions":"Tindakan","close_entry":"Tutup","info_url_copied":"Alamat URL disalin ke papanklip.","error_share_native":"Tidak dapat membagikan item.","error_share_native_abort":"Tidak dapat membagikan item\u2014kemungkinan disana tidak ada target untuk dibagikan, atau Anda membatalkan hal tersebut.","error_configuration":"Tidak dapat memuat konfigurasi.","error_invalid_subsection":"Subbagian tidak valid:","error_offline_storage_not_available":"Penyimpanan offline tidak tersedia. Pastikan peramban web Anda {0} mendukung DB API yang Terindeks {1} dan, jika Anda menggunakan peramban web Goggle Chrome, pastikan Anda tidak menjalankan selfoss di dalam mode incognito (rahasia).","error_offline_storage":"Kesalahan penyimpanan offline: {0}. Memuat ulang mungkin dapat membantu. Menonaktifkan offline untuk saat ini.","error_sync":"Tidak dapat mengsinkronisasi perubahan terakhir dari server:","error_refreshing_source":"Tidak dapat menyegarkan sumber:","error_saving_color":"Tidak dapat menyimpan warna baru:","error_loading_stats":"Tidak dapat memuat statistik navigasi:","error_loading":"Kesalahan dalam memuat:","error_logout":"Tidak dapat keluar:","error_star_item":"Tidak dapat bintangi/batal bintangi item:","error_mark_item":"Tidak dapat menandai/hapus tanda item:","error_mark_items":"Tidak dapat menandai semua item yang terlihat:","error_unknown_source":"ID sumber tidak diketahui:","error_unknown_tag":"Tag yang tidak diketahui:","error_load_tags":"Tidak dapat memuat tag:","error_delete_source":"Tidak dapat menghapus sumber:","error_edit_source":"Tidak dapat menyimpan perubahan sumber:","error_add_source":"Tidak dapat menambahkan sumber:","error_session_expired":"Sesi kadaluarsa","app_reload":"Muat ulang","app_update":"selfoss telah diperbarui, silahkan muat ulang","sources_refreshed":"Sumber telah disegarkan","reload_list":"Muat ulang daftar","streamerror":"Tidak ada item yang dimuat, muat ulang?","error_unwritable_logs":"Tidak dapat menulis log.","error_check_system_logs":"Sebuah kesalahan terjadi, silahkan periksa log sistem Anda.","error_check_log_file":"Sebuah kesalahan terjadi, silahkan periksa berkas log \\"{0}\\".","error":"Sebuah kesalahan terjadi","experimental":"Eksperimental","no_title":"Tidak ada judul","login_offline":"Penyimpanan offline","login_invalid_credentials":"Nama pengguna/kata sandi salah","login_password":"Kata sandi","login_username":"Nama pengguna","login":"Masuk","more":"Lebih banyak","no_entries":"Tidak ada entri ditemukan","source_refresh":"Segarkan sumber ini","source_last_post":"Postingan terakhir yang dilihat","source_cancel":"Batal","source_saved":"Disimpan","source_save":"Simpan","source_type":"Jenis","source_select":"Silahkan pilih sumber","source_comma":"Dipisahkan oleh koma","source_pwd_placeholder":"Tidak diubah","source_tags":"Tag","source_autotitle_hint":"Biarkan kosong untuk mengambil judul","source_title":"Judul","source_new":"Sumber baru yang belum disimpan","source_warn":"Yakin ingin menghapus sumber ini?","source_delete":"Hapus","source_filter":"Saring","source_edit":"Sunting","source_export":"Ekspor sumber","source_opml":"atau import sebuah berkas OPML","source_add":"Tambahkan sumber","sources":"Sumber","loginbutton":"Masuk","logoutbutton":"Keluar","settingsbutton":"Pengaturan","refreshbutton":"Segarkan sumber","searchremove":"Sembunyikan pencarian","searchbutton":"Cari","search_label":"Cari istilah","share_copy_label":"Salin tautan ke papanklip","share_mail_label":"Bagikan menggunakan email","share_wordpress_label":"Bagikan di WordPress","share_wallabag_label":"Simpan ke Wallabag","share_pocket_label":"Simpan ke Pocket","share_facebook_label":"Bagikan di Facebook","share_twitter_label":"Bagikan di Twitter","share_diaspora_label":"Bagikan di Diaspora","share_native_label":"Bagikan","load_img":"Tampilkan gambar","open_window":"Buka","next":"Selanjutnya","unmark":"Tandai sebagai belum dibaca","mark":"Tandai sebagai telah dibaca","unstar":"Batal Bintangi","star":"Bintangi","days":"{0,plural,zero {today},satu {yesterday},lainnya {# days ago}}","seconds":"{0,plural,one {1 second},lainnya {# seconds}} lalu","minutes":"{0,plural,one {1 minute},lainnya {# minutes}} lalu","hours":"{0,plural,one {1 hour},lainnya {# hours}} lalu","alltags":"Semua tag","tags":"Tag","offline_navigation_unavailable":"Menukar tag dan sumber saat ini tidak tersedia dalam mode offline.","offline_count":"Item tersedia secara lokal","online_count":"Item tersedia di server","starred":"Dilihat","unread":"Belum Dibaca","newest":"Terbaru","filter":"Saring","markread":"Tandai sebagai telah dibaca","entries_loading":"Memuat entri\u2026","source_deleting":"Menghapus sumber\u2026","source_saving":"Menyimpan perubahan sumber\u2026","sources_leaving_unsaved_prompt":"Tinggalkan setelan dengan perubahan sumber yang belum disimpan?","source_go_to_settings":"Buka pengaturan","source_menu":"Tindakan lainnya","login_in_progress":"Mencoba masuk\u2026","source_browse":"Telusuri","login_error_generic":"Tidak bisa masuk: {errorMessage}","source_params_loading":"Memuat parameter\u2026","share_mastodon_label":"Bagikan di Mastodon","sources_loading":"Memuat sumber\u2026","no_sources":"Tidak ada sumber yang dikonfigurasi.","error_unauthorized":"Silakan {link_begin}masuk{link_end} untuk melanjutkan.","source_warn_cancel_dirty":"Buang perubahan yang belum disimpan?","tag_change_color_button_title":"Ubah warna"}');


var $bcc60c6870c45310$exports = {};
$bcc60c6870c45310$exports = JSON.parse('{"markread":"Tutte lette","newest":"Recenti","unread":"Non lette","starred":"Contrassegnate","tags":"Etichette","alltags":"Tutte le etichette","timestamp":"{0,date} {0,time}","days":"{0,plural,one {1 ora},other {# ore}} fa","minutes":"{0,plural,one {1 minuto},other {# minuti}} fa","seconds":"{0,plural,one {1 secondo},other {# secondi}} fa","star":"Contrassegna","unstar":"Togli contrassegno","mark":"Segna come letta","unmark":"Segna come non letta","load_img":"Caricare le immagini","open_window":"Apri","searchbutton":"Ricerca","sources":"Fonti","source_add":"Aggiungi una fonte","source_opml":"o importa un file OPML / Google reader","source_export":"Esporta fonti","source_edit":"modifica","source_delete":"cancella","source_warn":"Vuoi veramente eliminare questa fonte?","source_new":"Nuova fonte","source_title":"Titolo","source_tags":"Etichette","source_comma":"separate da una virgola","source_select":"seleziona il tipo di fonte","source_type":"Tipo","source_save":"salva","source_cancel":"annulla","no_entries":"Nessuna pubblicazione","more":"Caricare altre pubblicazioni","login":"Accedi","login_username":"Nome utente","login_password":"Password","no_title":"Senza titolo","error_star_item":"Non \xe8 possibile contrassegnare/togliere il contrassegno per l\'elemento:","error_mark_item":"Impossibile segnare l\'elemento come letto/non letto:","article_actions":"Azioni","close_entry":"Chiudi","info_url_copied":"URL copiato negli appunti.","error_share_native":"Impossibile condividere l\'elemento.","error_share_native_abort":"Impossibile condividere l\'articolo\u202F\u2013\u202Fnon ci sono obiettivi di condivisione o l\'hai cancellato.","error_configuration":"Impossibile caricare la configurazione.","error_invalid_subsection":"Sottosezione non valida:","error_offline_storage":"Errore di archiviazione offline: {0}. Il ricaricamento pu\xf2 aiutare. Disabilitazione la modalit\xe0 offline per ora.","error_sync":"Impossibile sincronizzare le ultime modifiche dal server:","error_refreshing_source":"Impossibile aggiornare le fonti:","error_saving_color":"Impossibile salvare un nuovo colore:","error_loading_stats":"Impossibile caricare le statistiche di navigazione:","error_loading":"Errore di caricamento:","error_logout":"Impossibile uscire:","error_mark_items":"Impossibile contrassegnare tutti gli elementi visibili:","error_unknown_source":"Identificazione della fonte sconosciuta:","error_unknown_tag":"Etichetta sconosciuta:","error_load_tags":"Impossibile caricare le etichette:","error_delete_source":"Impossibile eliminare l\'origine:","error_add_source":"Impossibile aggiungere la fonte:","error_session_expired":"Sessione scaduta","app_reload":"Ricarica","app_update":"selfoss \xe8 stato aggiornato, si prega di ricaricare","sources_refreshed":"Fonti aggiornate","reload_list":"Ricarica l\'elenco","streamerror":"Nessun elemento caricato, ricaricare?","error":"Si \xe8 verificato un errore","source_refresh":"Aggiorna questa fonte","source_last_post":"Ultimo elemento visto","source_saved":"Salvato","source_pwd_placeholder":"Non cambiato","source_autotitle_hint":"Lascia vuoto per recuperare il titolo","source_filter":"Filtro","loginbutton":"Accedi","logoutbutton":"Esci","settingsbutton":"Impostazioni","refreshbutton":"Aggiorna le fonti","searchremove":"Nascondi la ricerca","search_label":"Termine di ricerca","share_copy_label":"Copia il collegamento negli appunti","share_wordpress_label":"Condividi su WordPress","share_wallabag_label":"Salva in Wallabag","share_pocket_label":"Salva in Pocket","share_facebook_label":"Condividi su Facebook","share_twitter_label":"Condividi su Twitter","share_diaspora_label":"Condividi su Diaspora","share_native_label":"Condividi","next":"Avanti","hours":"{0,plural,one {1 ora},other {# ore}} fa","offline_count":"Elementi disponibili localmente","online_count":"Articoli disponibili sul server","filter":"Filtra","share_mail_label":"Condividi via posta elettronica","login_offline":"Archiviazione offline","login_invalid_credentials":"Nome utente o password errato","error_offline_storage_not_available":"Non \xe8 disponibile memoria offline. Assicurati che il tuo browser web {0} supporti IdexedDB API {1} e che tu non stia utilizzando la modalit\xe0 incognito su browser basati su Google Chrome.","error_edit_source":"Impossibile salvare le modifiche alla fonte:","error_unwritable_logs":"Impossibile scrivere i log.","error_check_system_logs":"Si \xe8 verificato un errore, controlla i tuoi log di sistema.","error_check_log_file":"Si \xe8 verificato un errore, controlla il file di log \xab{0}\xbb.","offline_navigation_unavailable":"Al momento non \xe8 possibile modificare etichette e fonti nella modalit\xe0 fuori linea.","article_reading_time":"{0} min letti","experimental":"Sperimentale","source_go_to_settings":"Apri nelle impostazioni","sources_loading":"Caricamento delle fonti\u2026","source_deleting":"Eliminazione della fonte\u2026","source_browse":"Sfoglia","source_params_loading":"Caricamento dei parametri\u2026","no_sources":"Nessuna fonte configurata.","source_warn_cancel_dirty":"Scartare le modifiche non salvate?","source_menu":"Pi\xf9 azioni","sources_leaving_unsaved_prompt":"Esci dalle impostazioni con delle modifiche della fonte non salvate?","tag_change_color_button_title":"Cambia il colore","entries_loading":"Caricamento delle pubblicazioni\u2026","source_saving":"Salvataggio delle modifiche alla fonte\u2026","error_unauthorized":"Per favore {link_begin} connettiti{link_end} per continuare.","login_in_progress":"Tentativo di connessione\u2026","login_error_generic":"Connessione impossibile: {errorMessage}"}');


var $176dd0c127d964ee$exports = {};
$176dd0c127d964ee$exports = JSON.parse('{"markread":"\u65E2\u8AAD\u306B\u3059\u308B","filter":"\u30D5\u30A3\u30EB\u30BF\u30FC","newest":"\u65B0\u7740","unread":"\u672A\u8AAD","starred":"\u30B9\u30BF\u30FC","tags":"\u30BF\u30B0","alltags":"\u5168\u3066\u306E\u30BF\u30B0","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 \u6642\u9593},other {# \u6642\u9593}}\u524D","minutes":"{0,plural,one {1 \u5206},other {# \u5206}}\u524D","seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","days":"{0,plural,zero {\u4ECA\u65E5},one {\u6628\u65E5},other {# \u65E5\u524D}}","star":"\u30B9\u30BF\u30FC\u3092\u3064\u3051\u308B","unstar":"\u30B9\u30BF\u30FC\u3092\u5916\u3059","mark":"\u65E2\u8AAD\u306B\u3059\u308B","unmark":"\u672A\u8AAD\u306B\u3059\u308B","load_img":"\u753B\u50CF\u3092\u8868\u793A","open_window":"\u958B\u304F","next":"\u6B21\u3078","searchbutton":"\u691C\u7D22","searchremove":"\u691C\u7D22\u3092\u975E\u8868\u793A","refreshbutton":"\u30BD\u30FC\u30B9\u306E\u66F4\u65B0","settingsbutton":"\u8A2D\u5B9A","logoutbutton":"\u30ED\u30B0\u30A2\u30A6\u30C8","loginbutton":"\u30ED\u30B0\u30A4\u30F3","sources":"\u30BD\u30FC\u30B9","source_add":"\u30BD\u30FC\u30B9\u3092\u8FFD\u52A0","source_opml":"\u307E\u305F\u306F OPML \u30D5\u30A1\u30A4\u30EB\u3092\u30A4\u30F3\u30DD\u30FC\u30C8","source_export":"\u30BD\u30FC\u30B9\u3092\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8","source_edit":"\u7DE8\u96C6","source_filter":"\u30D5\u30A3\u30EB\u30BF\u30FC","source_delete":"\u524A\u9664","source_warn":"\u3053\u306E\u30BD\u30FC\u30B9\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","source_new":"\u65B0\u3057\u3044\u672A\u4FDD\u5B58\u306E\u30BD\u30FC\u30B9","source_title":"\u30BF\u30A4\u30C8\u30EB","source_tags":"\u30BF\u30B0","source_pwd_placeholder":"\u5909\u66F4\u3055\u308C\u3066\u3044\u307E\u305B\u3093","source_comma":"\u30AB\u30F3\u30DE(,)\u533A\u5207\u308A","source_select":"\u30BD\u30FC\u30B9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","source_type":"\u30BF\u30A4\u30D7","source_save":"\u4FDD\u5B58","source_cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","source_saved":"\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F","source_last_post":"\u6700\u7D42\u53C2\u7167\u65E5","source_refresh":"\u3053\u306E\u30BD\u30FC\u30B9\u3092\u66F4\u65B0","no_entries":"\u8A18\u4E8B\u304C\u3042\u308A\u307E\u305B\u3093","more":"\u3082\u3063\u3068\u898B\u308B","login":"\u30ED\u30B0\u30A4\u30F3","login_username":"\u30E6\u30FC\u30B6\u30FC\u540D","login_password":"\u30D1\u30B9\u30EF\u30FC\u30C9","no_title":"\u30BF\u30A4\u30C8\u30EB\u306A\u3057","error":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","streamerror":"\u8A18\u4E8B\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u307E\u3059\u304B\uFF1F","source_autotitle_hint":"\u7A7A\u306E\u307E\u307E\u306B\u3059\u308B\u3068\u30BF\u30A4\u30C8\u30EB\u3092\u53D6\u5F97\u3057\u307E\u3059","login_invalid_credentials":"\u30E6\u30FC\u30B6\u30FC\u540D/\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u9593\u9055\u3063\u3066\u3044\u307E\u3059","reload_list":"\u4E00\u89A7\u3092\u518D\u8AAD\u307F\u8FBC\u307F","sources_refreshed":"\u30BD\u30FC\u30B9\u3092\u66F4\u65B0\u3057\u307E\u3057\u305F","error_session_expired":"\u30BB\u30C3\u30B7\u30E7\u30F3\u304C\u671F\u9650\u5207\u308C\u3067\u3059","error_add_source":"\u30BD\u30FC\u30B9\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093:","error_delete_source":"\u30BD\u30FC\u30B9\u3092\u524A\u9664\u3067\u304D\u307E\u305B\u3093:","error_load_tags":"\u30BF\u30B0\u3092\u8AAD\u307F\u8FBC\u307F\u3067\u304D\u307E\u305B\u3093:","error_unknown_tag":"\u4E0D\u660E\u306A\u30BF\u30B0:","error_unknown_source":"\u4E0D\u660E\u306A\u30BD\u30FC\u30B9ID:","error_mark_items":"\u3059\u3079\u3066\u306E\u8868\u793A\u9805\u76EE\u3092\u30DE\u30FC\u30AF\u3067\u304D\u307E\u305B\u3093:","error_mark_item":"\u9805\u76EE\u3092\u30DE\u30FC\u30AF/\u30DE\u30FC\u30AF\u89E3\u9664\u3067\u304D\u307E\u305B\u3093:","error_star_item":"\u9805\u76EE\u3092\u30B9\u30BF\u30FC/\u30B9\u30BF\u30FC\u89E3\u9664\u3067\u304D\u307E\u305B\u3093:","error_logout":"\u30ED\u30B0\u30A2\u30A6\u30C8\u3067\u304D\u307E\u305B\u3093:","error_loading":"\u8AAD\u307F\u8FBC\u307F\u30A8\u30E9\u30FC:","error_loading_stats":"NAV\u7D71\u8A08\u3092\u8AAD\u307F\u8FBC\u307F\u3067\u304D\u307E\u305B\u3093:","error_saving_color":"\u65B0\u3057\u3044\u8272\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093:","error_refreshing_source":"\u30BD\u30FC\u30B9\u3092\u66F4\u65B0\u3067\u304D\u307E\u305B\u3093:","error_sync":"\u30B5\u30FC\u30D0\u304B\u3089\u6700\u5F8C\u306E\u5909\u66F4\u3092\u540C\u671F\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F:","error_invalid_subsection":"\u4E0D\u6B63\u306A\u30B5\u30D6\u30BB\u30AF\u30B7\u30E7\u30F3:","online_count":"\u30B5\u30FC\u30D0\u30FC\u3067\u5229\u7528\u53EF\u80FD\u306A\u9805\u76EE","offline_count":"\u30ED\u30FC\u30AB\u30EB\u3067\u5229\u7528\u53EF\u80FD\u306A\u9805\u76EE","login_offline":"\u30AA\u30D5\u30E9\u30A4\u30F3 \u30B9\u30C8\u30EC\u30FC\u30B8","app_update":"selfoss \u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u304F\u3060\u3055\u3044","app_reload":"\u518D\u8AAD\u307F\u8FBC\u307F","error_offline_storage":"\u30AA\u30D5\u30E9\u30A4\u30F3 \u30B9\u30C8\u30EC\u30FC\u30B8 \u30A8\u30E9\u30FC: {0}\u3002 \u518D\u8AAD\u307F\u8FBC\u307F\u304C\u5F79\u7ACB\u3064\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u4ECA\u306E\u3068\u3053\u308D\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u3092\u7121\u52B9\u306B\u3057\u307E\u3059\u3002","search_label":"\u691C\u7D22\u6761\u4EF6","article_actions":"\u30A2\u30AF\u30B7\u30E7\u30F3","error_configuration":"\u8A2D\u5B9A\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3002","info_url_copied":"URL\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002","article_reading_time":"{0} \u5206 \u8AAD\u307F\u307E\u3057\u305F","source_menu":"\u305D\u306E\u4ED6\u306E\u30A2\u30AF\u30B7\u30E7\u30F3","source_browse":"\u691C\u7D22","source_warn_cancel_dirty":"\u4FDD\u5B58\u3055\u308C\u3066\u3044\u306A\u3044\u5909\u66F4\u3092\u7834\u68C4\u3057\u307E\u3059\u304B\uFF1F","sources_leaving_unsaved_prompt":"\u30BD\u30FC\u30B9\u306E\u5909\u66F4\u3092\u4FDD\u5B58\u305B\u305A\u306B\u8A2D\u5B9A\u3092\u6B8B\u3057\u307E\u3059\u304B\uFF1F","experimental":"\u8A66\u9A13\u7684","error_check_system_logs":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30B7\u30B9\u30C6\u30E0\u30ED\u30B0\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","error_edit_source":"\u30BD\u30FC\u30B9\u306E\u5909\u66F4\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\uFF1A","error_share_native":"\u30A2\u30A4\u30C6\u30E0\u3092\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u3002","error_share_native_abort":"\u30A2\u30A4\u30C6\u30E0\u3092\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u2014\u5171\u6709\u5148\u304C\u306A\u3044\u304B\u3001\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F\u3002","share_pocket_label":"Pocket \u306B\u4FDD\u5B58","share_twitter_label":"Twitter \u3067\u30B7\u30A7\u30A2","close_entry":"\u9589\u3058\u308B","share_facebook_label":"Facebook \u3067\u30B7\u30A7\u30A2","offline_navigation_unavailable":"\u73FE\u5728\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u30E2\u30FC\u30C9\u3067\u306F\u30BF\u30B0\u3068\u30BD\u30FC\u30B9\u306E\u5207\u308A\u66FF\u3048\u304C\u3067\u304D\u307E\u305B\u3093\u3002","share_diaspora_label":"Diaspora \u3067\u30B7\u30A7\u30A2","share_wallabag_label":"Wallabag \u306B\u4FDD\u5B58","share_copy_label":"\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC","error_check_log_file":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30ED\u30B0\u30D5\u30A1\u30A4\u30EB\u300C{0}\u300D\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","error_unwritable_logs":"\u30ED\u30B0\u3092\u66F8\u304D\u8FBC\u3081\u307E\u305B\u3093\u3002","share_mail_label":"\u30E1\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u3066\u5171\u6709","share_native_label":"\u5171\u6709","share_wordpress_label":"WordPress \u3067\u30B7\u30A7\u30A2","error_offline_storage_not_available":"\u30AA\u30D5\u30E9\u30A4\u30F3\u30B9\u30C8\u30EC\u30FC\u30B8\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002 Web\u30D6\u30E9\u30A6\u30B6 {0} \u304CIndexedDBAPI {1} \u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u308B\u3053\u3068\u3001\u304A\u3088\u3073 Google Chrome \u30D9\u30FC\u30B9\u306E\u30D6\u30E9\u30A6\u30B6\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u30E2\u30FC\u30C9\u3067 selfoss \u3092\u5B9F\u884C\u3057\u3066\u3044\u306A\u3044\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","share_mastodon_label":"Mastodon \u3067\u30B7\u30A7\u30A2"}');


var $96d4cdcff3e97d75$exports = {};
$96d4cdcff3e97d75$exports = JSON.parse('{"markread":"atz\u012Bm\u0113t k\u0101 izlas\u012Btu","filter":"filtrs","newest":"jaun\u0101kais","unread":"neizlas\u012Bts","starred":"ar zvaigzn\u012Bt\u0113m","tags":"Birkas","alltags":"visas birkas","timestamp":"{0,date} {0,time}","hours":"pirms {0,plural,one {1 stundas},other {# stund\u0101m}}","minutes":"pirms {0,plural,one {1 min\u016Btes},other {# min\u016Bt\u0113m}}","seconds":"pirms {0,plural,one {1 sekundes},other {# sekund\u0113m}}","days":"{0,plural,zero {\u0161odien},one {vakardien},other {pirms # dien\u0101m}}","star":"pievienot zvaigzn\u012Bti","unstar":"no\u0146emt zvaigzn\u012Bti","mark":"atz\u012Bm\u0113t k\u0101 izlas\u012Btu","unmark":"atz\u012Bm\u0113t k\u0101 neizlas\u012Btu","load_img":"iel\u0101d\u0113t bildes","open_window":"atv\u0113rt","next":"n\u0101kamais","searchbutton":"mekl\u0113t","searchremove":"sl\u0113pt mekl\u0113\u0161anu","refreshbutton":"atsvaidzin\u0101t avotus","settingsbutton":"iestat\u012Bjumi","logoutbutton":"iziet","loginbutton":"ieiet","sources":"Avoti","source_add":"pievienot avotu","source_opml":"vai import\u0113t opml failu, vai google las\u012Bt\u0101ju","source_export":"eksport\u0113t avotus","source_edit":"labot","source_filter":"Filtrs","source_delete":"dz\u0113st","source_warn":"Vai tie\u0161\u0101m v\u0113laties dz\u0113st \u0161o avotu?","source_new":"nesaglab\u0101ts avots","source_title":"Nosaukums","source_tags":"Birkas","source_pwd_placeholder":"nav main\u012Bjies","source_comma":"atdal\u012Bt ar komatu","source_select":"l\u016Bdzu izv\u0113lieties avotu","source_type":"Tips","source_save":"saglab\u0101t","source_cancel":"atcelt","source_saved":"saglab\u0101ts","source_last_post":"P\u0113d\u0113j\u0101 zi\u0146a redz\u0113ta","no_entries":"nav ierakstu","more":"v\u0113l","login":"ien\u0101kt","login_username":"Lietot\u0101jv\u0101rds","login_password":"Parole","no_title":"nav nosaukuma","error":"k\u013C\u016Bda","streamerror":"Zi\u0146as nav iel\u0101d\u0113tas, p\u0101rl\u0101d\u0113t?"}');


var $662f6aa9e169a442$exports = {};
$662f6aa9e169a442$exports = JSON.parse('{"markread":"Marker som lest","newest":"Nyeste","unread":"Ulest","starred":"Stjernemerket","tags":"Etiketter","alltags":"Alle etiketter","timestamp":"{0,date} {0,time}","hours":"for {0,plural,one {\xe9n time},other {# timer}} ago","minutes":"for {0,plural,one {ett minutt},other {# minutter}} ago","seconds":"for {0,plural,one {ett sekund},other {# sekunder}} siden","star":"Stjernemerk","unstar":"Fjern stjerne","mark":"Marker som lest","unmark":"Marker som ulest","load_img":"Vis bilder","open_window":"\xc5pne","searchbutton":"S\xf8k","sources":"Kilder","source_add":"Legg til kilde","source_opml":"eller importer en OPML-fil","source_export":"Eksporter kilder","source_edit":"Endre","source_delete":"Slett","source_warn":"Vil du virkelig fjerne denne kilden?","source_new":"Ny ulagret kilde","source_title":"Tittel","source_tags":"Etiketter","source_comma":"Kommainndelt","source_select":"Velg kilde","source_type":"Type","source_save":"Lagre","source_cancel":"Avbryt","source_saved":"Lagret","no_entries":"Ingen data funnet","more":"Mer","login":"Logg inn","login_username":"Brukernavn","login_password":"Passord","filter":"Filtrer","days":"{0,plural,zero {i dag},one {i g\xe5r},other {# dager siden}}","next":"Neste","searchremove":"Skjul s\xf8k","refreshbutton":"Gjenoppfrisk kilder","settingsbutton":"Innstillinger","logoutbutton":"Logg ut","loginbutton":"Logg inn","source_filter":"Filter","source_autotitle_hint":"La st\xe5 tom for \xe5 hente tittel","source_pwd_placeholder":"Ikke endret","source_last_post":"Siste post sett","source_refresh":"Gjenoppfrisk denne kilden","login_invalid_credentials":"Feil brukernavn/passord","no_title":"Ingen tittel","error":"En feil inntraff","streamerror":"Ingen elementer ble lastet inn, gjeninnlast?","reload_list":"Gjeninnlast liste","sources_refreshed":"Kilder gjeninnlastet","error_session_expired":"\xd8kt utl\xf8pt","error_add_source":"Kunne ikke legge til kilde:","error_delete_source":"Kunne ikke slette kilde:","error_load_tags":"Kunne ikke laste inn etiketter:","error_unknown_tag":"Ukjent etikett:","error_unknown_source":"Ukjent kilde-ID:","error_mark_items":"Kan ikke merke alle synlige elementer:","error_mark_item":"Kan ikke merke/oppheve merking av element:","error_star_item":"Kan ikke stjernemerke/oppheve stjernemerking av element:","error_logout":"Kunne ikke logge ut:","error_loading":"Innlastingsfeil:","error_loading_stats":"Kan ikke laste navigeringsstatistikk:","error_saving_color":"Kan ikke lagre ny farge:","error_refreshing_source":"Kan ikke gjenoppfriske kilder:","error_sync":"Kunne ikke synkronisere siste endringer fra tjener:","error_invalid_subsection":"Ugyldig underdel:","online_count":"Elementer tilgjengelige p\xe5 tjeneren","offline_count":"Elementer tilgjengelige lokalt","login_offline":"Frakoblet lagring","app_update":"selfoss har blitt oppdatert, last inn p\xe5 ny","app_reload":"Gjeninnlast","error_offline_storage":"Lagringsfeil for frakoblet lagring: {0}. Gjeninnlasting kan hjelpe. Skrur av frakoblet imens.","search_label":"S\xf8ketekst","article_actions":"Handlinger","error_configuration":"Kunne ikke laste inn oppsett.","info_url_copied":"Nettadresse kopiert til utklippstavle.","share_native_label":"Del","share_diaspora_label":"Del p\xe5 Diaspora","share_twitter_label":"Del p\xe5 Twitter","share_facebook_label":"Del p\xe5 Facebook","share_pocket_label":"Del til Pocket","share_wallabag_label":"Lagre p\xe5 Wallabag","share_wordpress_label":"Lagre p\xe5 WordPress","share_mail_label":"Del ved bruk av e-post","share_copy_label":"Kopier lenke til utklippstavle","error_share_native_abort":"Kunne ikke dele element, enten finnes det ingen delingsm\xe5l, eller du har avbrutt deling.","error_share_native":"Kunne ikke dele element.","close_entry":"Lukk","error_unwritable_logs":"Kunne ikke loggf\xf8re.","error_check_log_file":"En feil inntraff, sjekk loggfilen \u201C{0}\u201D.","error_check_system_logs":"En feil inntraff, sjekk systemloggene dine.","offline_navigation_unavailable":"\xc5 bytte etiketter og kilder st\xf8ttes forel\xf8pig ikke i frakoblet modus.","error_offline_storage_not_available":"Frakoblet lager ikke tilgjengelig. S\xf8rg for at din nettleser {0}st\xf8tter IndexedDB-API-et{1}, samt at du ikke bruker incognito-modus i en Chrome-basert nettleser.","error_edit_source":"Kunne ikke lagre kildeendringer:","article_reading_time":"{0} min \xe5 lese","experimental":"Eksperimentell","sources_leaving_unsaved_prompt":"Forlat innstillinger med ulagrede kildeendringer?","source_warn_cancel_dirty":"Forkast ulagrede endringer?"}');


var $ce919b35c66c9734$exports = {};
$ce919b35c66c9734$exports = JSON.parse("{\"markread\":\"markeer gelezen\",\"newest\":\"nieuwste\",\"unread\":\"ongelezen\",\"starred\":\"met ster\",\"tags\":\"Tags\",\"alltags\":\"alle tags\",\"timestamp\":\"{0,date} {0,time}\",\"hours\":\"{0,plural,one {1 hour},other {# uren}} geleden\",\"minutes\":\"{0,plural,one {1 minute},other {# minuten}} geleden\",\"seconds\":\"{0,plural,one {1 second},other {# seconden}} geleden\",\"days\":\"{0,plural,zero {vandaag},one {gisteren},other {# dagen geleden}}\",\"star\":\"ster\",\"unstar\":\"ster verwijderen\",\"mark\":\"gelezen\",\"unmark\":\"ongelezen\",\"load_img\":\"afbeeldingen tonen\",\"open_window\":\"open\",\"searchbutton\":\"zoeken\",\"sources\":\"Bron\",\"source_add\":\"bron toevoegen\",\"source_opml\":\"of importeer opml bestand of google reader\",\"source_export\":\"exporteer bronnen\",\"source_edit\":\"wijzig\",\"source_delete\":\"verwijder\",\"source_warn\":\"bron echt verwijderen?\",\"source_new\":\"nieuwe bron\",\"source_title\":\"Titel\",\"source_tags\":\"Tags\",\"source_comma\":\"komma gescheiden\",\"source_select\":\"selecteer een bron\",\"source_type\":\"Soort\",\"source_save\":\"opslaan\",\"source_cancel\":\"annuleren\",\"source_saved\":\"opgeslagen\",\"source_last_post\":\"Meest recente artikel is gevonden\",\"no_entries\":\"geen items gevonden\",\"more\":\"meer\",\"login\":\"inloggen\",\"login_username\":\"gebruikersnaam\",\"login_password\":\"wachtwoord\",\"no_title\":\"geen titel\"}");


var $33fd991f65022a1d$exports = {};
$33fd991f65022a1d$exports = JSON.parse('{"markread":"oznacz jako przeczytane","filter":"filtr","newest":"najnowsze","unread":"nieprzeczytane","starred":"z gwiazdk\u0105","tags":"Tagi","alltags":"wszystkie","timestamp":"{0,date} {0,time}","hours":"przed {0,plural,one {godzin\u0105},other {# godzinami}}","minutes":"przed {0,plural,one {minut\u0105},other {# minutami}}","seconds":"przed {0,plural,one {chwil\u0105},other {# sekundami}}","days":"{0,plural,zero {dzisiaj},one {wczoraj},other {przejrzany # dni temu}}","star":"oznacz gwiazdk\u0105","unstar":"usu\u0144 gwiazdk\u0119","mark":"oznacz jako przeczytane","unmark":"oznacz jako nieprzeczytane","load_img":"pobierz obrazy","open_window":"otw\xf3rz","next":"nast\u0119pny","searchbutton":"szukaj","searchremove":"ukryj wyszukiwanie","refreshbutton":"od\u015Bwie\u017C","settingsbutton":"opcje","logoutbutton":"wyloguj","loginbutton":"zaloguj","sources":"\u0179r\xf3d\u0142a","source_add":"dodaj \u017Ar\xf3d\u0142o","source_opml":"lub zaimportuj plik OPML z Google Reader","source_export":"eksportuj \u017Ar\xf3d\u0142a","source_edit":"edytuj","source_filter":"Filtr","source_delete":"usu\u0144","source_warn":"Czy na pewno chcesz usun\u0105\u0107 to \u017Ar\xf3d\u0142o?","source_new":"nowe niezapisane \u017Ar\xf3d\u0142o","source_title":"Tytu\u0142","source_autotitle_hint":"Pozostaw puste, aby uzupe\u0142ni\u0107 automatycznie","source_tags":"Tagi","source_pwd_placeholder":"bez zmian","source_comma":"rozdzielone przecinkami","source_select":"prosz\u0119 wybra\u0107 typ \u017Ar\xf3d\u0142a","source_type":"Typ","source_save":"zapisz","source_cancel":"anuluj","source_saved":"zapisano","source_last_post":"Ostatni artyku\u0142 zosta\u0142 przejrzany ","source_refresh":"Od\u015Bwie\u017C to \u017Ar\xf3d\u0142o","no_entries":"brak wpis\xf3w","more":"wi\u0119cej","login":"zaloguj","login_username":"u\u017Cytkownik","login_password":"has\u0142o","login_invalid_credentials":"nieprawid\u0142owy login lub has\u0142o.","no_title":"bez tytu\u0142u","error":"wyst\u0105pi\u0142 b\u0142\u0105d","streamerror":"Nie za\u0142adowano \u017Cadnych element\xf3w, od\u015Bwie\u017Cy\u0107?","error_loading":"B\u0142\u0105d podczas \u0142adowania:","experimental":"Eksperymentalny","article_actions":"Dzia\u0142ania","share_native_label":"Udost\u0119pnij","source_browse":"Przegl\u0105daj","app_reload":"Za\u0142aduj ponownie","error_session_expired":"Sesja wygas\u0142a","close_entry":"Zamknij","sources_refreshed":"Od\u015Bwie\u017Cono \u017Ar\xf3d\u0142a","error_unknown_tag":"Nieznany tag:"}');


var $239d5b3fdb03f0e7$exports = {};
$239d5b3fdb03f0e7$exports = JSON.parse('{"share_mail_label":"Compartilhar usando correio eletr\xf4nico","error":"um erro ocorreu","no_title":"sem t\xedtulo","login_password":"palavra-passe","login_username":"utilizador","login":"entrar","more":"mais","no_entries":"nenhum registo encontrado","source_saved":"gravado","source_cancel":"cancelar","source_save":"gravar","source_type":"Tipo","source_select":"por favor, selecione a fonte","source_comma":"separado por v\xedrgula","source_tags":"Marcadores","source_title":"T\xedtulo","source_new":"nova fonte (n\xe3o salva)","source_warn":"realmente deletar esta fonte?","source_delete":"deletar","source_filter":"Filtro","source_edit":"editar","source_export":"exportar fontes","source_opml":"ou importar ficheiro opml ou google reader","source_add":"adicionar fonte","sources":"Fontes","loginbutton":"entrar","logoutbutton":"sair","settingsbutton":"configura\xe7\xf5es","refreshbutton":"atualizar fontes","searchbutton":"procurar","next":"pr\xf3ximo","open_window":"abrir","load_img":"carregar Imagens","unmark":"marcar como n\xe3o lido","mark":"marcar como lido","unstar":"remover estrela","star":"marcar com estrela","seconds":"{0,plural,one {1 segundo},other {# segundos}} atr\xe1s","minutes":"{0,plural,one {1 minuto},other {# minutos}} atr\xe1s","hours":"{0,plural,one {1 hora},other {# horas}} atr\xe1s","timestamp":"{0,date} {0,time}","alltags":"todos os marcadores","tags":"Marcadores","starred":"com estrela","unread":"n\xe3o lidos","newest":"novos","markread":"marcar como lido","source_last_post":"\xdaltima postagem vista","source_menu":"Mais a\xe7\xf5es","offline_navigation_unavailable":"A troca de etiquetas e fontes n\xe3o est\xe1 atualmente dispon\xedvel em modo offline.","offline_count":"Artigos dispon\xedveis localmente","searchremove":"Ocultar busca","share_diaspora_label":"Compartilhar na Di\xe1spora","share_facebook_label":"Compartilhar no Facebook","share_pocket_label":"Salvar no Pocket","share_wallabag_label":"Salvar no Wallabag","share_copy_label":"Copiar link para a \xe1rea de transfer\xeancia","source_refresh":"Atualizar esta fonte","share_native_label":"Compartilhar","search_label":"Termo de pesquisa","sources_leaving_unsaved_prompt":"Deixar configura\xe7\xf5es com altera\xe7\xf5es de fonte n\xe3o salvas?","online_count":"Itens dispon\xedveis no servidor","share_wordpress_label":"Compartilhar no WordPress","source_autotitle_hint":"Deixe vazio para buscar t\xedtulo","source_browse":"Navegar","source_warn_cancel_dirty":"Descartar altera\xe7\xf5es n\xe3o salvas?","filter":"Filtro","share_twitter_label":"Compartilhe no Twitter","tag_change_color_button_title":"Alterar a cor","sources_loading":"Carregando fontes\u2026","no_sources":"Nenhuma fonte configurada.","source_deleting":"Excluindo fonte\u2026","source_pwd_placeholder":"N\xe3o alterado","source_params_loading":"Carregando par\xe2metros\u2026","source_saving":"Salvar mudan\xe7as de fonte\u2026","source_go_to_settings":"Abrir nas configura\xe7\xf5es","entries_loading":"Carregando entradas\u2026","login_in_progress":"Tentando fazer login\u2026"}');


var $0b5a97e9c325f976$exports = {};
$0b5a97e9c325f976$exports = JSON.parse('{"markread":"marcar como lido","newest":"novos","unread":"n\xe3o lidos","starred":"com estrela","tags":"Marcadores","alltags":"todos os marcadores","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 hora},other {# horas}} atr\xe1s","minutes":"{0,plural,one {1 minuto},other {# minutos}} atr\xe1s","seconds":"{0,plural,one {1 segundo},other {# segundos}} atr\xe1s","star":"marcar com estrela","unstar":"remover estrela","mark":"marcar como lido","unmark":"marcar como n\xe3o lido","load_img":"carregar Imagens","open_window":"abrir","next":"pr\xf3ximo","searchbutton":"procurar","refreshbutton":"atualizar fontes","settingsbutton":"configura\xe7\xf5es","logoutbutton":"sair","loginbutton":"entrar","sources":"Fontes","source_add":"adicionar fonte","source_opml":"ou importar arquivo opml ou google reader","source_export":"exportar fontes","source_edit":"editar","source_filter":"Filtro","source_delete":"deletar","source_warn":"realmente deletar esta fonte?","source_new":"nova fonte (n\xe3o salva)","source_title":"T\xedtulo","source_tags":"Marcadores","source_comma":"separado por v\xedrgula","source_select":"por favor, selecione a fonte","source_type":"Tipo","source_save":"salvar","source_cancel":"cancelar","source_saved":"salvo","no_entries":"nenhum registro encontrado","more":"mais","login":"entrar","login_username":"usu\xe1rio","login_password":"senha","no_title":"sem t\xedtulo","error":"um erro ocorreu","share_mail_label":"Compartilhar usando correio eletr\xf4nico"}');


var $655a661d0a47f25d$exports = {};
$655a661d0a47f25d$exports = JSON.parse('{"markread":"marcar sco leg\xec","newest":"pli novas","unread":"nunleg\xec","starred":"cun staila","tags":"Etichettas","alltags":"tut las etichettas","timestamp":"{0,date} {0,time}","hours":"Avant {0,plural,one {1 ura},other {# uras}}","minutes":"Avant {0,plural,one {1 minuta},other {# minutas}}","seconds":"Avant {0,plural,one {1 secunda},other {# secundas}}","star":"agiuntar staila","unstar":"allontanar staila","mark":"marcar sco leg\xec","unmark":"marcar sco nunleg\xec","load_img":"chargiar maletgs","open_window":"avrir","searchbutton":"tschertgar","sources":"Funtaunas","source_add":"agiuntar funtauna","source_opml":"u importar ina datoteca opml u da google reader","source_export":"exportar las funtaunas","source_edit":"modifitgar","source_delete":"stizzar","source_warn":"propi stizzar questa funtauna?","source_new":"nova funtauna betg memorisada","source_title":"Titel","source_tags":"Etichettas","source_comma":"seper\xe0 entras commas","source_select":"tscherna p.pl. la funtauna","source_type":"Tip","source_save":"memorisar","source_cancel":"interrumper","source_saved":"memoris\xe0","no_entries":"chatt\xe0 naginas endataziuns","more":"dapli","login":"s\'annunziar","login_username":"num d\'utilisader","login_password":"pled-clav","no_title":"nagin titel"}');


var $436a71a33b0f932a$exports = {};
$436a71a33b0f932a$exports = JSON.parse('{"markread":"\u043F\u043E\u043C\u0435\u0442\u0438\u0442\u044C \u043A\u0430\u043A \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0435","newest":"\u0441\u0432\u0435\u0436\u0438\u0435","unread":"\u043D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0435","starred":"\u043E\u0442\u043C\u0435\u0447\u0435\u043D\u043D\u044B\u0435","tags":"\u041C\u0435\u0442\u043A\u0438","alltags":"\u0432\u0441\u0435 \u043C\u0435\u0442\u043A\u0438","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 \u0447\u0430\u0441},other {# \u0447\u0430\u0441\u043E\u0432}} \u043D\u0430\u0437\u0430\u0434","minutes":"{0,plural,one {1 \u043C\u0438\u043D\u0443\u0442\u0443},other {# \u043C\u0438\u043D\u0443\u0442}} \u043D\u0430\u0437\u0430\u0434","seconds":"{0,plural,one {1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443},other {# \u0441\u0435\u043A\u0443\u043D\u0434}} \u043D\u0430\u0437\u0430\u0434","star":"\u043E\u0442\u043C\u0435\u0442\u0438\u0442\u044C","unstar":"\u0441\u043D\u044F\u0442\u044C \u043E\u0442\u043C\u0435\u0442\u043A\u0443","mark":"\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E","unmark":"\u043D\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E","load_img":"\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F","open_window":"\u043E\u0442\u043A\u0440\u044B\u0442\u044C","searchbutton":"\u041F\u043E\u0438\u0441\u043A","sources":"\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438","source_add":"\u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A","source_opml":"\u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0444\u0430\u0439\u043B OPML, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u0438\u0437 Google Reader","source_export":"\u044D\u043A\u0441\u043F\u043E\u0440\u0442 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u0432","source_edit":"\u043F\u0440\u0430\u0432\u0438\u0442\u044C","source_delete":"\u0443\u0434\u0430\u043B\u0438\u0442\u044C","source_warn":"\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A?","source_new":"\u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0439 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A","source_title":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435","source_tags":"\u041C\u0435\u0442\u043A\u0438","source_comma":"\u0440\u0430\u0434\u0435\u043B\u044F\u0439\u0442\u0435 \u0437\u0430\u043F\u044F\u0442\u043E\u0439","source_select":"\u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430","source_type":"\u0422\u0438\u043F","source_save":"\u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C","source_cancel":"\u043E\u0442\u043C\u0435\u043D\u0430","source_saved":"\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E","no_entries":"\u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E","more":"\u0435\u0449\u0435","login":"\u0432\u0445\u043E\u0434","login_username":"\u0438\u043C\u044F","login_password":"\u043F\u0430\u0440\u043E\u043B\u044C","no_title":"\u0431\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F","searchremove":"\u0421\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0438\u0441\u043A"}');


var $f5ba6c0d14de49b4$exports = {};
$f5ba6c0d14de49b4$exports = JSON.parse('{"markread":"ozna\u010Di\u0165 ako pre\u010D\xedtan\xe9","filter":"Zobrazova\u0165","newest":"najnov\u0161ie","unread":"nepre\u010D\xedtan\xe9","starred":"ozna\u010Den\xe9","tags":"Tagy","alltags":"v\u0161etky tagy","timestamp":"{0,date} {0,time}","hours":"pred {0,plural,one {1 hodinou},other {# hodinami}}","minutes":"pred {0,plural,one {1 min\xfatou},other {# min\xfatami}}","seconds":"pred {0,plural,one {chv\xed\u013Eou},other {# sekundami}}","star":"ozna\u010Di\u0165","unstar":"odzna\u010Di\u0165","mark":"ozna\u010Di\u0165 ako pre\u010D\xedtan\xe9","unmark":"ozna\u010Di\u0165 ako nepr\u010D\xedtan\xe9","load_img":"nahra\u0165 obr\xe1zky","open_window":"otvori\u0165","next":"\u010Fal\u0161ie","searchbutton":"vyh\u013Eada\u0165","searchremove":"skry\u0165 vyh\u013Ead\xe1vanie","refreshbutton":"obnovi\u0165 zdroje","settingsbutton":"nastavenia","logoutbutton":"odhl\xe1si\u0165 sa","loginbutton":"prihl\xe1si\u0165 sa","sources":"Zdroje","source_add":"prida\u0165 zdroj","source_opml":"alebo nahra\u0165 opml s\xfabor","source_export":"export zdrojov","source_edit":"upravi\u0165","source_filter":"Filter","source_delete":"zmaza\u0165","source_warn":"Naozaj chcete tento zdroj zmaza\u0165?","source_new":"nov\xfd neulo\u017Een\xfd zdroj","source_title":"N\xe1zov","source_tags":"Tagy","source_comma":"oddelen\xe9 \u010Diarkou","source_select":"vyberte pros\xedm zdroj","source_type":"Typ","source_save":"ulo\u017Ei\u0165","source_cancel":"zru\u0161i\u0165","source_saved":"ulo\u017Een\xe9","no_entries":"\u017Eiadny z\xe1znam","more":"v\xedac","login":"prihl\xe1si\u0165","login_username":"meno","login_password":"heslo","no_title":"Bez titulku","error":"nastala chyba"}');


var $075ee780f7474188$exports = {};
$075ee780f7474188$exports = JSON.parse('{"markread":"Markera som l\xe4st","newest":"Nyast","unread":"Ol\xe4st","starred":"Stj\xe4rnm\xe4rkta","tags":"Taggar","alltags":"Alla taggar","timestamp":"{0,date} {0,time}","hours":"f\xf6r {0,plural,one {1 timme},other {# timmar}} sedan","minutes":"f\xf6r {0,plural,one {1 minut},other {# minuter}} sedan","seconds":"f\xf6r {0,plural,one {1 sekund},other {# sekunder}} sedan","days":"{0,plural,zero {idag},one {ig\xe5r},other {f\xf6r # dagar sedan}}","star":"Stj\xe4rnm\xe4rk","unstar":"Ta bort stj\xe4rnm\xe4rkning","mark":"Markera som l\xe4st","unmark":"Markera som ol\xe4st","load_img":"L\xe4s in bilder","open_window":"\xd6ppna i nytt f\xf6nster","searchbutton":"S\xf6k","sources":"K\xe4llor","source_add":"L\xe4gg till k\xe4lla","source_opml":"eller importera fr\xe5n en OPML-fil eller Google Reader","source_edit":"Redigera","source_delete":"Ta bort","source_warn":"Vill du verkligen ta bort k\xe4llan?","source_new":"Ny k\xe4lla","source_title":"Titel","source_tags":"Taggar","source_comma":"Kommaseparerade","source_select":"V\xe4lj k\xe4lla","source_type":"Typ","source_save":"Spara","source_cancel":"Avbryt","source_saved":"K\xe4llan har sparats","no_entries":"Inga inl\xe4gg hittades","more":"Fler","login":"Logga in","login_username":"Anv\xe4ndarnamn","login_password":"L\xf6senord","source_last_post":"Senaste inl\xe4gg","filter":"Filter","online_count":"Inl\xe4gg tillg\xe4ngliga p\xe5 servern","offline_count":"Inl\xe4gg tillg\xe4ngliga lokalt","next":"N\xe4sta","searchremove":"D\xf6lj s\xf6kningen","refreshbutton":"Uppdatera k\xe4llorna","settingsbutton":"Inst\xe4llningar","logoutbutton":"Logga ut","loginbutton":"Logga in","source_export":"Exportera k\xe4llor","source_filter":"Filter","source_autotitle_hint":"L\xe4mna tomt f\xf6r att h\xe4mta titeln","source_pwd_placeholder":"Of\xf6r\xe4ndrat","source_refresh":"Uppdatera k\xe4llan","login_invalid_credentials":"Felaktigt anv\xe4ndarnamn eller l\xf6senord","login_offline":"Offlinelagring","no_title":"Ingen titel","error":"Ett fel uppstod","streamerror":"Inga inl\xe4gg l\xe4stes in. L\xe4sa in igen?","reload_list":"Ladda om listan","sources_refreshed":"K\xe4llorna har uppdaterats","app_update":"selfoss har uppdaterats. L\xe4s in sidan igen.","app_reload":"Ladda om","error_session_expired":"Sessionen har g\xe5tt ut","error_add_source":"Det gick inte att l\xe4gga till k\xe4llan:","error_delete_source":"Det gick inte att ta bort k\xe4llan:","error_load_tags":"Det gick inte att l\xe4sa in taggarna:","error_unknown_tag":"Ok\xe4nd tagg:","error_unknown_source":"Ok\xe4nt k\xe4ll-ID:","error_mark_items":"Det gick inte att markera alla synliga inl\xe4gg:","error_mark_item":"Det gick inte att markera eller avmarkera inl\xe4gget:","error_star_item":"Det gick inte att stj\xe4rnm\xe4rka inl\xe4gget eller ta bort dess stj\xe4rnm\xe4rkning:","error_logout":"Det gick inte att logga ut:","error_loading":"Fel vid inl\xe4sning:","error_loading_stats":"Det gick inte att l\xe4sa in navigeringsstatistiken:","error_saving_color":"Det gick inte att spara den nya f\xe4rgen:","error_refreshing_source":"Det gick inte att uppdatera k\xe4llan:","error_sync":"Det gick inte att synkronisera de senaste \xe4ndringarna fr\xe5n servern:","error_offline_storage":"Fel i offlinelagringen: {0}. Det kan hj\xe4lpa att l\xe4sa in sidan igen. Offlinel\xe4get inaktiveras tillf\xe4lligt.","error_invalid_subsection":"Ogiltigt underavsnitt:","search_label":"S\xf6kterm","article_actions":"\xc5tg\xe4rder","error_configuration":"Det gick inte att l\xe4sa in konfigurationen.","info_url_copied":"URL:en har kopierats till urklipp.","share_native_label":"Dela","share_diaspora_label":"Dela p\xe5 diaspora*","share_twitter_label":"Dela p\xe5 Twitter","share_facebook_label":"Dela p\xe5 Facebook","share_pocket_label":"Spara i Pocket","share_wallabag_label":"Spara i wallabag","share_wordpress_label":"Dela p\xe5 WordPress","share_mail_label":"Dela via e-post","share_copy_label":"Kopiera l\xe4nk till urklipp","error_share_native_abort":"Det gick inte att dela inl\xe4gget \u2013 det finns inga delningsm\xe5l eller s\xe5 avbr\xf6ts delningen.","error_share_native":"Det gick inte att dela inl\xe4gget.","close_entry":"St\xe4ng inl\xe4gget","experimental":"Experimentellt","error_unwritable_logs":"Det gick inte att skriva till loggarna.","error_check_system_logs":"Ett fel uppstod. Kontrollera systemloggarna.","error_check_log_file":"Ett fel uppstod. Kontrollera loggfilen \u201C{0}\u201D.","source_browse":"Bl\xe4ddra","tag_change_color_button_title":"\xc4ndra f\xe4rg","source_warn_cancel_dirty":"Kasta osparade \xe4ndringar?","offline_navigation_unavailable":"Det g\xe5r f\xf6r n\xe4rvarande inte att byta tagg eller k\xe4lla i offlinel\xe4ge.","sources_leaving_unsaved_prompt":"Vill du l\xe4mna inst\xe4llningarna trots osparade \xe4ndringar i k\xe4llorna?","error_offline_storage_not_available":"Offlinelagring \xe4r inte tillg\xe4nglig. Kontrollera att webbl\xe4saren {0}st\xf6der IndexedDB-API:t{1} och, om du anv\xe4nder en Chromium-baserad webbl\xe4sare, att selfoss inte k\xf6rs i inkognitol\xe4ge.","error_edit_source":"Det gick inte att spara \xe4ndringarna i k\xe4llan:","source_menu":"Fler \xe5tg\xe4rder","no_sources":"Inga k\xe4llor har konfigurerats.","source_deleting":"Tar bort k\xe4llan\u2026","login_error_generic":"Det gick inte att logga in: {errorMessage}","sources_loading":"L\xe4ser in k\xe4llor\u2026","source_params_loading":"L\xe4ser in parametrar\u2026","source_saving":"Sparar \xe4ndringar i k\xe4llan\u2026","source_go_to_settings":"\xd6ppna i inst\xe4llningarna","entries_loading":"L\xe4ser in inl\xe4gg\u2026","login_in_progress":"Loggar in\u2026","error_unauthorized":"{link_begin}Logga in{link_end} f\xf6r att forts\xe4tta.","article_reading_time":"L\xe4stid: {0} min","share_mastodon_label":"Dela p\xe5 Mastodon"}');


var $9b311e5dd0437ccb$exports = {};
$9b311e5dd0437ccb$exports = JSON.parse('{"offline_count":"\u0B89\u0BB3\u0BCD\u0BB3\u0B95\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0B95\u0BB3\u0BCD","offline_navigation_unavailable":"\u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BCA\u0BB1\u0BCD\u0B95\u0BB3\u0BCD \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD \u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0BC1\u0BB5\u0BA4\u0BC1 \u0BA4\u0BB1\u0BCD\u0BAA\u0BCB\u0BA4\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0BAA\u0BAF\u0BA9\u0BCD\u0BAE\u0BC1\u0BB1\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","tags":"\u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB1\u0BCD\u0B95\u0BB3\u0BCD","alltags":"\u0B85\u0BA9\u0BC8\u0BA4\u0BCD\u0BA4\u0BC1 \u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BCA\u0BB1\u0BCD\u0B95\u0BB3\u0BC1\u0BAE\u0BCD","timestamp":"{0,date}-{0,time}","days":"{0,plural,zero {\u0B87\u0BA9\u0BCD\u0BB1\u0BC1},one {\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1},other {# \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1}}","star":"\u0BB5\u0BBF\u0BA3\u0BCD\u0BAE\u0BC0\u0BA9\u0BCD \u0B87\u0B9F\u0BC1","unstar":"\u0BB5\u0BBF\u0BA3\u0BCD\u0BAE\u0BC0\u0BA9\u0BCD \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BC1","mark":"\u0BAA\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BAA\u0B9F\u0BBF \u0B95\u0BC1\u0BB1\u0BBF","unmark":"\u0BAA\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BBE\u0BA4\u0BA4\u0BC1 \u0B8E\u0BA9\u0B95\u0BCD \u0B95\u0BC1\u0BB1\u0BBF","load_img":"\u0BAA\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0B95\u0BCD \u0B95\u0BBE\u0B9F\u0BCD\u0B9F\u0BC1","open_window":"\u0BA4\u0BBF\u0BB1","next":"\u0B85\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BA4\u0BC1","share_native_label":"\u0BAA\u0B99\u0BCD\u0B95\u0BC1","share_diaspora_label":"\u0BAA\u0BC1\u0BB2\u0BAE\u0BCD\u0BAA\u0BC6\u0BAF\u0BB0\u0BCD\u0BA8\u0BCD\u0BA4\u0BCB\u0BB0\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","share_twitter_label":"\u0B95\u0BC0\u0B9A\u0BCD\u0B9A\u0B95\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","share_facebook_label":"\u0BAE\u0BC1\u0B95\u0BA8\u0BC2\u0BB2\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","share_mastodon_label":"\u0B95\u0BC1\u0B9F\u0BCD\u0B9F\u0BC8\u0BAA\u0BCD \u0BAA\u0BB0\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","share_pocket_label":"\u0BAA\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF","share_wallabag_label":"\u0BB5\u0BBE\u0BB2\u0BAA\u0BBE\u0B95\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF","share_wordpress_label":"\u0B9A\u0BCA\u0BB2\u0BCD\u0B85\u0BB4\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","share_mail_label":"\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BC8\u0BAA\u0BCD \u0BAA\u0BAF\u0BA9\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","share_copy_label":"\u0B87\u0B9F\u0BC8\u0BA8\u0BBF\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BB2\u0B95\u0BC8\u0B95\u0BCD\u0B95\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC8 \u0BA8\u0B95\u0BB2\u0BC6\u0B9F\u0BC1","search_label":"\u0BA4\u0BC7\u0B9F\u0BAE\u0BCD \u0B9A\u0BCA\u0BB2\u0BCD","searchbutton":"\u0BA4\u0BC7\u0B9F\u0BC1","searchremove":"\u0BA4\u0BC7\u0B9F\u0BB2\u0BC8 \u0BAE\u0BB1\u0BC8","refreshbutton":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0BAA\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF","settingsbutton":"\u0B85\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD","logoutbutton":"\u0BB5\u0BBF\u0B9F\u0BC1\u0BAA\u0BA4\u0BBF\u0B95\u0BC8","loginbutton":"\u0BAA\u0BC1\u0B95\u0BC1\u0BAA\u0BA4\u0BBF\u0B95\u0BC8","sources":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BCD","sources_loading":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","no_sources":"\u0B8E\u0BA8\u0BCD\u0BA4 \u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0BAE\u0BCD \u0B95\u0B9F\u0BCD\u0B9F\u0BAE\u0BC8\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","source_add":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD","source_opml":"\u0B85\u0BB2\u0BCD\u0BB2\u0BA4\u0BC1 \u0B92\u0BAA\u0BBF\u0B8E\u0BAE\u0BCD\u0B8E\u0BB2\u0BCD \u0B95\u0BCB\u0BAA\u0BCD\u0BAA\u0BC8 \u0B87\u0BB1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BA4\u0BBF \u0B9A\u0BC6\u0BAF\u0BCD","source_export":"\u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BA4\u0BBF \u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BCD","source_edit":"\u0BA4\u0BC6\u0BBE\u0B95\u0BC1","source_filter":"\u0BB5\u0B9F\u0BBF\u0BAA\u0BCD\u0BAA\u0BBF","source_menu":"\u0BAE\u0BC7\u0BB2\u0BC1\u0BAE\u0BCD \u0B9A\u0BC6\u0BAF\u0BB2\u0BCD\u0B95\u0BB3\u0BCD","source_browse":"\u0B89\u0BB2\u0BBE\u0BB5\u0BC1","source_delete":"\u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BC1","source_warn":"\u0B89\u0BA3\u0BCD\u0BAE\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B87\u0BA8\u0BCD\u0BA4 \u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BB5\u0BBE?","source_deleting":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BC1\u0BA4\u0BB2\u0BCD\u2026","source_warn_cancel_dirty":"\u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BBE\u0BA4 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0BA8\u0BBF\u0BB0\u0BBE\u0B95\u0BB0\u0BBF\u0B95\u0BCD\u0B95\u0BB5\u0BBE?","source_new":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF \u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BBE\u0BA4 \u0BAE\u0BC2\u0BB2","source_title":"\u0BA4\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1","source_autotitle_hint":"\u0BA4\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BC8\u0BAA\u0BCD \u0BAA\u0BC6\u0BB1 \u0B95\u0BBE\u0BB2\u0BBF\u0BAF\u0BBE\u0B95 \u0BB5\u0BBF\u0B9F\u0BC1","source_tags":"\u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB1\u0BCD\u0B95\u0BB3\u0BCD","source_pwd_placeholder":"\u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0BAA\u0BCD\u0BAA\u0B9F\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8","source_comma":"\u0B95\u0BBE\u0BB1\u0BCD\u0BAA\u0BC1\u0BB3\u0BCD\u0BB3\u0BBF\u0BAF\u0BBE\u0BB2\u0BCD \u0BAA\u0BBF\u0BB0\u0BBF\u0BA8\u0BCD\u0BA4\u0BA4\u0BC1","source_select":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8\u0BA4\u0BCD \u0BA4\u0BC7\u0BB0\u0BCD\u0BA8\u0BCD\u0BA4\u0BC6\u0B9F\u0BC1","source_params_loading":"\u0B85\u0BB3\u0BB5\u0BC1\u0BB0\u0BC1\u0B95\u0BCD\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","source_type":"\u0BB5\u0B95\u0BC8","source_save":"\u0B9A\u0BC7\u0BAE\u0BBF","source_cancel":"\u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BB1\u0BB2\u0BCD","source_saving":"\u0BAE\u0BC2\u0BB2 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","source_saved":"\u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","source_last_post":"\u0B95\u0B9F\u0BC8\u0B9A\u0BBF \u0B87\u0B9F\u0BC1\u0B95\u0BC8 \u0BAA\u0BBE\u0BB0\u0BCD\u0BA4\u0BCD\u0BA4\u0BA4\u0BC1","source_refresh":"\u0B87\u0BA8\u0BCD\u0BA4 \u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8\u0BAA\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF","source_go_to_settings":"\u0B85\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD \u0BA4\u0BBF\u0BB1","sources_leaving_unsaved_prompt":"\u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BBE\u0BA4 \u0BAE\u0BC2\u0BB2 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B9F\u0BA9\u0BCD \u0B85\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BC8 \u0BB5\u0BBF\u0B9F\u0BB2\u0BBE\u0BAE\u0BBE?","tag_change_color_button_title":"\u0BA8\u0BBF\u0BB1\u0BA4\u0BCD\u0BA4\u0BC8 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0BC1","entries_loading":"\u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","no_entries":"\u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1\u0B95\u0BB3\u0BCD \u0B8E\u0BA4\u0BC1\u0BB5\u0BC1\u0BAE\u0BCD \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8","login_error_generic":"\u0B89\u0BB3\u0BCD\u0BA8\u0BC1\u0BB4\u0BC8\u0BAF \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8: {errorMessage}","error_check_log_file":"\u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1, \u0BA4\u0BAF\u0BB5\u0BC1\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BC1 \u201C{0}\u201D \u0BAA\u0BA4\u0BBF\u0BB5\u0BC1\u0B95\u0BCD \u0B95\u0BCB\u0BAA\u0BCD\u0BAA\u0BC8 \u0B9A\u0BB0\u0BBF\u0BAA\u0BBE\u0BB0\u0BCD.","error_check_system_logs":"\u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1, \u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0BA3\u0BBF\u0BA9\u0BBF \u0BAA\u0BA4\u0BBF\u0BB5\u0BC1\u0B95\u0BB3\u0BC8\u0B9A\u0BCD \u0B9A\u0BB0\u0BBF\u0BAA\u0BBE\u0BB0\u0BCD.","error_unwritable_logs":"\u0BAA\u0BA4\u0BBF\u0BB5\u0BC1\u0B95\u0BB3\u0BCD \u0B8E\u0BB4\u0BC1\u0BA4 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","streamerror":"\u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0B95\u0BB3\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BAA\u0BCD\u0BAA\u0B9F\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8, \u0BAE\u0BC0\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BBE?","reload_list":"\u0BAA\u0B9F\u0BCD\u0B9F\u0BBF\u0BAF\u0BB2\u0BCD \u0BAE\u0BC0\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1","sources_refreshed":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","error_session_expired":"\u0B85\u0BAE\u0BB0\u0BCD\u0BB5\u0BC1 \u0B95\u0BBE\u0BB2\u0BBE\u0BB5\u0BA4\u0BBF\u0BAF\u0BBE\u0BA9\u0BA4\u0BC1","error_add_source":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","error_edit_source":"\u0BAE\u0BC2\u0BB2 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","error_delete_source":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","error_load_tags":"\u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BCA\u0BB1\u0BCD\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","error_unknown_tag":"\u0BA4\u0BC6\u0BB0\u0BBF\u0BAF\u0BBE\u0BA4 \u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD:","error_sync":"\u0B9A\u0BC7\u0BB5\u0BC8\u0BAF\u0B95\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BBF\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0B95\u0B9F\u0BC8\u0B9A\u0BBF \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0B92\u0BA4\u0BCD\u0BA4\u0BBF\u0B9A\u0BC8\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","error_offline_storage":"\u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0B9A\u0BC7\u0BAE\u0BBF\u0BAA\u0BCD\u0BAA\u0B95 \u0BAA\u0BBF\u0BB4\u0BC8: {0}. \u0BAE\u0BC0\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0BB5\u0BA4\u0BC1 \u0B89\u0BA4\u0BB5\u0B95\u0BCD\u0B95\u0BC2\u0B9F\u0BC1\u0BAE\u0BCD. \u0B87\u0BAA\u0BCD\u0BAA\u0BCB\u0BA4\u0BC8\u0B95\u0BCD\u0B95\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4\u0BA4\u0BC8 \u0BAE\u0BC1\u0B9F\u0B95\u0BCD\u0B95\u0BC1\u0B95\u0BBF\u0BB1\u0BA4\u0BC1.","markread":"\u0BAA\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BAA\u0B9F\u0BBF \u0B95\u0BC1\u0BB1\u0BBF","filter":"\u0BB5\u0B9F\u0BBF\u0BAA\u0BCD\u0BAA\u0BBF","newest":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF\u0BA4\u0BC1","unread":"\u0BAA\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BBE\u0BA4\u0BA4\u0BC1","starred":"\u0BB5\u0BBF\u0BA3\u0BCD\u0BAE\u0BC0\u0BA9\u0BCD \u0B87\u0B9F\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","online_count":"\u0B9A\u0BC7\u0BB5\u0BC8\u0BAF\u0B95\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0B95\u0BB3\u0BCD","hours":"{0,plural,one {1 \u0BAE\u0BA3\u0BBF\u0BA8\u0BC7\u0BB0\u0BAE\u0BCD},other {# \u0BAE\u0BA3\u0BBF\u0BA8\u0BC7\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD}} \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1","minutes":"{0,plural,one {1 \u0BA8\u0BBF\u0BAE\u0BC8\u0BAF\u0BAE\u0BCD},other {# \u0BA8\u0BBF\u0BAE\u0BC8\u0BAF\u0B99\u0BCD\u0B95\u0BB3\u0BCD}} \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1","seconds":"{0,plural,one {1 \u0BA8\u0BCA\u0B9F\u0BBF},other {# \u0BA8\u0BCA\u0B9F\u0BBF\u0B95\u0BB3\u0BCD}} \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1","more":"\u0BAE\u0BC7\u0BB2\u0BC1\u0BAE\u0BCD","login":"\u0BAA\u0BC1\u0B95\u0BC1\u0BAA\u0BA4\u0BBF\u0B95\u0BC8","login_in_progress":"\u0B89\u0BB3\u0BCD\u0BA8\u0BC1\u0BB4\u0BC8\u0BAF \u0BAE\u0BC1\u0BAF\u0BB1\u0BCD\u0B9A\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","login_username":"\u0BAA\u0BAF\u0BA9\u0BB0\u0BCD\u0BAA\u0BC6\u0BAF\u0BB0\u0BCD","login_password":"\u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD","login_invalid_credentials":"\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0BAA\u0BAF\u0BA9\u0BB0\u0BCD\u0BAA\u0BC6\u0BAF\u0BB0\u0BCD/\u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD","login_offline":"\u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0B9A\u0BC7\u0BAE\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1","no_title":"\u0BA4\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1 \u0B87\u0BB2\u0BCD\u0BB2\u0BC8","experimental":"\u0B9A\u0BCB\u0BA4\u0BA9\u0BC8","error":"\u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","error_unauthorized":"\u0BA4\u0BCA\u0B9F\u0BB0 {link_begin}\u0B89\u0BB3\u0BCD\u0BA8\u0BC1\u0BB4\u0BC8\u0B95{link_end}.","app_update":"\u0B9A\u0BC6\u0BB2\u0BCD\u0BAA\u0BCB\u0B9A\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BC1\u0BB3\u0BCD\u0BB3\u0BA4\u0BC1, \u0BA4\u0BAF\u0BB5\u0BC1\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BC1 \u0BAE\u0BC0\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1","app_reload":"\u0BAE\u0BB1\u0BC1\u0B8F\u0BB1\u0BCD\u0BB1\u0BC1","error_unknown_source":"\u0BA4\u0BC6\u0BB0\u0BBF\u0BAF\u0BBE\u0BA4 \u0BAE\u0BC2\u0BB2 \u0B85\u0B9F\u0BC8\u0BAF\u0BBE\u0BB3\u0BAE\u0BCD:","error_mark_items":"\u0BAA\u0BC1\u0BB2\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BAE\u0BCD \u0B85\u0BA9\u0BC8\u0BA4\u0BCD\u0BA4\u0BC1 \u0BAA\u0BCA\u0BB0\u0BC1\u0B9F\u0BCD\u0B95\u0BB3\u0BC8\u0BAF\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BBF\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","error_mark_item":"\u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0BAF\u0BC8\u0B95\u0BCD \u0B95\u0BC1\u0BB1\u0BBF\u0B95\u0BCD\u0B95/\u0B95\u0BC1\u0BB1\u0BBF\u0BA8\u0BC0\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","error_star_item":"\u0BB5\u0BBF\u0BA3\u0BCD\u0BAE\u0BC0\u0BA9\u0BCD \u0B87\u0B9F/\u0BA8\u0BC0\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4 \u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF:","error_logout":"\u0BB5\u0BC6\u0BB3\u0BBF\u0BAF\u0BC7\u0BB1 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","error_loading":"\u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0BA4\u0BB2\u0BCD \u0BAA\u0BBF\u0BB4\u0BC8:","error_loading_stats":"\u0BB5\u0BB4\u0BBF\u0B9A\u0BC6\u0BB2\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF\u0BAF \u0BAA\u0BC1\u0BB3\u0BCD\u0BB3\u0BBF\u0BB5\u0BBF\u0BB5\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","error_saving_color":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF \u0BB5\u0BA3\u0BCD\u0BA3\u0BA4\u0BCD\u0BA4\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","error_refreshing_source":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0BAA\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","error_invalid_subsection":"\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0BA4\u0BC1\u0BA3\u0BC8\u0BAA\u0B95\u0BC1\u0BA4\u0BBF:","error_configuration":"\u0B89\u0BB3\u0BCD\u0BB3\u0BAE\u0BC8\u0BB5\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","error_share_native_abort":"\u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0BAF\u0BC8\u0BAA\u0BCD \u0BAA\u0B95\u0BBF\u0BB0 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8 -\u0BAA\u0B99\u0BCD\u0B95\u0BC1 \u0B87\u0BB2\u0B95\u0BCD\u0B95\u0BC1\u0B95\u0BB3\u0BCD \u0B87\u0BB2\u0BCD\u0BB2\u0BC8, \u0B85\u0BB2\u0BCD\u0BB2\u0BA4\u0BC1 \u0BA8\u0BC0\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B85\u0BA4\u0BC8\u0BA4\u0BCD \u0BA4\u0BB3\u0BCD\u0BB3\u0BC1\u0BAA\u0B9F\u0BBF \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BCD.","close_entry":"\u0BAE\u0BC2\u0B9F\u0BC1","error_offline_storage_not_available":"\u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0B9A\u0BC7\u0BAE\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1 \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8. \u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BB5\u0BB2\u0BC8 \u0B89\u0BB2\u0BBE\u0BB5\u0BBF {0} \u0B85\u0B9F\u0BCD\u0B9F\u0BB5\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F \u0BA4\u0BB0\u0BB5\u0BC1\u0BA4\u0BCD\u0BA4\u0BB3\u0BAE\u0BCD \u0BAA\u0BA8\u0BBF\u0B87 {1} \u0B90 \u0B86\u0BA4\u0BB0\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB1\u0BA4\u0BC1 \u0B8E\u0BA9\u0BCD\u0BAA\u0BA4\u0BC8 \u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF\u0B95\u0BCD \u0B95\u0BCA\u0BB3\u0BCD\u0BB3\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD, \u0BAE\u0BC7\u0BB2\u0BC1\u0BAE\u0BCD \u0BA8\u0BC0\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0BC2\u0B95\u0BBF\u0BB3\u0BCD \u0BA8\u0BBF\u0BB1\u0BAE\u0BBF \u0B85\u0B9F\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC8\u0BAF\u0BBF\u0BB2\u0BBE\u0BA9 \u0B89\u0BB2\u0BBE\u0BB5\u0BBF\u0BAF\u0BC8\u0BAA\u0BCD \u0BAA\u0BAF\u0BA9\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BBF\u0BB1\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BCD \u0B8E\u0BA9\u0BCD\u0BB1\u0BBE\u0BB2\u0BCD, \u0BA8\u0BC0\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BAE\u0BB1\u0BC8\u0BA8\u0BBF\u0BB2\u0BC8 \u0BAA\u0BAF\u0BA9\u0BCD\u0BAE\u0BC1\u0BB1\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B9A\u0BC6\u0BB2\u0BCD\u0BAA\u0BCB\u0B9A\u0BC8 \u0B87\u0BAF\u0B95\u0BCD\u0B95\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8 \u0B8E\u0BA9\u0BCD\u0BAA\u0BA4\u0BC8 \u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BB5\u0BC1\u0BAE\u0BCD.","error_share_native":"\u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0BAF\u0BC8\u0BAA\u0BCD \u0BAA\u0B95\u0BBF\u0BB0 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","info_url_copied":"\u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF \u0B87\u0B9F\u0BC8\u0BA8\u0BBF\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BB2\u0B95\u0BC8\u0B95\u0BCD\u0B95\u0BC1 \u0BA8\u0B95\u0BB2\u0BC6\u0B9F\u0BC1\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1.","article_actions":"\u0B9A\u0BC6\u0BAF\u0BB2\u0BCD\u0B95\u0BB3\u0BCD","article_reading_time":"{0} \u0BA8\u0BBF\u0BAE\u0BC8\u0BAF\u0BAE\u0BCD \u0BAA\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BA4\u0BC1"}');


var $2fdd723177d78183$exports = {};
$2fdd723177d78183$exports = JSON.parse('{"markread":"Okundu olarak i\u015Faretle","newest":"En yeni","unread":"Okunmayan","starred":"Y\u0131ld\u0131zlanan","tags":"Etiketler","alltags":"T\xfcm etiketler","timestamp":"{0,date} {0,time}","hours":"{0, plural,other {#}} saat \xf6nce","minutes":"{0, plural,other {#}} dakika \xf6nce","seconds":"{0, plural,other {#}} saniye \xf6nce","star":"Y\u0131ld\u0131z ekle","unstar":"Y\u0131ld\u0131z kald\u0131r","mark":"Okundu olarak i\u015Faretle","unmark":"Okunmad\u0131 olarak i\u015Faretle","load_img":"Resimleri g\xf6ster","open_window":"A\xe7","searchbutton":"Ara","sources":"Kaynaklar","source_add":"Kaynak ekle","source_opml":"veya bir OPML dosyas\u0131n\u0131 i\xe7e aktar","source_export":"Kaynaklar\u0131 d\u0131\u015Fa aktar","source_edit":"D\xfczenle","source_delete":"Sil","source_warn":"Bu kaynak ger\xe7ekten silinsin mi?","source_new":"Yeni kaydedilmemi\u015F kaynak","source_title":"Ba\u015Fl\u0131k","source_tags":"Etiketler","source_comma":"Virg\xfclle ayr\u0131lm\u0131\u015F","source_select":"L\xfctfen kaynak se\xe7in","source_type":"T\xfcr","source_save":"Kaydet","source_cancel":"\u0130ptal","source_saved":"Kaydedildi","no_entries":"Yay\u0131n bulunmad\u0131","more":"Daha fazla","login":"Oturum a\xe7","login_username":"Kullan\u0131c\u0131 ad\u0131","login_password":"Parola","no_title":"Ba\u015Fl\u0131k yok","article_actions":"Eylemler","close_entry":"Kapat","info_url_copied":"URL panoya kopyaland\u0131.","error_share_native":"\xd6ge payla\u015F\u0131lam\u0131yor.","error_share_native_abort":"\xd6ge payla\u015F\u0131lam\u0131yor \u2014 ya hi\xe7 payla\u015F\u0131m hedefi yok ya da siz iptal ettiniz.","error_configuration":"Yap\u0131land\u0131rma y\xfcklenemiyor.","error_invalid_subsection":"Ge\xe7ersiz alt b\xf6l\xfcm:","error_offline_storage_not_available":"\xc7evrim d\u0131\u015F\u0131 depolama kullan\u0131lam\u0131yor. Web taray\u0131c\u0131n\u0131z\u0131n {0}IndexedDB API\'sini{1} destekledi\u011Finden ve Google Chrome tabanl\u0131 bir taray\u0131c\u0131 kullan\u0131yorsan\u0131z selfoss\'u gizli modda \xe7al\u0131\u015Ft\u0131rmad\u0131\u011F\u0131n\u0131zdan emin olun.","error_offline_storage":"\xc7evrim d\u0131\u015F\u0131 depolama hatas\u0131: {0}. Yeniden y\xfcklemek yard\u0131mc\u0131 olabilir. \xc7evrim d\u0131\u015F\u0131 \u015Fimdilik devre d\u0131\u015F\u0131 b\u0131rak\u0131l\u0131yor.","error_sync":"Sunucudan son de\u011Fi\u015Fiklikler e\u015Fzamanlanamad\u0131:","error_refreshing_source":"Kaynaklar yenilenemiyor:","error_saving_color":"Yeni renk kaydedilemiyor:","error_loading_stats":"G\xf6z atma istatistikleri y\xfcklenemiyor:","error_loading":"Y\xfckleme hatas\u0131:","error_logout":"Oturum kapat\u0131lamad\u0131:","error_star_item":"\xd6geye y\u0131ld\u0131z eklenemiyor/y\u0131ld\u0131z\u0131 kald\u0131r\u0131lam\u0131yor:","error_mark_item":"\xd6ge i\u015Faretlenemiyor/i\u015Fareti kald\u0131r\u0131lam\u0131yor:","error_mark_items":"T\xfcm g\xf6r\xfcn\xfcr \xf6geler i\u015Faretlenemiyor:","error_unknown_source":"Bilinmeyen kaynak kimli\u011Fi:","error_unknown_tag":"Bilinmeyen etiket:","error_load_tags":"Etiketler y\xfcklenemedi:","error_delete_source":"Kaynak silinemedi:","error_edit_source":"Kaynak de\u011Fi\u015Fiklikleri kaydedilemedi:","error_add_source":"Kaynak eklenemedi:","error_session_expired":"Oturumun s\xfcresi doldu","app_reload":"Yeniden y\xfckle","app_update":"selfoss g\xfcncellendi, l\xfctfen yeniden y\xfckleyin","sources_refreshed":"Kaynaklar yenilendi","reload_list":"Listeyi yeniden y\xfckle","streamerror":"Hi\xe7bir \xf6ge y\xfcklenmedi, yeniden y\xfcklensin mi?","error_unwritable_logs":"G\xfcnl\xfck yaz\u0131lam\u0131yor.","error_check_system_logs":"Bir hata olu\u015Ftu, l\xfctfen sistem g\xfcnl\xfcklerinize bak\u0131n.","error_check_log_file":"Bir hata olu\u015Ftu, l\xfctfen g\xfcnl\xfck dosyas\u0131na bak\u0131n \u201C{0}\u201D.","error":"Bir hata olu\u015Ftu","login_offline":"\xc7evrim d\u0131\u015F\u0131 depolama","login_invalid_credentials":"Yanl\u0131\u015F kullan\u0131c\u0131 ad\u0131/parola","source_refresh":"Bu kayna\u011F\u0131 yenile","source_last_post":"G\xf6r\xfclen son g\xf6nderi","source_pwd_placeholder":"De\u011Fi\u015Fmedi","source_autotitle_hint":"Ba\u015Fl\u0131\u011F\u0131 almak i\xe7in bo\u015F b\u0131rak\u0131n","source_filter":"Filtrele","loginbutton":"Oturum a\xe7","logoutbutton":"Oturumu kapat","settingsbutton":"Ayarlar","refreshbutton":"Kaynaklar\u0131 yenile","searchremove":"Aramay\u0131 gizle","search_label":"Arama terimi","share_copy_label":"Ba\u011Flant\u0131y\u0131 panoya kopyala","share_mail_label":"E-posta ile payla\u015F","share_wordpress_label":"WordPress\'te payla\u015F","share_wallabag_label":"Wallabag\'e kaydet","share_pocket_label":"Pocket\'a kaydet","share_facebook_label":"Facebook\'ta payla\u015F","share_twitter_label":"Twitter\'da payla\u015F","share_diaspora_label":"Diaspora\'da payla\u015F","share_native_label":"Payla\u015F","next":"Sonraki","days":"{0,plural,zero {bug\xfcn},one {d\xfcn},other {# g\xfcn \xf6nce}}","offline_navigation_unavailable":"Etiketleri ve kaynaklar\u0131 de\u011Fi\u015Ftirmek \u015Fu anda \xe7evrim d\u0131\u015F\u0131 modda kullan\u0131lam\u0131yor.","offline_count":"Yerel olarak kullan\u0131labilen \xf6geler","online_count":"Sunucuda bulunan \xf6geler","filter":"Filtrele","article_reading_time":"{0} dakika okuma","experimental":"Deneysel","source_warn_cancel_dirty":"Kaydedilmemi\u015F de\u011Fi\u015Fiklikler at\u0131ls\u0131n m\u0131?","sources_leaving_unsaved_prompt":"Kaydedilmemi\u015F kaynak de\u011Fi\u015Fiklikleri olmas\u0131na ra\u011Fmen ayarlardan \xe7\u0131k\u0131ls\u0131n m\u0131?","source_browse":"G\xf6z at","source_menu":"Daha fazla eylem","tag_change_color_button_title":"Rengi de\u011Fi\u015Ftir","source_go_to_settings":"Ayarlarda a\xe7","sources_loading":"Kaynaklar y\xfckleniyor\u2026","no_sources":"Yap\u0131land\u0131r\u0131lan kaynak yok.","entries_loading":"Yay\u0131nlar y\xfckleniyor\u2026","source_deleting":"Kaynak siliniyor\u2026","login_in_progress":"Oturum a\xe7maya \xe7al\u0131\u015F\u0131l\u0131yor\u2026","source_params_loading":"Parametreler y\xfckleniyor\u2026","source_saving":"Kaynak de\u011Fi\u015Fiklikleri kaydediliyor\u2026","error_unauthorized":"Devam etmek i\xe7in l\xfctfen {link_begin}oturum a\xe7\u0131n{link_end}.","login_error_generic":"Oturum a\xe7\u0131lamad\u0131: {errorMessage}","share_mastodon_label":"Mastodon\'da payla\u015F"}');


var $d1a3f8492d1a8641$exports = {};
$d1a3f8492d1a8641$exports = JSON.parse('{"markread":"\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0438\u043C","newest":"\u041D\u0430\u0439\u043D\u043E\u0432\u0456\u0448\u0456","unread":"\u041D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0456","starred":"\u041F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0456","tags":"\u041C\u0456\u0442\u043A\u0438","alltags":"\u0423\u0441\u0456 \u043C\u0456\u0442\u043A\u0438","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 \u0433\u043E\u0434\u0438\u043D\u0443},other {# \u0433\u043E\u0434\u0438\u043D\u0438}} \u0442\u043E\u043C\u0443","minutes":"{0,plural,one {1 \u0445\u0432\u0438\u043B\u0438\u043D\u0443},other {# \u0445\u0432\u0438\u043B\u0438\u043D\u0438}} \u0442\u043E\u043C\u0443","seconds":"{0,plural,one {1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443},other {# \u0441\u0435\u043A\u0443\u043D\u0434\u0438}} \u0442\u043E\u043C\u0443","star":"\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438","unstar":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F","mark":"\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0438\u043C","unmark":"\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u043D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0438\u043C","load_img":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F","open_window":"\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438","searchbutton":"\u041F\u043E\u0448\u0443\u043A","sources":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430","source_add":"\u0414\u043E\u0434\u0430\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","source_opml":"\u0430\u0431\u043E \u0456\u043C\u043F\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437 OPML-\u0444\u0430\u0439\u043B\u0443","source_export":"\u0435\u043A\u0441\u043F\u043E\u0440\u0442 \u0434\u0436\u0435\u0440\u0435\u043B","source_edit":"\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438","source_delete":"\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438","source_warn":"\u0414\u0456\u0439\u0441\u043D\u043E \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E?","source_new":"\u041D\u043E\u0432\u0435 \u043D\u0435 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","source_title":"\u041D\u0430\u0437\u0432\u0430","source_tags":"\u041C\u0456\u0442\u043A\u0438","source_comma":"\u0420\u043E\u0437\u0434\u0456\u043B\u0435\u043D\u0456 \u043A\u043E\u043C\u043E\u044E","source_select":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F \u0434\u0436\u0435\u0440\u0435\u043B\u0430","source_type":"\u0422\u0438\u043F","source_save":"\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438","source_cancel":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438","source_saved":"\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E","no_entries":"\u0417\u0430\u043F\u0438\u0441\u0456\u0432 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E","more":"\u0429\u0435","login":"\u0412\u0445\u0456\u0434","login_username":"\u0406\u043C\'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430","login_password":"\u041F\u0430\u0440\u043E\u043B\u044C","no_title":"\u0411\u0435\u0437 \u043D\u0430\u0437\u0432\u0438","filter":"\u0424\u0456\u043B\u044C\u0442\u0440","online_count":"\u0415\u043B\u0435\u043C\u0435\u043D\u0442\u0438, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0456","offline_count":"\u0415\u043B\u0435\u043C\u0435\u043D\u0442\u0438, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E","source_browse":"\u041E\u0433\u043B\u044F\u0434","share_facebook_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Facebook","error_check_log_file":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430, \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0444\u0430\u0439\u043B \u0436\u0443\u0440\u043D\u0430\u043B\u0443 \\"{0}\\".","error_check_system_logs":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430, \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0456 \u0436\u0443\u0440\u043D\u0430\u043B\u0438.","error_unwritable_logs":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u0436\u0443\u0440\u043D\u0430\u043B\u0438.","streamerror":"\u0415\u043B\u0435\u043C\u0435\u043D\u0442\u0438 \u043D\u0435 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0456, \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438?","error_edit_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","error_mark_items":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0432\u0441\u0456 \u0432\u0438\u0434\u0438\u043C\u0456 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438:","error_star_item":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0430\u0431\u043E \u0437\u043D\u044F\u0442\u0438 \u0437\u0456\u0440\u043E\u0447\u043A\u0443:","error_logout":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0439\u0442\u0438:","error_saving_color":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043A\u043E\u043B\u0456\u0440:","error_sync":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0443\u0432\u0430\u0442\u0438 \u043E\u0441\u0442\u0430\u043D\u043D\u0456 \u0437\u043C\u0456\u043D\u0438 \u0437 \u0441\u0435\u0440\u0432\u0435\u0440\u0430:","error_unknown_source":"\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0438\u0439 ID \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","error_load_tags":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043C\u0456\u0442\u043A\u0438:","error_unknown_tag":"\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043C\u0456\u0442\u043A\u0430:","error_refreshing_source":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","error_mark_item":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438/\u0437\u043D\u044F\u0442\u0438 \u043F\u043E\u0437\u043D\u0430\u0447\u043A\u0443 \u0437 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430:","error_offline_storage":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432 \u043E\u0444\u043B\u0430\u0439\u043D-\u0441\u0445\u043E\u0432\u0438\u0449\u0456: {0}. \u041F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043C\u043E\u0436\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438. \u041D\u0430\u0440\u0430\u0437\u0456 \u0432\u0438\u043C\u0438\u043A\u0430\u0454\u0442\u044C\u0441\u044F \u043E\u0444\u043B\u0430\u0439\u043D.","days":"{0,plural,zero {\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456},one {\u0432\u0447\u043E\u0440\u0430},other {# \u0434\u043D\u0456\u0432 \u0442\u043E\u043C\u0443}}","error_unauthorized":"\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, {link_begin}\u0443\u0432\u0456\u0439\u0434\u0456\u0442\u044C{link_end}, \u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438.","share_native_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F","share_twitter_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0432 Twitter","share_mastodon_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Mastodon","source_deleting":"\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0434\u0436\u0435\u0440\u0435\u043B\u0430\u2026","share_wordpress_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 WordPress","share_copy_label":"\u0421\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0456\u043D\u0443","search_label":"\u041F\u043E\u0448\u0443\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0442","share_mail_label":"\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0435-\u043F\u043E\u0448\u0442\u043E\u044E","searchremove":"\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u043F\u043E\u0448\u0443\u043A","logoutbutton":"\u0412\u0438\u0439\u0442\u0438","settingsbutton":"\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F","loginbutton":"\u0423\u0432\u0456\u0439\u0442\u0438","no_sources":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430 \u043D\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u0456.","source_filter":"\u0424\u0456\u043B\u044C\u0442\u0440","error_loading_stats":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u0439\u043D\u0443 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443:","source_menu":"\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0434\u0456\u0457","sources_leaving_unsaved_prompt":"\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u0438 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0437 \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0438\u043C\u0438 \u0437\u043C\u0456\u043D\u0430\u043C\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430?","login_error_generic":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0443\u0432\u0456\u0439\u0442\u0438: {errorMessage}","experimental":"\u0415\u043A\u0441\u043F\u0435\u0440\u0438\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u0456","tag_change_color_button_title":"\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043A\u043E\u043B\u0456\u0440","login_in_progress":"\u0421\u043F\u0440\u043E\u0431\u0430 \u0443\u0432\u0456\u0439\u0442\u0438\u2026","sources_refreshed":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u0456","error":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430","sources_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0436\u0435\u0440\u0435\u043B\u2026","login_invalid_credentials":"\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0435 \u0456\u043C\'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430/\u043F\u0430\u0440\u043E\u043B\u044C","error_loading":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u0456:","source_last_post":"\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 \u043F\u043E\u0431\u0430\u0447\u0435\u043D\u0438\u0439 \u0434\u043E\u043F\u0438\u0441","refreshbutton":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430","share_diaspora_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Diaspora","share_wallabag_label":"\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0443 Wallabag","next":"\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439","source_saving":"\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F \u0437\u043C\u0456\u043D \u0434\u0436\u0435\u0440\u0435\u043B\u0430\u2026","entries_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u0430\u043F\u0438\u0441\u0456\u0432\u2026","reload_list":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u043F\u0438\u0441\u043E\u043A","share_pocket_label":"\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0432 Pocket","info_url_copied":"URL \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0456\u043D\u0443.","offline_navigation_unavailable":"\u041F\u0435\u0440\u0435\u043C\u0438\u043A\u0430\u043D\u043D\u044F \u043C\u0456\u0442\u043E\u043A \u0456 \u0434\u0436\u0435\u0440\u0435\u043B \u043D\u0430\u0440\u0430\u0437\u0456 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435 \u0432 \u0440\u0435\u0436\u0438\u043C\u0456 \u043E\u0444\u043B\u0430\u0439\u043D.","source_warn_cancel_dirty":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456 \u0437\u043C\u0456\u043D\u0438?","error_offline_storage_not_available":"\u041E\u0444\u043B\u0430\u0439\u043D-\u0441\u0445\u043E\u0432\u0438\u0449\u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435. \u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0432\u0430\u0448 \u0432\u0435\u0431\u0431\u0440\u0430\u0443\u0437\u0435\u0440 {0} \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454 API IndexedDB{1} \u0456, \u044F\u043A\u0449\u043E \u0432\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0454\u0442\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0430 \u0431\u0430\u0437\u0456 Google Chrome, \u0442\u043E \u0432\u0438 \u043D\u0435 \u0437\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0443\u0454\u0442\u0435 selfoss \u0432 \u0440\u0435\u0436\u0438\u043C\u0456 \u0456\u043D\u043A\u043E\u0433\u043D\u0456\u0442\u043E.","error_invalid_subsection":"\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u043F\u0456\u0434\u0440\u043E\u0437\u0434\u0456\u043B:","error_configuration":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u044E.","error_share_native_abort":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F - \u0430\u0431\u043E \u043D\u0435\u043C\u0430\u0454 \u0446\u0456\u043B\u0435\u0439, \u0430\u0431\u043E \u0432\u0438 \u0457\u0445 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u043B\u0438.","error_share_native":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F.","close_entry":"\u0417\u0430\u043A\u0440\u0438\u0442\u0438","article_actions":"\u0414\u0456\u0457","article_reading_time":"{0} \u0445\u0432 \u0447\u0438\u0442\u0430\u043D\u043D\u044F","source_autotitle_hint":"\u0417\u0430\u043B\u0438\u0448\u0442\u0435 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C, \u0449\u043E\u0431 \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u043D\u0430\u0437\u0432\u0443","source_pwd_placeholder":"\u0411\u0435\u0437 \u0437\u043C\u0456\u043D","source_params_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454\u043C\u043E \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438\u2026","source_refresh":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0446\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","source_go_to_settings":"\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F\u0445","login_offline":"\u041E\u0444\u043B\u0430\u0439\u043D-\u0441\u0445\u043E\u0432\u0438\u0449\u0435","app_update":"selfoss \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E, \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435","app_reload":"\u041F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438","error_session_expired":"\u0421\u0435\u0430\u043D\u0441 \u0443\u0436\u0435 \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u0432\u0441\u044F","error_add_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E:","error_delete_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E:"}');


var $e7426becb1609a72$exports = {};
$e7426becb1609a72$exports = JSON.parse('{"markread":"\u5168\u90E8\u6807\u8BB0\u4E3A\u5DF2\u8BFB","newest":"\u6700\u65B0\u6761\u76EE","unread":"\u672A\u8BFB\u6761\u76EE","starred":"\u52A0\u661F\u6807\u7684\u6761\u76EE","tags":"\u6807\u7B7E","alltags":"\u6240\u6709\u6807\u7B7E","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 \u5C0F\u65F6},other {# \u5C0F\u65F6}}\u524D","minutes":"{0,plural,one {1 \u5206\u949F},other {# \u5206\u949F}}\u524D","seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","days":"{0,plural,zero {\u4ECA\u5929},one {\u6628\u5929},other {# \u5929\u524D}}","star":"\u52A0\u661F\u6807","unstar":"\u53D6\u6D88\u661F\u6807","mark":"\u6807\u8BB0\u4E3A\u5DF2\u8BFB","unmark":"\u6807\u8BB0\u4E3A\u672A\u8BFB","load_img":"\u52A0\u8F7D\u56FE\u7247","open_window":"\u6253\u5F00","searchbutton":"\u641C\u7D22","sources":"\u6E90","source_add":"\u6DFB\u52A0\u6E90","source_opml":"\u6216\u5BFC\u5165 OPML \u6587\u4EF6/Google \u9605\u8BFB\u5668\u8BA2\u9605","source_export":"\u5BFC\u51FA\u6E90","source_edit":"\u7F16\u8F91","source_delete":"\u5220\u9664","source_warn":"\u786E\u8BA4\u8981\u5220\u9664\u8BE5\u6E90?","source_new":"\u65B0\u7684\u6E90","source_title":"\u6807\u9898","source_tags":"\u6807\u7B7E","source_comma":"\u4EE5\u9017\u53F7\u5206\u9694","source_select":"\u8BF7\u9009\u62E9\u6E90","source_type":"\u7C7B\u578B","source_save":"\u4FDD\u5B58","source_cancel":"\u53D6\u6D88","source_saved":"\u5DF2\u4FDD\u5B58","source_last_post":"\u66F4\u65B0\u4E8E","no_entries":"\u6CA1\u6709\u6761\u76EE","more":"\u66F4\u591A","login":"\u767B\u5F55","login_username":"\u7528\u6237\u540D","login_password":"\u5BC6\u7801","no_title":"\u65E0\u6807\u9898","logoutbutton":"\u767B\u51FA","loginbutton":"\u767B\u5F55","error_logout":"\u4E0D\u80FD\u767B\u51FA\uFF1A","settingsbutton":"\u8BBE\u7F6E","app_reload":"\u518D\u542F\u52A8","error_session_expired":"\u4F1A\u8BDD\u5DF2\u8FC7\u671F","close_entry":"\u5173\u95ED","error_sync":"\u65E0\u6CD5\u4ECE\u670D\u52A1\u5668\u540C\u6B65\u65B0\u7684\u66F4\u6539\uFF1A","share_pocket_label":"\u4FDD\u5B58\u5230 Pocket","searchremove":"\u9690\u85CF\u641C\u7D22","error_share_native_abort":"\u65E0\u6CD5\u5206\u4EAB\u6761\u76EE - \u53EF\u80FD\u662F\u7F3A\u5C11\u5206\u4EAB\u5BF9\u8C61\u6216\u60A8\u5DF2\u53D6\u6D88\u5206\u4EAB\u3002","error_mark_items":"\u65E0\u6CD5\u6807\u8BB0\u6240\u6709\u53EF\u89C1\u9879\u76EE\uFF1A","share_twitter_label":"\u5206\u4EAB\u5230 Twitter","share_wallabag_label":"\u4FDD\u5B58\u5230 Wallabag","filter":"\u7B5B\u9009","online_count":"\u670D\u52A1\u5668\u53EF\u7528\u7684\u6761\u76EE","offline_navigation_unavailable":"\u79BB\u7EBF\u6A21\u5F0F\u4E0B\u6682\u65F6\u4E0D\u80FD\u5207\u6362\u6807\u7B7E\u548C\u6765\u6E90\u3002","source_menu":"\u66F4\u591A\u64CD\u4F5C","source_browse":"\u6D4F\u89C8","offline_count":"\u672C\u5730\u53EF\u7528\u7684\u6761\u76EE","next":"\u4E0B\u4E00\u4E2A","share_native_label":"\u5206\u4EAB","refreshbutton":"\u66F4\u65B0\u6570\u636E\u6E90","share_diaspora_label":"\u5206\u4EAB\u5230 Diaspora","share_wordpress_label":"\u5206\u4EAB\u5230 WordPress","search_label":"\u641C\u7D22\u8BCD","share_mail_label":"\u901A\u8FC7\u90AE\u4EF6\u5206\u4EAB","source_warn_cancel_dirty":"\u4E22\u5F03\u672A\u4FDD\u5B58\u7684\u66F4\u6539\uFF1F","share_copy_label":"\u590D\u5236\u94FE\u63A5\u5230\u526A\u5207\u677F","source_filter":"\u7B5B\u9009","share_facebook_label":"\u5206\u4EAB\u5230 Facebook","tag_change_color_button_title":"\u66F4\u6539\u989C\u8272","experimental":"\u8BD5\u9A8C\u6027\u7684","login_invalid_credentials":"\u9519\u8BEF\u7684\u7528\u6237\u540D\u6216\u5BC6\u7801","error_check_log_file":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u65E5\u5FD7\u6587\u4EF6 \u201C{0}\u201D\u3002","login_offline":"\u79BB\u7EBF\u5B58\u50A8","error_unknown_source":"\u672A\u77E5\u6765\u6E90 ID\uFF1A","error_mark_item":"\u65E0\u6CD5\u6807\u8BB0\u6216\u53D6\u6D88\u6807\u8BB0\uFF1A","error_star_item":"\u65E0\u6CD5\u661F\u6807\u6216\u53D6\u6D88\u661F\u6807\uFF1A","error_loading":"\u52A0\u8F7D\u9519\u8BEF\uFF1A","article_reading_time":"{0} \u5206\u949F\u9605\u8BFB\u65F6\u957F","sources_loading":"\u6570\u636E\u6E90\u52A0\u8F7D\u4E2D\u2026","no_sources":"\u6570\u636E\u6E90\u672A\u914D\u7F6E\u3002","source_deleting":"\u6B63\u5728\u5220\u9664\u6570\u636E\u6E90\u2026","source_autotitle_hint":"\u7559\u7A7A\u4EE5\u81EA\u52A8\u586B\u5145\u6807\u9898","source_pwd_placeholder":"\u6CA1\u6709\u6539\u53D8","source_params_loading":"\u6B63\u5728\u52A0\u8F7D\u53C2\u6570\u2026","source_saving":"\u6B63\u5728\u4FDD\u5B58\u6570\u636E\u6E90\u66F4\u6539\u2026","source_refresh":"\u5237\u65B0\u6B64\u6570\u636E\u6E90","source_go_to_settings":"\u5728\u8BBE\u7F6E\u4E2D\u6253\u5F00","sources_leaving_unsaved_prompt":"\u4FDD\u7559\u672A\u4FDD\u5B58\u7684\u6570\u636E\u6E90\u66F4\u6539\uFF1F","entries_loading":"\u52A0\u8F7D\u6761\u76EE\u4E2D\u2026","login_in_progress":"\u5C1D\u8BD5\u767B\u5F55\u4E2D\u2026","error":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF","error_check_system_logs":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u4F60\u7684\u7CFB\u7EDF\u65E5\u5FD7\u3002","error_unwritable_logs":"\u65E0\u6CD5\u5199\u5165\u65E5\u5FD7\u3002","streamerror":"\u6CA1\u6709\u52A0\u8F7D\u5230\u6761\u76EE\uFF0C\u91CD\u65B0\u52A0\u8F7D\uFF1F","sources_refreshed":"\u6570\u636E\u6E90\u5DF2\u5237\u65B0","app_update":"selfoss \u5DF2\u88AB\u66F4\u65B0\uFF0C\u8BF7\u91CD\u65B0\u52A0\u8F7D","error_add_source":"\u65E0\u6CD5\u6DFB\u52A0\u6E90\uFF1A","error_edit_source":"\u65E0\u6CD5\u4FDD\u5B58\u6E90\u66F4\u6539\uFF1A","error_delete_source":"\u65E0\u6CD5\u5220\u9664\u6E90\uFF1A","error_load_tags":"\u65E0\u6CD5\u52A0\u8F7D\u6807\u7B7E\uFF1A","error_unknown_tag":"\u672A\u77E5\u7684\u6807\u7B7E\uFF1A","error_loading_stats":"\u65E0\u6CD5\u52A0\u8F7D\u7EDF\u8BA1\u4FE1\u606F\uFF1A","error_saving_color":"\u65E0\u6CD5\u4FDD\u5B58\u65B0\u989C\u8272\uFF1A","error_refreshing_source":"\u65E0\u6CD5\u5237\u65B0\u6570\u636E\u6E90\uFF1A","error_offline_storage":"\u79BB\u7EBF\u5B58\u50A8\u51FA\u9519\uFF1A{0} \uFF0C\u8BF7\u5C1D\u8BD5\u91CD\u65B0\u52A0\u8F7D\u3002\u79BB\u7EBF\u6A21\u5F0F\u5DF2\u88AB\u4E34\u65F6\u7981\u7528\u3002","error_offline_storage_not_available":"\u79BB\u7EBF\u5B58\u50A8\u4E0D\u53EF\u7528\u3002\u786E\u4FDD\u60A8\u7684\u7F51\u7EDC\u6D4F\u89C8\u5668 {0} \u652F\u6301 IndexedDB API{1}\uFF0C\u5982\u679C\u60A8\u4F7F\u7528\u7684\u662F\u57FA\u4E8E Google Chrome \u7684\u6D4F\u89C8\u5668\uFF0C\u8BF7\u786E\u4FDD\u60A8\u6CA1\u6709\u5728\u9690\u8EAB\u6A21\u5F0F\u4E0B\u8FD0\u884C selfoss\u3002","error_invalid_subsection":"\u65E0\u6548\u7684\u5C0F\u8282\uFF1A","error_configuration":"\u65E0\u6CD5\u52A0\u8F7D\u914D\u7F6E\u3002","info_url_copied":"URL \u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F\u3002","error_share_native":"\u65E0\u6CD5\u5206\u4EAB\u6761\u76EE\u3002","article_actions":"\u52A8\u4F5C","reload_list":"\u91CD\u65B0\u52A0\u8F7D\u5217\u8868","login_error_generic":"\u65E0\u6CD5\u767B\u5F55: {errorMessage}","error_unauthorized":"\u8BF7 {link_begin}\u767B\u5F55{link_end} \u4EE5\u7EE7\u7EED\u3002","share_mastodon_label":"\u5728 Mastodon \u4E0A\u5206\u4EAB"}');


var $71137174854b0ca9$exports = {};
$71137174854b0ca9$exports = JSON.parse('{"markread":"\u6A19\u8A18\u70BA\u5DF2\u8B80","newest":"\u6700\u65B0","unread":"\u672A\u8B80","starred":"\u5DF2\u52A0\u661F\u6A19","tags":"\u6A19\u7C64","alltags":"\u6240\u6709\u6A19\u7C64","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 \u5C0F\u6642},other {# \u5C0F\u6642}}\u524D","minutes":"{0,plural,one {1 \u5206\u9418},other {# \u5206\u9418}}\u524D","seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","days":"{0,plural,zero {\u4ECA\u5929},one {\u6628\u5929},other {# \u5929\u524D}}","star":"\u52A0\u661F\u6A19","unstar":"\u53D6\u6D88\u661F\u6A19","mark":"\u6A19\u8A18\u70BA\u5DF2\u8B80","unmark":"\u6A19\u8A18\u70BA\u672A\u8B80","load_img":"\u986F\u793A\u5716\u7247","open_window":"\u958B\u555F","searchbutton":"\u641C\u5C0B","sources":"\u4F86\u6E90","source_add":"\u65B0\u589E\u4F86\u6E90","source_opml":"\u6216\u532F\u5165\u4E00\u500B OPML \u6A94\u6848","source_export":"\u532F\u51FA\u4F86\u6E90","source_edit":"\u7DE8\u8F2F","source_delete":"\u522A\u9664","source_warn":"\u771F\u7684\u522A\u9664\u9019\u500B\u4F86\u6E90\u55CE\uFF1F","source_new":"\u65B0\u7684\u672A\u5132\u5B58\u4F86\u6E90","source_title":"\u6A19\u984C","source_tags":"\u6A19\u7C64","source_comma":"\u4EE5\u9017\u865F\u5206\u9694","source_select":"\u8ACB\u9078\u64C7\u4F86\u6E90","source_type":"\u985E\u578B","source_save":"\u5132\u5B58","source_cancel":"\u53D6\u6D88","source_saved":"\u5DF2\u5132\u5B58","source_last_post":"\u66F4\u65B0\u65BC","no_entries":"\u627E\u4E0D\u5230\u689D\u76EE","more":"\u66F4\u591A","login":"\u767B\u5165","login_username":"\u4F7F\u7528\u8005\u540D\u7A31","login_password":"\u5BC6\u78BC","no_title":"\u7121\u6A19\u984C","error_saving_color":"\u7121\u6CD5\u5132\u5B58\u65B0\u984F\u8272\uFF1A","error_share_native_abort":"\u7121\u6CD5\u5206\u4EAB\u9805\u76EE\u2014\u6C92\u6709\u5206\u4EAB\u76EE\u6A19\uFF0C\u6216\u8005\u4F60\u5DF2\u53D6\u6D88\u5B83\u3002","article_actions":"\u52D5\u4F5C","error_check_log_file":"\u767C\u751F\u932F\u8AA4\uFF0C\u8ACB\u6AA2\u67E5\u65E5\u8A8C\u6A94\u6848\u300C{0}\u300D\u3002","filter":"\u904E\u6FFE\u5668","share_diaspora_label":"\u5728 Diaspora \u4E0A\u5206\u4EAB","error_add_source":"\u7121\u6CD5\u65B0\u589E\u4F86\u6E90\uFF1A","share_copy_label":"\u8907\u88FD\u9023\u7D50\u81F3\u526A\u8CBC\u7C3F","sources_refreshed":"\u4F86\u6E90\u5DF2\u91CD\u65B0\u6574\u7406","app_reload":"\u91CD\u65B0\u8F09\u5165","error_unknown_source":"\u672A\u77E5\u7684\u4F86\u6E90 ID\uFF1A","error_mark_item":"\u7121\u6CD5\u6A19\u8A18\uFF0F\u53D6\u6D88\u6A19\u8A18\u9805\u76EE\uFF1A","error_refreshing_source":"\u7121\u6CD5\u91CD\u65B0\u6574\u7406\u4F86\u6E90\uFF1A","error_sync":"\u7121\u6CD5\u5F9E\u4F3A\u670D\u5668\u540C\u6B65\u6700\u5F8C\u7684\u8B8A\u66F4\uFF1A","error_offline_storage_not_available":"\u96E2\u7DDA\u5132\u5B58\u4E0D\u53EF\u7528\u3002\u78BA\u4FDD\u4F60\u7684\u7DB2\u9801\u700F\u89BD\u5668{0}\u652F\u63F4 IndexedDB API{1}\uFF0C\u4E26\u4E14\u5982\u679C\u4F60\u6B63\u5728\u4F7F\u7528\u7684\u662F\u57FA\u65BC Google Chrome \u7684\u700F\u89BD\u5668\uFF0C\u8ACB\u78BA\u4FDD\u4F60\u6C92\u6709\u5728\u7121\u75D5\u6A21\u5F0F\u4E0B\u57F7\u884C selfoss\u3002","error_invalid_subsection":"\u7121\u6548\u7684\u5C0F\u7BC0\uFF1A","error_configuration":"\u7121\u6CD5\u8F09\u5165\u914D\u7F6E\u3002","error_share_native":"\u7121\u6CD5\u5206\u4EAB\u9805\u76EE\u3002","info_url_copied":"\u7DB2\u5740\u5DF2\u8907\u88FD\u81F3\u526A\u8CBC\u7C3F\u3002","close_entry":"\u95DC\u9589","online_count":"\u4F3A\u670D\u5668\u4E0A\u53EF\u7528\u7684\u9805\u76EE","searchremove":"\u96B1\u85CF\u641C\u5C0B","offline_count":"\u672C\u5730\u53EF\u7528\u7684\u9805\u76EE","offline_navigation_unavailable":"\u76EE\u524D\u5728\u96E2\u7DDA\u6A21\u5F0F\u4E0B\u7121\u6CD5\u5207\u63DB\u6A19\u7C64\u548C\u4F86\u6E90\u3002","settingsbutton":"\u8A2D\u5B9A","logoutbutton":"\u767B\u51FA","source_filter":"\u904E\u6FFE\u5668","share_twitter_label":"\u5728 Twitter \u4E0A\u5206\u4EAB","share_facebook_label":"\u5728 Facebook \u4E0A\u5206\u4EAB","next":"\u4E0B\u4E00\u500B","share_mastodon_label":"\u5728 Mastodon \u4E0A\u5206\u4EAB","share_pocket_label":"\u5132\u5B58\u81F3 Pocket","refreshbutton":"\u91CD\u65B0\u6574\u7406\u4F86\u6E90","share_wallabag_label":"\u5132\u5B58\u81F3 Wallabag","share_wordpress_label":"\u5728 WordPress \u4E0A\u5206\u4EAB","share_mail_label":"\u4F7F\u7528\u96FB\u5B50\u90F5\u4EF6\u5206\u4EAB","loginbutton":"\u767B\u5165","source_autotitle_hint":"\u7559\u7A7A\u4EE5\u81EA\u52D5\u7372\u53D6\u6A19\u984C","source_saving":"\u6B63\u5728\u5132\u5B58\u4F86\u6E90\u8B8A\u66F4\u2026","source_pwd_placeholder":"\u6C92\u6709\u8B8A\u66F4","source_go_to_settings":"\u5728\u8A2D\u5B9A\u4E2D\u958B\u555F","source_refresh":"\u91CD\u65B0\u6574\u7406\u9019\u500B\u4F86\u6E90","error_edit_source":"\u7121\u6CD5\u5132\u5B58\u4F86\u6E90\u8B8A\u66F4\uFF1A","search_label":"\u641C\u5C0B\u8A5E\u8A9E","login_invalid_credentials":"\u932F\u8AA4\u7684\u4F7F\u7528\u8005\u540D\u7A31\uFF0F\u5BC6\u78BC","login_offline":"\u96E2\u7DDA\u5132\u5B58","error":"\u767C\u751F\u932F\u8AA4","streamerror":"\u6C92\u6709\u8F09\u5165\u4EFB\u4F55\u9805\u76EE\uFF0C\u91CD\u65B0\u8F09\u5165\u55CE\uFF1F","reload_list":"\u91CD\u65B0\u8F09\u5165\u5217\u8868","app_update":"selfoss \u5DF2\u66F4\u65B0\uFF0C\u8ACB\u91CD\u65B0\u8F09\u5165","error_session_expired":"\u5DE5\u4F5C\u968E\u6BB5\u5DF2\u904E\u671F","error_delete_source":"\u7121\u6CD5\u522A\u9664\u4F86\u6E90\uFF1A","error_load_tags":"\u7121\u6CD5\u8F09\u5165\u6A19\u7C64\uFF1A","error_unknown_tag":"\u672A\u77E5\u7684\u6A19\u7C64\uFF1A","error_mark_items":"\u7121\u6CD5\u6A19\u8A18\u6240\u6709\u53EF\u898B\u9805\u76EE\uFF1A","error_star_item":"\u7121\u6CD5\u52A0\u661F\u6A19\uFF0F\u53D6\u6D88\u661F\u6A19\u9805\u76EE\uFF1A","error_logout":"\u7121\u6CD5\u767B\u51FA\uFF1A","error_loading":"\u8F09\u5165\u932F\u8AA4\uFF1A","error_loading_stats":"\u7121\u6CD5\u8F09\u5165\u5C0E\u822A\u7D71\u8A08\u8CC7\u6599\uFF1A","error_offline_storage":"\u96E2\u7DDA\u5132\u5B58\u932F\u8AA4\uFF1A{0}\u3002\u91CD\u65B0\u8F09\u5165\u53EF\u80FD\u6703\u6709\u6240\u5E6B\u52A9\u3002\u66AB\u6642\u505C\u7528\u96E2\u7DDA\u529F\u80FD\u3002","share_native_label":"\u5206\u4EAB","sources_loading":"\u6B63\u5728\u8F09\u5165\u4F86\u6E90\u2026","no_sources":"\u6C92\u6709\u5DF2\u914D\u7F6E\u7684\u4F86\u6E90\u3002","source_menu":"\u66F4\u591A\u52D5\u4F5C","source_browse":"\u700F\u89BD","source_deleting":"\u6B63\u5728\u522A\u9664\u4F86\u6E90\u2026","source_warn_cancel_dirty":"\u653E\u68C4\u672A\u5132\u5B58\u7684\u8B8A\u66F4\uFF1F","source_params_loading":"\u6B63\u5728\u8F09\u5165\u53C3\u6578\u2026","tag_change_color_button_title":"\u8B8A\u66F4\u984F\u8272","entries_loading":"\u6B63\u5728\u8F09\u5165\u689D\u76EE\u2026","login_in_progress":"\u6B63\u5728\u5617\u8A66\u767B\u5165\u2026","login_error_generic":"\u7121\u6CD5\u767B\u5165\uFF1A{errorMessage}","experimental":"\u5BE6\u9A57\u6027","error_unauthorized":"\u8ACB{link_begin}\u767B\u5165{link_end}\u4EE5\u7E7C\u7E8C\u3002","error_check_system_logs":"\u767C\u751F\u932F\u8AA4\uFF0C\u8ACB\u6AA2\u67E5\u4F60\u7684\u7CFB\u7D71\u65E5\u8A8C\u3002","error_unwritable_logs":"\u7121\u6CD5\u5BEB\u5165\u65E5\u8A8C\u3002","article_reading_time":"{0} \u5206\u9418\u95B1\u8B80","sources_leaving_unsaved_prompt":"\u672A\u5132\u5B58\u4F86\u6E90\u8B8A\u66F4\uFF0C\u96E2\u958B\u8A2D\u5B9A\uFF1F"}');


const $b074686b7cd1e86c$var$locales_ = {
    ca: (0, (/*@__PURE__*/$parcel$interopDefault($647f766074d64773$exports))),
    cs: (0, (/*@__PURE__*/$parcel$interopDefault($18e6d39c6df6a504$exports))),
    de: (0, (/*@__PURE__*/$parcel$interopDefault($0f57265ba749b28b$exports))),
    en: (0, (/*@__PURE__*/$parcel$interopDefault($38fe93b221363e36$exports))),
    'en-GB': (0, (/*@__PURE__*/$parcel$interopDefault($75c67d0db824a550$exports))),
    es: (0, (/*@__PURE__*/$parcel$interopDefault($e09fd591c81d8c00$exports))),
    et: (0, (/*@__PURE__*/$parcel$interopDefault($09197c62e8f40c51$exports))),
    fi: (0, (/*@__PURE__*/$parcel$interopDefault($7bfc007d210a165f$exports))),
    fr: (0, (/*@__PURE__*/$parcel$interopDefault($5d661914acf6fff5$exports))),
    'fr-CA': (0, (/*@__PURE__*/$parcel$interopDefault($17710b319b719f9f$exports))),
    gl: (0, (/*@__PURE__*/$parcel$interopDefault($5842b3cf59e511d5$exports))),
    he: (0, (/*@__PURE__*/$parcel$interopDefault($785c4eb045100ebe$exports))),
    hu: (0, (/*@__PURE__*/$parcel$interopDefault($2e8fa1e1c4881081$exports))),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($21a979911d58571c$exports))),
    it: (0, (/*@__PURE__*/$parcel$interopDefault($bcc60c6870c45310$exports))),
    ja: (0, (/*@__PURE__*/$parcel$interopDefault($176dd0c127d964ee$exports))),
    lv: (0, (/*@__PURE__*/$parcel$interopDefault($96d4cdcff3e97d75$exports))),
    nb: (0, (/*@__PURE__*/$parcel$interopDefault($662f6aa9e169a442$exports))),
    nl: (0, (/*@__PURE__*/$parcel$interopDefault($ce919b35c66c9734$exports))),
    pl: (0, (/*@__PURE__*/$parcel$interopDefault($33fd991f65022a1d$exports))),
    pt: (0, (/*@__PURE__*/$parcel$interopDefault($239d5b3fdb03f0e7$exports))),
    'pt-BR': (0, (/*@__PURE__*/$parcel$interopDefault($0b5a97e9c325f976$exports))),
    rm: (0, (/*@__PURE__*/$parcel$interopDefault($655a661d0a47f25d$exports))),
    ru: (0, (/*@__PURE__*/$parcel$interopDefault($436a71a33b0f932a$exports))),
    sk: (0, (/*@__PURE__*/$parcel$interopDefault($f5ba6c0d14de49b4$exports))),
    sv: (0, (/*@__PURE__*/$parcel$interopDefault($075ee780f7474188$exports))),
    ta: (0, (/*@__PURE__*/$parcel$interopDefault($9b311e5dd0437ccb$exports))),
    tr: (0, (/*@__PURE__*/$parcel$interopDefault($2fdd723177d78183$exports))),
    uk: (0, (/*@__PURE__*/$parcel$interopDefault($d1a3f8492d1a8641$exports))),
    'zh-CN': (0, (/*@__PURE__*/$parcel$interopDefault($e7426becb1609a72$exports))),
    'zh-TW': (0, (/*@__PURE__*/$parcel$interopDefault($71137174854b0ca9$exports)))
};
const $b074686b7cd1e86c$var$localeKeys = new Set(Object.keys($b074686b7cd1e86c$var$locales_));
const $b074686b7cd1e86c$var$locales = $b074686b7cd1e86c$var$locales_;
var $b074686b7cd1e86c$export$2e2bcd8739ae039 = $b074686b7cd1e86c$var$locales;
function $b074686b7cd1e86c$export$b7c662043e31af59(lang) {
    return $b074686b7cd1e86c$var$localeKeys.has(lang);
}





var $5NSbj = parcelRequire("5NSbj");



function $f1a03c79a94f2ac1$export$2e2bcd8739ae039(props) {
    const { ref: ref, children: children } = props;
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("dialog", {
        ref: ref,
        onClick: ({ target: target, currentTarget: currentTarget })=>{
            if (target === currentTarget) ref.current.close();
        },
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                "aria-label": _('close_dialog'),
                className: "close",
                onClick: ()=>{
                    ref.current.close();
                },
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                    icon: $72abcd8059f7a937$exports.faTimesCircle
                })
            }),
            children
        ]
    });
}



parcelRequire("5NSbj");

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var $be27cef8e331a9de$export$2e2bcd8739ae039 = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};


function $aa30b60383c14be2$export$2e2bcd8739ae039(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, $be27cef8e331a9de$export$2e2bcd8739ae039)(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}


function $edab4d39fc8cf8cc$export$2e2bcd8739ae039(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}


function $554acfa1837f38de$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $edab4d39fc8cf8cc$export$2e2bcd8739ae039)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}



function $92157285ad14a9dc$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $edab4d39fc8cf8cc$export$2e2bcd8739ae039)(a) ? f2 : (0, $554acfa1837f38de$export$2e2bcd8739ae039)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $edab4d39fc8cf8cc$export$2e2bcd8739ae039)(a) && (0, $edab4d39fc8cf8cc$export$2e2bcd8739ae039)(b) ? f2 : (0, $edab4d39fc8cf8cc$export$2e2bcd8739ae039)(a) ? (0, $554acfa1837f38de$export$2e2bcd8739ae039)(function(_a) {
                    return fn(_a, b);
                }) : (0, $edab4d39fc8cf8cc$export$2e2bcd8739ae039)(b) ? (0, $554acfa1837f38de$export$2e2bcd8739ae039)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}


/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('a', ['b', 'n', 'n', 's']); //=> ['b', 'a', 'n', 'a', 'n', 'a', 's']
 */ var $aafaede6d98b3dee$var$intersperse = /*#__PURE__*/ (0, $92157285ad14a9dc$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $aa30b60383c14be2$export$2e2bcd8739ae039)('intersperse', function _intersperse(separator, list) {
    var length = list.length;
    if (length === 0) return [];
    var out = Array(length * 2 - 1);
    var idx = 0;
    while(idx < length){
        var i = idx * 2;
        if (idx === length - 1) out[i] = list[idx];
        else {
            out[i] = list[idx];
            out[i + 1] = separator;
        }
        idx += 1;
    }
    return out;
}));
var $aafaede6d98b3dee$export$2e2bcd8739ae039 = $aafaede6d98b3dee$var$intersperse;


function $921bc8caa0025bcf$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("section", {
        className: "shortcuts",
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("h2", {
                children: "Keybindings"
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("dl", {
                children: Object.entries((0, $9a99005d054db156$export$9784374fba94ce79)).map(([keycombo, keybinding])=>{
                    let readableKeycombo;
                    if (keybinding.readableName) readableKeycombo = /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("kbd", {
                        children: keybinding.readableName
                    });
                    else if (keycombo.includes('+')) {
                        const keys = keycombo.split('+') // key={key} required for TS
                        .map((key)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("kbd", {
                                children: key
                            }, key));
                        readableKeycombo = (0, $aafaede6d98b3dee$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                            children: "+"
                        }), keys);
                    } else readableKeycombo = /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("kbd", {
                        children: keycombo
                    });
                    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $fcda9d1f1901e894$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("dt", {
                                children: readableKeycombo
                            }),
                            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("dd", {
                                children: keybinding.description
                            })
                        ]
                    });
                })
            })
        ]
    });
}


function $e2370261ec80d344$var$handleNavToggle(args) {
    const { event: event, setNavExpanded: setNavExpanded } = args;
    event.preventDefault();
    // show hide navigation for mobile version
    setNavExpanded((expanded)=>!expanded);
    window.scrollTo({
        top: 0
    });
}
function $e2370261ec80d344$var$dismissMessage(event) {
    (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setGlobalMessage(null);
    event.stopPropagation();
}
/**
 * Global message bar for showing errors/information at the top of the page.
 * It watches globalMessage and updates/shows/hides itself as necessary
 * when the value changes.
 */ function $e2370261ec80d344$var$Message(props) {
    const { message: message } = props;
    // Whenever message changes, dismiss it after 15 seconds.
    (0, $5NSbj.useEffect)(()=>{
        if (message !== null) {
            const dismissTimeout = window.setTimeout(()=>{
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setGlobalMessage(null);
            }, 15000);
            return ()=>{
                // Destory previous timeout.
                window.clearTimeout(dismissTimeout);
            };
        }
    }, [
        message
    ]);
    return message !== null ? /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
        id: "message",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
            error: message.isError
        }),
        onClick: $e2370261ec80d344$var$dismissMessage,
        children: [
            message.message,
            message.actions.map(({ label: label, callback: callback }, index)=>/*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                    type: "button",
                    onClick: callback,
                    children: label
                }, index))
        ]
    }) : null;
}
function $e2370261ec80d344$var$NotFound() {
    const location = (0, $dcbcccfe7d0a797a$export$45d76561a5302f2b)();
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("p", {
        children: _('error_invalid_subsection') + location.pathname
    });
}
function $e2370261ec80d344$var$CheckAuthorization(props) {
    const { isAllowed: isAllowed, returnLocation: returnLocation, _: _, children: children } = props;
    const navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    const redirect = (0, $5NSbj.useEffectEvent)(()=>{
        navigate('/sign/in', {
            state: {
                returnLocation: returnLocation
            }
        });
    });
    (0, $5NSbj.useEffect)(()=>{
        if (!isAllowed) redirect();
    }, [
        isAllowed
    ]);
    if (!isAllowed) {
        const [preLink, inLink, postLink] = _('error_unauthorized').split(/\{(?:link_begin|link_end)\}/);
        return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("p", {
            children: [
                preLink,
                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $1b28ddd4ebfaf955$export$a6c7ac8248d6e38a), {
                    to: "/sign/in",
                    children: inLink
                }),
                postLink
            ]
        });
    } else return children;
}
// Work around for regex patterns not being supported
// https://github.com/remix-run/react-router/issues/8254
function $e2370261ec80d344$var$EntriesFilter(props) {
    const { entriesRef: entriesRef, setNavExpanded: setNavExpanded, configuration: configuration, navSourcesExpanded: navSourcesExpanded, unreadItemsCount: unreadItemsCount, setGlobalUnreadCount: setGlobalUnreadCount, showError: showError } = props;
    const params = (0, $dcbcccfe7d0a797a$export$216385125ee84ae7)();
    if (params === null) return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($e2370261ec80d344$var$NotFound, {});
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $903e325e4cd4f232$export$2e2bcd8739ae039), {
        ref: entriesRef,
        setNavExpanded: setNavExpanded,
        configuration: configuration,
        navSourcesExpanded: navSourcesExpanded,
        unreadItemsCount: unreadItemsCount,
        setGlobalUnreadCount: setGlobalUnreadCount,
        showError: showError
    });
}
function $e2370261ec80d344$var$PureApp(props) {
    const { navSourcesExpanded: navSourcesExpanded, setNavSourcesExpanded: setNavSourcesExpanded, offlineState: offlineState, allItemsCount: allItemsCount, allItemsOfflineCount: allItemsOfflineCount, unreadItemsCount: unreadItemsCount, unreadItemsOfflineCount: unreadItemsOfflineCount, starredItemsCount: starredItemsCount, starredItemsOfflineCount: starredItemsOfflineCount, globalMessage: globalMessage, sourcesState: sourcesState, setSourcesState: setSourcesState, sources: sources, setSources: setSources, tags: tags, reloadAll: reloadAll, showError: showError } = props;
    const [navExpanded, setNavExpanded] = (0, $5NSbj.useState)(false);
    const shortcutsDialog = (0, $5NSbj.useRef)(null);
    const smartphone = (0, $d30756b433a819bb$export$443718c44347a6b3)();
    const offlineEnabled = (0, $d30756b433a819bb$export$96b5b894afc1d2e3)((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.enableOffline);
    const [entriesPage, setEntriesPage] = (0, $5NSbj.useState)(null);
    const configuration = (0, $5NSbj.use)((0, $b7416e8649ee66da$export$326f6d1b69f1c06e));
    (0, $5NSbj.useEffect)(()=>{
        // init shortcut handler
        const destroyShortcuts = (0, $9a99005d054db156$export$2e2bcd8739ae039)(shortcutsDialog);
        return ()=>{
            destroyShortcuts();
        };
    }, []);
    // TODO: move stuff that depends on this to the App.
    const navigate = (0, $4a2ef0180f3aa5fe$export$9770f232ac06a008)();
    (0, $5NSbj.useEffect)(()=>{
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).navigate = navigate;
    }, [
        navigate
    ]);
    // Prepare path of the homepage for redirecting from /
    const homePagePath = configuration.homepage.split('/');
    if (!homePagePath[1]) homePagePath.push('all');
    const menuButtonOnClick = (0, $5NSbj.useCallback)((event)=>$e2370261ec80d344$var$handleNavToggle({
            event: event,
            setNavExpanded: setNavExpanded
        }), []);
    const entriesRef = (0, $5NSbj.useCallback)((entriesPage)=>{
        setEntriesPage(entriesPage);
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage = entriesPage;
        return ()=>{
            setEntriesPage(null);
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage = null;
        };
    }, []);
    const [title, setTitle] = (0, $5NSbj.useState)(null);
    const [globalUnreadCount, setGlobalUnreadCount] = (0, $5NSbj.useState)(null);
    const titleText = (0, $5NSbj.useMemo)(()=>(title ?? configuration.htmlTitle) + ((globalUnreadCount ?? 0) > 0 ? ` (${globalUnreadCount})` : ''), [
        configuration,
        title,
        globalUnreadCount
    ]);
    const _ = (0, $5NSbj.use)((0, $433f7d372a884a6c$export$51216bcc3983e55d));
    const isAllowedToRead = (0, $fa4deecc6161d7ee$export$f5bdb3b3cec7f803)();
    const isAllowedToWrite = (0, $fa4deecc6161d7ee$export$b416b77cd328c02f)();
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).StrictMode, {
        children: [
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("title", {
                children: titleText
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($e2370261ec80d344$var$Message, {
                message: globalMessage
            }),
            /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $cc78a6e3ef89ca34$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $cc78a6e3ef89ca34$export$e7b0ac011bb776c6), {
                        path: "/sign/in",
                        element: /* menu open for smartphone */ /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                            id: "loginform",
                            role: "main",
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $2fd9af2234740b06$export$2e2bcd8739ae039), {
                                offlineEnabled: offlineEnabled
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $cc78a6e3ef89ca34$export$e7b0ac011bb776c6), {
                        path: "/password",
                        element: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($e2370261ec80d344$var$CheckAuthorization, {
                            isAllowed: isAllowedToWrite,
                            returnLocation: "/password",
                            _: _,
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                                id: "hashpasswordbody",
                                role: "main",
                                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $2118d280c9bed8e8$export$2e2bcd8739ae039), {
                                    setTitle: setTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $cc78a6e3ef89ca34$export$e7b0ac011bb776c6), {
                        path: "/opml",
                        element: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($e2370261ec80d344$var$CheckAuthorization, {
                            isAllowed: isAllowedToWrite,
                            returnLocation: "/opml",
                            _: _,
                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("main", {
                                id: "opmlbody",
                                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $75268d55fcc03c89$export$2e2bcd8739ae039), {
                                    setTitle: setTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $cc78a6e3ef89ca34$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)($e2370261ec80d344$var$CheckAuthorization, {
                            isAllowed: isAllowedToRead,
                            _: _,
                            children: [
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                                    id: "nav-mobile",
                                    role: "navigation",
                                    children: [
                                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                                            id: "nav-mobile-logo",
                                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                                                id: "nav-mobile-count",
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                                    'unread-count': true,
                                                    offline: offlineState,
                                                    online: !offlineState,
                                                    unread: unreadItemsCount > 0
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9230d46773d20d22$exports)))({
                                                            'offline-count': true,
                                                            offline: offlineState,
                                                            online: !offlineState,
                                                            diff: unreadItemsCount !== unreadItemsOfflineCount && unreadItemsOfflineCount
                                                        }),
                                                        children: unreadItemsOfflineCount > 0 ? unreadItemsOfflineCount : ''
                                                    }),
                                                    /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("span", {
                                                        className: "count",
                                                        children: unreadItemsCount
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("button", {
                                            id: "nav-mobile-settings",
                                            accessKey: "t",
                                            "aria-label": _('settingsbutton'),
                                            onClick: menuButtonOnClick,
                                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $ef2738a79ec9a22f$export$2b9260d4a45c8710), {
                                                icon: $2af23e40017b25d9$exports.faCog,
                                                size: "2x"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $5c9ab921368ace58$export$78768a9af065a7b), {
                                    isOpen: !smartphone || navExpanded,
                                    className: "collapse-css-transition",
                                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("div", {
                                        id: "nav",
                                        role: "navigation",
                                        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $c85565e69a0d22e9$export$2e2bcd8739ae039), {
                                            entriesPage: entriesPage,
                                            setNavExpanded: setNavExpanded,
                                            navSourcesExpanded: navSourcesExpanded,
                                            setNavSourcesExpanded: setNavSourcesExpanded,
                                            offlineState: offlineState,
                                            allItemsCount: allItemsCount,
                                            allItemsOfflineCount: allItemsOfflineCount,
                                            unreadItemsCount: unreadItemsCount,
                                            unreadItemsOfflineCount: unreadItemsOfflineCount,
                                            starredItemsCount: starredItemsCount,
                                            starredItemsOfflineCount: starredItemsOfflineCount,
                                            sourcesState: sourcesState,
                                            setSourcesState: setSourcesState,
                                            sources: sources,
                                            setSources: setSources,
                                            tags: tags,
                                            reloadAll: reloadAll,
                                            showError: showError
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)("ul", {
                                    id: "search-list",
                                    children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $dabab91edb61a70e$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)("div", {
                                    id: "content",
                                    role: "main",
                                    children: [
                                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsxs)((0, $cc78a6e3ef89ca34$export$3565eb3d00ca5a74), {
                                            children: [
                                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $cc78a6e3ef89ca34$export$e7b0ac011bb776c6), {
                                                    path: "/",
                                                    element: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $cc78a6e3ef89ca34$export$444b3ab0cb9aec40), {
                                                        to: `/${homePagePath.join('/')}`,
                                                        replace: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $cc78a6e3ef89ca34$export$e7b0ac011bb776c6), {
                                                    path: "/:filter/:category/:id?",
                                                    element: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($e2370261ec80d344$var$EntriesFilter, {
                                                        entriesRef: entriesRef,
                                                        setNavExpanded: setNavExpanded,
                                                        configuration: configuration,
                                                        navSourcesExpanded: navSourcesExpanded,
                                                        unreadItemsCount: unreadItemsCount,
                                                        setGlobalUnreadCount: setGlobalUnreadCount,
                                                        showError: showError
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $cc78a6e3ef89ca34$export$e7b0ac011bb776c6), {
                                                    path: "/manage/sources/add?",
                                                    element: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $9c2874d6b18f7de8$export$2e2bcd8739ae039), {
                                                        showError: showError
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $cc78a6e3ef89ca34$export$e7b0ac011bb776c6), {
                                                    path: "*",
                                                    element: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($e2370261ec80d344$var$NotFound, {})
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $f1a03c79a94f2ac1$export$2e2bcd8739ae039), {
                                            ref: shortcutsDialog,
                                            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $921bc8caa0025bcf$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
class $e2370261ec80d344$export$86fbec116b87613f extends (0, (/*@__PURE__*/$parcel$interopDefault($5NSbj))).Component {
    constructor(props){
        super(props);
        this.state = {
            tags: [],
            tagsState: (0, $f5b3c040e086fbc1$export$62aa48085237e36f).INITIAL,
            sources: [],
            sourcesState: (0, $f5b3c040e086fbc1$export$62aa48085237e36f).INITIAL,
            navSourcesExpanded: false,
            offlineState: false,
            unreadItemsCount: 0,
            unreadItemsOfflineCount: 0,
            starredItemsCount: 0,
            starredItemsOfflineCount: 0,
            allItemsCount: 0,
            allItemsOfflineCount: 0,
            globalMessage: null
        };
        this._ = this._.bind(this);
        this.setTags = this.setTags.bind(this);
        this.setTagsState = this.setTagsState.bind(this);
        this.setSources = this.setSources.bind(this);
        this.setSourcesState = this.setSourcesState.bind(this);
        this.setOfflineState = this.setOfflineState.bind(this);
        this.setNavSourcesExpanded = this.setNavSourcesExpanded.bind(this);
        this.setUnreadItemsCount = this.setUnreadItemsCount.bind(this);
        this.setUnreadItemsOfflineCount = this.setUnreadItemsOfflineCount.bind(this);
        this.setStarredItemsCount = this.setStarredItemsCount.bind(this);
        this.setStarredItemsOfflineCount = this.setStarredItemsOfflineCount.bind(this);
        this.setAllItemsCount = this.setAllItemsCount.bind(this);
        this.setAllItemsOfflineCount = this.setAllItemsOfflineCount.bind(this);
        this.setGlobalMessage = this.setGlobalMessage.bind(this);
        this.showError = this.showError.bind(this);
        this.reloadAll = this.reloadAll.bind(this);
        [this.primaryLocale, this.fallbackLocale] = $e2370261ec80d344$export$86fbec116b87613f.setupLocales(props.configuration.language);
    }
    setTags(tags) {
        if (typeof tags === 'function') this.setState((state)=>({
                tags: tags(state.tags)
            }));
        else this.setState({
            tags: tags
        });
    }
    setTagsState(tagsState) {
        if (typeof tagsState === 'function') this.setState((state)=>({
                tagsState: tagsState(state.tagsState)
            }));
        else this.setState({
            tagsState: tagsState
        });
    }
    setSources(sources) {
        if (typeof sources === 'function') this.setState((state)=>({
                sources: sources(state.sources)
            }));
        else this.setState({
            sources: sources
        });
    }
    setSourcesState(sourcesState) {
        if (typeof sourcesState === 'function') this.setState((state)=>({
                sourcesState: sourcesState(state.sourcesState)
            }));
        else this.setState({
            sourcesState: sourcesState
        });
    }
    setOfflineState(offlineState) {
        if (typeof offlineState === 'function') this.setState((state)=>({
                offlineState: offlineState(state.offlineState)
            }));
        else this.setState({
            offlineState: offlineState
        });
    }
    setNavSourcesExpanded(navSourcesExpanded) {
        if (typeof navSourcesExpanded === 'function') this.setState((state)=>({
                navSourcesExpanded: navSourcesExpanded(state.navSourcesExpanded)
            }));
        else this.setState({
            navSourcesExpanded: navSourcesExpanded
        });
    }
    setUnreadItemsCount(unreadItemsCount) {
        if (typeof unreadItemsCount === 'function') this.setState((state)=>({
                unreadItemsCount: unreadItemsCount(state.unreadItemsCount)
            }));
        else this.setState({
            unreadItemsCount: unreadItemsCount
        });
    }
    setUnreadItemsOfflineCount(unreadItemsOfflineCount) {
        if (typeof unreadItemsOfflineCount === 'function') this.setState((state)=>({
                unreadItemsOfflineCount: unreadItemsOfflineCount(state.unreadItemsOfflineCount)
            }));
        else this.setState({
            unreadItemsOfflineCount: unreadItemsOfflineCount
        });
    }
    setStarredItemsCount(starredItemsCount) {
        if (typeof starredItemsCount === 'function') this.setState((state)=>({
                starredItemsCount: starredItemsCount(state.starredItemsCount)
            }));
        else this.setState({
            starredItemsCount: starredItemsCount
        });
    }
    setStarredItemsOfflineCount(starredItemsOfflineCount) {
        if (typeof starredItemsOfflineCount === 'function') this.setState((state)=>({
                starredItemsOfflineCount: starredItemsOfflineCount(state.starredItemsOfflineCount)
            }));
        else this.setState({
            starredItemsOfflineCount: starredItemsOfflineCount
        });
    }
    setAllItemsCount(allItemsCount) {
        if (typeof allItemsCount === 'function') this.setState((state)=>({
                allItemsCount: allItemsCount(state.allItemsCount)
            }));
        else this.setState({
            allItemsCount: allItemsCount
        });
    }
    setAllItemsOfflineCount(allItemsOfflineCount) {
        if (typeof allItemsOfflineCount === 'function') this.setState((state)=>({
                allItemsOfflineCount: allItemsOfflineCount(state.allItemsOfflineCount)
            }));
        else this.setState({
            allItemsOfflineCount: allItemsOfflineCount
        });
    }
    setGlobalMessage(globalMessage) {
        if (typeof globalMessage === 'function') this.setState((state)=>({
                globalMessage: globalMessage(state.globalMessage)
            }));
        else this.setState({
            globalMessage: globalMessage
        });
    }
    /**
     * Triggers fetching news from all sources.
     */ reloadAll() {
        if (!(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isOnline()) return Promise.resolve();
        return $377e66b0ec5c5519$export$c5eb18431f66026b().then(()=>{
            // probe stats and prompt reload to the user
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOnline.sync().then(()=>{
                if (this.state.unreadItemsCount > 0) this.showMessage(this._('sources_refreshed'), [
                    {
                        label: this._('reload_list'),
                        callback () {
                            document.querySelector('#nav-filter-unread').click();
                        }
                    }
                ]);
            });
        }).catch((error)=>{
            this.showError(this._('error_refreshing_source') + ' ' + error.message);
        });
    }
    static setupLocales(configuredLanguage) {
        const fallbackLanguage = 'en';
        let preferredLanguage;
        // locale auto-detection
        if (configuredLanguage === null) {
            if ('languages' in navigator) preferredLanguage = navigator.languages.find((0, $b074686b7cd1e86c$export$b7c662043e31af59));
        } else if ((0, $b074686b7cd1e86c$export$b7c662043e31af59)(configuredLanguage)) preferredLanguage = configuredLanguage;
        if (preferredLanguage === undefined) preferredLanguage = fallbackLanguage;
        return [
            (0, $b074686b7cd1e86c$export$2e2bcd8739ae039)[preferredLanguage],
            (0, $b074686b7cd1e86c$export$2e2bcd8739ae039)[fallbackLanguage]
        ];
    }
    /**
     * Obtain a localized message for given key, substituting placeholders for values, when given.
     */ _(identifier, params) {
        let translated = this.primaryLocale[identifier] || this.fallbackLocale[identifier];
        if (params) translated = (0, $433f7d372a884a6c$export$e51161e9fbfde80e)(translated, params);
        return translated;
    }
    /**
     * Show error message in the message bar in the UI.
     */ showError(message) {
        this.showMessage(message, [], true);
    }
    /**
     * Show message in the message bar in the UI.
     */ showMessage(message, actions = [], isError = false) {
        this.setGlobalMessage({
            message: message,
            actions: actions,
            isError: isError
        });
    }
    notifyNewVersion(cb) {
        if (!cb) cb = ()=>{
            window.location.reload();
        };
        this.showMessage(this._('app_update'), [
            {
                label: this._('app_reload'),
                callback: cb
            }
        ]);
    }
    refreshTagSourceUnread(tagCounts, sourceCounts, diff = true) {
        this.setTags((tags)=>tags.map((tag)=>{
                if (!(tag.tag in tagCounts)) return tag;
                let unread;
                if (diff) unread = tag.unread + tagCounts[tag.tag];
                else unread = tagCounts[tag.tag];
                return {
                    ...tag,
                    unread: unread
                };
            }));
        this.setSources((sources)=>sources.map((source)=>{
                if (!(source.id in sourceCounts)) return source;
                let unread;
                if (diff) unread = source.unread + sourceCounts[source.id];
                else unread = sourceCounts[source.id];
                return {
                    ...source,
                    unread: unread
                };
            }));
    }
    refreshOfflineCounts(offlineCounts) {
        for (const [kind, newCount] of Object.entries(offlineCounts)){
            if (newCount === 'keep') continue;
            if (kind === 'unread') this.setUnreadItemsOfflineCount(newCount);
            else if (kind === 'starred') this.setStarredItemsOfflineCount(newCount);
            else if (kind === 'newest') this.setAllItemsOfflineCount(newCount);
        }
    }
    render() {
        return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $b7416e8649ee66da$export$326f6d1b69f1c06e), {
            value: this.props.configuration,
            children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $433f7d372a884a6c$export$51216bcc3983e55d), {
                value: this._,
                children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($e2370261ec80d344$var$PureApp, {
                    navSourcesExpanded: this.state.navSourcesExpanded,
                    setNavSourcesExpanded: this.setNavSourcesExpanded,
                    offlineState: this.state.offlineState,
                    allItemsCount: this.state.allItemsCount,
                    allItemsOfflineCount: this.state.allItemsOfflineCount,
                    unreadItemsCount: this.state.unreadItemsCount,
                    unreadItemsOfflineCount: this.state.unreadItemsOfflineCount,
                    starredItemsCount: this.state.starredItemsCount,
                    starredItemsOfflineCount: this.state.starredItemsOfflineCount,
                    globalMessage: this.state.globalMessage,
                    sourcesState: this.state.sourcesState,
                    setSourcesState: this.setSourcesState,
                    sources: this.state.sources,
                    setSources: this.setSources,
                    tags: this.state.tags,
                    reloadAll: this.reloadAll,
                    showError: this.showError
                })
            })
        });
    }
}
function $e2370261ec80d344$export$4e373c34abfa8c68(args) {
    const { basePath: basePath, appRef: appRef, configuration: configuration } = args;
    return /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)((0, $1b28ddd4ebfaf955$export$9ba4e89fdfa1fc54), {
        basename: basePath,
        children: /*#__PURE__*/ (0, $fcda9d1f1901e894$exports.jsx)($e2370261ec80d344$export$86fbec116b87613f, {
            ref: appRef,
            configuration: configuration
        })
    });
}






class $49e95a5a7ce8064c$export$2e2bcd8739ae039 {
    _syncBegin() {
        if (!this.syncing.promise) {
            this.syncing.promise = new Promise((resolve, reject)=>{
                this.syncing.resolve = resolve;
                this.syncing.reject = reject;
                const monitor = window.setInterval(()=>{
                    let stopChecking = false;
                    if (this.syncing.promise) {
                        if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.userWaiting) {
                            // reject if user has been waiting for more than 10s,
                            // this means that connectivity is bad: user will get
                            // local content and server request will continue in
                            // the background.
                            reject();
                            stopChecking = true;
                        }
                    } else stopChecking = true;
                    if (stopChecking) window.clearInterval(monitor);
                }, 10000);
            });
            this.syncing.promise.finally(()=>{
                this.syncing.promise = null;
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.userWaiting = false;
            });
        }
        return this.syncing.promise;
    }
    _syncDone(success = true) {
        if (this.syncing.promise) {
            if (success) this.syncing.resolve();
            else {
                const request = this.syncing.request;
                this.syncing.reject();
                if (request) request.controller.abort();
            }
        }
    }
    /**
     * sync server status.
     */ sync(updatedStatuses, chained = false) {
        if (this.syncing.promise && !chained) {
            if (updatedStatuses) // Ensure the status queue is not cleared and gets sync'ed at
            // next sync.
            return Promise.reject();
            else return this.syncing.promise;
        }
        const syncing = this._syncBegin();
        let getStatuses = true;
        if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.lastUpdate === null || this.firstSync) {
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.lastUpdate = new Date(0);
            getStatuses = undefined;
        }
        const syncParams = {
            since: (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.lastUpdate,
            tags: true,
            sources: (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.state.navSourcesExpanded || undefined,
            itemsStatuses: getStatuses
        };
        if (updatedStatuses && updatedStatuses.length > 0) syncParams.updatedStatuses = updatedStatuses;
        if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.enableOffline.value) {
            syncParams.itemsSinceId = (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.lastItemId;
            syncParams.itemsNotBefore = (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.newestGCedEntry;
            syncParams.itemsHowMany = (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).config.itemsPerPage;
        }
        this.statsDirty = false;
        this.syncing.request = $e7889816bf1934b6$export$92d6409d68f0739a(updatedStatuses, syncParams);
        this.syncing.request.promise.then((data)=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.setOnline();
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.lastSync = Date.now();
            this.firstSync = false;
            const dataDate = data.lastUpdate;
            let storing = false;
            if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.enableOffline.value) {
                if ('newItems' in data) {
                    let maxId = 0;
                    data.newItems.forEach((item)=>{
                        maxId = Math.max(item.id, maxId);
                    });
                    (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing = 'lastId' in data && data.lastId > (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.lastItemId && data.lastId > maxId;
                    storing = (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing;
                    (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.shouldLoadEntriesOnline = 'lastId' in data && data.lastId - (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.lastItemId > 2 * (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).config.itemsPerPage;
                    (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.storeEntries(data.newItems).then(()=>{
                        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.storeLastUpdate(dataDate);
                        this._syncDone();
                    });
                }
                if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing || (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.needsSync) // There are still new items to fetch
                // or statuses to send
                syncing.then(()=>{
                    (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.sendNewStatuses();
                });
                if ('itemUpdates' in data) // refresh entry statuses in db and dequeue queued
                // statuses but do not calculate stats as they are taken
                // directly from the server as provided.
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.storeEntryStatuses(data.itemUpdates, true, false).then(()=>{
                    (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.storeLastUpdate(dataDate);
                });
                if ('stats' in data) (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.storeStats(data.stats);
            }
            if (!this.statsDirty && 'stats' in data) (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).refreshStats(data.stats.total, data.stats.unread, data.stats.starred);
            if ('tags' in data) {
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setTags(data.tags);
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setTagsState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS);
            }
            if ('sources' in data) {
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setSources(data.sources);
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setSourcesState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS);
            }
            if ('stats' in data && data.stats.unread > 0 && (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage && ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.state.entries.length === 0 || (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.state.loadingState === (0, $f5b3c040e086fbc1$export$62aa48085237e36f).FAILURE)) (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.reload();
            else {
                if ('itemUpdates' in data) (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.refreshEntryStatuses(data.itemUpdates);
                if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage && (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.getActiveFilter() === (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).UNREAD) {
                    const unreadCount = 'stats' in data ? data.stats.unread : (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.state.unreadItemsCount;
                    if (unreadCount > (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.state.entries.filter(({ unread: unread })=>unread).length) (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage.setHasMore(true);
                }
            }
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.lastUpdate = dataDate;
            if (!storing) this._syncDone();
        }).catch((error)=>{
            this._syncDone(false);
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).handleAjaxError(error).catch((error)=>{
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.showError((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app._('error_sync') + ' ' + error.message);
            });
        }).finally(()=>{
            if (this.syncing.promise) this.syncing.request = null;
        });
        return syncing;
    }
    /**
     * refresh current items.
     */ getEntries(fetchParams, abortController) {
        return $e7889816bf1934b6$export$d2f92acf417bbf5d({
            ...fetchParams,
            itemsPerPage: (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).config.itemsPerPage
        }, abortController).then((data)=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.setOnline();
            if (!(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.enableOffline.value) {
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.lastSync = Date.now();
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.lastUpdate = data.lastUpdate;
            }
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).refreshStats(data.all, data.unread, data.starred);
            // update tags
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setTags(data.tags);
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setTagsState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS);
            if (typeof data.sources !== 'undefined' && (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.state.navSourcesExpanded) {
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setSources(data.sources);
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setSourcesState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS);
            }
            return {
                entries: data.entries,
                hasMore: data.hasMore
            };
        }).catch((error)=>{
            if (error.name === 'AbortError') return;
            return (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).handleAjaxError(error).then(()=>{
                return (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.getEntries(fetchParams);
            });
        });
    }
    constructor(){
        this.syncing = {
            promise: null,
            request: null,
            resolve: null,
            reject: null
        };
        this.statsDirty = false;
        this.firstSync = true;
    }
}




// Making the module version consumable via require - to prohibit
// multiple occurrancies of the same module in the same app
// (dual package hazard, https://nodejs.org/api/packages.html#dual-package-hazard)
var $ec2f0f6dece9d452$exports = {};
((e, t)=>{
    $ec2f0f6dece9d452$exports = t();
})($ec2f0f6dece9d452$exports, function() {
    var B = function(e, t) {
        return (B = Object.setPrototypeOf || (({
            __proto__: []
        }) instanceof Array ? function(e, t) {
            e.__proto__ = t;
        } : function(e, t) {
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }))(e, t);
    };
    var _ = function() {
        return (_ = Object.assign || function(e) {
            for(var t, n = 1, r = arguments.length; n < r; n++)for(var i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            return e;
        }).apply(this, arguments);
    };
    function R(e, t, n) {
        if (n || 2 === arguments.length) for(var r, i = 0, o = t.length; i < o; i++)!r && i in t || ((r = r || Array.prototype.slice.call(t, 0, i))[i] = t[i]);
        return e.concat(r || Array.prototype.slice.call(t));
    }
    var f = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : $parcel$global, O = Object.keys, x = Array.isArray;
    function a(t, n) {
        return "object" == typeof n && O(n).forEach(function(e) {
            t[e] = n[e];
        }), t;
    }
    "undefined" == typeof Promise || f.Promise || (f.Promise = Promise);
    var F = Object.getPrototypeOf, N = {}.hasOwnProperty;
    function m(e, t) {
        return N.call(e, t);
    }
    function M(t, n) {
        "function" == typeof n && (n = n(F(t))), ("undefined" == typeof Reflect ? O : Reflect.ownKeys)(n).forEach(function(e) {
            u(t, e, n[e]);
        });
    }
    var L = Object.defineProperty;
    function u(e, t, n, r) {
        L(e, t, a(n && m(n, "get") && "function" == typeof n.get ? {
            get: n.get,
            set: n.set,
            configurable: !0
        } : {
            value: n,
            configurable: !0,
            writable: !0
        }, r));
    }
    function U(t) {
        return {
            from: function(e) {
                return t.prototype = Object.create(e.prototype), u(t.prototype, "constructor", t), {
                    extend: M.bind(null, t.prototype)
                };
            }
        };
    }
    var z = Object.getOwnPropertyDescriptor;
    var V = [].slice;
    function W(e, t, n) {
        return V.call(e, t, n);
    }
    function Y(e, t) {
        return t(e);
    }
    function $(e) {
        if (!e) throw new Error("Assertion Failed");
    }
    function Q(e) {
        f.setImmediate ? setImmediate(e) : setTimeout(e, 0);
    }
    function c(e, t) {
        if ("string" == typeof t && m(e, t)) return e[t];
        if (!t) return e;
        if ("string" != typeof t) {
            for(var n = [], r = 0, i = t.length; r < i; ++r){
                var o = c(e, t[r]);
                n.push(o);
            }
            return n;
        }
        var a, u = t.indexOf(".");
        return -1 === u || null == (a = e[t.substr(0, u)]) ? void 0 : c(a, t.substr(u + 1));
    }
    function b(e, t, n) {
        if (e && void 0 !== t && !("isFrozen" in Object && Object.isFrozen(e))) {
            if ("string" != typeof t && "length" in t) {
                $("string" != typeof n && "length" in n);
                for(var r = 0, i = t.length; r < i; ++r)b(e, t[r], n[r]);
            } else {
                var o = t.indexOf(".");
                if (-1 !== o) {
                    var a = t.substr(0, o), o = t.substr(o + 1);
                    if ("" === o) void 0 === n ? x(e) && !isNaN(parseInt(a)) ? e.splice(a, 1) : delete e[a] : e[a] = n;
                    else {
                        var u = e[a];
                        if (!u || !m(e, a)) {
                            if (void 0 === n) return;
                            u = e[a] = {};
                        }
                        b(u, o, n);
                    }
                } else void 0 === n ? x(e) && !isNaN(parseInt(t)) ? e.splice(t, 1) : delete e[t] : e[t] = n;
            }
        }
    }
    function G(e) {
        var t, n = {};
        for(t in e)m(e, t) && (n[t] = e[t]);
        return n;
    }
    var X = [].concat;
    function H(e) {
        return X.apply([], e);
    }
    var e = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat(H([
        8,
        16,
        32,
        64
    ].map(function(t) {
        return [
            "Int",
            "Uint",
            "Float"
        ].map(function(e) {
            return e + t + "Array";
        });
    }))).filter(function(e) {
        return f[e];
    }), J = new Set(e.map(function(e) {
        return f[e];
    }));
    var Z = null;
    function ee(e) {
        Z = new WeakMap;
        e = function e(t) {
            if (!t || "object" != typeof t) return t;
            var n = Z.get(t);
            if (n) return n;
            if (x(t)) {
                n = [], Z.set(t, n);
                for(var r = 0, i = t.length; r < i; ++r)n.push(e(t[r]));
            } else if (J.has(t.constructor)) n = t;
            else {
                var o, a = F(t);
                for(o in n = a === Object.prototype ? {} : Object.create(a), Z.set(t, n), t)m(t, o) && (n[o] = e(t[o]));
            }
            return n;
        }(e);
        return Z = null, e;
    }
    var te = {}.toString;
    function ne(e) {
        return te.call(e).slice(8, -1);
    }
    var re = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator", ie = "symbol" == typeof re ? function(e) {
        var t;
        return null != e && (t = e[re]) && t.apply(e);
    } : function() {
        return null;
    };
    function oe(e, t) {
        t = e.indexOf(t);
        0 <= t && e.splice(t, 1);
    }
    var ae = {};
    function n(e) {
        var t, n, r, i;
        if (1 === arguments.length) {
            if (x(e)) return e.slice();
            if (this === ae && "string" == typeof e) return [
                e
            ];
            if (i = ie(e)) for(n = []; !(r = i.next()).done;)n.push(r.value);
            else {
                if (null == e) return [
                    e
                ];
                if ("number" != typeof (t = e.length)) return [
                    e
                ];
                for(n = new Array(t); t--;)n[t] = e[t];
            }
        } else for(t = arguments.length, n = new Array(t); t--;)n[t] = arguments[t];
        return n;
    }
    var ue = "undefined" != typeof Symbol ? function(e) {
        return "AsyncFunction" === e[Symbol.toStringTag];
    } : function() {
        return !1;
    }, e = [
        "Unknown",
        "Constraint",
        "Data",
        "TransactionInactive",
        "ReadOnly",
        "Version",
        "NotFound",
        "InvalidState",
        "InvalidAccess",
        "Abort",
        "Timeout",
        "QuotaExceeded",
        "Syntax",
        "DataClone"
    ], t = [
        "Modify",
        "Bulk",
        "OpenFailed",
        "VersionChange",
        "Schema",
        "Upgrade",
        "InvalidTable",
        "MissingAPI",
        "NoSuchDatabase",
        "InvalidArgument",
        "SubTransaction",
        "Unsupported",
        "Internal",
        "DatabaseClosed",
        "PrematureCommit",
        "ForeignAwait"
    ].concat(e), se = {
        VersionChanged: "Database version changed by other database connection",
        DatabaseClosed: "Database has been closed",
        Abort: "Transaction aborted",
        TransactionInactive: "Transaction has already completed or failed",
        MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
    };
    function ce(e, t) {
        this.name = e, this.message = t;
    }
    function le(e, t) {
        return e + ". Errors: " + Object.keys(t).map(function(e) {
            return t[e].toString();
        }).filter(function(e, t, n) {
            return n.indexOf(e) === t;
        }).join("\n");
    }
    function fe(e, t, n, r) {
        this.failures = t, this.failedKeys = r, this.successCount = n, this.message = le(e, t);
    }
    function he(e, t) {
        this.name = "BulkError", this.failures = Object.keys(t).map(function(e) {
            return t[e];
        }), this.failuresByPos = t, this.message = le(e, this.failures);
    }
    U(ce).from(Error).extend({
        toString: function() {
            return this.name + ": " + this.message;
        }
    }), U(fe).from(ce), U(he).from(ce);
    var de = t.reduce(function(e, t) {
        return e[t] = t + "Error", e;
    }, {}), pe = ce, k = t.reduce(function(e, n) {
        var r = n + "Error";
        function t(e, t) {
            this.name = r, e ? "string" == typeof e ? (this.message = "".concat(e).concat(t ? "\n " + t : ""), this.inner = t || null) : "object" == typeof e && (this.message = "".concat(e.name, " ").concat(e.message), this.inner = e) : (this.message = se[n] || r, this.inner = null);
        }
        return U(t).from(pe), e[n] = t, e;
    }, {}), ye = (k.Syntax = SyntaxError, k.Type = TypeError, k.Range = RangeError, e.reduce(function(e, t) {
        return e[t + "Error"] = k[t], e;
    }, {}));
    e = t.reduce(function(e, t) {
        return -1 === [
            "Syntax",
            "Type",
            "Range"
        ].indexOf(t) && (e[t + "Error"] = k[t]), e;
    }, {});
    function g() {}
    function ve(e) {
        return e;
    }
    function me(t, n) {
        return null == t || t === ve ? n : function(e) {
            return n(t(e));
        };
    }
    function be(e, t) {
        return function() {
            e.apply(this, arguments), t.apply(this, arguments);
        };
    }
    function ge(i, o) {
        return i === g ? o : function() {
            var e = i.apply(this, arguments), t = (void 0 !== e && (arguments[0] = e), this.onsuccess), n = this.onerror, r = (this.onsuccess = null, this.onerror = null, o.apply(this, arguments));
            return t && (this.onsuccess = this.onsuccess ? be(t, this.onsuccess) : t), n && (this.onerror = this.onerror ? be(n, this.onerror) : n), void 0 !== r ? r : e;
        };
    }
    function we(n, r) {
        return n === g ? r : function() {
            n.apply(this, arguments);
            var e = this.onsuccess, t = this.onerror;
            this.onsuccess = this.onerror = null, r.apply(this, arguments), e && (this.onsuccess = this.onsuccess ? be(e, this.onsuccess) : e), t && (this.onerror = this.onerror ? be(t, this.onerror) : t);
        };
    }
    function _e(i, o) {
        return i === g ? o : function() {
            var e = i.apply(this, arguments), t = (a(arguments[0], e), this.onsuccess), n = this.onerror, r = (this.onsuccess = null, this.onerror = null, o.apply(this, arguments));
            return t && (this.onsuccess = this.onsuccess ? be(t, this.onsuccess) : t), n && (this.onerror = this.onerror ? be(n, this.onerror) : n), void 0 === e ? void 0 === r ? void 0 : r : a(e, r);
        };
    }
    function xe(e, t) {
        return e === g ? t : function() {
            return !1 !== t.apply(this, arguments) && e.apply(this, arguments);
        };
    }
    function ke(i, o) {
        return i === g ? o : function() {
            var e = i.apply(this, arguments);
            if (e && "function" == typeof e.then) {
                for(var t = this, n = arguments.length, r = new Array(n); n--;)r[n] = arguments[n];
                return e.then(function() {
                    return o.apply(t, r);
                });
            }
            return o.apply(this, arguments);
        };
    }
    e.ModifyError = fe, e.DexieError = ce, e.BulkError = he;
    var l = "undefined" != typeof location && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
    function Oe(e) {
        l = e;
    }
    var Pe = {}, Ke = 100, Ee = "undefined" == typeof Promise ? [] : (t = Promise.resolve(), "undefined" != typeof crypto && crypto.subtle ? [
        Ee = crypto.subtle.digest("SHA-512", new Uint8Array([
            0
        ])),
        F(Ee),
        t
    ] : [
        t,
        F(t),
        t
    ]), t = Ee[0], Se = Ee[1], Se = Se && Se.then, Ae = t && t.constructor, je = !!Ee[2];
    var Ce = function(e, t) {
        Re.push([
            e,
            t
        ]), Ie && (queueMicrotask(Ye), Ie = !1);
    }, Te = !0, Ie = !0, qe = [], De = [], Be = ve, s = {
        id: "global",
        global: !0,
        ref: 0,
        unhandleds: [],
        onunhandled: g,
        pgp: !1,
        env: {},
        finalize: g
    }, P = s, Re = [], Fe = 0, Ne = [];
    function K(e) {
        if ("object" != typeof this) throw new TypeError("Promises must be constructed via new");
        this._listeners = [], this._lib = !1;
        var t = this._PSD = P;
        if ("function" != typeof e) {
            if (e !== Pe) throw new TypeError("Not a function");
            this._state = arguments[1], this._value = arguments[2], !1 === this._state && Ue(this, this._value);
        } else this._state = null, this._value = null, ++t.ref, function t(r, e) {
            try {
                e(function(n) {
                    if (null === r._state) {
                        if (n === r) throw new TypeError("A promise cannot be resolved with itself.");
                        var e = r._lib && $e();
                        n && "function" == typeof n.then ? t(r, function(e, t) {
                            n instanceof K ? n._then(e, t) : n.then(e, t);
                        }) : (r._state = !0, r._value = n, ze(r)), e && Qe();
                    }
                }, Ue.bind(null, r));
            } catch (e) {
                Ue(r, e);
            }
        }(this, e);
    }
    var Me = {
        get: function() {
            var u = P, t = et;
            function e(n, r) {
                var i = this, o = !u.global && (u !== P || t !== et), a = o && !w(), e = new K(function(e, t) {
                    Ve(i, new Le(ut(n, u, o, a), ut(r, u, o, a), e, t, u));
                });
                return this._consoleTask && (e._consoleTask = this._consoleTask), e;
            }
            return e.prototype = Pe, e;
        },
        set: function(e) {
            u(this, "then", e && e.prototype === Pe ? Me : {
                get: function() {
                    return e;
                },
                set: Me.set
            });
        }
    };
    function Le(e, t, n, r, i) {
        this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.resolve = n, this.reject = r, this.psd = i;
    }
    function Ue(e, t) {
        var n, r;
        De.push(t), null === e._state && (n = e._lib && $e(), t = Be(t), e._state = !1, e._value = t, r = e, qe.some(function(e) {
            return e._value === r._value;
        }) || qe.push(r), ze(e), n) && Qe();
    }
    function ze(e) {
        var t = e._listeners;
        e._listeners = [];
        for(var n = 0, r = t.length; n < r; ++n)Ve(e, t[n]);
        var i = e._PSD;
        --i.ref || i.finalize(), 0 === Fe && (++Fe, Ce(function() {
            0 == --Fe && Ge();
        }, []));
    }
    function Ve(e, t) {
        if (null === e._state) e._listeners.push(t);
        else {
            var n = e._state ? t.onFulfilled : t.onRejected;
            if (null === n) return (e._state ? t.resolve : t.reject)(e._value);
            ++t.psd.ref, ++Fe, Ce(We, [
                n,
                e,
                t
            ]);
        }
    }
    function We(e, t, n) {
        try {
            var r, i = t._value;
            !t._state && De.length && (De = []), r = l && t._consoleTask ? t._consoleTask.run(function() {
                return e(i);
            }) : e(i), t._state || -1 !== De.indexOf(i) || ((e)=>{
                for(var t = qe.length; t;)if (qe[--t]._value === e._value) return qe.splice(t, 1);
            })(t), n.resolve(r);
        } catch (e) {
            n.reject(e);
        } finally{
            0 == --Fe && Ge(), --n.psd.ref || n.psd.finalize();
        }
    }
    function Ye() {
        at(s, function() {
            $e() && Qe();
        });
    }
    function $e() {
        var e = Te;
        return Ie = Te = !1, e;
    }
    function Qe() {
        var e, t, n;
        do {
            for(; 0 < Re.length;)for(e = Re, Re = [], n = e.length, t = 0; t < n; ++t){
                var r = e[t];
                r[0].apply(null, r[1]);
            }
        }while (0 < Re.length);
        Ie = Te = !0;
    }
    function Ge() {
        for(var e = qe, t = (qe = [], e.forEach(function(e) {
            e._PSD.onunhandled.call(null, e._value, e);
        }), Ne.slice(0)), n = t.length; n;)t[--n]();
    }
    function Xe(e) {
        return new K(Pe, !1, e);
    }
    function E(n, r) {
        var i = P;
        return function() {
            var e = $e(), t = P;
            try {
                return h(i, !0), n.apply(this, arguments);
            } catch (e) {
                r && r(e);
            } finally{
                h(t, !1), e && Qe();
            }
        };
    }
    M(K.prototype, {
        then: Me,
        _then: function(e, t) {
            Ve(this, new Le(null, null, e, t, P));
        },
        catch: function(e) {
            var t, n;
            return 1 === arguments.length ? this.then(null, e) : (t = e, n = arguments[1], "function" == typeof t ? this.then(null, function(e) {
                return (e instanceof t ? n : Xe)(e);
            }) : this.then(null, function(e) {
                return (e && e.name === t ? n : Xe)(e);
            }));
        },
        finally: function(t) {
            return this.then(function(e) {
                return K.resolve(t()).then(function() {
                    return e;
                });
            }, function(e) {
                return K.resolve(t()).then(function() {
                    return Xe(e);
                });
            });
        },
        timeout: function(r, i) {
            var o = this;
            return r < 1 / 0 ? new K(function(e, t) {
                var n = setTimeout(function() {
                    return t(new k.Timeout(i));
                }, r);
                o.then(e, t).finally(clearTimeout.bind(null, n));
            }) : this;
        }
    }), "undefined" != typeof Symbol && Symbol.toStringTag && u(K.prototype, Symbol.toStringTag, "Dexie.Promise"), s.env = ot(), M(K, {
        all: function() {
            var o = n.apply(null, arguments).map(rt);
            return new K(function(n, r) {
                0 === o.length && n([]);
                var i = o.length;
                o.forEach(function(e, t) {
                    return K.resolve(e).then(function(e) {
                        o[t] = e, --i || n(o);
                    }, r);
                });
            });
        },
        resolve: function(n) {
            return n instanceof K ? n : n && "function" == typeof n.then ? new K(function(e, t) {
                n.then(e, t);
            }) : new K(Pe, !0, n);
        },
        reject: Xe,
        race: function() {
            var e = n.apply(null, arguments).map(rt);
            return new K(function(t, n) {
                e.map(function(e) {
                    return K.resolve(e).then(t, n);
                });
            });
        },
        PSD: {
            get: function() {
                return P;
            },
            set: function(e) {
                return P = e;
            }
        },
        totalEchoes: {
            get: function() {
                return et;
            }
        },
        newPSD: v,
        usePSD: at,
        scheduler: {
            get: function() {
                return Ce;
            },
            set: function(e) {
                Ce = e;
            }
        },
        rejectionMapper: {
            get: function() {
                return Be;
            },
            set: function(e) {
                Be = e;
            }
        },
        follow: function(i, n) {
            return new K(function(e, t) {
                return v(function(n, r) {
                    var e = P;
                    e.unhandleds = [], e.onunhandled = r, e.finalize = be(function() {
                        var t, e = this;
                        t = function() {
                            0 === e.unhandleds.length ? n() : r(e.unhandleds[0]);
                        }, Ne.push(function e() {
                            t(), Ne.splice(Ne.indexOf(e), 1);
                        }), ++Fe, Ce(function() {
                            0 == --Fe && Ge();
                        }, []);
                    }, e.finalize), i();
                }, n, e, t);
            });
        }
    }), Ae && (Ae.allSettled && u(K, "allSettled", function() {
        var e = n.apply(null, arguments).map(rt);
        return new K(function(n) {
            0 === e.length && n([]);
            var r = e.length, i = new Array(r);
            e.forEach(function(e, t) {
                return K.resolve(e).then(function(e) {
                    return i[t] = {
                        status: "fulfilled",
                        value: e
                    };
                }, function(e) {
                    return i[t] = {
                        status: "rejected",
                        reason: e
                    };
                }).then(function() {
                    return --r || n(i);
                });
            });
        });
    }), Ae.any && "undefined" != typeof AggregateError && u(K, "any", function() {
        var e = n.apply(null, arguments).map(rt);
        return new K(function(n, r) {
            0 === e.length && r(new AggregateError([]));
            var i = e.length, o = new Array(i);
            e.forEach(function(e, t) {
                return K.resolve(e).then(function(e) {
                    return n(e);
                }, function(e) {
                    o[t] = e, --i || r(new AggregateError(o));
                });
            });
        });
    }), Ae.withResolvers) && (K.withResolvers = Ae.withResolvers);
    var o = {
        awaits: 0,
        echoes: 0,
        id: 0
    }, He = 0, Je = [], Ze = 0, et = 0, tt = 0;
    function v(e, t, n, r) {
        var i = P, o = Object.create(i), t = (o.parent = i, o.ref = 0, o.global = !1, o.id = ++tt, s.env, o.env = je ? {
            Promise: K,
            PromiseProp: {
                value: K,
                configurable: !0,
                writable: !0
            },
            all: K.all,
            race: K.race,
            allSettled: K.allSettled,
            any: K.any,
            resolve: K.resolve,
            reject: K.reject
        } : {}, t && a(o, t), ++i.ref, o.finalize = function() {
            --this.parent.ref || this.parent.finalize();
        }, at(o, e, n, r));
        return 0 === o.ref && o.finalize(), t;
    }
    function nt() {
        return o.id || (o.id = ++He), ++o.awaits, o.echoes += Ke, o.id;
    }
    function w() {
        return !!o.awaits && (0 == --o.awaits && (o.id = 0), o.echoes = o.awaits * Ke, !0);
    }
    function rt(e) {
        return o.echoes && e && e.constructor === Ae ? (nt(), e.then(function(e) {
            return w(), e;
        }, function(e) {
            return w(), S(e);
        })) : e;
    }
    function it() {
        var e = Je[Je.length - 1];
        Je.pop(), h(e, !1);
    }
    function h(e, t) {
        var n, r, i = P;
        (t ? !o.echoes || Ze++ && e === P : !Ze || --Ze && e === P) || queueMicrotask(t ? (function(e) {
            ++et, o.echoes && 0 != --o.echoes || (o.echoes = o.awaits = o.id = 0), Je.push(P), h(e, !0);
        }).bind(null, e) : it), e !== P && (P = e, i === s && (s.env = ot()), je) && (n = s.env.Promise, r = e.env, i.global || e.global) && (Object.defineProperty(f, "Promise", r.PromiseProp), n.all = r.all, n.race = r.race, n.resolve = r.resolve, n.reject = r.reject, r.allSettled && (n.allSettled = r.allSettled), r.any) && (n.any = r.any);
    }
    function ot() {
        var e = f.Promise;
        return je ? {
            Promise: e,
            PromiseProp: Object.getOwnPropertyDescriptor(f, "Promise"),
            all: e.all,
            race: e.race,
            allSettled: e.allSettled,
            any: e.any,
            resolve: e.resolve,
            reject: e.reject
        } : {};
    }
    function at(e, t, n, r, i) {
        var o = P;
        try {
            return h(e, !0), t(n, r, i);
        } finally{
            h(o, !1);
        }
    }
    function ut(t, n, r, i) {
        return "function" != typeof t ? t : function() {
            var e = P;
            r && nt(), h(n, !0);
            try {
                return t.apply(this, arguments);
            } finally{
                h(e, !1), i && queueMicrotask(w);
            }
        };
    }
    function st(e) {
        Promise === Ae && 0 === o.echoes ? 0 === Ze ? e() : enqueueNativeMicroTask(e) : setTimeout(e, 0);
    }
    -1 === ("" + Se).indexOf("[native code]") && (nt = w = g);
    var S = K.reject;
    var ct = String.fromCharCode(65535), A = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.", lt = "String expected.", ft = "__dbnames", ht = "readonly", dt = "readwrite";
    function pt(e, t) {
        return e ? t ? function() {
            return e.apply(this, arguments) && t.apply(this, arguments);
        } : e : t;
    }
    var yt = {
        type: 3,
        lower: -1 / 0,
        lowerOpen: !1,
        upper: [
            []
        ],
        upperOpen: !1
    };
    function vt(t) {
        return "string" != typeof t || /\./.test(t) ? function(e) {
            return e;
        } : function(e) {
            return void 0 === e[t] && t in e && delete (e = ee(e))[t], e;
        };
    }
    function mt() {
        throw k.Type("Entity instances must never be new:ed. Instances are generated by the framework bypassing the constructor.");
    }
    function j(e, t) {
        try {
            var n = bt(e), r = bt(t);
            if (n !== r) return "Array" === n ? 1 : "Array" === r ? -1 : "binary" === n ? 1 : "binary" === r ? -1 : "string" === n ? 1 : "string" === r ? -1 : "Date" === n ? 1 : "Date" !== r ? NaN : -1;
            switch(n){
                case "number":
                case "Date":
                case "string":
                    return t < e ? 1 : e < t ? -1 : 0;
                case "binary":
                    for(var i = gt(e), o = gt(t), a = i.length, u = o.length, s = a < u ? a : u, c = 0; c < s; ++c)if (i[c] !== o[c]) return i[c] < o[c] ? -1 : 1;
                    return a === u ? 0 : a < u ? -1 : 1;
                case "Array":
                    for(var l = e, f = t, h = l.length, d = f.length, p = h < d ? h : d, y = 0; y < p; ++y){
                        var v = j(l[y], f[y]);
                        if (0 !== v) return v;
                    }
                    return h === d ? 0 : h < d ? -1 : 1;
            }
        } catch (e) {}
        return NaN;
    }
    function bt(e) {
        var t = typeof e;
        return "object" == t && (ArrayBuffer.isView(e) || "ArrayBuffer" === (t = ne(e))) ? "binary" : t;
    }
    function gt(e) {
        return e instanceof Uint8Array ? e : ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : new Uint8Array(e);
    }
    function wt(t, n, r) {
        var e = t.schema.yProps;
        return e ? (n && 0 < r.numFailures && (n = n.filter(function(e, t) {
            return !r.failures[t];
        })), Promise.all(e.map(function(e) {
            e = e.updatesTable;
            return n ? t.db.table(e).where("k").anyOf(n).delete() : t.db.table(e).clear();
        })).then(function() {
            return r;
        })) : r;
    }
    xt.prototype.execute = function(e) {
        var t = this["@@propmod"];
        if (void 0 !== t.add) {
            var n = t.add;
            if (x(n)) return R(R([], x(e) ? e : [], !0), n, !0).sort();
            if ("number" == typeof n) return (Number(e) || 0) + n;
            if ("bigint" == typeof n) try {
                return BigInt(e) + n;
            } catch (e) {
                return BigInt(0) + n;
            }
            throw new TypeError("Invalid term ".concat(n));
        }
        if (void 0 !== t.remove) {
            var r = t.remove;
            if (x(r)) return x(e) ? e.filter(function(e) {
                return !r.includes(e);
            }).sort() : [];
            if ("number" == typeof r) return Number(e) - r;
            if ("bigint" == typeof r) try {
                return BigInt(e) - r;
            } catch (e) {
                return BigInt(0) - r;
            }
            throw new TypeError("Invalid subtrahend ".concat(r));
        }
        n = null == (n = t.replacePrefix) ? void 0 : n[0];
        return n && "string" == typeof e && e.startsWith(n) ? t.replacePrefix[1] + e.substring(n.length) : e;
    };
    var _t = xt;
    function xt(e) {
        this["@@propmod"] = e;
    }
    function kt(e, t) {
        for(var n = O(t), r = n.length, i = !1, o = 0; o < r; ++o){
            var a = n[o], u = t[a], s = c(e, a);
            u instanceof _t ? (b(e, a, u.execute(s)), i = !0) : s !== u && (b(e, a, u), i = !0);
        }
        return i;
    }
    r.prototype._trans = function(e, r, t) {
        var n = this._tx || P.trans, i = this.name, o = l && "undefined" != typeof console && console.createTask && console.createTask("Dexie: ".concat("readonly" === e ? "read" : "write", " ").concat(this.name));
        function a(e, t, n) {
            if (n.schema[i]) return r(n.idbtrans, n);
            throw new k.NotFound("Table " + i + " not part of transaction");
        }
        var u = $e();
        try {
            var s = n && n.db._novip === this.db._novip ? n === P.trans ? n._promise(e, a, t) : v(function() {
                return n._promise(e, a, t);
            }, {
                trans: n,
                transless: P.transless || P
            }) : function t(n, r, i, o) {
                if (n.idbdb && (n._state.openComplete || P.letThrough || n._vip)) {
                    var a = n._createTransaction(r, i, n._dbSchema);
                    try {
                        a.create(), n._state.PR1398_maxLoop = 3;
                    } catch (e) {
                        return e.name === de.InvalidState && n.isOpen() && 0 < --n._state.PR1398_maxLoop ? (console.warn("Dexie: Need to reopen db"), n.close({
                            disableAutoOpen: !1
                        }), n.open().then(function() {
                            return t(n, r, i, o);
                        })) : S(e);
                    }
                    return a._promise(r, function(e, t) {
                        return v(function() {
                            return P.trans = a, o(e, t, a);
                        });
                    }).then(function(e) {
                        if ("readwrite" === r) try {
                            a.idbtrans.commit();
                        } catch (e) {}
                        return "readonly" === r ? e : a._completion.then(function() {
                            return e;
                        });
                    });
                }
                if (n._state.openComplete) return S(new k.DatabaseClosed(n._state.dbOpenError));
                if (!n._state.isBeingOpened) {
                    if (!n._state.autoOpen) return S(new k.DatabaseClosed);
                    n.open().catch(g);
                }
                return n._state.dbReadyPromise.then(function() {
                    return t(n, r, i, o);
                });
            }(this.db, e, [
                this.name
            ], a);
            return o && (s._consoleTask = o, s = s.catch(function(e) {
                return console.trace(e), S(e);
            })), s;
        } finally{
            u && Qe();
        }
    }, r.prototype.get = function(t, e) {
        var n = this;
        return t && t.constructor === Object ? this.where(t).first(e) : null == t ? S(new k.Type("Invalid argument to Table.get()")) : this._trans("readonly", function(e) {
            return n.core.get({
                trans: e,
                key: t
            }).then(function(e) {
                return n.hook.reading.fire(e);
            });
        }).then(e);
    }, r.prototype.where = function(o) {
        if ("string" == typeof o) return new this.db.WhereClause(this, o);
        if (x(o)) return new this.db.WhereClause(this, "[".concat(o.join("+"), "]"));
        var n = O(o);
        if (1 === n.length) return this.where(n[0]).equals(o[n[0]]);
        var e = this.schema.indexes.concat(this.schema.primKey).filter(function(t) {
            if (t.compound && n.every(function(e) {
                return 0 <= t.keyPath.indexOf(e);
            })) {
                for(var e = 0; e < n.length; ++e)if (-1 === n.indexOf(t.keyPath[e])) return !1;
                return !0;
            }
            return !1;
        }).sort(function(e, t) {
            return e.keyPath.length - t.keyPath.length;
        })[0];
        if (e && this.db._maxKey !== ct) return t = e.keyPath.slice(0, n.length), this.where(t).equals(t.map(function(e) {
            return o[e];
        }));
        !e && l && console.warn("The query ".concat(JSON.stringify(o), " on ").concat(this.name, " would benefit from a ") + "compound index [".concat(n.join("+"), "]"));
        var a = this.schema.idxByName;
        function u(e, t) {
            return 0 === j(e, t);
        }
        var t = n.reduce(function(e, t) {
            var n = e[0], e = e[1], r = a[t], i = o[t];
            return [
                n || r,
                n || !r ? pt(e, r && r.multi ? function(e) {
                    e = c(e, t);
                    return x(e) && e.some(function(e) {
                        return u(i, e);
                    });
                } : function(e) {
                    return u(i, c(e, t));
                }) : e
            ];
        }, [
            null,
            null
        ]), r = t[0], t = t[1];
        return r ? this.where(r.name).equals(o[r.keyPath]).filter(t) : e ? this.filter(t) : this.where(n).equals("");
    }, r.prototype.filter = function(e) {
        return this.toCollection().and(e);
    }, r.prototype.count = function(e) {
        return this.toCollection().count(e);
    }, r.prototype.offset = function(e) {
        return this.toCollection().offset(e);
    }, r.prototype.limit = function(e) {
        return this.toCollection().limit(e);
    }, r.prototype.each = function(e) {
        return this.toCollection().each(e);
    }, r.prototype.toArray = function(e) {
        return this.toCollection().toArray(e);
    }, r.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    }, r.prototype.orderBy = function(e) {
        return new this.db.Collection(new this.db.WhereClause(this, x(e) ? "[".concat(e.join("+"), "]") : e));
    }, r.prototype.reverse = function() {
        return this.toCollection().reverse();
    }, r.prototype.mapToClass = function(r) {
        for(var o = this.db, a = this.name, i = ((this.schema.mappedClass = r).prototype instanceof mt && (r = ((e)=>{
            var t = i, n = e;
            if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
            function r() {
                this.constructor = t;
            }
            function i() {
                return null !== e && e.apply(this, arguments) || this;
            }
            return B(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r), Object.defineProperty(i.prototype, "db", {
                get: function() {
                    return o;
                },
                enumerable: !1,
                configurable: !0
            }), i.prototype.table = function() {
                return a;
            }, i;
        })(r)), new Set), e = r.prototype; e; e = F(e))Object.getOwnPropertyNames(e).forEach(function(e) {
            return i.add(e);
        });
        function t(e) {
            if (!e) return e;
            var t, n = Object.create(r.prototype);
            for(t in e)if (!i.has(t)) try {
                n[t] = e[t];
            } catch (e) {}
            return n;
        }
        return this.schema.readHook && this.hook.reading.unsubscribe(this.schema.readHook), this.schema.readHook = t, this.hook("reading", t), r;
    }, r.prototype.defineClass = function() {
        return this.mapToClass(function(e) {
            a(this, e);
        });
    }, r.prototype.add = function(t, n) {
        var r = this, e = this.schema.primKey, i = e.auto, o = e.keyPath, a = t;
        return o && i && (a = vt(o)(t)), this._trans("readwrite", function(e) {
            return r.core.mutate({
                trans: e,
                type: "add",
                keys: null != n ? [
                    n
                ] : null,
                values: [
                    a
                ]
            });
        }).then(function(e) {
            return e.numFailures ? K.reject(e.failures[0]) : e.lastResult;
        }).then(function(e) {
            if (o) try {
                b(t, o, e);
            } catch (e) {}
            return e;
        });
    }, r.prototype.upsert = function(r, i) {
        var o = this, a = this.schema.primKey.keyPath;
        return this._trans("readwrite", function(n) {
            return o.core.get({
                trans: n,
                key: r
            }).then(function(t) {
                var e = null != t ? t : {};
                return kt(e, i), a && b(e, a, r), o.core.mutate({
                    trans: n,
                    type: "put",
                    values: [
                        e
                    ],
                    keys: [
                        r
                    ],
                    upsert: !0,
                    updates: {
                        keys: [
                            r
                        ],
                        changeSpecs: [
                            i
                        ]
                    }
                }).then(function(e) {
                    return e.numFailures ? K.reject(e.failures[0]) : !!t;
                });
            });
        });
    }, r.prototype.update = function(e, t) {
        return "object" != typeof e || x(e) ? this.where(":id").equals(e).modify(t) : void 0 === (e = c(e, this.schema.primKey.keyPath)) ? S(new k.InvalidArgument("Given object does not contain its primary key")) : this.where(":id").equals(e).modify(t);
    }, r.prototype.put = function(t, n) {
        var r = this, e = this.schema.primKey, i = e.auto, o = e.keyPath, a = t;
        return o && i && (a = vt(o)(t)), this._trans("readwrite", function(e) {
            return r.core.mutate({
                trans: e,
                type: "put",
                values: [
                    a
                ],
                keys: null != n ? [
                    n
                ] : null
            });
        }).then(function(e) {
            return e.numFailures ? K.reject(e.failures[0]) : e.lastResult;
        }).then(function(e) {
            if (o) try {
                b(t, o, e);
            } catch (e) {}
            return e;
        });
    }, r.prototype.delete = function(t) {
        var n = this;
        return this._trans("readwrite", function(e) {
            return n.core.mutate({
                trans: e,
                type: "delete",
                keys: [
                    t
                ]
            }).then(function(e) {
                return wt(n, [
                    t
                ], e);
            }).then(function(e) {
                return e.numFailures ? K.reject(e.failures[0]) : void 0;
            });
        });
    }, r.prototype.clear = function() {
        var t = this;
        return this._trans("readwrite", function(e) {
            return t.core.mutate({
                trans: e,
                type: "deleteRange",
                range: yt
            }).then(function(e) {
                return wt(t, null, e);
            });
        }).then(function(e) {
            return e.numFailures ? K.reject(e.failures[0]) : void 0;
        });
    }, r.prototype.bulkGet = function(t) {
        var n = this;
        return this._trans("readonly", function(e) {
            return n.core.getMany({
                keys: t,
                trans: e
            }).then(function(e) {
                return e.map(function(e) {
                    return n.hook.reading.fire(e);
                });
            });
        });
    }, r.prototype.bulkAdd = function(i, e, t) {
        var o = this, a = Array.isArray(e) ? e : void 0, u = (t = t || (a ? void 0 : e)) ? t.allKeys : void 0;
        return this._trans("readwrite", function(e) {
            var t = o.schema.primKey, n = t.auto, t = t.keyPath;
            if (t && a) throw new k.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (a && a.length !== i.length) throw new k.InvalidArgument("Arguments objects and keys must have the same length");
            var r = i.length, n = t && n ? i.map(vt(t)) : i;
            return o.core.mutate({
                trans: e,
                type: "add",
                keys: a,
                values: n,
                wantResults: u
            }).then(function(e) {
                var t = e.numFailures, n = e.failures;
                if (0 === t) return u ? e.results : e.lastResult;
                throw new he("".concat(o.name, ".bulkAdd(): ").concat(t, " of ").concat(r, " operations failed"), n);
            });
        });
    }, r.prototype.bulkPut = function(i, e, t) {
        var o = this, a = Array.isArray(e) ? e : void 0, u = (t = t || (a ? void 0 : e)) ? t.allKeys : void 0;
        return this._trans("readwrite", function(e) {
            var t = o.schema.primKey, n = t.auto, t = t.keyPath;
            if (t && a) throw new k.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (a && a.length !== i.length) throw new k.InvalidArgument("Arguments objects and keys must have the same length");
            var r = i.length, n = t && n ? i.map(vt(t)) : i;
            return o.core.mutate({
                trans: e,
                type: "put",
                keys: a,
                values: n,
                wantResults: u
            }).then(function(e) {
                var t = e.numFailures, n = e.failures;
                if (0 === t) return u ? e.results : e.lastResult;
                throw new he("".concat(o.name, ".bulkPut(): ").concat(t, " of ").concat(r, " operations failed"), n);
            });
        });
    }, r.prototype.bulkUpdate = function(t) {
        var h = this, n = this.core, r = t.map(function(e) {
            return e.key;
        }), i = t.map(function(e) {
            return e.changes;
        }), d = [];
        return this._trans("readwrite", function(e) {
            return n.getMany({
                trans: e,
                keys: r,
                cache: "clone"
            }).then(function(c) {
                var l = [], f = [], s = (t.forEach(function(e, t) {
                    var n = e.key, r = e.changes, i = c[t];
                    if (i) {
                        for(var o = 0, a = Object.keys(r); o < a.length; o++){
                            var u = a[o], s = r[u];
                            if (u === h.schema.primKey.keyPath) {
                                if (0 !== j(s, n)) throw new k.Constraint("Cannot update primary key in bulkUpdate()");
                            } else b(i, u, s);
                        }
                        d.push(t), l.push(n), f.push(i);
                    }
                }), l.length);
                return n.mutate({
                    trans: e,
                    type: "put",
                    keys: l,
                    values: f,
                    updates: {
                        keys: r,
                        changeSpecs: i
                    }
                }).then(function(e) {
                    var t = e.numFailures, n = e.failures;
                    if (0 === t) return s;
                    for(var r = 0, i = Object.keys(n); r < i.length; r++){
                        var o, a = i[r], u = d[Number(a)];
                        null != u && (o = n[a], delete n[a], n[u] = o);
                    }
                    throw new he("".concat(h.name, ".bulkUpdate(): ").concat(t, " of ").concat(s, " operations failed"), n);
                });
            });
        });
    }, r.prototype.bulkDelete = function(t) {
        var r = this, i = t.length;
        return this._trans("readwrite", function(e) {
            return r.core.mutate({
                trans: e,
                type: "delete",
                keys: t
            }).then(function(e) {
                return wt(r, t, e);
            });
        }).then(function(e) {
            var t = e.numFailures, n = e.failures;
            if (0 === t) return e.lastResult;
            throw new he("".concat(r.name, ".bulkDelete(): ").concat(t, " of ").concat(i, " operations failed"), n);
        });
    };
    var Ot = r;
    function r() {}
    function Pt(i) {
        function t(e, t) {
            if (t) {
                for(var n = arguments.length, r = new Array(n - 1); --n;)r[n - 1] = arguments[n];
                return a[e].subscribe.apply(null, r), i;
            }
            if ("string" == typeof e) return a[e];
        }
        var a = {};
        t.addEventType = u;
        for(var e = 1, n = arguments.length; e < n; ++e)u(arguments[e]);
        return t;
        function u(e, n, r) {
            var i, o;
            if ("object" != typeof e) return n = n || xe, o = {
                subscribers: [],
                fire: r = r || g,
                subscribe: function(e) {
                    -1 === o.subscribers.indexOf(e) && (o.subscribers.push(e), o.fire = n(o.fire, e));
                },
                unsubscribe: function(t) {
                    o.subscribers = o.subscribers.filter(function(e) {
                        return e !== t;
                    }), o.fire = o.subscribers.reduce(n, r);
                }
            }, a[e] = t[e] = o;
            O(i = e).forEach(function(e) {
                var t = i[e];
                if (x(t)) u(e, i[e][0], i[e][1]);
                else {
                    if ("asap" !== t) throw new k.InvalidArgument("Invalid event config");
                    var n = u(e, ve, function() {
                        for(var e = arguments.length, t = new Array(e); e--;)t[e] = arguments[e];
                        n.subscribers.forEach(function(e) {
                            Q(function() {
                                e.apply(null, t);
                            });
                        });
                    });
                }
            });
        }
    }
    function Kt(e, t) {
        return U(t).from({
            prototype: e
        }), t;
    }
    function Et(e, t) {
        return !(e.filter || e.algorithm || e.or) && (t ? e.justLimit : !e.replayFilter);
    }
    function St(e, t) {
        e.filter = pt(e.filter, t);
    }
    function At(e, t, n) {
        var r = e.replayFilter;
        e.replayFilter = r ? function() {
            return pt(r(), t());
        } : t, e.justLimit = n && !r;
    }
    function jt(e, t) {
        if (e.isPrimKey) return t.primaryKey;
        var n = t.getIndexByKeyPath(e.index);
        if (n) return n;
        throw new k.Schema("KeyPath " + e.index + " on object store " + t.name + " is not indexed");
    }
    function Ct(e, t, n) {
        var r = jt(e, t.schema);
        return t.openCursor({
            trans: n,
            values: !e.keysOnly,
            reverse: "prev" === e.dir,
            unique: !!e.unique,
            query: {
                index: r,
                range: e.range
            }
        });
    }
    function Tt(e, o, t, n) {
        var a, r, u = e.replayFilter ? pt(e.filter, e.replayFilter()) : e.filter;
        return e.or ? (a = {}, r = function(e, t, n) {
            var r, i;
            u && !u(t, n, function(e) {
                return t.stop(e);
            }, function(e) {
                return t.fail(e);
            }) || ("[object ArrayBuffer]" === (i = "" + (r = t.primaryKey)) && (i = "" + new Uint8Array(r)), m(a, i)) || (a[i] = !0, o(e, t, n));
        }, Promise.all([
            e.or._iterate(r, t),
            It(Ct(e, n, t), e.algorithm, r, !e.keysOnly && e.valueMapper)
        ])) : It(Ct(e, n, t), pt(e.algorithm, u), o, !e.keysOnly && e.valueMapper);
    }
    function It(e, r, i, o) {
        var a = E(o ? function(e, t, n) {
            return i(o(e), t, n);
        } : i);
        return e.then(function(n) {
            if (n) return n.start(function() {
                var t = function() {
                    return n.continue();
                };
                r && !r(n, function(e) {
                    return t = e;
                }, function(e) {
                    n.stop(e), t = g;
                }, function(e) {
                    n.fail(e), t = g;
                }) || a(n.value, n, function(e) {
                    return t = e;
                }), t();
            });
        });
    }
    i.prototype._read = function(e, t) {
        var n = this._ctx;
        return n.error ? n.table._trans(null, S.bind(null, n.error)) : n.table._trans("readonly", e).then(t);
    }, i.prototype._write = function(e) {
        var t = this._ctx;
        return t.error ? t.table._trans(null, S.bind(null, t.error)) : t.table._trans("readwrite", e, "locked");
    }, i.prototype._addAlgorithm = function(e) {
        var t = this._ctx;
        t.algorithm = pt(t.algorithm, e);
    }, i.prototype._iterate = function(e, t) {
        return Tt(this._ctx, e, t, this._ctx.table.core);
    }, i.prototype.clone = function(e) {
        var t = Object.create(this.constructor.prototype), n = Object.create(this._ctx);
        return e && a(n, e), t._ctx = n, t;
    }, i.prototype.raw = function() {
        return this._ctx.valueMapper = null, this;
    }, i.prototype.each = function(t) {
        var n = this._ctx;
        return this._read(function(e) {
            return Tt(n, t, e, n.table.core);
        });
    }, i.prototype.count = function(e) {
        var i = this;
        return this._read(function(e) {
            var t, n = i._ctx, r = n.table.core;
            return Et(n, !0) ? r.count({
                trans: e,
                query: {
                    index: jt(n, r.schema),
                    range: n.range
                }
            }).then(function(e) {
                return Math.min(e, n.limit);
            }) : (t = 0, Tt(n, function() {
                return ++t, !1;
            }, e, r).then(function() {
                return t;
            }));
        }).then(e);
    }, i.prototype.sortBy = function(e, t) {
        var n = e.split(".").reverse(), r = n[0], i = n.length - 1;
        function o(e, t) {
            return t ? o(e[n[t]], t - 1) : e[r];
        }
        var a = "next" === this._ctx.dir ? 1 : -1;
        function u(e, t) {
            return j(o(e, i), o(t, i)) * a;
        }
        return this.toArray(function(e) {
            return e.slice().sort(u);
        }).then(t);
    }, i.prototype.toArray = function(e) {
        var o = this;
        return this._read(function(e) {
            var t, n, r, i = o._ctx;
            return Et(i, !0) && 0 < i.limit ? (t = i.valueMapper, n = jt(i, i.table.core.schema), i.table.core.query({
                trans: e,
                limit: i.limit,
                values: !0,
                direction: "prev" === i.dir ? "prev" : void 0,
                query: {
                    index: n,
                    range: i.range
                }
            }).then(function(e) {
                e = e.result;
                return t ? e.map(t) : e;
            })) : (r = [], Tt(i, function(e) {
                return r.push(e);
            }, e, i.table.core).then(function() {
                return r;
            }));
        }, e);
    }, i.prototype.offset = function(t) {
        var e = this._ctx;
        return t <= 0 || (e.offset += t, Et(e) ? At(e, function() {
            var n = t;
            return function(e, t) {
                return 0 === n || (1 === n ? --n : t(function() {
                    e.advance(n), n = 0;
                }), !1);
            };
        }) : At(e, function() {
            var e = t;
            return function() {
                return --e < 0;
            };
        })), this;
    }, i.prototype.limit = function(e) {
        return this._ctx.limit = Math.min(this._ctx.limit, e), At(this._ctx, function() {
            var r = e;
            return function(e, t, n) {
                return --r <= 0 && t(n), 0 <= r;
            };
        }, !0), this;
    }, i.prototype.until = function(r, i) {
        return St(this._ctx, function(e, t, n) {
            return !r(e.value) || (t(n), i);
        }), this;
    }, i.prototype.first = function(e) {
        return this.limit(1).toArray(function(e) {
            return e[0];
        }).then(e);
    }, i.prototype.last = function(e) {
        return this.reverse().first(e);
    }, i.prototype.filter = function(t) {
        var e;
        return St(this._ctx, function(e) {
            return t(e.value);
        }), (e = this._ctx).isMatch = pt(e.isMatch, t), this;
    }, i.prototype.and = function(e) {
        return this.filter(e);
    }, i.prototype.or = function(e) {
        return new this.db.WhereClause(this._ctx.table, e, this);
    }, i.prototype.reverse = function() {
        return this._ctx.dir = "prev" === this._ctx.dir ? "next" : "prev", this._ondirectionchange && this._ondirectionchange(this._ctx.dir), this;
    }, i.prototype.desc = function() {
        return this.reverse();
    }, i.prototype.eachKey = function(n) {
        var e = this._ctx;
        return e.keysOnly = !e.isMatch, this.each(function(e, t) {
            n(t.key, t);
        });
    }, i.prototype.eachUniqueKey = function(e) {
        return this._ctx.unique = "unique", this.eachKey(e);
    }, i.prototype.eachPrimaryKey = function(n) {
        var e = this._ctx;
        return e.keysOnly = !e.isMatch, this.each(function(e, t) {
            n(t.primaryKey, t);
        });
    }, i.prototype.keys = function(e) {
        var t = this._ctx, n = (t.keysOnly = !t.isMatch, []);
        return this.each(function(e, t) {
            n.push(t.key);
        }).then(function() {
            return n;
        }).then(e);
    }, i.prototype.primaryKeys = function(e) {
        var n = this._ctx;
        if (Et(n, !0) && 0 < n.limit) return this._read(function(e) {
            var t = jt(n, n.table.core.schema);
            return n.table.core.query({
                trans: e,
                values: !1,
                limit: n.limit,
                direction: "prev" === n.dir ? "prev" : void 0,
                query: {
                    index: t,
                    range: n.range
                }
            });
        }).then(function(e) {
            return e.result;
        }).then(e);
        n.keysOnly = !n.isMatch;
        var r = [];
        return this.each(function(e, t) {
            r.push(t.primaryKey);
        }).then(function() {
            return r;
        }).then(e);
    }, i.prototype.uniqueKeys = function(e) {
        return this._ctx.unique = "unique", this.keys(e);
    }, i.prototype.firstKey = function(e) {
        return this.limit(1).keys(function(e) {
            return e[0];
        }).then(e);
    }, i.prototype.lastKey = function(e) {
        return this.reverse().firstKey(e);
    }, i.prototype.distinct = function() {
        var n, e = this._ctx, e = e.index && e.table.schema.idxByName[e.index];
        return e && e.multi && (n = {}, St(this._ctx, function(e) {
            var e = e.primaryKey.toString(), t = m(n, e);
            return n[e] = !0, !t;
        })), this;
    }, i.prototype.modify = function(x) {
        var n = this, k = this._ctx;
        return this._write(function(p) {
            function y(e, t) {
                var n = t.failures;
                u += e - t.numFailures;
                for(var r = 0, i = O(n); r < i.length; r++){
                    var o = i[r];
                    a.push(n[o]);
                }
            }
            var v = "function" == typeof x ? x : function(e) {
                return kt(e, x);
            }, m = k.table.core, e = m.schema.primaryKey, b = e.outbound, g = e.extractKey, w = 200, e = n.db._options.modifyChunkSize, a = (e && (w = "object" == typeof e ? e[m.name] || e["*"] || 200 : e), []), u = 0, t = [], _ = x === Dt;
            return n.clone().primaryKeys().then(function(f) {
                function h(s) {
                    var c = Math.min(w, f.length - s), l = f.slice(s, s + c);
                    return (_ ? Promise.resolve([]) : m.getMany({
                        trans: p,
                        keys: l,
                        cache: "immutable"
                    })).then(function(e) {
                        var n = [], t = [], r = b ? [] : null, i = _ ? l : [];
                        if (!_) for(var o = 0; o < c; ++o){
                            var a = e[o], u = {
                                value: ee(a),
                                primKey: f[s + o]
                            };
                            !1 !== v.call(u, u.value, u) && (null == u.value ? i.push(f[s + o]) : b || 0 === j(g(a), g(u.value)) ? (t.push(u.value), b && r.push(f[s + o])) : (i.push(f[s + o]), n.push(u.value)));
                        }
                        return Promise.resolve(0 < n.length && m.mutate({
                            trans: p,
                            type: "add",
                            values: n
                        }).then(function(e) {
                            for(var t in e.failures)i.splice(parseInt(t), 1);
                            y(n.length, e);
                        })).then(function() {
                            return (0 < t.length || d && "object" == typeof x) && m.mutate({
                                trans: p,
                                type: "put",
                                keys: r,
                                values: t,
                                criteria: d,
                                changeSpec: "function" != typeof x && x,
                                isAdditionalChunk: 0 < s
                            }).then(function(e) {
                                return y(t.length, e);
                            });
                        }).then(function() {
                            return (0 < i.length || d && _) && m.mutate({
                                trans: p,
                                type: "delete",
                                keys: i,
                                criteria: d,
                                isAdditionalChunk: 0 < s
                            }).then(function(e) {
                                return wt(k.table, i, e);
                            }).then(function(e) {
                                return y(i.length, e);
                            });
                        }).then(function() {
                            return f.length > s + c && h(s + w);
                        });
                    });
                }
                var d = Et(k) && k.limit === 1 / 0 && ("function" != typeof x || _) && {
                    index: k.index,
                    range: k.range
                };
                return h(0).then(function() {
                    if (0 < a.length) throw new fe("Error modifying one or more objects", a, u, t);
                    return f.length;
                });
            });
        });
    }, i.prototype.delete = function() {
        var i = this._ctx, n = i.range;
        return !Et(i) || i.table.schema.yProps || !i.isPrimKey && 3 !== n.type ? this.modify(Dt) : this._write(function(e) {
            var t = i.table.core.schema.primaryKey, r = n;
            return i.table.core.count({
                trans: e,
                query: {
                    index: t,
                    range: r
                }
            }).then(function(n) {
                return i.table.core.mutate({
                    trans: e,
                    type: "deleteRange",
                    range: r
                }).then(function(e) {
                    var t = e.failures, e = e.numFailures;
                    if (e) throw new fe("Could not delete some values", Object.keys(t).map(function(e) {
                        return t[e];
                    }), n - e);
                    return n - e;
                });
            });
        });
    };
    var qt = i;
    function i() {}
    var Dt = function(e, t) {
        return t.value = null;
    };
    function Bt(e, t) {
        return e < t ? -1 : e === t ? 0 : 1;
    }
    function Rt(e, t) {
        return t < e ? -1 : e === t ? 0 : 1;
    }
    function C(e, t, n) {
        e = e instanceof Lt ? new e.Collection(e) : e;
        return e._ctx.error = new (n || TypeError)(t), e;
    }
    function Ft(e) {
        return new e.Collection(e, function() {
            return Mt("");
        }).limit(0);
    }
    function Nt(e, s, n, r) {
        var i, c, l, f, h, d, p, y = n.length;
        if (!n.every(function(e) {
            return "string" == typeof e;
        })) return C(e, lt);
        function t(e) {
            i = "next" === e ? function(e) {
                return e.toUpperCase();
            } : function(e) {
                return e.toLowerCase();
            }, c = "next" === e ? function(e) {
                return e.toLowerCase();
            } : function(e) {
                return e.toUpperCase();
            }, l = "next" === e ? Bt : Rt;
            var t = n.map(function(e) {
                return {
                    lower: c(e),
                    upper: i(e)
                };
            }).sort(function(e, t) {
                return l(e.lower, t.lower);
            });
            f = t.map(function(e) {
                return e.upper;
            }), h = t.map(function(e) {
                return e.lower;
            }), p = "next" === (d = e) ? "" : r;
        }
        t("next");
        var e = new e.Collection(e, function() {
            return T(f[0], h[y - 1] + r);
        }), v = (e._ondirectionchange = function(e) {
            t(e);
        }, 0);
        return e._addAlgorithm(function(e, t, n) {
            var r = e.key;
            if ("string" == typeof r) {
                var i = c(r);
                if (s(i, h, v)) return !0;
                for(var o = null, a = v; a < y; ++a){
                    var u = ((e, t, n, r, i, o)=>{
                        for(var a = Math.min(e.length, r.length), u = -1, s = 0; s < a; ++s){
                            var c = t[s];
                            if (c !== r[s]) return i(e[s], n[s]) < 0 ? e.substr(0, s) + n[s] + n.substr(s + 1) : i(e[s], r[s]) < 0 ? e.substr(0, s) + r[s] + n.substr(s + 1) : 0 <= u ? e.substr(0, u) + t[u] + n.substr(u + 1) : null;
                            i(e[s], c) < 0 && (u = s);
                        }
                        return a < r.length && "next" === o ? e + n.substr(e.length) : a < e.length && "prev" === o ? e.substr(0, n.length) : u < 0 ? null : e.substr(0, u) + r[u] + n.substr(u + 1);
                    })(r, i, f[a], h[a], l, d);
                    null === u && null === o ? v = a + 1 : (null === o || 0 < l(o, u)) && (o = u);
                }
                t(null !== o ? function() {
                    e.continue(o + p);
                } : n);
            }
            return !1;
        }), e;
    }
    function T(e, t, n, r) {
        return {
            type: 2,
            lower: e,
            upper: t,
            lowerOpen: n,
            upperOpen: r
        };
    }
    function Mt(e) {
        return {
            type: 1,
            lower: e,
            upper: e
        };
    }
    Object.defineProperty(d.prototype, "Collection", {
        get: function() {
            return this._ctx.table.db.Collection;
        },
        enumerable: !1,
        configurable: !0
    }), d.prototype.between = function(e, t, n, r) {
        n = !1 !== n, r = !0 === r;
        try {
            return 0 < this._cmp(e, t) || 0 === this._cmp(e, t) && (n || r) && (!n || !r) ? Ft(this) : new this.Collection(this, function() {
                return T(e, t, !n, !r);
            });
        } catch (e) {
            return C(this, A);
        }
    }, d.prototype.equals = function(e) {
        return null == e ? C(this, A) : new this.Collection(this, function() {
            return Mt(e);
        });
    }, d.prototype.above = function(e) {
        return null == e ? C(this, A) : new this.Collection(this, function() {
            return T(e, void 0, !0);
        });
    }, d.prototype.aboveOrEqual = function(e) {
        return null == e ? C(this, A) : new this.Collection(this, function() {
            return T(e, void 0, !1);
        });
    }, d.prototype.below = function(e) {
        return null == e ? C(this, A) : new this.Collection(this, function() {
            return T(void 0, e, !1, !0);
        });
    }, d.prototype.belowOrEqual = function(e) {
        return null == e ? C(this, A) : new this.Collection(this, function() {
            return T(void 0, e);
        });
    }, d.prototype.startsWith = function(e) {
        return "string" != typeof e ? C(this, lt) : this.between(e, e + ct, !0, !0);
    }, d.prototype.startsWithIgnoreCase = function(e) {
        return "" === e ? this.startsWith(e) : Nt(this, function(e, t) {
            return 0 === e.indexOf(t[0]);
        }, [
            e
        ], ct);
    }, d.prototype.equalsIgnoreCase = function(e) {
        return Nt(this, function(e, t) {
            return e === t[0];
        }, [
            e
        ], "");
    }, d.prototype.anyOfIgnoreCase = function() {
        var e = n.apply(ae, arguments);
        return 0 === e.length ? Ft(this) : Nt(this, function(e, t) {
            return -1 !== t.indexOf(e);
        }, e, "");
    }, d.prototype.startsWithAnyOfIgnoreCase = function() {
        var e = n.apply(ae, arguments);
        return 0 === e.length ? Ft(this) : Nt(this, function(t, e) {
            return e.some(function(e) {
                return 0 === t.indexOf(e);
            });
        }, e, ct);
    }, d.prototype.anyOf = function() {
        var e, i, t = this, o = n.apply(ae, arguments), a = this._cmp;
        try {
            o.sort(a);
        } catch (e) {
            return C(this, A);
        }
        return 0 === o.length ? Ft(this) : ((e = new this.Collection(this, function() {
            return T(o[0], o[o.length - 1]);
        }))._ondirectionchange = function(e) {
            a = "next" === e ? t._ascending : t._descending, o.sort(a);
        }, i = 0, e._addAlgorithm(function(e, t, n) {
            for(var r = e.key; 0 < a(r, o[i]);)if (++i === o.length) return t(n), !1;
            return 0 === a(r, o[i]) || (t(function() {
                e.continue(o[i]);
            }), !1);
        }), e);
    }, d.prototype.notEqual = function(e) {
        return this.inAnyRange([
            [
                -1 / 0,
                e
            ],
            [
                e,
                this.db._maxKey
            ]
        ], {
            includeLowers: !1,
            includeUppers: !1
        });
    }, d.prototype.noneOf = function() {
        var e = n.apply(ae, arguments);
        if (0 === e.length) return new this.Collection(this);
        try {
            e.sort(this._ascending);
        } catch (e) {
            return C(this, A);
        }
        var t = e.reduce(function(e, t) {
            return e ? e.concat([
                [
                    e[e.length - 1][1],
                    t
                ]
            ]) : [
                [
                    -1 / 0,
                    t
                ]
            ];
        }, null);
        return t.push([
            e[e.length - 1],
            this.db._maxKey
        ]), this.inAnyRange(t, {
            includeLowers: !1,
            includeUppers: !1
        });
    }, d.prototype.inAnyRange = function(e, t) {
        var o = this, a = this._cmp, u = this._ascending, n = this._descending, s = this._min, c = this._max;
        if (0 === e.length) return Ft(this);
        if (!e.every(function(e) {
            return void 0 !== e[0] && void 0 !== e[1] && u(e[0], e[1]) <= 0;
        })) return C(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", k.InvalidArgument);
        var r = !t || !1 !== t.includeLowers, i = t && !0 === t.includeUppers;
        var l, f = u;
        function h(e, t) {
            return f(e[0], t[0]);
        }
        try {
            (l = e.reduce(function(e, t) {
                for(var n = 0, r = e.length; n < r; ++n){
                    var i = e[n];
                    if (a(t[0], i[1]) < 0 && 0 < a(t[1], i[0])) {
                        i[0] = s(i[0], t[0]), i[1] = c(i[1], t[1]);
                        break;
                    }
                }
                return n === r && e.push(t), e;
            }, [])).sort(h);
        } catch (e) {
            return C(this, A);
        }
        var d = 0, p = i ? function(e) {
            return 0 < u(e, l[d][1]);
        } : function(e) {
            return 0 <= u(e, l[d][1]);
        }, y = r ? function(e) {
            return 0 < n(e, l[d][0]);
        } : function(e) {
            return 0 <= n(e, l[d][0]);
        };
        var v = p, t = new this.Collection(this, function() {
            return T(l[0][0], l[l.length - 1][1], !r, !i);
        });
        return t._ondirectionchange = function(e) {
            f = "next" === e ? (v = p, u) : (v = y, n), l.sort(h);
        }, t._addAlgorithm(function(e, t, n) {
            for(var r, i = e.key; v(i);)if (++d === l.length) return t(n), !1;
            return !p(r = i) && !y(r) || (0 === o._cmp(i, l[d][1]) || 0 === o._cmp(i, l[d][0]) || t(function() {
                f === u ? e.continue(l[d][0]) : e.continue(l[d][1]);
            }), !1);
        }), t;
    }, d.prototype.startsWithAnyOf = function() {
        var e = n.apply(ae, arguments);
        return e.every(function(e) {
            return "string" == typeof e;
        }) ? 0 === e.length ? Ft(this) : this.inAnyRange(e.map(function(e) {
            return [
                e,
                e + ct
            ];
        })) : C(this, "startsWithAnyOf() only works with strings");
    };
    var Lt = d;
    function d() {}
    function I(t) {
        return E(function(e) {
            return Ut(e), t(e.target.error), !1;
        });
    }
    function Ut(e) {
        e.stopPropagation && e.stopPropagation(), e.preventDefault && e.preventDefault();
    }
    var zt = "storagemutated", Vt = "x-storagemutated-1", Wt = Pt(null, zt), Yt = (p.prototype._lock = function() {
        return $(!P.global), ++this._reculock, 1 !== this._reculock || P.global || (P.lockOwnerFor = this), this;
    }, p.prototype._unlock = function() {
        if ($(!P.global), 0 == --this._reculock) for(P.global || (P.lockOwnerFor = null); 0 < this._blockedFuncs.length && !this._locked();){
            var e = this._blockedFuncs.shift();
            try {
                at(e[1], e[0]);
            } catch (e) {}
        }
        return this;
    }, p.prototype._locked = function() {
        return this._reculock && P.lockOwnerFor !== this;
    }, p.prototype.create = function(t) {
        var n = this;
        if (this.mode) {
            var e = this.db.idbdb, r = this.db._state.dbOpenError;
            if ($(!this.idbtrans), !t && !e) switch(r && r.name){
                case "DatabaseClosedError":
                    throw new k.DatabaseClosed(r);
                case "MissingAPIError":
                    throw new k.MissingAPI(r.message, r);
                default:
                    throw new k.OpenFailed(r);
            }
            if (!this.active) throw new k.TransactionInactive;
            $(null === this._completion._state), (t = this.idbtrans = t || (this.db.core || e).transaction(this.storeNames, this.mode, {
                durability: this.chromeTransactionDurability
            })).onerror = E(function(e) {
                Ut(e), n._reject(t.error);
            }), t.onabort = E(function(e) {
                Ut(e), n.active && n._reject(new k.Abort(t.error)), n.active = !1, n.on("abort").fire(e);
            }), t.oncomplete = E(function() {
                n.active = !1, n._resolve(), "mutatedParts" in t && Wt.storagemutated.fire(t.mutatedParts);
            });
        }
        return this;
    }, p.prototype._promise = function(n, r, i) {
        var e, o = this;
        return "readwrite" === n && "readwrite" !== this.mode ? S(new k.ReadOnly("Transaction is readonly")) : this.active ? this._locked() ? new K(function(e, t) {
            o._blockedFuncs.push([
                function() {
                    o._promise(n, r, i).then(e, t);
                },
                P
            ]);
        }) : i ? v(function() {
            var e = new K(function(e, t) {
                o._lock();
                var n = r(e, t, o);
                n && n.then && n.then(e, t);
            });
            return e.finally(function() {
                return o._unlock();
            }), e._lib = !0, e;
        }) : ((e = new K(function(e, t) {
            var n = r(e, t, o);
            n && n.then && n.then(e, t);
        }))._lib = !0, e) : S(new k.TransactionInactive);
    }, p.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    }, p.prototype.waitFor = function(e) {
        var t, r = this._root(), i = K.resolve(e), o = (r._waitingFor ? r._waitingFor = r._waitingFor.then(function() {
            return i;
        }) : (r._waitingFor = i, r._waitingQueue = [], t = r.idbtrans.objectStore(r.storeNames[0]), function e() {
            for(++r._spinCount; r._waitingQueue.length;)r._waitingQueue.shift()();
            r._waitingFor && (t.get(-1 / 0).onsuccess = e);
        }()), r._waitingFor);
        return new K(function(t, n) {
            i.then(function(e) {
                return r._waitingQueue.push(E(t.bind(null, e)));
            }, function(e) {
                return r._waitingQueue.push(E(n.bind(null, e)));
            }).finally(function() {
                r._waitingFor === o && (r._waitingFor = null);
            });
        });
    }, p.prototype.abort = function() {
        this.active && (this.active = !1, this.idbtrans && this.idbtrans.abort(), this._reject(new k.Abort));
    }, p.prototype.table = function(e) {
        var t = this._memoizedTables || (this._memoizedTables = {});
        if (m(t, e)) return t[e];
        var n = this.schema[e];
        if (n) return (n = new this.db.Table(e, n, this)).core = this.db.core.table(e), t[e] = n;
        throw new k.NotFound("Table " + e + " not part of transaction");
    }, p);
    function p() {}
    function $t(e, t, n, r, i, o, a, u) {
        return {
            name: e,
            keyPath: t,
            unique: n,
            multi: r,
            auto: i,
            compound: o,
            src: (n && !a ? "&" : "") + (r ? "*" : "") + (i ? "++" : "") + Qt(t),
            type: u
        };
    }
    function Qt(e) {
        return "string" == typeof e ? e : e ? "[" + [].join.call(e, "+") + "]" : "";
    }
    function Gt(e, t, n) {
        var r;
        return {
            name: e,
            primKey: t,
            indexes: n,
            mappedClass: null,
            idxByName: (r = function(e) {
                return [
                    e.name,
                    e
                ];
            }, n.reduce(function(e, t, n) {
                t = r(t, n);
                return t && (e[t[0]] = t[1]), e;
            }, {}))
        };
    }
    var Xt = function(e) {
        try {
            return e.only([
                []
            ]), Xt = function() {
                return [
                    []
                ];
            }, [
                []
            ];
        } catch (e) {
            return Xt = function() {
                return ct;
            }, ct;
        }
    };
    function Ht(t) {
        var n;
        return null == t ? function() {} : "string" == typeof t ? 1 === (n = t).split(".").length ? function(e) {
            return e[n];
        } : function(e) {
            return c(e, n);
        } : function(e) {
            return c(e, t);
        };
    }
    function Jt(e) {
        return [].slice.call(e);
    }
    var Zt = 0;
    function en(e) {
        return null == e ? ":id" : "string" == typeof e ? e : "[".concat(e.join("+"), "]");
    }
    function tn(e, i, t) {
        function _(e) {
            if (3 === e.type) return null;
            if (4 === e.type) throw new Error("Cannot convert never type to IDBKeyRange");
            var t = e.lower, n = e.upper, r = e.lowerOpen, e = e.upperOpen;
            return void 0 === t ? void 0 === n ? null : i.upperBound(n, !!e) : void 0 === n ? i.lowerBound(t, !!r) : i.bound(t, n, !!r, !!e);
        }
        function n(e) {
            var p, y, w = e.name;
            return {
                name: w,
                schema: e,
                mutate: function(e) {
                    var y = e.trans, v = e.type, m = e.keys, b = e.values, g = e.range;
                    return new Promise(function(t, e) {
                        t = E(t);
                        var n = y.objectStore(w), r = null == n.keyPath, i = "put" === v || "add" === v;
                        if (!i && "delete" !== v && "deleteRange" !== v) throw new Error("Invalid operation type: " + v);
                        var o, a = (m || b || {
                            length: 1
                        }).length;
                        if (m && b && m.length !== b.length) throw new Error("Given keys array must have same length as given values array.");
                        if (0 === a) return t({
                            numFailures: 0,
                            failures: {},
                            results: [],
                            lastResult: void 0
                        });
                        function u(e) {
                            ++l, Ut(e);
                        }
                        var s = [], c = [], l = 0;
                        if ("deleteRange" === v) {
                            if (4 === g.type) return t({
                                numFailures: l,
                                failures: c,
                                results: [],
                                lastResult: void 0
                            });
                            3 === g.type ? s.push(o = n.clear()) : s.push(o = n.delete(_(g)));
                        } else {
                            var r = i ? r ? [
                                b,
                                m
                            ] : [
                                b,
                                null
                            ] : [
                                m,
                                null
                            ], f = r[0], h = r[1];
                            if (i) for(var d = 0; d < a; ++d)s.push(o = h && void 0 !== h[d] ? n[v](f[d], h[d]) : n[v](f[d])), o.onerror = u;
                            else for(d = 0; d < a; ++d)s.push(o = n[v](f[d])), o.onerror = u;
                        }
                        function p(e) {
                            e = e.target.result, s.forEach(function(e, t) {
                                return null != e.error && (c[t] = e.error);
                            }), t({
                                numFailures: l,
                                failures: c,
                                results: "delete" === v ? m : s.map(function(e) {
                                    return e.result;
                                }),
                                lastResult: e
                            });
                        }
                        o.onerror = function(e) {
                            u(e), p(e);
                        }, o.onsuccess = p;
                    });
                },
                getMany: function(e) {
                    var f = e.trans, h = e.keys;
                    return new Promise(function(t, e) {
                        t = E(t);
                        for(var n, r = f.objectStore(w), i = h.length, o = new Array(i), a = 0, u = 0, s = function(e) {
                            e = e.target;
                            o[e._pos] = e.result, ++u === a && t(o);
                        }, c = I(e), l = 0; l < i; ++l)null != h[l] && ((n = r.get(h[l]))._pos = l, n.onsuccess = s, n.onerror = c, ++a);
                        0 === a && t(o);
                    });
                },
                get: function(e) {
                    var r = e.trans, i = e.key;
                    return new Promise(function(t, e) {
                        t = E(t);
                        var n = r.objectStore(w).get(i);
                        n.onsuccess = function(e) {
                            return t(e.target.result);
                        }, n.onerror = I(e);
                    });
                },
                query: (p = a, y = u, function(d) {
                    return new Promise(function(t, e) {
                        t = E(t);
                        var n, r, i, o, a = d.trans, u = d.values, s = d.limit, c = d.query, l = null != (l = d.direction) ? l : "next", f = s === 1 / 0 ? void 0 : s, h = c.index, c = c.range, a = a.objectStore(w), a = h.isPrimaryKey ? a : a.index(h.name), h = _(c);
                        if (0 === s) return t({
                            result: []
                        });
                        y ? (c = {
                            query: h,
                            count: f,
                            direction: l
                        }, (n = u ? a.getAll(c) : a.getAllKeys(c)).onsuccess = function(e) {
                            return t({
                                result: e.target.result
                            });
                        }, n.onerror = I(e)) : p && "next" === l ? ((n = u ? a.getAll(h, f) : a.getAllKeys(h, f)).onsuccess = function(e) {
                            return t({
                                result: e.target.result
                            });
                        }, n.onerror = I(e)) : (r = 0, i = !u && "openKeyCursor" in a ? a.openKeyCursor(h, l) : a.openCursor(h, l), o = [], i.onsuccess = function() {
                            var e = i.result;
                            return !e || (o.push(u ? e.value : e.primaryKey), ++r === s) ? t({
                                result: o
                            }) : void e.continue();
                        }, i.onerror = I(e));
                    });
                }),
                openCursor: function(e) {
                    var c = e.trans, o = e.values, a = e.query, u = e.reverse, l = e.unique;
                    return new Promise(function(t, n) {
                        t = E(t);
                        var e = a.index, r = a.range, i = c.objectStore(w), i = e.isPrimaryKey ? i : i.index(e.name), e = u ? l ? "prevunique" : "prev" : l ? "nextunique" : "next", s = !o && "openKeyCursor" in i ? i.openKeyCursor(_(r), e) : i.openCursor(_(r), e);
                        s.onerror = I(n), s.onsuccess = E(function(e) {
                            var r, i, o, a, u = s.result;
                            u ? (u.___id = ++Zt, u.done = !1, r = u.continue.bind(u), i = (i = u.continuePrimaryKey) && i.bind(u), o = u.advance.bind(u), a = function() {
                                throw new Error("Cursor not stopped");
                            }, u.trans = c, u.stop = u.continue = u.continuePrimaryKey = u.advance = function() {
                                throw new Error("Cursor not started");
                            }, u.fail = E(n), u.next = function() {
                                var e = this, t = 1;
                                return this.start(function() {
                                    return t-- ? e.continue() : e.stop();
                                }).then(function() {
                                    return e;
                                });
                            }, u.start = function(e) {
                                function t() {
                                    if (s.result) try {
                                        e();
                                    } catch (e) {
                                        u.fail(e);
                                    }
                                    else u.done = !0, u.start = function() {
                                        throw new Error("Cursor behind last entry");
                                    }, u.stop();
                                }
                                var n = new Promise(function(t, e) {
                                    t = E(t), s.onerror = I(e), u.fail = e, u.stop = function(e) {
                                        u.stop = u.continue = u.continuePrimaryKey = u.advance = a, t(e);
                                    };
                                });
                                return s.onsuccess = E(function(e) {
                                    s.onsuccess = t, t();
                                }), u.continue = r, u.continuePrimaryKey = i, u.advance = o, t(), n;
                            }, t(u)) : t(null);
                        }, n);
                    });
                },
                count: function(e) {
                    var t = e.query, i = e.trans, o = t.index, a = t.range;
                    return new Promise(function(t, e) {
                        var n = i.objectStore(w), n = o.isPrimaryKey ? n : n.index(o.name), r = _(a), r = r ? n.count(r) : n.count();
                        r.onsuccess = E(function(e) {
                            return t(e.target.result);
                        }), r.onerror = I(e);
                    });
                }
            };
        }
        r = t, o = Jt((t = e).objectStoreNames), s = 0 < o.length ? r.objectStore(o[0]) : {};
        var r, t = {
            schema: {
                name: t.name,
                tables: o.map(function(e) {
                    return r.objectStore(e);
                }).map(function(t) {
                    var e = t.keyPath, n = t.autoIncrement, r = x(e), i = {}, r = {
                        name: t.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: !0,
                            outbound: null == e,
                            compound: r,
                            keyPath: e,
                            autoIncrement: n,
                            unique: !0,
                            extractKey: Ht(e)
                        },
                        indexes: Jt(t.indexNames).map(function(e) {
                            return t.index(e);
                        }).map(function(e) {
                            var t = e.name, n = e.unique, r = e.multiEntry, e = e.keyPath, t = {
                                name: t,
                                compound: x(e),
                                keyPath: e,
                                unique: n,
                                multiEntry: r,
                                extractKey: Ht(e)
                            };
                            return i[en(e)] = t;
                        }),
                        getIndexByKeyPath: function(e) {
                            return i[en(e)];
                        }
                    };
                    return i[":id"] = r.primaryKey, null != e && (i[en(e)] = r.primaryKey), r;
                })
            },
            hasGetAll: 0 < o.length && "getAll" in s && !("undefined" != typeof navigator && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604),
            hasIdb3Features: "getAllRecords" in s
        }, o = t.schema, a = t.hasGetAll, u = t.hasIdb3Features, s = o.tables.map(n), c = {};
        return s.forEach(function(e) {
            return c[e.name] = e;
        }), {
            stack: "dbcore",
            transaction: e.transaction.bind(e),
            table: function(e) {
                if (c[e]) return c[e];
                throw new Error("Table '".concat(e, "' not found"));
            },
            MIN_KEY: -1 / 0,
            MAX_KEY: Xt(i),
            schema: o
        };
    }
    function nn(e, t, n, r) {
        n = n.IDBKeyRange;
        return t = tn(t, n, r), {
            dbcore: e.dbcore.reduce(function(e, t) {
                t = t.create;
                return _(_({}, e), t(e));
            }, t)
        };
    }
    function rn(n, e) {
        var t = e.db, t = nn(n._middlewares, t, n._deps, e);
        n.core = t.dbcore, n.tables.forEach(function(e) {
            var t = e.name;
            n.core.schema.tables.some(function(e) {
                return e.name === t;
            }) && (e.core = n.core.table(t), n[t] instanceof n.Table) && (n[t].core = e.core);
        });
    }
    function on(i, e, t, o) {
        t.forEach(function(n) {
            var r = o[n];
            e.forEach(function(e) {
                var t = function e(t, n) {
                    return z(t, n) || (t = F(t)) && e(t, n);
                }(e, n);
                (!t || "value" in t && void 0 === t.value) && (e === i.Transaction.prototype || e instanceof i.Transaction ? u(e, n, {
                    get: function() {
                        return this.table(n);
                    },
                    set: function(e) {
                        L(this, n, {
                            value: e,
                            writable: !0,
                            configurable: !0,
                            enumerable: !0
                        });
                    }
                }) : e[n] = new i.Table(n, r));
            });
        });
    }
    function an(n, e) {
        e.forEach(function(e) {
            for(var t in e)e[t] instanceof n.Table && delete e[t];
        });
    }
    function un(e, t) {
        return e._cfg.version - t._cfg.version;
    }
    function sn(n, r, i, e) {
        var o = n._dbSchema, a = (i.objectStoreNames.contains("$meta") && !o.$meta && (o.$meta = Gt("$meta", vn("")[0], []), n._storeNames.push("$meta")), n._createTransaction("readwrite", n._storeNames, o)), u = (a.create(i), a._completion.catch(e), a._reject.bind(a)), s = P.transless || P;
        v(function() {
            if (P.trans = a, P.transless = s, 0 !== r) return rn(n, i), t = r, ((e = a).storeNames.includes("$meta") ? e.table("$meta").get("version").then(function(e) {
                return null != e ? e : t;
            }) : K.resolve(t)).then(function(e) {
                var s = n, c = e, l = a, f = i, t = [], e = s._versions, h = s._dbSchema = pn(0, s.idbdb, f);
                return 0 === (e = e.filter(function(e) {
                    return e._cfg.version >= c;
                })).length ? K.resolve() : (e.forEach(function(u) {
                    t.push(function() {
                        var t, n, r, i = h, e = u._cfg.dbschema, o = (yn(s, i, f), yn(s, e, f), h = s._dbSchema = e, ln(i, e)), a = (o.add.forEach(function(e) {
                            fn(f, e[0], e[1].primKey, e[1].indexes);
                        }), o.change.forEach(function(e) {
                            if (e.recreate) throw new k.Upgrade("Not yet support for changing primary key");
                            var t = f.objectStore(e.name);
                            e.add.forEach(function(e) {
                                return dn(t, e);
                            }), e.change.forEach(function(e) {
                                t.deleteIndex(e.name), dn(t, e);
                            }), e.del.forEach(function(e) {
                                return t.deleteIndex(e);
                            });
                        }), u._cfg.contentUpgrade);
                        if (a && u._cfg.version > c) return rn(s, f), l._memoizedTables = {}, t = G(e), o.del.forEach(function(e) {
                            t[e] = i[e];
                        }), an(s, [
                            s.Transaction.prototype
                        ]), on(s, [
                            s.Transaction.prototype
                        ], O(t), t), l.schema = t, (n = ue(a)) && nt(), e = K.follow(function() {
                            var e;
                            (r = a(l)) && n && (e = w.bind(null, null), r.then(e, e));
                        }), r && "function" == typeof r.then ? K.resolve(r) : e.then(function() {
                            return r;
                        });
                    }), t.push(function(e) {
                        var t, n, r = u._cfg.dbschema;
                        t = r, n = e, [].slice.call(n.db.objectStoreNames).forEach(function(e) {
                            return null == t[e] && n.db.deleteObjectStore(e);
                        }), an(s, [
                            s.Transaction.prototype
                        ]), on(s, [
                            s.Transaction.prototype
                        ], s._storeNames, s._dbSchema), l.schema = s._dbSchema;
                    }), t.push(function(e) {
                        s.idbdb.objectStoreNames.contains("$meta") && (Math.ceil(s.idbdb.version / 10) === u._cfg.version ? (s.idbdb.deleteObjectStore("$meta"), delete s._dbSchema.$meta, s._storeNames = s._storeNames.filter(function(e) {
                            return "$meta" !== e;
                        })) : e.objectStore("$meta").put(u._cfg.version, "version"));
                    });
                }), (function e() {
                    return t.length ? K.resolve(t.shift()(l.idbtrans)).then(e) : K.resolve();
                })().then(function() {
                    hn(h, f);
                }));
            }).catch(u);
            var e, t;
            O(o).forEach(function(e) {
                fn(i, e, o[e].primKey, o[e].indexes);
            }), rn(n, i), K.follow(function() {
                return n.on.populate.fire(a);
            }).catch(u);
        });
    }
    function cn(e, r) {
        hn(e._dbSchema, r), r.db.version % 10 != 0 || r.objectStoreNames.contains("$meta") || r.db.createObjectStore("$meta").add(Math.ceil(r.db.version / 10 - 1), "version");
        var t = pn(0, e.idbdb, r);
        yn(e, e._dbSchema, r);
        for(var n = 0, i = ln(t, e._dbSchema).change; n < i.length; n++){
            var o = ((t)=>{
                if (t.change.length || t.recreate) return console.warn("Unable to patch indexes of table ".concat(t.name, " because it has changes on the type of index or primary key.")), {
                    value: void 0
                };
                var n = r.objectStore(t.name);
                t.add.forEach(function(e) {
                    l && console.debug("Dexie upgrade patch: Creating missing index ".concat(t.name, ".").concat(e.src)), dn(n, e);
                });
            })(i[n]);
            if ("object" == typeof o) return o.value;
        }
    }
    function ln(e, t) {
        var n, r = {
            del: [],
            add: [],
            change: []
        };
        for(n in e)t[n] || r.del.push(n);
        for(n in t){
            var i = e[n], o = t[n];
            if (i) {
                var a = {
                    name: n,
                    def: o,
                    recreate: !1,
                    del: [],
                    add: [],
                    change: []
                };
                if ("" + (i.primKey.keyPath || "") != "" + (o.primKey.keyPath || "") || i.primKey.auto !== o.primKey.auto) a.recreate = !0, r.change.push(a);
                else {
                    var u = i.idxByName, s = o.idxByName, c = void 0;
                    for(c in u)s[c] || a.del.push(c);
                    for(c in s){
                        var l = u[c], f = s[c];
                        l ? l.src !== f.src && a.change.push(f) : a.add.push(f);
                    }
                    (0 < a.del.length || 0 < a.add.length || 0 < a.change.length) && r.change.push(a);
                }
            } else r.add.push([
                n,
                o
            ]);
        }
        return r;
    }
    function fn(e, t, n, r) {
        var i = e.db.createObjectStore(t, n.keyPath ? {
            keyPath: n.keyPath,
            autoIncrement: n.auto
        } : {
            autoIncrement: n.auto
        });
        r.forEach(function(e) {
            return dn(i, e);
        });
    }
    function hn(t, n) {
        O(t).forEach(function(e) {
            n.db.objectStoreNames.contains(e) || (l && console.debug("Dexie: Creating missing table", e), fn(n, e, t[e].primKey, t[e].indexes));
        });
    }
    function dn(e, t) {
        e.createIndex(t.name, t.keyPath, {
            unique: t.unique,
            multiEntry: t.multi
        });
    }
    function pn(e, t, u) {
        var s = {};
        return W(t.objectStoreNames, 0).forEach(function(e) {
            for(var t = u.objectStore(e), n = $t(Qt(a = t.keyPath), a || "", !0, !1, !!t.autoIncrement, a && "string" != typeof a, !0), r = [], i = 0; i < t.indexNames.length; ++i){
                var o = t.index(t.indexNames[i]), a = o.keyPath, o = $t(o.name, a, !!o.unique, !!o.multiEntry, !1, a && "string" != typeof a, !1);
                r.push(o);
            }
            s[e] = Gt(e, n, r);
        }), s;
    }
    function yn(e, t, n) {
        for(var r = n.db.objectStoreNames, i = 0; i < r.length; ++i){
            var o = r[i], a = n.objectStore(o);
            e._hasGetAll = "getAll" in a;
            for(var u = 0; u < a.indexNames.length; ++u){
                var s, c = a.indexNames[u], l = a.index(c).keyPath, l = "string" == typeof l ? l : "[" + W(l).join("+") + "]";
                t[o] && (s = t[o].idxByName[l]) && (s.name = c, delete t[o].idxByName[l], t[o].idxByName[c] = s);
            }
        }
        "undefined" != typeof navigator && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && f.WorkerGlobalScope && f instanceof f.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604 && (e._hasGetAll = !1);
    }
    function vn(e) {
        return e.split(",").map(function(e, t) {
            var n = e.split(":"), r = null == (r = n[1]) ? void 0 : r.trim(), n = (e = n[0].trim()).replace(/([&*]|\+\+)/g, ""), i = /^\[/.test(n) ? n.match(/^\[(.*)\]$/)[1].split("+") : n;
            return $t(n, i || null, /\&/.test(e), /\*/.test(e), /\+\+/.test(e), x(i), 0 === t, r);
        });
    }
    bn.prototype._createTableSchema = Gt, bn.prototype._parseIndexSyntax = vn, bn.prototype._parseStoresSpec = function(r, i) {
        var o = this;
        O(r).forEach(function(e) {
            if (null !== r[e]) {
                var t = o._parseIndexSyntax(r[e]), n = t.shift();
                if (!n) throw new k.Schema("Invalid schema for table " + e + ": " + r[e]);
                if (n.unique = !0, n.multi) throw new k.Schema("Primary key cannot be multiEntry*");
                t.forEach(function(e) {
                    if (e.auto) throw new k.Schema("Only primary key can be marked as autoIncrement (++)");
                    if (!e.keyPath) throw new k.Schema("Index must have a name and cannot be an empty string");
                });
                n = o._createTableSchema(e, n, t);
                i[e] = n;
            }
        });
    }, bn.prototype.stores = function(e) {
        var t = this.db, e = (this._cfg.storesSource = this._cfg.storesSource ? a(this._cfg.storesSource, e) : e, t._versions), n = {}, r = {};
        return e.forEach(function(e) {
            a(n, e._cfg.storesSource), r = e._cfg.dbschema = {}, e._parseStoresSpec(n, r);
        }), t._dbSchema = r, an(t, [
            t._allTables,
            t,
            t.Transaction.prototype
        ]), on(t, [
            t._allTables,
            t,
            t.Transaction.prototype,
            this._cfg.tables
        ], O(r), r), t._storeNames = O(r), this;
    }, bn.prototype.upgrade = function(e) {
        return this._cfg.contentUpgrade = ke(this._cfg.contentUpgrade || g, e), this;
    };
    var mn = bn;
    function bn() {}
    var gn = (()=>{
        var i, o, t;
        return "undefined" != typeof FinalizationRegistry && "undefined" != typeof WeakRef ? (i = new Set, o = new FinalizationRegistry(function(e) {
            i.delete(e);
        }), {
            toArray: function() {
                return Array.from(i).map(function(e) {
                    return e.deref();
                }).filter(function(e) {
                    return void 0 !== e;
                });
            },
            add: function(e) {
                var t = new WeakRef(e._novip);
                i.add(t), o.register(e._novip, t, t), i.size > e._options.maxConnections && (t = i.values().next().value, i.delete(t), o.unregister(t));
            },
            remove: function(e) {
                if (e) for(var t = i.values(), n = t.next(); !n.done;){
                    var r = n.value;
                    if (r.deref() === e._novip) return i.delete(r), void o.unregister(r);
                    n = t.next();
                }
            }
        }) : (t = [], {
            toArray: function() {
                return t;
            },
            add: function(e) {
                t.push(e._novip);
            },
            remove: function(e) {
                e && -1 !== (e = t.indexOf(e._novip)) && t.splice(e, 1);
            }
        });
    })();
    function wn(e, t) {
        var n = e._dbNamesDB;
        return n || (n = e._dbNamesDB = new y(ft, {
            addons: [],
            indexedDB: e,
            IDBKeyRange: t
        })).version(1).stores({
            dbnames: "name"
        }), n.table("dbnames");
    }
    function _n(e) {
        return e && "function" == typeof e.databases;
    }
    function xn(e) {
        return v(function() {
            return P.letThrough = !0, e();
        });
    }
    function kn(e) {
        return !("from" in e);
    }
    var q = function(e, t) {
        var n;
        if (!this) return n = new q, e && "d" in e && a(n, e), n;
        a(this, arguments.length ? {
            d: 1,
            from: e,
            to: 1 < arguments.length ? t : e
        } : {
            d: 0
        });
    };
    function On(e, t, n) {
        var r = j(t, n);
        if (!isNaN(r)) {
            if (0 < r) throw RangeError();
            if (kn(e)) return a(e, {
                from: t,
                to: n,
                d: 1
            });
            var r = e.l, i = e.r;
            if (j(n, e.from) < 0) return r ? On(r, t, n) : e.l = {
                from: t,
                to: n,
                d: 1,
                l: null,
                r: null
            }, Sn(e);
            if (0 < j(t, e.to)) return i ? On(i, t, n) : e.r = {
                from: t,
                to: n,
                d: 1,
                l: null,
                r: null
            }, Sn(e);
            j(t, e.from) < 0 && (e.from = t, e.l = null, e.d = i ? i.d + 1 : 1), 0 < j(n, e.to) && (e.to = n, e.r = null, e.d = e.l ? e.l.d + 1 : 1);
            t = !e.r;
            r && !e.l && Pn(e, r), i && t && Pn(e, i);
        }
    }
    function Pn(e, t) {
        kn(t) || function e(t, n) {
            var r = n.from, i = n.l, o = n.r;
            On(t, r, n.to), i && e(t, i), o && e(t, o);
        }(e, t);
    }
    function Kn(e, t) {
        var n = En(t), r = n.next();
        if (!r.done) for(var i = r.value, o = En(e), a = o.next(i.from), u = a.value; !r.done && !a.done;){
            if (j(u.from, i.to) <= 0 && 0 <= j(u.to, i.from)) return !0;
            j(i.from, u.from) < 0 ? i = (r = n.next(u.from)).value : u = (a = o.next(i.from)).value;
        }
        return !1;
    }
    function En(e) {
        var n = kn(e) ? null : {
            s: 0,
            n: e
        };
        return {
            next: function(e) {
                for(var t = 0 < arguments.length; n;)switch(n.s){
                    case 0:
                        if (n.s = 1, t) for(; n.n.l && j(e, n.n.from) < 0;)n = {
                            up: n,
                            n: n.n.l,
                            s: 1
                        };
                        else for(; n.n.l;)n = {
                            up: n,
                            n: n.n.l,
                            s: 1
                        };
                    case 1:
                        if (n.s = 2, !t || j(e, n.n.to) <= 0) return {
                            value: n.n,
                            done: !1
                        };
                    case 2:
                        if (n.n.r) {
                            n.s = 3, n = {
                                up: n,
                                n: n.n.r,
                                s: 0
                            };
                            continue;
                        }
                    case 3:
                        n = n.up;
                }
                return {
                    done: !0
                };
            }
        };
    }
    function Sn(e) {
        var t, n, r, i = ((null == (i = e.r) ? void 0 : i.d) || 0) - ((null == (i = e.l) ? void 0 : i.d) || 0), i = 1 < i ? "r" : i < -1 ? "l" : "";
        i && (t = "r" == i ? "l" : "r", n = _({}, e), r = e[i], e.from = r.from, e.to = r.to, e[i] = r[i], n[i] = r[t], (e[t] = n).d = An(n)), e.d = An(e);
    }
    function An(e) {
        var t = e.r, e = e.l;
        return (t ? e ? Math.max(t.d, e.d) : t.d : e ? e.d : 0) + 1;
    }
    function jn(t, n) {
        return O(n).forEach(function(e) {
            t[e] ? Pn(t[e], n[e]) : t[e] = function e(t) {
                var n, r, i = {};
                for(n in t)m(t, n) && (r = t[n], i[n] = !r || "object" != typeof r || J.has(r.constructor) ? r : e(r));
                return i;
            }(n[e]);
        }), t;
    }
    function Cn(t, n) {
        return t.all || n.all || Object.keys(t).some(function(e) {
            return n[e] && Kn(n[e], t[e]);
        });
    }
    M(q.prototype, ((t = {
        add: function(e) {
            return Pn(this, e), this;
        },
        addKey: function(e) {
            return On(this, e, e), this;
        },
        addKeys: function(e) {
            var t = this;
            return e.forEach(function(e) {
                return On(t, e, e);
            }), this;
        },
        hasKey: function(e) {
            var t = En(this).next(e).value;
            return t && j(t.from, e) <= 0 && 0 <= j(t.to, e);
        }
    })[re] = function() {
        return En(this);
    }, t));
    var Tn = {}, In = {}, qn = !1;
    function Dn(e) {
        jn(In, e), qn || (qn = !0, setTimeout(function() {
            qn = !1, Bn(In, (In = {}, false));
        }, 0));
    }
    function Bn(e, t) {
        void 0 === t && (t = !1);
        var n = new Set;
        if (e.all) for(var r = 0, i = Object.values(Tn); r < i.length; r++)Rn(u = i[r], e, n, t);
        else for(var o in e){
            var a, u, o = /^idb\:\/\/(.*)\/(.*)\//.exec(o);
            o && (a = o[1], o = o[2], u = Tn["idb://".concat(a, "/").concat(o)]) && Rn(u, e, n, t);
        }
        n.forEach(function(e) {
            return e();
        });
    }
    function Rn(e, t, n, r) {
        for(var i = [], o = 0, a = Object.entries(e.queries.query); o < a.length; o++){
            for(var u = a[o], s = u[0], c = [], l = 0, f = u[1]; l < f.length; l++){
                var h = f[l];
                Cn(t, h.obsSet) ? h.subscribers.forEach(function(e) {
                    return n.add(e);
                }) : r && c.push(h);
            }
            r && i.push([
                s,
                c
            ]);
        }
        if (r) for(var d = 0, p = i; d < p.length; d++){
            var y = p[d], s = y[0], c = y[1];
            e.queries.query[s] = c;
        }
    }
    function Fn(h) {
        var d = h._state, r = h._deps.indexedDB;
        if (d.isBeingOpened || h.idbdb) return d.dbReadyPromise.then(function() {
            return d.dbOpenError ? S(d.dbOpenError) : h;
        });
        d.isBeingOpened = !0, d.dbOpenError = null, d.openComplete = !1;
        var t = d.openCanceller, p = Math.round(10 * h.verno), y = !1;
        function e() {
            if (d.openCanceller !== t) throw new k.DatabaseClosed("db.open() was cancelled");
        }
        function v() {
            return new K(function(c, n) {
                if (e(), !r) throw new k.MissingAPI;
                var l = h.name, f = d.autoSchema || !p ? r.open(l) : r.open(l, p);
                if (!f) throw new k.MissingAPI;
                f.onerror = I(n), f.onblocked = E(h._fireOnBlocked), f.onupgradeneeded = E(function(e) {
                    var t;
                    m = f.transaction, d.autoSchema && !h._options.allowEmptyDB ? (f.onerror = Ut, m.abort(), f.result.close(), (t = r.deleteDatabase(l)).onsuccess = t.onerror = E(function() {
                        n(new k.NoSuchDatabase("Database ".concat(l, " doesnt exist")));
                    })) : (m.onerror = I(n), t = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion, b = t < 1, h.idbdb = f.result, y && cn(h, m), sn(h, t / 10, m, n));
                }, n), f.onsuccess = E(function() {
                    m = null;
                    var e, t, n, r, i, o, a = h.idbdb = f.result, u = W(a.objectStoreNames);
                    if (0 < u.length) try {
                        var s = a.transaction(1 === (i = u).length ? i[0] : i, "readonly");
                        if (d.autoSchema) o = a, r = s, (n = h).verno = o.version / 10, r = n._dbSchema = pn(0, o, r), n._storeNames = W(o.objectStoreNames, 0), on(n, [
                            n._allTables
                        ], O(r), r);
                        else if (yn(h, h._dbSchema, s), t = s, ((t = ln(pn(0, (e = h).idbdb, t), e._dbSchema)).add.length || t.change.some(function(e) {
                            return e.add.length || e.change.length;
                        })) && !y) return console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Dexie will add missing parts and increment native version number to workaround this."), a.close(), p = a.version + 1, y = !0, c(v());
                        rn(h, s);
                    } catch (e) {}
                    gn.add(h), a.onversionchange = E(function(e) {
                        d.vcFired = !0, h.on("versionchange").fire(e);
                    }), a.onclose = E(function() {
                        h.close({
                            disableAutoOpen: !1
                        });
                    }), b && (u = h._deps, i = l, _n(o = u.indexedDB) || i === ft || wn(o, u.IDBKeyRange).put({
                        name: i
                    }).catch(g)), c();
                }, n);
            }).catch(function(e) {
                switch(null == e ? void 0 : e.name){
                    case "UnknownError":
                        if (0 < d.PR1398_maxLoop) return d.PR1398_maxLoop--, console.warn("Dexie: Workaround for Chrome UnknownError on open()"), v();
                        break;
                    case "VersionError":
                        if (0 < p) return p = 0, v();
                }
                return K.reject(e);
            });
        }
        var n, i = d.dbReadyResolve, m = null, b = !1;
        return K.race([
            t,
            ("undefined" == typeof navigator ? K.resolve() : !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent) && indexedDB.databases ? new Promise(function(e) {
                function t() {
                    return indexedDB.databases().finally(e);
                }
                n = setInterval(t, 100), t();
            }).finally(function() {
                return clearInterval(n);
            }) : Promise.resolve()).then(v)
        ]).then(function() {
            return e(), d.onReadyBeingFired = [], K.resolve(xn(function() {
                return h.on.ready.fire(h.vip);
            })).then(function e() {
                var t;
                if (0 < d.onReadyBeingFired.length) return t = d.onReadyBeingFired.reduce(ke, g), d.onReadyBeingFired = [], K.resolve(xn(function() {
                    return t(h.vip);
                })).then(e);
            });
        }).finally(function() {
            d.openCanceller === t && (d.onReadyBeingFired = null, d.isBeingOpened = !1);
        }).catch(function(e) {
            d.dbOpenError = e;
            try {
                m && m.abort();
            } catch (e) {}
            return t === d.openCanceller && h._close(), S(e);
        }).finally(function() {
            d.openComplete = !0, i();
        }).then(function() {
            var n;
            return b && (n = {}, h.tables.forEach(function(t) {
                t.schema.indexes.forEach(function(e) {
                    e.name && (n["idb://".concat(h.name, "/").concat(t.name, "/").concat(e.name)] = new q(-1 / 0, [
                        [
                            []
                        ]
                    ]));
                }), n["idb://".concat(h.name, "/").concat(t.name, "/")] = n["idb://".concat(h.name, "/").concat(t.name, "/:dels")] = new q(-1 / 0, [
                    [
                        []
                    ]
                ]);
            }), Wt(zt).fire(n), Bn(n, !0)), h;
        });
    }
    function Nn(t) {
        function e(e) {
            return t.next(e);
        }
        var r = n(e), i = n(function(e) {
            return t.throw(e);
        });
        function n(n) {
            return function(e) {
                var e = n(e), t = e.value;
                return e.done ? t : t && "function" == typeof t.then ? t.then(r, i) : x(t) ? Promise.all(t).then(r, i) : r(t);
            };
        }
        return n(e)();
    }
    function Mn(e, t, n) {
        for(var r = x(e) ? e.slice() : [
            e
        ], i = 0; i < n; ++i)r.push(t);
        return r;
    }
    var Ln = {
        stack: "dbcore",
        name: "VirtualIndexMiddleware",
        level: 1,
        create: function(l) {
            return _(_({}, l), {
                table: function(e) {
                    var o = l.table(e), e = o.schema, u = Object.create(null), s = [];
                    function c(e, t, n) {
                        var r = en(e), i = u[r] = u[r] || [], o = null == e ? 0 : "string" == typeof e ? 1 : e.length, a = 0 < t, r = _(_({}, n), {
                            name: a ? "".concat(r, "(virtual-from:").concat(n.name, ")") : n.name,
                            lowLevelIndex: n,
                            isVirtual: a,
                            keyTail: t,
                            keyLength: o,
                            extractKey: Ht(e),
                            unique: !a && n.unique
                        });
                        return i.push(r), r.isPrimaryKey || s.push(r), 1 < o && c(2 === o ? e[0] : e.slice(0, o - 1), t + 1, n), i.sort(function(e, t) {
                            return e.keyTail - t.keyTail;
                        }), r;
                    }
                    var t = c(e.primaryKey.keyPath, 0, e.primaryKey);
                    u[":id"] = [
                        t
                    ];
                    for(var n = 0, r = e.indexes; n < r.length; n++){
                        var i = r[n];
                        c(i.keyPath, 0, i);
                    }
                    function a(e) {
                        var t, n = e.query.index;
                        return n.isVirtual ? _(_({}, e), {
                            query: {
                                index: n.lowLevelIndex,
                                range: (t = e.query.range, n = n.keyTail, {
                                    type: 1 === t.type ? 2 : t.type,
                                    lower: Mn(t.lower, t.lowerOpen ? l.MAX_KEY : l.MIN_KEY, n),
                                    lowerOpen: !0,
                                    upper: Mn(t.upper, t.upperOpen ? l.MIN_KEY : l.MAX_KEY, n),
                                    upperOpen: !0
                                })
                            }
                        }) : e;
                    }
                    return _(_({}, o), {
                        schema: _(_({}, e), {
                            primaryKey: t,
                            indexes: s,
                            getIndexByKeyPath: function(e) {
                                return (e = u[en(e)]) && e[0];
                            }
                        }),
                        count: function(e) {
                            return o.count(a(e));
                        },
                        query: function(e) {
                            return o.query(a(e));
                        },
                        openCursor: function(t) {
                            var e = t.query.index, r = e.keyTail, i = e.keyLength;
                            return e.isVirtual ? o.openCursor(a(t)).then(function(e) {
                                return e && n(e);
                            }) : o.openCursor(t);
                            function n(n) {
                                return Object.create(n, {
                                    continue: {
                                        value: function(e) {
                                            null != e ? n.continue(Mn(e, t.reverse ? l.MAX_KEY : l.MIN_KEY, r)) : t.unique ? n.continue(n.key.slice(0, i).concat(t.reverse ? l.MIN_KEY : l.MAX_KEY, r)) : n.continue();
                                        }
                                    },
                                    continuePrimaryKey: {
                                        value: function(e, t) {
                                            n.continuePrimaryKey(Mn(e, l.MAX_KEY, r), t);
                                        }
                                    },
                                    primaryKey: {
                                        get: function() {
                                            return n.primaryKey;
                                        }
                                    },
                                    key: {
                                        get: function() {
                                            var e = n.key;
                                            return 1 === i ? e[0] : e.slice(0, i);
                                        }
                                    },
                                    value: {
                                        get: function() {
                                            return n.value;
                                        }
                                    }
                                });
                            }
                        }
                    });
                }
            });
        }
    };
    function Un(i, o, a, u) {
        return a = a || {}, u = u || "", O(i).forEach(function(e) {
            var t, n, r;
            m(o, e) ? (t = i[e], n = o[e], "object" == typeof t && "object" == typeof n && t && n ? (r = ne(t)) !== ne(n) ? a[u + e] = o[e] : "Object" === r ? Un(t, n, a, u + e + ".") : t !== n && (a[u + e] = o[e]) : t !== n && (a[u + e] = o[e])) : a[u + e] = void 0;
        }), O(o).forEach(function(e) {
            m(i, e) || (a[u + e] = o[e]);
        }), a;
    }
    function zn(e, t) {
        return "delete" === t.type ? t.keys : t.keys || t.values.map(e.extractKey);
    }
    var Vn = {
        stack: "dbcore",
        name: "HooksMiddleware",
        level: 2,
        create: function(e) {
            return _(_({}, e), {
                table: function(r) {
                    var y = e.table(r), v = y.schema.primaryKey;
                    return _(_({}, y), {
                        mutate: function(e) {
                            var t = P.trans, n = t.table(r).hook, h = n.deleting, d = n.creating, p = n.updating;
                            switch(e.type){
                                case "add":
                                    if (d.fire === g) break;
                                    return t._promise("readwrite", function() {
                                        return a(e);
                                    }, !0);
                                case "put":
                                    if (d.fire === g && p.fire === g) break;
                                    return t._promise("readwrite", function() {
                                        return a(e);
                                    }, !0);
                                case "delete":
                                    if (h.fire === g) break;
                                    return t._promise("readwrite", function() {
                                        return a(e);
                                    }, !0);
                                case "deleteRange":
                                    if (h.fire === g) break;
                                    return t._promise("readwrite", function() {
                                        return function n(r, i, o) {
                                            return y.query({
                                                trans: r,
                                                values: !1,
                                                query: {
                                                    index: v,
                                                    range: i
                                                },
                                                limit: o
                                            }).then(function(e) {
                                                var t = e.result;
                                                return a({
                                                    type: "delete",
                                                    keys: t,
                                                    trans: r
                                                }).then(function(e) {
                                                    return 0 < e.numFailures ? Promise.reject(e.failures[0]) : t.length < o ? {
                                                        failures: [],
                                                        numFailures: 0,
                                                        lastResult: void 0
                                                    } : n(r, _(_({}, i), {
                                                        lower: t[t.length - 1],
                                                        lowerOpen: !0
                                                    }), o);
                                                });
                                            });
                                        }(e.trans, e.range, 1e4);
                                    }, !0);
                            }
                            return y.mutate(e);
                            function a(c) {
                                var e, t, n, l = P.trans, f = c.keys || zn(v, c);
                                if (f) return "delete" !== (c = "add" === c.type || "put" === c.type ? _(_({}, c), {
                                    keys: f
                                }) : _({}, c)).type && (c.values = R([], c.values, !0)), c.keys && (c.keys = R([], c.keys, !0)), e = y, n = f, ("add" === (t = c).type ? Promise.resolve([]) : e.getMany({
                                    trans: t.trans,
                                    keys: n,
                                    cache: "immutable"
                                })).then(function(u) {
                                    var s = f.map(function(e, t) {
                                        var n, r, i, o = u[t], a = {
                                            onerror: null,
                                            onsuccess: null
                                        };
                                        return "delete" === c.type ? h.fire.call(a, e, o, l) : "add" === c.type || void 0 === o ? (n = d.fire.call(a, e, c.values[t], l), null == e && null != n && (c.keys[t] = e = n, v.outbound || b(c.values[t], v.keyPath, e))) : (n = Un(o, c.values[t]), (r = p.fire.call(a, n, e, o, l)) && (i = c.values[t], Object.keys(r).forEach(function(e) {
                                            m(i, e) ? i[e] = r[e] : b(i, e, r[e]);
                                        }))), a;
                                    });
                                    return y.mutate(c).then(function(e) {
                                        for(var t = e.failures, n = e.results, r = e.numFailures, e = e.lastResult, i = 0; i < f.length; ++i){
                                            var o = (n || f)[i], a = s[i];
                                            null == o ? a.onerror && a.onerror(t[i]) : a.onsuccess && a.onsuccess("put" === c.type && u[i] ? c.values[i] : o);
                                        }
                                        return {
                                            failures: t,
                                            results: n,
                                            numFailures: r,
                                            lastResult: e
                                        };
                                    }).catch(function(t) {
                                        return s.forEach(function(e) {
                                            return e.onerror && e.onerror(t);
                                        }), Promise.reject(t);
                                    });
                                });
                                throw new Error("Keys missing");
                            }
                        }
                    });
                }
            });
        }
    };
    function Wn(e, t, n) {
        try {
            if (!t) return null;
            if (t.keys.length < e.length) return null;
            for(var r = [], i = 0, o = 0; i < t.keys.length && o < e.length; ++i)0 === j(t.keys[i], e[o]) && (r.push(n ? ee(t.values[i]) : t.values[i]), ++o);
            return r.length === e.length ? r : null;
        } catch (e) {
            return null;
        }
    }
    var Yn = {
        stack: "dbcore",
        level: -1,
        create: function(t) {
            return {
                table: function(e) {
                    var n = t.table(e);
                    return _(_({}, n), {
                        getMany: function(t) {
                            var e;
                            return t.cache ? (e = Wn(t.keys, t.trans._cache, "clone" === t.cache)) ? K.resolve(e) : n.getMany(t).then(function(e) {
                                return t.trans._cache = {
                                    keys: t.keys,
                                    values: "clone" === t.cache ? ee(e) : e
                                }, e;
                            }) : n.getMany(t);
                        },
                        mutate: function(e) {
                            return "add" !== e.type && (e.trans._cache = null), n.mutate(e);
                        }
                    });
                }
            };
        }
    };
    function $n(e, t) {
        return "readonly" === e.trans.mode && !!e.subscr && !e.trans.explicit && "disabled" !== e.trans.db._options.cache && !t.schema.primaryKey.outbound;
    }
    function Qn(e, t) {
        switch(e){
            case "query":
                return t.values && !t.unique;
            case "get":
            case "getMany":
            case "count":
            case "openCursor":
                return !1;
        }
    }
    var Gn = {
        stack: "dbcore",
        level: 0,
        name: "Observability",
        create: function(b) {
            var g = b.schema.name, w = new q(b.MIN_KEY, b.MAX_KEY);
            return _(_({}, b), {
                transaction: function(e, t, n) {
                    if (P.subscr && "readonly" !== t) throw new k.ReadOnly("Readwrite transaction in liveQuery context. Querier source: ".concat(P.querier));
                    return b.transaction(e, t, n);
                },
                table: function(d) {
                    function e(e) {
                        var t, e = e.query;
                        return [
                            t = e.index,
                            new q(null != (t = (e = e.range).lower) ? t : b.MIN_KEY, null != (t = e.upper) ? t : b.MAX_KEY)
                        ];
                    }
                    var p = b.table(d), y = p.schema, v = y.primaryKey, t = y.indexes, c = v.extractKey, l = v.outbound, m = v.autoIncrement && t.filter(function(e) {
                        return e.compound && e.keyPath.includes(v.keyPath);
                    }), n = _(_({}, p), {
                        mutate: function(a) {
                            function u(e) {
                                return e = "idb://".concat(g, "/").concat(d, "/").concat(e), n[e] || (n[e] = new q);
                            }
                            var e, o, s, t = a.trans, n = a.mutatedParts || (a.mutatedParts = {}), r = u(""), i = u(":dels"), c = a.type, l = "deleteRange" === a.type ? [
                                a.range
                            ] : "delete" === a.type ? [
                                a.keys
                            ] : a.values.length < 50 ? [
                                zn(v, a).filter(function(e) {
                                    return e;
                                }),
                                a.values
                            ] : [], f = l[0], l = l[1], h = a.trans._cache;
                            return x(f) ? (r.addKeys(f), (c = "delete" === c || f.length === l.length ? Wn(f, h) : null) || i.addKeys(f), (c || l) && (e = u, o = c, s = l, y.indexes.forEach(function(t) {
                                var n = e(t.name || "");
                                function r(e) {
                                    return null != e ? t.extractKey(e) : null;
                                }
                                function i(e) {
                                    t.multiEntry && x(e) ? e.forEach(function(e) {
                                        return n.addKey(e);
                                    }) : n.addKey(e);
                                }
                                (o || s).forEach(function(e, t) {
                                    var n = o && r(o[t]), t = s && r(s[t]);
                                    0 !== j(n, t) && (null != n && i(n), null != t) && i(t);
                                });
                            }))) : f ? (l = {
                                from: null != (h = f.lower) ? h : b.MIN_KEY,
                                to: null != (c = f.upper) ? c : b.MAX_KEY
                            }, i.add(l), r.add(l)) : (r.add(w), i.add(w), y.indexes.forEach(function(e) {
                                return u(e.name).add(w);
                            })), p.mutate(a).then(function(o) {
                                return !f || "add" !== a.type && "put" !== a.type || (r.addKeys(o.results), m && m.forEach(function(t) {
                                    for(var e = a.values.map(function(e) {
                                        return t.extractKey(e);
                                    }), n = t.keyPath.findIndex(function(e) {
                                        return e === v.keyPath;
                                    }), r = 0, i = o.results.length; r < i; ++r)e[r][n] = o.results[r];
                                    u(t.name).addKeys(e);
                                })), t.mutatedParts = jn(t.mutatedParts || {}, n), o;
                            });
                        }
                    }), f = {
                        get: function(e) {
                            return [
                                v,
                                new q(e.key)
                            ];
                        },
                        getMany: function(e) {
                            return [
                                v,
                                (new q).addKeys(e.keys)
                            ];
                        },
                        count: e,
                        query: e,
                        openCursor: e
                    };
                    return O(f).forEach(function(s) {
                        n[s] = function(i) {
                            var e = P.subscr, t = !!e, n = $n(P, p) && Qn(s, i) ? i.obsSet = {} : e;
                            if (t) {
                                var o, e = function(e) {
                                    e = "idb://".concat(g, "/").concat(d, "/").concat(e);
                                    return n[e] || (n[e] = new q);
                                }, a = e(""), u = e(":dels"), t = f[s](i), r = t[0], t = t[1];
                                if (("query" === s && r.isPrimaryKey && !i.values ? u : e(r.name || "")).add(t), !r.isPrimaryKey) {
                                    if ("count" !== s) return o = "query" === s && l && i.values && p.query(_(_({}, i), {
                                        values: !1
                                    })), p[s].apply(this, arguments).then(function(t) {
                                        if ("query" === s) {
                                            if (l && i.values) return o.then(function(e) {
                                                e = e.result;
                                                return a.addKeys(e), t;
                                            });
                                            var e = i.values ? t.result.map(c) : t.result;
                                            (i.values ? a : u).addKeys(e);
                                        } else {
                                            var n, r;
                                            if ("openCursor" === s) return r = i.values, (n = t) && Object.create(n, {
                                                key: {
                                                    get: function() {
                                                        return u.addKey(n.primaryKey), n.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function() {
                                                        var e = n.primaryKey;
                                                        return u.addKey(e), e;
                                                    }
                                                },
                                                value: {
                                                    get: function() {
                                                        return r && a.addKey(n.primaryKey), n.value;
                                                    }
                                                }
                                            });
                                        }
                                        return t;
                                    });
                                    u.add(w);
                                }
                            }
                            return p[s].apply(this, arguments);
                        };
                    }), n;
                }
            });
        }
    };
    function Xn(e, t, n) {
        var r;
        return 0 === n.numFailures ? t : "deleteRange" === t.type || (r = t.keys ? t.keys.length : "values" in t && t.values ? t.values.length : 1, n.numFailures === r) ? null : (r = _({}, t), x(r.keys) && (r.keys = r.keys.filter(function(e, t) {
            return !(t in n.failures);
        })), "values" in r && x(r.values) && (r.values = r.values.filter(function(e, t) {
            return !(t in n.failures);
        })), r);
    }
    function Hn(e, t) {
        var n, r;
        return n = e, (void 0 === (r = t).lower || (r.lowerOpen ? 0 < j(n, r.lower) : 0 <= j(n, r.lower))) && (n = e, void 0 === (r = t).upper || (r.upperOpen ? j(n, r.upper) < 0 : j(n, r.upper) <= 0));
    }
    function Jn(e, d, t, n, r, i) {
        var o, p, y, v, m, a, u;
        return !t || 0 === t.length || (o = d.query.index, p = o.multiEntry, y = d.query.range, v = n.schema.primaryKey.extractKey, m = o.extractKey, a = (o.lowLevelIndex || o).extractKey, (n = t.reduce(function(e, t) {
            var n = e, r = [];
            if ("add" === t.type || "put" === t.type) for(var i = new q, o = t.values.length - 1; 0 <= o; --o){
                var a, u = t.values[o], s = v(u);
                !i.hasKey(s) && (a = m(u), p && x(a) ? a.some(function(e) {
                    return Hn(e, y);
                }) : Hn(a, y)) && (i.addKey(s), r.push(u));
            }
            switch(t.type){
                case "add":
                    var c = (new q).addKeys(d.values ? e.map(function(e) {
                        return v(e);
                    }) : e), n = e.concat(d.values ? r.filter(function(e) {
                        e = v(e);
                        return !c.hasKey(e) && (c.addKey(e), !0);
                    }) : r.map(function(e) {
                        return v(e);
                    }).filter(function(e) {
                        return !c.hasKey(e) && (c.addKey(e), !0);
                    }));
                    break;
                case "put":
                    var l = (new q).addKeys(t.values.map(function(e) {
                        return v(e);
                    }));
                    n = e.filter(function(e) {
                        return !l.hasKey(d.values ? v(e) : e);
                    }).concat(d.values ? r : r.map(function(e) {
                        return v(e);
                    }));
                    break;
                case "delete":
                    var f = (new q).addKeys(t.keys);
                    n = e.filter(function(e) {
                        return !f.hasKey(d.values ? v(e) : e);
                    });
                    break;
                case "deleteRange":
                    var h = t.range;
                    n = e.filter(function(e) {
                        return !Hn(v(e), h);
                    });
            }
            return n;
        }, e)) === e) ? e : (u = function(e, t) {
            return j(a(e), a(t)) || j(v(e), v(t));
        }, n.sort("prev" === d.direction || "prevunique" === d.direction ? function(e, t) {
            return u(t, e);
        } : u), d.limit && d.limit < 1 / 0 && (n.length > d.limit ? n.length = d.limit : e.length === d.limit && n.length < d.limit && (r.dirty = !0)), i ? Object.freeze(n) : n);
    }
    function Zn(e, t) {
        return 0 === j(e.lower, t.lower) && 0 === j(e.upper, t.upper) && !!e.lowerOpen == !!t.lowerOpen && !!e.upperOpen == !!t.upperOpen;
    }
    function er(e, t) {
        return ((e, t, n, r)=>{
            if (void 0 === e) return void 0 !== t ? -1 : 0;
            if (void 0 === t) return 1;
            if (0 === (e = j(e, t))) {
                if (n && r) return 0;
                if (n) return 1;
                if (r) return -1;
            }
            return e;
        })(e.lower, t.lower, e.lowerOpen, t.lowerOpen) <= 0 && 0 <= ((e, t, n, r)=>{
            if (void 0 === e) return void 0 !== t ? 1 : 0;
            if (void 0 === t) return -1;
            if (0 === (e = j(e, t))) {
                if (n && r) return 0;
                if (n) return -1;
                if (r) return 1;
            }
            return e;
        })(e.upper, t.upper, e.upperOpen, t.upperOpen);
    }
    function tr(n, r, i, e) {
        n.subscribers.add(i), e.addEventListener("abort", function() {
            var e, t;
            n.subscribers.delete(i), 0 === n.subscribers.size && (e = n, t = r, setTimeout(function() {
                0 === e.subscribers.size && oe(t, e);
            }, 3e3));
        });
    }
    var nr = {
        stack: "dbcore",
        level: 0,
        name: "Cache",
        create: function(k) {
            var O = k.schema.name;
            return _(_({}, k), {
                transaction: function(g, w, e) {
                    var _, t, x = k.transaction(g, w, e);
                    return "readwrite" === w && (e = (_ = new AbortController).signal, x.addEventListener("abort", (t = function(b) {
                        return function() {
                            if (_.abort(), "readwrite" === w) {
                                for(var t = new Set, e = 0, n = g; e < n.length; e++){
                                    var r = n[e], i = Tn["idb://".concat(O, "/").concat(r)];
                                    if (i) {
                                        var o = k.table(r), a = i.optimisticOps.filter(function(e) {
                                            return e.trans === x;
                                        });
                                        if (x._explicit && b && x.mutatedParts) for(var u = 0, s = Object.values(i.queries.query); u < s.length; u++)for(var c = 0, l = (d = s[u]).slice(); c < l.length; c++)Cn((p = l[c]).obsSet, x.mutatedParts) && (oe(d, p), p.subscribers.forEach(function(e) {
                                            return t.add(e);
                                        }));
                                        else if (0 < a.length) {
                                            i.optimisticOps = i.optimisticOps.filter(function(e) {
                                                return e.trans !== x;
                                            });
                                            for(var f = 0, h = Object.values(i.queries.query); f < h.length; f++)for(var d, p, y, v = 0, m = (d = h[f]).slice(); v < m.length; v++)null != (p = m[v]).res && x.mutatedParts && (b && !p.dirty ? (y = Object.isFrozen(p.res), y = Jn(p.res, p.req, a, o, p, y), p.dirty ? (oe(d, p), p.subscribers.forEach(function(e) {
                                                return t.add(e);
                                            })) : y !== p.res && (p.res = y, p.promise = K.resolve({
                                                result: y
                                            }))) : (p.dirty && oe(d, p), p.subscribers.forEach(function(e) {
                                                return t.add(e);
                                            })));
                                        }
                                    }
                                }
                                t.forEach(function(e) {
                                    return e();
                                });
                            }
                        };
                    })(!1), {
                        signal: e
                    }), x.addEventListener("error", t(!1), {
                        signal: e
                    }), x.addEventListener("complete", t(!0), {
                        signal: e
                    })), x;
                },
                table: function(s) {
                    var c = k.table(s), i = c.schema.primaryKey;
                    return _(_({}, c), {
                        mutate: function(t) {
                            var n, e = P.trans;
                            return !i.outbound && "disabled" !== e.db._options.cache && !e.explicit && "readwrite" === e.idbtrans.mode && (n = Tn["idb://".concat(O, "/").concat(s)]) ? (e = c.mutate(t), "add" !== t.type && "put" !== t.type || !(50 <= t.values.length || zn(i, t).some(function(e) {
                                return null == e;
                            })) ? (n.optimisticOps.push(t), t.mutatedParts && Dn(t.mutatedParts), e.then(function(e) {
                                0 < e.numFailures && (oe(n.optimisticOps, t), (e = Xn(0, t, e)) && n.optimisticOps.push(e), t.mutatedParts) && Dn(t.mutatedParts);
                            }), e.catch(function() {
                                oe(n.optimisticOps, t), t.mutatedParts && Dn(t.mutatedParts);
                            })) : e.then(function(r) {
                                var e = Xn(0, _(_({}, t), {
                                    values: t.values.map(function(e, t) {
                                        var n;
                                        return r.failures[t] ? e : (b(n = null != (n = i.keyPath) && n.includes(".") ? ee(e) : _({}, e), i.keyPath, r.results[t]), n);
                                    })
                                }), r);
                                n.optimisticOps.push(e), queueMicrotask(function() {
                                    return t.mutatedParts && Dn(t.mutatedParts);
                                });
                            }), e) : c.mutate(t);
                        },
                        query: function(t) {
                            var i, e, n, r, o, a, u;
                            return $n(P, c) && Qn("query", t) ? (i = "immutable" === (null == (n = P.trans) ? void 0 : n.db._options.cache), e = (n = P).requery, n = n.signal, a = ((e, t, n, r)=>{
                                var i = Tn["idb://".concat(e, "/").concat(t)];
                                if (!i) return [];
                                if (!(e = i.queries[n])) return [
                                    null,
                                    !1,
                                    i,
                                    null
                                ];
                                var o = e[(r.query ? r.query.index.name : null) || ""];
                                if (!o) return [
                                    null,
                                    !1,
                                    i,
                                    null
                                ];
                                switch(n){
                                    case "query":
                                        var a = null != (u = r.direction) ? u : "next", u = o.find(function(e) {
                                            var t;
                                            return e.req.limit === r.limit && e.req.values === r.values && (null != (t = e.req.direction) ? t : "next") === a && Zn(e.req.query.range, r.query.range);
                                        });
                                        return u ? [
                                            u,
                                            !0,
                                            i,
                                            o
                                        ] : [
                                            o.find(function(e) {
                                                var t;
                                                return ("limit" in e.req ? e.req.limit : 1 / 0) >= r.limit && (null != (t = e.req.direction) ? t : "next") === a && (!r.values || e.req.values) && er(e.req.query.range, r.query.range);
                                            }),
                                            !1,
                                            i,
                                            o
                                        ];
                                    case "count":
                                        u = o.find(function(e) {
                                            return Zn(e.req.query.range, r.query.range);
                                        });
                                        return [
                                            u,
                                            !!u,
                                            i,
                                            o
                                        ];
                                }
                            })(O, s, "query", t), u = a[0], r = a[2], o = a[3], u && a[1] ? u.obsSet = t.obsSet : (a = c.query(t).then(function(e) {
                                var t = e.result;
                                if (u && (u.res = t), i) {
                                    for(var n = 0, r = t.length; n < r; ++n)Object.freeze(t[n]);
                                    Object.freeze(t);
                                }
                                return e;
                            }).catch(function(e) {
                                return o && u && oe(o, u), Promise.reject(e);
                            }), u = {
                                obsSet: t.obsSet,
                                promise: a,
                                subscribers: new Set,
                                type: "query",
                                req: t,
                                dirty: !1
                            }, o ? o.push(u) : (o = [
                                u
                            ], (r = r || (Tn["idb://".concat(O, "/").concat(s)] = {
                                queries: {
                                    query: {},
                                    count: {}
                                },
                                objs: new Map,
                                optimisticOps: [],
                                unsignaledParts: {}
                            })).queries.query[t.query.index.name || ""] = o)), tr(u, o, e, n), u.promise.then(function(e) {
                                e = Jn(e.result, t, null == r ? void 0 : r.optimisticOps, c, u, i);
                                return {
                                    result: i ? e : ee(e)
                                };
                            })) : c.query(t);
                        }
                    });
                }
            });
        }
    };
    function rr(e, r) {
        return new Proxy(e, {
            get: function(e, t, n) {
                return "db" === t ? r : Reflect.get(e, t, n);
            }
        });
    }
    D.prototype.version = function(t) {
        if (isNaN(t) || t < .1) throw new k.Type("Given version is not a positive number");
        if (t = Math.round(10 * t) / 10, this.idbdb || this._state.isBeingOpened) throw new k.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, t);
        var e = this._versions, n = e.filter(function(e) {
            return e._cfg.version === t;
        })[0];
        return n || (n = new this.Version(t), e.push(n), e.sort(un), n.stores({}), this._state.autoSchema = !1), n;
    }, D.prototype._whenReady = function(e) {
        var n = this;
        return this.idbdb && (this._state.openComplete || P.letThrough || this._vip) ? e() : new K(function(e, t) {
            if (n._state.openComplete) return t(new k.DatabaseClosed(n._state.dbOpenError));
            if (!n._state.isBeingOpened) {
                if (!n._state.autoOpen) return void t(new k.DatabaseClosed);
                n.open().catch(g);
            }
            n._state.dbReadyPromise.then(e, t);
        }).then(e);
    }, D.prototype.use = function(e) {
        var t = e.stack, n = e.create, r = e.level, e = e.name, i = (e && this.unuse({
            stack: t,
            name: e
        }), this._middlewares[t] || (this._middlewares[t] = []));
        return i.push({
            stack: t,
            create: n,
            level: null == r ? 10 : r,
            name: e
        }), i.sort(function(e, t) {
            return e.level - t.level;
        }), this;
    }, D.prototype.unuse = function(e) {
        var t = e.stack, n = e.name, r = e.create;
        return t && this._middlewares[t] && (this._middlewares[t] = this._middlewares[t].filter(function(e) {
            return r ? e.create !== r : !!n && e.name !== n;
        })), this;
    }, D.prototype.open = function() {
        var e = this;
        return at(s, function() {
            return Fn(e);
        });
    }, D.prototype._close = function() {
        this.on.close.fire(new CustomEvent("close"));
        var n = this._state;
        if (gn.remove(this), this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this.idbdb = null;
        }
        n.isBeingOpened || (n.dbReadyPromise = new K(function(e) {
            n.dbReadyResolve = e;
        }), n.openCanceller = new K(function(e, t) {
            n.cancelOpen = t;
        }));
    }, D.prototype.close = function(e) {
        var e = (void 0 === e ? {
            disableAutoOpen: !0
        } : e).disableAutoOpen, t = this._state;
        e ? (t.isBeingOpened && t.cancelOpen(new k.DatabaseClosed), this._close(), t.autoOpen = !1, t.dbOpenError = new k.DatabaseClosed) : (this._close(), t.autoOpen = this._options.autoOpen || t.isBeingOpened, t.openComplete = !1, t.dbOpenError = null);
    }, D.prototype.delete = function(n) {
        var i = this, o = (void 0 === n && (n = {
            disableAutoOpen: !0
        }), 0 < arguments.length && "object" != typeof arguments[0]), a = this._state;
        return new K(function(r, t) {
            function e() {
                i.close(n);
                var e = i._deps.indexedDB.deleteDatabase(i.name);
                e.onsuccess = E(function() {
                    var e, t, n;
                    e = i._deps, t = i.name, _n(n = e.indexedDB) || t === ft || wn(n, e.IDBKeyRange).delete(t).catch(g), r();
                }), e.onerror = I(t), e.onblocked = i._fireOnBlocked;
            }
            if (o) throw new k.InvalidArgument("Invalid closeOptions argument to db.delete()");
            a.isBeingOpened ? a.dbReadyPromise.then(e) : e();
        });
    }, D.prototype.backendDB = function() {
        return this.idbdb;
    }, D.prototype.isOpen = function() {
        return null !== this.idbdb;
    }, D.prototype.hasBeenClosed = function() {
        var e = this._state.dbOpenError;
        return e && "DatabaseClosed" === e.name;
    }, D.prototype.hasFailed = function() {
        return null !== this._state.dbOpenError;
    }, D.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    }, Object.defineProperty(D.prototype, "tables", {
        get: function() {
            var t = this;
            return O(this._allTables).map(function(e) {
                return t._allTables[e];
            });
        },
        enumerable: !1,
        configurable: !0
    }), D.prototype.transaction = function() {
        var e = (function(e, t, n) {
            var r = arguments.length;
            if (r < 2) throw new k.InvalidArgument("Too few arguments");
            for(var i = new Array(r - 1); --r;)i[r - 1] = arguments[r];
            return n = i.pop(), [
                e,
                H(i),
                n
            ];
        }).apply(this, arguments);
        return this._transaction.apply(this, e);
    }, D.prototype._transaction = function(e, t, n) {
        var r, i, o = this, a = P.trans, u = (a && a.db === this && -1 === e.indexOf("!") || (a = null), -1 !== e.indexOf("?"));
        e = e.replace("!", "").replace("?", "");
        try {
            if (i = t.map(function(e) {
                e = e instanceof o.Table ? e.name : e;
                if ("string" != typeof e) throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return e;
            }), "r" == e || e === ht) r = ht;
            else {
                if ("rw" != e && e != dt) throw new k.InvalidArgument("Invalid transaction mode: " + e);
                r = dt;
            }
            if (a) {
                if (a.mode === ht && r === dt) {
                    if (!u) throw new k.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                    a = null;
                }
                a && i.forEach(function(e) {
                    if (a && -1 === a.storeNames.indexOf(e)) {
                        if (!u) throw new k.SubTransaction("Table " + e + " not included in parent transaction.");
                        a = null;
                    }
                }), u && a && !a.active && (a = null);
            }
        } catch (n) {
            return a ? a._promise(null, function(e, t) {
                t(n);
            }) : S(n);
        }
        var s = (function i(o, a, u, s, c) {
            return K.resolve().then(function() {
                var e = P.transless || P, t = o._createTransaction(a, u, o._dbSchema, s), e = (t.explicit = !0, {
                    trans: t,
                    transless: e
                });
                if (s) t.idbtrans = s.idbtrans;
                else try {
                    t.create(), t.idbtrans._explicit = !0, o._state.PR1398_maxLoop = 3;
                } catch (e) {
                    return e.name === de.InvalidState && o.isOpen() && 0 < --o._state.PR1398_maxLoop ? (console.warn("Dexie: Need to reopen db"), o.close({
                        disableAutoOpen: !1
                    }), o.open().then(function() {
                        return i(o, a, u, null, c);
                    })) : S(e);
                }
                var n, r = ue(c), e = (r && nt(), K.follow(function() {
                    var e;
                    (n = c.call(t, t)) && (r ? (e = w.bind(null, null), n.then(e, e)) : "function" == typeof n.next && "function" == typeof n.throw && (n = Nn(n)));
                }, e));
                return (n && "function" == typeof n.then ? K.resolve(n).then(function(e) {
                    return t.active ? e : S(new k.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
                }) : e.then(function() {
                    return n;
                })).then(function(e) {
                    return s && t._resolve(), t._completion.then(function() {
                        return e;
                    });
                }).catch(function(e) {
                    return t._reject(e), S(e);
                });
            });
        }).bind(null, this, r, i, a, n);
        return a ? a._promise(r, s, "lock") : P.trans ? at(P.transless, function() {
            return o._whenReady(s);
        }) : this._whenReady(s);
    }, D.prototype.table = function(e) {
        if (m(this._allTables, e)) return this._allTables[e];
        throw new k.InvalidTable("Table ".concat(e, " does not exist"));
    };
    var y = D;
    function D(e, t) {
        var o, r, a, n, i, u = this, s = (this._middlewares = {}, this.verno = 0, D.dependencies), s = (this._options = t = _({
            addons: D.addons,
            autoOpen: !0,
            indexedDB: s.indexedDB,
            IDBKeyRange: s.IDBKeyRange,
            cache: "cloned",
            maxConnections: 1e3
        }, t), this._deps = {
            indexedDB: t.indexedDB,
            IDBKeyRange: t.IDBKeyRange
        }, t.addons), c = (this._dbSchema = {}, this._versions = [], this._storeNames = [], this._allTables = {}, this.idbdb = null, this._novip = this, {
            dbOpenError: null,
            isBeingOpened: !1,
            onReadyBeingFired: null,
            openComplete: !1,
            dbReadyResolve: g,
            dbReadyPromise: null,
            cancelOpen: g,
            openCanceller: null,
            autoSchema: !0,
            PR1398_maxLoop: 3,
            autoOpen: t.autoOpen
        }), l = (c.dbReadyPromise = new K(function(e) {
            c.dbReadyResolve = e;
        }), c.openCanceller = new K(function(e, t) {
            c.cancelOpen = t;
        }), this._state = c, this.name = e, this.on = Pt(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                ke,
                g
            ]
        }), this.once = function(n, r) {
            var i = function() {
                for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                u.on(n).unsubscribe(i), r.apply(u, e);
            };
            return u.on(n, i);
        }, this.on.ready.subscribe = Y(this.on.ready.subscribe, function(i) {
            return function(n, r) {
                D.vip(function() {
                    var t, e = u._state;
                    e.openComplete ? (e.dbOpenError || K.resolve().then(n), r && i(n)) : e.onReadyBeingFired ? (e.onReadyBeingFired.push(n), r && i(n)) : (i(n), t = u, r || i(function e() {
                        t.on.ready.unsubscribe(n), t.on.ready.unsubscribe(e);
                    }));
                });
            };
        }), this.Collection = (o = this, Kt(qt.prototype, function(e, t) {
            this.db = o;
            var n = yt, r = null;
            if (t) try {
                n = t();
            } catch (e) {
                r = e;
            }
            var t = e._ctx, e = t.table, i = e.hook.reading.fire;
            this._ctx = {
                table: e,
                index: t.index,
                isPrimKey: !t.index || e.schema.primKey.keyPath && t.index === e.schema.primKey.name,
                range: n,
                keysOnly: !1,
                dir: "next",
                unique: "",
                algorithm: null,
                filter: null,
                replayFilter: null,
                justLimit: !0,
                isMatch: null,
                offset: 0,
                limit: 1 / 0,
                error: r,
                or: t.or,
                valueMapper: i !== ve ? i : null
            };
        })), this.Table = (r = this, Kt(Ot.prototype, function(e, t, n) {
            this.db = r, this._tx = n, this.name = e, this.schema = t, this.hook = r._allTables[e] ? r._allTables[e].hook : Pt(null, {
                creating: [
                    ge,
                    g
                ],
                reading: [
                    me,
                    ve
                ],
                updating: [
                    _e,
                    g
                ],
                deleting: [
                    we,
                    g
                ]
            });
        })), this.Transaction = (a = this, Kt(Yt.prototype, function(e, t, n, r, i) {
            var o = this;
            "readonly" !== e && t.forEach(function(e) {
                e = null == (e = n[e]) ? void 0 : e.yProps;
                e && (t = t.concat(e.map(function(e) {
                    return e.updatesTable;
                })));
            }), this.db = a, this.mode = e, this.storeNames = t, this.schema = n, this.chromeTransactionDurability = r, this.idbtrans = null, this.on = Pt(this, "complete", "error", "abort"), this.parent = i || null, this.active = !0, this._reculock = 0, this._blockedFuncs = [], this._resolve = null, this._reject = null, this._waitingFor = null, this._waitingQueue = null, this._spinCount = 0, this._completion = new K(function(e, t) {
                o._resolve = e, o._reject = t;
            }), this._completion.then(function() {
                o.active = !1, o.on.complete.fire();
            }, function(e) {
                var t = o.active;
                return o.active = !1, o.on.error.fire(e), o.parent ? o.parent._reject(e) : t && o.idbtrans && o.idbtrans.abort(), S(e);
            });
        })), this.Version = (n = this, Kt(mn.prototype, function(e) {
            this.db = n, this._cfg = {
                version: e,
                storesSource: null,
                dbschema: {},
                tables: {},
                contentUpgrade: null
            };
        })), this.WhereClause = (i = this, Kt(Lt.prototype, function(e, t, n) {
            if (this.db = i, this._ctx = {
                table: e,
                index: ":id" === t ? null : t,
                or: n
            }, this._cmp = this._ascending = j, this._descending = function(e, t) {
                return j(t, e);
            }, this._max = function(e, t) {
                return 0 < j(e, t) ? e : t;
            }, this._min = function(e, t) {
                return j(e, t) < 0 ? e : t;
            }, this._IDBKeyRange = i._deps.IDBKeyRange, !this._IDBKeyRange) throw new k.MissingAPI;
        })), this.on("versionchange", function(e) {
            0 < e.newVersion ? console.warn("Another connection wants to upgrade database '".concat(u.name, "'. Closing db now to resume the upgrade.")) : console.warn("Another connection wants to delete database '".concat(u.name, "'. Closing db now to resume the delete request.")), u.close({
                disableAutoOpen: !1
            });
        }), this.on("blocked", function(e) {
            !e.newVersion || e.newVersion < e.oldVersion ? console.warn("Dexie.delete('".concat(u.name, "') was blocked")) : console.warn("Upgrade '".concat(u.name, "' blocked by other connection holding version ").concat(e.oldVersion / 10));
        }), this._maxKey = Xt(t.IDBKeyRange), this._createTransaction = function(e, t, n, r) {
            return new u.Transaction(e, t, n, u._options.chromeTransactionDurability, r);
        }, this._fireOnBlocked = function(t) {
            u.on("blocked").fire(t), gn.toArray().filter(function(e) {
                return e.name === u.name && e !== u && !e._state.vcFired;
            }).map(function(e) {
                return e.on("versionchange").fire(t);
            });
        }, this.use(Yn), this.use(nr), this.use(Gn), this.use(Ln), this.use(Vn), new Proxy(this, {
            get: function(e, t, n) {
                var r;
                return "_vip" === t || ("table" === t ? function(e) {
                    return rr(u.table(e), l);
                } : (r = Reflect.get(e, t, n)) instanceof Ot ? rr(r, l) : "tables" === t ? r.map(function(e) {
                    return rr(e, l);
                }) : "_createTransaction" === t ? function() {
                    return rr(r.apply(this, arguments), l);
                } : r);
            }
        }));
        this.vip = l, s.forEach(function(e) {
            return e(u);
        });
    }
    var ir, Se = "undefined" != typeof Symbol && "observable" in Symbol ? Symbol.observable : "@@observable", or = (ar.prototype.subscribe = function(e, t, n) {
        return this._subscribe(e && "function" != typeof e ? e : {
            next: e,
            error: t,
            complete: n
        });
    }, ar.prototype[Se] = function() {
        return this;
    }, ar);
    function ar(e) {
        this._subscribe = e;
    }
    try {
        ir = {
            indexedDB: f.indexedDB || f.mozIndexedDB || f.webkitIndexedDB || f.msIndexedDB,
            IDBKeyRange: f.IDBKeyRange || f.webkitIDBKeyRange
        };
    } catch (e) {
        ir = {
            indexedDB: null,
            IDBKeyRange: null
        };
    }
    function ur(d) {
        var p, y = !1, e = new or(function(r) {
            var i = ue(d);
            var o, a = !1, u = {}, s = {}, e = {
                get closed () {
                    return a;
                },
                unsubscribe: function() {
                    a || (a = !0, o && o.abort(), c && Wt.storagemutated.unsubscribe(h));
                }
            }, c = (r.start && r.start(e), !1), l = function() {
                return st(t);
            };
            function f() {
                return Cn(s, u);
            }
            var h = function(e) {
                jn(u, e), f() && l();
            }, t = function() {
                var t, n, e;
                !a && ir.indexedDB && (u = {}, t = {}, o && o.abort(), o = new AbortController, e = ((e)=>{
                    var t = $e();
                    try {
                        i && nt();
                        var n = v(d, e);
                        return n = i ? n.finally(w) : n;
                    } finally{
                        t && Qe();
                    }
                })(n = {
                    subscr: t,
                    signal: o.signal,
                    requery: l,
                    querier: d,
                    trans: null
                }), c || (Wt.storagemutated.subscribe(h), c = !0), Promise.resolve(e).then(function(e) {
                    y = !0, p = e, a || n.signal.aborted || (f() || (s = t, f()) ? l() : (u = {}, st(function() {
                        return !a && r.next && r.next(e);
                    })));
                }, function(e) {
                    y = !1, [
                        "DatabaseClosedError",
                        "AbortError"
                    ].includes(null == e ? void 0 : e.name) || a || st(function() {
                        a || r.error && r.error(e);
                    });
                }));
            };
            return setTimeout(l, 0), e;
        });
        return e.hasValue = function() {
            return y;
        }, e.getValue = function() {
            return p;
        }, e;
    }
    var sr = y;
    function cr(e) {
        var t = fr;
        try {
            fr = !0, Wt.storagemutated.fire(e), Bn(e, !0);
        } finally{
            fr = t;
        }
    }
    M(sr, _(_({}, e), {
        delete: function(e) {
            return new sr(e, {
                addons: []
            }).delete();
        },
        exists: function(e) {
            return new sr(e, {
                addons: []
            }).open().then(function(e) {
                return e.close(), !0;
            }).catch("NoSuchDatabaseError", function() {
                return !1;
            });
        },
        getDatabaseNames: function(e) {
            try {
                return t = sr.dependencies, n = t.indexedDB, t = t.IDBKeyRange, (_n(n) ? Promise.resolve(n.databases()).then(function(e) {
                    return e.map(function(e) {
                        return e.name;
                    }).filter(function(e) {
                        return e !== ft;
                    });
                }) : wn(n, t).toCollection().primaryKeys()).then(e);
            } catch (e) {
                return S(new k.MissingAPI);
            }
            var t, n;
        },
        defineClass: function() {
            return function(e) {
                a(this, e);
            };
        },
        ignoreTransaction: function(e) {
            return P.trans ? at(P.transless || s, e) : e();
        },
        vip: xn,
        async: function(t) {
            return function() {
                try {
                    var e = Nn(t.apply(this, arguments));
                    return e && "function" == typeof e.then ? e : K.resolve(e);
                } catch (e) {
                    return S(e);
                }
            };
        },
        spawn: function(e, t, n) {
            try {
                var r = Nn(e.apply(n, t || []));
                return r && "function" == typeof r.then ? r : K.resolve(r);
            } catch (e) {
                return S(e);
            }
        },
        currentTransaction: {
            get: function() {
                return P.trans || null;
            }
        },
        waitFor: function(e, t) {
            e = K.resolve("function" == typeof e ? sr.ignoreTransaction(e) : e).timeout(t || 6e4);
            return P.trans ? P.trans.waitFor(e) : e;
        },
        Promise: K,
        debug: {
            get: function() {
                return l;
            },
            set: function(e) {
                Oe(e);
            }
        },
        derive: U,
        extend: a,
        props: M,
        override: Y,
        Events: Pt,
        on: Wt,
        liveQuery: ur,
        extendObservabilitySet: jn,
        getByKeyPath: c,
        setByKeyPath: b,
        delByKeyPath: function(t, e) {
            "string" == typeof e ? b(t, e, void 0) : "length" in e && [].map.call(e, function(e) {
                b(t, e, void 0);
            });
        },
        shallowClone: G,
        deepClone: ee,
        getObjectDiff: Un,
        cmp: j,
        asap: Q,
        minKey: -1 / 0,
        addons: [],
        connections: {
            get: gn.toArray
        },
        errnames: de,
        dependencies: ir,
        cache: Tn,
        semVer: "4.4.6",
        version: "4.4.6".split(".").map(function(e) {
            return parseInt(e);
        }).reduce(function(e, t, n) {
            return e + t / Math.pow(10, 2 * n);
        })
    })), sr.maxKey = Xt(sr.dependencies.IDBKeyRange), "undefined" != typeof dispatchEvent && "undefined" != typeof addEventListener && (Wt(zt, function(e) {
        fr || (e = new CustomEvent(Vt, {
            detail: e
        }), fr = !0, dispatchEvent(e), fr = !1);
    }), addEventListener(Vt, function(e) {
        e = e.detail;
        fr || cr(e);
    }));
    var lr, fr = !1, hr = function() {};
    return "undefined" != typeof BroadcastChannel && ((hr = function() {
        (lr = new BroadcastChannel(Vt)).onmessage = function(e) {
            return e.data && cr(e.data);
        };
    })(), "function" == typeof lr.unref && lr.unref(), Wt(zt, function(e) {
        fr || lr.postMessage(e);
    })), "undefined" != typeof addEventListener && (addEventListener("pagehide", function(e) {
        if (!y.disableBfCache && e.persisted) {
            l && console.debug("Dexie: handling persisted pagehide"), null != lr && lr.close();
            for(var t = 0, n = gn.toArray(); t < n.length; t++)n[t].close({
                disableAutoOpen: !1
            });
        }
    }), addEventListener("pageshow", function(e) {
        !y.disableBfCache && e.persisted && (l && console.debug("Dexie: handling persisted pageshow"), hr(), cr({
            all: new q(-1 / 0, [
                []
            ])
        }));
    })), K.rejectionMapper = function(e, t) {
        return !e || e instanceof ce || e instanceof TypeError || e instanceof SyntaxError || !e.name || !ye[e.name] ? e : (t = new ye[e.name](t || e.message, e), "stack" in e && u(t, "stack", {
            get: function() {
                return this.inner.stack;
            }
        }), t);
    }, Oe(l), _(y, Object.freeze({
        __proto__: null,
        DEFAULT_MAX_CONNECTIONS: 1e3,
        Dexie: y,
        Entity: mt,
        PropModification: _t,
        RangeSet: q,
        add: function(e) {
            return new _t({
                add: e
            });
        },
        cmp: j,
        default: y,
        liveQuery: ur,
        mergeRanges: Pn,
        rangesOverlap: Kn,
        remove: function(e) {
            return new _t({
                remove: e
            });
        },
        replacePrefix: function(e, t) {
            return new _t({
                replacePrefix: [
                    e,
                    t
                ]
            });
        }
    }), {
        default: y
    }), y;
});


const $ffcc43593520f083$var$DexieSymbol = Symbol.for("Dexie");
const $ffcc43593520f083$export$4ece27d405df7279 = globalThis[$ffcc43593520f083$var$DexieSymbol] || (globalThis[$ffcc43593520f083$var$DexieSymbol] = (0, (/*@__PURE__*/$parcel$interopDefault($ec2f0f6dece9d452$exports))));
if ((0, (/*@__PURE__*/$parcel$interopDefault($ec2f0f6dece9d452$exports))).semVer !== $ffcc43593520f083$export$4ece27d405df7279.semVer) throw new Error(`Two different versions of Dexie loaded in the same app: ${(0, (/*@__PURE__*/$parcel$interopDefault($ec2f0f6dece9d452$exports))).semVer} and ${$ffcc43593520f083$export$4ece27d405df7279.semVer}`);
const { liveQuery: $ffcc43593520f083$export$6a9705d8f6f38796, mergeRanges: $ffcc43593520f083$export$4876cc3130d3f820, rangesOverlap: $ffcc43593520f083$export$8f43b23b5d8de905, RangeSet: $ffcc43593520f083$export$34cb5241245008dd, cmp: $ffcc43593520f083$export$6154dcdb7d23e37b, Entity: $ffcc43593520f083$export$bc644a473284d944, PropModification: $ffcc43593520f083$export$4118fdb20badc28d, replacePrefix: $ffcc43593520f083$export$22ef8700548ec20, add: $ffcc43593520f083$export$e16d8520af44a096, remove: $ffcc43593520f083$export$cd7f480d6b8286c3, DexieYProvider: $ffcc43593520f083$export$562c52a428f04e31 } = $ffcc43593520f083$export$4ece27d405df7279;
var $ffcc43593520f083$export$2e2bcd8739ae039 = $ffcc43593520f083$export$4ece27d405df7279;



class $4fdb481bdfdd2f63$export$ccf5caea584f47fd extends (0, $ffcc43593520f083$export$2e2bcd8739ae039) {
    constructor(){
        super('selfoss');
        this.version(1).stores({
            entries: '&id,*datetime,[datetime+id]',
            statusq: '++id,*entryId',
            stamps: '&name,datetime',
            stats: '&name',
            tags: '&name',
            sources: '&id'
        });
    }
}



function $e2898f5d9ba245f0$var$statToNumber(stat) {
    return stat === undefined ? 0 : stat ? 1 : -1;
}
class $e2898f5d9ba245f0$export$2e2bcd8739ae039 {
    _tr(mode, tables, scope) {
        return (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.transaction(mode, tables, scope).catch((error)=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.showError((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app._('error_offline_storage', {
                '0': error.message
            }));
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.broken = true;
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.enableOffline.update(false);
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).entriesPage?.reload();
            // If this is a QuotaExceededError, garbage collect more
            // entries and hope it helps.
            if (error.name === (0, $ffcc43593520f083$export$2e2bcd8739ae039).errnames.QuotaExceeded) this.GCEntries(true);
            return Promise.reject(error);
        });
    }
    init() {
        if (!(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.enableOffline.value || (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage) return;
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.broken = false;
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage = new (0, $4fdb481bdfdd2f63$export$ccf5caea584f47fd)();
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.on('populate', ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stats.add({
                name: 'unread',
                value: 0
            });
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stats.add({
                name: 'starred',
                value: 0
            });
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stats.add({
                name: 'total',
                value: 0
            });
        });
        // retrieve last update stats in offline db
        return (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline._tr('r', [
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.entries,
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stamps
        ], ()=>{
            this._memLastItemId();
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stamps.get('lastItemsUpdate', (stamp)=>{
                if (stamp) {
                    (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.lastUpdate = stamp.datetime;
                    (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOnline.firstSync = false;
                } else this.shouldLoadEntriesOnline = true;
            });
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stamps.get('newestGCedEntry', (stamp)=>{
                if (stamp) this.newestGCedEntry = stamp.datetime;
                const limit = new Date(Date.now() - 259200000);
                if (!stamp || this.newestGCedEntry < limit) this.newestGCedEntry = new Date(Date.now() - 86400000);
            });
        }).then(()=>{
            const offlineDays = window.localStorage.getItem('offlineDays');
            if (offlineDays !== null) this.offlineDays = parseInt(offlineDays);
            // The newest garbage collected entry is either what's already
            // in the offline db or if more recent the entry older than
            // offlineDays ago.
            this.newestGCedEntry = new Date(Math.max(+this.newestGCedEntry, Date.now() - this.offlineDays * 86400000));
            window.addEventListener('online', ()=>{
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.tryOnline();
            });
            window.addEventListener('offline', ()=>{
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.setOffline().catch((error)=>{
                    if (error instanceof (0, $b82622975d92f7af$export$1871035840b7f83a)) (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.showError((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app._('error_offline_storage_not_available', {
                        '0': '<a href="https://caniuse.com/#feat=indexeddb">',
                        '1': '</a>'
                    }));
                    else throw error;
                });
            });
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setOfflineState(false);
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.tryOnline().then(()=>{
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).reloadTags();
            });
            this.reloadOnlineStats();
            this.refreshStats();
        }).catch(()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.broken = true;
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.enableOffline.update(false);
        });
    }
    _memLastItemId() {
        return (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.entries.orderBy('id').reverse().first((entry)=>{
            if (entry) this.lastItemId = entry.id;
            else this.lastItemId = 0;
        });
    }
    storeEntries(entries) {
        return this._tr('rw', [
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.entries,
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stamps
        ], ()=>{
            this.GCEntries();
            // store entries offline
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.entries.bulkPut(entries).then(()=>{
                this._memLastItemId();
                this.refreshStats();
            });
        });
    }
    GCEntries(more = false) {
        if (more) {
            // We need to garbage collect more, as the browser storage limit
            // seems to be exceeded: decrease the amount of days entries are
            // kept offline.
            const keptDays = Math.floor((Date.now() - +this.newestGCedEntry) / 86400000);
            this.offlineDays = Math.max(Math.min(keptDays - 1, this.offlineDays - 1), 0);
            window.localStorage.setItem('offlineDays', this.offlineDays.toString());
        }
        return (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.transaction('rw', (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.entries, (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stamps, ()=>{
            // cleanup and remember when
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stamps.get('lastCleanup', (stamp)=>{
                // Cleanup once a day or once after db reset
                if (!stamp || more || stamp && Date.now() - +stamp.datetime > 86400000) {
                    // Cleanup items older than offlineDays days, not of
                    // interest.
                    const limit = new Date(Date.now() - this.offlineDays * 86400000);
                    (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.entries.where('datetime').below(limit).filter((entry)=>{
                        return !entry.unread && !entry.starred;
                    }).each((entry)=>{
                        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.entries.delete(entry.id);
                        if (this.newestGCedEntry < entry.datetime) this.newestGCedEntry = entry.datetime;
                    }).then(()=>{
                        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stamps.bulkPut([
                            {
                                name: 'lastCleanup',
                                datetime: new Date()
                            },
                            {
                                name: 'newestGCedEntry',
                                datetime: this.newestGCedEntry
                            }
                        ]);
                    });
                }
            });
        });
    }
    storeStats(stats) {
        return this._tr('rw', [
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stats
        ], ()=>{
            for (const [name, value] of Object.entries(stats))(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stats.put({
                name: name,
                value: value
            });
        });
    }
    storeLastUpdate(lastUpdate) {
        return this._tr('rw', [
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stamps
        ], ()=>{
            if (lastUpdate) (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stamps.put({
                name: 'lastItemsUpdate',
                datetime: lastUpdate
            });
        });
    }
    getEntries(fetchParams) {
        let hasMore = false;
        return (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline._tr('r', [
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.entries
        ], ()=>{
            let howMany = 0;
            const ascOrder = (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).config.unreadOrder === 'asc' && fetchParams.type === (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).UNREAD;
            let entries = (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.entries.orderBy('[datetime+id]');
            if (!ascOrder) entries = entries.reverse();
            const fromDatetime = fetchParams.fromDatetime;
            const fromId = fetchParams.fromId;
            const seek = fromDatetime && fromId;
            const alwaysInDb = fetchParams.type === (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).STARRED || fetchParams.type === (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).UNREAD;
            return entries.filter((entry)=>{
                let keepEntry = false;
                if (fetchParams.extraIds.includes(entry.id)) return true;
                if (fetchParams.type === (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).STARRED) keepEntry = entry.starred;
                else if (fetchParams.type === (0, $42d3119d6a1baa33$export$c67e46de1ec7dfa6).UNREAD) keepEntry = entry.unread;
                else keepEntry = true;
                // seek pagination
                if (seek) {
                    if (ascOrder) keepEntry &&= entry.datetime > fromDatetime || entry.datetime.getTime() == fromDatetime.getTime() && entry.id > fromId;
                    else keepEntry &&= entry.datetime < fromDatetime || entry.datetime.getTime() == fromDatetime.getTime() && entry.id < fromId;
                }
                return keepEntry;
            }).until((entry)=>{
                howMany += 1;
                if (!ascOrder && !alwaysInDb && entry.datetime < this.newestGCedEntry) {
                    // the offline db is missing older entries, the next
                    // seek will have to find them online.
                    this.olderEntriesOnline = true;
                    hasMore = true;
                    return true; // stop iteration
                }
                // stop iteration if enough entries have been shown
                // go one further to assess if has more
                if (howMany >= (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).config.itemsPerPage + 1) {
                    hasMore = true;
                    return true;
                }
                return false;
            });
        }).then((entriesCollection)=>entriesCollection.toArray()).then((entries)=>({
                entries: entries,
                hasMore: hasMore
            }));
    }
    reloadOnlineStats() {
        return this._tr('r', [
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stats
        ], ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stats.toArray((stats)=>{
                const newStats = {
                    unread: 0,
                    starred: 0,
                    total: 0
                };
                stats.forEach((stat)=>{
                    newStats[stat.name] = stat.value;
                });
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).refreshStats(newStats.total, newStats.unread, newStats.starred);
            });
        });
    }
    refreshStats() {
        return this._tr('r', [
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.entries
        ], ()=>{
            const offlineCounts = {
                newest: 0,
                unread: 0,
                starred: 0
            };
            // IDBKeyRange does not support boolean indexes, so we need to
            // iterate over all the entries.
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.entries.each((entry)=>{
                offlineCounts.newest = offlineCounts.newest + 1;
                if (entry.unread) offlineCounts.unread = offlineCounts.unread + 1;
                if (entry.starred) offlineCounts.starred = offlineCounts.starred + 1;
            }).then(()=>{
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.refreshOfflineCounts(offlineCounts);
            });
        });
    }
    enqueueStatuses(statuses) {
        if (statuses) this.needsSync = true;
        const d = new Date();
        const newQueuedStatuses = statuses.map((newStatus)=>({
                entryId: newStatus.entryId,
                name: newStatus.name,
                value: newStatus.value,
                datetime: d
            }));
        return this._tr('rw', [
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.statusq
        ], ()=>{
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.statusq.bulkAdd(newQueuedStatuses);
        });
    }
    enqueueStatus(entryId, statusName, statusValue) {
        return this.enqueueStatuses([
            {
                entryId: entryId,
                name: statusName,
                value: statusValue
            }
        ]);
    }
    sendNewStatuses() {
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.statusq.toArray().then((statuses)=>{
            return statuses.map((s)=>{
                const statusUpdate = {
                    id: s.entryId,
                    datetime: s.datetime,
                    [s.name]: s.value
                };
                return statusUpdate;
            });
        }).then((statuses)=>{
            const s = statuses.length > 0 ? statuses : undefined;
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOnline.sync(s, true).then(()=>{
                this.needsSync = false;
            });
        });
        return (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOnline._syncBegin();
    }
    /**
     * Update `unread` and `starred` statuses of items in the offline database.
     *
     * @param dequee - also clear the local status updates queued to upload to server
     * @param updateStats - also update local statistics
     *
     * Note: Do not use `updateStats` with `itemStatuses` obtained from the server.
     * The server report cannot distinguish which of the status fields was changed
     * so both will be considered changed.
     */ storeEntryStatuses(itemStatuses, dequeue = false, updateStats = true) {
        return (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline._tr('rw', [
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.entries,
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stats,
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.statusq
        ], ()=>{
            const statsDiff = {
                unread: 0,
                starred: 0
            };
            // update entries statuses
            itemStatuses.forEach((itemStatus)=>{
                const newStatus = {
                    ...'unread' in itemStatus && {
                        unread: itemStatus.unread
                    },
                    ...'starred' in itemStatus && {
                        starred: itemStatus.starred
                    }
                };
                if (updateStats) {
                    statsDiff.unread += $e2898f5d9ba245f0$var$statToNumber(itemStatus.unread);
                    statsDiff.starred += $e2898f5d9ba245f0$var$statToNumber(itemStatus.starred);
                }
                const id = itemStatus.id;
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.entries.get(id).then(()=>{
                    (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.entries.update(id, newStatus);
                }, ()=>{
                    // the key was not found, the status of an entry
                    // missing in db was updated, request sync.
                    this.needsSync = true;
                });
                if (dequeue) // status update from server, remove from status queue
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.statusq.where('entryId').equals(id).delete();
            });
            if (updateStats) for (const [name, value] of Object.entries(statsDiff))(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stats.get(name, (stat)=>{
                (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).db.storage.stats.put({
                    name: name,
                    value: stat.value + value
                });
            });
        }).then(this.refreshStats);
    }
    entriesMark(itemIds, unread) {
        (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOnline.statsDirty = true;
        const newStatuses = itemIds.map((itemId)=>{
            return {
                id: itemId,
                unread: unread
            };
        });
        return this.storeEntryStatuses(newStatuses);
    }
    entryMark(itemId, unread) {
        return this.entriesMark([
            itemId
        ], unread);
    }
    entryStar(itemId, starred) {
        return this.storeEntryStatuses([
            {
                id: itemId,
                starred: starred
            }
        ]);
    }
    constructor(){
        /** @var Date the datetime of the newest garbage collected entry, i.e. deleted because not of interest. */ this.newestGCedEntry = null;
        this.offlineDays = 10;
        this.lastItemId = null;
        this.newerEntriesMissing = false;
        this.shouldLoadEntriesOnline = false;
        this.olderEntriesOnline = false;
    }
}


/**
 * db functions: client data repository (and offline storage)
 *
 * db is a dispatcher class and holds the logic for deciding whether selfoss
 * is running online with access to the server or offline.
 *
 * dbOnline contains AJAX calls that provide access to the server db.
 *
 * dbOffline is the entry point for the offline database held in the client.
 */ 


class $979185dcfae3369b$export$2e2bcd8739ae039 {
    setOnline() {
        if (!this.online) {
            this.online = true;
            this.sync();
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).reloadTags();
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setOfflineState(false);
        }
    }
    tryOnline() {
        return this.sync(true);
    }
    setOffline() {
        if (this.storage && !this.broken) {
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOnline._syncDone(false);
            this.online = false;
            (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.setOfflineState(true);
            return Promise.resolve();
        } else {
            const err = new (0, $b82622975d92f7af$export$1871035840b7f83a)();
            return Promise.reject(err);
        }
    }
    clear() {
        if (this.storage) {
            window.localStorage.removeItem('offlineDays');
            const clearing = this.storage.delete();
            this.storage = null;
            this.lastUpdate = null;
            return clearing;
        } else return Promise.resolve();
    }
    isValidTag(name) {
        return (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.state.tags.length === 0 || (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.state.tags.find((tag)=>tag.tag === name) !== undefined;
    }
    isValidSource(id) {
        return (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.state.sources.length === 0 || (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).app.state.sources.find((source)=>source.id === id) !== undefined;
    }
    sync(force = false) {
        const lastUpdateIsOld = this.lastUpdate === null || this.lastSync === null || Date.now() - this.lastSync > 300000;
        const shouldSync = force || (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.needsSync || lastUpdateIsOld;
        if ((0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isAllowedToRead() && (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).isOnline() && shouldSync) {
            if (this.enableOffline.value) return (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOffline.sendNewStatuses();
            else return (0, $2fc926cfb36b748a$export$2e2bcd8739ae039).dbOnline.sync();
        } else return Promise.resolve(); // ensure any chained function runs
    }
    constructor(){
        /** When an error occurs we disable the offline mode and mark the database as broken so it can be retried. */ this.broken = false;
        this.storage = null;
        this.online = true;
        this.enableOffline = new (0, $9b6f9431d1a0bef0$export$8fa6ce44b7b131e9)(window.localStorage.getItem('enableOffline') === 'true');
        this.userWaiting = true;
        /**
     * last db timestamp known client side
     */ this.lastUpdate = null;
        this.lastSync = null;
    }
}


var $1f2746d1e6eadef5$exports = {};
$1f2746d1e6eadef5$exports = $parcel$resolve("api2T");


/**
 * base javascript application
 *
 * @package    public_js
 * @copyright  Copyright (c) Tobias Zeising (http://www.aditu.de)
 * @license    GPLv3 (https://www.gnu.org/licenses/gpl-3.0.html)
 */ class $2fc926cfb36b748a$var$selfoss {
    static{
        /**
     * The main App component.
     */ this.app = null;
    }
    static{
        /**
     * React component for entries page.
     */ this.entriesPage = null;
    }
    static{
        this.serviceWorkerInitialized = false;
    }
    static{
        /**
     * Whether lightbox is open.
     */ this.lightboxActive = new (0, $9b6f9431d1a0bef0$export$8fa6ce44b7b131e9)(false);
    }
    static{
        this.db = new (0, $979185dcfae3369b$export$2e2bcd8739ae039)();
    }
    static{
        this.dbOnline = new (0, $49e95a5a7ce8064c$export$2e2bcd8739ae039)();
    }
    static{
        this.dbOffline = new (0, $e2898f5d9ba245f0$export$2e2bcd8739ae039)();
    }
    static{
        this.navigate = undefined;
    }
    /**
     * initialize application
     */ static async init() {
        // Load off-line mode enabledness.
        this.db.enableOffline.update(window.localStorage.getItem('enableOffline') === 'true');
        // Ignore stored config when off-line mode is disabled, since it is likely stale.
        const storedConfig = this.db.enableOffline.value ? localStorage.getItem('configuration') : null;
        let oldConfiguration = null;
        try {
            oldConfiguration = storedConfig !== null ? JSON.parse(storedConfig) : null;
        } catch  {
        // We will try to obtain a new configuration anyway.
        }
        // Fall back to the last cached config on failure.
        let configurationToUse = oldConfiguration;
        try {
            const { configuration: configuration } = await (0, $139c0902db4c349b$export$1d2e6bc0307ffd89)();
            configurationToUse = configuration;
            // We are on-line, prune the user files when changed.
            if ('caches' in window && 'serviceWorker' in navigator) {
                if (oldConfiguration === null || oldConfiguration.userCss !== configuration.userCss) await caches.delete('userCss');
                if (oldConfiguration === null || oldConfiguration.userJs !== configuration.userJs) await caches.delete('userJs');
            }
        } finally{
            if (configurationToUse) await this.initMain(configurationToUse);
            else // TODO: Add a more proper error page
            document.body.innerHTML = this.app._('error_configuration');
        }
    }
    static async initMain(configuration) {
        this.config = configuration;
        if (this.db.enableOffline.value) this.setupServiceWorker();
        if (configuration.language !== null) document.documentElement.setAttribute('lang', configuration.language);
        document.querySelector('meta[name="application-name"]').setAttribute('content', configuration.htmlTitle);
        const feedLink = document.createElement('link');
        feedLink.setAttribute('rel', 'alternate');
        feedLink.setAttribute('type', 'application/rss+xml');
        feedLink.setAttribute('title', 'RSS Feed');
        feedLink.setAttribute('href', 'feed');
        document.head.appendChild(feedLink);
        if (configuration.userCss !== null) {
            const link = document.createElement('link');
            link.setAttribute('rel', 'stylesheet');
            link.setAttribute('href', `user.css?v=${configuration.userCss}`);
            document.head.appendChild(link);
        }
        if (configuration.userJs !== null) {
            const script = document.createElement('script');
            script.setAttribute('src', `user.js?v=${configuration.userJs}`);
            document.body.appendChild(script);
        }
        // init offline if supported
        this.dbOffline.init();
        if (configuration.authEnabled) this.loggedin.update(window.localStorage.getItem('onlineSession') == 'true');
        this.attachApp(configuration);
    }
    /**
     * Create basic DOM structure of the page.
     */ static attachApp(configuration) {
        document.getElementById('js-loading-message')?.remove();
        const mainUi = document.createElement('div');
        document.body.appendChild(mainUi);
        mainUi.classList.add('app-toplevel');
        // BrowserRouter expects no slash at the end.
        const basePath = new URL(document.baseURI).pathname.replace(/\/$/, '');
        const root = (0, $fdb09cd070e137df$exports.createRoot)(mainUi);
        root.render((0, $e2370261ec80d344$export$4e373c34abfa8c68)({
            basePath: basePath,
            appRef: (app)=>{
                this.app = app;
                return ()=>{
                    this.app = null;
                };
            },
            configuration: configuration
        }));
    }
    static{
        this.loggedin = new (0, $9b6f9431d1a0bef0$export$8fa6ce44b7b131e9)(false);
    }
    static setSession() {
        window.localStorage.setItem('onlineSession', 'true');
        this.loggedin.update(true);
    }
    static clearSession() {
        window.localStorage.removeItem('onlineSession');
        this.loggedin.update(false);
    }
    static hasSession() {
        return this.loggedin.value;
    }
    /**
     * Try to log in using given credentials
     */ static login(props) {
        const { configuration: configuration, username: username, password: password, enableOffline: enableOffline } = props;
        this.db.enableOffline.update(enableOffline);
        window.localStorage.setItem('enableOffline', this.db.enableOffline.value.toString());
        if (!this.db.enableOffline.value) this.db.clear();
        const credentials = {
            username: username,
            password: password
        };
        return (0, $139c0902db4c349b$export$596d806903d1f59e)(credentials).then(()=>{
            this.setSession();
            // init offline if supported and not inited yet
            this.dbOffline.init();
            if ((!this.db.storage || this.db.broken) && this.db.enableOffline.value) {
                // Initialize database in offline mode when it has not been initialized yet or it got broken.
                this.dbOffline.init();
                // Store config for off-line use.
                localStorage.setItem('configuration', JSON.stringify(configuration));
                // Cache user files manually since service worker is not aware of them.
                if ('caches' in window && 'serviceWorker' in navigator) {
                    caches.open('userCss').then((cache)=>cache.add(`user.css?v=${configuration.userCss}`));
                    caches.open('userJs').then((cache)=>cache.add(`user.js?v=${configuration.userJs}`));
                }
                this.setupServiceWorker();
            }
        });
    }
    static setupServiceWorker() {
        if (!('serviceWorker' in navigator) || this.serviceWorkerInitialized) return;
        this.serviceWorkerInitialized = true;
        navigator.serviceWorker.addEventListener('controllerchange', ()=>{
            window.location.reload();
        });
        navigator.serviceWorker.register($1f2746d1e6eadef5$exports).then((reg)=>{
            this.listenWaitingSW(reg, (reg)=>{
                this.app.notifyNewVersion(()=>{
                    if (reg.waiting) reg.waiting.postMessage('skipWaiting');
                });
            });
        });
    }
    static async logout() {
        this.clearSession();
        this.db.clear(); // will not work after a failure, since storage is nulled
        window.localStorage.clear();
        if ('serviceWorker' in navigator) {
            if ('caches' in window) caches.keys().then((keys)=>keys.forEach((key)=>caches.delete(key)));
            navigator.serviceWorker.getRegistrations().then((registrations)=>{
                registrations.forEach((reg)=>{
                    reg.unregister();
                });
            });
            this.serviceWorkerInitialized = false;
        }
        try {
            await (0, $139c0902db4c349b$export$a0973bcfe11b05c9)();
            if (!this.config.publicMode) $2fc926cfb36b748a$var$selfoss.navigate('/sign/in');
        } catch (error) {
            this.app.showError(this.app._('error_logout') + ' ' + error.message);
        }
    }
    /**
     * Checks whether the current user is allowed to perform read operations.
     */ static isAllowedToRead() {
        return this.hasSession() || !this.config.authEnabled || this.config.publicMode;
    }
    /**
     * Checks whether the current user is allowed to perform update-tier operations.
     */ static isAllowedToUpdate() {
        return this.hasSession() || !this.config.authEnabled || this.config.allowPublicUpdate;
    }
    /**
     * Checks whether the current user is allowed to perform write operations.
     */ static isAllowedToWrite() {
        return this.hasSession() || !this.config.authEnabled;
    }
    /**
     * Checks whether the current user is allowed to perform write operations.
     */ static isOnline() {
        return this.db.online;
    }
    /**
     * indicates whether a mobile device is host
     *
     * @return true if device resolution smaller equals 1024
     */ static isMobile() {
        // first check useragent
        if (/iPhone|iPod|iPad|Android|BlackBerry/.test(navigator.userAgent)) return true;
        // otherwise check resolution
        return this.isTablet() || this.isSmartphone();
    }
    /**
     * indicates whether a tablet is the device or not
     *
     * @return true if device resolution smaller equals 1024
     */ static isTablet() {
        if (document.body.clientWidth <= 1024) return true;
        return false;
    }
    /**
     * indicates whether a tablet is the device or not
     *
     * @return true if device resolution smaller equals 1024
     */ static isSmartphone() {
        if (document.body.clientWidth <= 640) return true;
        return false;
    }
    static{
        /**
     * Override these functions to customize selfoss behaviour.
     */ this.extensionPoints = {
            /**
         * Called when an article is first expanded.
         * @param _contents HTML element containing the article contents
         */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
            processItemContents (_contents) {}
        };
    }
    /**
     * refresh stats.
     *
     * @param all new all stats
     * @param unread new unread stats
     * @param starred new starred stats
     */ static refreshStats(all, unread, starred) {
        this.app.setAllItemsCount(all);
        this.app.setStarredItemsCount(starred);
        this.refreshUnread(unread);
    }
    /**
     * refresh unread stats.
     *
     * @param unread new unread stats
     */ static refreshUnread(unread) {
        this.app.setUnreadItemsCount(unread);
    }
    /**
     * refresh current tags.
     */ static reloadTags() {
        this.app.setTagsState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).LOADING);
        (0, $cfb76a7b6769ced6$export$c36f611d5eb39a7)().then((data)=>{
            this.app.setTags(data);
            this.app.setTagsState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).SUCCESS);
        }).catch((error)=>{
            this.app.setTagsState((0, $f5b3c040e086fbc1$export$62aa48085237e36f).FAILURE);
            this.app.showError(this.app._('error_load_tags') + ' ' + error.message);
        });
    }
    static handleAjaxError(error, tryOffline = true) {
        if (!(error instanceof (0, $b82622975d92f7af$export$65bd6083489bd8bb) || error instanceof (0, $b82622975d92f7af$export$66d311bf29d5c89c))) return Promise.reject(error);
        const httpCode = 'response' in error ? error.response.status : 0;
        if (tryOffline && httpCode != 403) return this.db.setOffline();
        else return Promise.reject(error);
    }
    static listenWaitingSW(reg, callback) {
        const awaitStateChange = ()=>{
            reg.installing.addEventListener('statechange', (event)=>{
                // https://github.com/microsoft/TypeScript/issues/37842
                const sw = event.currentTarget;
                if (sw.state === 'installed') callback(reg);
            });
        };
        if (!reg) return;
        else if (reg.waiting) return callback(reg);
        else if (reg.installing) {
            awaitStateChange();
            reg.addEventListener('updatefound', awaitStateChange);
        }
    }
    static{
        // Include helpers for user scripts.
        this.ajax = $0081a42221085bd6$exports;
    }
}
var $2fc926cfb36b748a$export$2e2bcd8739ae039 = $2fc926cfb36b748a$var$selfoss;


(0, $2fc926cfb36b748a$export$2e2bcd8739ae039).init();
// make selfoss available in console for debugging
window.selfoss = (0, $2fc926cfb36b748a$export$2e2bcd8739ae039);


//# sourceMappingURL=client.04ce54f3.js.map
